/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 7679:
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;// addapted from the document.currentScript polyfill by Adam Miller
// MIT license
// source: https://github.com/amiller-gh/currentScript-polyfill

// added support for Firefox https://bugzilla.mozilla.org/show_bug.cgi?id=1620505

(function (root, factory) {
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  } else {}
}(typeof self !== 'undefined' ? self : this, function () {
  function getCurrentScript () {
    var descriptor = Object.getOwnPropertyDescriptor(document, 'currentScript')
    // for chrome
    if (!descriptor && 'currentScript' in document && document.currentScript) {
      return document.currentScript
    }

    // for other browsers with native support for currentScript
    if (descriptor && descriptor.get !== getCurrentScript && document.currentScript) {
      return document.currentScript
    }
  
    // IE 8-10 support script readyState
    // IE 11+ & Firefox support stack trace
    try {
      throw new Error();
    }
    catch (err) {
      // Find the second match for the "at" string to get file src url from stack.
      var ieStackRegExp = /.*at [^(]*\((.*):(.+):(.+)\)$/ig,
        ffStackRegExp = /@([^@]*):(\d+):(\d+)\s*$/ig,
        stackDetails = ieStackRegExp.exec(err.stack) || ffStackRegExp.exec(err.stack),
        scriptLocation = (stackDetails && stackDetails[1]) || false,
        line = (stackDetails && stackDetails[2]) || false,
        currentLocation = document.location.href.replace(document.location.hash, ''),
        pageSource,
        inlineScriptSourceRegExp,
        inlineScriptSource,
        scripts = document.getElementsByTagName('script'); // Live NodeList collection
  
      if (scriptLocation === currentLocation) {
        pageSource = document.documentElement.outerHTML;
        inlineScriptSourceRegExp = new RegExp('(?:[^\\n]+?\\n){0,' + (line - 2) + '}[^<]*<script>([\\d\\D]*?)<\\/script>[\\d\\D]*', 'i');
        inlineScriptSource = pageSource.replace(inlineScriptSourceRegExp, '$1').trim();
      }
  
      for (var i = 0; i < scripts.length; i++) {
        // If ready state is interactive, return the script tag
        if (scripts[i].readyState === 'interactive') {
          return scripts[i];
        }
  
        // If src matches, return the script tag
        if (scripts[i].src === scriptLocation) {
          return scripts[i];
        }
  
        // If inline source matches, return the script tag
        if (
          scriptLocation === currentLocation &&
          scripts[i].innerHTML &&
          scripts[i].innerHTML.trim() === inlineScriptSource
        ) {
          return scripts[i];
        }
      }
  
      // If no match, return null
      return null;
    }
  };

  return getCurrentScript
}));


/***/ }),

/***/ 9662:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsCallable(argument) is true`
module.exports = function (argument) {
  if (isCallable(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a function');
};


/***/ }),

/***/ 9483:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isConstructor = __webpack_require__(4411);
var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

// `Assert: IsConstructor(argument) is true`
module.exports = function (argument) {
  if (isConstructor(argument)) return argument;
  throw $TypeError(tryToString(argument) + ' is not a constructor');
};


/***/ }),

/***/ 6077:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);

var $String = String;
var $TypeError = TypeError;

module.exports = function (argument) {
  if (typeof argument == 'object' || isCallable(argument)) return argument;
  throw $TypeError("Can't set " + $String(argument) + ' as a prototype');
};


/***/ }),

/***/ 1223:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);
var create = __webpack_require__(30);
var defineProperty = (__webpack_require__(3070).f);

var UNSCOPABLES = wellKnownSymbol('unscopables');
var ArrayPrototype = Array.prototype;

// Array.prototype[@@unscopables]
// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
if (ArrayPrototype[UNSCOPABLES] === undefined) {
  defineProperty(ArrayPrototype, UNSCOPABLES, {
    configurable: true,
    value: create(null)
  });
}

// add a key to Array.prototype[@@unscopables]
module.exports = function (key) {
  ArrayPrototype[UNSCOPABLES][key] = true;
};


/***/ }),

/***/ 1530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);

// `AdvanceStringIndex` abstract operation
// https://tc39.es/ecma262/#sec-advancestringindex
module.exports = function (S, index, unicode) {
  return index + (unicode ? charAt(S, index).length : 1);
};


/***/ }),

/***/ 5787:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isPrototypeOf = __webpack_require__(7976);

var $TypeError = TypeError;

module.exports = function (it, Prototype) {
  if (isPrototypeOf(Prototype, it)) return it;
  throw $TypeError('Incorrect invocation');
};


/***/ }),

/***/ 9670:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(111);

var $String = String;
var $TypeError = TypeError;

// `Assert: Type(argument) is Object`
module.exports = function (argument) {
  if (isObject(argument)) return argument;
  throw $TypeError($String(argument) + ' is not an object');
};


/***/ }),

/***/ 8533:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $forEach = (__webpack_require__(2092).forEach);
var arrayMethodIsStrict = __webpack_require__(2133);

var STRICT_METHOD = arrayMethodIsStrict('forEach');

// `Array.prototype.forEach` method implementation
// https://tc39.es/ecma262/#sec-array.prototype.foreach
module.exports = !STRICT_METHOD ? function forEach(callbackfn /* , thisArg */) {
  return $forEach(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
// eslint-disable-next-line es/no-array-prototype-foreach -- safe
} : [].forEach;


/***/ }),

/***/ 8457:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var call = __webpack_require__(6916);
var toObject = __webpack_require__(7908);
var callWithSafeIterationClosing = __webpack_require__(3411);
var isArrayIteratorMethod = __webpack_require__(7659);
var isConstructor = __webpack_require__(4411);
var lengthOfArrayLike = __webpack_require__(6244);
var createProperty = __webpack_require__(6135);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);

var $Array = Array;

// `Array.from` method implementation
// https://tc39.es/ecma262/#sec-array.from
module.exports = function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
  var O = toObject(arrayLike);
  var IS_CONSTRUCTOR = isConstructor(this);
  var argumentsLength = arguments.length;
  var mapfn = argumentsLength > 1 ? arguments[1] : undefined;
  var mapping = mapfn !== undefined;
  if (mapping) mapfn = bind(mapfn, argumentsLength > 2 ? arguments[2] : undefined);
  var iteratorMethod = getIteratorMethod(O);
  var index = 0;
  var length, result, step, iterator, next, value;
  // if the target is not iterable or it's an array with the default iterator - use a simple case
  if (iteratorMethod && !(this === $Array && isArrayIteratorMethod(iteratorMethod))) {
    iterator = getIterator(O, iteratorMethod);
    next = iterator.next;
    result = IS_CONSTRUCTOR ? new this() : [];
    for (;!(step = call(next, iterator)).done; index++) {
      value = mapping ? callWithSafeIterationClosing(iterator, mapfn, [step.value, index], true) : step.value;
      createProperty(result, index, value);
    }
  } else {
    length = lengthOfArrayLike(O);
    result = IS_CONSTRUCTOR ? new this(length) : $Array(length);
    for (;length > index; index++) {
      value = mapping ? mapfn(O[index], index) : O[index];
      createProperty(result, index, value);
    }
  }
  result.length = index;
  return result;
};


/***/ }),

/***/ 1318:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5656);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);

// `Array.prototype.{ indexOf, includes }` methods implementation
var createMethod = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIndexedObject($this);
    var length = lengthOfArrayLike(O);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare -- NaN check
    if (IS_INCLUDES && el !== el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare -- NaN check
      if (value !== value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) {
      if ((IS_INCLUDES || index in O) && O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};

module.exports = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: createMethod(true),
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: createMethod(false)
};


/***/ }),

/***/ 2092:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var uncurryThis = __webpack_require__(1702);
var IndexedObject = __webpack_require__(8361);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var arraySpeciesCreate = __webpack_require__(5417);

var push = uncurryThis([].push);

// `Array.prototype.{ forEach, map, filter, some, every, find, findIndex, filterReject }` methods implementation
var createMethod = function (TYPE) {
  var IS_MAP = TYPE === 1;
  var IS_FILTER = TYPE === 2;
  var IS_SOME = TYPE === 3;
  var IS_EVERY = TYPE === 4;
  var IS_FIND_INDEX = TYPE === 6;
  var IS_FILTER_REJECT = TYPE === 7;
  var NO_HOLES = TYPE === 5 || IS_FIND_INDEX;
  return function ($this, callbackfn, that, specificCreate) {
    var O = toObject($this);
    var self = IndexedObject(O);
    var boundFunction = bind(callbackfn, that);
    var length = lengthOfArrayLike(self);
    var index = 0;
    var create = specificCreate || arraySpeciesCreate;
    var target = IS_MAP ? create($this, length) : IS_FILTER || IS_FILTER_REJECT ? create($this, 0) : undefined;
    var value, result;
    for (;length > index; index++) if (NO_HOLES || index in self) {
      value = self[index];
      result = boundFunction(value, index, O);
      if (TYPE) {
        if (IS_MAP) target[index] = result; // map
        else if (result) switch (TYPE) {
          case 3: return true;              // some
          case 5: return value;             // find
          case 6: return index;             // findIndex
          case 2: push(target, value);      // filter
        } else switch (TYPE) {
          case 4: return false;             // every
          case 7: push(target, value);      // filterReject
        }
      }
    }
    return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : target;
  };
};

module.exports = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: createMethod(0),
  // `Array.prototype.map` method
  // https://tc39.es/ecma262/#sec-array.prototype.map
  map: createMethod(1),
  // `Array.prototype.filter` method
  // https://tc39.es/ecma262/#sec-array.prototype.filter
  filter: createMethod(2),
  // `Array.prototype.some` method
  // https://tc39.es/ecma262/#sec-array.prototype.some
  some: createMethod(3),
  // `Array.prototype.every` method
  // https://tc39.es/ecma262/#sec-array.prototype.every
  every: createMethod(4),
  // `Array.prototype.find` method
  // https://tc39.es/ecma262/#sec-array.prototype.find
  find: createMethod(5),
  // `Array.prototype.findIndex` method
  // https://tc39.es/ecma262/#sec-array.prototype.findIndex
  findIndex: createMethod(6),
  // `Array.prototype.filterReject` method
  // https://github.com/tc39/proposal-array-filtering
  filterReject: createMethod(7)
};


/***/ }),

/***/ 1194:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var SPECIES = wellKnownSymbol('species');

module.exports = function (METHOD_NAME) {
  // We can't use this feature detection in V8 since it causes
  // deoptimization and serious performance degradation
  // https://github.com/zloirock/core-js/issues/677
  return V8_VERSION >= 51 || !fails(function () {
    var array = [];
    var constructor = array.constructor = {};
    constructor[SPECIES] = function () {
      return { foo: 1 };
    };
    return array[METHOD_NAME](Boolean).foo !== 1;
  });
};


/***/ }),

/***/ 2133:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = function (METHOD_NAME, argument) {
  var method = [][METHOD_NAME];
  return !!method && fails(function () {
    // eslint-disable-next-line no-useless-call -- required for testing
    method.call(null, argument || function () { return 1; }, 1);
  });
};


/***/ }),

/***/ 3658:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var isArray = __webpack_require__(3157);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Safari < 13 does not throw an error in this case
var SILENT_ON_NON_WRITABLE_LENGTH_SET = DESCRIPTORS && !function () {
  // makes no sense without proper strict mode support
  if (this !== undefined) return true;
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).length = 1;
  } catch (error) {
    return error instanceof TypeError;
  }
}();

module.exports = SILENT_ON_NON_WRITABLE_LENGTH_SET ? function (O, length) {
  if (isArray(O) && !getOwnPropertyDescriptor(O, 'length').writable) {
    throw $TypeError('Cannot set read only .length');
  } return O.length = length;
} : function (O, length) {
  return O.length = length;
};


/***/ }),

/***/ 1589:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);
var createProperty = __webpack_require__(6135);

var $Array = Array;
var max = Math.max;

module.exports = function (O, start, end) {
  var length = lengthOfArrayLike(O);
  var k = toAbsoluteIndex(start, length);
  var fin = toAbsoluteIndex(end === undefined ? length : end, length);
  var result = $Array(max(fin - k, 0));
  var n = 0;
  for (; k < fin; k++, n++) createProperty(result, n, O[k]);
  result.length = n;
  return result;
};


/***/ }),

/***/ 206:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis([].slice);


/***/ }),

/***/ 4362:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySlice = __webpack_require__(1589);

var floor = Math.floor;

var mergeSort = function (array, comparefn) {
  var length = array.length;
  var middle = floor(length / 2);
  return length < 8 ? insertionSort(array, comparefn) : merge(
    array,
    mergeSort(arraySlice(array, 0, middle), comparefn),
    mergeSort(arraySlice(array, middle), comparefn),
    comparefn
  );
};

var insertionSort = function (array, comparefn) {
  var length = array.length;
  var i = 1;
  var element, j;

  while (i < length) {
    j = i;
    element = array[i];
    while (j && comparefn(array[j - 1], element) > 0) {
      array[j] = array[--j];
    }
    if (j !== i++) array[j] = element;
  } return array;
};

var merge = function (array, left, right, comparefn) {
  var llength = left.length;
  var rlength = right.length;
  var lindex = 0;
  var rindex = 0;

  while (lindex < llength || rindex < rlength) {
    array[lindex + rindex] = (lindex < llength && rindex < rlength)
      ? comparefn(left[lindex], right[rindex]) <= 0 ? left[lindex++] : right[rindex++]
      : lindex < llength ? left[lindex++] : right[rindex++];
  } return array;
};

module.exports = mergeSort;


/***/ }),

/***/ 7475:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');
var $Array = Array;

// a part of `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray) {
  var C;
  if (isArray(originalArray)) {
    C = originalArray.constructor;
    // cross-realm fallback
    if (isConstructor(C) && (C === $Array || isArray(C.prototype))) C = undefined;
    else if (isObject(C)) {
      C = C[SPECIES];
      if (C === null) C = undefined;
    }
  } return C === undefined ? $Array : C;
};


/***/ }),

/***/ 5417:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var arraySpeciesConstructor = __webpack_require__(7475);

// `ArraySpeciesCreate` abstract operation
// https://tc39.es/ecma262/#sec-arrayspeciescreate
module.exports = function (originalArray, length) {
  return new (arraySpeciesConstructor(originalArray))(length === 0 ? 0 : length);
};


/***/ }),

/***/ 4170:
/***/ (function(module) {

"use strict";

var itoc = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=';
var ctoi = {};

for (var index = 0; index < 66; index++) ctoi[itoc.charAt(index)] = index;

module.exports = {
  itoc: itoc,
  ctoi: ctoi
};


/***/ }),

/***/ 3411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var iteratorClose = __webpack_require__(9212);

// call something on iterator step with safe closing on error
module.exports = function (iterator, fn, value, ENTRIES) {
  try {
    return ENTRIES ? fn(anObject(value)[0], value[1]) : fn(value);
  } catch (error) {
    iteratorClose(iterator, 'throw', error);
  }
};


/***/ }),

/***/ 7072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var SAFE_CLOSING = false;

try {
  var called = 0;
  var iteratorWithReturn = {
    next: function () {
      return { done: !!called++ };
    },
    'return': function () {
      SAFE_CLOSING = true;
    }
  };
  iteratorWithReturn[ITERATOR] = function () {
    return this;
  };
  // eslint-disable-next-line es/no-array-from, no-throw-literal -- required for testing
  Array.from(iteratorWithReturn, function () { throw 2; });
} catch (error) { /* empty */ }

module.exports = function (exec, SKIP_CLOSING) {
  if (!SKIP_CLOSING && !SAFE_CLOSING) return false;
  var ITERATION_SUPPORT = false;
  try {
    var object = {};
    object[ITERATOR] = function () {
      return {
        next: function () {
          return { done: ITERATION_SUPPORT = true };
        }
      };
    };
    exec(object);
  } catch (error) { /* empty */ }
  return ITERATION_SUPPORT;
};


/***/ }),

/***/ 4326:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis(''.slice);

module.exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};


/***/ }),

/***/ 648:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var isCallable = __webpack_require__(614);
var classofRaw = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var $Object = Object;

// ES3 wrong here
var CORRECT_ARGUMENTS = classofRaw(function () { return arguments; }()) === 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (error) { /* empty */ }
};

// getting tag from ES6+ `Object.prototype.toString`
module.exports = TO_STRING_TAG_SUPPORT ? classofRaw : function (it) {
  var O, tag, result;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (tag = tryGet(O = $Object(it), TO_STRING_TAG)) == 'string' ? tag
    // builtinTag case
    : CORRECT_ARGUMENTS ? classofRaw(O)
    // ES3 arguments fallback
    : (result = classofRaw(O)) === 'Object' && isCallable(O.callee) ? 'Arguments' : result;
};


/***/ }),

/***/ 9920:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var ownKeys = __webpack_require__(3887);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);

module.exports = function (target, source, exceptions) {
  var keys = ownKeys(source);
  var defineProperty = definePropertyModule.f;
  var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
  for (var i = 0; i < keys.length; i++) {
    var key = keys[i];
    if (!hasOwn(target, key) && !(exceptions && hasOwn(exceptions, key))) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};


/***/ }),

/***/ 4964:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

module.exports = function (METHOD_NAME) {
  var regexp = /./;
  try {
    '/./'[METHOD_NAME](regexp);
  } catch (error1) {
    try {
      regexp[MATCH] = false;
      return '/./'[METHOD_NAME](regexp);
    } catch (error2) { /* empty */ }
  } return false;
};


/***/ }),

/***/ 8544:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  function F() { /* empty */ }
  F.prototype.constructor = null;
  // eslint-disable-next-line es/no-object-getprototypeof -- required for testing
  return Object.getPrototypeOf(new F()) !== F.prototype;
});


/***/ }),

/***/ 4230:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var requireObjectCoercible = __webpack_require__(4488);
var toString = __webpack_require__(1340);

var quot = /"/g;
var replace = uncurryThis(''.replace);

// `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml
module.exports = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};


/***/ }),

/***/ 6178:
/***/ (function(module) {

"use strict";

// `CreateIterResultObject` abstract operation
// https://tc39.es/ecma262/#sec-createiterresultobject
module.exports = function (value, done) {
  return { value: value, done: done };
};


/***/ }),

/***/ 8880:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = DESCRIPTORS ? function (object, key, value) {
  return definePropertyModule.f(object, key, createPropertyDescriptor(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),

/***/ 9114:
/***/ (function(module) {

"use strict";

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),

/***/ 6135:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPropertyKey = __webpack_require__(4948);
var definePropertyModule = __webpack_require__(3070);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = function (object, key, value) {
  var propertyKey = toPropertyKey(key);
  if (propertyKey in object) definePropertyModule.f(object, propertyKey, createPropertyDescriptor(0, value));
  else object[propertyKey] = value;
};


/***/ }),

/***/ 8709:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var ordinaryToPrimitive = __webpack_require__(2140);

var $TypeError = TypeError;

// `Date.prototype[@@toPrimitive](hint)` method implementation
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
module.exports = function (hint) {
  anObject(this);
  if (hint === 'string' || hint === 'default') hint = 'string';
  else if (hint !== 'number') throw $TypeError('Incorrect hint');
  return ordinaryToPrimitive(this, hint);
};


/***/ }),

/***/ 7045:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var makeBuiltIn = __webpack_require__(6339);
var defineProperty = __webpack_require__(3070);

module.exports = function (target, name, descriptor) {
  if (descriptor.get) makeBuiltIn(descriptor.get, name, { getter: true });
  if (descriptor.set) makeBuiltIn(descriptor.set, name, { setter: true });
  return defineProperty.f(target, name, descriptor);
};


/***/ }),

/***/ 8052:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var definePropertyModule = __webpack_require__(3070);
var makeBuiltIn = __webpack_require__(6339);
var defineGlobalProperty = __webpack_require__(3072);

module.exports = function (O, key, value, options) {
  if (!options) options = {};
  var simple = options.enumerable;
  var name = options.name !== undefined ? options.name : key;
  if (isCallable(value)) makeBuiltIn(value, name, options);
  if (options.global) {
    if (simple) O[key] = value;
    else defineGlobalProperty(key, value);
  } else {
    try {
      if (!options.unsafe) delete O[key];
      else if (O[key]) simple = true;
    } catch (error) { /* empty */ }
    if (simple) O[key] = value;
    else definePropertyModule.f(O, key, {
      value: value,
      enumerable: false,
      configurable: !options.nonConfigurable,
      writable: !options.nonWritable
    });
  } return O;
};


/***/ }),

/***/ 3072:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;

module.exports = function (key, value) {
  try {
    defineProperty(global, key, { value: value, configurable: true, writable: true });
  } catch (error) {
    global[key] = value;
  } return value;
};


/***/ }),

/***/ 5117:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var tryToString = __webpack_require__(6330);

var $TypeError = TypeError;

module.exports = function (O, P) {
  if (!delete O[P]) throw $TypeError('Cannot delete property ' + tryToString(P) + ' of ' + tryToString(O));
};


/***/ }),

/***/ 9781:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

// Detect IE8's incomplete defineProperty implementation
module.exports = !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty({}, 1, { get: function () { return 7; } })[1] !== 7;
});


/***/ }),

/***/ 4154:
/***/ (function(module) {

"use strict";

var documentAll = typeof document == 'object' && document.all;

// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot
// eslint-disable-next-line unicorn/no-typeof-undefined -- required for testing
var IS_HTMLDDA = typeof documentAll == 'undefined' && documentAll !== undefined;

module.exports = {
  all: documentAll,
  IS_HTMLDDA: IS_HTMLDDA
};


/***/ }),

/***/ 317:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);

var document = global.document;
// typeof document.createElement is 'object' in old IE
var EXISTS = isObject(document) && isObject(document.createElement);

module.exports = function (it) {
  return EXISTS ? document.createElement(it) : {};
};


/***/ }),

/***/ 7207:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;
var MAX_SAFE_INTEGER = 0x1FFFFFFFFFFFFF; // 2 ** 53 - 1 == 9007199254740991

module.exports = function (it) {
  if (it > MAX_SAFE_INTEGER) throw $TypeError('Maximum allowed index exceeded');
  return it;
};


/***/ }),

/***/ 3678:
/***/ (function(module) {

"use strict";

module.exports = {
  IndexSizeError: { s: 'INDEX_SIZE_ERR', c: 1, m: 1 },
  DOMStringSizeError: { s: 'DOMSTRING_SIZE_ERR', c: 2, m: 0 },
  HierarchyRequestError: { s: 'HIERARCHY_REQUEST_ERR', c: 3, m: 1 },
  WrongDocumentError: { s: 'WRONG_DOCUMENT_ERR', c: 4, m: 1 },
  InvalidCharacterError: { s: 'INVALID_CHARACTER_ERR', c: 5, m: 1 },
  NoDataAllowedError: { s: 'NO_DATA_ALLOWED_ERR', c: 6, m: 0 },
  NoModificationAllowedError: { s: 'NO_MODIFICATION_ALLOWED_ERR', c: 7, m: 1 },
  NotFoundError: { s: 'NOT_FOUND_ERR', c: 8, m: 1 },
  NotSupportedError: { s: 'NOT_SUPPORTED_ERR', c: 9, m: 1 },
  InUseAttributeError: { s: 'INUSE_ATTRIBUTE_ERR', c: 10, m: 1 },
  InvalidStateError: { s: 'INVALID_STATE_ERR', c: 11, m: 1 },
  SyntaxError: { s: 'SYNTAX_ERR', c: 12, m: 1 },
  InvalidModificationError: { s: 'INVALID_MODIFICATION_ERR', c: 13, m: 1 },
  NamespaceError: { s: 'NAMESPACE_ERR', c: 14, m: 1 },
  InvalidAccessError: { s: 'INVALID_ACCESS_ERR', c: 15, m: 1 },
  ValidationError: { s: 'VALIDATION_ERR', c: 16, m: 0 },
  TypeMismatchError: { s: 'TYPE_MISMATCH_ERR', c: 17, m: 1 },
  SecurityError: { s: 'SECURITY_ERR', c: 18, m: 1 },
  NetworkError: { s: 'NETWORK_ERR', c: 19, m: 1 },
  AbortError: { s: 'ABORT_ERR', c: 20, m: 1 },
  URLMismatchError: { s: 'URL_MISMATCH_ERR', c: 21, m: 1 },
  QuotaExceededError: { s: 'QUOTA_EXCEEDED_ERR', c: 22, m: 1 },
  TimeoutError: { s: 'TIMEOUT_ERR', c: 23, m: 1 },
  InvalidNodeTypeError: { s: 'INVALID_NODE_TYPE_ERR', c: 24, m: 1 },
  DataCloneError: { s: 'DATA_CLONE_ERR', c: 25, m: 1 }
};


/***/ }),

/***/ 8324:
/***/ (function(module) {

"use strict";

// iterable DOM collections
// flag - `iterable` interface - 'entries', 'keys', 'values', 'forEach' methods
module.exports = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
};


/***/ }),

/***/ 8509:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// in old WebKit versions, `element.classList` is not an instance of global `DOMTokenList`
var documentCreateElement = __webpack_require__(317);

var classList = documentCreateElement('span').classList;
var DOMTokenListPrototype = classList && classList.constructor && classList.constructor.prototype;

module.exports = DOMTokenListPrototype === Object.prototype ? undefined : DOMTokenListPrototype;


/***/ }),

/***/ 8886:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

var firefox = userAgent.match(/firefox\/(\d+)/i);

module.exports = !!firefox && +firefox[1];


/***/ }),

/***/ 7871:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_DENO = __webpack_require__(3823);
var IS_NODE = __webpack_require__(5268);

module.exports = !IS_DENO && !IS_NODE
  && typeof window == 'object'
  && typeof document == 'object';


/***/ }),

/***/ 3823:
/***/ (function(module) {

"use strict";

/* global Deno -- Deno case */
module.exports = typeof Deno == 'object' && Deno && typeof Deno.version == 'object';


/***/ }),

/***/ 256:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var UA = __webpack_require__(8113);

module.exports = /MSIE|Trident/.test(UA);


/***/ }),

/***/ 1528:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

module.exports = /ipad|iphone|ipod/i.test(userAgent) && typeof Pebble != 'undefined';


/***/ }),

/***/ 6833:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

// eslint-disable-next-line redos/no-vulnerable -- safe
module.exports = /(?:ipad|iphone|ipod).*applewebkit/i.test(userAgent);


/***/ }),

/***/ 5268:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var classof = __webpack_require__(4326);

module.exports = classof(global.process) === 'process';


/***/ }),

/***/ 1036:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

module.exports = /web0s(?!.*chrome)/i.test(userAgent);


/***/ }),

/***/ 8113:
/***/ (function(module) {

"use strict";

module.exports = typeof navigator != 'undefined' && String(navigator.userAgent) || '';


/***/ }),

/***/ 7392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var userAgent = __webpack_require__(8113);

var process = global.process;
var Deno = global.Deno;
var versions = process && process.versions || Deno && Deno.version;
var v8 = versions && versions.v8;
var match, version;

if (v8) {
  match = v8.split('.');
  // in old Chrome, versions of V8 isn't V8 = Chrome / 10
  // but their correct versions are not interesting for us
  version = match[0] > 0 && match[0] < 4 ? 1 : +(match[0] + match[1]);
}

// BrowserFS NodeJS `process` polyfill incorrectly set `.v8` to `0.0`
// so check `userAgent` even if `.v8` exists, but 0
if (!version && userAgent) {
  match = userAgent.match(/Edge\/(\d+)/);
  if (!match || match[1] >= 74) {
    match = userAgent.match(/Chrome\/(\d+)/);
    if (match) version = +match[1];
  }
}

module.exports = version;


/***/ }),

/***/ 8008:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var userAgent = __webpack_require__(8113);

var webkit = userAgent.match(/AppleWebKit\/(\d+)\./);

module.exports = !!webkit && +webkit[1];


/***/ }),

/***/ 748:
/***/ (function(module) {

"use strict";

// IE8- don't enum bug keys
module.exports = [
  'constructor',
  'hasOwnProperty',
  'isPrototypeOf',
  'propertyIsEnumerable',
  'toLocaleString',
  'toString',
  'valueOf'
];


/***/ }),

/***/ 1060:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var $Error = Error;
var replace = uncurryThis(''.replace);

var TEST = (function (arg) { return String($Error(arg).stack); })('zxcasd');
// eslint-disable-next-line redos/no-vulnerable -- safe
var V8_OR_CHAKRA_STACK_ENTRY = /\n\s*at [^:]*:[^\n]*/;
var IS_V8_OR_CHAKRA_STACK = V8_OR_CHAKRA_STACK_ENTRY.test(TEST);

module.exports = function (stack, dropEntries) {
  if (IS_V8_OR_CHAKRA_STACK && typeof stack == 'string' && !$Error.prepareStackTrace) {
    while (dropEntries--) stack = replace(stack, V8_OR_CHAKRA_STACK_ENTRY, '');
  } return stack;
};


/***/ }),

/***/ 5392:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var createNonEnumerableProperty = __webpack_require__(8880);
var clearErrorStack = __webpack_require__(1060);
var ERROR_STACK_INSTALLABLE = __webpack_require__(2914);

// non-standard V8
var captureStackTrace = Error.captureStackTrace;

module.exports = function (error, C, stack, dropEntries) {
  if (ERROR_STACK_INSTALLABLE) {
    if (captureStackTrace) captureStackTrace(error, C);
    else createNonEnumerableProperty(error, 'stack', clearErrorStack(stack, dropEntries));
  }
};


/***/ }),

/***/ 2914:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var createPropertyDescriptor = __webpack_require__(9114);

module.exports = !fails(function () {
  var error = Error('a');
  if (!('stack' in error)) return true;
  // eslint-disable-next-line es/no-object-defineproperty -- safe
  Object.defineProperty(error, 'stack', createPropertyDescriptor(1, 7));
  return error.stack !== 7;
});


/***/ }),

/***/ 7762:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var anObject = __webpack_require__(9670);
var create = __webpack_require__(30);
var normalizeStringArgument = __webpack_require__(6277);

var nativeErrorToString = Error.prototype.toString;

var INCORRECT_TO_STRING = fails(function () {
  if (DESCRIPTORS) {
    // Chrome 32- incorrectly call accessor
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    var object = create(Object.defineProperty({}, 'name', { get: function () {
      return this === object;
    } }));
    if (nativeErrorToString.call(object) !== 'true') return true;
  }
  // FF10- does not properly handle non-strings
  return nativeErrorToString.call({ message: 1, name: 2 }) !== '2: 1'
    // IE8 does not properly handle defaults
    || nativeErrorToString.call({}) !== 'Error';
});

module.exports = INCORRECT_TO_STRING ? function toString() {
  var O = anObject(this);
  var name = normalizeStringArgument(O.name, 'Error');
  var message = normalizeStringArgument(O.message);
  return !name ? message : !message ? name : name + ': ' + message;
} : nativeErrorToString;


/***/ }),

/***/ 2109:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var defineGlobalProperty = __webpack_require__(3072);
var copyConstructorProperties = __webpack_require__(9920);
var isForced = __webpack_require__(4705);

/*
  options.target         - name of the target object
  options.global         - target is the global object
  options.stat           - export as static methods of target
  options.proto          - export as prototype methods of target
  options.real           - real prototype method for the `pure` version
  options.forced         - export even if the native feature is available
  options.bind           - bind methods to the target, required for the `pure` version
  options.wrap           - wrap constructors to preventing global pollution, required for the `pure` version
  options.unsafe         - use the simple assignment of property instead of delete + defineProperty
  options.sham           - add a flag to not completely full polyfills
  options.enumerable     - export as enumerable property
  options.dontCallGetSet - prevent calling a getter on target
  options.name           - the .name of the function if it does not match the key
*/
module.exports = function (options, source) {
  var TARGET = options.target;
  var GLOBAL = options.global;
  var STATIC = options.stat;
  var FORCED, target, key, targetProperty, sourceProperty, descriptor;
  if (GLOBAL) {
    target = global;
  } else if (STATIC) {
    target = global[TARGET] || defineGlobalProperty(TARGET, {});
  } else {
    target = (global[TARGET] || {}).prototype;
  }
  if (target) for (key in source) {
    sourceProperty = source[key];
    if (options.dontCallGetSet) {
      descriptor = getOwnPropertyDescriptor(target, key);
      targetProperty = descriptor && descriptor.value;
    } else targetProperty = target[key];
    FORCED = isForced(GLOBAL ? key : TARGET + (STATIC ? '.' : '#') + key, options.forced);
    // contained in target
    if (!FORCED && targetProperty !== undefined) {
      if (typeof sourceProperty == typeof targetProperty) continue;
      copyConstructorProperties(sourceProperty, targetProperty);
    }
    // add a flag to not completely full polyfills
    if (options.sham || (targetProperty && targetProperty.sham)) {
      createNonEnumerableProperty(sourceProperty, 'sham', true);
    }
    defineBuiltIn(target, key, sourceProperty, options);
  }
};


/***/ }),

/***/ 7293:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (error) {
    return true;
  }
};


/***/ }),

/***/ 7007:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var uncurryThis = __webpack_require__(1470);
var defineBuiltIn = __webpack_require__(8052);
var regexpExec = __webpack_require__(2261);
var fails = __webpack_require__(7293);
var wellKnownSymbol = __webpack_require__(5112);
var createNonEnumerableProperty = __webpack_require__(8880);

var SPECIES = wellKnownSymbol('species');
var RegExpPrototype = RegExp.prototype;

module.exports = function (KEY, exec, FORCED, SHAM) {
  var SYMBOL = wellKnownSymbol(KEY);

  var DELEGATES_TO_SYMBOL = !fails(function () {
    // String methods call symbol-named RegEp methods
    var O = {};
    O[SYMBOL] = function () { return 7; };
    return ''[KEY](O) !== 7;
  });

  var DELEGATES_TO_EXEC = DELEGATES_TO_SYMBOL && !fails(function () {
    // Symbol-named RegExp methods call .exec
    var execCalled = false;
    var re = /a/;

    if (KEY === 'split') {
      // We can't use real regex here since it causes deoptimization
      // and serious performance degradation in V8
      // https://github.com/zloirock/core-js/issues/306
      re = {};
      // RegExp[@@split] doesn't call the regex's exec method, but first creates
      // a new one. We need to return the patched regex when creating the new one.
      re.constructor = {};
      re.constructor[SPECIES] = function () { return re; };
      re.flags = '';
      re[SYMBOL] = /./[SYMBOL];
    }

    re.exec = function () { execCalled = true; return null; };

    re[SYMBOL]('');
    return !execCalled;
  });

  if (
    !DELEGATES_TO_SYMBOL ||
    !DELEGATES_TO_EXEC ||
    FORCED
  ) {
    var uncurriedNativeRegExpMethod = uncurryThis(/./[SYMBOL]);
    var methods = exec(SYMBOL, ''[KEY], function (nativeMethod, regexp, str, arg2, forceStringMethod) {
      var uncurriedNativeMethod = uncurryThis(nativeMethod);
      var $exec = regexp.exec;
      if ($exec === regexpExec || $exec === RegExpPrototype.exec) {
        if (DELEGATES_TO_SYMBOL && !forceStringMethod) {
          // The native String method already delegates to @@method (this
          // polyfilled function), leasing to infinite recursion.
          // We avoid it by directly calling the native @@method method.
          return { done: true, value: uncurriedNativeRegExpMethod(regexp, str, arg2) };
        }
        return { done: true, value: uncurriedNativeMethod(str, regexp, arg2) };
      }
      return { done: false };
    });

    defineBuiltIn(String.prototype, KEY, methods[0]);
    defineBuiltIn(RegExpPrototype, SYMBOL, methods[1]);
  }

  if (SHAM) createNonEnumerableProperty(RegExpPrototype[SYMBOL], 'sham', true);
};


/***/ }),

/***/ 2104:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var apply = FunctionPrototype.apply;
var call = FunctionPrototype.call;

// eslint-disable-next-line es/no-reflect -- safe
module.exports = typeof Reflect == 'object' && Reflect.apply || (NATIVE_BIND ? call.bind(apply) : function () {
  return call.apply(apply, arguments);
});


/***/ }),

/***/ 9974:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1470);
var aCallable = __webpack_require__(9662);
var NATIVE_BIND = __webpack_require__(4374);

var bind = uncurryThis(uncurryThis.bind);

// optional / simple context binding
module.exports = function (fn, that) {
  aCallable(fn);
  return that === undefined ? fn : NATIVE_BIND ? bind(fn, that) : function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),

/***/ 4374:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

module.exports = !fails(function () {
  // eslint-disable-next-line es/no-function-prototype-bind -- safe
  var test = (function () { /* empty */ }).bind();
  // eslint-disable-next-line no-prototype-builtins -- safe
  return typeof test != 'function' || test.hasOwnProperty('prototype');
});


/***/ }),

/***/ 6916:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var call = Function.prototype.call;

module.exports = NATIVE_BIND ? call.bind(call) : function () {
  return call.apply(call, arguments);
};


/***/ }),

/***/ 6530:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var hasOwn = __webpack_require__(2597);

var FunctionPrototype = Function.prototype;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getDescriptor = DESCRIPTORS && Object.getOwnPropertyDescriptor;

var EXISTS = hasOwn(FunctionPrototype, 'name');
// additional protection from minified / mangled / dropped function names
var PROPER = EXISTS && (function something() { /* empty */ }).name === 'something';
var CONFIGURABLE = EXISTS && (!DESCRIPTORS || (DESCRIPTORS && getDescriptor(FunctionPrototype, 'name').configurable));

module.exports = {
  EXISTS: EXISTS,
  PROPER: PROPER,
  CONFIGURABLE: CONFIGURABLE
};


/***/ }),

/***/ 5668:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var aCallable = __webpack_require__(9662);

module.exports = function (object, key, method) {
  try {
    // eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
    return uncurryThis(aCallable(Object.getOwnPropertyDescriptor(object, key)[method]));
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 1470:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classofRaw = __webpack_require__(4326);
var uncurryThis = __webpack_require__(1702);

module.exports = function (fn) {
  // Nashorn bug:
  //   https://github.com/zloirock/core-js/issues/1128
  //   https://github.com/zloirock/core-js/issues/1130
  if (classofRaw(fn) === 'Function') return uncurryThis(fn);
};


/***/ }),

/***/ 1702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_BIND = __webpack_require__(4374);

var FunctionPrototype = Function.prototype;
var call = FunctionPrototype.call;
var uncurryThisWithBind = NATIVE_BIND && FunctionPrototype.bind.bind(call, call);

module.exports = NATIVE_BIND ? uncurryThisWithBind : function (fn) {
  return function () {
    return call.apply(fn, arguments);
  };
};


/***/ }),

/***/ 5005:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var aFunction = function (argument) {
  return isCallable(argument) ? argument : undefined;
};

module.exports = function (namespace, method) {
  return arguments.length < 2 ? aFunction(global[namespace]) : global[namespace] && global[namespace][method];
};


/***/ }),

/***/ 1246:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(648);
var getMethod = __webpack_require__(8173);
var isNullOrUndefined = __webpack_require__(8554);
var Iterators = __webpack_require__(7497);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');

module.exports = function (it) {
  if (!isNullOrUndefined(it)) return getMethod(it, ITERATOR)
    || getMethod(it, '@@iterator')
    || Iterators[classof(it)];
};


/***/ }),

/***/ 4121:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var getIteratorMethod = __webpack_require__(1246);

var $TypeError = TypeError;

module.exports = function (argument, usingIterator) {
  var iteratorMethod = arguments.length < 2 ? getIteratorMethod(argument) : usingIterator;
  if (aCallable(iteratorMethod)) return anObject(call(iteratorMethod, argument));
  throw $TypeError(tryToString(argument) + ' is not iterable');
};


/***/ }),

/***/ 8044:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var isArray = __webpack_require__(3157);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(4326);
var toString = __webpack_require__(1340);

var push = uncurryThis([].push);

module.exports = function (replacer) {
  if (isCallable(replacer)) return replacer;
  if (!isArray(replacer)) return;
  var rawLength = replacer.length;
  var keys = [];
  for (var i = 0; i < rawLength; i++) {
    var element = replacer[i];
    if (typeof element == 'string') push(keys, element);
    else if (typeof element == 'number' || classof(element) === 'Number' || classof(element) === 'String') push(keys, toString(element));
  }
  var keysLength = keys.length;
  var root = true;
  return function (key, value) {
    if (root) {
      root = false;
      return value;
    }
    if (isArray(this)) return value;
    for (var j = 0; j < keysLength; j++) if (keys[j] === key) return value;
  };
};


/***/ }),

/***/ 8173:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9662);
var isNullOrUndefined = __webpack_require__(8554);

// `GetMethod` abstract operation
// https://tc39.es/ecma262/#sec-getmethod
module.exports = function (V, P) {
  var func = V[P];
  return isNullOrUndefined(func) ? undefined : aCallable(func);
};


/***/ }),

/***/ 647:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var floor = Math.floor;
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);
// eslint-disable-next-line redos/no-vulnerable -- safe
var SUBSTITUTION_SYMBOLS = /\$([$&'`]|\d{1,2}|<[^>]*>)/g;
var SUBSTITUTION_SYMBOLS_NO_NAMED = /\$([$&'`]|\d{1,2})/g;

// `GetSubstitution` abstract operation
// https://tc39.es/ecma262/#sec-getsubstitution
module.exports = function (matched, str, position, captures, namedCaptures, replacement) {
  var tailPos = position + matched.length;
  var m = captures.length;
  var symbols = SUBSTITUTION_SYMBOLS_NO_NAMED;
  if (namedCaptures !== undefined) {
    namedCaptures = toObject(namedCaptures);
    symbols = SUBSTITUTION_SYMBOLS;
  }
  return replace(replacement, symbols, function (match, ch) {
    var capture;
    switch (charAt(ch, 0)) {
      case '$': return '$';
      case '&': return matched;
      case '`': return stringSlice(str, 0, position);
      case "'": return stringSlice(str, tailPos);
      case '<':
        capture = namedCaptures[stringSlice(ch, 1, -1)];
        break;
      default: // \d\d?
        var n = +ch;
        if (n === 0) return match;
        if (n > m) {
          var f = floor(n / 10);
          if (f === 0) return match;
          if (f <= m) return captures[f - 1] === undefined ? charAt(ch, 1) : captures[f - 1] + charAt(ch, 1);
          return match;
        }
        capture = captures[n - 1];
    }
    return capture === undefined ? '' : capture;
  });
};


/***/ }),

/***/ 7854:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var check = function (it) {
  return it && it.Math === Math && it;
};

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
module.exports =
  // eslint-disable-next-line es/no-global-this -- safe
  check(typeof globalThis == 'object' && globalThis) ||
  check(typeof window == 'object' && window) ||
  // eslint-disable-next-line no-restricted-globals -- safe
  check(typeof self == 'object' && self) ||
  check(typeof __webpack_require__.g == 'object' && __webpack_require__.g) ||
  // eslint-disable-next-line no-new-func -- fallback
  (function () { return this; })() || this || Function('return this')();


/***/ }),

/***/ 2597:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var toObject = __webpack_require__(7908);

var hasOwnProperty = uncurryThis({}.hasOwnProperty);

// `HasOwnProperty` abstract operation
// https://tc39.es/ecma262/#sec-hasownproperty
// eslint-disable-next-line es/no-object-hasown -- safe
module.exports = Object.hasOwn || function hasOwn(it, key) {
  return hasOwnProperty(toObject(it), key);
};


/***/ }),

/***/ 3501:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 842:
/***/ (function(module) {

"use strict";

module.exports = function (a, b) {
  try {
    // eslint-disable-next-line no-console -- safe
    arguments.length === 1 ? console.error(a) : console.error(a, b);
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 490:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);

module.exports = getBuiltIn('document', 'documentElement');


/***/ }),

/***/ 4664:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);
var createElement = __webpack_require__(317);

// Thanks to IE8 for its funny defineProperty
module.exports = !DESCRIPTORS && !fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(createElement('div'), 'a', {
    get: function () { return 7; }
  }).a !== 7;
});


/***/ }),

/***/ 8361:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var classof = __webpack_require__(4326);

var $Object = Object;
var split = uncurryThis(''.split);

// fallback for non-array-like ES3 and non-enumerable old V8 strings
module.exports = fails(function () {
  // throws an error in rhino, see https://github.com/mozilla/rhino/issues/346
  // eslint-disable-next-line no-prototype-builtins -- safe
  return !$Object('z').propertyIsEnumerable(0);
}) ? function (it) {
  return classof(it) === 'String' ? split(it, '') : $Object(it);
} : $Object;


/***/ }),

/***/ 9587:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var setPrototypeOf = __webpack_require__(7674);

// makes subclassing work correct for wrapped built-ins
module.exports = function ($this, dummy, Wrapper) {
  var NewTarget, NewTargetPrototype;
  if (
    // it can work only with native `setPrototypeOf`
    setPrototypeOf &&
    // we haven't completely correct pre-ES6 way for getting `new.target`, so use this
    isCallable(NewTarget = dummy.constructor) &&
    NewTarget !== Wrapper &&
    isObject(NewTargetPrototype = NewTarget.prototype) &&
    NewTargetPrototype !== Wrapper.prototype
  ) setPrototypeOf($this, NewTargetPrototype);
  return $this;
};


/***/ }),

/***/ 2788:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var isCallable = __webpack_require__(614);
var store = __webpack_require__(5465);

var functionToString = uncurryThis(Function.toString);

// this helper broken in `core-js@3.4.1-3.4.4`, so we can't use `shared` helper
if (!isCallable(store.inspectSource)) {
  store.inspectSource = function (it) {
    return functionToString(it);
  };
}

module.exports = store.inspectSource;


/***/ }),

/***/ 8340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);

// `InstallErrorCause` abstract operation
// https://tc39.es/proposal-error-cause/#sec-errorobjects-install-error-cause
module.exports = function (O, options) {
  if (isObject(options) && 'cause' in options) {
    createNonEnumerableProperty(O, 'cause', options.cause);
  }
};


/***/ }),

/***/ 9909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_WEAK_MAP = __webpack_require__(4811);
var global = __webpack_require__(7854);
var isObject = __webpack_require__(111);
var createNonEnumerableProperty = __webpack_require__(8880);
var hasOwn = __webpack_require__(2597);
var shared = __webpack_require__(5465);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);

var OBJECT_ALREADY_INITIALIZED = 'Object already initialized';
var TypeError = global.TypeError;
var WeakMap = global.WeakMap;
var set, get, has;

var enforce = function (it) {
  return has(it) ? get(it) : set(it, {});
};

var getterFor = function (TYPE) {
  return function (it) {
    var state;
    if (!isObject(it) || (state = get(it)).type !== TYPE) {
      throw TypeError('Incompatible receiver, ' + TYPE + ' required');
    } return state;
  };
};

if (NATIVE_WEAK_MAP || shared.state) {
  var store = shared.state || (shared.state = new WeakMap());
  /* eslint-disable no-self-assign -- prototype methods protection */
  store.get = store.get;
  store.has = store.has;
  store.set = store.set;
  /* eslint-enable no-self-assign -- prototype methods protection */
  set = function (it, metadata) {
    if (store.has(it)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    store.set(it, metadata);
    return metadata;
  };
  get = function (it) {
    return store.get(it) || {};
  };
  has = function (it) {
    return store.has(it);
  };
} else {
  var STATE = sharedKey('state');
  hiddenKeys[STATE] = true;
  set = function (it, metadata) {
    if (hasOwn(it, STATE)) throw TypeError(OBJECT_ALREADY_INITIALIZED);
    metadata.facade = it;
    createNonEnumerableProperty(it, STATE, metadata);
    return metadata;
  };
  get = function (it) {
    return hasOwn(it, STATE) ? it[STATE] : {};
  };
  has = function (it) {
    return hasOwn(it, STATE);
  };
}

module.exports = {
  set: set,
  get: get,
  has: has,
  enforce: enforce,
  getterFor: getterFor
};


/***/ }),

/***/ 7659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);

var ITERATOR = wellKnownSymbol('iterator');
var ArrayPrototype = Array.prototype;

// check on default Array iterator
module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayPrototype[ITERATOR] === it);
};


/***/ }),

/***/ 3157:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(4326);

// `IsArray` abstract operation
// https://tc39.es/ecma262/#sec-isarray
// eslint-disable-next-line es/no-array-isarray -- safe
module.exports = Array.isArray || function isArray(argument) {
  return classof(argument) === 'Array';
};


/***/ }),

/***/ 614:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

// `IsCallable` abstract operation
// https://tc39.es/ecma262/#sec-iscallable
module.exports = $documentAll.IS_HTMLDDA ? function (argument) {
  return typeof argument == 'function' || argument === documentAll;
} : function (argument) {
  return typeof argument == 'function';
};


/***/ }),

/***/ 4411:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(648);
var getBuiltIn = __webpack_require__(5005);
var inspectSource = __webpack_require__(2788);

var noop = function () { /* empty */ };
var empty = [];
var construct = getBuiltIn('Reflect', 'construct');
var constructorRegExp = /^\s*(?:class|function)\b/;
var exec = uncurryThis(constructorRegExp.exec);
var INCORRECT_TO_STRING = !constructorRegExp.exec(noop);

var isConstructorModern = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  try {
    construct(noop, empty, argument);
    return true;
  } catch (error) {
    return false;
  }
};

var isConstructorLegacy = function isConstructor(argument) {
  if (!isCallable(argument)) return false;
  switch (classof(argument)) {
    case 'AsyncFunction':
    case 'GeneratorFunction':
    case 'AsyncGeneratorFunction': return false;
  }
  try {
    // we can't check .prototype since constructors produced by .bind haven't it
    // `Function#toString` throws on some built-it function in some legacy engines
    // (for example, `DOMQuad` and similar in FF41-)
    return INCORRECT_TO_STRING || !!exec(constructorRegExp, inspectSource(argument));
  } catch (error) {
    return true;
  }
};

isConstructorLegacy.sham = true;

// `IsConstructor` abstract operation
// https://tc39.es/ecma262/#sec-isconstructor
module.exports = !construct || fails(function () {
  var called;
  return isConstructorModern(isConstructorModern.call)
    || !isConstructorModern(Object)
    || !isConstructorModern(function () { called = true; })
    || called;
}) ? isConstructorLegacy : isConstructorModern;


/***/ }),

/***/ 4705:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);

var replacement = /#|\.prototype\./;

var isForced = function (feature, detection) {
  var value = data[normalize(feature)];
  return value === POLYFILL ? true
    : value === NATIVE ? false
    : isCallable(detection) ? fails(detection)
    : !!detection;
};

var normalize = isForced.normalize = function (string) {
  return String(string).replace(replacement, '.').toLowerCase();
};

var data = isForced.data = {};
var NATIVE = isForced.NATIVE = 'N';
var POLYFILL = isForced.POLYFILL = 'P';

module.exports = isForced;


/***/ }),

/***/ 8554:
/***/ (function(module) {

"use strict";

// we can't use just `it == null` since of `document.all` special case
// https://tc39.es/ecma262/#sec-IsHTMLDDA-internal-slot-aec
module.exports = function (it) {
  return it === null || it === undefined;
};


/***/ }),

/***/ 111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isCallable = __webpack_require__(614);
var $documentAll = __webpack_require__(4154);

var documentAll = $documentAll.all;

module.exports = $documentAll.IS_HTMLDDA ? function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it) || it === documentAll;
} : function (it) {
  return typeof it == 'object' ? it !== null : isCallable(it);
};


/***/ }),

/***/ 1913:
/***/ (function(module) {

"use strict";

module.exports = false;


/***/ }),

/***/ 7850:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isObject = __webpack_require__(111);
var classof = __webpack_require__(4326);
var wellKnownSymbol = __webpack_require__(5112);

var MATCH = wellKnownSymbol('match');

// `IsRegExp` abstract operation
// https://tc39.es/ecma262/#sec-isregexp
module.exports = function (it) {
  var isRegExp;
  return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : classof(it) === 'RegExp');
};


/***/ }),

/***/ 2190:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var $Object = Object;

module.exports = USE_SYMBOL_AS_UID ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  var $Symbol = getBuiltIn('Symbol');
  return isCallable($Symbol) && isPrototypeOf($Symbol.prototype, $Object(it));
};


/***/ }),

/***/ 612:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var bind = __webpack_require__(9974);
var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var tryToString = __webpack_require__(6330);
var isArrayIteratorMethod = __webpack_require__(7659);
var lengthOfArrayLike = __webpack_require__(6244);
var isPrototypeOf = __webpack_require__(7976);
var getIterator = __webpack_require__(4121);
var getIteratorMethod = __webpack_require__(1246);
var iteratorClose = __webpack_require__(9212);

var $TypeError = TypeError;

var Result = function (stopped, result) {
  this.stopped = stopped;
  this.result = result;
};

var ResultPrototype = Result.prototype;

module.exports = function (iterable, unboundFunction, options) {
  var that = options && options.that;
  var AS_ENTRIES = !!(options && options.AS_ENTRIES);
  var IS_RECORD = !!(options && options.IS_RECORD);
  var IS_ITERATOR = !!(options && options.IS_ITERATOR);
  var INTERRUPTED = !!(options && options.INTERRUPTED);
  var fn = bind(unboundFunction, that);
  var iterator, iterFn, index, length, result, next, step;

  var stop = function (condition) {
    if (iterator) iteratorClose(iterator, 'normal', condition);
    return new Result(true, condition);
  };

  var callFn = function (value) {
    if (AS_ENTRIES) {
      anObject(value);
      return INTERRUPTED ? fn(value[0], value[1], stop) : fn(value[0], value[1]);
    } return INTERRUPTED ? fn(value, stop) : fn(value);
  };

  if (IS_RECORD) {
    iterator = iterable.iterator;
  } else if (IS_ITERATOR) {
    iterator = iterable;
  } else {
    iterFn = getIteratorMethod(iterable);
    if (!iterFn) throw $TypeError(tryToString(iterable) + ' is not iterable');
    // optimisation for array iterators
    if (isArrayIteratorMethod(iterFn)) {
      for (index = 0, length = lengthOfArrayLike(iterable); length > index; index++) {
        result = callFn(iterable[index]);
        if (result && isPrototypeOf(ResultPrototype, result)) return result;
      } return new Result(false);
    }
    iterator = getIterator(iterable, iterFn);
  }

  next = IS_RECORD ? iterable.next : iterator.next;
  while (!(step = call(next, iterator)).done) {
    try {
      result = callFn(step.value);
    } catch (error) {
      iteratorClose(iterator, 'throw', error);
    }
    if (typeof result == 'object' && result && isPrototypeOf(ResultPrototype, result)) return result;
  } return new Result(false);
};


/***/ }),

/***/ 9212:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var getMethod = __webpack_require__(8173);

module.exports = function (iterator, kind, value) {
  var innerResult, innerError;
  anObject(iterator);
  try {
    innerResult = getMethod(iterator, 'return');
    if (!innerResult) {
      if (kind === 'throw') throw value;
      return value;
    }
    innerResult = call(innerResult, iterator);
  } catch (error) {
    innerError = true;
    innerResult = error;
  }
  if (kind === 'throw') throw value;
  if (innerError) throw innerResult;
  anObject(innerResult);
  return value;
};


/***/ }),

/***/ 3061:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IteratorPrototype = (__webpack_require__(3383).IteratorPrototype);
var create = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(9114);
var setToStringTag = __webpack_require__(8003);
var Iterators = __webpack_require__(7497);

var returnThis = function () { return this; };

module.exports = function (IteratorConstructor, NAME, next, ENUMERABLE_NEXT) {
  var TO_STRING_TAG = NAME + ' Iterator';
  IteratorConstructor.prototype = create(IteratorPrototype, { next: createPropertyDescriptor(+!ENUMERABLE_NEXT, next) });
  setToStringTag(IteratorConstructor, TO_STRING_TAG, false, true);
  Iterators[TO_STRING_TAG] = returnThis;
  return IteratorConstructor;
};


/***/ }),

/***/ 1656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var IS_PURE = __webpack_require__(1913);
var FunctionName = __webpack_require__(6530);
var isCallable = __webpack_require__(614);
var createIteratorConstructor = __webpack_require__(3061);
var getPrototypeOf = __webpack_require__(9518);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var createNonEnumerableProperty = __webpack_require__(8880);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var Iterators = __webpack_require__(7497);
var IteratorsCore = __webpack_require__(3383);

var PROPER_FUNCTION_NAME = FunctionName.PROPER;
var CONFIGURABLE_FUNCTION_NAME = FunctionName.CONFIGURABLE;
var IteratorPrototype = IteratorsCore.IteratorPrototype;
var BUGGY_SAFARI_ITERATORS = IteratorsCore.BUGGY_SAFARI_ITERATORS;
var ITERATOR = wellKnownSymbol('iterator');
var KEYS = 'keys';
var VALUES = 'values';
var ENTRIES = 'entries';

var returnThis = function () { return this; };

module.exports = function (Iterable, NAME, IteratorConstructor, next, DEFAULT, IS_SET, FORCED) {
  createIteratorConstructor(IteratorConstructor, NAME, next);

  var getIterationMethod = function (KIND) {
    if (KIND === DEFAULT && defaultIterator) return defaultIterator;
    if (!BUGGY_SAFARI_ITERATORS && KIND in IterablePrototype) return IterablePrototype[KIND];
    switch (KIND) {
      case KEYS: return function keys() { return new IteratorConstructor(this, KIND); };
      case VALUES: return function values() { return new IteratorConstructor(this, KIND); };
      case ENTRIES: return function entries() { return new IteratorConstructor(this, KIND); };
    } return function () { return new IteratorConstructor(this); };
  };

  var TO_STRING_TAG = NAME + ' Iterator';
  var INCORRECT_VALUES_NAME = false;
  var IterablePrototype = Iterable.prototype;
  var nativeIterator = IterablePrototype[ITERATOR]
    || IterablePrototype['@@iterator']
    || DEFAULT && IterablePrototype[DEFAULT];
  var defaultIterator = !BUGGY_SAFARI_ITERATORS && nativeIterator || getIterationMethod(DEFAULT);
  var anyNativeIterator = NAME === 'Array' ? IterablePrototype.entries || nativeIterator : nativeIterator;
  var CurrentIteratorPrototype, methods, KEY;

  // fix native
  if (anyNativeIterator) {
    CurrentIteratorPrototype = getPrototypeOf(anyNativeIterator.call(new Iterable()));
    if (CurrentIteratorPrototype !== Object.prototype && CurrentIteratorPrototype.next) {
      if (!IS_PURE && getPrototypeOf(CurrentIteratorPrototype) !== IteratorPrototype) {
        if (setPrototypeOf) {
          setPrototypeOf(CurrentIteratorPrototype, IteratorPrototype);
        } else if (!isCallable(CurrentIteratorPrototype[ITERATOR])) {
          defineBuiltIn(CurrentIteratorPrototype, ITERATOR, returnThis);
        }
      }
      // Set @@toStringTag to native iterators
      setToStringTag(CurrentIteratorPrototype, TO_STRING_TAG, true, true);
      if (IS_PURE) Iterators[TO_STRING_TAG] = returnThis;
    }
  }

  // fix Array.prototype.{ values, @@iterator }.name in V8 / FF
  if (PROPER_FUNCTION_NAME && DEFAULT === VALUES && nativeIterator && nativeIterator.name !== VALUES) {
    if (!IS_PURE && CONFIGURABLE_FUNCTION_NAME) {
      createNonEnumerableProperty(IterablePrototype, 'name', VALUES);
    } else {
      INCORRECT_VALUES_NAME = true;
      defaultIterator = function values() { return call(nativeIterator, this); };
    }
  }

  // export additional methods
  if (DEFAULT) {
    methods = {
      values: getIterationMethod(VALUES),
      keys: IS_SET ? defaultIterator : getIterationMethod(KEYS),
      entries: getIterationMethod(ENTRIES)
    };
    if (FORCED) for (KEY in methods) {
      if (BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME || !(KEY in IterablePrototype)) {
        defineBuiltIn(IterablePrototype, KEY, methods[KEY]);
      }
    } else $({ target: NAME, proto: true, forced: BUGGY_SAFARI_ITERATORS || INCORRECT_VALUES_NAME }, methods);
  }

  // define iterator
  if ((!IS_PURE || FORCED) && IterablePrototype[ITERATOR] !== defaultIterator) {
    defineBuiltIn(IterablePrototype, ITERATOR, defaultIterator, { name: DEFAULT });
  }
  Iterators[NAME] = defaultIterator;

  return methods;
};


/***/ }),

/***/ 3383:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var create = __webpack_require__(30);
var getPrototypeOf = __webpack_require__(9518);
var defineBuiltIn = __webpack_require__(8052);
var wellKnownSymbol = __webpack_require__(5112);
var IS_PURE = __webpack_require__(1913);

var ITERATOR = wellKnownSymbol('iterator');
var BUGGY_SAFARI_ITERATORS = false;

// `%IteratorPrototype%` object
// https://tc39.es/ecma262/#sec-%iteratorprototype%-object
var IteratorPrototype, PrototypeOfArrayIteratorPrototype, arrayIterator;

/* eslint-disable es/no-array-prototype-keys -- safe */
if ([].keys) {
  arrayIterator = [].keys();
  // Safari 8 has buggy iterators w/o `next`
  if (!('next' in arrayIterator)) BUGGY_SAFARI_ITERATORS = true;
  else {
    PrototypeOfArrayIteratorPrototype = getPrototypeOf(getPrototypeOf(arrayIterator));
    if (PrototypeOfArrayIteratorPrototype !== Object.prototype) IteratorPrototype = PrototypeOfArrayIteratorPrototype;
  }
}

var NEW_ITERATOR_PROTOTYPE = !isObject(IteratorPrototype) || fails(function () {
  var test = {};
  // FF44- legacy iterators case
  return IteratorPrototype[ITERATOR].call(test) !== test;
});

if (NEW_ITERATOR_PROTOTYPE) IteratorPrototype = {};
else if (IS_PURE) IteratorPrototype = create(IteratorPrototype);

// `%IteratorPrototype%[@@iterator]()` method
// https://tc39.es/ecma262/#sec-%iteratorprototype%-@@iterator
if (!isCallable(IteratorPrototype[ITERATOR])) {
  defineBuiltIn(IteratorPrototype, ITERATOR, function () {
    return this;
  });
}

module.exports = {
  IteratorPrototype: IteratorPrototype,
  BUGGY_SAFARI_ITERATORS: BUGGY_SAFARI_ITERATORS
};


/***/ }),

/***/ 7497:
/***/ (function(module) {

"use strict";

module.exports = {};


/***/ }),

/***/ 6244:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toLength = __webpack_require__(7466);

// `LengthOfArrayLike` abstract operation
// https://tc39.es/ecma262/#sec-lengthofarraylike
module.exports = function (obj) {
  return toLength(obj.length);
};


/***/ }),

/***/ 6339:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var DESCRIPTORS = __webpack_require__(9781);
var CONFIGURABLE_FUNCTION_NAME = (__webpack_require__(6530).CONFIGURABLE);
var inspectSource = __webpack_require__(2788);
var InternalStateModule = __webpack_require__(9909);

var enforceInternalState = InternalStateModule.enforce;
var getInternalState = InternalStateModule.get;
var $String = String;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var defineProperty = Object.defineProperty;
var stringSlice = uncurryThis(''.slice);
var replace = uncurryThis(''.replace);
var join = uncurryThis([].join);

var CONFIGURABLE_LENGTH = DESCRIPTORS && !fails(function () {
  return defineProperty(function () { /* empty */ }, 'length', { value: 8 }).length !== 8;
});

var TEMPLATE = String(String).split('String');

var makeBuiltIn = module.exports = function (value, name, options) {
  if (stringSlice($String(name), 0, 7) === 'Symbol(') {
    name = '[' + replace($String(name), /^Symbol\(([^)]*)\)/, '$1') + ']';
  }
  if (options && options.getter) name = 'get ' + name;
  if (options && options.setter) name = 'set ' + name;
  if (!hasOwn(value, 'name') || (CONFIGURABLE_FUNCTION_NAME && value.name !== name)) {
    if (DESCRIPTORS) defineProperty(value, 'name', { value: name, configurable: true });
    else value.name = name;
  }
  if (CONFIGURABLE_LENGTH && options && hasOwn(options, 'arity') && value.length !== options.arity) {
    defineProperty(value, 'length', { value: options.arity });
  }
  try {
    if (options && hasOwn(options, 'constructor') && options.constructor) {
      if (DESCRIPTORS) defineProperty(value, 'prototype', { writable: false });
    // in V8 ~ Chrome 53, prototypes of some methods, like `Array.prototype.values`, are non-writable
    } else if (value.prototype) value.prototype = undefined;
  } catch (error) { /* empty */ }
  var state = enforceInternalState(value);
  if (!hasOwn(state, 'source')) {
    state.source = join(TEMPLATE, typeof name == 'string' ? name : '');
  } return value;
};

// add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
// eslint-disable-next-line no-extend-native -- required
Function.prototype.toString = makeBuiltIn(function toString() {
  return isCallable(this) && getInternalState(this).source || inspectSource(this);
}, 'toString');


/***/ }),

/***/ 4758:
/***/ (function(module) {

"use strict";

var ceil = Math.ceil;
var floor = Math.floor;

// `Math.trunc` method
// https://tc39.es/ecma262/#sec-math.trunc
// eslint-disable-next-line es/no-math-trunc -- safe
module.exports = Math.trunc || function trunc(x) {
  var n = +x;
  return (n > 0 ? floor : ceil)(n);
};


/***/ }),

/***/ 5948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var bind = __webpack_require__(9974);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var macrotask = (__webpack_require__(261).set);
var Queue = __webpack_require__(8572);
var IS_IOS = __webpack_require__(6833);
var IS_IOS_PEBBLE = __webpack_require__(1528);
var IS_WEBOS_WEBKIT = __webpack_require__(1036);
var IS_NODE = __webpack_require__(5268);

var MutationObserver = global.MutationObserver || global.WebKitMutationObserver;
var document = global.document;
var process = global.process;
var Promise = global.Promise;
// Node.js 11 shows ExperimentalWarning on getting `queueMicrotask`
var queueMicrotaskDescriptor = getOwnPropertyDescriptor(global, 'queueMicrotask');
var microtask = queueMicrotaskDescriptor && queueMicrotaskDescriptor.value;
var notify, toggle, node, promise, then;

// modern engines have queueMicrotask method
if (!microtask) {
  var queue = new Queue();

  var flush = function () {
    var parent, fn;
    if (IS_NODE && (parent = process.domain)) parent.exit();
    while (fn = queue.get()) try {
      fn();
    } catch (error) {
      if (queue.head) notify();
      throw error;
    }
    if (parent) parent.enter();
  };

  // browsers with MutationObserver, except iOS - https://github.com/zloirock/core-js/issues/339
  // also except WebOS Webkit https://github.com/zloirock/core-js/issues/898
  if (!IS_IOS && !IS_NODE && !IS_WEBOS_WEBKIT && MutationObserver && document) {
    toggle = true;
    node = document.createTextNode('');
    new MutationObserver(flush).observe(node, { characterData: true });
    notify = function () {
      node.data = toggle = !toggle;
    };
  // environments with maybe non-completely correct, but existent Promise
  } else if (!IS_IOS_PEBBLE && Promise && Promise.resolve) {
    // Promise.resolve without an argument throws an error in LG WebOS 2
    promise = Promise.resolve(undefined);
    // workaround of WebKit ~ iOS Safari 10.1 bug
    promise.constructor = Promise;
    then = bind(promise.then, promise);
    notify = function () {
      then(flush);
    };
  // Node.js without promises
  } else if (IS_NODE) {
    notify = function () {
      process.nextTick(flush);
    };
  // for other environments - macrotask based on:
  // - setImmediate
  // - MessageChannel
  // - window.postMessage
  // - onreadystatechange
  // - setTimeout
  } else {
    // `webpack` dev server bug on IE global methods - use bind(fn, global)
    macrotask = bind(macrotask, global);
    notify = function () {
      macrotask(flush);
    };
  }

  microtask = function (fn) {
    if (!queue.head) notify();
    queue.add(fn);
  };
}

module.exports = microtask;


/***/ }),

/***/ 8523:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var aCallable = __webpack_require__(9662);

var $TypeError = TypeError;

var PromiseCapability = function (C) {
  var resolve, reject;
  this.promise = new C(function ($$resolve, $$reject) {
    if (resolve !== undefined || reject !== undefined) throw $TypeError('Bad Promise constructor');
    resolve = $$resolve;
    reject = $$reject;
  });
  this.resolve = aCallable(resolve);
  this.reject = aCallable(reject);
};

// `NewPromiseCapability` abstract operation
// https://tc39.es/ecma262/#sec-newpromisecapability
module.exports.f = function (C) {
  return new PromiseCapability(C);
};


/***/ }),

/***/ 6277:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toString = __webpack_require__(1340);

module.exports = function (argument, $default) {
  return argument === undefined ? arguments.length < 2 ? '' : $default : toString(argument);
};


/***/ }),

/***/ 3929:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isRegExp = __webpack_require__(7850);

var $TypeError = TypeError;

module.exports = function (it) {
  if (isRegExp(it)) {
    throw $TypeError("The method doesn't accept regular expressions");
  } return it;
};


/***/ }),

/***/ 30:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* global ActiveXObject -- old IE, WSH */
var anObject = __webpack_require__(9670);
var definePropertiesModule = __webpack_require__(6048);
var enumBugKeys = __webpack_require__(748);
var hiddenKeys = __webpack_require__(3501);
var html = __webpack_require__(490);
var documentCreateElement = __webpack_require__(317);
var sharedKey = __webpack_require__(6200);

var GT = '>';
var LT = '<';
var PROTOTYPE = 'prototype';
var SCRIPT = 'script';
var IE_PROTO = sharedKey('IE_PROTO');

var EmptyConstructor = function () { /* empty */ };

var scriptTag = function (content) {
  return LT + SCRIPT + GT + content + LT + '/' + SCRIPT + GT;
};

// Create object with fake `null` prototype: use ActiveX Object with cleared prototype
var NullProtoObjectViaActiveX = function (activeXDocument) {
  activeXDocument.write(scriptTag(''));
  activeXDocument.close();
  var temp = activeXDocument.parentWindow.Object;
  activeXDocument = null; // avoid memory leak
  return temp;
};

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var NullProtoObjectViaIFrame = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = documentCreateElement('iframe');
  var JS = 'java' + SCRIPT + ':';
  var iframeDocument;
  iframe.style.display = 'none';
  html.appendChild(iframe);
  // https://github.com/zloirock/core-js/issues/475
  iframe.src = String(JS);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(scriptTag('document.F=Object'));
  iframeDocument.close();
  return iframeDocument.F;
};

// Check for document.domain and active x support
// No need to use active x approach when document.domain is not set
// see https://github.com/es-shims/es5-shim/issues/150
// variation of https://github.com/kitcambridge/es5-shim/commit/4f738ac066346
// avoid IE GC bug
var activeXDocument;
var NullProtoObject = function () {
  try {
    activeXDocument = new ActiveXObject('htmlfile');
  } catch (error) { /* ignore */ }
  NullProtoObject = typeof document != 'undefined'
    ? document.domain && activeXDocument
      ? NullProtoObjectViaActiveX(activeXDocument) // old IE
      : NullProtoObjectViaIFrame()
    : NullProtoObjectViaActiveX(activeXDocument); // WSH
  var length = enumBugKeys.length;
  while (length--) delete NullProtoObject[PROTOTYPE][enumBugKeys[length]];
  return NullProtoObject();
};

hiddenKeys[IE_PROTO] = true;

// `Object.create` method
// https://tc39.es/ecma262/#sec-object.create
// eslint-disable-next-line es/no-object-create -- safe
module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    EmptyConstructor[PROTOTYPE] = anObject(O);
    result = new EmptyConstructor();
    EmptyConstructor[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = NullProtoObject();
  return Properties === undefined ? result : definePropertiesModule.f(result, Properties);
};


/***/ }),

/***/ 6048:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var definePropertyModule = __webpack_require__(3070);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var objectKeys = __webpack_require__(1956);

// `Object.defineProperties` method
// https://tc39.es/ecma262/#sec-object.defineproperties
// eslint-disable-next-line es/no-object-defineproperties -- safe
exports.f = DESCRIPTORS && !V8_PROTOTYPE_DEFINE_BUG ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var props = toIndexedObject(Properties);
  var keys = objectKeys(Properties);
  var length = keys.length;
  var index = 0;
  var key;
  while (length > index) definePropertyModule.f(O, key = keys[index++], props[key]);
  return O;
};


/***/ }),

/***/ 3070:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var IE8_DOM_DEFINE = __webpack_require__(4664);
var V8_PROTOTYPE_DEFINE_BUG = __webpack_require__(3353);
var anObject = __webpack_require__(9670);
var toPropertyKey = __webpack_require__(4948);

var $TypeError = TypeError;
// eslint-disable-next-line es/no-object-defineproperty -- safe
var $defineProperty = Object.defineProperty;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var ENUMERABLE = 'enumerable';
var CONFIGURABLE = 'configurable';
var WRITABLE = 'writable';

// `Object.defineProperty` method
// https://tc39.es/ecma262/#sec-object.defineproperty
exports.f = DESCRIPTORS ? V8_PROTOTYPE_DEFINE_BUG ? function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (typeof O === 'function' && P === 'prototype' && 'value' in Attributes && WRITABLE in Attributes && !Attributes[WRITABLE]) {
    var current = $getOwnPropertyDescriptor(O, P);
    if (current && current[WRITABLE]) {
      O[P] = Attributes.value;
      Attributes = {
        configurable: CONFIGURABLE in Attributes ? Attributes[CONFIGURABLE] : current[CONFIGURABLE],
        enumerable: ENUMERABLE in Attributes ? Attributes[ENUMERABLE] : current[ENUMERABLE],
        writable: false
      };
    }
  } return $defineProperty(O, P, Attributes);
} : $defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPropertyKey(P);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return $defineProperty(O, P, Attributes);
  } catch (error) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw $TypeError('Accessors not supported');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),

/***/ 1236:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var call = __webpack_require__(6916);
var propertyIsEnumerableModule = __webpack_require__(5296);
var createPropertyDescriptor = __webpack_require__(9114);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var hasOwn = __webpack_require__(2597);
var IE8_DOM_DEFINE = __webpack_require__(4664);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var $getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
exports.f = DESCRIPTORS ? $getOwnPropertyDescriptor : function getOwnPropertyDescriptor(O, P) {
  O = toIndexedObject(O);
  P = toPropertyKey(P);
  if (IE8_DOM_DEFINE) try {
    return $getOwnPropertyDescriptor(O, P);
  } catch (error) { /* empty */ }
  if (hasOwn(O, P)) return createPropertyDescriptor(!call(propertyIsEnumerableModule.f, O, P), O[P]);
};


/***/ }),

/***/ 1156:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-object-getownpropertynames -- safe */
var classof = __webpack_require__(4326);
var toIndexedObject = __webpack_require__(5656);
var $getOwnPropertyNames = (__webpack_require__(8006).f);
var arraySlice = __webpack_require__(1589);

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return $getOwnPropertyNames(it);
  } catch (error) {
    return arraySlice(windowNames);
  }
};

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && classof(it) === 'Window'
    ? getWindowNames(it)
    : $getOwnPropertyNames(toIndexedObject(it));
};


/***/ }),

/***/ 8006:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

var hiddenKeys = enumBugKeys.concat('length', 'prototype');

// `Object.getOwnPropertyNames` method
// https://tc39.es/ecma262/#sec-object.getownpropertynames
// eslint-disable-next-line es/no-object-getownpropertynames -- safe
exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return internalObjectKeys(O, hiddenKeys);
};


/***/ }),

/***/ 5181:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

// eslint-disable-next-line es/no-object-getownpropertysymbols -- safe
exports.f = Object.getOwnPropertySymbols;


/***/ }),

/***/ 9518:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var toObject = __webpack_require__(7908);
var sharedKey = __webpack_require__(6200);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var IE_PROTO = sharedKey('IE_PROTO');
var $Object = Object;
var ObjectPrototype = $Object.prototype;

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
// eslint-disable-next-line es/no-object-getprototypeof -- safe
module.exports = CORRECT_PROTOTYPE_GETTER ? $Object.getPrototypeOf : function (O) {
  var object = toObject(O);
  if (hasOwn(object, IE_PROTO)) return object[IE_PROTO];
  var constructor = object.constructor;
  if (isCallable(constructor) && object instanceof constructor) {
    return constructor.prototype;
  } return object instanceof $Object ? ObjectPrototype : null;
};


/***/ }),

/***/ 7976:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

module.exports = uncurryThis({}.isPrototypeOf);


/***/ }),

/***/ 6324:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var toIndexedObject = __webpack_require__(5656);
var indexOf = (__webpack_require__(1318).indexOf);
var hiddenKeys = __webpack_require__(3501);

var push = uncurryThis([].push);

module.exports = function (object, names) {
  var O = toIndexedObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) !hasOwn(hiddenKeys, key) && hasOwn(O, key) && push(result, key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (hasOwn(O, key = names[i++])) {
    ~indexOf(result, key) || push(result, key);
  }
  return result;
};


/***/ }),

/***/ 1956:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var internalObjectKeys = __webpack_require__(6324);
var enumBugKeys = __webpack_require__(748);

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe
module.exports = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, exports) {

"use strict";

var $propertyIsEnumerable = {}.propertyIsEnumerable;
// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;

// Nashorn ~ JDK8 bug
var NASHORN_BUG = getOwnPropertyDescriptor && !$propertyIsEnumerable.call({ 1: 2 }, 1);

// `Object.prototype.propertyIsEnumerable` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.propertyisenumerable
exports.f = NASHORN_BUG ? function propertyIsEnumerable(V) {
  var descriptor = getOwnPropertyDescriptor(this, V);
  return !!descriptor && descriptor.enumerable;
} : $propertyIsEnumerable;


/***/ }),

/***/ 7674:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-proto -- safe */
var uncurryThisAccessor = __webpack_require__(5668);
var anObject = __webpack_require__(9670);
var aPossiblePrototype = __webpack_require__(6077);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
// Works with __proto__ only. Old v8 can't work with null proto objects.
// eslint-disable-next-line es/no-object-setprototypeof -- safe
module.exports = Object.setPrototypeOf || ('__proto__' in {} ? function () {
  var CORRECT_SETTER = false;
  var test = {};
  var setter;
  try {
    setter = uncurryThisAccessor(Object.prototype, '__proto__', 'set');
    setter(test, []);
    CORRECT_SETTER = test instanceof Array;
  } catch (error) { /* empty */ }
  return function setPrototypeOf(O, proto) {
    anObject(O);
    aPossiblePrototype(proto);
    if (CORRECT_SETTER) setter(O, proto);
    else O.__proto__ = proto;
    return O;
  };
}() : undefined);


/***/ }),

/***/ 288:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var classof = __webpack_require__(648);

// `Object.prototype.toString` method implementation
// https://tc39.es/ecma262/#sec-object.prototype.tostring
module.exports = TO_STRING_TAG_SUPPORT ? {}.toString : function toString() {
  return '[object ' + classof(this) + ']';
};


/***/ }),

/***/ 2140:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);

var $TypeError = TypeError;

// `OrdinaryToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-ordinarytoprimitive
module.exports = function (input, pref) {
  var fn, val;
  if (pref === 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  if (isCallable(fn = input.valueOf) && !isObject(val = call(fn, input))) return val;
  if (pref !== 'string' && isCallable(fn = input.toString) && !isObject(val = call(fn, input))) return val;
  throw $TypeError("Can't convert object to primitive value");
};


/***/ }),

/***/ 3887:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var anObject = __webpack_require__(9670);

var concat = uncurryThis([].concat);

// all object keys, includes non-enumerable and symbols
module.exports = getBuiltIn('Reflect', 'ownKeys') || function ownKeys(it) {
  var keys = getOwnPropertyNamesModule.f(anObject(it));
  var getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
  return getOwnPropertySymbols ? concat(keys, getOwnPropertySymbols(it)) : keys;
};


/***/ }),

/***/ 857:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

module.exports = global;


/***/ }),

/***/ 2534:
/***/ (function(module) {

"use strict";

module.exports = function (exec) {
  try {
    return { error: false, value: exec() };
  } catch (error) {
    return { error: true, value: error };
  }
};


/***/ }),

/***/ 3702:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var NativePromiseConstructor = __webpack_require__(2492);
var isCallable = __webpack_require__(614);
var isForced = __webpack_require__(4705);
var inspectSource = __webpack_require__(2788);
var wellKnownSymbol = __webpack_require__(5112);
var IS_BROWSER = __webpack_require__(7871);
var IS_DENO = __webpack_require__(3823);
var IS_PURE = __webpack_require__(1913);
var V8_VERSION = __webpack_require__(7392);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var SPECIES = wellKnownSymbol('species');
var SUBCLASSING = false;
var NATIVE_PROMISE_REJECTION_EVENT = isCallable(global.PromiseRejectionEvent);

var FORCED_PROMISE_CONSTRUCTOR = isForced('Promise', function () {
  var PROMISE_CONSTRUCTOR_SOURCE = inspectSource(NativePromiseConstructor);
  var GLOBAL_CORE_JS_PROMISE = PROMISE_CONSTRUCTOR_SOURCE !== String(NativePromiseConstructor);
  // V8 6.6 (Node 10 and Chrome 66) have a bug with resolving custom thenables
  // https://bugs.chromium.org/p/chromium/issues/detail?id=830565
  // We can't detect it synchronously, so just check versions
  if (!GLOBAL_CORE_JS_PROMISE && V8_VERSION === 66) return true;
  // We need Promise#{ catch, finally } in the pure version for preventing prototype pollution
  if (IS_PURE && !(NativePromisePrototype['catch'] && NativePromisePrototype['finally'])) return true;
  // We can't use @@species feature detection in V8 since it causes
  // deoptimization and performance degradation
  // https://github.com/zloirock/core-js/issues/679
  if (!V8_VERSION || V8_VERSION < 51 || !/native code/.test(PROMISE_CONSTRUCTOR_SOURCE)) {
    // Detect correctness of subclassing with @@species support
    var promise = new NativePromiseConstructor(function (resolve) { resolve(1); });
    var FakePromise = function (exec) {
      exec(function () { /* empty */ }, function () { /* empty */ });
    };
    var constructor = promise.constructor = {};
    constructor[SPECIES] = FakePromise;
    SUBCLASSING = promise.then(function () { /* empty */ }) instanceof FakePromise;
    if (!SUBCLASSING) return true;
  // Unhandled rejections tracking support, NodeJS Promise without it fails @@species test
  } return !GLOBAL_CORE_JS_PROMISE && (IS_BROWSER || IS_DENO) && !NATIVE_PROMISE_REJECTION_EVENT;
});

module.exports = {
  CONSTRUCTOR: FORCED_PROMISE_CONSTRUCTOR,
  REJECTION_EVENT: NATIVE_PROMISE_REJECTION_EVENT,
  SUBCLASSING: SUBCLASSING
};


/***/ }),

/***/ 2492:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);

module.exports = global.Promise;


/***/ }),

/***/ 9478:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var isObject = __webpack_require__(111);
var newPromiseCapability = __webpack_require__(8523);

module.exports = function (C, x) {
  anObject(C);
  if (isObject(x) && x.constructor === C) return x;
  var promiseCapability = newPromiseCapability.f(C);
  var resolve = promiseCapability.resolve;
  resolve(x);
  return promiseCapability.promise;
};


/***/ }),

/***/ 8368:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NativePromiseConstructor = __webpack_require__(2492);
var checkCorrectnessOfIteration = __webpack_require__(7072);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

module.exports = FORCED_PROMISE_CONSTRUCTOR || !checkCorrectnessOfIteration(function (iterable) {
  NativePromiseConstructor.all(iterable).then(undefined, function () { /* empty */ });
});


/***/ }),

/***/ 2626:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(3070).f);

module.exports = function (Target, Source, key) {
  key in Target || defineProperty(Target, key, {
    configurable: true,
    get: function () { return Source[key]; },
    set: function (it) { Source[key] = it; }
  });
};


/***/ }),

/***/ 8572:
/***/ (function(module) {

"use strict";

var Queue = function () {
  this.head = null;
  this.tail = null;
};

Queue.prototype = {
  add: function (item) {
    var entry = { item: item, next: null };
    var tail = this.tail;
    if (tail) tail.next = entry;
    else this.head = entry;
    this.tail = entry;
  },
  get: function () {
    var entry = this.head;
    if (entry) {
      var next = this.head = entry.next;
      if (next === null) this.tail = null;
      return entry.item;
    }
  }
};

module.exports = Queue;


/***/ }),

/***/ 7651:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var anObject = __webpack_require__(9670);
var isCallable = __webpack_require__(614);
var classof = __webpack_require__(4326);
var regexpExec = __webpack_require__(2261);

var $TypeError = TypeError;

// `RegExpExec` abstract operation
// https://tc39.es/ecma262/#sec-regexpexec
module.exports = function (R, S) {
  var exec = R.exec;
  if (isCallable(exec)) {
    var result = call(exec, R, S);
    if (result !== null) anObject(result);
    return result;
  }
  if (classof(R) === 'RegExp') return call(regexpExec, R, S);
  throw $TypeError('RegExp#exec called on incompatible receiver');
};


/***/ }),

/***/ 2261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable regexp/no-empty-capturing-group, regexp/no-empty-group, regexp/no-lazy-ends -- testing */
/* eslint-disable regexp/no-useless-quantifier -- testing */
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var toString = __webpack_require__(1340);
var regexpFlags = __webpack_require__(7066);
var stickyHelpers = __webpack_require__(2999);
var shared = __webpack_require__(2309);
var create = __webpack_require__(30);
var getInternalState = (__webpack_require__(9909).get);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(7168);

var nativeReplace = shared('native-string-replace', String.prototype.replace);
var nativeExec = RegExp.prototype.exec;
var patchedExec = nativeExec;
var charAt = uncurryThis(''.charAt);
var indexOf = uncurryThis(''.indexOf);
var replace = uncurryThis(''.replace);
var stringSlice = uncurryThis(''.slice);

var UPDATES_LAST_INDEX_WRONG = (function () {
  var re1 = /a/;
  var re2 = /b*/g;
  call(nativeExec, re1, 'a');
  call(nativeExec, re2, 'a');
  return re1.lastIndex !== 0 || re2.lastIndex !== 0;
})();

var UNSUPPORTED_Y = stickyHelpers.BROKEN_CARET;

// nonparticipating capturing group, copied from es5-shim's String#split patch.
var NPCG_INCLUDED = /()??/.exec('')[1] !== undefined;

var PATCH = UPDATES_LAST_INDEX_WRONG || NPCG_INCLUDED || UNSUPPORTED_Y || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG;

if (PATCH) {
  patchedExec = function exec(string) {
    var re = this;
    var state = getInternalState(re);
    var str = toString(string);
    var raw = state.raw;
    var result, reCopy, lastIndex, match, i, object, group;

    if (raw) {
      raw.lastIndex = re.lastIndex;
      result = call(patchedExec, raw, str);
      re.lastIndex = raw.lastIndex;
      return result;
    }

    var groups = state.groups;
    var sticky = UNSUPPORTED_Y && re.sticky;
    var flags = call(regexpFlags, re);
    var source = re.source;
    var charsAdded = 0;
    var strCopy = str;

    if (sticky) {
      flags = replace(flags, 'y', '');
      if (indexOf(flags, 'g') === -1) {
        flags += 'g';
      }

      strCopy = stringSlice(str, re.lastIndex);
      // Support anchored sticky behavior.
      if (re.lastIndex > 0 && (!re.multiline || re.multiline && charAt(str, re.lastIndex - 1) !== '\n')) {
        source = '(?: ' + source + ')';
        strCopy = ' ' + strCopy;
        charsAdded++;
      }
      // ^(? + rx + ) is needed, in combination with some str slicing, to
      // simulate the 'y' flag.
      reCopy = new RegExp('^(?:' + source + ')', flags);
    }

    if (NPCG_INCLUDED) {
      reCopy = new RegExp('^' + source + '$(?!\\s)', flags);
    }
    if (UPDATES_LAST_INDEX_WRONG) lastIndex = re.lastIndex;

    match = call(nativeExec, sticky ? reCopy : re, strCopy);

    if (sticky) {
      if (match) {
        match.input = stringSlice(match.input, charsAdded);
        match[0] = stringSlice(match[0], charsAdded);
        match.index = re.lastIndex;
        re.lastIndex += match[0].length;
      } else re.lastIndex = 0;
    } else if (UPDATES_LAST_INDEX_WRONG && match) {
      re.lastIndex = re.global ? match.index + match[0].length : lastIndex;
    }
    if (NPCG_INCLUDED && match && match.length > 1) {
      // Fix browsers whose `exec` methods don't consistently return `undefined`
      // for NPCG, like IE8. NOTE: This doesn't work for /(.?)?/
      call(nativeReplace, match[0], reCopy, function () {
        for (i = 1; i < arguments.length - 2; i++) {
          if (arguments[i] === undefined) match[i] = undefined;
        }
      });
    }

    if (match && groups) {
      match.groups = object = create(null);
      for (i = 0; i < groups.length; i++) {
        group = groups[i];
        object[group[0]] = match[group[1]];
      }
    }

    return match;
  };
}

module.exports = patchedExec;


/***/ }),

/***/ 7066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);

// `RegExp.prototype.flags` getter implementation
// https://tc39.es/ecma262/#sec-get-regexp.prototype.flags
module.exports = function () {
  var that = anObject(this);
  var result = '';
  if (that.hasIndices) result += 'd';
  if (that.global) result += 'g';
  if (that.ignoreCase) result += 'i';
  if (that.multiline) result += 'm';
  if (that.dotAll) result += 's';
  if (that.unicode) result += 'u';
  if (that.unicodeSets) result += 'v';
  if (that.sticky) result += 'y';
  return result;
};


/***/ }),

/***/ 4706:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var hasOwn = __webpack_require__(2597);
var isPrototypeOf = __webpack_require__(7976);
var regExpFlags = __webpack_require__(7066);

var RegExpPrototype = RegExp.prototype;

module.exports = function (R) {
  var flags = R.flags;
  return flags === undefined && !('flags' in RegExpPrototype) && !hasOwn(R, 'flags') && isPrototypeOf(RegExpPrototype, R)
    ? call(regExpFlags, R) : flags;
};


/***/ }),

/***/ 2999:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('a', 'y') -> /a/y and it causes SyntaxError
var $RegExp = global.RegExp;

var UNSUPPORTED_Y = fails(function () {
  var re = $RegExp('a', 'y');
  re.lastIndex = 2;
  return re.exec('abcd') !== null;
});

// UC Browser bug
// https://github.com/zloirock/core-js/issues/1008
var MISSED_STICKY = UNSUPPORTED_Y || fails(function () {
  return !$RegExp('a', 'y').sticky;
});

var BROKEN_CARET = UNSUPPORTED_Y || fails(function () {
  // https://bugzilla.mozilla.org/show_bug.cgi?id=773687
  var re = $RegExp('^r', 'gy');
  re.lastIndex = 2;
  return re.exec('str') !== null;
});

module.exports = {
  BROKEN_CARET: BROKEN_CARET,
  MISSED_STICKY: MISSED_STICKY,
  UNSUPPORTED_Y: UNSUPPORTED_Y
};


/***/ }),

/***/ 9441:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('.', 's') -> /./s and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('.', 's');
  return !(re.dotAll && re.exec('\n') && re.flags === 's');
});


/***/ }),

/***/ 7168:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

// babel-minify and Closure Compiler transpiles RegExp('(?<a>b)', 'g') -> /(?<a>b)/g and it causes SyntaxError
var $RegExp = global.RegExp;

module.exports = fails(function () {
  var re = $RegExp('(?<a>b)', 'g');
  return re.exec('b').groups.a !== 'b' ||
    'b'.replace(re, '$<a>c') !== 'bc';
});


/***/ }),

/***/ 4488:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var isNullOrUndefined = __webpack_require__(8554);

var $TypeError = TypeError;

// `RequireObjectCoercible` abstract operation
// https://tc39.es/ecma262/#sec-requireobjectcoercible
module.exports = function (it) {
  if (isNullOrUndefined(it)) throw $TypeError("Can't call method on " + it);
  return it;
};


/***/ }),

/***/ 1150:
/***/ (function(module) {

"use strict";

// `SameValue` abstract operation
// https://tc39.es/ecma262/#sec-samevalue
// eslint-disable-next-line es/no-object-is -- safe
module.exports = Object.is || function is(x, y) {
  // eslint-disable-next-line no-self-compare -- NaN check
  return x === y ? x !== 0 || 1 / x === 1 / y : x !== x && y !== y;
};


/***/ }),

/***/ 6340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var defineBuiltInAccessor = __webpack_require__(7045);
var wellKnownSymbol = __webpack_require__(5112);
var DESCRIPTORS = __webpack_require__(9781);

var SPECIES = wellKnownSymbol('species');

module.exports = function (CONSTRUCTOR_NAME) {
  var Constructor = getBuiltIn(CONSTRUCTOR_NAME);

  if (DESCRIPTORS && Constructor && !Constructor[SPECIES]) {
    defineBuiltInAccessor(Constructor, SPECIES, {
      configurable: true,
      get: function () { return this; }
    });
  }
};


/***/ }),

/***/ 8003:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');

module.exports = function (target, TAG, STATIC) {
  if (target && !STATIC) target = target.prototype;
  if (target && !hasOwn(target, TO_STRING_TAG)) {
    defineProperty(target, TO_STRING_TAG, { configurable: true, value: TAG });
  }
};


/***/ }),

/***/ 6200:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var shared = __webpack_require__(2309);
var uid = __webpack_require__(9711);

var keys = shared('keys');

module.exports = function (key) {
  return keys[key] || (keys[key] = uid(key));
};


/***/ }),

/***/ 5465:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var defineGlobalProperty = __webpack_require__(3072);

var SHARED = '__core-js_shared__';
var store = global[SHARED] || defineGlobalProperty(SHARED, {});

module.exports = store;


/***/ }),

/***/ 2309:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_PURE = __webpack_require__(1913);
var store = __webpack_require__(5465);

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: '3.32.1',
  mode: IS_PURE ? 'pure' : 'global',
  copyright: '© 2014-2023 Denis Pushkarev (zloirock.ru)',
  license: 'https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE',
  source: 'https://github.com/zloirock/core-js'
});


/***/ }),

/***/ 6707:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var anObject = __webpack_require__(9670);
var aConstructor = __webpack_require__(9483);
var isNullOrUndefined = __webpack_require__(8554);
var wellKnownSymbol = __webpack_require__(5112);

var SPECIES = wellKnownSymbol('species');

// `SpeciesConstructor` abstract operation
// https://tc39.es/ecma262/#sec-speciesconstructor
module.exports = function (O, defaultConstructor) {
  var C = anObject(O).constructor;
  var S;
  return C === undefined || isNullOrUndefined(S = anObject(C)[SPECIES]) ? defaultConstructor : aConstructor(S);
};


/***/ }),

/***/ 3429:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var fails = __webpack_require__(7293);

// check the existence of a method, lowercase
// of a tag and escaping quotes in arguments
module.exports = function (METHOD_NAME) {
  return fails(function () {
    var test = ''[METHOD_NAME]('"');
    return test !== test.toLowerCase() || test.split('"').length > 3;
  });
};


/***/ }),

/***/ 8710:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var toIntegerOrInfinity = __webpack_require__(9303);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);

var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var stringSlice = uncurryThis(''.slice);

var createMethod = function (CONVERT_TO_STRING) {
  return function ($this, pos) {
    var S = toString(requireObjectCoercible($this));
    var position = toIntegerOrInfinity(pos);
    var size = S.length;
    var first, second;
    if (position < 0 || position >= size) return CONVERT_TO_STRING ? '' : undefined;
    first = charCodeAt(S, position);
    return first < 0xD800 || first > 0xDBFF || position + 1 === size
      || (second = charCodeAt(S, position + 1)) < 0xDC00 || second > 0xDFFF
        ? CONVERT_TO_STRING
          ? charAt(S, position)
          : first
        : CONVERT_TO_STRING
          ? stringSlice(S, position, position + 2)
          : (first - 0xD800 << 10) + (second - 0xDC00) + 0x10000;
  };
};

module.exports = {
  // `String.prototype.codePointAt` method
  // https://tc39.es/ecma262/#sec-string.prototype.codepointat
  codeAt: createMethod(false),
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: createMethod(true)
};


/***/ }),

/***/ 3111:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);
var requireObjectCoercible = __webpack_require__(4488);
var toString = __webpack_require__(1340);
var whitespaces = __webpack_require__(1361);

var replace = uncurryThis(''.replace);
var ltrim = RegExp('^[' + whitespaces + ']+');
var rtrim = RegExp('(^|[^' + whitespaces + '])[' + whitespaces + ']+$');

// `String.prototype.{ trim, trimStart, trimEnd, trimLeft, trimRight }` methods implementation
var createMethod = function (TYPE) {
  return function ($this) {
    var string = toString(requireObjectCoercible($this));
    if (TYPE & 1) string = replace(string, ltrim, '');
    if (TYPE & 2) string = replace(string, rtrim, '$1');
    return string;
  };
};

module.exports = {
  // `String.prototype.{ trimLeft, trimStart }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimstart
  start: createMethod(1),
  // `String.prototype.{ trimRight, trimEnd }` methods
  // https://tc39.es/ecma262/#sec-string.prototype.trimend
  end: createMethod(2),
  // `String.prototype.trim` method
  // https://tc39.es/ecma262/#sec-string.prototype.trim
  trim: createMethod(3)
};


/***/ }),

/***/ 6293:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var V8_VERSION = __webpack_require__(7392);
var fails = __webpack_require__(7293);
var global = __webpack_require__(7854);

var $String = global.String;

// eslint-disable-next-line es/no-object-getownpropertysymbols -- required for testing
module.exports = !!Object.getOwnPropertySymbols && !fails(function () {
  var symbol = Symbol('symbol detection');
  // Chrome 38 Symbol has incorrect toString conversion
  // `get-own-property-symbols` polyfill symbols converted to object are not Symbol instances
  // nb: Do not call `String` directly to avoid this being optimized out to `symbol+''` which will,
  // of course, fail.
  return !$String(symbol) || !(Object(symbol) instanceof Symbol) ||
    // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
    !Symbol.sham && V8_VERSION && V8_VERSION < 41;
});


/***/ }),

/***/ 6532:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var getBuiltIn = __webpack_require__(5005);
var wellKnownSymbol = __webpack_require__(5112);
var defineBuiltIn = __webpack_require__(8052);

module.exports = function () {
  var Symbol = getBuiltIn('Symbol');
  var SymbolPrototype = Symbol && Symbol.prototype;
  var valueOf = SymbolPrototype && SymbolPrototype.valueOf;
  var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

  if (SymbolPrototype && !SymbolPrototype[TO_PRIMITIVE]) {
    // `Symbol.prototype[@@toPrimitive]` method
    // https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
    // eslint-disable-next-line no-unused-vars -- required for .length
    defineBuiltIn(SymbolPrototype, TO_PRIMITIVE, function (hint) {
      return call(valueOf, this);
    }, { arity: 1 });
  }
};


/***/ }),

/***/ 2015:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var NATIVE_SYMBOL = __webpack_require__(6293);

/* eslint-disable es/no-symbol -- safe */
module.exports = NATIVE_SYMBOL && !!Symbol['for'] && !!Symbol.keyFor;


/***/ }),

/***/ 261:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var bind = __webpack_require__(9974);
var isCallable = __webpack_require__(614);
var hasOwn = __webpack_require__(2597);
var fails = __webpack_require__(7293);
var html = __webpack_require__(490);
var arraySlice = __webpack_require__(206);
var createElement = __webpack_require__(317);
var validateArgumentsLength = __webpack_require__(8053);
var IS_IOS = __webpack_require__(6833);
var IS_NODE = __webpack_require__(5268);

var set = global.setImmediate;
var clear = global.clearImmediate;
var process = global.process;
var Dispatch = global.Dispatch;
var Function = global.Function;
var MessageChannel = global.MessageChannel;
var String = global.String;
var counter = 0;
var queue = {};
var ONREADYSTATECHANGE = 'onreadystatechange';
var $location, defer, channel, port;

fails(function () {
  // Deno throws a ReferenceError on `location` access without `--location` flag
  $location = global.location;
});

var run = function (id) {
  if (hasOwn(queue, id)) {
    var fn = queue[id];
    delete queue[id];
    fn();
  }
};

var runner = function (id) {
  return function () {
    run(id);
  };
};

var eventListener = function (event) {
  run(event.data);
};

var globalPostMessageDefer = function (id) {
  // old engines have not location.origin
  global.postMessage(String(id), $location.protocol + '//' + $location.host);
};

// Node.js 0.9+ & IE10+ has setImmediate, otherwise:
if (!set || !clear) {
  set = function setImmediate(handler) {
    validateArgumentsLength(arguments.length, 1);
    var fn = isCallable(handler) ? handler : Function(handler);
    var args = arraySlice(arguments, 1);
    queue[++counter] = function () {
      apply(fn, undefined, args);
    };
    defer(counter);
    return counter;
  };
  clear = function clearImmediate(id) {
    delete queue[id];
  };
  // Node.js 0.8-
  if (IS_NODE) {
    defer = function (id) {
      process.nextTick(runner(id));
    };
  // Sphere (JS game engine) Dispatch API
  } else if (Dispatch && Dispatch.now) {
    defer = function (id) {
      Dispatch.now(runner(id));
    };
  // Browsers with MessageChannel, includes WebWorkers
  // except iOS - https://github.com/zloirock/core-js/issues/624
  } else if (MessageChannel && !IS_IOS) {
    channel = new MessageChannel();
    port = channel.port2;
    channel.port1.onmessage = eventListener;
    defer = bind(port.postMessage, port);
  // Browsers with postMessage, skip WebWorkers
  // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
  } else if (
    global.addEventListener &&
    isCallable(global.postMessage) &&
    !global.importScripts &&
    $location && $location.protocol !== 'file:' &&
    !fails(globalPostMessageDefer)
  ) {
    defer = globalPostMessageDefer;
    global.addEventListener('message', eventListener, false);
  // IE8-
  } else if (ONREADYSTATECHANGE in createElement('script')) {
    defer = function (id) {
      html.appendChild(createElement('script'))[ONREADYSTATECHANGE] = function () {
        html.removeChild(this);
        run(id);
      };
    };
  // Rest old browsers
  } else {
    defer = function (id) {
      setTimeout(runner(id), 0);
    };
  }
}

module.exports = {
  set: set,
  clear: clear
};


/***/ }),

/***/ 863:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

// `thisNumberValue` abstract operation
// https://tc39.es/ecma262/#sec-thisnumbervalue
module.exports = uncurryThis(1.0.valueOf);


/***/ }),

/***/ 1400:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9303);

var max = Math.max;
var min = Math.min;

// Helper for a popular repeating case of the spec:
// Let integer be ? ToInteger(index).
// If integer < 0, let result be max((length + integer), 0); else let result be min(integer, length).
module.exports = function (index, length) {
  var integer = toIntegerOrInfinity(index);
  return integer < 0 ? max(integer + length, 0) : min(integer, length);
};


/***/ }),

/***/ 5656:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// toObject with fallback for non-array-like ES3 strings
var IndexedObject = __webpack_require__(8361);
var requireObjectCoercible = __webpack_require__(4488);

module.exports = function (it) {
  return IndexedObject(requireObjectCoercible(it));
};


/***/ }),

/***/ 9303:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var trunc = __webpack_require__(4758);

// `ToIntegerOrInfinity` abstract operation
// https://tc39.es/ecma262/#sec-tointegerorinfinity
module.exports = function (argument) {
  var number = +argument;
  // eslint-disable-next-line no-self-compare -- NaN check
  return number !== number || number === 0 ? 0 : trunc(number);
};


/***/ }),

/***/ 7466:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIntegerOrInfinity = __webpack_require__(9303);

var min = Math.min;

// `ToLength` abstract operation
// https://tc39.es/ecma262/#sec-tolength
module.exports = function (argument) {
  return argument > 0 ? min(toIntegerOrInfinity(argument), 0x1FFFFFFFFFFFFF) : 0; // 2 ** 53 - 1 == 9007199254740991
};


/***/ }),

/***/ 7908:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var requireObjectCoercible = __webpack_require__(4488);

var $Object = Object;

// `ToObject` abstract operation
// https://tc39.es/ecma262/#sec-toobject
module.exports = function (argument) {
  return $Object(requireObjectCoercible(argument));
};


/***/ }),

/***/ 7593:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var isObject = __webpack_require__(111);
var isSymbol = __webpack_require__(2190);
var getMethod = __webpack_require__(8173);
var ordinaryToPrimitive = __webpack_require__(2140);
var wellKnownSymbol = __webpack_require__(5112);

var $TypeError = TypeError;
var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');

// `ToPrimitive` abstract operation
// https://tc39.es/ecma262/#sec-toprimitive
module.exports = function (input, pref) {
  if (!isObject(input) || isSymbol(input)) return input;
  var exoticToPrim = getMethod(input, TO_PRIMITIVE);
  var result;
  if (exoticToPrim) {
    if (pref === undefined) pref = 'default';
    result = call(exoticToPrim, input, pref);
    if (!isObject(result) || isSymbol(result)) return result;
    throw $TypeError("Can't convert object to primitive value");
  }
  if (pref === undefined) pref = 'number';
  return ordinaryToPrimitive(input, pref);
};


/***/ }),

/***/ 4948:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toPrimitive = __webpack_require__(7593);
var isSymbol = __webpack_require__(2190);

// `ToPropertyKey` abstract operation
// https://tc39.es/ecma262/#sec-topropertykey
module.exports = function (argument) {
  var key = toPrimitive(argument, 'string');
  return isSymbol(key) ? key : key + '';
};


/***/ }),

/***/ 1694:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var test = {};

test[TO_STRING_TAG] = 'z';

module.exports = String(test) === '[object z]';


/***/ }),

/***/ 1340:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var classof = __webpack_require__(648);

var $String = String;

module.exports = function (argument) {
  if (classof(argument) === 'Symbol') throw TypeError('Cannot convert a Symbol value to a string');
  return $String(argument);
};


/***/ }),

/***/ 4038:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var IS_NODE = __webpack_require__(5268);

module.exports = function (name) {
  try {
    // eslint-disable-next-line no-new-func -- safe
    if (IS_NODE) return Function('return require("' + name + '")')();
  } catch (error) { /* empty */ }
};


/***/ }),

/***/ 6330:
/***/ (function(module) {

"use strict";

var $String = String;

module.exports = function (argument) {
  try {
    return $String(argument);
  } catch (error) {
    return 'Object';
  }
};


/***/ }),

/***/ 9711:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var uncurryThis = __webpack_require__(1702);

var id = 0;
var postfix = Math.random();
var toString = uncurryThis(1.0.toString);

module.exports = function (key) {
  return 'Symbol(' + (key === undefined ? '' : key) + ')_' + toString(++id + postfix, 36);
};


/***/ }),

/***/ 3307:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable es/no-symbol -- required for testing */
var NATIVE_SYMBOL = __webpack_require__(6293);

module.exports = NATIVE_SYMBOL
  && !Symbol.sham
  && typeof Symbol.iterator == 'symbol';


/***/ }),

/***/ 3353:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var fails = __webpack_require__(7293);

// V8 ~ Chrome 36-
// https://bugs.chromium.org/p/v8/issues/detail?id=3334
module.exports = DESCRIPTORS && fails(function () {
  // eslint-disable-next-line es/no-object-defineproperty -- required for testing
  return Object.defineProperty(function () { /* empty */ }, 'prototype', {
    value: 42,
    writable: false
  }).prototype !== 42;
});


/***/ }),

/***/ 8053:
/***/ (function(module) {

"use strict";

var $TypeError = TypeError;

module.exports = function (passed, required) {
  if (passed < required) throw $TypeError('Not enough arguments');
  return passed;
};


/***/ }),

/***/ 4811:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var isCallable = __webpack_require__(614);

var WeakMap = global.WeakMap;

module.exports = isCallable(WeakMap) && /native code/.test(String(WeakMap));


/***/ }),

/***/ 6800:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var path = __webpack_require__(857);
var hasOwn = __webpack_require__(2597);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineProperty = (__webpack_require__(3070).f);

module.exports = function (NAME) {
  var Symbol = path.Symbol || (path.Symbol = {});
  if (!hasOwn(Symbol, NAME)) defineProperty(Symbol, NAME, {
    value: wrappedWellKnownSymbolModule.f(NAME)
  });
};


/***/ }),

/***/ 6061:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

var wellKnownSymbol = __webpack_require__(5112);

exports.f = wellKnownSymbol;


/***/ }),

/***/ 5112:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var shared = __webpack_require__(2309);
var hasOwn = __webpack_require__(2597);
var uid = __webpack_require__(9711);
var NATIVE_SYMBOL = __webpack_require__(6293);
var USE_SYMBOL_AS_UID = __webpack_require__(3307);

var Symbol = global.Symbol;
var WellKnownSymbolsStore = shared('wks');
var createWellKnownSymbol = USE_SYMBOL_AS_UID ? Symbol['for'] || Symbol : Symbol && Symbol.withoutSetter || uid;

module.exports = function (name) {
  if (!hasOwn(WellKnownSymbolsStore, name)) {
    WellKnownSymbolsStore[name] = NATIVE_SYMBOL && hasOwn(Symbol, name)
      ? Symbol[name]
      : createWellKnownSymbol('Symbol.' + name);
  } return WellKnownSymbolsStore[name];
};


/***/ }),

/***/ 1361:
/***/ (function(module) {

"use strict";

// a string of all valid unicode whitespaces
module.exports = '\u0009\u000A\u000B\u000C\u000D\u0020\u00A0\u1680\u2000\u2001\u2002' +
  '\u2003\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF';


/***/ }),

/***/ 9191:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var createNonEnumerableProperty = __webpack_require__(8880);
var isPrototypeOf = __webpack_require__(7976);
var setPrototypeOf = __webpack_require__(7674);
var copyConstructorProperties = __webpack_require__(9920);
var proxyAccessor = __webpack_require__(2626);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var installErrorCause = __webpack_require__(8340);
var installErrorStack = __webpack_require__(5392);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

module.exports = function (FULL_NAME, wrapper, FORCED, IS_AGGREGATE_ERROR) {
  var STACK_TRACE_LIMIT = 'stackTraceLimit';
  var OPTIONS_POSITION = IS_AGGREGATE_ERROR ? 2 : 1;
  var path = FULL_NAME.split('.');
  var ERROR_NAME = path[path.length - 1];
  var OriginalError = getBuiltIn.apply(null, path);

  if (!OriginalError) return;

  var OriginalErrorPrototype = OriginalError.prototype;

  // V8 9.3- bug https://bugs.chromium.org/p/v8/issues/detail?id=12006
  if (!IS_PURE && hasOwn(OriginalErrorPrototype, 'cause')) delete OriginalErrorPrototype.cause;

  if (!FORCED) return OriginalError;

  var BaseError = getBuiltIn('Error');

  var WrappedError = wrapper(function (a, b) {
    var message = normalizeStringArgument(IS_AGGREGATE_ERROR ? b : a, undefined);
    var result = IS_AGGREGATE_ERROR ? new OriginalError(a) : new OriginalError();
    if (message !== undefined) createNonEnumerableProperty(result, 'message', message);
    installErrorStack(result, WrappedError, result.stack, 2);
    if (this && isPrototypeOf(OriginalErrorPrototype, this)) inheritIfRequired(result, this, WrappedError);
    if (arguments.length > OPTIONS_POSITION) installErrorCause(result, arguments[OPTIONS_POSITION]);
    return result;
  });

  WrappedError.prototype = OriginalErrorPrototype;

  if (ERROR_NAME !== 'Error') {
    if (setPrototypeOf) setPrototypeOf(WrappedError, BaseError);
    else copyConstructorProperties(WrappedError, BaseError, { name: true });
  } else if (DESCRIPTORS && STACK_TRACE_LIMIT in OriginalError) {
    proxyAccessor(WrappedError, OriginalError, STACK_TRACE_LIMIT);
    proxyAccessor(WrappedError, OriginalError, 'prepareStackTrace');
  }

  copyConstructorProperties(WrappedError, OriginalError);

  if (!IS_PURE) try {
    // Safari 13- bug: WebAssembly errors does not have a proper `.name`
    if (OriginalErrorPrototype.name !== ERROR_NAME) {
      createNonEnumerableProperty(OriginalErrorPrototype, 'name', ERROR_NAME);
    }
    OriginalErrorPrototype.constructor = WrappedError;
  } catch (error) { /* empty */ }

  return WrappedError;
};


/***/ }),

/***/ 2222:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var isArray = __webpack_require__(3157);
var isObject = __webpack_require__(111);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var createProperty = __webpack_require__(6135);
var arraySpeciesCreate = __webpack_require__(5417);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);
var wellKnownSymbol = __webpack_require__(5112);
var V8_VERSION = __webpack_require__(7392);

var IS_CONCAT_SPREADABLE = wellKnownSymbol('isConcatSpreadable');

// We can't use this feature detection in V8 since it causes
// deoptimization and serious performance degradation
// https://github.com/zloirock/core-js/issues/679
var IS_CONCAT_SPREADABLE_SUPPORT = V8_VERSION >= 51 || !fails(function () {
  var array = [];
  array[IS_CONCAT_SPREADABLE] = false;
  return array.concat()[0] !== array;
});

var isConcatSpreadable = function (O) {
  if (!isObject(O)) return false;
  var spreadable = O[IS_CONCAT_SPREADABLE];
  return spreadable !== undefined ? !!spreadable : isArray(O);
};

var FORCED = !IS_CONCAT_SPREADABLE_SUPPORT || !arrayMethodHasSpeciesSupport('concat');

// `Array.prototype.concat` method
// https://tc39.es/ecma262/#sec-array.prototype.concat
// with adding support of @@isConcatSpreadable and @@species
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function concat(arg) {
    var O = toObject(this);
    var A = arraySpeciesCreate(O, 0);
    var n = 0;
    var i, k, length, len, E;
    for (i = -1, length = arguments.length; i < length; i++) {
      E = i === -1 ? O : arguments[i];
      if (isConcatSpreadable(E)) {
        len = lengthOfArrayLike(E);
        doesNotExceedSafeInteger(n + len);
        for (k = 0; k < len; k++, n++) if (k in E) createProperty(A, n, E[k]);
      } else {
        doesNotExceedSafeInteger(n + 1);
        createProperty(A, n++, E);
      }
    }
    A.length = n;
    return A;
  }
});


/***/ }),

/***/ 7327:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $filter = (__webpack_require__(2092).filter);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('filter');

// `Array.prototype.filter` method
// https://tc39.es/ecma262/#sec-array.prototype.filter
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  filter: function filter(callbackfn /* , thisArg */) {
    return $filter(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 9826:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $find = (__webpack_require__(2092).find);
var addToUnscopables = __webpack_require__(1223);

var FIND = 'find';
var SKIPS_HOLES = true;

// Shouldn't skip holes
// eslint-disable-next-line es/no-array-prototype-find -- testing
if (FIND in []) Array(1)[FIND](function () { SKIPS_HOLES = false; });

// `Array.prototype.find` method
// https://tc39.es/ecma262/#sec-array.prototype.find
$({ target: 'Array', proto: true, forced: SKIPS_HOLES }, {
  find: function find(callbackfn /* , that = undefined */) {
    return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables(FIND);


/***/ }),

/***/ 1038:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var from = __webpack_require__(8457);
var checkCorrectnessOfIteration = __webpack_require__(7072);

var INCORRECT_ITERATION = !checkCorrectnessOfIteration(function (iterable) {
  // eslint-disable-next-line es/no-array-from -- required for testing
  Array.from(iterable);
});

// `Array.from` method
// https://tc39.es/ecma262/#sec-array.from
$({ target: 'Array', stat: true, forced: INCORRECT_ITERATION }, {
  from: from
});


/***/ }),

/***/ 6699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $includes = (__webpack_require__(1318).includes);
var fails = __webpack_require__(7293);
var addToUnscopables = __webpack_require__(1223);

// FF99+ bug
var BROKEN_ON_SPARSE = fails(function () {
  // eslint-disable-next-line es/no-array-prototype-includes -- detection
  return !Array(1).includes();
});

// `Array.prototype.includes` method
// https://tc39.es/ecma262/#sec-array.prototype.includes
$({ target: 'Array', proto: true, forced: BROKEN_ON_SPARSE }, {
  includes: function includes(el /* , fromIndex = 0 */) {
    return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
  }
});

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('includes');


/***/ }),

/***/ 6992:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var toIndexedObject = __webpack_require__(5656);
var addToUnscopables = __webpack_require__(1223);
var Iterators = __webpack_require__(7497);
var InternalStateModule = __webpack_require__(9909);
var defineProperty = (__webpack_require__(3070).f);
var defineIterator = __webpack_require__(1656);
var createIterResultObject = __webpack_require__(6178);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);

var ARRAY_ITERATOR = 'Array Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(ARRAY_ITERATOR);

// `Array.prototype.entries` method
// https://tc39.es/ecma262/#sec-array.prototype.entries
// `Array.prototype.keys` method
// https://tc39.es/ecma262/#sec-array.prototype.keys
// `Array.prototype.values` method
// https://tc39.es/ecma262/#sec-array.prototype.values
// `Array.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-array.prototype-@@iterator
// `CreateArrayIterator` internal method
// https://tc39.es/ecma262/#sec-createarrayiterator
module.exports = defineIterator(Array, 'Array', function (iterated, kind) {
  setInternalState(this, {
    type: ARRAY_ITERATOR,
    target: toIndexedObject(iterated), // target
    index: 0,                          // next index
    kind: kind                         // kind
  });
// `%ArrayIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%arrayiteratorprototype%.next
}, function () {
  var state = getInternalState(this);
  var target = state.target;
  var kind = state.kind;
  var index = state.index++;
  if (!target || index >= target.length) {
    state.target = undefined;
    return createIterResultObject(undefined, true);
  }
  switch (kind) {
    case 'keys': return createIterResultObject(index, false);
    case 'values': return createIterResultObject(target[index], false);
  } return createIterResultObject([index, target[index]], false);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values%
// https://tc39.es/ecma262/#sec-createunmappedargumentsobject
// https://tc39.es/ecma262/#sec-createmappedargumentsobject
var values = Iterators.Arguments = Iterators.Array;

// https://tc39.es/ecma262/#sec-array.prototype-@@unscopables
addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');

// V8 ~ Chrome 45- bug
if (!IS_PURE && DESCRIPTORS && values.name !== 'values') try {
  defineProperty(values, 'name', { value: 'values' });
} catch (error) { /* empty */ }


/***/ }),

/***/ 1249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var $map = (__webpack_require__(2092).map);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('map');

// `Array.prototype.map` method
// https://tc39.es/ecma262/#sec-array.prototype.map
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  map: function map(callbackfn /* , thisArg */) {
    return $map(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
  }
});


/***/ }),

/***/ 7658:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var fails = __webpack_require__(7293);

var INCORRECT_TO_LENGTH = fails(function () {
  return [].push.call({ length: 0x100000000 }, 1) !== 4294967297;
});

// V8 and Safari <= 15.4, FF < 23 throws InternalError
// https://bugs.chromium.org/p/v8/issues/detail?id=12681
var properErrorOnNonWritableLength = function () {
  try {
    // eslint-disable-next-line es/no-object-defineproperty -- safe
    Object.defineProperty([], 'length', { writable: false }).push();
  } catch (error) {
    return error instanceof TypeError;
  }
};

var FORCED = INCORRECT_TO_LENGTH || !properErrorOnNonWritableLength();

// `Array.prototype.push` method
// https://tc39.es/ecma262/#sec-array.prototype.push
$({ target: 'Array', proto: true, arity: 1, forced: FORCED }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  push: function push(item) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var argCount = arguments.length;
    doesNotExceedSafeInteger(len + argCount);
    for (var i = 0; i < argCount; i++) {
      O[len] = arguments[i];
      len++;
    }
    setArrayLength(O, len);
    return len;
  }
});


/***/ }),

/***/ 7042:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var isArray = __webpack_require__(3157);
var isConstructor = __webpack_require__(4411);
var isObject = __webpack_require__(111);
var toAbsoluteIndex = __webpack_require__(1400);
var lengthOfArrayLike = __webpack_require__(6244);
var toIndexedObject = __webpack_require__(5656);
var createProperty = __webpack_require__(6135);
var wellKnownSymbol = __webpack_require__(5112);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);
var nativeSlice = __webpack_require__(206);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('slice');

var SPECIES = wellKnownSymbol('species');
var $Array = Array;
var max = Math.max;

// `Array.prototype.slice` method
// https://tc39.es/ecma262/#sec-array.prototype.slice
// fallback for not array-like ES3 strings and DOM objects
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  slice: function slice(start, end) {
    var O = toIndexedObject(this);
    var length = lengthOfArrayLike(O);
    var k = toAbsoluteIndex(start, length);
    var fin = toAbsoluteIndex(end === undefined ? length : end, length);
    // inline `ArraySpeciesCreate` for usage native `Array#slice` where it's possible
    var Constructor, result, n;
    if (isArray(O)) {
      Constructor = O.constructor;
      // cross-realm fallback
      if (isConstructor(Constructor) && (Constructor === $Array || isArray(Constructor.prototype))) {
        Constructor = undefined;
      } else if (isObject(Constructor)) {
        Constructor = Constructor[SPECIES];
        if (Constructor === null) Constructor = undefined;
      }
      if (Constructor === $Array || Constructor === undefined) {
        return nativeSlice(O, k, fin);
      }
    }
    result = new (Constructor === undefined ? $Array : Constructor)(max(fin - k, 0));
    for (n = 0; k < fin; k++, n++) if (k in O) createProperty(result, n, O[k]);
    result.length = n;
    return result;
  }
});


/***/ }),

/***/ 2707:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var uncurryThis = __webpack_require__(1702);
var aCallable = __webpack_require__(9662);
var toObject = __webpack_require__(7908);
var lengthOfArrayLike = __webpack_require__(6244);
var deletePropertyOrThrow = __webpack_require__(5117);
var toString = __webpack_require__(1340);
var fails = __webpack_require__(7293);
var internalSort = __webpack_require__(4362);
var arrayMethodIsStrict = __webpack_require__(2133);
var FF = __webpack_require__(8886);
var IE_OR_EDGE = __webpack_require__(256);
var V8 = __webpack_require__(7392);
var WEBKIT = __webpack_require__(8008);

var test = [];
var nativeSort = uncurryThis(test.sort);
var push = uncurryThis(test.push);

// IE8-
var FAILS_ON_UNDEFINED = fails(function () {
  test.sort(undefined);
});
// V8 bug
var FAILS_ON_NULL = fails(function () {
  test.sort(null);
});
// Old WebKit
var STRICT_METHOD = arrayMethodIsStrict('sort');

var STABLE_SORT = !fails(function () {
  // feature detection can be too slow, so check engines versions
  if (V8) return V8 < 70;
  if (FF && FF > 3) return;
  if (IE_OR_EDGE) return true;
  if (WEBKIT) return WEBKIT < 603;

  var result = '';
  var code, chr, value, index;

  // generate an array with more 512 elements (Chakra and old V8 fails only in this case)
  for (code = 65; code < 76; code++) {
    chr = String.fromCharCode(code);

    switch (code) {
      case 66: case 69: case 70: case 72: value = 3; break;
      case 68: case 71: value = 4; break;
      default: value = 2;
    }

    for (index = 0; index < 47; index++) {
      test.push({ k: chr + index, v: value });
    }
  }

  test.sort(function (a, b) { return b.v - a.v; });

  for (index = 0; index < test.length; index++) {
    chr = test[index].k.charAt(0);
    if (result.charAt(result.length - 1) !== chr) result += chr;
  }

  return result !== 'DGBEFHACIJK';
});

var FORCED = FAILS_ON_UNDEFINED || !FAILS_ON_NULL || !STRICT_METHOD || !STABLE_SORT;

var getSortCompare = function (comparefn) {
  return function (x, y) {
    if (y === undefined) return -1;
    if (x === undefined) return 1;
    if (comparefn !== undefined) return +comparefn(x, y) || 0;
    return toString(x) > toString(y) ? 1 : -1;
  };
};

// `Array.prototype.sort` method
// https://tc39.es/ecma262/#sec-array.prototype.sort
$({ target: 'Array', proto: true, forced: FORCED }, {
  sort: function sort(comparefn) {
    if (comparefn !== undefined) aCallable(comparefn);

    var array = toObject(this);

    if (STABLE_SORT) return comparefn === undefined ? nativeSort(array) : nativeSort(array, comparefn);

    var items = [];
    var arrayLength = lengthOfArrayLike(array);
    var itemsLength, index;

    for (index = 0; index < arrayLength; index++) {
      if (index in array) push(items, array[index]);
    }

    internalSort(items, getSortCompare(comparefn));

    itemsLength = lengthOfArrayLike(items);
    index = 0;

    while (index < itemsLength) array[index] = items[index++];
    while (index < arrayLength) deletePropertyOrThrow(array, index++);

    return array;
  }
});


/***/ }),

/***/ 561:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var toAbsoluteIndex = __webpack_require__(1400);
var toIntegerOrInfinity = __webpack_require__(9303);
var lengthOfArrayLike = __webpack_require__(6244);
var setArrayLength = __webpack_require__(3658);
var doesNotExceedSafeInteger = __webpack_require__(7207);
var arraySpeciesCreate = __webpack_require__(5417);
var createProperty = __webpack_require__(6135);
var deletePropertyOrThrow = __webpack_require__(5117);
var arrayMethodHasSpeciesSupport = __webpack_require__(1194);

var HAS_SPECIES_SUPPORT = arrayMethodHasSpeciesSupport('splice');

var max = Math.max;
var min = Math.min;

// `Array.prototype.splice` method
// https://tc39.es/ecma262/#sec-array.prototype.splice
// with adding support of @@species
$({ target: 'Array', proto: true, forced: !HAS_SPECIES_SUPPORT }, {
  splice: function splice(start, deleteCount /* , ...items */) {
    var O = toObject(this);
    var len = lengthOfArrayLike(O);
    var actualStart = toAbsoluteIndex(start, len);
    var argumentsLength = arguments.length;
    var insertCount, actualDeleteCount, A, k, from, to;
    if (argumentsLength === 0) {
      insertCount = actualDeleteCount = 0;
    } else if (argumentsLength === 1) {
      insertCount = 0;
      actualDeleteCount = len - actualStart;
    } else {
      insertCount = argumentsLength - 2;
      actualDeleteCount = min(max(toIntegerOrInfinity(deleteCount), 0), len - actualStart);
    }
    doesNotExceedSafeInteger(len + insertCount - actualDeleteCount);
    A = arraySpeciesCreate(O, actualDeleteCount);
    for (k = 0; k < actualDeleteCount; k++) {
      from = actualStart + k;
      if (from in O) createProperty(A, k, O[from]);
    }
    A.length = actualDeleteCount;
    if (insertCount < actualDeleteCount) {
      for (k = actualStart; k < len - actualDeleteCount; k++) {
        from = k + actualDeleteCount;
        to = k + insertCount;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
      for (k = len; k > len - actualDeleteCount + insertCount; k--) deletePropertyOrThrow(O, k - 1);
    } else if (insertCount > actualDeleteCount) {
      for (k = len - actualDeleteCount; k > actualStart; k--) {
        from = k + actualDeleteCount - 1;
        to = k + insertCount - 1;
        if (from in O) O[to] = O[from];
        else deletePropertyOrThrow(O, to);
      }
    }
    for (k = 0; k < insertCount; k++) {
      O[k + actualStart] = arguments[k + 2];
    }
    setArrayLength(O, len - actualDeleteCount + insertCount);
    return A;
  }
});


/***/ }),

/***/ 6078:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var hasOwn = __webpack_require__(2597);
var defineBuiltIn = __webpack_require__(8052);
var dateToPrimitive = __webpack_require__(8709);
var wellKnownSymbol = __webpack_require__(5112);

var TO_PRIMITIVE = wellKnownSymbol('toPrimitive');
var DatePrototype = Date.prototype;

// `Date.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-date.prototype-@@toprimitive
if (!hasOwn(DatePrototype, TO_PRIMITIVE)) {
  defineBuiltIn(DatePrototype, TO_PRIMITIVE, dateToPrimitive);
}


/***/ }),

/***/ 1703:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

/* eslint-disable no-unused-vars -- required for functions `.length` */
var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var apply = __webpack_require__(2104);
var wrapErrorConstructorWithCause = __webpack_require__(9191);

var WEB_ASSEMBLY = 'WebAssembly';
var WebAssembly = global[WEB_ASSEMBLY];

var FORCED = Error('e', { cause: 7 }).cause !== 7;

var exportGlobalErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  var O = {};
  O[ERROR_NAME] = wrapErrorConstructorWithCause(ERROR_NAME, wrapper, FORCED);
  $({ global: true, constructor: true, arity: 1, forced: FORCED }, O);
};

var exportWebAssemblyErrorCauseWrapper = function (ERROR_NAME, wrapper) {
  if (WebAssembly && WebAssembly[ERROR_NAME]) {
    var O = {};
    O[ERROR_NAME] = wrapErrorConstructorWithCause(WEB_ASSEMBLY + '.' + ERROR_NAME, wrapper, FORCED);
    $({ target: WEB_ASSEMBLY, stat: true, constructor: true, arity: 1, forced: FORCED }, O);
  }
};

// https://tc39.es/ecma262/#sec-nativeerror
exportGlobalErrorCauseWrapper('Error', function (init) {
  return function Error(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('EvalError', function (init) {
  return function EvalError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('RangeError', function (init) {
  return function RangeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('ReferenceError', function (init) {
  return function ReferenceError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('SyntaxError', function (init) {
  return function SyntaxError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('TypeError', function (init) {
  return function TypeError(message) { return apply(init, this, arguments); };
});
exportGlobalErrorCauseWrapper('URIError', function (init) {
  return function URIError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('CompileError', function (init) {
  return function CompileError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('LinkError', function (init) {
  return function LinkError(message) { return apply(init, this, arguments); };
});
exportWebAssemblyErrorCauseWrapper('RuntimeError', function (init) {
  return function RuntimeError(message) { return apply(init, this, arguments); };
});


/***/ }),

/***/ 8309:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var FUNCTION_NAME_EXISTS = (__webpack_require__(6530).EXISTS);
var uncurryThis = __webpack_require__(1702);
var defineBuiltInAccessor = __webpack_require__(7045);

var FunctionPrototype = Function.prototype;
var functionToString = uncurryThis(FunctionPrototype.toString);
var nameRE = /function\b(?:\s|\/\*[\S\s]*?\*\/|\/\/[^\n\r]*[\n\r]+)*([^\s(/]*)/;
var regExpExec = uncurryThis(nameRE.exec);
var NAME = 'name';

// Function instances `.name` property
// https://tc39.es/ecma262/#sec-function-instances-name
if (DESCRIPTORS && !FUNCTION_NAME_EXISTS) {
  defineBuiltInAccessor(FunctionPrototype, NAME, {
    configurable: true,
    get: function () {
      try {
        return regExpExec(nameRE, functionToString(this))[1];
      } catch (error) {
        return '';
      }
    }
  });
}


/***/ }),

/***/ 8862:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var apply = __webpack_require__(2104);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var fails = __webpack_require__(7293);
var isCallable = __webpack_require__(614);
var isSymbol = __webpack_require__(2190);
var arraySlice = __webpack_require__(206);
var getReplacerFunction = __webpack_require__(8044);
var NATIVE_SYMBOL = __webpack_require__(6293);

var $String = String;
var $stringify = getBuiltIn('JSON', 'stringify');
var exec = uncurryThis(/./.exec);
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);
var replace = uncurryThis(''.replace);
var numberToString = uncurryThis(1.0.toString);

var tester = /[\uD800-\uDFFF]/g;
var low = /^[\uD800-\uDBFF]$/;
var hi = /^[\uDC00-\uDFFF]$/;

var WRONG_SYMBOLS_CONVERSION = !NATIVE_SYMBOL || fails(function () {
  var symbol = getBuiltIn('Symbol')('stringify detection');
  // MS Edge converts symbol values to JSON as {}
  return $stringify([symbol]) !== '[null]'
    // WebKit converts symbol values to JSON as null
    || $stringify({ a: symbol }) !== '{}'
    // V8 throws on boxed symbols
    || $stringify(Object(symbol)) !== '{}';
});

// https://github.com/tc39/proposal-well-formed-stringify
var ILL_FORMED_UNICODE = fails(function () {
  return $stringify('\uDF06\uD834') !== '"\\udf06\\ud834"'
    || $stringify('\uDEAD') !== '"\\udead"';
});

var stringifyWithSymbolsFix = function (it, replacer) {
  var args = arraySlice(arguments);
  var $replacer = getReplacerFunction(replacer);
  if (!isCallable($replacer) && (it === undefined || isSymbol(it))) return; // IE8 returns string on undefined
  args[1] = function (key, value) {
    // some old implementations (like WebKit) could pass numbers as keys
    if (isCallable($replacer)) value = call($replacer, this, $String(key), value);
    if (!isSymbol(value)) return value;
  };
  return apply($stringify, null, args);
};

var fixIllFormed = function (match, offset, string) {
  var prev = charAt(string, offset - 1);
  var next = charAt(string, offset + 1);
  if ((exec(low, match) && !exec(hi, next)) || (exec(hi, match) && !exec(low, prev))) {
    return '\\u' + numberToString(charCodeAt(match, 0), 16);
  } return match;
};

if ($stringify) {
  // `JSON.stringify` method
  // https://tc39.es/ecma262/#sec-json.stringify
  $({ target: 'JSON', stat: true, arity: 3, forced: WRONG_SYMBOLS_CONVERSION || ILL_FORMED_UNICODE }, {
    // eslint-disable-next-line no-unused-vars -- required for `.length`
    stringify: function stringify(it, replacer, space) {
      var args = arraySlice(arguments);
      var result = apply(WRONG_SYMBOLS_CONVERSION ? stringifyWithSymbolsFix : $stringify, null, args);
      return ILL_FORMED_UNICODE && typeof result == 'string' ? replace(result, tester, fixIllFormed) : result;
    }
  });
}


/***/ }),

/***/ 3706:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var setToStringTag = __webpack_require__(8003);

// JSON[@@toStringTag] property
// https://tc39.es/ecma262/#sec-json-@@tostringtag
setToStringTag(global.JSON, 'JSON', true);


/***/ }),

/***/ 408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var setToStringTag = __webpack_require__(8003);

// Math[@@toStringTag] property
// https://tc39.es/ecma262/#sec-math-@@tostringtag
setToStringTag(Math, 'Math', true);


/***/ }),

/***/ 9653:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var path = __webpack_require__(857);
var uncurryThis = __webpack_require__(1702);
var isForced = __webpack_require__(4705);
var hasOwn = __webpack_require__(2597);
var inheritIfRequired = __webpack_require__(9587);
var isPrototypeOf = __webpack_require__(7976);
var isSymbol = __webpack_require__(2190);
var toPrimitive = __webpack_require__(7593);
var fails = __webpack_require__(7293);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var defineProperty = (__webpack_require__(3070).f);
var thisNumberValue = __webpack_require__(863);
var trim = (__webpack_require__(3111).trim);

var NUMBER = 'Number';
var NativeNumber = global[NUMBER];
var PureNumberNamespace = path[NUMBER];
var NumberPrototype = NativeNumber.prototype;
var TypeError = global.TypeError;
var stringSlice = uncurryThis(''.slice);
var charCodeAt = uncurryThis(''.charCodeAt);

// `ToNumeric` abstract operation
// https://tc39.es/ecma262/#sec-tonumeric
var toNumeric = function (value) {
  var primValue = toPrimitive(value, 'number');
  return typeof primValue == 'bigint' ? primValue : toNumber(primValue);
};

// `ToNumber` abstract operation
// https://tc39.es/ecma262/#sec-tonumber
var toNumber = function (argument) {
  var it = toPrimitive(argument, 'number');
  var first, third, radix, maxCode, digits, length, index, code;
  if (isSymbol(it)) throw TypeError('Cannot convert a Symbol value to a number');
  if (typeof it == 'string' && it.length > 2) {
    it = trim(it);
    first = charCodeAt(it, 0);
    if (first === 43 || first === 45) {
      third = charCodeAt(it, 2);
      if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
    } else if (first === 48) {
      switch (charCodeAt(it, 1)) {
        case 66: case 98: radix = 2; maxCode = 49; break; // fast equal of /^0b[01]+$/i
        case 79: case 111: radix = 8; maxCode = 55; break; // fast equal of /^0o[0-7]+$/i
        default: return +it;
      }
      digits = stringSlice(it, 2);
      length = digits.length;
      for (index = 0; index < length; index++) {
        code = charCodeAt(digits, index);
        // parseInt parses a string to a first unavailable symbol
        // but ToNumber should return NaN if a string contains unavailable symbols
        if (code < 48 || code > maxCode) return NaN;
      } return parseInt(digits, radix);
    }
  } return +it;
};

var FORCED = isForced(NUMBER, !NativeNumber(' 0o1') || !NativeNumber('0b1') || NativeNumber('+0x1'));

var calledWithNew = function (dummy) {
  // includes check on 1..constructor(foo) case
  return isPrototypeOf(NumberPrototype, dummy) && fails(function () { thisNumberValue(dummy); });
};

// `Number` constructor
// https://tc39.es/ecma262/#sec-number-constructor
var NumberWrapper = function Number(value) {
  var n = arguments.length < 1 ? 0 : NativeNumber(toNumeric(value));
  return calledWithNew(this) ? inheritIfRequired(Object(n), this, NumberWrapper) : n;
};

NumberWrapper.prototype = NumberPrototype;
if (FORCED && !IS_PURE) NumberPrototype.constructor = NumberWrapper;

$({ global: true, constructor: true, wrap: true, forced: FORCED }, {
  Number: NumberWrapper
});

// Use `internal/copy-constructor-properties` helper in `core-js@4`
var copyConstructorProperties = function (target, source) {
  for (var keys = DESCRIPTORS ? getOwnPropertyNames(source) : (
    // ES3:
    'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
    // ES2015 (in case, if modules with ES2015 Number statics required before):
    'EPSILON,MAX_SAFE_INTEGER,MIN_SAFE_INTEGER,isFinite,isInteger,isNaN,isSafeInteger,parseFloat,parseInt,' +
    // ESNext
    'fromString,range'
  ).split(','), j = 0, key; keys.length > j; j++) {
    if (hasOwn(source, key = keys[j]) && !hasOwn(target, key)) {
      defineProperty(target, key, getOwnPropertyDescriptor(source, key));
    }
  }
};

if (IS_PURE && PureNumberNamespace) copyConstructorProperties(path[NUMBER], PureNumberNamespace);
if (FORCED || IS_PURE) copyConstructorProperties(path[NUMBER], NativeNumber);


/***/ }),

/***/ 5003:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var toIndexedObject = __webpack_require__(5656);
var nativeGetOwnPropertyDescriptor = (__webpack_require__(1236).f);
var DESCRIPTORS = __webpack_require__(9781);

var FORCED = !DESCRIPTORS || fails(function () { nativeGetOwnPropertyDescriptor(1); });

// `Object.getOwnPropertyDescriptor` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptor
$({ target: 'Object', stat: true, forced: FORCED, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptor: function getOwnPropertyDescriptor(it, key) {
    return nativeGetOwnPropertyDescriptor(toIndexedObject(it), key);
  }
});


/***/ }),

/***/ 9337:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var DESCRIPTORS = __webpack_require__(9781);
var ownKeys = __webpack_require__(3887);
var toIndexedObject = __webpack_require__(5656);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var createProperty = __webpack_require__(6135);

// `Object.getOwnPropertyDescriptors` method
// https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
$({ target: 'Object', stat: true, sham: !DESCRIPTORS }, {
  getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
    var O = toIndexedObject(object);
    var getOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
    var keys = ownKeys(O);
    var result = {};
    var index = 0;
    var key, descriptor;
    while (keys.length > index) {
      descriptor = getOwnPropertyDescriptor(O, key = keys[index++]);
      if (descriptor !== undefined) createProperty(result, key, descriptor);
    }
    return result;
  }
});


/***/ }),

/***/ 9660:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var toObject = __webpack_require__(7908);

// V8 ~ Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FORCED = !NATIVE_SYMBOL || fails(function () { getOwnPropertySymbolsModule.f(1); });

// `Object.getOwnPropertySymbols` method
// https://tc39.es/ecma262/#sec-object.getownpropertysymbols
$({ target: 'Object', stat: true, forced: FORCED }, {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    var $getOwnPropertySymbols = getOwnPropertySymbolsModule.f;
    return $getOwnPropertySymbols ? $getOwnPropertySymbols(toObject(it)) : [];
  }
});


/***/ }),

/***/ 489:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var fails = __webpack_require__(7293);
var toObject = __webpack_require__(7908);
var nativeGetPrototypeOf = __webpack_require__(9518);
var CORRECT_PROTOTYPE_GETTER = __webpack_require__(8544);

var FAILS_ON_PRIMITIVES = fails(function () { nativeGetPrototypeOf(1); });

// `Object.getPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.getprototypeof
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES, sham: !CORRECT_PROTOTYPE_GETTER }, {
  getPrototypeOf: function getPrototypeOf(it) {
    return nativeGetPrototypeOf(toObject(it));
  }
});



/***/ }),

/***/ 7941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var toObject = __webpack_require__(7908);
var nativeKeys = __webpack_require__(1956);
var fails = __webpack_require__(7293);

var FAILS_ON_PRIMITIVES = fails(function () { nativeKeys(1); });

// `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
$({ target: 'Object', stat: true, forced: FAILS_ON_PRIMITIVES }, {
  keys: function keys(it) {
    return nativeKeys(toObject(it));
  }
});


/***/ }),

/***/ 7987:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var defineBuiltInAccessor = __webpack_require__(7045);
var isObject = __webpack_require__(111);
var toObject = __webpack_require__(7908);
var requireObjectCoercible = __webpack_require__(4488);

// eslint-disable-next-line es/no-object-getprototypeof -- safe
var getPrototypeOf = Object.getPrototypeOf;
// eslint-disable-next-line es/no-object-setprototypeof -- safe
var setPrototypeOf = Object.setPrototypeOf;
var ObjectPrototype = Object.prototype;
var PROTO = '__proto__';

// `Object.prototype.__proto__` accessor
// https://tc39.es/ecma262/#sec-object.prototype.__proto__
if (DESCRIPTORS && getPrototypeOf && setPrototypeOf && !(PROTO in ObjectPrototype)) try {
  defineBuiltInAccessor(ObjectPrototype, PROTO, {
    configurable: true,
    get: function __proto__() {
      return getPrototypeOf(toObject(this));
    },
    set: function __proto__(proto) {
      var O = requireObjectCoercible(this);
      if (!isObject(proto) && proto !== null || !isObject(O)) return;
      setPrototypeOf(O, proto);
    }
  });
} catch (error) { /* empty */ }


/***/ }),

/***/ 8304:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var setPrototypeOf = __webpack_require__(7674);

// `Object.setPrototypeOf` method
// https://tc39.es/ecma262/#sec-object.setprototypeof
$({ target: 'Object', stat: true }, {
  setPrototypeOf: setPrototypeOf
});


/***/ }),

/***/ 1539:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var TO_STRING_TAG_SUPPORT = __webpack_require__(1694);
var defineBuiltIn = __webpack_require__(8052);
var toString = __webpack_require__(288);

// `Object.prototype.toString` method
// https://tc39.es/ecma262/#sec-object.prototype.tostring
if (!TO_STRING_TAG_SUPPORT) {
  defineBuiltIn(Object.prototype, 'toString', toString, { unsafe: true });
}


/***/ }),

/***/ 821:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(612);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(8368);

// `Promise.all` method
// https://tc39.es/ecma262/#sec-promise.all
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  all: function all(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var resolve = capability.resolve;
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      var values = [];
      var counter = 0;
      var remaining = 1;
      iterate(iterable, function (promise) {
        var index = counter++;
        var alreadyCalled = false;
        remaining++;
        call($promiseResolve, C, promise).then(function (value) {
          if (alreadyCalled) return;
          alreadyCalled = true;
          values[index] = value;
          --remaining || resolve(values);
        }, reject);
      });
      --remaining || resolve(values);
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 4164:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var NativePromiseConstructor = __webpack_require__(2492);
var getBuiltIn = __webpack_require__(5005);
var isCallable = __webpack_require__(614);
var defineBuiltIn = __webpack_require__(8052);

var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;

// `Promise.prototype.catch` method
// https://tc39.es/ecma262/#sec-promise.prototype.catch
$({ target: 'Promise', proto: true, forced: FORCED_PROMISE_CONSTRUCTOR, real: true }, {
  'catch': function (onRejected) {
    return this.then(undefined, onRejected);
  }
});

// makes sure that native promise-based APIs `Promise#catch` properly works with patched `Promise#then`
if (!IS_PURE && isCallable(NativePromiseConstructor)) {
  var method = getBuiltIn('Promise').prototype['catch'];
  if (NativePromisePrototype['catch'] !== method) {
    defineBuiltIn(NativePromisePrototype, 'catch', method, { unsafe: true });
  }
}


/***/ }),

/***/ 3401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var IS_PURE = __webpack_require__(1913);
var IS_NODE = __webpack_require__(5268);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var defineBuiltIn = __webpack_require__(8052);
var setPrototypeOf = __webpack_require__(7674);
var setToStringTag = __webpack_require__(8003);
var setSpecies = __webpack_require__(6340);
var aCallable = __webpack_require__(9662);
var isCallable = __webpack_require__(614);
var isObject = __webpack_require__(111);
var anInstance = __webpack_require__(5787);
var speciesConstructor = __webpack_require__(6707);
var task = (__webpack_require__(261).set);
var microtask = __webpack_require__(5948);
var hostReportErrors = __webpack_require__(842);
var perform = __webpack_require__(2534);
var Queue = __webpack_require__(8572);
var InternalStateModule = __webpack_require__(9909);
var NativePromiseConstructor = __webpack_require__(2492);
var PromiseConstructorDetection = __webpack_require__(3702);
var newPromiseCapabilityModule = __webpack_require__(8523);

var PROMISE = 'Promise';
var FORCED_PROMISE_CONSTRUCTOR = PromiseConstructorDetection.CONSTRUCTOR;
var NATIVE_PROMISE_REJECTION_EVENT = PromiseConstructorDetection.REJECTION_EVENT;
var NATIVE_PROMISE_SUBCLASSING = PromiseConstructorDetection.SUBCLASSING;
var getInternalPromiseState = InternalStateModule.getterFor(PROMISE);
var setInternalState = InternalStateModule.set;
var NativePromisePrototype = NativePromiseConstructor && NativePromiseConstructor.prototype;
var PromiseConstructor = NativePromiseConstructor;
var PromisePrototype = NativePromisePrototype;
var TypeError = global.TypeError;
var document = global.document;
var process = global.process;
var newPromiseCapability = newPromiseCapabilityModule.f;
var newGenericPromiseCapability = newPromiseCapability;

var DISPATCH_EVENT = !!(document && document.createEvent && global.dispatchEvent);
var UNHANDLED_REJECTION = 'unhandledrejection';
var REJECTION_HANDLED = 'rejectionhandled';
var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;
var HANDLED = 1;
var UNHANDLED = 2;

var Internal, OwnPromiseCapability, PromiseWrapper, nativeThen;

// helpers
var isThenable = function (it) {
  var then;
  return isObject(it) && isCallable(then = it.then) ? then : false;
};

var callReaction = function (reaction, state) {
  var value = state.value;
  var ok = state.state === FULFILLED;
  var handler = ok ? reaction.ok : reaction.fail;
  var resolve = reaction.resolve;
  var reject = reaction.reject;
  var domain = reaction.domain;
  var result, then, exited;
  try {
    if (handler) {
      if (!ok) {
        if (state.rejection === UNHANDLED) onHandleUnhandled(state);
        state.rejection = HANDLED;
      }
      if (handler === true) result = value;
      else {
        if (domain) domain.enter();
        result = handler(value); // can throw
        if (domain) {
          domain.exit();
          exited = true;
        }
      }
      if (result === reaction.promise) {
        reject(TypeError('Promise-chain cycle'));
      } else if (then = isThenable(result)) {
        call(then, result, resolve, reject);
      } else resolve(result);
    } else reject(value);
  } catch (error) {
    if (domain && !exited) domain.exit();
    reject(error);
  }
};

var notify = function (state, isReject) {
  if (state.notified) return;
  state.notified = true;
  microtask(function () {
    var reactions = state.reactions;
    var reaction;
    while (reaction = reactions.get()) {
      callReaction(reaction, state);
    }
    state.notified = false;
    if (isReject && !state.rejection) onUnhandled(state);
  });
};

var dispatchEvent = function (name, promise, reason) {
  var event, handler;
  if (DISPATCH_EVENT) {
    event = document.createEvent('Event');
    event.promise = promise;
    event.reason = reason;
    event.initEvent(name, false, true);
    global.dispatchEvent(event);
  } else event = { promise: promise, reason: reason };
  if (!NATIVE_PROMISE_REJECTION_EVENT && (handler = global['on' + name])) handler(event);
  else if (name === UNHANDLED_REJECTION) hostReportErrors('Unhandled promise rejection', reason);
};

var onUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    var value = state.value;
    var IS_UNHANDLED = isUnhandled(state);
    var result;
    if (IS_UNHANDLED) {
      result = perform(function () {
        if (IS_NODE) {
          process.emit('unhandledRejection', value, promise);
        } else dispatchEvent(UNHANDLED_REJECTION, promise, value);
      });
      // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
      state.rejection = IS_NODE || isUnhandled(state) ? UNHANDLED : HANDLED;
      if (result.error) throw result.value;
    }
  });
};

var isUnhandled = function (state) {
  return state.rejection !== HANDLED && !state.parent;
};

var onHandleUnhandled = function (state) {
  call(task, global, function () {
    var promise = state.facade;
    if (IS_NODE) {
      process.emit('rejectionHandled', promise);
    } else dispatchEvent(REJECTION_HANDLED, promise, state.value);
  });
};

var bind = function (fn, state, unwrap) {
  return function (value) {
    fn(state, value, unwrap);
  };
};

var internalReject = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  state.value = value;
  state.state = REJECTED;
  notify(state, true);
};

var internalResolve = function (state, value, unwrap) {
  if (state.done) return;
  state.done = true;
  if (unwrap) state = unwrap;
  try {
    if (state.facade === value) throw TypeError("Promise can't be resolved itself");
    var then = isThenable(value);
    if (then) {
      microtask(function () {
        var wrapper = { done: false };
        try {
          call(then, value,
            bind(internalResolve, wrapper, state),
            bind(internalReject, wrapper, state)
          );
        } catch (error) {
          internalReject(wrapper, error, state);
        }
      });
    } else {
      state.value = value;
      state.state = FULFILLED;
      notify(state, false);
    }
  } catch (error) {
    internalReject({ done: false }, error, state);
  }
};

// constructor polyfill
if (FORCED_PROMISE_CONSTRUCTOR) {
  // 25.4.3.1 Promise(executor)
  PromiseConstructor = function Promise(executor) {
    anInstance(this, PromisePrototype);
    aCallable(executor);
    call(Internal, this);
    var state = getInternalPromiseState(this);
    try {
      executor(bind(internalResolve, state), bind(internalReject, state));
    } catch (error) {
      internalReject(state, error);
    }
  };

  PromisePrototype = PromiseConstructor.prototype;

  // eslint-disable-next-line no-unused-vars -- required for `.length`
  Internal = function Promise(executor) {
    setInternalState(this, {
      type: PROMISE,
      done: false,
      notified: false,
      parent: false,
      reactions: new Queue(),
      rejection: false,
      state: PENDING,
      value: undefined
    });
  };

  // `Promise.prototype.then` method
  // https://tc39.es/ecma262/#sec-promise.prototype.then
  Internal.prototype = defineBuiltIn(PromisePrototype, 'then', function then(onFulfilled, onRejected) {
    var state = getInternalPromiseState(this);
    var reaction = newPromiseCapability(speciesConstructor(this, PromiseConstructor));
    state.parent = true;
    reaction.ok = isCallable(onFulfilled) ? onFulfilled : true;
    reaction.fail = isCallable(onRejected) && onRejected;
    reaction.domain = IS_NODE ? process.domain : undefined;
    if (state.state === PENDING) state.reactions.add(reaction);
    else microtask(function () {
      callReaction(reaction, state);
    });
    return reaction.promise;
  });

  OwnPromiseCapability = function () {
    var promise = new Internal();
    var state = getInternalPromiseState(promise);
    this.promise = promise;
    this.resolve = bind(internalResolve, state);
    this.reject = bind(internalReject, state);
  };

  newPromiseCapabilityModule.f = newPromiseCapability = function (C) {
    return C === PromiseConstructor || C === PromiseWrapper
      ? new OwnPromiseCapability(C)
      : newGenericPromiseCapability(C);
  };

  if (!IS_PURE && isCallable(NativePromiseConstructor) && NativePromisePrototype !== Object.prototype) {
    nativeThen = NativePromisePrototype.then;

    if (!NATIVE_PROMISE_SUBCLASSING) {
      // make `Promise#then` return a polyfilled `Promise` for native promise-based APIs
      defineBuiltIn(NativePromisePrototype, 'then', function then(onFulfilled, onRejected) {
        var that = this;
        return new PromiseConstructor(function (resolve, reject) {
          call(nativeThen, that, resolve, reject);
        }).then(onFulfilled, onRejected);
      // https://github.com/zloirock/core-js/issues/640
      }, { unsafe: true });
    }

    // make `.constructor === Promise` work for native promise-based APIs
    try {
      delete NativePromisePrototype.constructor;
    } catch (error) { /* empty */ }

    // make `instanceof Promise` work for native promise-based APIs
    if (setPrototypeOf) {
      setPrototypeOf(NativePromisePrototype, PromisePrototype);
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  Promise: PromiseConstructor
});

setToStringTag(PromiseConstructor, PROMISE, false, true);
setSpecies(PROMISE);


/***/ }),

/***/ 8674:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(3401);
__webpack_require__(821);
__webpack_require__(4164);
__webpack_require__(6027);
__webpack_require__(683);
__webpack_require__(6294);


/***/ }),

/***/ 6027:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var aCallable = __webpack_require__(9662);
var newPromiseCapabilityModule = __webpack_require__(8523);
var perform = __webpack_require__(2534);
var iterate = __webpack_require__(612);
var PROMISE_STATICS_INCORRECT_ITERATION = __webpack_require__(8368);

// `Promise.race` method
// https://tc39.es/ecma262/#sec-promise.race
$({ target: 'Promise', stat: true, forced: PROMISE_STATICS_INCORRECT_ITERATION }, {
  race: function race(iterable) {
    var C = this;
    var capability = newPromiseCapabilityModule.f(C);
    var reject = capability.reject;
    var result = perform(function () {
      var $promiseResolve = aCallable(C.resolve);
      iterate(iterable, function (promise) {
        call($promiseResolve, C, promise).then(capability.resolve, reject);
      });
    });
    if (result.error) reject(result.value);
    return capability.promise;
  }
});


/***/ }),

/***/ 683:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var newPromiseCapabilityModule = __webpack_require__(8523);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);

// `Promise.reject` method
// https://tc39.es/ecma262/#sec-promise.reject
$({ target: 'Promise', stat: true, forced: FORCED_PROMISE_CONSTRUCTOR }, {
  reject: function reject(r) {
    var capability = newPromiseCapabilityModule.f(this);
    call(capability.reject, undefined, r);
    return capability.promise;
  }
});


/***/ }),

/***/ 6294:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var IS_PURE = __webpack_require__(1913);
var NativePromiseConstructor = __webpack_require__(2492);
var FORCED_PROMISE_CONSTRUCTOR = (__webpack_require__(3702).CONSTRUCTOR);
var promiseResolve = __webpack_require__(9478);

var PromiseConstructorWrapper = getBuiltIn('Promise');
var CHECK_WRAPPER = IS_PURE && !FORCED_PROMISE_CONSTRUCTOR;

// `Promise.resolve` method
// https://tc39.es/ecma262/#sec-promise.resolve
$({ target: 'Promise', stat: true, forced: IS_PURE || FORCED_PROMISE_CONSTRUCTOR }, {
  resolve: function resolve(x) {
    return promiseResolve(CHECK_WRAPPER && this === PromiseConstructorWrapper ? NativePromiseConstructor : this, x);
  }
});


/***/ }),

/***/ 4603:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var isForced = __webpack_require__(4705);
var inheritIfRequired = __webpack_require__(9587);
var createNonEnumerableProperty = __webpack_require__(8880);
var getOwnPropertyNames = (__webpack_require__(8006).f);
var isPrototypeOf = __webpack_require__(7976);
var isRegExp = __webpack_require__(7850);
var toString = __webpack_require__(1340);
var getRegExpFlags = __webpack_require__(4706);
var stickyHelpers = __webpack_require__(2999);
var proxyAccessor = __webpack_require__(2626);
var defineBuiltIn = __webpack_require__(8052);
var fails = __webpack_require__(7293);
var hasOwn = __webpack_require__(2597);
var enforceInternalState = (__webpack_require__(9909).enforce);
var setSpecies = __webpack_require__(6340);
var wellKnownSymbol = __webpack_require__(5112);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var UNSUPPORTED_NCG = __webpack_require__(7168);

var MATCH = wellKnownSymbol('match');
var NativeRegExp = global.RegExp;
var RegExpPrototype = NativeRegExp.prototype;
var SyntaxError = global.SyntaxError;
var exec = uncurryThis(RegExpPrototype.exec);
var charAt = uncurryThis(''.charAt);
var replace = uncurryThis(''.replace);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);
// TODO: Use only proper RegExpIdentifierName
var IS_NCG = /^\?<[^\s\d!#%&*+<=>@^][^\s!#%&*+<=>@^]*>/;
var re1 = /a/g;
var re2 = /a/g;

// "new" should create a new object, old webkit bug
var CORRECT_NEW = new NativeRegExp(re1) !== re1;

var MISSED_STICKY = stickyHelpers.MISSED_STICKY;
var UNSUPPORTED_Y = stickyHelpers.UNSUPPORTED_Y;

var BASE_FORCED = DESCRIPTORS &&
  (!CORRECT_NEW || MISSED_STICKY || UNSUPPORTED_DOT_ALL || UNSUPPORTED_NCG || fails(function () {
    re2[MATCH] = false;
    // RegExp constructor can alter flags and IsRegExp works correct with @@match
    return NativeRegExp(re1) !== re1 || NativeRegExp(re2) === re2 || String(NativeRegExp(re1, 'i')) !== '/a/i';
  }));

var handleDotAll = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var brackets = false;
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      result += chr + charAt(string, ++index);
      continue;
    }
    if (!brackets && chr === '.') {
      result += '[\\s\\S]';
    } else {
      if (chr === '[') {
        brackets = true;
      } else if (chr === ']') {
        brackets = false;
      } result += chr;
    }
  } return result;
};

var handleNCG = function (string) {
  var length = string.length;
  var index = 0;
  var result = '';
  var named = [];
  var names = {};
  var brackets = false;
  var ncg = false;
  var groupid = 0;
  var groupname = '';
  var chr;
  for (; index <= length; index++) {
    chr = charAt(string, index);
    if (chr === '\\') {
      chr = chr + charAt(string, ++index);
    } else if (chr === ']') {
      brackets = false;
    } else if (!brackets) switch (true) {
      case chr === '[':
        brackets = true;
        break;
      case chr === '(':
        if (exec(IS_NCG, stringSlice(string, index + 1))) {
          index += 2;
          ncg = true;
        }
        result += chr;
        groupid++;
        continue;
      case chr === '>' && ncg:
        if (groupname === '' || hasOwn(names, groupname)) {
          throw new SyntaxError('Invalid capture group name');
        }
        names[groupname] = true;
        named[named.length] = [groupname, groupid];
        ncg = false;
        groupname = '';
        continue;
    }
    if (ncg) groupname += chr;
    else result += chr;
  } return [result, named];
};

// `RegExp` constructor
// https://tc39.es/ecma262/#sec-regexp-constructor
if (isForced('RegExp', BASE_FORCED)) {
  var RegExpWrapper = function RegExp(pattern, flags) {
    var thisIsRegExp = isPrototypeOf(RegExpPrototype, this);
    var patternIsRegExp = isRegExp(pattern);
    var flagsAreUndefined = flags === undefined;
    var groups = [];
    var rawPattern = pattern;
    var rawFlags, dotAll, sticky, handled, result, state;

    if (!thisIsRegExp && patternIsRegExp && flagsAreUndefined && pattern.constructor === RegExpWrapper) {
      return pattern;
    }

    if (patternIsRegExp || isPrototypeOf(RegExpPrototype, pattern)) {
      pattern = pattern.source;
      if (flagsAreUndefined) flags = getRegExpFlags(rawPattern);
    }

    pattern = pattern === undefined ? '' : toString(pattern);
    flags = flags === undefined ? '' : toString(flags);
    rawPattern = pattern;

    if (UNSUPPORTED_DOT_ALL && 'dotAll' in re1) {
      dotAll = !!flags && stringIndexOf(flags, 's') > -1;
      if (dotAll) flags = replace(flags, /s/g, '');
    }

    rawFlags = flags;

    if (MISSED_STICKY && 'sticky' in re1) {
      sticky = !!flags && stringIndexOf(flags, 'y') > -1;
      if (sticky && UNSUPPORTED_Y) flags = replace(flags, /y/g, '');
    }

    if (UNSUPPORTED_NCG) {
      handled = handleNCG(pattern);
      pattern = handled[0];
      groups = handled[1];
    }

    result = inheritIfRequired(NativeRegExp(pattern, flags), thisIsRegExp ? this : RegExpPrototype, RegExpWrapper);

    if (dotAll || sticky || groups.length) {
      state = enforceInternalState(result);
      if (dotAll) {
        state.dotAll = true;
        state.raw = RegExpWrapper(handleDotAll(pattern), rawFlags);
      }
      if (sticky) state.sticky = true;
      if (groups.length) state.groups = groups;
    }

    if (pattern !== rawPattern) try {
      // fails in old engines, but we have no alternatives for unsupported regex syntax
      createNonEnumerableProperty(result, 'source', rawPattern === '' ? '(?:)' : rawPattern);
    } catch (error) { /* empty */ }

    return result;
  };

  for (var keys = getOwnPropertyNames(NativeRegExp), index = 0; keys.length > index;) {
    proxyAccessor(RegExpWrapper, NativeRegExp, keys[index++]);
  }

  RegExpPrototype.constructor = RegExpWrapper;
  RegExpWrapper.prototype = RegExpPrototype;
  defineBuiltIn(global, 'RegExp', RegExpWrapper, { constructor: true });
}

// https://tc39.es/ecma262/#sec-get-regexp-@@species
setSpecies('RegExp');


/***/ }),

/***/ 8450:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var UNSUPPORTED_DOT_ALL = __webpack_require__(9441);
var classof = __webpack_require__(4326);
var defineBuiltInAccessor = __webpack_require__(7045);
var getInternalState = (__webpack_require__(9909).get);

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.dotAll` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.dotall
if (DESCRIPTORS && UNSUPPORTED_DOT_ALL) {
  defineBuiltInAccessor(RegExpPrototype, 'dotAll', {
    configurable: true,
    get: function dotAll() {
      if (this === RegExpPrototype) return undefined;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).dotAll;
      }
      throw $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 4916:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var exec = __webpack_require__(2261);

// `RegExp.prototype.exec` method
// https://tc39.es/ecma262/#sec-regexp.prototype.exec
$({ target: 'RegExp', proto: true, forced: /./.exec !== exec }, {
  exec: exec
});


/***/ }),

/***/ 8386:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var DESCRIPTORS = __webpack_require__(9781);
var MISSED_STICKY = (__webpack_require__(2999).MISSED_STICKY);
var classof = __webpack_require__(4326);
var defineBuiltInAccessor = __webpack_require__(7045);
var getInternalState = (__webpack_require__(9909).get);

var RegExpPrototype = RegExp.prototype;
var $TypeError = TypeError;

// `RegExp.prototype.sticky` getter
// https://tc39.es/ecma262/#sec-get-regexp.prototype.sticky
if (DESCRIPTORS && MISSED_STICKY) {
  defineBuiltInAccessor(RegExpPrototype, 'sticky', {
    configurable: true,
    get: function sticky() {
      if (this === RegExpPrototype) return;
      // We can't use InternalStateModule.getterFor because
      // we don't add metadata for regexps created by a literal.
      if (classof(this) === 'RegExp') {
        return !!getInternalState(this).sticky;
      }
      throw $TypeError('Incompatible receiver, RegExp required');
    }
  });
}


/***/ }),

/***/ 7601:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove from `core-js@4` since it's moved to entry points
__webpack_require__(4916);
var $ = __webpack_require__(2109);
var call = __webpack_require__(6916);
var isCallable = __webpack_require__(614);
var anObject = __webpack_require__(9670);
var toString = __webpack_require__(1340);

var DELEGATES_TO_EXEC = function () {
  var execCalled = false;
  var re = /[ac]/;
  re.exec = function () {
    execCalled = true;
    return /./.exec.apply(this, arguments);
  };
  return re.test('abc') === true && execCalled;
}();

var nativeTest = /./.test;

// `RegExp.prototype.test` method
// https://tc39.es/ecma262/#sec-regexp.prototype.test
$({ target: 'RegExp', proto: true, forced: !DELEGATES_TO_EXEC }, {
  test: function (S) {
    var R = anObject(this);
    var string = toString(S);
    var exec = R.exec;
    if (!isCallable(exec)) return call(nativeTest, R, string);
    var result = call(exec, R, string);
    if (result === null) return false;
    anObject(result);
    return true;
  }
});


/***/ }),

/***/ 9714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var PROPER_FUNCTION_NAME = (__webpack_require__(6530).PROPER);
var defineBuiltIn = __webpack_require__(8052);
var anObject = __webpack_require__(9670);
var $toString = __webpack_require__(1340);
var fails = __webpack_require__(7293);
var getRegExpFlags = __webpack_require__(4706);

var TO_STRING = 'toString';
var RegExpPrototype = RegExp.prototype;
var nativeToString = RegExpPrototype[TO_STRING];

var NOT_GENERIC = fails(function () { return nativeToString.call({ source: 'a', flags: 'b' }) !== '/a/b'; });
// FF44- RegExp#toString has a wrong name
var INCORRECT_NAME = PROPER_FUNCTION_NAME && nativeToString.name !== TO_STRING;

// `RegExp.prototype.toString` method
// https://tc39.es/ecma262/#sec-regexp.prototype.tostring
if (NOT_GENERIC || INCORRECT_NAME) {
  defineBuiltIn(RegExp.prototype, TO_STRING, function toString() {
    var R = anObject(this);
    var pattern = $toString(R.source);
    var flags = $toString(getRegExpFlags(R));
    return '/' + pattern + '/' + flags;
  }, { unsafe: true });
}


/***/ }),

/***/ 915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var createHTML = __webpack_require__(4230);
var forcedStringHTMLMethod = __webpack_require__(3429);

// `String.prototype.bold` method
// https://tc39.es/ecma262/#sec-string.prototype.bold
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('bold') }, {
  bold: function bold() {
    return createHTML(this, 'b', '', '');
  }
});


/***/ }),

/***/ 2023:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var uncurryThis = __webpack_require__(1702);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(4488);
var toString = __webpack_require__(1340);
var correctIsRegExpLogic = __webpack_require__(4964);

var stringIndexOf = uncurryThis(''.indexOf);

// `String.prototype.includes` method
// https://tc39.es/ecma262/#sec-string.prototype.includes
$({ target: 'String', proto: true, forced: !correctIsRegExpLogic('includes') }, {
  includes: function includes(searchString /* , position = 0 */) {
    return !!~stringIndexOf(
      toString(requireObjectCoercible(this)),
      toString(notARegExp(searchString)),
      arguments.length > 1 ? arguments[1] : undefined
    );
  }
});


/***/ }),

/***/ 8734:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var createHTML = __webpack_require__(4230);
var forcedStringHTMLMethod = __webpack_require__(3429);

// `String.prototype.italics` method
// https://tc39.es/ecma262/#sec-string.prototype.italics
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('italics') }, {
  italics: function italics() {
    return createHTML(this, 'i', '', '');
  }
});


/***/ }),

/***/ 8783:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var charAt = (__webpack_require__(8710).charAt);
var toString = __webpack_require__(1340);
var InternalStateModule = __webpack_require__(9909);
var defineIterator = __webpack_require__(1656);
var createIterResultObject = __webpack_require__(6178);

var STRING_ITERATOR = 'String Iterator';
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(STRING_ITERATOR);

// `String.prototype[@@iterator]` method
// https://tc39.es/ecma262/#sec-string.prototype-@@iterator
defineIterator(String, 'String', function (iterated) {
  setInternalState(this, {
    type: STRING_ITERATOR,
    string: toString(iterated),
    index: 0
  });
// `%StringIteratorPrototype%.next` method
// https://tc39.es/ecma262/#sec-%stringiteratorprototype%.next
}, function next() {
  var state = getInternalState(this);
  var string = state.string;
  var index = state.index;
  var point;
  if (index >= string.length) return createIterResultObject(undefined, true);
  point = charAt(string, index);
  state.index += point.length;
  return createIterResultObject(point, false);
});


/***/ }),

/***/ 4723:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var anObject = __webpack_require__(9670);
var isNullOrUndefined = __webpack_require__(8554);
var toLength = __webpack_require__(7466);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);
var getMethod = __webpack_require__(8173);
var advanceStringIndex = __webpack_require__(1530);
var regExpExec = __webpack_require__(7651);

// @@match logic
fixRegExpWellKnownSymbolLogic('match', function (MATCH, nativeMatch, maybeCallNative) {
  return [
    // `String.prototype.match` method
    // https://tc39.es/ecma262/#sec-string.prototype.match
    function match(regexp) {
      var O = requireObjectCoercible(this);
      var matcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, MATCH);
      return matcher ? call(matcher, regexp, O) : new RegExp(regexp)[MATCH](toString(O));
    },
    // `RegExp.prototype[@@match]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@match
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeMatch, rx, S);

      if (res.done) return res.value;

      if (!rx.global) return regExpExec(rx, S);

      var fullUnicode = rx.unicode;
      rx.lastIndex = 0;
      var A = [];
      var n = 0;
      var result;
      while ((result = regExpExec(rx, S)) !== null) {
        var matchStr = toString(result[0]);
        A[n] = matchStr;
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
        n++;
      }
      return n === 0 ? null : A;
    }
  ];
});


/***/ }),

/***/ 5306:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var apply = __webpack_require__(2104);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var fails = __webpack_require__(7293);
var anObject = __webpack_require__(9670);
var isCallable = __webpack_require__(614);
var isNullOrUndefined = __webpack_require__(8554);
var toIntegerOrInfinity = __webpack_require__(9303);
var toLength = __webpack_require__(7466);
var toString = __webpack_require__(1340);
var requireObjectCoercible = __webpack_require__(4488);
var advanceStringIndex = __webpack_require__(1530);
var getMethod = __webpack_require__(8173);
var getSubstitution = __webpack_require__(647);
var regExpExec = __webpack_require__(7651);
var wellKnownSymbol = __webpack_require__(5112);

var REPLACE = wellKnownSymbol('replace');
var max = Math.max;
var min = Math.min;
var concat = uncurryThis([].concat);
var push = uncurryThis([].push);
var stringIndexOf = uncurryThis(''.indexOf);
var stringSlice = uncurryThis(''.slice);

var maybeToString = function (it) {
  return it === undefined ? it : String(it);
};

// IE <= 11 replaces $0 with the whole match, as if it was $&
// https://stackoverflow.com/questions/6024666/getting-ie-to-replace-a-regex-with-the-literal-string-0
var REPLACE_KEEPS_$0 = (function () {
  // eslint-disable-next-line regexp/prefer-escape-replacement-dollar-char -- required for testing
  return 'a'.replace(/./, '$0') === '$0';
})();

// Safari <= 13.0.3(?) substitutes nth capture where n>m with an empty string
var REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE = (function () {
  if (/./[REPLACE]) {
    return /./[REPLACE]('a', '$0') === '';
  }
  return false;
})();

var REPLACE_SUPPORTS_NAMED_GROUPS = !fails(function () {
  var re = /./;
  re.exec = function () {
    var result = [];
    result.groups = { a: '7' };
    return result;
  };
  // eslint-disable-next-line regexp/no-useless-dollar-replacements -- false positive
  return ''.replace(re, '$<a>') !== '7';
});

// @@replace logic
fixRegExpWellKnownSymbolLogic('replace', function (_, nativeReplace, maybeCallNative) {
  var UNSAFE_SUBSTITUTE = REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE ? '$' : '$0';

  return [
    // `String.prototype.replace` method
    // https://tc39.es/ecma262/#sec-string.prototype.replace
    function replace(searchValue, replaceValue) {
      var O = requireObjectCoercible(this);
      var replacer = isNullOrUndefined(searchValue) ? undefined : getMethod(searchValue, REPLACE);
      return replacer
        ? call(replacer, searchValue, O, replaceValue)
        : call(nativeReplace, toString(O), searchValue, replaceValue);
    },
    // `RegExp.prototype[@@replace]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@replace
    function (string, replaceValue) {
      var rx = anObject(this);
      var S = toString(string);

      if (
        typeof replaceValue == 'string' &&
        stringIndexOf(replaceValue, UNSAFE_SUBSTITUTE) === -1 &&
        stringIndexOf(replaceValue, '$<') === -1
      ) {
        var res = maybeCallNative(nativeReplace, rx, S, replaceValue);
        if (res.done) return res.value;
      }

      var functionalReplace = isCallable(replaceValue);
      if (!functionalReplace) replaceValue = toString(replaceValue);

      var global = rx.global;
      var fullUnicode;
      if (global) {
        fullUnicode = rx.unicode;
        rx.lastIndex = 0;
      }

      var results = [];
      var result;
      while (true) {
        result = regExpExec(rx, S);
        if (result === null) break;

        push(results, result);
        if (!global) break;

        var matchStr = toString(result[0]);
        if (matchStr === '') rx.lastIndex = advanceStringIndex(S, toLength(rx.lastIndex), fullUnicode);
      }

      var accumulatedResult = '';
      var nextSourcePosition = 0;
      for (var i = 0; i < results.length; i++) {
        result = results[i];

        var matched = toString(result[0]);
        var position = max(min(toIntegerOrInfinity(result.index), S.length), 0);
        var captures = [];
        var replacement;
        // NOTE: This is equivalent to
        //   captures = result.slice(1).map(maybeToString)
        // but for some reason `nativeSlice.call(result, 1, result.length)` (called in
        // the slice polyfill when slicing native arrays) "doesn't work" in safari 9 and
        // causes a crash (https://pastebin.com/N21QzeQA) when trying to debug it.
        for (var j = 1; j < result.length; j++) push(captures, maybeToString(result[j]));
        var namedCaptures = result.groups;
        if (functionalReplace) {
          var replacerArgs = concat([matched], captures, position, S);
          if (namedCaptures !== undefined) push(replacerArgs, namedCaptures);
          replacement = toString(apply(replaceValue, undefined, replacerArgs));
        } else {
          replacement = getSubstitution(matched, S, position, captures, namedCaptures, replaceValue);
        }
        if (position >= nextSourcePosition) {
          accumulatedResult += stringSlice(S, nextSourcePosition, position) + replacement;
          nextSourcePosition = position + matched.length;
        }
      }

      return accumulatedResult + stringSlice(S, nextSourcePosition);
    }
  ];
}, !REPLACE_SUPPORTS_NAMED_GROUPS || !REPLACE_KEEPS_$0 || REGEXP_REPLACE_SUBSTITUTES_UNDEFINED_CAPTURE);


/***/ }),

/***/ 4765:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var call = __webpack_require__(6916);
var fixRegExpWellKnownSymbolLogic = __webpack_require__(7007);
var anObject = __webpack_require__(9670);
var isNullOrUndefined = __webpack_require__(8554);
var requireObjectCoercible = __webpack_require__(4488);
var sameValue = __webpack_require__(1150);
var toString = __webpack_require__(1340);
var getMethod = __webpack_require__(8173);
var regExpExec = __webpack_require__(7651);

// @@search logic
fixRegExpWellKnownSymbolLogic('search', function (SEARCH, nativeSearch, maybeCallNative) {
  return [
    // `String.prototype.search` method
    // https://tc39.es/ecma262/#sec-string.prototype.search
    function search(regexp) {
      var O = requireObjectCoercible(this);
      var searcher = isNullOrUndefined(regexp) ? undefined : getMethod(regexp, SEARCH);
      return searcher ? call(searcher, regexp, O) : new RegExp(regexp)[SEARCH](toString(O));
    },
    // `RegExp.prototype[@@search]` method
    // https://tc39.es/ecma262/#sec-regexp.prototype-@@search
    function (string) {
      var rx = anObject(this);
      var S = toString(string);
      var res = maybeCallNative(nativeSearch, rx, S);

      if (res.done) return res.value;

      var previousLastIndex = rx.lastIndex;
      if (!sameValue(previousLastIndex, 0)) rx.lastIndex = 0;
      var result = regExpExec(rx, S);
      if (!sameValue(rx.lastIndex, previousLastIndex)) rx.lastIndex = previousLastIndex;
      return result === null ? -1 : result.index;
    }
  ];
});


/***/ }),

/***/ 7268:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var createHTML = __webpack_require__(4230);
var forcedStringHTMLMethod = __webpack_require__(3429);

// `String.prototype.small` method
// https://tc39.es/ecma262/#sec-string.prototype.small
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('small') }, {
  small: function small() {
    return createHTML(this, 'small', '', '');
  }
});


/***/ }),

/***/ 6755:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var uncurryThis = __webpack_require__(1470);
var getOwnPropertyDescriptor = (__webpack_require__(1236).f);
var toLength = __webpack_require__(7466);
var toString = __webpack_require__(1340);
var notARegExp = __webpack_require__(3929);
var requireObjectCoercible = __webpack_require__(4488);
var correctIsRegExpLogic = __webpack_require__(4964);
var IS_PURE = __webpack_require__(1913);

// eslint-disable-next-line es/no-string-prototype-startswith -- safe
var nativeStartsWith = uncurryThis(''.startsWith);
var stringSlice = uncurryThis(''.slice);
var min = Math.min;

var CORRECT_IS_REGEXP_LOGIC = correctIsRegExpLogic('startsWith');
// https://github.com/zloirock/core-js/pull/702
var MDN_POLYFILL_BUG = !IS_PURE && !CORRECT_IS_REGEXP_LOGIC && !!function () {
  var descriptor = getOwnPropertyDescriptor(String.prototype, 'startsWith');
  return descriptor && !descriptor.writable;
}();

// `String.prototype.startsWith` method
// https://tc39.es/ecma262/#sec-string.prototype.startswith
$({ target: 'String', proto: true, forced: !MDN_POLYFILL_BUG && !CORRECT_IS_REGEXP_LOGIC }, {
  startsWith: function startsWith(searchString /* , position = 0 */) {
    var that = toString(requireObjectCoercible(this));
    notARegExp(searchString);
    var index = toLength(min(arguments.length > 1 ? arguments[1] : undefined, that.length));
    var search = toString(searchString);
    return nativeStartsWith
      ? nativeStartsWith(that, search, index)
      : stringSlice(that, index, index + search.length) === search;
  }
});


/***/ }),

/***/ 7397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var createHTML = __webpack_require__(4230);
var forcedStringHTMLMethod = __webpack_require__(3429);

// `String.prototype.strike` method
// https://tc39.es/ecma262/#sec-string.prototype.strike
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('strike') }, {
  strike: function strike() {
    return createHTML(this, 'strike', '', '');
  }
});


/***/ }),

/***/ 2443:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(6800);

// `Symbol.asyncIterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.asynciterator
defineWellKnownSymbol('asyncIterator');


/***/ }),

/***/ 4032:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var call = __webpack_require__(6916);
var uncurryThis = __webpack_require__(1702);
var IS_PURE = __webpack_require__(1913);
var DESCRIPTORS = __webpack_require__(9781);
var NATIVE_SYMBOL = __webpack_require__(6293);
var fails = __webpack_require__(7293);
var hasOwn = __webpack_require__(2597);
var isPrototypeOf = __webpack_require__(7976);
var anObject = __webpack_require__(9670);
var toIndexedObject = __webpack_require__(5656);
var toPropertyKey = __webpack_require__(4948);
var $toString = __webpack_require__(1340);
var createPropertyDescriptor = __webpack_require__(9114);
var nativeObjectCreate = __webpack_require__(30);
var objectKeys = __webpack_require__(1956);
var getOwnPropertyNamesModule = __webpack_require__(8006);
var getOwnPropertyNamesExternal = __webpack_require__(1156);
var getOwnPropertySymbolsModule = __webpack_require__(5181);
var getOwnPropertyDescriptorModule = __webpack_require__(1236);
var definePropertyModule = __webpack_require__(3070);
var definePropertiesModule = __webpack_require__(6048);
var propertyIsEnumerableModule = __webpack_require__(5296);
var defineBuiltIn = __webpack_require__(8052);
var defineBuiltInAccessor = __webpack_require__(7045);
var shared = __webpack_require__(2309);
var sharedKey = __webpack_require__(6200);
var hiddenKeys = __webpack_require__(3501);
var uid = __webpack_require__(9711);
var wellKnownSymbol = __webpack_require__(5112);
var wrappedWellKnownSymbolModule = __webpack_require__(6061);
var defineWellKnownSymbol = __webpack_require__(6800);
var defineSymbolToPrimitive = __webpack_require__(6532);
var setToStringTag = __webpack_require__(8003);
var InternalStateModule = __webpack_require__(9909);
var $forEach = (__webpack_require__(2092).forEach);

var HIDDEN = sharedKey('hidden');
var SYMBOL = 'Symbol';
var PROTOTYPE = 'prototype';

var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(SYMBOL);

var ObjectPrototype = Object[PROTOTYPE];
var $Symbol = global.Symbol;
var SymbolPrototype = $Symbol && $Symbol[PROTOTYPE];
var TypeError = global.TypeError;
var QObject = global.QObject;
var nativeGetOwnPropertyDescriptor = getOwnPropertyDescriptorModule.f;
var nativeDefineProperty = definePropertyModule.f;
var nativeGetOwnPropertyNames = getOwnPropertyNamesExternal.f;
var nativePropertyIsEnumerable = propertyIsEnumerableModule.f;
var push = uncurryThis([].push);

var AllSymbols = shared('symbols');
var ObjectPrototypeSymbols = shared('op-symbols');
var WellKnownSymbolsStore = shared('wks');

// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var USE_SETTER = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDescriptor = DESCRIPTORS && fails(function () {
  return nativeObjectCreate(nativeDefineProperty({}, 'a', {
    get: function () { return nativeDefineProperty(this, 'a', { value: 7 }).a; }
  })).a !== 7;
}) ? function (O, P, Attributes) {
  var ObjectPrototypeDescriptor = nativeGetOwnPropertyDescriptor(ObjectPrototype, P);
  if (ObjectPrototypeDescriptor) delete ObjectPrototype[P];
  nativeDefineProperty(O, P, Attributes);
  if (ObjectPrototypeDescriptor && O !== ObjectPrototype) {
    nativeDefineProperty(ObjectPrototype, P, ObjectPrototypeDescriptor);
  }
} : nativeDefineProperty;

var wrap = function (tag, description) {
  var symbol = AllSymbols[tag] = nativeObjectCreate(SymbolPrototype);
  setInternalState(symbol, {
    type: SYMBOL,
    tag: tag,
    description: description
  });
  if (!DESCRIPTORS) symbol.description = description;
  return symbol;
};

var $defineProperty = function defineProperty(O, P, Attributes) {
  if (O === ObjectPrototype) $defineProperty(ObjectPrototypeSymbols, P, Attributes);
  anObject(O);
  var key = toPropertyKey(P);
  anObject(Attributes);
  if (hasOwn(AllSymbols, key)) {
    if (!Attributes.enumerable) {
      if (!hasOwn(O, HIDDEN)) nativeDefineProperty(O, HIDDEN, createPropertyDescriptor(1, {}));
      O[HIDDEN][key] = true;
    } else {
      if (hasOwn(O, HIDDEN) && O[HIDDEN][key]) O[HIDDEN][key] = false;
      Attributes = nativeObjectCreate(Attributes, { enumerable: createPropertyDescriptor(0, false) });
    } return setSymbolDescriptor(O, key, Attributes);
  } return nativeDefineProperty(O, key, Attributes);
};

var $defineProperties = function defineProperties(O, Properties) {
  anObject(O);
  var properties = toIndexedObject(Properties);
  var keys = objectKeys(properties).concat($getOwnPropertySymbols(properties));
  $forEach(keys, function (key) {
    if (!DESCRIPTORS || call($propertyIsEnumerable, properties, key)) $defineProperty(O, key, properties[key]);
  });
  return O;
};

var $create = function create(O, Properties) {
  return Properties === undefined ? nativeObjectCreate(O) : $defineProperties(nativeObjectCreate(O), Properties);
};

var $propertyIsEnumerable = function propertyIsEnumerable(V) {
  var P = toPropertyKey(V);
  var enumerable = call(nativePropertyIsEnumerable, this, P);
  if (this === ObjectPrototype && hasOwn(AllSymbols, P) && !hasOwn(ObjectPrototypeSymbols, P)) return false;
  return enumerable || !hasOwn(this, P) || !hasOwn(AllSymbols, P) || hasOwn(this, HIDDEN) && this[HIDDEN][P]
    ? enumerable : true;
};

var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(O, P) {
  var it = toIndexedObject(O);
  var key = toPropertyKey(P);
  if (it === ObjectPrototype && hasOwn(AllSymbols, key) && !hasOwn(ObjectPrototypeSymbols, key)) return;
  var descriptor = nativeGetOwnPropertyDescriptor(it, key);
  if (descriptor && hasOwn(AllSymbols, key) && !(hasOwn(it, HIDDEN) && it[HIDDEN][key])) {
    descriptor.enumerable = true;
  }
  return descriptor;
};

var $getOwnPropertyNames = function getOwnPropertyNames(O) {
  var names = nativeGetOwnPropertyNames(toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (!hasOwn(AllSymbols, key) && !hasOwn(hiddenKeys, key)) push(result, key);
  });
  return result;
};

var $getOwnPropertySymbols = function (O) {
  var IS_OBJECT_PROTOTYPE = O === ObjectPrototype;
  var names = nativeGetOwnPropertyNames(IS_OBJECT_PROTOTYPE ? ObjectPrototypeSymbols : toIndexedObject(O));
  var result = [];
  $forEach(names, function (key) {
    if (hasOwn(AllSymbols, key) && (!IS_OBJECT_PROTOTYPE || hasOwn(ObjectPrototype, key))) {
      push(result, AllSymbols[key]);
    }
  });
  return result;
};

// `Symbol` constructor
// https://tc39.es/ecma262/#sec-symbol-constructor
if (!NATIVE_SYMBOL) {
  $Symbol = function Symbol() {
    if (isPrototypeOf(SymbolPrototype, this)) throw TypeError('Symbol is not a constructor');
    var description = !arguments.length || arguments[0] === undefined ? undefined : $toString(arguments[0]);
    var tag = uid(description);
    var setter = function (value) {
      if (this === ObjectPrototype) call(setter, ObjectPrototypeSymbols, value);
      if (hasOwn(this, HIDDEN) && hasOwn(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDescriptor(this, tag, createPropertyDescriptor(1, value));
    };
    if (DESCRIPTORS && USE_SETTER) setSymbolDescriptor(ObjectPrototype, tag, { configurable: true, set: setter });
    return wrap(tag, description);
  };

  SymbolPrototype = $Symbol[PROTOTYPE];

  defineBuiltIn(SymbolPrototype, 'toString', function toString() {
    return getInternalState(this).tag;
  });

  defineBuiltIn($Symbol, 'withoutSetter', function (description) {
    return wrap(uid(description), description);
  });

  propertyIsEnumerableModule.f = $propertyIsEnumerable;
  definePropertyModule.f = $defineProperty;
  definePropertiesModule.f = $defineProperties;
  getOwnPropertyDescriptorModule.f = $getOwnPropertyDescriptor;
  getOwnPropertyNamesModule.f = getOwnPropertyNamesExternal.f = $getOwnPropertyNames;
  getOwnPropertySymbolsModule.f = $getOwnPropertySymbols;

  wrappedWellKnownSymbolModule.f = function (name) {
    return wrap(wellKnownSymbol(name), name);
  };

  if (DESCRIPTORS) {
    // https://github.com/tc39/proposal-Symbol-description
    defineBuiltInAccessor(SymbolPrototype, 'description', {
      configurable: true,
      get: function description() {
        return getInternalState(this).description;
      }
    });
    if (!IS_PURE) {
      defineBuiltIn(ObjectPrototype, 'propertyIsEnumerable', $propertyIsEnumerable, { unsafe: true });
    }
  }
}

$({ global: true, constructor: true, wrap: true, forced: !NATIVE_SYMBOL, sham: !NATIVE_SYMBOL }, {
  Symbol: $Symbol
});

$forEach(objectKeys(WellKnownSymbolsStore), function (name) {
  defineWellKnownSymbol(name);
});

$({ target: SYMBOL, stat: true, forced: !NATIVE_SYMBOL }, {
  useSetter: function () { USE_SETTER = true; },
  useSimple: function () { USE_SETTER = false; }
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL, sham: !DESCRIPTORS }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: $create,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: $defineProperty,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: $defineProperties,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor
});

$({ target: 'Object', stat: true, forced: !NATIVE_SYMBOL }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: $getOwnPropertyNames
});

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag($Symbol, SYMBOL);

hiddenKeys[HIDDEN] = true;


/***/ }),

/***/ 1817:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";
// `Symbol.prototype.description` getter
// https://tc39.es/ecma262/#sec-symbol.prototype.description

var $ = __webpack_require__(2109);
var DESCRIPTORS = __webpack_require__(9781);
var global = __webpack_require__(7854);
var uncurryThis = __webpack_require__(1702);
var hasOwn = __webpack_require__(2597);
var isCallable = __webpack_require__(614);
var isPrototypeOf = __webpack_require__(7976);
var toString = __webpack_require__(1340);
var defineBuiltInAccessor = __webpack_require__(7045);
var copyConstructorProperties = __webpack_require__(9920);

var NativeSymbol = global.Symbol;
var SymbolPrototype = NativeSymbol && NativeSymbol.prototype;

if (DESCRIPTORS && isCallable(NativeSymbol) && (!('description' in SymbolPrototype) ||
  // Safari 12 bug
  NativeSymbol().description !== undefined
)) {
  var EmptyStringDescriptionStore = {};
  // wrap Symbol constructor for correct work with undefined description
  var SymbolWrapper = function Symbol() {
    var description = arguments.length < 1 || arguments[0] === undefined ? undefined : toString(arguments[0]);
    var result = isPrototypeOf(SymbolPrototype, this)
      ? new NativeSymbol(description)
      // in Edge 13, String(Symbol(undefined)) === 'Symbol(undefined)'
      : description === undefined ? NativeSymbol() : NativeSymbol(description);
    if (description === '') EmptyStringDescriptionStore[result] = true;
    return result;
  };

  copyConstructorProperties(SymbolWrapper, NativeSymbol);
  SymbolWrapper.prototype = SymbolPrototype;
  SymbolPrototype.constructor = SymbolWrapper;

  var NATIVE_SYMBOL = String(NativeSymbol('description detection')) === 'Symbol(description detection)';
  var thisSymbolValue = uncurryThis(SymbolPrototype.valueOf);
  var symbolDescriptiveString = uncurryThis(SymbolPrototype.toString);
  var regexp = /^Symbol\((.*)\)[^)]+$/;
  var replace = uncurryThis(''.replace);
  var stringSlice = uncurryThis(''.slice);

  defineBuiltInAccessor(SymbolPrototype, 'description', {
    configurable: true,
    get: function description() {
      var symbol = thisSymbolValue(this);
      if (hasOwn(EmptyStringDescriptionStore, symbol)) return '';
      var string = symbolDescriptiveString(symbol);
      var desc = NATIVE_SYMBOL ? stringSlice(string, 7, -1) : replace(string, regexp, '$1');
      return desc === '' ? undefined : desc;
    }
  });

  $({ global: true, constructor: true, forced: true }, {
    Symbol: SymbolWrapper
  });
}


/***/ }),

/***/ 763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var getBuiltIn = __webpack_require__(5005);
var hasOwn = __webpack_require__(2597);
var toString = __webpack_require__(1340);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var StringToSymbolRegistry = shared('string-to-symbol-registry');
var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.for` method
// https://tc39.es/ecma262/#sec-symbol.for
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  'for': function (key) {
    var string = toString(key);
    if (hasOwn(StringToSymbolRegistry, string)) return StringToSymbolRegistry[string];
    var symbol = getBuiltIn('Symbol')(string);
    StringToSymbolRegistry[string] = symbol;
    SymbolToStringRegistry[symbol] = string;
    return symbol;
  }
});


/***/ }),

/***/ 2165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(6800);

// `Symbol.iterator` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.iterator
defineWellKnownSymbol('iterator');


/***/ }),

/***/ 2526:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

// TODO: Remove this module from `core-js@4` since it's split to modules listed below
__webpack_require__(4032);
__webpack_require__(763);
__webpack_require__(6620);
__webpack_require__(8862);
__webpack_require__(9660);


/***/ }),

/***/ 6620:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var hasOwn = __webpack_require__(2597);
var isSymbol = __webpack_require__(2190);
var tryToString = __webpack_require__(6330);
var shared = __webpack_require__(2309);
var NATIVE_SYMBOL_REGISTRY = __webpack_require__(2015);

var SymbolToStringRegistry = shared('symbol-to-string-registry');

// `Symbol.keyFor` method
// https://tc39.es/ecma262/#sec-symbol.keyfor
$({ target: 'Symbol', stat: true, forced: !NATIVE_SYMBOL_REGISTRY }, {
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(tryToString(sym) + ' is not a symbol');
    if (hasOwn(SymbolToStringRegistry, sym)) return SymbolToStringRegistry[sym];
  }
});


/***/ }),

/***/ 6649:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var defineWellKnownSymbol = __webpack_require__(6800);
var defineSymbolToPrimitive = __webpack_require__(6532);

// `Symbol.toPrimitive` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.toprimitive
defineWellKnownSymbol('toPrimitive');

// `Symbol.prototype[@@toPrimitive]` method
// https://tc39.es/ecma262/#sec-symbol.prototype-@@toprimitive
defineSymbolToPrimitive();


/***/ }),

/***/ 9341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var defineWellKnownSymbol = __webpack_require__(6800);
var setToStringTag = __webpack_require__(8003);

// `Symbol.toStringTag` well-known symbol
// https://tc39.es/ecma262/#sec-symbol.tostringtag
defineWellKnownSymbol('toStringTag');

// `Symbol.prototype[@@toStringTag]` property
// https://tc39.es/ecma262/#sec-symbol.prototype-@@tostringtag
setToStringTag(getBuiltIn('Symbol'), 'Symbol');


/***/ }),

/***/ 7479:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var getBuiltIn = __webpack_require__(5005);
var uncurryThis = __webpack_require__(1702);
var call = __webpack_require__(6916);
var fails = __webpack_require__(7293);
var toString = __webpack_require__(1340);
var validateArgumentsLength = __webpack_require__(8053);
var itoc = (__webpack_require__(4170).itoc);

var $btoa = getBuiltIn('btoa');
var charAt = uncurryThis(''.charAt);
var charCodeAt = uncurryThis(''.charCodeAt);

var NO_ARG_RECEIVING_CHECK = !!$btoa && !fails(function () {
  $btoa();
});

var WRONG_ARG_CONVERSION = !!$btoa && fails(function () {
  return $btoa(null) !== 'bnVsbA==';
});

var WRONG_ARITY = !!$btoa && $btoa.length !== 1;

// `btoa` method
// https://html.spec.whatwg.org/multipage/webappapis.html#dom-btoa
$({ global: true, bind: true, enumerable: true, forced: NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY }, {
  btoa: function btoa(data) {
    validateArgumentsLength(arguments.length, 1);
    // `webpack` dev server bug on IE global methods - use call(fn, global, ...)
    if (NO_ARG_RECEIVING_CHECK || WRONG_ARG_CONVERSION || WRONG_ARITY) return call($btoa, global, toString(data));
    var string = toString(data);
    var output = '';
    var position = 0;
    var map = itoc;
    var block, charCode;
    while (charAt(string, position) || (map = '=', position % 1)) {
      charCode = charCodeAt(string, position += 3 / 4);
      if (charCode > 0xFF) {
        throw new (getBuiltIn('DOMException'))('The string contains characters outside of the Latin1 range', 'InvalidCharacterError');
      }
      block = block << 8 | charCode;
      output += charAt(map, 63 & block >> 8 - position % 1 * 8);
    } return output;
  }
});


/***/ }),

/***/ 4747:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var forEach = __webpack_require__(8533);
var createNonEnumerableProperty = __webpack_require__(8880);

var handlePrototype = function (CollectionPrototype) {
  // some Chrome versions have non-configurable methods on DOMTokenList
  if (CollectionPrototype && CollectionPrototype.forEach !== forEach) try {
    createNonEnumerableProperty(CollectionPrototype, 'forEach', forEach);
  } catch (error) {
    CollectionPrototype.forEach = forEach;
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  if (DOMIterables[COLLECTION_NAME]) {
    handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype);
  }
}

handlePrototype(DOMTokenListPrototype);


/***/ }),

/***/ 3948:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var global = __webpack_require__(7854);
var DOMIterables = __webpack_require__(8324);
var DOMTokenListPrototype = __webpack_require__(8509);
var ArrayIteratorMethods = __webpack_require__(6992);
var createNonEnumerableProperty = __webpack_require__(8880);
var wellKnownSymbol = __webpack_require__(5112);

var ITERATOR = wellKnownSymbol('iterator');
var TO_STRING_TAG = wellKnownSymbol('toStringTag');
var ArrayValues = ArrayIteratorMethods.values;

var handlePrototype = function (CollectionPrototype, COLLECTION_NAME) {
  if (CollectionPrototype) {
    // some Chrome versions have non-configurable methods on DOMTokenList
    if (CollectionPrototype[ITERATOR] !== ArrayValues) try {
      createNonEnumerableProperty(CollectionPrototype, ITERATOR, ArrayValues);
    } catch (error) {
      CollectionPrototype[ITERATOR] = ArrayValues;
    }
    if (!CollectionPrototype[TO_STRING_TAG]) {
      createNonEnumerableProperty(CollectionPrototype, TO_STRING_TAG, COLLECTION_NAME);
    }
    if (DOMIterables[COLLECTION_NAME]) for (var METHOD_NAME in ArrayIteratorMethods) {
      // some Chrome versions have non-configurable methods on DOMTokenList
      if (CollectionPrototype[METHOD_NAME] !== ArrayIteratorMethods[METHOD_NAME]) try {
        createNonEnumerableProperty(CollectionPrototype, METHOD_NAME, ArrayIteratorMethods[METHOD_NAME]);
      } catch (error) {
        CollectionPrototype[METHOD_NAME] = ArrayIteratorMethods[METHOD_NAME];
      }
    }
  }
};

for (var COLLECTION_NAME in DOMIterables) {
  handlePrototype(global[COLLECTION_NAME] && global[COLLECTION_NAME].prototype, COLLECTION_NAME);
}

handlePrototype(DOMTokenListPrototype, 'DOMTokenList');


/***/ }),

/***/ 7714:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var tryNodeRequire = __webpack_require__(4038);
var getBuiltIn = __webpack_require__(5005);
var fails = __webpack_require__(7293);
var create = __webpack_require__(30);
var createPropertyDescriptor = __webpack_require__(9114);
var defineProperty = (__webpack_require__(3070).f);
var defineBuiltIn = __webpack_require__(8052);
var defineBuiltInAccessor = __webpack_require__(7045);
var hasOwn = __webpack_require__(2597);
var anInstance = __webpack_require__(5787);
var anObject = __webpack_require__(9670);
var errorToString = __webpack_require__(7762);
var normalizeStringArgument = __webpack_require__(6277);
var DOMExceptionConstants = __webpack_require__(3678);
var clearErrorStack = __webpack_require__(1060);
var InternalStateModule = __webpack_require__(9909);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

var DOM_EXCEPTION = 'DOMException';
var DATA_CLONE_ERR = 'DATA_CLONE_ERR';
var Error = getBuiltIn('Error');
// NodeJS < 17.0 does not expose `DOMException` to global
var NativeDOMException = getBuiltIn(DOM_EXCEPTION) || (function () {
  try {
    // NodeJS < 15.0 does not expose `MessageChannel` to global
    var MessageChannel = getBuiltIn('MessageChannel') || tryNodeRequire('worker_threads').MessageChannel;
    // eslint-disable-next-line es/no-weak-map, unicorn/require-post-message-target-origin -- safe
    new MessageChannel().port1.postMessage(new WeakMap());
  } catch (error) {
    if (error.name === DATA_CLONE_ERR && error.code === 25) return error.constructor;
  }
})();
var NativeDOMExceptionPrototype = NativeDOMException && NativeDOMException.prototype;
var ErrorPrototype = Error.prototype;
var setInternalState = InternalStateModule.set;
var getInternalState = InternalStateModule.getterFor(DOM_EXCEPTION);
var HAS_STACK = 'stack' in Error(DOM_EXCEPTION);

var codeFor = function (name) {
  return hasOwn(DOMExceptionConstants, name) && DOMExceptionConstants[name].m ? DOMExceptionConstants[name].c : 0;
};

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var code = codeFor(name);
  setInternalState(this, {
    type: DOM_EXCEPTION,
    name: name,
    message: message,
    code: code
  });
  if (!DESCRIPTORS) {
    this.name = name;
    this.message = message;
    this.code = code;
  }
  if (HAS_STACK) {
    var error = Error(message);
    error.name = DOM_EXCEPTION;
    defineProperty(this, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  }
};

var DOMExceptionPrototype = $DOMException.prototype = create(ErrorPrototype);

var createGetterDescriptor = function (get) {
  return { enumerable: true, configurable: true, get: get };
};

var getterFor = function (key) {
  return createGetterDescriptor(function () {
    return getInternalState(this)[key];
  });
};

if (DESCRIPTORS) {
  // `DOMException.prototype.code` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'code', getterFor('code'));
  // `DOMException.prototype.message` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'message', getterFor('message'));
  // `DOMException.prototype.name` getter
  defineBuiltInAccessor(DOMExceptionPrototype, 'name', getterFor('name'));
}

defineProperty(DOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, $DOMException));

// FF36- DOMException is a function, but can't be constructed
var INCORRECT_CONSTRUCTOR = fails(function () {
  return !(new NativeDOMException() instanceof Error);
});

// Safari 10.1 / Chrome 32- / IE8- DOMException.prototype.toString bugs
var INCORRECT_TO_STRING = INCORRECT_CONSTRUCTOR || fails(function () {
  return ErrorPrototype.toString !== errorToString || String(new NativeDOMException(1, 2)) !== '2: 1';
});

// Deno 1.6.3- DOMException.prototype.code just missed
var INCORRECT_CODE = INCORRECT_CONSTRUCTOR || fails(function () {
  return new NativeDOMException(1, 'DataCloneError').code !== 25;
});

// Deno 1.6.3- DOMException constants just missed
var MISSED_CONSTANTS = INCORRECT_CONSTRUCTOR
  || NativeDOMException[DATA_CLONE_ERR] !== 25
  || NativeDOMExceptionPrototype[DATA_CLONE_ERR] !== 25;

var FORCED_CONSTRUCTOR = IS_PURE ? INCORRECT_TO_STRING || INCORRECT_CODE || MISSED_CONSTANTS : INCORRECT_CONSTRUCTOR;

// `DOMException` constructor
// https://webidl.spec.whatwg.org/#idl-DOMException
$({ global: true, constructor: true, forced: FORCED_CONSTRUCTOR }, {
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (INCORRECT_TO_STRING && (IS_PURE || NativeDOMException === PolyfilledDOMException)) {
  defineBuiltIn(PolyfilledDOMExceptionPrototype, 'toString', errorToString);
}

if (INCORRECT_CODE && DESCRIPTORS && NativeDOMException === PolyfilledDOMException) {
  defineBuiltInAccessor(PolyfilledDOMExceptionPrototype, 'code', createGetterDescriptor(function () {
    return codeFor(anObject(this).name);
  }));
}

// `DOMException` constants
for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
  var constant = DOMExceptionConstants[key];
  var constantName = constant.s;
  var descriptor = createPropertyDescriptor(6, constant.c);
  if (!hasOwn(PolyfilledDOMException, constantName)) {
    defineProperty(PolyfilledDOMException, constantName, descriptor);
  }
  if (!hasOwn(PolyfilledDOMExceptionPrototype, constantName)) {
    defineProperty(PolyfilledDOMExceptionPrototype, constantName, descriptor);
  }
}


/***/ }),

/***/ 2801:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var $ = __webpack_require__(2109);
var global = __webpack_require__(7854);
var getBuiltIn = __webpack_require__(5005);
var createPropertyDescriptor = __webpack_require__(9114);
var defineProperty = (__webpack_require__(3070).f);
var hasOwn = __webpack_require__(2597);
var anInstance = __webpack_require__(5787);
var inheritIfRequired = __webpack_require__(9587);
var normalizeStringArgument = __webpack_require__(6277);
var DOMExceptionConstants = __webpack_require__(3678);
var clearErrorStack = __webpack_require__(1060);
var DESCRIPTORS = __webpack_require__(9781);
var IS_PURE = __webpack_require__(1913);

var DOM_EXCEPTION = 'DOMException';
var Error = getBuiltIn('Error');
var NativeDOMException = getBuiltIn(DOM_EXCEPTION);

var $DOMException = function DOMException() {
  anInstance(this, DOMExceptionPrototype);
  var argumentsLength = arguments.length;
  var message = normalizeStringArgument(argumentsLength < 1 ? undefined : arguments[0]);
  var name = normalizeStringArgument(argumentsLength < 2 ? undefined : arguments[1], 'Error');
  var that = new NativeDOMException(message, name);
  var error = Error(message);
  error.name = DOM_EXCEPTION;
  defineProperty(that, 'stack', createPropertyDescriptor(1, clearErrorStack(error.stack, 1)));
  inheritIfRequired(that, this, $DOMException);
  return that;
};

var DOMExceptionPrototype = $DOMException.prototype = NativeDOMException.prototype;

var ERROR_HAS_STACK = 'stack' in Error(DOM_EXCEPTION);
var DOM_EXCEPTION_HAS_STACK = 'stack' in new NativeDOMException(1, 2);

// eslint-disable-next-line es/no-object-getownpropertydescriptor -- safe
var descriptor = NativeDOMException && DESCRIPTORS && Object.getOwnPropertyDescriptor(global, DOM_EXCEPTION);

// Bun ~ 0.1.1 DOMException have incorrect descriptor and we can't redefine it
// https://github.com/Jarred-Sumner/bun/issues/399
var BUGGY_DESCRIPTOR = !!descriptor && !(descriptor.writable && descriptor.configurable);

var FORCED_CONSTRUCTOR = ERROR_HAS_STACK && !BUGGY_DESCRIPTOR && !DOM_EXCEPTION_HAS_STACK;

// `DOMException` constructor patch for `.stack` where it's required
// https://webidl.spec.whatwg.org/#es-DOMException-specialness
$({ global: true, constructor: true, forced: IS_PURE || FORCED_CONSTRUCTOR }, { // TODO: fix export logic
  DOMException: FORCED_CONSTRUCTOR ? $DOMException : NativeDOMException
});

var PolyfilledDOMException = getBuiltIn(DOM_EXCEPTION);
var PolyfilledDOMExceptionPrototype = PolyfilledDOMException.prototype;

if (PolyfilledDOMExceptionPrototype.constructor !== PolyfilledDOMException) {
  if (!IS_PURE) {
    defineProperty(PolyfilledDOMExceptionPrototype, 'constructor', createPropertyDescriptor(1, PolyfilledDOMException));
  }

  for (var key in DOMExceptionConstants) if (hasOwn(DOMExceptionConstants, key)) {
    var constant = DOMExceptionConstants[key];
    var constantName = constant.s;
    if (!hasOwn(PolyfilledDOMException, constantName)) {
      defineProperty(PolyfilledDOMException, constantName, createPropertyDescriptor(6, constant.c));
    }
  }
}


/***/ }),

/***/ 1174:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

"use strict";

var getBuiltIn = __webpack_require__(5005);
var setToStringTag = __webpack_require__(8003);

var DOM_EXCEPTION = 'DOMException';

// `DOMException.prototype[@@toStringTag]` property
setToStringTag(getBuiltIn(DOM_EXCEPTION), DOM_EXCEPTION);


/***/ }),

/***/ 296:
/***/ (function(module) {

/**
 * Returns a function, that, as long as it continues to be invoked, will not
 * be triggered. The function will be called after it stops being called for
 * N milliseconds. If `immediate` is passed, trigger the function on the
 * leading edge, instead of the trailing. The function also has a property 'clear' 
 * that is a function which will clear the timer to prevent previously scheduled executions. 
 *
 * @source underscore.js
 * @see http://unscriptable.com/2009/03/20/debouncing-javascript-methods/
 * @param {Function} function to wrap
 * @param {Number} timeout in ms (`100`)
 * @param {Boolean} whether to execute at the beginning (`false`)
 * @api public
 */
function debounce(func, wait, immediate){
  var timeout, args, context, timestamp, result;
  if (null == wait) wait = 100;

  function later() {
    var last = Date.now() - timestamp;

    if (last < wait && last >= 0) {
      timeout = setTimeout(later, wait - last);
    } else {
      timeout = null;
      if (!immediate) {
        result = func.apply(context, args);
        context = args = null;
      }
    }
  };

  var debounced = function(){
    context = this;
    args = arguments;
    timestamp = Date.now();
    var callNow = immediate && !timeout;
    if (!timeout) timeout = setTimeout(later, wait);
    if (callNow) {
      result = func.apply(context, args);
      context = args = null;
    }

    return result;
  };

  debounced.clear = function() {
    if (timeout) {
      clearTimeout(timeout);
      timeout = null;
    }
  };
  
  debounced.flush = function() {
    if (timeout) {
      result = func.apply(context, args);
      context = args = null;
      
      clearTimeout(timeout);
      timeout = null;
    }
  };

  return debounced;
};

// Adds compatibility for ES modules
debounce.debounce = debounce;

module.exports = debounce;


/***/ }),

/***/ 4070:
/***/ (function(module) {

/*!
 * Fuse.js v3.6.1 - Lightweight fuzzy-search (http://fusejs.io)
 * 
 * Copyright (c) 2012-2017 Kirollos Risk (http://kiro.me)
 * All Rights Reserved. Apache Software License 2.0
 * 
 * http://www.apache.org/licenses/LICENSE-2.0
 */
!function(e,t){ true?module.exports=t():0}(this,function(){return function(e){var t={};function r(n){if(t[n])return t[n].exports;var o=t[n]={i:n,l:!1,exports:{}};return e[n].call(o.exports,o,o.exports,r),o.l=!0,o.exports}return r.m=e,r.c=t,r.d=function(e,t,n){r.o(e,t)||Object.defineProperty(e,t,{enumerable:!0,get:n})},r.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},r.t=function(e,t){if(1&t&&(e=r(e)),8&t)return e;if(4&t&&"object"==typeof e&&e&&e.__esModule)return e;var n=Object.create(null);if(r.r(n),Object.defineProperty(n,"default",{enumerable:!0,value:e}),2&t&&"string"!=typeof e)for(var o in e)r.d(n,o,function(t){return e[t]}.bind(null,o));return n},r.n=function(e){var t=e&&e.__esModule?function(){return e.default}:function(){return e};return r.d(t,"a",t),t},r.o=function(e,t){return Object.prototype.hasOwnProperty.call(e,t)},r.p="",r(r.s=0)}([function(e,t,r){function n(e){return(n="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function o(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var i=r(1),a=r(7),s=a.get,c=(a.deepValue,a.isArray),h=function(){function e(t,r){var n=r.location,o=void 0===n?0:n,i=r.distance,a=void 0===i?100:i,c=r.threshold,h=void 0===c?.6:c,l=r.maxPatternLength,u=void 0===l?32:l,f=r.caseSensitive,v=void 0!==f&&f,p=r.tokenSeparator,d=void 0===p?/ +/g:p,g=r.findAllMatches,y=void 0!==g&&g,m=r.minMatchCharLength,k=void 0===m?1:m,b=r.id,S=void 0===b?null:b,x=r.keys,M=void 0===x?[]:x,_=r.shouldSort,w=void 0===_||_,L=r.getFn,A=void 0===L?s:L,O=r.sortFn,C=void 0===O?function(e,t){return e.score-t.score}:O,j=r.tokenize,P=void 0!==j&&j,I=r.matchAllTokens,F=void 0!==I&&I,T=r.includeMatches,N=void 0!==T&&T,z=r.includeScore,E=void 0!==z&&z,W=r.verbose,K=void 0!==W&&W;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:a,threshold:h,maxPatternLength:u,isCaseSensitive:v,tokenSeparator:d,findAllMatches:y,minMatchCharLength:k,id:S,keys:M,includeMatches:N,includeScore:E,shouldSort:w,getFn:A,sortFn:C,verbose:K,tokenize:P,matchAllTokens:F},this.setCollection(t),this._processKeys(M)}var t,r,a;return t=e,(r=[{key:"setCollection",value:function(e){return this.list=e,e}},{key:"_processKeys",value:function(e){if(this._keyWeights={},this._keyNames=[],e.length&&"string"==typeof e[0])for(var t=0,r=e.length;t<r;t+=1){var n=e[t];this._keyWeights[n]=1,this._keyNames.push(n)}else{for(var o=null,i=null,a=0,s=0,c=e.length;s<c;s+=1){var h=e[s];if(!h.hasOwnProperty("name"))throw new Error('Missing "name" property in key object');var l=h.name;if(this._keyNames.push(l),!h.hasOwnProperty("weight"))throw new Error('Missing "weight" property in key object');var u=h.weight;if(u<0||u>1)throw new Error('"weight" property in key must bein the range of [0, 1)');i=null==i?u:Math.max(i,u),o=null==o?u:Math.min(o,u),this._keyWeights[l]=u,a+=u}if(a>1)throw new Error("Total of weights cannot exceed 1")}}},{key:"search",value:function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{limit:!1};this._log('---------\nSearch pattern: "'.concat(e,'"'));var r=this._prepareSearchers(e),n=r.tokenSearchers,o=r.fullSearcher,i=this._search(n,o);return this._computeScore(i),this.options.shouldSort&&this._sort(i),t.limit&&"number"==typeof t.limit&&(i=i.slice(0,t.limit)),this._format(i)}},{key:"_prepareSearchers",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:"",t=[];if(this.options.tokenize)for(var r=e.split(this.options.tokenSeparator),n=0,o=r.length;n<o;n+=1)t.push(new i(r[n],this.options));return{tokenSearchers:t,fullSearcher:new i(e,this.options)}}},{key:"_search",value:function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1?arguments[1]:void 0,r=this.list,n={},o=[];if("string"==typeof r[0]){for(var i=0,a=r.length;i<a;i+=1)this._analyze({key:"",value:r[i],record:i,index:i},{resultMap:n,results:o,tokenSearchers:e,fullSearcher:t});return o}for(var s=0,c=r.length;s<c;s+=1)for(var h=r[s],l=0,u=this._keyNames.length;l<u;l+=1){var f=this._keyNames[l];this._analyze({key:f,value:this.options.getFn(h,f),record:h,index:s},{resultMap:n,results:o,tokenSearchers:e,fullSearcher:t})}return o}},{key:"_analyze",value:function(e,t){var r=this,n=e.key,o=e.arrayIndex,i=void 0===o?-1:o,a=e.value,s=e.record,h=e.index,l=t.tokenSearchers,u=void 0===l?[]:l,f=t.fullSearcher,v=t.resultMap,p=void 0===v?{}:v,d=t.results,g=void 0===d?[]:d;!function e(t,o,i,a){if(null!=o)if("string"==typeof o){var s=!1,h=-1,l=0;r._log("\nKey: ".concat(""===n?"--":n));var v=f.search(o);if(r._log('Full text: "'.concat(o,'", score: ').concat(v.score)),r.options.tokenize){for(var d=o.split(r.options.tokenSeparator),y=d.length,m=[],k=0,b=u.length;k<b;k+=1){var S=u[k];r._log('\nPattern: "'.concat(S.pattern,'"'));for(var x=!1,M=0;M<y;M+=1){var _=d[M],w=S.search(_),L={};w.isMatch?(L[_]=w.score,s=!0,x=!0,m.push(w.score)):(L[_]=1,r.options.matchAllTokens||m.push(1)),r._log('Token: "'.concat(_,'", score: ').concat(L[_]))}x&&(l+=1)}h=m[0];for(var A=m.length,O=1;O<A;O+=1)h+=m[O];h/=A,r._log("Token score average:",h)}var C=v.score;h>-1&&(C=(C+h)/2),r._log("Score average:",C);var j=!r.options.tokenize||!r.options.matchAllTokens||l>=u.length;if(r._log("\nCheck Matches: ".concat(j)),(s||v.isMatch)&&j){var P={key:n,arrayIndex:t,value:o,score:C};r.options.includeMatches&&(P.matchedIndices=v.matchedIndices);var I=p[a];I?I.output.push(P):(p[a]={item:i,output:[P]},g.push(p[a]))}}else if(c(o))for(var F=0,T=o.length;F<T;F+=1)e(F,o[F],i,a)}(i,a,s,h)}},{key:"_computeScore",value:function(e){this._log("\n\nComputing score:\n");for(var t=this._keyWeights,r=!!Object.keys(t).length,n=0,o=e.length;n<o;n+=1){for(var i=e[n],a=i.output,s=a.length,c=1,h=0;h<s;h+=1){var l=a[h],u=l.key,f=r?t[u]:1,v=0===l.score&&t&&t[u]>0?Number.EPSILON:l.score;c*=Math.pow(v,f)}i.score=c,this._log(i)}}},{key:"_sort",value:function(e){this._log("\n\nSorting...."),e.sort(this.options.sortFn)}},{key:"_format",value:function(e){var t=[];if(this.options.verbose){var r=[];this._log("\n\nOutput:\n\n",JSON.stringify(e,function(e,t){if("object"===n(t)&&null!==t){if(-1!==r.indexOf(t))return;r.push(t)}return t},2)),r=null}var o=[];this.options.includeMatches&&o.push(function(e,t){var r=e.output;t.matches=[];for(var n=0,o=r.length;n<o;n+=1){var i=r[n];if(0!==i.matchedIndices.length){var a={indices:i.matchedIndices,value:i.value};i.key&&(a.key=i.key),i.hasOwnProperty("arrayIndex")&&i.arrayIndex>-1&&(a.arrayIndex=i.arrayIndex),t.matches.push(a)}}}),this.options.includeScore&&o.push(function(e,t){t.score=e.score});for(var i=0,a=e.length;i<a;i+=1){var s=e[i];if(this.options.id&&(s.item=this.options.getFn(s.item,this.options.id)[0]),o.length){for(var c={item:s.item},h=0,l=o.length;h<l;h+=1)o[h](s,c);t.push(c)}else t.push(s.item)}return t}},{key:"_log",value:function(){var e;this.options.verbose&&(e=console).log.apply(e,arguments)}}])&&o(t.prototype,r),a&&o(t,a),e}();e.exports=h},function(e,t,r){function n(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,n.key,n)}}var o=r(2),i=r(3),a=r(6),s=function(){function e(t,r){var n=r.location,o=void 0===n?0:n,i=r.distance,s=void 0===i?100:i,c=r.threshold,h=void 0===c?.6:c,l=r.maxPatternLength,u=void 0===l?32:l,f=r.isCaseSensitive,v=void 0!==f&&f,p=r.tokenSeparator,d=void 0===p?/ +/g:p,g=r.findAllMatches,y=void 0!==g&&g,m=r.minMatchCharLength,k=void 0===m?1:m,b=r.includeMatches,S=void 0!==b&&b;!function(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}(this,e),this.options={location:o,distance:s,threshold:h,maxPatternLength:u,isCaseSensitive:v,tokenSeparator:d,findAllMatches:y,includeMatches:S,minMatchCharLength:k},this.pattern=v?t:t.toLowerCase(),this.pattern.length<=u&&(this.patternAlphabet=a(this.pattern))}var t,r,s;return t=e,(r=[{key:"search",value:function(e){var t=this.options,r=t.isCaseSensitive,n=t.includeMatches;if(r||(e=e.toLowerCase()),this.pattern===e){var a={isMatch:!0,score:0};return n&&(a.matchedIndices=[[0,e.length-1]]),a}var s=this.options,c=s.maxPatternLength,h=s.tokenSeparator;if(this.pattern.length>c)return o(e,this.pattern,h);var l=this.options,u=l.location,f=l.distance,v=l.threshold,p=l.findAllMatches,d=l.minMatchCharLength;return i(e,this.pattern,this.patternAlphabet,{location:u,distance:f,threshold:v,findAllMatches:p,minMatchCharLength:d,includeMatches:n})}}])&&n(t.prototype,r),s&&n(t,s),e}();e.exports=s},function(e,t){var r=/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;e.exports=function(e,t){var n=arguments.length>2&&void 0!==arguments[2]?arguments[2]:/ +/g,o=new RegExp(t.replace(r,"\\$&").replace(n,"|")),i=e.match(o),a=!!i,s=[];if(a)for(var c=0,h=i.length;c<h;c+=1){var l=i[c];s.push([e.indexOf(l),l.length-1])}return{score:a?.5:1,isMatch:a,matchedIndices:s}}},function(e,t,r){var n=r(4),o=r(5);e.exports=function(e,t,r,i){for(var a=i.location,s=void 0===a?0:a,c=i.distance,h=void 0===c?100:c,l=i.threshold,u=void 0===l?.6:l,f=i.findAllMatches,v=void 0!==f&&f,p=i.minMatchCharLength,d=void 0===p?1:p,g=i.includeMatches,y=void 0!==g&&g,m=s,k=e.length,b=u,S=e.indexOf(t,m),x=t.length,M=[],_=0;_<k;_+=1)M[_]=0;if(-1!==S){var w=n(t,{errors:0,currentLocation:S,expectedLocation:m,distance:h});if(b=Math.min(w,b),-1!==(S=e.lastIndexOf(t,m+x))){var L=n(t,{errors:0,currentLocation:S,expectedLocation:m,distance:h});b=Math.min(L,b)}}S=-1;for(var A=[],O=1,C=x+k,j=1<<(x<=31?x-1:30),P=0;P<x;P+=1){for(var I=0,F=C;I<F;){n(t,{errors:P,currentLocation:m+F,expectedLocation:m,distance:h})<=b?I=F:C=F,F=Math.floor((C-I)/2+I)}C=F;var T=Math.max(1,m-F+1),N=v?k:Math.min(m+F,k)+x,z=Array(N+2);z[N+1]=(1<<P)-1;for(var E=N;E>=T;E-=1){var W=E-1,K=r[e.charAt(W)];if(K&&(M[W]=1),z[E]=(z[E+1]<<1|1)&K,0!==P&&(z[E]|=(A[E+1]|A[E])<<1|1|A[E+1]),z[E]&j&&(O=n(t,{errors:P,currentLocation:W,expectedLocation:m,distance:h}))<=b){if(b=O,(S=W)<=m)break;T=Math.max(1,2*m-S)}}if(n(t,{errors:P+1,currentLocation:m,expectedLocation:m,distance:h})>b)break;A=z}var $={isMatch:S>=0,score:0===O?.001:O};return y&&($.matchedIndices=o(M,d)),$}},function(e,t){e.exports=function(e,t){var r=t.errors,n=void 0===r?0:r,o=t.currentLocation,i=void 0===o?0:o,a=t.expectedLocation,s=void 0===a?0:a,c=t.distance,h=void 0===c?100:c,l=n/e.length,u=Math.abs(s-i);return h?l+u/h:u?1:l}},function(e,t){e.exports=function(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:1,r=[],n=-1,o=-1,i=0,a=e.length;i<a;i+=1){var s=e[i];s&&-1===n?n=i:s||-1===n||((o=i-1)-n+1>=t&&r.push([n,o]),n=-1)}return e[i-1]&&i-n>=t&&r.push([n,i-1]),r}},function(e,t){e.exports=function(e){for(var t={},r=e.length,n=0;n<r;n+=1)t[e.charAt(n)]=0;for(var o=0;o<r;o+=1)t[e.charAt(o)]|=1<<r-o-1;return t}},function(e,t){var r=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)},n=function(e){return null==e?"":function(e){if("string"==typeof e)return e;var t=e+"";return"0"==t&&1/e==-1/0?"-0":t}(e)},o=function(e){return"string"==typeof e},i=function(e){return"number"==typeof e};e.exports={get:function(e,t){var a=[];return function e(t,s){if(s){var c=s.indexOf("."),h=s,l=null;-1!==c&&(h=s.slice(0,c),l=s.slice(c+1));var u=t[h];if(null!=u)if(l||!o(u)&&!i(u))if(r(u))for(var f=0,v=u.length;f<v;f+=1)e(u[f],l);else l&&e(u,l);else a.push(n(u))}else a.push(t)}(e,t),a},isArray:r,isString:o,isNum:i,toString:n}}])});

/***/ }),

/***/ 1248:
/***/ (function(module, exports, __webpack_require__) {

(typeof navigator !== "undefined") && (function (global, factory) {
   true ? module.exports = factory() :
  0;
})(this, (function () { 'use strict';

  var svgNS = 'http://www.w3.org/2000/svg';
  var locationHref = '';
  var _useWebWorker = false;
  var initialDefaultFrame = -999999;

  var setWebWorker = function setWebWorker(flag) {
    _useWebWorker = !!flag;
  };

  var getWebWorker = function getWebWorker() {
    return _useWebWorker;
  };

  var setLocationHref = function setLocationHref(value) {
    locationHref = value;
  };

  var getLocationHref = function getLocationHref() {
    return locationHref;
  };

  function createTag(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElement(type);
  }

  function extendPrototype(sources, destination) {
    var i;
    var len = sources.length;
    var sourcePrototype;

    for (i = 0; i < len; i += 1) {
      sourcePrototype = sources[i].prototype;

      for (var attr in sourcePrototype) {
        if (Object.prototype.hasOwnProperty.call(sourcePrototype, attr)) destination.prototype[attr] = sourcePrototype[attr];
      }
    }
  }

  function getDescriptor(object, prop) {
    return Object.getOwnPropertyDescriptor(object, prop);
  }

  function createProxyFunction(prototype) {
    function ProxyFunction() {}

    ProxyFunction.prototype = prototype;
    return ProxyFunction;
  }

  // import Howl from '../../3rd_party/howler';
  var audioControllerFactory = function () {
    function AudioController(audioFactory) {
      this.audios = [];
      this.audioFactory = audioFactory;
      this._volume = 1;
      this._isMuted = false;
    }

    AudioController.prototype = {
      addAudio: function addAudio(audio) {
        this.audios.push(audio);
      },
      pause: function pause() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].pause();
        }
      },
      resume: function resume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].resume();
        }
      },
      setRate: function setRate(rateValue) {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].setRate(rateValue);
        }
      },
      createAudio: function createAudio(assetPath) {
        if (this.audioFactory) {
          return this.audioFactory(assetPath);
        }

        if (window.Howl) {
          return new window.Howl({
            src: [assetPath]
          });
        }

        return {
          isPlaying: false,
          play: function play() {
            this.isPlaying = true;
          },
          seek: function seek() {
            this.isPlaying = false;
          },
          playing: function playing() {},
          rate: function rate() {},
          setVolume: function setVolume() {}
        };
      },
      setAudioFactory: function setAudioFactory(audioFactory) {
        this.audioFactory = audioFactory;
      },
      setVolume: function setVolume(value) {
        this._volume = value;

        this._updateVolume();
      },
      mute: function mute() {
        this._isMuted = true;

        this._updateVolume();
      },
      unmute: function unmute() {
        this._isMuted = false;

        this._updateVolume();
      },
      getVolume: function getVolume() {
        return this._volume;
      },
      _updateVolume: function _updateVolume() {
        var i;
        var len = this.audios.length;

        for (i = 0; i < len; i += 1) {
          this.audios[i].volume(this._volume * (this._isMuted ? 0 : 1));
        }
      }
    };
    return function () {
      return new AudioController();
    };
  }();

  var createTypedArray = function () {
    function createRegularArray(type, len) {
      var i = 0;
      var arr = [];
      var value;

      switch (type) {
        case 'int16':
        case 'uint8c':
          value = 1;
          break;

        default:
          value = 1.1;
          break;
      }

      for (i = 0; i < len; i += 1) {
        arr.push(value);
      }

      return arr;
    }

    function createTypedArrayFactory(type, len) {
      if (type === 'float32') {
        return new Float32Array(len);
      }

      if (type === 'int16') {
        return new Int16Array(len);
      }

      if (type === 'uint8c') {
        return new Uint8ClampedArray(len);
      }

      return createRegularArray(type, len);
    }

    if (typeof Uint8ClampedArray === 'function' && typeof Float32Array === 'function') {
      return createTypedArrayFactory;
    }

    return createRegularArray;
  }();

  function createSizedArray(len) {
    return Array.apply(null, {
      length: len
    });
  }

  function _typeof$6(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$6 = function _typeof(obj) { return typeof obj; }; } else { _typeof$6 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$6(obj); }
  var subframeEnabled = true;
  var expressionsPlugin = null;
  var expressionsInterfaces = null;
  var idPrefix$1 = '';
  var isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
  var _shouldRoundValues = false;
  var bmPow = Math.pow;
  var bmSqrt = Math.sqrt;
  var bmFloor = Math.floor;
  var bmMax = Math.max;
  var bmMin = Math.min;
  var BMMath = {};

  (function () {
    var propertyNames = ['abs', 'acos', 'acosh', 'asin', 'asinh', 'atan', 'atanh', 'atan2', 'ceil', 'cbrt', 'expm1', 'clz32', 'cos', 'cosh', 'exp', 'floor', 'fround', 'hypot', 'imul', 'log', 'log1p', 'log2', 'log10', 'max', 'min', 'pow', 'random', 'round', 'sign', 'sin', 'sinh', 'sqrt', 'tan', 'tanh', 'trunc', 'E', 'LN10', 'LN2', 'LOG10E', 'LOG2E', 'PI', 'SQRT1_2', 'SQRT2'];
    var i;
    var len = propertyNames.length;

    for (i = 0; i < len; i += 1) {
      BMMath[propertyNames[i]] = Math[propertyNames[i]];
    }
  })();

  function ProjectInterface$1() {
    return {};
  }

  BMMath.random = Math.random;

  BMMath.abs = function (val) {
    var tOfVal = _typeof$6(val);

    if (tOfVal === 'object' && val.length) {
      var absArr = createSizedArray(val.length);
      var i;
      var len = val.length;

      for (i = 0; i < len; i += 1) {
        absArr[i] = Math.abs(val[i]);
      }

      return absArr;
    }

    return Math.abs(val);
  };

  var defaultCurveSegments = 150;
  var degToRads = Math.PI / 180;
  var roundCorner = 0.5519;

  function roundValues(flag) {
    _shouldRoundValues = !!flag;
  }

  function bmRnd(value) {
    if (_shouldRoundValues) {
      return Math.round(value);
    }

    return value;
  }

  function styleDiv(element) {
    element.style.position = 'absolute';
    element.style.top = 0;
    element.style.left = 0;
    element.style.display = 'block';
    element.style.transformOrigin = '0 0';
    element.style.webkitTransformOrigin = '0 0';
    element.style.backfaceVisibility = 'visible';
    element.style.webkitBackfaceVisibility = 'visible';
    element.style.transformStyle = 'preserve-3d';
    element.style.webkitTransformStyle = 'preserve-3d';
    element.style.mozTransformStyle = 'preserve-3d';
  }

  function BMEnterFrameEvent(type, currentTime, totalTime, frameMultiplier) {
    this.type = type;
    this.currentTime = currentTime;
    this.totalTime = totalTime;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteEvent(type, frameMultiplier) {
    this.type = type;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMCompleteLoopEvent(type, totalLoops, currentLoop, frameMultiplier) {
    this.type = type;
    this.currentLoop = currentLoop;
    this.totalLoops = totalLoops;
    this.direction = frameMultiplier < 0 ? -1 : 1;
  }

  function BMSegmentStartEvent(type, firstFrame, totalFrames) {
    this.type = type;
    this.firstFrame = firstFrame;
    this.totalFrames = totalFrames;
  }

  function BMDestroyEvent(type, target) {
    this.type = type;
    this.target = target;
  }

  function BMRenderFrameErrorEvent(nativeError, currentTime) {
    this.type = 'renderFrameError';
    this.nativeError = nativeError;
    this.currentTime = currentTime;
  }

  function BMConfigErrorEvent(nativeError) {
    this.type = 'configError';
    this.nativeError = nativeError;
  }

  function BMAnimationConfigErrorEvent(type, nativeError) {
    this.type = type;
    this.nativeError = nativeError;
  }

  var createElementID = function () {
    var _count = 0;
    return function createID() {
      _count += 1;
      return idPrefix$1 + '__lottie_element_' + _count;
    };
  }();

  function HSVtoRGB(h, s, v) {
    var r;
    var g;
    var b;
    var i;
    var f;
    var p;
    var q;
    var t;
    i = Math.floor(h * 6);
    f = h * 6 - i;
    p = v * (1 - s);
    q = v * (1 - f * s);
    t = v * (1 - (1 - f) * s);

    switch (i % 6) {
      case 0:
        r = v;
        g = t;
        b = p;
        break;

      case 1:
        r = q;
        g = v;
        b = p;
        break;

      case 2:
        r = p;
        g = v;
        b = t;
        break;

      case 3:
        r = p;
        g = q;
        b = v;
        break;

      case 4:
        r = t;
        g = p;
        b = v;
        break;

      case 5:
        r = v;
        g = p;
        b = q;
        break;

      default:
        break;
    }

    return [r, g, b];
  }

  function RGBtoHSV(r, g, b) {
    var max = Math.max(r, g, b);
    var min = Math.min(r, g, b);
    var d = max - min;
    var h;
    var s = max === 0 ? 0 : d / max;
    var v = max / 255;

    switch (max) {
      case min:
        h = 0;
        break;

      case r:
        h = g - b + d * (g < b ? 6 : 0);
        h /= 6 * d;
        break;

      case g:
        h = b - r + d * 2;
        h /= 6 * d;
        break;

      case b:
        h = r - g + d * 4;
        h /= 6 * d;
        break;

      default:
        break;
    }

    return [h, s, v];
  }

  function addSaturationToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[1] += offset;

    if (hsv[1] > 1) {
      hsv[1] = 1;
    } else if (hsv[1] <= 0) {
      hsv[1] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addBrightnessToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[2] += offset;

    if (hsv[2] > 1) {
      hsv[2] = 1;
    } else if (hsv[2] < 0) {
      hsv[2] = 0;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  function addHueToRGB(color, offset) {
    var hsv = RGBtoHSV(color[0] * 255, color[1] * 255, color[2] * 255);
    hsv[0] += offset / 360;

    if (hsv[0] > 1) {
      hsv[0] -= 1;
    } else if (hsv[0] < 0) {
      hsv[0] += 1;
    }

    return HSVtoRGB(hsv[0], hsv[1], hsv[2]);
  }

  var rgbToHex = function () {
    var colorMap = [];
    var i;
    var hex;

    for (i = 0; i < 256; i += 1) {
      hex = i.toString(16);
      colorMap[i] = hex.length === 1 ? '0' + hex : hex;
    }

    return function (r, g, b) {
      if (r < 0) {
        r = 0;
      }

      if (g < 0) {
        g = 0;
      }

      if (b < 0) {
        b = 0;
      }

      return '#' + colorMap[r] + colorMap[g] + colorMap[b];
    };
  }();

  var setSubframeEnabled = function setSubframeEnabled(flag) {
    subframeEnabled = !!flag;
  };

  var getSubframeEnabled = function getSubframeEnabled() {
    return subframeEnabled;
  };

  var setExpressionsPlugin = function setExpressionsPlugin(value) {
    expressionsPlugin = value;
  };

  var getExpressionsPlugin = function getExpressionsPlugin() {
    return expressionsPlugin;
  };

  var setExpressionInterfaces = function setExpressionInterfaces(value) {
    expressionsInterfaces = value;
  };

  var getExpressionInterfaces = function getExpressionInterfaces() {
    return expressionsInterfaces;
  };

  var setDefaultCurveSegments = function setDefaultCurveSegments(value) {
    defaultCurveSegments = value;
  };

  var getDefaultCurveSegments = function getDefaultCurveSegments() {
    return defaultCurveSegments;
  };

  var setIdPrefix = function setIdPrefix(value) {
    idPrefix$1 = value;
  };

  var getIdPrefix = function getIdPrefix() {
    return idPrefix$1;
  };

  function createNS(type) {
    // return {appendChild:function(){},setAttribute:function(){},style:{}}
    return document.createElementNS(svgNS, type);
  }

  function _typeof$5(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$5 = function _typeof(obj) { return typeof obj; }; } else { _typeof$5 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$5(obj); }

  var dataManager = function () {
    var _counterId = 1;
    var processes = [];
    var workerFn;
    var workerInstance;
    var workerProxy = {
      onmessage: function onmessage() {},
      postMessage: function postMessage(path) {
        workerFn({
          data: path
        });
      }
    };
    var _workerSelf = {
      postMessage: function postMessage(data) {
        workerProxy.onmessage({
          data: data
        });
      }
    };

    function createWorker(fn) {
      if (window.Worker && window.Blob && getWebWorker()) {
        var blob = new Blob(['var _workerSelf = self; self.onmessage = ', fn.toString()], {
          type: 'text/javascript'
        }); // var blob = new Blob(['self.onmessage = ', fn.toString()], { type: 'text/javascript' });

        var url = URL.createObjectURL(blob);
        return new Worker(url);
      }

      workerFn = fn;
      return workerProxy;
    }

    function setupWorker() {
      if (!workerInstance) {
        workerInstance = createWorker(function workerStart(e) {
          function dataFunctionManager() {
            function completeLayers(layers, comps) {
              var layerData;
              var i;
              var len = layers.length;
              var j;
              var jLen;
              var k;
              var kLen;

              for (i = 0; i < len; i += 1) {
                layerData = layers[i];

                if ('ks' in layerData && !layerData.completed) {
                  layerData.completed = true;

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        convertPathsToAbsoluteValues(maskProps[j].pt.k);
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].s[0]);
                          }

                          if (maskProps[j].pt.k[k].e) {
                            convertPathsToAbsoluteValues(maskProps[j].pt.k[k].e[0]);
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 0) {
                    layerData.layers = findCompLayers(layerData.refId, comps);
                    completeLayers(layerData.layers, comps);
                  } else if (layerData.ty === 4) {
                    completeShapes(layerData.shapes);
                  } else if (layerData.ty === 5) {
                    completeText(layerData);
                  }
                }
              }
            }

            function completeChars(chars, assets) {
              if (chars) {
                var i = 0;
                var len = chars.length;

                for (i = 0; i < len; i += 1) {
                  if (chars[i].t === 1) {
                    // var compData = findComp(chars[i].data.refId, assets);
                    chars[i].data.layers = findCompLayers(chars[i].data.refId, assets); // chars[i].data.ip = 0;
                    // chars[i].data.op = 99999;
                    // chars[i].data.st = 0;
                    // chars[i].data.sr = 1;
                    // chars[i].w = compData.w;
                    // chars[i].data.ks = {
                    //   a: { k: [0, 0, 0], a: 0 },
                    //   p: { k: [0, -compData.h, 0], a: 0 },
                    //   r: { k: 0, a: 0 },
                    //   s: { k: [100, 100], a: 0 },
                    //   o: { k: 100, a: 0 },
                    // };

                    completeLayers(chars[i].data.layers, assets);
                  }
                }
              }
            }

            function findComp(id, comps) {
              var i = 0;
              var len = comps.length;

              while (i < len) {
                if (comps[i].id === id) {
                  return comps[i];
                }

                i += 1;
              }

              return null;
            }

            function findCompLayers(id, comps) {
              var comp = findComp(id, comps);

              if (comp) {
                if (!comp.layers.__used) {
                  comp.layers.__used = true;
                  return comp.layers;
                }

                return JSON.parse(JSON.stringify(comp.layers));
              }

              return null;
            }

            function completeShapes(arr) {
              var i;
              var len = arr.length;
              var j;
              var jLen;

              for (i = len - 1; i >= 0; i -= 1) {
                if (arr[i].ty === 'sh') {
                  if (arr[i].ks.k.i) {
                    convertPathsToAbsoluteValues(arr[i].ks.k);
                  } else {
                    jLen = arr[i].ks.k.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (arr[i].ks.k[j].s) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].s[0]);
                      }

                      if (arr[i].ks.k[j].e) {
                        convertPathsToAbsoluteValues(arr[i].ks.k[j].e[0]);
                      }
                    }
                  }
                } else if (arr[i].ty === 'gr') {
                  completeShapes(arr[i].it);
                }
              }
            }

            function convertPathsToAbsoluteValues(path) {
              var i;
              var len = path.i.length;

              for (i = 0; i < len; i += 1) {
                path.i[i][0] += path.v[i][0];
                path.i[i][1] += path.v[i][1];
                path.o[i][0] += path.v[i][0];
                path.o[i][1] += path.v[i][1];
              }
            }

            function checkVersion(minimum, animVersionString) {
              var animVersion = animVersionString ? animVersionString.split('.') : [100, 100, 100];

              if (minimum[0] > animVersion[0]) {
                return true;
              }

              if (animVersion[0] > minimum[0]) {
                return false;
              }

              if (minimum[1] > animVersion[1]) {
                return true;
              }

              if (animVersion[1] > minimum[1]) {
                return false;
              }

              if (minimum[2] > animVersion[2]) {
                return true;
              }

              if (animVersion[2] > minimum[2]) {
                return false;
              }

              return null;
            }

            var checkText = function () {
              var minimumVersion = [4, 4, 14];

              function updateTextLayer(textLayer) {
                var documentData = textLayer.t.d;
                textLayer.t.d = {
                  k: [{
                    s: documentData,
                    t: 0
                  }]
                };
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkChars = function () {
              var minimumVersion = [4, 7, 99];
              return function (animationData) {
                if (animationData.chars && !checkVersion(minimumVersion, animationData.v)) {
                  var i;
                  var len = animationData.chars.length;

                  for (i = 0; i < len; i += 1) {
                    var charData = animationData.chars[i];

                    if (charData.data && charData.data.shapes) {
                      completeShapes(charData.data.shapes);
                      charData.data.ip = 0;
                      charData.data.op = 99999;
                      charData.data.st = 0;
                      charData.data.sr = 1;
                      charData.data.ks = {
                        p: {
                          k: [0, 0],
                          a: 0
                        },
                        s: {
                          k: [100, 100],
                          a: 0
                        },
                        a: {
                          k: [0, 0],
                          a: 0
                        },
                        r: {
                          k: 0,
                          a: 0
                        },
                        o: {
                          k: 100,
                          a: 0
                        }
                      };

                      if (!animationData.chars[i].t) {
                        charData.data.shapes.push({
                          ty: 'no'
                        });
                        charData.data.shapes[0].it.push({
                          p: {
                            k: [0, 0],
                            a: 0
                          },
                          s: {
                            k: [100, 100],
                            a: 0
                          },
                          a: {
                            k: [0, 0],
                            a: 0
                          },
                          r: {
                            k: 0,
                            a: 0
                          },
                          o: {
                            k: 100,
                            a: 0
                          },
                          sk: {
                            k: 0,
                            a: 0
                          },
                          sa: {
                            k: 0,
                            a: 0
                          },
                          ty: 'tr'
                        });
                      }
                    }
                  }
                }
              };
            }();

            var checkPathProperties = function () {
              var minimumVersion = [5, 7, 15];

              function updateTextLayer(textLayer) {
                var pathData = textLayer.t.p;

                if (typeof pathData.a === 'number') {
                  pathData.a = {
                    a: 0,
                    k: pathData.a
                  };
                }

                if (typeof pathData.p === 'number') {
                  pathData.p = {
                    a: 0,
                    k: pathData.p
                  };
                }

                if (typeof pathData.r === 'number') {
                  pathData.r = {
                    a: 0,
                    k: pathData.r
                  };
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 5) {
                    updateTextLayer(layers[i]);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkColors = function () {
              var minimumVersion = [4, 1, 9];

              function iterateShapes(shapes) {
                var i;
                var len = shapes.length;
                var j;
                var jLen;

                for (i = 0; i < len; i += 1) {
                  if (shapes[i].ty === 'gr') {
                    iterateShapes(shapes[i].it);
                  } else if (shapes[i].ty === 'fl' || shapes[i].ty === 'st') {
                    if (shapes[i].c.k && shapes[i].c.k[0].i) {
                      jLen = shapes[i].c.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (shapes[i].c.k[j].s) {
                          shapes[i].c.k[j].s[0] /= 255;
                          shapes[i].c.k[j].s[1] /= 255;
                          shapes[i].c.k[j].s[2] /= 255;
                          shapes[i].c.k[j].s[3] /= 255;
                        }

                        if (shapes[i].c.k[j].e) {
                          shapes[i].c.k[j].e[0] /= 255;
                          shapes[i].c.k[j].e[1] /= 255;
                          shapes[i].c.k[j].e[2] /= 255;
                          shapes[i].c.k[j].e[3] /= 255;
                        }
                      }
                    } else {
                      shapes[i].c.k[0] /= 255;
                      shapes[i].c.k[1] /= 255;
                      shapes[i].c.k[2] /= 255;
                      shapes[i].c.k[3] /= 255;
                    }
                  }
                }
              }

              function iterateLayers(layers) {
                var i;
                var len = layers.length;

                for (i = 0; i < len; i += 1) {
                  if (layers[i].ty === 4) {
                    iterateShapes(layers[i].shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            var checkShapes = function () {
              var minimumVersion = [4, 4, 18];

              function completeClosingShapes(arr) {
                var i;
                var len = arr.length;
                var j;
                var jLen;

                for (i = len - 1; i >= 0; i -= 1) {
                  if (arr[i].ty === 'sh') {
                    if (arr[i].ks.k.i) {
                      arr[i].ks.k.c = arr[i].closed;
                    } else {
                      jLen = arr[i].ks.k.length;

                      for (j = 0; j < jLen; j += 1) {
                        if (arr[i].ks.k[j].s) {
                          arr[i].ks.k[j].s[0].c = arr[i].closed;
                        }

                        if (arr[i].ks.k[j].e) {
                          arr[i].ks.k[j].e[0].c = arr[i].closed;
                        }
                      }
                    }
                  } else if (arr[i].ty === 'gr') {
                    completeClosingShapes(arr[i].it);
                  }
                }
              }

              function iterateLayers(layers) {
                var layerData;
                var i;
                var len = layers.length;
                var j;
                var jLen;
                var k;
                var kLen;

                for (i = 0; i < len; i += 1) {
                  layerData = layers[i];

                  if (layerData.hasMask) {
                    var maskProps = layerData.masksProperties;
                    jLen = maskProps.length;

                    for (j = 0; j < jLen; j += 1) {
                      if (maskProps[j].pt.k.i) {
                        maskProps[j].pt.k.c = maskProps[j].cl;
                      } else {
                        kLen = maskProps[j].pt.k.length;

                        for (k = 0; k < kLen; k += 1) {
                          if (maskProps[j].pt.k[k].s) {
                            maskProps[j].pt.k[k].s[0].c = maskProps[j].cl;
                          }

                          if (maskProps[j].pt.k[k].e) {
                            maskProps[j].pt.k[k].e[0].c = maskProps[j].cl;
                          }
                        }
                      }
                    }
                  }

                  if (layerData.ty === 4) {
                    completeClosingShapes(layerData.shapes);
                  }
                }
              }

              return function (animationData) {
                if (checkVersion(minimumVersion, animationData.v)) {
                  iterateLayers(animationData.layers);

                  if (animationData.assets) {
                    var i;
                    var len = animationData.assets.length;

                    for (i = 0; i < len; i += 1) {
                      if (animationData.assets[i].layers) {
                        iterateLayers(animationData.assets[i].layers);
                      }
                    }
                  }
                }
              };
            }();

            function completeData(animationData) {
              if (animationData.__complete) {
                return;
              }

              checkColors(animationData);
              checkText(animationData);
              checkChars(animationData);
              checkPathProperties(animationData);
              checkShapes(animationData);
              completeLayers(animationData.layers, animationData.assets);
              completeChars(animationData.chars, animationData.assets);
              animationData.__complete = true;
            }

            function completeText(data) {
              if (data.t.a.length === 0 && !('m' in data.t.p)) {// data.singleShape = true;
              }
            }

            var moduleOb = {};
            moduleOb.completeData = completeData;
            moduleOb.checkColors = checkColors;
            moduleOb.checkChars = checkChars;
            moduleOb.checkPathProperties = checkPathProperties;
            moduleOb.checkShapes = checkShapes;
            moduleOb.completeLayers = completeLayers;
            return moduleOb;
          }

          if (!_workerSelf.dataManager) {
            _workerSelf.dataManager = dataFunctionManager();
          }

          if (!_workerSelf.assetLoader) {
            _workerSelf.assetLoader = function () {
              function formatResponse(xhr) {
                // using typeof doubles the time of execution of this method,
                // so if available, it's better to use the header to validate the type
                var contentTypeHeader = xhr.getResponseHeader('content-type');

                if (contentTypeHeader && xhr.responseType === 'json' && contentTypeHeader.indexOf('json') !== -1) {
                  return xhr.response;
                }

                if (xhr.response && _typeof$5(xhr.response) === 'object') {
                  return xhr.response;
                }

                if (xhr.response && typeof xhr.response === 'string') {
                  return JSON.parse(xhr.response);
                }

                if (xhr.responseText) {
                  return JSON.parse(xhr.responseText);
                }

                return null;
              }

              function loadAsset(path, fullPath, callback, errorCallback) {
                var response;
                var xhr = new XMLHttpRequest(); // set responseType after calling open or IE will break.

                try {
                  // This crashes on Android WebView prior to KitKat
                  xhr.responseType = 'json';
                } catch (err) {} // eslint-disable-line no-empty


                xhr.onreadystatechange = function () {
                  if (xhr.readyState === 4) {
                    if (xhr.status === 200) {
                      response = formatResponse(xhr);
                      callback(response);
                    } else {
                      try {
                        response = formatResponse(xhr);
                        callback(response);
                      } catch (err) {
                        if (errorCallback) {
                          errorCallback(err);
                        }
                      }
                    }
                  }
                };

                try {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), path, true);
                } catch (error) {
                  // Hack to workaround banner validation
                  xhr.open(['G', 'E', 'T'].join(''), fullPath + '/' + path, true);
                }

                xhr.send();
              }

              return {
                load: loadAsset
              };
            }();
          }

          if (e.data.type === 'loadAnimation') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.dataManager.completeData(data);

              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          } else if (e.data.type === 'complete') {
            var animation = e.data.animation;

            _workerSelf.dataManager.completeData(animation);

            _workerSelf.postMessage({
              id: e.data.id,
              payload: animation,
              status: 'success'
            });
          } else if (e.data.type === 'loadData') {
            _workerSelf.assetLoader.load(e.data.path, e.data.fullPath, function (data) {
              _workerSelf.postMessage({
                id: e.data.id,
                payload: data,
                status: 'success'
              });
            }, function () {
              _workerSelf.postMessage({
                id: e.data.id,
                status: 'error'
              });
            });
          }
        });

        workerInstance.onmessage = function (event) {
          var data = event.data;
          var id = data.id;
          var process = processes[id];
          processes[id] = null;

          if (data.status === 'success') {
            process.onComplete(data.payload);
          } else if (process.onError) {
            process.onError();
          }
        };
      }
    }

    function createProcess(onComplete, onError) {
      _counterId += 1;
      var id = 'processId_' + _counterId;
      processes[id] = {
        onComplete: onComplete,
        onError: onError
      };
      return id;
    }

    function loadAnimation(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadAnimation',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function loadData(path, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'loadData',
        path: path,
        fullPath: window.location.origin + window.location.pathname,
        id: processId
      });
    }

    function completeAnimation(anim, onComplete, onError) {
      setupWorker();
      var processId = createProcess(onComplete, onError);
      workerInstance.postMessage({
        type: 'complete',
        animation: anim,
        id: processId
      });
    }

    return {
      loadAnimation: loadAnimation,
      loadData: loadData,
      completeAnimation: completeAnimation
    };
  }();

  var ImagePreloader = function () {
    var proxyImage = function () {
      var canvas = createTag('canvas');
      canvas.width = 1;
      canvas.height = 1;
      var ctx = canvas.getContext('2d');
      ctx.fillStyle = 'rgba(0,0,0,0)';
      ctx.fillRect(0, 0, 1, 1);
      return canvas;
    }();

    function imageLoaded() {
      this.loadedAssets += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function footageLoaded() {
      this.loadedFootagesCount += 1;

      if (this.loadedAssets === this.totalImages && this.loadedFootagesCount === this.totalFootages) {
        if (this.imagesLoadedCb) {
          this.imagesLoadedCb(null);
        }
      }
    }

    function getAssetsPath(assetData, assetsPath, originalPath) {
      var path = '';

      if (assetData.e) {
        path = assetData.p;
      } else if (assetsPath) {
        var imagePath = assetData.p;

        if (imagePath.indexOf('images/') !== -1) {
          imagePath = imagePath.split('/')[1];
        }

        path = assetsPath + imagePath;
      } else {
        path = originalPath;
        path += assetData.u ? assetData.u : '';
        path += assetData.p;
      }

      return path;
    }

    function testImageLoaded(img) {
      var _count = 0;
      var intervalId = setInterval(function () {
        var box = img.getBBox();

        if (box.width || _count > 500) {
          this._imageLoaded();

          clearInterval(intervalId);
        }

        _count += 1;
      }.bind(this), 50);
    }

    function createImageData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createNS('image');

      if (isSafari) {
        this.testImageLoaded(img);
      } else {
        img.addEventListener('load', this._imageLoaded, false);
      }

      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.setAttributeNS('http://www.w3.org/1999/xlink', 'href', path);

      if (this._elementHelper.append) {
        this._elementHelper.append(img);
      } else {
        this._elementHelper.appendChild(img);
      }

      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createImgData(assetData) {
      var path = getAssetsPath(assetData, this.assetsPath, this.path);
      var img = createTag('img');
      img.crossOrigin = 'anonymous';
      img.addEventListener('load', this._imageLoaded, false);
      img.addEventListener('error', function () {
        ob.img = proxyImage;

        this._imageLoaded();
      }.bind(this), false);
      img.src = path;
      var ob = {
        img: img,
        assetData: assetData
      };
      return ob;
    }

    function createFootageData(data) {
      var ob = {
        assetData: data
      };
      var path = getAssetsPath(data, this.assetsPath, this.path);
      dataManager.loadData(path, function (footageData) {
        ob.img = footageData;

        this._footageLoaded();
      }.bind(this), function () {
        ob.img = {};

        this._footageLoaded();
      }.bind(this));
      return ob;
    }

    function loadAssets(assets, cb) {
      this.imagesLoadedCb = cb;
      var i;
      var len = assets.length;

      for (i = 0; i < len; i += 1) {
        if (!assets[i].layers) {
          if (!assets[i].t || assets[i].t === 'seq') {
            this.totalImages += 1;
            this.images.push(this._createImageData(assets[i]));
          } else if (assets[i].t === 3) {
            this.totalFootages += 1;
            this.images.push(this.createFootageData(assets[i]));
          }
        }
      }
    }

    function setPath(path) {
      this.path = path || '';
    }

    function setAssetsPath(path) {
      this.assetsPath = path || '';
    }

    function getAsset(assetData) {
      var i = 0;
      var len = this.images.length;

      while (i < len) {
        if (this.images[i].assetData === assetData) {
          return this.images[i].img;
        }

        i += 1;
      }

      return null;
    }

    function destroy() {
      this.imagesLoadedCb = null;
      this.images.length = 0;
    }

    function loadedImages() {
      return this.totalImages === this.loadedAssets;
    }

    function loadedFootages() {
      return this.totalFootages === this.loadedFootagesCount;
    }

    function setCacheType(type, elementHelper) {
      if (type === 'svg') {
        this._elementHelper = elementHelper;
        this._createImageData = this.createImageData.bind(this);
      } else {
        this._createImageData = this.createImgData.bind(this);
      }
    }

    function ImagePreloaderFactory() {
      this._imageLoaded = imageLoaded.bind(this);
      this._footageLoaded = footageLoaded.bind(this);
      this.testImageLoaded = testImageLoaded.bind(this);
      this.createFootageData = createFootageData.bind(this);
      this.assetsPath = '';
      this.path = '';
      this.totalImages = 0;
      this.totalFootages = 0;
      this.loadedAssets = 0;
      this.loadedFootagesCount = 0;
      this.imagesLoadedCb = null;
      this.images = [];
    }

    ImagePreloaderFactory.prototype = {
      loadAssets: loadAssets,
      setAssetsPath: setAssetsPath,
      setPath: setPath,
      loadedImages: loadedImages,
      loadedFootages: loadedFootages,
      destroy: destroy,
      getAsset: getAsset,
      createImgData: createImgData,
      createImageData: createImageData,
      imageLoaded: imageLoaded,
      footageLoaded: footageLoaded,
      setCacheType: setCacheType
    };
    return ImagePreloaderFactory;
  }();

  function BaseEvent() {}

  BaseEvent.prototype = {
    triggerEvent: function triggerEvent(eventName, args) {
      if (this._cbs[eventName]) {
        var callbacks = this._cbs[eventName];

        for (var i = 0; i < callbacks.length; i += 1) {
          callbacks[i](args);
        }
      }
    },
    addEventListener: function addEventListener(eventName, callback) {
      if (!this._cbs[eventName]) {
        this._cbs[eventName] = [];
      }

      this._cbs[eventName].push(callback);

      return function () {
        this.removeEventListener(eventName, callback);
      }.bind(this);
    },
    removeEventListener: function removeEventListener(eventName, callback) {
      if (!callback) {
        this._cbs[eventName] = null;
      } else if (this._cbs[eventName]) {
        var i = 0;
        var len = this._cbs[eventName].length;

        while (i < len) {
          if (this._cbs[eventName][i] === callback) {
            this._cbs[eventName].splice(i, 1);

            i -= 1;
            len -= 1;
          }

          i += 1;
        }

        if (!this._cbs[eventName].length) {
          this._cbs[eventName] = null;
        }
      }
    }
  };

  var markerParser = function () {
    function parsePayloadLines(payload) {
      var lines = payload.split('\r\n');
      var keys = {};
      var line;
      var keysCount = 0;

      for (var i = 0; i < lines.length; i += 1) {
        line = lines[i].split(':');

        if (line.length === 2) {
          keys[line[0]] = line[1].trim();
          keysCount += 1;
        }
      }

      if (keysCount === 0) {
        throw new Error();
      }

      return keys;
    }

    return function (_markers) {
      var markers = [];

      for (var i = 0; i < _markers.length; i += 1) {
        var _marker = _markers[i];
        var markerData = {
          time: _marker.tm,
          duration: _marker.dr
        };

        try {
          markerData.payload = JSON.parse(_markers[i].cm);
        } catch (_) {
          try {
            markerData.payload = parsePayloadLines(_markers[i].cm);
          } catch (__) {
            markerData.payload = {
              name: _markers[i].cm
            };
          }
        }

        markers.push(markerData);
      }

      return markers;
    };
  }();

  var ProjectInterface = function () {
    function registerComposition(comp) {
      this.compositions.push(comp);
    }

    return function () {
      function _thisProjectFunction(name) {
        var i = 0;
        var len = this.compositions.length;

        while (i < len) {
          if (this.compositions[i].data && this.compositions[i].data.nm === name) {
            if (this.compositions[i].prepareFrame && this.compositions[i].data.xt) {
              this.compositions[i].prepareFrame(this.currentFrame);
            }

            return this.compositions[i].compInterface;
          }

          i += 1;
        }

        return null;
      }

      _thisProjectFunction.compositions = [];
      _thisProjectFunction.currentFrame = 0;
      _thisProjectFunction.registerComposition = registerComposition;
      return _thisProjectFunction;
    };
  }();

  var renderers = {};

  var registerRenderer = function registerRenderer(key, value) {
    renderers[key] = value;
  };

  function getRenderer(key) {
    return renderers[key];
  }

  function getRegisteredRenderer() {
    // Returns canvas by default for compatibility
    if (renderers.canvas) {
      return 'canvas';
    } // Returns any renderer that is registered


    for (var key in renderers) {
      if (renderers[key]) {
        return key;
      }
    }

    return '';
  }

  function _typeof$4(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$4 = function _typeof(obj) { return typeof obj; }; } else { _typeof$4 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$4(obj); }

  var AnimationItem = function AnimationItem() {
    this._cbs = [];
    this.name = '';
    this.path = '';
    this.isLoaded = false;
    this.currentFrame = 0;
    this.currentRawFrame = 0;
    this.firstFrame = 0;
    this.totalFrames = 0;
    this.frameRate = 0;
    this.frameMult = 0;
    this.playSpeed = 1;
    this.playDirection = 1;
    this.playCount = 0;
    this.animationData = {};
    this.assets = [];
    this.isPaused = true;
    this.autoplay = false;
    this.loop = true;
    this.renderer = null;
    this.animationID = createElementID();
    this.assetsPath = '';
    this.timeCompleted = 0;
    this.segmentPos = 0;
    this.isSubframeEnabled = getSubframeEnabled();
    this.segments = [];
    this._idle = true;
    this._completedLoop = false;
    this.projectInterface = ProjectInterface();
    this.imagePreloader = new ImagePreloader();
    this.audioController = audioControllerFactory();
    this.markers = [];
    this.configAnimation = this.configAnimation.bind(this);
    this.onSetupError = this.onSetupError.bind(this);
    this.onSegmentComplete = this.onSegmentComplete.bind(this);
    this.drawnFrameEvent = new BMEnterFrameEvent('drawnFrame', 0, 0, 0);
    this.expressionsPlugin = getExpressionsPlugin();
  };

  extendPrototype([BaseEvent], AnimationItem);

  AnimationItem.prototype.setParams = function (params) {
    if (params.wrapper || params.container) {
      this.wrapper = params.wrapper || params.container;
    }

    var animType = 'svg';

    if (params.animType) {
      animType = params.animType;
    } else if (params.renderer) {
      animType = params.renderer;
    }

    var RendererClass = getRenderer(animType);
    this.renderer = new RendererClass(this, params.rendererSettings);
    this.imagePreloader.setCacheType(animType, this.renderer.globalData.defs);
    this.renderer.setProjectInterface(this.projectInterface);
    this.animType = animType;

    if (params.loop === '' || params.loop === null || params.loop === undefined || params.loop === true) {
      this.loop = true;
    } else if (params.loop === false) {
      this.loop = false;
    } else {
      this.loop = parseInt(params.loop, 10);
    }

    this.autoplay = 'autoplay' in params ? params.autoplay : true;
    this.name = params.name ? params.name : '';
    this.autoloadSegments = Object.prototype.hasOwnProperty.call(params, 'autoloadSegments') ? params.autoloadSegments : true;
    this.assetsPath = params.assetsPath;
    this.initialSegment = params.initialSegment;

    if (params.audioFactory) {
      this.audioController.setAudioFactory(params.audioFactory);
    }

    if (params.animationData) {
      this.setupAnimation(params.animationData);
    } else if (params.path) {
      if (params.path.lastIndexOf('\\') !== -1) {
        this.path = params.path.substr(0, params.path.lastIndexOf('\\') + 1);
      } else {
        this.path = params.path.substr(0, params.path.lastIndexOf('/') + 1);
      }

      this.fileName = params.path.substr(params.path.lastIndexOf('/') + 1);
      this.fileName = this.fileName.substr(0, this.fileName.lastIndexOf('.json'));
      dataManager.loadAnimation(params.path, this.configAnimation, this.onSetupError);
    }
  };

  AnimationItem.prototype.onSetupError = function () {
    this.trigger('data_failed');
  };

  AnimationItem.prototype.setupAnimation = function (data) {
    dataManager.completeAnimation(data, this.configAnimation);
  };

  AnimationItem.prototype.setData = function (wrapper, animationData) {
    if (animationData) {
      if (_typeof$4(animationData) !== 'object') {
        animationData = JSON.parse(animationData);
      }
    }

    var params = {
      wrapper: wrapper,
      animationData: animationData
    };
    var wrapperAttributes = wrapper.attributes;
    params.path = wrapperAttributes.getNamedItem('data-animation-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-animation-path').value : wrapperAttributes.getNamedItem('data-bm-path') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-path').value : wrapperAttributes.getNamedItem('bm-path') ? wrapperAttributes.getNamedItem('bm-path').value : '';
    params.animType = wrapperAttributes.getNamedItem('data-anim-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-type').value : wrapperAttributes.getNamedItem('data-bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-type').value : wrapperAttributes.getNamedItem('bm-type') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('bm-type').value : wrapperAttributes.getNamedItem('data-bm-renderer') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-renderer').value : wrapperAttributes.getNamedItem('bm-renderer') ? wrapperAttributes.getNamedItem('bm-renderer').value : getRegisteredRenderer() || 'canvas';
    var loop = wrapperAttributes.getNamedItem('data-anim-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-loop').value : wrapperAttributes.getNamedItem('data-bm-loop') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-loop').value : wrapperAttributes.getNamedItem('bm-loop') ? wrapperAttributes.getNamedItem('bm-loop').value : '';

    if (loop === 'false') {
      params.loop = false;
    } else if (loop === 'true') {
      params.loop = true;
    } else if (loop !== '') {
      params.loop = parseInt(loop, 10);
    }

    var autoplay = wrapperAttributes.getNamedItem('data-anim-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-autoplay').value : wrapperAttributes.getNamedItem('data-bm-autoplay') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-autoplay').value : wrapperAttributes.getNamedItem('bm-autoplay') ? wrapperAttributes.getNamedItem('bm-autoplay').value : true;
    params.autoplay = autoplay !== 'false';
    params.name = wrapperAttributes.getNamedItem('data-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-name').value : wrapperAttributes.getNamedItem('data-bm-name') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-name').value : wrapperAttributes.getNamedItem('bm-name') ? wrapperAttributes.getNamedItem('bm-name').value : '';
    var prerender = wrapperAttributes.getNamedItem('data-anim-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-anim-prerender').value : wrapperAttributes.getNamedItem('data-bm-prerender') // eslint-disable-line no-nested-ternary
    ? wrapperAttributes.getNamedItem('data-bm-prerender').value : wrapperAttributes.getNamedItem('bm-prerender') ? wrapperAttributes.getNamedItem('bm-prerender').value : '';

    if (prerender === 'false') {
      params.prerender = false;
    }

    if (!params.path) {
      this.trigger('destroy');
    } else {
      this.setParams(params);
    }
  };

  AnimationItem.prototype.includeLayers = function (data) {
    if (data.op > this.animationData.op) {
      this.animationData.op = data.op;
      this.totalFrames = Math.floor(data.op - this.animationData.ip);
    }

    var layers = this.animationData.layers;
    var i;
    var len = layers.length;
    var newLayers = data.layers;
    var j;
    var jLen = newLayers.length;

    for (j = 0; j < jLen; j += 1) {
      i = 0;

      while (i < len) {
        if (layers[i].id === newLayers[j].id) {
          layers[i] = newLayers[j];
          break;
        }

        i += 1;
      }
    }

    if (data.chars || data.fonts) {
      this.renderer.globalData.fontManager.addChars(data.chars);
      this.renderer.globalData.fontManager.addFonts(data.fonts, this.renderer.globalData.defs);
    }

    if (data.assets) {
      len = data.assets.length;

      for (i = 0; i < len; i += 1) {
        this.animationData.assets.push(data.assets[i]);
      }
    }

    this.animationData.__complete = false;
    dataManager.completeAnimation(this.animationData, this.onSegmentComplete);
  };

  AnimationItem.prototype.onSegmentComplete = function (data) {
    this.animationData = data;
    var expressionsPlugin = getExpressionsPlugin();

    if (expressionsPlugin) {
      expressionsPlugin.initExpressions(this);
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.loadNextSegment = function () {
    var segments = this.animationData.segments;

    if (!segments || segments.length === 0 || !this.autoloadSegments) {
      this.trigger('data_ready');
      this.timeCompleted = this.totalFrames;
      return;
    }

    var segment = segments.shift();
    this.timeCompleted = segment.time * this.frameRate;
    var segmentPath = this.path + this.fileName + '_' + this.segmentPos + '.json';
    this.segmentPos += 1;
    dataManager.loadData(segmentPath, this.includeLayers.bind(this), function () {
      this.trigger('data_failed');
    }.bind(this));
  };

  AnimationItem.prototype.loadSegments = function () {
    var segments = this.animationData.segments;

    if (!segments) {
      this.timeCompleted = this.totalFrames;
    }

    this.loadNextSegment();
  };

  AnimationItem.prototype.imagesLoaded = function () {
    this.trigger('loaded_images');
    this.checkLoaded();
  };

  AnimationItem.prototype.preloadImages = function () {
    this.imagePreloader.setAssetsPath(this.assetsPath);
    this.imagePreloader.setPath(this.path);
    this.imagePreloader.loadAssets(this.animationData.assets, this.imagesLoaded.bind(this));
  };

  AnimationItem.prototype.configAnimation = function (animData) {
    if (!this.renderer) {
      return;
    }

    try {
      this.animationData = animData;

      if (this.initialSegment) {
        this.totalFrames = Math.floor(this.initialSegment[1] - this.initialSegment[0]);
        this.firstFrame = Math.round(this.initialSegment[0]);
      } else {
        this.totalFrames = Math.floor(this.animationData.op - this.animationData.ip);
        this.firstFrame = Math.round(this.animationData.ip);
      }

      this.renderer.configAnimation(animData);

      if (!animData.assets) {
        animData.assets = [];
      }

      this.assets = this.animationData.assets;
      this.frameRate = this.animationData.fr;
      this.frameMult = this.animationData.fr / 1000;
      this.renderer.searchExtraCompositions(animData.assets);
      this.markers = markerParser(animData.markers || []);
      this.trigger('config_ready');
      this.preloadImages();
      this.loadSegments();
      this.updaFrameModifier();
      this.waitForFontsLoaded();

      if (this.isPaused) {
        this.audioController.pause();
      }
    } catch (error) {
      this.triggerConfigError(error);
    }
  };

  AnimationItem.prototype.waitForFontsLoaded = function () {
    if (!this.renderer) {
      return;
    }

    if (this.renderer.globalData.fontManager.isLoaded) {
      this.checkLoaded();
    } else {
      setTimeout(this.waitForFontsLoaded.bind(this), 20);
    }
  };

  AnimationItem.prototype.checkLoaded = function () {
    if (!this.isLoaded && this.renderer.globalData.fontManager.isLoaded && (this.imagePreloader.loadedImages() || this.renderer.rendererType !== 'canvas') && this.imagePreloader.loadedFootages()) {
      this.isLoaded = true;
      var expressionsPlugin = getExpressionsPlugin();

      if (expressionsPlugin) {
        expressionsPlugin.initExpressions(this);
      }

      this.renderer.initItems();
      setTimeout(function () {
        this.trigger('DOMLoaded');
      }.bind(this), 0);
      this.gotoFrame();

      if (this.autoplay) {
        this.play();
      }
    }
  };

  AnimationItem.prototype.resize = function (width, height) {
    // Adding this validation for backwards compatibility in case an event object was being passed down
    var _width = typeof width === 'number' ? width : undefined;

    var _height = typeof height === 'number' ? height : undefined;

    this.renderer.updateContainerSize(_width, _height);
  };

  AnimationItem.prototype.setSubframe = function (flag) {
    this.isSubframeEnabled = !!flag;
  };

  AnimationItem.prototype.gotoFrame = function () {
    this.currentFrame = this.isSubframeEnabled ? this.currentRawFrame : ~~this.currentRawFrame; // eslint-disable-line no-bitwise

    if (this.timeCompleted !== this.totalFrames && this.currentFrame > this.timeCompleted) {
      this.currentFrame = this.timeCompleted;
    }

    this.trigger('enterFrame');
    this.renderFrame();
    this.trigger('drawnFrame');
  };

  AnimationItem.prototype.renderFrame = function () {
    if (this.isLoaded === false || !this.renderer) {
      return;
    }

    try {
      if (this.expressionsPlugin) {
        this.expressionsPlugin.resetFrame();
      }

      this.renderer.renderFrame(this.currentFrame + this.firstFrame);
    } catch (error) {
      this.triggerRenderFrameError(error);
    }
  };

  AnimationItem.prototype.play = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.isPaused = false;
      this.trigger('_play');
      this.audioController.resume();

      if (this._idle) {
        this._idle = false;
        this.trigger('_active');
      }
    }
  };

  AnimationItem.prototype.pause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === false) {
      this.isPaused = true;
      this.trigger('_pause');
      this._idle = true;
      this.trigger('_idle');
      this.audioController.pause();
    }
  };

  AnimationItem.prototype.togglePause = function (name) {
    if (name && this.name !== name) {
      return;
    }

    if (this.isPaused === true) {
      this.play();
    } else {
      this.pause();
    }
  };

  AnimationItem.prototype.stop = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.pause();
    this.playCount = 0;
    this._completedLoop = false;
    this.setCurrentRawFrameValue(0);
  };

  AnimationItem.prototype.getMarkerData = function (markerName) {
    var marker;

    for (var i = 0; i < this.markers.length; i += 1) {
      marker = this.markers[i];

      if (marker.payload && marker.payload.name === markerName) {
        return marker;
      }
    }

    return null;
  };

  AnimationItem.prototype.goToAndStop = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        this.goToAndStop(marker.time, true);
      }
    } else if (isFrame) {
      this.setCurrentRawFrameValue(value);
    } else {
      this.setCurrentRawFrameValue(value * this.frameModifier);
    }

    this.pause();
  };

  AnimationItem.prototype.goToAndPlay = function (value, isFrame, name) {
    if (name && this.name !== name) {
      return;
    }

    var numValue = Number(value);

    if (isNaN(numValue)) {
      var marker = this.getMarkerData(value);

      if (marker) {
        if (!marker.duration) {
          this.goToAndStop(marker.time, true);
        } else {
          this.playSegments([marker.time, marker.time + marker.duration], true);
        }
      }
    } else {
      this.goToAndStop(numValue, isFrame, name);
    }

    this.play();
  };

  AnimationItem.prototype.advanceTime = function (value) {
    if (this.isPaused === true || this.isLoaded === false) {
      return;
    }

    var nextValue = this.currentRawFrame + value * this.frameModifier;
    var _isComplete = false; // Checking if nextValue > totalFrames - 1 for addressing non looping and looping animations.
    // If animation won't loop, it should stop at totalFrames - 1. If it will loop it should complete the last frame and then loop.

    if (nextValue >= this.totalFrames - 1 && this.frameModifier > 0) {
      if (!this.loop || this.playCount === this.loop) {
        if (!this.checkSegments(nextValue > this.totalFrames ? nextValue % this.totalFrames : 0)) {
          _isComplete = true;
          nextValue = this.totalFrames - 1;
        }
      } else if (nextValue >= this.totalFrames) {
        this.playCount += 1;

        if (!this.checkSegments(nextValue % this.totalFrames)) {
          this.setCurrentRawFrameValue(nextValue % this.totalFrames);
          this._completedLoop = true;
          this.trigger('loopComplete');
        }
      } else {
        this.setCurrentRawFrameValue(nextValue);
      }
    } else if (nextValue < 0) {
      if (!this.checkSegments(nextValue % this.totalFrames)) {
        if (this.loop && !(this.playCount-- <= 0 && this.loop !== true)) {
          // eslint-disable-line no-plusplus
          this.setCurrentRawFrameValue(this.totalFrames + nextValue % this.totalFrames);

          if (!this._completedLoop) {
            this._completedLoop = true;
          } else {
            this.trigger('loopComplete');
          }
        } else {
          _isComplete = true;
          nextValue = 0;
        }
      }
    } else {
      this.setCurrentRawFrameValue(nextValue);
    }

    if (_isComplete) {
      this.setCurrentRawFrameValue(nextValue);
      this.pause();
      this.trigger('complete');
    }
  };

  AnimationItem.prototype.adjustSegment = function (arr, offset) {
    this.playCount = 0;

    if (arr[1] < arr[0]) {
      if (this.frameModifier > 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(-1);
        }
      }

      this.totalFrames = arr[0] - arr[1];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[1];
      this.setCurrentRawFrameValue(this.totalFrames - 0.001 - offset);
    } else if (arr[1] > arr[0]) {
      if (this.frameModifier < 0) {
        if (this.playSpeed < 0) {
          this.setSpeed(-this.playSpeed);
        } else {
          this.setDirection(1);
        }
      }

      this.totalFrames = arr[1] - arr[0];
      this.timeCompleted = this.totalFrames;
      this.firstFrame = arr[0];
      this.setCurrentRawFrameValue(0.001 + offset);
    }

    this.trigger('segmentStart');
  };

  AnimationItem.prototype.setSegment = function (init, end) {
    var pendingFrame = -1;

    if (this.isPaused) {
      if (this.currentRawFrame + this.firstFrame < init) {
        pendingFrame = init;
      } else if (this.currentRawFrame + this.firstFrame > end) {
        pendingFrame = end - init;
      }
    }

    this.firstFrame = init;
    this.totalFrames = end - init;
    this.timeCompleted = this.totalFrames;

    if (pendingFrame !== -1) {
      this.goToAndStop(pendingFrame, true);
    }
  };

  AnimationItem.prototype.playSegments = function (arr, forceFlag) {
    if (forceFlag) {
      this.segments.length = 0;
    }

    if (_typeof$4(arr[0]) === 'object') {
      var i;
      var len = arr.length;

      for (i = 0; i < len; i += 1) {
        this.segments.push(arr[i]);
      }
    } else {
      this.segments.push(arr);
    }

    if (this.segments.length && forceFlag) {
      this.adjustSegment(this.segments.shift(), 0);
    }

    if (this.isPaused) {
      this.play();
    }
  };

  AnimationItem.prototype.resetSegments = function (forceFlag) {
    this.segments.length = 0;
    this.segments.push([this.animationData.ip, this.animationData.op]);

    if (forceFlag) {
      this.checkSegments(0);
    }
  };

  AnimationItem.prototype.checkSegments = function (offset) {
    if (this.segments.length) {
      this.adjustSegment(this.segments.shift(), offset);
      return true;
    }

    return false;
  };

  AnimationItem.prototype.destroy = function (name) {
    if (name && this.name !== name || !this.renderer) {
      return;
    }

    this.renderer.destroy();
    this.imagePreloader.destroy();
    this.trigger('destroy');
    this._cbs = null;
    this.onEnterFrame = null;
    this.onLoopComplete = null;
    this.onComplete = null;
    this.onSegmentStart = null;
    this.onDestroy = null;
    this.renderer = null;
    this.expressionsPlugin = null;
    this.imagePreloader = null;
    this.projectInterface = null;
  };

  AnimationItem.prototype.setCurrentRawFrameValue = function (value) {
    this.currentRawFrame = value;
    this.gotoFrame();
  };

  AnimationItem.prototype.setSpeed = function (val) {
    this.playSpeed = val;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setDirection = function (val) {
    this.playDirection = val < 0 ? -1 : 1;
    this.updaFrameModifier();
  };

  AnimationItem.prototype.setLoop = function (isLooping) {
    this.loop = isLooping;
  };

  AnimationItem.prototype.setVolume = function (val, name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.setVolume(val);
  };

  AnimationItem.prototype.getVolume = function () {
    return this.audioController.getVolume();
  };

  AnimationItem.prototype.mute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.mute();
  };

  AnimationItem.prototype.unmute = function (name) {
    if (name && this.name !== name) {
      return;
    }

    this.audioController.unmute();
  };

  AnimationItem.prototype.updaFrameModifier = function () {
    this.frameModifier = this.frameMult * this.playSpeed * this.playDirection;
    this.audioController.setRate(this.playSpeed * this.playDirection);
  };

  AnimationItem.prototype.getPath = function () {
    return this.path;
  };

  AnimationItem.prototype.getAssetsPath = function (assetData) {
    var path = '';

    if (assetData.e) {
      path = assetData.p;
    } else if (this.assetsPath) {
      var imagePath = assetData.p;

      if (imagePath.indexOf('images/') !== -1) {
        imagePath = imagePath.split('/')[1];
      }

      path = this.assetsPath + imagePath;
    } else {
      path = this.path;
      path += assetData.u ? assetData.u : '';
      path += assetData.p;
    }

    return path;
  };

  AnimationItem.prototype.getAssetData = function (id) {
    var i = 0;
    var len = this.assets.length;

    while (i < len) {
      if (id === this.assets[i].id) {
        return this.assets[i];
      }

      i += 1;
    }

    return null;
  };

  AnimationItem.prototype.hide = function () {
    this.renderer.hide();
  };

  AnimationItem.prototype.show = function () {
    this.renderer.show();
  };

  AnimationItem.prototype.getDuration = function (isFrame) {
    return isFrame ? this.totalFrames : this.totalFrames / this.frameRate;
  };

  AnimationItem.prototype.updateDocumentData = function (path, documentData, index) {
    try {
      var element = this.renderer.getElementByPath(path);
      element.updateDocumentData(documentData, index);
    } catch (error) {// TODO: decide how to handle catch case
    }
  };

  AnimationItem.prototype.trigger = function (name) {
    if (this._cbs && this._cbs[name]) {
      switch (name) {
        case 'enterFrame':
          this.triggerEvent(name, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameModifier));
          break;

        case 'drawnFrame':
          this.drawnFrameEvent.currentTime = this.currentFrame;
          this.drawnFrameEvent.totalTime = this.totalFrames;
          this.drawnFrameEvent.direction = this.frameModifier;
          this.triggerEvent(name, this.drawnFrameEvent);
          break;

        case 'loopComplete':
          this.triggerEvent(name, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
          break;

        case 'complete':
          this.triggerEvent(name, new BMCompleteEvent(name, this.frameMult));
          break;

        case 'segmentStart':
          this.triggerEvent(name, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
          break;

        case 'destroy':
          this.triggerEvent(name, new BMDestroyEvent(name, this));
          break;

        default:
          this.triggerEvent(name);
      }
    }

    if (name === 'enterFrame' && this.onEnterFrame) {
      this.onEnterFrame.call(this, new BMEnterFrameEvent(name, this.currentFrame, this.totalFrames, this.frameMult));
    }

    if (name === 'loopComplete' && this.onLoopComplete) {
      this.onLoopComplete.call(this, new BMCompleteLoopEvent(name, this.loop, this.playCount, this.frameMult));
    }

    if (name === 'complete' && this.onComplete) {
      this.onComplete.call(this, new BMCompleteEvent(name, this.frameMult));
    }

    if (name === 'segmentStart' && this.onSegmentStart) {
      this.onSegmentStart.call(this, new BMSegmentStartEvent(name, this.firstFrame, this.totalFrames));
    }

    if (name === 'destroy' && this.onDestroy) {
      this.onDestroy.call(this, new BMDestroyEvent(name, this));
    }
  };

  AnimationItem.prototype.triggerRenderFrameError = function (nativeError) {
    var error = new BMRenderFrameErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  AnimationItem.prototype.triggerConfigError = function (nativeError) {
    var error = new BMConfigErrorEvent(nativeError, this.currentFrame);
    this.triggerEvent('error', error);

    if (this.onError) {
      this.onError.call(this, error);
    }
  };

  var animationManager = function () {
    var moduleOb = {};
    var registeredAnimations = [];
    var initTime = 0;
    var len = 0;
    var playingAnimationsNum = 0;
    var _stopped = true;
    var _isFrozen = false;

    function removeElement(ev) {
      var i = 0;
      var animItem = ev.target;

      while (i < len) {
        if (registeredAnimations[i].animation === animItem) {
          registeredAnimations.splice(i, 1);
          i -= 1;
          len -= 1;

          if (!animItem.isPaused) {
            subtractPlayingCount();
          }
        }

        i += 1;
      }
    }

    function registerAnimation(element, animationData) {
      if (!element) {
        return null;
      }

      var i = 0;

      while (i < len) {
        if (registeredAnimations[i].elem === element && registeredAnimations[i].elem !== null) {
          return registeredAnimations[i].animation;
        }

        i += 1;
      }

      var animItem = new AnimationItem();
      setupAnimation(animItem, element);
      animItem.setData(element, animationData);
      return animItem;
    }

    function getRegisteredAnimations() {
      var i;
      var lenAnims = registeredAnimations.length;
      var animations = [];

      for (i = 0; i < lenAnims; i += 1) {
        animations.push(registeredAnimations[i].animation);
      }

      return animations;
    }

    function addPlayingCount() {
      playingAnimationsNum += 1;
      activate();
    }

    function subtractPlayingCount() {
      playingAnimationsNum -= 1;
    }

    function setupAnimation(animItem, element) {
      animItem.addEventListener('destroy', removeElement);
      animItem.addEventListener('_active', addPlayingCount);
      animItem.addEventListener('_idle', subtractPlayingCount);
      registeredAnimations.push({
        elem: element,
        animation: animItem
      });
      len += 1;
    }

    function loadAnimation(params) {
      var animItem = new AnimationItem();
      setupAnimation(animItem, null);
      animItem.setParams(params);
      return animItem;
    }

    function setSpeed(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setSpeed(val, animation);
      }
    }

    function setDirection(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setDirection(val, animation);
      }
    }

    function play(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.play(animation);
      }
    }

    function resume(nowTime) {
      var elapsedTime = nowTime - initTime;
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.advanceTime(elapsedTime);
      }

      initTime = nowTime;

      if (playingAnimationsNum && !_isFrozen) {
        window.requestAnimationFrame(resume);
      } else {
        _stopped = true;
      }
    }

    function first(nowTime) {
      initTime = nowTime;
      window.requestAnimationFrame(resume);
    }

    function pause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.pause(animation);
      }
    }

    function goToAndStop(value, isFrame, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.goToAndStop(value, isFrame, animation);
      }
    }

    function stop(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.stop(animation);
      }
    }

    function togglePause(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.togglePause(animation);
      }
    }

    function destroy(animation) {
      var i;

      for (i = len - 1; i >= 0; i -= 1) {
        registeredAnimations[i].animation.destroy(animation);
      }
    }

    function searchAnimations(animationData, standalone, renderer) {
      var animElements = [].concat([].slice.call(document.getElementsByClassName('lottie')), [].slice.call(document.getElementsByClassName('bodymovin')));
      var i;
      var lenAnims = animElements.length;

      for (i = 0; i < lenAnims; i += 1) {
        if (renderer) {
          animElements[i].setAttribute('data-bm-type', renderer);
        }

        registerAnimation(animElements[i], animationData);
      }

      if (standalone && lenAnims === 0) {
        if (!renderer) {
          renderer = 'svg';
        }

        var body = document.getElementsByTagName('body')[0];
        body.innerText = '';
        var div = createTag('div');
        div.style.width = '100%';
        div.style.height = '100%';
        div.setAttribute('data-bm-type', renderer);
        body.appendChild(div);
        registerAnimation(div, animationData);
      }
    }

    function resize() {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.resize();
      }
    }

    function activate() {
      if (!_isFrozen && playingAnimationsNum) {
        if (_stopped) {
          window.requestAnimationFrame(first);
          _stopped = false;
        }
      }
    }

    function freeze() {
      _isFrozen = true;
    }

    function unfreeze() {
      _isFrozen = false;
      activate();
    }

    function setVolume(val, animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.setVolume(val, animation);
      }
    }

    function mute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.mute(animation);
      }
    }

    function unmute(animation) {
      var i;

      for (i = 0; i < len; i += 1) {
        registeredAnimations[i].animation.unmute(animation);
      }
    }

    moduleOb.registerAnimation = registerAnimation;
    moduleOb.loadAnimation = loadAnimation;
    moduleOb.setSpeed = setSpeed;
    moduleOb.setDirection = setDirection;
    moduleOb.play = play;
    moduleOb.pause = pause;
    moduleOb.stop = stop;
    moduleOb.togglePause = togglePause;
    moduleOb.searchAnimations = searchAnimations;
    moduleOb.resize = resize; // moduleOb.start = start;

    moduleOb.goToAndStop = goToAndStop;
    moduleOb.destroy = destroy;
    moduleOb.freeze = freeze;
    moduleOb.unfreeze = unfreeze;
    moduleOb.setVolume = setVolume;
    moduleOb.mute = mute;
    moduleOb.unmute = unmute;
    moduleOb.getRegisteredAnimations = getRegisteredAnimations;
    return moduleOb;
  }();

  /* eslint-disable */
  var BezierFactory = function () {
    /**
       * BezierEasing - use bezier curve for transition easing function
       * by Gaëtan Renaudeau 2014 - 2015 – MIT License
       *
       * Credits: is based on Firefox's nsSMILKeySpline.cpp
       * Usage:
       * var spline = BezierEasing([ 0.25, 0.1, 0.25, 1.0 ])
       * spline.get(x) => returns the easing value | x must be in [0, 1] range
       *
       */
    var ob = {};
    ob.getBezierEasing = getBezierEasing;
    var beziers = {};

    function getBezierEasing(a, b, c, d, nm) {
      var str = nm || ('bez_' + a + '_' + b + '_' + c + '_' + d).replace(/\./g, 'p');

      if (beziers[str]) {
        return beziers[str];
      }

      var bezEasing = new BezierEasing([a, b, c, d]);
      beziers[str] = bezEasing;
      return bezEasing;
    } // These values are established by empiricism with tests (tradeoff: performance VS precision)


    var NEWTON_ITERATIONS = 4;
    var NEWTON_MIN_SLOPE = 0.001;
    var SUBDIVISION_PRECISION = 0.0000001;
    var SUBDIVISION_MAX_ITERATIONS = 10;
    var kSplineTableSize = 11;
    var kSampleStepSize = 1.0 / (kSplineTableSize - 1.0);
    var float32ArraySupported = typeof Float32Array === 'function';

    function A(aA1, aA2) {
      return 1.0 - 3.0 * aA2 + 3.0 * aA1;
    }

    function B(aA1, aA2) {
      return 3.0 * aA2 - 6.0 * aA1;
    }

    function C(aA1) {
      return 3.0 * aA1;
    } // Returns x(t) given t, x1, and x2, or y(t) given t, y1, and y2.


    function calcBezier(aT, aA1, aA2) {
      return ((A(aA1, aA2) * aT + B(aA1, aA2)) * aT + C(aA1)) * aT;
    } // Returns dx/dt given t, x1, and x2, or dy/dt given t, y1, and y2.


    function getSlope(aT, aA1, aA2) {
      return 3.0 * A(aA1, aA2) * aT * aT + 2.0 * B(aA1, aA2) * aT + C(aA1);
    }

    function binarySubdivide(aX, aA, aB, mX1, mX2) {
      var currentX,
          currentT,
          i = 0;

      do {
        currentT = aA + (aB - aA) / 2.0;
        currentX = calcBezier(currentT, mX1, mX2) - aX;

        if (currentX > 0.0) {
          aB = currentT;
        } else {
          aA = currentT;
        }
      } while (Math.abs(currentX) > SUBDIVISION_PRECISION && ++i < SUBDIVISION_MAX_ITERATIONS);

      return currentT;
    }

    function newtonRaphsonIterate(aX, aGuessT, mX1, mX2) {
      for (var i = 0; i < NEWTON_ITERATIONS; ++i) {
        var currentSlope = getSlope(aGuessT, mX1, mX2);
        if (currentSlope === 0.0) return aGuessT;
        var currentX = calcBezier(aGuessT, mX1, mX2) - aX;
        aGuessT -= currentX / currentSlope;
      }

      return aGuessT;
    }
    /**
       * points is an array of [ mX1, mY1, mX2, mY2 ]
       */


    function BezierEasing(points) {
      this._p = points;
      this._mSampleValues = float32ArraySupported ? new Float32Array(kSplineTableSize) : new Array(kSplineTableSize);
      this._precomputed = false;
      this.get = this.get.bind(this);
    }

    BezierEasing.prototype = {
      get: function get(x) {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        if (!this._precomputed) this._precompute();
        if (mX1 === mY1 && mX2 === mY2) return x; // linear
        // Because JavaScript number are imprecise, we should guarantee the extremes are right.

        if (x === 0) return 0;
        if (x === 1) return 1;
        return calcBezier(this._getTForX(x), mY1, mY2);
      },
      // Private part
      _precompute: function _precompute() {
        var mX1 = this._p[0],
            mY1 = this._p[1],
            mX2 = this._p[2],
            mY2 = this._p[3];
        this._precomputed = true;

        if (mX1 !== mY1 || mX2 !== mY2) {
          this._calcSampleValues();
        }
      },
      _calcSampleValues: function _calcSampleValues() {
        var mX1 = this._p[0],
            mX2 = this._p[2];

        for (var i = 0; i < kSplineTableSize; ++i) {
          this._mSampleValues[i] = calcBezier(i * kSampleStepSize, mX1, mX2);
        }
      },

      /**
           * getTForX chose the fastest heuristic to determine the percentage value precisely from a given X projection.
           */
      _getTForX: function _getTForX(aX) {
        var mX1 = this._p[0],
            mX2 = this._p[2],
            mSampleValues = this._mSampleValues;
        var intervalStart = 0.0;
        var currentSample = 1;
        var lastSample = kSplineTableSize - 1;

        for (; currentSample !== lastSample && mSampleValues[currentSample] <= aX; ++currentSample) {
          intervalStart += kSampleStepSize;
        }

        --currentSample; // Interpolate to provide an initial guess for t

        var dist = (aX - mSampleValues[currentSample]) / (mSampleValues[currentSample + 1] - mSampleValues[currentSample]);
        var guessForT = intervalStart + dist * kSampleStepSize;
        var initialSlope = getSlope(guessForT, mX1, mX2);

        if (initialSlope >= NEWTON_MIN_SLOPE) {
          return newtonRaphsonIterate(aX, guessForT, mX1, mX2);
        }

        if (initialSlope === 0.0) {
          return guessForT;
        }

        return binarySubdivide(aX, intervalStart, intervalStart + kSampleStepSize, mX1, mX2);
      }
    };
    return ob;
  }();

  var pooling = function () {
    function _double(arr) {
      return arr.concat(createSizedArray(arr.length));
    }

    return {
      "double": _double
    };
  }();

  var poolFactory = function () {
    return function (initialLength, _create, _release) {
      var _length = 0;
      var _maxLength = initialLength;
      var pool = createSizedArray(_maxLength);
      var ob = {
        newElement: newElement,
        release: release
      };

      function newElement() {
        var element;

        if (_length) {
          _length -= 1;
          element = pool[_length];
        } else {
          element = _create();
        }

        return element;
      }

      function release(element) {
        if (_length === _maxLength) {
          pool = pooling["double"](pool);
          _maxLength *= 2;
        }

        if (_release) {
          _release(element);
        }

        pool[_length] = element;
        _length += 1;
      }

      return ob;
    };
  }();

  var bezierLengthPool = function () {
    function create() {
      return {
        addedLength: 0,
        percents: createTypedArray('float32', getDefaultCurveSegments()),
        lengths: createTypedArray('float32', getDefaultCurveSegments())
      };
    }

    return poolFactory(8, create);
  }();

  var segmentsLengthPool = function () {
    function create() {
      return {
        lengths: [],
        totalLength: 0
      };
    }

    function release(element) {
      var i;
      var len = element.lengths.length;

      for (i = 0; i < len; i += 1) {
        bezierLengthPool.release(element.lengths[i]);
      }

      element.lengths.length = 0;
    }

    return poolFactory(8, create, release);
  }();

  function bezFunction() {
    var math = Math;

    function pointOnLine2D(x1, y1, x2, y2, x3, y3) {
      var det1 = x1 * y2 + y1 * x3 + x2 * y3 - x3 * y2 - y3 * x1 - x2 * y1;
      return det1 > -0.001 && det1 < 0.001;
    }

    function pointOnLine3D(x1, y1, z1, x2, y2, z2, x3, y3, z3) {
      if (z1 === 0 && z2 === 0 && z3 === 0) {
        return pointOnLine2D(x1, y1, x2, y2, x3, y3);
      }

      var dist1 = math.sqrt(math.pow(x2 - x1, 2) + math.pow(y2 - y1, 2) + math.pow(z2 - z1, 2));
      var dist2 = math.sqrt(math.pow(x3 - x1, 2) + math.pow(y3 - y1, 2) + math.pow(z3 - z1, 2));
      var dist3 = math.sqrt(math.pow(x3 - x2, 2) + math.pow(y3 - y2, 2) + math.pow(z3 - z2, 2));
      var diffDist;

      if (dist1 > dist2) {
        if (dist1 > dist3) {
          diffDist = dist1 - dist2 - dist3;
        } else {
          diffDist = dist3 - dist2 - dist1;
        }
      } else if (dist3 > dist2) {
        diffDist = dist3 - dist2 - dist1;
      } else {
        diffDist = dist2 - dist1 - dist3;
      }

      return diffDist > -0.0001 && diffDist < 0.0001;
    }

    var getBezierLength = function () {
      return function (pt1, pt2, pt3, pt4) {
        var curveSegments = getDefaultCurveSegments();
        var k;
        var i;
        var len;
        var ptCoord;
        var perc;
        var addedLength = 0;
        var ptDistance;
        var point = [];
        var lastPoint = [];
        var lengthData = bezierLengthPool.newElement();
        len = pt3.length;

        for (k = 0; k < curveSegments; k += 1) {
          perc = k / (curveSegments - 1);
          ptDistance = 0;

          for (i = 0; i < len; i += 1) {
            ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * pt3[i] + 3 * (1 - perc) * bmPow(perc, 2) * pt4[i] + bmPow(perc, 3) * pt2[i];
            point[i] = ptCoord;

            if (lastPoint[i] !== null) {
              ptDistance += bmPow(point[i] - lastPoint[i], 2);
            }

            lastPoint[i] = point[i];
          }

          if (ptDistance) {
            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
          }

          lengthData.percents[k] = perc;
          lengthData.lengths[k] = addedLength;
        }

        lengthData.addedLength = addedLength;
        return lengthData;
      };
    }();

    function getSegmentsLength(shapeData) {
      var segmentsLength = segmentsLengthPool.newElement();
      var closed = shapeData.c;
      var pathV = shapeData.v;
      var pathO = shapeData.o;
      var pathI = shapeData.i;
      var i;
      var len = shapeData._length;
      var lengths = segmentsLength.lengths;
      var totalLength = 0;

      for (i = 0; i < len - 1; i += 1) {
        lengths[i] = getBezierLength(pathV[i], pathV[i + 1], pathO[i], pathI[i + 1]);
        totalLength += lengths[i].addedLength;
      }

      if (closed && len) {
        lengths[i] = getBezierLength(pathV[i], pathV[0], pathO[i], pathI[0]);
        totalLength += lengths[i].addedLength;
      }

      segmentsLength.totalLength = totalLength;
      return segmentsLength;
    }

    function BezierData(length) {
      this.segmentLength = 0;
      this.points = new Array(length);
    }

    function PointData(partial, point) {
      this.partialLength = partial;
      this.point = point;
    }

    var buildBezierData = function () {
      var storedData = {};
      return function (pt1, pt2, pt3, pt4) {
        var bezierName = (pt1[0] + '_' + pt1[1] + '_' + pt2[0] + '_' + pt2[1] + '_' + pt3[0] + '_' + pt3[1] + '_' + pt4[0] + '_' + pt4[1]).replace(/\./g, 'p');

        if (!storedData[bezierName]) {
          var curveSegments = getDefaultCurveSegments();
          var k;
          var i;
          var len;
          var ptCoord;
          var perc;
          var addedLength = 0;
          var ptDistance;
          var point;
          var lastPoint = null;

          if (pt1.length === 2 && (pt1[0] !== pt2[0] || pt1[1] !== pt2[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt1[0] + pt3[0], pt1[1] + pt3[1]) && pointOnLine2D(pt1[0], pt1[1], pt2[0], pt2[1], pt2[0] + pt4[0], pt2[1] + pt4[1])) {
            curveSegments = 2;
          }

          var bezierData = new BezierData(curveSegments);
          len = pt3.length;

          for (k = 0; k < curveSegments; k += 1) {
            point = createSizedArray(len);
            perc = k / (curveSegments - 1);
            ptDistance = 0;

            for (i = 0; i < len; i += 1) {
              ptCoord = bmPow(1 - perc, 3) * pt1[i] + 3 * bmPow(1 - perc, 2) * perc * (pt1[i] + pt3[i]) + 3 * (1 - perc) * bmPow(perc, 2) * (pt2[i] + pt4[i]) + bmPow(perc, 3) * pt2[i];
              point[i] = ptCoord;

              if (lastPoint !== null) {
                ptDistance += bmPow(point[i] - lastPoint[i], 2);
              }
            }

            ptDistance = bmSqrt(ptDistance);
            addedLength += ptDistance;
            bezierData.points[k] = new PointData(ptDistance, point);
            lastPoint = point;
          }

          bezierData.segmentLength = addedLength;
          storedData[bezierName] = bezierData;
        }

        return storedData[bezierName];
      };
    }();

    function getDistancePerc(perc, bezierData) {
      var percents = bezierData.percents;
      var lengths = bezierData.lengths;
      var len = percents.length;
      var initPos = bmFloor((len - 1) * perc);
      var lengthPos = perc * bezierData.addedLength;
      var lPerc = 0;

      if (initPos === len - 1 || initPos === 0 || lengthPos === lengths[initPos]) {
        return percents[initPos];
      }

      var dir = lengths[initPos] > lengthPos ? -1 : 1;
      var flag = true;

      while (flag) {
        if (lengths[initPos] <= lengthPos && lengths[initPos + 1] > lengthPos) {
          lPerc = (lengthPos - lengths[initPos]) / (lengths[initPos + 1] - lengths[initPos]);
          flag = false;
        } else {
          initPos += dir;
        }

        if (initPos < 0 || initPos >= len - 1) {
          // FIX for TypedArrays that don't store floating point values with enough accuracy
          if (initPos === len - 1) {
            return percents[initPos];
          }

          flag = false;
        }
      }

      return percents[initPos] + (percents[initPos + 1] - percents[initPos]) * lPerc;
    }

    function getPointInSegment(pt1, pt2, pt3, pt4, percent, bezierData) {
      var t1 = getDistancePerc(percent, bezierData);
      var u1 = 1 - t1;
      var ptX = math.round((u1 * u1 * u1 * pt1[0] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[0] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[0] + t1 * t1 * t1 * pt2[0]) * 1000) / 1000;
      var ptY = math.round((u1 * u1 * u1 * pt1[1] + (t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1) * pt3[1] + (t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1) * pt4[1] + t1 * t1 * t1 * pt2[1]) * 1000) / 1000;
      return [ptX, ptY];
    }

    var bezierSegmentPoints = createTypedArray('float32', 8);

    function getNewSegment(pt1, pt2, pt3, pt4, startPerc, endPerc, bezierData) {
      if (startPerc < 0) {
        startPerc = 0;
      } else if (startPerc > 1) {
        startPerc = 1;
      }

      var t0 = getDistancePerc(startPerc, bezierData);
      endPerc = endPerc > 1 ? 1 : endPerc;
      var t1 = getDistancePerc(endPerc, bezierData);
      var i;
      var len = pt1.length;
      var u0 = 1 - t0;
      var u1 = 1 - t1;
      var u0u0u0 = u0 * u0 * u0;
      var t0u0u0_3 = t0 * u0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0u0_3 = t0 * t0 * u0 * 3; // eslint-disable-line camelcase

      var t0t0t0 = t0 * t0 * t0; //

      var u0u0u1 = u0 * u0 * u1;
      var t0u0u1_3 = t0 * u0 * u1 + u0 * t0 * u1 + u0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0u1_3 = t0 * t0 * u1 + u0 * t0 * t1 + t0 * u0 * t1; // eslint-disable-line camelcase

      var t0t0t1 = t0 * t0 * t1; //

      var u0u1u1 = u0 * u1 * u1;
      var t0u1u1_3 = t0 * u1 * u1 + u0 * t1 * u1 + u0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1u1_3 = t0 * t1 * u1 + u0 * t1 * t1 + t0 * u1 * t1; // eslint-disable-line camelcase

      var t0t1t1 = t0 * t1 * t1; //

      var u1u1u1 = u1 * u1 * u1;
      var t1u1u1_3 = t1 * u1 * u1 + u1 * t1 * u1 + u1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1u1_3 = t1 * t1 * u1 + u1 * t1 * t1 + t1 * u1 * t1; // eslint-disable-line camelcase

      var t1t1t1 = t1 * t1 * t1;

      for (i = 0; i < len; i += 1) {
        bezierSegmentPoints[i * 4] = math.round((u0u0u0 * pt1[i] + t0u0u0_3 * pt3[i] + t0t0u0_3 * pt4[i] + t0t0t0 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 1] = math.round((u0u0u1 * pt1[i] + t0u0u1_3 * pt3[i] + t0t0u1_3 * pt4[i] + t0t0t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 2] = math.round((u0u1u1 * pt1[i] + t0u1u1_3 * pt3[i] + t0t1u1_3 * pt4[i] + t0t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase

        bezierSegmentPoints[i * 4 + 3] = math.round((u1u1u1 * pt1[i] + t1u1u1_3 * pt3[i] + t1t1u1_3 * pt4[i] + t1t1t1 * pt2[i]) * 1000) / 1000; // eslint-disable-line camelcase
      }

      return bezierSegmentPoints;
    }

    return {
      getSegmentsLength: getSegmentsLength,
      getNewSegment: getNewSegment,
      getPointInSegment: getPointInSegment,
      buildBezierData: buildBezierData,
      pointOnLine2D: pointOnLine2D,
      pointOnLine3D: pointOnLine3D
    };
  }

  var bez = bezFunction();

  var initFrame = initialDefaultFrame;
  var mathAbs = Math.abs;

  function interpolateValue(frameNum, caching) {
    var offsetTime = this.offsetTime;
    var newValue;

    if (this.propType === 'multidimensional') {
      newValue = createTypedArray('float32', this.pv.length);
    }

    var iterationIndex = caching.lastIndex;
    var i = iterationIndex;
    var len = this.keyframes.length - 1;
    var flag = true;
    var keyData;
    var nextKeyData;
    var keyframeMetadata;

    while (flag) {
      keyData = this.keyframes[i];
      nextKeyData = this.keyframes[i + 1];

      if (i === len - 1 && frameNum >= nextKeyData.t - offsetTime) {
        if (keyData.h) {
          keyData = nextKeyData;
        }

        iterationIndex = 0;
        break;
      }

      if (nextKeyData.t - offsetTime > frameNum) {
        iterationIndex = i;
        break;
      }

      if (i < len - 1) {
        i += 1;
      } else {
        iterationIndex = 0;
        flag = false;
      }
    }

    keyframeMetadata = this.keyframesMetadata[i] || {};
    var k;
    var kLen;
    var perc;
    var jLen;
    var j;
    var fnc;
    var nextKeyTime = nextKeyData.t - offsetTime;
    var keyTime = keyData.t - offsetTime;
    var endValue;

    if (keyData.to) {
      if (!keyframeMetadata.bezierData) {
        keyframeMetadata.bezierData = bez.buildBezierData(keyData.s, nextKeyData.s || keyData.e, keyData.to, keyData.ti);
      }

      var bezierData = keyframeMetadata.bezierData;

      if (frameNum >= nextKeyTime || frameNum < keyTime) {
        var ind = frameNum >= nextKeyTime ? bezierData.points.length - 1 : 0;
        kLen = bezierData.points[ind].point.length;

        for (k = 0; k < kLen; k += 1) {
          newValue[k] = bezierData.points[ind].point[k];
        } // caching._lastKeyframeIndex = -1;

      } else {
        if (keyframeMetadata.__fnct) {
          fnc = keyframeMetadata.__fnct;
        } else {
          fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y, keyData.n).get;
          keyframeMetadata.__fnct = fnc;
        }

        perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
        var distanceInLine = bezierData.segmentLength * perc;
        var segmentPerc;
        var addedLength = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastAddedLength : 0;
        j = caching.lastFrame < frameNum && caching._lastKeyframeIndex === i ? caching._lastPoint : 0;
        flag = true;
        jLen = bezierData.points.length;

        while (flag) {
          addedLength += bezierData.points[j].partialLength;

          if (distanceInLine === 0 || perc === 0 || j === bezierData.points.length - 1) {
            kLen = bezierData.points[j].point.length;

            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k];
            }

            break;
          } else if (distanceInLine >= addedLength && distanceInLine < addedLength + bezierData.points[j + 1].partialLength) {
            segmentPerc = (distanceInLine - addedLength) / bezierData.points[j + 1].partialLength;
            kLen = bezierData.points[j].point.length;

            for (k = 0; k < kLen; k += 1) {
              newValue[k] = bezierData.points[j].point[k] + (bezierData.points[j + 1].point[k] - bezierData.points[j].point[k]) * segmentPerc;
            }

            break;
          }

          if (j < jLen - 1) {
            j += 1;
          } else {
            flag = false;
          }
        }

        caching._lastPoint = j;
        caching._lastAddedLength = addedLength - bezierData.points[j].partialLength;
        caching._lastKeyframeIndex = i;
      }
    } else {
      var outX;
      var outY;
      var inX;
      var inY;
      var keyValue;
      len = keyData.s.length;
      endValue = nextKeyData.s || keyData.e;

      if (this.sh && keyData.h !== 1) {
        if (frameNum >= nextKeyTime) {
          newValue[0] = endValue[0];
          newValue[1] = endValue[1];
          newValue[2] = endValue[2];
        } else if (frameNum <= keyTime) {
          newValue[0] = keyData.s[0];
          newValue[1] = keyData.s[1];
          newValue[2] = keyData.s[2];
        } else {
          var quatStart = createQuaternion(keyData.s);
          var quatEnd = createQuaternion(endValue);
          var time = (frameNum - keyTime) / (nextKeyTime - keyTime);
          quaternionToEuler(newValue, slerp(quatStart, quatEnd, time));
        }
      } else {
        for (i = 0; i < len; i += 1) {
          if (keyData.h !== 1) {
            if (frameNum >= nextKeyTime) {
              perc = 1;
            } else if (frameNum < keyTime) {
              perc = 0;
            } else {
              if (keyData.o.x.constructor === Array) {
                if (!keyframeMetadata.__fnct) {
                  keyframeMetadata.__fnct = [];
                }

                if (!keyframeMetadata.__fnct[i]) {
                  outX = keyData.o.x[i] === undefined ? keyData.o.x[0] : keyData.o.x[i];
                  outY = keyData.o.y[i] === undefined ? keyData.o.y[0] : keyData.o.y[i];
                  inX = keyData.i.x[i] === undefined ? keyData.i.x[0] : keyData.i.x[i];
                  inY = keyData.i.y[i] === undefined ? keyData.i.y[0] : keyData.i.y[i];
                  fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                  keyframeMetadata.__fnct[i] = fnc;
                } else {
                  fnc = keyframeMetadata.__fnct[i];
                }
              } else if (!keyframeMetadata.__fnct) {
                outX = keyData.o.x;
                outY = keyData.o.y;
                inX = keyData.i.x;
                inY = keyData.i.y;
                fnc = BezierFactory.getBezierEasing(outX, outY, inX, inY).get;
                keyData.keyframeMetadata = fnc;
              } else {
                fnc = keyframeMetadata.__fnct;
              }

              perc = fnc((frameNum - keyTime) / (nextKeyTime - keyTime));
            }
          }

          endValue = nextKeyData.s || keyData.e;
          keyValue = keyData.h === 1 ? keyData.s[i] : keyData.s[i] + (endValue[i] - keyData.s[i]) * perc;

          if (this.propType === 'multidimensional') {
            newValue[i] = keyValue;
          } else {
            newValue = keyValue;
          }
        }
      }
    }

    caching.lastIndex = iterationIndex;
    return newValue;
  } // based on @Toji's https://github.com/toji/gl-matrix/


  function slerp(a, b, t) {
    var out = [];
    var ax = a[0];
    var ay = a[1];
    var az = a[2];
    var aw = a[3];
    var bx = b[0];
    var by = b[1];
    var bz = b[2];
    var bw = b[3];
    var omega;
    var cosom;
    var sinom;
    var scale0;
    var scale1;
    cosom = ax * bx + ay * by + az * bz + aw * bw;

    if (cosom < 0.0) {
      cosom = -cosom;
      bx = -bx;
      by = -by;
      bz = -bz;
      bw = -bw;
    }

    if (1.0 - cosom > 0.000001) {
      omega = Math.acos(cosom);
      sinom = Math.sin(omega);
      scale0 = Math.sin((1.0 - t) * omega) / sinom;
      scale1 = Math.sin(t * omega) / sinom;
    } else {
      scale0 = 1.0 - t;
      scale1 = t;
    }

    out[0] = scale0 * ax + scale1 * bx;
    out[1] = scale0 * ay + scale1 * by;
    out[2] = scale0 * az + scale1 * bz;
    out[3] = scale0 * aw + scale1 * bw;
    return out;
  }

  function quaternionToEuler(out, quat) {
    var qx = quat[0];
    var qy = quat[1];
    var qz = quat[2];
    var qw = quat[3];
    var heading = Math.atan2(2 * qy * qw - 2 * qx * qz, 1 - 2 * qy * qy - 2 * qz * qz);
    var attitude = Math.asin(2 * qx * qy + 2 * qz * qw);
    var bank = Math.atan2(2 * qx * qw - 2 * qy * qz, 1 - 2 * qx * qx - 2 * qz * qz);
    out[0] = heading / degToRads;
    out[1] = attitude / degToRads;
    out[2] = bank / degToRads;
  }

  function createQuaternion(values) {
    var heading = values[0] * degToRads;
    var attitude = values[1] * degToRads;
    var bank = values[2] * degToRads;
    var c1 = Math.cos(heading / 2);
    var c2 = Math.cos(attitude / 2);
    var c3 = Math.cos(bank / 2);
    var s1 = Math.sin(heading / 2);
    var s2 = Math.sin(attitude / 2);
    var s3 = Math.sin(bank / 2);
    var w = c1 * c2 * c3 - s1 * s2 * s3;
    var x = s1 * s2 * c3 + c1 * c2 * s3;
    var y = s1 * c2 * c3 + c1 * s2 * s3;
    var z = c1 * s2 * c3 - s1 * c2 * s3;
    return [x, y, z, w];
  }

  function getValueAtCurrentTime() {
    var frameNum = this.comp.renderedFrame - this.offsetTime;
    var initTime = this.keyframes[0].t - this.offsetTime;
    var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;

    if (!(frameNum === this._caching.lastFrame || this._caching.lastFrame !== initFrame && (this._caching.lastFrame >= endTime && frameNum >= endTime || this._caching.lastFrame < initTime && frameNum < initTime))) {
      if (this._caching.lastFrame >= frameNum) {
        this._caching._lastKeyframeIndex = -1;
        this._caching.lastIndex = 0;
      }

      var renderResult = this.interpolateValue(frameNum, this._caching);
      this.pv = renderResult;
    }

    this._caching.lastFrame = frameNum;
    return this.pv;
  }

  function setVValue(val) {
    var multipliedValue;

    if (this.propType === 'unidimensional') {
      multipliedValue = val * this.mult;

      if (mathAbs(this.v - multipliedValue) > 0.00001) {
        this.v = multipliedValue;
        this._mdf = true;
      }
    } else {
      var i = 0;
      var len = this.v.length;

      while (i < len) {
        multipliedValue = val[i] * this.mult;

        if (mathAbs(this.v[i] - multipliedValue) > 0.00001) {
          this.v[i] = multipliedValue;
          this._mdf = true;
        }

        i += 1;
      }
    }
  }

  function processEffectsSequence() {
    if (this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) {
      return;
    }

    if (this.lock) {
      this.setVValue(this.pv);
      return;
    }

    this.lock = true;
    this._mdf = this._isFirstFrame;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = this.kf ? this.pv : this.data.k;

    for (i = 0; i < len; i += 1) {
      finalValue = this.effectsSequence[i](finalValue);
    }

    this.setVValue(finalValue);
    this._isFirstFrame = false;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  }

  function addEffect(effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.container.addDynamicProperty(this);
  }

  function ValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.mult = mult || 1;
    this.data = data;
    this.v = mult ? data.k * mult : data.k;
    this.pv = data.k;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.vel = 0;
    this.effectsSequence = [];
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function MultiDimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    this.mult = mult || 1;
    this.data = data;
    this._mdf = false;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.k = false;
    this.kf = false;
    this.frameId = -1;
    var i;
    var len = data.k.length;
    this.v = createTypedArray('float32', len);
    this.pv = createTypedArray('float32', len);
    this.vel = createTypedArray('float32', len);

    for (i = 0; i < len; i += 1) {
      this.v[i] = data.k[i] * this.mult;
      this.pv[i] = data.k[i];
    }

    this._isFirstFrame = true;
    this.effectsSequence = [];
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.addEffect = addEffect;
  }

  function KeyframedValueProperty(elem, data, mult, container) {
    this.propType = 'unidimensional';
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.frameId = -1;
    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: 0,
      _lastKeyframeIndex: -1
    };
    this.k = true;
    this.kf = true;
    this.data = data;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.v = initFrame;
    this.pv = initFrame;
    this._isFirstFrame = true;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.addEffect = addEffect;
  }

  function KeyframedMultidimensionalProperty(elem, data, mult, container) {
    this.propType = 'multidimensional';
    var i;
    var len = data.k.length;
    var s;
    var e;
    var to;
    var ti;

    for (i = 0; i < len - 1; i += 1) {
      if (data.k[i].to && data.k[i].s && data.k[i + 1] && data.k[i + 1].s) {
        s = data.k[i].s;
        e = data.k[i + 1].s;
        to = data.k[i].to;
        ti = data.k[i].ti;

        if (s.length === 2 && !(s[0] === e[0] && s[1] === e[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], s[0] + to[0], s[1] + to[1]) && bez.pointOnLine2D(s[0], s[1], e[0], e[1], e[0] + ti[0], e[1] + ti[1]) || s.length === 3 && !(s[0] === e[0] && s[1] === e[1] && s[2] === e[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], s[0] + to[0], s[1] + to[1], s[2] + to[2]) && bez.pointOnLine3D(s[0], s[1], s[2], e[0], e[1], e[2], e[0] + ti[0], e[1] + ti[1], e[2] + ti[2])) {
          data.k[i].to = null;
          data.k[i].ti = null;
        }

        if (s[0] === e[0] && s[1] === e[1] && to[0] === 0 && to[1] === 0 && ti[0] === 0 && ti[1] === 0) {
          if (s.length === 2 || s[2] === e[2] && to[2] === 0 && ti[2] === 0) {
            data.k[i].to = null;
            data.k[i].ti = null;
          }
        }
      }
    }

    this.effectsSequence = [getValueAtCurrentTime.bind(this)];
    this.data = data;
    this.keyframes = data.k;
    this.keyframesMetadata = [];
    this.offsetTime = elem.data.st;
    this.k = true;
    this.kf = true;
    this._isFirstFrame = true;
    this.mult = mult || 1;
    this.elem = elem;
    this.container = container;
    this.comp = elem.comp;
    this.getValue = processEffectsSequence;
    this.setVValue = setVValue;
    this.interpolateValue = interpolateValue;
    this.frameId = -1;
    var arrLen = data.k[0].s.length;
    this.v = createTypedArray('float32', arrLen);
    this.pv = createTypedArray('float32', arrLen);

    for (i = 0; i < arrLen; i += 1) {
      this.v[i] = initFrame;
      this.pv[i] = initFrame;
    }

    this._caching = {
      lastFrame: initFrame,
      lastIndex: 0,
      value: createTypedArray('float32', arrLen)
    };
    this.addEffect = addEffect;
  }

  var PropertyFactory = function () {
    function getProp(elem, data, type, mult, container) {
      if (data.sid) {
        data = elem.globalData.slotManager.getProp(data);
      }

      var p;

      if (!data.k.length) {
        p = new ValueProperty(elem, data, mult, container);
      } else if (typeof data.k[0] === 'number') {
        p = new MultiDimensionalProperty(elem, data, mult, container);
      } else {
        switch (type) {
          case 0:
            p = new KeyframedValueProperty(elem, data, mult, container);
            break;

          case 1:
            p = new KeyframedMultidimensionalProperty(elem, data, mult, container);
            break;

          default:
            break;
        }
      }

      if (p.effectsSequence.length) {
        container.addDynamicProperty(p);
      }

      return p;
    }

    var ob = {
      getProp: getProp
    };
    return ob;
  }();

  function DynamicPropertyContainer() {}

  DynamicPropertyContainer.prototype = {
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
        this.container.addDynamicProperty(this);
        this._isAnimated = true;
      }
    },
    iterateDynamicProperties: function iterateDynamicProperties() {
      this._mdf = false;
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        this.dynamicProperties[i].getValue();

        if (this.dynamicProperties[i]._mdf) {
          this._mdf = true;
        }
      }
    },
    initDynamicPropertyContainer: function initDynamicPropertyContainer(container) {
      this.container = container;
      this.dynamicProperties = [];
      this._mdf = false;
      this._isAnimated = false;
    }
  };

  var pointPool = function () {
    function create() {
      return createTypedArray('float32', 2);
    }

    return poolFactory(8, create);
  }();

  function ShapePath() {
    this.c = false;
    this._length = 0;
    this._maxLength = 8;
    this.v = createSizedArray(this._maxLength);
    this.o = createSizedArray(this._maxLength);
    this.i = createSizedArray(this._maxLength);
  }

  ShapePath.prototype.setPathData = function (closed, len) {
    this.c = closed;
    this.setLength(len);
    var i = 0;

    while (i < len) {
      this.v[i] = pointPool.newElement();
      this.o[i] = pointPool.newElement();
      this.i[i] = pointPool.newElement();
      i += 1;
    }
  };

  ShapePath.prototype.setLength = function (len) {
    while (this._maxLength < len) {
      this.doubleArrayLength();
    }

    this._length = len;
  };

  ShapePath.prototype.doubleArrayLength = function () {
    this.v = this.v.concat(createSizedArray(this._maxLength));
    this.i = this.i.concat(createSizedArray(this._maxLength));
    this.o = this.o.concat(createSizedArray(this._maxLength));
    this._maxLength *= 2;
  };

  ShapePath.prototype.setXYAt = function (x, y, type, pos, replace) {
    var arr;
    this._length = Math.max(this._length, pos + 1);

    if (this._length >= this._maxLength) {
      this.doubleArrayLength();
    }

    switch (type) {
      case 'v':
        arr = this.v;
        break;

      case 'i':
        arr = this.i;
        break;

      case 'o':
        arr = this.o;
        break;

      default:
        arr = [];
        break;
    }

    if (!arr[pos] || arr[pos] && !replace) {
      arr[pos] = pointPool.newElement();
    }

    arr[pos][0] = x;
    arr[pos][1] = y;
  };

  ShapePath.prototype.setTripleAt = function (vX, vY, oX, oY, iX, iY, pos, replace) {
    this.setXYAt(vX, vY, 'v', pos, replace);
    this.setXYAt(oX, oY, 'o', pos, replace);
    this.setXYAt(iX, iY, 'i', pos, replace);
  };

  ShapePath.prototype.reverse = function () {
    var newPath = new ShapePath();
    newPath.setPathData(this.c, this._length);
    var vertices = this.v;
    var outPoints = this.o;
    var inPoints = this.i;
    var init = 0;

    if (this.c) {
      newPath.setTripleAt(vertices[0][0], vertices[0][1], inPoints[0][0], inPoints[0][1], outPoints[0][0], outPoints[0][1], 0, false);
      init = 1;
    }

    var cnt = this._length - 1;
    var len = this._length;
    var i;

    for (i = init; i < len; i += 1) {
      newPath.setTripleAt(vertices[cnt][0], vertices[cnt][1], inPoints[cnt][0], inPoints[cnt][1], outPoints[cnt][0], outPoints[cnt][1], i, false);
      cnt -= 1;
    }

    return newPath;
  };

  ShapePath.prototype.length = function () {
    return this._length;
  };

  var shapePool = function () {
    function create() {
      return new ShapePath();
    }

    function release(shapePath) {
      var len = shapePath._length;
      var i;

      for (i = 0; i < len; i += 1) {
        pointPool.release(shapePath.v[i]);
        pointPool.release(shapePath.i[i]);
        pointPool.release(shapePath.o[i]);
        shapePath.v[i] = null;
        shapePath.i[i] = null;
        shapePath.o[i] = null;
      }

      shapePath._length = 0;
      shapePath.c = false;
    }

    function clone(shape) {
      var cloned = factory.newElement();
      var i;
      var len = shape._length === undefined ? shape.v.length : shape._length;
      cloned.setLength(len);
      cloned.c = shape.c;

      for (i = 0; i < len; i += 1) {
        cloned.setTripleAt(shape.v[i][0], shape.v[i][1], shape.o[i][0], shape.o[i][1], shape.i[i][0], shape.i[i][1], i);
      }

      return cloned;
    }

    var factory = poolFactory(4, create, release);
    factory.clone = clone;
    return factory;
  }();

  function ShapeCollection() {
    this._length = 0;
    this._maxLength = 4;
    this.shapes = createSizedArray(this._maxLength);
  }

  ShapeCollection.prototype.addShape = function (shapeData) {
    if (this._length === this._maxLength) {
      this.shapes = this.shapes.concat(createSizedArray(this._maxLength));
      this._maxLength *= 2;
    }

    this.shapes[this._length] = shapeData;
    this._length += 1;
  };

  ShapeCollection.prototype.releaseShapes = function () {
    var i;

    for (i = 0; i < this._length; i += 1) {
      shapePool.release(this.shapes[i]);
    }

    this._length = 0;
  };

  var shapeCollectionPool = function () {
    var ob = {
      newShapeCollection: newShapeCollection,
      release: release
    };
    var _length = 0;
    var _maxLength = 4;
    var pool = createSizedArray(_maxLength);

    function newShapeCollection() {
      var shapeCollection;

      if (_length) {
        _length -= 1;
        shapeCollection = pool[_length];
      } else {
        shapeCollection = new ShapeCollection();
      }

      return shapeCollection;
    }

    function release(shapeCollection) {
      var i;
      var len = shapeCollection._length;

      for (i = 0; i < len; i += 1) {
        shapePool.release(shapeCollection.shapes[i]);
      }

      shapeCollection._length = 0;

      if (_length === _maxLength) {
        pool = pooling["double"](pool);
        _maxLength *= 2;
      }

      pool[_length] = shapeCollection;
      _length += 1;
    }

    return ob;
  }();

  var ShapePropertyFactory = function () {
    var initFrame = -999999;

    function interpolateShape(frameNum, previousValue, caching) {
      var iterationIndex = caching.lastIndex;
      var keyPropS;
      var keyPropE;
      var isHold;
      var j;
      var k;
      var jLen;
      var kLen;
      var perc;
      var vertexValue;
      var kf = this.keyframes;

      if (frameNum < kf[0].t - this.offsetTime) {
        keyPropS = kf[0].s[0];
        isHold = true;
        iterationIndex = 0;
      } else if (frameNum >= kf[kf.length - 1].t - this.offsetTime) {
        keyPropS = kf[kf.length - 1].s ? kf[kf.length - 1].s[0] : kf[kf.length - 2].e[0];
        /* if(kf[kf.length - 1].s){
                  keyPropS = kf[kf.length - 1].s[0];
              }else{
                  keyPropS = kf[kf.length - 2].e[0];
              } */

        isHold = true;
      } else {
        var i = iterationIndex;
        var len = kf.length - 1;
        var flag = true;
        var keyData;
        var nextKeyData;
        var keyframeMetadata;

        while (flag) {
          keyData = kf[i];
          nextKeyData = kf[i + 1];

          if (nextKeyData.t - this.offsetTime > frameNum) {
            break;
          }

          if (i < len - 1) {
            i += 1;
          } else {
            flag = false;
          }
        }

        keyframeMetadata = this.keyframesMetadata[i] || {};
        isHold = keyData.h === 1;
        iterationIndex = i;

        if (!isHold) {
          if (frameNum >= nextKeyData.t - this.offsetTime) {
            perc = 1;
          } else if (frameNum < keyData.t - this.offsetTime) {
            perc = 0;
          } else {
            var fnc;

            if (keyframeMetadata.__fnct) {
              fnc = keyframeMetadata.__fnct;
            } else {
              fnc = BezierFactory.getBezierEasing(keyData.o.x, keyData.o.y, keyData.i.x, keyData.i.y).get;
              keyframeMetadata.__fnct = fnc;
            }

            perc = fnc((frameNum - (keyData.t - this.offsetTime)) / (nextKeyData.t - this.offsetTime - (keyData.t - this.offsetTime)));
          }

          keyPropE = nextKeyData.s ? nextKeyData.s[0] : keyData.e[0];
        }

        keyPropS = keyData.s[0];
      }

      jLen = previousValue._length;
      kLen = keyPropS.i[0].length;
      caching.lastIndex = iterationIndex;

      for (j = 0; j < jLen; j += 1) {
        for (k = 0; k < kLen; k += 1) {
          vertexValue = isHold ? keyPropS.i[j][k] : keyPropS.i[j][k] + (keyPropE.i[j][k] - keyPropS.i[j][k]) * perc;
          previousValue.i[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.o[j][k] : keyPropS.o[j][k] + (keyPropE.o[j][k] - keyPropS.o[j][k]) * perc;
          previousValue.o[j][k] = vertexValue;
          vertexValue = isHold ? keyPropS.v[j][k] : keyPropS.v[j][k] + (keyPropE.v[j][k] - keyPropS.v[j][k]) * perc;
          previousValue.v[j][k] = vertexValue;
        }
      }
    }

    function interpolateShapeCurrentTime() {
      var frameNum = this.comp.renderedFrame - this.offsetTime;
      var initTime = this.keyframes[0].t - this.offsetTime;
      var endTime = this.keyframes[this.keyframes.length - 1].t - this.offsetTime;
      var lastFrame = this._caching.lastFrame;

      if (!(lastFrame !== initFrame && (lastFrame < initTime && frameNum < initTime || lastFrame > endTime && frameNum > endTime))) {
        /// /
        this._caching.lastIndex = lastFrame < frameNum ? this._caching.lastIndex : 0;
        this.interpolateShape(frameNum, this.pv, this._caching); /// /
      }

      this._caching.lastFrame = frameNum;
      return this.pv;
    }

    function resetShape() {
      this.paths = this.localShapeCollection;
    }

    function shapesEqual(shape1, shape2) {
      if (shape1._length !== shape2._length || shape1.c !== shape2.c) {
        return false;
      }

      var i;
      var len = shape1._length;

      for (i = 0; i < len; i += 1) {
        if (shape1.v[i][0] !== shape2.v[i][0] || shape1.v[i][1] !== shape2.v[i][1] || shape1.o[i][0] !== shape2.o[i][0] || shape1.o[i][1] !== shape2.o[i][1] || shape1.i[i][0] !== shape2.i[i][0] || shape1.i[i][1] !== shape2.i[i][1]) {
          return false;
        }
      }

      return true;
    }

    function setVValue(newPath) {
      if (!shapesEqual(this.v, newPath)) {
        this.v = shapePool.clone(newPath);
        this.localShapeCollection.releaseShapes();
        this.localShapeCollection.addShape(this.v);
        this._mdf = true;
        this.paths = this.localShapeCollection;
      }
    }

    function processEffectsSequence() {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (!this.effectsSequence.length) {
        this._mdf = false;
        return;
      }

      if (this.lock) {
        this.setVValue(this.pv);
        return;
      }

      this.lock = true;
      this._mdf = false;
      var finalValue;

      if (this.kf) {
        finalValue = this.pv;
      } else if (this.data.ks) {
        finalValue = this.data.ks.k;
      } else {
        finalValue = this.data.pt.k;
      }

      var i;
      var len = this.effectsSequence.length;

      for (i = 0; i < len; i += 1) {
        finalValue = this.effectsSequence[i](finalValue);
      }

      this.setVValue(finalValue);
      this.lock = false;
      this.frameId = this.elem.globalData.frameId;
    }

    function ShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.container = elem;
      this.elem = elem;
      this.data = data;
      this.k = false;
      this.kf = false;
      this._mdf = false;
      var pathData = type === 3 ? data.pt.k : data.ks.k;
      this.v = shapePool.clone(pathData);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.reset = resetShape;
      this.effectsSequence = [];
    }

    function addEffect(effectFunction) {
      this.effectsSequence.push(effectFunction);
      this.container.addDynamicProperty(this);
    }

    ShapeProperty.prototype.interpolateShape = interpolateShape;
    ShapeProperty.prototype.getValue = processEffectsSequence;
    ShapeProperty.prototype.setVValue = setVValue;
    ShapeProperty.prototype.addEffect = addEffect;

    function KeyframedShapeProperty(elem, data, type) {
      this.propType = 'shape';
      this.comp = elem.comp;
      this.elem = elem;
      this.container = elem;
      this.offsetTime = elem.data.st;
      this.keyframes = type === 3 ? data.pt.k : data.ks.k;
      this.keyframesMetadata = [];
      this.k = true;
      this.kf = true;
      var len = this.keyframes[0].s[0].i.length;
      this.v = shapePool.newElement();
      this.v.setPathData(this.keyframes[0].s[0].c, len);
      this.pv = shapePool.clone(this.v);
      this.localShapeCollection = shapeCollectionPool.newShapeCollection();
      this.paths = this.localShapeCollection;
      this.paths.addShape(this.v);
      this.lastFrame = initFrame;
      this.reset = resetShape;
      this._caching = {
        lastFrame: initFrame,
        lastIndex: 0
      };
      this.effectsSequence = [interpolateShapeCurrentTime.bind(this)];
    }

    KeyframedShapeProperty.prototype.getValue = processEffectsSequence;
    KeyframedShapeProperty.prototype.interpolateShape = interpolateShape;
    KeyframedShapeProperty.prototype.setVValue = setVValue;
    KeyframedShapeProperty.prototype.addEffect = addEffect;

    var EllShapeProperty = function () {
      var cPoint = roundCorner;

      function EllShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 4);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.paths = this.localShapeCollection;
        this.localShapeCollection.addShape(this.v);
        this.d = data.d;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertEllToPath();
        }
      }

      EllShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertEllToPath();
          }
        },
        convertEllToPath: function convertEllToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var s0 = this.s.v[0] / 2;
          var s1 = this.s.v[1] / 2;

          var _cw = this.d !== 3;

          var _v = this.v;
          _v.v[0][0] = p0;
          _v.v[0][1] = p1 - s1;
          _v.v[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.v[1][1] = p1;
          _v.v[2][0] = p0;
          _v.v[2][1] = p1 + s1;
          _v.v[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.v[3][1] = p1;
          _v.i[0][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.i[0][1] = p1 - s1;
          _v.i[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.i[1][1] = p1 - s1 * cPoint;
          _v.i[2][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.i[2][1] = p1 + s1;
          _v.i[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.i[3][1] = p1 + s1 * cPoint;
          _v.o[0][0] = _cw ? p0 + s0 * cPoint : p0 - s0 * cPoint;
          _v.o[0][1] = p1 - s1;
          _v.o[1][0] = _cw ? p0 + s0 : p0 - s0;
          _v.o[1][1] = p1 + s1 * cPoint;
          _v.o[2][0] = _cw ? p0 - s0 * cPoint : p0 + s0 * cPoint;
          _v.o[2][1] = p1 + s1;
          _v.o[3][0] = _cw ? p0 - s0 : p0 + s0;
          _v.o[3][1] = p1 - s1 * cPoint;
        }
      };
      extendPrototype([DynamicPropertyContainer], EllShapePropertyFactory);
      return EllShapePropertyFactory;
    }();

    var StarShapeProperty = function () {
      function StarShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.setPathData(true, 0);
        this.elem = elem;
        this.comp = elem.comp;
        this.data = data;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);

        if (data.sy === 1) {
          this.ir = PropertyFactory.getProp(elem, data.ir, 0, 0, this);
          this.is = PropertyFactory.getProp(elem, data.is, 0, 0.01, this);
          this.convertToPath = this.convertStarToPath;
        } else {
          this.convertToPath = this.convertPolygonToPath;
        }

        this.pt = PropertyFactory.getProp(elem, data.pt, 0, 0, this);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, degToRads, this);
        this.or = PropertyFactory.getProp(elem, data.or, 0, 0, this);
        this.os = PropertyFactory.getProp(elem, data.os, 0, 0.01, this);
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertToPath();
        }
      }

      StarShapePropertyFactory.prototype = {
        reset: resetShape,
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertToPath();
          }
        },
        convertStarToPath: function convertStarToPath() {
          var numPts = Math.floor(this.pt.v) * 2;
          var angle = Math.PI * 2 / numPts;
          /* this.v.v.length = numPts;
                  this.v.i.length = numPts;
                  this.v.o.length = numPts; */

          var longFlag = true;
          var longRad = this.or.v;
          var shortRad = this.ir.v;
          var longRound = this.os.v;
          var shortRound = this.is.v;
          var longPerimSegment = 2 * Math.PI * longRad / (numPts * 2);
          var shortPerimSegment = 2 * Math.PI * shortRad / (numPts * 2);
          var i;
          var rad;
          var roundness;
          var perimSegment;
          var currentAng = -Math.PI / 2;
          currentAng += this.r.v;
          var dir = this.data.d === 3 ? -1 : 1;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            rad = longFlag ? longRad : shortRad;
            roundness = longFlag ? longRound : shortRound;
            perimSegment = longFlag ? longPerimSegment : shortPerimSegment;
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            /* this.v.v[i] = [x,y];
                      this.v.i[i] = [x+ox*perimSegment*roundness*dir,y+oy*perimSegment*roundness*dir];
                      this.v.o[i] = [x-ox*perimSegment*roundness*dir,y-oy*perimSegment*roundness*dir];
                      this.v._length = numPts; */

            longFlag = !longFlag;
            currentAng += angle * dir;
          }
        },
        convertPolygonToPath: function convertPolygonToPath() {
          var numPts = Math.floor(this.pt.v);
          var angle = Math.PI * 2 / numPts;
          var rad = this.or.v;
          var roundness = this.os.v;
          var perimSegment = 2 * Math.PI * rad / (numPts * 4);
          var i;
          var currentAng = -Math.PI * 0.5;
          var dir = this.data.d === 3 ? -1 : 1;
          currentAng += this.r.v;
          this.v._length = 0;

          for (i = 0; i < numPts; i += 1) {
            var x = rad * Math.cos(currentAng);
            var y = rad * Math.sin(currentAng);
            var ox = x === 0 && y === 0 ? 0 : y / Math.sqrt(x * x + y * y);
            var oy = x === 0 && y === 0 ? 0 : -x / Math.sqrt(x * x + y * y);
            x += +this.p.v[0];
            y += +this.p.v[1];
            this.v.setTripleAt(x, y, x - ox * perimSegment * roundness * dir, y - oy * perimSegment * roundness * dir, x + ox * perimSegment * roundness * dir, y + oy * perimSegment * roundness * dir, i, true);
            currentAng += angle * dir;
          }

          this.paths.length = 0;
          this.paths[0] = this.v;
        }
      };
      extendPrototype([DynamicPropertyContainer], StarShapePropertyFactory);
      return StarShapePropertyFactory;
    }();

    var RectShapeProperty = function () {
      function RectShapePropertyFactory(elem, data) {
        this.v = shapePool.newElement();
        this.v.c = true;
        this.localShapeCollection = shapeCollectionPool.newShapeCollection();
        this.localShapeCollection.addShape(this.v);
        this.paths = this.localShapeCollection;
        this.elem = elem;
        this.comp = elem.comp;
        this.frameId = -1;
        this.d = data.d;
        this.initDynamicPropertyContainer(elem);
        this.p = PropertyFactory.getProp(elem, data.p, 1, 0, this);
        this.s = PropertyFactory.getProp(elem, data.s, 1, 0, this);
        this.r = PropertyFactory.getProp(elem, data.r, 0, 0, this);

        if (this.dynamicProperties.length) {
          this.k = true;
        } else {
          this.k = false;
          this.convertRectToPath();
        }
      }

      RectShapePropertyFactory.prototype = {
        convertRectToPath: function convertRectToPath() {
          var p0 = this.p.v[0];
          var p1 = this.p.v[1];
          var v0 = this.s.v[0] / 2;
          var v1 = this.s.v[1] / 2;
          var round = bmMin(v0, v1, this.r.v);
          var cPoint = round * (1 - roundCorner);
          this.v._length = 0;

          if (this.d === 2 || this.d === 1) {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, 0, true);
            this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, p0 + v0, p1 + v1 - round, 1, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, 2, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0 + round, p1 + v1, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, 4, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1 + round, 5, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, 6, true);
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, p0 + v0 - round, p1 - v1, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0 + cPoint, p1 + v1, p0 - v0, p1 + v1, 2);
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0, p1 - v1 + cPoint, p0 - v0, p1 - v1, 3);
            }
          } else {
            this.v.setTripleAt(p0 + v0, p1 - v1 + round, p0 + v0, p1 - v1 + cPoint, p0 + v0, p1 - v1 + round, 0, true);

            if (round !== 0) {
              this.v.setTripleAt(p0 + v0 - round, p1 - v1, p0 + v0 - round, p1 - v1, p0 + v0 - cPoint, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0 + round, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0 + round, p1 - v1, 2, true);
              this.v.setTripleAt(p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + round, p0 - v0, p1 - v1 + cPoint, 3, true);
              this.v.setTripleAt(p0 - v0, p1 + v1 - round, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1 - round, 4, true);
              this.v.setTripleAt(p0 - v0 + round, p1 + v1, p0 - v0 + round, p1 + v1, p0 - v0 + cPoint, p1 + v1, 5, true);
              this.v.setTripleAt(p0 + v0 - round, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0 - round, p1 + v1, 6, true);
              this.v.setTripleAt(p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - round, p0 + v0, p1 + v1 - cPoint, 7, true);
            } else {
              this.v.setTripleAt(p0 - v0, p1 - v1, p0 - v0 + cPoint, p1 - v1, p0 - v0, p1 - v1, 1, true);
              this.v.setTripleAt(p0 - v0, p1 + v1, p0 - v0, p1 + v1 - cPoint, p0 - v0, p1 + v1, 2, true);
              this.v.setTripleAt(p0 + v0, p1 + v1, p0 + v0 - cPoint, p1 + v1, p0 + v0, p1 + v1, 3, true);
            }
          }
        },
        getValue: function getValue() {
          if (this.elem.globalData.frameId === this.frameId) {
            return;
          }

          this.frameId = this.elem.globalData.frameId;
          this.iterateDynamicProperties();

          if (this._mdf) {
            this.convertRectToPath();
          }
        },
        reset: resetShape
      };
      extendPrototype([DynamicPropertyContainer], RectShapePropertyFactory);
      return RectShapePropertyFactory;
    }();

    function getShapeProp(elem, data, type) {
      var prop;

      if (type === 3 || type === 4) {
        var dataProp = type === 3 ? data.pt : data.ks;
        var keys = dataProp.k;

        if (keys.length) {
          prop = new KeyframedShapeProperty(elem, data, type);
        } else {
          prop = new ShapeProperty(elem, data, type);
        }
      } else if (type === 5) {
        prop = new RectShapeProperty(elem, data);
      } else if (type === 6) {
        prop = new EllShapeProperty(elem, data);
      } else if (type === 7) {
        prop = new StarShapeProperty(elem, data);
      }

      if (prop.k) {
        elem.addDynamicProperty(prop);
      }

      return prop;
    }

    function getConstructorFunction() {
      return ShapeProperty;
    }

    function getKeyframedConstructorFunction() {
      return KeyframedShapeProperty;
    }

    var ob = {};
    ob.getShapeProp = getShapeProp;
    ob.getConstructorFunction = getConstructorFunction;
    ob.getKeyframedConstructorFunction = getKeyframedConstructorFunction;
    return ob;
  }();

  /*!
   Transformation Matrix v2.0
   (c) Epistemex 2014-2015
   www.epistemex.com
   By Ken Fyrstenberg
   Contributions by leeoniya.
   License: MIT, header required.
   */

  /**
   * 2D transformation matrix object initialized with identity matrix.
   *
   * The matrix can synchronize a canvas context by supplying the context
   * as an argument, or later apply current absolute transform to an
   * existing context.
   *
   * All values are handled as floating point values.
   *
   * @param {CanvasRenderingContext2D} [context] - Optional context to sync with Matrix
   * @prop {number} a - scale x
   * @prop {number} b - shear y
   * @prop {number} c - shear x
   * @prop {number} d - scale y
   * @prop {number} e - translate x
   * @prop {number} f - translate y
   * @prop {CanvasRenderingContext2D|null} [context=null] - set or get current canvas context
   * @constructor
   */

  var Matrix = function () {
    var _cos = Math.cos;
    var _sin = Math.sin;
    var _tan = Math.tan;
    var _rnd = Math.round;

    function reset() {
      this.props[0] = 1;
      this.props[1] = 0;
      this.props[2] = 0;
      this.props[3] = 0;
      this.props[4] = 0;
      this.props[5] = 1;
      this.props[6] = 0;
      this.props[7] = 0;
      this.props[8] = 0;
      this.props[9] = 0;
      this.props[10] = 1;
      this.props[11] = 0;
      this.props[12] = 0;
      this.props[13] = 0;
      this.props[14] = 0;
      this.props[15] = 1;
      return this;
    }

    function rotate(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function rotateX(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(1, 0, 0, 0, 0, mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1);
    }

    function rotateY(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, 0, mSin, 0, 0, 1, 0, 0, -mSin, 0, mCos, 0, 0, 0, 0, 1);
    }

    function rotateZ(angle) {
      if (angle === 0) {
        return this;
      }

      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
    }

    function shear(sx, sy) {
      return this._t(1, sy, sx, 1, 0, 0);
    }

    function skew(ax, ay) {
      return this.shear(_tan(ax), _tan(ay));
    }

    function skewFromAxis(ax, angle) {
      var mCos = _cos(angle);

      var mSin = _sin(angle);

      return this._t(mCos, mSin, 0, 0, -mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(1, 0, 0, 0, _tan(ax), 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1)._t(mCos, -mSin, 0, 0, mSin, mCos, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1); // return this._t(mCos, mSin, -mSin, mCos, 0, 0)._t(1, 0, _tan(ax), 1, 0, 0)._t(mCos, -mSin, mSin, mCos, 0, 0);
    }

    function scale(sx, sy, sz) {
      if (!sz && sz !== 0) {
        sz = 1;
      }

      if (sx === 1 && sy === 1 && sz === 1) {
        return this;
      }

      return this._t(sx, 0, 0, 0, 0, sy, 0, 0, 0, 0, sz, 0, 0, 0, 0, 1);
    }

    function setTransform(a, b, c, d, e, f, g, h, i, j, k, l, m, n, o, p) {
      this.props[0] = a;
      this.props[1] = b;
      this.props[2] = c;
      this.props[3] = d;
      this.props[4] = e;
      this.props[5] = f;
      this.props[6] = g;
      this.props[7] = h;
      this.props[8] = i;
      this.props[9] = j;
      this.props[10] = k;
      this.props[11] = l;
      this.props[12] = m;
      this.props[13] = n;
      this.props[14] = o;
      this.props[15] = p;
      return this;
    }

    function translate(tx, ty, tz) {
      tz = tz || 0;

      if (tx !== 0 || ty !== 0 || tz !== 0) {
        return this._t(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, tx, ty, tz, 1);
      }

      return this;
    }

    function transform(a2, b2, c2, d2, e2, f2, g2, h2, i2, j2, k2, l2, m2, n2, o2, p2) {
      var _p = this.props;

      if (a2 === 1 && b2 === 0 && c2 === 0 && d2 === 0 && e2 === 0 && f2 === 1 && g2 === 0 && h2 === 0 && i2 === 0 && j2 === 0 && k2 === 1 && l2 === 0) {
        // NOTE: commenting this condition because TurboFan deoptimizes code when present
        // if(m2 !== 0 || n2 !== 0 || o2 !== 0){
        _p[12] = _p[12] * a2 + _p[15] * m2;
        _p[13] = _p[13] * f2 + _p[15] * n2;
        _p[14] = _p[14] * k2 + _p[15] * o2;
        _p[15] *= p2; // }

        this._identityCalculated = false;
        return this;
      }

      var a1 = _p[0];
      var b1 = _p[1];
      var c1 = _p[2];
      var d1 = _p[3];
      var e1 = _p[4];
      var f1 = _p[5];
      var g1 = _p[6];
      var h1 = _p[7];
      var i1 = _p[8];
      var j1 = _p[9];
      var k1 = _p[10];
      var l1 = _p[11];
      var m1 = _p[12];
      var n1 = _p[13];
      var o1 = _p[14];
      var p1 = _p[15];
      /* matrix order (canvas compatible):
           * ace
           * bdf
           * 001
           */

      _p[0] = a1 * a2 + b1 * e2 + c1 * i2 + d1 * m2;
      _p[1] = a1 * b2 + b1 * f2 + c1 * j2 + d1 * n2;
      _p[2] = a1 * c2 + b1 * g2 + c1 * k2 + d1 * o2;
      _p[3] = a1 * d2 + b1 * h2 + c1 * l2 + d1 * p2;
      _p[4] = e1 * a2 + f1 * e2 + g1 * i2 + h1 * m2;
      _p[5] = e1 * b2 + f1 * f2 + g1 * j2 + h1 * n2;
      _p[6] = e1 * c2 + f1 * g2 + g1 * k2 + h1 * o2;
      _p[7] = e1 * d2 + f1 * h2 + g1 * l2 + h1 * p2;
      _p[8] = i1 * a2 + j1 * e2 + k1 * i2 + l1 * m2;
      _p[9] = i1 * b2 + j1 * f2 + k1 * j2 + l1 * n2;
      _p[10] = i1 * c2 + j1 * g2 + k1 * k2 + l1 * o2;
      _p[11] = i1 * d2 + j1 * h2 + k1 * l2 + l1 * p2;
      _p[12] = m1 * a2 + n1 * e2 + o1 * i2 + p1 * m2;
      _p[13] = m1 * b2 + n1 * f2 + o1 * j2 + p1 * n2;
      _p[14] = m1 * c2 + n1 * g2 + o1 * k2 + p1 * o2;
      _p[15] = m1 * d2 + n1 * h2 + o1 * l2 + p1 * p2;
      this._identityCalculated = false;
      return this;
    }

    function multiply(matrix) {
      var matrixProps = matrix.props;
      return this.transform(matrixProps[0], matrixProps[1], matrixProps[2], matrixProps[3], matrixProps[4], matrixProps[5], matrixProps[6], matrixProps[7], matrixProps[8], matrixProps[9], matrixProps[10], matrixProps[11], matrixProps[12], matrixProps[13], matrixProps[14], matrixProps[15]);
    }

    function isIdentity() {
      if (!this._identityCalculated) {
        this._identity = !(this.props[0] !== 1 || this.props[1] !== 0 || this.props[2] !== 0 || this.props[3] !== 0 || this.props[4] !== 0 || this.props[5] !== 1 || this.props[6] !== 0 || this.props[7] !== 0 || this.props[8] !== 0 || this.props[9] !== 0 || this.props[10] !== 1 || this.props[11] !== 0 || this.props[12] !== 0 || this.props[13] !== 0 || this.props[14] !== 0 || this.props[15] !== 1);
        this._identityCalculated = true;
      }

      return this._identity;
    }

    function equals(matr) {
      var i = 0;

      while (i < 16) {
        if (matr.props[i] !== this.props[i]) {
          return false;
        }

        i += 1;
      }

      return true;
    }

    function clone(matr) {
      var i;

      for (i = 0; i < 16; i += 1) {
        matr.props[i] = this.props[i];
      }

      return matr;
    }

    function cloneFromProps(props) {
      var i;

      for (i = 0; i < 16; i += 1) {
        this.props[i] = props[i];
      }
    }

    function applyToPoint(x, y, z) {
      return {
        x: x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12],
        y: x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13],
        z: x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]
      };
      /* return {
           x: x * me.a + y * me.c + me.e,
           y: x * me.b + y * me.d + me.f
           }; */
    }

    function applyToX(x, y, z) {
      return x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12];
    }

    function applyToY(x, y, z) {
      return x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13];
    }

    function applyToZ(x, y, z) {
      return x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14];
    }

    function getInverseMatrix() {
      var determinant = this.props[0] * this.props[5] - this.props[1] * this.props[4];
      var a = this.props[5] / determinant;
      var b = -this.props[1] / determinant;
      var c = -this.props[4] / determinant;
      var d = this.props[0] / determinant;
      var e = (this.props[4] * this.props[13] - this.props[5] * this.props[12]) / determinant;
      var f = -(this.props[0] * this.props[13] - this.props[1] * this.props[12]) / determinant;
      var inverseMatrix = new Matrix();
      inverseMatrix.props[0] = a;
      inverseMatrix.props[1] = b;
      inverseMatrix.props[4] = c;
      inverseMatrix.props[5] = d;
      inverseMatrix.props[12] = e;
      inverseMatrix.props[13] = f;
      return inverseMatrix;
    }

    function inversePoint(pt) {
      var inverseMatrix = this.getInverseMatrix();
      return inverseMatrix.applyToPointArray(pt[0], pt[1], pt[2] || 0);
    }

    function inversePoints(pts) {
      var i;
      var len = pts.length;
      var retPts = [];

      for (i = 0; i < len; i += 1) {
        retPts[i] = inversePoint(pts[i]);
      }

      return retPts;
    }

    function applyToTriplePoints(pt1, pt2, pt3) {
      var arr = createTypedArray('float32', 6);

      if (this.isIdentity()) {
        arr[0] = pt1[0];
        arr[1] = pt1[1];
        arr[2] = pt2[0];
        arr[3] = pt2[1];
        arr[4] = pt3[0];
        arr[5] = pt3[1];
      } else {
        var p0 = this.props[0];
        var p1 = this.props[1];
        var p4 = this.props[4];
        var p5 = this.props[5];
        var p12 = this.props[12];
        var p13 = this.props[13];
        arr[0] = pt1[0] * p0 + pt1[1] * p4 + p12;
        arr[1] = pt1[0] * p1 + pt1[1] * p5 + p13;
        arr[2] = pt2[0] * p0 + pt2[1] * p4 + p12;
        arr[3] = pt2[0] * p1 + pt2[1] * p5 + p13;
        arr[4] = pt3[0] * p0 + pt3[1] * p4 + p12;
        arr[5] = pt3[0] * p1 + pt3[1] * p5 + p13;
      }

      return arr;
    }

    function applyToPointArray(x, y, z) {
      var arr;

      if (this.isIdentity()) {
        arr = [x, y, z];
      } else {
        arr = [x * this.props[0] + y * this.props[4] + z * this.props[8] + this.props[12], x * this.props[1] + y * this.props[5] + z * this.props[9] + this.props[13], x * this.props[2] + y * this.props[6] + z * this.props[10] + this.props[14]];
      }

      return arr;
    }

    function applyToPointStringified(x, y) {
      if (this.isIdentity()) {
        return x + ',' + y;
      }

      var _p = this.props;
      return Math.round((x * _p[0] + y * _p[4] + _p[12]) * 100) / 100 + ',' + Math.round((x * _p[1] + y * _p[5] + _p[13]) * 100) / 100;
    }

    function toCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var i = 0;
      var props = this.props;
      var cssValue = 'matrix3d(';
      var v = 10000;

      while (i < 16) {
        cssValue += _rnd(props[i] * v) / v;
        cssValue += i === 15 ? ')' : ',';
        i += 1;
      }

      return cssValue;
    }

    function roundMatrixProperty(val) {
      var v = 10000;

      if (val < 0.000001 && val > 0 || val > -0.000001 && val < 0) {
        return _rnd(val * v) / v;
      }

      return val;
    }

    function to2dCSS() {
      // Doesn't make much sense to add this optimization. If it is an identity matrix, it's very likely this will get called only once since it won't be keyframed.

      /* if(this.isIdentity()) {
              return '';
          } */
      var props = this.props;

      var _a = roundMatrixProperty(props[0]);

      var _b = roundMatrixProperty(props[1]);

      var _c = roundMatrixProperty(props[4]);

      var _d = roundMatrixProperty(props[5]);

      var _e = roundMatrixProperty(props[12]);

      var _f = roundMatrixProperty(props[13]);

      return 'matrix(' + _a + ',' + _b + ',' + _c + ',' + _d + ',' + _e + ',' + _f + ')';
    }

    return function () {
      this.reset = reset;
      this.rotate = rotate;
      this.rotateX = rotateX;
      this.rotateY = rotateY;
      this.rotateZ = rotateZ;
      this.skew = skew;
      this.skewFromAxis = skewFromAxis;
      this.shear = shear;
      this.scale = scale;
      this.setTransform = setTransform;
      this.translate = translate;
      this.transform = transform;
      this.multiply = multiply;
      this.applyToPoint = applyToPoint;
      this.applyToX = applyToX;
      this.applyToY = applyToY;
      this.applyToZ = applyToZ;
      this.applyToPointArray = applyToPointArray;
      this.applyToTriplePoints = applyToTriplePoints;
      this.applyToPointStringified = applyToPointStringified;
      this.toCSS = toCSS;
      this.to2dCSS = to2dCSS;
      this.clone = clone;
      this.cloneFromProps = cloneFromProps;
      this.equals = equals;
      this.inversePoints = inversePoints;
      this.inversePoint = inversePoint;
      this.getInverseMatrix = getInverseMatrix;
      this._t = this.transform;
      this.isIdentity = isIdentity;
      this._identity = true;
      this._identityCalculated = false;
      this.props = createTypedArray('float32', 16);
      this.reset();
    };
  }();

  function _typeof$3(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$3 = function _typeof(obj) { return typeof obj; }; } else { _typeof$3 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$3(obj); }
  var lottie = {};
  var standalone = '__[STANDALONE]__';
  var animationData = '__[ANIMATIONDATA]__';
  var renderer = '';

  function setLocation(href) {
    setLocationHref(href);
  }

  function searchAnimations() {
    if (standalone === true) {
      animationManager.searchAnimations(animationData, standalone, renderer);
    } else {
      animationManager.searchAnimations();
    }
  }

  function setSubframeRendering(flag) {
    setSubframeEnabled(flag);
  }

  function setPrefix(prefix) {
    setIdPrefix(prefix);
  }

  function loadAnimation(params) {
    if (standalone === true) {
      params.animationData = JSON.parse(animationData);
    }

    return animationManager.loadAnimation(params);
  }

  function setQuality(value) {
    if (typeof value === 'string') {
      switch (value) {
        case 'high':
          setDefaultCurveSegments(200);
          break;

        default:
        case 'medium':
          setDefaultCurveSegments(50);
          break;

        case 'low':
          setDefaultCurveSegments(10);
          break;
      }
    } else if (!isNaN(value) && value > 1) {
      setDefaultCurveSegments(value);
    }

    if (getDefaultCurveSegments() >= 50) {
      roundValues(false);
    } else {
      roundValues(true);
    }
  }

  function inBrowser() {
    return typeof navigator !== 'undefined';
  }

  function installPlugin(type, plugin) {
    if (type === 'expressions') {
      setExpressionsPlugin(plugin);
    }
  }

  function getFactory(name) {
    switch (name) {
      case 'propertyFactory':
        return PropertyFactory;

      case 'shapePropertyFactory':
        return ShapePropertyFactory;

      case 'matrix':
        return Matrix;

      default:
        return null;
    }
  }

  lottie.play = animationManager.play;
  lottie.pause = animationManager.pause;
  lottie.setLocationHref = setLocation;
  lottie.togglePause = animationManager.togglePause;
  lottie.setSpeed = animationManager.setSpeed;
  lottie.setDirection = animationManager.setDirection;
  lottie.stop = animationManager.stop;
  lottie.searchAnimations = searchAnimations;
  lottie.registerAnimation = animationManager.registerAnimation;
  lottie.loadAnimation = loadAnimation;
  lottie.setSubframeRendering = setSubframeRendering;
  lottie.resize = animationManager.resize; // lottie.start = start;

  lottie.goToAndStop = animationManager.goToAndStop;
  lottie.destroy = animationManager.destroy;
  lottie.setQuality = setQuality;
  lottie.inBrowser = inBrowser;
  lottie.installPlugin = installPlugin;
  lottie.freeze = animationManager.freeze;
  lottie.unfreeze = animationManager.unfreeze;
  lottie.setVolume = animationManager.setVolume;
  lottie.mute = animationManager.mute;
  lottie.unmute = animationManager.unmute;
  lottie.getRegisteredAnimations = animationManager.getRegisteredAnimations;
  lottie.useWebWorker = setWebWorker;
  lottie.setIDPrefix = setPrefix;
  lottie.__getFactory = getFactory;
  lottie.version = '5.12.2';

  function checkReady() {
    if (document.readyState === 'complete') {
      clearInterval(readyStateCheckInterval);
      searchAnimations();
    }
  }

  function getQueryVariable(variable) {
    var vars = queryString.split('&');

    for (var i = 0; i < vars.length; i += 1) {
      var pair = vars[i].split('=');

      if (decodeURIComponent(pair[0]) == variable) {
        // eslint-disable-line eqeqeq
        return decodeURIComponent(pair[1]);
      }
    }

    return null;
  }

  var queryString = '';

  if (standalone) {
    var scripts = document.getElementsByTagName('script');
    var index = scripts.length - 1;
    var myScript = scripts[index] || {
      src: ''
    };
    queryString = myScript.src ? myScript.src.replace(/^[^\?]+\??/, '') : ''; // eslint-disable-line no-useless-escape

    renderer = getQueryVariable('renderer');
  }

  var readyStateCheckInterval = setInterval(checkReady, 100); // this adds bodymovin to the window object for backwards compatibility

  try {
    if (!(( false ? 0 : _typeof$3(exports)) === 'object' && "object" !== 'undefined') && !( true && __webpack_require__.amdO) // eslint-disable-line no-undef
    ) {}
  } catch (err) {//
  }

  var ShapeModifiers = function () {
    var ob = {};
    var modifiers = {};
    ob.registerModifier = registerModifier;
    ob.getModifier = getModifier;

    function registerModifier(nm, factory) {
      if (!modifiers[nm]) {
        modifiers[nm] = factory;
      }
    }

    function getModifier(nm, elem, data) {
      return new modifiers[nm](elem, data);
    }

    return ob;
  }();

  function ShapeModifier() {}

  ShapeModifier.prototype.initModifierProperties = function () {};

  ShapeModifier.prototype.addShapeToModifier = function () {};

  ShapeModifier.prototype.addShape = function (data) {
    if (!this.closed) {
      // Adding shape to dynamic properties. It covers the case where a shape has no effects applied, to reset it's _mdf state on every tick.
      data.sh.container.addDynamicProperty(data.sh);
      var shapeData = {
        shape: data.sh,
        data: data,
        localShapeCollection: shapeCollectionPool.newShapeCollection()
      };
      this.shapes.push(shapeData);
      this.addShapeToModifier(shapeData);

      if (this._isAnimated) {
        data.setAsAnimated();
      }
    }
  };

  ShapeModifier.prototype.init = function (elem, data) {
    this.shapes = [];
    this.elem = elem;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, data);
    this.frameId = initialDefaultFrame;
    this.closed = false;
    this.k = false;

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  ShapeModifier.prototype.processKeys = function () {
    if (this.elem.globalData.frameId === this.frameId) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  extendPrototype([DynamicPropertyContainer], ShapeModifier);

  function TrimModifier() {}

  extendPrototype([ShapeModifier], TrimModifier);

  TrimModifier.prototype.initModifierProperties = function (elem, data) {
    this.s = PropertyFactory.getProp(elem, data.s, 0, 0.01, this);
    this.e = PropertyFactory.getProp(elem, data.e, 0, 0.01, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0, this);
    this.sValue = 0;
    this.eValue = 0;
    this.getValue = this.processKeys;
    this.m = data.m;
    this._isAnimated = !!this.s.effectsSequence.length || !!this.e.effectsSequence.length || !!this.o.effectsSequence.length;
  };

  TrimModifier.prototype.addShapeToModifier = function (shapeData) {
    shapeData.pathsData = [];
  };

  TrimModifier.prototype.calculateShapeEdges = function (s, e, shapeLength, addedLength, totalModifierLength) {
    var segments = [];

    if (e <= 1) {
      segments.push({
        s: s,
        e: e
      });
    } else if (s >= 1) {
      segments.push({
        s: s - 1,
        e: e - 1
      });
    } else {
      segments.push({
        s: s,
        e: 1
      });
      segments.push({
        s: 0,
        e: e - 1
      });
    }

    var shapeSegments = [];
    var i;
    var len = segments.length;
    var segmentOb;

    for (i = 0; i < len; i += 1) {
      segmentOb = segments[i];

      if (!(segmentOb.e * totalModifierLength < addedLength || segmentOb.s * totalModifierLength > addedLength + shapeLength)) {
        var shapeS;
        var shapeE;

        if (segmentOb.s * totalModifierLength <= addedLength) {
          shapeS = 0;
        } else {
          shapeS = (segmentOb.s * totalModifierLength - addedLength) / shapeLength;
        }

        if (segmentOb.e * totalModifierLength >= addedLength + shapeLength) {
          shapeE = 1;
        } else {
          shapeE = (segmentOb.e * totalModifierLength - addedLength) / shapeLength;
        }

        shapeSegments.push([shapeS, shapeE]);
      }
    }

    if (!shapeSegments.length) {
      shapeSegments.push([0, 0]);
    }

    return shapeSegments;
  };

  TrimModifier.prototype.releasePathsData = function (pathsData) {
    var i;
    var len = pathsData.length;

    for (i = 0; i < len; i += 1) {
      segmentsLengthPool.release(pathsData[i]);
    }

    pathsData.length = 0;
    return pathsData;
  };

  TrimModifier.prototype.processShapes = function (_isFirstFrame) {
    var s;
    var e;

    if (this._mdf || _isFirstFrame) {
      var o = this.o.v % 360 / 360;

      if (o < 0) {
        o += 1;
      }

      if (this.s.v > 1) {
        s = 1 + o;
      } else if (this.s.v < 0) {
        s = 0 + o;
      } else {
        s = this.s.v + o;
      }

      if (this.e.v > 1) {
        e = 1 + o;
      } else if (this.e.v < 0) {
        e = 0 + o;
      } else {
        e = this.e.v + o;
      }

      if (s > e) {
        var _s = s;
        s = e;
        e = _s;
      }

      s = Math.round(s * 10000) * 0.0001;
      e = Math.round(e * 10000) * 0.0001;
      this.sValue = s;
      this.eValue = e;
    } else {
      s = this.sValue;
      e = this.eValue;
    }

    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var pathsData;
    var pathData;
    var totalShapeLength;
    var totalModifierLength = 0;

    if (e === s) {
      for (i = 0; i < len; i += 1) {
        this.shapes[i].localShapeCollection.releaseShapes();
        this.shapes[i].shape._mdf = true;
        this.shapes[i].shape.paths = this.shapes[i].localShapeCollection;

        if (this._mdf) {
          this.shapes[i].pathsData.length = 0;
        }
      }
    } else if (!(e === 1 && s === 0 || e === 0 && s === 1)) {
      var segments = [];
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i]; // if shape hasn't changed and trim properties haven't changed, cached previous path can be used

        if (!shapeData.shape._mdf && !this._mdf && !_isFirstFrame && this.m !== 2) {
          shapeData.shape.paths = shapeData.localShapeCollection;
        } else {
          shapePaths = shapeData.shape.paths;
          jLen = shapePaths._length;
          totalShapeLength = 0;

          if (!shapeData.shape._mdf && shapeData.pathsData.length) {
            totalShapeLength = shapeData.totalShapeLength;
          } else {
            pathsData = this.releasePathsData(shapeData.pathsData);

            for (j = 0; j < jLen; j += 1) {
              pathData = bez.getSegmentsLength(shapePaths.shapes[j]);
              pathsData.push(pathData);
              totalShapeLength += pathData.totalLength;
            }

            shapeData.totalShapeLength = totalShapeLength;
            shapeData.pathsData = pathsData;
          }

          totalModifierLength += totalShapeLength;
          shapeData.shape._mdf = true;
        }
      }

      var shapeS = s;
      var shapeE = e;
      var addedLength = 0;
      var edges;

      for (i = len - 1; i >= 0; i -= 1) {
        shapeData = this.shapes[i];

        if (shapeData.shape._mdf) {
          localShapeCollection = shapeData.localShapeCollection;
          localShapeCollection.releaseShapes(); // if m === 2 means paths are trimmed individually so edges need to be found for this specific shape relative to whoel group

          if (this.m === 2 && len > 1) {
            edges = this.calculateShapeEdges(s, e, shapeData.totalShapeLength, addedLength, totalModifierLength);
            addedLength += shapeData.totalShapeLength;
          } else {
            edges = [[shapeS, shapeE]];
          }

          jLen = edges.length;

          for (j = 0; j < jLen; j += 1) {
            shapeS = edges[j][0];
            shapeE = edges[j][1];
            segments.length = 0;

            if (shapeE <= 1) {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength * shapeE
              });
            } else if (shapeS >= 1) {
              segments.push({
                s: shapeData.totalShapeLength * (shapeS - 1),
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            } else {
              segments.push({
                s: shapeData.totalShapeLength * shapeS,
                e: shapeData.totalShapeLength
              });
              segments.push({
                s: 0,
                e: shapeData.totalShapeLength * (shapeE - 1)
              });
            }

            var newShapesData = this.addShapes(shapeData, segments[0]);

            if (segments[0].s !== segments[0].e) {
              if (segments.length > 1) {
                var lastShapeInCollection = shapeData.shape.paths.shapes[shapeData.shape.paths._length - 1];

                if (lastShapeInCollection.c) {
                  var lastShape = newShapesData.pop();
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1], lastShape);
                } else {
                  this.addPaths(newShapesData, localShapeCollection);
                  newShapesData = this.addShapes(shapeData, segments[1]);
                }
              }

              this.addPaths(newShapesData, localShapeCollection);
            }
          }

          shapeData.shape.paths = localShapeCollection;
        }
      }
    } else if (this._mdf) {
      for (i = 0; i < len; i += 1) {
        // Releasign Trim Cached paths data when no trim applied in case shapes are modified inbetween.
        // Don't remove this even if it's losing cached info.
        this.shapes[i].pathsData.length = 0;
        this.shapes[i].shape._mdf = true;
      }
    }
  };

  TrimModifier.prototype.addPaths = function (newPaths, localShapeCollection) {
    var i;
    var len = newPaths.length;

    for (i = 0; i < len; i += 1) {
      localShapeCollection.addShape(newPaths[i]);
    }
  };

  TrimModifier.prototype.addSegment = function (pt1, pt2, pt3, pt4, shapePath, pos, newShape) {
    shapePath.setXYAt(pt2[0], pt2[1], 'o', pos);
    shapePath.setXYAt(pt3[0], pt3[1], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(pt1[0], pt1[1], 'v', pos);
    }

    shapePath.setXYAt(pt4[0], pt4[1], 'v', pos + 1);
  };

  TrimModifier.prototype.addSegmentFromArray = function (points, shapePath, pos, newShape) {
    shapePath.setXYAt(points[1], points[5], 'o', pos);
    shapePath.setXYAt(points[2], points[6], 'i', pos + 1);

    if (newShape) {
      shapePath.setXYAt(points[0], points[4], 'v', pos);
    }

    shapePath.setXYAt(points[3], points[7], 'v', pos + 1);
  };

  TrimModifier.prototype.addShapes = function (shapeData, shapeSegment, shapePath) {
    var pathsData = shapeData.pathsData;
    var shapePaths = shapeData.shape.paths.shapes;
    var i;
    var len = shapeData.shape.paths._length;
    var j;
    var jLen;
    var addedLength = 0;
    var currentLengthData;
    var segmentCount;
    var lengths;
    var segment;
    var shapes = [];
    var initPos;
    var newShape = true;

    if (!shapePath) {
      shapePath = shapePool.newElement();
      segmentCount = 0;
      initPos = 0;
    } else {
      segmentCount = shapePath._length;
      initPos = shapePath._length;
    }

    shapes.push(shapePath);

    for (i = 0; i < len; i += 1) {
      lengths = pathsData[i].lengths;
      shapePath.c = shapePaths[i].c;
      jLen = shapePaths[i].c ? lengths.length : lengths.length + 1;

      for (j = 1; j < jLen; j += 1) {
        currentLengthData = lengths[j - 1];

        if (addedLength + currentLengthData.addedLength < shapeSegment.s) {
          addedLength += currentLengthData.addedLength;
          shapePath.c = false;
        } else if (addedLength > shapeSegment.e) {
          shapePath.c = false;
          break;
        } else {
          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + currentLengthData.addedLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[j], shapePaths[i].v[j], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[j], shapePaths[i].o[j - 1], shapePaths[i].i[j], (shapeSegment.s - addedLength) / currentLengthData.addedLength, (shapeSegment.e - addedLength) / currentLengthData.addedLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }

          addedLength += currentLengthData.addedLength;
          segmentCount += 1;
        }
      }

      if (shapePaths[i].c && lengths.length) {
        currentLengthData = lengths[j - 1];

        if (addedLength <= shapeSegment.e) {
          var segmentLength = lengths[j - 1].addedLength;

          if (shapeSegment.s <= addedLength && shapeSegment.e >= addedLength + segmentLength) {
            this.addSegment(shapePaths[i].v[j - 1], shapePaths[i].o[j - 1], shapePaths[i].i[0], shapePaths[i].v[0], shapePath, segmentCount, newShape);
            newShape = false;
          } else {
            segment = bez.getNewSegment(shapePaths[i].v[j - 1], shapePaths[i].v[0], shapePaths[i].o[j - 1], shapePaths[i].i[0], (shapeSegment.s - addedLength) / segmentLength, (shapeSegment.e - addedLength) / segmentLength, lengths[j - 1]);
            this.addSegmentFromArray(segment, shapePath, segmentCount, newShape); // this.addSegment(segment.pt1, segment.pt3, segment.pt4, segment.pt2, shapePath, segmentCount, newShape);

            newShape = false;
            shapePath.c = false;
          }
        } else {
          shapePath.c = false;
        }

        addedLength += currentLengthData.addedLength;
        segmentCount += 1;
      }

      if (shapePath._length) {
        shapePath.setXYAt(shapePath.v[initPos][0], shapePath.v[initPos][1], 'i', initPos);
        shapePath.setXYAt(shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1], 'o', shapePath._length - 1);
      }

      if (addedLength > shapeSegment.e) {
        break;
      }

      if (i < len - 1) {
        shapePath = shapePool.newElement();
        newShape = true;
        shapes.push(shapePath);
        segmentCount = 0;
      }
    }

    return shapes;
  };

  function PuckerAndBloatModifier() {}

  extendPrototype([ShapeModifier], PuckerAndBloatModifier);

  PuckerAndBloatModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this._isAnimated = !!this.amount.effectsSequence.length;
  };

  PuckerAndBloatModifier.prototype.processPath = function (path, amount) {
    var percent = amount / 100;
    var centerPoint = [0, 0];
    var pathLength = path._length;
    var i = 0;

    for (i = 0; i < pathLength; i += 1) {
      centerPoint[0] += path.v[i][0];
      centerPoint[1] += path.v[i][1];
    }

    centerPoint[0] /= pathLength;
    centerPoint[1] /= pathLength;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < pathLength; i += 1) {
      vX = path.v[i][0] + (centerPoint[0] - path.v[i][0]) * percent;
      vY = path.v[i][1] + (centerPoint[1] - path.v[i][1]) * percent;
      oX = path.o[i][0] + (centerPoint[0] - path.o[i][0]) * -percent;
      oY = path.o[i][1] + (centerPoint[1] - path.o[i][1]) * -percent;
      iX = path.i[i][0] + (centerPoint[0] - path.i[i][0]) * -percent;
      iY = path.i[i][1] + (centerPoint[1] - path.i[i][1]) * -percent;
      clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, i);
    }

    return clonedPath;
  };

  PuckerAndBloatModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;

    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  var TransformPropertyFactory = function () {
    var defaultVector = [0, 0];

    function applyToMatrix(mat) {
      var _mdf = this._mdf;
      this.iterateDynamicProperties();
      this._mdf = this._mdf || _mdf;

      if (this.a) {
        mat.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
      }

      if (this.s) {
        mat.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
      }

      if (this.sk) {
        mat.skewFromAxis(-this.sk.v, this.sa.v);
      }

      if (this.r) {
        mat.rotate(-this.r.v);
      } else {
        mat.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
      }

      if (this.data.p.s) {
        if (this.data.p.z) {
          mat.translate(this.px.v, this.py.v, -this.pz.v);
        } else {
          mat.translate(this.px.v, this.py.v, 0);
        }
      } else {
        mat.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
      }
    }

    function processKeys(forceRender) {
      if (this.elem.globalData.frameId === this.frameId) {
        return;
      }

      if (this._isDirty) {
        this.precalculateMatrix();
        this._isDirty = false;
      }

      this.iterateDynamicProperties();

      if (this._mdf || forceRender) {
        var frameRate;
        this.v.cloneFromProps(this.pre.props);

        if (this.appliedTransformations < 1) {
          this.v.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        }

        if (this.appliedTransformations < 2) {
          this.v.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        }

        if (this.sk && this.appliedTransformations < 3) {
          this.v.skewFromAxis(-this.sk.v, this.sa.v);
        }

        if (this.r && this.appliedTransformations < 4) {
          this.v.rotate(-this.r.v);
        } else if (!this.r && this.appliedTransformations < 4) {
          this.v.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        }

        if (this.autoOriented) {
          var v1;
          var v2;
          frameRate = this.elem.globalData.frameRate;

          if (this.p && this.p.keyframes && this.p.getValueAtTime) {
            if (this.p._caching.lastFrame + this.p.offsetTime <= this.p.keyframes[0].t) {
              v1 = this.p.getValueAtTime((this.p.keyframes[0].t + 0.01) / frameRate, 0);
              v2 = this.p.getValueAtTime(this.p.keyframes[0].t / frameRate, 0);
            } else if (this.p._caching.lastFrame + this.p.offsetTime >= this.p.keyframes[this.p.keyframes.length - 1].t) {
              v1 = this.p.getValueAtTime(this.p.keyframes[this.p.keyframes.length - 1].t / frameRate, 0);
              v2 = this.p.getValueAtTime((this.p.keyframes[this.p.keyframes.length - 1].t - 0.05) / frameRate, 0);
            } else {
              v1 = this.p.pv;
              v2 = this.p.getValueAtTime((this.p._caching.lastFrame + this.p.offsetTime - 0.01) / frameRate, this.p.offsetTime);
            }
          } else if (this.px && this.px.keyframes && this.py.keyframes && this.px.getValueAtTime && this.py.getValueAtTime) {
            v1 = [];
            v2 = [];
            var px = this.px;
            var py = this.py;

            if (px._caching.lastFrame + px.offsetTime <= px.keyframes[0].t) {
              v1[0] = px.getValueAtTime((px.keyframes[0].t + 0.01) / frameRate, 0);
              v1[1] = py.getValueAtTime((py.keyframes[0].t + 0.01) / frameRate, 0);
              v2[0] = px.getValueAtTime(px.keyframes[0].t / frameRate, 0);
              v2[1] = py.getValueAtTime(py.keyframes[0].t / frameRate, 0);
            } else if (px._caching.lastFrame + px.offsetTime >= px.keyframes[px.keyframes.length - 1].t) {
              v1[0] = px.getValueAtTime(px.keyframes[px.keyframes.length - 1].t / frameRate, 0);
              v1[1] = py.getValueAtTime(py.keyframes[py.keyframes.length - 1].t / frameRate, 0);
              v2[0] = px.getValueAtTime((px.keyframes[px.keyframes.length - 1].t - 0.01) / frameRate, 0);
              v2[1] = py.getValueAtTime((py.keyframes[py.keyframes.length - 1].t - 0.01) / frameRate, 0);
            } else {
              v1 = [px.pv, py.pv];
              v2[0] = px.getValueAtTime((px._caching.lastFrame + px.offsetTime - 0.01) / frameRate, px.offsetTime);
              v2[1] = py.getValueAtTime((py._caching.lastFrame + py.offsetTime - 0.01) / frameRate, py.offsetTime);
            }
          } else {
            v2 = defaultVector;
            v1 = v2;
          }

          this.v.rotate(-Math.atan2(v1[1] - v2[1], v1[0] - v2[0]));
        }

        if (this.data.p && this.data.p.s) {
          if (this.data.p.z) {
            this.v.translate(this.px.v, this.py.v, -this.pz.v);
          } else {
            this.v.translate(this.px.v, this.py.v, 0);
          }
        } else {
          this.v.translate(this.p.v[0], this.p.v[1], -this.p.v[2]);
        }
      }

      this.frameId = this.elem.globalData.frameId;
    }

    function precalculateMatrix() {
      this.appliedTransformations = 0;
      this.pre.reset();

      if (!this.a.effectsSequence.length) {
        this.pre.translate(-this.a.v[0], -this.a.v[1], this.a.v[2]);
        this.appliedTransformations = 1;
      } else {
        return;
      }

      if (!this.s.effectsSequence.length) {
        this.pre.scale(this.s.v[0], this.s.v[1], this.s.v[2]);
        this.appliedTransformations = 2;
      } else {
        return;
      }

      if (this.sk) {
        if (!this.sk.effectsSequence.length && !this.sa.effectsSequence.length) {
          this.pre.skewFromAxis(-this.sk.v, this.sa.v);
          this.appliedTransformations = 3;
        } else {
          return;
        }
      }

      if (this.r) {
        if (!this.r.effectsSequence.length) {
          this.pre.rotate(-this.r.v);
          this.appliedTransformations = 4;
        }
      } else if (!this.rz.effectsSequence.length && !this.ry.effectsSequence.length && !this.rx.effectsSequence.length && !this.or.effectsSequence.length) {
        this.pre.rotateZ(-this.rz.v).rotateY(this.ry.v).rotateX(this.rx.v).rotateZ(-this.or.v[2]).rotateY(this.or.v[1]).rotateX(this.or.v[0]);
        this.appliedTransformations = 4;
      }
    }

    function autoOrient() {//
      // var prevP = this.getValueAtTime();
    }

    function addDynamicProperty(prop) {
      this._addDynamicProperty(prop);

      this.elem.addDynamicProperty(prop);
      this._isDirty = true;
    }

    function TransformProperty(elem, data, container) {
      this.elem = elem;
      this.frameId = -1;
      this.propType = 'transform';
      this.data = data;
      this.v = new Matrix(); // Precalculated matrix with non animated properties

      this.pre = new Matrix();
      this.appliedTransformations = 0;
      this.initDynamicPropertyContainer(container || elem);

      if (data.p && data.p.s) {
        this.px = PropertyFactory.getProp(elem, data.p.x, 0, 0, this);
        this.py = PropertyFactory.getProp(elem, data.p.y, 0, 0, this);

        if (data.p.z) {
          this.pz = PropertyFactory.getProp(elem, data.p.z, 0, 0, this);
        }
      } else {
        this.p = PropertyFactory.getProp(elem, data.p || {
          k: [0, 0, 0]
        }, 1, 0, this);
      }

      if (data.rx) {
        this.rx = PropertyFactory.getProp(elem, data.rx, 0, degToRads, this);
        this.ry = PropertyFactory.getProp(elem, data.ry, 0, degToRads, this);
        this.rz = PropertyFactory.getProp(elem, data.rz, 0, degToRads, this);

        if (data.or.k[0].ti) {
          var i;
          var len = data.or.k.length;

          for (i = 0; i < len; i += 1) {
            data.or.k[i].to = null;
            data.or.k[i].ti = null;
          }
        }

        this.or = PropertyFactory.getProp(elem, data.or, 1, degToRads, this); // sh Indicates it needs to be capped between -180 and 180

        this.or.sh = true;
      } else {
        this.r = PropertyFactory.getProp(elem, data.r || {
          k: 0
        }, 0, degToRads, this);
      }

      if (data.sk) {
        this.sk = PropertyFactory.getProp(elem, data.sk, 0, degToRads, this);
        this.sa = PropertyFactory.getProp(elem, data.sa, 0, degToRads, this);
      }

      this.a = PropertyFactory.getProp(elem, data.a || {
        k: [0, 0, 0]
      }, 1, 0, this);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: [100, 100, 100]
      }, 1, 0.01, this); // Opacity is not part of the transform properties, that's why it won't use this.dynamicProperties. That way transforms won't get updated if opacity changes.

      if (data.o) {
        this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, elem);
      } else {
        this.o = {
          _mdf: false,
          v: 1
        };
      }

      this._isDirty = true;

      if (!this.dynamicProperties.length) {
        this.getValue(true);
      }
    }

    TransformProperty.prototype = {
      applyToMatrix: applyToMatrix,
      getValue: processKeys,
      precalculateMatrix: precalculateMatrix,
      autoOrient: autoOrient
    };
    extendPrototype([DynamicPropertyContainer], TransformProperty);
    TransformProperty.prototype.addDynamicProperty = addDynamicProperty;
    TransformProperty.prototype._addDynamicProperty = DynamicPropertyContainer.prototype.addDynamicProperty;

    function getTransformProperty(elem, data, container) {
      return new TransformProperty(elem, data, container);
    }

    return {
      getTransformProperty: getTransformProperty
    };
  }();

  function RepeaterModifier() {}

  extendPrototype([ShapeModifier], RepeaterModifier);

  RepeaterModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.c = PropertyFactory.getProp(elem, data.c, 0, null, this);
    this.o = PropertyFactory.getProp(elem, data.o, 0, null, this);
    this.tr = TransformPropertyFactory.getTransformProperty(elem, data.tr, this);
    this.so = PropertyFactory.getProp(elem, data.tr.so, 0, 0.01, this);
    this.eo = PropertyFactory.getProp(elem, data.tr.eo, 0, 0.01, this);
    this.data = data;

    if (!this.dynamicProperties.length) {
      this.getValue(true);
    }

    this._isAnimated = !!this.dynamicProperties.length;
    this.pMatrix = new Matrix();
    this.rMatrix = new Matrix();
    this.sMatrix = new Matrix();
    this.tMatrix = new Matrix();
    this.matrix = new Matrix();
  };

  RepeaterModifier.prototype.applyTransforms = function (pMatrix, rMatrix, sMatrix, transform, perc, inv) {
    var dir = inv ? -1 : 1;
    var scaleX = transform.s.v[0] + (1 - transform.s.v[0]) * (1 - perc);
    var scaleY = transform.s.v[1] + (1 - transform.s.v[1]) * (1 - perc);
    pMatrix.translate(transform.p.v[0] * dir * perc, transform.p.v[1] * dir * perc, transform.p.v[2]);
    rMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    rMatrix.rotate(-transform.r.v * dir * perc);
    rMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
    sMatrix.translate(-transform.a.v[0], -transform.a.v[1], transform.a.v[2]);
    sMatrix.scale(inv ? 1 / scaleX : scaleX, inv ? 1 / scaleY : scaleY);
    sMatrix.translate(transform.a.v[0], transform.a.v[1], transform.a.v[2]);
  };

  RepeaterModifier.prototype.init = function (elem, arr, pos, elemsData) {
    this.elem = elem;
    this.arr = arr;
    this.pos = pos;
    this.elemsData = elemsData;
    this._currentCopies = 0;
    this._elements = [];
    this._groups = [];
    this.frameId = -1;
    this.initDynamicPropertyContainer(elem);
    this.initModifierProperties(elem, arr[pos]);

    while (pos > 0) {
      pos -= 1; // this._elements.unshift(arr.splice(pos,1)[0]);

      this._elements.unshift(arr[pos]);
    }

    if (this.dynamicProperties.length) {
      this.k = true;
    } else {
      this.getValue(true);
    }
  };

  RepeaterModifier.prototype.resetElements = function (elements) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._processed = false;

      if (elements[i].ty === 'gr') {
        this.resetElements(elements[i].it);
      }
    }
  };

  RepeaterModifier.prototype.cloneElements = function (elements) {
    var newElements = JSON.parse(JSON.stringify(elements));
    this.resetElements(newElements);
    return newElements;
  };

  RepeaterModifier.prototype.changeGroupRender = function (elements, renderFlag) {
    var i;
    var len = elements.length;

    for (i = 0; i < len; i += 1) {
      elements[i]._render = renderFlag;

      if (elements[i].ty === 'gr') {
        this.changeGroupRender(elements[i].it, renderFlag);
      }
    }
  };

  RepeaterModifier.prototype.processShapes = function (_isFirstFrame) {
    var items;
    var itemsTransform;
    var i;
    var dir;
    var cont;
    var hasReloaded = false;

    if (this._mdf || _isFirstFrame) {
      var copies = Math.ceil(this.c.v);

      if (this._groups.length < copies) {
        while (this._groups.length < copies) {
          var group = {
            it: this.cloneElements(this._elements),
            ty: 'gr'
          };
          group.it.push({
            a: {
              a: 0,
              ix: 1,
              k: [0, 0]
            },
            nm: 'Transform',
            o: {
              a: 0,
              ix: 7,
              k: 100
            },
            p: {
              a: 0,
              ix: 2,
              k: [0, 0]
            },
            r: {
              a: 1,
              ix: 6,
              k: [{
                s: 0,
                e: 0,
                t: 0
              }, {
                s: 0,
                e: 0,
                t: 1
              }]
            },
            s: {
              a: 0,
              ix: 3,
              k: [100, 100]
            },
            sa: {
              a: 0,
              ix: 5,
              k: 0
            },
            sk: {
              a: 0,
              ix: 4,
              k: 0
            },
            ty: 'tr'
          });
          this.arr.splice(0, 0, group);

          this._groups.splice(0, 0, group);

          this._currentCopies += 1;
        }

        this.elem.reloadShapes();
        hasReloaded = true;
      }

      cont = 0;
      var renderFlag;

      for (i = 0; i <= this._groups.length - 1; i += 1) {
        renderFlag = cont < copies;
        this._groups[i]._render = renderFlag;
        this.changeGroupRender(this._groups[i].it, renderFlag);

        if (!renderFlag) {
          var elems = this.elemsData[i].it;
          var transformData = elems[elems.length - 1];

          if (transformData.transform.op.v !== 0) {
            transformData.transform.op._mdf = true;
            transformData.transform.op.v = 0;
          } else {
            transformData.transform.op._mdf = false;
          }
        }

        cont += 1;
      }

      this._currentCopies = copies; /// /

      var offset = this.o.v;
      var offsetModulo = offset % 1;
      var roundOffset = offset > 0 ? Math.floor(offset) : Math.ceil(offset);
      var pProps = this.pMatrix.props;
      var rProps = this.rMatrix.props;
      var sProps = this.sMatrix.props;
      this.pMatrix.reset();
      this.rMatrix.reset();
      this.sMatrix.reset();
      this.tMatrix.reset();
      this.matrix.reset();
      var iteration = 0;

      if (offset > 0) {
        while (iteration < roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          iteration += 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, offsetModulo, false);
          iteration += offsetModulo;
        }
      } else if (offset < 0) {
        while (iteration > roundOffset) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, true);
          iteration -= 1;
        }

        if (offsetModulo) {
          this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, -offsetModulo, true);
          iteration -= offsetModulo;
        }
      }

      i = this.data.m === 1 ? 0 : this._currentCopies - 1;
      dir = this.data.m === 1 ? 1 : -1;
      cont = this._currentCopies;
      var j;
      var jLen;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        jLen = itemsTransform.length;
        items[items.length - 1].transform.mProps._mdf = true;
        items[items.length - 1].transform.op._mdf = true;
        items[items.length - 1].transform.op.v = this._currentCopies === 1 ? this.so.v : this.so.v + (this.eo.v - this.so.v) * (i / (this._currentCopies - 1));

        if (iteration !== 0) {
          if (i !== 0 && dir === 1 || i !== this._currentCopies - 1 && dir === -1) {
            this.applyTransforms(this.pMatrix, this.rMatrix, this.sMatrix, this.tr, 1, false);
          }

          this.matrix.transform(rProps[0], rProps[1], rProps[2], rProps[3], rProps[4], rProps[5], rProps[6], rProps[7], rProps[8], rProps[9], rProps[10], rProps[11], rProps[12], rProps[13], rProps[14], rProps[15]);
          this.matrix.transform(sProps[0], sProps[1], sProps[2], sProps[3], sProps[4], sProps[5], sProps[6], sProps[7], sProps[8], sProps[9], sProps[10], sProps[11], sProps[12], sProps[13], sProps[14], sProps[15]);
          this.matrix.transform(pProps[0], pProps[1], pProps[2], pProps[3], pProps[4], pProps[5], pProps[6], pProps[7], pProps[8], pProps[9], pProps[10], pProps[11], pProps[12], pProps[13], pProps[14], pProps[15]);

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }

          this.matrix.reset();
        } else {
          this.matrix.reset();

          for (j = 0; j < jLen; j += 1) {
            itemsTransform[j] = this.matrix.props[j];
          }
        }

        iteration += 1;
        cont -= 1;
        i += dir;
      }
    } else {
      cont = this._currentCopies;
      i = 0;
      dir = 1;

      while (cont) {
        items = this.elemsData[i].it;
        itemsTransform = items[items.length - 1].transform.mProps.v.props;
        items[items.length - 1].transform.mProps._mdf = false;
        items[items.length - 1].transform.op._mdf = false;
        cont -= 1;
        i += dir;
      }
    }

    return hasReloaded;
  };

  RepeaterModifier.prototype.addShape = function () {};

  function RoundCornersModifier() {}

  extendPrototype([ShapeModifier], RoundCornersModifier);

  RoundCornersModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.rd = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this._isAnimated = !!this.rd.effectsSequence.length;
  };

  RoundCornersModifier.prototype.processPath = function (path, round) {
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;
    var i;
    var len = path._length;
    var currentV;
    var currentI;
    var currentO;
    var closerV;
    var distance;
    var newPosPerc;
    var index = 0;
    var vX;
    var vY;
    var oX;
    var oY;
    var iX;
    var iY;

    for (i = 0; i < len; i += 1) {
      currentV = path.v[i];
      currentO = path.o[i];
      currentI = path.i[i];

      if (currentV[0] === currentO[0] && currentV[1] === currentO[1] && currentV[0] === currentI[0] && currentV[1] === currentI[1]) {
        if ((i === 0 || i === len - 1) && !path.c) {
          clonedPath.setTripleAt(currentV[0], currentV[1], currentO[0], currentO[1], currentI[0], currentI[1], index);
          /* clonedPath.v[index] = currentV;
                  clonedPath.o[index] = currentO;
                  clonedPath.i[index] = currentI; */

          index += 1;
        } else {
          if (i === 0) {
            closerV = path.v[len - 1];
          } else {
            closerV = path.v[i - 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          iX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = iX;
          iY = currentV[1] - (currentV[1] - closerV[1]) * newPosPerc;
          vY = iY;
          oX = vX - (vX - currentV[0]) * roundCorner;
          oY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;

          if (i === len - 1) {
            closerV = path.v[0];
          } else {
            closerV = path.v[i + 1];
          }

          distance = Math.sqrt(Math.pow(currentV[0] - closerV[0], 2) + Math.pow(currentV[1] - closerV[1], 2));
          newPosPerc = distance ? Math.min(distance / 2, round) / distance : 0;
          oX = currentV[0] + (closerV[0] - currentV[0]) * newPosPerc;
          vX = oX;
          oY = currentV[1] + (closerV[1] - currentV[1]) * newPosPerc;
          vY = oY;
          iX = vX - (vX - currentV[0]) * roundCorner;
          iY = vY - (vY - currentV[1]) * roundCorner;
          clonedPath.setTripleAt(vX, vY, oX, oY, iX, iY, index);
          index += 1;
        }
      } else {
        clonedPath.setTripleAt(path.v[i][0], path.v[i][1], path.o[i][0], path.o[i][1], path.i[i][0], path.i[i][1], index);
        index += 1;
      }
    }

    return clonedPath;
  };

  RoundCornersModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var rd = this.rd.v;

    if (rd !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], rd));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function floatEqual(a, b) {
    return Math.abs(a - b) * 100000 <= Math.min(Math.abs(a), Math.abs(b));
  }

  function floatZero(f) {
    return Math.abs(f) <= 0.00001;
  }

  function lerp(p0, p1, amount) {
    return p0 * (1 - amount) + p1 * amount;
  }

  function lerpPoint(p0, p1, amount) {
    return [lerp(p0[0], p1[0], amount), lerp(p0[1], p1[1], amount)];
  }

  function quadRoots(a, b, c) {
    // no root
    if (a === 0) return [];
    var s = b * b - 4 * a * c; // Complex roots

    if (s < 0) return [];
    var singleRoot = -b / (2 * a); // 1 root

    if (s === 0) return [singleRoot];
    var delta = Math.sqrt(s) / (2 * a); // 2 roots

    return [singleRoot - delta, singleRoot + delta];
  }

  function polynomialCoefficients(p0, p1, p2, p3) {
    return [-p0 + 3 * p1 - 3 * p2 + p3, 3 * p0 - 6 * p1 + 3 * p2, -3 * p0 + 3 * p1, p0];
  }

  function singlePoint(p) {
    return new PolynomialBezier(p, p, p, p, false);
  }

  function PolynomialBezier(p0, p1, p2, p3, linearize) {
    if (linearize && pointEqual(p0, p1)) {
      p1 = lerpPoint(p0, p3, 1 / 3);
    }

    if (linearize && pointEqual(p2, p3)) {
      p2 = lerpPoint(p0, p3, 2 / 3);
    }

    var coeffx = polynomialCoefficients(p0[0], p1[0], p2[0], p3[0]);
    var coeffy = polynomialCoefficients(p0[1], p1[1], p2[1], p3[1]);
    this.a = [coeffx[0], coeffy[0]];
    this.b = [coeffx[1], coeffy[1]];
    this.c = [coeffx[2], coeffy[2]];
    this.d = [coeffx[3], coeffy[3]];
    this.points = [p0, p1, p2, p3];
  }

  PolynomialBezier.prototype.point = function (t) {
    return [((this.a[0] * t + this.b[0]) * t + this.c[0]) * t + this.d[0], ((this.a[1] * t + this.b[1]) * t + this.c[1]) * t + this.d[1]];
  };

  PolynomialBezier.prototype.derivative = function (t) {
    return [(3 * t * this.a[0] + 2 * this.b[0]) * t + this.c[0], (3 * t * this.a[1] + 2 * this.b[1]) * t + this.c[1]];
  };

  PolynomialBezier.prototype.tangentAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[1], p[0]);
  };

  PolynomialBezier.prototype.normalAngle = function (t) {
    var p = this.derivative(t);
    return Math.atan2(p[0], p[1]);
  };

  PolynomialBezier.prototype.inflectionPoints = function () {
    var denom = this.a[1] * this.b[0] - this.a[0] * this.b[1];
    if (floatZero(denom)) return [];
    var tcusp = -0.5 * (this.a[1] * this.c[0] - this.a[0] * this.c[1]) / denom;
    var square = tcusp * tcusp - 1 / 3 * (this.b[1] * this.c[0] - this.b[0] * this.c[1]) / denom;
    if (square < 0) return [];
    var root = Math.sqrt(square);

    if (floatZero(root)) {
      if (root > 0 && root < 1) return [tcusp];
      return [];
    }

    return [tcusp - root, tcusp + root].filter(function (r) {
      return r > 0 && r < 1;
    });
  };

  PolynomialBezier.prototype.split = function (t) {
    if (t <= 0) return [singlePoint(this.points[0]), this];
    if (t >= 1) return [this, singlePoint(this.points[this.points.length - 1])];
    var p10 = lerpPoint(this.points[0], this.points[1], t);
    var p11 = lerpPoint(this.points[1], this.points[2], t);
    var p12 = lerpPoint(this.points[2], this.points[3], t);
    var p20 = lerpPoint(p10, p11, t);
    var p21 = lerpPoint(p11, p12, t);
    var p3 = lerpPoint(p20, p21, t);
    return [new PolynomialBezier(this.points[0], p10, p20, p3, true), new PolynomialBezier(p3, p21, p12, this.points[3], true)];
  };

  function extrema(bez, comp) {
    var min = bez.points[0][comp];
    var max = bez.points[bez.points.length - 1][comp];

    if (min > max) {
      var e = max;
      max = min;
      min = e;
    } // Derivative roots to find min/max


    var f = quadRoots(3 * bez.a[comp], 2 * bez.b[comp], bez.c[comp]);

    for (var i = 0; i < f.length; i += 1) {
      if (f[i] > 0 && f[i] < 1) {
        var val = bez.point(f[i])[comp];
        if (val < min) min = val;else if (val > max) max = val;
      }
    }

    return {
      min: min,
      max: max
    };
  }

  PolynomialBezier.prototype.bounds = function () {
    return {
      x: extrema(this, 0),
      y: extrema(this, 1)
    };
  };

  PolynomialBezier.prototype.boundingBox = function () {
    var bounds = this.bounds();
    return {
      left: bounds.x.min,
      right: bounds.x.max,
      top: bounds.y.min,
      bottom: bounds.y.max,
      width: bounds.x.max - bounds.x.min,
      height: bounds.y.max - bounds.y.min,
      cx: (bounds.x.max + bounds.x.min) / 2,
      cy: (bounds.y.max + bounds.y.min) / 2
    };
  };

  function intersectData(bez, t1, t2) {
    var box = bez.boundingBox();
    return {
      cx: box.cx,
      cy: box.cy,
      width: box.width,
      height: box.height,
      bez: bez,
      t: (t1 + t2) / 2,
      t1: t1,
      t2: t2
    };
  }

  function splitData(data) {
    var split = data.bez.split(0.5);
    return [intersectData(split[0], data.t1, data.t), intersectData(split[1], data.t, data.t2)];
  }

  function boxIntersect(b1, b2) {
    return Math.abs(b1.cx - b2.cx) * 2 < b1.width + b2.width && Math.abs(b1.cy - b2.cy) * 2 < b1.height + b2.height;
  }

  function intersectsImpl(d1, d2, depth, tolerance, intersections, maxRecursion) {
    if (!boxIntersect(d1, d2)) return;

    if (depth >= maxRecursion || d1.width <= tolerance && d1.height <= tolerance && d2.width <= tolerance && d2.height <= tolerance) {
      intersections.push([d1.t, d2.t]);
      return;
    }

    var d1s = splitData(d1);
    var d2s = splitData(d2);
    intersectsImpl(d1s[0], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[0], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[0], depth + 1, tolerance, intersections, maxRecursion);
    intersectsImpl(d1s[1], d2s[1], depth + 1, tolerance, intersections, maxRecursion);
  }

  PolynomialBezier.prototype.intersections = function (other, tolerance, maxRecursion) {
    if (tolerance === undefined) tolerance = 2;
    if (maxRecursion === undefined) maxRecursion = 7;
    var intersections = [];
    intersectsImpl(intersectData(this, 0, 1), intersectData(other, 0, 1), 0, tolerance, intersections, maxRecursion);
    return intersections;
  };

  PolynomialBezier.shapeSegment = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[index], shapePath.o[index], shapePath.i[nextIndex], shapePath.v[nextIndex], true);
  };

  PolynomialBezier.shapeSegmentInverted = function (shapePath, index) {
    var nextIndex = (index + 1) % shapePath.length();
    return new PolynomialBezier(shapePath.v[nextIndex], shapePath.i[nextIndex], shapePath.o[index], shapePath.v[index], true);
  };

  function crossProduct(a, b) {
    return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
  }

  function lineIntersection(start1, end1, start2, end2) {
    var v1 = [start1[0], start1[1], 1];
    var v2 = [end1[0], end1[1], 1];
    var v3 = [start2[0], start2[1], 1];
    var v4 = [end2[0], end2[1], 1];
    var r = crossProduct(crossProduct(v1, v2), crossProduct(v3, v4));
    if (floatZero(r[2])) return null;
    return [r[0] / r[2], r[1] / r[2]];
  }

  function polarOffset(p, angle, length) {
    return [p[0] + Math.cos(angle) * length, p[1] - Math.sin(angle) * length];
  }

  function pointDistance(p1, p2) {
    return Math.hypot(p1[0] - p2[0], p1[1] - p2[1]);
  }

  function pointEqual(p1, p2) {
    return floatEqual(p1[0], p2[0]) && floatEqual(p1[1], p2[1]);
  }

  function ZigZagModifier() {}

  extendPrototype([ShapeModifier], ZigZagModifier);

  ZigZagModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amplitude = PropertyFactory.getProp(elem, data.s, 0, null, this);
    this.frequency = PropertyFactory.getProp(elem, data.r, 0, null, this);
    this.pointsType = PropertyFactory.getProp(elem, data.pt, 0, null, this);
    this._isAnimated = this.amplitude.effectsSequence.length !== 0 || this.frequency.effectsSequence.length !== 0 || this.pointsType.effectsSequence.length !== 0;
  };

  function setPoint(outputBezier, point, angle, direction, amplitude, outAmplitude, inAmplitude) {
    var angO = angle - Math.PI / 2;
    var angI = angle + Math.PI / 2;
    var px = point[0] + Math.cos(angle) * direction * amplitude;
    var py = point[1] - Math.sin(angle) * direction * amplitude;
    outputBezier.setTripleAt(px, py, px + Math.cos(angO) * outAmplitude, py - Math.sin(angO) * outAmplitude, px + Math.cos(angI) * inAmplitude, py - Math.sin(angI) * inAmplitude, outputBezier.length());
  }

  function getPerpendicularVector(pt1, pt2) {
    var vector = [pt2[0] - pt1[0], pt2[1] - pt1[1]];
    var rot = -Math.PI * 0.5;
    var rotatedVector = [Math.cos(rot) * vector[0] - Math.sin(rot) * vector[1], Math.sin(rot) * vector[0] + Math.cos(rot) * vector[1]];
    return rotatedVector;
  }

  function getProjectingAngle(path, cur) {
    var prevIndex = cur === 0 ? path.length() - 1 : cur - 1;
    var nextIndex = (cur + 1) % path.length();
    var prevPoint = path.v[prevIndex];
    var nextPoint = path.v[nextIndex];
    var pVector = getPerpendicularVector(prevPoint, nextPoint);
    return Math.atan2(0, 1) - Math.atan2(pVector[1], pVector[0]);
  }

  function zigZagCorner(outputBezier, path, cur, amplitude, frequency, pointType, direction) {
    var angle = getProjectingAngle(path, cur);
    var point = path.v[cur % path._length];
    var prevPoint = path.v[cur === 0 ? path._length - 1 : cur - 1];
    var nextPoint = path.v[(cur + 1) % path._length];
    var prevDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - prevPoint[0], 2) + Math.pow(point[1] - prevPoint[1], 2)) : 0;
    var nextDist = pointType === 2 ? Math.sqrt(Math.pow(point[0] - nextPoint[0], 2) + Math.pow(point[1] - nextPoint[1], 2)) : 0;
    setPoint(outputBezier, path.v[cur % path._length], angle, direction, amplitude, nextDist / ((frequency + 1) * 2), prevDist / ((frequency + 1) * 2), pointType);
  }

  function zigZagSegment(outputBezier, segment, amplitude, frequency, pointType, direction) {
    for (var i = 0; i < frequency; i += 1) {
      var t = (i + 1) / (frequency + 1);
      var dist = pointType === 2 ? Math.sqrt(Math.pow(segment.points[3][0] - segment.points[0][0], 2) + Math.pow(segment.points[3][1] - segment.points[0][1], 2)) : 0;
      var angle = segment.normalAngle(t);
      var point = segment.point(t);
      setPoint(outputBezier, point, angle, direction, amplitude, dist / ((frequency + 1) * 2), dist / ((frequency + 1) * 2), pointType);
      direction = -direction;
    }

    return direction;
  }

  ZigZagModifier.prototype.processPath = function (path, amplitude, frequency, pointType) {
    var count = path._length;
    var clonedPath = shapePool.newElement();
    clonedPath.c = path.c;

    if (!path.c) {
      count -= 1;
    }

    if (count === 0) return clonedPath;
    var direction = -1;
    var segment = PolynomialBezier.shapeSegment(path, 0);
    zigZagCorner(clonedPath, path, 0, amplitude, frequency, pointType, direction);

    for (var i = 0; i < count; i += 1) {
      direction = zigZagSegment(clonedPath, segment, amplitude, frequency, pointType, -direction);

      if (i === count - 1 && !path.c) {
        segment = null;
      } else {
        segment = PolynomialBezier.shapeSegment(path, (i + 1) % count);
      }

      zigZagCorner(clonedPath, path, i + 1, amplitude, frequency, pointType, direction);
    }

    return clonedPath;
  };

  ZigZagModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amplitude = this.amplitude.v;
    var frequency = Math.max(0, Math.round(this.frequency.v));
    var pointType = this.pointsType.v;

    if (amplitude !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amplitude, frequency, pointType));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function linearOffset(p1, p2, amount) {
    var angle = Math.atan2(p2[0] - p1[0], p2[1] - p1[1]);
    return [polarOffset(p1, angle, amount), polarOffset(p2, angle, amount)];
  }

  function offsetSegment(segment, amount) {
    var p0;
    var p1a;
    var p1b;
    var p2b;
    var p2a;
    var p3;
    var e;
    e = linearOffset(segment.points[0], segment.points[1], amount);
    p0 = e[0];
    p1a = e[1];
    e = linearOffset(segment.points[1], segment.points[2], amount);
    p1b = e[0];
    p2b = e[1];
    e = linearOffset(segment.points[2], segment.points[3], amount);
    p2a = e[0];
    p3 = e[1];
    var p1 = lineIntersection(p0, p1a, p1b, p2b);
    if (p1 === null) p1 = p1a;
    var p2 = lineIntersection(p2a, p3, p1b, p2b);
    if (p2 === null) p2 = p2a;
    return new PolynomialBezier(p0, p1, p2, p3);
  }

  function joinLines(outputBezier, seg1, seg2, lineJoin, miterLimit) {
    var p0 = seg1.points[3];
    var p1 = seg2.points[0]; // Bevel

    if (lineJoin === 3) return p0; // Connected, they don't need a joint

    if (pointEqual(p0, p1)) return p0; // Round

    if (lineJoin === 2) {
      var angleOut = -seg1.tangentAngle(1);
      var angleIn = -seg2.tangentAngle(0) + Math.PI;
      var center = lineIntersection(p0, polarOffset(p0, angleOut + Math.PI / 2, 100), p1, polarOffset(p1, angleOut + Math.PI / 2, 100));
      var radius = center ? pointDistance(center, p0) : pointDistance(p0, p1) / 2;
      var tan = polarOffset(p0, angleOut, 2 * radius * roundCorner);
      outputBezier.setXYAt(tan[0], tan[1], 'o', outputBezier.length() - 1);
      tan = polarOffset(p1, angleIn, 2 * radius * roundCorner);
      outputBezier.setTripleAt(p1[0], p1[1], p1[0], p1[1], tan[0], tan[1], outputBezier.length());
      return p1;
    } // Miter


    var t0 = pointEqual(p0, seg1.points[2]) ? seg1.points[0] : seg1.points[2];
    var t1 = pointEqual(p1, seg2.points[1]) ? seg2.points[3] : seg2.points[1];
    var intersection = lineIntersection(t0, p0, p1, t1);

    if (intersection && pointDistance(intersection, p0) < miterLimit) {
      outputBezier.setTripleAt(intersection[0], intersection[1], intersection[0], intersection[1], intersection[0], intersection[1], outputBezier.length());
      return intersection;
    }

    return p0;
  }

  function getIntersection(a, b) {
    var intersect = a.intersections(b);
    if (intersect.length && floatEqual(intersect[0][0], 1)) intersect.shift();
    if (intersect.length) return intersect[0];
    return null;
  }

  function pruneSegmentIntersection(a, b) {
    var outa = a.slice();
    var outb = b.slice();
    var intersect = getIntersection(a[a.length - 1], b[0]);

    if (intersect) {
      outa[a.length - 1] = a[a.length - 1].split(intersect[0])[0];
      outb[0] = b[0].split(intersect[1])[1];
    }

    if (a.length > 1 && b.length > 1) {
      intersect = getIntersection(a[0], b[b.length - 1]);

      if (intersect) {
        return [[a[0].split(intersect[0])[0]], [b[b.length - 1].split(intersect[1])[1]]];
      }
    }

    return [outa, outb];
  }

  function pruneIntersections(segments) {
    var e;

    for (var i = 1; i < segments.length; i += 1) {
      e = pruneSegmentIntersection(segments[i - 1], segments[i]);
      segments[i - 1] = e[0];
      segments[i] = e[1];
    }

    if (segments.length > 1) {
      e = pruneSegmentIntersection(segments[segments.length - 1], segments[0]);
      segments[segments.length - 1] = e[0];
      segments[0] = e[1];
    }

    return segments;
  }

  function offsetSegmentSplit(segment, amount) {
    /*
      We split each bezier segment into smaller pieces based
      on inflection points, this ensures the control point
      polygon is convex.
        (A cubic bezier can have none, one, or two inflection points)
    */
    var flex = segment.inflectionPoints();
    var left;
    var right;
    var split;
    var mid;

    if (flex.length === 0) {
      return [offsetSegment(segment, amount)];
    }

    if (flex.length === 1 || floatEqual(flex[1], 1)) {
      split = segment.split(flex[0]);
      left = split[0];
      right = split[1];
      return [offsetSegment(left, amount), offsetSegment(right, amount)];
    }

    split = segment.split(flex[0]);
    left = split[0];
    var t = (flex[1] - flex[0]) / (1 - flex[0]);
    split = split[1].split(t);
    mid = split[0];
    right = split[1];
    return [offsetSegment(left, amount), offsetSegment(mid, amount), offsetSegment(right, amount)];
  }

  function OffsetPathModifier() {}

  extendPrototype([ShapeModifier], OffsetPathModifier);

  OffsetPathModifier.prototype.initModifierProperties = function (elem, data) {
    this.getValue = this.processKeys;
    this.amount = PropertyFactory.getProp(elem, data.a, 0, null, this);
    this.miterLimit = PropertyFactory.getProp(elem, data.ml, 0, null, this);
    this.lineJoin = data.lj;
    this._isAnimated = this.amount.effectsSequence.length !== 0;
  };

  OffsetPathModifier.prototype.processPath = function (inputBezier, amount, lineJoin, miterLimit) {
    var outputBezier = shapePool.newElement();
    outputBezier.c = inputBezier.c;
    var count = inputBezier.length();

    if (!inputBezier.c) {
      count -= 1;
    }

    var i;
    var j;
    var segment;
    var multiSegments = [];

    for (i = 0; i < count; i += 1) {
      segment = PolynomialBezier.shapeSegment(inputBezier, i);
      multiSegments.push(offsetSegmentSplit(segment, amount));
    }

    if (!inputBezier.c) {
      for (i = count - 1; i >= 0; i -= 1) {
        segment = PolynomialBezier.shapeSegmentInverted(inputBezier, i);
        multiSegments.push(offsetSegmentSplit(segment, amount));
      }
    }

    multiSegments = pruneIntersections(multiSegments); // Add bezier segments to the output and apply line joints

    var lastPoint = null;
    var lastSeg = null;

    for (i = 0; i < multiSegments.length; i += 1) {
      var multiSegment = multiSegments[i];
      if (lastSeg) lastPoint = joinLines(outputBezier, lastSeg, multiSegment[0], lineJoin, miterLimit);
      lastSeg = multiSegment[multiSegment.length - 1];

      for (j = 0; j < multiSegment.length; j += 1) {
        segment = multiSegment[j];

        if (lastPoint && pointEqual(segment.points[0], lastPoint)) {
          outputBezier.setXYAt(segment.points[1][0], segment.points[1][1], 'o', outputBezier.length() - 1);
        } else {
          outputBezier.setTripleAt(segment.points[0][0], segment.points[0][1], segment.points[1][0], segment.points[1][1], segment.points[0][0], segment.points[0][1], outputBezier.length());
        }

        outputBezier.setTripleAt(segment.points[3][0], segment.points[3][1], segment.points[3][0], segment.points[3][1], segment.points[2][0], segment.points[2][1], outputBezier.length());
        lastPoint = segment.points[3];
      }
    }

    if (multiSegments.length) joinLines(outputBezier, lastSeg, multiSegments[0][0], lineJoin, miterLimit);
    return outputBezier;
  };

  OffsetPathModifier.prototype.processShapes = function (_isFirstFrame) {
    var shapePaths;
    var i;
    var len = this.shapes.length;
    var j;
    var jLen;
    var amount = this.amount.v;
    var miterLimit = this.miterLimit.v;
    var lineJoin = this.lineJoin;

    if (amount !== 0) {
      var shapeData;
      var localShapeCollection;

      for (i = 0; i < len; i += 1) {
        shapeData = this.shapes[i];
        localShapeCollection = shapeData.localShapeCollection;

        if (!(!shapeData.shape._mdf && !this._mdf && !_isFirstFrame)) {
          localShapeCollection.releaseShapes();
          shapeData.shape._mdf = true;
          shapePaths = shapeData.shape.paths.shapes;
          jLen = shapeData.shape.paths._length;

          for (j = 0; j < jLen; j += 1) {
            localShapeCollection.addShape(this.processPath(shapePaths[j], amount, lineJoin, miterLimit));
          }
        }

        shapeData.shape.paths = shapeData.localShapeCollection;
      }
    }

    if (!this.dynamicProperties.length) {
      this._mdf = false;
    }
  };

  function getFontProperties(fontData) {
    var styles = fontData.fStyle ? fontData.fStyle.split(' ') : [];
    var fWeight = 'normal';
    var fStyle = 'normal';
    var len = styles.length;
    var styleName;

    for (var i = 0; i < len; i += 1) {
      styleName = styles[i].toLowerCase();

      switch (styleName) {
        case 'italic':
          fStyle = 'italic';
          break;

        case 'bold':
          fWeight = '700';
          break;

        case 'black':
          fWeight = '900';
          break;

        case 'medium':
          fWeight = '500';
          break;

        case 'regular':
        case 'normal':
          fWeight = '400';
          break;

        case 'light':
        case 'thin':
          fWeight = '200';
          break;

        default:
          break;
      }
    }

    return {
      style: fStyle,
      weight: fontData.fWeight || fWeight
    };
  }

  var FontManager = function () {
    var maxWaitingTime = 5000;
    var emptyChar = {
      w: 0,
      size: 0,
      shapes: [],
      data: {
        shapes: []
      }
    };
    var combinedCharacters = []; // Hindi characters

    combinedCharacters = combinedCharacters.concat([2304, 2305, 2306, 2307, 2362, 2363, 2364, 2364, 2366, 2367, 2368, 2369, 2370, 2371, 2372, 2373, 2374, 2375, 2376, 2377, 2378, 2379, 2380, 2381, 2382, 2383, 2387, 2388, 2389, 2390, 2391, 2402, 2403]);
    var BLACK_FLAG_CODE_POINT = 127988;
    var CANCEL_TAG_CODE_POINT = 917631;
    var A_TAG_CODE_POINT = 917601;
    var Z_TAG_CODE_POINT = 917626;
    var VARIATION_SELECTOR_16_CODE_POINT = 65039;
    var ZERO_WIDTH_JOINER_CODE_POINT = 8205;
    var REGIONAL_CHARACTER_A_CODE_POINT = 127462;
    var REGIONAL_CHARACTER_Z_CODE_POINT = 127487;
    var surrogateModifiers = ['d83cdffb', 'd83cdffc', 'd83cdffd', 'd83cdffe', 'd83cdfff'];

    function trimFontOptions(font) {
      var familyArray = font.split(',');
      var i;
      var len = familyArray.length;
      var enabledFamilies = [];

      for (i = 0; i < len; i += 1) {
        if (familyArray[i] !== 'sans-serif' && familyArray[i] !== 'monospace') {
          enabledFamilies.push(familyArray[i]);
        }
      }

      return enabledFamilies.join(',');
    }

    function setUpNode(font, family) {
      var parentNode = createTag('span'); // Node is invisible to screen readers.

      parentNode.setAttribute('aria-hidden', true);
      parentNode.style.fontFamily = family;
      var node = createTag('span'); // Characters that vary significantly among different fonts

      node.innerText = 'giItT1WQy@!-/#'; // Visible - so we can measure it - but not on the screen

      parentNode.style.position = 'absolute';
      parentNode.style.left = '-10000px';
      parentNode.style.top = '-10000px'; // Large font size makes even subtle changes obvious

      parentNode.style.fontSize = '300px'; // Reset any font properties

      parentNode.style.fontVariant = 'normal';
      parentNode.style.fontStyle = 'normal';
      parentNode.style.fontWeight = 'normal';
      parentNode.style.letterSpacing = '0';
      parentNode.appendChild(node);
      document.body.appendChild(parentNode); // Remember width with no applied web font

      var width = node.offsetWidth;
      node.style.fontFamily = trimFontOptions(font) + ', ' + family;
      return {
        node: node,
        w: width,
        parent: parentNode
      };
    }

    function checkLoadedFonts() {
      var i;
      var len = this.fonts.length;
      var node;
      var w;
      var loadedCount = len;

      for (i = 0; i < len; i += 1) {
        if (this.fonts[i].loaded) {
          loadedCount -= 1;
        } else if (this.fonts[i].fOrigin === 'n' || this.fonts[i].origin === 0) {
          this.fonts[i].loaded = true;
        } else {
          node = this.fonts[i].monoCase.node;
          w = this.fonts[i].monoCase.w;

          if (node.offsetWidth !== w) {
            loadedCount -= 1;
            this.fonts[i].loaded = true;
          } else {
            node = this.fonts[i].sansCase.node;
            w = this.fonts[i].sansCase.w;

            if (node.offsetWidth !== w) {
              loadedCount -= 1;
              this.fonts[i].loaded = true;
            }
          }

          if (this.fonts[i].loaded) {
            this.fonts[i].sansCase.parent.parentNode.removeChild(this.fonts[i].sansCase.parent);
            this.fonts[i].monoCase.parent.parentNode.removeChild(this.fonts[i].monoCase.parent);
          }
        }
      }

      if (loadedCount !== 0 && Date.now() - this.initTime < maxWaitingTime) {
        setTimeout(this.checkLoadedFontsBinded, 20);
      } else {
        setTimeout(this.setIsLoadedBinded, 10);
      }
    }

    function createHelper(fontData, def) {
      var engine = document.body && def ? 'svg' : 'canvas';
      var helper;
      var fontProps = getFontProperties(fontData);

      if (engine === 'svg') {
        var tHelper = createNS('text');
        tHelper.style.fontSize = '100px'; // tHelper.style.fontFamily = fontData.fFamily;

        tHelper.setAttribute('font-family', fontData.fFamily);
        tHelper.setAttribute('font-style', fontProps.style);
        tHelper.setAttribute('font-weight', fontProps.weight);
        tHelper.textContent = '1';

        if (fontData.fClass) {
          tHelper.style.fontFamily = 'inherit';
          tHelper.setAttribute('class', fontData.fClass);
        } else {
          tHelper.style.fontFamily = fontData.fFamily;
        }

        def.appendChild(tHelper);
        helper = tHelper;
      } else {
        var tCanvasHelper = new OffscreenCanvas(500, 500).getContext('2d');
        tCanvasHelper.font = fontProps.style + ' ' + fontProps.weight + ' 100px ' + fontData.fFamily;
        helper = tCanvasHelper;
      }

      function measure(text) {
        if (engine === 'svg') {
          helper.textContent = text;
          return helper.getComputedTextLength();
        }

        return helper.measureText(text).width;
      }

      return {
        measureText: measure
      };
    }

    function addFonts(fontData, defs) {
      if (!fontData) {
        this.isLoaded = true;
        return;
      }

      if (this.chars) {
        this.isLoaded = true;
        this.fonts = fontData.list;
        return;
      }

      if (!document.body) {
        this.isLoaded = true;
        fontData.list.forEach(function (data) {
          data.helper = createHelper(data);
          data.cache = {};
        });
        this.fonts = fontData.list;
        return;
      }

      var fontArr = fontData.list;
      var i;
      var len = fontArr.length;
      var _pendingFonts = len;

      for (i = 0; i < len; i += 1) {
        var shouldLoadFont = true;
        var loadedSelector;
        var j;
        fontArr[i].loaded = false;
        fontArr[i].monoCase = setUpNode(fontArr[i].fFamily, 'monospace');
        fontArr[i].sansCase = setUpNode(fontArr[i].fFamily, 'sans-serif');

        if (!fontArr[i].fPath) {
          fontArr[i].loaded = true;
          _pendingFonts -= 1;
        } else if (fontArr[i].fOrigin === 'p' || fontArr[i].origin === 3) {
          loadedSelector = document.querySelectorAll('style[f-forigin="p"][f-family="' + fontArr[i].fFamily + '"], style[f-origin="3"][f-family="' + fontArr[i].fFamily + '"]');

          if (loadedSelector.length > 0) {
            shouldLoadFont = false;
          }

          if (shouldLoadFont) {
            var s = createTag('style');
            s.setAttribute('f-forigin', fontArr[i].fOrigin);
            s.setAttribute('f-origin', fontArr[i].origin);
            s.setAttribute('f-family', fontArr[i].fFamily);
            s.type = 'text/css';
            s.innerText = '@font-face {font-family: ' + fontArr[i].fFamily + "; font-style: normal; src: url('" + fontArr[i].fPath + "');}";
            defs.appendChild(s);
          }
        } else if (fontArr[i].fOrigin === 'g' || fontArr[i].origin === 1) {
          loadedSelector = document.querySelectorAll('link[f-forigin="g"], link[f-origin="1"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (loadedSelector[j].href.indexOf(fontArr[i].fPath) !== -1) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var l = createTag('link');
            l.setAttribute('f-forigin', fontArr[i].fOrigin);
            l.setAttribute('f-origin', fontArr[i].origin);
            l.type = 'text/css';
            l.rel = 'stylesheet';
            l.href = fontArr[i].fPath;
            document.body.appendChild(l);
          }
        } else if (fontArr[i].fOrigin === 't' || fontArr[i].origin === 2) {
          loadedSelector = document.querySelectorAll('script[f-forigin="t"], script[f-origin="2"]');

          for (j = 0; j < loadedSelector.length; j += 1) {
            if (fontArr[i].fPath === loadedSelector[j].src) {
              // Font is already loaded
              shouldLoadFont = false;
            }
          }

          if (shouldLoadFont) {
            var sc = createTag('link');
            sc.setAttribute('f-forigin', fontArr[i].fOrigin);
            sc.setAttribute('f-origin', fontArr[i].origin);
            sc.setAttribute('rel', 'stylesheet');
            sc.setAttribute('href', fontArr[i].fPath);
            defs.appendChild(sc);
          }
        }

        fontArr[i].helper = createHelper(fontArr[i], defs);
        fontArr[i].cache = {};
        this.fonts.push(fontArr[i]);
      }

      if (_pendingFonts === 0) {
        this.isLoaded = true;
      } else {
        // On some cases even if the font is loaded, it won't load correctly when measuring text on canvas.
        // Adding this timeout seems to fix it
        setTimeout(this.checkLoadedFonts.bind(this), 100);
      }
    }

    function addChars(chars) {
      if (!chars) {
        return;
      }

      if (!this.chars) {
        this.chars = [];
      }

      var i;
      var len = chars.length;
      var j;
      var jLen = this.chars.length;
      var found;

      for (i = 0; i < len; i += 1) {
        j = 0;
        found = false;

        while (j < jLen) {
          if (this.chars[j].style === chars[i].style && this.chars[j].fFamily === chars[i].fFamily && this.chars[j].ch === chars[i].ch) {
            found = true;
          }

          j += 1;
        }

        if (!found) {
          this.chars.push(chars[i]);
          jLen += 1;
        }
      }
    }

    function getCharData(_char, style, font) {
      var i = 0;
      var len = this.chars.length;

      while (i < len) {
        if (this.chars[i].ch === _char && this.chars[i].style === style && this.chars[i].fFamily === font) {
          return this.chars[i];
        }

        i += 1;
      }

      if ((typeof _char === 'string' && _char.charCodeAt(0) !== 13 || !_char) && console && console.warn // eslint-disable-line no-console
      && !this._warned) {
        this._warned = true;
        console.warn('Missing character from exported characters list: ', _char, style, font); // eslint-disable-line no-console
      }

      return emptyChar;
    }

    function measureText(_char2, fontName, size) {
      var fontData = this.getFontByName(fontName); // Using the char instead of char.charCodeAt(0)
      // to avoid collisions between equal chars

      var index = _char2;

      if (!fontData.cache[index]) {
        var tHelper = fontData.helper;

        if (_char2 === ' ') {
          var doubleSize = tHelper.measureText('|' + _char2 + '|');
          var singleSize = tHelper.measureText('||');
          fontData.cache[index] = (doubleSize - singleSize) / 100;
        } else {
          fontData.cache[index] = tHelper.measureText(_char2) / 100;
        }
      }

      return fontData.cache[index] * size;
    }

    function getFontByName(name) {
      var i = 0;
      var len = this.fonts.length;

      while (i < len) {
        if (this.fonts[i].fName === name) {
          return this.fonts[i];
        }

        i += 1;
      }

      return this.fonts[0];
    }

    function getCodePoint(string) {
      var codePoint = 0;
      var first = string.charCodeAt(0);

      if (first >= 0xD800 && first <= 0xDBFF) {
        var second = string.charCodeAt(1);

        if (second >= 0xDC00 && second <= 0xDFFF) {
          codePoint = (first - 0xD800) * 0x400 + second - 0xDC00 + 0x10000;
        }
      }

      return codePoint;
    } // Skin tone modifiers


    function isModifier(firstCharCode, secondCharCode) {
      var sum = firstCharCode.toString(16) + secondCharCode.toString(16);
      return surrogateModifiers.indexOf(sum) !== -1;
    }

    function isZeroWidthJoiner(charCode) {
      return charCode === ZERO_WIDTH_JOINER_CODE_POINT;
    } // This codepoint may change the appearance of the preceding character.
    // If that is a symbol, dingbat or emoji, U+FE0F forces it to be rendered
    // as a colorful image as compared to a monochrome text variant.


    function isVariationSelector(charCode) {
      return charCode === VARIATION_SELECTOR_16_CODE_POINT;
    } // The regional indicator symbols are a set of 26 alphabetic Unicode
    /// characters (A–Z) intended to be used to encode ISO 3166-1 alpha-2
    // two-letter country codes in a way that allows optional special treatment.


    function isRegionalCode(string) {
      var codePoint = getCodePoint(string);

      if (codePoint >= REGIONAL_CHARACTER_A_CODE_POINT && codePoint <= REGIONAL_CHARACTER_Z_CODE_POINT) {
        return true;
      }

      return false;
    } // Some Emoji implementations represent combinations of
    // two “regional indicator” letters as a single flag symbol.


    function isFlagEmoji(string) {
      return isRegionalCode(string.substr(0, 2)) && isRegionalCode(string.substr(2, 2));
    }

    function isCombinedCharacter(_char3) {
      return combinedCharacters.indexOf(_char3) !== -1;
    } // Regional flags start with a BLACK_FLAG_CODE_POINT
    // folowed by 5 chars in the TAG range
    // and end with a CANCEL_TAG_CODE_POINT


    function isRegionalFlag(text, index) {
      var codePoint = getCodePoint(text.substr(index, 2));

      if (codePoint !== BLACK_FLAG_CODE_POINT) {
        return false;
      }

      var count = 0;
      index += 2;

      while (count < 5) {
        codePoint = getCodePoint(text.substr(index, 2));

        if (codePoint < A_TAG_CODE_POINT || codePoint > Z_TAG_CODE_POINT) {
          return false;
        }

        count += 1;
        index += 2;
      }

      return getCodePoint(text.substr(index, 2)) === CANCEL_TAG_CODE_POINT;
    }

    function setIsLoaded() {
      this.isLoaded = true;
    }

    var Font = function Font() {
      this.fonts = [];
      this.chars = null;
      this.typekitLoaded = 0;
      this.isLoaded = false;
      this._warned = false;
      this.initTime = Date.now();
      this.setIsLoadedBinded = this.setIsLoaded.bind(this);
      this.checkLoadedFontsBinded = this.checkLoadedFonts.bind(this);
    };

    Font.isModifier = isModifier;
    Font.isZeroWidthJoiner = isZeroWidthJoiner;
    Font.isFlagEmoji = isFlagEmoji;
    Font.isRegionalCode = isRegionalCode;
    Font.isCombinedCharacter = isCombinedCharacter;
    Font.isRegionalFlag = isRegionalFlag;
    Font.isVariationSelector = isVariationSelector;
    Font.BLACK_FLAG_CODE_POINT = BLACK_FLAG_CODE_POINT;
    var fontPrototype = {
      addChars: addChars,
      addFonts: addFonts,
      getCharData: getCharData,
      getFontByName: getFontByName,
      measureText: measureText,
      checkLoadedFonts: checkLoadedFonts,
      setIsLoaded: setIsLoaded
    };
    Font.prototype = fontPrototype;
    return Font;
  }();

  function SlotManager(animationData) {
    this.animationData = animationData;
  }

  SlotManager.prototype.getProp = function (data) {
    if (this.animationData.slots && this.animationData.slots[data.sid]) {
      return Object.assign(data, this.animationData.slots[data.sid].p);
    }

    return data;
  };

  function slotFactory(animationData) {
    return new SlotManager(animationData);
  }

  function RenderableElement() {}

  RenderableElement.prototype = {
    initRenderable: function initRenderable() {
      // layer's visibility related to inpoint and outpoint. Rename isVisible to isInRange
      this.isInRange = false; // layer's display state

      this.hidden = false; // If layer's transparency equals 0, it can be hidden

      this.isTransparent = false; // list of animated components

      this.renderableComponents = [];
    },
    addRenderableComponent: function addRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) === -1) {
        this.renderableComponents.push(component);
      }
    },
    removeRenderableComponent: function removeRenderableComponent(component) {
      if (this.renderableComponents.indexOf(component) !== -1) {
        this.renderableComponents.splice(this.renderableComponents.indexOf(component), 1);
      }
    },
    prepareRenderableFrame: function prepareRenderableFrame(num) {
      this.checkLayerLimits(num);
    },
    checkTransparency: function checkTransparency() {
      if (this.finalTransform.mProp.o.v <= 0) {
        if (!this.isTransparent && this.globalData.renderConfig.hideOnTransparent) {
          this.isTransparent = true;
          this.hide();
        }
      } else if (this.isTransparent) {
        this.isTransparent = false;
        this.show();
      }
    },

    /**
       * @function
       * Initializes frame related properties.
       *
       * @param {number} num
       * current frame number in Layer's time
       *
       */
    checkLayerLimits: function checkLayerLimits(num) {
      if (this.data.ip - this.data.st <= num && this.data.op - this.data.st > num) {
        if (this.isInRange !== true) {
          this.globalData._mdf = true;
          this._mdf = true;
          this.isInRange = true;
          this.show();
        }
      } else if (this.isInRange !== false) {
        this.globalData._mdf = true;
        this.isInRange = false;
        this.hide();
      }
    },
    renderRenderable: function renderRenderable() {
      var i;
      var len = this.renderableComponents.length;

      for (i = 0; i < len; i += 1) {
        this.renderableComponents[i].renderFrame(this._isFirstFrame);
      }
      /* this.maskManager.renderFrame(this.finalTransform.mat);
          this.renderableEffectsManager.renderFrame(this._isFirstFrame); */

    },
    sourceRectAtTime: function sourceRectAtTime() {
      return {
        top: 0,
        left: 0,
        width: 100,
        height: 100
      };
    },
    getLayerSize: function getLayerSize() {
      if (this.data.ty === 5) {
        return {
          w: this.data.textData.width,
          h: this.data.textData.height
        };
      }

      return {
        w: this.data.width,
        h: this.data.height
      };
    }
  };

  var getBlendMode = function () {
    var blendModeEnums = {
      0: 'source-over',
      1: 'multiply',
      2: 'screen',
      3: 'overlay',
      4: 'darken',
      5: 'lighten',
      6: 'color-dodge',
      7: 'color-burn',
      8: 'hard-light',
      9: 'soft-light',
      10: 'difference',
      11: 'exclusion',
      12: 'hue',
      13: 'saturation',
      14: 'color',
      15: 'luminosity'
    };
    return function (mode) {
      return blendModeEnums[mode] || '';
    };
  }();

  function SliderEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function AngleEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function ColorEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function PointEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 1, 0, container);
  }

  function LayerIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function MaskIndexEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function CheckboxEffect(data, elem, container) {
    this.p = PropertyFactory.getProp(elem, data.v, 0, 0, container);
  }

  function NoValueEffect() {
    this.p = {};
  }

  function EffectsManager(data, element) {
    var effects = data.ef || [];
    this.effectElements = [];
    var i;
    var len = effects.length;
    var effectItem;

    for (i = 0; i < len; i += 1) {
      effectItem = new GroupEffect(effects[i], element);
      this.effectElements.push(effectItem);
    }
  }

  function GroupEffect(data, element) {
    this.init(data, element);
  }

  extendPrototype([DynamicPropertyContainer], GroupEffect);
  GroupEffect.prototype.getValue = GroupEffect.prototype.iterateDynamicProperties;

  GroupEffect.prototype.init = function (data, element) {
    this.data = data;
    this.effectElements = [];
    this.initDynamicPropertyContainer(element);
    var i;
    var len = this.data.ef.length;
    var eff;
    var effects = this.data.ef;

    for (i = 0; i < len; i += 1) {
      eff = null;

      switch (effects[i].ty) {
        case 0:
          eff = new SliderEffect(effects[i], element, this);
          break;

        case 1:
          eff = new AngleEffect(effects[i], element, this);
          break;

        case 2:
          eff = new ColorEffect(effects[i], element, this);
          break;

        case 3:
          eff = new PointEffect(effects[i], element, this);
          break;

        case 4:
        case 7:
          eff = new CheckboxEffect(effects[i], element, this);
          break;

        case 10:
          eff = new LayerIndexEffect(effects[i], element, this);
          break;

        case 11:
          eff = new MaskIndexEffect(effects[i], element, this);
          break;

        case 5:
          eff = new EffectsManager(effects[i], element, this);
          break;
        // case 6:

        default:
          eff = new NoValueEffect(effects[i], element, this);
          break;
      }

      if (eff) {
        this.effectElements.push(eff);
      }
    }
  };

  function BaseElement() {}

  BaseElement.prototype = {
    checkMasks: function checkMasks() {
      if (!this.data.hasMask) {
        return false;
      }

      var i = 0;
      var len = this.data.masksProperties.length;

      while (i < len) {
        if (this.data.masksProperties[i].mode !== 'n' && this.data.masksProperties[i].cl !== false) {
          return true;
        }

        i += 1;
      }

      return false;
    },
    initExpressions: function initExpressions() {
      var expressionsInterfaces = getExpressionInterfaces();

      if (!expressionsInterfaces) {
        return;
      }

      var LayerExpressionInterface = expressionsInterfaces('layer');
      var EffectsExpressionInterface = expressionsInterfaces('effects');
      var ShapeExpressionInterface = expressionsInterfaces('shape');
      var TextExpressionInterface = expressionsInterfaces('text');
      var CompExpressionInterface = expressionsInterfaces('comp');
      this.layerInterface = LayerExpressionInterface(this);

      if (this.data.hasMask && this.maskManager) {
        this.layerInterface.registerMaskInterface(this.maskManager);
      }

      var effectsInterface = EffectsExpressionInterface.createEffectsInterface(this, this.layerInterface);
      this.layerInterface.registerEffectsInterface(effectsInterface);

      if (this.data.ty === 0 || this.data.xt) {
        this.compInterface = CompExpressionInterface(this);
      } else if (this.data.ty === 4) {
        this.layerInterface.shapeInterface = ShapeExpressionInterface(this.shapesData, this.itemsData, this.layerInterface);
        this.layerInterface.content = this.layerInterface.shapeInterface;
      } else if (this.data.ty === 5) {
        this.layerInterface.textInterface = TextExpressionInterface(this);
        this.layerInterface.text = this.layerInterface.textInterface;
      }
    },
    setBlendMode: function setBlendMode() {
      var blendModeValue = getBlendMode(this.data.bm);
      var elem = this.baseElement || this.layerElement;
      elem.style['mix-blend-mode'] = blendModeValue;
    },
    initBaseData: function initBaseData(data, globalData, comp) {
      this.globalData = globalData;
      this.comp = comp;
      this.data = data;
      this.layerId = createElementID(); // Stretch factor for old animations missing this property.

      if (!this.data.sr) {
        this.data.sr = 1;
      } // effects manager


      this.effectsManager = new EffectsManager(this.data, this, this.dynamicProperties);
    },
    getType: function getType() {
      return this.type;
    },
    sourceRectAtTime: function sourceRectAtTime() {}
  };

  /**
   * @file
   * Handles element's layer frame update.
   * Checks layer in point and out point
   *
   */
  function FrameElement() {}

  FrameElement.prototype = {
    /**
       * @function
       * Initializes frame related properties.
       *
       */
    initFrame: function initFrame() {
      // set to true when inpoint is rendered
      this._isFirstFrame = false; // list of animated properties

      this.dynamicProperties = []; // If layer has been modified in current tick this will be true

      this._mdf = false;
    },

    /**
       * @function
       * Calculates all dynamic values
       *
       * @param {number} num
       * current frame number in Layer's time
       * @param {boolean} isVisible
       * if layers is currently in range
       *
       */
    prepareProperties: function prepareProperties(num, isVisible) {
      var i;
      var len = this.dynamicProperties.length;

      for (i = 0; i < len; i += 1) {
        if (isVisible || this._isParent && this.dynamicProperties[i].propType === 'transform') {
          this.dynamicProperties[i].getValue();

          if (this.dynamicProperties[i]._mdf) {
            this.globalData._mdf = true;
            this._mdf = true;
          }
        }
      }
    },
    addDynamicProperty: function addDynamicProperty(prop) {
      if (this.dynamicProperties.indexOf(prop) === -1) {
        this.dynamicProperties.push(prop);
      }
    }
  };

  function FootageElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.footageData = globalData.imageLoader.getAsset(this.assetData);
    this.initBaseData(data, globalData, comp);
  }

  FootageElement.prototype.prepareFrame = function () {};

  extendPrototype([RenderableElement, BaseElement, FrameElement], FootageElement);

  FootageElement.prototype.getBaseElement = function () {
    return null;
  };

  FootageElement.prototype.renderFrame = function () {};

  FootageElement.prototype.destroy = function () {};

  FootageElement.prototype.initExpressions = function () {
    var expressionsInterfaces = getExpressionInterfaces();

    if (!expressionsInterfaces) {
      return;
    }

    var FootageInterface = expressionsInterfaces('footage');
    this.layerInterface = FootageInterface(this);
  };

  FootageElement.prototype.getFootageData = function () {
    return this.footageData;
  };

  function AudioElement(data, globalData, comp) {
    this.initFrame();
    this.initRenderable();
    this.assetData = globalData.getAssetData(data.refId);
    this.initBaseData(data, globalData, comp);
    this._isPlaying = false;
    this._canPlay = false;
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.audio = this.globalData.audioController.createAudio(assetPath);
    this._currentTime = 0;
    this.globalData.audioController.addAudio(this);
    this._volumeMultiplier = 1;
    this._volume = 1;
    this._previousVolume = null;
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
    this.lv = PropertyFactory.getProp(this, data.au && data.au.lv ? data.au.lv : {
      k: [100]
    }, 1, 0.01, this);
  }

  AudioElement.prototype.prepareFrame = function (num) {
    this.prepareRenderableFrame(num, true);
    this.prepareProperties(num, true);

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;
      this._currentTime = timeRemapped;
    } else {
      this._currentTime = num / this.data.sr;
    }

    this._volume = this.lv.v[0];
    var totalVolume = this._volume * this._volumeMultiplier;

    if (this._previousVolume !== totalVolume) {
      this._previousVolume = totalVolume;
      this.audio.volume(totalVolume);
    }
  };

  extendPrototype([RenderableElement, BaseElement, FrameElement], AudioElement);

  AudioElement.prototype.renderFrame = function () {
    if (this.isInRange && this._canPlay) {
      if (!this._isPlaying) {
        this.audio.play();
        this.audio.seek(this._currentTime / this.globalData.frameRate);
        this._isPlaying = true;
      } else if (!this.audio.playing() || Math.abs(this._currentTime / this.globalData.frameRate - this.audio.seek()) > 0.1) {
        this.audio.seek(this._currentTime / this.globalData.frameRate);
      }
    }
  };

  AudioElement.prototype.show = function () {// this.audio.play()
  };

  AudioElement.prototype.hide = function () {
    this.audio.pause();
    this._isPlaying = false;
  };

  AudioElement.prototype.pause = function () {
    this.audio.pause();
    this._isPlaying = false;
    this._canPlay = false;
  };

  AudioElement.prototype.resume = function () {
    this._canPlay = true;
  };

  AudioElement.prototype.setRate = function (rateValue) {
    this.audio.rate(rateValue);
  };

  AudioElement.prototype.volume = function (volumeValue) {
    this._volumeMultiplier = volumeValue;
    this._previousVolume = volumeValue * this._volume;
    this.audio.volume(this._previousVolume);
  };

  AudioElement.prototype.getBaseElement = function () {
    return null;
  };

  AudioElement.prototype.destroy = function () {};

  AudioElement.prototype.sourceRectAtTime = function () {};

  AudioElement.prototype.initExpressions = function () {};

  function BaseRenderer() {}

  BaseRenderer.prototype.checkLayers = function (num) {
    var i;
    var len = this.layers.length;
    var data;
    this.completeLayers = true;

    for (i = len - 1; i >= 0; i -= 1) {
      if (!this.elements[i]) {
        data = this.layers[i];

        if (data.ip - data.st <= num - this.layers[i].st && data.op - data.st > num - this.layers[i].st) {
          this.buildItem(i);
        }
      }

      this.completeLayers = this.elements[i] ? this.completeLayers : false;
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.createItem = function (layer) {
    switch (layer.ty) {
      case 2:
        return this.createImage(layer);

      case 0:
        return this.createComp(layer);

      case 1:
        return this.createSolid(layer);

      case 3:
        return this.createNull(layer);

      case 4:
        return this.createShape(layer);

      case 5:
        return this.createText(layer);

      case 6:
        return this.createAudio(layer);

      case 13:
        return this.createCamera(layer);

      case 15:
        return this.createFootage(layer);

      default:
        return this.createNull(layer);
    }
  };

  BaseRenderer.prototype.createCamera = function () {
    throw new Error('You\'re using a 3d camera. Try the html renderer.');
  };

  BaseRenderer.prototype.createAudio = function (data) {
    return new AudioElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.createFootage = function (data) {
    return new FootageElement(data, this.globalData, this);
  };

  BaseRenderer.prototype.buildAllItems = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      this.buildItem(i);
    }

    this.checkPendingElements();
  };

  BaseRenderer.prototype.includeLayers = function (newLayers) {
    this.completeLayers = false;
    var i;
    var len = newLayers.length;
    var j;
    var jLen = this.layers.length;

    for (i = 0; i < len; i += 1) {
      j = 0;

      while (j < jLen) {
        if (this.layers[j].id === newLayers[i].id) {
          this.layers[j] = newLayers[i];
          break;
        }

        j += 1;
      }
    }
  };

  BaseRenderer.prototype.setProjectInterface = function (pInterface) {
    this.globalData.projectInterface = pInterface;
  };

  BaseRenderer.prototype.initItems = function () {
    if (!this.globalData.progressiveLoad) {
      this.buildAllItems();
    }
  };

  BaseRenderer.prototype.buildElementParenting = function (element, parentName, hierarchy) {
    var elements = this.elements;
    var layers = this.layers;
    var i = 0;
    var len = layers.length;

    while (i < len) {
      if (layers[i].ind == parentName) {
        // eslint-disable-line eqeqeq
        if (!elements[i] || elements[i] === true) {
          this.buildItem(i);
          this.addPendingElement(element);
        } else {
          hierarchy.push(elements[i]);
          elements[i].setAsParent();

          if (layers[i].parent !== undefined) {
            this.buildElementParenting(element, layers[i].parent, hierarchy);
          } else {
            element.setHierarchy(hierarchy);
          }
        }
      }

      i += 1;
    }
  };

  BaseRenderer.prototype.addPendingElement = function (element) {
    this.pendingElements.push(element);
  };

  BaseRenderer.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;

    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i]);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  BaseRenderer.prototype.getElementById = function (ind) {
    var i;
    var len = this.elements.length;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i].data.ind === ind) {
        return this.elements[i];
      }
    }

    return null;
  };

  BaseRenderer.prototype.getElementByPath = function (path) {
    var pathValue = path.shift();
    var element;

    if (typeof pathValue === 'number') {
      element = this.elements[pathValue];
    } else {
      var i;
      var len = this.elements.length;

      for (i = 0; i < len; i += 1) {
        if (this.elements[i].data.nm === pathValue) {
          element = this.elements[i];
          break;
        }
      }
    }

    if (path.length === 0) {
      return element;
    }

    return element.getElementByPath(path);
  };

  BaseRenderer.prototype.setupGlobalData = function (animData, fontsContainer) {
    this.globalData.fontManager = new FontManager();
    this.globalData.slotManager = slotFactory(animData);
    this.globalData.fontManager.addChars(animData.chars);
    this.globalData.fontManager.addFonts(animData.fonts, fontsContainer);
    this.globalData.getAssetData = this.animationItem.getAssetData.bind(this.animationItem);
    this.globalData.getAssetsPath = this.animationItem.getAssetsPath.bind(this.animationItem);
    this.globalData.imageLoader = this.animationItem.imagePreloader;
    this.globalData.audioController = this.animationItem.audioController;
    this.globalData.frameId = 0;
    this.globalData.frameRate = animData.fr;
    this.globalData.nm = animData.nm;
    this.globalData.compSize = {
      w: animData.w,
      h: animData.h
    };
  };

  var effectTypes = {
    TRANSFORM_EFFECT: 'transformEFfect'
  };

  function TransformElement() {}

  TransformElement.prototype = {
    initTransform: function initTransform() {
      var mat = new Matrix();
      this.finalTransform = {
        mProp: this.data.ks ? TransformPropertyFactory.getTransformProperty(this, this.data.ks, this) : {
          o: 0
        },
        _matMdf: false,
        _localMatMdf: false,
        _opMdf: false,
        mat: mat,
        localMat: mat,
        localOpacity: 1
      };

      if (this.data.ao) {
        this.finalTransform.mProp.autoOriented = true;
      } // TODO: check TYPE 11: Guided elements


      if (this.data.ty !== 11) {// this.createElements();
      }
    },
    renderTransform: function renderTransform() {
      this.finalTransform._opMdf = this.finalTransform.mProp.o._mdf || this._isFirstFrame;
      this.finalTransform._matMdf = this.finalTransform.mProp._mdf || this._isFirstFrame;

      if (this.hierarchy) {
        var mat;
        var finalMat = this.finalTransform.mat;
        var i = 0;
        var len = this.hierarchy.length; // Checking if any of the transformation matrices in the hierarchy chain has changed.

        if (!this.finalTransform._matMdf) {
          while (i < len) {
            if (this.hierarchy[i].finalTransform.mProp._mdf) {
              this.finalTransform._matMdf = true;
              break;
            }

            i += 1;
          }
        }

        if (this.finalTransform._matMdf) {
          mat = this.finalTransform.mProp.v.props;
          finalMat.cloneFromProps(mat);

          for (i = 0; i < len; i += 1) {
            finalMat.multiply(this.hierarchy[i].finalTransform.mProp.v);
          }
        }
      }

      if (this.finalTransform._matMdf) {
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;
      }

      if (this.finalTransform._opMdf) {
        this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
      }
    },
    renderLocalTransform: function renderLocalTransform() {
      if (this.localTransforms) {
        var i = 0;
        var len = this.localTransforms.length;
        this.finalTransform._localMatMdf = this.finalTransform._matMdf;

        if (!this.finalTransform._localMatMdf || !this.finalTransform._opMdf) {
          while (i < len) {
            if (this.localTransforms[i]._mdf) {
              this.finalTransform._localMatMdf = true;
            }

            if (this.localTransforms[i]._opMdf && !this.finalTransform._opMdf) {
              this.finalTransform.localOpacity = this.finalTransform.mProp.o.v;
              this.finalTransform._opMdf = true;
            }

            i += 1;
          }
        }

        if (this.finalTransform._localMatMdf) {
          var localMat = this.finalTransform.localMat;
          this.localTransforms[0].matrix.clone(localMat);

          for (i = 1; i < len; i += 1) {
            var lmat = this.localTransforms[i].matrix;
            localMat.multiply(lmat);
          }

          localMat.multiply(this.finalTransform.mat);
        }

        if (this.finalTransform._opMdf) {
          var localOp = this.finalTransform.localOpacity;

          for (i = 0; i < len; i += 1) {
            localOp *= this.localTransforms[i].opacity * 0.01;
          }

          this.finalTransform.localOpacity = localOp;
        }
      }
    },
    searchEffectTransforms: function searchEffectTransforms() {
      if (this.renderableEffectsManager) {
        var transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);

        if (transformEffects.length) {
          this.localTransforms = [];
          this.finalTransform.localMat = new Matrix();
          var i = 0;
          var len = transformEffects.length;

          for (i = 0; i < len; i += 1) {
            this.localTransforms.push(transformEffects[i]);
          }
        }
      }
    },
    globalToLocal: function globalToLocal(pt) {
      var transforms = [];
      transforms.push(this.finalTransform);
      var flag = true;
      var comp = this.comp;

      while (flag) {
        if (comp.finalTransform) {
          if (comp.data.hasMask) {
            transforms.splice(0, 0, comp.finalTransform);
          }

          comp = comp.comp;
        } else {
          flag = false;
        }
      }

      var i;
      var len = transforms.length;
      var ptNew;

      for (i = 0; i < len; i += 1) {
        ptNew = transforms[i].mat.applyToPointArray(0, 0, 0); // ptNew = transforms[i].mat.applyToPointArray(pt[0],pt[1],pt[2]);

        pt = [pt[0] - ptNew[0], pt[1] - ptNew[1], 0];
      }

      return pt;
    },
    mHelper: new Matrix()
  };

  function MaskElement(data, element, globalData) {
    this.data = data;
    this.element = element;
    this.globalData = globalData;
    this.storedData = [];
    this.masksProperties = this.data.masksProperties || [];
    this.maskElement = null;
    var defs = this.globalData.defs;
    var i;
    var len = this.masksProperties ? this.masksProperties.length : 0;
    this.viewData = createSizedArray(len);
    this.solidPath = '';
    var path;
    var properties = this.masksProperties;
    var count = 0;
    var currentMasks = [];
    var j;
    var jLen;
    var layerId = createElementID();
    var rect;
    var expansor;
    var feMorph;
    var x;
    var maskType = 'clipPath';
    var maskRef = 'clip-path';

    for (i = 0; i < len; i += 1) {
      if (properties[i].mode !== 'a' && properties[i].mode !== 'n' || properties[i].inv || properties[i].o.k !== 100 || properties[i].o.x) {
        maskType = 'mask';
        maskRef = 'mask';
      }

      if ((properties[i].mode === 's' || properties[i].mode === 'i') && count === 0) {
        rect = createNS('rect');
        rect.setAttribute('fill', '#ffffff');
        rect.setAttribute('width', this.element.comp.data.w || 0);
        rect.setAttribute('height', this.element.comp.data.h || 0);
        currentMasks.push(rect);
      } else {
        rect = null;
      }

      path = createNS('path');

      if (properties[i].mode === 'n') {
        // TODO move this to a factory or to a constructor
        this.viewData[i] = {
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          elem: path,
          lastPath: ''
        };
        defs.appendChild(path);
      } else {
        count += 1;
        path.setAttribute('fill', properties[i].mode === 's' ? '#000000' : '#ffffff');
        path.setAttribute('clip-rule', 'nonzero');
        var filterID;

        if (properties[i].x.k !== 0) {
          maskType = 'mask';
          maskRef = 'mask';
          x = PropertyFactory.getProp(this.element, properties[i].x, 0, null, this.element);
          filterID = createElementID();
          expansor = createNS('filter');
          expansor.setAttribute('id', filterID);
          feMorph = createNS('feMorphology');
          feMorph.setAttribute('operator', 'erode');
          feMorph.setAttribute('in', 'SourceGraphic');
          feMorph.setAttribute('radius', '0');
          expansor.appendChild(feMorph);
          defs.appendChild(expansor);
          path.setAttribute('stroke', properties[i].mode === 's' ? '#000000' : '#ffffff');
        } else {
          feMorph = null;
          x = null;
        } // TODO move this to a factory or to a constructor


        this.storedData[i] = {
          elem: path,
          x: x,
          expan: feMorph,
          lastPath: '',
          lastOperator: '',
          filterId: filterID,
          lastRadius: 0
        };

        if (properties[i].mode === 'i') {
          jLen = currentMasks.length;
          var g = createNS('g');

          for (j = 0; j < jLen; j += 1) {
            g.appendChild(currentMasks[j]);
          }

          var mask = createNS('mask');
          mask.setAttribute('mask-type', 'alpha');
          mask.setAttribute('id', layerId + '_' + count);
          mask.appendChild(path);
          defs.appendChild(mask);
          g.setAttribute('mask', 'url(' + getLocationHref() + '#' + layerId + '_' + count + ')');
          currentMasks.length = 0;
          currentMasks.push(g);
        } else {
          currentMasks.push(path);
        }

        if (properties[i].inv && !this.solidPath) {
          this.solidPath = this.createLayerSolidPath();
        } // TODO move this to a factory or to a constructor


        this.viewData[i] = {
          elem: path,
          lastPath: '',
          op: PropertyFactory.getProp(this.element, properties[i].o, 0, 0.01, this.element),
          prop: ShapePropertyFactory.getShapeProp(this.element, properties[i], 3),
          invRect: rect
        };

        if (!this.viewData[i].prop.k) {
          this.drawPath(properties[i], this.viewData[i].prop.v, this.viewData[i]);
        }
      }
    }

    this.maskElement = createNS(maskType);
    len = currentMasks.length;

    for (i = 0; i < len; i += 1) {
      this.maskElement.appendChild(currentMasks[i]);
    }

    if (count > 0) {
      this.maskElement.setAttribute('id', layerId);
      this.element.maskedElement.setAttribute(maskRef, 'url(' + getLocationHref() + '#' + layerId + ')');
      defs.appendChild(this.maskElement);
    }

    if (this.viewData.length) {
      this.element.addRenderableComponent(this);
    }
  }

  MaskElement.prototype.getMaskProperty = function (pos) {
    return this.viewData[pos].prop;
  };

  MaskElement.prototype.renderFrame = function (isFirstFrame) {
    var finalMat = this.element.finalTransform.mat;
    var i;
    var len = this.masksProperties.length;

    for (i = 0; i < len; i += 1) {
      if (this.viewData[i].prop._mdf || isFirstFrame) {
        this.drawPath(this.masksProperties[i], this.viewData[i].prop.v, this.viewData[i]);
      }

      if (this.viewData[i].op._mdf || isFirstFrame) {
        this.viewData[i].elem.setAttribute('fill-opacity', this.viewData[i].op.v);
      }

      if (this.masksProperties[i].mode !== 'n') {
        if (this.viewData[i].invRect && (this.element.finalTransform.mProp._mdf || isFirstFrame)) {
          this.viewData[i].invRect.setAttribute('transform', finalMat.getInverseMatrix().to2dCSS());
        }

        if (this.storedData[i].x && (this.storedData[i].x._mdf || isFirstFrame)) {
          var feMorph = this.storedData[i].expan;

          if (this.storedData[i].x.v < 0) {
            if (this.storedData[i].lastOperator !== 'erode') {
              this.storedData[i].lastOperator = 'erode';
              this.storedData[i].elem.setAttribute('filter', 'url(' + getLocationHref() + '#' + this.storedData[i].filterId + ')');
            }

            feMorph.setAttribute('radius', -this.storedData[i].x.v);
          } else {
            if (this.storedData[i].lastOperator !== 'dilate') {
              this.storedData[i].lastOperator = 'dilate';
              this.storedData[i].elem.setAttribute('filter', null);
            }

            this.storedData[i].elem.setAttribute('stroke-width', this.storedData[i].x.v * 2);
          }
        }
      }
    }
  };

  MaskElement.prototype.getMaskelement = function () {
    return this.maskElement;
  };

  MaskElement.prototype.createLayerSolidPath = function () {
    var path = 'M0,0 ';
    path += ' h' + this.globalData.compSize.w;
    path += ' v' + this.globalData.compSize.h;
    path += ' h-' + this.globalData.compSize.w;
    path += ' v-' + this.globalData.compSize.h + ' ';
    return path;
  };

  MaskElement.prototype.drawPath = function (pathData, pathNodes, viewData) {
    var pathString = ' M' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    var i;
    var len;
    len = pathNodes._length;

    for (i = 1; i < len; i += 1) {
      // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[i][0]+','+pathNodes.i[i][1] + " "+pathNodes.v[i][0]+','+pathNodes.v[i][1];
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[i][0] + ',' + pathNodes.i[i][1] + ' ' + pathNodes.v[i][0] + ',' + pathNodes.v[i][1];
    } // pathString += " C"+pathNodes.o[i-1][0]+','+pathNodes.o[i-1][1] + " "+pathNodes.i[0][0]+','+pathNodes.i[0][1] + " "+pathNodes.v[0][0]+','+pathNodes.v[0][1];


    if (pathNodes.c && len > 1) {
      pathString += ' C' + pathNodes.o[i - 1][0] + ',' + pathNodes.o[i - 1][1] + ' ' + pathNodes.i[0][0] + ',' + pathNodes.i[0][1] + ' ' + pathNodes.v[0][0] + ',' + pathNodes.v[0][1];
    } // pathNodes.__renderedString = pathString;


    if (viewData.lastPath !== pathString) {
      var pathShapeValue = '';

      if (viewData.elem) {
        if (pathNodes.c) {
          pathShapeValue = pathData.inv ? this.solidPath + pathString : pathString;
        }

        viewData.elem.setAttribute('d', pathShapeValue);
      }

      viewData.lastPath = pathString;
    }
  };

  MaskElement.prototype.destroy = function () {
    this.element = null;
    this.globalData = null;
    this.maskElement = null;
    this.data = null;
    this.masksProperties = null;
  };

  var filtersFactory = function () {
    var ob = {};
    ob.createFilter = createFilter;
    ob.createAlphaToLuminanceFilter = createAlphaToLuminanceFilter;

    function createFilter(filId, skipCoordinates) {
      var fil = createNS('filter');
      fil.setAttribute('id', filId);

      if (skipCoordinates !== true) {
        fil.setAttribute('filterUnits', 'objectBoundingBox');
        fil.setAttribute('x', '0%');
        fil.setAttribute('y', '0%');
        fil.setAttribute('width', '100%');
        fil.setAttribute('height', '100%');
      }

      return fil;
    }

    function createAlphaToLuminanceFilter() {
      var feColorMatrix = createNS('feColorMatrix');
      feColorMatrix.setAttribute('type', 'matrix');
      feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
      feColorMatrix.setAttribute('values', '0 0 0 1 0  0 0 0 1 0  0 0 0 1 0  0 0 0 1 1');
      return feColorMatrix;
    }

    return ob;
  }();

  var featureSupport = function () {
    var ob = {
      maskType: true,
      svgLumaHidden: true,
      offscreenCanvas: typeof OffscreenCanvas !== 'undefined'
    };

    if (/MSIE 10/i.test(navigator.userAgent) || /MSIE 9/i.test(navigator.userAgent) || /rv:11.0/i.test(navigator.userAgent) || /Edge\/\d./i.test(navigator.userAgent)) {
      ob.maskType = false;
    }

    if (/firefox/i.test(navigator.userAgent)) {
      ob.svgLumaHidden = false;
    }

    return ob;
  }();

  var registeredEffects$1 = {};
  var idPrefix = 'filter_result_';

  function SVGEffects(elem) {
    var i;
    var source = 'SourceGraphic';
    var len = elem.data.ef ? elem.data.ef.length : 0;
    var filId = createElementID();
    var fil = filtersFactory.createFilter(filId, true);
    var count = 0;
    this.filters = [];
    var filterManager;

    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;

      if (registeredEffects$1[type]) {
        var Effect = registeredEffects$1[type].effect;
        filterManager = new Effect(fil, elem.effectsManager.effectElements[i], elem, idPrefix + count, source);
        source = idPrefix + count;

        if (registeredEffects$1[type].countsAsEffect) {
          count += 1;
        }
      }

      if (filterManager) {
        this.filters.push(filterManager);
      }
    }

    if (count) {
      elem.globalData.defs.appendChild(fil);
      elem.layerElement.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
    }

    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }

  SVGEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;

    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };

  SVGEffects.prototype.getEffects = function (type) {
    var i;
    var len = this.filters.length;
    var effects = [];

    for (i = 0; i < len; i += 1) {
      if (this.filters[i].type === type) {
        effects.push(this.filters[i]);
      }
    }

    return effects;
  };

  function registerEffect$1(id, effect, countsAsEffect) {
    registeredEffects$1[id] = {
      effect: effect,
      countsAsEffect: countsAsEffect
    };
  }

  function SVGBaseElement() {}

  SVGBaseElement.prototype = {
    initRendererElement: function initRendererElement() {
      this.layerElement = createNS('g');
    },
    createContainerElements: function createContainerElements() {
      this.matteElement = createNS('g');
      this.transformedElement = this.layerElement;
      this.maskedElement = this.layerElement;
      this._sizeChanged = false;
      var layerElementParent = null; // If this layer acts as a mask for the following layer

      if (this.data.td) {
        this.matteMasks = {};
        var gg = createNS('g');
        gg.setAttribute('id', this.layerId);
        gg.appendChild(this.layerElement);
        layerElementParent = gg;
        this.globalData.defs.appendChild(gg);
      } else if (this.data.tt) {
        this.matteElement.appendChild(this.layerElement);
        layerElementParent = this.matteElement;
        this.baseElement = this.matteElement;
      } else {
        this.baseElement = this.layerElement;
      }

      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }

      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      } // Clipping compositions to hide content that exceeds boundaries. If collapsed transformations is on, component should not be clipped


      if (this.data.ty === 0 && !this.data.hd) {
        var cp = createNS('clipPath');
        var pt = createNS('path');
        pt.setAttribute('d', 'M0,0 L' + this.data.w + ',0 L' + this.data.w + ',' + this.data.h + ' L0,' + this.data.h + 'z');
        var clipId = createElementID();
        cp.setAttribute('id', clipId);
        cp.appendChild(pt);
        this.globalData.defs.appendChild(cp);

        if (this.checkMasks()) {
          var cpGroup = createNS('g');
          cpGroup.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
          cpGroup.appendChild(this.layerElement);
          this.transformedElement = cpGroup;

          if (layerElementParent) {
            layerElementParent.appendChild(this.transformedElement);
          } else {
            this.baseElement = this.transformedElement;
          }
        } else {
          this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + clipId + ')');
        }
      }

      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      if (this.finalTransform._localMatMdf) {
        this.transformedElement.setAttribute('transform', this.finalTransform.localMat.to2dCSS());
      }

      if (this.finalTransform._opMdf) {
        this.transformedElement.setAttribute('opacity', this.finalTransform.localOpacity);
      }
    },
    destroyBaseElement: function destroyBaseElement() {
      this.layerElement = null;
      this.matteElement = null;
      this.maskManager.destroy();
    },
    getBaseElement: function getBaseElement() {
      if (this.data.hd) {
        return null;
      }

      return this.baseElement;
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
      this.renderableEffectsManager = new SVGEffects(this);
      this.searchEffectTransforms();
    },
    getMatte: function getMatte(matteType) {
      // This should not be a common case. But for backward compatibility, we'll create the matte object.
      // It solves animations that have two consecutive layers marked as matte masks.
      // Which is an undefined behavior in AE.
      if (!this.matteMasks) {
        this.matteMasks = {};
      }

      if (!this.matteMasks[matteType]) {
        var id = this.layerId + '_' + matteType;
        var filId;
        var fil;
        var useElement;
        var gg;

        if (matteType === 1 || matteType === 3) {
          var masker = createNS('mask');
          masker.setAttribute('id', id);
          masker.setAttribute('mask-type', matteType === 3 ? 'luminance' : 'alpha');
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          masker.appendChild(useElement);
          this.globalData.defs.appendChild(masker);

          if (!featureSupport.maskType && matteType === 1) {
            masker.setAttribute('mask-type', 'luminance');
            filId = createElementID();
            fil = filtersFactory.createFilter(filId);
            this.globalData.defs.appendChild(fil);
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            gg.appendChild(useElement);
            masker.appendChild(gg);
            gg.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          }
        } else if (matteType === 2) {
          var maskGroup = createNS('mask');
          maskGroup.setAttribute('id', id);
          maskGroup.setAttribute('mask-type', 'alpha');
          var maskGrouper = createNS('g');
          maskGroup.appendChild(maskGrouper);
          filId = createElementID();
          fil = filtersFactory.createFilter(filId); /// /

          var feCTr = createNS('feComponentTransfer');
          feCTr.setAttribute('in', 'SourceGraphic');
          fil.appendChild(feCTr);
          var feFunc = createNS('feFuncA');
          feFunc.setAttribute('type', 'table');
          feFunc.setAttribute('tableValues', '1.0 0.0');
          feCTr.appendChild(feFunc); /// /

          this.globalData.defs.appendChild(fil);
          var alphaRect = createNS('rect');
          alphaRect.setAttribute('width', this.comp.data.w);
          alphaRect.setAttribute('height', this.comp.data.h);
          alphaRect.setAttribute('x', '0');
          alphaRect.setAttribute('y', '0');
          alphaRect.setAttribute('fill', '#ffffff');
          alphaRect.setAttribute('opacity', '0');
          maskGrouper.setAttribute('filter', 'url(' + getLocationHref() + '#' + filId + ')');
          maskGrouper.appendChild(alphaRect);
          useElement = createNS('use');
          useElement.setAttributeNS('http://www.w3.org/1999/xlink', 'href', '#' + this.layerId);
          maskGrouper.appendChild(useElement);

          if (!featureSupport.maskType) {
            maskGroup.setAttribute('mask-type', 'luminance');
            fil.appendChild(filtersFactory.createAlphaToLuminanceFilter());
            gg = createNS('g');
            maskGrouper.appendChild(alphaRect);
            gg.appendChild(this.layerElement);
            maskGrouper.appendChild(gg);
          }

          this.globalData.defs.appendChild(maskGroup);
        }

        this.matteMasks[matteType] = id;
      }

      return this.matteMasks[matteType];
    },
    setMatte: function setMatte(id) {
      if (!this.matteElement) {
        return;
      }

      this.matteElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');
    }
  };

  /**
   * @file
   * Handles AE's layer parenting property.
   *
   */
  function HierarchyElement() {}

  HierarchyElement.prototype = {
    /**
       * @function
       * Initializes hierarchy properties
       *
       */
    initHierarchy: function initHierarchy() {
      // element's parent list
      this.hierarchy = []; // if element is parent of another layer _isParent will be true

      this._isParent = false;
      this.checkParenting();
    },

    /**
       * @function
       * Sets layer's hierarchy.
       * @param {array} hierarch
       * layer's parent list
       *
       */
    setHierarchy: function setHierarchy(hierarchy) {
      this.hierarchy = hierarchy;
    },

    /**
       * @function
       * Sets layer as parent.
       *
       */
    setAsParent: function setAsParent() {
      this._isParent = true;
    },

    /**
       * @function
       * Searches layer's parenting chain
       *
       */
    checkParenting: function checkParenting() {
      if (this.data.parent !== undefined) {
        this.comp.buildElementParenting(this, this.data.parent, []);
      }
    }
  };

  function RenderableDOMElement() {}

  (function () {
    var _prototype = {
      initElement: function initElement(data, globalData, comp) {
        this.initFrame();
        this.initBaseData(data, globalData, comp);
        this.initTransform(data, globalData, comp);
        this.initHierarchy();
        this.initRenderable();
        this.initRendererElement();
        this.createContainerElements();
        this.createRenderableComponents();
        this.createContent();
        this.hide();
      },
      hide: function hide() {
        // console.log('HIDE', this);
        if (!this.hidden && (!this.isInRange || this.isTransparent)) {
          var elem = this.baseElement || this.layerElement;
          elem.style.display = 'none';
          this.hidden = true;
        }
      },
      show: function show() {
        // console.log('SHOW', this);
        if (this.isInRange && !this.isTransparent) {
          if (!this.data.hd) {
            var elem = this.baseElement || this.layerElement;
            elem.style.display = 'block';
          }

          this.hidden = false;
          this._isFirstFrame = true;
        }
      },
      renderFrame: function renderFrame() {
        // If it is exported as hidden (data.hd === true) no need to render
        // If it is not visible no need to render
        if (this.data.hd || this.hidden) {
          return;
        }

        this.renderTransform();
        this.renderRenderable();
        this.renderLocalTransform();
        this.renderElement();
        this.renderInnerContent();

        if (this._isFirstFrame) {
          this._isFirstFrame = false;
        }
      },
      renderInnerContent: function renderInnerContent() {},
      prepareFrame: function prepareFrame(num) {
        this._mdf = false;
        this.prepareRenderableFrame(num);
        this.prepareProperties(num, this.isInRange);
        this.checkTransparency();
      },
      destroy: function destroy() {
        this.innerElem = null;
        this.destroyBaseElement();
      }
    };
    extendPrototype([RenderableElement, createProxyFunction(_prototype)], RenderableDOMElement);
  })();

  function IImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);

    if (this.assetData && this.assetData.sid) {
      this.assetData = globalData.slotManager.getProp(this.assetData);
    }

    this.initElement(data, globalData, comp);
    this.sourceRect = {
      top: 0,
      left: 0,
      width: this.assetData.w,
      height: this.assetData.h
    };
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], IImageElement);

  IImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    this.innerElem = createNS('image');
    this.innerElem.setAttribute('width', this.assetData.w + 'px');
    this.innerElem.setAttribute('height', this.assetData.h + 'px');
    this.innerElem.setAttribute('preserveAspectRatio', this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio);
    this.innerElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
    this.layerElement.appendChild(this.innerElem);
  };

  IImageElement.prototype.sourceRectAtTime = function () {
    return this.sourceRect;
  };

  function ProcessedElement(element, position) {
    this.elem = element;
    this.pos = position;
  }

  function IShapeElement() {}

  IShapeElement.prototype = {
    addShapeToModifiers: function addShapeToModifiers(data) {
      var i;
      var len = this.shapeModifiers.length;

      for (i = 0; i < len; i += 1) {
        this.shapeModifiers[i].addShape(data);
      }
    },
    isShapeInAnimatedModifiers: function isShapeInAnimatedModifiers(data) {
      var i = 0;
      var len = this.shapeModifiers.length;

      while (i < len) {
        if (this.shapeModifiers[i].isAnimatedWithShape(data)) {
          return true;
        }
      }

      return false;
    },
    renderModifiers: function renderModifiers() {
      if (!this.shapeModifiers.length) {
        return;
      }

      var i;
      var len = this.shapes.length;

      for (i = 0; i < len; i += 1) {
        this.shapes[i].sh.reset();
      }

      len = this.shapeModifiers.length;
      var shouldBreakProcess;

      for (i = len - 1; i >= 0; i -= 1) {
        shouldBreakProcess = this.shapeModifiers[i].processShapes(this._isFirstFrame); // workaround to fix cases where a repeater resets the shape so the following processes get called twice
        // TODO: find a better solution for this

        if (shouldBreakProcess) {
          break;
        }
      }
    },
    searchProcessedElement: function searchProcessedElement(elem) {
      var elements = this.processedElements;
      var i = 0;
      var len = elements.length;

      while (i < len) {
        if (elements[i].elem === elem) {
          return elements[i].pos;
        }

        i += 1;
      }

      return 0;
    },
    addProcessedElement: function addProcessedElement(elem, pos) {
      var elements = this.processedElements;
      var i = elements.length;

      while (i) {
        i -= 1;

        if (elements[i].elem === elem) {
          elements[i].pos = pos;
          return;
        }
      }

      elements.push(new ProcessedElement(elem, pos));
    },
    prepareFrame: function prepareFrame(num) {
      this.prepareRenderableFrame(num);
      this.prepareProperties(num, this.isInRange);
    }
  };

  var lineCapEnum = {
    1: 'butt',
    2: 'round',
    3: 'square'
  };
  var lineJoinEnum = {
    1: 'miter',
    2: 'round',
    3: 'bevel'
  };

  function SVGShapeData(transformers, level, shape) {
    this.caches = [];
    this.styles = [];
    this.transformers = transformers;
    this.lStr = '';
    this.sh = shape;
    this.lvl = level; // TODO find if there are some cases where _isAnimated can be false.
    // For now, since shapes add up with other shapes. They have to be calculated every time.
    // One way of finding out is checking if all styles associated to this shape depend only of this shape

    this._isAnimated = !!shape.k; // TODO: commenting this for now since all shapes are animated

    var i = 0;
    var len = transformers.length;

    while (i < len) {
      if (transformers[i].mProps.dynamicProperties.length) {
        this._isAnimated = true;
        break;
      }

      i += 1;
    }
  }

  SVGShapeData.prototype.setAsAnimated = function () {
    this._isAnimated = true;
  };

  function SVGStyleData(data, level) {
    this.data = data;
    this.type = data.ty;
    this.d = '';
    this.lvl = level;
    this._mdf = false;
    this.closed = data.hd === true;
    this.pElem = createNS('path');
    this.msElem = null;
  }

  SVGStyleData.prototype.reset = function () {
    this.d = '';
    this._mdf = false;
  };

  function DashProperty(elem, data, renderer, container) {
    this.elem = elem;
    this.frameId = -1;
    this.dataProps = createSizedArray(data.length);
    this.renderer = renderer;
    this.k = false;
    this.dashStr = '';
    this.dashArray = createTypedArray('float32', data.length ? data.length - 1 : 0);
    this.dashoffset = createTypedArray('float32', 1);
    this.initDynamicPropertyContainer(container);
    var i;
    var len = data.length || 0;
    var prop;

    for (i = 0; i < len; i += 1) {
      prop = PropertyFactory.getProp(elem, data[i].v, 0, 0, this);
      this.k = prop.k || this.k;
      this.dataProps[i] = {
        n: data[i].n,
        p: prop
      };
    }

    if (!this.k) {
      this.getValue(true);
    }

    this._isAnimated = this.k;
  }

  DashProperty.prototype.getValue = function (forceRender) {
    if (this.elem.globalData.frameId === this.frameId && !forceRender) {
      return;
    }

    this.frameId = this.elem.globalData.frameId;
    this.iterateDynamicProperties();
    this._mdf = this._mdf || forceRender;

    if (this._mdf) {
      var i = 0;
      var len = this.dataProps.length;

      if (this.renderer === 'svg') {
        this.dashStr = '';
      }

      for (i = 0; i < len; i += 1) {
        if (this.dataProps[i].n !== 'o') {
          if (this.renderer === 'svg') {
            this.dashStr += ' ' + this.dataProps[i].p.v;
          } else {
            this.dashArray[i] = this.dataProps[i].p.v;
          }
        } else {
          this.dashoffset[0] = this.dataProps[i].p.v;
        }
      }
    }
  };

  extendPrototype([DynamicPropertyContainer], DashProperty);

  function SVGStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([DynamicPropertyContainer], SVGStrokeStyleData);

  function SVGFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.c = PropertyFactory.getProp(elem, data.c, 1, 255, this);
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGFillStyleData);

  function SVGNoStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.style = styleOb;
  }

  extendPrototype([DynamicPropertyContainer], SVGNoStyleData);

  function GradientProperty(elem, data, container) {
    this.data = data;
    this.c = createTypedArray('uint8c', data.p * 4);
    var cLength = data.k.k[0].s ? data.k.k[0].s.length - data.p * 4 : data.k.k.length - data.p * 4;
    this.o = createTypedArray('float32', cLength);
    this._cmdf = false;
    this._omdf = false;
    this._collapsable = this.checkCollapsable();
    this._hasOpacity = cLength;
    this.initDynamicPropertyContainer(container);
    this.prop = PropertyFactory.getProp(elem, data.k, 1, null, this);
    this.k = this.prop.k;
    this.getValue(true);
  }

  GradientProperty.prototype.comparePoints = function (values, points) {
    var i = 0;
    var len = this.o.length / 2;
    var diff;

    while (i < len) {
      diff = Math.abs(values[i * 4] - values[points * 4 + i * 2]);

      if (diff > 0.01) {
        return false;
      }

      i += 1;
    }

    return true;
  };

  GradientProperty.prototype.checkCollapsable = function () {
    if (this.o.length / 2 !== this.c.length / 4) {
      return false;
    }

    if (this.data.k.k[0].s) {
      var i = 0;
      var len = this.data.k.k.length;

      while (i < len) {
        if (!this.comparePoints(this.data.k.k[i].s, this.data.p)) {
          return false;
        }

        i += 1;
      }
    } else if (!this.comparePoints(this.data.k.k, this.data.p)) {
      return false;
    }

    return true;
  };

  GradientProperty.prototype.getValue = function (forceRender) {
    this.prop.getValue();
    this._mdf = false;
    this._cmdf = false;
    this._omdf = false;

    if (this.prop._mdf || forceRender) {
      var i;
      var len = this.data.p * 4;
      var mult;
      var val;

      for (i = 0; i < len; i += 1) {
        mult = i % 4 === 0 ? 100 : 255;
        val = Math.round(this.prop.v[i] * mult);

        if (this.c[i] !== val) {
          this.c[i] = val;
          this._cmdf = !forceRender;
        }
      }

      if (this.o.length) {
        len = this.prop.v.length;

        for (i = this.data.p * 4; i < len; i += 1) {
          mult = i % 2 === 0 ? 100 : 1;
          val = i % 2 === 0 ? Math.round(this.prop.v[i] * 100) : this.prop.v[i];

          if (this.o[i - this.data.p * 4] !== val) {
            this.o[i - this.data.p * 4] = val;
            this._omdf = !forceRender;
          }
        }
      }

      this._mdf = !forceRender;
    }
  };

  extendPrototype([DynamicPropertyContainer], GradientProperty);

  function SVGGradientFillStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.initGradientData(elem, data, styleOb);
  }

  SVGGradientFillStyleData.prototype.initGradientData = function (elem, data, styleOb) {
    this.o = PropertyFactory.getProp(elem, data.o, 0, 0.01, this);
    this.s = PropertyFactory.getProp(elem, data.s, 1, null, this);
    this.e = PropertyFactory.getProp(elem, data.e, 1, null, this);
    this.h = PropertyFactory.getProp(elem, data.h || {
      k: 0
    }, 0, 0.01, this);
    this.a = PropertyFactory.getProp(elem, data.a || {
      k: 0
    }, 0, degToRads, this);
    this.g = new GradientProperty(elem, data.g, this);
    this.style = styleOb;
    this.stops = [];
    this.setGradientData(styleOb.pElem, data);
    this.setGradientOpacity(data, styleOb);
    this._isAnimated = !!this._isAnimated;
  };

  SVGGradientFillStyleData.prototype.setGradientData = function (pathElement, data) {
    var gradientId = createElementID();
    var gfill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
    gfill.setAttribute('id', gradientId);
    gfill.setAttribute('spreadMethod', 'pad');
    gfill.setAttribute('gradientUnits', 'userSpaceOnUse');
    var stops = [];
    var stop;
    var j;
    var jLen;
    jLen = data.g.p * 4;

    for (j = 0; j < jLen; j += 4) {
      stop = createNS('stop');
      gfill.appendChild(stop);
      stops.push(stop);
    }

    pathElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + gradientId + ')');
    this.gf = gfill;
    this.cst = stops;
  };

  SVGGradientFillStyleData.prototype.setGradientOpacity = function (data, styleOb) {
    if (this.g._hasOpacity && !this.g._collapsable) {
      var stop;
      var j;
      var jLen;
      var mask = createNS('mask');
      var maskElement = createNS('path');
      mask.appendChild(maskElement);
      var opacityId = createElementID();
      var maskId = createElementID();
      mask.setAttribute('id', maskId);
      var opFill = createNS(data.t === 1 ? 'linearGradient' : 'radialGradient');
      opFill.setAttribute('id', opacityId);
      opFill.setAttribute('spreadMethod', 'pad');
      opFill.setAttribute('gradientUnits', 'userSpaceOnUse');
      jLen = data.g.k.k[0].s ? data.g.k.k[0].s.length : data.g.k.k.length;
      var stops = this.stops;

      for (j = data.g.p * 4; j < jLen; j += 2) {
        stop = createNS('stop');
        stop.setAttribute('stop-color', 'rgb(255,255,255)');
        opFill.appendChild(stop);
        stops.push(stop);
      }

      maskElement.setAttribute(data.ty === 'gf' ? 'fill' : 'stroke', 'url(' + getLocationHref() + '#' + opacityId + ')');

      if (data.ty === 'gs') {
        maskElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
        maskElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);

        if (data.lj === 1) {
          maskElement.setAttribute('stroke-miterlimit', data.ml);
        }
      }

      this.of = opFill;
      this.ms = mask;
      this.ost = stops;
      this.maskId = maskId;
      styleOb.msElem = maskElement;
    }
  };

  extendPrototype([DynamicPropertyContainer], SVGGradientFillStyleData);

  function SVGGradientStrokeStyleData(elem, data, styleOb) {
    this.initDynamicPropertyContainer(elem);
    this.getValue = this.iterateDynamicProperties;
    this.w = PropertyFactory.getProp(elem, data.w, 0, null, this);
    this.d = new DashProperty(elem, data.d || {}, 'svg', this);
    this.initGradientData(elem, data, styleOb);
    this._isAnimated = !!this._isAnimated;
  }

  extendPrototype([SVGGradientFillStyleData, DynamicPropertyContainer], SVGGradientStrokeStyleData);

  function ShapeGroupData() {
    this.it = [];
    this.prevViewData = [];
    this.gr = createNS('g');
  }

  function SVGTransformData(mProps, op, container) {
    this.transform = {
      mProps: mProps,
      op: op,
      container: container
    };
    this.elements = [];
    this._isAnimated = this.transform.mProps.dynamicProperties.length || this.transform.op.effectsSequence.length;
  }

  var buildShapeString = function buildShapeString(pathNodes, length, closed, mat) {
    if (length === 0) {
      return '';
    }

    var _o = pathNodes.o;
    var _i = pathNodes.i;
    var _v = pathNodes.v;
    var i;
    var shapeString = ' M' + mat.applyToPointStringified(_v[0][0], _v[0][1]);

    for (i = 1; i < length; i += 1) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[i][0], _i[i][1]) + ' ' + mat.applyToPointStringified(_v[i][0], _v[i][1]);
    }

    if (closed && length) {
      shapeString += ' C' + mat.applyToPointStringified(_o[i - 1][0], _o[i - 1][1]) + ' ' + mat.applyToPointStringified(_i[0][0], _i[0][1]) + ' ' + mat.applyToPointStringified(_v[0][0], _v[0][1]);
      shapeString += 'z';
    }

    return shapeString;
  };

  var SVGElementsRenderer = function () {
    var _identityMatrix = new Matrix();

    var _matrixHelper = new Matrix();

    var ob = {
      createRenderFunction: createRenderFunction
    };

    function createRenderFunction(data) {
      switch (data.ty) {
        case 'fl':
          return renderFill;

        case 'gf':
          return renderGradient;

        case 'gs':
          return renderGradientStroke;

        case 'st':
          return renderStroke;

        case 'sh':
        case 'el':
        case 'rc':
        case 'sr':
          return renderPath;

        case 'tr':
          return renderContentTransform;

        case 'no':
          return renderNoop;

        default:
          return null;
      }
    }

    function renderContentTransform(styleData, itemData, isFirstFrame) {
      if (isFirstFrame || itemData.transform.op._mdf) {
        itemData.transform.container.setAttribute('opacity', itemData.transform.op.v);
      }

      if (isFirstFrame || itemData.transform.mProps._mdf) {
        itemData.transform.container.setAttribute('transform', itemData.transform.mProps.v.to2dCSS());
      }
    }

    function renderNoop() {}

    function renderPath(styleData, itemData, isFirstFrame) {
      var j;
      var jLen;
      var pathStringTransformed;
      var redraw;
      var pathNodes;
      var l;
      var lLen = itemData.styles.length;
      var lvl = itemData.lvl;
      var paths;
      var mat;
      var iterations;
      var k;

      for (l = 0; l < lLen; l += 1) {
        redraw = itemData.sh._mdf || isFirstFrame;

        if (itemData.styles[l].lvl < lvl) {
          mat = _matrixHelper.reset();
          iterations = lvl - itemData.styles[l].lvl;
          k = itemData.transformers.length - 1;

          while (!redraw && iterations > 0) {
            redraw = itemData.transformers[k].mProps._mdf || redraw;
            iterations -= 1;
            k -= 1;
          }

          if (redraw) {
            iterations = lvl - itemData.styles[l].lvl;
            k = itemData.transformers.length - 1;

            while (iterations > 0) {
              mat.multiply(itemData.transformers[k].mProps.v);
              iterations -= 1;
              k -= 1;
            }
          }
        } else {
          mat = _identityMatrix;
        }

        paths = itemData.sh.paths;
        jLen = paths._length;

        if (redraw) {
          pathStringTransformed = '';

          for (j = 0; j < jLen; j += 1) {
            pathNodes = paths.shapes[j];

            if (pathNodes && pathNodes._length) {
              pathStringTransformed += buildShapeString(pathNodes, pathNodes._length, pathNodes.c, mat);
            }
          }

          itemData.caches[l] = pathStringTransformed;
        } else {
          pathStringTransformed = itemData.caches[l];
        }

        itemData.styles[l].d += styleData.hd === true ? '' : pathStringTransformed;
        itemData.styles[l]._mdf = redraw || itemData.styles[l]._mdf;
      }
    }

    function renderFill(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;

      if (itemData.c._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('fill-opacity', itemData.o.v);
      }
    }

    function renderGradientStroke(styleData, itemData, isFirstFrame) {
      renderGradient(styleData, itemData, isFirstFrame);
      renderStroke(styleData, itemData, isFirstFrame);
    }

    function renderGradient(styleData, itemData, isFirstFrame) {
      var gfill = itemData.gf;
      var hasOpacity = itemData.g._hasOpacity;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;

      if (itemData.o._mdf || isFirstFrame) {
        var attr = styleData.ty === 'gf' ? 'fill-opacity' : 'stroke-opacity';
        itemData.style.pElem.setAttribute(attr, itemData.o.v);
      }

      if (itemData.s._mdf || isFirstFrame) {
        var attr1 = styleData.t === 1 ? 'x1' : 'cx';
        var attr2 = attr1 === 'x1' ? 'y1' : 'cy';
        gfill.setAttribute(attr1, pt1[0]);
        gfill.setAttribute(attr2, pt1[1]);

        if (hasOpacity && !itemData.g._collapsable) {
          itemData.of.setAttribute(attr1, pt1[0]);
          itemData.of.setAttribute(attr2, pt1[1]);
        }
      }

      var stops;
      var i;
      var len;
      var stop;

      if (itemData.g._cmdf || isFirstFrame) {
        stops = itemData.cst;
        var cValues = itemData.g.c;
        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];
          stop.setAttribute('offset', cValues[i * 4] + '%');
          stop.setAttribute('stop-color', 'rgb(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ')');
        }
      }

      if (hasOpacity && (itemData.g._omdf || isFirstFrame)) {
        var oValues = itemData.g.o;

        if (itemData.g._collapsable) {
          stops = itemData.cst;
        } else {
          stops = itemData.ost;
        }

        len = stops.length;

        for (i = 0; i < len; i += 1) {
          stop = stops[i];

          if (!itemData.g._collapsable) {
            stop.setAttribute('offset', oValues[i * 2] + '%');
          }

          stop.setAttribute('stop-opacity', oValues[i * 2 + 1]);
        }
      }

      if (styleData.t === 1) {
        if (itemData.e._mdf || isFirstFrame) {
          gfill.setAttribute('x2', pt2[0]);
          gfill.setAttribute('y2', pt2[1]);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('x2', pt2[0]);
            itemData.of.setAttribute('y2', pt2[1]);
          }
        }
      } else {
        var rad;

        if (itemData.s._mdf || itemData.e._mdf || isFirstFrame) {
          rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          gfill.setAttribute('r', rad);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('r', rad);
          }
        }

        if (itemData.e._mdf || itemData.h._mdf || itemData.a._mdf || isFirstFrame) {
          if (!rad) {
            rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
          }

          var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
          var percent = itemData.h.v;

          if (percent >= 1) {
            percent = 0.99;
          } else if (percent <= -1) {
            percent = -0.99;
          }

          var dist = rad * percent;
          var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
          var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
          gfill.setAttribute('fx', x);
          gfill.setAttribute('fy', y);

          if (hasOpacity && !itemData.g._collapsable) {
            itemData.of.setAttribute('fx', x);
            itemData.of.setAttribute('fy', y);
          }
        } // gfill.setAttribute('fy','200');

      }
    }

    function renderStroke(styleData, itemData, isFirstFrame) {
      var styleElem = itemData.style;
      var d = itemData.d;

      if (d && (d._mdf || isFirstFrame) && d.dashStr) {
        styleElem.pElem.setAttribute('stroke-dasharray', d.dashStr);
        styleElem.pElem.setAttribute('stroke-dashoffset', d.dashoffset[0]);
      }

      if (itemData.c && (itemData.c._mdf || isFirstFrame)) {
        styleElem.pElem.setAttribute('stroke', 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')');
      }

      if (itemData.o._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-opacity', itemData.o.v);
      }

      if (itemData.w._mdf || isFirstFrame) {
        styleElem.pElem.setAttribute('stroke-width', itemData.w.v);

        if (styleElem.msElem) {
          styleElem.msElem.setAttribute('stroke-width', itemData.w.v);
        }
      }
    }

    return ob;
  }();

  function SVGShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = []; // Full shape data

    this.shapesData = data.shapes; // List of styles that will be applied to shapes

    this.stylesList = []; // List of modifiers that will be applied to shapes

    this.shapeModifiers = []; // List of items in shape tree

    this.itemsData = []; // List of items in previous shape tree

    this.processedElements = []; // List of animated components

    this.animatedContents = [];
    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created

    this.prevViewData = []; // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableDOMElement], SVGShapeElement);

  SVGShapeElement.prototype.initSecondaryElement = function () {};

  SVGShapeElement.prototype.identityMatrix = new Matrix();

  SVGShapeElement.prototype.buildExpressionInterface = function () {};

  SVGShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
  };
  /*
  This method searches for multiple shapes that affect a single element and one of them is animated
  */


  SVGShapeElement.prototype.filterUniqueShapes = function () {
    var i;
    var len = this.shapes.length;
    var shape;
    var j;
    var jLen = this.stylesList.length;
    var style;
    var tempShapes = [];
    var areAnimated = false;

    for (j = 0; j < jLen; j += 1) {
      style = this.stylesList[j];
      areAnimated = false;
      tempShapes.length = 0;

      for (i = 0; i < len; i += 1) {
        shape = this.shapes[i];

        if (shape.styles.indexOf(style) !== -1) {
          tempShapes.push(shape);
          areAnimated = shape._isAnimated || areAnimated;
        }
      }

      if (tempShapes.length > 1 && areAnimated) {
        this.setShapesAsAnimated(tempShapes);
      }
    }
  };

  SVGShapeElement.prototype.setShapesAsAnimated = function (shapes) {
    var i;
    var len = shapes.length;

    for (i = 0; i < len; i += 1) {
      shapes[i].setAsAnimated();
    }
  };

  SVGShapeElement.prototype.createStyleElement = function (data, level) {
    // TODO: prevent drawing of hidden styles
    var elementData;
    var styleOb = new SVGStyleData(data, level);
    var pathElement = styleOb.pElem;

    if (data.ty === 'st') {
      elementData = new SVGStrokeStyleData(this, data, styleOb);
    } else if (data.ty === 'fl') {
      elementData = new SVGFillStyleData(this, data, styleOb);
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      var GradientConstructor = data.ty === 'gf' ? SVGGradientFillStyleData : SVGGradientStrokeStyleData;
      elementData = new GradientConstructor(this, data, styleOb);
      this.globalData.defs.appendChild(elementData.gf);

      if (elementData.maskId) {
        this.globalData.defs.appendChild(elementData.ms);
        this.globalData.defs.appendChild(elementData.of);
        pathElement.setAttribute('mask', 'url(' + getLocationHref() + '#' + elementData.maskId + ')');
      }
    } else if (data.ty === 'no') {
      elementData = new SVGNoStyleData(this, data, styleOb);
    }

    if (data.ty === 'st' || data.ty === 'gs') {
      pathElement.setAttribute('stroke-linecap', lineCapEnum[data.lc || 2]);
      pathElement.setAttribute('stroke-linejoin', lineJoinEnum[data.lj || 2]);
      pathElement.setAttribute('fill-opacity', '0');

      if (data.lj === 1) {
        pathElement.setAttribute('stroke-miterlimit', data.ml);
      }
    }

    if (data.r === 2) {
      pathElement.setAttribute('fill-rule', 'evenodd');
    }

    if (data.ln) {
      pathElement.setAttribute('id', data.ln);
    }

    if (data.cl) {
      pathElement.setAttribute('class', data.cl);
    }

    if (data.bm) {
      pathElement.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    this.stylesList.push(styleOb);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createGroupElement = function (data) {
    var elementData = new ShapeGroupData();

    if (data.ln) {
      elementData.gr.setAttribute('id', data.ln);
    }

    if (data.cl) {
      elementData.gr.setAttribute('class', data.cl);
    }

    if (data.bm) {
      elementData.gr.style['mix-blend-mode'] = getBlendMode(data.bm);
    }

    return elementData;
  };

  SVGShapeElement.prototype.createTransformElement = function (data, container) {
    var transformProperty = TransformPropertyFactory.getTransformProperty(this, data, this);
    var elementData = new SVGTransformData(transformProperty, transformProperty.o, container);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.createShapeElement = function (data, ownTransformers, level) {
    var ty = 4;

    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }

    var shapeProperty = ShapePropertyFactory.getShapeProp(this, data, ty, this);
    var elementData = new SVGShapeData(ownTransformers, level, shapeProperty);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    this.addToAnimatedContents(data, elementData);
    return elementData;
  };

  SVGShapeElement.prototype.addToAnimatedContents = function (data, element) {
    var i = 0;
    var len = this.animatedContents.length;

    while (i < len) {
      if (this.animatedContents[i].element === element) {
        return;
      }

      i += 1;
    }

    this.animatedContents.push({
      fn: SVGElementsRenderer.createRenderFunction(data),
      element: element,
      data: data
    });
  };

  SVGShapeElement.prototype.setElementStyles = function (elementData) {
    var arr = elementData.styles;
    var j;
    var jLen = this.stylesList.length;

    for (j = 0; j < jLen; j += 1) {
      if (!this.stylesList[j].closed) {
        arr.push(this.stylesList[j]);
      }
    }
  };

  SVGShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;

    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.layerElement, 0, [], true);
    this.filterUniqueShapes();
    len = this.dynamicProperties.length;

    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }

    this.renderModifiers();
  };

  SVGShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, container, level, transformers, render) {
    var ownTransformers = [].concat(transformers);
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var currentTransform;
    var modifier;
    var processedPos;

    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);

      if (!processedPos) {
        arr[i]._render = render;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }

      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs' || arr[i].ty === 'no') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], level);
        } else {
          itemsData[i].style.closed = false;
        }

        if (arr[i]._render) {
          if (itemsData[i].style.pElem.parentNode !== container) {
            container.appendChild(itemsData[i].style.pElem);
          }
        }

        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;

          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }

        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, itemsData[i].gr, level + 1, ownTransformers, render);

        if (arr[i]._render) {
          if (itemsData[i].gr.parentNode !== container) {
            container.appendChild(itemsData[i].gr);
          }
        }
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          itemsData[i] = this.createTransformElement(arr[i], container);
        }

        currentTransform = itemsData[i].transform;
        ownTransformers.push(currentTransform);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i], ownTransformers, level);
        }

        this.setElementStyles(itemsData[i]);
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'ms' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }

        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          render = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }

        ownModifiers.push(modifier);
      }

      this.addProcessedElement(arr[i], i + 1);
    }

    len = ownStyles.length;

    for (i = 0; i < len; i += 1) {
      ownStyles[i].closed = true;
    }

    len = ownModifiers.length;

    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };

  SVGShapeElement.prototype.renderInnerContent = function () {
    this.renderModifiers();
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      this.stylesList[i].reset();
    }

    this.renderShape();

    for (i = 0; i < len; i += 1) {
      if (this.stylesList[i]._mdf || this._isFirstFrame) {
        if (this.stylesList[i].msElem) {
          this.stylesList[i].msElem.setAttribute('d', this.stylesList[i].d); // Adding M0 0 fixes same mask bug on all browsers

          this.stylesList[i].d = 'M0 0' + this.stylesList[i].d;
        }

        this.stylesList[i].pElem.setAttribute('d', this.stylesList[i].d || 'M0 0');
      }
    }
  };

  SVGShapeElement.prototype.renderShape = function () {
    var i;
    var len = this.animatedContents.length;
    var animatedContent;

    for (i = 0; i < len; i += 1) {
      animatedContent = this.animatedContents[i];

      if ((this._isFirstFrame || animatedContent.element._isAnimated) && animatedContent.data !== true) {
        animatedContent.fn(animatedContent.data, animatedContent.element, this._isFirstFrame);
      }
    }
  };

  SVGShapeElement.prototype.destroy = function () {
    this.destroyBaseElement();
    this.shapesData = null;
    this.itemsData = null;
  };

  function LetterProps(o, sw, sc, fc, m, p) {
    this.o = o;
    this.sw = sw;
    this.sc = sc;
    this.fc = fc;
    this.m = m;
    this.p = p;
    this._mdf = {
      o: true,
      sw: !!sw,
      sc: !!sc,
      fc: !!fc,
      m: true,
      p: true
    };
  }

  LetterProps.prototype.update = function (o, sw, sc, fc, m, p) {
    this._mdf.o = false;
    this._mdf.sw = false;
    this._mdf.sc = false;
    this._mdf.fc = false;
    this._mdf.m = false;
    this._mdf.p = false;
    var updated = false;

    if (this.o !== o) {
      this.o = o;
      this._mdf.o = true;
      updated = true;
    }

    if (this.sw !== sw) {
      this.sw = sw;
      this._mdf.sw = true;
      updated = true;
    }

    if (this.sc !== sc) {
      this.sc = sc;
      this._mdf.sc = true;
      updated = true;
    }

    if (this.fc !== fc) {
      this.fc = fc;
      this._mdf.fc = true;
      updated = true;
    }

    if (this.m !== m) {
      this.m = m;
      this._mdf.m = true;
      updated = true;
    }

    if (p.length && (this.p[0] !== p[0] || this.p[1] !== p[1] || this.p[4] !== p[4] || this.p[5] !== p[5] || this.p[12] !== p[12] || this.p[13] !== p[13])) {
      this.p = p;
      this._mdf.p = true;
      updated = true;
    }

    return updated;
  };

  function TextProperty(elem, data) {
    this._frameId = initialDefaultFrame;
    this.pv = '';
    this.v = '';
    this.kf = false;
    this._isFirstFrame = true;
    this._mdf = false;

    if (data.d && data.d.sid) {
      data.d = elem.globalData.slotManager.getProp(data.d);
    }

    this.data = data;
    this.elem = elem;
    this.comp = this.elem.comp;
    this.keysIndex = 0;
    this.canResize = false;
    this.minimumFontSize = 1;
    this.effectsSequence = [];
    this.currentData = {
      ascent: 0,
      boxWidth: this.defaultBoxWidth,
      f: '',
      fStyle: '',
      fWeight: '',
      fc: '',
      j: '',
      justifyOffset: '',
      l: [],
      lh: 0,
      lineWidths: [],
      ls: '',
      of: '',
      s: '',
      sc: '',
      sw: 0,
      t: 0,
      tr: 0,
      sz: 0,
      ps: null,
      fillColorAnim: false,
      strokeColorAnim: false,
      strokeWidthAnim: false,
      yOffset: 0,
      finalSize: 0,
      finalText: [],
      finalLineHeight: 0,
      __complete: false
    };
    this.copyData(this.currentData, this.data.d.k[0].s);

    if (!this.searchProperty()) {
      this.completeTextData(this.currentData);
    }
  }

  TextProperty.prototype.defaultBoxWidth = [0, 0];

  TextProperty.prototype.copyData = function (obj, data) {
    for (var s in data) {
      if (Object.prototype.hasOwnProperty.call(data, s)) {
        obj[s] = data[s];
      }
    }

    return obj;
  };

  TextProperty.prototype.setCurrentData = function (data) {
    if (!data.__complete) {
      this.completeTextData(data);
    }

    this.currentData = data;
    this.currentData.boxWidth = this.currentData.boxWidth || this.defaultBoxWidth;
    this._mdf = true;
  };

  TextProperty.prototype.searchProperty = function () {
    return this.searchKeyframes();
  };

  TextProperty.prototype.searchKeyframes = function () {
    this.kf = this.data.d.k.length > 1;

    if (this.kf) {
      this.addEffect(this.getKeyframeValue.bind(this));
    }

    return this.kf;
  };

  TextProperty.prototype.addEffect = function (effectFunction) {
    this.effectsSequence.push(effectFunction);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.getValue = function (_finalValue) {
    if ((this.elem.globalData.frameId === this.frameId || !this.effectsSequence.length) && !_finalValue) {
      return;
    }

    this.currentData.t = this.data.d.k[this.keysIndex].s.t;
    var currentValue = this.currentData;
    var currentIndex = this.keysIndex;

    if (this.lock) {
      this.setCurrentData(this.currentData);
      return;
    }

    this.lock = true;
    this._mdf = false;
    var i;
    var len = this.effectsSequence.length;
    var finalValue = _finalValue || this.data.d.k[this.keysIndex].s;

    for (i = 0; i < len; i += 1) {
      // Checking if index changed to prevent creating a new object every time the expression updates.
      if (currentIndex !== this.keysIndex) {
        finalValue = this.effectsSequence[i](finalValue, finalValue.t);
      } else {
        finalValue = this.effectsSequence[i](this.currentData, finalValue.t);
      }
    }

    if (currentValue !== finalValue) {
      this.setCurrentData(finalValue);
    }

    this.v = this.currentData;
    this.pv = this.v;
    this.lock = false;
    this.frameId = this.elem.globalData.frameId;
  };

  TextProperty.prototype.getKeyframeValue = function () {
    var textKeys = this.data.d.k;
    var frameNum = this.elem.comp.renderedFrame;
    var i = 0;
    var len = textKeys.length;

    while (i <= len - 1) {
      if (i === len - 1 || textKeys[i + 1].t > frameNum) {
        break;
      }

      i += 1;
    }

    if (this.keysIndex !== i) {
      this.keysIndex = i;
    }

    return this.data.d.k[this.keysIndex].s;
  };

  TextProperty.prototype.buildFinalText = function (text) {
    var charactersArray = [];
    var i = 0;
    var len = text.length;
    var charCode;
    var secondCharCode;
    var shouldCombine = false;
    var shouldCombineNext = false;
    var currentChars = '';

    while (i < len) {
      shouldCombine = shouldCombineNext;
      shouldCombineNext = false;
      charCode = text.charCodeAt(i);
      currentChars = text.charAt(i);

      if (FontManager.isCombinedCharacter(charCode)) {
        shouldCombine = true; // It's a potential surrogate pair (this is the High surrogate)
      } else if (charCode >= 0xD800 && charCode <= 0xDBFF) {
        if (FontManager.isRegionalFlag(text, i)) {
          currentChars = text.substr(i, 14);
        } else {
          secondCharCode = text.charCodeAt(i + 1); // It's a surrogate pair (this is the Low surrogate)

          if (secondCharCode >= 0xDC00 && secondCharCode <= 0xDFFF) {
            if (FontManager.isModifier(charCode, secondCharCode)) {
              currentChars = text.substr(i, 2);
              shouldCombine = true;
            } else if (FontManager.isFlagEmoji(text.substr(i, 4))) {
              currentChars = text.substr(i, 4);
            } else {
              currentChars = text.substr(i, 2);
            }
          }
        }
      } else if (charCode > 0xDBFF) {
        secondCharCode = text.charCodeAt(i + 1);

        if (FontManager.isVariationSelector(charCode)) {
          shouldCombine = true;
        }
      } else if (FontManager.isZeroWidthJoiner(charCode)) {
        shouldCombine = true;
        shouldCombineNext = true;
      }

      if (shouldCombine) {
        charactersArray[charactersArray.length - 1] += currentChars;
        shouldCombine = false;
      } else {
        charactersArray.push(currentChars);
      }

      i += currentChars.length;
    }

    return charactersArray;
  };

  TextProperty.prototype.completeTextData = function (documentData) {
    documentData.__complete = true;
    var fontManager = this.elem.globalData.fontManager;
    var data = this.data;
    var letters = [];
    var i;
    var len;
    var newLineFlag;
    var index = 0;
    var val;
    var anchorGrouping = data.m.g;
    var currentSize = 0;
    var currentPos = 0;
    var currentLine = 0;
    var lineWidths = [];
    var lineWidth = 0;
    var maxLineWidth = 0;
    var j;
    var jLen;
    var fontData = fontManager.getFontByName(documentData.f);
    var charData;
    var cLength = 0;
    var fontProps = getFontProperties(fontData);
    documentData.fWeight = fontProps.weight;
    documentData.fStyle = fontProps.style;
    documentData.finalSize = documentData.s;
    documentData.finalText = this.buildFinalText(documentData.t);
    len = documentData.finalText.length;
    documentData.finalLineHeight = documentData.lh;
    var trackingOffset = documentData.tr / 1000 * documentData.finalSize;
    var charCode;

    if (documentData.sz) {
      var flag = true;
      var boxWidth = documentData.sz[0];
      var boxHeight = documentData.sz[1];
      var currentHeight;
      var finalText;

      while (flag) {
        finalText = this.buildFinalText(documentData.t);
        currentHeight = 0;
        lineWidth = 0;
        len = finalText.length;
        trackingOffset = documentData.tr / 1000 * documentData.finalSize;
        var lastSpaceIndex = -1;

        for (i = 0; i < len; i += 1) {
          charCode = finalText[i].charCodeAt(0);
          newLineFlag = false;

          if (finalText[i] === ' ') {
            lastSpaceIndex = i;
          } else if (charCode === 13 || charCode === 3) {
            lineWidth = 0;
            newLineFlag = true;
            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
          }

          if (fontManager.chars) {
            charData = fontManager.getCharData(finalText[i], fontData.fStyle, fontData.fFamily);
            cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
          } else {
            // tCanvasHelper.font = documentData.s + 'px '+ fontData.fFamily;
            cLength = fontManager.measureText(finalText[i], documentData.f, documentData.finalSize);
          }

          if (lineWidth + cLength > boxWidth && finalText[i] !== ' ') {
            if (lastSpaceIndex === -1) {
              len += 1;
            } else {
              i = lastSpaceIndex;
            }

            currentHeight += documentData.finalLineHeight || documentData.finalSize * 1.2;
            finalText.splice(i, lastSpaceIndex === i ? 1 : 0, '\r'); // finalText = finalText.substr(0,i) + "\r" + finalText.substr(i === lastSpaceIndex ? i + 1 : i);

            lastSpaceIndex = -1;
            lineWidth = 0;
          } else {
            lineWidth += cLength;
            lineWidth += trackingOffset;
          }
        }

        currentHeight += fontData.ascent * documentData.finalSize / 100;

        if (this.canResize && documentData.finalSize > this.minimumFontSize && boxHeight < currentHeight) {
          documentData.finalSize -= 1;
          documentData.finalLineHeight = documentData.finalSize * documentData.lh / documentData.s;
        } else {
          documentData.finalText = finalText;
          len = documentData.finalText.length;
          flag = false;
        }
      }
    }

    lineWidth = -trackingOffset;
    cLength = 0;
    var uncollapsedSpaces = 0;
    var currentChar;

    for (i = 0; i < len; i += 1) {
      newLineFlag = false;
      currentChar = documentData.finalText[i];
      charCode = currentChar.charCodeAt(0);

      if (charCode === 13 || charCode === 3) {
        uncollapsedSpaces = 0;
        lineWidths.push(lineWidth);
        maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
        lineWidth = -2 * trackingOffset;
        val = '';
        newLineFlag = true;
        currentLine += 1;
      } else {
        val = currentChar;
      }

      if (fontManager.chars) {
        charData = fontManager.getCharData(currentChar, fontData.fStyle, fontManager.getFontByName(documentData.f).fFamily);
        cLength = newLineFlag ? 0 : charData.w * documentData.finalSize / 100;
      } else {
        // var charWidth = fontManager.measureText(val, documentData.f, documentData.finalSize);
        // tCanvasHelper.font = documentData.finalSize + 'px '+ fontManager.getFontByName(documentData.f).fFamily;
        cLength = fontManager.measureText(val, documentData.f, documentData.finalSize);
      } //


      if (currentChar === ' ') {
        uncollapsedSpaces += cLength + trackingOffset;
      } else {
        lineWidth += cLength + trackingOffset + uncollapsedSpaces;
        uncollapsedSpaces = 0;
      }

      letters.push({
        l: cLength,
        an: cLength,
        add: currentSize,
        n: newLineFlag,
        anIndexes: [],
        val: val,
        line: currentLine,
        animatorJustifyOffset: 0
      });

      if (anchorGrouping == 2) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || val === ' ' || i === len - 1) {
          if (val === '' || val === ' ') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          index += 1;
          currentSize = 0;
        }
      } else if (anchorGrouping == 3) {
        // eslint-disable-line eqeqeq
        currentSize += cLength;

        if (val === '' || i === len - 1) {
          if (val === '') {
            currentSize -= cLength;
          }

          while (currentPos <= i) {
            letters[currentPos].an = currentSize;
            letters[currentPos].ind = index;
            letters[currentPos].extra = cLength;
            currentPos += 1;
          }

          currentSize = 0;
          index += 1;
        }
      } else {
        letters[index].ind = index;
        letters[index].extra = 0;
        index += 1;
      }
    }

    documentData.l = letters;
    maxLineWidth = lineWidth > maxLineWidth ? lineWidth : maxLineWidth;
    lineWidths.push(lineWidth);

    if (documentData.sz) {
      documentData.boxWidth = documentData.sz[0];
      documentData.justifyOffset = 0;
    } else {
      documentData.boxWidth = maxLineWidth;

      switch (documentData.j) {
        case 1:
          documentData.justifyOffset = -documentData.boxWidth;
          break;

        case 2:
          documentData.justifyOffset = -documentData.boxWidth / 2;
          break;

        default:
          documentData.justifyOffset = 0;
      }
    }

    documentData.lineWidths = lineWidths;
    var animators = data.a;
    var animatorData;
    var letterData;
    jLen = animators.length;
    var based;
    var ind;
    var indexes = [];

    for (j = 0; j < jLen; j += 1) {
      animatorData = animators[j];

      if (animatorData.a.sc) {
        documentData.strokeColorAnim = true;
      }

      if (animatorData.a.sw) {
        documentData.strokeWidthAnim = true;
      }

      if (animatorData.a.fc || animatorData.a.fh || animatorData.a.fs || animatorData.a.fb) {
        documentData.fillColorAnim = true;
      }

      ind = 0;
      based = animatorData.s.b;

      for (i = 0; i < len; i += 1) {
        letterData = letters[i];
        letterData.anIndexes[j] = ind;

        if (based == 1 && letterData.val !== '' || based == 2 && letterData.val !== '' && letterData.val !== ' ' || based == 3 && (letterData.n || letterData.val == ' ' || i == len - 1) || based == 4 && (letterData.n || i == len - 1)) {
          // eslint-disable-line eqeqeq
          if (animatorData.s.rn === 1) {
            indexes.push(ind);
          }

          ind += 1;
        }
      }

      data.a[j].s.totalChars = ind;
      var currentInd = -1;
      var newInd;

      if (animatorData.s.rn === 1) {
        for (i = 0; i < len; i += 1) {
          letterData = letters[i];

          if (currentInd != letterData.anIndexes[j]) {
            // eslint-disable-line eqeqeq
            currentInd = letterData.anIndexes[j];
            newInd = indexes.splice(Math.floor(Math.random() * indexes.length), 1)[0];
          }

          letterData.anIndexes[j] = newInd;
        }
      }
    }

    documentData.yOffset = documentData.finalLineHeight || documentData.finalSize * 1.2;
    documentData.ls = documentData.ls || 0;
    documentData.ascent = fontData.ascent * documentData.finalSize / 100;
  };

  TextProperty.prototype.updateDocumentData = function (newData, index) {
    index = index === undefined ? this.keysIndex : index;
    var dData = this.copyData({}, this.data.d.k[index].s);
    dData = this.copyData(dData, newData);
    this.data.d.k[index].s = dData;
    this.recalculate(index);
    this.setCurrentData(dData);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.recalculate = function (index) {
    var dData = this.data.d.k[index].s;
    dData.__complete = false;
    this.keysIndex = 0;
    this._isFirstFrame = true;
    this.getValue(dData);
  };

  TextProperty.prototype.canResizeFont = function (_canResize) {
    this.canResize = _canResize;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  TextProperty.prototype.setMinimumFontSize = function (_fontValue) {
    this.minimumFontSize = Math.floor(_fontValue) || 1;
    this.recalculate(this.keysIndex);
    this.elem.addDynamicProperty(this);
  };

  var TextSelectorProp = function () {
    var max = Math.max;
    var min = Math.min;
    var floor = Math.floor;

    function TextSelectorPropFactory(elem, data) {
      this._currentTextLength = -1;
      this.k = false;
      this.data = data;
      this.elem = elem;
      this.comp = elem.comp;
      this.finalS = 0;
      this.finalE = 0;
      this.initDynamicPropertyContainer(elem);
      this.s = PropertyFactory.getProp(elem, data.s || {
        k: 0
      }, 0, 0, this);

      if ('e' in data) {
        this.e = PropertyFactory.getProp(elem, data.e, 0, 0, this);
      } else {
        this.e = {
          v: 100
        };
      }

      this.o = PropertyFactory.getProp(elem, data.o || {
        k: 0
      }, 0, 0, this);
      this.xe = PropertyFactory.getProp(elem, data.xe || {
        k: 0
      }, 0, 0, this);
      this.ne = PropertyFactory.getProp(elem, data.ne || {
        k: 0
      }, 0, 0, this);
      this.sm = PropertyFactory.getProp(elem, data.sm || {
        k: 100
      }, 0, 0, this);
      this.a = PropertyFactory.getProp(elem, data.a, 0, 0.01, this);

      if (!this.dynamicProperties.length) {
        this.getValue();
      }
    }

    TextSelectorPropFactory.prototype = {
      getMult: function getMult(ind) {
        if (this._currentTextLength !== this.elem.textProperty.currentData.l.length) {
          this.getValue();
        }

        var x1 = 0;
        var y1 = 0;
        var x2 = 1;
        var y2 = 1;

        if (this.ne.v > 0) {
          x1 = this.ne.v / 100.0;
        } else {
          y1 = -this.ne.v / 100.0;
        }

        if (this.xe.v > 0) {
          x2 = 1.0 - this.xe.v / 100.0;
        } else {
          y2 = 1.0 + this.xe.v / 100.0;
        }

        var easer = BezierFactory.getBezierEasing(x1, y1, x2, y2).get;
        var mult = 0;
        var s = this.finalS;
        var e = this.finalE;
        var type = this.data.sh;

        if (type === 2) {
          if (e === s) {
            mult = ind >= e ? 1 : 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 3) {
          if (e === s) {
            mult = ind >= e ? 0 : 1;
          } else {
            mult = 1 - max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));
          }

          mult = easer(mult);
        } else if (type === 4) {
          if (e === s) {
            mult = 0;
          } else {
            mult = max(0, min(0.5 / (e - s) + (ind - s) / (e - s), 1));

            if (mult < 0.5) {
              mult *= 2;
            } else {
              mult = 1 - 2 * (mult - 0.5);
            }
          }

          mult = easer(mult);
        } else if (type === 5) {
          if (e === s) {
            mult = 0;
          } else {
            var tot = e - s;
            /* ind += 0.5;
                      mult = -4/(tot*tot)*(ind*ind)+(4/tot)*ind; */

            ind = min(max(0, ind + 0.5 - s), e - s);
            var x = -tot / 2 + ind;
            var a = tot / 2;
            mult = Math.sqrt(1 - x * x / (a * a));
          }

          mult = easer(mult);
        } else if (type === 6) {
          if (e === s) {
            mult = 0;
          } else {
            ind = min(max(0, ind + 0.5 - s), e - s);
            mult = (1 + Math.cos(Math.PI + Math.PI * 2 * ind / (e - s))) / 2; // eslint-disable-line
          }

          mult = easer(mult);
        } else {
          if (ind >= floor(s)) {
            if (ind - s < 0) {
              mult = max(0, min(min(e, 1) - (s - ind), 1));
            } else {
              mult = max(0, min(e - ind, 1));
            }
          }

          mult = easer(mult);
        } // Smoothness implementation.
        // The smoothness represents a reduced range of the original [0; 1] range.
        // if smoothness is 25%, the new range will be [0.375; 0.625]
        // Steps are:
        // - find the lower value of the new range (threshold)
        // - if multiplier is smaller than that value, floor it to 0
        // - if it is larger,
        //     - subtract the threshold
        //     - divide it by the smoothness (this will return the range to [0; 1])
        // Note: If it doesn't work on some scenarios, consider applying it before the easer.


        if (this.sm.v !== 100) {
          var smoothness = this.sm.v * 0.01;

          if (smoothness === 0) {
            smoothness = 0.00000001;
          }

          var threshold = 0.5 - smoothness * 0.5;

          if (mult < threshold) {
            mult = 0;
          } else {
            mult = (mult - threshold) / smoothness;

            if (mult > 1) {
              mult = 1;
            }
          }
        }

        return mult * this.a.v;
      },
      getValue: function getValue(newCharsFlag) {
        this.iterateDynamicProperties();
        this._mdf = newCharsFlag || this._mdf;
        this._currentTextLength = this.elem.textProperty.currentData.l.length || 0;

        if (newCharsFlag && this.data.r === 2) {
          this.e.v = this._currentTextLength;
        }

        var divisor = this.data.r === 2 ? 1 : 100 / this.data.totalChars;
        var o = this.o.v / divisor;
        var s = this.s.v / divisor + o;
        var e = this.e.v / divisor + o;

        if (s > e) {
          var _s = s;
          s = e;
          e = _s;
        }

        this.finalS = s;
        this.finalE = e;
      }
    };
    extendPrototype([DynamicPropertyContainer], TextSelectorPropFactory);

    function getTextSelectorProp(elem, data, arr) {
      return new TextSelectorPropFactory(elem, data, arr);
    }

    return {
      getTextSelectorProp: getTextSelectorProp
    };
  }();

  function TextAnimatorDataProperty(elem, animatorProps, container) {
    var defaultData = {
      propType: false
    };
    var getProp = PropertyFactory.getProp;
    var textAnimatorAnimatables = animatorProps.a;
    this.a = {
      r: textAnimatorAnimatables.r ? getProp(elem, textAnimatorAnimatables.r, 0, degToRads, container) : defaultData,
      rx: textAnimatorAnimatables.rx ? getProp(elem, textAnimatorAnimatables.rx, 0, degToRads, container) : defaultData,
      ry: textAnimatorAnimatables.ry ? getProp(elem, textAnimatorAnimatables.ry, 0, degToRads, container) : defaultData,
      sk: textAnimatorAnimatables.sk ? getProp(elem, textAnimatorAnimatables.sk, 0, degToRads, container) : defaultData,
      sa: textAnimatorAnimatables.sa ? getProp(elem, textAnimatorAnimatables.sa, 0, degToRads, container) : defaultData,
      s: textAnimatorAnimatables.s ? getProp(elem, textAnimatorAnimatables.s, 1, 0.01, container) : defaultData,
      a: textAnimatorAnimatables.a ? getProp(elem, textAnimatorAnimatables.a, 1, 0, container) : defaultData,
      o: textAnimatorAnimatables.o ? getProp(elem, textAnimatorAnimatables.o, 0, 0.01, container) : defaultData,
      p: textAnimatorAnimatables.p ? getProp(elem, textAnimatorAnimatables.p, 1, 0, container) : defaultData,
      sw: textAnimatorAnimatables.sw ? getProp(elem, textAnimatorAnimatables.sw, 0, 0, container) : defaultData,
      sc: textAnimatorAnimatables.sc ? getProp(elem, textAnimatorAnimatables.sc, 1, 0, container) : defaultData,
      fc: textAnimatorAnimatables.fc ? getProp(elem, textAnimatorAnimatables.fc, 1, 0, container) : defaultData,
      fh: textAnimatorAnimatables.fh ? getProp(elem, textAnimatorAnimatables.fh, 0, 0, container) : defaultData,
      fs: textAnimatorAnimatables.fs ? getProp(elem, textAnimatorAnimatables.fs, 0, 0.01, container) : defaultData,
      fb: textAnimatorAnimatables.fb ? getProp(elem, textAnimatorAnimatables.fb, 0, 0.01, container) : defaultData,
      t: textAnimatorAnimatables.t ? getProp(elem, textAnimatorAnimatables.t, 0, 0, container) : defaultData
    };
    this.s = TextSelectorProp.getTextSelectorProp(elem, animatorProps.s, container);
    this.s.t = animatorProps.s.t;
  }

  function TextAnimatorProperty(textData, renderType, elem) {
    this._isFirstFrame = true;
    this._hasMaskedPath = false;
    this._frameId = -1;
    this._textData = textData;
    this._renderType = renderType;
    this._elem = elem;
    this._animatorsData = createSizedArray(this._textData.a.length);
    this._pathData = {};
    this._moreOptions = {
      alignment: {}
    };
    this.renderedLetters = [];
    this.lettersChangedFlag = false;
    this.initDynamicPropertyContainer(elem);
  }

  TextAnimatorProperty.prototype.searchProperties = function () {
    var i;
    var len = this._textData.a.length;
    var animatorProps;
    var getProp = PropertyFactory.getProp;

    for (i = 0; i < len; i += 1) {
      animatorProps = this._textData.a[i];
      this._animatorsData[i] = new TextAnimatorDataProperty(this._elem, animatorProps, this);
    }

    if (this._textData.p && 'm' in this._textData.p) {
      this._pathData = {
        a: getProp(this._elem, this._textData.p.a, 0, 0, this),
        f: getProp(this._elem, this._textData.p.f, 0, 0, this),
        l: getProp(this._elem, this._textData.p.l, 0, 0, this),
        r: getProp(this._elem, this._textData.p.r, 0, 0, this),
        p: getProp(this._elem, this._textData.p.p, 0, 0, this),
        m: this._elem.maskManager.getMaskProperty(this._textData.p.m)
      };
      this._hasMaskedPath = true;
    } else {
      this._hasMaskedPath = false;
    }

    this._moreOptions.alignment = getProp(this._elem, this._textData.m.a, 1, 0, this);
  };

  TextAnimatorProperty.prototype.getMeasures = function (documentData, lettersChangedFlag) {
    this.lettersChangedFlag = lettersChangedFlag;

    if (!this._mdf && !this._isFirstFrame && !lettersChangedFlag && (!this._hasMaskedPath || !this._pathData.m._mdf)) {
      return;
    }

    this._isFirstFrame = false;
    var alignment = this._moreOptions.alignment.v;
    var animators = this._animatorsData;
    var textData = this._textData;
    var matrixHelper = this.mHelper;
    var renderType = this._renderType;
    var renderedLettersCount = this.renderedLetters.length;
    var xPos;
    var yPos;
    var i;
    var len;
    var letters = documentData.l;
    var pathInfo;
    var currentLength;
    var currentPoint;
    var segmentLength;
    var flag;
    var pointInd;
    var segmentInd;
    var prevPoint;
    var points;
    var segments;
    var partialLength;
    var totalLength;
    var perc;
    var tanAngle;
    var mask;

    if (this._hasMaskedPath) {
      mask = this._pathData.m;

      if (!this._pathData.n || this._pathData._mdf) {
        var paths = mask.v;

        if (this._pathData.r.v) {
          paths = paths.reverse();
        } // TODO: release bezier data cached from previous pathInfo: this._pathData.pi


        pathInfo = {
          tLength: 0,
          segments: []
        };
        len = paths._length - 1;
        var bezierData;
        totalLength = 0;

        for (i = 0; i < len; i += 1) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[i + 1], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[i + 1][0] - paths.v[i + 1][0], paths.i[i + 1][1] - paths.v[i + 1][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        i = len;

        if (mask.v.c) {
          bezierData = bez.buildBezierData(paths.v[i], paths.v[0], [paths.o[i][0] - paths.v[i][0], paths.o[i][1] - paths.v[i][1]], [paths.i[0][0] - paths.v[0][0], paths.i[0][1] - paths.v[0][1]]);
          pathInfo.tLength += bezierData.segmentLength;
          pathInfo.segments.push(bezierData);
          totalLength += bezierData.segmentLength;
        }

        this._pathData.pi = pathInfo;
      }

      pathInfo = this._pathData.pi;
      currentLength = this._pathData.f.v;
      segmentInd = 0;
      pointInd = 1;
      segmentLength = 0;
      flag = true;
      segments = pathInfo.segments;

      if (currentLength < 0 && mask.v.c) {
        if (pathInfo.tLength < Math.abs(currentLength)) {
          currentLength = -Math.abs(currentLength) % pathInfo.tLength;
        }

        segmentInd = segments.length - 1;
        points = segments[segmentInd].points;
        pointInd = points.length - 1;

        while (currentLength < 0) {
          currentLength += points[pointInd].partialLength;
          pointInd -= 1;

          if (pointInd < 0) {
            segmentInd -= 1;
            points = segments[segmentInd].points;
            pointInd = points.length - 1;
          }
        }
      }

      points = segments[segmentInd].points;
      prevPoint = points[pointInd - 1];
      currentPoint = points[pointInd];
      partialLength = currentPoint.partialLength;
    }

    len = letters.length;
    xPos = 0;
    yPos = 0;
    var yOff = documentData.finalSize * 1.2 * 0.714;
    var firstLine = true;
    var animatorProps;
    var animatorSelector;
    var j;
    var jLen;
    var letterValue;
    jLen = animators.length;
    var mult;
    var ind = -1;
    var offf;
    var xPathPos;
    var yPathPos;
    var initPathPos = currentLength;
    var initSegmentInd = segmentInd;
    var initPointInd = pointInd;
    var currentLine = -1;
    var elemOpacity;
    var sc;
    var sw;
    var fc;
    var k;
    var letterSw;
    var letterSc;
    var letterFc;
    var letterM = '';
    var letterP = this.defaultPropsArray;
    var letterO; //

    if (documentData.j === 2 || documentData.j === 1) {
      var animatorJustifyOffset = 0;
      var animatorFirstCharOffset = 0;
      var justifyOffsetMult = documentData.j === 2 ? -0.5 : -1;
      var lastIndex = 0;
      var isNewLine = true;

      for (i = 0; i < len; i += 1) {
        if (letters[i].n) {
          if (animatorJustifyOffset) {
            animatorJustifyOffset += animatorFirstCharOffset;
          }

          while (lastIndex < i) {
            letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
            lastIndex += 1;
          }

          animatorJustifyOffset = 0;
          isNewLine = true;
        } else {
          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.t.propType) {
              if (isNewLine && documentData.j === 2) {
                animatorFirstCharOffset += animatorProps.t.v * justifyOffsetMult;
              }

              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorJustifyOffset += animatorProps.t.v * mult[0] * justifyOffsetMult;
              } else {
                animatorJustifyOffset += animatorProps.t.v * mult * justifyOffsetMult;
              }
            }
          }

          isNewLine = false;
        }
      }

      if (animatorJustifyOffset) {
        animatorJustifyOffset += animatorFirstCharOffset;
      }

      while (lastIndex < i) {
        letters[lastIndex].animatorJustifyOffset = animatorJustifyOffset;
        lastIndex += 1;
      }
    } //


    for (i = 0; i < len; i += 1) {
      matrixHelper.reset();
      elemOpacity = 1;

      if (letters[i].n) {
        xPos = 0;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        currentLength = initPathPos;
        firstLine = false;

        if (this._hasMaskedPath) {
          segmentInd = initSegmentInd;
          pointInd = initPointInd;
          points = segments[segmentInd].points;
          prevPoint = points[pointInd - 1];
          currentPoint = points[pointInd];
          partialLength = currentPoint.partialLength;
          segmentLength = 0;
        }

        letterM = '';
        letterFc = '';
        letterSw = '';
        letterO = '';
        letterP = this.defaultPropsArray;
      } else {
        if (this._hasMaskedPath) {
          if (currentLine !== letters[i].line) {
            switch (documentData.j) {
              case 1:
                currentLength += totalLength - documentData.lineWidths[letters[i].line];
                break;

              case 2:
                currentLength += (totalLength - documentData.lineWidths[letters[i].line]) / 2;
                break;

              default:
                break;
            }

            currentLine = letters[i].line;
          }

          if (ind !== letters[i].ind) {
            if (letters[ind]) {
              currentLength += letters[ind].extra;
            }

            currentLength += letters[i].an / 2;
            ind = letters[i].ind;
          }

          currentLength += alignment[0] * letters[i].an * 0.005;
          var animatorOffset = 0;

          for (j = 0; j < jLen; j += 1) {
            animatorProps = animators[j].a;

            if (animatorProps.p.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.p.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.p.v[0] * mult;
              }
            }

            if (animatorProps.a.propType) {
              animatorSelector = animators[j].s;
              mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

              if (mult.length) {
                animatorOffset += animatorProps.a.v[0] * mult[0];
              } else {
                animatorOffset += animatorProps.a.v[0] * mult;
              }
            }
          }

          flag = true; // Force alignment only works with a single line for now

          if (this._pathData.a.v) {
            currentLength = letters[0].an * 0.5 + (totalLength - this._pathData.f.v - letters[0].an * 0.5 - letters[letters.length - 1].an * 0.5) * ind / (len - 1);
            currentLength += this._pathData.f.v;
          }

          while (flag) {
            if (segmentLength + partialLength >= currentLength + animatorOffset || !points) {
              perc = (currentLength + animatorOffset - segmentLength) / currentPoint.partialLength;
              xPathPos = prevPoint.point[0] + (currentPoint.point[0] - prevPoint.point[0]) * perc;
              yPathPos = prevPoint.point[1] + (currentPoint.point[1] - prevPoint.point[1]) * perc;
              matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -(alignment[1] * yOff) * 0.01);
              flag = false;
            } else if (points) {
              segmentLength += currentPoint.partialLength;
              pointInd += 1;

              if (pointInd >= points.length) {
                pointInd = 0;
                segmentInd += 1;

                if (!segments[segmentInd]) {
                  if (mask.v.c) {
                    pointInd = 0;
                    segmentInd = 0;
                    points = segments[segmentInd].points;
                  } else {
                    segmentLength -= currentPoint.partialLength;
                    points = null;
                  }
                } else {
                  points = segments[segmentInd].points;
                }
              }

              if (points) {
                prevPoint = currentPoint;
                currentPoint = points[pointInd];
                partialLength = currentPoint.partialLength;
              }
            }
          }

          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0);
        } else {
          offf = letters[i].an / 2 - letters[i].add;
          matrixHelper.translate(-offf, 0, 0); // Grouping alignment

          matrixHelper.translate(-alignment[0] * letters[i].an * 0.005, -alignment[1] * yOff * 0.01, 0);
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.t.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars); // This condition is to prevent applying tracking to first character in each line. Might be better to use a boolean "isNewLine"

            if (xPos !== 0 || documentData.j !== 0) {
              if (this._hasMaskedPath) {
                if (mult.length) {
                  currentLength += animatorProps.t.v * mult[0];
                } else {
                  currentLength += animatorProps.t.v * mult;
                }
              } else if (mult.length) {
                xPos += animatorProps.t.v * mult[0];
              } else {
                xPos += animatorProps.t.v * mult;
              }
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          sw = documentData.sw || 0;
        }

        if (documentData.strokeColorAnim) {
          if (documentData.sc) {
            sc = [documentData.sc[0], documentData.sc[1], documentData.sc[2]];
          } else {
            sc = [0, 0, 0];
          }
        }

        if (documentData.fillColorAnim && documentData.fc) {
          fc = [documentData.fc[0], documentData.fc[1], documentData.fc[2]];
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.a.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.translate(-animatorProps.a.v[0] * mult[0], -animatorProps.a.v[1] * mult[1], animatorProps.a.v[2] * mult[2]);
            } else {
              matrixHelper.translate(-animatorProps.a.v[0] * mult, -animatorProps.a.v[1] * mult, animatorProps.a.v[2] * mult);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.s.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (mult.length) {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult[0], 1 + (animatorProps.s.v[1] - 1) * mult[1], 1);
            } else {
              matrixHelper.scale(1 + (animatorProps.s.v[0] - 1) * mult, 1 + (animatorProps.s.v[1] - 1) * mult, 1);
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;
          animatorSelector = animators[j].s;
          mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

          if (animatorProps.sk.propType) {
            if (mult.length) {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult[0], animatorProps.sa.v * mult[1]);
            } else {
              matrixHelper.skewFromAxis(-animatorProps.sk.v * mult, animatorProps.sa.v * mult);
            }
          }

          if (animatorProps.r.propType) {
            if (mult.length) {
              matrixHelper.rotateZ(-animatorProps.r.v * mult[2]);
            } else {
              matrixHelper.rotateZ(-animatorProps.r.v * mult);
            }
          }

          if (animatorProps.ry.propType) {
            if (mult.length) {
              matrixHelper.rotateY(animatorProps.ry.v * mult[1]);
            } else {
              matrixHelper.rotateY(animatorProps.ry.v * mult);
            }
          }

          if (animatorProps.rx.propType) {
            if (mult.length) {
              matrixHelper.rotateX(animatorProps.rx.v * mult[0]);
            } else {
              matrixHelper.rotateX(animatorProps.rx.v * mult);
            }
          }

          if (animatorProps.o.propType) {
            if (mult.length) {
              elemOpacity += (animatorProps.o.v * mult[0] - elemOpacity) * mult[0];
            } else {
              elemOpacity += (animatorProps.o.v * mult - elemOpacity) * mult;
            }
          }

          if (documentData.strokeWidthAnim && animatorProps.sw.propType) {
            if (mult.length) {
              sw += animatorProps.sw.v * mult[0];
            } else {
              sw += animatorProps.sw.v * mult;
            }
          }

          if (documentData.strokeColorAnim && animatorProps.sc.propType) {
            for (k = 0; k < 3; k += 1) {
              if (mult.length) {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult[0];
              } else {
                sc[k] += (animatorProps.sc.v[k] - sc[k]) * mult;
              }
            }
          }

          if (documentData.fillColorAnim && documentData.fc) {
            if (animatorProps.fc.propType) {
              for (k = 0; k < 3; k += 1) {
                if (mult.length) {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult[0];
                } else {
                  fc[k] += (animatorProps.fc.v[k] - fc[k]) * mult;
                }
              }
            }

            if (animatorProps.fh.propType) {
              if (mult.length) {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult[0]);
              } else {
                fc = addHueToRGB(fc, animatorProps.fh.v * mult);
              }
            }

            if (animatorProps.fs.propType) {
              if (mult.length) {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult[0]);
              } else {
                fc = addSaturationToRGB(fc, animatorProps.fs.v * mult);
              }
            }

            if (animatorProps.fb.propType) {
              if (mult.length) {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult[0]);
              } else {
                fc = addBrightnessToRGB(fc, animatorProps.fb.v * mult);
              }
            }
          }
        }

        for (j = 0; j < jLen; j += 1) {
          animatorProps = animators[j].a;

          if (animatorProps.p.propType) {
            animatorSelector = animators[j].s;
            mult = animatorSelector.getMult(letters[i].anIndexes[j], textData.a[j].s.totalChars);

            if (this._hasMaskedPath) {
              if (mult.length) {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult[0], -animatorProps.p.v[2] * mult[1]);
              } else {
                matrixHelper.translate(0, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
              }
            } else if (mult.length) {
              matrixHelper.translate(animatorProps.p.v[0] * mult[0], animatorProps.p.v[1] * mult[1], -animatorProps.p.v[2] * mult[2]);
            } else {
              matrixHelper.translate(animatorProps.p.v[0] * mult, animatorProps.p.v[1] * mult, -animatorProps.p.v[2] * mult);
            }
          }
        }

        if (documentData.strokeWidthAnim) {
          letterSw = sw < 0 ? 0 : sw;
        }

        if (documentData.strokeColorAnim) {
          letterSc = 'rgb(' + Math.round(sc[0] * 255) + ',' + Math.round(sc[1] * 255) + ',' + Math.round(sc[2] * 255) + ')';
        }

        if (documentData.fillColorAnim && documentData.fc) {
          letterFc = 'rgb(' + Math.round(fc[0] * 255) + ',' + Math.round(fc[1] * 255) + ',' + Math.round(fc[2] * 255) + ')';
        }

        if (this._hasMaskedPath) {
          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(0, alignment[1] * yOff * 0.01 + yPos, 0);

          if (this._pathData.p.v) {
            tanAngle = (currentPoint.point[1] - prevPoint.point[1]) / (currentPoint.point[0] - prevPoint.point[0]);
            var rot = Math.atan(tanAngle) * 180 / Math.PI;

            if (currentPoint.point[0] < prevPoint.point[0]) {
              rot += 180;
            }

            matrixHelper.rotate(-rot * Math.PI / 180);
          }

          matrixHelper.translate(xPathPos, yPathPos, 0);
          currentLength -= alignment[0] * letters[i].an * 0.005;

          if (letters[i + 1] && ind !== letters[i + 1].ind) {
            currentLength += letters[i].an / 2;
            currentLength += documentData.tr * 0.001 * documentData.finalSize;
          }
        } else {
          matrixHelper.translate(xPos, yPos, 0);

          if (documentData.ps) {
            // matrixHelper.translate(documentData.ps[0],documentData.ps[1],0);
            matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
          }

          switch (documentData.j) {
            case 1:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]), 0, 0);
              break;

            case 2:
              matrixHelper.translate(letters[i].animatorJustifyOffset + documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[letters[i].line]) / 2, 0, 0);
              break;

            default:
              break;
          }

          matrixHelper.translate(0, -documentData.ls);
          matrixHelper.translate(offf, 0, 0);
          matrixHelper.translate(alignment[0] * letters[i].an * 0.005, alignment[1] * yOff * 0.01, 0);
          xPos += letters[i].l + documentData.tr * 0.001 * documentData.finalSize;
        }

        if (renderType === 'html') {
          letterM = matrixHelper.toCSS();
        } else if (renderType === 'svg') {
          letterM = matrixHelper.to2dCSS();
        } else {
          letterP = [matrixHelper.props[0], matrixHelper.props[1], matrixHelper.props[2], matrixHelper.props[3], matrixHelper.props[4], matrixHelper.props[5], matrixHelper.props[6], matrixHelper.props[7], matrixHelper.props[8], matrixHelper.props[9], matrixHelper.props[10], matrixHelper.props[11], matrixHelper.props[12], matrixHelper.props[13], matrixHelper.props[14], matrixHelper.props[15]];
        }

        letterO = elemOpacity;
      }

      if (renderedLettersCount <= i) {
        letterValue = new LetterProps(letterO, letterSw, letterSc, letterFc, letterM, letterP);
        this.renderedLetters.push(letterValue);
        renderedLettersCount += 1;
        this.lettersChangedFlag = true;
      } else {
        letterValue = this.renderedLetters[i];
        this.lettersChangedFlag = letterValue.update(letterO, letterSw, letterSc, letterFc, letterM, letterP) || this.lettersChangedFlag;
      }
    }
  };

  TextAnimatorProperty.prototype.getValue = function () {
    if (this._elem.globalData.frameId === this._frameId) {
      return;
    }

    this._frameId = this._elem.globalData.frameId;
    this.iterateDynamicProperties();
  };

  TextAnimatorProperty.prototype.mHelper = new Matrix();
  TextAnimatorProperty.prototype.defaultPropsArray = [];
  extendPrototype([DynamicPropertyContainer], TextAnimatorProperty);

  function ITextElement() {}

  ITextElement.prototype.initElement = function (data, globalData, comp) {
    this.lettersChangedFlag = true;
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.textProperty = new TextProperty(this, data.t, this.dynamicProperties);
    this.textAnimator = new TextAnimatorProperty(data.t, this.renderType, this);
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
    this.initRenderable();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();
    this.createContent();
    this.hide();
    this.textAnimator.searchProperties(this.dynamicProperties);
  };

  ITextElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);
  };

  ITextElement.prototype.createPathShape = function (matrixHelper, shapes) {
    var j;
    var jLen = shapes.length;
    var pathNodes;
    var shapeStr = '';

    for (j = 0; j < jLen; j += 1) {
      if (shapes[j].ty === 'sh') {
        pathNodes = shapes[j].ks.k;
        shapeStr += buildShapeString(pathNodes, pathNodes.i.length, true, matrixHelper);
      }
    }

    return shapeStr;
  };

  ITextElement.prototype.updateDocumentData = function (newData, index) {
    this.textProperty.updateDocumentData(newData, index);
  };

  ITextElement.prototype.canResizeFont = function (_canResize) {
    this.textProperty.canResizeFont(_canResize);
  };

  ITextElement.prototype.setMinimumFontSize = function (_fontSize) {
    this.textProperty.setMinimumFontSize(_fontSize);
  };

  ITextElement.prototype.applyTextPropertiesToMatrix = function (documentData, matrixHelper, lineNumber, xPos, yPos) {
    if (documentData.ps) {
      matrixHelper.translate(documentData.ps[0], documentData.ps[1] + documentData.ascent, 0);
    }

    matrixHelper.translate(0, -documentData.ls, 0);

    switch (documentData.j) {
      case 1:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]), 0, 0);
        break;

      case 2:
        matrixHelper.translate(documentData.justifyOffset + (documentData.boxWidth - documentData.lineWidths[lineNumber]) / 2, 0, 0);
        break;

      default:
        break;
    }

    matrixHelper.translate(xPos, yPos, 0);
  };

  ITextElement.prototype.buildColor = function (colorData) {
    return 'rgb(' + Math.round(colorData[0] * 255) + ',' + Math.round(colorData[1] * 255) + ',' + Math.round(colorData[2] * 255) + ')';
  };

  ITextElement.prototype.emptyProp = new LetterProps();

  ITextElement.prototype.destroy = function () {};

  ITextElement.prototype.validateText = function () {
    if (this.textProperty._mdf || this.textProperty._isFirstFrame) {
      this.buildNewText();
      this.textProperty._isFirstFrame = false;
      this.textProperty._mdf = false;
    }
  };

  var emptyShapeData = {
    shapes: []
  };

  function SVGTextLottieElement(data, globalData, comp) {
    this.textSpans = [];
    this.renderType = 'svg';
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, SVGBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], SVGTextLottieElement);

  SVGTextLottieElement.prototype.createContent = function () {
    if (this.data.singleShape && !this.globalData.fontManager.chars) {
      this.textContainer = createNS('text');
    }
  };

  SVGTextLottieElement.prototype.buildTextContents = function (textArray) {
    var i = 0;
    var len = textArray.length;
    var textContents = [];
    var currentTextContent = '';

    while (i < len) {
      if (textArray[i] === String.fromCharCode(13) || textArray[i] === String.fromCharCode(3)) {
        textContents.push(currentTextContent);
        currentTextContent = '';
      } else {
        currentTextContent += textArray[i];
      }

      i += 1;
    }

    textContents.push(currentTextContent);
    return textContents;
  };

  SVGTextLottieElement.prototype.buildShapeData = function (data, scale) {
    // data should probably be cloned to apply scale separately to each instance of a text on different layers
    // but since text internal content gets only rendered once and then it's never rerendered,
    // it's probably safe not to clone data and reuse always the same instance even if the object is mutated.
    // Avoiding cloning is preferred since cloning each character shape data is expensive
    if (data.shapes && data.shapes.length) {
      var shape = data.shapes[0];

      if (shape.it) {
        var shapeItem = shape.it[shape.it.length - 1];

        if (shapeItem.s) {
          shapeItem.s.k[0] = scale;
          shapeItem.s.k[1] = scale;
        }
      }
    }

    return data;
  };

  SVGTextLottieElement.prototype.buildNewText = function () {
    this.addDynamicProperty(this);
    var i;
    var len;
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData ? documentData.l.length : 0);

    if (documentData.fc) {
      this.layerElement.setAttribute('fill', this.buildColor(documentData.fc));
    } else {
      this.layerElement.setAttribute('fill', 'rgba(0,0,0,0)');
    }

    if (documentData.sc) {
      this.layerElement.setAttribute('stroke', this.buildColor(documentData.sc));
      this.layerElement.setAttribute('stroke-width', documentData.sw);
    }

    this.layerElement.setAttribute('font-size', documentData.finalSize);
    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

    if (fontData.fClass) {
      this.layerElement.setAttribute('class', fontData.fClass);
    } else {
      this.layerElement.setAttribute('font-family', fontData.fFamily);
      var fWeight = documentData.fWeight;
      var fStyle = documentData.fStyle;
      this.layerElement.setAttribute('font-style', fStyle);
      this.layerElement.setAttribute('font-weight', fWeight);
    }

    this.layerElement.setAttribute('aria-label', documentData.t);
    var letters = documentData.l || [];
    var usesGlyphs = !!this.globalData.fontManager.chars;
    len = letters.length;
    var tSpan;
    var matrixHelper = this.mHelper;
    var shapeStr = '';
    var singleShape = this.data.singleShape;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;

    if (singleShape && !usesGlyphs && !documentData.sz) {
      var tElement = this.textContainer;
      var justify = 'start';

      switch (documentData.j) {
        case 1:
          justify = 'end';
          break;

        case 2:
          justify = 'middle';
          break;

        default:
          justify = 'start';
          break;
      }

      tElement.setAttribute('text-anchor', justify);
      tElement.setAttribute('letter-spacing', trackingOffset);
      var textContent = this.buildTextContents(documentData.finalText);
      len = textContent.length;
      yPos = documentData.ps ? documentData.ps[1] + documentData.ascent : 0;

      for (i = 0; i < len; i += 1) {
        tSpan = this.textSpans[i].span || createNS('tspan');
        tSpan.textContent = textContent[i];
        tSpan.setAttribute('x', 0);
        tSpan.setAttribute('y', yPos);
        tSpan.style.display = 'inherit';
        tElement.appendChild(tSpan);

        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            glyph: null
          };
        }

        this.textSpans[i].span = tSpan;
        yPos += documentData.finalLineHeight;
      }

      this.layerElement.appendChild(tElement);
    } else {
      var cachedSpansLength = this.textSpans.length;
      var charData;

      for (i = 0; i < len; i += 1) {
        if (!this.textSpans[i]) {
          this.textSpans[i] = {
            span: null,
            childSpan: null,
            glyph: null
          };
        }

        if (!usesGlyphs || !singleShape || i === 0) {
          tSpan = cachedSpansLength > i ? this.textSpans[i].span : createNS(usesGlyphs ? 'g' : 'text');

          if (cachedSpansLength <= i) {
            tSpan.setAttribute('stroke-linecap', 'butt');
            tSpan.setAttribute('stroke-linejoin', 'round');
            tSpan.setAttribute('stroke-miterlimit', '4');
            this.textSpans[i].span = tSpan;

            if (usesGlyphs) {
              var childSpan = createNS('g');
              tSpan.appendChild(childSpan);
              this.textSpans[i].childSpan = childSpan;
            }

            this.textSpans[i].span = tSpan;
            this.layerElement.appendChild(tSpan);
          }

          tSpan.style.display = 'inherit';
        }

        matrixHelper.reset();

        if (singleShape) {
          if (letters[i].n) {
            xPos = -trackingOffset;
            yPos += documentData.yOffset;
            yPos += firstLine ? 1 : 0;
            firstLine = false;
          }

          this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
          xPos += letters[i].l || 0; // xPos += letters[i].val === ' ' ? 0 : trackingOffset;

          xPos += trackingOffset;
        }

        if (usesGlyphs) {
          charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
          var glyphElement; // t === 1 means the character has been replaced with an animated shaped

          if (charData.t === 1) {
            glyphElement = new SVGCompElement(charData.data, this.globalData, this);
          } else {
            var data = emptyShapeData;

            if (charData.data && charData.data.shapes) {
              data = this.buildShapeData(charData.data, documentData.finalSize);
            }

            glyphElement = new SVGShapeElement(data, this.globalData, this);
          }

          if (this.textSpans[i].glyph) {
            var glyph = this.textSpans[i].glyph;
            this.textSpans[i].childSpan.removeChild(glyph.layerElement);
            glyph.destroy();
          }

          this.textSpans[i].glyph = glyphElement;
          glyphElement._debug = true;
          glyphElement.prepareFrame(0);
          glyphElement.renderFrame();
          this.textSpans[i].childSpan.appendChild(glyphElement.layerElement); // when using animated shapes, the layer will be scaled instead of replacing the internal scale
          // this might have issues with strokes and might need a different solution

          if (charData.t === 1) {
            this.textSpans[i].childSpan.setAttribute('transform', 'scale(' + documentData.finalSize / 100 + ',' + documentData.finalSize / 100 + ')');
          }
        } else {
          if (singleShape) {
            tSpan.setAttribute('transform', 'translate(' + matrixHelper.props[12] + ',' + matrixHelper.props[13] + ')');
          }

          tSpan.textContent = letters[i].val;
          tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');
        } //

      }

      if (singleShape && tSpan) {
        tSpan.setAttribute('d', shapeStr);
      }
    }

    while (i < this.textSpans.length) {
      this.textSpans[i].span.style.display = 'none';
      i += 1;
    }

    this._sizeChanged = true;
  };

  SVGTextLottieElement.prototype.sourceRectAtTime = function () {
    this.prepareFrame(this.comp.renderedFrame - this.data.st);
    this.renderInnerContent();

    if (this._sizeChanged) {
      this._sizeChanged = false;
      var textBox = this.layerElement.getBBox();
      this.bbox = {
        top: textBox.y,
        left: textBox.x,
        width: textBox.width,
        height: textBox.height
      };
    }

    return this.bbox;
  };

  SVGTextLottieElement.prototype.getValue = function () {
    var i;
    var len = this.textSpans.length;
    var glyphElement;
    this.renderedFrame = this.comp.renderedFrame;

    for (i = 0; i < len; i += 1) {
      glyphElement = this.textSpans[i].glyph;

      if (glyphElement) {
        glyphElement.prepareFrame(this.comp.renderedFrame - this.data.st);

        if (glyphElement._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  SVGTextLottieElement.prototype.renderInnerContent = function () {
    this.validateText();

    if (!this.data.singleShape || this._mdf) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

      if (this.lettersChangedFlag || this.textAnimator.lettersChangedFlag) {
        this._sizeChanged = true;
        var i;
        var len;
        var renderedLetters = this.textAnimator.renderedLetters;
        var letters = this.textProperty.currentData.l;
        len = letters.length;
        var renderedLetter;
        var textSpan;
        var glyphElement;

        for (i = 0; i < len; i += 1) {
          if (!letters[i].n) {
            renderedLetter = renderedLetters[i];
            textSpan = this.textSpans[i].span;
            glyphElement = this.textSpans[i].glyph;

            if (glyphElement) {
              glyphElement.renderFrame();
            }

            if (renderedLetter._mdf.m) {
              textSpan.setAttribute('transform', renderedLetter.m);
            }

            if (renderedLetter._mdf.o) {
              textSpan.setAttribute('opacity', renderedLetter.o);
            }

            if (renderedLetter._mdf.sw) {
              textSpan.setAttribute('stroke-width', renderedLetter.sw);
            }

            if (renderedLetter._mdf.sc) {
              textSpan.setAttribute('stroke', renderedLetter.sc);
            }

            if (renderedLetter._mdf.fc) {
              textSpan.setAttribute('fill', renderedLetter.fc);
            }
          }
        }
      }
    }
  };

  function ISolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([IImageElement], ISolidElement);

  ISolidElement.prototype.createContent = function () {
    var rect = createNS('rect'); /// /rect.style.width = this.data.sw;
    /// /rect.style.height = this.data.sh;
    /// /rect.style.fill = this.data.sc;

    rect.setAttribute('width', this.data.sw);
    rect.setAttribute('height', this.data.sh);
    rect.setAttribute('fill', this.data.sc);
    this.layerElement.appendChild(rect);
  };

  function NullElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initFrame();
    this.initTransform(data, globalData, comp);
    this.initHierarchy();
  }

  NullElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };

  NullElement.prototype.renderFrame = function () {};

  NullElement.prototype.getBaseElement = function () {
    return null;
  };

  NullElement.prototype.destroy = function () {};

  NullElement.prototype.sourceRectAtTime = function () {};

  NullElement.prototype.hide = function () {};

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement], NullElement);

  function SVGRendererBase() {}

  extendPrototype([BaseRenderer], SVGRendererBase);

  SVGRendererBase.prototype.createNull = function (data) {
    return new NullElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createShape = function (data) {
    return new SVGShapeElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createText = function (data) {
    return new SVGTextLottieElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createImage = function (data) {
    return new IImageElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.createSolid = function (data) {
    return new ISolidElement(data, this.globalData, this);
  };

  SVGRendererBase.prototype.configAnimation = function (animData) {
    this.svgElement.setAttribute('xmlns', 'http://www.w3.org/2000/svg');
    this.svgElement.setAttribute('xmlns:xlink', 'http://www.w3.org/1999/xlink');

    if (this.renderConfig.viewBoxSize) {
      this.svgElement.setAttribute('viewBox', this.renderConfig.viewBoxSize);
    } else {
      this.svgElement.setAttribute('viewBox', '0 0 ' + animData.w + ' ' + animData.h);
    }

    if (!this.renderConfig.viewBoxOnly) {
      this.svgElement.setAttribute('width', animData.w);
      this.svgElement.setAttribute('height', animData.h);
      this.svgElement.style.width = '100%';
      this.svgElement.style.height = '100%';
      this.svgElement.style.transform = 'translate3d(0,0,0)';
      this.svgElement.style.contentVisibility = this.renderConfig.contentVisibility;
    }

    if (this.renderConfig.width) {
      this.svgElement.setAttribute('width', this.renderConfig.width);
    }

    if (this.renderConfig.height) {
      this.svgElement.setAttribute('height', this.renderConfig.height);
    }

    if (this.renderConfig.className) {
      this.svgElement.setAttribute('class', this.renderConfig.className);
    }

    if (this.renderConfig.id) {
      this.svgElement.setAttribute('id', this.renderConfig.id);
    }

    if (this.renderConfig.focusable !== undefined) {
      this.svgElement.setAttribute('focusable', this.renderConfig.focusable);
    }

    this.svgElement.setAttribute('preserveAspectRatio', this.renderConfig.preserveAspectRatio); // this.layerElement.style.transform = 'translate3d(0,0,0)';
    // this.layerElement.style.transformOrigin = this.layerElement.style.mozTransformOrigin = this.layerElement.style.webkitTransformOrigin = this.layerElement.style['-webkit-transform'] = "0px 0px 0px";

    this.animationItem.wrapper.appendChild(this.svgElement); // Mask animation

    var defs = this.globalData.defs;
    this.setupGlobalData(animData, defs);
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.data = animData;
    var maskElement = createNS('clipPath');
    var rect = createNS('rect');
    rect.setAttribute('width', animData.w);
    rect.setAttribute('height', animData.h);
    rect.setAttribute('x', 0);
    rect.setAttribute('y', 0);
    var maskId = createElementID();
    maskElement.setAttribute('id', maskId);
    maskElement.appendChild(rect);
    this.layerElement.setAttribute('clip-path', 'url(' + getLocationHref() + '#' + maskId + ')');
    defs.appendChild(maskElement);
    this.layers = animData.layers;
    this.elements = createSizedArray(animData.layers.length);
  };

  SVGRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    this.layerElement = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };

  SVGRendererBase.prototype.updateContainerSize = function () {};

  SVGRendererBase.prototype.findIndexByInd = function (ind) {
    var i = 0;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ind === ind) {
        return i;
      }
    }

    return -1;
  };

  SVGRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;

    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }

    elements[pos] = true;
    var element = this.createItem(this.layers[pos]);
    elements[pos] = element;

    if (getExpressionsPlugin()) {
      if (this.layers[pos].ty === 0) {
        this.globalData.projectInterface.registerComposition(element);
      }

      element.initExpressions();
    }

    this.appendElementInPos(element, pos);

    if (this.layers[pos].tt) {
      var elementIndex = 'tp' in this.layers[pos] ? this.findIndexByInd(this.layers[pos].tp) : pos - 1;

      if (elementIndex === -1) {
        return;
      }

      if (!this.elements[elementIndex] || this.elements[elementIndex] === true) {
        this.buildItem(elementIndex);
        this.addPendingElement(element);
      } else {
        var matteElement = elements[elementIndex];
        var matteMask = matteElement.getMatte(this.layers[pos].tt);
        element.setMatte(matteMask);
      }
    }
  };

  SVGRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();

      if (element.data.tt) {
        var i = 0;
        var len = this.elements.length;

        while (i < len) {
          if (this.elements[i] === element) {
            var elementIndex = 'tp' in element.data ? this.findIndexByInd(element.data.tp) : i - 1;
            var matteElement = this.elements[elementIndex];
            var matteMask = matteElement.getMatte(this.layers[i].tt);
            element.setMatte(matteMask);
            break;
          }

          i += 1;
        }
      }
    }
  };

  SVGRendererBase.prototype.renderFrame = function (num) {
    if (this.renderedFrame === num || this.destroyed) {
      return;
    }

    if (num === null) {
      num = this.renderedFrame;
    } else {
      this.renderedFrame = num;
    } // console.log('-------');
    // console.log('FRAME ',num);


    this.globalData.frameNum = num;
    this.globalData.frameId += 1;
    this.globalData.projectInterface.currentFrame = num;
    this.globalData._mdf = false;
    var i;
    var len = this.layers.length;

    if (!this.completeLayers) {
      this.checkLayers(num);
    }

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }

    if (this.globalData._mdf) {
      for (i = 0; i < len; i += 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }
    }
  };

  SVGRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newElement = element.getBaseElement();

    if (!newElement) {
      return;
    }

    var i = 0;
    var nextElement;

    while (i < pos) {
      if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement()) {
        nextElement = this.elements[i].getBaseElement();
      }

      i += 1;
    }

    if (nextElement) {
      this.layerElement.insertBefore(newElement, nextElement);
    } else {
      this.layerElement.appendChild(newElement);
    }
  };

  SVGRendererBase.prototype.hide = function () {
    this.layerElement.style.display = 'none';
  };

  SVGRendererBase.prototype.show = function () {
    this.layerElement.style.display = 'block';
  };

  function ICompElement() {}

  extendPrototype([BaseElement, TransformElement, HierarchyElement, FrameElement, RenderableDOMElement], ICompElement);

  ICompElement.prototype.initElement = function (data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initTransform(data, globalData, comp);
    this.initRenderable();
    this.initHierarchy();
    this.initRendererElement();
    this.createContainerElements();
    this.createRenderableComponents();

    if (this.data.xt || !globalData.progressiveLoad) {
      this.buildAllItems();
    }

    this.hide();
  };
  /* ICompElement.prototype.hide = function(){
      if(!this.hidden){
          this.hideElement();
          var i,len = this.elements.length;
          for( i = 0; i < len; i+=1 ){
              if(this.elements[i]){
                  this.elements[i].hide();
              }
          }
      }
  }; */


  ICompElement.prototype.prepareFrame = function (num) {
    this._mdf = false;
    this.prepareRenderableFrame(num);
    this.prepareProperties(num, this.isInRange);

    if (!this.isInRange && !this.data.xt) {
      return;
    }

    if (!this.tm._placeholder) {
      var timeRemapped = this.tm.v;

      if (timeRemapped === this.data.op) {
        timeRemapped = this.data.op - 1;
      }

      this.renderedFrame = timeRemapped;
    } else {
      this.renderedFrame = num / this.data.sr;
    }

    var i;
    var len = this.elements.length;

    if (!this.completeLayers) {
      this.checkLayers(this.renderedFrame);
    } // This iteration needs to be backwards because of how expressions connect between each other


    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(this.renderedFrame - this.layers[i].st);

        if (this.elements[i]._mdf) {
          this._mdf = true;
        }
      }
    }
  };

  ICompElement.prototype.renderInnerContent = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };

  ICompElement.prototype.setElements = function (elems) {
    this.elements = elems;
  };

  ICompElement.prototype.getElements = function () {
    return this.elements;
  };

  ICompElement.prototype.destroyElements = function () {
    var i;
    var len = this.layers.length;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }
  };

  ICompElement.prototype.destroy = function () {
    this.destroyElements();
    this.destroyBaseElement();
  };

  function SVGCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = true;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([SVGRendererBase, ICompElement, SVGBaseElement], SVGCompElement);

  SVGCompElement.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function SVGRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.svgElement = createNS('svg');
    var ariaLabel = '';

    if (config && config.title) {
      var titleElement = createNS('title');
      var titleId = createElementID();
      titleElement.setAttribute('id', titleId);
      titleElement.textContent = config.title;
      this.svgElement.appendChild(titleElement);
      ariaLabel += titleId;
    }

    if (config && config.description) {
      var descElement = createNS('desc');
      var descId = createElementID();
      descElement.setAttribute('id', descId);
      descElement.textContent = config.description;
      this.svgElement.appendChild(descElement);
      ariaLabel += ' ' + descId;
    }

    if (ariaLabel) {
      this.svgElement.setAttribute('aria-labelledby', ariaLabel);
    }

    var defs = createNS('defs');
    this.svgElement.appendChild(defs);
    var maskElement = createNS('g');
    this.svgElement.appendChild(maskElement);
    this.layerElement = maskElement;
    this.renderConfig = {
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      progressiveLoad: config && config.progressiveLoad || false,
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      viewBoxOnly: config && config.viewBoxOnly || false,
      viewBoxSize: config && config.viewBoxSize || false,
      className: config && config.className || '',
      id: config && config.id || '',
      focusable: config && config.focusable,
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '100%',
        height: config && config.filterSize && config.filterSize.height || '100%',
        x: config && config.filterSize && config.filterSize.x || '0%',
        y: config && config.filterSize && config.filterSize.y || '0%'
      },
      width: config && config.width,
      height: config && config.height,
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      defs: defs,
      renderConfig: this.renderConfig
    };
    this.elements = [];
    this.pendingElements = [];
    this.destroyed = false;
    this.rendererType = 'svg';
  }

  extendPrototype([SVGRendererBase], SVGRenderer);

  SVGRenderer.prototype.createComp = function (data) {
    return new SVGCompElement(data, this.globalData, this);
  };

  function ShapeTransformManager() {
    this.sequences = {};
    this.sequenceList = [];
    this.transform_key_count = 0;
  }

  ShapeTransformManager.prototype = {
    addTransformSequence: function addTransformSequence(transforms) {
      var i;
      var len = transforms.length;
      var key = '_';

      for (i = 0; i < len; i += 1) {
        key += transforms[i].transform.key + '_';
      }

      var sequence = this.sequences[key];

      if (!sequence) {
        sequence = {
          transforms: [].concat(transforms),
          finalTransform: new Matrix(),
          _mdf: false
        };
        this.sequences[key] = sequence;
        this.sequenceList.push(sequence);
      }

      return sequence;
    },
    processSequence: function processSequence(sequence, isFirstFrame) {
      var i = 0;
      var len = sequence.transforms.length;
      var _mdf = isFirstFrame;

      while (i < len && !isFirstFrame) {
        if (sequence.transforms[i].transform.mProps._mdf) {
          _mdf = true;
          break;
        }

        i += 1;
      }

      if (_mdf) {
        sequence.finalTransform.reset();

        for (i = len - 1; i >= 0; i -= 1) {
          sequence.finalTransform.multiply(sequence.transforms[i].transform.mProps.v);
        }
      }

      sequence._mdf = _mdf;
    },
    processSequences: function processSequences(isFirstFrame) {
      var i;
      var len = this.sequenceList.length;

      for (i = 0; i < len; i += 1) {
        this.processSequence(this.sequenceList[i], isFirstFrame);
      }
    },
    getNewKey: function getNewKey() {
      this.transform_key_count += 1;
      return '_' + this.transform_key_count;
    }
  };

  var lumaLoader = function lumaLoader() {
    var id = '__lottie_element_luma_buffer';
    var lumaBuffer = null;
    var lumaBufferCtx = null;
    var svg = null; // This alternate solution has a slight delay before the filter is applied, resulting in a flicker on the first frame.
    // Keeping this here for reference, and in the future, if offscreen canvas supports url filters, this can be used.
    // For now, neither of them work for offscreen canvas, so canvas workers can't support the luma track matte mask.
    // Naming it solution 2 to mark the extra comment lines.

    /*
    var svgString = [
      '<svg xmlns="http://www.w3.org/2000/svg">',
      '<filter id="' + id + '">',
      '<feColorMatrix type="matrix" color-interpolation-filters="sRGB" values="',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0, ',
      '0.3, 0.3, 0.3, 0, 0',
      '"/>',
      '</filter>',
      '</svg>',
    ].join('');
    var blob = new Blob([svgString], { type: 'image/svg+xml' });
    var url = URL.createObjectURL(blob);
    */

    function createLumaSvgFilter() {
      var _svg = createNS('svg');

      var fil = createNS('filter');
      var matrix = createNS('feColorMatrix');
      fil.setAttribute('id', id);
      matrix.setAttribute('type', 'matrix');
      matrix.setAttribute('color-interpolation-filters', 'sRGB');
      matrix.setAttribute('values', '0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0, 0.3, 0.3, 0.3, 0, 0');
      fil.appendChild(matrix);

      _svg.appendChild(fil);

      _svg.setAttribute('id', id + '_svg');

      if (featureSupport.svgLumaHidden) {
        _svg.style.display = 'none';
      }

      return _svg;
    }

    function loadLuma() {
      if (!lumaBuffer) {
        svg = createLumaSvgFilter();
        document.body.appendChild(svg);
        lumaBuffer = createTag('canvas');
        lumaBufferCtx = lumaBuffer.getContext('2d'); // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

        lumaBufferCtx.filter = 'url(#' + id + ')';
        lumaBufferCtx.fillStyle = 'rgba(0,0,0,0)';
        lumaBufferCtx.fillRect(0, 0, 1, 1);
      }
    }

    function getLuma(canvas) {
      if (!lumaBuffer) {
        loadLuma();
      }

      lumaBuffer.width = canvas.width;
      lumaBuffer.height = canvas.height; // lumaBufferCtx.filter = `url('${url}#__lottie_element_luma_buffer')`; // part of solution 2

      lumaBufferCtx.filter = 'url(#' + id + ')';
      return lumaBuffer;
    }

    return {
      load: loadLuma,
      get: getLuma
    };
  };

  function createCanvas(width, height) {
    if (featureSupport.offscreenCanvas) {
      return new OffscreenCanvas(width, height);
    }

    var canvas = createTag('canvas');
    canvas.width = width;
    canvas.height = height;
    return canvas;
  }

  var assetLoader = function () {
    return {
      loadLumaCanvas: lumaLoader.load,
      getLumaCanvas: lumaLoader.get,
      createCanvas: createCanvas
    };
  }();

  var registeredEffects = {};

  function CVEffects(elem) {
    var i;
    var len = elem.data.ef ? elem.data.ef.length : 0;
    this.filters = [];
    var filterManager;

    for (i = 0; i < len; i += 1) {
      filterManager = null;
      var type = elem.data.ef[i].ty;

      if (registeredEffects[type]) {
        var Effect = registeredEffects[type].effect;
        filterManager = new Effect(elem.effectsManager.effectElements[i], elem);
      }

      if (filterManager) {
        this.filters.push(filterManager);
      }
    }

    if (this.filters.length) {
      elem.addRenderableComponent(this);
    }
  }

  CVEffects.prototype.renderFrame = function (_isFirstFrame) {
    var i;
    var len = this.filters.length;

    for (i = 0; i < len; i += 1) {
      this.filters[i].renderFrame(_isFirstFrame);
    }
  };

  CVEffects.prototype.getEffects = function (type) {
    var i;
    var len = this.filters.length;
    var effects = [];

    for (i = 0; i < len; i += 1) {
      if (this.filters[i].type === type) {
        effects.push(this.filters[i]);
      }
    }

    return effects;
  };

  function registerEffect(id, effect) {
    registeredEffects[id] = {
      effect: effect
    };
  }

  function CVMaskElement(data, element) {
    this.data = data;
    this.element = element;
    this.masksProperties = this.data.masksProperties || [];
    this.viewData = createSizedArray(this.masksProperties.length);
    var i;
    var len = this.masksProperties.length;
    var hasMasks = false;

    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        hasMasks = true;
      }

      this.viewData[i] = ShapePropertyFactory.getShapeProp(this.element, this.masksProperties[i], 3);
    }

    this.hasMasks = hasMasks;

    if (hasMasks) {
      this.element.addRenderableComponent(this);
    }
  }

  CVMaskElement.prototype.renderFrame = function () {
    if (!this.hasMasks) {
      return;
    }

    var transform = this.element.finalTransform.mat;
    var ctx = this.element.canvasContext;
    var i;
    var len = this.masksProperties.length;
    var pt;
    var pts;
    var data;
    ctx.beginPath();

    for (i = 0; i < len; i += 1) {
      if (this.masksProperties[i].mode !== 'n') {
        if (this.masksProperties[i].inv) {
          ctx.moveTo(0, 0);
          ctx.lineTo(this.element.globalData.compSize.w, 0);
          ctx.lineTo(this.element.globalData.compSize.w, this.element.globalData.compSize.h);
          ctx.lineTo(0, this.element.globalData.compSize.h);
          ctx.lineTo(0, 0);
        }

        data = this.viewData[i].v;
        pt = transform.applyToPointArray(data.v[0][0], data.v[0][1], 0);
        ctx.moveTo(pt[0], pt[1]);
        var j;
        var jLen = data._length;

        for (j = 1; j < jLen; j += 1) {
          pts = transform.applyToTriplePoints(data.o[j - 1], data.i[j], data.v[j]);
          ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
        }

        pts = transform.applyToTriplePoints(data.o[j - 1], data.i[0], data.v[0]);
        ctx.bezierCurveTo(pts[0], pts[1], pts[2], pts[3], pts[4], pts[5]);
      }
    }

    this.element.globalData.renderer.save(true);
    ctx.clip();
  };

  CVMaskElement.prototype.getMaskProperty = MaskElement.prototype.getMaskProperty;

  CVMaskElement.prototype.destroy = function () {
    this.element = null;
  };

  function CVBaseElement() {}

  var operationsMap = {
    1: 'source-in',
    2: 'source-out',
    3: 'source-in',
    4: 'source-out'
  };
  CVBaseElement.prototype = {
    createElements: function createElements() {},
    initRendererElement: function initRendererElement() {},
    createContainerElements: function createContainerElements() {
      // If the layer is masked we will use two buffers to store each different states of the drawing
      // This solution is not ideal for several reason. But unfortunately, because of the recursive
      // nature of the render tree, it's the only simple way to make sure one inner mask doesn't override an outer mask.
      // TODO: try to reduce the size of these buffers to the size of the composition contaning the layer
      // It might be challenging because the layer most likely is transformed in some way
      if (this.data.tt >= 1) {
        this.buffers = [];
        var canvasContext = this.globalData.canvasContext;
        var bufferCanvas = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
        this.buffers.push(bufferCanvas);
        var bufferCanvas2 = assetLoader.createCanvas(canvasContext.canvas.width, canvasContext.canvas.height);
        this.buffers.push(bufferCanvas2);

        if (this.data.tt >= 3 && !document._isProxy) {
          assetLoader.loadLumaCanvas();
        }
      }

      this.canvasContext = this.globalData.canvasContext;
      this.transformCanvas = this.globalData.transformCanvas;
      this.renderableEffectsManager = new CVEffects(this);
      this.searchEffectTransforms();
    },
    createContent: function createContent() {},
    setBlendMode: function setBlendMode() {
      var globalData = this.globalData;

      if (globalData.blendMode !== this.data.bm) {
        globalData.blendMode = this.data.bm;
        var blendModeValue = getBlendMode(this.data.bm);
        globalData.canvasContext.globalCompositeOperation = blendModeValue;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new CVMaskElement(this.data, this);
      this.transformEffects = this.renderableEffectsManager.getEffects(effectTypes.TRANSFORM_EFFECT);
    },
    hideElement: function hideElement() {
      if (!this.hidden && (!this.isInRange || this.isTransparent)) {
        this.hidden = true;
      }
    },
    showElement: function showElement() {
      if (this.isInRange && !this.isTransparent) {
        this.hidden = false;
        this._isFirstFrame = true;
        this.maskManager._isFirstFrame = true;
      }
    },
    clearCanvas: function clearCanvas(canvasContext) {
      canvasContext.clearRect(this.transformCanvas.tx, this.transformCanvas.ty, this.transformCanvas.w * this.transformCanvas.sx, this.transformCanvas.h * this.transformCanvas.sy);
    },
    prepareLayer: function prepareLayer() {
      if (this.data.tt >= 1) {
        var buffer = this.buffers[0];
        var bufferCtx = buffer.getContext('2d');
        this.clearCanvas(bufferCtx); // on the first buffer we store the current state of the global drawing

        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // The next four lines are to clear the canvas
        // TODO: Check if there is a way to clear the canvas without resetting the transform

        this.currentTransform = this.canvasContext.getTransform();
        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
        this.clearCanvas(this.canvasContext);
        this.canvasContext.setTransform(this.currentTransform);
      }
    },
    exitLayer: function exitLayer() {
      if (this.data.tt >= 1) {
        var buffer = this.buffers[1]; // On the second buffer we store the current state of the global drawing
        // that only contains the content of this layer
        // (if it is a composition, it also includes the nested layers)

        var bufferCtx = buffer.getContext('2d');
        this.clearCanvas(bufferCtx);
        bufferCtx.drawImage(this.canvasContext.canvas, 0, 0); // We clear the canvas again

        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0);
        this.clearCanvas(this.canvasContext);
        this.canvasContext.setTransform(this.currentTransform); // We draw the mask

        var mask = this.comp.getElementById('tp' in this.data ? this.data.tp : this.data.ind - 1);
        mask.renderFrame(true); // We draw the second buffer (that contains the content of this layer)

        this.canvasContext.setTransform(1, 0, 0, 1, 0, 0); // If the mask is a Luma matte, we need to do two extra painting operations
        // the _isProxy check is to avoid drawing a fake canvas in workers that will throw an error

        if (this.data.tt >= 3 && !document._isProxy) {
          // We copy the painted mask to a buffer that has a color matrix filter applied to it
          // that applies the rgb values to the alpha channel
          var lumaBuffer = assetLoader.getLumaCanvas(this.canvasContext.canvas);
          var lumaBufferCtx = lumaBuffer.getContext('2d');
          lumaBufferCtx.drawImage(this.canvasContext.canvas, 0, 0);
          this.clearCanvas(this.canvasContext); // we repaint the context with the mask applied to it

          this.canvasContext.drawImage(lumaBuffer, 0, 0);
        }

        this.canvasContext.globalCompositeOperation = operationsMap[this.data.tt];
        this.canvasContext.drawImage(buffer, 0, 0); // We finally draw the first buffer (that contains the content of the global drawing)
        // We use destination-over to draw the global drawing below the current layer

        this.canvasContext.globalCompositeOperation = 'destination-over';
        this.canvasContext.drawImage(this.buffers[0], 0, 0);
        this.canvasContext.setTransform(this.currentTransform); // We reset the globalCompositeOperation to source-over, the standard type of operation

        this.canvasContext.globalCompositeOperation = 'source-over';
      }
    },
    renderFrame: function renderFrame(forceRender) {
      if (this.hidden || this.data.hd) {
        return;
      }

      if (this.data.td === 1 && !forceRender) {
        return;
      }

      this.renderTransform();
      this.renderRenderable();
      this.renderLocalTransform();
      this.setBlendMode();
      var forceRealStack = this.data.ty === 0;
      this.prepareLayer();
      this.globalData.renderer.save(forceRealStack);
      this.globalData.renderer.ctxTransform(this.finalTransform.localMat.props);
      this.globalData.renderer.ctxOpacity(this.finalTransform.localOpacity);
      this.renderInnerContent();
      this.globalData.renderer.restore(forceRealStack);
      this.exitLayer();

      if (this.maskManager.hasMasks) {
        this.globalData.renderer.restore(true);
      }

      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.canvasContext = null;
      this.data = null;
      this.globalData = null;
      this.maskManager.destroy();
    },
    mHelper: new Matrix()
  };
  CVBaseElement.prototype.hide = CVBaseElement.prototype.hideElement;
  CVBaseElement.prototype.show = CVBaseElement.prototype.showElement;

  function CVShapeData(element, data, styles, transformsManager) {
    this.styledShapes = [];
    this.tr = [0, 0, 0, 0, 0, 0];
    var ty = 4;

    if (data.ty === 'rc') {
      ty = 5;
    } else if (data.ty === 'el') {
      ty = 6;
    } else if (data.ty === 'sr') {
      ty = 7;
    }

    this.sh = ShapePropertyFactory.getShapeProp(element, data, ty, element);
    var i;
    var len = styles.length;
    var styledShape;

    for (i = 0; i < len; i += 1) {
      if (!styles[i].closed) {
        styledShape = {
          transforms: transformsManager.addTransformSequence(styles[i].transforms),
          trNodes: []
        };
        this.styledShapes.push(styledShape);
        styles[i].elements.push(styledShape);
      }
    }
  }

  CVShapeData.prototype.setAsAnimated = SVGShapeData.prototype.setAsAnimated;

  function CVShapeElement(data, globalData, comp) {
    this.shapes = [];
    this.shapesData = data.shapes;
    this.stylesList = [];
    this.itemsData = [];
    this.prevViewData = [];
    this.shapeModifiers = [];
    this.processedElements = [];
    this.transformsManager = new ShapeTransformManager();
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, IShapeElement, HierarchyElement, FrameElement, RenderableElement], CVShapeElement);
  CVShapeElement.prototype.initElement = RenderableDOMElement.prototype.initElement;
  CVShapeElement.prototype.transformHelper = {
    opacity: 1,
    _opMdf: false
  };
  CVShapeElement.prototype.dashResetter = [];

  CVShapeElement.prototype.createContent = function () {
    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
  };

  CVShapeElement.prototype.createStyleElement = function (data, transforms) {
    var styleElem = {
      data: data,
      type: data.ty,
      preTransforms: this.transformsManager.addTransformSequence(transforms),
      transforms: [],
      elements: [],
      closed: data.hd === true
    };
    var elementData = {};

    if (data.ty === 'fl' || data.ty === 'st') {
      elementData.c = PropertyFactory.getProp(this, data.c, 1, 255, this);

      if (!elementData.c.k) {
        styleElem.co = 'rgb(' + bmFloor(elementData.c.v[0]) + ',' + bmFloor(elementData.c.v[1]) + ',' + bmFloor(elementData.c.v[2]) + ')';
      }
    } else if (data.ty === 'gf' || data.ty === 'gs') {
      elementData.s = PropertyFactory.getProp(this, data.s, 1, null, this);
      elementData.e = PropertyFactory.getProp(this, data.e, 1, null, this);
      elementData.h = PropertyFactory.getProp(this, data.h || {
        k: 0
      }, 0, 0.01, this);
      elementData.a = PropertyFactory.getProp(this, data.a || {
        k: 0
      }, 0, degToRads, this);
      elementData.g = new GradientProperty(this, data.g, this);
    }

    elementData.o = PropertyFactory.getProp(this, data.o, 0, 0.01, this);

    if (data.ty === 'st' || data.ty === 'gs') {
      styleElem.lc = lineCapEnum[data.lc || 2];
      styleElem.lj = lineJoinEnum[data.lj || 2];

      if (data.lj == 1) {
        // eslint-disable-line eqeqeq
        styleElem.ml = data.ml;
      }

      elementData.w = PropertyFactory.getProp(this, data.w, 0, null, this);

      if (!elementData.w.k) {
        styleElem.wi = elementData.w.v;
      }

      if (data.d) {
        var d = new DashProperty(this, data.d, 'canvas', this);
        elementData.d = d;

        if (!elementData.d.k) {
          styleElem.da = elementData.d.dashArray;
          styleElem["do"] = elementData.d.dashoffset[0];
        }
      }
    } else {
      styleElem.r = data.r === 2 ? 'evenodd' : 'nonzero';
    }

    this.stylesList.push(styleElem);
    elementData.style = styleElem;
    return elementData;
  };

  CVShapeElement.prototype.createGroupElement = function () {
    var elementData = {
      it: [],
      prevViewData: []
    };
    return elementData;
  };

  CVShapeElement.prototype.createTransformElement = function (data) {
    var elementData = {
      transform: {
        opacity: 1,
        _opMdf: false,
        key: this.transformsManager.getNewKey(),
        op: PropertyFactory.getProp(this, data.o, 0, 0.01, this),
        mProps: TransformPropertyFactory.getTransformProperty(this, data, this)
      }
    };
    return elementData;
  };

  CVShapeElement.prototype.createShapeElement = function (data) {
    var elementData = new CVShapeData(this, data, this.stylesList, this.transformsManager);
    this.shapes.push(elementData);
    this.addShapeToModifiers(elementData);
    return elementData;
  };

  CVShapeElement.prototype.reloadShapes = function () {
    this._isFirstFrame = true;
    var i;
    var len = this.itemsData.length;

    for (i = 0; i < len; i += 1) {
      this.prevViewData[i] = this.itemsData[i];
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, true, []);
    len = this.dynamicProperties.length;

    for (i = 0; i < len; i += 1) {
      this.dynamicProperties[i].getValue();
    }

    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
  };

  CVShapeElement.prototype.addTransformToStyleList = function (transform) {
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.push(transform);
      }
    }
  };

  CVShapeElement.prototype.removeTransformFromStyleList = function () {
    var i;
    var len = this.stylesList.length;

    for (i = 0; i < len; i += 1) {
      if (!this.stylesList[i].closed) {
        this.stylesList[i].transforms.pop();
      }
    }
  };

  CVShapeElement.prototype.closeStyles = function (styles) {
    var i;
    var len = styles.length;

    for (i = 0; i < len; i += 1) {
      styles[i].closed = true;
    }
  };

  CVShapeElement.prototype.searchShapes = function (arr, itemsData, prevViewData, shouldRender, transforms) {
    var i;
    var len = arr.length - 1;
    var j;
    var jLen;
    var ownStyles = [];
    var ownModifiers = [];
    var processedPos;
    var modifier;
    var currentTransform;
    var ownTransforms = [].concat(transforms);

    for (i = len; i >= 0; i -= 1) {
      processedPos = this.searchProcessedElement(arr[i]);

      if (!processedPos) {
        arr[i]._shouldRender = shouldRender;
      } else {
        itemsData[i] = prevViewData[processedPos - 1];
      }

      if (arr[i].ty === 'fl' || arr[i].ty === 'st' || arr[i].ty === 'gf' || arr[i].ty === 'gs') {
        if (!processedPos) {
          itemsData[i] = this.createStyleElement(arr[i], ownTransforms);
        } else {
          itemsData[i].style.closed = false;
        }

        ownStyles.push(itemsData[i].style);
      } else if (arr[i].ty === 'gr') {
        if (!processedPos) {
          itemsData[i] = this.createGroupElement(arr[i]);
        } else {
          jLen = itemsData[i].it.length;

          for (j = 0; j < jLen; j += 1) {
            itemsData[i].prevViewData[j] = itemsData[i].it[j];
          }
        }

        this.searchShapes(arr[i].it, itemsData[i].it, itemsData[i].prevViewData, shouldRender, ownTransforms);
      } else if (arr[i].ty === 'tr') {
        if (!processedPos) {
          currentTransform = this.createTransformElement(arr[i]);
          itemsData[i] = currentTransform;
        }

        ownTransforms.push(itemsData[i]);
        this.addTransformToStyleList(itemsData[i]);
      } else if (arr[i].ty === 'sh' || arr[i].ty === 'rc' || arr[i].ty === 'el' || arr[i].ty === 'sr') {
        if (!processedPos) {
          itemsData[i] = this.createShapeElement(arr[i]);
        }
      } else if (arr[i].ty === 'tm' || arr[i].ty === 'rd' || arr[i].ty === 'pb' || arr[i].ty === 'zz' || arr[i].ty === 'op') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          modifier.init(this, arr[i]);
          itemsData[i] = modifier;
          this.shapeModifiers.push(modifier);
        } else {
          modifier = itemsData[i];
          modifier.closed = false;
        }

        ownModifiers.push(modifier);
      } else if (arr[i].ty === 'rp') {
        if (!processedPos) {
          modifier = ShapeModifiers.getModifier(arr[i].ty);
          itemsData[i] = modifier;
          modifier.init(this, arr, i, itemsData);
          this.shapeModifiers.push(modifier);
          shouldRender = false;
        } else {
          modifier = itemsData[i];
          modifier.closed = true;
        }

        ownModifiers.push(modifier);
      }

      this.addProcessedElement(arr[i], i + 1);
    }

    this.removeTransformFromStyleList();
    this.closeStyles(ownStyles);
    len = ownModifiers.length;

    for (i = 0; i < len; i += 1) {
      ownModifiers[i].closed = true;
    }
  };

  CVShapeElement.prototype.renderInnerContent = function () {
    this.transformHelper.opacity = 1;
    this.transformHelper._opMdf = false;
    this.renderModifiers();
    this.transformsManager.processSequences(this._isFirstFrame);
    this.renderShape(this.transformHelper, this.shapesData, this.itemsData, true);
  };

  CVShapeElement.prototype.renderShapeTransform = function (parentTransform, groupTransform) {
    if (parentTransform._opMdf || groupTransform.op._mdf || this._isFirstFrame) {
      groupTransform.opacity = parentTransform.opacity;
      groupTransform.opacity *= groupTransform.op.v;
      groupTransform._opMdf = true;
    }
  };

  CVShapeElement.prototype.drawLayer = function () {
    var i;
    var len = this.stylesList.length;
    var j;
    var jLen;
    var k;
    var kLen;
    var elems;
    var nodes;
    var renderer = this.globalData.renderer;
    var ctx = this.globalData.canvasContext;
    var type;
    var currentStyle;

    for (i = 0; i < len; i += 1) {
      currentStyle = this.stylesList[i];
      type = currentStyle.type; // Skipping style when
      // Stroke width equals 0
      // style should not be rendered (extra unused repeaters)
      // current opacity equals 0
      // global opacity equals 0

      if (!((type === 'st' || type === 'gs') && currentStyle.wi === 0 || !currentStyle.data._shouldRender || currentStyle.coOp === 0 || this.globalData.currentGlobalAlpha === 0)) {
        renderer.save();
        elems = currentStyle.elements;

        if (type === 'st' || type === 'gs') {
          renderer.ctxStrokeStyle(type === 'st' ? currentStyle.co : currentStyle.grd); // ctx.strokeStyle = type === 'st' ? currentStyle.co : currentStyle.grd;

          renderer.ctxLineWidth(currentStyle.wi); // ctx.lineWidth = currentStyle.wi;

          renderer.ctxLineCap(currentStyle.lc); // ctx.lineCap = currentStyle.lc;

          renderer.ctxLineJoin(currentStyle.lj); // ctx.lineJoin = currentStyle.lj;

          renderer.ctxMiterLimit(currentStyle.ml || 0); // ctx.miterLimit = currentStyle.ml || 0;
        } else {
          renderer.ctxFillStyle(type === 'fl' ? currentStyle.co : currentStyle.grd); // ctx.fillStyle = type === 'fl' ? currentStyle.co : currentStyle.grd;
        }

        renderer.ctxOpacity(currentStyle.coOp);

        if (type !== 'st' && type !== 'gs') {
          ctx.beginPath();
        }

        renderer.ctxTransform(currentStyle.preTransforms.finalTransform.props);
        jLen = elems.length;

        for (j = 0; j < jLen; j += 1) {
          if (type === 'st' || type === 'gs') {
            ctx.beginPath();

            if (currentStyle.da) {
              ctx.setLineDash(currentStyle.da);
              ctx.lineDashOffset = currentStyle["do"];
            }
          }

          nodes = elems[j].trNodes;
          kLen = nodes.length;

          for (k = 0; k < kLen; k += 1) {
            if (nodes[k].t === 'm') {
              ctx.moveTo(nodes[k].p[0], nodes[k].p[1]);
            } else if (nodes[k].t === 'c') {
              ctx.bezierCurveTo(nodes[k].pts[0], nodes[k].pts[1], nodes[k].pts[2], nodes[k].pts[3], nodes[k].pts[4], nodes[k].pts[5]);
            } else {
              ctx.closePath();
            }
          }

          if (type === 'st' || type === 'gs') {
            // ctx.stroke();
            renderer.ctxStroke();

            if (currentStyle.da) {
              ctx.setLineDash(this.dashResetter);
            }
          }
        }

        if (type !== 'st' && type !== 'gs') {
          // ctx.fill(currentStyle.r);
          this.globalData.renderer.ctxFill(currentStyle.r);
        }

        renderer.restore();
      }
    }
  };

  CVShapeElement.prototype.renderShape = function (parentTransform, items, data, isMain) {
    var i;
    var len = items.length - 1;
    var groupTransform;
    groupTransform = parentTransform;

    for (i = len; i >= 0; i -= 1) {
      if (items[i].ty === 'tr') {
        groupTransform = data[i].transform;
        this.renderShapeTransform(parentTransform, groupTransform);
      } else if (items[i].ty === 'sh' || items[i].ty === 'el' || items[i].ty === 'rc' || items[i].ty === 'sr') {
        this.renderPath(items[i], data[i]);
      } else if (items[i].ty === 'fl') {
        this.renderFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'st') {
        this.renderStroke(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gf' || items[i].ty === 'gs') {
        this.renderGradientFill(items[i], data[i], groupTransform);
      } else if (items[i].ty === 'gr') {
        this.renderShape(groupTransform, items[i].it, data[i].it);
      } else if (items[i].ty === 'tm') {//
      }
    }

    if (isMain) {
      this.drawLayer();
    }
  };

  CVShapeElement.prototype.renderStyledShape = function (styledShape, shape) {
    if (this._isFirstFrame || shape._mdf || styledShape.transforms._mdf) {
      var shapeNodes = styledShape.trNodes;
      var paths = shape.paths;
      var i;
      var len;
      var j;
      var jLen = paths._length;
      shapeNodes.length = 0;
      var groupTransformMat = styledShape.transforms.finalTransform;

      for (j = 0; j < jLen; j += 1) {
        var pathNodes = paths.shapes[j];

        if (pathNodes && pathNodes.v) {
          len = pathNodes._length;

          for (i = 1; i < len; i += 1) {
            if (i === 1) {
              shapeNodes.push({
                t: 'm',
                p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
              });
            }

            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[i], pathNodes.v[i])
            });
          }

          if (len === 1) {
            shapeNodes.push({
              t: 'm',
              p: groupTransformMat.applyToPointArray(pathNodes.v[0][0], pathNodes.v[0][1], 0)
            });
          }

          if (pathNodes.c && len) {
            shapeNodes.push({
              t: 'c',
              pts: groupTransformMat.applyToTriplePoints(pathNodes.o[i - 1], pathNodes.i[0], pathNodes.v[0])
            });
            shapeNodes.push({
              t: 'z'
            });
          }
        }
      }

      styledShape.trNodes = shapeNodes;
    }
  };

  CVShapeElement.prototype.renderPath = function (pathData, itemData) {
    if (pathData.hd !== true && pathData._shouldRender) {
      var i;
      var len = itemData.styledShapes.length;

      for (i = 0; i < len; i += 1) {
        this.renderStyledShape(itemData.styledShapes[i], itemData.sh);
      }
    }
  };

  CVShapeElement.prototype.renderFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;

    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }

    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }
  };

  CVShapeElement.prototype.renderGradientFill = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var grd;

    if (!styleElem.grd || itemData.g._mdf || itemData.s._mdf || itemData.e._mdf || styleData.t !== 1 && (itemData.h._mdf || itemData.a._mdf)) {
      var ctx = this.globalData.canvasContext;
      var pt1 = itemData.s.v;
      var pt2 = itemData.e.v;

      if (styleData.t === 1) {
        grd = ctx.createLinearGradient(pt1[0], pt1[1], pt2[0], pt2[1]);
      } else {
        var rad = Math.sqrt(Math.pow(pt1[0] - pt2[0], 2) + Math.pow(pt1[1] - pt2[1], 2));
        var ang = Math.atan2(pt2[1] - pt1[1], pt2[0] - pt1[0]);
        var percent = itemData.h.v;

        if (percent >= 1) {
          percent = 0.99;
        } else if (percent <= -1) {
          percent = -0.99;
        }

        var dist = rad * percent;
        var x = Math.cos(ang + itemData.a.v) * dist + pt1[0];
        var y = Math.sin(ang + itemData.a.v) * dist + pt1[1];
        grd = ctx.createRadialGradient(x, y, 0, pt1[0], pt1[1], rad);
      }

      var i;
      var len = styleData.g.p;
      var cValues = itemData.g.c;
      var opacity = 1;

      for (i = 0; i < len; i += 1) {
        if (itemData.g._hasOpacity && itemData.g._collapsable) {
          opacity = itemData.g.o[i * 2 + 1];
        }

        grd.addColorStop(cValues[i * 4] / 100, 'rgba(' + cValues[i * 4 + 1] + ',' + cValues[i * 4 + 2] + ',' + cValues[i * 4 + 3] + ',' + opacity + ')');
      }

      styleElem.grd = grd;
    }

    styleElem.coOp = itemData.o.v * groupTransform.opacity;
  };

  CVShapeElement.prototype.renderStroke = function (styleData, itemData, groupTransform) {
    var styleElem = itemData.style;
    var d = itemData.d;

    if (d && (d._mdf || this._isFirstFrame)) {
      styleElem.da = d.dashArray;
      styleElem["do"] = d.dashoffset[0];
    }

    if (itemData.c._mdf || this._isFirstFrame) {
      styleElem.co = 'rgb(' + bmFloor(itemData.c.v[0]) + ',' + bmFloor(itemData.c.v[1]) + ',' + bmFloor(itemData.c.v[2]) + ')';
    }

    if (itemData.o._mdf || groupTransform._opMdf || this._isFirstFrame) {
      styleElem.coOp = itemData.o.v * groupTransform.opacity;
    }

    if (itemData.w._mdf || this._isFirstFrame) {
      styleElem.wi = itemData.w.v;
    }
  };

  CVShapeElement.prototype.destroy = function () {
    this.shapesData = null;
    this.globalData = null;
    this.canvasContext = null;
    this.stylesList.length = 0;
    this.itemsData.length = 0;
  };

  function CVTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.yOffset = 0;
    this.fillColorAnim = false;
    this.strokeColorAnim = false;
    this.strokeWidthAnim = false;
    this.stroke = false;
    this.fill = false;
    this.justifyOffset = 0;
    this.currentRender = null;
    this.renderType = 'canvas';
    this.values = {
      fill: 'rgba(0,0,0,0)',
      stroke: 'rgba(0,0,0,0)',
      sWidth: 0,
      fValue: ''
    };
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement, ITextElement], CVTextElement);
  CVTextElement.prototype.tHelper = createTag('canvas').getContext('2d');

  CVTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var hasFill = false;

    if (documentData.fc) {
      hasFill = true;
      this.values.fill = this.buildColor(documentData.fc);
    } else {
      this.values.fill = 'rgba(0,0,0,0)';
    }

    this.fill = hasFill;
    var hasStroke = false;

    if (documentData.sc) {
      hasStroke = true;
      this.values.stroke = this.buildColor(documentData.sc);
      this.values.sWidth = documentData.sw;
    }

    var fontData = this.globalData.fontManager.getFontByName(documentData.f);
    var i;
    var len;
    var letters = documentData.l;
    var matrixHelper = this.mHelper;
    this.stroke = hasStroke;
    this.values.fValue = documentData.finalSize + 'px ' + this.globalData.fontManager.getFontByName(documentData.f).fFamily;
    len = documentData.finalText.length; // this.tHelper.font = this.values.fValue;

    var charData;
    var shapeData;
    var k;
    var kLen;
    var shapes;
    var j;
    var jLen;
    var pathNodes;
    var commands;
    var pathArr;
    var singleShape = this.data.singleShape;
    var trackingOffset = documentData.tr * 0.001 * documentData.finalSize;
    var xPos = 0;
    var yPos = 0;
    var firstLine = true;
    var cnt = 0;

    for (i = 0; i < len; i += 1) {
      charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
      shapeData = charData && charData.data || {};
      matrixHelper.reset();

      if (singleShape && letters[i].n) {
        xPos = -trackingOffset;
        yPos += documentData.yOffset;
        yPos += firstLine ? 1 : 0;
        firstLine = false;
      }

      shapes = shapeData.shapes ? shapeData.shapes[0].it : [];
      jLen = shapes.length;
      matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);

      if (singleShape) {
        this.applyTextPropertiesToMatrix(documentData, matrixHelper, letters[i].line, xPos, yPos);
      }

      commands = createSizedArray(jLen - 1);
      var commandsCounter = 0;

      for (j = 0; j < jLen; j += 1) {
        if (shapes[j].ty === 'sh') {
          kLen = shapes[j].ks.k.i.length;
          pathNodes = shapes[j].ks.k;
          pathArr = [];

          for (k = 1; k < kLen; k += 1) {
            if (k === 1) {
              pathArr.push(matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
            }

            pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToY(pathNodes.i[k][0], pathNodes.i[k][1], 0), matrixHelper.applyToX(pathNodes.v[k][0], pathNodes.v[k][1], 0), matrixHelper.applyToY(pathNodes.v[k][0], pathNodes.v[k][1], 0));
          }

          pathArr.push(matrixHelper.applyToX(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToY(pathNodes.o[k - 1][0], pathNodes.o[k - 1][1], 0), matrixHelper.applyToX(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToY(pathNodes.i[0][0], pathNodes.i[0][1], 0), matrixHelper.applyToX(pathNodes.v[0][0], pathNodes.v[0][1], 0), matrixHelper.applyToY(pathNodes.v[0][0], pathNodes.v[0][1], 0));
          commands[commandsCounter] = pathArr;
          commandsCounter += 1;
        }
      }

      if (singleShape) {
        xPos += letters[i].l;
        xPos += trackingOffset;
      }

      if (this.textSpans[cnt]) {
        this.textSpans[cnt].elem = commands;
      } else {
        this.textSpans[cnt] = {
          elem: commands
        };
      }

      cnt += 1;
    }
  };

  CVTextElement.prototype.renderInnerContent = function () {
    this.validateText();
    var ctx = this.canvasContext;
    ctx.font = this.values.fValue;
    this.globalData.renderer.ctxLineCap('butt'); // ctx.lineCap = 'butt';

    this.globalData.renderer.ctxLineJoin('miter'); // ctx.lineJoin = 'miter';

    this.globalData.renderer.ctxMiterLimit(4); // ctx.miterLimit = 4;

    if (!this.data.singleShape) {
      this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);
    }

    var i;
    var len;
    var j;
    var jLen;
    var k;
    var kLen;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var lastFill = null;
    var lastStroke = null;
    var lastStrokeW = null;
    var commands;
    var pathArr;
    var renderer = this.globalData.renderer;

    for (i = 0; i < len; i += 1) {
      if (!letters[i].n) {
        renderedLetter = renderedLetters[i];

        if (renderedLetter) {
          renderer.save();
          renderer.ctxTransform(renderedLetter.p);
          renderer.ctxOpacity(renderedLetter.o);
        }

        if (this.fill) {
          if (renderedLetter && renderedLetter.fc) {
            if (lastFill !== renderedLetter.fc) {
              renderer.ctxFillStyle(renderedLetter.fc);
              lastFill = renderedLetter.fc; // ctx.fillStyle = renderedLetter.fc;
            }
          } else if (lastFill !== this.values.fill) {
            lastFill = this.values.fill;
            renderer.ctxFillStyle(this.values.fill); // ctx.fillStyle = this.values.fill;
          }

          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();

          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }

          this.globalData.canvasContext.closePath();
          renderer.ctxFill(); // this.globalData.canvasContext.fill();
          /// ctx.fillText(this.textSpans[i].val,0,0);
        }

        if (this.stroke) {
          if (renderedLetter && renderedLetter.sw) {
            if (lastStrokeW !== renderedLetter.sw) {
              lastStrokeW = renderedLetter.sw;
              renderer.ctxLineWidth(renderedLetter.sw); // ctx.lineWidth = renderedLetter.sw;
            }
          } else if (lastStrokeW !== this.values.sWidth) {
            lastStrokeW = this.values.sWidth;
            renderer.ctxLineWidth(this.values.sWidth); // ctx.lineWidth = this.values.sWidth;
          }

          if (renderedLetter && renderedLetter.sc) {
            if (lastStroke !== renderedLetter.sc) {
              lastStroke = renderedLetter.sc;
              renderer.ctxStrokeStyle(renderedLetter.sc); // ctx.strokeStyle = renderedLetter.sc;
            }
          } else if (lastStroke !== this.values.stroke) {
            lastStroke = this.values.stroke;
            renderer.ctxStrokeStyle(this.values.stroke); // ctx.strokeStyle = this.values.stroke;
          }

          commands = this.textSpans[i].elem;
          jLen = commands.length;
          this.globalData.canvasContext.beginPath();

          for (j = 0; j < jLen; j += 1) {
            pathArr = commands[j];
            kLen = pathArr.length;
            this.globalData.canvasContext.moveTo(pathArr[0], pathArr[1]);

            for (k = 2; k < kLen; k += 6) {
              this.globalData.canvasContext.bezierCurveTo(pathArr[k], pathArr[k + 1], pathArr[k + 2], pathArr[k + 3], pathArr[k + 4], pathArr[k + 5]);
            }
          }

          this.globalData.canvasContext.closePath();
          renderer.ctxStroke(); // this.globalData.canvasContext.stroke();
          /// ctx.strokeText(letters[i].val,0,0);
        }

        if (renderedLetter) {
          this.globalData.renderer.restore();
        }
      }
    }
  };

  function CVImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.img = globalData.imageLoader.getAsset(this.assetData);
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVImageElement);
  CVImageElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVImageElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

  CVImageElement.prototype.createContent = function () {
    if (this.img.width && (this.assetData.w !== this.img.width || this.assetData.h !== this.img.height)) {
      var canvas = createTag('canvas');
      canvas.width = this.assetData.w;
      canvas.height = this.assetData.h;
      var ctx = canvas.getContext('2d');
      var imgW = this.img.width;
      var imgH = this.img.height;
      var imgRel = imgW / imgH;
      var canvasRel = this.assetData.w / this.assetData.h;
      var widthCrop;
      var heightCrop;
      var par = this.assetData.pr || this.globalData.renderConfig.imagePreserveAspectRatio;

      if (imgRel > canvasRel && par === 'xMidYMid slice' || imgRel < canvasRel && par !== 'xMidYMid slice') {
        heightCrop = imgH;
        widthCrop = heightCrop * canvasRel;
      } else {
        widthCrop = imgW;
        heightCrop = widthCrop / canvasRel;
      }

      ctx.drawImage(this.img, (imgW - widthCrop) / 2, (imgH - heightCrop) / 2, widthCrop, heightCrop, 0, 0, this.assetData.w, this.assetData.h);
      this.img = canvas;
    }
  };

  CVImageElement.prototype.renderInnerContent = function () {
    this.canvasContext.drawImage(this.img, 0, 0);
  };

  CVImageElement.prototype.destroy = function () {
    this.img = null;
  };

  function CVSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, CVBaseElement, HierarchyElement, FrameElement, RenderableElement], CVSolidElement);
  CVSolidElement.prototype.initElement = SVGShapeElement.prototype.initElement;
  CVSolidElement.prototype.prepareFrame = IImageElement.prototype.prepareFrame;

  CVSolidElement.prototype.renderInnerContent = function () {
    // var ctx = this.canvasContext;
    this.globalData.renderer.ctxFillStyle(this.data.sc); // ctx.fillStyle = this.data.sc;

    this.globalData.renderer.ctxFillRect(0, 0, this.data.sw, this.data.sh); // ctx.fillRect(0, 0, this.data.sw, this.data.sh);
    //
  };

  function CanvasRendererBase() {}

  extendPrototype([BaseRenderer], CanvasRendererBase);

  CanvasRendererBase.prototype.createShape = function (data) {
    return new CVShapeElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createText = function (data) {
    return new CVTextElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createImage = function (data) {
    return new CVImageElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createSolid = function (data) {
    return new CVSolidElement(data, this.globalData, this);
  };

  CanvasRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

  CanvasRendererBase.prototype.ctxTransform = function (props) {
    if (props[0] === 1 && props[1] === 0 && props[4] === 0 && props[5] === 1 && props[12] === 0 && props[13] === 0) {
      return;
    }

    this.canvasContext.transform(props[0], props[1], props[4], props[5], props[12], props[13]);
  };

  CanvasRendererBase.prototype.ctxOpacity = function (op) {
    this.canvasContext.globalAlpha *= op < 0 ? 0 : op;
  };

  CanvasRendererBase.prototype.ctxFillStyle = function (value) {
    this.canvasContext.fillStyle = value;
  };

  CanvasRendererBase.prototype.ctxStrokeStyle = function (value) {
    this.canvasContext.strokeStyle = value;
  };

  CanvasRendererBase.prototype.ctxLineWidth = function (value) {
    this.canvasContext.lineWidth = value;
  };

  CanvasRendererBase.prototype.ctxLineCap = function (value) {
    this.canvasContext.lineCap = value;
  };

  CanvasRendererBase.prototype.ctxLineJoin = function (value) {
    this.canvasContext.lineJoin = value;
  };

  CanvasRendererBase.prototype.ctxMiterLimit = function (value) {
    this.canvasContext.miterLimit = value;
  };

  CanvasRendererBase.prototype.ctxFill = function (rule) {
    this.canvasContext.fill(rule);
  };

  CanvasRendererBase.prototype.ctxFillRect = function (x, y, w, h) {
    this.canvasContext.fillRect(x, y, w, h);
  };

  CanvasRendererBase.prototype.ctxStroke = function () {
    this.canvasContext.stroke();
  };

  CanvasRendererBase.prototype.reset = function () {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }

    this.contextData.reset();
  };

  CanvasRendererBase.prototype.save = function () {
    this.canvasContext.save();
  };

  CanvasRendererBase.prototype.restore = function (actionFlag) {
    if (!this.renderConfig.clearCanvas) {
      this.canvasContext.restore();
      return;
    }

    if (actionFlag) {
      this.globalData.blendMode = 'source-over';
    }

    this.contextData.restore(actionFlag);
  };

  CanvasRendererBase.prototype.configAnimation = function (animData) {
    if (this.animationItem.wrapper) {
      this.animationItem.container = createTag('canvas');
      var containerStyle = this.animationItem.container.style;
      containerStyle.width = '100%';
      containerStyle.height = '100%';
      var origin = '0px 0px 0px';
      containerStyle.transformOrigin = origin;
      containerStyle.mozTransformOrigin = origin;
      containerStyle.webkitTransformOrigin = origin;
      containerStyle['-webkit-transform'] = origin;
      containerStyle.contentVisibility = this.renderConfig.contentVisibility;
      this.animationItem.wrapper.appendChild(this.animationItem.container);
      this.canvasContext = this.animationItem.container.getContext('2d');

      if (this.renderConfig.className) {
        this.animationItem.container.setAttribute('class', this.renderConfig.className);
      }

      if (this.renderConfig.id) {
        this.animationItem.container.setAttribute('id', this.renderConfig.id);
      }
    } else {
      this.canvasContext = this.renderConfig.context;
    }

    this.contextData.setContext(this.canvasContext);
    this.data = animData;
    this.layers = animData.layers;
    this.transformCanvas = {
      w: animData.w,
      h: animData.h,
      sx: 0,
      sy: 0,
      tx: 0,
      ty: 0
    };
    this.setupGlobalData(animData, document.body);
    this.globalData.canvasContext = this.canvasContext;
    this.globalData.renderer = this;
    this.globalData.isDashed = false;
    this.globalData.progressiveLoad = this.renderConfig.progressiveLoad;
    this.globalData.transformCanvas = this.transformCanvas;
    this.elements = createSizedArray(animData.layers.length);
    this.updateContainerSize();
  };

  CanvasRendererBase.prototype.updateContainerSize = function (width, height) {
    this.reset();
    var elementWidth;
    var elementHeight;

    if (width) {
      elementWidth = width;
      elementHeight = height;
      this.canvasContext.canvas.width = elementWidth;
      this.canvasContext.canvas.height = elementHeight;
    } else {
      if (this.animationItem.wrapper && this.animationItem.container) {
        elementWidth = this.animationItem.wrapper.offsetWidth;
        elementHeight = this.animationItem.wrapper.offsetHeight;
      } else {
        elementWidth = this.canvasContext.canvas.width;
        elementHeight = this.canvasContext.canvas.height;
      }

      this.canvasContext.canvas.width = elementWidth * this.renderConfig.dpr;
      this.canvasContext.canvas.height = elementHeight * this.renderConfig.dpr;
    }

    var elementRel;
    var animationRel;

    if (this.renderConfig.preserveAspectRatio.indexOf('meet') !== -1 || this.renderConfig.preserveAspectRatio.indexOf('slice') !== -1) {
      var par = this.renderConfig.preserveAspectRatio.split(' ');
      var fillType = par[1] || 'meet';
      var pos = par[0] || 'xMidYMid';
      var xPos = pos.substr(0, 4);
      var yPos = pos.substr(4);
      elementRel = elementWidth / elementHeight;
      animationRel = this.transformCanvas.w / this.transformCanvas.h;

      if (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice') {
        this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
        this.transformCanvas.sy = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      } else {
        this.transformCanvas.sx = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
        this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      }

      if (xPos === 'xMid' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) / 2 * this.renderConfig.dpr;
      } else if (xPos === 'xMax' && (animationRel < elementRel && fillType === 'meet' || animationRel > elementRel && fillType === 'slice')) {
        this.transformCanvas.tx = (elementWidth - this.transformCanvas.w * (elementHeight / this.transformCanvas.h)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.tx = 0;
      }

      if (yPos === 'YMid' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) / 2 * this.renderConfig.dpr;
      } else if (yPos === 'YMax' && (animationRel > elementRel && fillType === 'meet' || animationRel < elementRel && fillType === 'slice')) {
        this.transformCanvas.ty = (elementHeight - this.transformCanvas.h * (elementWidth / this.transformCanvas.w)) * this.renderConfig.dpr;
      } else {
        this.transformCanvas.ty = 0;
      }
    } else if (this.renderConfig.preserveAspectRatio === 'none') {
      this.transformCanvas.sx = elementWidth / (this.transformCanvas.w / this.renderConfig.dpr);
      this.transformCanvas.sy = elementHeight / (this.transformCanvas.h / this.renderConfig.dpr);
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    } else {
      this.transformCanvas.sx = this.renderConfig.dpr;
      this.transformCanvas.sy = this.renderConfig.dpr;
      this.transformCanvas.tx = 0;
      this.transformCanvas.ty = 0;
    }

    this.transformCanvas.props = [this.transformCanvas.sx, 0, 0, 0, 0, this.transformCanvas.sy, 0, 0, 0, 0, 1, 0, this.transformCanvas.tx, this.transformCanvas.ty, 0, 1];
    /* var i, len = this.elements.length;
      for(i=0;i<len;i+=1){
          if(this.elements[i] && this.elements[i].data.ty === 0){
              this.elements[i].resize(this.globalData.transformCanvas);
          }
      } */

    this.ctxTransform(this.transformCanvas.props);
    this.canvasContext.beginPath();
    this.canvasContext.rect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
    this.canvasContext.closePath();
    this.canvasContext.clip();
    this.renderFrame(this.renderedFrame, true);
  };

  CanvasRendererBase.prototype.destroy = function () {
    if (this.renderConfig.clearCanvas && this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.globalData.canvasContext = null;
    this.animationItem.container = null;
    this.destroyed = true;
  };

  CanvasRendererBase.prototype.renderFrame = function (num, forceRender) {
    if (this.renderedFrame === num && this.renderConfig.clearCanvas === true && !forceRender || this.destroyed || num === -1) {
      return;
    }

    this.renderedFrame = num;
    this.globalData.frameNum = num - this.animationItem._isFirstFrame;
    this.globalData.frameId += 1;
    this.globalData._mdf = !this.renderConfig.clearCanvas || forceRender;
    this.globalData.projectInterface.currentFrame = num; // console.log('--------');
    // console.log('NEW: ',num);

    var i;
    var len = this.layers.length;

    if (!this.completeLayers) {
      this.checkLayers(num);
    }

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].prepareFrame(num - this.layers[i].st);
      }
    }

    if (this.globalData._mdf) {
      if (this.renderConfig.clearCanvas === true) {
        this.canvasContext.clearRect(0, 0, this.transformCanvas.w, this.transformCanvas.h);
      } else {
        this.save();
      }

      for (i = len - 1; i >= 0; i -= 1) {
        if (this.completeLayers || this.elements[i]) {
          this.elements[i].renderFrame();
        }
      }

      if (this.renderConfig.clearCanvas !== true) {
        this.restore();
      }
    }
  };

  CanvasRendererBase.prototype.buildItem = function (pos) {
    var elements = this.elements;

    if (elements[pos] || this.layers[pos].ty === 99) {
      return;
    }

    var element = this.createItem(this.layers[pos], this, this.globalData);
    elements[pos] = element;
    element.initExpressions();
    /* if(this.layers[pos].ty === 0){
          element.resize(this.globalData.transformCanvas);
      } */
  };

  CanvasRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };

  CanvasRendererBase.prototype.hide = function () {
    this.animationItem.container.style.display = 'none';
  };

  CanvasRendererBase.prototype.show = function () {
    this.animationItem.container.style.display = 'block';
  };

  function CanvasContext() {
    this.opacity = -1;
    this.transform = createTypedArray('float32', 16);
    this.fillStyle = '';
    this.strokeStyle = '';
    this.lineWidth = '';
    this.lineCap = '';
    this.lineJoin = '';
    this.miterLimit = '';
    this.id = Math.random();
  }

  function CVContextData() {
    this.stack = [];
    this.cArrPos = 0;
    this.cTr = new Matrix();
    var i;
    var len = 15;

    for (i = 0; i < len; i += 1) {
      var canvasContext = new CanvasContext();
      this.stack[i] = canvasContext;
    }

    this._length = len;
    this.nativeContext = null;
    this.transformMat = new Matrix();
    this.currentOpacity = 1; //

    this.currentFillStyle = '';
    this.appliedFillStyle = ''; //

    this.currentStrokeStyle = '';
    this.appliedStrokeStyle = ''; //

    this.currentLineWidth = '';
    this.appliedLineWidth = ''; //

    this.currentLineCap = '';
    this.appliedLineCap = ''; //

    this.currentLineJoin = '';
    this.appliedLineJoin = ''; //

    this.appliedMiterLimit = '';
    this.currentMiterLimit = '';
  }

  CVContextData.prototype.duplicate = function () {
    var newLength = this._length * 2;
    var i = 0;

    for (i = this._length; i < newLength; i += 1) {
      this.stack[i] = new CanvasContext();
    }

    this._length = newLength;
  };

  CVContextData.prototype.reset = function () {
    this.cArrPos = 0;
    this.cTr.reset();
    this.stack[this.cArrPos].opacity = 1;
  };

  CVContextData.prototype.restore = function (forceRestore) {
    this.cArrPos -= 1;
    var currentContext = this.stack[this.cArrPos];
    var transform = currentContext.transform;
    var i;
    var arr = this.cTr.props;

    for (i = 0; i < 16; i += 1) {
      arr[i] = transform[i];
    }

    if (forceRestore) {
      this.nativeContext.restore();
      var prevStack = this.stack[this.cArrPos + 1];
      this.appliedFillStyle = prevStack.fillStyle;
      this.appliedStrokeStyle = prevStack.strokeStyle;
      this.appliedLineWidth = prevStack.lineWidth;
      this.appliedLineCap = prevStack.lineCap;
      this.appliedLineJoin = prevStack.lineJoin;
      this.appliedMiterLimit = prevStack.miterLimit;
    }

    this.nativeContext.setTransform(transform[0], transform[1], transform[4], transform[5], transform[12], transform[13]);

    if (forceRestore || currentContext.opacity !== -1 && this.currentOpacity !== currentContext.opacity) {
      this.nativeContext.globalAlpha = currentContext.opacity;
      this.currentOpacity = currentContext.opacity;
    }

    this.currentFillStyle = currentContext.fillStyle;
    this.currentStrokeStyle = currentContext.strokeStyle;
    this.currentLineWidth = currentContext.lineWidth;
    this.currentLineCap = currentContext.lineCap;
    this.currentLineJoin = currentContext.lineJoin;
    this.currentMiterLimit = currentContext.miterLimit;
  };

  CVContextData.prototype.save = function (saveOnNativeFlag) {
    if (saveOnNativeFlag) {
      this.nativeContext.save();
    }

    var props = this.cTr.props;

    if (this._length <= this.cArrPos) {
      this.duplicate();
    }

    var currentStack = this.stack[this.cArrPos];
    var i;

    for (i = 0; i < 16; i += 1) {
      currentStack.transform[i] = props[i];
    }

    this.cArrPos += 1;
    var newStack = this.stack[this.cArrPos];
    newStack.opacity = currentStack.opacity;
    newStack.fillStyle = currentStack.fillStyle;
    newStack.strokeStyle = currentStack.strokeStyle;
    newStack.lineWidth = currentStack.lineWidth;
    newStack.lineCap = currentStack.lineCap;
    newStack.lineJoin = currentStack.lineJoin;
    newStack.miterLimit = currentStack.miterLimit;
  };

  CVContextData.prototype.setOpacity = function (value) {
    this.stack[this.cArrPos].opacity = value;
  };

  CVContextData.prototype.setContext = function (value) {
    this.nativeContext = value;
  };

  CVContextData.prototype.fillStyle = function (value) {
    if (this.stack[this.cArrPos].fillStyle !== value) {
      this.currentFillStyle = value;
      this.stack[this.cArrPos].fillStyle = value;
    }
  };

  CVContextData.prototype.strokeStyle = function (value) {
    if (this.stack[this.cArrPos].strokeStyle !== value) {
      this.currentStrokeStyle = value;
      this.stack[this.cArrPos].strokeStyle = value;
    }
  };

  CVContextData.prototype.lineWidth = function (value) {
    if (this.stack[this.cArrPos].lineWidth !== value) {
      this.currentLineWidth = value;
      this.stack[this.cArrPos].lineWidth = value;
    }
  };

  CVContextData.prototype.lineCap = function (value) {
    if (this.stack[this.cArrPos].lineCap !== value) {
      this.currentLineCap = value;
      this.stack[this.cArrPos].lineCap = value;
    }
  };

  CVContextData.prototype.lineJoin = function (value) {
    if (this.stack[this.cArrPos].lineJoin !== value) {
      this.currentLineJoin = value;
      this.stack[this.cArrPos].lineJoin = value;
    }
  };

  CVContextData.prototype.miterLimit = function (value) {
    if (this.stack[this.cArrPos].miterLimit !== value) {
      this.currentMiterLimit = value;
      this.stack[this.cArrPos].miterLimit = value;
    }
  };

  CVContextData.prototype.transform = function (props) {
    this.transformMat.cloneFromProps(props); // Taking the last transform value from the stored stack of transforms

    var currentTransform = this.cTr; // Applying the last transform value after the new transform to respect the order of transformations

    this.transformMat.multiply(currentTransform); // Storing the new transformed value in the stored transform

    currentTransform.cloneFromProps(this.transformMat.props);
    var trProps = currentTransform.props; // Applying the new transform to the canvas

    this.nativeContext.setTransform(trProps[0], trProps[1], trProps[4], trProps[5], trProps[12], trProps[13]);
  };

  CVContextData.prototype.opacity = function (op) {
    var currentOpacity = this.stack[this.cArrPos].opacity;
    currentOpacity *= op < 0 ? 0 : op;

    if (this.stack[this.cArrPos].opacity !== currentOpacity) {
      if (this.currentOpacity !== op) {
        this.nativeContext.globalAlpha = op;
        this.currentOpacity = op;
      }

      this.stack[this.cArrPos].opacity = currentOpacity;
    }
  };

  CVContextData.prototype.fill = function (rule) {
    if (this.appliedFillStyle !== this.currentFillStyle) {
      this.appliedFillStyle = this.currentFillStyle;
      this.nativeContext.fillStyle = this.appliedFillStyle;
    }

    this.nativeContext.fill(rule);
  };

  CVContextData.prototype.fillRect = function (x, y, w, h) {
    if (this.appliedFillStyle !== this.currentFillStyle) {
      this.appliedFillStyle = this.currentFillStyle;
      this.nativeContext.fillStyle = this.appliedFillStyle;
    }

    this.nativeContext.fillRect(x, y, w, h);
  };

  CVContextData.prototype.stroke = function () {
    if (this.appliedStrokeStyle !== this.currentStrokeStyle) {
      this.appliedStrokeStyle = this.currentStrokeStyle;
      this.nativeContext.strokeStyle = this.appliedStrokeStyle;
    }

    if (this.appliedLineWidth !== this.currentLineWidth) {
      this.appliedLineWidth = this.currentLineWidth;
      this.nativeContext.lineWidth = this.appliedLineWidth;
    }

    if (this.appliedLineCap !== this.currentLineCap) {
      this.appliedLineCap = this.currentLineCap;
      this.nativeContext.lineCap = this.appliedLineCap;
    }

    if (this.appliedLineJoin !== this.currentLineJoin) {
      this.appliedLineJoin = this.currentLineJoin;
      this.nativeContext.lineJoin = this.appliedLineJoin;
    }

    if (this.appliedMiterLimit !== this.currentMiterLimit) {
      this.appliedMiterLimit = this.currentMiterLimit;
      this.nativeContext.miterLimit = this.appliedMiterLimit;
    }

    this.nativeContext.stroke();
  };

  function CVCompElement(data, globalData, comp) {
    this.completeLayers = false;
    this.layers = data.layers;
    this.pendingElements = [];
    this.elements = createSizedArray(this.layers.length);
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([CanvasRendererBase, ICompElement, CVBaseElement], CVCompElement);

  CVCompElement.prototype.renderInnerContent = function () {
    var ctx = this.canvasContext;
    ctx.beginPath();
    ctx.moveTo(0, 0);
    ctx.lineTo(this.data.w, 0);
    ctx.lineTo(this.data.w, this.data.h);
    ctx.lineTo(0, this.data.h);
    ctx.lineTo(0, 0);
    ctx.clip();
    var i;
    var len = this.layers.length;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.completeLayers || this.elements[i]) {
        this.elements[i].renderFrame();
      }
    }
  };

  CVCompElement.prototype.destroy = function () {
    var i;
    var len = this.layers.length;

    for (i = len - 1; i >= 0; i -= 1) {
      if (this.elements[i]) {
        this.elements[i].destroy();
      }
    }

    this.layers = null;
    this.elements = null;
  };

  CVCompElement.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function CanvasRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.renderConfig = {
      clearCanvas: config && config.clearCanvas !== undefined ? config.clearCanvas : true,
      context: config && config.context || null,
      progressiveLoad: config && config.progressiveLoad || false,
      preserveAspectRatio: config && config.preserveAspectRatio || 'xMidYMid meet',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      contentVisibility: config && config.contentVisibility || 'visible',
      className: config && config.className || '',
      id: config && config.id || '',
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.renderConfig.dpr = config && config.dpr || 1;

    if (this.animationItem.wrapper) {
      this.renderConfig.dpr = config && config.dpr || window.devicePixelRatio || 1;
    }

    this.renderedFrame = -1;
    this.globalData = {
      frameNum: -1,
      _mdf: false,
      renderConfig: this.renderConfig,
      currentGlobalAlpha: -1
    };
    this.contextData = new CVContextData();
    this.elements = [];
    this.pendingElements = [];
    this.transformMat = new Matrix();
    this.completeLayers = false;
    this.rendererType = 'canvas';

    if (this.renderConfig.clearCanvas) {
      this.ctxTransform = this.contextData.transform.bind(this.contextData);
      this.ctxOpacity = this.contextData.opacity.bind(this.contextData);
      this.ctxFillStyle = this.contextData.fillStyle.bind(this.contextData);
      this.ctxStrokeStyle = this.contextData.strokeStyle.bind(this.contextData);
      this.ctxLineWidth = this.contextData.lineWidth.bind(this.contextData);
      this.ctxLineCap = this.contextData.lineCap.bind(this.contextData);
      this.ctxLineJoin = this.contextData.lineJoin.bind(this.contextData);
      this.ctxMiterLimit = this.contextData.miterLimit.bind(this.contextData);
      this.ctxFill = this.contextData.fill.bind(this.contextData);
      this.ctxFillRect = this.contextData.fillRect.bind(this.contextData);
      this.ctxStroke = this.contextData.stroke.bind(this.contextData);
      this.save = this.contextData.save.bind(this.contextData);
    }
  }

  extendPrototype([CanvasRendererBase], CanvasRenderer);

  CanvasRenderer.prototype.createComp = function (data) {
    return new CVCompElement(data, this.globalData, this);
  };

  function HBaseElement() {}

  HBaseElement.prototype = {
    checkBlendMode: function checkBlendMode() {},
    initRendererElement: function initRendererElement() {
      this.baseElement = createTag(this.data.tg || 'div');

      if (this.data.hasMask) {
        this.svgElement = createNS('svg');
        this.layerElement = createNS('g');
        this.maskedElement = this.layerElement;
        this.svgElement.appendChild(this.layerElement);
        this.baseElement.appendChild(this.svgElement);
      } else {
        this.layerElement = this.baseElement;
      }

      styleDiv(this.baseElement);
    },
    createContainerElements: function createContainerElements() {
      this.renderableEffectsManager = new CVEffects(this);
      this.transformedElement = this.baseElement;
      this.maskedElement = this.layerElement;

      if (this.data.ln) {
        this.layerElement.setAttribute('id', this.data.ln);
      }

      if (this.data.cl) {
        this.layerElement.setAttribute('class', this.data.cl);
      }

      if (this.data.bm !== 0) {
        this.setBlendMode();
      }
    },
    renderElement: function renderElement() {
      var transformedElementStyle = this.transformedElement ? this.transformedElement.style : {};

      if (this.finalTransform._matMdf) {
        var matrixValue = this.finalTransform.mat.toCSS();
        transformedElementStyle.transform = matrixValue;
        transformedElementStyle.webkitTransform = matrixValue;
      }

      if (this.finalTransform._opMdf) {
        transformedElementStyle.opacity = this.finalTransform.mProp.o.v;
      }
    },
    renderFrame: function renderFrame() {
      // If it is exported as hidden (data.hd === true) no need to render
      // If it is not visible no need to render
      if (this.data.hd || this.hidden) {
        return;
      }

      this.renderTransform();
      this.renderRenderable();
      this.renderElement();
      this.renderInnerContent();

      if (this._isFirstFrame) {
        this._isFirstFrame = false;
      }
    },
    destroy: function destroy() {
      this.layerElement = null;
      this.transformedElement = null;

      if (this.matteElement) {
        this.matteElement = null;
      }

      if (this.maskManager) {
        this.maskManager.destroy();
        this.maskManager = null;
      }
    },
    createRenderableComponents: function createRenderableComponents() {
      this.maskManager = new MaskElement(this.data, this, this.globalData);
    },
    addEffects: function addEffects() {},
    setMatte: function setMatte() {}
  };
  HBaseElement.prototype.getBaseElement = SVGBaseElement.prototype.getBaseElement;
  HBaseElement.prototype.destroyBaseElement = HBaseElement.prototype.destroy;
  HBaseElement.prototype.buildElementParenting = BaseRenderer.prototype.buildElementParenting;

  function HSolidElement(data, globalData, comp) {
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement], HSolidElement);

  HSolidElement.prototype.createContent = function () {
    var rect;

    if (this.data.hasMask) {
      rect = createNS('rect');
      rect.setAttribute('width', this.data.sw);
      rect.setAttribute('height', this.data.sh);
      rect.setAttribute('fill', this.data.sc);
      this.svgElement.setAttribute('width', this.data.sw);
      this.svgElement.setAttribute('height', this.data.sh);
    } else {
      rect = createTag('div');
      rect.style.width = this.data.sw + 'px';
      rect.style.height = this.data.sh + 'px';
      rect.style.backgroundColor = this.data.sc;
    }

    this.layerElement.appendChild(rect);
  };

  function HShapeElement(data, globalData, comp) {
    // List of drawable elements
    this.shapes = []; // Full shape data

    this.shapesData = data.shapes; // List of styles that will be applied to shapes

    this.stylesList = []; // List of modifiers that will be applied to shapes

    this.shapeModifiers = []; // List of items in shape tree

    this.itemsData = []; // List of items in previous shape tree

    this.processedElements = []; // List of animated components

    this.animatedContents = [];
    this.shapesContainer = createNS('g');
    this.initElement(data, globalData, comp); // Moving any property that doesn't get too much access after initialization because of v8 way of handling more than 10 properties.
    // List of elements that have been created

    this.prevViewData = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
  }

  extendPrototype([BaseElement, TransformElement, HSolidElement, SVGShapeElement, HBaseElement, HierarchyElement, FrameElement, RenderableElement], HShapeElement);
  HShapeElement.prototype._renderShapeFrame = HShapeElement.prototype.renderInnerContent;

  HShapeElement.prototype.createContent = function () {
    var cont;
    this.baseElement.style.fontSize = 0;

    if (this.data.hasMask) {
      this.layerElement.appendChild(this.shapesContainer);
      cont = this.svgElement;
    } else {
      cont = createNS('svg');
      var size = this.comp.data ? this.comp.data : this.globalData.compSize;
      cont.setAttribute('width', size.w);
      cont.setAttribute('height', size.h);
      cont.appendChild(this.shapesContainer);
      this.layerElement.appendChild(cont);
    }

    this.searchShapes(this.shapesData, this.itemsData, this.prevViewData, this.shapesContainer, 0, [], true);
    this.filterUniqueShapes();
    this.shapeCont = cont;
  };

  HShapeElement.prototype.getTransformedPoint = function (transformers, point) {
    var i;
    var len = transformers.length;

    for (i = 0; i < len; i += 1) {
      point = transformers[i].mProps.v.applyToPointArray(point[0], point[1], 0);
    }

    return point;
  };

  HShapeElement.prototype.calculateShapeBoundingBox = function (item, boundingBox) {
    var shape = item.sh.v;
    var transformers = item.transformers;
    var i;
    var len = shape._length;
    var vPoint;
    var oPoint;
    var nextIPoint;
    var nextVPoint;

    if (len <= 1) {
      return;
    }

    for (i = 0; i < len - 1; i += 1) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[i + 1]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[i + 1]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }

    if (shape.c) {
      vPoint = this.getTransformedPoint(transformers, shape.v[i]);
      oPoint = this.getTransformedPoint(transformers, shape.o[i]);
      nextIPoint = this.getTransformedPoint(transformers, shape.i[0]);
      nextVPoint = this.getTransformedPoint(transformers, shape.v[0]);
      this.checkBounds(vPoint, oPoint, nextIPoint, nextVPoint, boundingBox);
    }
  };

  HShapeElement.prototype.checkBounds = function (vPoint, oPoint, nextIPoint, nextVPoint, boundingBox) {
    this.getBoundsOfCurve(vPoint, oPoint, nextIPoint, nextVPoint);
    var bounds = this.shapeBoundingBox;
    boundingBox.x = bmMin(bounds.left, boundingBox.x);
    boundingBox.xMax = bmMax(bounds.right, boundingBox.xMax);
    boundingBox.y = bmMin(bounds.top, boundingBox.y);
    boundingBox.yMax = bmMax(bounds.bottom, boundingBox.yMax);
  };

  HShapeElement.prototype.shapeBoundingBox = {
    left: 0,
    right: 0,
    top: 0,
    bottom: 0
  };
  HShapeElement.prototype.tempBoundingBox = {
    x: 0,
    xMax: 0,
    y: 0,
    yMax: 0,
    width: 0,
    height: 0
  };

  HShapeElement.prototype.getBoundsOfCurve = function (p0, p1, p2, p3) {
    var bounds = [[p0[0], p3[0]], [p0[1], p3[1]]];

    for (var a, b, c, t, b2ac, t1, t2, i = 0; i < 2; ++i) {
      // eslint-disable-line no-plusplus
      b = 6 * p0[i] - 12 * p1[i] + 6 * p2[i];
      a = -3 * p0[i] + 9 * p1[i] - 9 * p2[i] + 3 * p3[i];
      c = 3 * p1[i] - 3 * p0[i];
      b |= 0; // eslint-disable-line no-bitwise

      a |= 0; // eslint-disable-line no-bitwise

      c |= 0; // eslint-disable-line no-bitwise

      if (a === 0 && b === 0) {//
      } else if (a === 0) {
        t = -c / b;

        if (t > 0 && t < 1) {
          bounds[i].push(this.calculateF(t, p0, p1, p2, p3, i));
        }
      } else {
        b2ac = b * b - 4 * c * a;

        if (b2ac >= 0) {
          t1 = (-b + bmSqrt(b2ac)) / (2 * a);
          if (t1 > 0 && t1 < 1) bounds[i].push(this.calculateF(t1, p0, p1, p2, p3, i));
          t2 = (-b - bmSqrt(b2ac)) / (2 * a);
          if (t2 > 0 && t2 < 1) bounds[i].push(this.calculateF(t2, p0, p1, p2, p3, i));
        }
      }
    }

    this.shapeBoundingBox.left = bmMin.apply(null, bounds[0]);
    this.shapeBoundingBox.top = bmMin.apply(null, bounds[1]);
    this.shapeBoundingBox.right = bmMax.apply(null, bounds[0]);
    this.shapeBoundingBox.bottom = bmMax.apply(null, bounds[1]);
  };

  HShapeElement.prototype.calculateF = function (t, p0, p1, p2, p3, i) {
    return bmPow(1 - t, 3) * p0[i] + 3 * bmPow(1 - t, 2) * t * p1[i] + 3 * (1 - t) * bmPow(t, 2) * p2[i] + bmPow(t, 3) * p3[i];
  };

  HShapeElement.prototype.calculateBoundingBox = function (itemsData, boundingBox) {
    var i;
    var len = itemsData.length;

    for (i = 0; i < len; i += 1) {
      if (itemsData[i] && itemsData[i].sh) {
        this.calculateShapeBoundingBox(itemsData[i], boundingBox);
      } else if (itemsData[i] && itemsData[i].it) {
        this.calculateBoundingBox(itemsData[i].it, boundingBox);
      } else if (itemsData[i] && itemsData[i].style && itemsData[i].w) {
        this.expandStrokeBoundingBox(itemsData[i].w, boundingBox);
      }
    }
  };

  HShapeElement.prototype.expandStrokeBoundingBox = function (widthProperty, boundingBox) {
    var width = 0;

    if (widthProperty.keyframes) {
      for (var i = 0; i < widthProperty.keyframes.length; i += 1) {
        var kfw = widthProperty.keyframes[i].s;

        if (kfw > width) {
          width = kfw;
        }
      }

      width *= widthProperty.mult;
    } else {
      width = widthProperty.v * widthProperty.mult;
    }

    boundingBox.x -= width;
    boundingBox.xMax += width;
    boundingBox.y -= width;
    boundingBox.yMax += width;
  };

  HShapeElement.prototype.currentBoxContains = function (box) {
    return this.currentBBox.x <= box.x && this.currentBBox.y <= box.y && this.currentBBox.width + this.currentBBox.x >= box.x + box.width && this.currentBBox.height + this.currentBBox.y >= box.y + box.height;
  };

  HShapeElement.prototype.renderInnerContent = function () {
    this._renderShapeFrame();

    if (!this.hidden && (this._isFirstFrame || this._mdf)) {
      var tempBoundingBox = this.tempBoundingBox;
      var max = 999999;
      tempBoundingBox.x = max;
      tempBoundingBox.xMax = -max;
      tempBoundingBox.y = max;
      tempBoundingBox.yMax = -max;
      this.calculateBoundingBox(this.itemsData, tempBoundingBox);
      tempBoundingBox.width = tempBoundingBox.xMax < tempBoundingBox.x ? 0 : tempBoundingBox.xMax - tempBoundingBox.x;
      tempBoundingBox.height = tempBoundingBox.yMax < tempBoundingBox.y ? 0 : tempBoundingBox.yMax - tempBoundingBox.y; // var tempBoundingBox = this.shapeCont.getBBox();

      if (this.currentBoxContains(tempBoundingBox)) {
        return;
      }

      var changed = false;

      if (this.currentBBox.w !== tempBoundingBox.width) {
        this.currentBBox.w = tempBoundingBox.width;
        this.shapeCont.setAttribute('width', tempBoundingBox.width);
        changed = true;
      }

      if (this.currentBBox.h !== tempBoundingBox.height) {
        this.currentBBox.h = tempBoundingBox.height;
        this.shapeCont.setAttribute('height', tempBoundingBox.height);
        changed = true;
      }

      if (changed || this.currentBBox.x !== tempBoundingBox.x || this.currentBBox.y !== tempBoundingBox.y) {
        this.currentBBox.w = tempBoundingBox.width;
        this.currentBBox.h = tempBoundingBox.height;
        this.currentBBox.x = tempBoundingBox.x;
        this.currentBBox.y = tempBoundingBox.y;
        this.shapeCont.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        var shapeStyle = this.shapeCont.style;
        var shapeTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        shapeStyle.transform = shapeTransform;
        shapeStyle.webkitTransform = shapeTransform;
      }
    }
  };

  function HTextElement(data, globalData, comp) {
    this.textSpans = [];
    this.textPaths = [];
    this.currentBBox = {
      x: 999999,
      y: -999999,
      h: 0,
      w: 0
    };
    this.renderType = 'svg';
    this.isMasked = false;
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HierarchyElement, FrameElement, RenderableDOMElement, ITextElement], HTextElement);

  HTextElement.prototype.createContent = function () {
    this.isMasked = this.checkMasks();

    if (this.isMasked) {
      this.renderType = 'svg';
      this.compW = this.comp.data.w;
      this.compH = this.comp.data.h;
      this.svgElement.setAttribute('width', this.compW);
      this.svgElement.setAttribute('height', this.compH);
      var g = createNS('g');
      this.maskedElement.appendChild(g);
      this.innerElem = g;
    } else {
      this.renderType = 'html';
      this.innerElem = this.layerElement;
    }

    this.checkParenting();
  };

  HTextElement.prototype.buildNewText = function () {
    var documentData = this.textProperty.currentData;
    this.renderedLetters = createSizedArray(documentData.l ? documentData.l.length : 0);
    var innerElemStyle = this.innerElem.style;
    var textColor = documentData.fc ? this.buildColor(documentData.fc) : 'rgba(0,0,0,0)';
    innerElemStyle.fill = textColor;
    innerElemStyle.color = textColor;

    if (documentData.sc) {
      innerElemStyle.stroke = this.buildColor(documentData.sc);
      innerElemStyle.strokeWidth = documentData.sw + 'px';
    }

    var fontData = this.globalData.fontManager.getFontByName(documentData.f);

    if (!this.globalData.fontManager.chars) {
      innerElemStyle.fontSize = documentData.finalSize + 'px';
      innerElemStyle.lineHeight = documentData.finalSize + 'px';

      if (fontData.fClass) {
        this.innerElem.className = fontData.fClass;
      } else {
        innerElemStyle.fontFamily = fontData.fFamily;
        var fWeight = documentData.fWeight;
        var fStyle = documentData.fStyle;
        innerElemStyle.fontStyle = fStyle;
        innerElemStyle.fontWeight = fWeight;
      }
    }

    var i;
    var len;
    var letters = documentData.l;
    len = letters.length;
    var tSpan;
    var tParent;
    var tCont;
    var matrixHelper = this.mHelper;
    var shapes;
    var shapeStr = '';
    var cnt = 0;

    for (i = 0; i < len; i += 1) {
      if (this.globalData.fontManager.chars) {
        if (!this.textPaths[cnt]) {
          tSpan = createNS('path');
          tSpan.setAttribute('stroke-linecap', lineCapEnum[1]);
          tSpan.setAttribute('stroke-linejoin', lineJoinEnum[2]);
          tSpan.setAttribute('stroke-miterlimit', '4');
        } else {
          tSpan = this.textPaths[cnt];
        }

        if (!this.isMasked) {
          if (this.textSpans[cnt]) {
            tParent = this.textSpans[cnt];
            tCont = tParent.children[0];
          } else {
            tParent = createTag('div');
            tParent.style.lineHeight = 0;
            tCont = createNS('svg');
            tCont.appendChild(tSpan);
            styleDiv(tParent);
          }
        }
      } else if (!this.isMasked) {
        if (this.textSpans[cnt]) {
          tParent = this.textSpans[cnt];
          tSpan = this.textPaths[cnt];
        } else {
          tParent = createTag('span');
          styleDiv(tParent);
          tSpan = createTag('span');
          styleDiv(tSpan);
          tParent.appendChild(tSpan);
        }
      } else {
        tSpan = this.textPaths[cnt] ? this.textPaths[cnt] : createNS('text');
      } // tSpan.setAttribute('visibility', 'hidden');


      if (this.globalData.fontManager.chars) {
        var charData = this.globalData.fontManager.getCharData(documentData.finalText[i], fontData.fStyle, this.globalData.fontManager.getFontByName(documentData.f).fFamily);
        var shapeData;

        if (charData) {
          shapeData = charData.data;
        } else {
          shapeData = null;
        }

        matrixHelper.reset();

        if (shapeData && shapeData.shapes && shapeData.shapes.length) {
          shapes = shapeData.shapes[0].it;
          matrixHelper.scale(documentData.finalSize / 100, documentData.finalSize / 100);
          shapeStr = this.createPathShape(matrixHelper, shapes);
          tSpan.setAttribute('d', shapeStr);
        }

        if (!this.isMasked) {
          this.innerElem.appendChild(tParent);

          if (shapeData && shapeData.shapes) {
            // document.body.appendChild is needed to get exact measure of shape
            document.body.appendChild(tCont);
            var boundingBox = tCont.getBBox();
            tCont.setAttribute('width', boundingBox.width + 2);
            tCont.setAttribute('height', boundingBox.height + 2);
            tCont.setAttribute('viewBox', boundingBox.x - 1 + ' ' + (boundingBox.y - 1) + ' ' + (boundingBox.width + 2) + ' ' + (boundingBox.height + 2));
            var tContStyle = tCont.style;
            var tContTranslation = 'translate(' + (boundingBox.x - 1) + 'px,' + (boundingBox.y - 1) + 'px)';
            tContStyle.transform = tContTranslation;
            tContStyle.webkitTransform = tContTranslation;
            letters[i].yOffset = boundingBox.y - 1;
          } else {
            tCont.setAttribute('width', 1);
            tCont.setAttribute('height', 1);
          }

          tParent.appendChild(tCont);
        } else {
          this.innerElem.appendChild(tSpan);
        }
      } else {
        tSpan.textContent = letters[i].val;
        tSpan.setAttributeNS('http://www.w3.org/XML/1998/namespace', 'xml:space', 'preserve');

        if (!this.isMasked) {
          this.innerElem.appendChild(tParent); //

          var tStyle = tSpan.style;
          var tSpanTranslation = 'translate3d(0,' + -documentData.finalSize / 1.2 + 'px,0)';
          tStyle.transform = tSpanTranslation;
          tStyle.webkitTransform = tSpanTranslation;
        } else {
          this.innerElem.appendChild(tSpan);
        }
      } //


      if (!this.isMasked) {
        this.textSpans[cnt] = tParent;
      } else {
        this.textSpans[cnt] = tSpan;
      }

      this.textSpans[cnt].style.display = 'block';
      this.textPaths[cnt] = tSpan;
      cnt += 1;
    }

    while (cnt < this.textSpans.length) {
      this.textSpans[cnt].style.display = 'none';
      cnt += 1;
    }
  };

  HTextElement.prototype.renderInnerContent = function () {
    this.validateText();
    var svgStyle;

    if (this.data.singleShape) {
      if (!this._isFirstFrame && !this.lettersChangedFlag) {
        return;
      }

      if (this.isMasked && this.finalTransform._matMdf) {
        // Todo Benchmark if using this is better than getBBox
        this.svgElement.setAttribute('viewBox', -this.finalTransform.mProp.p.v[0] + ' ' + -this.finalTransform.mProp.p.v[1] + ' ' + this.compW + ' ' + this.compH);
        svgStyle = this.svgElement.style;
        var translation = 'translate(' + -this.finalTransform.mProp.p.v[0] + 'px,' + -this.finalTransform.mProp.p.v[1] + 'px)';
        svgStyle.transform = translation;
        svgStyle.webkitTransform = translation;
      }
    }

    this.textAnimator.getMeasures(this.textProperty.currentData, this.lettersChangedFlag);

    if (!this.lettersChangedFlag && !this.textAnimator.lettersChangedFlag) {
      return;
    }

    var i;
    var len;
    var count = 0;
    var renderedLetters = this.textAnimator.renderedLetters;
    var letters = this.textProperty.currentData.l;
    len = letters.length;
    var renderedLetter;
    var textSpan;
    var textPath;

    for (i = 0; i < len; i += 1) {
      if (letters[i].n) {
        count += 1;
      } else {
        textSpan = this.textSpans[i];
        textPath = this.textPaths[i];
        renderedLetter = renderedLetters[count];
        count += 1;

        if (renderedLetter._mdf.m) {
          if (!this.isMasked) {
            textSpan.style.webkitTransform = renderedLetter.m;
            textSpan.style.transform = renderedLetter.m;
          } else {
            textSpan.setAttribute('transform', renderedLetter.m);
          }
        } /// /textSpan.setAttribute('opacity',renderedLetter.o);


        textSpan.style.opacity = renderedLetter.o;

        if (renderedLetter.sw && renderedLetter._mdf.sw) {
          textPath.setAttribute('stroke-width', renderedLetter.sw);
        }

        if (renderedLetter.sc && renderedLetter._mdf.sc) {
          textPath.setAttribute('stroke', renderedLetter.sc);
        }

        if (renderedLetter.fc && renderedLetter._mdf.fc) {
          textPath.setAttribute('fill', renderedLetter.fc);
          textPath.style.color = renderedLetter.fc;
        }
      }
    }

    if (this.innerElem.getBBox && !this.hidden && (this._isFirstFrame || this._mdf)) {
      var boundingBox = this.innerElem.getBBox();

      if (this.currentBBox.w !== boundingBox.width) {
        this.currentBBox.w = boundingBox.width;
        this.svgElement.setAttribute('width', boundingBox.width);
      }

      if (this.currentBBox.h !== boundingBox.height) {
        this.currentBBox.h = boundingBox.height;
        this.svgElement.setAttribute('height', boundingBox.height);
      }

      var margin = 1;

      if (this.currentBBox.w !== boundingBox.width + margin * 2 || this.currentBBox.h !== boundingBox.height + margin * 2 || this.currentBBox.x !== boundingBox.x - margin || this.currentBBox.y !== boundingBox.y - margin) {
        this.currentBBox.w = boundingBox.width + margin * 2;
        this.currentBBox.h = boundingBox.height + margin * 2;
        this.currentBBox.x = boundingBox.x - margin;
        this.currentBBox.y = boundingBox.y - margin;
        this.svgElement.setAttribute('viewBox', this.currentBBox.x + ' ' + this.currentBBox.y + ' ' + this.currentBBox.w + ' ' + this.currentBBox.h);
        svgStyle = this.svgElement.style;
        var svgTransform = 'translate(' + this.currentBBox.x + 'px,' + this.currentBBox.y + 'px)';
        svgStyle.transform = svgTransform;
        svgStyle.webkitTransform = svgTransform;
      }
    }
  };

  function HCameraElement(data, globalData, comp) {
    this.initFrame();
    this.initBaseData(data, globalData, comp);
    this.initHierarchy();
    var getProp = PropertyFactory.getProp;
    this.pe = getProp(this, data.pe, 0, 0, this);

    if (data.ks.p.s) {
      this.px = getProp(this, data.ks.p.x, 1, 0, this);
      this.py = getProp(this, data.ks.p.y, 1, 0, this);
      this.pz = getProp(this, data.ks.p.z, 1, 0, this);
    } else {
      this.p = getProp(this, data.ks.p, 1, 0, this);
    }

    if (data.ks.a) {
      this.a = getProp(this, data.ks.a, 1, 0, this);
    }

    if (data.ks.or.k.length && data.ks.or.k[0].to) {
      var i;
      var len = data.ks.or.k.length;

      for (i = 0; i < len; i += 1) {
        data.ks.or.k[i].to = null;
        data.ks.or.k[i].ti = null;
      }
    }

    this.or = getProp(this, data.ks.or, 1, degToRads, this);
    this.or.sh = true;
    this.rx = getProp(this, data.ks.rx, 0, degToRads, this);
    this.ry = getProp(this, data.ks.ry, 0, degToRads, this);
    this.rz = getProp(this, data.ks.rz, 0, degToRads, this);
    this.mat = new Matrix();
    this._prevMat = new Matrix();
    this._isFirstFrame = true; // TODO: find a better way to make the HCamera element to be compatible with the LayerInterface and TransformInterface.

    this.finalTransform = {
      mProp: this
    };
  }

  extendPrototype([BaseElement, FrameElement, HierarchyElement], HCameraElement);

  HCameraElement.prototype.setup = function () {
    var i;
    var len = this.comp.threeDElements.length;
    var comp;
    var perspectiveStyle;
    var containerStyle;

    for (i = 0; i < len; i += 1) {
      // [perspectiveElem,container]
      comp = this.comp.threeDElements[i];

      if (comp.type === '3d') {
        perspectiveStyle = comp.perspectiveElem.style;
        containerStyle = comp.container.style;
        var perspective = this.pe.v + 'px';
        var origin = '0px 0px 0px';
        var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
        perspectiveStyle.perspective = perspective;
        perspectiveStyle.webkitPerspective = perspective;
        containerStyle.transformOrigin = origin;
        containerStyle.mozTransformOrigin = origin;
        containerStyle.webkitTransformOrigin = origin;
        perspectiveStyle.transform = matrix;
        perspectiveStyle.webkitTransform = matrix;
      }
    }
  };

  HCameraElement.prototype.createElements = function () {};

  HCameraElement.prototype.hide = function () {};

  HCameraElement.prototype.renderFrame = function () {
    var _mdf = this._isFirstFrame;
    var i;
    var len;

    if (this.hierarchy) {
      len = this.hierarchy.length;

      for (i = 0; i < len; i += 1) {
        _mdf = this.hierarchy[i].finalTransform.mProp._mdf || _mdf;
      }
    }

    if (_mdf || this.pe._mdf || this.p && this.p._mdf || this.px && (this.px._mdf || this.py._mdf || this.pz._mdf) || this.rx._mdf || this.ry._mdf || this.rz._mdf || this.or._mdf || this.a && this.a._mdf) {
      this.mat.reset();

      if (this.hierarchy) {
        len = this.hierarchy.length - 1;

        for (i = len; i >= 0; i -= 1) {
          var mTransf = this.hierarchy[i].finalTransform.mProp;
          this.mat.translate(-mTransf.p.v[0], -mTransf.p.v[1], mTransf.p.v[2]);
          this.mat.rotateX(-mTransf.or.v[0]).rotateY(-mTransf.or.v[1]).rotateZ(mTransf.or.v[2]);
          this.mat.rotateX(-mTransf.rx.v).rotateY(-mTransf.ry.v).rotateZ(mTransf.rz.v);
          this.mat.scale(1 / mTransf.s.v[0], 1 / mTransf.s.v[1], 1 / mTransf.s.v[2]);
          this.mat.translate(mTransf.a.v[0], mTransf.a.v[1], mTransf.a.v[2]);
        }
      }

      if (this.p) {
        this.mat.translate(-this.p.v[0], -this.p.v[1], this.p.v[2]);
      } else {
        this.mat.translate(-this.px.v, -this.py.v, this.pz.v);
      }

      if (this.a) {
        var diffVector;

        if (this.p) {
          diffVector = [this.p.v[0] - this.a.v[0], this.p.v[1] - this.a.v[1], this.p.v[2] - this.a.v[2]];
        } else {
          diffVector = [this.px.v - this.a.v[0], this.py.v - this.a.v[1], this.pz.v - this.a.v[2]];
        }

        var mag = Math.sqrt(Math.pow(diffVector[0], 2) + Math.pow(diffVector[1], 2) + Math.pow(diffVector[2], 2)); // var lookDir = getNormalizedPoint(getDiffVector(this.a.v,this.p.v));

        var lookDir = [diffVector[0] / mag, diffVector[1] / mag, diffVector[2] / mag];
        var lookLengthOnXZ = Math.sqrt(lookDir[2] * lookDir[2] + lookDir[0] * lookDir[0]);
        var mRotationX = Math.atan2(lookDir[1], lookLengthOnXZ);
        var mRotationY = Math.atan2(lookDir[0], -lookDir[2]);
        this.mat.rotateY(mRotationY).rotateX(-mRotationX);
      }

      this.mat.rotateX(-this.rx.v).rotateY(-this.ry.v).rotateZ(this.rz.v);
      this.mat.rotateX(-this.or.v[0]).rotateY(-this.or.v[1]).rotateZ(this.or.v[2]);
      this.mat.translate(this.globalData.compSize.w / 2, this.globalData.compSize.h / 2, 0);
      this.mat.translate(0, 0, this.pe.v);
      var hasMatrixChanged = !this._prevMat.equals(this.mat);

      if ((hasMatrixChanged || this.pe._mdf) && this.comp.threeDElements) {
        len = this.comp.threeDElements.length;
        var comp;
        var perspectiveStyle;
        var containerStyle;

        for (i = 0; i < len; i += 1) {
          comp = this.comp.threeDElements[i];

          if (comp.type === '3d') {
            if (hasMatrixChanged) {
              var matValue = this.mat.toCSS();
              containerStyle = comp.container.style;
              containerStyle.transform = matValue;
              containerStyle.webkitTransform = matValue;
            }

            if (this.pe._mdf) {
              perspectiveStyle = comp.perspectiveElem.style;
              perspectiveStyle.perspective = this.pe.v + 'px';
              perspectiveStyle.webkitPerspective = this.pe.v + 'px';
            }
          }
        }

        this.mat.clone(this._prevMat);
      }
    }

    this._isFirstFrame = false;
  };

  HCameraElement.prototype.prepareFrame = function (num) {
    this.prepareProperties(num, true);
  };

  HCameraElement.prototype.destroy = function () {};

  HCameraElement.prototype.getBaseElement = function () {
    return null;
  };

  function HImageElement(data, globalData, comp) {
    this.assetData = globalData.getAssetData(data.refId);
    this.initElement(data, globalData, comp);
  }

  extendPrototype([BaseElement, TransformElement, HBaseElement, HSolidElement, HierarchyElement, FrameElement, RenderableElement], HImageElement);

  HImageElement.prototype.createContent = function () {
    var assetPath = this.globalData.getAssetsPath(this.assetData);
    var img = new Image();

    if (this.data.hasMask) {
      this.imageElem = createNS('image');
      this.imageElem.setAttribute('width', this.assetData.w + 'px');
      this.imageElem.setAttribute('height', this.assetData.h + 'px');
      this.imageElem.setAttributeNS('http://www.w3.org/1999/xlink', 'href', assetPath);
      this.layerElement.appendChild(this.imageElem);
      this.baseElement.setAttribute('width', this.assetData.w);
      this.baseElement.setAttribute('height', this.assetData.h);
    } else {
      this.layerElement.appendChild(img);
    }

    img.crossOrigin = 'anonymous';
    img.src = assetPath;

    if (this.data.ln) {
      this.baseElement.setAttribute('id', this.data.ln);
    }
  };

  function HybridRendererBase(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      }
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }

  extendPrototype([BaseRenderer], HybridRendererBase);
  HybridRendererBase.prototype.buildItem = SVGRenderer.prototype.buildItem;

  HybridRendererBase.prototype.checkPendingElements = function () {
    while (this.pendingElements.length) {
      var element = this.pendingElements.pop();
      element.checkParenting();
    }
  };

  HybridRendererBase.prototype.appendElementInPos = function (element, pos) {
    var newDOMElement = element.getBaseElement();

    if (!newDOMElement) {
      return;
    }

    var layer = this.layers[pos];

    if (!layer.ddd || !this.supports3d) {
      if (this.threeDElements) {
        this.addTo3dContainer(newDOMElement, pos);
      } else {
        var i = 0;
        var nextDOMElement;
        var nextLayer;
        var tmpDOMElement;

        while (i < pos) {
          if (this.elements[i] && this.elements[i] !== true && this.elements[i].getBaseElement) {
            nextLayer = this.elements[i];
            tmpDOMElement = this.layers[i].ddd ? this.getThreeDContainerByPos(i) : nextLayer.getBaseElement();
            nextDOMElement = tmpDOMElement || nextDOMElement;
          }

          i += 1;
        }

        if (nextDOMElement) {
          if (!layer.ddd || !this.supports3d) {
            this.layerElement.insertBefore(newDOMElement, nextDOMElement);
          }
        } else if (!layer.ddd || !this.supports3d) {
          this.layerElement.appendChild(newDOMElement);
        }
      }
    } else {
      this.addTo3dContainer(newDOMElement, pos);
    }
  };

  HybridRendererBase.prototype.createShape = function (data) {
    if (!this.supports3d) {
      return new SVGShapeElement(data, this.globalData, this);
    }

    return new HShapeElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createText = function (data) {
    if (!this.supports3d) {
      return new SVGTextLottieElement(data, this.globalData, this);
    }

    return new HTextElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createCamera = function (data) {
    this.camera = new HCameraElement(data, this.globalData, this);
    return this.camera;
  };

  HybridRendererBase.prototype.createImage = function (data) {
    if (!this.supports3d) {
      return new IImageElement(data, this.globalData, this);
    }

    return new HImageElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createSolid = function (data) {
    if (!this.supports3d) {
      return new ISolidElement(data, this.globalData, this);
    }

    return new HSolidElement(data, this.globalData, this);
  };

  HybridRendererBase.prototype.createNull = SVGRenderer.prototype.createNull;

  HybridRendererBase.prototype.getThreeDContainerByPos = function (pos) {
    var i = 0;
    var len = this.threeDElements.length;

    while (i < len) {
      if (this.threeDElements[i].startPos <= pos && this.threeDElements[i].endPos >= pos) {
        return this.threeDElements[i].perspectiveElem;
      }

      i += 1;
    }

    return null;
  };

  HybridRendererBase.prototype.createThreeDContainer = function (pos, type) {
    var perspectiveElem = createTag('div');
    var style;
    var containerStyle;
    styleDiv(perspectiveElem);
    var container = createTag('div');
    styleDiv(container);

    if (type === '3d') {
      style = perspectiveElem.style;
      style.width = this.globalData.compSize.w + 'px';
      style.height = this.globalData.compSize.h + 'px';
      var center = '50% 50%';
      style.webkitTransformOrigin = center;
      style.mozTransformOrigin = center;
      style.transformOrigin = center;
      containerStyle = container.style;
      var matrix = 'matrix3d(1,0,0,0,0,1,0,0,0,0,1,0,0,0,0,1)';
      containerStyle.transform = matrix;
      containerStyle.webkitTransform = matrix;
    }

    perspectiveElem.appendChild(container); // this.resizerElem.appendChild(perspectiveElem);

    var threeDContainerData = {
      container: container,
      perspectiveElem: perspectiveElem,
      startPos: pos,
      endPos: pos,
      type: type
    };
    this.threeDElements.push(threeDContainerData);
    return threeDContainerData;
  };

  HybridRendererBase.prototype.build3dContainers = function () {
    var i;
    var len = this.layers.length;
    var lastThreeDContainerData;
    var currentContainer = '';

    for (i = 0; i < len; i += 1) {
      if (this.layers[i].ddd && this.layers[i].ty !== 3) {
        if (currentContainer !== '3d') {
          currentContainer = '3d';
          lastThreeDContainerData = this.createThreeDContainer(i, '3d');
        }

        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      } else {
        if (currentContainer !== '2d') {
          currentContainer = '2d';
          lastThreeDContainerData = this.createThreeDContainer(i, '2d');
        }

        lastThreeDContainerData.endPos = Math.max(lastThreeDContainerData.endPos, i);
      }
    }

    len = this.threeDElements.length;

    for (i = len - 1; i >= 0; i -= 1) {
      this.resizerElem.appendChild(this.threeDElements[i].perspectiveElem);
    }
  };

  HybridRendererBase.prototype.addTo3dContainer = function (elem, pos) {
    var i = 0;
    var len = this.threeDElements.length;

    while (i < len) {
      if (pos <= this.threeDElements[i].endPos) {
        var j = this.threeDElements[i].startPos;
        var nextElement;

        while (j < pos) {
          if (this.elements[j] && this.elements[j].getBaseElement) {
            nextElement = this.elements[j].getBaseElement();
          }

          j += 1;
        }

        if (nextElement) {
          this.threeDElements[i].container.insertBefore(elem, nextElement);
        } else {
          this.threeDElements[i].container.appendChild(elem);
        }

        break;
      }

      i += 1;
    }
  };

  HybridRendererBase.prototype.configAnimation = function (animData) {
    var resizerElem = createTag('div');
    var wrapper = this.animationItem.wrapper;
    var style = resizerElem.style;
    style.width = animData.w + 'px';
    style.height = animData.h + 'px';
    this.resizerElem = resizerElem;
    styleDiv(resizerElem);
    style.transformStyle = 'flat';
    style.mozTransformStyle = 'flat';
    style.webkitTransformStyle = 'flat';

    if (this.renderConfig.className) {
      resizerElem.setAttribute('class', this.renderConfig.className);
    }

    wrapper.appendChild(resizerElem);
    style.overflow = 'hidden';
    var svg = createNS('svg');
    svg.setAttribute('width', '1');
    svg.setAttribute('height', '1');
    styleDiv(svg);
    this.resizerElem.appendChild(svg);
    var defs = createNS('defs');
    svg.appendChild(defs);
    this.data = animData; // Mask animation

    this.setupGlobalData(animData, svg);
    this.globalData.defs = defs;
    this.layers = animData.layers;
    this.layerElement = this.resizerElem;
    this.build3dContainers();
    this.updateContainerSize();
  };

  HybridRendererBase.prototype.destroy = function () {
    if (this.animationItem.wrapper) {
      this.animationItem.wrapper.innerText = '';
    }

    this.animationItem.container = null;
    this.globalData.defs = null;
    var i;
    var len = this.layers ? this.layers.length : 0;

    for (i = 0; i < len; i += 1) {
      if (this.elements[i] && this.elements[i].destroy) {
        this.elements[i].destroy();
      }
    }

    this.elements.length = 0;
    this.destroyed = true;
    this.animationItem = null;
  };

  HybridRendererBase.prototype.updateContainerSize = function () {
    var elementWidth = this.animationItem.wrapper.offsetWidth;
    var elementHeight = this.animationItem.wrapper.offsetHeight;
    var elementRel = elementWidth / elementHeight;
    var animationRel = this.globalData.compSize.w / this.globalData.compSize.h;
    var sx;
    var sy;
    var tx;
    var ty;

    if (animationRel > elementRel) {
      sx = elementWidth / this.globalData.compSize.w;
      sy = elementWidth / this.globalData.compSize.w;
      tx = 0;
      ty = (elementHeight - this.globalData.compSize.h * (elementWidth / this.globalData.compSize.w)) / 2;
    } else {
      sx = elementHeight / this.globalData.compSize.h;
      sy = elementHeight / this.globalData.compSize.h;
      tx = (elementWidth - this.globalData.compSize.w * (elementHeight / this.globalData.compSize.h)) / 2;
      ty = 0;
    }

    var style = this.resizerElem.style;
    style.webkitTransform = 'matrix3d(' + sx + ',0,0,0,0,' + sy + ',0,0,0,0,1,0,' + tx + ',' + ty + ',0,1)';
    style.transform = style.webkitTransform;
  };

  HybridRendererBase.prototype.renderFrame = SVGRenderer.prototype.renderFrame;

  HybridRendererBase.prototype.hide = function () {
    this.resizerElem.style.display = 'none';
  };

  HybridRendererBase.prototype.show = function () {
    this.resizerElem.style.display = 'block';
  };

  HybridRendererBase.prototype.initItems = function () {
    this.buildAllItems();

    if (this.camera) {
      this.camera.setup();
    } else {
      var cWidth = this.globalData.compSize.w;
      var cHeight = this.globalData.compSize.h;
      var i;
      var len = this.threeDElements.length;

      for (i = 0; i < len; i += 1) {
        var style = this.threeDElements[i].perspectiveElem.style;
        style.webkitPerspective = Math.sqrt(Math.pow(cWidth, 2) + Math.pow(cHeight, 2)) + 'px';
        style.perspective = style.webkitPerspective;
      }
    }
  };

  HybridRendererBase.prototype.searchExtraCompositions = function (assets) {
    var i;
    var len = assets.length;
    var floatingContainer = createTag('div');

    for (i = 0; i < len; i += 1) {
      if (assets[i].xt) {
        var comp = this.createComp(assets[i], floatingContainer, this.globalData.comp, null);
        comp.initExpressions();
        this.globalData.projectInterface.registerComposition(comp);
      }
    }
  };

  function HCompElement(data, globalData, comp) {
    this.layers = data.layers;
    this.supports3d = !data.hasMask;
    this.completeLayers = false;
    this.pendingElements = [];
    this.elements = this.layers ? createSizedArray(this.layers.length) : [];
    this.initElement(data, globalData, comp);
    this.tm = data.tm ? PropertyFactory.getProp(this, data.tm, 0, globalData.frameRate, this) : {
      _placeholder: true
    };
  }

  extendPrototype([HybridRendererBase, ICompElement, HBaseElement], HCompElement);
  HCompElement.prototype._createBaseContainerElements = HCompElement.prototype.createContainerElements;

  HCompElement.prototype.createContainerElements = function () {
    this._createBaseContainerElements(); // divElement.style.clip = 'rect(0px, '+this.data.w+'px, '+this.data.h+'px, 0px)';


    if (this.data.hasMask) {
      this.svgElement.setAttribute('width', this.data.w);
      this.svgElement.setAttribute('height', this.data.h);
      this.transformedElement = this.baseElement;
    } else {
      this.transformedElement = this.layerElement;
    }
  };

  HCompElement.prototype.addTo3dContainer = function (elem, pos) {
    var j = 0;
    var nextElement;

    while (j < pos) {
      if (this.elements[j] && this.elements[j].getBaseElement) {
        nextElement = this.elements[j].getBaseElement();
      }

      j += 1;
    }

    if (nextElement) {
      this.layerElement.insertBefore(elem, nextElement);
    } else {
      this.layerElement.appendChild(elem);
    }
  };

  HCompElement.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }

    return new HCompElement(data, this.globalData, this);
  };

  function HybridRenderer(animationItem, config) {
    this.animationItem = animationItem;
    this.layers = null;
    this.renderedFrame = -1;
    this.renderConfig = {
      className: config && config.className || '',
      imagePreserveAspectRatio: config && config.imagePreserveAspectRatio || 'xMidYMid slice',
      hideOnTransparent: !(config && config.hideOnTransparent === false),
      filterSize: {
        width: config && config.filterSize && config.filterSize.width || '400%',
        height: config && config.filterSize && config.filterSize.height || '400%',
        x: config && config.filterSize && config.filterSize.x || '-100%',
        y: config && config.filterSize && config.filterSize.y || '-100%'
      },
      runExpressions: !config || config.runExpressions === undefined || config.runExpressions
    };
    this.globalData = {
      _mdf: false,
      frameNum: -1,
      renderConfig: this.renderConfig
    };
    this.pendingElements = [];
    this.elements = [];
    this.threeDElements = [];
    this.destroyed = false;
    this.camera = null;
    this.supports3d = true;
    this.rendererType = 'html';
  }

  extendPrototype([HybridRendererBase], HybridRenderer);

  HybridRenderer.prototype.createComp = function (data) {
    if (!this.supports3d) {
      return new SVGCompElement(data, this.globalData, this);
    }

    return new HCompElement(data, this.globalData, this);
  };

  var CompExpressionInterface = function () {
    return function (comp) {
      function _thisLayerFunction(name) {
        var i = 0;
        var len = comp.layers.length;

        while (i < len) {
          if (comp.layers[i].nm === name || comp.layers[i].ind === name) {
            return comp.elements[i].layerInterface;
          }

          i += 1;
        }

        return null; // return {active:false};
      }

      Object.defineProperty(_thisLayerFunction, '_name', {
        value: comp.data.nm
      });
      _thisLayerFunction.layer = _thisLayerFunction;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.height = comp.data.h || comp.globalData.compSize.h;
      _thisLayerFunction.width = comp.data.w || comp.globalData.compSize.w;
      _thisLayerFunction.pixelAspect = 1;
      _thisLayerFunction.frameDuration = 1 / comp.globalData.frameRate;
      _thisLayerFunction.displayStartTime = 0;
      _thisLayerFunction.numLayers = comp.layers.length;
      return _thisLayerFunction;
    };
  }();

  function _typeof$2(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$2 = function _typeof(obj) { return typeof obj; }; } else { _typeof$2 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$2(obj); }

  /* eslint-disable */

  /*
   Copyright 2014 David Bau.

   Permission is hereby granted, free of charge, to any person obtaining
   a copy of this software and associated documentation files (the
   "Software"), to deal in the Software without restriction, including
   without limitation the rights to use, copy, modify, merge, publish,
   distribute, sublicense, and/or sell copies of the Software, and to
   permit persons to whom the Software is furnished to do so, subject to
   the following conditions:

   The above copyright notice and this permission notice shall be
   included in all copies or substantial portions of the Software.

   THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
   EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
   MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
   IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
   CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
   TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
   SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.

   */
  function seedRandom(pool, math) {
    //
    // The following constants are related to IEEE 754 limits.
    //
    var global = this,
        width = 256,
        // each RC4 output is 0 <= x < 256
    chunks = 6,
        // at least six RC4 outputs for each double
    digits = 52,
        // there are 52 significant digits in a double
    rngname = 'random',
        // rngname: name for Math.random and Math.seedrandom
    startdenom = math.pow(width, chunks),
        significance = math.pow(2, digits),
        overflow = significance * 2,
        mask = width - 1,
        nodecrypto; // node.js crypto module, initialized at the bottom.
    //
    // seedrandom()
    // This is the seedrandom function described above.
    //

    function seedrandom(seed, options, callback) {
      var key = [];
      options = options === true ? {
        entropy: true
      } : options || {}; // Flatten the seed string or build one from local entropy if needed.

      var shortseed = mixkey(flatten(options.entropy ? [seed, tostring(pool)] : seed === null ? autoseed() : seed, 3), key); // Use the seed to initialize an ARC4 generator.

      var arc4 = new ARC4(key); // This function returns a random double in [0, 1) that contains
      // randomness in every bit of the mantissa of the IEEE 754 value.

      var prng = function prng() {
        var n = arc4.g(chunks),
            // Start with a numerator n < 2 ^ 48
        d = startdenom,
            //   and denominator d = 2 ^ 48.
        x = 0; //   and no 'extra last byte'.

        while (n < significance) {
          // Fill up all significant digits by
          n = (n + x) * width; //   shifting numerator and

          d *= width; //   denominator and generating a

          x = arc4.g(1); //   new least-significant-byte.
        }

        while (n >= overflow) {
          // To avoid rounding up, before adding
          n /= 2; //   last byte, shift everything

          d /= 2; //   right using integer math until

          x >>>= 1; //   we have exactly the desired bits.
        }

        return (n + x) / d; // Form the number within [0, 1).
      };

      prng.int32 = function () {
        return arc4.g(4) | 0;
      };

      prng.quick = function () {
        return arc4.g(4) / 0x100000000;
      };

      prng["double"] = prng; // Mix the randomness into accumulated entropy.

      mixkey(tostring(arc4.S), pool); // Calling convention: what to return as a function of prng, seed, is_math.

      return (options.pass || callback || function (prng, seed, is_math_call, state) {
        if (state) {
          // Load the arc4 state from the given state if it has an S array.
          if (state.S) {
            copy(state, arc4);
          } // Only provide the .state method if requested via options.state.


          prng.state = function () {
            return copy(arc4, {});
          };
        } // If called as a method of Math (Math.seedrandom()), mutate
        // Math.random because that is how seedrandom.js has worked since v1.0.


        if (is_math_call) {
          math[rngname] = prng;
          return seed;
        } // Otherwise, it is a newer calling convention, so return the
        // prng directly.
        else return prng;
      })(prng, shortseed, 'global' in options ? options.global : this == math, options.state);
    }

    math['seed' + rngname] = seedrandom; //
    // ARC4
    //
    // An ARC4 implementation.  The constructor takes a key in the form of
    // an array of at most (width) integers that should be 0 <= x < (width).
    //
    // The g(count) method returns a pseudorandom integer that concatenates
    // the next (count) outputs from ARC4.  Its return value is a number x
    // that is in the range 0 <= x < (width ^ count).
    //

    function ARC4(key) {
      var t,
          keylen = key.length,
          me = this,
          i = 0,
          j = me.i = me.j = 0,
          s = me.S = []; // The empty key [] is treated as [0].

      if (!keylen) {
        key = [keylen++];
      } // Set up S using the standard key scheduling algorithm.


      while (i < width) {
        s[i] = i++;
      }

      for (i = 0; i < width; i++) {
        s[i] = s[j = mask & j + key[i % keylen] + (t = s[i])];
        s[j] = t;
      } // The "g" method returns the next (count) outputs as one number.


      me.g = function (count) {
        // Using instance members instead of closure state nearly doubles speed.
        var t,
            r = 0,
            i = me.i,
            j = me.j,
            s = me.S;

        while (count--) {
          t = s[i = mask & i + 1];
          r = r * width + s[mask & (s[i] = s[j = mask & j + t]) + (s[j] = t)];
        }

        me.i = i;
        me.j = j;
        return r; // For robust unpredictability, the function call below automatically
        // discards an initial batch of values.  This is called RC4-drop[256].
        // See http://google.com/search?q=rsa+fluhrer+response&btnI
      };
    } //
    // copy()
    // Copies internal state of ARC4 to or from a plain object.
    //


    function copy(f, t) {
      t.i = f.i;
      t.j = f.j;
      t.S = f.S.slice();
      return t;
    } //
    // flatten()
    // Converts an object tree to nested arrays of strings.
    //


    function flatten(obj, depth) {
      var result = [],
          typ = _typeof$2(obj),
          prop;

      if (depth && typ == 'object') {
        for (prop in obj) {
          try {
            result.push(flatten(obj[prop], depth - 1));
          } catch (e) {}
        }
      }

      return result.length ? result : typ == 'string' ? obj : obj + '\0';
    } //
    // mixkey()
    // Mixes a string seed into a key that is an array of integers, and
    // returns a shortened string seed that is equivalent to the result key.
    //


    function mixkey(seed, key) {
      var stringseed = seed + '',
          smear,
          j = 0;

      while (j < stringseed.length) {
        key[mask & j] = mask & (smear ^= key[mask & j] * 19) + stringseed.charCodeAt(j++);
      }

      return tostring(key);
    } //
    // autoseed()
    // Returns an object for autoseeding, using window.crypto and Node crypto
    // module if available.
    //


    function autoseed() {
      try {
        if (nodecrypto) {
          return tostring(nodecrypto.randomBytes(width));
        }

        var out = new Uint8Array(width);
        (global.crypto || global.msCrypto).getRandomValues(out);
        return tostring(out);
      } catch (e) {
        var browser = global.navigator,
            plugins = browser && browser.plugins;
        return [+new Date(), global, plugins, global.screen, tostring(pool)];
      }
    } //
    // tostring()
    // Converts an array of charcodes to a string
    //


    function tostring(a) {
      return String.fromCharCode.apply(0, a);
    } //
    // When seedrandom.js is loaded, we immediately mix a few bits
    // from the built-in RNG into the entropy pool.  Because we do
    // not want to interfere with deterministic PRNG state later,
    // seedrandom will not call math.random on its own again after
    // initialization.
    //


    mixkey(math.random(), pool); //
    // Nodejs and AMD support: export the implementation as a module using
    // either convention.
    //
    // End anonymous scope, and pass initial values.
  }

  ;

  function initialize$2(BMMath) {
    seedRandom([], BMMath);
  }

  var propTypes = {
    SHAPE: 'shape'
  };

  function _typeof$1(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof$1 = function _typeof(obj) { return typeof obj; }; } else { _typeof$1 = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof$1(obj); }

  var ExpressionManager = function () {
    'use strict';

    var ob = {};
    var Math = BMMath;
    var window = null;
    var document = null;
    var XMLHttpRequest = null;
    var fetch = null;
    var frames = null;
    var _lottieGlobal = {};
    initialize$2(BMMath);

    function resetFrame() {
      _lottieGlobal = {};
    }

    function $bm_isInstanceOfArray(arr) {
      return arr.constructor === Array || arr.constructor === Float32Array;
    }

    function isNumerable(tOfV, v) {
      return tOfV === 'number' || v instanceof Number || tOfV === 'boolean' || tOfV === 'string';
    }

    function $bm_neg(a) {
      var tOfA = _typeof$1(a);

      if (tOfA === 'number' || a instanceof Number || tOfA === 'boolean') {
        return -a;
      }

      if ($bm_isInstanceOfArray(a)) {
        var i;
        var lenA = a.length;
        var retArr = [];

        for (i = 0; i < lenA; i += 1) {
          retArr[i] = -a[i];
        }

        return retArr;
      }

      if (a.propType) {
        return a.v;
      }

      return -a;
    }

    var easeInBez = BezierFactory.getBezierEasing(0.333, 0, 0.833, 0.833, 'easeIn').get;
    var easeOutBez = BezierFactory.getBezierEasing(0.167, 0.167, 0.667, 1, 'easeOut').get;
    var easeInOutBez = BezierFactory.getBezierEasing(0.33, 0, 0.667, 1, 'easeInOut').get;

    function sum(a, b) {
      var tOfA = _typeof$1(a);

      var tOfB = _typeof$1(b);

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b) || tOfA === 'string' || tOfB === 'string') {
        return a + b;
      }

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] += b;
        return a;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a + b[0];
        return b;
      }

      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];

        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] + b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }

          i += 1;
        }

        return retArr;
      }

      return 0;
    }

    var add = sum;

    function sub(a, b) {
      var tOfA = _typeof$1(a);

      var tOfB = _typeof$1(b);

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        if (tOfA === 'string') {
          a = parseInt(a, 10);
        }

        if (tOfB === 'string') {
          b = parseInt(b, 10);
        }

        return a - b;
      }

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        a = a.slice(0);
        a[0] -= b;
        return a;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        b = b.slice(0);
        b[0] = a - b[0];
        return b;
      }

      if ($bm_isInstanceOfArray(a) && $bm_isInstanceOfArray(b)) {
        var i = 0;
        var lenA = a.length;
        var lenB = b.length;
        var retArr = [];

        while (i < lenA || i < lenB) {
          if ((typeof a[i] === 'number' || a[i] instanceof Number) && (typeof b[i] === 'number' || b[i] instanceof Number)) {
            retArr[i] = a[i] - b[i];
          } else {
            retArr[i] = b[i] === undefined ? a[i] : a[i] || b[i];
          }

          i += 1;
        }

        return retArr;
      }

      return 0;
    }

    function mul(a, b) {
      var tOfA = _typeof$1(a);

      var tOfB = _typeof$1(b);

      var arr;

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a * b;
      }

      var i;
      var len;

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] * b;
        }

        return arr;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a * b[i];
        }

        return arr;
      }

      return 0;
    }

    function div(a, b) {
      var tOfA = _typeof$1(a);

      var tOfB = _typeof$1(b);

      var arr;

      if (isNumerable(tOfA, a) && isNumerable(tOfB, b)) {
        return a / b;
      }

      var i;
      var len;

      if ($bm_isInstanceOfArray(a) && isNumerable(tOfB, b)) {
        len = a.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a[i] / b;
        }

        return arr;
      }

      if (isNumerable(tOfA, a) && $bm_isInstanceOfArray(b)) {
        len = b.length;
        arr = createTypedArray('float32', len);

        for (i = 0; i < len; i += 1) {
          arr[i] = a / b[i];
        }

        return arr;
      }

      return 0;
    }

    function mod(a, b) {
      if (typeof a === 'string') {
        a = parseInt(a, 10);
      }

      if (typeof b === 'string') {
        b = parseInt(b, 10);
      }

      return a % b;
    }

    var $bm_sum = sum;
    var $bm_sub = sub;
    var $bm_mul = mul;
    var $bm_div = div;
    var $bm_mod = mod;

    function clamp(num, min, max) {
      if (min > max) {
        var mm = max;
        max = min;
        min = mm;
      }

      return Math.min(Math.max(num, min), max);
    }

    function radiansToDegrees(val) {
      return val / degToRads;
    }

    var radians_to_degrees = radiansToDegrees;

    function degreesToRadians(val) {
      return val * degToRads;
    }

    var degrees_to_radians = radiansToDegrees;
    var helperLengthArray = [0, 0, 0, 0, 0, 0];

    function length(arr1, arr2) {
      if (typeof arr1 === 'number' || arr1 instanceof Number) {
        arr2 = arr2 || 0;
        return Math.abs(arr1 - arr2);
      }

      if (!arr2) {
        arr2 = helperLengthArray;
      }

      var i;
      var len = Math.min(arr1.length, arr2.length);
      var addedLength = 0;

      for (i = 0; i < len; i += 1) {
        addedLength += Math.pow(arr2[i] - arr1[i], 2);
      }

      return Math.sqrt(addedLength);
    }

    function normalize(vec) {
      return div(vec, length(vec));
    }

    function rgbToHsl(val) {
      var r = val[0];
      var g = val[1];
      var b = val[2];
      var max = Math.max(r, g, b);
      var min = Math.min(r, g, b);
      var h;
      var s;
      var l = (max + min) / 2;

      if (max === min) {
        h = 0; // achromatic

        s = 0; // achromatic
      } else {
        var d = max - min;
        s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

        switch (max) {
          case r:
            h = (g - b) / d + (g < b ? 6 : 0);
            break;

          case g:
            h = (b - r) / d + 2;
            break;

          case b:
            h = (r - g) / d + 4;
            break;

          default:
            break;
        }

        h /= 6;
      }

      return [h, s, l, val[3]];
    }

    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }

    function hslToRgb(val) {
      var h = val[0];
      var s = val[1];
      var l = val[2];
      var r;
      var g;
      var b;

      if (s === 0) {
        r = l; // achromatic

        b = l; // achromatic

        g = l; // achromatic
      } else {
        var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
        var p = 2 * l - q;
        r = hue2rgb(p, q, h + 1 / 3);
        g = hue2rgb(p, q, h);
        b = hue2rgb(p, q, h - 1 / 3);
      }

      return [r, g, b, val[3]];
    }

    function linear(t, tMin, tMax, value1, value2) {
      if (value1 === undefined || value2 === undefined) {
        value1 = tMin;
        value2 = tMax;
        tMin = 0;
        tMax = 1;
      }

      if (tMax < tMin) {
        var _tMin = tMax;
        tMax = tMin;
        tMin = _tMin;
      }

      if (t <= tMin) {
        return value1;
      }

      if (t >= tMax) {
        return value2;
      }

      var perc = tMax === tMin ? 0 : (t - tMin) / (tMax - tMin);

      if (!value1.length) {
        return value1 + (value2 - value1) * perc;
      }

      var i;
      var len = value1.length;
      var arr = createTypedArray('float32', len);

      for (i = 0; i < len; i += 1) {
        arr[i] = value1[i] + (value2[i] - value1[i]) * perc;
      }

      return arr;
    }

    function random(min, max) {
      if (max === undefined) {
        if (min === undefined) {
          min = 0;
          max = 1;
        } else {
          max = min;
          min = undefined;
        }
      }

      if (max.length) {
        var i;
        var len = max.length;

        if (!min) {
          min = createTypedArray('float32', len);
        }

        var arr = createTypedArray('float32', len);
        var rnd = BMMath.random();

        for (i = 0; i < len; i += 1) {
          arr[i] = min[i] + rnd * (max[i] - min[i]);
        }

        return arr;
      }

      if (min === undefined) {
        min = 0;
      }

      var rndm = BMMath.random();
      return min + rndm * (max - min);
    }

    function createPath(points, inTangents, outTangents, closed) {
      var i;
      var len = points.length;
      var path = shapePool.newElement();
      path.setPathData(!!closed, len);
      var arrPlaceholder = [0, 0];
      var inVertexPoint;
      var outVertexPoint;

      for (i = 0; i < len; i += 1) {
        inVertexPoint = inTangents && inTangents[i] ? inTangents[i] : arrPlaceholder;
        outVertexPoint = outTangents && outTangents[i] ? outTangents[i] : arrPlaceholder;
        path.setTripleAt(points[i][0], points[i][1], outVertexPoint[0] + points[i][0], outVertexPoint[1] + points[i][1], inVertexPoint[0] + points[i][0], inVertexPoint[1] + points[i][1], i, true);
      }

      return path;
    }

    function initiateExpression(elem, data, property) {
      // Bail out if we don't want expressions
      function noOp(_value) {
        return _value;
      }

      if (!elem.globalData.renderConfig.runExpressions) {
        return noOp;
      }

      var val = data.x;
      var needsVelocity = /velocity(?![\w\d])/.test(val);

      var _needsRandom = val.indexOf('random') !== -1;

      var elemType = elem.data.ty;
      var transform;
      var $bm_transform;
      var content;
      var effect;
      var thisProperty = property;
      thisProperty.valueAtTime = thisProperty.getValueAtTime;
      Object.defineProperty(thisProperty, 'value', {
        get: function get() {
          return thisProperty.v;
        }
      });
      elem.comp.frameDuration = 1 / elem.comp.globalData.frameRate;
      elem.comp.displayStartTime = 0;
      var inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      var outPoint = elem.data.op / elem.comp.globalData.frameRate;
      var width = elem.data.sw ? elem.data.sw : 0;
      var height = elem.data.sh ? elem.data.sh : 0;
      var name = elem.data.nm;
      var loopIn;
      var loop_in;
      var loopOut;
      var loop_out;
      var smooth;
      var toWorld;
      var fromWorld;
      var fromComp;
      var toComp;
      var fromCompToSurface;
      var position;
      var rotation;
      var anchorPoint;
      var scale;
      var thisLayer;
      var thisComp;
      var mask;
      var valueAtTime;
      var velocityAtTime;
      var scoped_bm_rt; // val = val.replace(/(\\?"|')((http)(s)?(:\/))?\/.*?(\\?"|')/g, "\"\""); // deter potential network calls

      var expression_function = eval('[function _expression_function(){' + val + ';scoped_bm_rt=$bm_rt}]')[0]; // eslint-disable-line no-eval

      var numKeys = property.kf ? data.k.length : 0;
      var active = !this.data || this.data.hd !== true;

      var wiggle = function wiggle(freq, amp) {
        var iWiggle;
        var j;
        var lenWiggle = this.pv.length ? this.pv.length : 1;
        var addedAmps = createTypedArray('float32', lenWiggle);
        freq = 5;
        var iterations = Math.floor(time * freq);
        iWiggle = 0;
        j = 0;

        while (iWiggle < iterations) {
          // var rnd = BMMath.random();
          for (j = 0; j < lenWiggle; j += 1) {
            addedAmps[j] += -amp + amp * 2 * BMMath.random(); // addedAmps[j] += -amp + amp*2*rnd;
          }

          iWiggle += 1;
        } // var rnd2 = BMMath.random();


        var periods = time * freq;
        var perc = periods - Math.floor(periods);
        var arr = createTypedArray('float32', lenWiggle);

        if (lenWiggle > 1) {
          for (j = 0; j < lenWiggle; j += 1) {
            arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp * 2 * BMMath.random()) * perc; // arr[j] = this.pv[j] + addedAmps[j] + (-amp + amp*2*rnd)*perc;
            // arr[i] = this.pv[i] + addedAmp + amp1*perc + amp2*(1-perc);
          }

          return arr;
        }

        return this.pv + addedAmps[0] + (-amp + amp * 2 * BMMath.random()) * perc;
      }.bind(this);

      if (thisProperty.loopIn) {
        loopIn = thisProperty.loopIn.bind(thisProperty);
        loop_in = loopIn;
      }

      if (thisProperty.loopOut) {
        loopOut = thisProperty.loopOut.bind(thisProperty);
        loop_out = loopOut;
      }

      if (thisProperty.smooth) {
        smooth = thisProperty.smooth.bind(thisProperty);
      }

      function loopInDuration(type, duration) {
        return loopIn(type, duration, true);
      }

      function loopOutDuration(type, duration) {
        return loopOut(type, duration, true);
      }

      if (this.getValueAtTime) {
        valueAtTime = this.getValueAtTime.bind(this);
      }

      if (this.getVelocityAtTime) {
        velocityAtTime = this.getVelocityAtTime.bind(this);
      }

      var comp = elem.comp.globalData.projectInterface.bind(elem.comp.globalData.projectInterface);

      function lookAt(elem1, elem2) {
        var fVec = [elem2[0] - elem1[0], elem2[1] - elem1[1], elem2[2] - elem1[2]];
        var pitch = Math.atan2(fVec[0], Math.sqrt(fVec[1] * fVec[1] + fVec[2] * fVec[2])) / degToRads;
        var yaw = -Math.atan2(fVec[1], fVec[2]) / degToRads;
        return [yaw, pitch, 0];
      }

      function easeOut(t, tMin, tMax, val1, val2) {
        return applyEase(easeOutBez, t, tMin, tMax, val1, val2);
      }

      function easeIn(t, tMin, tMax, val1, val2) {
        return applyEase(easeInBez, t, tMin, tMax, val1, val2);
      }

      function ease(t, tMin, tMax, val1, val2) {
        return applyEase(easeInOutBez, t, tMin, tMax, val1, val2);
      }

      function applyEase(fn, t, tMin, tMax, val1, val2) {
        if (val1 === undefined) {
          val1 = tMin;
          val2 = tMax;
        } else {
          t = (t - tMin) / (tMax - tMin);
        }

        if (t > 1) {
          t = 1;
        } else if (t < 0) {
          t = 0;
        }

        var mult = fn(t);

        if ($bm_isInstanceOfArray(val1)) {
          var iKey;
          var lenKey = val1.length;
          var arr = createTypedArray('float32', lenKey);

          for (iKey = 0; iKey < lenKey; iKey += 1) {
            arr[iKey] = (val2[iKey] - val1[iKey]) * mult + val1[iKey];
          }

          return arr;
        }

        return (val2 - val1) * mult + val1;
      }

      function nearestKey(time) {
        var iKey;
        var lenKey = data.k.length;
        var index;
        var keyTime;

        if (!data.k.length || typeof data.k[0] === 'number') {
          index = 0;
          keyTime = 0;
        } else {
          index = -1;
          time *= elem.comp.globalData.frameRate;

          if (time < data.k[0].t) {
            index = 1;
            keyTime = data.k[0].t;
          } else {
            for (iKey = 0; iKey < lenKey - 1; iKey += 1) {
              if (time === data.k[iKey].t) {
                index = iKey + 1;
                keyTime = data.k[iKey].t;
                break;
              } else if (time > data.k[iKey].t && time < data.k[iKey + 1].t) {
                if (time - data.k[iKey].t > data.k[iKey + 1].t - time) {
                  index = iKey + 2;
                  keyTime = data.k[iKey + 1].t;
                } else {
                  index = iKey + 1;
                  keyTime = data.k[iKey].t;
                }

                break;
              }
            }

            if (index === -1) {
              index = iKey + 1;
              keyTime = data.k[iKey].t;
            }
          }
        }

        var obKey = {};
        obKey.index = index;
        obKey.time = keyTime / elem.comp.globalData.frameRate;
        return obKey;
      }

      function key(ind) {
        var obKey;
        var iKey;
        var lenKey;

        if (!data.k.length || typeof data.k[0] === 'number') {
          throw new Error('The property has no keyframe at index ' + ind);
        }

        ind -= 1;
        obKey = {
          time: data.k[ind].t / elem.comp.globalData.frameRate,
          value: []
        };
        var arr = Object.prototype.hasOwnProperty.call(data.k[ind], 's') ? data.k[ind].s : data.k[ind - 1].e;
        lenKey = arr.length;

        for (iKey = 0; iKey < lenKey; iKey += 1) {
          obKey[iKey] = arr[iKey];
          obKey.value[iKey] = arr[iKey];
        }

        return obKey;
      }

      function framesToTime(fr, fps) {
        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }

        return fr / fps;
      }

      function timeToFrames(t, fps) {
        if (!t && t !== 0) {
          t = time;
        }

        if (!fps) {
          fps = elem.comp.globalData.frameRate;
        }

        return t * fps;
      }

      function seedRandom(seed) {
        BMMath.seedrandom(randSeed + seed);
      }

      function sourceRectAtTime() {
        return elem.sourceRectAtTime();
      }

      function substring(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substring(init);
          }

          return value.substring(init, end);
        }

        return '';
      }

      function substr(init, end) {
        if (typeof value === 'string') {
          if (end === undefined) {
            return value.substr(init);
          }

          return value.substr(init, end);
        }

        return '';
      }

      function posterizeTime(framesPerSecond) {
        time = framesPerSecond === 0 ? 0 : Math.floor(time * framesPerSecond) / framesPerSecond;
        value = valueAtTime(time);
      }

      var time;
      var velocity;
      var value;
      var text;
      var textIndex;
      var textTotal;
      var selectorValue;
      var index = elem.data.ind;
      var hasParent = !!(elem.hierarchy && elem.hierarchy.length);
      var parent;
      var randSeed = Math.floor(Math.random() * 1000000);
      var globalData = elem.globalData;

      function executeExpression(_value) {
        // globalData.pushExpression();
        value = _value;

        if (this.frameExpressionId === elem.globalData.frameId && this.propType !== 'textSelector') {
          return value;
        }

        if (this.propType === 'textSelector') {
          textIndex = this.textIndex;
          textTotal = this.textTotal;
          selectorValue = this.selectorValue;
        }

        if (!thisLayer) {
          text = elem.layerInterface.text;
          thisLayer = elem.layerInterface;
          thisComp = elem.comp.compInterface;
          toWorld = thisLayer.toWorld.bind(thisLayer);
          fromWorld = thisLayer.fromWorld.bind(thisLayer);
          fromComp = thisLayer.fromComp.bind(thisLayer);
          toComp = thisLayer.toComp.bind(thisLayer);
          mask = thisLayer.mask ? thisLayer.mask.bind(thisLayer) : null;
          fromCompToSurface = fromComp;
        }

        if (!transform) {
          transform = elem.layerInterface('ADBE Transform Group');
          $bm_transform = transform;

          if (transform) {
            anchorPoint = transform.anchorPoint;
            /* position = transform.position;
                      rotation = transform.rotation;
                      scale = transform.scale; */
          }
        }

        if (elemType === 4 && !content) {
          content = thisLayer('ADBE Root Vectors Group');
        }

        if (!effect) {
          effect = thisLayer(4);
        }

        hasParent = !!(elem.hierarchy && elem.hierarchy.length);

        if (hasParent && !parent) {
          parent = elem.hierarchy[0].layerInterface;
        }

        time = this.comp.renderedFrame / this.comp.globalData.frameRate;

        if (_needsRandom) {
          seedRandom(randSeed + time);
        }

        if (needsVelocity) {
          velocity = velocityAtTime(time);
        }

        expression_function();
        this.frameExpressionId = elem.globalData.frameId; // TODO: Check if it's possible to return on ShapeInterface the .v value
        // Changed this to a ternary operation because Rollup failed compiling it correctly

        scoped_bm_rt = scoped_bm_rt.propType === propTypes.SHAPE ? scoped_bm_rt.v : scoped_bm_rt;
        return scoped_bm_rt;
      } // Bundlers will see these as dead code and unless we reference them


      executeExpression.__preventDeadCodeRemoval = [$bm_transform, anchorPoint, time, velocity, inPoint, outPoint, width, height, name, loop_in, loop_out, smooth, toComp, fromCompToSurface, toWorld, fromWorld, mask, position, rotation, scale, thisComp, numKeys, active, wiggle, loopInDuration, loopOutDuration, comp, lookAt, easeOut, easeIn, ease, nearestKey, key, text, textIndex, textTotal, selectorValue, framesToTime, timeToFrames, sourceRectAtTime, substring, substr, posterizeTime, index, globalData];
      return executeExpression;
    }

    ob.initiateExpression = initiateExpression;
    ob.__preventDeadCodeRemoval = [window, document, XMLHttpRequest, fetch, frames, $bm_neg, add, $bm_sum, $bm_sub, $bm_mul, $bm_div, $bm_mod, clamp, radians_to_degrees, degreesToRadians, degrees_to_radians, normalize, rgbToHsl, hslToRgb, linear, random, createPath, _lottieGlobal];
    ob.resetFrame = resetFrame;
    return ob;
  }();

  var Expressions = function () {
    var ob = {};
    ob.initExpressions = initExpressions;
    ob.resetFrame = ExpressionManager.resetFrame;

    function initExpressions(animation) {
      var stackCount = 0;
      var registers = [];

      function pushExpression() {
        stackCount += 1;
      }

      function popExpression() {
        stackCount -= 1;

        if (stackCount === 0) {
          releaseInstances();
        }
      }

      function registerExpressionProperty(expression) {
        if (registers.indexOf(expression) === -1) {
          registers.push(expression);
        }
      }

      function releaseInstances() {
        var i;
        var len = registers.length;

        for (i = 0; i < len; i += 1) {
          registers[i].release();
        }

        registers.length = 0;
      }

      animation.renderer.compInterface = CompExpressionInterface(animation.renderer);
      animation.renderer.globalData.projectInterface.registerComposition(animation.renderer);
      animation.renderer.globalData.pushExpression = pushExpression;
      animation.renderer.globalData.popExpression = popExpression;
      animation.renderer.globalData.registerExpressionProperty = registerExpressionProperty;
    }

    return ob;
  }();

  var MaskManagerInterface = function () {
    function MaskInterface(mask, data) {
      this._mask = mask;
      this._data = data;
    }

    Object.defineProperty(MaskInterface.prototype, 'maskPath', {
      get: function get() {
        if (this._mask.prop.k) {
          this._mask.prop.getValue();
        }

        return this._mask.prop;
      }
    });
    Object.defineProperty(MaskInterface.prototype, 'maskOpacity', {
      get: function get() {
        if (this._mask.op.k) {
          this._mask.op.getValue();
        }

        return this._mask.op.v * 100;
      }
    });

    var MaskManager = function MaskManager(maskManager) {
      var _masksInterfaces = createSizedArray(maskManager.viewData.length);

      var i;
      var len = maskManager.viewData.length;

      for (i = 0; i < len; i += 1) {
        _masksInterfaces[i] = new MaskInterface(maskManager.viewData[i], maskManager.masksProperties[i]);
      }

      var maskFunction = function maskFunction(name) {
        i = 0;

        while (i < len) {
          if (maskManager.masksProperties[i].nm === name) {
            return _masksInterfaces[i];
          }

          i += 1;
        }

        return null;
      };

      return maskFunction;
    };

    return MaskManager;
  }();

  var ExpressionPropertyInterface = function () {
    var defaultUnidimensionalValue = {
      pv: 0,
      v: 0,
      mult: 1
    };
    var defaultMultidimensionalValue = {
      pv: [0, 0, 0],
      v: [0, 0, 0],
      mult: 1
    };

    function completeProperty(expressionValue, property, type) {
      Object.defineProperty(expressionValue, 'velocity', {
        get: function get() {
          return property.getVelocityAtTime(property.comp.currentFrame);
        }
      });
      expressionValue.numKeys = property.keyframes ? property.keyframes.length : 0;

      expressionValue.key = function (pos) {
        if (!expressionValue.numKeys) {
          return 0;
        }

        var value = '';

        if ('s' in property.keyframes[pos - 1]) {
          value = property.keyframes[pos - 1].s;
        } else if ('e' in property.keyframes[pos - 2]) {
          value = property.keyframes[pos - 2].e;
        } else {
          value = property.keyframes[pos - 2].s;
        }

        var valueProp = type === 'unidimensional' ? new Number(value) : Object.assign({}, value); // eslint-disable-line no-new-wrappers

        valueProp.time = property.keyframes[pos - 1].t / property.elem.comp.globalData.frameRate;
        valueProp.value = type === 'unidimensional' ? value[0] : value;
        return valueProp;
      };

      expressionValue.valueAtTime = property.getValueAtTime;
      expressionValue.speedAtTime = property.getSpeedAtTime;
      expressionValue.velocityAtTime = property.getVelocityAtTime;
      expressionValue.propertyGroup = property.propertyGroup;
    }

    function UnidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultUnidimensionalValue;
      }

      var mult = 1 / property.mult;
      var val = property.pv * mult;
      var expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

      expressionValue.value = val;
      completeProperty(expressionValue, property, 'unidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }

        val = property.v * mult;

        if (expressionValue.value !== val) {
          expressionValue = new Number(val); // eslint-disable-line no-new-wrappers

          expressionValue.value = val;
          completeProperty(expressionValue, property, 'unidimensional');
        }

        return expressionValue;
      };
    }

    function MultidimensionalPropertyInterface(property) {
      if (!property || !('pv' in property)) {
        property = defaultMultidimensionalValue;
      }

      var mult = 1 / property.mult;
      var len = property.data && property.data.l || property.pv.length;
      var expressionValue = createTypedArray('float32', len);
      var arrValue = createTypedArray('float32', len);
      expressionValue.value = arrValue;
      completeProperty(expressionValue, property, 'multidimensional');
      return function () {
        if (property.k) {
          property.getValue();
        }

        for (var i = 0; i < len; i += 1) {
          arrValue[i] = property.v[i] * mult;
          expressionValue[i] = arrValue[i];
        }

        return expressionValue;
      };
    } // TODO: try to avoid using this getter


    function defaultGetter() {
      return defaultUnidimensionalValue;
    }

    return function (property) {
      if (!property) {
        return defaultGetter;
      }

      if (property.propType === 'unidimensional') {
        return UnidimensionalPropertyInterface(property);
      }

      return MultidimensionalPropertyInterface(property);
    };
  }();

  var TransformExpressionInterface = function () {
    return function (transform) {
      function _thisFunction(name) {
        switch (name) {
          case 'scale':
          case 'Scale':
          case 'ADBE Scale':
          case 6:
            return _thisFunction.scale;

          case 'rotation':
          case 'Rotation':
          case 'ADBE Rotation':
          case 'ADBE Rotate Z':
          case 10:
            return _thisFunction.rotation;

          case 'ADBE Rotate X':
            return _thisFunction.xRotation;

          case 'ADBE Rotate Y':
            return _thisFunction.yRotation;

          case 'position':
          case 'Position':
          case 'ADBE Position':
          case 2:
            return _thisFunction.position;

          case 'ADBE Position_0':
            return _thisFunction.xPosition;

          case 'ADBE Position_1':
            return _thisFunction.yPosition;

          case 'ADBE Position_2':
            return _thisFunction.zPosition;

          case 'anchorPoint':
          case 'AnchorPoint':
          case 'Anchor Point':
          case 'ADBE AnchorPoint':
          case 1:
            return _thisFunction.anchorPoint;

          case 'opacity':
          case 'Opacity':
          case 11:
            return _thisFunction.opacity;

          default:
            return null;
        }
      }

      Object.defineProperty(_thisFunction, 'rotation', {
        get: ExpressionPropertyInterface(transform.r || transform.rz)
      });
      Object.defineProperty(_thisFunction, 'zRotation', {
        get: ExpressionPropertyInterface(transform.rz || transform.r)
      });
      Object.defineProperty(_thisFunction, 'xRotation', {
        get: ExpressionPropertyInterface(transform.rx)
      });
      Object.defineProperty(_thisFunction, 'yRotation', {
        get: ExpressionPropertyInterface(transform.ry)
      });
      Object.defineProperty(_thisFunction, 'scale', {
        get: ExpressionPropertyInterface(transform.s)
      });

      var _px;

      var _py;

      var _pz;

      var _transformFactory;

      if (transform.p) {
        _transformFactory = ExpressionPropertyInterface(transform.p);
      } else {
        _px = ExpressionPropertyInterface(transform.px);
        _py = ExpressionPropertyInterface(transform.py);

        if (transform.pz) {
          _pz = ExpressionPropertyInterface(transform.pz);
        }
      }

      Object.defineProperty(_thisFunction, 'position', {
        get: function get() {
          if (transform.p) {
            return _transformFactory();
          }

          return [_px(), _py(), _pz ? _pz() : 0];
        }
      });
      Object.defineProperty(_thisFunction, 'xPosition', {
        get: ExpressionPropertyInterface(transform.px)
      });
      Object.defineProperty(_thisFunction, 'yPosition', {
        get: ExpressionPropertyInterface(transform.py)
      });
      Object.defineProperty(_thisFunction, 'zPosition', {
        get: ExpressionPropertyInterface(transform.pz)
      });
      Object.defineProperty(_thisFunction, 'anchorPoint', {
        get: ExpressionPropertyInterface(transform.a)
      });
      Object.defineProperty(_thisFunction, 'opacity', {
        get: ExpressionPropertyInterface(transform.o)
      });
      Object.defineProperty(_thisFunction, 'skew', {
        get: ExpressionPropertyInterface(transform.sk)
      });
      Object.defineProperty(_thisFunction, 'skewAxis', {
        get: ExpressionPropertyInterface(transform.sa)
      });
      Object.defineProperty(_thisFunction, 'orientation', {
        get: ExpressionPropertyInterface(transform.or)
      });
      return _thisFunction;
    };
  }();

  var LayerExpressionInterface = function () {
    function getMatrix(time) {
      var toWorldMat = new Matrix();

      if (time !== undefined) {
        var propMatrix = this._elem.finalTransform.mProp.getValueAtTime(time);

        propMatrix.clone(toWorldMat);
      } else {
        var transformMat = this._elem.finalTransform.mProp;
        transformMat.applyToMatrix(toWorldMat);
      }

      return toWorldMat;
    }

    function toWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.applyPoint(toWorldMat, arr);
    }

    function toWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.applyPoint(toWorldMat, arr);
    }

    function fromWorldVec(arr, time) {
      var toWorldMat = this.getMatrix(time);
      toWorldMat.props[12] = 0;
      toWorldMat.props[13] = 0;
      toWorldMat.props[14] = 0;
      return this.invertPoint(toWorldMat, arr);
    }

    function fromWorld(arr, time) {
      var toWorldMat = this.getMatrix(time);
      return this.invertPoint(toWorldMat, arr);
    }

    function applyPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }

      return matrix.applyToPointArray(arr[0], arr[1], arr[2] || 0);
    }

    function invertPoint(matrix, arr) {
      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(matrix);
        }
      }

      return matrix.inversePoint(arr);
    }

    function fromComp(arr) {
      var toWorldMat = new Matrix();
      toWorldMat.reset();

      this._elem.finalTransform.mProp.applyToMatrix(toWorldMat);

      if (this._elem.hierarchy && this._elem.hierarchy.length) {
        var i;
        var len = this._elem.hierarchy.length;

        for (i = 0; i < len; i += 1) {
          this._elem.hierarchy[i].finalTransform.mProp.applyToMatrix(toWorldMat);
        }

        return toWorldMat.inversePoint(arr);
      }

      return toWorldMat.inversePoint(arr);
    }

    function sampleImage() {
      return [1, 1, 1, 1];
    }

    return function (elem) {
      var transformInterface;

      function _registerMaskInterface(maskManager) {
        _thisLayerFunction.mask = new MaskManagerInterface(maskManager, elem);
      }

      function _registerEffectsInterface(effects) {
        _thisLayerFunction.effect = effects;
      }

      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Root Vectors Group':
          case 'Contents':
          case 2:
            return _thisLayerFunction.shapeInterface;

          case 1:
          case 6:
          case 'Transform':
          case 'transform':
          case 'ADBE Transform Group':
            return transformInterface;

          case 4:
          case 'ADBE Effect Parade':
          case 'effects':
          case 'Effects':
            return _thisLayerFunction.effect;

          case 'ADBE Text Properties':
            return _thisLayerFunction.textInterface;

          default:
            return null;
        }
      }

      _thisLayerFunction.getMatrix = getMatrix;
      _thisLayerFunction.invertPoint = invertPoint;
      _thisLayerFunction.applyPoint = applyPoint;
      _thisLayerFunction.toWorld = toWorld;
      _thisLayerFunction.toWorldVec = toWorldVec;
      _thisLayerFunction.fromWorld = fromWorld;
      _thisLayerFunction.fromWorldVec = fromWorldVec;
      _thisLayerFunction.toComp = toWorld;
      _thisLayerFunction.fromComp = fromComp;
      _thisLayerFunction.sampleImage = sampleImage;
      _thisLayerFunction.sourceRectAtTime = elem.sourceRectAtTime.bind(elem);
      _thisLayerFunction._elem = elem;
      transformInterface = TransformExpressionInterface(elem.finalTransform.mProp);
      var anchorPointDescriptor = getDescriptor(transformInterface, 'anchorPoint');
      Object.defineProperties(_thisLayerFunction, {
        hasParent: {
          get: function get() {
            return elem.hierarchy.length;
          }
        },
        parent: {
          get: function get() {
            return elem.hierarchy[0].layerInterface;
          }
        },
        rotation: getDescriptor(transformInterface, 'rotation'),
        scale: getDescriptor(transformInterface, 'scale'),
        position: getDescriptor(transformInterface, 'position'),
        opacity: getDescriptor(transformInterface, 'opacity'),
        anchorPoint: anchorPointDescriptor,
        anchor_point: anchorPointDescriptor,
        transform: {
          get: function get() {
            return transformInterface;
          }
        },
        active: {
          get: function get() {
            return elem.isInRange;
          }
        }
      });
      _thisLayerFunction.startTime = elem.data.st;
      _thisLayerFunction.index = elem.data.ind;
      _thisLayerFunction.source = elem.data.refId;
      _thisLayerFunction.height = elem.data.ty === 0 ? elem.data.h : 100;
      _thisLayerFunction.width = elem.data.ty === 0 ? elem.data.w : 100;
      _thisLayerFunction.inPoint = elem.data.ip / elem.comp.globalData.frameRate;
      _thisLayerFunction.outPoint = elem.data.op / elem.comp.globalData.frameRate;
      _thisLayerFunction._name = elem.data.nm;
      _thisLayerFunction.registerMaskInterface = _registerMaskInterface;
      _thisLayerFunction.registerEffectsInterface = _registerEffectsInterface;
      return _thisLayerFunction;
    };
  }();

  var propertyGroupFactory = function () {
    return function (interfaceFunction, parentPropertyGroup) {
      return function (val) {
        val = val === undefined ? 1 : val;

        if (val <= 0) {
          return interfaceFunction;
        }

        return parentPropertyGroup(val - 1);
      };
    };
  }();

  var PropertyInterface = function () {
    return function (propertyName, propertyGroup) {
      var interfaceFunction = {
        _name: propertyName
      };

      function _propertyGroup(val) {
        val = val === undefined ? 1 : val;

        if (val <= 0) {
          return interfaceFunction;
        }

        return propertyGroup(val - 1);
      }

      return _propertyGroup;
    };
  }();

  var EffectsExpressionInterface = function () {
    var ob = {
      createEffectsInterface: createEffectsInterface
    };

    function createEffectsInterface(elem, propertyGroup) {
      if (elem.effectsManager) {
        var effectElements = [];
        var effectsData = elem.data.ef;
        var i;
        var len = elem.effectsManager.effectElements.length;

        for (i = 0; i < len; i += 1) {
          effectElements.push(createGroupInterface(effectsData[i], elem.effectsManager.effectElements[i], propertyGroup, elem));
        }

        var effects = elem.data.ef || [];

        var groupInterface = function groupInterface(name) {
          i = 0;
          len = effects.length;

          while (i < len) {
            if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
              return effectElements[i];
            }

            i += 1;
          }

          return null;
        };

        Object.defineProperty(groupInterface, 'numProperties', {
          get: function get() {
            return effects.length;
          }
        });
        return groupInterface;
      }

      return null;
    }

    function createGroupInterface(data, elements, propertyGroup, elem) {
      function groupInterface(name) {
        var effects = data.ef;
        var i = 0;
        var len = effects.length;

        while (i < len) {
          if (name === effects[i].nm || name === effects[i].mn || name === effects[i].ix) {
            if (effects[i].ty === 5) {
              return effectElements[i];
            }

            return effectElements[i]();
          }

          i += 1;
        }

        throw new Error();
      }

      var _propertyGroup = propertyGroupFactory(groupInterface, propertyGroup);

      var effectElements = [];
      var i;
      var len = data.ef.length;

      for (i = 0; i < len; i += 1) {
        if (data.ef[i].ty === 5) {
          effectElements.push(createGroupInterface(data.ef[i], elements.effectElements[i], elements.effectElements[i].propertyGroup, elem));
        } else {
          effectElements.push(createValueInterface(elements.effectElements[i], data.ef[i].ty, elem, _propertyGroup));
        }
      }

      if (data.mn === 'ADBE Color Control') {
        Object.defineProperty(groupInterface, 'color', {
          get: function get() {
            return effectElements[0]();
          }
        });
      }

      Object.defineProperties(groupInterface, {
        numProperties: {
          get: function get() {
            return data.np;
          }
        },
        _name: {
          value: data.nm
        },
        propertyGroup: {
          value: _propertyGroup
        }
      });
      groupInterface.enabled = data.en !== 0;
      groupInterface.active = groupInterface.enabled;
      return groupInterface;
    }

    function createValueInterface(element, type, elem, propertyGroup) {
      var expressionProperty = ExpressionPropertyInterface(element.p);

      function interfaceFunction() {
        if (type === 10) {
          return elem.comp.compInterface(element.p.v);
        }

        return expressionProperty();
      }

      if (element.p.setGroupProperty) {
        element.p.setGroupProperty(PropertyInterface('', propertyGroup));
      }

      return interfaceFunction;
    }

    return ob;
  }();

  var ShapePathInterface = function () {
    return function pathInterfaceFactory(shape, view, propertyGroup) {
      var prop = view.sh;

      function interfaceFunction(val) {
        if (val === 'Shape' || val === 'shape' || val === 'Path' || val === 'path' || val === 'ADBE Vector Shape' || val === 2) {
          return interfaceFunction.path;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      prop.setGroupProperty(PropertyInterface('Path', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        path: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }

            return prop;
          }
        },
        shape: {
          get: function get() {
            if (prop.k) {
              prop.getValue();
            }

            return prop;
          }
        },
        _name: {
          value: shape.nm
        },
        ix: {
          value: shape.ix
        },
        propertyIndex: {
          value: shape.ix
        },
        mn: {
          value: shape.mn
        },
        propertyGroup: {
          value: propertyGroup
        }
      });
      return interfaceFunction;
    };
  }();

  var ShapeExpressionInterface = function () {
    function iterateElements(shapes, view, propertyGroup) {
      var arr = [];
      var i;
      var len = shapes ? shapes.length : 0;

      for (i = 0; i < len; i += 1) {
        if (shapes[i].ty === 'gr') {
          arr.push(groupInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'fl') {
          arr.push(fillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'st') {
          arr.push(strokeInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tm') {
          arr.push(trimInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'tr') {// arr.push(transformInterfaceFactory(shapes[i],view[i],propertyGroup));
        } else if (shapes[i].ty === 'el') {
          arr.push(ellipseInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sr') {
          arr.push(starInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'sh') {
          arr.push(ShapePathInterface(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rc') {
          arr.push(rectInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rd') {
          arr.push(roundedInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'rp') {
          arr.push(repeaterInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else if (shapes[i].ty === 'gf') {
          arr.push(gradientFillInterfaceFactory(shapes[i], view[i], propertyGroup));
        } else {
          arr.push(defaultInterfaceFactory(shapes[i], view[i], propertyGroup));
        }
      }

      return arr;
    }

    function contentsInterfaceFactory(shape, view, propertyGroup) {
      var interfaces;

      var interfaceFunction = function _interfaceFunction(value) {
        var i = 0;
        var len = interfaces.length;

        while (i < len) {
          if (interfaces[i]._name === value || interfaces[i].mn === value || interfaces[i].propertyIndex === value || interfaces[i].ix === value || interfaces[i].ind === value) {
            return interfaces[i];
          }

          i += 1;
        }

        if (typeof value === 'number') {
          return interfaces[value - 1];
        }

        return null;
      };

      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      interfaces = iterateElements(shape.it, view.it, interfaceFunction.propertyGroup);
      interfaceFunction.numProperties = interfaces.length;
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.transform = transformInterface;
      interfaceFunction.propertyIndex = shape.cix;
      interfaceFunction._name = shape.nm;
      return interfaceFunction;
    }

    function groupInterfaceFactory(shape, view, propertyGroup) {
      var interfaceFunction = function _interfaceFunction(value) {
        switch (value) {
          case 'ADBE Vectors Group':
          case 'Contents':
          case 2:
            return interfaceFunction.content;
          // Not necessary for now. Keeping them here in case a new case appears
          // case 'ADBE Vector Transform Group':
          // case 3:

          default:
            return interfaceFunction.transform;
        }
      };

      interfaceFunction.propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);
      var content = contentsInterfaceFactory(shape, view, interfaceFunction.propertyGroup);
      var transformInterface = transformInterfaceFactory(shape.it[shape.it.length - 1], view.it[view.it.length - 1], interfaceFunction.propertyGroup);
      interfaceFunction.content = content;
      interfaceFunction.transform = transformInterface;
      Object.defineProperty(interfaceFunction, '_name', {
        get: function get() {
          return shape.nm;
        }
      }); // interfaceFunction.content = interfaceFunction;

      interfaceFunction.numProperties = shape.np;
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.nm = shape.nm;
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function fillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }

    function gradientFillInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === 'Start Point' || val === 'start point') {
          return interfaceFunction.startPoint;
        }

        if (val === 'End Point' || val === 'end point') {
          return interfaceFunction.endPoint;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        startPoint: {
          get: ExpressionPropertyInterface(view.s)
        },
        endPoint: {
          get: ExpressionPropertyInterface(view.e)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        type: {
          get: function get() {
            return 'a';
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.s.setGroupProperty(PropertyInterface('Start Point', propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End Point', propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', propertyGroup));
      return interfaceFunction;
    }

    function defaultInterfaceFactory() {
      function interfaceFunction() {
        return null;
      }

      return interfaceFunction;
    }

    function strokeInterfaceFactory(shape, view, propertyGroup) {
      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var _dashPropertyGroup = propertyGroupFactory(dashOb, _propertyGroup);

      function addPropertyToDashOb(i) {
        Object.defineProperty(dashOb, shape.d[i].nm, {
          get: ExpressionPropertyInterface(view.d.dataProps[i].p)
        });
      }

      var i;
      var len = shape.d ? shape.d.length : 0;
      var dashOb = {};

      for (i = 0; i < len; i += 1) {
        addPropertyToDashOb(i);
        view.d.dataProps[i].p.setGroupProperty(_dashPropertyGroup);
      }

      function interfaceFunction(val) {
        if (val === 'Color' || val === 'color') {
          return interfaceFunction.color;
        }

        if (val === 'Opacity' || val === 'opacity') {
          return interfaceFunction.opacity;
        }

        if (val === 'Stroke Width' || val === 'stroke width') {
          return interfaceFunction.strokeWidth;
        }

        return null;
      }

      Object.defineProperties(interfaceFunction, {
        color: {
          get: ExpressionPropertyInterface(view.c)
        },
        opacity: {
          get: ExpressionPropertyInterface(view.o)
        },
        strokeWidth: {
          get: ExpressionPropertyInterface(view.w)
        },
        dash: {
          get: function get() {
            return dashOb;
          }
        },
        _name: {
          value: shape.nm
        },
        mn: {
          value: shape.mn
        }
      });
      view.c.setGroupProperty(PropertyInterface('Color', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.w.setGroupProperty(PropertyInterface('Stroke Width', _propertyGroup));
      return interfaceFunction;
    }

    function trimInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(val) {
        if (val === shape.e.ix || val === 'End' || val === 'end') {
          return interfaceFunction.end;
        }

        if (val === shape.s.ix) {
          return interfaceFunction.start;
        }

        if (val === shape.o.ix) {
          return interfaceFunction.offset;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      interfaceFunction.propertyIndex = shape.ix;
      view.s.setGroupProperty(PropertyInterface('Start', _propertyGroup));
      view.e.setGroupProperty(PropertyInterface('End', _propertyGroup));
      view.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      interfaceFunction.propertyIndex = shape.ix;
      interfaceFunction.propertyGroup = propertyGroup;
      Object.defineProperties(interfaceFunction, {
        start: {
          get: ExpressionPropertyInterface(view.s)
        },
        end: {
          get: ExpressionPropertyInterface(view.e)
        },
        offset: {
          get: ExpressionPropertyInterface(view.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function transformInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.a.ix === value || value === 'Anchor Point') {
          return interfaceFunction.anchorPoint;
        }

        if (shape.o.ix === value || value === 'Opacity') {
          return interfaceFunction.opacity;
        }

        if (shape.p.ix === value || value === 'Position') {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value || value === 'Rotation' || value === 'ADBE Vector Rotation') {
          return interfaceFunction.rotation;
        }

        if (shape.s.ix === value || value === 'Scale') {
          return interfaceFunction.scale;
        }

        if (shape.sk && shape.sk.ix === value || value === 'Skew') {
          return interfaceFunction.skew;
        }

        if (shape.sa && shape.sa.ix === value || value === 'Skew Axis') {
          return interfaceFunction.skewAxis;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      view.transform.mProps.o.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      view.transform.mProps.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      view.transform.mProps.a.setGroupProperty(PropertyInterface('Anchor Point', _propertyGroup));
      view.transform.mProps.s.setGroupProperty(PropertyInterface('Scale', _propertyGroup));
      view.transform.mProps.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

      if (view.transform.mProps.sk) {
        view.transform.mProps.sk.setGroupProperty(PropertyInterface('Skew', _propertyGroup));
        view.transform.mProps.sa.setGroupProperty(PropertyInterface('Skew Angle', _propertyGroup));
      }

      view.transform.op.setGroupProperty(PropertyInterface('Opacity', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        opacity: {
          get: ExpressionPropertyInterface(view.transform.mProps.o)
        },
        position: {
          get: ExpressionPropertyInterface(view.transform.mProps.p)
        },
        anchorPoint: {
          get: ExpressionPropertyInterface(view.transform.mProps.a)
        },
        scale: {
          get: ExpressionPropertyInterface(view.transform.mProps.s)
        },
        rotation: {
          get: ExpressionPropertyInterface(view.transform.mProps.r)
        },
        skew: {
          get: ExpressionPropertyInterface(view.transform.mProps.sk)
        },
        skewAxis: {
          get: ExpressionPropertyInterface(view.transform.mProps.sa)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.ty = 'tr';
      interfaceFunction.mn = shape.mn;
      interfaceFunction.propertyGroup = propertyGroup;
      return interfaceFunction;
    }

    function ellipseInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.s.ix === value) {
          return interfaceFunction.size;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      interfaceFunction.propertyIndex = shape.ix;
      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function starInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value) {
          return interfaceFunction.rotation;
        }

        if (shape.pt.ix === value) {
          return interfaceFunction.points;
        }

        if (shape.or.ix === value || value === 'ADBE Vector Star Outer Radius') {
          return interfaceFunction.outerRadius;
        }

        if (shape.os.ix === value) {
          return interfaceFunction.outerRoundness;
        }

        if (shape.ir && (shape.ir.ix === value || value === 'ADBE Vector Star Inner Radius')) {
          return interfaceFunction.innerRadius;
        }

        if (shape.is && shape.is.ix === value) {
          return interfaceFunction.innerRoundness;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.or.setGroupProperty(PropertyInterface('Outer Radius', _propertyGroup));
      prop.os.setGroupProperty(PropertyInterface('Outer Roundness', _propertyGroup));
      prop.pt.setGroupProperty(PropertyInterface('Points', _propertyGroup));
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));

      if (shape.ir) {
        prop.ir.setGroupProperty(PropertyInterface('Inner Radius', _propertyGroup));
        prop.is.setGroupProperty(PropertyInterface('Inner Roundness', _propertyGroup));
      }

      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        rotation: {
          get: ExpressionPropertyInterface(prop.r)
        },
        points: {
          get: ExpressionPropertyInterface(prop.pt)
        },
        outerRadius: {
          get: ExpressionPropertyInterface(prop.or)
        },
        outerRoundness: {
          get: ExpressionPropertyInterface(prop.os)
        },
        innerRadius: {
          get: ExpressionPropertyInterface(prop.ir)
        },
        innerRoundness: {
          get: ExpressionPropertyInterface(prop.is)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function rectInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.p.ix === value) {
          return interfaceFunction.position;
        }

        if (shape.r.ix === value) {
          return interfaceFunction.roundness;
        }

        if (shape.s.ix === value || value === 'Size' || value === 'ADBE Vector Rect Size') {
          return interfaceFunction.size;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view.sh.ty === 'tm' ? view.sh.prop : view.sh;
      interfaceFunction.propertyIndex = shape.ix;
      prop.p.setGroupProperty(PropertyInterface('Position', _propertyGroup));
      prop.s.setGroupProperty(PropertyInterface('Size', _propertyGroup));
      prop.r.setGroupProperty(PropertyInterface('Rotation', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        position: {
          get: ExpressionPropertyInterface(prop.p)
        },
        roundness: {
          get: ExpressionPropertyInterface(prop.r)
        },
        size: {
          get: ExpressionPropertyInterface(prop.s)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function roundedInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.r.ix === value || value === 'Round Corners 1') {
          return interfaceFunction.radius;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.rd.setGroupProperty(PropertyInterface('Radius', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        radius: {
          get: ExpressionPropertyInterface(prop.rd)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    function repeaterInterfaceFactory(shape, view, propertyGroup) {
      function interfaceFunction(value) {
        if (shape.c.ix === value || value === 'Copies') {
          return interfaceFunction.copies;
        }

        if (shape.o.ix === value || value === 'Offset') {
          return interfaceFunction.offset;
        }

        return null;
      }

      var _propertyGroup = propertyGroupFactory(interfaceFunction, propertyGroup);

      var prop = view;
      interfaceFunction.propertyIndex = shape.ix;
      prop.c.setGroupProperty(PropertyInterface('Copies', _propertyGroup));
      prop.o.setGroupProperty(PropertyInterface('Offset', _propertyGroup));
      Object.defineProperties(interfaceFunction, {
        copies: {
          get: ExpressionPropertyInterface(prop.c)
        },
        offset: {
          get: ExpressionPropertyInterface(prop.o)
        },
        _name: {
          value: shape.nm
        }
      });
      interfaceFunction.mn = shape.mn;
      return interfaceFunction;
    }

    return function (shapes, view, propertyGroup) {
      var interfaces;

      function _interfaceFunction(value) {
        if (typeof value === 'number') {
          value = value === undefined ? 1 : value;

          if (value === 0) {
            return propertyGroup;
          }

          return interfaces[value - 1];
        }

        var i = 0;
        var len = interfaces.length;

        while (i < len) {
          if (interfaces[i]._name === value) {
            return interfaces[i];
          }

          i += 1;
        }

        return null;
      }

      function parentGroupWrapper() {
        return propertyGroup;
      }

      _interfaceFunction.propertyGroup = propertyGroupFactory(_interfaceFunction, parentGroupWrapper);
      interfaces = iterateElements(shapes, view, _interfaceFunction.propertyGroup);
      _interfaceFunction.numProperties = interfaces.length;
      _interfaceFunction._name = 'Contents';
      return _interfaceFunction;
    };
  }();

  var TextExpressionInterface = function () {
    return function (elem) {
      var _sourceText;

      function _thisLayerFunction(name) {
        switch (name) {
          case 'ADBE Text Document':
            return _thisLayerFunction.sourceText;

          default:
            return null;
        }
      }

      Object.defineProperty(_thisLayerFunction, 'sourceText', {
        get: function get() {
          elem.textProperty.getValue();
          var stringValue = elem.textProperty.currentData.t;

          if (!_sourceText || stringValue !== _sourceText.value) {
            _sourceText = new String(stringValue); // eslint-disable-line no-new-wrappers
            // If stringValue is an empty string, eval returns undefined, so it has to be returned as a String primitive

            _sourceText.value = stringValue || new String(stringValue); // eslint-disable-line no-new-wrappers

            Object.defineProperty(_sourceText, 'style', {
              get: function get() {
                return {
                  fillColor: elem.textProperty.currentData.fc
                };
              }
            });
          }

          return _sourceText;
        }
      });
      return _thisLayerFunction;
    };
  }();

  function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

  var FootageInterface = function () {
    var outlineInterfaceFactory = function outlineInterfaceFactory(elem) {
      var currentPropertyName = '';
      var currentProperty = elem.getFootageData();

      function init() {
        currentPropertyName = '';
        currentProperty = elem.getFootageData();
        return searchProperty;
      }

      function searchProperty(value) {
        if (currentProperty[value]) {
          currentPropertyName = value;
          currentProperty = currentProperty[value];

          if (_typeof(currentProperty) === 'object') {
            return searchProperty;
          }

          return currentProperty;
        }

        var propertyNameIndex = value.indexOf(currentPropertyName);

        if (propertyNameIndex !== -1) {
          var index = parseInt(value.substr(propertyNameIndex + currentPropertyName.length), 10);
          currentProperty = currentProperty[index];

          if (_typeof(currentProperty) === 'object') {
            return searchProperty;
          }

          return currentProperty;
        }

        return '';
      }

      return init;
    };

    var dataInterfaceFactory = function dataInterfaceFactory(elem) {
      function interfaceFunction(value) {
        if (value === 'Outline') {
          return interfaceFunction.outlineInterface();
        }

        return null;
      }

      interfaceFunction._name = 'Outline';
      interfaceFunction.outlineInterface = outlineInterfaceFactory(elem);
      return interfaceFunction;
    };

    return function (elem) {
      function _interfaceFunction(value) {
        if (value === 'Data') {
          return _interfaceFunction.dataInterface;
        }

        return null;
      }

      _interfaceFunction._name = 'Data';
      _interfaceFunction.dataInterface = dataInterfaceFactory(elem);
      return _interfaceFunction;
    };
  }();

  var interfaces = {
    layer: LayerExpressionInterface,
    effects: EffectsExpressionInterface,
    comp: CompExpressionInterface,
    shape: ShapeExpressionInterface,
    text: TextExpressionInterface,
    footage: FootageInterface
  };

  function getInterface(type) {
    return interfaces[type] || null;
  }

  var expressionHelpers = function () {
    function searchExpressions(elem, data, prop) {
      if (data.x) {
        prop.k = true;
        prop.x = true;
        prop.initiateExpression = ExpressionManager.initiateExpression;
        prop.effectsSequence.push(prop.initiateExpression(elem, data, prop).bind(prop));
      }
    }

    function getValueAtTime(frameNum) {
      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;

      if (frameNum !== this._cachingAtTime.lastFrame) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastFrame < frameNum ? this._cachingAtTime.lastIndex : 0;
        this._cachingAtTime.value = this.interpolateValue(frameNum, this._cachingAtTime);
        this._cachingAtTime.lastFrame = frameNum;
      }

      return this._cachingAtTime.value;
    }

    function getSpeedAtTime(frameNum) {
      var delta = -0.01;
      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var speed = 0;

      if (v1.length) {
        var i;

        for (i = 0; i < v1.length; i += 1) {
          speed += Math.pow(v2[i] - v1[i], 2);
        }

        speed = Math.sqrt(speed) * 100;
      } else {
        speed = 0;
      }

      return speed;
    }

    function getVelocityAtTime(frameNum) {
      if (this.vel !== undefined) {
        return this.vel;
      }

      var delta = -0.001; // frameNum += this.elem.data.st;

      var v1 = this.getValueAtTime(frameNum);
      var v2 = this.getValueAtTime(frameNum + delta);
      var velocity;

      if (v1.length) {
        velocity = createTypedArray('float32', v1.length);
        var i;

        for (i = 0; i < v1.length; i += 1) {
          // removing frameRate
          // if needed, don't add it here
          // velocity[i] = this.elem.globalData.frameRate*((v2[i] - v1[i])/delta);
          velocity[i] = (v2[i] - v1[i]) / delta;
        }
      } else {
        velocity = (v2 - v1) / delta;
      }

      return velocity;
    }

    function getStaticValueAtTime() {
      return this.pv;
    }

    function setGroupProperty(propertyGroup) {
      this.propertyGroup = propertyGroup;
    }

    return {
      searchExpressions: searchExpressions,
      getSpeedAtTime: getSpeedAtTime,
      getVelocityAtTime: getVelocityAtTime,
      getValueAtTime: getValueAtTime,
      getStaticValueAtTime: getStaticValueAtTime,
      setGroupProperty: setGroupProperty
    };
  }();

  function addPropertyDecorator() {
    function loopOut(type, duration, durationFlag) {
      if (!this.k || !this.keyframes) {
        return this.pv;
      }

      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var lastKeyFrame = keyframes[keyframes.length - 1].t;

      if (currentFrame <= lastKeyFrame) {
        return this.pv;
      }

      var cycleDuration;
      var firstKeyFrame;

      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }

        firstKeyFrame = keyframes[keyframes.length - 1 - duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, lastKeyFrame - this.elem.data.ip);
        } else {
          cycleDuration = Math.abs(lastKeyFrame - this.elem.comp.globalData.frameRate * duration);
        }

        firstKeyFrame = lastKeyFrame - cycleDuration;
      }

      var i;
      var len;
      var ret;

      if (type === 'pingpong') {
        var iterations = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

        if (iterations % 2 !== 0) {
          return this.getValueAtTime((cycleDuration - (currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line

        var repeats = Math.floor((currentFrame - firstKeyFrame) / cycleDuration);

        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = (endV[i] - initV[i]) * repeats + current[i];
          }

          return ret;
        }

        return (endV - initV) * repeats + current;
      } else if (type === 'continue') {
        var lastValue = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var nextLastValue = this.getValueAtTime((lastKeyFrame - 0.001) / this.comp.globalData.frameRate, 0);

        if (this.pv.length) {
          ret = new Array(lastValue.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = lastValue[i] + (lastValue[i] - nextLastValue[i]) * ((currentFrame - lastKeyFrame) / this.comp.globalData.frameRate) / 0.0005; // eslint-disable-line
          }

          return ret;
        }

        return lastValue + (lastValue - nextLastValue) * ((currentFrame - lastKeyFrame) / 0.001);
      }

      return this.getValueAtTime(((currentFrame - firstKeyFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }

    function loopIn(type, duration, durationFlag) {
      if (!this.k) {
        return this.pv;
      }

      type = type ? type.toLowerCase() : '';
      var currentFrame = this.comp.renderedFrame;
      var keyframes = this.keyframes;
      var firstKeyFrame = keyframes[0].t;

      if (currentFrame >= firstKeyFrame) {
        return this.pv;
      }

      var cycleDuration;
      var lastKeyFrame;

      if (!durationFlag) {
        if (!duration || duration > keyframes.length - 1) {
          duration = keyframes.length - 1;
        }

        lastKeyFrame = keyframes[duration].t;
        cycleDuration = lastKeyFrame - firstKeyFrame;
      } else {
        if (!duration) {
          cycleDuration = Math.max(0, this.elem.data.op - firstKeyFrame);
        } else {
          cycleDuration = Math.abs(this.elem.comp.globalData.frameRate * duration);
        }

        lastKeyFrame = firstKeyFrame + cycleDuration;
      }

      var i;
      var len;
      var ret;

      if (type === 'pingpong') {
        var iterations = Math.floor((firstKeyFrame - currentFrame) / cycleDuration);

        if (iterations % 2 === 0) {
          return this.getValueAtTime(((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0); // eslint-disable-line
        }
      } else if (type === 'offset') {
        var initV = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var endV = this.getValueAtTime(lastKeyFrame / this.comp.globalData.frameRate, 0);
        var current = this.getValueAtTime((cycleDuration - (firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame) / this.comp.globalData.frameRate, 0);
        var repeats = Math.floor((firstKeyFrame - currentFrame) / cycleDuration) + 1;

        if (this.pv.length) {
          ret = new Array(initV.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = current[i] - (endV[i] - initV[i]) * repeats;
          }

          return ret;
        }

        return current - (endV - initV) * repeats;
      } else if (type === 'continue') {
        var firstValue = this.getValueAtTime(firstKeyFrame / this.comp.globalData.frameRate, 0);
        var nextFirstValue = this.getValueAtTime((firstKeyFrame + 0.001) / this.comp.globalData.frameRate, 0);

        if (this.pv.length) {
          ret = new Array(firstValue.length);
          len = ret.length;

          for (i = 0; i < len; i += 1) {
            ret[i] = firstValue[i] + (firstValue[i] - nextFirstValue[i]) * (firstKeyFrame - currentFrame) / 0.001;
          }

          return ret;
        }

        return firstValue + (firstValue - nextFirstValue) * (firstKeyFrame - currentFrame) / 0.001;
      }

      return this.getValueAtTime((cycleDuration - ((firstKeyFrame - currentFrame) % cycleDuration + firstKeyFrame)) / this.comp.globalData.frameRate, 0); // eslint-disable-line
    }

    function smooth(width, samples) {
      if (!this.k) {
        return this.pv;
      }

      width = (width || 0.4) * 0.5;
      samples = Math.floor(samples || 5);

      if (samples <= 1) {
        return this.pv;
      }

      var currentTime = this.comp.renderedFrame / this.comp.globalData.frameRate;
      var initFrame = currentTime - width;
      var endFrame = currentTime + width;
      var sampleFrequency = samples > 1 ? (endFrame - initFrame) / (samples - 1) : 1;
      var i = 0;
      var j = 0;
      var value;

      if (this.pv.length) {
        value = createTypedArray('float32', this.pv.length);
      } else {
        value = 0;
      }

      var sampleValue;

      while (i < samples) {
        sampleValue = this.getValueAtTime(initFrame + i * sampleFrequency);

        if (this.pv.length) {
          for (j = 0; j < this.pv.length; j += 1) {
            value[j] += sampleValue[j];
          }
        } else {
          value += sampleValue;
        }

        i += 1;
      }

      if (this.pv.length) {
        for (j = 0; j < this.pv.length; j += 1) {
          value[j] /= samples;
        }
      } else {
        value /= samples;
      }

      return value;
    }

    function getTransformValueAtTime(time) {
      if (!this._transformCachingAtTime) {
        this._transformCachingAtTime = {
          v: new Matrix()
        };
      } /// /


      var matrix = this._transformCachingAtTime.v;
      matrix.cloneFromProps(this.pre.props);

      if (this.appliedTransformations < 1) {
        var anchor = this.a.getValueAtTime(time);
        matrix.translate(-anchor[0] * this.a.mult, -anchor[1] * this.a.mult, anchor[2] * this.a.mult);
      }

      if (this.appliedTransformations < 2) {
        var scale = this.s.getValueAtTime(time);
        matrix.scale(scale[0] * this.s.mult, scale[1] * this.s.mult, scale[2] * this.s.mult);
      }

      if (this.sk && this.appliedTransformations < 3) {
        var skew = this.sk.getValueAtTime(time);
        var skewAxis = this.sa.getValueAtTime(time);
        matrix.skewFromAxis(-skew * this.sk.mult, skewAxis * this.sa.mult);
      }

      if (this.r && this.appliedTransformations < 4) {
        var rotation = this.r.getValueAtTime(time);
        matrix.rotate(-rotation * this.r.mult);
      } else if (!this.r && this.appliedTransformations < 4) {
        var rotationZ = this.rz.getValueAtTime(time);
        var rotationY = this.ry.getValueAtTime(time);
        var rotationX = this.rx.getValueAtTime(time);
        var orientation = this.or.getValueAtTime(time);
        matrix.rotateZ(-rotationZ * this.rz.mult).rotateY(rotationY * this.ry.mult).rotateX(rotationX * this.rx.mult).rotateZ(-orientation[2] * this.or.mult).rotateY(orientation[1] * this.or.mult).rotateX(orientation[0] * this.or.mult);
      }

      if (this.data.p && this.data.p.s) {
        var positionX = this.px.getValueAtTime(time);
        var positionY = this.py.getValueAtTime(time);

        if (this.data.p.z) {
          var positionZ = this.pz.getValueAtTime(time);
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, -positionZ * this.pz.mult);
        } else {
          matrix.translate(positionX * this.px.mult, positionY * this.py.mult, 0);
        }
      } else {
        var position = this.p.getValueAtTime(time);
        matrix.translate(position[0] * this.p.mult, position[1] * this.p.mult, -position[2] * this.p.mult);
      }

      return matrix; /// /
    }

    function getTransformStaticValueAtTime() {
      return this.v.clone(new Matrix());
    }

    var getTransformProperty = TransformPropertyFactory.getTransformProperty;

    TransformPropertyFactory.getTransformProperty = function (elem, data, container) {
      var prop = getTransformProperty(elem, data, container);

      if (prop.dynamicProperties.length) {
        prop.getValueAtTime = getTransformValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = getTransformStaticValueAtTime.bind(prop);
      }

      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      return prop;
    };

    var propertyGetProp = PropertyFactory.getProp;

    PropertyFactory.getProp = function (elem, data, type, mult, container) {
      var prop = propertyGetProp(elem, data, type, mult, container); // prop.getVelocityAtTime = getVelocityAtTime;
      // prop.loopOut = loopOut;
      // prop.loopIn = loopIn;

      if (prop.kf) {
        prop.getValueAtTime = expressionHelpers.getValueAtTime.bind(prop);
      } else {
        prop.getValueAtTime = expressionHelpers.getStaticValueAtTime.bind(prop);
      }

      prop.setGroupProperty = expressionHelpers.setGroupProperty;
      prop.loopOut = loopOut;
      prop.loopIn = loopIn;
      prop.smooth = smooth;
      prop.getVelocityAtTime = expressionHelpers.getVelocityAtTime.bind(prop);
      prop.getSpeedAtTime = expressionHelpers.getSpeedAtTime.bind(prop);
      prop.numKeys = data.a === 1 ? data.k.length : 0;
      prop.propertyIndex = data.ix;
      var value = 0;

      if (type !== 0) {
        value = createTypedArray('float32', data.a === 1 ? data.k[0].s.length : data.k.length);
      }

      prop._cachingAtTime = {
        lastFrame: initialDefaultFrame,
        lastIndex: 0,
        value: value
      };
      expressionHelpers.searchExpressions(elem, data, prop);

      if (prop.k) {
        container.addDynamicProperty(prop);
      }

      return prop;
    };

    function getShapeValueAtTime(frameNum) {
      // For now this caching object is created only when needed instead of creating it when the shape is initialized.
      if (!this._cachingAtTime) {
        this._cachingAtTime = {
          shapeValue: shapePool.clone(this.pv),
          lastIndex: 0,
          lastTime: initialDefaultFrame
        };
      }

      frameNum *= this.elem.globalData.frameRate;
      frameNum -= this.offsetTime;

      if (frameNum !== this._cachingAtTime.lastTime) {
        this._cachingAtTime.lastIndex = this._cachingAtTime.lastTime < frameNum ? this._caching.lastIndex : 0;
        this._cachingAtTime.lastTime = frameNum;
        this.interpolateShape(frameNum, this._cachingAtTime.shapeValue, this._cachingAtTime);
      }

      return this._cachingAtTime.shapeValue;
    }

    var ShapePropertyConstructorFunction = ShapePropertyFactory.getConstructorFunction();
    var KeyframedShapePropertyConstructorFunction = ShapePropertyFactory.getKeyframedConstructorFunction();

    function ShapeExpressions() {}

    ShapeExpressions.prototype = {
      vertices: function vertices(prop, time) {
        if (this.k) {
          this.getValue();
        }

        var shapePath = this.v;

        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }

        var i;
        var len = shapePath._length;
        var vertices = shapePath[prop];
        var points = shapePath.v;
        var arr = createSizedArray(len);

        for (i = 0; i < len; i += 1) {
          if (prop === 'i' || prop === 'o') {
            arr[i] = [vertices[i][0] - points[i][0], vertices[i][1] - points[i][1]];
          } else {
            arr[i] = [vertices[i][0], vertices[i][1]];
          }
        }

        return arr;
      },
      points: function points(time) {
        return this.vertices('v', time);
      },
      inTangents: function inTangents(time) {
        return this.vertices('i', time);
      },
      outTangents: function outTangents(time) {
        return this.vertices('o', time);
      },
      isClosed: function isClosed() {
        return this.v.c;
      },
      pointOnPath: function pointOnPath(perc, time) {
        var shapePath = this.v;

        if (time !== undefined) {
          shapePath = this.getValueAtTime(time, 0);
        }

        if (!this._segmentsLength) {
          this._segmentsLength = bez.getSegmentsLength(shapePath);
        }

        var segmentsLength = this._segmentsLength;
        var lengths = segmentsLength.lengths;
        var lengthPos = segmentsLength.totalLength * perc;
        var i = 0;
        var len = lengths.length;
        var accumulatedLength = 0;
        var pt;

        while (i < len) {
          if (accumulatedLength + lengths[i].addedLength > lengthPos) {
            var initIndex = i;
            var endIndex = shapePath.c && i === len - 1 ? 0 : i + 1;
            var segmentPerc = (lengthPos - accumulatedLength) / lengths[i].addedLength;
            pt = bez.getPointInSegment(shapePath.v[initIndex], shapePath.v[endIndex], shapePath.o[initIndex], shapePath.i[endIndex], segmentPerc, lengths[i]);
            break;
          } else {
            accumulatedLength += lengths[i].addedLength;
          }

          i += 1;
        }

        if (!pt) {
          pt = shapePath.c ? [shapePath.v[0][0], shapePath.v[0][1]] : [shapePath.v[shapePath._length - 1][0], shapePath.v[shapePath._length - 1][1]];
        }

        return pt;
      },
      vectorOnPath: function vectorOnPath(perc, time, vectorType) {
        // perc doesn't use triple equality because it can be a Number object as well as a primitive.
        if (perc == 1) {
          // eslint-disable-line eqeqeq
          perc = this.v.c;
        } else if (perc == 0) {
          // eslint-disable-line eqeqeq
          perc = 0.999;
        }

        var pt1 = this.pointOnPath(perc, time);
        var pt2 = this.pointOnPath(perc + 0.001, time);
        var xLength = pt2[0] - pt1[0];
        var yLength = pt2[1] - pt1[1];
        var magnitude = Math.sqrt(Math.pow(xLength, 2) + Math.pow(yLength, 2));

        if (magnitude === 0) {
          return [0, 0];
        }

        var unitVector = vectorType === 'tangent' ? [xLength / magnitude, yLength / magnitude] : [-yLength / magnitude, xLength / magnitude];
        return unitVector;
      },
      tangentOnPath: function tangentOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'tangent');
      },
      normalOnPath: function normalOnPath(perc, time) {
        return this.vectorOnPath(perc, time, 'normal');
      },
      setGroupProperty: expressionHelpers.setGroupProperty,
      getValueAtTime: expressionHelpers.getStaticValueAtTime
    };
    extendPrototype([ShapeExpressions], ShapePropertyConstructorFunction);
    extendPrototype([ShapeExpressions], KeyframedShapePropertyConstructorFunction);
    KeyframedShapePropertyConstructorFunction.prototype.getValueAtTime = getShapeValueAtTime;
    KeyframedShapePropertyConstructorFunction.prototype.initiateExpression = ExpressionManager.initiateExpression;
    var propertyGetShapeProp = ShapePropertyFactory.getShapeProp;

    ShapePropertyFactory.getShapeProp = function (elem, data, type, arr, trims) {
      var prop = propertyGetShapeProp(elem, data, type, arr, trims);
      prop.propertyIndex = data.ix;
      prop.lock = false;

      if (type === 3) {
        expressionHelpers.searchExpressions(elem, data.pt, prop);
      } else if (type === 4) {
        expressionHelpers.searchExpressions(elem, data.ks, prop);
      }

      if (prop.k) {
        elem.addDynamicProperty(prop);
      }

      return prop;
    };
  }

  function initialize$1() {
    addPropertyDecorator();
  }

  function addDecorator() {
    function searchExpressions() {
      if (this.data.d.x) {
        this.calculateExpression = ExpressionManager.initiateExpression.bind(this)(this.elem, this.data.d, this);
        this.addEffect(this.getExpressionValue.bind(this));
        return true;
      }

      return null;
    }

    TextProperty.prototype.getExpressionValue = function (currentValue, text) {
      var newValue = this.calculateExpression(text);

      if (currentValue.t !== newValue) {
        var newData = {};
        this.copyData(newData, currentValue);
        newData.t = newValue.toString();
        newData.__complete = false;
        return newData;
      }

      return currentValue;
    };

    TextProperty.prototype.searchProperty = function () {
      var isKeyframed = this.searchKeyframes();
      var hasExpressions = this.searchExpressions();
      this.kf = isKeyframed || hasExpressions;
      return this.kf;
    };

    TextProperty.prototype.searchExpressions = searchExpressions;
  }

  function initialize() {
    addDecorator();
  }

  function SVGComposableEffect() {}

  SVGComposableEffect.prototype = {
    createMergeNode: function createMergeNode(resultId, ins) {
      var feMerge = createNS('feMerge');
      feMerge.setAttribute('result', resultId);
      var feMergeNode;
      var i;

      for (i = 0; i < ins.length; i += 1) {
        feMergeNode = createNS('feMergeNode');
        feMergeNode.setAttribute('in', ins[i]);
        feMerge.appendChild(feMergeNode);
        feMerge.appendChild(feMergeNode);
      }

      return feMerge;
    }
  };

  var linearFilterValue = '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0';

  function SVGTintFilter(filter, filterManager, elem, id, source) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', linearFilterValue + ' 1 0');
    this.linearFilter = feColorMatrix;
    feColorMatrix.setAttribute('result', id + '_tint_1');
    filter.appendChild(feColorMatrix);
    feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id + '_tint_2');
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
    var feMerge = this.createMergeNode(id, [source, id + '_tint_1', id + '_tint_2']);
    filter.appendChild(feMerge);
  }

  extendPrototype([SVGComposableEffect], SVGTintFilter);

  SVGTintFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var colorBlack = this.filterManager.effectElements[0].p.v;
      var colorWhite = this.filterManager.effectElements[1].p.v;
      var opacity = this.filterManager.effectElements[2].p.v / 100;
      this.linearFilter.setAttribute('values', linearFilterValue + ' ' + opacity + ' 0');
      this.matrixFilter.setAttribute('values', colorWhite[0] - colorBlack[0] + ' 0 0 0 ' + colorBlack[0] + ' ' + (colorWhite[1] - colorBlack[1]) + ' 0 0 0 ' + colorBlack[1] + ' ' + (colorWhite[2] - colorBlack[2]) + ' 0 0 0 ' + colorBlack[2] + ' 0 0 0 1 0');
    }
  };

  function SVGFillFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'sRGB');
    feColorMatrix.setAttribute('values', '1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0');
    feColorMatrix.setAttribute('result', id);
    filter.appendChild(feColorMatrix);
    this.matrixFilter = feColorMatrix;
  }

  SVGFillFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color = this.filterManager.effectElements[2].p.v;
      var opacity = this.filterManager.effectElements[6].p.v;
      this.matrixFilter.setAttribute('values', '0 0 0 0 ' + color[0] + ' 0 0 0 0 ' + color[1] + ' 0 0 0 0 ' + color[2] + ' 0 0 0 ' + opacity + ' 0');
    }
  };

  function SVGStrokeEffect(fil, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.elem = elem;
    this.paths = [];
  }

  SVGStrokeEffect.prototype.initialize = function () {
    var elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;
    var path;
    var groupPath;
    var i;
    var len;

    if (this.filterManager.effectElements[1].p.v === 1) {
      len = this.elem.maskManager.masksProperties.length;
      i = 0;
    } else {
      i = this.filterManager.effectElements[0].p.v - 1;
      len = i + 1;
    }

    groupPath = createNS('g');
    groupPath.setAttribute('fill', 'none');
    groupPath.setAttribute('stroke-linecap', 'round');
    groupPath.setAttribute('stroke-dashoffset', 1);

    for (i; i < len; i += 1) {
      path = createNS('path');
      groupPath.appendChild(path);
      this.paths.push({
        p: path,
        m: i
      });
    }

    if (this.filterManager.effectElements[10].p.v === 3) {
      var mask = createNS('mask');
      var id = createElementID();
      mask.setAttribute('id', id);
      mask.setAttribute('mask-type', 'alpha');
      mask.appendChild(groupPath);
      this.elem.globalData.defs.appendChild(mask);
      var g = createNS('g');
      g.setAttribute('mask', 'url(' + getLocationHref() + '#' + id + ')');

      while (elemChildren[0]) {
        g.appendChild(elemChildren[0]);
      }

      this.elem.layerElement.appendChild(g);
      this.masker = mask;
      groupPath.setAttribute('stroke', '#fff');
    } else if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (this.filterManager.effectElements[10].p.v === 2) {
        elemChildren = this.elem.layerElement.children || this.elem.layerElement.childNodes;

        while (elemChildren.length) {
          this.elem.layerElement.removeChild(elemChildren[0]);
        }
      }

      this.elem.layerElement.appendChild(groupPath);
      this.elem.layerElement.removeAttribute('mask');
      groupPath.setAttribute('stroke', '#fff');
    }

    this.initialized = true;
    this.pathMasker = groupPath;
  };

  SVGStrokeEffect.prototype.renderFrame = function (forceRender) {
    if (!this.initialized) {
      this.initialize();
    }

    var i;
    var len = this.paths.length;
    var mask;
    var path;

    for (i = 0; i < len; i += 1) {
      if (this.paths[i].m !== -1) {
        mask = this.elem.maskManager.viewData[this.paths[i].m];
        path = this.paths[i].p;

        if (forceRender || this.filterManager._mdf || mask.prop._mdf) {
          path.setAttribute('d', mask.lastPath);
        }

        if (forceRender || this.filterManager.effectElements[9].p._mdf || this.filterManager.effectElements[4].p._mdf || this.filterManager.effectElements[7].p._mdf || this.filterManager.effectElements[8].p._mdf || mask.prop._mdf) {
          var dasharrayValue;

          if (this.filterManager.effectElements[7].p.v !== 0 || this.filterManager.effectElements[8].p.v !== 100) {
            var s = Math.min(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var e = Math.max(this.filterManager.effectElements[7].p.v, this.filterManager.effectElements[8].p.v) * 0.01;
            var l = path.getTotalLength();
            dasharrayValue = '0 0 0 ' + l * s + ' ';
            var lineLength = l * (e - s);
            var segment = 1 + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
            var units = Math.floor(lineLength / segment);
            var j;

            for (j = 0; j < units; j += 1) {
              dasharrayValue += '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01 + ' ';
            }

            dasharrayValue += '0 ' + l * 10 + ' 0 0';
          } else {
            dasharrayValue = '1 ' + this.filterManager.effectElements[4].p.v * 2 * this.filterManager.effectElements[9].p.v * 0.01;
          }

          path.setAttribute('stroke-dasharray', dasharrayValue);
        }
      }
    }

    if (forceRender || this.filterManager.effectElements[4].p._mdf) {
      this.pathMasker.setAttribute('stroke-width', this.filterManager.effectElements[4].p.v * 2);
    }

    if (forceRender || this.filterManager.effectElements[6].p._mdf) {
      this.pathMasker.setAttribute('opacity', this.filterManager.effectElements[6].p.v);
    }

    if (this.filterManager.effectElements[10].p.v === 1 || this.filterManager.effectElements[10].p.v === 2) {
      if (forceRender || this.filterManager.effectElements[3].p._mdf) {
        var color = this.filterManager.effectElements[3].p.v;
        this.pathMasker.setAttribute('stroke', 'rgb(' + bmFloor(color[0] * 255) + ',' + bmFloor(color[1] * 255) + ',' + bmFloor(color[2] * 255) + ')');
      }
    }
  };

  function SVGTritoneFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var feColorMatrix = createNS('feColorMatrix');
    feColorMatrix.setAttribute('type', 'matrix');
    feColorMatrix.setAttribute('color-interpolation-filters', 'linearRGB');
    feColorMatrix.setAttribute('values', '0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0.3333 0.3333 0.3333 0 0 0 0 0 1 0');
    filter.appendChild(feColorMatrix);
    var feComponentTransfer = createNS('feComponentTransfer');
    feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
    feComponentTransfer.setAttribute('result', id);
    this.matrixFilter = feComponentTransfer;
    var feFuncR = createNS('feFuncR');
    feFuncR.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncR);
    this.feFuncR = feFuncR;
    var feFuncG = createNS('feFuncG');
    feFuncG.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncG);
    this.feFuncG = feFuncG;
    var feFuncB = createNS('feFuncB');
    feFuncB.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFuncB);
    this.feFuncB = feFuncB;
    filter.appendChild(feComponentTransfer);
  }

  SVGTritoneFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var color1 = this.filterManager.effectElements[0].p.v;
      var color2 = this.filterManager.effectElements[1].p.v;
      var color3 = this.filterManager.effectElements[2].p.v;
      var tableR = color3[0] + ' ' + color2[0] + ' ' + color1[0];
      var tableG = color3[1] + ' ' + color2[1] + ' ' + color1[1];
      var tableB = color3[2] + ' ' + color2[2] + ' ' + color1[2];
      this.feFuncR.setAttribute('tableValues', tableR);
      this.feFuncG.setAttribute('tableValues', tableG);
      this.feFuncB.setAttribute('tableValues', tableB);
    }
  };

  function SVGProLevelsFilter(filter, filterManager, elem, id) {
    this.filterManager = filterManager;
    var effectElements = this.filterManager.effectElements;
    var feComponentTransfer = createNS('feComponentTransfer'); // Red

    if (effectElements[10].p.k || effectElements[10].p.v !== 0 || effectElements[11].p.k || effectElements[11].p.v !== 1 || effectElements[12].p.k || effectElements[12].p.v !== 1 || effectElements[13].p.k || effectElements[13].p.v !== 0 || effectElements[14].p.k || effectElements[14].p.v !== 1) {
      this.feFuncR = this.createFeFunc('feFuncR', feComponentTransfer);
    } // Green


    if (effectElements[17].p.k || effectElements[17].p.v !== 0 || effectElements[18].p.k || effectElements[18].p.v !== 1 || effectElements[19].p.k || effectElements[19].p.v !== 1 || effectElements[20].p.k || effectElements[20].p.v !== 0 || effectElements[21].p.k || effectElements[21].p.v !== 1) {
      this.feFuncG = this.createFeFunc('feFuncG', feComponentTransfer);
    } // Blue


    if (effectElements[24].p.k || effectElements[24].p.v !== 0 || effectElements[25].p.k || effectElements[25].p.v !== 1 || effectElements[26].p.k || effectElements[26].p.v !== 1 || effectElements[27].p.k || effectElements[27].p.v !== 0 || effectElements[28].p.k || effectElements[28].p.v !== 1) {
      this.feFuncB = this.createFeFunc('feFuncB', feComponentTransfer);
    } // Alpha


    if (effectElements[31].p.k || effectElements[31].p.v !== 0 || effectElements[32].p.k || effectElements[32].p.v !== 1 || effectElements[33].p.k || effectElements[33].p.v !== 1 || effectElements[34].p.k || effectElements[34].p.v !== 0 || effectElements[35].p.k || effectElements[35].p.v !== 1) {
      this.feFuncA = this.createFeFunc('feFuncA', feComponentTransfer);
    } // RGB


    if (this.feFuncR || this.feFuncG || this.feFuncB || this.feFuncA) {
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      filter.appendChild(feComponentTransfer);
    }

    if (effectElements[3].p.k || effectElements[3].p.v !== 0 || effectElements[4].p.k || effectElements[4].p.v !== 1 || effectElements[5].p.k || effectElements[5].p.v !== 1 || effectElements[6].p.k || effectElements[6].p.v !== 0 || effectElements[7].p.k || effectElements[7].p.v !== 1) {
      feComponentTransfer = createNS('feComponentTransfer');
      feComponentTransfer.setAttribute('color-interpolation-filters', 'sRGB');
      feComponentTransfer.setAttribute('result', id);
      filter.appendChild(feComponentTransfer);
      this.feFuncRComposed = this.createFeFunc('feFuncR', feComponentTransfer);
      this.feFuncGComposed = this.createFeFunc('feFuncG', feComponentTransfer);
      this.feFuncBComposed = this.createFeFunc('feFuncB', feComponentTransfer);
    }
  }

  SVGProLevelsFilter.prototype.createFeFunc = function (type, feComponentTransfer) {
    var feFunc = createNS(type);
    feFunc.setAttribute('type', 'table');
    feComponentTransfer.appendChild(feFunc);
    return feFunc;
  };

  SVGProLevelsFilter.prototype.getTableValue = function (inputBlack, inputWhite, gamma, outputBlack, outputWhite) {
    var cnt = 0;
    var segments = 256;
    var perc;
    var min = Math.min(inputBlack, inputWhite);
    var max = Math.max(inputBlack, inputWhite);
    var table = Array.call(null, {
      length: segments
    });
    var colorValue;
    var pos = 0;
    var outputDelta = outputWhite - outputBlack;
    var inputDelta = inputWhite - inputBlack;

    while (cnt <= 256) {
      perc = cnt / 256;

      if (perc <= min) {
        colorValue = inputDelta < 0 ? outputWhite : outputBlack;
      } else if (perc >= max) {
        colorValue = inputDelta < 0 ? outputBlack : outputWhite;
      } else {
        colorValue = outputBlack + outputDelta * Math.pow((perc - inputBlack) / inputDelta, 1 / gamma);
      }

      table[pos] = colorValue;
      pos += 1;
      cnt += 256 / (segments - 1);
    }

    return table.join(' ');
  };

  SVGProLevelsFilter.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      var val;
      var effectElements = this.filterManager.effectElements;

      if (this.feFuncRComposed && (forceRender || effectElements[3].p._mdf || effectElements[4].p._mdf || effectElements[5].p._mdf || effectElements[6].p._mdf || effectElements[7].p._mdf)) {
        val = this.getTableValue(effectElements[3].p.v, effectElements[4].p.v, effectElements[5].p.v, effectElements[6].p.v, effectElements[7].p.v);
        this.feFuncRComposed.setAttribute('tableValues', val);
        this.feFuncGComposed.setAttribute('tableValues', val);
        this.feFuncBComposed.setAttribute('tableValues', val);
      }

      if (this.feFuncR && (forceRender || effectElements[10].p._mdf || effectElements[11].p._mdf || effectElements[12].p._mdf || effectElements[13].p._mdf || effectElements[14].p._mdf)) {
        val = this.getTableValue(effectElements[10].p.v, effectElements[11].p.v, effectElements[12].p.v, effectElements[13].p.v, effectElements[14].p.v);
        this.feFuncR.setAttribute('tableValues', val);
      }

      if (this.feFuncG && (forceRender || effectElements[17].p._mdf || effectElements[18].p._mdf || effectElements[19].p._mdf || effectElements[20].p._mdf || effectElements[21].p._mdf)) {
        val = this.getTableValue(effectElements[17].p.v, effectElements[18].p.v, effectElements[19].p.v, effectElements[20].p.v, effectElements[21].p.v);
        this.feFuncG.setAttribute('tableValues', val);
      }

      if (this.feFuncB && (forceRender || effectElements[24].p._mdf || effectElements[25].p._mdf || effectElements[26].p._mdf || effectElements[27].p._mdf || effectElements[28].p._mdf)) {
        val = this.getTableValue(effectElements[24].p.v, effectElements[25].p.v, effectElements[26].p.v, effectElements[27].p.v, effectElements[28].p.v);
        this.feFuncB.setAttribute('tableValues', val);
      }

      if (this.feFuncA && (forceRender || effectElements[31].p._mdf || effectElements[32].p._mdf || effectElements[33].p._mdf || effectElements[34].p._mdf || effectElements[35].p._mdf)) {
        val = this.getTableValue(effectElements[31].p.v, effectElements[32].p.v, effectElements[33].p.v, effectElements[34].p.v, effectElements[35].p.v);
        this.feFuncA.setAttribute('tableValues', val);
      }
    }
  };

  function SVGDropShadowEffect(filter, filterManager, elem, id, source) {
    var globalFilterSize = filterManager.container.globalData.renderConfig.filterSize;
    var filterSize = filterManager.data.fs || globalFilterSize;
    filter.setAttribute('x', filterSize.x || globalFilterSize.x);
    filter.setAttribute('y', filterSize.y || globalFilterSize.y);
    filter.setAttribute('width', filterSize.width || globalFilterSize.width);
    filter.setAttribute('height', filterSize.height || globalFilterSize.height);
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('in', 'SourceAlpha');
    feGaussianBlur.setAttribute('result', id + '_drop_shadow_1');
    feGaussianBlur.setAttribute('stdDeviation', '0');
    this.feGaussianBlur = feGaussianBlur;
    filter.appendChild(feGaussianBlur);
    var feOffset = createNS('feOffset');
    feOffset.setAttribute('dx', '25');
    feOffset.setAttribute('dy', '0');
    feOffset.setAttribute('in', id + '_drop_shadow_1');
    feOffset.setAttribute('result', id + '_drop_shadow_2');
    this.feOffset = feOffset;
    filter.appendChild(feOffset);
    var feFlood = createNS('feFlood');
    feFlood.setAttribute('flood-color', '#00ff00');
    feFlood.setAttribute('flood-opacity', '1');
    feFlood.setAttribute('result', id + '_drop_shadow_3');
    this.feFlood = feFlood;
    filter.appendChild(feFlood);
    var feComposite = createNS('feComposite');
    feComposite.setAttribute('in', id + '_drop_shadow_3');
    feComposite.setAttribute('in2', id + '_drop_shadow_2');
    feComposite.setAttribute('operator', 'in');
    feComposite.setAttribute('result', id + '_drop_shadow_4');
    filter.appendChild(feComposite);
    var feMerge = this.createMergeNode(id, [id + '_drop_shadow_4', source]);
    filter.appendChild(feMerge); //
  }

  extendPrototype([SVGComposableEffect], SVGDropShadowEffect);

  SVGDropShadowEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      if (forceRender || this.filterManager.effectElements[4].p._mdf) {
        this.feGaussianBlur.setAttribute('stdDeviation', this.filterManager.effectElements[4].p.v / 4);
      }

      if (forceRender || this.filterManager.effectElements[0].p._mdf) {
        var col = this.filterManager.effectElements[0].p.v;
        this.feFlood.setAttribute('flood-color', rgbToHex(Math.round(col[0] * 255), Math.round(col[1] * 255), Math.round(col[2] * 255)));
      }

      if (forceRender || this.filterManager.effectElements[1].p._mdf) {
        this.feFlood.setAttribute('flood-opacity', this.filterManager.effectElements[1].p.v / 255);
      }

      if (forceRender || this.filterManager.effectElements[2].p._mdf || this.filterManager.effectElements[3].p._mdf) {
        var distance = this.filterManager.effectElements[3].p.v;
        var angle = (this.filterManager.effectElements[2].p.v - 90) * degToRads;
        var x = distance * Math.cos(angle);
        var y = distance * Math.sin(angle);
        this.feOffset.setAttribute('dx', x);
        this.feOffset.setAttribute('dy', y);
      }
    }
  };

  var _svgMatteSymbols = [];

  function SVGMatte3Effect(filterElem, filterManager, elem) {
    this.initialized = false;
    this.filterManager = filterManager;
    this.filterElem = filterElem;
    this.elem = elem;
    elem.matteElement = createNS('g');
    elem.matteElement.appendChild(elem.layerElement);
    elem.matteElement.appendChild(elem.transformedElement);
    elem.baseElement = elem.matteElement;
  }

  SVGMatte3Effect.prototype.findSymbol = function (mask) {
    var i = 0;
    var len = _svgMatteSymbols.length;

    while (i < len) {
      if (_svgMatteSymbols[i] === mask) {
        return _svgMatteSymbols[i];
      }

      i += 1;
    }

    return null;
  };

  SVGMatte3Effect.prototype.replaceInParent = function (mask, symbolId) {
    var parentNode = mask.layerElement.parentNode;

    if (!parentNode) {
      return;
    }

    var children = parentNode.children;
    var i = 0;
    var len = children.length;

    while (i < len) {
      if (children[i] === mask.layerElement) {
        break;
      }

      i += 1;
    }

    var nextChild;

    if (i <= len - 2) {
      nextChild = children[i + 1];
    }

    var useElem = createNS('use');
    useElem.setAttribute('href', '#' + symbolId);

    if (nextChild) {
      parentNode.insertBefore(useElem, nextChild);
    } else {
      parentNode.appendChild(useElem);
    }
  };

  SVGMatte3Effect.prototype.setElementAsMask = function (elem, mask) {
    if (!this.findSymbol(mask)) {
      var symbolId = createElementID();
      var masker = createNS('mask');
      masker.setAttribute('id', mask.layerId);
      masker.setAttribute('mask-type', 'alpha');

      _svgMatteSymbols.push(mask);

      var defs = elem.globalData.defs;
      defs.appendChild(masker);
      var symbol = createNS('symbol');
      symbol.setAttribute('id', symbolId);
      this.replaceInParent(mask, symbolId);
      symbol.appendChild(mask.layerElement);
      defs.appendChild(symbol);
      var useElem = createNS('use');
      useElem.setAttribute('href', '#' + symbolId);
      masker.appendChild(useElem);
      mask.data.hd = false;
      mask.show();
    }

    elem.setMatte(mask.layerId);
  };

  SVGMatte3Effect.prototype.initialize = function () {
    var ind = this.filterManager.effectElements[0].p.v;
    var elements = this.elem.comp.elements;
    var i = 0;
    var len = elements.length;

    while (i < len) {
      if (elements[i] && elements[i].data.ind === ind) {
        this.setElementAsMask(this.elem, elements[i]);
      }

      i += 1;
    }

    this.initialized = true;
  };

  SVGMatte3Effect.prototype.renderFrame = function () {
    if (!this.initialized) {
      this.initialize();
    }
  };

  function SVGGaussianBlurEffect(filter, filterManager, elem, id) {
    // Outset the filter region by 100% on all sides to accommodate blur expansion.
    filter.setAttribute('x', '-100%');
    filter.setAttribute('y', '-100%');
    filter.setAttribute('width', '300%');
    filter.setAttribute('height', '300%');
    this.filterManager = filterManager;
    var feGaussianBlur = createNS('feGaussianBlur');
    feGaussianBlur.setAttribute('result', id);
    filter.appendChild(feGaussianBlur);
    this.feGaussianBlur = feGaussianBlur;
  }

  SVGGaussianBlurEffect.prototype.renderFrame = function (forceRender) {
    if (forceRender || this.filterManager._mdf) {
      // Empirical value, matching AE's blur appearance.
      var kBlurrinessToSigma = 0.3;
      var sigma = this.filterManager.effectElements[0].p.v * kBlurrinessToSigma; // Dimensions mapping:
      //
      //   1 -> horizontal & vertical
      //   2 -> horizontal only
      //   3 -> vertical only
      //

      var dimensions = this.filterManager.effectElements[1].p.v;
      var sigmaX = dimensions == 3 ? 0 : sigma; // eslint-disable-line eqeqeq

      var sigmaY = dimensions == 2 ? 0 : sigma; // eslint-disable-line eqeqeq

      this.feGaussianBlur.setAttribute('stdDeviation', sigmaX + ' ' + sigmaY); // Repeat edges mapping:
      //
      //   0 -> off -> duplicate
      //   1 -> on  -> wrap

      var edgeMode = this.filterManager.effectElements[2].p.v == 1 ? 'wrap' : 'duplicate'; // eslint-disable-line eqeqeq

      this.feGaussianBlur.setAttribute('edgeMode', edgeMode);
    }
  };

  function TransformEffect() {}

  TransformEffect.prototype.init = function (effectsManager) {
    this.effectsManager = effectsManager;
    this.type = effectTypes.TRANSFORM_EFFECT;
    this.matrix = new Matrix();
    this.opacity = -1;
    this._mdf = false;
    this._opMdf = false;
  };

  TransformEffect.prototype.renderFrame = function (forceFrame) {
    this._opMdf = false;
    this._mdf = false;

    if (forceFrame || this.effectsManager._mdf) {
      var effectElements = this.effectsManager.effectElements;
      var anchor = effectElements[0].p.v;
      var position = effectElements[1].p.v;
      var isUniformScale = effectElements[2].p.v === 1;
      var scaleHeight = effectElements[3].p.v;
      var scaleWidth = isUniformScale ? scaleHeight : effectElements[4].p.v;
      var skew = effectElements[5].p.v;
      var skewAxis = effectElements[6].p.v;
      var rotation = effectElements[7].p.v;
      this.matrix.reset();
      this.matrix.translate(-anchor[0], -anchor[1], anchor[2]);
      this.matrix.scale(scaleWidth * 0.01, scaleHeight * 0.01, 1);
      this.matrix.rotate(-rotation * degToRads);
      this.matrix.skewFromAxis(-skew * degToRads, (skewAxis + 90) * degToRads);
      this.matrix.translate(position[0], position[1], 0);
      this._mdf = true;

      if (this.opacity !== effectElements[8].p.v) {
        this.opacity = effectElements[8].p.v;
        this._opMdf = true;
      }
    }
  };

  function SVGTransformEffect(_, filterManager) {
    this.init(filterManager);
  }

  extendPrototype([TransformEffect], SVGTransformEffect);

  function CVTransformEffect(effectsManager) {
    this.init(effectsManager);
  }

  extendPrototype([TransformEffect], CVTransformEffect);

  registerRenderer('canvas', CanvasRenderer);
  registerRenderer('html', HybridRenderer);
  registerRenderer('svg', SVGRenderer); // Registering shape modifiers

  ShapeModifiers.registerModifier('tm', TrimModifier);
  ShapeModifiers.registerModifier('pb', PuckerAndBloatModifier);
  ShapeModifiers.registerModifier('rp', RepeaterModifier);
  ShapeModifiers.registerModifier('rd', RoundCornersModifier);
  ShapeModifiers.registerModifier('zz', ZigZagModifier);
  ShapeModifiers.registerModifier('op', OffsetPathModifier); // Registering expression plugin

  setExpressionsPlugin(Expressions);
  setExpressionInterfaces(getInterface);
  initialize$1();
  initialize(); // Registering svg effects

  registerEffect$1(20, SVGTintFilter, true);
  registerEffect$1(21, SVGFillFilter, true);
  registerEffect$1(22, SVGStrokeEffect, false);
  registerEffect$1(23, SVGTritoneFilter, true);
  registerEffect$1(24, SVGProLevelsFilter, true);
  registerEffect$1(25, SVGDropShadowEffect, true);
  registerEffect$1(28, SVGMatte3Effect, false);
  registerEffect$1(29, SVGGaussianBlurEffect, true);
  registerEffect$1(35, SVGTransformEffect, false);
  registerEffect(35, CVTransformEffect);

  return lottie;

}));


/***/ }),

/***/ 2786:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Afrikaans [af]
//! author : Werner Mollentze : https://github.com/wernerm

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var af = moment.defineLocale('af', {
        months: 'Januarie_Februarie_Maart_April_Mei_Junie_Julie_Augustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mrt_Apr_Mei_Jun_Jul_Aug_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Sondag_Maandag_Dinsdag_Woensdag_Donderdag_Vrydag_Saterdag'.split(
            '_'
        ),
        weekdaysShort: 'Son_Maa_Din_Woe_Don_Vry_Sat'.split('_'),
        weekdaysMin: 'So_Ma_Di_Wo_Do_Vr_Sa'.split('_'),
        meridiemParse: /vm|nm/i,
        isPM: function (input) {
            return /^nm$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'vm' : 'VM';
            } else {
                return isLower ? 'nm' : 'NM';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Vandag om] LT',
            nextDay: '[Môre om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[Gister om] LT',
            lastWeek: '[Laas] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oor %s',
            past: '%s gelede',
            s: "'n paar sekondes",
            ss: '%d sekondes',
            m: "'n minuut",
            mm: '%d minute',
            h: "'n uur",
            hh: '%d ure',
            d: "'n dag",
            dd: '%d dae',
            M: "'n maand",
            MM: '%d maande',
            y: "'n jaar",
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            ); // Thanks to Joris Röling : https://github.com/jjupiter
        },
        week: {
            dow: 1, // Maandag is die eerste dag van die week.
            doy: 4, // Die week wat die 4de Januarie bevat is die eerste week van die jaar.
        },
    });

    return af;

})));


/***/ }),

/***/ 4130:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Algeria) [ar-dz]
//! author : Amine Roukh: https://github.com/Amine27
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi
//! author : Noureddine LOUAHEDJ : https://github.com/noureddinem

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'جانفي',
            'فيفري',
            'مارس',
            'أفريل',
            'ماي',
            'جوان',
            'جويلية',
            'أوت',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arDz = moment.defineLocale('ar-dz', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arDz;

})));


/***/ }),

/***/ 6737:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Kuwait) [ar-kw]
//! author : Nusret Parlak: https://github.com/nusretparlak

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arKw = moment.defineLocale('ar-kw', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإتنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اتنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arKw;

})));


/***/ }),

/***/ 6440:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Libya) [ar-ly]
//! author : Ali Hmer: https://github.com/kikoanis

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '1',
            2: '2',
            3: '3',
            4: '4',
            5: '5',
            6: '6',
            7: '7',
            8: '8',
            9: '9',
            0: '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var arLy = moment.defineLocale('ar-ly', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return arLy;

})));


/***/ }),

/***/ 7702:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Morocco) [ar-ma]
//! author : ElFadili Yassine : https://github.com/ElFadiliY
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arMa = moment.defineLocale('ar-ma', {
        months: 'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_ماي_يونيو_يوليوز_غشت_شتنبر_أكتوبر_نونبر_دجنبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'احد_اثنين_ثلاثاء_اربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arMa;

})));


/***/ }),

/***/ 6040:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic (Saudi Arabia) [ar-sa]
//! author : Suhail Alkowaileet : https://github.com/xsoh

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        };

    var arSa = moment.defineLocale('ar-sa', {
        months: 'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'يناير_فبراير_مارس_أبريل_مايو_يونيو_يوليو_أغسطس_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return arSa;

})));


/***/ }),

/***/ 7100:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale  :  Arabic (Tunisia) [ar-tn]
//! author : Nader Toukabri : https://github.com/naderio

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var arTn = moment.defineLocale('ar-tn', {
        months: 'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
            '_'
        ),
        monthsShort:
            'جانفي_فيفري_مارس_أفريل_ماي_جوان_جويلية_أوت_سبتمبر_أكتوبر_نوفمبر_ديسمبر'.split(
                '_'
            ),
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[اليوم على الساعة] LT',
            nextDay: '[غدا على الساعة] LT',
            nextWeek: 'dddd [على الساعة] LT',
            lastDay: '[أمس على الساعة] LT',
            lastWeek: 'dddd [على الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'في %s',
            past: 'منذ %s',
            s: 'ثوان',
            ss: '%d ثانية',
            m: 'دقيقة',
            mm: '%d دقائق',
            h: 'ساعة',
            hh: '%d ساعات',
            d: 'يوم',
            dd: '%d أيام',
            M: 'شهر',
            MM: '%d أشهر',
            y: 'سنة',
            yy: '%d سنوات',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return arTn;

})));


/***/ }),

/***/ 867:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Arabic [ar]
//! author : Abdel Said: https://github.com/abdelsaid
//! author : Ahmed Elkhatib
//! author : forabi https://github.com/forabi

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        pluralForm = function (n) {
            return n === 0
                ? 0
                : n === 1
                ? 1
                : n === 2
                ? 2
                : n % 100 >= 3 && n % 100 <= 10
                ? 3
                : n % 100 >= 11
                ? 4
                : 5;
        },
        plurals = {
            s: [
                'أقل من ثانية',
                'ثانية واحدة',
                ['ثانيتان', 'ثانيتين'],
                '%d ثوان',
                '%d ثانية',
                '%d ثانية',
            ],
            m: [
                'أقل من دقيقة',
                'دقيقة واحدة',
                ['دقيقتان', 'دقيقتين'],
                '%d دقائق',
                '%d دقيقة',
                '%d دقيقة',
            ],
            h: [
                'أقل من ساعة',
                'ساعة واحدة',
                ['ساعتان', 'ساعتين'],
                '%d ساعات',
                '%d ساعة',
                '%d ساعة',
            ],
            d: [
                'أقل من يوم',
                'يوم واحد',
                ['يومان', 'يومين'],
                '%d أيام',
                '%d يومًا',
                '%d يوم',
            ],
            M: [
                'أقل من شهر',
                'شهر واحد',
                ['شهران', 'شهرين'],
                '%d أشهر',
                '%d شهرا',
                '%d شهر',
            ],
            y: [
                'أقل من عام',
                'عام واحد',
                ['عامان', 'عامين'],
                '%d أعوام',
                '%d عامًا',
                '%d عام',
            ],
        },
        pluralize = function (u) {
            return function (number, withoutSuffix, string, isFuture) {
                var f = pluralForm(number),
                    str = plurals[u][pluralForm(number)];
                if (f === 2) {
                    str = str[withoutSuffix ? 0 : 1];
                }
                return str.replace(/%d/i, number);
            };
        },
        months = [
            'يناير',
            'فبراير',
            'مارس',
            'أبريل',
            'مايو',
            'يونيو',
            'يوليو',
            'أغسطس',
            'سبتمبر',
            'أكتوبر',
            'نوفمبر',
            'ديسمبر',
        ];

    var ar = moment.defineLocale('ar', {
        months: months,
        monthsShort: months,
        weekdays: 'الأحد_الإثنين_الثلاثاء_الأربعاء_الخميس_الجمعة_السبت'.split('_'),
        weekdaysShort: 'أحد_إثنين_ثلاثاء_أربعاء_خميس_جمعة_سبت'.split('_'),
        weekdaysMin: 'ح_ن_ث_ر_خ_ج_س'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/\u200FM/\u200FYYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ص|م/,
        isPM: function (input) {
            return 'م' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ص';
            } else {
                return 'م';
            }
        },
        calendar: {
            sameDay: '[اليوم عند الساعة] LT',
            nextDay: '[غدًا عند الساعة] LT',
            nextWeek: 'dddd [عند الساعة] LT',
            lastDay: '[أمس عند الساعة] LT',
            lastWeek: 'dddd [عند الساعة] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'بعد %s',
            past: 'منذ %s',
            s: pluralize('s'),
            ss: pluralize('s'),
            m: pluralize('m'),
            mm: pluralize('m'),
            h: pluralize('h'),
            hh: pluralize('h'),
            d: pluralize('d'),
            dd: pluralize('d'),
            M: pluralize('M'),
            MM: pluralize('M'),
            y: pluralize('y'),
            yy: pluralize('y'),
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ar;

})));


/***/ }),

/***/ 1083:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Azerbaijani [az]
//! author : topchiyev : https://github.com/topchiyev

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: '-inci',
        5: '-inci',
        8: '-inci',
        70: '-inci',
        80: '-inci',
        2: '-nci',
        7: '-nci',
        20: '-nci',
        50: '-nci',
        3: '-üncü',
        4: '-üncü',
        100: '-üncü',
        6: '-ncı',
        9: '-uncu',
        10: '-uncu',
        30: '-uncu',
        60: '-ıncı',
        90: '-ıncı',
    };

    var az = moment.defineLocale('az', {
        months: 'yanvar_fevral_mart_aprel_may_iyun_iyul_avqust_sentyabr_oktyabr_noyabr_dekabr'.split(
            '_'
        ),
        monthsShort: 'yan_fev_mar_apr_may_iyn_iyl_avq_sen_okt_noy_dek'.split('_'),
        weekdays:
            'Bazar_Bazar ertəsi_Çərşənbə axşamı_Çərşənbə_Cümə axşamı_Cümə_Şənbə'.split(
                '_'
            ),
        weekdaysShort: 'Baz_BzE_ÇAx_Çər_CAx_Cüm_Şən'.split('_'),
        weekdaysMin: 'Bz_BE_ÇA_Çə_CA_Cü_Şə'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[sabah saat] LT',
            nextWeek: '[gələn həftə] dddd [saat] LT',
            lastDay: '[dünən] LT',
            lastWeek: '[keçən həftə] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s əvvəl',
            s: 'bir neçə saniyə',
            ss: '%d saniyə',
            m: 'bir dəqiqə',
            mm: '%d dəqiqə',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir il',
            yy: '%d il',
        },
        meridiemParse: /gecə|səhər|gündüz|axşam/,
        isPM: function (input) {
            return /^(gündüz|axşam)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'gecə';
            } else if (hour < 12) {
                return 'səhər';
            } else if (hour < 17) {
                return 'gündüz';
            } else {
                return 'axşam';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ıncı|inci|nci|üncü|ncı|uncu)/,
        ordinal: function (number) {
            if (number === 0) {
                // special case for zero
                return number + '-ıncı';
            }
            var a = number % 10,
                b = (number % 100) - a,
                c = number >= 100 ? 100 : null;
            return number + (suffixes[a] || suffixes[b] || suffixes[c]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return az;

})));


/***/ }),

/***/ 9808:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Belarusian [be]
//! author : Dmitry Demidov : https://github.com/demidov91
//! author: Praleska: http://praleska.pro/
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'хвіліна_хвіліны_хвілін' : 'хвіліну_хвіліны_хвілін',
            hh: withoutSuffix ? 'гадзіна_гадзіны_гадзін' : 'гадзіну_гадзіны_гадзін',
            dd: 'дзень_дні_дзён',
            MM: 'месяц_месяцы_месяцаў',
            yy: 'год_гады_гадоў',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвіліна' : 'хвіліну';
        } else if (key === 'h') {
            return withoutSuffix ? 'гадзіна' : 'гадзіну';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }

    var be = moment.defineLocale('be', {
        months: {
            format: 'студзеня_лютага_сакавіка_красавіка_траўня_чэрвеня_ліпеня_жніўня_верасня_кастрычніка_лістапада_снежня'.split(
                '_'
            ),
            standalone:
                'студзень_люты_сакавік_красавік_травень_чэрвень_ліпень_жнівень_верасень_кастрычнік_лістапад_снежань'.split(
                    '_'
                ),
        },
        monthsShort:
            'студ_лют_сак_крас_трав_чэрв_ліп_жнів_вер_каст_ліст_снеж'.split('_'),
        weekdays: {
            format: 'нядзелю_панядзелак_аўторак_сераду_чацвер_пятніцу_суботу'.split(
                '_'
            ),
            standalone:
                'нядзеля_панядзелак_аўторак_серада_чацвер_пятніца_субота'.split(
                    '_'
                ),
            isFormat: /\[ ?[Ууў] ?(?:мінулую|наступную)? ?\] ?dddd/,
        },
        weekdaysShort: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_ат_ср_чц_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., HH:mm',
            LLLL: 'dddd, D MMMM YYYY г., HH:mm',
        },
        calendar: {
            sameDay: '[Сёння ў] LT',
            nextDay: '[Заўтра ў] LT',
            lastDay: '[Учора ў] LT',
            nextWeek: function () {
                return '[У] dddd [ў] LT';
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return '[У мінулую] dddd [ў] LT';
                    case 1:
                    case 2:
                    case 4:
                        return '[У мінулы] dddd [ў] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'праз %s',
            past: '%s таму',
            s: 'некалькі секунд',
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithPlural,
            hh: relativeTimeWithPlural,
            d: 'дзень',
            dd: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночы|раніцы|дня|вечара/,
        isPM: function (input) {
            return /^(дня|вечара)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночы';
            } else if (hour < 12) {
                return 'раніцы';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечара';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(і|ы|га)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return (number % 10 === 2 || number % 10 === 3) &&
                        number % 100 !== 12 &&
                        number % 100 !== 13
                        ? number + '-і'
                        : number + '-ы';
                case 'D':
                    return number + '-га';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return be;

})));


/***/ }),

/***/ 8338:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bulgarian [bg]
//! author : Krasen Borisov : https://github.com/kraz

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bg = moment.defineLocale('bg', {
        months: 'януари_февруари_март_април_май_юни_юли_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'яну_фев_мар_апр_май_юни_юли_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'неделя_понеделник_вторник_сряда_четвъртък_петък_събота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сря_чет_пет_съб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Днес в] LT',
            nextDay: '[Утре в] LT',
            nextWeek: 'dddd [в] LT',
            lastDay: '[Вчера в] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Миналата] dddd [в] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Миналия] dddd [в] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'след %s',
            past: 'преди %s',
            s: 'няколко секунди',
            ss: '%d секунди',
            m: 'минута',
            mm: '%d минути',
            h: 'час',
            hh: '%d часа',
            d: 'ден',
            dd: '%d дена',
            w: 'седмица',
            ww: '%d седмици',
            M: 'месец',
            MM: '%d месеца',
            y: 'година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bg;

})));


/***/ }),

/***/ 7438:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bambara [bm]
//! author : Estelle Comment : https://github.com/estellecomment

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var bm = moment.defineLocale('bm', {
        months: 'Zanwuyekalo_Fewuruyekalo_Marisikalo_Awirilikalo_Mɛkalo_Zuwɛnkalo_Zuluyekalo_Utikalo_Sɛtanburukalo_ɔkutɔburukalo_Nowanburukalo_Desanburukalo'.split(
            '_'
        ),
        monthsShort: 'Zan_Few_Mar_Awi_Mɛ_Zuw_Zul_Uti_Sɛt_ɔku_Now_Des'.split('_'),
        weekdays: 'Kari_Ntɛnɛn_Tarata_Araba_Alamisa_Juma_Sibiri'.split('_'),
        weekdaysShort: 'Kar_Ntɛ_Tar_Ara_Ala_Jum_Sib'.split('_'),
        weekdaysMin: 'Ka_Nt_Ta_Ar_Al_Ju_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'MMMM [tile] D [san] YYYY',
            LLL: 'MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
            LLLL: 'dddd MMMM [tile] D [san] YYYY [lɛrɛ] HH:mm',
        },
        calendar: {
            sameDay: '[Bi lɛrɛ] LT',
            nextDay: '[Sini lɛrɛ] LT',
            nextWeek: 'dddd [don lɛrɛ] LT',
            lastDay: '[Kunu lɛrɛ] LT',
            lastWeek: 'dddd [tɛmɛnen lɛrɛ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s kɔnɔ',
            past: 'a bɛ %s bɔ',
            s: 'sanga dama dama',
            ss: 'sekondi %d',
            m: 'miniti kelen',
            mm: 'miniti %d',
            h: 'lɛrɛ kelen',
            hh: 'lɛrɛ %d',
            d: 'tile kelen',
            dd: 'tile %d',
            M: 'kalo kelen',
            MM: 'kalo %d',
            y: 'san kelen',
            yy: 'san %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return bm;

})));


/***/ }),

/***/ 6225:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali (Bangladesh) [bn-bd]
//! author : Asraf Hossain Patoary : https://github.com/ashwoolford

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bnBd = moment.defineLocale('bn-bd', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },

        meridiemParse: /রাত|ভোর|সকাল|দুপুর|বিকাল|সন্ধ্যা|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'রাত') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ভোর') {
                return hour;
            } else if (meridiem === 'সকাল') {
                return hour;
            } else if (meridiem === 'দুপুর') {
                return hour >= 3 ? hour : hour + 12;
            } else if (meridiem === 'বিকাল') {
                return hour + 12;
            } else if (meridiem === 'সন্ধ্যা') {
                return hour + 12;
            }
        },

        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 6) {
                return 'ভোর';
            } else if (hour < 12) {
                return 'সকাল';
            } else if (hour < 15) {
                return 'দুপুর';
            } else if (hour < 18) {
                return 'বিকাল';
            } else if (hour < 20) {
                return 'সন্ধ্যা';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bnBd;

})));


/***/ }),

/***/ 8905:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bengali [bn]
//! author : Kaushik Gandhi : https://github.com/kaushikgandhi

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '১',
            2: '২',
            3: '৩',
            4: '৪',
            5: '৫',
            6: '৬',
            7: '৭',
            8: '৮',
            9: '৯',
            0: '০',
        },
        numberMap = {
            '১': '1',
            '২': '2',
            '৩': '3',
            '৪': '4',
            '৫': '5',
            '৬': '6',
            '৭': '7',
            '৮': '8',
            '৯': '9',
            '০': '0',
        };

    var bn = moment.defineLocale('bn', {
        months: 'জানুয়ারি_ফেব্রুয়ারি_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্টেম্বর_অক্টোবর_নভেম্বর_ডিসেম্বর'.split(
            '_'
        ),
        monthsShort:
            'জানু_ফেব্রু_মার্চ_এপ্রিল_মে_জুন_জুলাই_আগস্ট_সেপ্ট_অক্টো_নভে_ডিসে'.split(
                '_'
            ),
        weekdays: 'রবিবার_সোমবার_মঙ্গলবার_বুধবার_বৃহস্পতিবার_শুক্রবার_শনিবার'.split(
            '_'
        ),
        weekdaysShort: 'রবি_সোম_মঙ্গল_বুধ_বৃহস্পতি_শুক্র_শনি'.split('_'),
        weekdaysMin: 'রবি_সোম_মঙ্গল_বুধ_বৃহ_শুক্র_শনি'.split('_'),
        longDateFormat: {
            LT: 'A h:mm সময়',
            LTS: 'A h:mm:ss সময়',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm সময়',
            LLLL: 'dddd, D MMMM YYYY, A h:mm সময়',
        },
        calendar: {
            sameDay: '[আজ] LT',
            nextDay: '[আগামীকাল] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[গতকাল] LT',
            lastWeek: '[গত] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s পরে',
            past: '%s আগে',
            s: 'কয়েক সেকেন্ড',
            ss: '%d সেকেন্ড',
            m: 'এক মিনিট',
            mm: '%d মিনিট',
            h: 'এক ঘন্টা',
            hh: '%d ঘন্টা',
            d: 'এক দিন',
            dd: '%d দিন',
            M: 'এক মাস',
            MM: '%d মাস',
            y: 'এক বছর',
            yy: '%d বছর',
        },
        preparse: function (string) {
            return string.replace(/[১২৩৪৫৬৭৮৯০]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /রাত|সকাল|দুপুর|বিকাল|রাত/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'রাত' && hour >= 4) ||
                (meridiem === 'দুপুর' && hour < 5) ||
                meridiem === 'বিকাল'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'রাত';
            } else if (hour < 10) {
                return 'সকাল';
            } else if (hour < 17) {
                return 'দুপুর';
            } else if (hour < 20) {
                return 'বিকাল';
            } else {
                return 'রাত';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bn;

})));


/***/ }),

/***/ 1560:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tibetan [bo]
//! author : Thupten N. Chakrishar : https://github.com/vajradog

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '༡',
            2: '༢',
            3: '༣',
            4: '༤',
            5: '༥',
            6: '༦',
            7: '༧',
            8: '༨',
            9: '༩',
            0: '༠',
        },
        numberMap = {
            '༡': '1',
            '༢': '2',
            '༣': '3',
            '༤': '4',
            '༥': '5',
            '༦': '6',
            '༧': '7',
            '༨': '8',
            '༩': '9',
            '༠': '0',
        };

    var bo = moment.defineLocale('bo', {
        months: 'ཟླ་བ་དང་པོ_ཟླ་བ་གཉིས་པ_ཟླ་བ་གསུམ་པ_ཟླ་བ་བཞི་པ_ཟླ་བ་ལྔ་པ_ཟླ་བ་དྲུག་པ_ཟླ་བ་བདུན་པ_ཟླ་བ་བརྒྱད་པ_ཟླ་བ་དགུ་པ_ཟླ་བ་བཅུ་པ_ཟླ་བ་བཅུ་གཅིག་པ_ཟླ་བ་བཅུ་གཉིས་པ'.split(
            '_'
        ),
        monthsShort:
            'ཟླ་1_ཟླ་2_ཟླ་3_ཟླ་4_ཟླ་5_ཟླ་6_ཟླ་7_ཟླ་8_ཟླ་9_ཟླ་10_ཟླ་11_ཟླ་12'.split(
                '_'
            ),
        monthsShortRegex: /^(ཟླ་\d{1,2})/,
        monthsParseExact: true,
        weekdays:
            'གཟའ་ཉི་མ་_གཟའ་ཟླ་བ་_གཟའ་མིག་དམར་_གཟའ་ལྷག་པ་_གཟའ་ཕུར་བུ_གཟའ་པ་སངས་_གཟའ་སྤེན་པ་'.split(
                '_'
            ),
        weekdaysShort: 'ཉི་མ་_ཟླ་བ་_མིག་དམར་_ལྷག་པ་_ཕུར་བུ_པ་སངས་_སྤེན་པ་'.split(
            '_'
        ),
        weekdaysMin: 'ཉི_ཟླ_མིག_ལྷག_ཕུར_སངས_སྤེན'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[དི་རིང] LT',
            nextDay: '[སང་ཉིན] LT',
            nextWeek: '[བདུན་ཕྲག་རྗེས་མ], LT',
            lastDay: '[ཁ་སང] LT',
            lastWeek: '[བདུན་ཕྲག་མཐའ་མ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ལ་',
            past: '%s སྔན་ལ',
            s: 'ལམ་སང',
            ss: '%d སྐར་ཆ།',
            m: 'སྐར་མ་གཅིག',
            mm: '%d སྐར་མ',
            h: 'ཆུ་ཚོད་གཅིག',
            hh: '%d ཆུ་ཚོད',
            d: 'ཉིན་གཅིག',
            dd: '%d ཉིན་',
            M: 'ཟླ་བ་གཅིག',
            MM: '%d ཟླ་བ',
            y: 'ལོ་གཅིག',
            yy: '%d ལོ',
        },
        preparse: function (string) {
            return string.replace(/[༡༢༣༤༥༦༧༨༩༠]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /མཚན་མོ|ཞོགས་ཀས|ཉིན་གུང|དགོང་དག|མཚན་མོ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'མཚན་མོ' && hour >= 4) ||
                (meridiem === 'ཉིན་གུང' && hour < 5) ||
                meridiem === 'དགོང་དག'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'མཚན་མོ';
            } else if (hour < 10) {
                return 'ཞོགས་ཀས';
            } else if (hour < 17) {
                return 'ཉིན་གུང';
            } else if (hour < 20) {
                return 'དགོང་དག';
            } else {
                return 'མཚན་མོ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return bo;

})));


/***/ }),

/***/ 1278:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Breton [br]
//! author : Jean-Baptiste Le Duigou : https://github.com/jbleduigou

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithMutation(number, withoutSuffix, key) {
        var format = {
            mm: 'munutenn',
            MM: 'miz',
            dd: 'devezh',
        };
        return number + ' ' + mutation(format[key], number);
    }
    function specialMutationForYears(number) {
        switch (lastNumber(number)) {
            case 1:
            case 3:
            case 4:
            case 5:
            case 9:
                return number + ' bloaz';
            default:
                return number + ' vloaz';
        }
    }
    function lastNumber(number) {
        if (number > 9) {
            return lastNumber(number % 10);
        }
        return number;
    }
    function mutation(text, number) {
        if (number === 2) {
            return softMutation(text);
        }
        return text;
    }
    function softMutation(text) {
        var mutationTable = {
            m: 'v',
            b: 'v',
            d: 'z',
        };
        if (mutationTable[text.charAt(0)] === undefined) {
            return text;
        }
        return mutationTable[text.charAt(0)] + text.substring(1);
    }

    var monthsParse = [
            /^gen/i,
            /^c[ʼ\']hwe/i,
            /^meu/i,
            /^ebr/i,
            /^mae/i,
            /^(mez|eve)/i,
            /^gou/i,
            /^eos/i,
            /^gwe/i,
            /^her/i,
            /^du/i,
            /^ker/i,
        ],
        monthsRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu|gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        monthsStrictRegex =
            /^(genver|c[ʼ\']hwevrer|meurzh|ebrel|mae|mezheven|gouere|eost|gwengolo|here|du|kerzu)/i,
        monthsShortStrictRegex =
            /^(gen|c[ʼ\']hwe|meu|ebr|mae|eve|gou|eos|gwe|her|du|ker)/i,
        fullWeekdaysParse = [
            /^sul/i,
            /^lun/i,
            /^meurzh/i,
            /^merc[ʼ\']her/i,
            /^yaou/i,
            /^gwener/i,
            /^sadorn/i,
        ],
        shortWeekdaysParse = [
            /^Sul/i,
            /^Lun/i,
            /^Meu/i,
            /^Mer/i,
            /^Yao/i,
            /^Gwe/i,
            /^Sad/i,
        ],
        minWeekdaysParse = [
            /^Su/i,
            /^Lu/i,
            /^Me([^r]|$)/i,
            /^Mer/i,
            /^Ya/i,
            /^Gw/i,
            /^Sa/i,
        ];

    var br = moment.defineLocale('br', {
        months: 'Genver_Cʼhwevrer_Meurzh_Ebrel_Mae_Mezheven_Gouere_Eost_Gwengolo_Here_Du_Kerzu'.split(
            '_'
        ),
        monthsShort: 'Gen_Cʼhwe_Meu_Ebr_Mae_Eve_Gou_Eos_Gwe_Her_Du_Ker'.split('_'),
        weekdays: 'Sul_Lun_Meurzh_Mercʼher_Yaou_Gwener_Sadorn'.split('_'),
        weekdaysShort: 'Sul_Lun_Meu_Mer_Yao_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Lu_Me_Mer_Ya_Gw_Sa'.split('_'),
        weekdaysParse: minWeekdaysParse,
        fullWeekdaysParse: fullWeekdaysParse,
        shortWeekdaysParse: shortWeekdaysParse,
        minWeekdaysParse: minWeekdaysParse,

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [a viz] MMMM YYYY',
            LLL: 'D [a viz] MMMM YYYY HH:mm',
            LLLL: 'dddd, D [a viz] MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hiziv da] LT',
            nextDay: '[Warcʼhoazh da] LT',
            nextWeek: 'dddd [da] LT',
            lastDay: '[Decʼh da] LT',
            lastWeek: 'dddd [paset da] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'a-benn %s',
            past: '%s ʼzo',
            s: 'un nebeud segondennoù',
            ss: '%d eilenn',
            m: 'ur vunutenn',
            mm: relativeTimeWithMutation,
            h: 'un eur',
            hh: '%d eur',
            d: 'un devezh',
            dd: relativeTimeWithMutation,
            M: 'ur miz',
            MM: relativeTimeWithMutation,
            y: 'ur bloaz',
            yy: specialMutationForYears,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(añ|vet)/,
        ordinal: function (number) {
            var output = number === 1 ? 'añ' : 'vet';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        meridiemParse: /a.m.|g.m./, // goude merenn | a-raok merenn
        isPM: function (token) {
            return token === 'g.m.';
        },
        meridiem: function (hour, minute, isLower) {
            return hour < 12 ? 'a.m.' : 'g.m.';
        },
    });

    return br;

})));


/***/ }),

/***/ 622:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Bosnian [bs]
//! author : Nedim Cholich : https://github.com/frontyard
//! based on (hr) translation by Bojan Marković

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var bs = moment.defineLocale('bs', {
        months: 'januar_februar_mart_april_maj_juni_juli_august_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._aug._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                        return '[prošlu] dddd [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return bs;

})));


/***/ }),

/***/ 2468:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Catalan [ca]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ca = moment.defineLocale('ca', {
        months: {
            standalone:
                'gener_febrer_març_abril_maig_juny_juliol_agost_setembre_octubre_novembre_desembre'.split(
                    '_'
                ),
            format: "de gener_de febrer_de març_d'abril_de maig_de juny_de juliol_d'agost_de setembre_d'octubre_de novembre_de desembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._maig_juny_jul._ag._set._oct._nov._des.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'diumenge_dilluns_dimarts_dimecres_dijous_divendres_dissabte'.split(
                '_'
            ),
        weekdaysShort: 'dg._dl._dt._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dt_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a les] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a les] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[avui a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextDay: function () {
                return '[demà a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastDay: function () {
                return '[ahir a ' + (this.hours() !== 1 ? 'les' : 'la') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [passat a ' +
                    (this.hours() !== 1 ? 'les' : 'la') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'uns segons',
            ss: '%d segons',
            m: 'un minut',
            mm: '%d minuts',
            h: 'una hora',
            hh: '%d hores',
            d: 'un dia',
            dd: '%d dies',
            M: 'un mes',
            MM: '%d mesos',
            y: 'un any',
            yy: '%d anys',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ca;

})));


/***/ }),

/***/ 5822:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Czech [cs]
//! author : petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = {
            format: 'leden_únor_březen_duben_květen_červen_červenec_srpen_září_říjen_listopad_prosinec'.split(
                '_'
            ),
            standalone:
                'ledna_února_března_dubna_května_června_července_srpna_září_října_listopadu_prosince'.split(
                    '_'
                ),
        },
        monthsShort = 'led_úno_bře_dub_kvě_čvn_čvc_srp_zář_říj_lis_pro'.split('_'),
        monthsParse = [
            /^led/i,
            /^úno/i,
            /^bře/i,
            /^dub/i,
            /^kvě/i,
            /^(čvn|červen$|června)/i,
            /^(čvc|červenec|července)/i,
            /^srp/i,
            /^zář/i,
            /^říj/i,
            /^lis/i,
            /^pro/i,
        ],
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsRegex =
            /^(leden|únor|březen|duben|květen|červenec|července|červen|června|srpen|září|říjen|listopad|prosinec|led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i;

    function plural(n) {
        return n > 1 && n < 5 && ~~(n / 10) !== 1;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekund' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekund');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minuta' : isFuture ? 'minutu' : 'minutou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minuty' : 'minut');
                } else {
                    return result + 'minutami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodin');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'den' : 'dnem';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dny' : 'dní');
                } else {
                    return result + 'dny';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'měsíc' : 'měsícem';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'měsíce' : 'měsíců');
                } else {
                    return result + 'měsíci';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokem';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'let');
                } else {
                    return result + 'lety';
                }
        }
    }

    var cs = moment.defineLocale('cs', {
        months: months,
        monthsShort: monthsShort,
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        // NOTE: 'červen' is substring of 'červenec'; therefore 'červenec' must precede 'červen' in the regex to be fully matched.
        // Otherwise parser matches '1. červenec' as '1. červen' + 'ec'.
        monthsStrictRegex:
            /^(leden|ledna|února|únor|březen|března|duben|dubna|květen|května|červenec|července|červen|června|srpen|srpna|září|říjen|října|listopadu|listopad|prosinec|prosince)/i,
        monthsShortStrictRegex:
            /^(led|úno|bře|dub|kvě|čvn|čvc|srp|zář|říj|lis|pro)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'neděle_pondělí_úterý_středa_čtvrtek_pátek_sobota'.split('_'),
        weekdaysShort: 'ne_po_út_st_čt_pá_so'.split('_'),
        weekdaysMin: 'ne_po_út_st_čt_pá_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
            l: 'D. M. YYYY',
        },
        calendar: {
            sameDay: '[dnes v] LT',
            nextDay: '[zítra v] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v neděli v] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [v] LT';
                    case 3:
                        return '[ve středu v] LT';
                    case 4:
                        return '[ve čtvrtek v] LT';
                    case 5:
                        return '[v pátek v] LT';
                    case 6:
                        return '[v sobotu v] LT';
                }
            },
            lastDay: '[včera v] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulou neděli v] LT';
                    case 1:
                    case 2:
                        return '[minulé] dddd [v] LT';
                    case 3:
                        return '[minulou středu v] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [v] LT';
                    case 6:
                        return '[minulou sobotu v] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'před %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cs;

})));


/***/ }),

/***/ 877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chuvash [cv]
//! author : Anatoly Mironov : https://github.com/mirontoli

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cv = moment.defineLocale('cv', {
        months: 'кӑрлач_нарӑс_пуш_ака_май_ҫӗртме_утӑ_ҫурла_авӑн_юпа_чӳк_раштав'.split(
            '_'
        ),
        monthsShort: 'кӑр_нар_пуш_ака_май_ҫӗр_утӑ_ҫур_авн_юпа_чӳк_раш'.split('_'),
        weekdays:
            'вырсарникун_тунтикун_ытларикун_юнкун_кӗҫнерникун_эрнекун_шӑматкун'.split(
                '_'
            ),
        weekdaysShort: 'выр_тун_ытл_юн_кӗҫ_эрн_шӑм'.split('_'),
        weekdaysMin: 'вр_тн_ыт_юн_кҫ_эр_шм'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ]',
            LLL: 'YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
            LLLL: 'dddd, YYYY [ҫулхи] MMMM [уйӑхӗн] D[-мӗшӗ], HH:mm',
        },
        calendar: {
            sameDay: '[Паян] LT [сехетре]',
            nextDay: '[Ыран] LT [сехетре]',
            lastDay: '[Ӗнер] LT [сехетре]',
            nextWeek: '[Ҫитес] dddd LT [сехетре]',
            lastWeek: '[Иртнӗ] dddd LT [сехетре]',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (output) {
                var affix = /сехет$/i.exec(output)
                    ? 'рен'
                    : /ҫул$/i.exec(output)
                    ? 'тан'
                    : 'ран';
                return output + affix;
            },
            past: '%s каялла',
            s: 'пӗр-ик ҫеккунт',
            ss: '%d ҫеккунт',
            m: 'пӗр минут',
            mm: '%d минут',
            h: 'пӗр сехет',
            hh: '%d сехет',
            d: 'пӗр кун',
            dd: '%d кун',
            M: 'пӗр уйӑх',
            MM: '%d уйӑх',
            y: 'пӗр ҫул',
            yy: '%d ҫул',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-мӗш/,
        ordinal: '%d-мӗш',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return cv;

})));


/***/ }),

/***/ 7373:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Welsh [cy]
//! author : Robert Allen : https://github.com/robgallen
//! author : https://github.com/ryangreaves

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var cy = moment.defineLocale('cy', {
        months: 'Ionawr_Chwefror_Mawrth_Ebrill_Mai_Mehefin_Gorffennaf_Awst_Medi_Hydref_Tachwedd_Rhagfyr'.split(
            '_'
        ),
        monthsShort: 'Ion_Chwe_Maw_Ebr_Mai_Meh_Gor_Aws_Med_Hyd_Tach_Rhag'.split(
            '_'
        ),
        weekdays:
            'Dydd Sul_Dydd Llun_Dydd Mawrth_Dydd Mercher_Dydd Iau_Dydd Gwener_Dydd Sadwrn'.split(
                '_'
            ),
        weekdaysShort: 'Sul_Llun_Maw_Mer_Iau_Gwe_Sad'.split('_'),
        weekdaysMin: 'Su_Ll_Ma_Me_Ia_Gw_Sa'.split('_'),
        weekdaysParseExact: true,
        // time formats are the same as en-gb
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Heddiw am] LT',
            nextDay: '[Yfory am] LT',
            nextWeek: 'dddd [am] LT',
            lastDay: '[Ddoe am] LT',
            lastWeek: 'dddd [diwethaf am] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'mewn %s',
            past: '%s yn ôl',
            s: 'ychydig eiliadau',
            ss: '%d eiliad',
            m: 'munud',
            mm: '%d munud',
            h: 'awr',
            hh: '%d awr',
            d: 'diwrnod',
            dd: '%d diwrnod',
            M: 'mis',
            MM: '%d mis',
            y: 'blwyddyn',
            yy: '%d flynedd',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(fed|ain|af|il|ydd|ed|eg)/,
        // traditional ordinal numbers above 31 are not commonly used in colloquial Welsh
        ordinal: function (number) {
            var b = number,
                output = '',
                lookup = [
                    '',
                    'af',
                    'il',
                    'ydd',
                    'ydd',
                    'ed',
                    'ed',
                    'ed',
                    'fed',
                    'fed',
                    'fed', // 1af to 10fed
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'eg',
                    'fed',
                    'eg',
                    'fed', // 11eg to 20fed
                ];
            if (b > 20) {
                if (b === 40 || b === 50 || b === 60 || b === 80 || b === 100) {
                    output = 'fed'; // not 30ain, 70ain or 90ain
                } else {
                    output = 'ain';
                }
            } else if (b > 0) {
                output = lookup[b];
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return cy;

})));


/***/ }),

/***/ 4780:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Danish [da]
//! author : Ulrik Nielsen : https://github.com/mrbase

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var da = moment.defineLocale('da', {
        months: 'januar_februar_marts_april_maj_juni_juli_august_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'søn_man_tir_ons_tor_fre_lør'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd [d.] D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'på dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[i] dddd[s kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'få sekunder',
            ss: '%d sekunder',
            m: 'et minut',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dage',
            M: 'en måned',
            MM: '%d måneder',
            y: 'et år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return da;

})));


/***/ }),

/***/ 217:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Austria) [de-at]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Martin Groller : https://github.com/MadMG
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deAt = moment.defineLocale('de-at', {
        months: 'Jänner_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jän._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deAt;

})));


/***/ }),

/***/ 894:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German (Switzerland) [de-ch]
//! author : sschueller : https://github.com/sschueller

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var deCh = moment.defineLocale('de-ch', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return deCh;

})));


/***/ }),

/***/ 9740:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : German [de]
//! author : lluchs : https://github.com/lluchs
//! author: Menelion Elensúle: https://github.com/Oire
//! author : Mikolaj Dadela : https://github.com/mik01aj

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eine Minute', 'einer Minute'],
            h: ['eine Stunde', 'einer Stunde'],
            d: ['ein Tag', 'einem Tag'],
            dd: [number + ' Tage', number + ' Tagen'],
            w: ['eine Woche', 'einer Woche'],
            M: ['ein Monat', 'einem Monat'],
            MM: [number + ' Monate', number + ' Monaten'],
            y: ['ein Jahr', 'einem Jahr'],
            yy: [number + ' Jahre', number + ' Jahren'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }

    var de = moment.defineLocale('de', {
        months: 'Januar_Februar_März_April_Mai_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Feb._März_Apr._Mai_Juni_Juli_Aug._Sep._Okt._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays:
            'Sonntag_Montag_Dienstag_Mittwoch_Donnerstag_Freitag_Samstag'.split(
                '_'
            ),
        weekdaysShort: 'So._Mo._Di._Mi._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mo_Di_Mi_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY HH:mm',
            LLLL: 'dddd, D. MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[heute um] LT [Uhr]',
            sameElse: 'L',
            nextDay: '[morgen um] LT [Uhr]',
            nextWeek: 'dddd [um] LT [Uhr]',
            lastDay: '[gestern um] LT [Uhr]',
            lastWeek: '[letzten] dddd [um] LT [Uhr]',
        },
        relativeTime: {
            future: 'in %s',
            past: 'vor %s',
            s: 'ein paar Sekunden',
            ss: '%d Sekunden',
            m: processRelativeTime,
            mm: '%d Minuten',
            h: processRelativeTime,
            hh: '%d Stunden',
            d: processRelativeTime,
            dd: processRelativeTime,
            w: processRelativeTime,
            ww: '%d Wochen',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return de;

})));


/***/ }),

/***/ 5300:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maldivian [dv]
//! author : Jawish Hameed : https://github.com/jawish

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'ޖެނުއަރީ',
            'ފެބްރުއަރީ',
            'މާރިޗު',
            'އޭޕްރީލު',
            'މޭ',
            'ޖޫން',
            'ޖުލައި',
            'އޯގަސްޓު',
            'ސެޕްޓެމްބަރު',
            'އޮކްޓޯބަރު',
            'ނޮވެމްބަރު',
            'ޑިސެމްބަރު',
        ],
        weekdays = [
            'އާދިއްތަ',
            'ހޯމަ',
            'އަންގާރަ',
            'ބުދަ',
            'ބުރާސްފަތި',
            'ހުކުރު',
            'ހޮނިހިރު',
        ];

    var dv = moment.defineLocale('dv', {
        months: months,
        monthsShort: months,
        weekdays: weekdays,
        weekdaysShort: weekdays,
        weekdaysMin: 'އާދި_ހޯމަ_އަން_ބުދަ_ބުރާ_ހުކު_ހޮނި'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'D/M/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /މކ|މފ/,
        isPM: function (input) {
            return 'މފ' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'މކ';
            } else {
                return 'މފ';
            }
        },
        calendar: {
            sameDay: '[މިއަދު] LT',
            nextDay: '[މާދަމާ] LT',
            nextWeek: 'dddd LT',
            lastDay: '[އިއްޔެ] LT',
            lastWeek: '[ފާއިތުވި] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ތެރޭގައި %s',
            past: 'ކުރިން %s',
            s: 'ސިކުންތުކޮޅެއް',
            ss: 'd% ސިކުންތު',
            m: 'މިނިޓެއް',
            mm: 'މިނިޓު %d',
            h: 'ގަޑިއިރެއް',
            hh: 'ގަޑިއިރު %d',
            d: 'ދުވަހެއް',
            dd: 'ދުވަސް %d',
            M: 'މަހެއް',
            MM: 'މަސް %d',
            y: 'އަހަރެއް',
            yy: 'އަހަރު %d',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 7, // Sunday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return dv;

})));


/***/ }),

/***/ 837:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Greek [el]
//! author : Aggelos Karalias : https://github.com/mehiel

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    var el = moment.defineLocale('el', {
        monthsNominativeEl:
            'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
                '_'
            ),
        monthsGenitiveEl:
            'Ιανουαρίου_Φεβρουαρίου_Μαρτίου_Απριλίου_Μαΐου_Ιουνίου_Ιουλίου_Αυγούστου_Σεπτεμβρίου_Οκτωβρίου_Νοεμβρίου_Δεκεμβρίου'.split(
                '_'
            ),
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return this._monthsNominativeEl;
            } else if (
                typeof format === 'string' &&
                /D/.test(format.substring(0, format.indexOf('MMMM')))
            ) {
                // if there is a day number before 'MMMM'
                return this._monthsGenitiveEl[momentToFormat.month()];
            } else {
                return this._monthsNominativeEl[momentToFormat.month()];
            }
        },
        monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαϊ_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
        weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split(
            '_'
        ),
        weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
        weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'μμ' : 'ΜΜ';
            } else {
                return isLower ? 'πμ' : 'ΠΜ';
            }
        },
        isPM: function (input) {
            return (input + '').toLowerCase()[0] === 'μ';
        },
        meridiemParse: /[ΠΜ]\.?Μ?\.?/i,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendarEl: {
            sameDay: '[Σήμερα {}] LT',
            nextDay: '[Αύριο {}] LT',
            nextWeek: 'dddd [{}] LT',
            lastDay: '[Χθες {}] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 6:
                        return '[το προηγούμενο] dddd [{}] LT';
                    default:
                        return '[την προηγούμενη] dddd [{}] LT';
                }
            },
            sameElse: 'L',
        },
        calendar: function (key, mom) {
            var output = this._calendarEl[key],
                hours = mom && mom.hours();
            if (isFunction(output)) {
                output = output.apply(mom);
            }
            return output.replace('{}', hours % 12 === 1 ? 'στη' : 'στις');
        },
        relativeTime: {
            future: 'σε %s',
            past: '%s πριν',
            s: 'λίγα δευτερόλεπτα',
            ss: '%d δευτερόλεπτα',
            m: 'ένα λεπτό',
            mm: '%d λεπτά',
            h: 'μία ώρα',
            hh: '%d ώρες',
            d: 'μία μέρα',
            dd: '%d μέρες',
            M: 'ένας μήνας',
            MM: '%d μήνες',
            y: 'ένας χρόνος',
            yy: '%d χρόνια',
        },
        dayOfMonthOrdinalParse: /\d{1,2}η/,
        ordinal: '%dη',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4st is the first week of the year.
        },
    });

    return el;

})));


/***/ }),

/***/ 8348:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Australia) [en-au]
//! author : Jared Morse : https://github.com/jarcoal

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enAu = moment.defineLocale('en-au', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enAu;

})));


/***/ }),

/***/ 7925:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Canada) [en-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enCa = moment.defineLocale('en-ca', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'YYYY-MM-DD',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY h:mm A',
            LLLL: 'dddd, MMMM D, YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enCa;

})));


/***/ }),

/***/ 2243:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (United Kingdom) [en-gb]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enGb = moment.defineLocale('en-gb', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enGb;

})));


/***/ }),

/***/ 6436:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Ireland) [en-ie]
//! author : Chris Cartlidge : https://github.com/chriscartlidge

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIe = moment.defineLocale('en-ie', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enIe;

})));


/***/ }),

/***/ 941:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Israel) [en-il]
//! author : Chris Gedrim : https://github.com/chrisgedrim

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIl = moment.defineLocale('en-il', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    return enIl;

})));


/***/ }),

/***/ 4175:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (India) [en-in]
//! author : Jatin Agrawal : https://github.com/jatinag22

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enIn = moment.defineLocale('en-in', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return enIn;

})));


/***/ }),

/***/ 6319:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (New Zealand) [en-nz]
//! author : Luke McGregor : https://github.com/lukemcgregor

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enNz = moment.defineLocale('en-nz', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enNz;

})));


/***/ }),

/***/ 1662:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : English (Singapore) [en-sg]
//! author : Matthew Castrillon-Madrigal : https://github.com/techdimension

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var enSg = moment.defineLocale('en-sg', {
        months: 'January_February_March_April_May_June_July_August_September_October_November_December'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        weekdays: 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split(
            '_'
        ),
        weekdaysShort: 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        weekdaysMin: 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Today at] LT',
            nextDay: '[Tomorrow at] LT',
            nextWeek: 'dddd [at] LT',
            lastDay: '[Yesterday at] LT',
            lastWeek: '[Last] dddd [at] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'in %s',
            past: '%s ago',
            s: 'a few seconds',
            ss: '%d seconds',
            m: 'a minute',
            mm: '%d minutes',
            h: 'an hour',
            hh: '%d hours',
            d: 'a day',
            dd: '%d days',
            M: 'a month',
            MM: '%d months',
            y: 'a year',
            yy: '%d years',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return enSg;

})));


/***/ }),

/***/ 2915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Esperanto [eo]
//! author : Colin Dean : https://github.com/colindean
//! author : Mia Nordentoft Imperatori : https://github.com/miestasmia
//! comment : miestasmia corrected the translation by colindean
//! comment : Vivakvo corrected the translation by colindean and miestasmia

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eo = moment.defineLocale('eo', {
        months: 'januaro_februaro_marto_aprilo_majo_junio_julio_aŭgusto_septembro_oktobro_novembro_decembro'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mart_apr_maj_jun_jul_aŭg_sept_okt_nov_dec'.split('_'),
        weekdays: 'dimanĉo_lundo_mardo_merkredo_ĵaŭdo_vendredo_sabato'.split('_'),
        weekdaysShort: 'dim_lun_mard_merk_ĵaŭ_ven_sab'.split('_'),
        weekdaysMin: 'di_lu_ma_me_ĵa_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: '[la] D[-an de] MMMM, YYYY',
            LLL: '[la] D[-an de] MMMM, YYYY HH:mm',
            LLLL: 'dddd[n], [la] D[-an de] MMMM, YYYY HH:mm',
            llll: 'ddd, [la] D[-an de] MMM, YYYY HH:mm',
        },
        meridiemParse: /[ap]\.t\.m/i,
        isPM: function (input) {
            return input.charAt(0).toLowerCase() === 'p';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'p.t.m.' : 'P.T.M.';
            } else {
                return isLower ? 'a.t.m.' : 'A.T.M.';
            }
        },
        calendar: {
            sameDay: '[Hodiaŭ je] LT',
            nextDay: '[Morgaŭ je] LT',
            nextWeek: 'dddd[n je] LT',
            lastDay: '[Hieraŭ je] LT',
            lastWeek: '[pasintan] dddd[n je] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'post %s',
            past: 'antaŭ %s',
            s: 'kelkaj sekundoj',
            ss: '%d sekundoj',
            m: 'unu minuto',
            mm: '%d minutoj',
            h: 'unu horo',
            hh: '%d horoj',
            d: 'unu tago', //ne 'diurno', ĉar estas uzita por proksimumo
            dd: '%d tagoj',
            M: 'unu monato',
            MM: '%d monatoj',
            y: 'unu jaro',
            yy: '%d jaroj',
        },
        dayOfMonthOrdinalParse: /\d{1,2}a/,
        ordinal: '%da',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eo;

})));


/***/ }),

/***/ 5251:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Dominican Republic) [es-do]

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esDo = moment.defineLocale('es-do', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return esDo;

})));


/***/ }),

/***/ 6112:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (Mexico) [es-mx]
//! author : JC Franco : https://github.com/jcfranco

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esMx = moment.defineLocale('es-mx', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return esMx;

})));


/***/ }),

/***/ 1146:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish (United States) [es-us]
//! author : bustta : https://github.com/bustta
//! author : chrisrodz : https://github.com/chrisrodz

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var esUs = moment.defineLocale('es-us', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'MM/DD/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY h:mm A',
            LLLL: 'dddd, D [de] MMMM [de] YYYY h:mm A',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return esUs;

})));


/***/ }),

/***/ 5655:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Spanish [es]
//! author : Julio Napurí : https://github.com/julionc

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortDot =
            'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split(
                '_'
            ),
        monthsShort = 'ene_feb_mar_abr_may_jun_jul_ago_sep_oct_nov_dic'.split('_'),
        monthsParse = [
            /^ene/i,
            /^feb/i,
            /^mar/i,
            /^abr/i,
            /^may/i,
            /^jun/i,
            /^jul/i,
            /^ago/i,
            /^sep/i,
            /^oct/i,
            /^nov/i,
            /^dic/i,
        ],
        monthsRegex =
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

    var es = moment.defineLocale('es', {
        months: 'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortDot;
            } else if (/-MMM-/.test(format)) {
                return monthsShort[m.month()];
            } else {
                return monthsShortDot[m.month()];
            }
        },
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
        monthsShortStrictRegex:
            /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextDay: function () {
                return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastDay: function () {
                return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[el] dddd [pasado a la' +
                    (this.hours() !== 1 ? 's' : '') +
                    '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'en %s',
            past: 'hace %s',
            s: 'unos segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'una hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            w: 'una semana',
            ww: '%d semanas',
            M: 'un mes',
            MM: '%d meses',
            y: 'un año',
            yy: '%d años',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
        invalidDate: 'Fecha inválida',
    });

    return es;

})));


/***/ }),

/***/ 5603:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Estonian [et]
//! author : Henry Kehlmann : https://github.com/madhenry
//! improvements : Illimar Tambek : https://github.com/ragulka

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['mõne sekundi', 'mõni sekund', 'paar sekundit'],
            ss: [number + 'sekundi', number + 'sekundit'],
            m: ['ühe minuti', 'üks minut'],
            mm: [number + ' minuti', number + ' minutit'],
            h: ['ühe tunni', 'tund aega', 'üks tund'],
            hh: [number + ' tunni', number + ' tundi'],
            d: ['ühe päeva', 'üks päev'],
            M: ['kuu aja', 'kuu aega', 'üks kuu'],
            MM: [number + ' kuu', number + ' kuud'],
            y: ['ühe aasta', 'aasta', 'üks aasta'],
            yy: [number + ' aasta', number + ' aastat'],
        };
        if (withoutSuffix) {
            return format[key][2] ? format[key][2] : format[key][1];
        }
        return isFuture ? format[key][0] : format[key][1];
    }

    var et = moment.defineLocale('et', {
        months: 'jaanuar_veebruar_märts_aprill_mai_juuni_juuli_august_september_oktoober_november_detsember'.split(
            '_'
        ),
        monthsShort:
            'jaan_veebr_märts_apr_mai_juuni_juuli_aug_sept_okt_nov_dets'.split('_'),
        weekdays:
            'pühapäev_esmaspäev_teisipäev_kolmapäev_neljapäev_reede_laupäev'.split(
                '_'
            ),
        weekdaysShort: 'P_E_T_K_N_R_L'.split('_'),
        weekdaysMin: 'P_E_T_K_N_R_L'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Täna,] LT',
            nextDay: '[Homme,] LT',
            nextWeek: '[Järgmine] dddd LT',
            lastDay: '[Eile,] LT',
            lastWeek: '[Eelmine] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s pärast',
            past: '%s tagasi',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: '%d päeva',
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return et;

})));


/***/ }),

/***/ 7763:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Basque [eu]
//! author : Eneko Illarramendi : https://github.com/eillarra

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var eu = moment.defineLocale('eu', {
        months: 'urtarrila_otsaila_martxoa_apirila_maiatza_ekaina_uztaila_abuztua_iraila_urria_azaroa_abendua'.split(
            '_'
        ),
        monthsShort:
            'urt._ots._mar._api._mai._eka._uzt._abu._ira._urr._aza._abe.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'igandea_astelehena_asteartea_asteazkena_osteguna_ostirala_larunbata'.split(
                '_'
            ),
        weekdaysShort: 'ig._al._ar._az._og._ol._lr.'.split('_'),
        weekdaysMin: 'ig_al_ar_az_og_ol_lr'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY[ko] MMMM[ren] D[a]',
            LLL: 'YYYY[ko] MMMM[ren] D[a] HH:mm',
            LLLL: 'dddd, YYYY[ko] MMMM[ren] D[a] HH:mm',
            l: 'YYYY-M-D',
            ll: 'YYYY[ko] MMM D[a]',
            lll: 'YYYY[ko] MMM D[a] HH:mm',
            llll: 'ddd, YYYY[ko] MMM D[a] HH:mm',
        },
        calendar: {
            sameDay: '[gaur] LT[etan]',
            nextDay: '[bihar] LT[etan]',
            nextWeek: 'dddd LT[etan]',
            lastDay: '[atzo] LT[etan]',
            lastWeek: '[aurreko] dddd LT[etan]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s barru',
            past: 'duela %s',
            s: 'segundo batzuk',
            ss: '%d segundo',
            m: 'minutu bat',
            mm: '%d minutu',
            h: 'ordu bat',
            hh: '%d ordu',
            d: 'egun bat',
            dd: '%d egun',
            M: 'hilabete bat',
            MM: '%d hilabete',
            y: 'urte bat',
            yy: '%d urte',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return eu;

})));


/***/ }),

/***/ 6959:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Persian [fa]
//! author : Ebrahim Byagowi : https://github.com/ebraminio

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '۱',
            2: '۲',
            3: '۳',
            4: '۴',
            5: '۵',
            6: '۶',
            7: '۷',
            8: '۸',
            9: '۹',
            0: '۰',
        },
        numberMap = {
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9',
            '۰': '0',
        };

    var fa = moment.defineLocale('fa', {
        months: 'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
            '_'
        ),
        monthsShort:
            'ژانویه_فوریه_مارس_آوریل_مه_ژوئن_ژوئیه_اوت_سپتامبر_اکتبر_نوامبر_دسامبر'.split(
                '_'
            ),
        weekdays:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysShort:
            'یک\u200cشنبه_دوشنبه_سه\u200cشنبه_چهارشنبه_پنج\u200cشنبه_جمعه_شنبه'.split(
                '_'
            ),
        weekdaysMin: 'ی_د_س_چ_پ_ج_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /قبل از ظهر|بعد از ظهر/,
        isPM: function (input) {
            return /بعد از ظهر/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'قبل از ظهر';
            } else {
                return 'بعد از ظهر';
            }
        },
        calendar: {
            sameDay: '[امروز ساعت] LT',
            nextDay: '[فردا ساعت] LT',
            nextWeek: 'dddd [ساعت] LT',
            lastDay: '[دیروز ساعت] LT',
            lastWeek: 'dddd [پیش] [ساعت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'در %s',
            past: '%s پیش',
            s: 'چند ثانیه',
            ss: '%d ثانیه',
            m: 'یک دقیقه',
            mm: '%d دقیقه',
            h: 'یک ساعت',
            hh: '%d ساعت',
            d: 'یک روز',
            dd: '%d روز',
            M: 'یک ماه',
            MM: '%d ماه',
            y: 'یک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string
                .replace(/[۰-۹]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        dayOfMonthOrdinalParse: /\d{1,2}م/,
        ordinal: '%dم',
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return fa;

})));


/***/ }),

/***/ 1897:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Finnish [fi]
//! author : Tarmo Aidantausta : https://github.com/bleadof

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersPast =
            'nolla yksi kaksi kolme neljä viisi kuusi seitsemän kahdeksan yhdeksän'.split(
                ' '
            ),
        numbersFuture = [
            'nolla',
            'yhden',
            'kahden',
            'kolmen',
            'neljän',
            'viiden',
            'kuuden',
            numbersPast[7],
            numbersPast[8],
            numbersPast[9],
        ];
    function translate(number, withoutSuffix, key, isFuture) {
        var result = '';
        switch (key) {
            case 's':
                return isFuture ? 'muutaman sekunnin' : 'muutama sekunti';
            case 'ss':
                result = isFuture ? 'sekunnin' : 'sekuntia';
                break;
            case 'm':
                return isFuture ? 'minuutin' : 'minuutti';
            case 'mm':
                result = isFuture ? 'minuutin' : 'minuuttia';
                break;
            case 'h':
                return isFuture ? 'tunnin' : 'tunti';
            case 'hh':
                result = isFuture ? 'tunnin' : 'tuntia';
                break;
            case 'd':
                return isFuture ? 'päivän' : 'päivä';
            case 'dd':
                result = isFuture ? 'päivän' : 'päivää';
                break;
            case 'M':
                return isFuture ? 'kuukauden' : 'kuukausi';
            case 'MM':
                result = isFuture ? 'kuukauden' : 'kuukautta';
                break;
            case 'y':
                return isFuture ? 'vuoden' : 'vuosi';
            case 'yy':
                result = isFuture ? 'vuoden' : 'vuotta';
                break;
        }
        result = verbalNumber(number, isFuture) + ' ' + result;
        return result;
    }
    function verbalNumber(number, isFuture) {
        return number < 10
            ? isFuture
                ? numbersFuture[number]
                : numbersPast[number]
            : number;
    }

    var fi = moment.defineLocale('fi', {
        months: 'tammikuu_helmikuu_maaliskuu_huhtikuu_toukokuu_kesäkuu_heinäkuu_elokuu_syyskuu_lokakuu_marraskuu_joulukuu'.split(
            '_'
        ),
        monthsShort:
            'tammi_helmi_maalis_huhti_touko_kesä_heinä_elo_syys_loka_marras_joulu'.split(
                '_'
            ),
        weekdays:
            'sunnuntai_maanantai_tiistai_keskiviikko_torstai_perjantai_lauantai'.split(
                '_'
            ),
        weekdaysShort: 'su_ma_ti_ke_to_pe_la'.split('_'),
        weekdaysMin: 'su_ma_ti_ke_to_pe_la'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM[ta] YYYY',
            LLL: 'Do MMMM[ta] YYYY, [klo] HH.mm',
            LLLL: 'dddd, Do MMMM[ta] YYYY, [klo] HH.mm',
            l: 'D.M.YYYY',
            ll: 'Do MMM YYYY',
            lll: 'Do MMM YYYY, [klo] HH.mm',
            llll: 'ddd, Do MMM YYYY, [klo] HH.mm',
        },
        calendar: {
            sameDay: '[tänään] [klo] LT',
            nextDay: '[huomenna] [klo] LT',
            nextWeek: 'dddd [klo] LT',
            lastDay: '[eilen] [klo] LT',
            lastWeek: '[viime] dddd[na] [klo] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s päästä',
            past: '%s sitten',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fi;

})));


/***/ }),

/***/ 2549:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Filipino [fil]
//! author : Dan Hagman : https://github.com/hagmandan
//! author : Matthew Co : https://github.com/matthewdeeco

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fil = moment.defineLocale('fil', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fil;

})));


/***/ }),

/***/ 4694:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Faroese [fo]
//! author : Ragnar Johannesen : https://github.com/ragnar123
//! author : Kristian Sakarisson : https://github.com/sakarisson

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var fo = moment.defineLocale('fo', {
        months: 'januar_februar_mars_apríl_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_'),
        weekdays:
            'sunnudagur_mánadagur_týsdagur_mikudagur_hósdagur_fríggjadagur_leygardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_týs_mik_hós_frí_ley'.split('_'),
        weekdaysMin: 'su_má_tý_mi_hó_fr_le'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D. MMMM, YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Í dag kl.] LT',
            nextDay: '[Í morgin kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[Í gjár kl.] LT',
            lastWeek: '[síðstu] dddd [kl] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'um %s',
            past: '%s síðani',
            s: 'fá sekund',
            ss: '%d sekundir',
            m: 'ein minuttur',
            mm: '%d minuttir',
            h: 'ein tími',
            hh: '%d tímar',
            d: 'ein dagur',
            dd: '%d dagar',
            M: 'ein mánaður',
            MM: '%d mánaðir',
            y: 'eitt ár',
            yy: '%d ár',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fo;

})));


/***/ }),

/***/ 3049:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Canada) [fr-ca]
//! author : Jonathan Abourbih : https://github.com/jonbca

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCa = moment.defineLocale('fr-ca', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
    });

    return frCa;

})));


/***/ }),

/***/ 2330:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French (Switzerland) [fr-ch]
//! author : Gaspard Bucher : https://github.com/gaspard

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var frCh = moment.defineLocale('fr-ch', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|e)/,
        ordinal: function (number, period) {
            switch (period) {
                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'D':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return frCh;

})));


/***/ }),

/***/ 4470:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : French [fr]
//! author : John Fischer : https://github.com/jfroffice

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsStrictRegex =
            /^(janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsShortStrictRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?)/i,
        monthsRegex =
            /(janv\.?|févr\.?|mars|avr\.?|mai|juin|juil\.?|août|sept\.?|oct\.?|nov\.?|déc\.?|janvier|février|mars|avril|mai|juin|juillet|août|septembre|octobre|novembre|décembre)/i,
        monthsParse = [
            /^janv/i,
            /^févr/i,
            /^mars/i,
            /^avr/i,
            /^mai/i,
            /^juin/i,
            /^juil/i,
            /^août/i,
            /^sept/i,
            /^oct/i,
            /^nov/i,
            /^déc/i,
        ];

    var fr = moment.defineLocale('fr', {
        months: 'janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre'.split(
            '_'
        ),
        monthsShort:
            'janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.'.split(
                '_'
            ),
        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex: monthsStrictRegex,
        monthsShortStrictRegex: monthsShortStrictRegex,
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays: 'dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi'.split('_'),
        weekdaysShort: 'dim._lun._mar._mer._jeu._ven._sam.'.split('_'),
        weekdaysMin: 'di_lu_ma_me_je_ve_sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Aujourd’hui à] LT',
            nextDay: '[Demain à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[Hier à] LT',
            lastWeek: 'dddd [dernier à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dans %s',
            past: 'il y a %s',
            s: 'quelques secondes',
            ss: '%d secondes',
            m: 'une minute',
            mm: '%d minutes',
            h: 'une heure',
            hh: '%d heures',
            d: 'un jour',
            dd: '%d jours',
            w: 'une semaine',
            ww: '%d semaines',
            M: 'un mois',
            MM: '%d mois',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er|)/,
        ordinal: function (number, period) {
            switch (period) {
                // TODO: Return 'e' when day of month > 1. Move this case inside
                // block for masculine words below.
                // See https://github.com/moment/moment/issues/3375
                case 'D':
                    return number + (number === 1 ? 'er' : '');

                // Words with masculine grammatical gender: mois, trimestre, jour
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                    return number + (number === 1 ? 'er' : 'e');

                // Words with feminine grammatical gender: semaine
                case 'w':
                case 'W':
                    return number + (number === 1 ? 're' : 'e');
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fr;

})));


/***/ }),

/***/ 5044:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Frisian [fy]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mai_jun._jul._aug._sep._okt._nov._des.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mai_jun_jul_aug_sep_okt_nov_des'.split('_');

    var fy = moment.defineLocale('fy', {
        months: 'jannewaris_febrewaris_maart_april_maaie_juny_july_augustus_septimber_oktober_novimber_desimber'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },
        monthsParseExact: true,
        weekdays: 'snein_moandei_tiisdei_woansdei_tongersdei_freed_sneon'.split(
            '_'
        ),
        weekdaysShort: 'si._mo._ti._wo._to._fr._so.'.split('_'),
        weekdaysMin: 'Si_Mo_Ti_Wo_To_Fr_So'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[hjoed om] LT',
            nextDay: '[moarn om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[juster om] LT',
            lastWeek: '[ôfrûne] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'oer %s',
            past: '%s lyn',
            s: 'in pear sekonden',
            ss: '%d sekonden',
            m: 'ien minút',
            mm: '%d minuten',
            h: 'ien oere',
            hh: '%d oeren',
            d: 'ien dei',
            dd: '%d dagen',
            M: 'ien moanne',
            MM: '%d moannen',
            y: 'ien jier',
            yy: '%d jierren',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return fy;

})));


/***/ }),

/***/ 9295:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Irish or Irish Gaelic [ga]
//! author : André Silva : https://github.com/askpt

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Eanáir',
            'Feabhra',
            'Márta',
            'Aibreán',
            'Bealtaine',
            'Meitheamh',
            'Iúil',
            'Lúnasa',
            'Meán Fómhair',
            'Deireadh Fómhair',
            'Samhain',
            'Nollaig',
        ],
        monthsShort = [
            'Ean',
            'Feabh',
            'Márt',
            'Aib',
            'Beal',
            'Meith',
            'Iúil',
            'Lún',
            'M.F.',
            'D.F.',
            'Samh',
            'Noll',
        ],
        weekdays = [
            'Dé Domhnaigh',
            'Dé Luain',
            'Dé Máirt',
            'Dé Céadaoin',
            'Déardaoin',
            'Dé hAoine',
            'Dé Sathairn',
        ],
        weekdaysShort = ['Domh', 'Luan', 'Máirt', 'Céad', 'Déar', 'Aoine', 'Sath'],
        weekdaysMin = ['Do', 'Lu', 'Má', 'Cé', 'Dé', 'A', 'Sa'];

    var ga = moment.defineLocale('ga', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Inniu ag] LT',
            nextDay: '[Amárach ag] LT',
            nextWeek: 'dddd [ag] LT',
            lastDay: '[Inné ag] LT',
            lastWeek: 'dddd [seo caite] [ag] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i %s',
            past: '%s ó shin',
            s: 'cúpla soicind',
            ss: '%d soicind',
            m: 'nóiméad',
            mm: '%d nóiméad',
            h: 'uair an chloig',
            hh: '%d uair an chloig',
            d: 'lá',
            dd: '%d lá',
            M: 'mí',
            MM: '%d míonna',
            y: 'bliain',
            yy: '%d bliain',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ga;

})));


/***/ }),

/***/ 2101:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Scottish Gaelic [gd]
//! author : Jon Ashdown : https://github.com/jonashdown

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'Am Faoilleach',
            'An Gearran',
            'Am Màrt',
            'An Giblean',
            'An Cèitean',
            'An t-Ògmhios',
            'An t-Iuchar',
            'An Lùnastal',
            'An t-Sultain',
            'An Dàmhair',
            'An t-Samhain',
            'An Dùbhlachd',
        ],
        monthsShort = [
            'Faoi',
            'Gear',
            'Màrt',
            'Gibl',
            'Cèit',
            'Ògmh',
            'Iuch',
            'Lùn',
            'Sult',
            'Dàmh',
            'Samh',
            'Dùbh',
        ],
        weekdays = [
            'Didòmhnaich',
            'Diluain',
            'Dimàirt',
            'Diciadain',
            'Diardaoin',
            'Dihaoine',
            'Disathairne',
        ],
        weekdaysShort = ['Did', 'Dil', 'Dim', 'Dic', 'Dia', 'Dih', 'Dis'],
        weekdaysMin = ['Dò', 'Lu', 'Mà', 'Ci', 'Ar', 'Ha', 'Sa'];

    var gd = moment.defineLocale('gd', {
        months: months,
        monthsShort: monthsShort,
        monthsParseExact: true,
        weekdays: weekdays,
        weekdaysShort: weekdaysShort,
        weekdaysMin: weekdaysMin,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[An-diugh aig] LT',
            nextDay: '[A-màireach aig] LT',
            nextWeek: 'dddd [aig] LT',
            lastDay: '[An-dè aig] LT',
            lastWeek: 'dddd [seo chaidh] [aig] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ann an %s',
            past: 'bho chionn %s',
            s: 'beagan diogan',
            ss: '%d diogan',
            m: 'mionaid',
            mm: '%d mionaidean',
            h: 'uair',
            hh: '%d uairean',
            d: 'latha',
            dd: '%d latha',
            M: 'mìos',
            MM: '%d mìosan',
            y: 'bliadhna',
            yy: '%d bliadhna',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(d|na|mh)/,
        ordinal: function (number) {
            var output = number === 1 ? 'd' : number % 10 === 2 ? 'na' : 'mh';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gd;

})));


/***/ }),

/***/ 8794:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Galician [gl]
//! author : Juan G. Hurtado : https://github.com/juanghurtado

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var gl = moment.defineLocale('gl', {
        months: 'xaneiro_febreiro_marzo_abril_maio_xuño_xullo_agosto_setembro_outubro_novembro_decembro'.split(
            '_'
        ),
        monthsShort:
            'xan._feb._mar._abr._mai._xuñ._xul._ago._set._out._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'domingo_luns_martes_mércores_xoves_venres_sábado'.split('_'),
        weekdaysShort: 'dom._lun._mar._mér._xov._ven._sáb.'.split('_'),
        weekdaysMin: 'do_lu_ma_mé_xo_ve_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY H:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
        },
        calendar: {
            sameDay: function () {
                return '[hoxe ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextDay: function () {
                return '[mañá ' + (this.hours() !== 1 ? 'ás' : 'á') + '] LT';
            },
            nextWeek: function () {
                return 'dddd [' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT';
            },
            lastDay: function () {
                return '[onte ' + (this.hours() !== 1 ? 'á' : 'a') + '] LT';
            },
            lastWeek: function () {
                return (
                    '[o] dddd [pasado ' + (this.hours() !== 1 ? 'ás' : 'a') + '] LT'
                );
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (str) {
                if (str.indexOf('un') === 0) {
                    return 'n' + str;
                }
                return 'en ' + str;
            },
            past: 'hai %s',
            s: 'uns segundos',
            ss: '%d segundos',
            m: 'un minuto',
            mm: '%d minutos',
            h: 'unha hora',
            hh: '%d horas',
            d: 'un día',
            dd: '%d días',
            M: 'un mes',
            MM: '%d meses',
            y: 'un ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return gl;

})));


/***/ }),

/***/ 7884:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Devanagari script [gom-deva]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['थोडया सॅकंडांनी', 'थोडे सॅकंड'],
            ss: [number + ' सॅकंडांनी', number + ' सॅकंड'],
            m: ['एका मिणटान', 'एक मिनूट'],
            mm: [number + ' मिणटांनी', number + ' मिणटां'],
            h: ['एका वरान', 'एक वर'],
            hh: [number + ' वरांनी', number + ' वरां'],
            d: ['एका दिसान', 'एक दीस'],
            dd: [number + ' दिसांनी', number + ' दीस'],
            M: ['एका म्हयन्यान', 'एक म्हयनो'],
            MM: [number + ' म्हयन्यानी', number + ' म्हयने'],
            y: ['एका वर्सान', 'एक वर्स'],
            yy: [number + ' वर्सांनी', number + ' वर्सां'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomDeva = moment.defineLocale('gom-deva', {
        months: {
            standalone:
                'जानेवारी_फेब्रुवारी_मार्च_एप्रील_मे_जून_जुलय_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
                    '_'
                ),
            format: 'जानेवारीच्या_फेब्रुवारीच्या_मार्चाच्या_एप्रीलाच्या_मेयाच्या_जूनाच्या_जुलयाच्या_ऑगस्टाच्या_सप्टेंबराच्या_ऑक्टोबराच्या_नोव्हेंबराच्या_डिसेंबराच्या'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'जाने._फेब्रु._मार्च_एप्री._मे_जून_जुल._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आयतार_सोमार_मंगळार_बुधवार_बिरेस्तार_सुक्रार_शेनवार'.split('_'),
        weekdaysShort: 'आयत._सोम._मंगळ._बुध._ब्रेस्त._सुक्र._शेन.'.split('_'),
        weekdaysMin: 'आ_सो_मं_बु_ब्रे_सु_शे'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [वाजतां]',
            LTS: 'A h:mm:ss [वाजतां]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [वाजतां]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [वाजतां]',
            llll: 'ddd, D MMM YYYY, A h:mm [वाजतां]',
        },
        calendar: {
            sameDay: '[आयज] LT',
            nextDay: '[फाल्यां] LT',
            nextWeek: '[फुडलो] dddd[,] LT',
            lastDay: '[काल] LT',
            lastWeek: '[फाटलो] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s आदीं',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(वेर)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'वेर' only applies to day of the month
                case 'D':
                    return number + 'वेर';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /राती|सकाळीं|दनपारां|सांजे/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राती') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सकाळीं') {
                return hour;
            } else if (meridiem === 'दनपारां') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'सांजे') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'राती';
            } else if (hour < 12) {
                return 'सकाळीं';
            } else if (hour < 16) {
                return 'दनपारां';
            } else if (hour < 20) {
                return 'सांजे';
            } else {
                return 'राती';
            }
        },
    });

    return gomDeva;

})));


/***/ }),

/***/ 3168:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Konkani Latin script [gom-latn]
//! author : The Discoverer : https://github.com/WikiDiscoverer

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['thoddea sekondamni', 'thodde sekond'],
            ss: [number + ' sekondamni', number + ' sekond'],
            m: ['eka mintan', 'ek minut'],
            mm: [number + ' mintamni', number + ' mintam'],
            h: ['eka voran', 'ek vor'],
            hh: [number + ' voramni', number + ' voram'],
            d: ['eka disan', 'ek dis'],
            dd: [number + ' disamni', number + ' dis'],
            M: ['eka mhoinean', 'ek mhoino'],
            MM: [number + ' mhoineamni', number + ' mhoine'],
            y: ['eka vorsan', 'ek voros'],
            yy: [number + ' vorsamni', number + ' vorsam'],
        };
        return isFuture ? format[key][0] : format[key][1];
    }

    var gomLatn = moment.defineLocale('gom-latn', {
        months: {
            standalone:
                'Janer_Febrer_Mars_Abril_Mai_Jun_Julai_Agost_Setembr_Otubr_Novembr_Dezembr'.split(
                    '_'
                ),
            format: 'Janerachea_Febrerachea_Marsachea_Abrilachea_Maiachea_Junachea_Julaiachea_Agostachea_Setembrachea_Otubrachea_Novembrachea_Dezembrachea'.split(
                '_'
            ),
            isFormat: /MMMM(\s)+D[oD]?/,
        },
        monthsShort:
            'Jan._Feb._Mars_Abr._Mai_Jun_Jul._Ago._Set._Otu._Nov._Dez.'.split('_'),
        monthsParseExact: true,
        weekdays: "Aitar_Somar_Mongllar_Budhvar_Birestar_Sukrar_Son'var".split('_'),
        weekdaysShort: 'Ait._Som._Mon._Bud._Bre._Suk._Son.'.split('_'),
        weekdaysMin: 'Ai_Sm_Mo_Bu_Br_Su_Sn'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'A h:mm [vazta]',
            LTS: 'A h:mm:ss [vazta]',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY A h:mm [vazta]',
            LLLL: 'dddd, MMMM Do, YYYY, A h:mm [vazta]',
            llll: 'ddd, D MMM YYYY, A h:mm [vazta]',
        },
        calendar: {
            sameDay: '[Aiz] LT',
            nextDay: '[Faleam] LT',
            nextWeek: '[Fuddlo] dddd[,] LT',
            lastDay: '[Kal] LT',
            lastWeek: '[Fattlo] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s',
            past: '%s adim',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}(er)/,
        ordinal: function (number, period) {
            switch (period) {
                // the ordinal 'er' only applies to day of the month
                case 'D':
                    return number + 'er';
                default:
                case 'M':
                case 'Q':
                case 'DDD':
                case 'd':
                case 'w':
                case 'W':
                    return number;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week
            doy: 3, // The week that contains Jan 4th is the first week of the year (7 + 0 - 4)
        },
        meridiemParse: /rati|sokallim|donparam|sanje/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'rati') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'sokallim') {
                return hour;
            } else if (meridiem === 'donparam') {
                return hour > 12 ? hour : hour + 12;
            } else if (meridiem === 'sanje') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'rati';
            } else if (hour < 12) {
                return 'sokallim';
            } else if (hour < 16) {
                return 'donparam';
            } else if (hour < 20) {
                return 'sanje';
            } else {
                return 'rati';
            }
        },
    });

    return gomLatn;

})));


/***/ }),

/***/ 5349:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Gujarati [gu]
//! author : Kaushik Thanki : https://github.com/Kaushik1987

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '૧',
            2: '૨',
            3: '૩',
            4: '૪',
            5: '૫',
            6: '૬',
            7: '૭',
            8: '૮',
            9: '૯',
            0: '૦',
        },
        numberMap = {
            '૧': '1',
            '૨': '2',
            '૩': '3',
            '૪': '4',
            '૫': '5',
            '૬': '6',
            '૭': '7',
            '૮': '8',
            '૯': '9',
            '૦': '0',
        };

    var gu = moment.defineLocale('gu', {
        months: 'જાન્યુઆરી_ફેબ્રુઆરી_માર્ચ_એપ્રિલ_મે_જૂન_જુલાઈ_ઑગસ્ટ_સપ્ટેમ્બર_ઑક્ટ્બર_નવેમ્બર_ડિસેમ્બર'.split(
            '_'
        ),
        monthsShort:
            'જાન્યુ._ફેબ્રુ._માર્ચ_એપ્રિ._મે_જૂન_જુલા._ઑગ._સપ્ટે._ઑક્ટ્._નવે._ડિસે.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'રવિવાર_સોમવાર_મંગળવાર_બુધ્વાર_ગુરુવાર_શુક્રવાર_શનિવાર'.split(
            '_'
        ),
        weekdaysShort: 'રવિ_સોમ_મંગળ_બુધ્_ગુરુ_શુક્ર_શનિ'.split('_'),
        weekdaysMin: 'ર_સો_મં_બુ_ગુ_શુ_શ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm વાગ્યે',
            LTS: 'A h:mm:ss વાગ્યે',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm વાગ્યે',
            LLLL: 'dddd, D MMMM YYYY, A h:mm વાગ્યે',
        },
        calendar: {
            sameDay: '[આજ] LT',
            nextDay: '[કાલે] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ગઇકાલે] LT',
            lastWeek: '[પાછલા] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s મા',
            past: '%s પહેલા',
            s: 'અમુક પળો',
            ss: '%d સેકંડ',
            m: 'એક મિનિટ',
            mm: '%d મિનિટ',
            h: 'એક કલાક',
            hh: '%d કલાક',
            d: 'એક દિવસ',
            dd: '%d દિવસ',
            M: 'એક મહિનો',
            MM: '%d મહિનો',
            y: 'એક વર્ષ',
            yy: '%d વર્ષ',
        },
        preparse: function (string) {
            return string.replace(/[૧૨૩૪૫૬૭૮૯૦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Gujarati notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Gujarati.
        meridiemParse: /રાત|બપોર|સવાર|સાંજ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'રાત') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'સવાર') {
                return hour;
            } else if (meridiem === 'બપોર') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'સાંજ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'રાત';
            } else if (hour < 10) {
                return 'સવાર';
            } else if (hour < 17) {
                return 'બપોર';
            } else if (hour < 20) {
                return 'સાંજ';
            } else {
                return 'રાત';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return gu;

})));


/***/ }),

/***/ 4206:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hebrew [he]
//! author : Tomer Cohen : https://github.com/tomer
//! author : Moshe Simantov : https://github.com/DevelopmentIL
//! author : Tal Ater : https://github.com/TalAter

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var he = moment.defineLocale('he', {
        months: 'ינואר_פברואר_מרץ_אפריל_מאי_יוני_יולי_אוגוסט_ספטמבר_אוקטובר_נובמבר_דצמבר'.split(
            '_'
        ),
        monthsShort:
            'ינו׳_פבר׳_מרץ_אפר׳_מאי_יוני_יולי_אוג׳_ספט׳_אוק׳_נוב׳_דצמ׳'.split('_'),
        weekdays: 'ראשון_שני_שלישי_רביעי_חמישי_שישי_שבת'.split('_'),
        weekdaysShort: 'א׳_ב׳_ג׳_ד׳_ה׳_ו׳_ש׳'.split('_'),
        weekdaysMin: 'א_ב_ג_ד_ה_ו_ש'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [ב]MMMM YYYY',
            LLL: 'D [ב]MMMM YYYY HH:mm',
            LLLL: 'dddd, D [ב]MMMM YYYY HH:mm',
            l: 'D/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[היום ב־]LT',
            nextDay: '[מחר ב־]LT',
            nextWeek: 'dddd [בשעה] LT',
            lastDay: '[אתמול ב־]LT',
            lastWeek: '[ביום] dddd [האחרון בשעה] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'בעוד %s',
            past: 'לפני %s',
            s: 'מספר שניות',
            ss: '%d שניות',
            m: 'דקה',
            mm: '%d דקות',
            h: 'שעה',
            hh: function (number) {
                if (number === 2) {
                    return 'שעתיים';
                }
                return number + ' שעות';
            },
            d: 'יום',
            dd: function (number) {
                if (number === 2) {
                    return 'יומיים';
                }
                return number + ' ימים';
            },
            M: 'חודש',
            MM: function (number) {
                if (number === 2) {
                    return 'חודשיים';
                }
                return number + ' חודשים';
            },
            y: 'שנה',
            yy: function (number) {
                if (number === 2) {
                    return 'שנתיים';
                } else if (number % 10 === 0 && number !== 10) {
                    return number + ' שנה';
                }
                return number + ' שנים';
            },
        },
        meridiemParse:
            /אחה"צ|לפנה"צ|אחרי הצהריים|לפני הצהריים|לפנות בוקר|בבוקר|בערב/i,
        isPM: function (input) {
            return /^(אחה"צ|אחרי הצהריים|בערב)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 5) {
                return 'לפנות בוקר';
            } else if (hour < 10) {
                return 'בבוקר';
            } else if (hour < 12) {
                return isLower ? 'לפנה"צ' : 'לפני הצהריים';
            } else if (hour < 18) {
                return isLower ? 'אחה"צ' : 'אחרי הצהריים';
            } else {
                return 'בערב';
            }
        },
    });

    return he;

})));


/***/ }),

/***/ 94:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hindi [hi]
//! author : Mayank Singhal : https://github.com/mayanksinghal

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        },
        monthsParse = [
            /^जन/i,
            /^फ़र|फर/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सितं|सित/i,
            /^अक्टू/i,
            /^नव|नवं/i,
            /^दिसं|दिस/i,
        ],
        shortMonthsParse = [
            /^जन/i,
            /^फ़र/i,
            /^मार्च/i,
            /^अप्रै/i,
            /^मई/i,
            /^जून/i,
            /^जुल/i,
            /^अग/i,
            /^सित/i,
            /^अक्टू/i,
            /^नव/i,
            /^दिस/i,
        ];

    var hi = moment.defineLocale('hi', {
        months: {
            format: 'जनवरी_फ़रवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितम्बर_अक्टूबर_नवम्बर_दिसम्बर'.split(
                '_'
            ),
            standalone:
                'जनवरी_फरवरी_मार्च_अप्रैल_मई_जून_जुलाई_अगस्त_सितंबर_अक्टूबर_नवंबर_दिसंबर'.split(
                    '_'
                ),
        },
        monthsShort:
            'जन._फ़र._मार्च_अप्रै._मई_जून_जुल._अग._सित._अक्टू._नव._दिस.'.split('_'),
        weekdays: 'रविवार_सोमवार_मंगलवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगल_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm बजे',
            LTS: 'A h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, A h:mm बजे',
        },

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: shortMonthsParse,

        monthsRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsShortRegex:
            /^(जनवरी|जन\.?|फ़रवरी|फरवरी|फ़र\.?|मार्च?|अप्रैल|अप्रै\.?|मई?|जून?|जुलाई|जुल\.?|अगस्त|अग\.?|सितम्बर|सितंबर|सित\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर|नव\.?|दिसम्बर|दिसंबर|दिस\.?)/i,

        monthsStrictRegex:
            /^(जनवरी?|फ़रवरी|फरवरी?|मार्च?|अप्रैल?|मई?|जून?|जुलाई?|अगस्त?|सितम्बर|सितंबर|सित?\.?|अक्टूबर|अक्टू\.?|नवम्बर|नवंबर?|दिसम्बर|दिसंबर?)/i,

        monthsShortStrictRegex:
            /^(जन\.?|फ़र\.?|मार्च?|अप्रै\.?|मई?|जून?|जुल\.?|अग\.?|सित\.?|अक्टू\.?|नव\.?|दिस\.?)/i,

        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[कल] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[कल] LT',
            lastWeek: '[पिछले] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s में',
            past: '%s पहले',
            s: 'कुछ ही क्षण',
            ss: '%d सेकंड',
            m: 'एक मिनट',
            mm: '%d मिनट',
            h: 'एक घंटा',
            hh: '%d घंटे',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महीने',
            MM: '%d महीने',
            y: 'एक वर्ष',
            yy: '%d वर्ष',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Hindi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Hindi.
        meridiemParse: /रात|सुबह|दोपहर|शाम/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'रात') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'सुबह') {
                return hour;
            } else if (meridiem === 'दोपहर') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'शाम') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'रात';
            } else if (hour < 10) {
                return 'सुबह';
            } else if (hour < 17) {
                return 'दोपहर';
            } else if (hour < 20) {
                return 'शाम';
            } else {
                return 'रात';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return hi;

})));


/***/ }),

/***/ 316:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Croatian [hr]
//! author : Bojan Marković : https://github.com/bmarkovic

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                if (number === 1) {
                    result += 'sekunda';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sekunde';
                } else {
                    result += 'sekundi';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'jedna minuta' : 'jedne minute';
            case 'mm':
                if (number === 1) {
                    result += 'minuta';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'minute';
                } else {
                    result += 'minuta';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'jedan sat' : 'jednog sata';
            case 'hh':
                if (number === 1) {
                    result += 'sat';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'sata';
                } else {
                    result += 'sati';
                }
                return result;
            case 'dd':
                if (number === 1) {
                    result += 'dan';
                } else {
                    result += 'dana';
                }
                return result;
            case 'MM':
                if (number === 1) {
                    result += 'mjesec';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'mjeseca';
                } else {
                    result += 'mjeseci';
                }
                return result;
            case 'yy':
                if (number === 1) {
                    result += 'godina';
                } else if (number === 2 || number === 3 || number === 4) {
                    result += 'godine';
                } else {
                    result += 'godina';
                }
                return result;
        }
    }

    var hr = moment.defineLocale('hr', {
        months: {
            format: 'siječnja_veljače_ožujka_travnja_svibnja_lipnja_srpnja_kolovoza_rujna_listopada_studenoga_prosinca'.split(
                '_'
            ),
            standalone:
                'siječanj_veljača_ožujak_travanj_svibanj_lipanj_srpanj_kolovoz_rujan_listopad_studeni_prosinac'.split(
                    '_'
                ),
        },
        monthsShort:
            'sij._velj._ožu._tra._svi._lip._srp._kol._ruj._lis._stu._pro.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'Do MMMM YYYY',
            LLL: 'Do MMMM YYYY H:mm',
            LLLL: 'dddd, Do MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[jučer u] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prošlu] [nedjelju] [u] LT';
                    case 3:
                        return '[prošlu] [srijedu] [u] LT';
                    case 6:
                        return '[prošle] [subote] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prošli] dddd [u] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'par sekundi',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: 'dan',
            dd: translate,
            M: 'mjesec',
            MM: translate,
            y: 'godinu',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hr;

})));


/***/ }),

/***/ 2138:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Hungarian [hu]
//! author : Adam Brunner : https://github.com/adambrunner
//! author : Peter Viszt  : https://github.com/passatgt

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var weekEndings =
        'vasárnap hétfőn kedden szerdán csütörtökön pénteken szombaton'.split(' ');
    function translate(number, withoutSuffix, key, isFuture) {
        var num = number;
        switch (key) {
            case 's':
                return isFuture || withoutSuffix
                    ? 'néhány másodperc'
                    : 'néhány másodperce';
            case 'ss':
                return num + (isFuture || withoutSuffix)
                    ? ' másodperc'
                    : ' másodperce';
            case 'm':
                return 'egy' + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'mm':
                return num + (isFuture || withoutSuffix ? ' perc' : ' perce');
            case 'h':
                return 'egy' + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'hh':
                return num + (isFuture || withoutSuffix ? ' óra' : ' órája');
            case 'd':
                return 'egy' + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'dd':
                return num + (isFuture || withoutSuffix ? ' nap' : ' napja');
            case 'M':
                return 'egy' + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'MM':
                return num + (isFuture || withoutSuffix ? ' hónap' : ' hónapja');
            case 'y':
                return 'egy' + (isFuture || withoutSuffix ? ' év' : ' éve');
            case 'yy':
                return num + (isFuture || withoutSuffix ? ' év' : ' éve');
        }
        return '';
    }
    function week(isFuture) {
        return (
            (isFuture ? '' : '[múlt] ') +
            '[' +
            weekEndings[this.day()] +
            '] LT[-kor]'
        );
    }

    var hu = moment.defineLocale('hu', {
        months: 'január_február_március_április_május_június_július_augusztus_szeptember_október_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._márc._ápr._máj._jún._júl._aug._szept._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'vasárnap_hétfő_kedd_szerda_csütörtök_péntek_szombat'.split('_'),
        weekdaysShort: 'vas_hét_kedd_sze_csüt_pén_szo'.split('_'),
        weekdaysMin: 'v_h_k_sze_cs_p_szo'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY. MMMM D.',
            LLL: 'YYYY. MMMM D. H:mm',
            LLLL: 'YYYY. MMMM D., dddd H:mm',
        },
        meridiemParse: /de|du/i,
        isPM: function (input) {
            return input.charAt(1).toLowerCase() === 'u';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower === true ? 'de' : 'DE';
            } else {
                return isLower === true ? 'du' : 'DU';
            }
        },
        calendar: {
            sameDay: '[ma] LT[-kor]',
            nextDay: '[holnap] LT[-kor]',
            nextWeek: function () {
                return week.call(this, true);
            },
            lastDay: '[tegnap] LT[-kor]',
            lastWeek: function () {
                return week.call(this, false);
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s múlva',
            past: '%s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return hu;

})));


/***/ }),

/***/ 1423:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Armenian [hy-am]
//! author : Armendarabyan : https://github.com/armendarabyan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var hyAm = moment.defineLocale('hy-am', {
        months: {
            format: 'հունվարի_փետրվարի_մարտի_ապրիլի_մայիսի_հունիսի_հուլիսի_օգոստոսի_սեպտեմբերի_հոկտեմբերի_նոյեմբերի_դեկտեմբերի'.split(
                '_'
            ),
            standalone:
                'հունվար_փետրվար_մարտ_ապրիլ_մայիս_հունիս_հուլիս_օգոստոս_սեպտեմբեր_հոկտեմբեր_նոյեմբեր_դեկտեմբեր'.split(
                    '_'
                ),
        },
        monthsShort: 'հնվ_փտր_մրտ_ապր_մյս_հնս_հլս_օգս_սպտ_հկտ_նմբ_դկտ'.split('_'),
        weekdays:
            'կիրակի_երկուշաբթի_երեքշաբթի_չորեքշաբթի_հինգշաբթի_ուրբաթ_շաբաթ'.split(
                '_'
            ),
        weekdaysShort: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        weekdaysMin: 'կրկ_երկ_երք_չրք_հնգ_ուրբ_շբթ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY թ.',
            LLL: 'D MMMM YYYY թ., HH:mm',
            LLLL: 'dddd, D MMMM YYYY թ., HH:mm',
        },
        calendar: {
            sameDay: '[այսօր] LT',
            nextDay: '[վաղը] LT',
            lastDay: '[երեկ] LT',
            nextWeek: function () {
                return 'dddd [օրը ժամը] LT';
            },
            lastWeek: function () {
                return '[անցած] dddd [օրը ժամը] LT';
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s հետո',
            past: '%s առաջ',
            s: 'մի քանի վայրկյան',
            ss: '%d վայրկյան',
            m: 'րոպե',
            mm: '%d րոպե',
            h: 'ժամ',
            hh: '%d ժամ',
            d: 'օր',
            dd: '%d օր',
            M: 'ամիս',
            MM: '%d ամիս',
            y: 'տարի',
            yy: '%d տարի',
        },
        meridiemParse: /գիշերվա|առավոտվա|ցերեկվա|երեկոյան/,
        isPM: function (input) {
            return /^(ցերեկվա|երեկոյան)$/.test(input);
        },
        meridiem: function (hour) {
            if (hour < 4) {
                return 'գիշերվա';
            } else if (hour < 12) {
                return 'առավոտվա';
            } else if (hour < 17) {
                return 'ցերեկվա';
            } else {
                return 'երեկոյան';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}|\d{1,2}-(ին|րդ)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'DDD':
                case 'w':
                case 'W':
                case 'DDDo':
                    if (number === 1) {
                        return number + '-ին';
                    }
                    return number + '-րդ';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return hyAm;

})));


/***/ }),

/***/ 9218:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Indonesian [id]
//! author : Mohammad Satrio Utomo : https://github.com/tyok
//! reference: http://id.wikisource.org/wiki/Pedoman_Umum_Ejaan_Bahasa_Indonesia_yang_Disempurnakan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var id = moment.defineLocale('id', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_November_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Agt_Sep_Okt_Nov_Des'.split('_'),
        weekdays: 'Minggu_Senin_Selasa_Rabu_Kamis_Jumat_Sabtu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Rab_Kam_Jum_Sab'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|siang|sore|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'siang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sore' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'siang';
            } else if (hours < 19) {
                return 'sore';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Besok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kemarin pukul] LT',
            lastWeek: 'dddd [lalu pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lalu',
            s: 'beberapa detik',
            ss: '%d detik',
            m: 'semenit',
            mm: '%d menit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return id;

})));


/***/ }),

/***/ 135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Icelandic [is]
//! author : Hinrik Örn Sigurðsson : https://github.com/hinrik

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(n) {
        if (n % 100 === 11) {
            return true;
        } else if (n % 10 === 1) {
            return false;
        }
        return true;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nokkrar sekúndur'
                    : 'nokkrum sekúndum';
            case 'ss':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture ? 'sekúndur' : 'sekúndum')
                    );
                }
                return result + 'sekúnda';
            case 'm':
                return withoutSuffix ? 'mínúta' : 'mínútu';
            case 'mm':
                if (plural(number)) {
                    return (
                        result + (withoutSuffix || isFuture ? 'mínútur' : 'mínútum')
                    );
                } else if (withoutSuffix) {
                    return result + 'mínúta';
                }
                return result + 'mínútu';
            case 'hh':
                if (plural(number)) {
                    return (
                        result +
                        (withoutSuffix || isFuture
                            ? 'klukkustundir'
                            : 'klukkustundum')
                    );
                }
                return result + 'klukkustund';
            case 'd':
                if (withoutSuffix) {
                    return 'dagur';
                }
                return isFuture ? 'dag' : 'degi';
            case 'dd':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'dagar';
                    }
                    return result + (isFuture ? 'daga' : 'dögum');
                } else if (withoutSuffix) {
                    return result + 'dagur';
                }
                return result + (isFuture ? 'dag' : 'degi');
            case 'M':
                if (withoutSuffix) {
                    return 'mánuður';
                }
                return isFuture ? 'mánuð' : 'mánuði';
            case 'MM':
                if (plural(number)) {
                    if (withoutSuffix) {
                        return result + 'mánuðir';
                    }
                    return result + (isFuture ? 'mánuði' : 'mánuðum');
                } else if (withoutSuffix) {
                    return result + 'mánuður';
                }
                return result + (isFuture ? 'mánuð' : 'mánuði');
            case 'y':
                return withoutSuffix || isFuture ? 'ár' : 'ári';
            case 'yy':
                if (plural(number)) {
                    return result + (withoutSuffix || isFuture ? 'ár' : 'árum');
                }
                return result + (withoutSuffix || isFuture ? 'ár' : 'ári');
        }
    }

    var is = moment.defineLocale('is', {
        months: 'janúar_febrúar_mars_apríl_maí_júní_júlí_ágúst_september_október_nóvember_desember'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maí_jún_júl_ágú_sep_okt_nóv_des'.split('_'),
        weekdays:
            'sunnudagur_mánudagur_þriðjudagur_miðvikudagur_fimmtudagur_föstudagur_laugardagur'.split(
                '_'
            ),
        weekdaysShort: 'sun_mán_þri_mið_fim_fös_lau'.split('_'),
        weekdaysMin: 'Su_Má_Þr_Mi_Fi_Fö_La'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd, D. MMMM YYYY [kl.] H:mm',
        },
        calendar: {
            sameDay: '[í dag kl.] LT',
            nextDay: '[á morgun kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[í gær kl.] LT',
            lastWeek: '[síðasta] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'eftir %s',
            past: 'fyrir %s síðan',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: 'klukkustund',
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return is;

})));


/***/ }),

/***/ 150:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian (Switzerland) [it-ch]
//! author : xfh : https://github.com/xfh

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var itCh = moment.defineLocale('it-ch', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Oggi alle] LT',
            nextDay: '[Domani alle] LT',
            nextWeek: 'dddd [alle] LT',
            lastDay: '[Ieri alle] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[la scorsa] dddd [alle] LT';
                    default:
                        return '[lo scorso] dddd [alle] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return (/^[0-9].+$/.test(s) ? 'tra' : 'in') + ' ' + s;
            },
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return itCh;

})));


/***/ }),

/***/ 626:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Italian [it]
//! author : Lorenzo : https://github.com/aliem
//! author: Mattia Larentis: https://github.com/nostalgiaz
//! author: Marco : https://github.com/Manfre98

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var it = moment.defineLocale('it', {
        months: 'gennaio_febbraio_marzo_aprile_maggio_giugno_luglio_agosto_settembre_ottobre_novembre_dicembre'.split(
            '_'
        ),
        monthsShort: 'gen_feb_mar_apr_mag_giu_lug_ago_set_ott_nov_dic'.split('_'),
        weekdays: 'domenica_lunedì_martedì_mercoledì_giovedì_venerdì_sabato'.split(
            '_'
        ),
        weekdaysShort: 'dom_lun_mar_mer_gio_ven_sab'.split('_'),
        weekdaysMin: 'do_lu_ma_me_gi_ve_sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: function () {
                return (
                    '[Oggi a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextDay: function () {
                return (
                    '[Domani a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            nextWeek: function () {
                return (
                    'dddd [a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastDay: function () {
                return (
                    '[Ieri a' +
                    (this.hours() > 1 ? 'lle ' : this.hours() === 0 ? ' ' : "ll'") +
                    ']LT'
                );
            },
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return (
                            '[La scorsa] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                    default:
                        return (
                            '[Lo scorso] dddd [a' +
                            (this.hours() > 1
                                ? 'lle '
                                : this.hours() === 0
                                ? ' '
                                : "ll'") +
                            ']LT'
                        );
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'tra %s',
            past: '%s fa',
            s: 'alcuni secondi',
            ss: '%d secondi',
            m: 'un minuto',
            mm: '%d minuti',
            h: "un'ora",
            hh: '%d ore',
            d: 'un giorno',
            dd: '%d giorni',
            w: 'una settimana',
            ww: '%d settimane',
            M: 'un mese',
            MM: '%d mesi',
            y: 'un anno',
            yy: '%d anni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return it;

})));


/***/ }),

/***/ 9183:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Japanese [ja]
//! author : LI Long : https://github.com/baryon

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ja = moment.defineLocale('ja', {
        eras: [
            {
                since: '2019-05-01',
                offset: 1,
                name: '令和',
                narrow: '㋿',
                abbr: 'R',
            },
            {
                since: '1989-01-08',
                until: '2019-04-30',
                offset: 1,
                name: '平成',
                narrow: '㍻',
                abbr: 'H',
            },
            {
                since: '1926-12-25',
                until: '1989-01-07',
                offset: 1,
                name: '昭和',
                narrow: '㍼',
                abbr: 'S',
            },
            {
                since: '1912-07-30',
                until: '1926-12-24',
                offset: 1,
                name: '大正',
                narrow: '㍽',
                abbr: 'T',
            },
            {
                since: '1873-01-01',
                until: '1912-07-29',
                offset: 6,
                name: '明治',
                narrow: '㍾',
                abbr: 'M',
            },
            {
                since: '0001-01-01',
                until: '1873-12-31',
                offset: 1,
                name: '西暦',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: '紀元前',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        eraYearOrdinalRegex: /(元|\d+)年/,
        eraYearOrdinalParse: function (input, match) {
            return match[1] === '元' ? 1 : parseInt(match[1] || input, 10);
        },
        months: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split('_'),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '日曜日_月曜日_火曜日_水曜日_木曜日_金曜日_土曜日'.split('_'),
        weekdaysShort: '日_月_火_水_木_金_土'.split('_'),
        weekdaysMin: '日_月_火_水_木_金_土'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日 dddd HH:mm',
            l: 'YYYY/MM/DD',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日(ddd) HH:mm',
        },
        meridiemParse: /午前|午後/i,
        isPM: function (input) {
            return input === '午後';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return '午前';
            } else {
                return '午後';
            }
        },
        calendar: {
            sameDay: '[今日] LT',
            nextDay: '[明日] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[来週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            lastDay: '[昨日] LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[先週]dddd LT';
                } else {
                    return 'dddd LT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}日/,
        ordinal: function (number, period) {
            switch (period) {
                case 'y':
                    return number === 1 ? '元年' : number + '年';
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '数秒',
            ss: '%d秒',
            m: '1分',
            mm: '%d分',
            h: '1時間',
            hh: '%d時間',
            d: '1日',
            dd: '%d日',
            M: '1ヶ月',
            MM: '%dヶ月',
            y: '1年',
            yy: '%d年',
        },
    });

    return ja;

})));


/***/ }),

/***/ 4286:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Javanese [jv]
//! author : Rony Lantip : https://github.com/lantip
//! reference: http://jv.wikipedia.org/wiki/Basa_Jawa

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var jv = moment.defineLocale('jv', {
        months: 'Januari_Februari_Maret_April_Mei_Juni_Juli_Agustus_September_Oktober_Nopember_Desember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mar_Apr_Mei_Jun_Jul_Ags_Sep_Okt_Nop_Des'.split('_'),
        weekdays: 'Minggu_Senen_Seloso_Rebu_Kemis_Jemuwah_Septu'.split('_'),
        weekdaysShort: 'Min_Sen_Sel_Reb_Kem_Jem_Sep'.split('_'),
        weekdaysMin: 'Mg_Sn_Sl_Rb_Km_Jm_Sp'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /enjing|siyang|sonten|ndalu/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'enjing') {
                return hour;
            } else if (meridiem === 'siyang') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'sonten' || meridiem === 'ndalu') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'enjing';
            } else if (hours < 15) {
                return 'siyang';
            } else if (hours < 19) {
                return 'sonten';
            } else {
                return 'ndalu';
            }
        },
        calendar: {
            sameDay: '[Dinten puniko pukul] LT',
            nextDay: '[Mbenjang pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kala wingi pukul] LT',
            lastWeek: 'dddd [kepengker pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'wonten ing %s',
            past: '%s ingkang kepengker',
            s: 'sawetawis detik',
            ss: '%d detik',
            m: 'setunggal menit',
            mm: '%d menit',
            h: 'setunggal jam',
            hh: '%d jam',
            d: 'sedinten',
            dd: '%d dinten',
            M: 'sewulan',
            MM: '%d wulan',
            y: 'setaun',
            yy: '%d taun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return jv;

})));


/***/ }),

/***/ 2105:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Georgian [ka]
//! author : Irakli Janiashvili : https://github.com/IrakliJani

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ka = moment.defineLocale('ka', {
        months: 'იანვარი_თებერვალი_მარტი_აპრილი_მაისი_ივნისი_ივლისი_აგვისტო_სექტემბერი_ოქტომბერი_ნოემბერი_დეკემბერი'.split(
            '_'
        ),
        monthsShort: 'იან_თებ_მარ_აპრ_მაი_ივნ_ივლ_აგვ_სექ_ოქტ_ნოე_დეკ'.split('_'),
        weekdays: {
            standalone:
                'კვირა_ორშაბათი_სამშაბათი_ოთხშაბათი_ხუთშაბათი_პარასკევი_შაბათი'.split(
                    '_'
                ),
            format: 'კვირას_ორშაბათს_სამშაბათს_ოთხშაბათს_ხუთშაბათს_პარასკევს_შაბათს'.split(
                '_'
            ),
            isFormat: /(წინა|შემდეგ)/,
        },
        weekdaysShort: 'კვი_ორშ_სამ_ოთხ_ხუთ_პარ_შაბ'.split('_'),
        weekdaysMin: 'კვ_ორ_სა_ოთ_ხუ_პა_შა'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[დღეს] LT[-ზე]',
            nextDay: '[ხვალ] LT[-ზე]',
            lastDay: '[გუშინ] LT[-ზე]',
            nextWeek: '[შემდეგ] dddd LT[-ზე]',
            lastWeek: '[წინა] dddd LT-ზე',
            sameElse: 'L',
        },
        relativeTime: {
            future: function (s) {
                return s.replace(
                    /(წამ|წუთ|საათ|წელ|დღ|თვ)(ი|ე)/,
                    function ($0, $1, $2) {
                        return $2 === 'ი' ? $1 + 'ში' : $1 + $2 + 'ში';
                    }
                );
            },
            past: function (s) {
                if (/(წამი|წუთი|საათი|დღე|თვე)/.test(s)) {
                    return s.replace(/(ი|ე)$/, 'ის წინ');
                }
                if (/წელი/.test(s)) {
                    return s.replace(/წელი$/, 'წლის წინ');
                }
                return s;
            },
            s: 'რამდენიმე წამი',
            ss: '%d წამი',
            m: 'წუთი',
            mm: '%d წუთი',
            h: 'საათი',
            hh: '%d საათი',
            d: 'დღე',
            dd: '%d დღე',
            M: 'თვე',
            MM: '%d თვე',
            y: 'წელი',
            yy: '%d წელი',
        },
        dayOfMonthOrdinalParse: /0|1-ლი|მე-\d{1,2}|\d{1,2}-ე/,
        ordinal: function (number) {
            if (number === 0) {
                return number;
            }
            if (number === 1) {
                return number + '-ლი';
            }
            if (
                number < 20 ||
                (number <= 100 && number % 20 === 0) ||
                number % 100 === 0
            ) {
                return 'მე-' + number;
            }
            return number + '-ე';
        },
        week: {
            dow: 1,
            doy: 7,
        },
    });

    return ka;

})));


/***/ }),

/***/ 7772:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kazakh [kk]
//! authors : Nurlan Rakhimzhanov : https://github.com/nurlan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ші',
        1: '-ші',
        2: '-ші',
        3: '-ші',
        4: '-ші',
        5: '-ші',
        6: '-шы',
        7: '-ші',
        8: '-ші',
        9: '-шы',
        10: '-шы',
        20: '-шы',
        30: '-шы',
        40: '-шы',
        50: '-ші',
        60: '-шы',
        70: '-ші',
        80: '-ші',
        90: '-шы',
        100: '-ші',
    };

    var kk = moment.defineLocale('kk', {
        months: 'қаңтар_ақпан_наурыз_сәуір_мамыр_маусым_шілде_тамыз_қыркүйек_қазан_қараша_желтоқсан'.split(
            '_'
        ),
        monthsShort: 'қаң_ақп_нау_сәу_мам_мау_шіл_там_қыр_қаз_қар_жел'.split('_'),
        weekdays: 'жексенбі_дүйсенбі_сейсенбі_сәрсенбі_бейсенбі_жұма_сенбі'.split(
            '_'
        ),
        weekdaysShort: 'жек_дүй_сей_сәр_бей_жұм_сен'.split('_'),
        weekdaysMin: 'жк_дй_сй_ср_бй_жм_сн'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгін сағат] LT',
            nextDay: '[Ертең сағат] LT',
            nextWeek: 'dddd [сағат] LT',
            lastDay: '[Кеше сағат] LT',
            lastWeek: '[Өткен аптаның] dddd [сағат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ішінде',
            past: '%s бұрын',
            s: 'бірнеше секунд',
            ss: '%d секунд',
            m: 'бір минут',
            mm: '%d минут',
            h: 'бір сағат',
            hh: '%d сағат',
            d: 'бір күн',
            dd: '%d күн',
            M: 'бір ай',
            MM: '%d ай',
            y: 'бір жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ші|шы)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return kk;

})));


/***/ }),

/***/ 8758:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Cambodian [km]
//! author : Kruy Vanna : https://github.com/kruyvanna

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '១',
            2: '២',
            3: '៣',
            4: '៤',
            5: '៥',
            6: '៦',
            7: '៧',
            8: '៨',
            9: '៩',
            0: '០',
        },
        numberMap = {
            '១': '1',
            '២': '2',
            '៣': '3',
            '៤': '4',
            '៥': '5',
            '៦': '6',
            '៧': '7',
            '៨': '8',
            '៩': '9',
            '០': '0',
        };

    var km = moment.defineLocale('km', {
        months: 'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
            '_'
        ),
        monthsShort:
            'មករា_កុម្ភៈ_មីនា_មេសា_ឧសភា_មិថុនា_កក្កដា_សីហា_កញ្ញា_តុលា_វិច្ឆិកា_ធ្នូ'.split(
                '_'
            ),
        weekdays: 'អាទិត្យ_ច័ន្ទ_អង្គារ_ពុធ_ព្រហស្បតិ៍_សុក្រ_សៅរ៍'.split('_'),
        weekdaysShort: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysMin: 'អា_ច_អ_ព_ព្រ_សុ_ស'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ព្រឹក|ល្ងាច/,
        isPM: function (input) {
            return input === 'ល្ងាច';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ព្រឹក';
            } else {
                return 'ល្ងាច';
            }
        },
        calendar: {
            sameDay: '[ថ្ងៃនេះ ម៉ោង] LT',
            nextDay: '[ស្អែក ម៉ោង] LT',
            nextWeek: 'dddd [ម៉ោង] LT',
            lastDay: '[ម្សិលមិញ ម៉ោង] LT',
            lastWeek: 'dddd [សប្តាហ៍មុន] [ម៉ោង] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sទៀត',
            past: '%sមុន',
            s: 'ប៉ុន្មានវិនាទី',
            ss: '%d វិនាទី',
            m: 'មួយនាទី',
            mm: '%d នាទី',
            h: 'មួយម៉ោង',
            hh: '%d ម៉ោង',
            d: 'មួយថ្ងៃ',
            dd: '%d ថ្ងៃ',
            M: 'មួយខែ',
            MM: '%d ខែ',
            y: 'មួយឆ្នាំ',
            yy: '%d ឆ្នាំ',
        },
        dayOfMonthOrdinalParse: /ទី\d{1,2}/,
        ordinal: 'ទី%d',
        preparse: function (string) {
            return string.replace(/[១២៣៤៥៦៧៨៩០]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return km;

})));


/***/ }),

/***/ 9282:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kannada [kn]
//! author : Rajeev Naik : https://github.com/rajeevnaikte

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '೧',
            2: '೨',
            3: '೩',
            4: '೪',
            5: '೫',
            6: '೬',
            7: '೭',
            8: '೮',
            9: '೯',
            0: '೦',
        },
        numberMap = {
            '೧': '1',
            '೨': '2',
            '೩': '3',
            '೪': '4',
            '೫': '5',
            '೬': '6',
            '೭': '7',
            '೮': '8',
            '೯': '9',
            '೦': '0',
        };

    var kn = moment.defineLocale('kn', {
        months: 'ಜನವರಿ_ಫೆಬ್ರವರಿ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂಬರ್_ಅಕ್ಟೋಬರ್_ನವೆಂಬರ್_ಡಿಸೆಂಬರ್'.split(
            '_'
        ),
        monthsShort:
            'ಜನ_ಫೆಬ್ರ_ಮಾರ್ಚ್_ಏಪ್ರಿಲ್_ಮೇ_ಜೂನ್_ಜುಲೈ_ಆಗಸ್ಟ್_ಸೆಪ್ಟೆಂ_ಅಕ್ಟೋ_ನವೆಂ_ಡಿಸೆಂ'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'ಭಾನುವಾರ_ಸೋಮವಾರ_ಮಂಗಳವಾರ_ಬುಧವಾರ_ಗುರುವಾರ_ಶುಕ್ರವಾರ_ಶನಿವಾರ'.split(
            '_'
        ),
        weekdaysShort: 'ಭಾನು_ಸೋಮ_ಮಂಗಳ_ಬುಧ_ಗುರು_ಶುಕ್ರ_ಶನಿ'.split('_'),
        weekdaysMin: 'ಭಾ_ಸೋ_ಮಂ_ಬು_ಗು_ಶು_ಶ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[ಇಂದು] LT',
            nextDay: '[ನಾಳೆ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ನಿನ್ನೆ] LT',
            lastWeek: '[ಕೊನೆಯ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ನಂತರ',
            past: '%s ಹಿಂದೆ',
            s: 'ಕೆಲವು ಕ್ಷಣಗಳು',
            ss: '%d ಸೆಕೆಂಡುಗಳು',
            m: 'ಒಂದು ನಿಮಿಷ',
            mm: '%d ನಿಮಿಷ',
            h: 'ಒಂದು ಗಂಟೆ',
            hh: '%d ಗಂಟೆ',
            d: 'ಒಂದು ದಿನ',
            dd: '%d ದಿನ',
            M: 'ಒಂದು ತಿಂಗಳು',
            MM: '%d ತಿಂಗಳು',
            y: 'ಒಂದು ವರ್ಷ',
            yy: '%d ವರ್ಷ',
        },
        preparse: function (string) {
            return string.replace(/[೧೨೩೪೫೬೭೮೯೦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /ರಾತ್ರಿ|ಬೆಳಿಗ್ಗೆ|ಮಧ್ಯಾಹ್ನ|ಸಂಜೆ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ರಾತ್ರಿ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ಬೆಳಿಗ್ಗೆ') {
                return hour;
            } else if (meridiem === 'ಮಧ್ಯಾಹ್ನ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ಸಂಜೆ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ರಾತ್ರಿ';
            } else if (hour < 10) {
                return 'ಬೆಳಿಗ್ಗೆ';
            } else if (hour < 17) {
                return 'ಮಧ್ಯಾಹ್ನ';
            } else if (hour < 20) {
                return 'ಸಂಜೆ';
            } else {
                return 'ರಾತ್ರಿ';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ನೇ)/,
        ordinal: function (number) {
            return number + 'ನೇ';
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return kn;

})));


/***/ }),

/***/ 3730:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Korean [ko]
//! author : Kyungwook, Park : https://github.com/kyungw00k
//! author : Jeeeyul Lee <jeeeyul@gmail.com>

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ko = moment.defineLocale('ko', {
        months: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split('_'),
        monthsShort: '1월_2월_3월_4월_5월_6월_7월_8월_9월_10월_11월_12월'.split(
            '_'
        ),
        weekdays: '일요일_월요일_화요일_수요일_목요일_금요일_토요일'.split('_'),
        weekdaysShort: '일_월_화_수_목_금_토'.split('_'),
        weekdaysMin: '일_월_화_수_목_금_토'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'YYYY.MM.DD.',
            LL: 'YYYY년 MMMM D일',
            LLL: 'YYYY년 MMMM D일 A h:mm',
            LLLL: 'YYYY년 MMMM D일 dddd A h:mm',
            l: 'YYYY.MM.DD.',
            ll: 'YYYY년 MMMM D일',
            lll: 'YYYY년 MMMM D일 A h:mm',
            llll: 'YYYY년 MMMM D일 dddd A h:mm',
        },
        calendar: {
            sameDay: '오늘 LT',
            nextDay: '내일 LT',
            nextWeek: 'dddd LT',
            lastDay: '어제 LT',
            lastWeek: '지난주 dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s 후',
            past: '%s 전',
            s: '몇 초',
            ss: '%d초',
            m: '1분',
            mm: '%d분',
            h: '한 시간',
            hh: '%d시간',
            d: '하루',
            dd: '%d일',
            M: '한 달',
            MM: '%d달',
            y: '일 년',
            yy: '%d년',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(일|월|주)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '일';
                case 'M':
                    return number + '월';
                case 'w':
                case 'W':
                    return number + '주';
                default:
                    return number;
            }
        },
        meridiemParse: /오전|오후/,
        isPM: function (token) {
            return token === '오후';
        },
        meridiem: function (hour, minute, isUpper) {
            return hour < 12 ? '오전' : '오후';
        },
    });

    return ko;

})));


/***/ }),

/***/ 1408:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kurdish [ku]
//! author : Shahram Mebashar : https://github.com/ShahramMebashar

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '١',
            2: '٢',
            3: '٣',
            4: '٤',
            5: '٥',
            6: '٦',
            7: '٧',
            8: '٨',
            9: '٩',
            0: '٠',
        },
        numberMap = {
            '١': '1',
            '٢': '2',
            '٣': '3',
            '٤': '4',
            '٥': '5',
            '٦': '6',
            '٧': '7',
            '٨': '8',
            '٩': '9',
            '٠': '0',
        },
        months = [
            'کانونی دووەم',
            'شوبات',
            'ئازار',
            'نیسان',
            'ئایار',
            'حوزەیران',
            'تەمموز',
            'ئاب',
            'ئەیلوول',
            'تشرینی یەكەم',
            'تشرینی دووەم',
            'كانونی یەکەم',
        ];

    var ku = moment.defineLocale('ku', {
        months: months,
        monthsShort: months,
        weekdays:
            'یه‌كشه‌ممه‌_دووشه‌ممه‌_سێشه‌ممه‌_چوارشه‌ممه‌_پێنجشه‌ممه‌_هه‌ینی_شه‌ممه‌'.split(
                '_'
            ),
        weekdaysShort:
            'یه‌كشه‌م_دووشه‌م_سێشه‌م_چوارشه‌م_پێنجشه‌م_هه‌ینی_شه‌ممه‌'.split('_'),
        weekdaysMin: 'ی_د_س_چ_پ_ه_ش'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        meridiemParse: /ئێواره‌|به‌یانی/,
        isPM: function (input) {
            return /ئێواره‌/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'به‌یانی';
            } else {
                return 'ئێواره‌';
            }
        },
        calendar: {
            sameDay: '[ئه‌مرۆ كاتژمێر] LT',
            nextDay: '[به‌یانی كاتژمێر] LT',
            nextWeek: 'dddd [كاتژمێر] LT',
            lastDay: '[دوێنێ كاتژمێر] LT',
            lastWeek: 'dddd [كاتژمێر] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'له‌ %s',
            past: '%s',
            s: 'چه‌ند چركه‌یه‌ك',
            ss: 'چركه‌ %d',
            m: 'یه‌ك خوله‌ك',
            mm: '%d خوله‌ك',
            h: 'یه‌ك كاتژمێر',
            hh: '%d كاتژمێر',
            d: 'یه‌ك ڕۆژ',
            dd: '%d ڕۆژ',
            M: 'یه‌ك مانگ',
            MM: '%d مانگ',
            y: 'یه‌ك ساڵ',
            yy: '%d ساڵ',
        },
        preparse: function (string) {
            return string
                .replace(/[١٢٣٤٥٦٧٨٩٠]/g, function (match) {
                    return numberMap[match];
                })
                .replace(/،/g, ',');
        },
        postformat: function (string) {
            return string
                .replace(/\d/g, function (match) {
                    return symbolMap[match];
                })
                .replace(/,/g, '،');
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return ku;

})));


/***/ }),

/***/ 3291:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Kyrgyz [ky]
//! author : Chyngyz Arystan uulu : https://github.com/chyngyz

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-чү',
        1: '-чи',
        2: '-чи',
        3: '-чү',
        4: '-чү',
        5: '-чи',
        6: '-чы',
        7: '-чи',
        8: '-чи',
        9: '-чу',
        10: '-чу',
        20: '-чы',
        30: '-чу',
        40: '-чы',
        50: '-чү',
        60: '-чы',
        70: '-чи',
        80: '-чи',
        90: '-чу',
        100: '-чү',
    };

    var ky = moment.defineLocale('ky', {
        months: 'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
            '_'
        ),
        monthsShort: 'янв_фев_март_апр_май_июнь_июль_авг_сен_окт_ноя_дек'.split(
            '_'
        ),
        weekdays: 'Жекшемби_Дүйшөмбү_Шейшемби_Шаршемби_Бейшемби_Жума_Ишемби'.split(
            '_'
        ),
        weekdaysShort: 'Жек_Дүй_Шей_Шар_Бей_Жум_Ише'.split('_'),
        weekdaysMin: 'Жк_Дй_Шй_Шр_Бй_Жм_Иш'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Бүгүн саат] LT',
            nextDay: '[Эртең саат] LT',
            nextWeek: 'dddd [саат] LT',
            lastDay: '[Кечээ саат] LT',
            lastWeek: '[Өткөн аптанын] dddd [күнү] [саат] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ичинде',
            past: '%s мурун',
            s: 'бирнече секунд',
            ss: '%d секунд',
            m: 'бир мүнөт',
            mm: '%d мүнөт',
            h: 'бир саат',
            hh: '%d саат',
            d: 'бир күн',
            dd: '%d күн',
            M: 'бир ай',
            MM: '%d ай',
            y: 'бир жыл',
            yy: '%d жыл',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(чи|чы|чү|чу)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ky;

})));


/***/ }),

/***/ 6841:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Luxembourgish [lb]
//! author : mweimerskirch : https://github.com/mweimerskirch
//! author : David Raison : https://github.com/kwisatz

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            m: ['eng Minutt', 'enger Minutt'],
            h: ['eng Stonn', 'enger Stonn'],
            d: ['een Dag', 'engem Dag'],
            M: ['ee Mount', 'engem Mount'],
            y: ['ee Joer', 'engem Joer'],
        };
        return withoutSuffix ? format[key][0] : format[key][1];
    }
    function processFutureTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'a ' + string;
        }
        return 'an ' + string;
    }
    function processPastTime(string) {
        var number = string.substr(0, string.indexOf(' '));
        if (eifelerRegelAppliesToNumber(number)) {
            return 'viru ' + string;
        }
        return 'virun ' + string;
    }
    /**
     * Returns true if the word before the given number loses the '-n' ending.
     * e.g. 'an 10 Deeg' but 'a 5 Deeg'
     *
     * @param number {integer}
     * @returns {boolean}
     */
    function eifelerRegelAppliesToNumber(number) {
        number = parseInt(number, 10);
        if (isNaN(number)) {
            return false;
        }
        if (number < 0) {
            // Negative Number --> always true
            return true;
        } else if (number < 10) {
            // Only 1 digit
            if (4 <= number && number <= 7) {
                return true;
            }
            return false;
        } else if (number < 100) {
            // 2 digits
            var lastDigit = number % 10,
                firstDigit = number / 10;
            if (lastDigit === 0) {
                return eifelerRegelAppliesToNumber(firstDigit);
            }
            return eifelerRegelAppliesToNumber(lastDigit);
        } else if (number < 10000) {
            // 3 or 4 digits --> recursively check first digit
            while (number >= 10) {
                number = number / 10;
            }
            return eifelerRegelAppliesToNumber(number);
        } else {
            // Anything larger than 4 digits: recursively check first n-3 digits
            number = number / 1000;
            return eifelerRegelAppliesToNumber(number);
        }
    }

    var lb = moment.defineLocale('lb', {
        months: 'Januar_Februar_Mäerz_Abrëll_Mee_Juni_Juli_August_September_Oktober_November_Dezember'.split(
            '_'
        ),
        monthsShort:
            'Jan._Febr._Mrz._Abr._Mee_Jun._Jul._Aug._Sept._Okt._Nov._Dez.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'Sonndeg_Méindeg_Dënschdeg_Mëttwoch_Donneschdeg_Freideg_Samschdeg'.split(
                '_'
            ),
        weekdaysShort: 'So._Mé._Dë._Më._Do._Fr._Sa.'.split('_'),
        weekdaysMin: 'So_Mé_Dë_Më_Do_Fr_Sa'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm [Auer]',
            LTS: 'H:mm:ss [Auer]',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm [Auer]',
            LLLL: 'dddd, D. MMMM YYYY H:mm [Auer]',
        },
        calendar: {
            sameDay: '[Haut um] LT',
            sameElse: 'L',
            nextDay: '[Muer um] LT',
            nextWeek: 'dddd [um] LT',
            lastDay: '[Gëschter um] LT',
            lastWeek: function () {
                // Different date string for 'Dënschdeg' (Tuesday) and 'Donneschdeg' (Thursday) due to phonological rule
                switch (this.day()) {
                    case 2:
                    case 4:
                        return '[Leschten] dddd [um] LT';
                    default:
                        return '[Leschte] dddd [um] LT';
                }
            },
        },
        relativeTime: {
            future: processFutureTime,
            past: processPastTime,
            s: 'e puer Sekonnen',
            ss: '%d Sekonnen',
            m: processRelativeTime,
            mm: '%d Minutten',
            h: processRelativeTime,
            hh: '%d Stonnen',
            d: processRelativeTime,
            dd: '%d Deeg',
            M: processRelativeTime,
            MM: '%d Méint',
            y: processRelativeTime,
            yy: '%d Joer',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lb;

})));


/***/ }),

/***/ 5466:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lao [lo]
//! author : Ryan Hart : https://github.com/ryanhart2

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var lo = moment.defineLocale('lo', {
        months: 'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
            '_'
        ),
        monthsShort:
            'ມັງກອນ_ກຸມພາ_ມີນາ_ເມສາ_ພຶດສະພາ_ມິຖຸນາ_ກໍລະກົດ_ສິງຫາ_ກັນຍາ_ຕຸລາ_ພະຈິກ_ທັນວາ'.split(
                '_'
            ),
        weekdays: 'ອາທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysShort: 'ທິດ_ຈັນ_ອັງຄານ_ພຸດ_ພະຫັດ_ສຸກ_ເສົາ'.split('_'),
        weekdaysMin: 'ທ_ຈ_ອຄ_ພ_ພຫ_ສກ_ສ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'ວັນdddd D MMMM YYYY HH:mm',
        },
        meridiemParse: /ຕອນເຊົ້າ|ຕອນແລງ/,
        isPM: function (input) {
            return input === 'ຕອນແລງ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ຕອນເຊົ້າ';
            } else {
                return 'ຕອນແລງ';
            }
        },
        calendar: {
            sameDay: '[ມື້ນີ້ເວລາ] LT',
            nextDay: '[ມື້ອື່ນເວລາ] LT',
            nextWeek: '[ວັນ]dddd[ໜ້າເວລາ] LT',
            lastDay: '[ມື້ວານນີ້ເວລາ] LT',
            lastWeek: '[ວັນ]dddd[ແລ້ວນີ້ເວລາ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ອີກ %s',
            past: '%sຜ່ານມາ',
            s: 'ບໍ່ເທົ່າໃດວິນາທີ',
            ss: '%d ວິນາທີ',
            m: '1 ນາທີ',
            mm: '%d ນາທີ',
            h: '1 ຊົ່ວໂມງ',
            hh: '%d ຊົ່ວໂມງ',
            d: '1 ມື້',
            dd: '%d ມື້',
            M: '1 ເດືອນ',
            MM: '%d ເດືອນ',
            y: '1 ປີ',
            yy: '%d ປີ',
        },
        dayOfMonthOrdinalParse: /(ທີ່)\d{1,2}/,
        ordinal: function (number) {
            return 'ທີ່' + number;
        },
    });

    return lo;

})));


/***/ }),

/***/ 7010:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Lithuanian [lt]
//! author : Mindaugas Mozūras : https://github.com/mmozuras

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundė_sekundžių_sekundes',
        m: 'minutė_minutės_minutę',
        mm: 'minutės_minučių_minutes',
        h: 'valanda_valandos_valandą',
        hh: 'valandos_valandų_valandas',
        d: 'diena_dienos_dieną',
        dd: 'dienos_dienų_dienas',
        M: 'mėnuo_mėnesio_mėnesį',
        MM: 'mėnesiai_mėnesių_mėnesius',
        y: 'metai_metų_metus',
        yy: 'metai_metų_metus',
    };
    function translateSeconds(number, withoutSuffix, key, isFuture) {
        if (withoutSuffix) {
            return 'kelios sekundės';
        } else {
            return isFuture ? 'kelių sekundžių' : 'kelias sekundes';
        }
    }
    function translateSingular(number, withoutSuffix, key, isFuture) {
        return withoutSuffix
            ? forms(key)[0]
            : isFuture
            ? forms(key)[1]
            : forms(key)[2];
    }
    function special(number) {
        return number % 10 === 0 || (number > 10 && number < 20);
    }
    function forms(key) {
        return units[key].split('_');
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        if (number === 1) {
            return (
                result + translateSingular(number, withoutSuffix, key[0], isFuture)
            );
        } else if (withoutSuffix) {
            return result + (special(number) ? forms(key)[1] : forms(key)[0]);
        } else {
            if (isFuture) {
                return result + forms(key)[1];
            } else {
                return result + (special(number) ? forms(key)[1] : forms(key)[2]);
            }
        }
    }
    var lt = moment.defineLocale('lt', {
        months: {
            format: 'sausio_vasario_kovo_balandžio_gegužės_birželio_liepos_rugpjūčio_rugsėjo_spalio_lapkričio_gruodžio'.split(
                '_'
            ),
            standalone:
                'sausis_vasaris_kovas_balandis_gegužė_birželis_liepa_rugpjūtis_rugsėjis_spalis_lapkritis_gruodis'.split(
                    '_'
                ),
            isFormat: /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?|MMMM?(\[[^\[\]]*\]|\s)+D[oD]?/,
        },
        monthsShort: 'sau_vas_kov_bal_geg_bir_lie_rgp_rgs_spa_lap_grd'.split('_'),
        weekdays: {
            format: 'sekmadienį_pirmadienį_antradienį_trečiadienį_ketvirtadienį_penktadienį_šeštadienį'.split(
                '_'
            ),
            standalone:
                'sekmadienis_pirmadienis_antradienis_trečiadienis_ketvirtadienis_penktadienis_šeštadienis'.split(
                    '_'
                ),
            isFormat: /dddd HH:mm/,
        },
        weekdaysShort: 'Sek_Pir_Ant_Tre_Ket_Pen_Šeš'.split('_'),
        weekdaysMin: 'S_P_A_T_K_Pn_Š'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY [m.] MMMM D [d.]',
            LLL: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            LLLL: 'YYYY [m.] MMMM D [d.], dddd, HH:mm [val.]',
            l: 'YYYY-MM-DD',
            ll: 'YYYY [m.] MMMM D [d.]',
            lll: 'YYYY [m.] MMMM D [d.], HH:mm [val.]',
            llll: 'YYYY [m.] MMMM D [d.], ddd, HH:mm [val.]',
        },
        calendar: {
            sameDay: '[Šiandien] LT',
            nextDay: '[Rytoj] LT',
            nextWeek: 'dddd LT',
            lastDay: '[Vakar] LT',
            lastWeek: '[Praėjusį] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'po %s',
            past: 'prieš %s',
            s: translateSeconds,
            ss: translate,
            m: translateSingular,
            mm: translate,
            h: translateSingular,
            hh: translate,
            d: translateSingular,
            dd: translate,
            M: translateSingular,
            MM: translate,
            y: translateSingular,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}-oji/,
        ordinal: function (number) {
            return number + '-oji';
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lt;

})));


/***/ }),

/***/ 7595:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Latvian [lv]
//! author : Kristaps Karlsons : https://github.com/skakri
//! author : Jānis Elmeris : https://github.com/JanisE

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var units = {
        ss: 'sekundes_sekundēm_sekunde_sekundes'.split('_'),
        m: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        mm: 'minūtes_minūtēm_minūte_minūtes'.split('_'),
        h: 'stundas_stundām_stunda_stundas'.split('_'),
        hh: 'stundas_stundām_stunda_stundas'.split('_'),
        d: 'dienas_dienām_diena_dienas'.split('_'),
        dd: 'dienas_dienām_diena_dienas'.split('_'),
        M: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        MM: 'mēneša_mēnešiem_mēnesis_mēneši'.split('_'),
        y: 'gada_gadiem_gads_gadi'.split('_'),
        yy: 'gada_gadiem_gads_gadi'.split('_'),
    };
    /**
     * @param withoutSuffix boolean true = a length of time; false = before/after a period of time.
     */
    function format(forms, number, withoutSuffix) {
        if (withoutSuffix) {
            // E.g. "21 minūte", "3 minūtes".
            return number % 10 === 1 && number % 100 !== 11 ? forms[2] : forms[3];
        } else {
            // E.g. "21 minūtes" as in "pēc 21 minūtes".
            // E.g. "3 minūtēm" as in "pēc 3 minūtēm".
            return number % 10 === 1 && number % 100 !== 11 ? forms[0] : forms[1];
        }
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        return number + ' ' + format(units[key], number, withoutSuffix);
    }
    function relativeTimeWithSingular(number, withoutSuffix, key) {
        return format(units[key], number, withoutSuffix);
    }
    function relativeSeconds(number, withoutSuffix) {
        return withoutSuffix ? 'dažas sekundes' : 'dažām sekundēm';
    }

    var lv = moment.defineLocale('lv', {
        months: 'janvāris_februāris_marts_aprīlis_maijs_jūnijs_jūlijs_augusts_septembris_oktobris_novembris_decembris'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_mai_jūn_jūl_aug_sep_okt_nov_dec'.split('_'),
        weekdays:
            'svētdiena_pirmdiena_otrdiena_trešdiena_ceturtdiena_piektdiena_sestdiena'.split(
                '_'
            ),
        weekdaysShort: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysMin: 'Sv_P_O_T_C_Pk_S'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY.',
            LL: 'YYYY. [gada] D. MMMM',
            LLL: 'YYYY. [gada] D. MMMM, HH:mm',
            LLLL: 'YYYY. [gada] D. MMMM, dddd, HH:mm',
        },
        calendar: {
            sameDay: '[Šodien pulksten] LT',
            nextDay: '[Rīt pulksten] LT',
            nextWeek: 'dddd [pulksten] LT',
            lastDay: '[Vakar pulksten] LT',
            lastWeek: '[Pagājušā] dddd [pulksten] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'pēc %s',
            past: 'pirms %s',
            s: relativeSeconds,
            ss: relativeTimeWithPlural,
            m: relativeTimeWithSingular,
            mm: relativeTimeWithPlural,
            h: relativeTimeWithSingular,
            hh: relativeTimeWithPlural,
            d: relativeTimeWithSingular,
            dd: relativeTimeWithPlural,
            M: relativeTimeWithSingular,
            MM: relativeTimeWithPlural,
            y: relativeTimeWithSingular,
            yy: relativeTimeWithPlural,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return lv;

})));


/***/ }),

/***/ 9861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Montenegrin [me]
//! author : Miodrag Nikač <miodrag@restartit.me> : https://github.com/miodragnikac

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekund', 'sekunda', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            dd: ['dan', 'dana', 'dana'],
            MM: ['mjesec', 'mjeseca', 'mjeseci'],
            yy: ['godina', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            return number === 1
                ? wordKey[0]
                : number >= 2 && number <= 4
                ? wordKey[1]
                : wordKey[2];
        },
        translate: function (number, withoutSuffix, key) {
            var wordKey = translator.words[key];
            if (key.length === 1) {
                return withoutSuffix ? wordKey[0] : wordKey[1];
            } else {
                return (
                    number +
                    ' ' +
                    translator.correctGrammaticalCase(number, wordKey)
                );
            }
        },
    };

    var me = moment.defineLocale('me', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedjelja_ponedjeljak_utorak_srijeda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sri._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sjutra u] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedjelju] [u] LT';
                    case 3:
                        return '[u] [srijedu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedjelje] [u] LT',
                    '[prošlog] [ponedjeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srijede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'prije %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: 'dan',
            dd: translator.translate,
            M: 'mjesec',
            MM: translator.translate,
            y: 'godinu',
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return me;

})));


/***/ }),

/***/ 5493:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maori [mi]
//! author : John Corrigan <robbiecloset@gmail.com> : https://github.com/johnideal

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mi = moment.defineLocale('mi', {
        months: 'Kohi-tāte_Hui-tanguru_Poutū-te-rangi_Paenga-whāwhā_Haratua_Pipiri_Hōngoingoi_Here-turi-kōkā_Mahuru_Whiringa-ā-nuku_Whiringa-ā-rangi_Hakihea'.split(
            '_'
        ),
        monthsShort:
            'Kohi_Hui_Pou_Pae_Hara_Pipi_Hōngoi_Here_Mahu_Whi-nu_Whi-ra_Haki'.split(
                '_'
            ),
        monthsRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,3}/i,
        monthsShortStrictRegex: /(?:['a-z\u0101\u014D\u016B]+\-?){1,2}/i,
        weekdays: 'Rātapu_Mane_Tūrei_Wenerei_Tāite_Paraire_Hātarei'.split('_'),
        weekdaysShort: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        weekdaysMin: 'Ta_Ma_Tū_We_Tāi_Pa_Hā'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [i] HH:mm',
            LLLL: 'dddd, D MMMM YYYY [i] HH:mm',
        },
        calendar: {
            sameDay: '[i teie mahana, i] LT',
            nextDay: '[apopo i] LT',
            nextWeek: 'dddd [i] LT',
            lastDay: '[inanahi i] LT',
            lastWeek: 'dddd [whakamutunga i] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'i roto i %s',
            past: '%s i mua',
            s: 'te hēkona ruarua',
            ss: '%d hēkona',
            m: 'he meneti',
            mm: '%d meneti',
            h: 'te haora',
            hh: '%d haora',
            d: 'he ra',
            dd: '%d ra',
            M: 'he marama',
            MM: '%d marama',
            y: 'he tau',
            yy: '%d tau',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mi;

})));


/***/ }),

/***/ 5966:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Macedonian [mk]
//! author : Borislav Mickov : https://github.com/B0k0
//! author : Sashko Todorov : https://github.com/bkyceh

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mk = moment.defineLocale('mk', {
        months: 'јануари_февруари_март_април_мај_јуни_јули_август_септември_октомври_ноември_декември'.split(
            '_'
        ),
        monthsShort: 'јан_фев_мар_апр_мај_јун_јул_авг_сеп_окт_ное_дек'.split('_'),
        weekdays: 'недела_понеделник_вторник_среда_четврток_петок_сабота'.split(
            '_'
        ),
        weekdaysShort: 'нед_пон_вто_сре_чет_пет_саб'.split('_'),
        weekdaysMin: 'нe_пo_вт_ср_че_пе_сa'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[Денес во] LT',
            nextDay: '[Утре во] LT',
            nextWeek: '[Во] dddd [во] LT',
            lastDay: '[Вчера во] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 6:
                        return '[Изминатата] dddd [во] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[Изминатиот] dddd [во] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пред %s',
            s: 'неколку секунди',
            ss: '%d секунди',
            m: 'една минута',
            mm: '%d минути',
            h: 'еден час',
            hh: '%d часа',
            d: 'еден ден',
            dd: '%d дена',
            M: 'еден месец',
            MM: '%d месеци',
            y: 'една година',
            yy: '%d години',
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ев|ен|ти|ви|ри|ми)/,
        ordinal: function (number) {
            var lastDigit = number % 10,
                last2Digits = number % 100;
            if (number === 0) {
                return number + '-ев';
            } else if (last2Digits === 0) {
                return number + '-ен';
            } else if (last2Digits > 10 && last2Digits < 20) {
                return number + '-ти';
            } else if (lastDigit === 1) {
                return number + '-ви';
            } else if (lastDigit === 2) {
                return number + '-ри';
            } else if (lastDigit === 7 || lastDigit === 8) {
                return number + '-ми';
            } else {
                return number + '-ти';
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return mk;

})));


/***/ }),

/***/ 7341:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malayalam [ml]
//! author : Floyd Pink : https://github.com/floydpink

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ml = moment.defineLocale('ml', {
        months: 'ജനുവരി_ഫെബ്രുവരി_മാർച്ച്_ഏപ്രിൽ_മേയ്_ജൂൺ_ജൂലൈ_ഓഗസ്റ്റ്_സെപ്റ്റംബർ_ഒക്ടോബർ_നവംബർ_ഡിസംബർ'.split(
            '_'
        ),
        monthsShort:
            'ജനു._ഫെബ്രു._മാർ._ഏപ്രി._മേയ്_ജൂൺ_ജൂലൈ._ഓഗ._സെപ്റ്റ._ഒക്ടോ._നവം._ഡിസം.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ഞായറാഴ്ച_തിങ്കളാഴ്ച_ചൊവ്വാഴ്ച_ബുധനാഴ്ച_വ്യാഴാഴ്ച_വെള്ളിയാഴ്ച_ശനിയാഴ്ച'.split(
                '_'
            ),
        weekdaysShort: 'ഞായർ_തിങ്കൾ_ചൊവ്വ_ബുധൻ_വ്യാഴം_വെള്ളി_ശനി'.split('_'),
        weekdaysMin: 'ഞാ_തി_ചൊ_ബു_വ്യാ_വെ_ശ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm -നു',
            LTS: 'A h:mm:ss -നു',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm -നു',
            LLLL: 'dddd, D MMMM YYYY, A h:mm -നു',
        },
        calendar: {
            sameDay: '[ഇന്ന്] LT',
            nextDay: '[നാളെ] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[ഇന്നലെ] LT',
            lastWeek: '[കഴിഞ്ഞ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s കഴിഞ്ഞ്',
            past: '%s മുൻപ്',
            s: 'അൽപ നിമിഷങ്ങൾ',
            ss: '%d സെക്കൻഡ്',
            m: 'ഒരു മിനിറ്റ്',
            mm: '%d മിനിറ്റ്',
            h: 'ഒരു മണിക്കൂർ',
            hh: '%d മണിക്കൂർ',
            d: 'ഒരു ദിവസം',
            dd: '%d ദിവസം',
            M: 'ഒരു മാസം',
            MM: '%d മാസം',
            y: 'ഒരു വർഷം',
            yy: '%d വർഷം',
        },
        meridiemParse: /രാത്രി|രാവിലെ|ഉച്ച കഴിഞ്ഞ്|വൈകുന്നേരം|രാത്രി/i,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                (meridiem === 'രാത്രി' && hour >= 4) ||
                meridiem === 'ഉച്ച കഴിഞ്ഞ്' ||
                meridiem === 'വൈകുന്നേരം'
            ) {
                return hour + 12;
            } else {
                return hour;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'രാത്രി';
            } else if (hour < 12) {
                return 'രാവിലെ';
            } else if (hour < 17) {
                return 'ഉച്ച കഴിഞ്ഞ്';
            } else if (hour < 20) {
                return 'വൈകുന്നേരം';
            } else {
                return 'രാത്രി';
            }
        },
    });

    return ml;

})));


/***/ }),

/***/ 5115:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Mongolian [mn]
//! author : Javkhlantugs Nyamdorj : https://github.com/javkhaanj7

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function translate(number, withoutSuffix, key, isFuture) {
        switch (key) {
            case 's':
                return withoutSuffix ? 'хэдхэн секунд' : 'хэдхэн секундын';
            case 'ss':
                return number + (withoutSuffix ? ' секунд' : ' секундын');
            case 'm':
            case 'mm':
                return number + (withoutSuffix ? ' минут' : ' минутын');
            case 'h':
            case 'hh':
                return number + (withoutSuffix ? ' цаг' : ' цагийн');
            case 'd':
            case 'dd':
                return number + (withoutSuffix ? ' өдөр' : ' өдрийн');
            case 'M':
            case 'MM':
                return number + (withoutSuffix ? ' сар' : ' сарын');
            case 'y':
            case 'yy':
                return number + (withoutSuffix ? ' жил' : ' жилийн');
            default:
                return number;
        }
    }

    var mn = moment.defineLocale('mn', {
        months: 'Нэгдүгээр сар_Хоёрдугаар сар_Гуравдугаар сар_Дөрөвдүгээр сар_Тавдугаар сар_Зургадугаар сар_Долдугаар сар_Наймдугаар сар_Есдүгээр сар_Аравдугаар сар_Арван нэгдүгээр сар_Арван хоёрдугаар сар'.split(
            '_'
        ),
        monthsShort:
            '1 сар_2 сар_3 сар_4 сар_5 сар_6 сар_7 сар_8 сар_9 сар_10 сар_11 сар_12 сар'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'Ням_Даваа_Мягмар_Лхагва_Пүрэв_Баасан_Бямба'.split('_'),
        weekdaysShort: 'Ням_Дав_Мяг_Лха_Пүр_Баа_Бям'.split('_'),
        weekdaysMin: 'Ня_Да_Мя_Лх_Пү_Ба_Бя'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY оны MMMMын D',
            LLL: 'YYYY оны MMMMын D HH:mm',
            LLLL: 'dddd, YYYY оны MMMMын D HH:mm',
        },
        meridiemParse: /ҮӨ|ҮХ/i,
        isPM: function (input) {
            return input === 'ҮХ';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ҮӨ';
            } else {
                return 'ҮХ';
            }
        },
        calendar: {
            sameDay: '[Өнөөдөр] LT',
            nextDay: '[Маргааш] LT',
            nextWeek: '[Ирэх] dddd LT',
            lastDay: '[Өчигдөр] LT',
            lastWeek: '[Өнгөрсөн] dddd LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s дараа',
            past: '%s өмнө',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2} өдөр/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + ' өдөр';
                default:
                    return number;
            }
        },
    });

    return mn;

})));


/***/ }),

/***/ 370:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Marathi [mr]
//! author : Harshad Kale : https://github.com/kalehv
//! author : Vivek Athalye : https://github.com/vnathalye

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    function relativeTimeMr(number, withoutSuffix, string, isFuture) {
        var output = '';
        if (withoutSuffix) {
            switch (string) {
                case 's':
                    output = 'काही सेकंद';
                    break;
                case 'ss':
                    output = '%d सेकंद';
                    break;
                case 'm':
                    output = 'एक मिनिट';
                    break;
                case 'mm':
                    output = '%d मिनिटे';
                    break;
                case 'h':
                    output = 'एक तास';
                    break;
                case 'hh':
                    output = '%d तास';
                    break;
                case 'd':
                    output = 'एक दिवस';
                    break;
                case 'dd':
                    output = '%d दिवस';
                    break;
                case 'M':
                    output = 'एक महिना';
                    break;
                case 'MM':
                    output = '%d महिने';
                    break;
                case 'y':
                    output = 'एक वर्ष';
                    break;
                case 'yy':
                    output = '%d वर्षे';
                    break;
            }
        } else {
            switch (string) {
                case 's':
                    output = 'काही सेकंदां';
                    break;
                case 'ss':
                    output = '%d सेकंदां';
                    break;
                case 'm':
                    output = 'एका मिनिटा';
                    break;
                case 'mm':
                    output = '%d मिनिटां';
                    break;
                case 'h':
                    output = 'एका तासा';
                    break;
                case 'hh':
                    output = '%d तासां';
                    break;
                case 'd':
                    output = 'एका दिवसा';
                    break;
                case 'dd':
                    output = '%d दिवसां';
                    break;
                case 'M':
                    output = 'एका महिन्या';
                    break;
                case 'MM':
                    output = '%d महिन्यां';
                    break;
                case 'y':
                    output = 'एका वर्षा';
                    break;
                case 'yy':
                    output = '%d वर्षां';
                    break;
            }
        }
        return output.replace(/%d/i, number);
    }

    var mr = moment.defineLocale('mr', {
        months: 'जानेवारी_फेब्रुवारी_मार्च_एप्रिल_मे_जून_जुलै_ऑगस्ट_सप्टेंबर_ऑक्टोबर_नोव्हेंबर_डिसेंबर'.split(
            '_'
        ),
        monthsShort:
            'जाने._फेब्रु._मार्च._एप्रि._मे._जून._जुलै._ऑग._सप्टें._ऑक्टो._नोव्हें._डिसें.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'रविवार_सोमवार_मंगळवार_बुधवार_गुरूवार_शुक्रवार_शनिवार'.split('_'),
        weekdaysShort: 'रवि_सोम_मंगळ_बुध_गुरू_शुक्र_शनि'.split('_'),
        weekdaysMin: 'र_सो_मं_बु_गु_शु_श'.split('_'),
        longDateFormat: {
            LT: 'A h:mm वाजता',
            LTS: 'A h:mm:ss वाजता',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm वाजता',
            LLLL: 'dddd, D MMMM YYYY, A h:mm वाजता',
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[उद्या] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[काल] LT',
            lastWeek: '[मागील] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमध्ये',
            past: '%sपूर्वी',
            s: relativeTimeMr,
            ss: relativeTimeMr,
            m: relativeTimeMr,
            mm: relativeTimeMr,
            h: relativeTimeMr,
            hh: relativeTimeMr,
            d: relativeTimeMr,
            dd: relativeTimeMr,
            M: relativeTimeMr,
            MM: relativeTimeMr,
            y: relativeTimeMr,
            yy: relativeTimeMr,
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /पहाटे|सकाळी|दुपारी|सायंकाळी|रात्री/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'पहाटे' || meridiem === 'सकाळी') {
                return hour;
            } else if (
                meridiem === 'दुपारी' ||
                meridiem === 'सायंकाळी' ||
                meridiem === 'रात्री'
            ) {
                return hour >= 12 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour >= 0 && hour < 6) {
                return 'पहाटे';
            } else if (hour < 12) {
                return 'सकाळी';
            } else if (hour < 17) {
                return 'दुपारी';
            } else if (hour < 20) {
                return 'सायंकाळी';
            } else {
                return 'रात्री';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return mr;

})));


/***/ }),

/***/ 1237:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms-my]
//! note : DEPRECATED, the correct one is [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var msMy = moment.defineLocale('ms-my', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return msMy;

})));


/***/ }),

/***/ 9847:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Malay [ms]
//! author : Weldan Jamili : https://github.com/weldan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ms = moment.defineLocale('ms', {
        months: 'Januari_Februari_Mac_April_Mei_Jun_Julai_Ogos_September_Oktober_November_Disember'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ogs_Sep_Okt_Nov_Dis'.split('_'),
        weekdays: 'Ahad_Isnin_Selasa_Rabu_Khamis_Jumaat_Sabtu'.split('_'),
        weekdaysShort: 'Ahd_Isn_Sel_Rab_Kha_Jum_Sab'.split('_'),
        weekdaysMin: 'Ah_Is_Sl_Rb_Km_Jm_Sb'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [pukul] HH.mm',
            LLLL: 'dddd, D MMMM YYYY [pukul] HH.mm',
        },
        meridiemParse: /pagi|tengahari|petang|malam/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'pagi') {
                return hour;
            } else if (meridiem === 'tengahari') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'petang' || meridiem === 'malam') {
                return hour + 12;
            }
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'pagi';
            } else if (hours < 15) {
                return 'tengahari';
            } else if (hours < 19) {
                return 'petang';
            } else {
                return 'malam';
            }
        },
        calendar: {
            sameDay: '[Hari ini pukul] LT',
            nextDay: '[Esok pukul] LT',
            nextWeek: 'dddd [pukul] LT',
            lastDay: '[Kelmarin pukul] LT',
            lastWeek: 'dddd [lepas pukul] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dalam %s',
            past: '%s yang lepas',
            s: 'beberapa saat',
            ss: '%d saat',
            m: 'seminit',
            mm: '%d minit',
            h: 'sejam',
            hh: '%d jam',
            d: 'sehari',
            dd: '%d hari',
            M: 'sebulan',
            MM: '%d bulan',
            y: 'setahun',
            yy: '%d tahun',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ms;

})));


/***/ }),

/***/ 2126:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Maltese (Malta) [mt]
//! author : Alessandro Maruccia : https://github.com/alesma

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var mt = moment.defineLocale('mt', {
        months: 'Jannar_Frar_Marzu_April_Mejju_Ġunju_Lulju_Awwissu_Settembru_Ottubru_Novembru_Diċembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fra_Mar_Apr_Mej_Ġun_Lul_Aww_Set_Ott_Nov_Diċ'.split('_'),
        weekdays:
            'Il-Ħadd_It-Tnejn_It-Tlieta_L-Erbgħa_Il-Ħamis_Il-Ġimgħa_Is-Sibt'.split(
                '_'
            ),
        weekdaysShort: 'Ħad_Tne_Tli_Erb_Ħam_Ġim_Sib'.split('_'),
        weekdaysMin: 'Ħa_Tn_Tl_Er_Ħa_Ġi_Si'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Illum fil-]LT',
            nextDay: '[Għada fil-]LT',
            nextWeek: 'dddd [fil-]LT',
            lastDay: '[Il-bieraħ fil-]LT',
            lastWeek: 'dddd [li għadda] [fil-]LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'f’ %s',
            past: '%s ilu',
            s: 'ftit sekondi',
            ss: '%d sekondi',
            m: 'minuta',
            mm: '%d minuti',
            h: 'siegħa',
            hh: '%d siegħat',
            d: 'ġurnata',
            dd: '%d ġranet',
            M: 'xahar',
            MM: '%d xhur',
            y: 'sena',
            yy: '%d sni',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return mt;

})));


/***/ }),

/***/ 6165:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Burmese [my]
//! author : Squar team, mysquar.com
//! author : David Rossellat : https://github.com/gholadr
//! author : Tin Aung Lin : https://github.com/thanyawzinmin

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '၁',
            2: '၂',
            3: '၃',
            4: '၄',
            5: '၅',
            6: '၆',
            7: '၇',
            8: '၈',
            9: '၉',
            0: '၀',
        },
        numberMap = {
            '၁': '1',
            '၂': '2',
            '၃': '3',
            '၄': '4',
            '၅': '5',
            '၆': '6',
            '၇': '7',
            '၈': '8',
            '၉': '9',
            '၀': '0',
        };

    var my = moment.defineLocale('my', {
        months: 'ဇန်နဝါရီ_ဖေဖော်ဝါရီ_မတ်_ဧပြီ_မေ_ဇွန်_ဇူလိုင်_သြဂုတ်_စက်တင်ဘာ_အောက်တိုဘာ_နိုဝင်ဘာ_ဒီဇင်ဘာ'.split(
            '_'
        ),
        monthsShort: 'ဇန်_ဖေ_မတ်_ပြီ_မေ_ဇွန်_လိုင်_သြ_စက်_အောက်_နို_ဒီ'.split('_'),
        weekdays: 'တနင်္ဂနွေ_တနင်္လာ_အင်္ဂါ_ဗုဒ္ဓဟူး_ကြာသပတေး_သောကြာ_စနေ'.split(
            '_'
        ),
        weekdaysShort: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),
        weekdaysMin: 'နွေ_လာ_ဂါ_ဟူး_ကြာ_သော_နေ'.split('_'),

        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ယနေ.] LT [မှာ]',
            nextDay: '[မနက်ဖြန်] LT [မှာ]',
            nextWeek: 'dddd LT [မှာ]',
            lastDay: '[မနေ.က] LT [မှာ]',
            lastWeek: '[ပြီးခဲ့သော] dddd LT [မှာ]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'လာမည့် %s မှာ',
            past: 'လွန်ခဲ့သော %s က',
            s: 'စက္ကန်.အနည်းငယ်',
            ss: '%d စက္ကန့်',
            m: 'တစ်မိနစ်',
            mm: '%d မိနစ်',
            h: 'တစ်နာရီ',
            hh: '%d နာရီ',
            d: 'တစ်ရက်',
            dd: '%d ရက်',
            M: 'တစ်လ',
            MM: '%d လ',
            y: 'တစ်နှစ်',
            yy: '%d နှစ်',
        },
        preparse: function (string) {
            return string.replace(/[၁၂၃၄၅၆၇၈၉၀]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return my;

})));


/***/ }),

/***/ 4924:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Norwegian Bokmål [nb]
//! authors : Espen Hovlandsdal : https://github.com/rexxars
//!           Sigurd Gartmann : https://github.com/sigurdga
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nb = moment.defineLocale('nb', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'søndag_mandag_tirsdag_onsdag_torsdag_fredag_lørdag'.split('_'),
        weekdaysShort: 'sø._ma._ti._on._to._fr._lø.'.split('_'),
        weekdaysMin: 'sø_ma_ti_on_to_fr_lø'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[i dag kl.] LT',
            nextDay: '[i morgen kl.] LT',
            nextWeek: 'dddd [kl.] LT',
            lastDay: '[i går kl.] LT',
            lastWeek: '[forrige] dddd [kl.] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s siden',
            s: 'noen sekunder',
            ss: '%d sekunder',
            m: 'ett minutt',
            mm: '%d minutter',
            h: 'en time',
            hh: '%d timer',
            d: 'en dag',
            dd: '%d dager',
            w: 'en uke',
            ww: '%d uker',
            M: 'en måned',
            MM: '%d måneder',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nb;

})));


/***/ }),

/***/ 6744:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nepalese [ne]
//! author : suvash : https://github.com/suvash

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '१',
            2: '२',
            3: '३',
            4: '४',
            5: '५',
            6: '६',
            7: '७',
            8: '८',
            9: '९',
            0: '०',
        },
        numberMap = {
            '१': '1',
            '२': '2',
            '३': '3',
            '४': '4',
            '५': '5',
            '६': '6',
            '७': '7',
            '८': '8',
            '९': '9',
            '०': '0',
        };

    var ne = moment.defineLocale('ne', {
        months: 'जनवरी_फेब्रुवरी_मार्च_अप्रिल_मई_जुन_जुलाई_अगष्ट_सेप्टेम्बर_अक्टोबर_नोभेम्बर_डिसेम्बर'.split(
            '_'
        ),
        monthsShort:
            'जन._फेब्रु._मार्च_अप्रि._मई_जुन_जुलाई._अग._सेप्ट._अक्टो._नोभे._डिसे.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'आइतबार_सोमबार_मङ्गलबार_बुधबार_बिहिबार_शुक्रबार_शनिबार'.split(
            '_'
        ),
        weekdaysShort: 'आइत._सोम._मङ्गल._बुध._बिहि._शुक्र._शनि.'.split('_'),
        weekdaysMin: 'आ._सो._मं._बु._बि._शु._श.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'Aको h:mm बजे',
            LTS: 'Aको h:mm:ss बजे',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, Aको h:mm बजे',
            LLLL: 'dddd, D MMMM YYYY, Aको h:mm बजे',
        },
        preparse: function (string) {
            return string.replace(/[१२३४५६७८९०]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        meridiemParse: /राति|बिहान|दिउँसो|साँझ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'राति') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'बिहान') {
                return hour;
            } else if (meridiem === 'दिउँसो') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'साँझ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 3) {
                return 'राति';
            } else if (hour < 12) {
                return 'बिहान';
            } else if (hour < 16) {
                return 'दिउँसो';
            } else if (hour < 20) {
                return 'साँझ';
            } else {
                return 'राति';
            }
        },
        calendar: {
            sameDay: '[आज] LT',
            nextDay: '[भोलि] LT',
            nextWeek: '[आउँदो] dddd[,] LT',
            lastDay: '[हिजो] LT',
            lastWeek: '[गएको] dddd[,] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sमा',
            past: '%s अगाडि',
            s: 'केही क्षण',
            ss: '%d सेकेण्ड',
            m: 'एक मिनेट',
            mm: '%d मिनेट',
            h: 'एक घण्टा',
            hh: '%d घण्टा',
            d: 'एक दिन',
            dd: '%d दिन',
            M: 'एक महिना',
            MM: '%d महिना',
            y: 'एक बर्ष',
            yy: '%d बर्ष',
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ne;

})));


/***/ }),

/***/ 9814:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch (Belgium) [nl-be]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nlBe = moment.defineLocale('nl-be', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nlBe;

})));


/***/ }),

/***/ 3901:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Dutch [nl]
//! author : Joris Röling : https://github.com/jorisroling
//! author : Jacob Middag : https://github.com/middagj

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsShortWithDots =
            'jan._feb._mrt._apr._mei_jun._jul._aug._sep._okt._nov._dec.'.split('_'),
        monthsShortWithoutDots =
            'jan_feb_mrt_apr_mei_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        monthsParse = [
            /^jan/i,
            /^feb/i,
            /^maart|mrt.?$/i,
            /^apr/i,
            /^mei$/i,
            /^jun[i.]?$/i,
            /^jul[i.]?$/i,
            /^aug/i,
            /^sep/i,
            /^okt/i,
            /^nov/i,
            /^dec/i,
        ],
        monthsRegex =
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december|jan\.?|feb\.?|mrt\.?|apr\.?|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i;

    var nl = moment.defineLocale('nl', {
        months: 'januari_februari_maart_april_mei_juni_juli_augustus_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: function (m, format) {
            if (!m) {
                return monthsShortWithDots;
            } else if (/-MMM-/.test(format)) {
                return monthsShortWithoutDots[m.month()];
            } else {
                return monthsShortWithDots[m.month()];
            }
        },

        monthsRegex: monthsRegex,
        monthsShortRegex: monthsRegex,
        monthsStrictRegex:
            /^(januari|februari|maart|april|mei|ju[nl]i|augustus|september|oktober|november|december)/i,
        monthsShortStrictRegex:
            /^(jan\.?|feb\.?|mrt\.?|apr\.?|mei|ju[nl]\.?|aug\.?|sep\.?|okt\.?|nov\.?|dec\.?)/i,

        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        weekdays:
            'zondag_maandag_dinsdag_woensdag_donderdag_vrijdag_zaterdag'.split('_'),
        weekdaysShort: 'zo._ma._di._wo._do._vr._za.'.split('_'),
        weekdaysMin: 'zo_ma_di_wo_do_vr_za'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD-MM-YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[vandaag om] LT',
            nextDay: '[morgen om] LT',
            nextWeek: 'dddd [om] LT',
            lastDay: '[gisteren om] LT',
            lastWeek: '[afgelopen] dddd [om] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'over %s',
            past: '%s geleden',
            s: 'een paar seconden',
            ss: '%d seconden',
            m: 'één minuut',
            mm: '%d minuten',
            h: 'één uur',
            hh: '%d uur',
            d: 'één dag',
            dd: '%d dagen',
            w: 'één week',
            ww: '%d weken',
            M: 'één maand',
            MM: '%d maanden',
            y: 'één jaar',
            yy: '%d jaar',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(ste|de)/,
        ordinal: function (number) {
            return (
                number +
                (number === 1 || number === 8 || number >= 20 ? 'ste' : 'de')
            );
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nl;

})));


/***/ }),

/***/ 3877:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Nynorsk [nn]
//! authors : https://github.com/mechuwind
//!           Stephen Ramthun : https://github.com/stephenramthun

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var nn = moment.defineLocale('nn', {
        months: 'januar_februar_mars_april_mai_juni_juli_august_september_oktober_november_desember'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mars_apr._mai_juni_juli_aug._sep._okt._nov._des.'.split('_'),
        monthsParseExact: true,
        weekdays: 'sundag_måndag_tysdag_onsdag_torsdag_fredag_laurdag'.split('_'),
        weekdaysShort: 'su._må._ty._on._to._fr._lau.'.split('_'),
        weekdaysMin: 'su_må_ty_on_to_fr_la'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY [kl.] H:mm',
            LLLL: 'dddd D. MMMM YYYY [kl.] HH:mm',
        },
        calendar: {
            sameDay: '[I dag klokka] LT',
            nextDay: '[I morgon klokka] LT',
            nextWeek: 'dddd [klokka] LT',
            lastDay: '[I går klokka] LT',
            lastWeek: '[Føregåande] dddd [klokka] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: '%s sidan',
            s: 'nokre sekund',
            ss: '%d sekund',
            m: 'eit minutt',
            mm: '%d minutt',
            h: 'ein time',
            hh: '%d timar',
            d: 'ein dag',
            dd: '%d dagar',
            w: 'ei veke',
            ww: '%d veker',
            M: 'ein månad',
            MM: '%d månader',
            y: 'eit år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return nn;

})));


/***/ }),

/***/ 2135:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Occitan, lengadocian dialecte [oc-lnc]
//! author : Quentin PAGÈS : https://github.com/Quenty31

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ocLnc = moment.defineLocale('oc-lnc', {
        months: {
            standalone:
                'genièr_febrièr_març_abril_mai_junh_julhet_agost_setembre_octòbre_novembre_decembre'.split(
                    '_'
                ),
            format: "de genièr_de febrièr_de març_d'abril_de mai_de junh_de julhet_d'agost_de setembre_d'octòbre_de novembre_de decembre".split(
                '_'
            ),
            isFormat: /D[oD]?(\s)+MMMM/,
        },
        monthsShort:
            'gen._febr._març_abr._mai_junh_julh._ago._set._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'dimenge_diluns_dimars_dimècres_dijòus_divendres_dissabte'.split(
            '_'
        ),
        weekdaysShort: 'dg._dl._dm._dc._dj._dv._ds.'.split('_'),
        weekdaysMin: 'dg_dl_dm_dc_dj_dv_ds'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [de] YYYY',
            ll: 'D MMM YYYY',
            LLL: 'D MMMM [de] YYYY [a] H:mm',
            lll: 'D MMM YYYY, H:mm',
            LLLL: 'dddd D MMMM [de] YYYY [a] H:mm',
            llll: 'ddd D MMM YYYY, H:mm',
        },
        calendar: {
            sameDay: '[uèi a] LT',
            nextDay: '[deman a] LT',
            nextWeek: 'dddd [a] LT',
            lastDay: '[ièr a] LT',
            lastWeek: 'dddd [passat a] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: "d'aquí %s",
            past: 'fa %s',
            s: 'unas segondas',
            ss: '%d segondas',
            m: 'una minuta',
            mm: '%d minutas',
            h: 'una ora',
            hh: '%d oras',
            d: 'un jorn',
            dd: '%d jorns',
            M: 'un mes',
            MM: '%d meses',
            y: 'un an',
            yy: '%d ans',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(r|n|t|è|a)/,
        ordinal: function (number, period) {
            var output =
                number === 1
                    ? 'r'
                    : number === 2
                    ? 'n'
                    : number === 3
                    ? 'r'
                    : number === 4
                    ? 't'
                    : 'è';
            if (period === 'w' || period === 'W') {
                output = 'a';
            }
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4,
        },
    });

    return ocLnc;

})));


/***/ }),

/***/ 5858:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Punjabi (India) [pa-in]
//! author : Harpreet Singh : https://github.com/harpreetkhalsagtbit

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '੧',
            2: '੨',
            3: '੩',
            4: '੪',
            5: '੫',
            6: '੬',
            7: '੭',
            8: '੮',
            9: '੯',
            0: '੦',
        },
        numberMap = {
            '੧': '1',
            '੨': '2',
            '੩': '3',
            '੪': '4',
            '੫': '5',
            '੬': '6',
            '੭': '7',
            '੮': '8',
            '੯': '9',
            '੦': '0',
        };

    var paIn = moment.defineLocale('pa-in', {
        // There are months name as per Nanakshahi Calendar but they are not used as rigidly in modern Punjabi.
        months: 'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
            '_'
        ),
        monthsShort:
            'ਜਨਵਰੀ_ਫ਼ਰਵਰੀ_ਮਾਰਚ_ਅਪ੍ਰੈਲ_ਮਈ_ਜੂਨ_ਜੁਲਾਈ_ਅਗਸਤ_ਸਤੰਬਰ_ਅਕਤੂਬਰ_ਨਵੰਬਰ_ਦਸੰਬਰ'.split(
                '_'
            ),
        weekdays: 'ਐਤਵਾਰ_ਸੋਮਵਾਰ_ਮੰਗਲਵਾਰ_ਬੁਧਵਾਰ_ਵੀਰਵਾਰ_ਸ਼ੁੱਕਰਵਾਰ_ਸ਼ਨੀਚਰਵਾਰ'.split(
            '_'
        ),
        weekdaysShort: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        weekdaysMin: 'ਐਤ_ਸੋਮ_ਮੰਗਲ_ਬੁਧ_ਵੀਰ_ਸ਼ੁਕਰ_ਸ਼ਨੀ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm ਵਜੇ',
            LTS: 'A h:mm:ss ਵਜੇ',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm ਵਜੇ',
            LLLL: 'dddd, D MMMM YYYY, A h:mm ਵਜੇ',
        },
        calendar: {
            sameDay: '[ਅਜ] LT',
            nextDay: '[ਕਲ] LT',
            nextWeek: '[ਅਗਲਾ] dddd, LT',
            lastDay: '[ਕਲ] LT',
            lastWeek: '[ਪਿਛਲੇ] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s ਵਿੱਚ',
            past: '%s ਪਿਛਲੇ',
            s: 'ਕੁਝ ਸਕਿੰਟ',
            ss: '%d ਸਕਿੰਟ',
            m: 'ਇਕ ਮਿੰਟ',
            mm: '%d ਮਿੰਟ',
            h: 'ਇੱਕ ਘੰਟਾ',
            hh: '%d ਘੰਟੇ',
            d: 'ਇੱਕ ਦਿਨ',
            dd: '%d ਦਿਨ',
            M: 'ਇੱਕ ਮਹੀਨਾ',
            MM: '%d ਮਹੀਨੇ',
            y: 'ਇੱਕ ਸਾਲ',
            yy: '%d ਸਾਲ',
        },
        preparse: function (string) {
            return string.replace(/[੧੨੩੪੫੬੭੮੯੦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // Punjabi notation for meridiems are quite fuzzy in practice. While there exists
        // a rigid notion of a 'Pahar' it is not used as rigidly in modern Punjabi.
        meridiemParse: /ਰਾਤ|ਸਵੇਰ|ਦੁਪਹਿਰ|ਸ਼ਾਮ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ਰਾਤ') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ਸਵੇਰ') {
                return hour;
            } else if (meridiem === 'ਦੁਪਹਿਰ') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'ਸ਼ਾਮ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ਰਾਤ';
            } else if (hour < 10) {
                return 'ਸਵੇਰ';
            } else if (hour < 17) {
                return 'ਦੁਪਹਿਰ';
            } else if (hour < 20) {
                return 'ਸ਼ਾਮ';
            } else {
                return 'ਰਾਤ';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return paIn;

})));


/***/ }),

/***/ 4495:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Polish [pl]
//! author : Rafal Hirsz : https://github.com/evoL

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var monthsNominative =
            'styczeń_luty_marzec_kwiecień_maj_czerwiec_lipiec_sierpień_wrzesień_październik_listopad_grudzień'.split(
                '_'
            ),
        monthsSubjective =
            'stycznia_lutego_marca_kwietnia_maja_czerwca_lipca_sierpnia_września_października_listopada_grudnia'.split(
                '_'
            ),
        monthsParse = [
            /^sty/i,
            /^lut/i,
            /^mar/i,
            /^kwi/i,
            /^maj/i,
            /^cze/i,
            /^lip/i,
            /^sie/i,
            /^wrz/i,
            /^paź/i,
            /^lis/i,
            /^gru/i,
        ];
    function plural(n) {
        return n % 10 < 5 && n % 10 > 1 && ~~(n / 10) % 10 !== 1;
    }
    function translate(number, withoutSuffix, key) {
        var result = number + ' ';
        switch (key) {
            case 'ss':
                return result + (plural(number) ? 'sekundy' : 'sekund');
            case 'm':
                return withoutSuffix ? 'minuta' : 'minutę';
            case 'mm':
                return result + (plural(number) ? 'minuty' : 'minut');
            case 'h':
                return withoutSuffix ? 'godzina' : 'godzinę';
            case 'hh':
                return result + (plural(number) ? 'godziny' : 'godzin');
            case 'ww':
                return result + (plural(number) ? 'tygodnie' : 'tygodni');
            case 'MM':
                return result + (plural(number) ? 'miesiące' : 'miesięcy');
            case 'yy':
                return result + (plural(number) ? 'lata' : 'lat');
        }
    }

    var pl = moment.defineLocale('pl', {
        months: function (momentToFormat, format) {
            if (!momentToFormat) {
                return monthsNominative;
            } else if (/D MMMM/.test(format)) {
                return monthsSubjective[momentToFormat.month()];
            } else {
                return monthsNominative[momentToFormat.month()];
            }
        },
        monthsShort: 'sty_lut_mar_kwi_maj_cze_lip_sie_wrz_paź_lis_gru'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,
        weekdays:
            'niedziela_poniedziałek_wtorek_środa_czwartek_piątek_sobota'.split('_'),
        weekdaysShort: 'ndz_pon_wt_śr_czw_pt_sob'.split('_'),
        weekdaysMin: 'Nd_Pn_Wt_Śr_Cz_Pt_So'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Dziś o] LT',
            nextDay: '[Jutro o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W niedzielę o] LT';

                    case 2:
                        return '[We wtorek o] LT';

                    case 3:
                        return '[W środę o] LT';

                    case 6:
                        return '[W sobotę o] LT';

                    default:
                        return '[W] dddd [o] LT';
                }
            },
            lastDay: '[Wczoraj o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[W zeszłą niedzielę o] LT';
                    case 3:
                        return '[W zeszłą środę o] LT';
                    case 6:
                        return '[W zeszłą sobotę o] LT';
                    default:
                        return '[W zeszły] dddd [o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: '%s temu',
            s: 'kilka sekund',
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: '1 dzień',
            dd: '%d dni',
            w: 'tydzień',
            ww: translate,
            M: 'miesiąc',
            MM: translate,
            y: 'rok',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pl;

})));


/***/ }),

/***/ 7971:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese (Brazil) [pt-br]
//! author : Caio Ribeiro Pereira : https://github.com/caio-ribeiro-pereira

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ptBr = moment.defineLocale('pt-br', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'domingo_segunda-feira_terça-feira_quarta-feira_quinta-feira_sexta-feira_sábado'.split(
                '_'
            ),
        weekdaysShort: 'dom_seg_ter_qua_qui_sex_sáb'.split('_'),
        weekdaysMin: 'do_2ª_3ª_4ª_5ª_6ª_sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY [às] HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY [às] HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'poucos segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        invalidDate: 'Data inválida',
    });

    return ptBr;

})));


/***/ }),

/***/ 9520:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Portuguese [pt]
//! author : Jefferson : https://github.com/jalex79

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var pt = moment.defineLocale('pt', {
        months: 'janeiro_fevereiro_março_abril_maio_junho_julho_agosto_setembro_outubro_novembro_dezembro'.split(
            '_'
        ),
        monthsShort: 'jan_fev_mar_abr_mai_jun_jul_ago_set_out_nov_dez'.split('_'),
        weekdays:
            'Domingo_Segunda-feira_Terça-feira_Quarta-feira_Quinta-feira_Sexta-feira_Sábado'.split(
                '_'
            ),
        weekdaysShort: 'Dom_Seg_Ter_Qua_Qui_Sex_Sáb'.split('_'),
        weekdaysMin: 'Do_2ª_3ª_4ª_5ª_6ª_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D [de] MMMM [de] YYYY',
            LLL: 'D [de] MMMM [de] YYYY HH:mm',
            LLLL: 'dddd, D [de] MMMM [de] YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hoje às] LT',
            nextDay: '[Amanhã às] LT',
            nextWeek: 'dddd [às] LT',
            lastDay: '[Ontem às] LT',
            lastWeek: function () {
                return this.day() === 0 || this.day() === 6
                    ? '[Último] dddd [às] LT' // Saturday + Sunday
                    : '[Última] dddd [às] LT'; // Monday - Friday
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'em %s',
            past: 'há %s',
            s: 'segundos',
            ss: '%d segundos',
            m: 'um minuto',
            mm: '%d minutos',
            h: 'uma hora',
            hh: '%d horas',
            d: 'um dia',
            dd: '%d dias',
            w: 'uma semana',
            ww: '%d semanas',
            M: 'um mês',
            MM: '%d meses',
            y: 'um ano',
            yy: '%d anos',
        },
        dayOfMonthOrdinalParse: /\d{1,2}º/,
        ordinal: '%dº',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return pt;

})));


/***/ }),

/***/ 6459:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Romanian [ro]
//! author : Vlad Gurdiga : https://github.com/gurdiga
//! author : Valentin Agachi : https://github.com/avaly
//! author : Emanuel Cepoi : https://github.com/cepem

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
                ss: 'secunde',
                mm: 'minute',
                hh: 'ore',
                dd: 'zile',
                ww: 'săptămâni',
                MM: 'luni',
                yy: 'ani',
            },
            separator = ' ';
        if (number % 100 >= 20 || (number >= 100 && number % 100 === 0)) {
            separator = ' de ';
        }
        return number + separator + format[key];
    }

    var ro = moment.defineLocale('ro', {
        months: 'ianuarie_februarie_martie_aprilie_mai_iunie_iulie_august_septembrie_octombrie_noiembrie_decembrie'.split(
            '_'
        ),
        monthsShort:
            'ian._feb._mart._apr._mai_iun._iul._aug._sept._oct._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'duminică_luni_marți_miercuri_joi_vineri_sâmbătă'.split('_'),
        weekdaysShort: 'Dum_Lun_Mar_Mie_Joi_Vin_Sâm'.split('_'),
        weekdaysMin: 'Du_Lu_Ma_Mi_Jo_Vi_Sâ'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY H:mm',
            LLLL: 'dddd, D MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[azi la] LT',
            nextDay: '[mâine la] LT',
            nextWeek: 'dddd [la] LT',
            lastDay: '[ieri la] LT',
            lastWeek: '[fosta] dddd [la] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'peste %s',
            past: '%s în urmă',
            s: 'câteva secunde',
            ss: relativeTimeWithPlural,
            m: 'un minut',
            mm: relativeTimeWithPlural,
            h: 'o oră',
            hh: relativeTimeWithPlural,
            d: 'o zi',
            dd: relativeTimeWithPlural,
            w: 'o săptămână',
            ww: relativeTimeWithPlural,
            M: 'o lună',
            MM: relativeTimeWithPlural,
            y: 'un an',
            yy: relativeTimeWithPlural,
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return ro;

})));


/***/ }),

/***/ 1793:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Russian [ru]
//! author : Viktorminator : https://github.com/Viktorminator
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Коренберг Марк : https://github.com/socketpair

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунды_секунд' : 'секунду_секунды_секунд',
            mm: withoutSuffix ? 'минута_минуты_минут' : 'минуту_минуты_минут',
            hh: 'час_часа_часов',
            dd: 'день_дня_дней',
            ww: 'неделя_недели_недель',
            MM: 'месяц_месяца_месяцев',
            yy: 'год_года_лет',
        };
        if (key === 'm') {
            return withoutSuffix ? 'минута' : 'минуту';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    var monthsParse = [
        /^янв/i,
        /^фев/i,
        /^мар/i,
        /^апр/i,
        /^ма[йя]/i,
        /^июн/i,
        /^июл/i,
        /^авг/i,
        /^сен/i,
        /^окт/i,
        /^ноя/i,
        /^дек/i,
    ];

    // http://new.gramota.ru/spravka/rules/139-prop : § 103
    // Сокращения месяцев: http://new.gramota.ru/spravka/buro/search-answer?s=242637
    // CLDR data:          http://www.unicode.org/cldr/charts/28/summary/ru.html#1753
    var ru = moment.defineLocale('ru', {
        months: {
            format: 'января_февраля_марта_апреля_мая_июня_июля_августа_сентября_октября_ноября_декабря'.split(
                '_'
            ),
            standalone:
                'январь_февраль_март_апрель_май_июнь_июль_август_сентябрь_октябрь_ноябрь_декабрь'.split(
                    '_'
                ),
        },
        monthsShort: {
            // по CLDR именно "июл." и "июн.", но какой смысл менять букву на точку?
            format: 'янв._февр._мар._апр._мая_июня_июля_авг._сент._окт._нояб._дек.'.split(
                '_'
            ),
            standalone:
                'янв._февр._март_апр._май_июнь_июль_авг._сент._окт._нояб._дек.'.split(
                    '_'
                ),
        },
        weekdays: {
            standalone:
                'воскресенье_понедельник_вторник_среда_четверг_пятница_суббота'.split(
                    '_'
                ),
            format: 'воскресенье_понедельник_вторник_среду_четверг_пятницу_субботу'.split(
                '_'
            ),
            isFormat: /\[ ?[Вв] ?(?:прошлую|следующую|эту)? ?] ?dddd/,
        },
        weekdaysShort: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'вс_пн_вт_ср_чт_пт_сб'.split('_'),
        monthsParse: monthsParse,
        longMonthsParse: monthsParse,
        shortMonthsParse: monthsParse,

        // полные названия с падежами, по три буквы, для некоторых, по 4 буквы, сокращения с точкой и без точки
        monthsRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // копия предыдущего
        monthsShortRegex:
            /^(январ[ья]|янв\.?|феврал[ья]|февр?\.?|марта?|мар\.?|апрел[ья]|апр\.?|ма[йя]|июн[ья]|июн\.?|июл[ья]|июл\.?|августа?|авг\.?|сентябр[ья]|сент?\.?|октябр[ья]|окт\.?|ноябр[ья]|нояб?\.?|декабр[ья]|дек\.?)/i,

        // полные названия с падежами
        monthsStrictRegex:
            /^(январ[яь]|феврал[яь]|марта?|апрел[яь]|ма[яй]|июн[яь]|июл[яь]|августа?|сентябр[яь]|октябр[яь]|ноябр[яь]|декабр[яь])/i,

        // Выражение, которое соответствует только сокращённым формам
        monthsShortStrictRegex:
            /^(янв\.|февр?\.|мар[т.]|апр\.|ма[яй]|июн[ья.]|июл[ья.]|авг\.|сент?\.|окт\.|нояб?\.|дек\.)/i,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY г.',
            LLL: 'D MMMM YYYY г., H:mm',
            LLLL: 'dddd, D MMMM YYYY г., H:mm',
        },
        calendar: {
            sameDay: '[Сегодня, в] LT',
            nextDay: '[Завтра, в] LT',
            lastDay: '[Вчера, в] LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В следующее] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В следующий] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В следующую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            lastWeek: function (now) {
                if (now.week() !== this.week()) {
                    switch (this.day()) {
                        case 0:
                            return '[В прошлое] dddd, [в] LT';
                        case 1:
                        case 2:
                        case 4:
                            return '[В прошлый] dddd, [в] LT';
                        case 3:
                        case 5:
                        case 6:
                            return '[В прошлую] dddd, [в] LT';
                    }
                } else {
                    if (this.day() === 2) {
                        return '[Во] dddd, [в] LT';
                    } else {
                        return '[В] dddd, [в] LT';
                    }
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'через %s',
            past: '%s назад',
            s: 'несколько секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'час',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            w: 'неделя',
            ww: relativeTimeWithPlural,
            M: 'месяц',
            MM: relativeTimeWithPlural,
            y: 'год',
            yy: relativeTimeWithPlural,
        },
        meridiemParse: /ночи|утра|дня|вечера/i,
        isPM: function (input) {
            return /^(дня|вечера)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночи';
            } else if (hour < 12) {
                return 'утра';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечера';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го|я)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                case 'w':
                case 'W':
                    return number + '-я';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ru;

})));


/***/ }),

/***/ 950:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sindhi [sd]
//! author : Narain Sagar : https://github.com/narainsagar

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوري',
            'فيبروري',
            'مارچ',
            'اپريل',
            'مئي',
            'جون',
            'جولاءِ',
            'آگسٽ',
            'سيپٽمبر',
            'آڪٽوبر',
            'نومبر',
            'ڊسمبر',
        ],
        days = ['آچر', 'سومر', 'اڱارو', 'اربع', 'خميس', 'جمع', 'ڇنڇر'];

    var sd = moment.defineLocale('sd', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[اڄ] LT',
            nextDay: '[سڀاڻي] LT',
            nextWeek: 'dddd [اڳين هفتي تي] LT',
            lastDay: '[ڪالهه] LT',
            lastWeek: '[گزريل هفتي] dddd [تي] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s پوء',
            past: '%s اڳ',
            s: 'چند سيڪنڊ',
            ss: '%d سيڪنڊ',
            m: 'هڪ منٽ',
            mm: '%d منٽ',
            h: 'هڪ ڪلاڪ',
            hh: '%d ڪلاڪ',
            d: 'هڪ ڏينهن',
            dd: '%d ڏينهن',
            M: 'هڪ مهينو',
            MM: '%d مهينا',
            y: 'هڪ سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sd;

})));


/***/ }),

/***/ 7930:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Northern Sami [se]
//! authors : Bård Rolstad Henriksen : https://github.com/karamell

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var se = moment.defineLocale('se', {
        months: 'ođđajagemánnu_guovvamánnu_njukčamánnu_cuoŋománnu_miessemánnu_geassemánnu_suoidnemánnu_borgemánnu_čakčamánnu_golggotmánnu_skábmamánnu_juovlamánnu'.split(
            '_'
        ),
        monthsShort:
            'ođđj_guov_njuk_cuo_mies_geas_suoi_borg_čakč_golg_skáb_juov'.split('_'),
        weekdays:
            'sotnabeaivi_vuossárga_maŋŋebárga_gaskavahkku_duorastat_bearjadat_lávvardat'.split(
                '_'
            ),
        weekdaysShort: 'sotn_vuos_maŋ_gask_duor_bear_láv'.split('_'),
        weekdaysMin: 's_v_m_g_d_b_L'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'MMMM D. [b.] YYYY',
            LLL: 'MMMM D. [b.] YYYY [ti.] HH:mm',
            LLLL: 'dddd, MMMM D. [b.] YYYY [ti.] HH:mm',
        },
        calendar: {
            sameDay: '[otne ti] LT',
            nextDay: '[ihttin ti] LT',
            nextWeek: 'dddd [ti] LT',
            lastDay: '[ikte ti] LT',
            lastWeek: '[ovddit] dddd [ti] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s geažes',
            past: 'maŋit %s',
            s: 'moadde sekunddat',
            ss: '%d sekunddat',
            m: 'okta minuhta',
            mm: '%d minuhtat',
            h: 'okta diimmu',
            hh: '%d diimmut',
            d: 'okta beaivi',
            dd: '%d beaivvit',
            M: 'okta mánnu',
            MM: '%d mánut',
            y: 'okta jahki',
            yy: '%d jagit',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return se;

})));


/***/ }),

/***/ 124:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Sinhalese [si]
//! author : Sampath Sitinamaluwa : https://github.com/sampathsris

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    /*jshint -W100*/
    var si = moment.defineLocale('si', {
        months: 'ජනවාරි_පෙබරවාරි_මාර්තු_අප්‍රේල්_මැයි_ජූනි_ජූලි_අගෝස්තු_සැප්තැම්බර්_ඔක්තෝබර්_නොවැම්බර්_දෙසැම්බර්'.split(
            '_'
        ),
        monthsShort: 'ජන_පෙබ_මාර්_අප්_මැයි_ජූනි_ජූලි_අගෝ_සැප්_ඔක්_නොවැ_දෙසැ'.split(
            '_'
        ),
        weekdays:
            'ඉරිදා_සඳුදා_අඟහරුවාදා_බදාදා_බ්‍රහස්පතින්දා_සිකුරාදා_සෙනසුරාදා'.split(
                '_'
            ),
        weekdaysShort: 'ඉරි_සඳු_අඟ_බදා_බ්‍රහ_සිකු_සෙන'.split('_'),
        weekdaysMin: 'ඉ_ස_අ_බ_බ්‍ර_සි_සෙ'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'a h:mm',
            LTS: 'a h:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY MMMM D',
            LLL: 'YYYY MMMM D, a h:mm',
            LLLL: 'YYYY MMMM D [වැනි] dddd, a h:mm:ss',
        },
        calendar: {
            sameDay: '[අද] LT[ට]',
            nextDay: '[හෙට] LT[ට]',
            nextWeek: 'dddd LT[ට]',
            lastDay: '[ඊයේ] LT[ට]',
            lastWeek: '[පසුගිය] dddd LT[ට]',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%sකින්',
            past: '%sකට පෙර',
            s: 'තත්පර කිහිපය',
            ss: 'තත්පර %d',
            m: 'මිනිත්තුව',
            mm: 'මිනිත්තු %d',
            h: 'පැය',
            hh: 'පැය %d',
            d: 'දිනය',
            dd: 'දින %d',
            M: 'මාසය',
            MM: 'මාස %d',
            y: 'වසර',
            yy: 'වසර %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2} වැනි/,
        ordinal: function (number) {
            return number + ' වැනි';
        },
        meridiemParse: /පෙර වරු|පස් වරු|පෙ.ව|ප.ව./,
        isPM: function (input) {
            return input === 'ප.ව.' || input === 'පස් වරු';
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? 'ප.ව.' : 'පස් වරු';
            } else {
                return isLower ? 'පෙ.ව.' : 'පෙර වරු';
            }
        },
    });

    return si;

})));


/***/ }),

/***/ 4249:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovak [sk]
//! author : Martin Minka : https://github.com/k2s
//! based on work of petrbela : https://github.com/petrbela

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months =
            'január_február_marec_apríl_máj_jún_júl_august_september_október_november_december'.split(
                '_'
            ),
        monthsShort = 'jan_feb_mar_apr_máj_jún_júl_aug_sep_okt_nov_dec'.split('_');
    function plural(n) {
        return n > 1 && n < 5;
    }
    function translate(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's': // a few seconds / in a few seconds / a few seconds ago
                return withoutSuffix || isFuture ? 'pár sekúnd' : 'pár sekundami';
            case 'ss': // 9 seconds / in 9 seconds / 9 seconds ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'sekundy' : 'sekúnd');
                } else {
                    return result + 'sekundami';
                }
            case 'm': // a minute / in a minute / a minute ago
                return withoutSuffix ? 'minúta' : isFuture ? 'minútu' : 'minútou';
            case 'mm': // 9 minutes / in 9 minutes / 9 minutes ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'minúty' : 'minút');
                } else {
                    return result + 'minútami';
                }
            case 'h': // an hour / in an hour / an hour ago
                return withoutSuffix ? 'hodina' : isFuture ? 'hodinu' : 'hodinou';
            case 'hh': // 9 hours / in 9 hours / 9 hours ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'hodiny' : 'hodín');
                } else {
                    return result + 'hodinami';
                }
            case 'd': // a day / in a day / a day ago
                return withoutSuffix || isFuture ? 'deň' : 'dňom';
            case 'dd': // 9 days / in 9 days / 9 days ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'dni' : 'dní');
                } else {
                    return result + 'dňami';
                }
            case 'M': // a month / in a month / a month ago
                return withoutSuffix || isFuture ? 'mesiac' : 'mesiacom';
            case 'MM': // 9 months / in 9 months / 9 months ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'mesiace' : 'mesiacov');
                } else {
                    return result + 'mesiacmi';
                }
            case 'y': // a year / in a year / a year ago
                return withoutSuffix || isFuture ? 'rok' : 'rokom';
            case 'yy': // 9 years / in 9 years / 9 years ago
                if (withoutSuffix || isFuture) {
                    return result + (plural(number) ? 'roky' : 'rokov');
                } else {
                    return result + 'rokmi';
                }
        }
    }

    var sk = moment.defineLocale('sk', {
        months: months,
        monthsShort: monthsShort,
        weekdays: 'nedeľa_pondelok_utorok_streda_štvrtok_piatok_sobota'.split('_'),
        weekdaysShort: 'ne_po_ut_st_št_pi_so'.split('_'),
        weekdaysMin: 'ne_po_ut_st_št_pi_so'.split('_'),
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[dnes o] LT',
            nextDay: '[zajtra o] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[v] dddd [o] LT';
                    case 3:
                        return '[v stredu o] LT';
                    case 4:
                        return '[vo štvrtok o] LT';
                    case 5:
                        return '[v piatok o] LT';
                    case 6:
                        return '[v sobotu o] LT';
                }
            },
            lastDay: '[včera o] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[minulú nedeľu o] LT';
                    case 1:
                    case 2:
                        return '[minulý] dddd [o] LT';
                    case 3:
                        return '[minulú stredu o] LT';
                    case 4:
                    case 5:
                        return '[minulý] dddd [o] LT';
                    case 6:
                        return '[minulú sobotu o] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pred %s',
            s: translate,
            ss: translate,
            m: translate,
            mm: translate,
            h: translate,
            hh: translate,
            d: translate,
            dd: translate,
            M: translate,
            MM: translate,
            y: translate,
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sk;

})));


/***/ }),

/***/ 4985:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Slovenian [sl]
//! author : Robert Sedovšek : https://github.com/sedovsek

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var result = number + ' ';
        switch (key) {
            case 's':
                return withoutSuffix || isFuture
                    ? 'nekaj sekund'
                    : 'nekaj sekundami';
            case 'ss':
                if (number === 1) {
                    result += withoutSuffix ? 'sekundo' : 'sekundi';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'sekundi' : 'sekundah';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'sekunde' : 'sekundah';
                } else {
                    result += 'sekund';
                }
                return result;
            case 'm':
                return withoutSuffix ? 'ena minuta' : 'eno minuto';
            case 'mm':
                if (number === 1) {
                    result += withoutSuffix ? 'minuta' : 'minuto';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'minuti' : 'minutama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'minute' : 'minutami';
                } else {
                    result += withoutSuffix || isFuture ? 'minut' : 'minutami';
                }
                return result;
            case 'h':
                return withoutSuffix ? 'ena ura' : 'eno uro';
            case 'hh':
                if (number === 1) {
                    result += withoutSuffix ? 'ura' : 'uro';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'uri' : 'urama';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'ure' : 'urami';
                } else {
                    result += withoutSuffix || isFuture ? 'ur' : 'urami';
                }
                return result;
            case 'd':
                return withoutSuffix || isFuture ? 'en dan' : 'enim dnem';
            case 'dd':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'dan' : 'dnem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevoma';
                } else {
                    result += withoutSuffix || isFuture ? 'dni' : 'dnevi';
                }
                return result;
            case 'M':
                return withoutSuffix || isFuture ? 'en mesec' : 'enim mesecem';
            case 'MM':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'mesec' : 'mesecem';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'meseca' : 'mesecema';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'mesece' : 'meseci';
                } else {
                    result += withoutSuffix || isFuture ? 'mesecev' : 'meseci';
                }
                return result;
            case 'y':
                return withoutSuffix || isFuture ? 'eno leto' : 'enim letom';
            case 'yy':
                if (number === 1) {
                    result += withoutSuffix || isFuture ? 'leto' : 'letom';
                } else if (number === 2) {
                    result += withoutSuffix || isFuture ? 'leti' : 'letoma';
                } else if (number < 5) {
                    result += withoutSuffix || isFuture ? 'leta' : 'leti';
                } else {
                    result += withoutSuffix || isFuture ? 'let' : 'leti';
                }
                return result;
        }
    }

    var sl = moment.defineLocale('sl', {
        months: 'januar_februar_marec_april_maj_junij_julij_avgust_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj._jun._jul._avg._sep._okt._nov._dec.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljek_torek_sreda_četrtek_petek_sobota'.split('_'),
        weekdaysShort: 'ned._pon._tor._sre._čet._pet._sob.'.split('_'),
        weekdaysMin: 'ne_po_to_sr_če_pe_so'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD. MM. YYYY',
            LL: 'D. MMMM YYYY',
            LLL: 'D. MMMM YYYY H:mm',
            LLLL: 'dddd, D. MMMM YYYY H:mm',
        },
        calendar: {
            sameDay: '[danes ob] LT',
            nextDay: '[jutri ob] LT',

            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[v] [nedeljo] [ob] LT';
                    case 3:
                        return '[v] [sredo] [ob] LT';
                    case 6:
                        return '[v] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[v] dddd [ob] LT';
                }
            },
            lastDay: '[včeraj ob] LT',
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[prejšnjo] [nedeljo] [ob] LT';
                    case 3:
                        return '[prejšnjo] [sredo] [ob] LT';
                    case 6:
                        return '[prejšnjo] [soboto] [ob] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[prejšnji] dddd [ob] LT';
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'čez %s',
            past: 'pred %s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sl;

})));


/***/ }),

/***/ 1104:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Albanian [sq]
//! author : Flakërim Ismani : https://github.com/flakerimi
//! author : Menelion Elensúle : https://github.com/Oire
//! author : Oerd Cukalla : https://github.com/oerd

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sq = moment.defineLocale('sq', {
        months: 'Janar_Shkurt_Mars_Prill_Maj_Qershor_Korrik_Gusht_Shtator_Tetor_Nëntor_Dhjetor'.split(
            '_'
        ),
        monthsShort: 'Jan_Shk_Mar_Pri_Maj_Qer_Kor_Gus_Sht_Tet_Nën_Dhj'.split('_'),
        weekdays: 'E Diel_E Hënë_E Martë_E Mërkurë_E Enjte_E Premte_E Shtunë'.split(
            '_'
        ),
        weekdaysShort: 'Die_Hën_Mar_Mër_Enj_Pre_Sht'.split('_'),
        weekdaysMin: 'D_H_Ma_Më_E_P_Sh'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /PD|MD/,
        isPM: function (input) {
            return input.charAt(0) === 'M';
        },
        meridiem: function (hours, minutes, isLower) {
            return hours < 12 ? 'PD' : 'MD';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Sot në] LT',
            nextDay: '[Nesër në] LT',
            nextWeek: 'dddd [në] LT',
            lastDay: '[Dje në] LT',
            lastWeek: 'dddd [e kaluar në] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'në %s',
            past: '%s më parë',
            s: 'disa sekonda',
            ss: '%d sekonda',
            m: 'një minutë',
            mm: '%d minuta',
            h: 'një orë',
            hh: '%d orë',
            d: 'një ditë',
            dd: '%d ditë',
            M: 'një muaj',
            MM: '%d muaj',
            y: 'një vit',
            yy: '%d vite',
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sq;

})));


/***/ }),

/***/ 9915:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian Cyrillic [sr-cyrl]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['секунда', 'секунде', 'секунди'],
            m: ['један минут', 'једног минута'],
            mm: ['минут', 'минута', 'минута'],
            h: ['један сат', 'једног сата'],
            hh: ['сат', 'сата', 'сати'],
            d: ['један дан', 'једног дана'],
            dd: ['дан', 'дана', 'дана'],
            M: ['један месец', 'једног месеца'],
            MM: ['месец', 'месеца', 'месеци'],
            y: ['једну годину', 'једне године'],
            yy: ['годину', 'године', 'година'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'једна година';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'годину') {
                return number + ' година';
            }

            return number + ' ' + word;
        },
    };

    var srCyrl = moment.defineLocale('sr-cyrl', {
        months: 'јануар_фебруар_март_април_мај_јун_јул_август_септембар_октобар_новембар_децембар'.split(
            '_'
        ),
        monthsShort:
            'јан._феб._мар._апр._мај_јун_јул_авг._сеп._окт._нов._дец.'.split('_'),
        monthsParseExact: true,
        weekdays: 'недеља_понедељак_уторак_среда_четвртак_петак_субота'.split('_'),
        weekdaysShort: 'нед._пон._уто._сре._чет._пет._суб.'.split('_'),
        weekdaysMin: 'не_по_ут_ср_че_пе_су'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[данас у] LT',
            nextDay: '[сутра у] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[у] [недељу] [у] LT';
                    case 3:
                        return '[у] [среду] [у] LT';
                    case 6:
                        return '[у] [суботу] [у] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[у] dddd [у] LT';
                }
            },
            lastDay: '[јуче у] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[прошле] [недеље] [у] LT',
                    '[прошлог] [понедељка] [у] LT',
                    '[прошлог] [уторка] [у] LT',
                    '[прошле] [среде] [у] LT',
                    '[прошлог] [четвртка] [у] LT',
                    '[прошлог] [петка] [у] LT',
                    '[прошле] [суботе] [у] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: 'пре %s',
            s: 'неколико секунди',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return srCyrl;

})));


/***/ }),

/***/ 9131:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Serbian [sr]
//! author : Milan Janačković<milanjanackovic@gmail.com> : https://github.com/milan-j
//! author : Stefan Crnjaković <stefan@hotmail.rs> : https://github.com/crnjakovic

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var translator = {
        words: {
            //Different grammatical cases
            ss: ['sekunda', 'sekunde', 'sekundi'],
            m: ['jedan minut', 'jednog minuta'],
            mm: ['minut', 'minuta', 'minuta'],
            h: ['jedan sat', 'jednog sata'],
            hh: ['sat', 'sata', 'sati'],
            d: ['jedan dan', 'jednog dana'],
            dd: ['dan', 'dana', 'dana'],
            M: ['jedan mesec', 'jednog meseca'],
            MM: ['mesec', 'meseca', 'meseci'],
            y: ['jednu godinu', 'jedne godine'],
            yy: ['godinu', 'godine', 'godina'],
        },
        correctGrammaticalCase: function (number, wordKey) {
            if (
                number % 10 >= 1 &&
                number % 10 <= 4 &&
                (number % 100 < 10 || number % 100 >= 20)
            ) {
                return number % 10 === 1 ? wordKey[0] : wordKey[1];
            }
            return wordKey[2];
        },
        translate: function (number, withoutSuffix, key, isFuture) {
            var wordKey = translator.words[key],
                word;

            if (key.length === 1) {
                // Nominativ
                if (key === 'y' && withoutSuffix) return 'jedna godina';
                return isFuture || withoutSuffix ? wordKey[0] : wordKey[1];
            }

            word = translator.correctGrammaticalCase(number, wordKey);
            // Nominativ
            if (key === 'yy' && withoutSuffix && word === 'godinu') {
                return number + ' godina';
            }

            return number + ' ' + word;
        },
    };

    var sr = moment.defineLocale('sr', {
        months: 'januar_februar_mart_april_maj_jun_jul_avgust_septembar_oktobar_novembar_decembar'.split(
            '_'
        ),
        monthsShort:
            'jan._feb._mar._apr._maj_jun_jul_avg._sep._okt._nov._dec.'.split('_'),
        monthsParseExact: true,
        weekdays: 'nedelja_ponedeljak_utorak_sreda_četvrtak_petak_subota'.split(
            '_'
        ),
        weekdaysShort: 'ned._pon._uto._sre._čet._pet._sub.'.split('_'),
        weekdaysMin: 'ne_po_ut_sr_če_pe_su'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'D. M. YYYY.',
            LL: 'D. MMMM YYYY.',
            LLL: 'D. MMMM YYYY. H:mm',
            LLLL: 'dddd, D. MMMM YYYY. H:mm',
        },
        calendar: {
            sameDay: '[danas u] LT',
            nextDay: '[sutra u] LT',
            nextWeek: function () {
                switch (this.day()) {
                    case 0:
                        return '[u] [nedelju] [u] LT';
                    case 3:
                        return '[u] [sredu] [u] LT';
                    case 6:
                        return '[u] [subotu] [u] LT';
                    case 1:
                    case 2:
                    case 4:
                    case 5:
                        return '[u] dddd [u] LT';
                }
            },
            lastDay: '[juče u] LT',
            lastWeek: function () {
                var lastWeekDays = [
                    '[prošle] [nedelje] [u] LT',
                    '[prošlog] [ponedeljka] [u] LT',
                    '[prošlog] [utorka] [u] LT',
                    '[prošle] [srede] [u] LT',
                    '[prošlog] [četvrtka] [u] LT',
                    '[prošlog] [petka] [u] LT',
                    '[prošle] [subote] [u] LT',
                ];
                return lastWeekDays[this.day()];
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'za %s',
            past: 'pre %s',
            s: 'nekoliko sekundi',
            ss: translator.translate,
            m: translator.translate,
            mm: translator.translate,
            h: translator.translate,
            hh: translator.translate,
            d: translator.translate,
            dd: translator.translate,
            M: translator.translate,
            MM: translator.translate,
            y: translator.translate,
            yy: translator.translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sr;

})));


/***/ }),

/***/ 5893:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : siSwati [ss]
//! author : Nicolai Davies<mail@nicolai.io> : https://github.com/nicolaidavies

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ss = moment.defineLocale('ss', {
        months: "Bhimbidvwane_Indlovana_Indlov'lenkhulu_Mabasa_Inkhwekhweti_Inhlaba_Kholwane_Ingci_Inyoni_Imphala_Lweti_Ingongoni".split(
            '_'
        ),
        monthsShort: 'Bhi_Ina_Inu_Mab_Ink_Inh_Kho_Igc_Iny_Imp_Lwe_Igo'.split('_'),
        weekdays:
            'Lisontfo_Umsombuluko_Lesibili_Lesitsatfu_Lesine_Lesihlanu_Umgcibelo'.split(
                '_'
            ),
        weekdaysShort: 'Lis_Umb_Lsb_Les_Lsi_Lsh_Umg'.split('_'),
        weekdaysMin: 'Li_Us_Lb_Lt_Ls_Lh_Ug'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Namuhla nga] LT',
            nextDay: '[Kusasa nga] LT',
            nextWeek: 'dddd [nga] LT',
            lastDay: '[Itolo nga] LT',
            lastWeek: 'dddd [leliphelile] [nga] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'nga %s',
            past: 'wenteka nga %s',
            s: 'emizuzwana lomcane',
            ss: '%d mzuzwana',
            m: 'umzuzu',
            mm: '%d emizuzu',
            h: 'lihora',
            hh: '%d emahora',
            d: 'lilanga',
            dd: '%d emalanga',
            M: 'inyanga',
            MM: '%d tinyanga',
            y: 'umnyaka',
            yy: '%d iminyaka',
        },
        meridiemParse: /ekuseni|emini|entsambama|ebusuku/,
        meridiem: function (hours, minutes, isLower) {
            if (hours < 11) {
                return 'ekuseni';
            } else if (hours < 15) {
                return 'emini';
            } else if (hours < 19) {
                return 'entsambama';
            } else {
                return 'ebusuku';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'ekuseni') {
                return hour;
            } else if (meridiem === 'emini') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'entsambama' || meridiem === 'ebusuku') {
                if (hour === 0) {
                    return 0;
                }
                return hour + 12;
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: '%d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ss;

})));


/***/ }),

/***/ 8760:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swedish [sv]
//! author : Jens Alm : https://github.com/ulmus

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sv = moment.defineLocale('sv', {
        months: 'januari_februari_mars_april_maj_juni_juli_augusti_september_oktober_november_december'.split(
            '_'
        ),
        monthsShort: 'jan_feb_mar_apr_maj_jun_jul_aug_sep_okt_nov_dec'.split('_'),
        weekdays: 'söndag_måndag_tisdag_onsdag_torsdag_fredag_lördag'.split('_'),
        weekdaysShort: 'sön_mån_tis_ons_tor_fre_lör'.split('_'),
        weekdaysMin: 'sö_må_ti_on_to_fr_lö'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY [kl.] HH:mm',
            LLLL: 'dddd D MMMM YYYY [kl.] HH:mm',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Idag] LT',
            nextDay: '[Imorgon] LT',
            lastDay: '[Igår] LT',
            nextWeek: '[På] dddd LT',
            lastWeek: '[I] dddd[s] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'om %s',
            past: 'för %s sedan',
            s: 'några sekunder',
            ss: '%d sekunder',
            m: 'en minut',
            mm: '%d minuter',
            h: 'en timme',
            hh: '%d timmar',
            d: 'en dag',
            dd: '%d dagar',
            M: 'en månad',
            MM: '%d månader',
            y: 'ett år',
            yy: '%d år',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(\:e|\:a)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? ':e'
                        : b === 1
                        ? ':a'
                        : b === 2
                        ? ':a'
                        : b === 3
                        ? ':e'
                        : ':e';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return sv;

})));


/***/ }),

/***/ 1172:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Swahili [sw]
//! author : Fahad Kassim : https://github.com/fadsel

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var sw = moment.defineLocale('sw', {
        months: 'Januari_Februari_Machi_Aprili_Mei_Juni_Julai_Agosti_Septemba_Oktoba_Novemba_Desemba'.split(
            '_'
        ),
        monthsShort: 'Jan_Feb_Mac_Apr_Mei_Jun_Jul_Ago_Sep_Okt_Nov_Des'.split('_'),
        weekdays:
            'Jumapili_Jumatatu_Jumanne_Jumatano_Alhamisi_Ijumaa_Jumamosi'.split(
                '_'
            ),
        weekdaysShort: 'Jpl_Jtat_Jnne_Jtan_Alh_Ijm_Jmos'.split('_'),
        weekdaysMin: 'J2_J3_J4_J5_Al_Ij_J1'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'hh:mm A',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[leo saa] LT',
            nextDay: '[kesho saa] LT',
            nextWeek: '[wiki ijayo] dddd [saat] LT',
            lastDay: '[jana] LT',
            lastWeek: '[wiki iliyopita] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s baadaye',
            past: 'tokea %s',
            s: 'hivi punde',
            ss: 'sekunde %d',
            m: 'dakika moja',
            mm: 'dakika %d',
            h: 'saa limoja',
            hh: 'masaa %d',
            d: 'siku moja',
            dd: 'siku %d',
            M: 'mwezi mmoja',
            MM: 'miezi %d',
            y: 'mwaka mmoja',
            yy: 'miaka %d',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return sw;

})));


/***/ }),

/***/ 7333:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tamil [ta]
//! author : Arjunkumar Krishnamoorthy : https://github.com/tk120404

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var symbolMap = {
            1: '௧',
            2: '௨',
            3: '௩',
            4: '௪',
            5: '௫',
            6: '௬',
            7: '௭',
            8: '௮',
            9: '௯',
            0: '௦',
        },
        numberMap = {
            '௧': '1',
            '௨': '2',
            '௩': '3',
            '௪': '4',
            '௫': '5',
            '௬': '6',
            '௭': '7',
            '௮': '8',
            '௯': '9',
            '௦': '0',
        };

    var ta = moment.defineLocale('ta', {
        months: 'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
            '_'
        ),
        monthsShort:
            'ஜனவரி_பிப்ரவரி_மார்ச்_ஏப்ரல்_மே_ஜூன்_ஜூலை_ஆகஸ்ட்_செப்டெம்பர்_அக்டோபர்_நவம்பர்_டிசம்பர்'.split(
                '_'
            ),
        weekdays:
            'ஞாயிற்றுக்கிழமை_திங்கட்கிழமை_செவ்வாய்கிழமை_புதன்கிழமை_வியாழக்கிழமை_வெள்ளிக்கிழமை_சனிக்கிழமை'.split(
                '_'
            ),
        weekdaysShort: 'ஞாயிறு_திங்கள்_செவ்வாய்_புதன்_வியாழன்_வெள்ளி_சனி'.split(
            '_'
        ),
        weekdaysMin: 'ஞா_தி_செ_பு_வி_வெ_ச'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, HH:mm',
            LLLL: 'dddd, D MMMM YYYY, HH:mm',
        },
        calendar: {
            sameDay: '[இன்று] LT',
            nextDay: '[நாளை] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[நேற்று] LT',
            lastWeek: '[கடந்த வாரம்] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s இல்',
            past: '%s முன்',
            s: 'ஒரு சில விநாடிகள்',
            ss: '%d விநாடிகள்',
            m: 'ஒரு நிமிடம்',
            mm: '%d நிமிடங்கள்',
            h: 'ஒரு மணி நேரம்',
            hh: '%d மணி நேரம்',
            d: 'ஒரு நாள்',
            dd: '%d நாட்கள்',
            M: 'ஒரு மாதம்',
            MM: '%d மாதங்கள்',
            y: 'ஒரு வருடம்',
            yy: '%d ஆண்டுகள்',
        },
        dayOfMonthOrdinalParse: /\d{1,2}வது/,
        ordinal: function (number) {
            return number + 'வது';
        },
        preparse: function (string) {
            return string.replace(/[௧௨௩௪௫௬௭௮௯௦]/g, function (match) {
                return numberMap[match];
            });
        },
        postformat: function (string) {
            return string.replace(/\d/g, function (match) {
                return symbolMap[match];
            });
        },
        // refer http://ta.wikipedia.org/s/1er1
        meridiemParse: /யாமம்|வைகறை|காலை|நண்பகல்|எற்பாடு|மாலை/,
        meridiem: function (hour, minute, isLower) {
            if (hour < 2) {
                return ' யாமம்';
            } else if (hour < 6) {
                return ' வைகறை'; // வைகறை
            } else if (hour < 10) {
                return ' காலை'; // காலை
            } else if (hour < 14) {
                return ' நண்பகல்'; // நண்பகல்
            } else if (hour < 18) {
                return ' எற்பாடு'; // எற்பாடு
            } else if (hour < 22) {
                return ' மாலை'; // மாலை
            } else {
                return ' யாமம்';
            }
        },
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'யாமம்') {
                return hour < 2 ? hour : hour + 12;
            } else if (meridiem === 'வைகறை' || meridiem === 'காலை') {
                return hour;
            } else if (meridiem === 'நண்பகல்') {
                return hour >= 10 ? hour : hour + 12;
            } else {
                return hour + 12;
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return ta;

})));


/***/ }),

/***/ 3110:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Telugu [te]
//! author : Krishna Chaitanya Thota : https://github.com/kcthota

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var te = moment.defineLocale('te', {
        months: 'జనవరి_ఫిబ్రవరి_మార్చి_ఏప్రిల్_మే_జూన్_జులై_ఆగస్టు_సెప్టెంబర్_అక్టోబర్_నవంబర్_డిసెంబర్'.split(
            '_'
        ),
        monthsShort:
            'జన._ఫిబ్ర._మార్చి_ఏప్రి._మే_జూన్_జులై_ఆగ._సెప్._అక్టో._నవ._డిసె.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'ఆదివారం_సోమవారం_మంగళవారం_బుధవారం_గురువారం_శుక్రవారం_శనివారం'.split(
                '_'
            ),
        weekdaysShort: 'ఆది_సోమ_మంగళ_బుధ_గురు_శుక్ర_శని'.split('_'),
        weekdaysMin: 'ఆ_సో_మం_బు_గు_శు_శ'.split('_'),
        longDateFormat: {
            LT: 'A h:mm',
            LTS: 'A h:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY, A h:mm',
            LLLL: 'dddd, D MMMM YYYY, A h:mm',
        },
        calendar: {
            sameDay: '[నేడు] LT',
            nextDay: '[రేపు] LT',
            nextWeek: 'dddd, LT',
            lastDay: '[నిన్న] LT',
            lastWeek: '[గత] dddd, LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s లో',
            past: '%s క్రితం',
            s: 'కొన్ని క్షణాలు',
            ss: '%d సెకన్లు',
            m: 'ఒక నిమిషం',
            mm: '%d నిమిషాలు',
            h: 'ఒక గంట',
            hh: '%d గంటలు',
            d: 'ఒక రోజు',
            dd: '%d రోజులు',
            M: 'ఒక నెల',
            MM: '%d నెలలు',
            y: 'ఒక సంవత్సరం',
            yy: '%d సంవత్సరాలు',
        },
        dayOfMonthOrdinalParse: /\d{1,2}వ/,
        ordinal: '%dవ',
        meridiemParse: /రాత్రి|ఉదయం|మధ్యాహ్నం|సాయంత్రం/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'రాత్రి') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'ఉదయం') {
                return hour;
            } else if (meridiem === 'మధ్యాహ్నం') {
                return hour >= 10 ? hour : hour + 12;
            } else if (meridiem === 'సాయంత్రం') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'రాత్రి';
            } else if (hour < 10) {
                return 'ఉదయం';
            } else if (hour < 17) {
                return 'మధ్యాహ్నం';
            } else if (hour < 20) {
                return 'సాయంత్రం';
            } else {
                return 'రాత్రి';
            }
        },
        week: {
            dow: 0, // Sunday is the first day of the week.
            doy: 6, // The week that contains Jan 6th is the first week of the year.
        },
    });

    return te;

})));


/***/ }),

/***/ 2095:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tetun Dili (East Timor) [tet]
//! author : Joshua Brooks : https://github.com/joshbrooks
//! author : Onorio De J. Afonso : https://github.com/marobo
//! author : Sonia Simoes : https://github.com/soniasimoes

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tet = moment.defineLocale('tet', {
        months: 'Janeiru_Fevereiru_Marsu_Abril_Maiu_Juñu_Jullu_Agustu_Setembru_Outubru_Novembru_Dezembru'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez'.split('_'),
        weekdays: 'Domingu_Segunda_Tersa_Kuarta_Kinta_Sesta_Sabadu'.split('_'),
        weekdaysShort: 'Dom_Seg_Ters_Kua_Kint_Sest_Sab'.split('_'),
        weekdaysMin: 'Do_Seg_Te_Ku_Ki_Ses_Sa'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Ohin iha] LT',
            nextDay: '[Aban iha] LT',
            nextWeek: 'dddd [iha] LT',
            lastDay: '[Horiseik iha] LT',
            lastWeek: 'dddd [semana kotuk] [iha] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'iha %s',
            past: '%s liuba',
            s: 'segundu balun',
            ss: 'segundu %d',
            m: 'minutu ida',
            mm: 'minutu %d',
            h: 'oras ida',
            hh: 'oras %d',
            d: 'loron ida',
            dd: 'loron %d',
            M: 'fulan ida',
            MM: 'fulan %d',
            y: 'tinan ida',
            yy: 'tinan %d',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(st|nd|rd|th)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tet;

})));


/***/ }),

/***/ 7321:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tajik [tg]
//! author : Orif N. Jr. : https://github.com/orif-jr

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        0: '-ум',
        1: '-ум',
        2: '-юм',
        3: '-юм',
        4: '-ум',
        5: '-ум',
        6: '-ум',
        7: '-ум',
        8: '-ум',
        9: '-ум',
        10: '-ум',
        12: '-ум',
        13: '-ум',
        20: '-ум',
        30: '-юм',
        40: '-ум',
        50: '-ум',
        60: '-ум',
        70: '-ум',
        80: '-ум',
        90: '-ум',
        100: '-ум',
    };

    var tg = moment.defineLocale('tg', {
        months: {
            format: 'январи_феврали_марти_апрели_майи_июни_июли_августи_сентябри_октябри_ноябри_декабри'.split(
                '_'
            ),
            standalone:
                'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
                    '_'
                ),
        },
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'якшанбе_душанбе_сешанбе_чоршанбе_панҷшанбе_ҷумъа_шанбе'.split(
            '_'
        ),
        weekdaysShort: 'яшб_дшб_сшб_чшб_пшб_ҷум_шнб'.split('_'),
        weekdaysMin: 'яш_дш_сш_чш_пш_ҷм_шб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Имрӯз соати] LT',
            nextDay: '[Фардо соати] LT',
            lastDay: '[Дирӯз соати] LT',
            nextWeek: 'dddd[и] [ҳафтаи оянда соати] LT',
            lastWeek: 'dddd[и] [ҳафтаи гузашта соати] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'баъди %s',
            past: '%s пеш',
            s: 'якчанд сония',
            m: 'як дақиқа',
            mm: '%d дақиқа',
            h: 'як соат',
            hh: '%d соат',
            d: 'як рӯз',
            dd: '%d рӯз',
            M: 'як моҳ',
            MM: '%d моҳ',
            y: 'як сол',
            yy: '%d сол',
        },
        meridiemParse: /шаб|субҳ|рӯз|бегоҳ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === 'шаб') {
                return hour < 4 ? hour : hour + 12;
            } else if (meridiem === 'субҳ') {
                return hour;
            } else if (meridiem === 'рӯз') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === 'бегоҳ') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'шаб';
            } else if (hour < 11) {
                return 'субҳ';
            } else if (hour < 16) {
                return 'рӯз';
            } else if (hour < 19) {
                return 'бегоҳ';
            } else {
                return 'шаб';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(ум|юм)/,
        ordinal: function (number) {
            var a = number % 10,
                b = number >= 100 ? 100 : null;
            return number + (suffixes[number] || suffixes[a] || suffixes[b]);
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1th is the first week of the year.
        },
    });

    return tg;

})));


/***/ }),

/***/ 9041:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Thai [th]
//! author : Kridsada Thanabulpong : https://github.com/sirn

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var th = moment.defineLocale('th', {
        months: 'มกราคม_กุมภาพันธ์_มีนาคม_เมษายน_พฤษภาคม_มิถุนายน_กรกฎาคม_สิงหาคม_กันยายน_ตุลาคม_พฤศจิกายน_ธันวาคม'.split(
            '_'
        ),
        monthsShort:
            'ม.ค._ก.พ._มี.ค._เม.ย._พ.ค._มิ.ย._ก.ค._ส.ค._ก.ย._ต.ค._พ.ย._ธ.ค.'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัสบดี_ศุกร์_เสาร์'.split('_'),
        weekdaysShort: 'อาทิตย์_จันทร์_อังคาร_พุธ_พฤหัส_ศุกร์_เสาร์'.split('_'), // yes, three characters difference
        weekdaysMin: 'อา._จ._อ._พ._พฤ._ศ._ส.'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'H:mm',
            LTS: 'H:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY เวลา H:mm',
            LLLL: 'วันddddที่ D MMMM YYYY เวลา H:mm',
        },
        meridiemParse: /ก่อนเที่ยง|หลังเที่ยง/,
        isPM: function (input) {
            return input === 'หลังเที่ยง';
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'ก่อนเที่ยง';
            } else {
                return 'หลังเที่ยง';
            }
        },
        calendar: {
            sameDay: '[วันนี้ เวลา] LT',
            nextDay: '[พรุ่งนี้ เวลา] LT',
            nextWeek: 'dddd[หน้า เวลา] LT',
            lastDay: '[เมื่อวานนี้ เวลา] LT',
            lastWeek: '[วัน]dddd[ที่แล้ว เวลา] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'อีก %s',
            past: '%sที่แล้ว',
            s: 'ไม่กี่วินาที',
            ss: '%d วินาที',
            m: '1 นาที',
            mm: '%d นาที',
            h: '1 ชั่วโมง',
            hh: '%d ชั่วโมง',
            d: '1 วัน',
            dd: '%d วัน',
            w: '1 สัปดาห์',
            ww: '%d สัปดาห์',
            M: '1 เดือน',
            MM: '%d เดือน',
            y: '1 ปี',
            yy: '%d ปี',
        },
    });

    return th;

})));


/***/ }),

/***/ 9005:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkmen [tk]
//! author : Atamyrat Abdyrahmanov : https://github.com/atamyratabdy

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inji",
        5: "'inji",
        8: "'inji",
        70: "'inji",
        80: "'inji",
        2: "'nji",
        7: "'nji",
        20: "'nji",
        50: "'nji",
        3: "'ünji",
        4: "'ünji",
        100: "'ünji",
        6: "'njy",
        9: "'unjy",
        10: "'unjy",
        30: "'unjy",
        60: "'ynjy",
        90: "'ynjy",
    };

    var tk = moment.defineLocale('tk', {
        months: 'Ýanwar_Fewral_Mart_Aprel_Maý_Iýun_Iýul_Awgust_Sentýabr_Oktýabr_Noýabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Ýan_Few_Mar_Apr_Maý_Iýn_Iýl_Awg_Sen_Okt_Noý_Dek'.split('_'),
        weekdays: 'Ýekşenbe_Duşenbe_Sişenbe_Çarşenbe_Penşenbe_Anna_Şenbe'.split(
            '_'
        ),
        weekdaysShort: 'Ýek_Duş_Siş_Çar_Pen_Ann_Şen'.split('_'),
        weekdaysMin: 'Ýk_Dş_Sş_Çr_Pn_An_Şn'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün sagat] LT',
            nextDay: '[ertir sagat] LT',
            nextWeek: '[indiki] dddd [sagat] LT',
            lastDay: '[düýn] LT',
            lastWeek: '[geçen] dddd [sagat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s soň',
            past: '%s öň',
            s: 'birnäçe sekunt',
            m: 'bir minut',
            mm: '%d minut',
            h: 'bir sagat',
            hh: '%d sagat',
            d: 'bir gün',
            dd: '%d gün',
            M: 'bir aý',
            MM: '%d aý',
            y: 'bir ýyl',
            yy: '%d ýyl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'unjy";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tk;

})));


/***/ }),

/***/ 5768:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Tagalog (Philippines) [tl-ph]
//! author : Dan Hagman : https://github.com/hagmandan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tlPh = moment.defineLocale('tl-ph', {
        months: 'Enero_Pebrero_Marso_Abril_Mayo_Hunyo_Hulyo_Agosto_Setyembre_Oktubre_Nobyembre_Disyembre'.split(
            '_'
        ),
        monthsShort: 'Ene_Peb_Mar_Abr_May_Hun_Hul_Ago_Set_Okt_Nob_Dis'.split('_'),
        weekdays: 'Linggo_Lunes_Martes_Miyerkules_Huwebes_Biyernes_Sabado'.split(
            '_'
        ),
        weekdaysShort: 'Lin_Lun_Mar_Miy_Huw_Biy_Sab'.split('_'),
        weekdaysMin: 'Li_Lu_Ma_Mi_Hu_Bi_Sab'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'MM/D/YYYY',
            LL: 'MMMM D, YYYY',
            LLL: 'MMMM D, YYYY HH:mm',
            LLLL: 'dddd, MMMM DD, YYYY HH:mm',
        },
        calendar: {
            sameDay: 'LT [ngayong araw]',
            nextDay: '[Bukas ng] LT',
            nextWeek: 'LT [sa susunod na] dddd',
            lastDay: 'LT [kahapon]',
            lastWeek: 'LT [noong nakaraang] dddd',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'sa loob ng %s',
            past: '%s ang nakalipas',
            s: 'ilang segundo',
            ss: '%d segundo',
            m: 'isang minuto',
            mm: '%d minuto',
            h: 'isang oras',
            hh: '%d oras',
            d: 'isang araw',
            dd: '%d araw',
            M: 'isang buwan',
            MM: '%d buwan',
            y: 'isang taon',
            yy: '%d taon',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlPh;

})));


/***/ }),

/***/ 9444:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Klingon [tlh]
//! author : Dominika Kruk : https://github.com/amaranthrose

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var numbersNouns = 'pagh_wa’_cha’_wej_loS_vagh_jav_Soch_chorgh_Hut'.split('_');

    function translateFuture(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'leS'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'waQ'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'nem'
                : time + ' pIq';
        return time;
    }

    function translatePast(output) {
        var time = output;
        time =
            output.indexOf('jaj') !== -1
                ? time.slice(0, -3) + 'Hu’'
                : output.indexOf('jar') !== -1
                ? time.slice(0, -3) + 'wen'
                : output.indexOf('DIS') !== -1
                ? time.slice(0, -3) + 'ben'
                : time + ' ret';
        return time;
    }

    function translate(number, withoutSuffix, string, isFuture) {
        var numberNoun = numberAsNoun(number);
        switch (string) {
            case 'ss':
                return numberNoun + ' lup';
            case 'mm':
                return numberNoun + ' tup';
            case 'hh':
                return numberNoun + ' rep';
            case 'dd':
                return numberNoun + ' jaj';
            case 'MM':
                return numberNoun + ' jar';
            case 'yy':
                return numberNoun + ' DIS';
        }
    }

    function numberAsNoun(number) {
        var hundred = Math.floor((number % 1000) / 100),
            ten = Math.floor((number % 100) / 10),
            one = number % 10,
            word = '';
        if (hundred > 0) {
            word += numbersNouns[hundred] + 'vatlh';
        }
        if (ten > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[ten] + 'maH';
        }
        if (one > 0) {
            word += (word !== '' ? ' ' : '') + numbersNouns[one];
        }
        return word === '' ? 'pagh' : word;
    }

    var tlh = moment.defineLocale('tlh', {
        months: 'tera’ jar wa’_tera’ jar cha’_tera’ jar wej_tera’ jar loS_tera’ jar vagh_tera’ jar jav_tera’ jar Soch_tera’ jar chorgh_tera’ jar Hut_tera’ jar wa’maH_tera’ jar wa’maH wa’_tera’ jar wa’maH cha’'.split(
            '_'
        ),
        monthsShort:
            'jar wa’_jar cha’_jar wej_jar loS_jar vagh_jar jav_jar Soch_jar chorgh_jar Hut_jar wa’maH_jar wa’maH wa’_jar wa’maH cha’'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split(
            '_'
        ),
        weekdaysShort:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        weekdaysMin:
            'lojmItjaj_DaSjaj_povjaj_ghItlhjaj_loghjaj_buqjaj_ghInjaj'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[DaHjaj] LT',
            nextDay: '[wa’leS] LT',
            nextWeek: 'LLL',
            lastDay: '[wa’Hu’] LT',
            lastWeek: 'LLL',
            sameElse: 'L',
        },
        relativeTime: {
            future: translateFuture,
            past: translatePast,
            s: 'puS lup',
            ss: translate,
            m: 'wa’ tup',
            mm: translate,
            h: 'wa’ rep',
            hh: translate,
            d: 'wa’ jaj',
            dd: translate,
            M: 'wa’ jar',
            MM: translate,
            y: 'wa’ DIS',
            yy: translate,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return tlh;

})));


/***/ }),

/***/ 2397:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Turkish [tr]
//! authors : Erhan Gundogan : https://github.com/erhangundogan,
//!           Burak Yiğit Kaya: https://github.com/BYK

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var suffixes = {
        1: "'inci",
        5: "'inci",
        8: "'inci",
        70: "'inci",
        80: "'inci",
        2: "'nci",
        7: "'nci",
        20: "'nci",
        50: "'nci",
        3: "'üncü",
        4: "'üncü",
        100: "'üncü",
        6: "'ncı",
        9: "'uncu",
        10: "'uncu",
        30: "'uncu",
        60: "'ıncı",
        90: "'ıncı",
    };

    var tr = moment.defineLocale('tr', {
        months: 'Ocak_Şubat_Mart_Nisan_Mayıs_Haziran_Temmuz_Ağustos_Eylül_Ekim_Kasım_Aralık'.split(
            '_'
        ),
        monthsShort: 'Oca_Şub_Mar_Nis_May_Haz_Tem_Ağu_Eyl_Eki_Kas_Ara'.split('_'),
        weekdays: 'Pazar_Pazartesi_Salı_Çarşamba_Perşembe_Cuma_Cumartesi'.split(
            '_'
        ),
        weekdaysShort: 'Paz_Pzt_Sal_Çar_Per_Cum_Cmt'.split('_'),
        weekdaysMin: 'Pz_Pt_Sa_Ça_Pe_Cu_Ct'.split('_'),
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'öö' : 'ÖÖ';
            } else {
                return isLower ? 'ös' : 'ÖS';
            }
        },
        meridiemParse: /öö|ÖÖ|ös|ÖS/,
        isPM: function (input) {
            return input === 'ös' || input === 'ÖS';
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[bugün saat] LT',
            nextDay: '[yarın saat] LT',
            nextWeek: '[gelecek] dddd [saat] LT',
            lastDay: '[dün] LT',
            lastWeek: '[geçen] dddd [saat] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s sonra',
            past: '%s önce',
            s: 'birkaç saniye',
            ss: '%d saniye',
            m: 'bir dakika',
            mm: '%d dakika',
            h: 'bir saat',
            hh: '%d saat',
            d: 'bir gün',
            dd: '%d gün',
            w: 'bir hafta',
            ww: '%d hafta',
            M: 'bir ay',
            MM: '%d ay',
            y: 'bir yıl',
            yy: '%d yıl',
        },
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'Do':
                case 'DD':
                    return number;
                default:
                    if (number === 0) {
                        // special case for zero
                        return number + "'ıncı";
                    }
                    var a = number % 10,
                        b = (number % 100) - a,
                        c = number >= 100 ? 100 : null;
                    return number + (suffixes[a] || suffixes[b] || suffixes[c]);
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return tr;

})));


/***/ }),

/***/ 8254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Talossan [tzl]
//! author : Robin van der Vliet : https://github.com/robin0van0der0v
//! author : Iustì Canun

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    // After the year there should be a slash and the amount of years since December 26, 1979 in Roman numerals.
    // This is currently too difficult (maybe even impossible) to add.
    var tzl = moment.defineLocale('tzl', {
        months: 'Januar_Fevraglh_Març_Avrïu_Mai_Gün_Julia_Guscht_Setemvar_Listopäts_Noemvar_Zecemvar'.split(
            '_'
        ),
        monthsShort: 'Jan_Fev_Mar_Avr_Mai_Gün_Jul_Gus_Set_Lis_Noe_Zec'.split('_'),
        weekdays: 'Súladi_Lúneçi_Maitzi_Márcuri_Xhúadi_Viénerçi_Sáturi'.split('_'),
        weekdaysShort: 'Súl_Lún_Mai_Már_Xhú_Vié_Sát'.split('_'),
        weekdaysMin: 'Sú_Lú_Ma_Má_Xh_Vi_Sá'.split('_'),
        longDateFormat: {
            LT: 'HH.mm',
            LTS: 'HH.mm.ss',
            L: 'DD.MM.YYYY',
            LL: 'D. MMMM [dallas] YYYY',
            LLL: 'D. MMMM [dallas] YYYY HH.mm',
            LLLL: 'dddd, [li] D. MMMM [dallas] YYYY HH.mm',
        },
        meridiemParse: /d\'o|d\'a/i,
        isPM: function (input) {
            return "d'o" === input.toLowerCase();
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours > 11) {
                return isLower ? "d'o" : "D'O";
            } else {
                return isLower ? "d'a" : "D'A";
            }
        },
        calendar: {
            sameDay: '[oxhi à] LT',
            nextDay: '[demà à] LT',
            nextWeek: 'dddd [à] LT',
            lastDay: '[ieiri à] LT',
            lastWeek: '[sür el] dddd [lasteu à] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'osprei %s',
            past: 'ja%s',
            s: processRelativeTime,
            ss: processRelativeTime,
            m: processRelativeTime,
            mm: processRelativeTime,
            h: processRelativeTime,
            hh: processRelativeTime,
            d: processRelativeTime,
            dd: processRelativeTime,
            M: processRelativeTime,
            MM: processRelativeTime,
            y: processRelativeTime,
            yy: processRelativeTime,
        },
        dayOfMonthOrdinalParse: /\d{1,2}\./,
        ordinal: '%d.',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    function processRelativeTime(number, withoutSuffix, key, isFuture) {
        var format = {
            s: ['viensas secunds', "'iensas secunds"],
            ss: [number + ' secunds', '' + number + ' secunds'],
            m: ["'n míut", "'iens míut"],
            mm: [number + ' míuts', '' + number + ' míuts'],
            h: ["'n þora", "'iensa þora"],
            hh: [number + ' þoras', '' + number + ' þoras'],
            d: ["'n ziua", "'iensa ziua"],
            dd: [number + ' ziuas', '' + number + ' ziuas'],
            M: ["'n mes", "'iens mes"],
            MM: [number + ' mesen', '' + number + ' mesen'],
            y: ["'n ar", "'iens ar"],
            yy: [number + ' ars', '' + number + ' ars'],
        };
        return isFuture
            ? format[key][0]
            : withoutSuffix
            ? format[key][0]
            : format[key][1];
    }

    return tzl;

})));


/***/ }),

/***/ 699:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight Latin [tzm-latn]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzmLatn = moment.defineLocale('tzm-latn', {
        months: 'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
            '_'
        ),
        monthsShort:
            'innayr_brˤayrˤ_marˤsˤ_ibrir_mayyw_ywnyw_ywlywz_ɣwšt_šwtanbir_ktˤwbrˤ_nwwanbir_dwjnbir'.split(
                '_'
            ),
        weekdays: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysShort: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        weekdaysMin: 'asamas_aynas_asinas_akras_akwas_asimwas_asiḍyas'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[asdkh g] LT',
            nextDay: '[aska g] LT',
            nextWeek: 'dddd [g] LT',
            lastDay: '[assant g] LT',
            lastWeek: 'dddd [g] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'dadkh s yan %s',
            past: 'yan %s',
            s: 'imik',
            ss: '%d imik',
            m: 'minuḍ',
            mm: '%d minuḍ',
            h: 'saɛa',
            hh: '%d tassaɛin',
            d: 'ass',
            dd: '%d ossan',
            M: 'ayowr',
            MM: '%d iyyirn',
            y: 'asgas',
            yy: '%d isgasn',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzmLatn;

})));


/***/ }),

/***/ 1106:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Central Atlas Tamazight [tzm]
//! author : Abdel Said : https://github.com/abdelsaid

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var tzm = moment.defineLocale('tzm', {
        months: 'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
            '_'
        ),
        monthsShort:
            'ⵉⵏⵏⴰⵢⵔ_ⴱⵕⴰⵢⵕ_ⵎⴰⵕⵚ_ⵉⴱⵔⵉⵔ_ⵎⴰⵢⵢⵓ_ⵢⵓⵏⵢⵓ_ⵢⵓⵍⵢⵓⵣ_ⵖⵓⵛⵜ_ⵛⵓⵜⴰⵏⴱⵉⵔ_ⴽⵟⵓⴱⵕ_ⵏⵓⵡⴰⵏⴱⵉⵔ_ⴷⵓⵊⵏⴱⵉⵔ'.split(
                '_'
            ),
        weekdays: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysShort: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        weekdaysMin: 'ⴰⵙⴰⵎⴰⵙ_ⴰⵢⵏⴰⵙ_ⴰⵙⵉⵏⴰⵙ_ⴰⴽⵔⴰⵙ_ⴰⴽⵡⴰⵙ_ⴰⵙⵉⵎⵡⴰⵙ_ⴰⵙⵉⴹⵢⴰⵙ'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[ⴰⵙⴷⵅ ⴴ] LT',
            nextDay: '[ⴰⵙⴽⴰ ⴴ] LT',
            nextWeek: 'dddd [ⴴ] LT',
            lastDay: '[ⴰⵚⴰⵏⵜ ⴴ] LT',
            lastWeek: 'dddd [ⴴ] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ⴷⴰⴷⵅ ⵙ ⵢⴰⵏ %s',
            past: 'ⵢⴰⵏ %s',
            s: 'ⵉⵎⵉⴽ',
            ss: '%d ⵉⵎⵉⴽ',
            m: 'ⵎⵉⵏⵓⴺ',
            mm: '%d ⵎⵉⵏⵓⴺ',
            h: 'ⵙⴰⵄⴰ',
            hh: '%d ⵜⴰⵙⵙⴰⵄⵉⵏ',
            d: 'ⴰⵙⵙ',
            dd: '%d oⵙⵙⴰⵏ',
            M: 'ⴰⵢoⵓⵔ',
            MM: '%d ⵉⵢⵢⵉⵔⵏ',
            y: 'ⴰⵙⴳⴰⵙ',
            yy: '%d ⵉⵙⴳⴰⵙⵏ',
        },
        week: {
            dow: 6, // Saturday is the first day of the week.
            doy: 12, // The week that contains Jan 12th is the first week of the year.
        },
    });

    return tzm;

})));


/***/ }),

/***/ 9288:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uyghur (China) [ug-cn]
//! author: boyaq : https://github.com/boyaq

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var ugCn = moment.defineLocale('ug-cn', {
        months: 'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
            '_'
        ),
        monthsShort:
            'يانۋار_فېۋرال_مارت_ئاپرېل_ماي_ئىيۇن_ئىيۇل_ئاۋغۇست_سېنتەبىر_ئۆكتەبىر_نويابىر_دېكابىر'.split(
                '_'
            ),
        weekdays: 'يەكشەنبە_دۈشەنبە_سەيشەنبە_چارشەنبە_پەيشەنبە_جۈمە_شەنبە'.split(
            '_'
        ),
        weekdaysShort: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        weekdaysMin: 'يە_دۈ_سە_چا_پە_جۈ_شە'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY-MM-DD',
            LL: 'YYYY-يىلىM-ئاينىڭD-كۈنى',
            LLL: 'YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
            LLLL: 'dddd، YYYY-يىلىM-ئاينىڭD-كۈنى، HH:mm',
        },
        meridiemParse: /يېرىم كېچە|سەھەر|چۈشتىن بۇرۇن|چۈش|چۈشتىن كېيىن|كەچ/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (
                meridiem === 'يېرىم كېچە' ||
                meridiem === 'سەھەر' ||
                meridiem === 'چۈشتىن بۇرۇن'
            ) {
                return hour;
            } else if (meridiem === 'چۈشتىن كېيىن' || meridiem === 'كەچ') {
                return hour + 12;
            } else {
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return 'يېرىم كېچە';
            } else if (hm < 900) {
                return 'سەھەر';
            } else if (hm < 1130) {
                return 'چۈشتىن بۇرۇن';
            } else if (hm < 1230) {
                return 'چۈش';
            } else if (hm < 1800) {
                return 'چۈشتىن كېيىن';
            } else {
                return 'كەچ';
            }
        },
        calendar: {
            sameDay: '[بۈگۈن سائەت] LT',
            nextDay: '[ئەتە سائەت] LT',
            nextWeek: '[كېلەركى] dddd [سائەت] LT',
            lastDay: '[تۆنۈگۈن] LT',
            lastWeek: '[ئالدىنقى] dddd [سائەت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s كېيىن',
            past: '%s بۇرۇن',
            s: 'نەچچە سېكونت',
            ss: '%d سېكونت',
            m: 'بىر مىنۇت',
            mm: '%d مىنۇت',
            h: 'بىر سائەت',
            hh: '%d سائەت',
            d: 'بىر كۈن',
            dd: '%d كۈن',
            M: 'بىر ئاي',
            MM: '%d ئاي',
            y: 'بىر يىل',
            yy: '%d يىل',
        },

        dayOfMonthOrdinalParse: /\d{1,2}(-كۈنى|-ئاي|-ھەپتە)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '-كۈنى';
                case 'w':
                case 'W':
                    return number + '-ھەپتە';
                default:
                    return number;
            }
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 1st is the first week of the year.
        },
    });

    return ugCn;

})));


/***/ }),

/***/ 7691:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Ukrainian [uk]
//! author : zemlanin : https://github.com/zemlanin
//! Author : Menelion Elensúle : https://github.com/Oire

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    function plural(word, num) {
        var forms = word.split('_');
        return num % 10 === 1 && num % 100 !== 11
            ? forms[0]
            : num % 10 >= 2 && num % 10 <= 4 && (num % 100 < 10 || num % 100 >= 20)
            ? forms[1]
            : forms[2];
    }
    function relativeTimeWithPlural(number, withoutSuffix, key) {
        var format = {
            ss: withoutSuffix ? 'секунда_секунди_секунд' : 'секунду_секунди_секунд',
            mm: withoutSuffix ? 'хвилина_хвилини_хвилин' : 'хвилину_хвилини_хвилин',
            hh: withoutSuffix ? 'година_години_годин' : 'годину_години_годин',
            dd: 'день_дні_днів',
            MM: 'місяць_місяці_місяців',
            yy: 'рік_роки_років',
        };
        if (key === 'm') {
            return withoutSuffix ? 'хвилина' : 'хвилину';
        } else if (key === 'h') {
            return withoutSuffix ? 'година' : 'годину';
        } else {
            return number + ' ' + plural(format[key], +number);
        }
    }
    function weekdaysCaseReplace(m, format) {
        var weekdays = {
                nominative:
                    'неділя_понеділок_вівторок_середа_четвер_п’ятниця_субота'.split(
                        '_'
                    ),
                accusative:
                    'неділю_понеділок_вівторок_середу_четвер_п’ятницю_суботу'.split(
                        '_'
                    ),
                genitive:
                    'неділі_понеділка_вівторка_середи_четверга_п’ятниці_суботи'.split(
                        '_'
                    ),
            },
            nounCase;

        if (m === true) {
            return weekdays['nominative']
                .slice(1, 7)
                .concat(weekdays['nominative'].slice(0, 1));
        }
        if (!m) {
            return weekdays['nominative'];
        }

        nounCase = /(\[[ВвУу]\]) ?dddd/.test(format)
            ? 'accusative'
            : /\[?(?:минулої|наступної)? ?\] ?dddd/.test(format)
            ? 'genitive'
            : 'nominative';
        return weekdays[nounCase][m.day()];
    }
    function processHoursFunction(str) {
        return function () {
            return str + 'о' + (this.hours() === 11 ? 'б' : '') + '] LT';
        };
    }

    var uk = moment.defineLocale('uk', {
        months: {
            format: 'січня_лютого_березня_квітня_травня_червня_липня_серпня_вересня_жовтня_листопада_грудня'.split(
                '_'
            ),
            standalone:
                'січень_лютий_березень_квітень_травень_червень_липень_серпень_вересень_жовтень_листопад_грудень'.split(
                    '_'
                ),
        },
        monthsShort: 'січ_лют_бер_квіт_трав_черв_лип_серп_вер_жовт_лист_груд'.split(
            '_'
        ),
        weekdays: weekdaysCaseReplace,
        weekdaysShort: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        weekdaysMin: 'нд_пн_вт_ср_чт_пт_сб'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD.MM.YYYY',
            LL: 'D MMMM YYYY р.',
            LLL: 'D MMMM YYYY р., HH:mm',
            LLLL: 'dddd, D MMMM YYYY р., HH:mm',
        },
        calendar: {
            sameDay: processHoursFunction('[Сьогодні '),
            nextDay: processHoursFunction('[Завтра '),
            lastDay: processHoursFunction('[Вчора '),
            nextWeek: processHoursFunction('[У] dddd ['),
            lastWeek: function () {
                switch (this.day()) {
                    case 0:
                    case 3:
                    case 5:
                    case 6:
                        return processHoursFunction('[Минулої] dddd [').call(this);
                    case 1:
                    case 2:
                    case 4:
                        return processHoursFunction('[Минулого] dddd [').call(this);
                }
            },
            sameElse: 'L',
        },
        relativeTime: {
            future: 'за %s',
            past: '%s тому',
            s: 'декілька секунд',
            ss: relativeTimeWithPlural,
            m: relativeTimeWithPlural,
            mm: relativeTimeWithPlural,
            h: 'годину',
            hh: relativeTimeWithPlural,
            d: 'день',
            dd: relativeTimeWithPlural,
            M: 'місяць',
            MM: relativeTimeWithPlural,
            y: 'рік',
            yy: relativeTimeWithPlural,
        },
        // M. E.: those two are virtually unused but a user might want to implement them for his/her website for some reason
        meridiemParse: /ночі|ранку|дня|вечора/,
        isPM: function (input) {
            return /^(дня|вечора)$/.test(input);
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 4) {
                return 'ночі';
            } else if (hour < 12) {
                return 'ранку';
            } else if (hour < 17) {
                return 'дня';
            } else {
                return 'вечора';
            }
        },
        dayOfMonthOrdinalParse: /\d{1,2}-(й|го)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'M':
                case 'd':
                case 'DDD':
                case 'w':
                case 'W':
                    return number + '-й';
                case 'D':
                    return number + '-го';
                default:
                    return number;
            }
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uk;

})));


/***/ }),

/***/ 3795:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Urdu [ur]
//! author : Sawood Alam : https://github.com/ibnesayeed
//! author : Zack : https://github.com/ZackVision

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var months = [
            'جنوری',
            'فروری',
            'مارچ',
            'اپریل',
            'مئی',
            'جون',
            'جولائی',
            'اگست',
            'ستمبر',
            'اکتوبر',
            'نومبر',
            'دسمبر',
        ],
        days = ['اتوار', 'پیر', 'منگل', 'بدھ', 'جمعرات', 'جمعہ', 'ہفتہ'];

    var ur = moment.defineLocale('ur', {
        months: months,
        monthsShort: months,
        weekdays: days,
        weekdaysShort: days,
        weekdaysMin: days,
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd، D MMMM YYYY HH:mm',
        },
        meridiemParse: /صبح|شام/,
        isPM: function (input) {
            return 'شام' === input;
        },
        meridiem: function (hour, minute, isLower) {
            if (hour < 12) {
                return 'صبح';
            }
            return 'شام';
        },
        calendar: {
            sameDay: '[آج بوقت] LT',
            nextDay: '[کل بوقت] LT',
            nextWeek: 'dddd [بوقت] LT',
            lastDay: '[گذشتہ روز بوقت] LT',
            lastWeek: '[گذشتہ] dddd [بوقت] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s بعد',
            past: '%s قبل',
            s: 'چند سیکنڈ',
            ss: '%d سیکنڈ',
            m: 'ایک منٹ',
            mm: '%d منٹ',
            h: 'ایک گھنٹہ',
            hh: '%d گھنٹے',
            d: 'ایک دن',
            dd: '%d دن',
            M: 'ایک ماہ',
            MM: '%d ماہ',
            y: 'ایک سال',
            yy: '%d سال',
        },
        preparse: function (string) {
            return string.replace(/،/g, ',');
        },
        postformat: function (string) {
            return string.replace(/,/g, '،');
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return ur;

})));


/***/ }),

/***/ 588:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek Latin [uz-latn]
//! author : Rasulbek Mirzayev : github.com/Rasulbeeek

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uzLatn = moment.defineLocale('uz-latn', {
        months: 'Yanvar_Fevral_Mart_Aprel_May_Iyun_Iyul_Avgust_Sentabr_Oktabr_Noyabr_Dekabr'.split(
            '_'
        ),
        monthsShort: 'Yan_Fev_Mar_Apr_May_Iyun_Iyul_Avg_Sen_Okt_Noy_Dek'.split('_'),
        weekdays:
            'Yakshanba_Dushanba_Seshanba_Chorshanba_Payshanba_Juma_Shanba'.split(
                '_'
            ),
        weekdaysShort: 'Yak_Dush_Sesh_Chor_Pay_Jum_Shan'.split('_'),
        weekdaysMin: 'Ya_Du_Se_Cho_Pa_Ju_Sha'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Bugun soat] LT [da]',
            nextDay: '[Ertaga] LT [da]',
            nextWeek: 'dddd [kuni soat] LT [da]',
            lastDay: '[Kecha soat] LT [da]',
            lastWeek: "[O'tgan] dddd [kuni soat] LT [da]",
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Yaqin %s ichida',
            past: 'Bir necha %s oldin',
            s: 'soniya',
            ss: '%d soniya',
            m: 'bir daqiqa',
            mm: '%d daqiqa',
            h: 'bir soat',
            hh: '%d soat',
            d: 'bir kun',
            dd: '%d kun',
            M: 'bir oy',
            MM: '%d oy',
            y: 'bir yil',
            yy: '%d yil',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 7th is the first week of the year.
        },
    });

    return uzLatn;

})));


/***/ }),

/***/ 6791:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Uzbek [uz]
//! author : Sardor Muminov : https://github.com/muminoff

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var uz = moment.defineLocale('uz', {
        months: 'январ_феврал_март_апрел_май_июн_июл_август_сентябр_октябр_ноябр_декабр'.split(
            '_'
        ),
        monthsShort: 'янв_фев_мар_апр_май_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
        weekdays: 'Якшанба_Душанба_Сешанба_Чоршанба_Пайшанба_Жума_Шанба'.split('_'),
        weekdaysShort: 'Якш_Душ_Сеш_Чор_Пай_Жум_Шан'.split('_'),
        weekdaysMin: 'Як_Ду_Се_Чо_Па_Жу_Ша'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'D MMMM YYYY, dddd HH:mm',
        },
        calendar: {
            sameDay: '[Бугун соат] LT [да]',
            nextDay: '[Эртага] LT [да]',
            nextWeek: 'dddd [куни соат] LT [да]',
            lastDay: '[Кеча соат] LT [да]',
            lastWeek: '[Утган] dddd [куни соат] LT [да]',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'Якин %s ичида',
            past: 'Бир неча %s олдин',
            s: 'фурсат',
            ss: '%d фурсат',
            m: 'бир дакика',
            mm: '%d дакика',
            h: 'бир соат',
            hh: '%d соат',
            d: 'бир кун',
            dd: '%d кун',
            M: 'бир ой',
            MM: '%d ой',
            y: 'бир йил',
            yy: '%d йил',
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 7, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return uz;

})));


/***/ }),

/***/ 5666:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Vietnamese [vi]
//! author : Bang Nguyen : https://github.com/bangnk
//! author : Chien Kira : https://github.com/chienkira

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var vi = moment.defineLocale('vi', {
        months: 'tháng 1_tháng 2_tháng 3_tháng 4_tháng 5_tháng 6_tháng 7_tháng 8_tháng 9_tháng 10_tháng 11_tháng 12'.split(
            '_'
        ),
        monthsShort:
            'Thg 01_Thg 02_Thg 03_Thg 04_Thg 05_Thg 06_Thg 07_Thg 08_Thg 09_Thg 10_Thg 11_Thg 12'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays: 'chủ nhật_thứ hai_thứ ba_thứ tư_thứ năm_thứ sáu_thứ bảy'.split(
            '_'
        ),
        weekdaysShort: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysMin: 'CN_T2_T3_T4_T5_T6_T7'.split('_'),
        weekdaysParseExact: true,
        meridiemParse: /sa|ch/i,
        isPM: function (input) {
            return /^ch$/i.test(input);
        },
        meridiem: function (hours, minutes, isLower) {
            if (hours < 12) {
                return isLower ? 'sa' : 'SA';
            } else {
                return isLower ? 'ch' : 'CH';
            }
        },
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM [năm] YYYY',
            LLL: 'D MMMM [năm] YYYY HH:mm',
            LLLL: 'dddd, D MMMM [năm] YYYY HH:mm',
            l: 'DD/M/YYYY',
            ll: 'D MMM YYYY',
            lll: 'D MMM YYYY HH:mm',
            llll: 'ddd, D MMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[Hôm nay lúc] LT',
            nextDay: '[Ngày mai lúc] LT',
            nextWeek: 'dddd [tuần tới lúc] LT',
            lastDay: '[Hôm qua lúc] LT',
            lastWeek: 'dddd [tuần trước lúc] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: '%s tới',
            past: '%s trước',
            s: 'vài giây',
            ss: '%d giây',
            m: 'một phút',
            mm: '%d phút',
            h: 'một giờ',
            hh: '%d giờ',
            d: 'một ngày',
            dd: '%d ngày',
            w: 'một tuần',
            ww: '%d tuần',
            M: 'một tháng',
            MM: '%d tháng',
            y: 'một năm',
            yy: '%d năm',
        },
        dayOfMonthOrdinalParse: /\d{1,2}/,
        ordinal: function (number) {
            return number;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return vi;

})));


/***/ }),

/***/ 4378:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Pseudo [x-pseudo]
//! author : Andrew Hood : https://github.com/andrewhood125

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var xPseudo = moment.defineLocale('x-pseudo', {
        months: 'J~áñúá~rý_F~ébrú~árý_~Márc~h_Áp~ríl_~Máý_~Júñé~_Júl~ý_Áú~gúst~_Sép~témb~ér_Ó~ctób~ér_Ñ~óvém~bér_~Décé~mbér'.split(
            '_'
        ),
        monthsShort:
            'J~áñ_~Féb_~Már_~Ápr_~Máý_~Júñ_~Júl_~Áúg_~Sép_~Óct_~Ñóv_~Déc'.split(
                '_'
            ),
        monthsParseExact: true,
        weekdays:
            'S~úñdá~ý_Mó~ñdáý~_Túé~sdáý~_Wéd~ñésd~áý_T~húrs~dáý_~Fríd~áý_S~átúr~dáý'.split(
                '_'
            ),
        weekdaysShort: 'S~úñ_~Móñ_~Túé_~Wéd_~Thú_~Frí_~Sát'.split('_'),
        weekdaysMin: 'S~ú_Mó~_Tú_~Wé_T~h_Fr~_Sá'.split('_'),
        weekdaysParseExact: true,
        longDateFormat: {
            LT: 'HH:mm',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY HH:mm',
            LLLL: 'dddd, D MMMM YYYY HH:mm',
        },
        calendar: {
            sameDay: '[T~ódá~ý át] LT',
            nextDay: '[T~ómó~rró~w át] LT',
            nextWeek: 'dddd [át] LT',
            lastDay: '[Ý~ést~érdá~ý át] LT',
            lastWeek: '[L~ást] dddd [át] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'í~ñ %s',
            past: '%s á~gó',
            s: 'á ~féw ~sécó~ñds',
            ss: '%d s~écóñ~ds',
            m: 'á ~míñ~úté',
            mm: '%d m~íñú~tés',
            h: 'á~ñ hó~úr',
            hh: '%d h~óúrs',
            d: 'á ~dáý',
            dd: '%d d~áýs',
            M: 'á ~móñ~th',
            MM: '%d m~óñt~hs',
            y: 'á ~ýéár',
            yy: '%d ý~éárs',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    ~~((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return xPseudo;

})));


/***/ }),

/***/ 5805:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Yoruba Nigeria [yo]
//! author : Atolagbe Abisoye : https://github.com/andela-batolagbe

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var yo = moment.defineLocale('yo', {
        months: 'Sẹ́rẹ́_Èrèlè_Ẹrẹ̀nà_Ìgbé_Èbibi_Òkùdu_Agẹmo_Ògún_Owewe_Ọ̀wàrà_Bélú_Ọ̀pẹ̀̀'.split(
            '_'
        ),
        monthsShort: 'Sẹ́r_Èrl_Ẹrn_Ìgb_Èbi_Òkù_Agẹ_Ògú_Owe_Ọ̀wà_Bél_Ọ̀pẹ̀̀'.split('_'),
        weekdays: 'Àìkú_Ajé_Ìsẹ́gun_Ọjọ́rú_Ọjọ́bọ_Ẹtì_Àbámẹ́ta'.split('_'),
        weekdaysShort: 'Àìk_Ajé_Ìsẹ́_Ọjr_Ọjb_Ẹtì_Àbá'.split('_'),
        weekdaysMin: 'Àì_Aj_Ìs_Ọr_Ọb_Ẹt_Àb'.split('_'),
        longDateFormat: {
            LT: 'h:mm A',
            LTS: 'h:mm:ss A',
            L: 'DD/MM/YYYY',
            LL: 'D MMMM YYYY',
            LLL: 'D MMMM YYYY h:mm A',
            LLLL: 'dddd, D MMMM YYYY h:mm A',
        },
        calendar: {
            sameDay: '[Ònì ni] LT',
            nextDay: '[Ọ̀la ni] LT',
            nextWeek: "dddd [Ọsẹ̀ tón'bọ] [ni] LT",
            lastDay: '[Àna ni] LT',
            lastWeek: 'dddd [Ọsẹ̀ tólọ́] [ni] LT',
            sameElse: 'L',
        },
        relativeTime: {
            future: 'ní %s',
            past: '%s kọjá',
            s: 'ìsẹjú aayá die',
            ss: 'aayá %d',
            m: 'ìsẹjú kan',
            mm: 'ìsẹjú %d',
            h: 'wákati kan',
            hh: 'wákati %d',
            d: 'ọjọ́ kan',
            dd: 'ọjọ́ %d',
            M: 'osù kan',
            MM: 'osù %d',
            y: 'ọdún kan',
            yy: 'ọdún %d',
        },
        dayOfMonthOrdinalParse: /ọjọ́\s\d{1,2}/,
        ordinal: 'ọjọ́ %d',
        week: {
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return yo;

})));


/***/ }),

/***/ 3839:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (China) [zh-cn]
//! author : suupic : https://github.com/suupic
//! author : Zeno Zeng : https://github.com/zenozeng
//! author : uu109 : https://github.com/uu109

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhCn = moment.defineLocale('zh-cn', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '周日_周一_周二_周三_周四_周五_周六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日Ah点mm分',
            LLLL: 'YYYY年M月D日ddddAh点mm分',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            } else {
                // '中午'
                return hour >= 11 ? hour : hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: function (now) {
                if (now.week() !== this.week()) {
                    return '[下]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            lastDay: '[昨天]LT',
            lastWeek: function (now) {
                if (this.week() !== now.week()) {
                    return '[上]dddLT';
                } else {
                    return '[本]dddLT';
                }
            },
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|周)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '周';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s后',
            past: '%s前',
            s: '几秒',
            ss: '%d 秒',
            m: '1 分钟',
            mm: '%d 分钟',
            h: '1 小时',
            hh: '%d 小时',
            d: '1 天',
            dd: '%d 天',
            w: '1 周',
            ww: '%d 周',
            M: '1 个月',
            MM: '%d 个月',
            y: '1 年',
            yy: '%d 年',
        },
        week: {
            // GB/T 7408-1994《数据元和交换格式·信息交换·日期和时间表示法》与ISO 8601:1988等效
            dow: 1, // Monday is the first day of the week.
            doy: 4, // The week that contains Jan 4th is the first week of the year.
        },
    });

    return zhCn;

})));


/***/ }),

/***/ 5726:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Hong Kong) [zh-hk]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Konstantin : https://github.com/skfd
//! author : Anthony : https://github.com/anthonylau

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhHk = moment.defineLocale('zh-hk', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1200) {
                return '上午';
            } else if (hm === 1200) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天]LT',
            nextDay: '[明天]LT',
            nextWeek: '[下]ddddLT',
            lastDay: '[昨天]LT',
            lastWeek: '[上]ddddLT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhHk;

})));


/***/ }),

/***/ 9807:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Macau) [zh-mo]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris
//! author : Tan Yuanhong : https://github.com/le0tan

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhMo = moment.defineLocale('zh-mo', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'DD/MM/YYYY',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'D/M/YYYY',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s內',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhMo;

})));


/***/ }),

/***/ 4152:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {

//! moment.js locale configuration
//! locale : Chinese (Taiwan) [zh-tw]
//! author : Ben : https://github.com/ben-lin
//! author : Chris Lam : https://github.com/hehachris

;(function (global, factory) {
    true ? factory(__webpack_require__(381)) :
   0
}(this, (function (moment) { 'use strict';

    //! moment.js locale configuration

    var zhTw = moment.defineLocale('zh-tw', {
        months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月'.split(
            '_'
        ),
        monthsShort: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月'.split(
            '_'
        ),
        weekdays: '星期日_星期一_星期二_星期三_星期四_星期五_星期六'.split('_'),
        weekdaysShort: '週日_週一_週二_週三_週四_週五_週六'.split('_'),
        weekdaysMin: '日_一_二_三_四_五_六'.split('_'),
        longDateFormat: {
            LT: 'HH:mm',
            LTS: 'HH:mm:ss',
            L: 'YYYY/MM/DD',
            LL: 'YYYY年M月D日',
            LLL: 'YYYY年M月D日 HH:mm',
            LLLL: 'YYYY年M月D日dddd HH:mm',
            l: 'YYYY/M/D',
            ll: 'YYYY年M月D日',
            lll: 'YYYY年M月D日 HH:mm',
            llll: 'YYYY年M月D日dddd HH:mm',
        },
        meridiemParse: /凌晨|早上|上午|中午|下午|晚上/,
        meridiemHour: function (hour, meridiem) {
            if (hour === 12) {
                hour = 0;
            }
            if (meridiem === '凌晨' || meridiem === '早上' || meridiem === '上午') {
                return hour;
            } else if (meridiem === '中午') {
                return hour >= 11 ? hour : hour + 12;
            } else if (meridiem === '下午' || meridiem === '晚上') {
                return hour + 12;
            }
        },
        meridiem: function (hour, minute, isLower) {
            var hm = hour * 100 + minute;
            if (hm < 600) {
                return '凌晨';
            } else if (hm < 900) {
                return '早上';
            } else if (hm < 1130) {
                return '上午';
            } else if (hm < 1230) {
                return '中午';
            } else if (hm < 1800) {
                return '下午';
            } else {
                return '晚上';
            }
        },
        calendar: {
            sameDay: '[今天] LT',
            nextDay: '[明天] LT',
            nextWeek: '[下]dddd LT',
            lastDay: '[昨天] LT',
            lastWeek: '[上]dddd LT',
            sameElse: 'L',
        },
        dayOfMonthOrdinalParse: /\d{1,2}(日|月|週)/,
        ordinal: function (number, period) {
            switch (period) {
                case 'd':
                case 'D':
                case 'DDD':
                    return number + '日';
                case 'M':
                    return number + '月';
                case 'w':
                case 'W':
                    return number + '週';
                default:
                    return number;
            }
        },
        relativeTime: {
            future: '%s後',
            past: '%s前',
            s: '幾秒',
            ss: '%d 秒',
            m: '1 分鐘',
            mm: '%d 分鐘',
            h: '1 小時',
            hh: '%d 小時',
            d: '1 天',
            dd: '%d 天',
            M: '1 個月',
            MM: '%d 個月',
            y: '1 年',
            yy: '%d 年',
        },
    });

    return zhTw;

})));


/***/ }),

/***/ 6700:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./af": 2786,
	"./af.js": 2786,
	"./ar": 867,
	"./ar-dz": 4130,
	"./ar-dz.js": 4130,
	"./ar-kw": 6737,
	"./ar-kw.js": 6737,
	"./ar-ly": 6440,
	"./ar-ly.js": 6440,
	"./ar-ma": 7702,
	"./ar-ma.js": 7702,
	"./ar-sa": 6040,
	"./ar-sa.js": 6040,
	"./ar-tn": 7100,
	"./ar-tn.js": 7100,
	"./ar.js": 867,
	"./az": 1083,
	"./az.js": 1083,
	"./be": 9808,
	"./be.js": 9808,
	"./bg": 8338,
	"./bg.js": 8338,
	"./bm": 7438,
	"./bm.js": 7438,
	"./bn": 8905,
	"./bn-bd": 6225,
	"./bn-bd.js": 6225,
	"./bn.js": 8905,
	"./bo": 1560,
	"./bo.js": 1560,
	"./br": 1278,
	"./br.js": 1278,
	"./bs": 622,
	"./bs.js": 622,
	"./ca": 2468,
	"./ca.js": 2468,
	"./cs": 5822,
	"./cs.js": 5822,
	"./cv": 877,
	"./cv.js": 877,
	"./cy": 7373,
	"./cy.js": 7373,
	"./da": 4780,
	"./da.js": 4780,
	"./de": 9740,
	"./de-at": 217,
	"./de-at.js": 217,
	"./de-ch": 894,
	"./de-ch.js": 894,
	"./de.js": 9740,
	"./dv": 5300,
	"./dv.js": 5300,
	"./el": 837,
	"./el.js": 837,
	"./en-au": 8348,
	"./en-au.js": 8348,
	"./en-ca": 7925,
	"./en-ca.js": 7925,
	"./en-gb": 2243,
	"./en-gb.js": 2243,
	"./en-ie": 6436,
	"./en-ie.js": 6436,
	"./en-il": 941,
	"./en-il.js": 941,
	"./en-in": 4175,
	"./en-in.js": 4175,
	"./en-nz": 6319,
	"./en-nz.js": 6319,
	"./en-sg": 1662,
	"./en-sg.js": 1662,
	"./eo": 2915,
	"./eo.js": 2915,
	"./es": 5655,
	"./es-do": 5251,
	"./es-do.js": 5251,
	"./es-mx": 6112,
	"./es-mx.js": 6112,
	"./es-us": 1146,
	"./es-us.js": 1146,
	"./es.js": 5655,
	"./et": 5603,
	"./et.js": 5603,
	"./eu": 7763,
	"./eu.js": 7763,
	"./fa": 6959,
	"./fa.js": 6959,
	"./fi": 1897,
	"./fi.js": 1897,
	"./fil": 2549,
	"./fil.js": 2549,
	"./fo": 4694,
	"./fo.js": 4694,
	"./fr": 4470,
	"./fr-ca": 3049,
	"./fr-ca.js": 3049,
	"./fr-ch": 2330,
	"./fr-ch.js": 2330,
	"./fr.js": 4470,
	"./fy": 5044,
	"./fy.js": 5044,
	"./ga": 9295,
	"./ga.js": 9295,
	"./gd": 2101,
	"./gd.js": 2101,
	"./gl": 8794,
	"./gl.js": 8794,
	"./gom-deva": 7884,
	"./gom-deva.js": 7884,
	"./gom-latn": 3168,
	"./gom-latn.js": 3168,
	"./gu": 5349,
	"./gu.js": 5349,
	"./he": 4206,
	"./he.js": 4206,
	"./hi": 94,
	"./hi.js": 94,
	"./hr": 316,
	"./hr.js": 316,
	"./hu": 2138,
	"./hu.js": 2138,
	"./hy-am": 1423,
	"./hy-am.js": 1423,
	"./id": 9218,
	"./id.js": 9218,
	"./is": 135,
	"./is.js": 135,
	"./it": 626,
	"./it-ch": 150,
	"./it-ch.js": 150,
	"./it.js": 626,
	"./ja": 9183,
	"./ja.js": 9183,
	"./jv": 4286,
	"./jv.js": 4286,
	"./ka": 2105,
	"./ka.js": 2105,
	"./kk": 7772,
	"./kk.js": 7772,
	"./km": 8758,
	"./km.js": 8758,
	"./kn": 9282,
	"./kn.js": 9282,
	"./ko": 3730,
	"./ko.js": 3730,
	"./ku": 1408,
	"./ku.js": 1408,
	"./ky": 3291,
	"./ky.js": 3291,
	"./lb": 6841,
	"./lb.js": 6841,
	"./lo": 5466,
	"./lo.js": 5466,
	"./lt": 7010,
	"./lt.js": 7010,
	"./lv": 7595,
	"./lv.js": 7595,
	"./me": 9861,
	"./me.js": 9861,
	"./mi": 5493,
	"./mi.js": 5493,
	"./mk": 5966,
	"./mk.js": 5966,
	"./ml": 7341,
	"./ml.js": 7341,
	"./mn": 5115,
	"./mn.js": 5115,
	"./mr": 370,
	"./mr.js": 370,
	"./ms": 9847,
	"./ms-my": 1237,
	"./ms-my.js": 1237,
	"./ms.js": 9847,
	"./mt": 2126,
	"./mt.js": 2126,
	"./my": 6165,
	"./my.js": 6165,
	"./nb": 4924,
	"./nb.js": 4924,
	"./ne": 6744,
	"./ne.js": 6744,
	"./nl": 3901,
	"./nl-be": 9814,
	"./nl-be.js": 9814,
	"./nl.js": 3901,
	"./nn": 3877,
	"./nn.js": 3877,
	"./oc-lnc": 2135,
	"./oc-lnc.js": 2135,
	"./pa-in": 5858,
	"./pa-in.js": 5858,
	"./pl": 4495,
	"./pl.js": 4495,
	"./pt": 9520,
	"./pt-br": 7971,
	"./pt-br.js": 7971,
	"./pt.js": 9520,
	"./ro": 6459,
	"./ro.js": 6459,
	"./ru": 1793,
	"./ru.js": 1793,
	"./sd": 950,
	"./sd.js": 950,
	"./se": 7930,
	"./se.js": 7930,
	"./si": 124,
	"./si.js": 124,
	"./sk": 4249,
	"./sk.js": 4249,
	"./sl": 4985,
	"./sl.js": 4985,
	"./sq": 1104,
	"./sq.js": 1104,
	"./sr": 9131,
	"./sr-cyrl": 9915,
	"./sr-cyrl.js": 9915,
	"./sr.js": 9131,
	"./ss": 5893,
	"./ss.js": 5893,
	"./sv": 8760,
	"./sv.js": 8760,
	"./sw": 1172,
	"./sw.js": 1172,
	"./ta": 7333,
	"./ta.js": 7333,
	"./te": 3110,
	"./te.js": 3110,
	"./tet": 2095,
	"./tet.js": 2095,
	"./tg": 7321,
	"./tg.js": 7321,
	"./th": 9041,
	"./th.js": 9041,
	"./tk": 9005,
	"./tk.js": 9005,
	"./tl-ph": 5768,
	"./tl-ph.js": 5768,
	"./tlh": 9444,
	"./tlh.js": 9444,
	"./tr": 2397,
	"./tr.js": 2397,
	"./tzl": 8254,
	"./tzl.js": 8254,
	"./tzm": 1106,
	"./tzm-latn": 699,
	"./tzm-latn.js": 699,
	"./tzm.js": 1106,
	"./ug-cn": 9288,
	"./ug-cn.js": 9288,
	"./uk": 7691,
	"./uk.js": 7691,
	"./ur": 3795,
	"./ur.js": 3795,
	"./uz": 6791,
	"./uz-latn": 588,
	"./uz-latn.js": 588,
	"./uz.js": 6791,
	"./vi": 5666,
	"./vi.js": 5666,
	"./x-pseudo": 4378,
	"./x-pseudo.js": 4378,
	"./yo": 5805,
	"./yo.js": 5805,
	"./zh-cn": 3839,
	"./zh-cn.js": 3839,
	"./zh-hk": 5726,
	"./zh-hk.js": 5726,
	"./zh-mo": 9807,
	"./zh-mo.js": 9807,
	"./zh-tw": 4152,
	"./zh-tw.js": 4152
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6700;

/***/ }),

/***/ 381:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
//! moment.js
//! version : 2.29.4
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    0
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        if (m._isValid == null) {
            var flags = getParsingFlags(m),
                parsedParts = some.call(flags.parsedDateParts, function (i) {
                    return i != null;
                }),
                isNowValid =
                    !isNaN(m._d.getTime()) &&
                    flags.overflow < 0 &&
                    !flags.empty &&
                    !flags.invalidEra &&
                    !flags.invalidMonth &&
                    !flags.invalidWeekday &&
                    !flags.weekdayMismatch &&
                    !flags.nullInput &&
                    !flags.invalidFormat &&
                    !flags.userInvalidated &&
                    (!flags.meridiem || (flags.meridiem && parsedParts));

            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }

            if (Object.isFrozen == null || !Object.isFrozen(m)) {
                m._isValid = isNowValid;
            } else {
                return isNowValid;
            }
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {};

    function addUnitAlias(unit, shorthand) {
        var lowerCase = unit.toLowerCase();
        aliases[lowerCase] = aliases[lowerCase + 's'] = aliases[shorthand] = unit;
    }

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {};

    function addUnitPriority(unit, priority) {
        priorities[unit] = priority;
    }

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        return mom.isValid()
            ? mom._d['get' + (mom._isUTC ? 'UTC' : '') + unit]()
            : NaN;
    }

    function set$1(mom, unit, value) {
        if (mom.isValid() && !isNaN(value)) {
            if (
                unit === 'FullYear' &&
                isLeapYear(mom.year()) &&
                mom.month() === 1 &&
                mom.date() === 29
            ) {
                value = toInt(value);
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](
                    value,
                    mom.month(),
                    daysInMonth(value, mom.month())
                );
            } else {
                mom._d['set' + (mom._isUTC ? 'UTC' : '') + unit](value);
            }
        }
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // ALIASES

    addUnitAlias('month', 'M');

    // PRIORITY

    addUnitPriority('month', 8);

    // PARSING

    addRegexToken('M', match1to2);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        var dayOfMonth;

        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        dayOfMonth = Math.min(mom.date(), daysInMonth(mom.year(), value));
        mom._d['set' + (mom._isUTC ? 'UTC' : '') + 'Month'](value, dayOfMonth);
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortPieces.push(this.monthsShort(mom, ''));
            longPieces.push(this.months(mom, ''));
            mixedPieces.push(this.months(mom, ''));
            mixedPieces.push(this.monthsShort(mom, ''));
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        for (i = 0; i < 12; i++) {
            shortPieces[i] = regexEscape(shortPieces[i]);
            longPieces[i] = regexEscape(longPieces[i]);
        }
        for (i = 0; i < 24; i++) {
            mixedPieces[i] = regexEscape(mixedPieces[i]);
        }

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // ALIASES

    addUnitAlias('year', 'y');

    // PRIORITIES

    addUnitPriority('year', 1);

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // ALIASES

    addUnitAlias('week', 'w');
    addUnitAlias('isoWeek', 'W');

    // PRIORITIES

    addUnitPriority('week', 5);
    addUnitPriority('isoWeek', 5);

    // PARSING

    addRegexToken('w', match1to2);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // ALIASES

    addUnitAlias('day', 'd');
    addUnitAlias('weekday', 'e');
    addUnitAlias('isoWeekday', 'E');

    // PRIORITY
    addUnitPriority('day', 11);
    addUnitPriority('weekday', 11);
    addUnitPriority('isoWeekday', 11);

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
            ? weekdays[m.day()]
            : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
            ? this._weekdaysShort[m.day()]
            : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
            ? this._weekdaysMin[m.day()]
            : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var day = this._isUTC ? this._d.getUTCDay() : this._d.getDay();
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // ALIASES

    addUnitAlias('hour', 'h');

    // PRIORITY
    addUnitPriority('hour', 13);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2);
    addRegexToken('h', match1to2);
    addRegexToken('k', match1to2);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        return name.match('^[^/\\\\]*$') != null;
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            "object" !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = undefined;
                __webpack_require__(6700)("./" + name);
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                    ? DATE
                    : a[HOUR] < 0 ||
                      a[HOUR] > 24 ||
                      (a[HOUR] === 24 &&
                          (a[MINUTE] !== 0 ||
                              a[SECOND] !== 0 ||
                              a[MILLISECOND] !== 0))
                    ? HOUR
                    : a[MINUTE] < 0 || a[MINUTE] > 59
                    ? MINUTE
                    : a[SECOND] < 0 || a[SECOND] > 59
                    ? SECOND
                    : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                    ? MILLISECOND
                    : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
            ? 'lastWeek'
            : diff < 0
            ? 'lastDay'
            : diff < 1
            ? 'sameDay'
            : diff < 2
            ? 'nextDay'
            : diff < 7
            ? 'nextWeek'
            : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            namePieces.push(regexEscape(eras[i].name));
            abbrPieces.push(regexEscape(eras[i].abbr));
            narrowPieces.push(regexEscape(eras[i].narrow));

            mixedPieces.push(regexEscape(eras[i].name));
            mixedPieces.push(regexEscape(eras[i].abbr));
            mixedPieces.push(regexEscape(eras[i].narrow));
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    addUnitAlias('weekYear', 'gg');
    addUnitAlias('isoWeekYear', 'GG');

    // PRIORITY

    addUnitPriority('weekYear', 1);
    addUnitPriority('isoWeekYear', 1);

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday(),
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // ALIASES

    addUnitAlias('quarter', 'Q');

    // PRIORITY

    addUnitPriority('quarter', 7);

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // ALIASES

    addUnitAlias('date', 'D');

    // PRIORITY
    addUnitPriority('date', 9);

    // PARSING

    addRegexToken('D', match1to2);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // ALIASES

    addUnitAlias('dayOfYear', 'DDD');

    // PRIORITY
    addUnitPriority('dayOfYear', 4);

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // ALIASES

    addUnitAlias('minute', 'm');

    // PRIORITY

    addUnitPriority('minute', 14);

    // PARSING

    addRegexToken('m', match1to2);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // ALIASES

    addUnitAlias('second', 's');

    // PRIORITY

    addUnitPriority('second', 15);

    // PARSING

    addRegexToken('s', match1to2);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // ALIASES

    addUnitAlias('millisecond', 'ms');

    // PRIORITY

    addUnitPriority('millisecond', 16);

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                        ? 'st'
                        : b === 2
                        ? 'nd'
                        : b === 3
                        ? 'rd'
                        : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    // TODO: Use this.as('ms')?
    function valueOf$1() {
        if (!this.isValid()) {
            return NaN;
        }
        return (
            this._milliseconds +
            this._days * 864e5 +
            (this._months % 12) * 2592e6 +
            toInt(this._months / 12) * 31536e6
        );
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y');

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.29.4';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));


/***/ }),

/***/ 364:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

!function(e,o){ true?module.exports=o(__webpack_require__(6095)):0}(window,function(a){return function(a){var r={};function c(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return a[e].call(o.exports,o,o.exports,c),o.l=!0,o.exports}return c.m=a,c.c=r,c.d=function(e,o,a){c.o(e,o)||Object.defineProperty(e,o,{enumerable:!0,get:a})},c.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},c.t=function(o,e){if(1&e&&(o=c(o)),8&e)return o;if(4&e&&"object"==typeof o&&o&&o.__esModule)return o;var a=Object.create(null);if(c.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:o}),2&e&&"string"!=typeof o)for(var r in o)c.d(a,r,function(e){return o[e]}.bind(null,r));return a},c.n=function(e){var o=e&&e.__esModule?function(){return e.default}:function(){return e};return c.d(o,"a",o),o},c.o=function(e,o){return Object.prototype.hasOwnProperty.call(e,o)},c.p="",c(c.s=3)}([function(e,o){e.exports=a},function(e,o,a){var r;r=function(){return function(a){var r={};function c(e){if(r[e])return r[e].exports;var o=r[e]={i:e,l:!1,exports:{}};return a[e].call(o.exports,o,o.exports,c),o.l=!0,o.exports}return c.m=a,c.c=r,c.d=function(e,o,a){c.o(e,o)||Object.defineProperty(e,o,{enumerable:!0,get:a})},c.r=function(e){"undefined"!=typeof Symbol&&Symbol.toStringTag&&Object.defineProperty(e,Symbol.toStringTag,{value:"Module"}),Object.defineProperty(e,"__esModule",{value:!0})},c.t=function(o,e){if(1&e&&(o=c(o)),8&e)return o;if(4&e&&"object"==typeof o&&o&&o.__esModule)return o;var a=Object.create(null);if(c.r(a),Object.defineProperty(a,"default",{enumerable:!0,value:o}),2&e&&"string"!=typeof o)for(var r in o)c.d(a,r,function(e){return o[e]}.bind(null,r));return a},c.n=function(e){var o=e&&e.__esModule?function(){return e.default}:function(){return e};return c.d(o,"a",o),o},c.o=function(e,o){return Object.prototype.hasOwnProperty.call(e,o)},c.p="",c(c.s="./src/index.js")}({"./src/bitap/bitap_matched_indices.js":function(e,o){e.exports=function(){for(var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[],o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:1,a=[],r=-1,c=-1,n=0,d=e.length;n<d;n+=1){var i=e[n];i&&-1===r?r=n:i||-1===r||(o<=(c=n-1)-r+1&&a.push([r,c]),r=-1)}return e[n-1]&&o<=n-r&&a.push([r,n-1]),a}},"./src/bitap/bitap_pattern_alphabet.js":function(e,o){e.exports=function(e){for(var o={},a=e.length,r=0;r<a;r+=1)o[e.charAt(r)]=0;for(var c=0;c<a;c+=1)o[e.charAt(c)]|=1<<a-c-1;return o}},"./src/bitap/bitap_regex_search.js":function(e,o){var _=/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g;e.exports=function(e,o){var a=2<arguments.length&&void 0!==arguments[2]?arguments[2]:/ +/g,r=new RegExp(o.replace(_,"\\$&").replace(a,"|")),c=e.match(r),n=!!c,d=[];if(n)for(var i=0,m=c.length;i<m;i+=1){var t=c[i];d.push([e.indexOf(t),t.length-1])}return{score:n?.5:1,isMatch:n,matchedIndices:d}}},"./src/bitap/bitap_score.js":function(e,o){e.exports=function(e,o){var a=o.errors,r=void 0===a?0:a,c=o.currentLocation,n=void 0===c?0:c,d=o.expectedLocation,i=void 0===d?0:d,m=o.distance,t=void 0===m?100:m,_=r/e.length,l=Math.abs(i-n);return t?_+l/t:l?1:_}},"./src/bitap/bitap_search.js":function(e,o,a){var I=a("./src/bitap/bitap_score.js"),B=a("./src/bitap/bitap_matched_indices.js");e.exports=function(e,o,a,r){for(var c=r.location,n=void 0===c?0:c,d=r.distance,i=void 0===d?100:d,m=r.threshold,t=void 0===m?.6:m,_=r.findAllMatches,l=void 0!==_&&_,s=r.minMatchCharLength,f=void 0===s?1:s,g=n,u=e.length,h=t,y=e.indexOf(o,g),j=o.length,p=[],b=0;b<u;b+=1)p[b]=0;if(-1!==y){var v=I(o,{errors:0,currentLocation:y,expectedLocation:g,distance:i});if(h=Math.min(v,h),-1!==(y=e.lastIndexOf(o,g+j))){var k=I(o,{errors:0,currentLocation:y,expectedLocation:g,distance:i});h=Math.min(k,h)}}y=-1;for(var w=[],x=1,S=j+u,q=1<<j-1,E=0;E<j;E+=1){for(var C=0,L=S;C<L;){I(o,{errors:E,currentLocation:g+L,expectedLocation:g,distance:i})<=h?C=L:S=L,L=Math.floor((S-C)/2+C)}S=L;var O=Math.max(1,g-L+1),M=l?u:Math.min(g+L,u)+j,z=Array(M+2);z[M+1]=(1<<E)-1;for(var T=M;O<=T;T-=1){var P=T-1,A=a[e.charAt(P)];if(A&&(p[P]=1),z[T]=(z[T+1]<<1|1)&A,0!==E&&(z[T]|=(w[T+1]|w[T])<<1|1|w[T+1]),z[T]&q&&(x=I(o,{errors:E,currentLocation:P,expectedLocation:g,distance:i}))<=h){if(h=x,(y=P)<=g)break;O=Math.max(1,2*g-y)}}if(h<I(o,{errors:E+1,currentLocation:g,expectedLocation:g,distance:i}))break;w=z}return{isMatch:0<=y,score:0===x?.001:x,matchedIndices:B(p,f)}}},"./src/bitap/index.js":function(e,o,a){function r(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var _=a("./src/bitap/bitap_regex_search.js"),l=a("./src/bitap/bitap_search.js"),p=a("./src/bitap/bitap_pattern_alphabet.js"),c=function(){function j(e,o){var a=o.location,r=void 0===a?0:a,c=o.distance,n=void 0===c?100:c,d=o.threshold,i=void 0===d?.6:d,m=o.maxPatternLength,t=void 0===m?32:m,_=o.isCaseSensitive,l=void 0!==_&&_,s=o.tokenSeparator,f=void 0===s?/ +/g:s,g=o.findAllMatches,u=void 0!==g&&g,h=o.minMatchCharLength,y=void 0===h?1:h;!function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,j),this.options={location:r,distance:n,threshold:i,maxPatternLength:t,isCaseSensitive:l,tokenSeparator:f,findAllMatches:u,minMatchCharLength:y},this.pattern=this.options.isCaseSensitive?e:e.toLowerCase(),this.pattern.length<=t&&(this.patternAlphabet=p(this.pattern))}var e,o,a;return e=j,(o=[{key:"search",value:function(e){if(this.options.isCaseSensitive||(e=e.toLowerCase()),this.pattern===e)return{isMatch:!0,score:0,matchedIndices:[[0,e.length-1]]};var o=this.options,a=o.maxPatternLength,r=o.tokenSeparator;if(this.pattern.length>a)return _(e,this.pattern,r);var c=this.options,n=c.location,d=c.distance,i=c.threshold,m=c.findAllMatches,t=c.minMatchCharLength;return l(e,this.pattern,this.patternAlphabet,{location:n,distance:d,threshold:i,findAllMatches:m,minMatchCharLength:t})}}])&&r(e.prototype,o),a&&r(e,a),j}();e.exports=c},"./src/helpers/deep_value.js":function(e,o,a){var _=a("./src/helpers/is_array.js");e.exports=function(e,o){return function e(o,a,r){if(a){var c=a.indexOf("."),n=a,d=null;-1!==c&&(n=a.slice(0,c),d=a.slice(c+1));var i=o[n];if(null!=i)if(d||"string"!=typeof i&&"number"!=typeof i)if(_(i))for(var m=0,t=i.length;m<t;m+=1)e(i[m],d,r);else d&&e(i,d,r);else r.push(i.toString())}else r.push(o);return r}(e,o,[])}},"./src/helpers/is_array.js":function(e,o){e.exports=function(e){return Array.isArray?Array.isArray(e):"[object Array]"===Object.prototype.toString.call(e)}},"./src/index.js":function(e,o,a){function _(e){return(_="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function r(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}var n=a("./src/bitap/index.js"),R=a("./src/helpers/deep_value.js"),I=a("./src/helpers/is_array.js"),c=function(){function H(e,o){var a=o.location,r=void 0===a?0:a,c=o.distance,n=void 0===c?100:c,d=o.threshold,i=void 0===d?.6:d,m=o.maxPatternLength,t=void 0===m?32:m,_=o.caseSensitive,l=void 0!==_&&_,s=o.tokenSeparator,f=void 0===s?/ +/g:s,g=o.findAllMatches,u=void 0!==g&&g,h=o.minMatchCharLength,y=void 0===h?1:h,j=o.id,p=void 0===j?null:j,b=o.keys,v=void 0===b?[]:b,k=o.shouldSort,w=void 0===k||k,x=o.getFn,S=void 0===x?R:x,q=o.sortFn,E=void 0===q?function(e,o){return e.score-o.score}:q,C=o.tokenize,L=void 0!==C&&C,O=o.matchAllTokens,M=void 0!==O&&O,z=o.includeMatches,T=void 0!==z&&z,P=o.includeScore,A=void 0!==P&&P,I=o.verbose,B=void 0!==I&&I;!function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,H),this.options={location:r,distance:n,threshold:i,maxPatternLength:t,isCaseSensitive:l,tokenSeparator:f,findAllMatches:u,minMatchCharLength:y,id:p,keys:v,includeMatches:T,includeScore:A,shouldSort:w,getFn:S,sortFn:E,verbose:B,tokenize:L,matchAllTokens:M},this.setCollection(e)}var e,o,a;return e=H,(o=[{key:"setCollection",value:function(e){return this.list=e}},{key:"search",value:function(e){var o=1<arguments.length&&void 0!==arguments[1]?arguments[1]:{limit:!1};this._log('---------\nSearch pattern: "'.concat(e,'"'));var a=this._prepareSearchers(e),r=a.tokenSearchers,c=a.fullSearcher,n=this._search(r,c),d=n.weights,i=n.results;return this._computeScore(d,i),this.options.shouldSort&&this._sort(i),o.limit&&"number"==typeof o.limit&&(i=i.slice(0,o.limit)),this._format(i)}},{key:"_prepareSearchers",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:"",o=[];if(this.options.tokenize)for(var a=e.split(this.options.tokenSeparator),r=0,c=a.length;r<c;r+=1)o.push(new n(a[r],this.options));return{tokenSearchers:o,fullSearcher:new n(e,this.options)}}},{key:"_search",value:function(){var e=0<arguments.length&&void 0!==arguments[0]?arguments[0]:[],o=1<arguments.length?arguments[1]:void 0,a=this.list,r={},c=[];if("string"==typeof a[0]){for(var n=0,d=a.length;n<d;n+=1)this._analyze({key:"",value:a[n],record:n,index:n},{resultMap:r,results:c,tokenSearchers:e,fullSearcher:o});return{weights:null,results:c}}for(var i={},m=0,t=a.length;m<t;m+=1)for(var _=a[m],l=0,s=this.options.keys.length;l<s;l+=1){var f=this.options.keys[l];if("string"!=typeof f){if(i[f.name]={weight:1-f.weight||1},f.weight<=0||1<f.weight)throw new Error("Key weight has to be > 0 and <= 1");f=f.name}else i[f]={weight:1};this._analyze({key:f,value:this.options.getFn(_,f),record:_,index:m},{resultMap:r,results:c,tokenSearchers:e,fullSearcher:o})}return{weights:i,results:c}}},{key:"_analyze",value:function(e,o){var a=e.key,r=e.arrayIndex,c=void 0===r?-1:r,n=e.value,d=e.record,i=e.index,m=o.tokenSearchers,t=void 0===m?[]:m,_=o.fullSearcher,l=void 0===_?[]:_,s=o.resultMap,f=void 0===s?{}:s,g=o.results,u=void 0===g?[]:g;if(null!=n){var h=!1,y=-1,j=0;if("string"==typeof n){this._log("\nKey: ".concat(""===a?"-":a));var p=l.search(n);if(this._log('Full text: "'.concat(n,'", score: ').concat(p.score)),this.options.tokenize){for(var b=n.split(this.options.tokenSeparator),v=[],k=0;k<t.length;k+=1){var w=t[k];this._log('\nPattern: "'.concat(w.pattern,'"'));for(var x=!1,S=0;S<b.length;S+=1){var q=b[S],E=w.search(q),C={};E.isMatch?(C[q]=E.score,x=h=!0,v.push(E.score)):(C[q]=1,this.options.matchAllTokens||v.push(1)),this._log('Token: "'.concat(q,'", score: ').concat(C[q]))}x&&(j+=1)}y=v[0];for(var L=v.length,O=1;O<L;O+=1)y+=v[O];y/=L,this._log("Token score average:",y)}var M=p.score;-1<y&&(M=(M+y)/2),this._log("Score average:",M);var z=!this.options.tokenize||!this.options.matchAllTokens||j>=t.length;if(this._log("\nCheck Matches: ".concat(z)),(h||p.isMatch)&&z){var T=f[i];T?T.output.push({key:a,arrayIndex:c,value:n,score:M,matchedIndices:p.matchedIndices}):(f[i]={item:d,output:[{key:a,arrayIndex:c,value:n,score:M,matchedIndices:p.matchedIndices}]},u.push(f[i]))}}else if(I(n))for(var P=0,A=n.length;P<A;P+=1)this._analyze({key:a,arrayIndex:P,value:n[P],record:d,index:i},{resultMap:f,results:u,tokenSearchers:t,fullSearcher:l})}}},{key:"_computeScore",value:function(e,o){this._log("\n\nComputing score:\n");for(var a=0,r=o.length;a<r;a+=1){for(var c=o[a].output,n=c.length,d=1,i=1,m=0;m<n;m+=1){var t=e?e[c[m].key].weight:1,_=(1===t?c[m].score:c[m].score||.001)*t;1!==t?i=Math.min(i,_):d*=c[m].nScore=_}o[a].score=1===i?d:i,this._log(o[a])}}},{key:"_sort",value:function(e){this._log("\n\nSorting...."),e.sort(this.options.sortFn)}},{key:"_format",value:function(e){var o=[];if(this.options.verbose){var a=[];this._log("\n\nOutput:\n\n",JSON.stringify(e,function(e,o){if("object"===_(o)&&null!==o){if(-1!==a.indexOf(o))return;a.push(o)}return o})),a=null}var r=[];this.options.includeMatches&&r.push(function(e,o){var a=e.output;o.matches=[];for(var r=0,c=a.length;r<c;r+=1){var n=a[r];if(0!==n.matchedIndices.length){var d={indices:n.matchedIndices,value:n.value};n.key&&(d.key=n.key),n.hasOwnProperty("arrayIndex")&&-1<n.arrayIndex&&(d.arrayIndex=n.arrayIndex),o.matches.push(d)}}}),this.options.includeScore&&r.push(function(e,o){o.score=e.score});for(var c=0,n=e.length;c<n;c+=1){var d=e[c];if(this.options.id&&(d.item=this.options.getFn(d.item,this.options.id)[0]),r.length){for(var i={item:d.item},m=0,t=r.length;m<t;m+=1)r[m](d,i);o.push(i)}else o.push(d.item)}return o}},{key:"_log",value:function(){var e;this.options.verbose&&(e=console).log.apply(e,arguments)}}])&&r(e.prototype,o),a&&r(e,a),H}();e.exports=c}})},e.exports=r()},function(e,o,a){},function(e,o,a){"use strict";a.r(o);var r=a(0),m=a.n(r),c=[{name:"100",unicode:"1f4af",shortname:":100:",code_decimal:"&#128175;",category:"s",emoji_order:"2119"},{name:"1234",unicode:"1f522",shortname:":1234:",code_decimal:"&#128290;",category:"s",emoji_order:"2122"},{name:"grinning",unicode:"1f600",shortname:":grinning:",code_decimal:"&#128512;",category:"p",emoji_order:"1"},{name:"grin",unicode:"1f601",shortname:":grin:",code_decimal:"&#128513;",category:"p",emoji_order:"2"},{name:"joy",unicode:"1f602",shortname:":joy:",code_decimal:"&#128514;",category:"p",emoji_order:"3"},{name:"smiley",unicode:"1f603",shortname:":smiley:",code_decimal:"&#128515;",category:"p",emoji_order:"5"},{name:"smile",unicode:"1f604",shortname:":smile:",code_decimal:"&#128516;",category:"p",emoji_order:"6"},{name:"sweat_smile",unicode:"1f605",shortname:":sweat_smile:",code_decimal:"&#128517;",category:"p",emoji_order:"7"},{name:"laughing",unicode:"1f606",shortname:":laughing:",code_decimal:"&#128518;",category:"p",emoji_order:"8"},{name:"wink",unicode:"1f609",shortname:":wink:",code_decimal:"&#128521;",category:"p",emoji_order:"9"},{name:"blush",unicode:"1f60a",shortname:":blush:",code_decimal:"&#128522;",category:"p",emoji_order:"10"},{name:"yum",unicode:"1f60b",shortname:":yum:",code_decimal:"&#128523;",category:"p",emoji_order:"11"},{name:"sunglasses",unicode:"1f60e",shortname:":sunglasses:",code_decimal:"&#128526;",category:"p",emoji_order:"12"},{name:"heart_eyes",unicode:"1f60d",shortname:":heart_eyes:",code_decimal:"&#128525;",category:"p",emoji_order:"13"},{name:"kissing_heart",unicode:"1f618",shortname:":kissing_heart:",code_decimal:"&#128536;",category:"p",emoji_order:"14"},{name:"kissing",unicode:"1f617",shortname:":kissing:",code_decimal:"&#128535;",category:"p",emoji_order:"15"},{name:"kissing_smiling_eyes",unicode:"1f619",shortname:":kissing_smiling_eyes:",code_decimal:"&#128537;",category:"p",emoji_order:"16"},{name:"kissing_closed_eyes",unicode:"1f61a",shortname:":kissing_closed_eyes:",code_decimal:"&#128538;",category:"p",emoji_order:"17"},{name:"slightly_smiling_face",unicode:"1f642",shortname:":slight_smile:",code_decimal:"&#128578;",category:"p",emoji_order:"19"},{name:"hugging_face",unicode:"1f917",shortname:":hugging:",code_decimal:"&#129303;",category:"p",emoji_order:"20"},{name:"thinking_face",unicode:"1f914",shortname:":thinking:",code_decimal:"&#129300;",category:"p",emoji_order:"21"},{name:"neutral_face",unicode:"1f610",shortname:":neutral_face:",code_decimal:"&#128528;",category:"p",emoji_order:"22"},{name:"expressionless",unicode:"1f611",shortname:":expressionless:",code_decimal:"&#128529;",category:"p",emoji_order:"23"},{name:"no_mouth",unicode:"1f636",shortname:":no_mouth:",code_decimal:"&#128566;",category:"p",emoji_order:"24"},{name:"face_with_rolling_eyes",unicode:"1f644",shortname:":rolling_eyes:",code_decimal:"&#128580;",category:"p",emoji_order:"25"},{name:"smirk",unicode:"1f60f",shortname:":smirk:",code_decimal:"&#128527;",category:"p",emoji_order:"26"},{name:"persevere",unicode:"1f623",shortname:":persevere:",code_decimal:"&#128547;",category:"p",emoji_order:"27"},{name:"disappointed_relieved",unicode:"1f625",shortname:":disappointed_relieved:",code_decimal:"&#128549;",category:"p",emoji_order:"28"},{name:"open_mouth",unicode:"1f62e",shortname:":open_mouth:",code_decimal:"&#128558;",category:"p",emoji_order:"29"},{name:"zipper_mouth_face",unicode:"1f910",shortname:":zipper_mouth:",code_decimal:"&#129296;",category:"p",emoji_order:"30"},{name:"hushed",unicode:"1f62f",shortname:":hushed:",code_decimal:"&#128559;",category:"p",emoji_order:"31"},{name:"sleepy",unicode:"1f62a",shortname:":sleepy:",code_decimal:"&#128554;",category:"p",emoji_order:"32"},{name:"tired_face",unicode:"1f62b",shortname:":tired_face:",code_decimal:"&#128555;",category:"p",emoji_order:"33"},{name:"sleeping",unicode:"1f634",shortname:":sleeping:",code_decimal:"&#128564;",category:"p",emoji_order:"34"},{name:"relieved",unicode:"1f60c",shortname:":relieved:",code_decimal:"&#128524;",category:"p",emoji_order:"35"},{name:"nerd_face",unicode:"1f913",shortname:":nerd:",code_decimal:"&#129299;",category:"p",emoji_order:"36"},{name:"stuck_out_tongue",unicode:"1f61b",shortname:":stuck_out_tongue:",code_decimal:"&#128539;",category:"p",emoji_order:"37"},{name:"stuck_out_tongue_winking_eye",unicode:"1f61c",shortname:":stuck_out_tongue_winking_eye:",code_decimal:"&#128540;",category:"p",emoji_order:"38"},{name:"stuck_out_tongue_closed_eyes",unicode:"1f61d",shortname:":stuck_out_tongue_closed_eyes:",code_decimal:"&#128541;",category:"p",emoji_order:"39"},{name:"unamused",unicode:"1f612",shortname:":unamused:",code_decimal:"&#128530;",category:"p",emoji_order:"41"},{name:"sweat",unicode:"1f613",shortname:":sweat:",code_decimal:"&#128531;",category:"p",emoji_order:"42"},{name:"pensive",unicode:"1f614",shortname:":pensive:",code_decimal:"&#128532;",category:"p",emoji_order:"43"},{name:"confused",unicode:"1f615",shortname:":confused:",code_decimal:"&#128533;",category:"p",emoji_order:"44"},{name:"upside_down_face",unicode:"1f643",shortname:":upside_down:",code_decimal:"&#128579;",category:"p",emoji_order:"45"},{name:"money_mouth_face",unicode:"1f911",shortname:":money_mouth:",code_decimal:"&#129297;",category:"p",emoji_order:"46"},{name:"astonished",unicode:"1f632",shortname:":astonished:",code_decimal:"&#128562;",category:"p",emoji_order:"47"},{name:"slightly_frowning_face",unicode:"1f641",shortname:":slight_frown:",code_decimal:"&#128577;",category:"p",emoji_order:"49"},{name:"confounded",unicode:"1f616",shortname:":confounded:",code_decimal:"&#128534;",category:"p",emoji_order:"50"},{name:"disappointed",unicode:"1f61e",shortname:":disappointed:",code_decimal:"&#128542;",category:"p",emoji_order:"51"},{name:"worried",unicode:"1f61f",shortname:":worried:",code_decimal:"&#128543;",category:"p",emoji_order:"52"},{name:"triumph",unicode:"1f624",shortname:":triumph:",code_decimal:"&#128548;",category:"p",emoji_order:"53"},{name:"cry",unicode:"1f622",shortname:":cry:",code_decimal:"&#128546;",category:"p",emoji_order:"54"},{name:"sob",unicode:"1f62d",shortname:":sob:",code_decimal:"&#128557;",category:"p",emoji_order:"55"},{name:"frowning",unicode:"1f626",shortname:":frowning:",code_decimal:"&#128550;",category:"p",emoji_order:"56"},{name:"anguished",unicode:"1f627",shortname:":anguished:",code_decimal:"&#128551;",category:"p",emoji_order:"57"},{name:"fearful",unicode:"1f628",shortname:":fearful:",code_decimal:"&#128552;",category:"p",emoji_order:"58"},{name:"weary",unicode:"1f629",shortname:":weary:",code_decimal:"&#128553;",category:"p",emoji_order:"59"},{name:"grimacing",unicode:"1f62c",shortname:":grimacing:",code_decimal:"&#128556;",category:"p",emoji_order:"60"},{name:"cold_sweat",unicode:"1f630",shortname:":cold_sweat:",code_decimal:"&#128560;",category:"p",emoji_order:"61"},{name:"scream",unicode:"1f631",shortname:":scream:",code_decimal:"&#128561;",category:"p",emoji_order:"62"},{name:"flushed",unicode:"1f633",shortname:":flushed:",code_decimal:"&#128563;",category:"p",emoji_order:"63"},{name:"dizzy_face",unicode:"1f635",shortname:":dizzy_face:",code_decimal:"&#128565;",category:"p",emoji_order:"64"},{name:"rage",unicode:"1f621",shortname:":rage:",code_decimal:"&#128545;",category:"p",emoji_order:"65"},{name:"angry",unicode:"1f620",shortname:":angry:",code_decimal:"&#128544;",category:"p",emoji_order:"66"},{name:"innocent",unicode:"1f607",shortname:":innocent:",code_decimal:"&#128519;",category:"p",emoji_order:"67"},{name:"mask",unicode:"1f637",shortname:":mask:",code_decimal:"&#128567;",category:"p",emoji_order:"71"},{name:"face_with_thermometer",unicode:"1f912",shortname:":thermometer_face:",code_decimal:"&#129298;",category:"p",emoji_order:"72"},{name:"face_with_head_bandage",unicode:"1f915",shortname:":head_bandage:",code_decimal:"&#129301;",category:"p",emoji_order:"73"},{name:"smiling_imp",unicode:"1f608",shortname:":smiling_imp:",code_decimal:"&#128520;",category:"p",emoji_order:"76"},{name:"imp",unicode:"1f47f",shortname:":imp:",code_decimal:"&#128127;",category:"p",emoji_order:"77"},{name:"japanese_ogre",unicode:"1f479",shortname:":japanese_ogre:",code_decimal:"&#128121;",category:"p",emoji_order:"78"},{name:"japanese_goblin",unicode:"1f47a",shortname:":japanese_goblin:",code_decimal:"&#128122;",category:"p",emoji_order:"79"},{name:"skull",unicode:"1f480",shortname:":skull:",code_decimal:"&#128128;",category:"p",emoji_order:"80"},{name:"skull_and_crossbones",unicode:"2620",shortname:":skull_crossbones:",code_decimal:"&#9760;",category:"o",emoji_order:"81"},{name:"ghost",unicode:"1f47b",shortname:":ghost:",code_decimal:"&#128123;",category:"p",emoji_order:"82"},{name:"alien",unicode:"1f47d",shortname:":alien:",code_decimal:"&#128125;",category:"p",emoji_order:"83"},{name:"space_invader",unicode:"1f47e",shortname:":space_invader:",code_decimal:"&#128126;",category:"a",emoji_order:"84"},{name:"robot_face",unicode:"1f916",shortname:":robot:",code_decimal:"&#129302;",category:"p",emoji_order:"85"},{name:"hankey",unicode:"1f4a9",shortname:":poop:",code_decimal:"&#128169;",category:"p",emoji_order:"86"},{name:"smiley_cat",unicode:"1f63a",shortname:":smiley_cat:",code_decimal:"&#128570;",category:"p",emoji_order:"87"},{name:"smile_cat",unicode:"1f638",shortname:":smile_cat:",code_decimal:"&#128568;",category:"p",emoji_order:"88"},{name:"joy_cat",unicode:"1f639",shortname:":joy_cat:",code_decimal:"&#128569;",category:"p",emoji_order:"89"},{name:"heart_eyes_cat",unicode:"1f63b",shortname:":heart_eyes_cat:",code_decimal:"&#128571;",category:"p",emoji_order:"90"},{name:"smirk_cat",unicode:"1f63c",shortname:":smirk_cat:",code_decimal:"&#128572;",category:"p",emoji_order:"91"},{name:"kissing_cat",unicode:"1f63d",shortname:":kissing_cat:",code_decimal:"&#128573;",category:"p",emoji_order:"92"},{name:"scream_cat",unicode:"1f640",shortname:":scream_cat:",code_decimal:"&#128576;",category:"p",emoji_order:"93"},{name:"crying_cat_face",unicode:"1f63f",shortname:":crying_cat_face:",code_decimal:"&#128575;",category:"p",emoji_order:"94"},{name:"pouting_cat",unicode:"1f63e",shortname:":pouting_cat:",code_decimal:"&#128574;",category:"p",emoji_order:"95"},{name:"see_no_evil",unicode:"1f648",shortname:":see_no_evil:",code_decimal:"&#128584;",category:"n",emoji_order:"96"},{name:"hear_no_evil",unicode:"1f649",shortname:":hear_no_evil:",code_decimal:"&#128585;",category:"n",emoji_order:"97"},{name:"speak_no_evil",unicode:"1f64a",shortname:":speak_no_evil:",code_decimal:"&#128586;",category:"n",emoji_order:"98"},{name:"boy",unicode:"1f466",shortname:":boy:",code_decimal:"&#128102;",category:"p",emoji_order:"99"},{name:"girl",unicode:"1f467",shortname:":girl:",code_decimal:"&#128103;",category:"p",emoji_order:"105"},{name:"man",unicode:"1f468",shortname:":man:",code_decimal:"&#128104;",category:"p",emoji_order:"111"},{name:"woman",unicode:"1f469",shortname:":woman:",code_decimal:"&#128105;",category:"p",emoji_order:"117"},{name:"older_man",unicode:"1f474",shortname:":older_man:",code_decimal:"&#128116;",category:"p",emoji_order:"123"},{name:"older_woman",unicode:"1f475",shortname:":older_woman:",code_decimal:"&#128117;",category:"p",emoji_order:"129"},{name:"baby",unicode:"1f476",shortname:":baby:",code_decimal:"&#128118;",category:"p",emoji_order:"135"},{name:"angel",unicode:"1f47c",shortname:":angel:",code_decimal:"&#128124;",category:"p",emoji_order:"141"},{name:"cop",unicode:"1f46e",shortname:":cop:",code_decimal:"&#128110;",category:"p",emoji_order:"339"},{name:"sleuth_or_spy",unicode:"1f575",shortname:":spy:",code_decimal:"&#128373;",category:"p",emoji_order:"357"},{name:"guardsman",unicode:"1f482",shortname:":guardsman:",code_decimal:"&#128130;",category:"p",emoji_order:"375"},{name:"construction_worker",unicode:"1f477",shortname:":construction_worker:",code_decimal:"&#128119;",category:"p",emoji_order:"393"},{name:"man_with_turban",unicode:"1f473",shortname:":man_with_turban:",code_decimal:"&#128115;",category:"p",emoji_order:"411"},{name:"person_with_blond_hair",unicode:"1f471",shortname:":person_with_blond_hair:",code_decimal:"&#128113;",category:"p",emoji_order:"429"},{name:"santa",unicode:"1f385",shortname:":santa:",code_decimal:"&#127877;",category:"p",emoji_order:"447"},{name:"princess",unicode:"1f478",shortname:":princess:",code_decimal:"&#128120;",category:"p",emoji_order:"459"},{name:"bride_with_veil",unicode:"1f470",shortname:":bride_with_veil:",code_decimal:"&#128112;",category:"p",emoji_order:"471"},{name:"man_with_gua_pi_mao",unicode:"1f472",shortname:":man_with_gua_pi_mao:",code_decimal:"&#128114;",category:"p",emoji_order:"489"},{name:"person_frowning",unicode:"1f64d",shortname:":person_frowning:",code_decimal:"&#128589;",category:"p",emoji_order:"495"},{name:"person_with_pouting_face",unicode:"1f64e",shortname:":person_with_pouting_face:",code_decimal:"&#128590;",category:"p",emoji_order:"513"},{name:"no_good",unicode:"1f645",shortname:":no_good:",code_decimal:"&#128581;",category:"p",emoji_order:"531"},{name:"ok_woman",unicode:"1f646",shortname:":ok_woman:",code_decimal:"&#128582;",category:"p",emoji_order:"549"},{name:"information_desk_person",unicode:"1f481",shortname:":information_desk_person:",code_decimal:"&#128129;",category:"p",emoji_order:"567"},{name:"raising_hand",unicode:"1f64b",shortname:":raising_hand:",code_decimal:"&#128587;",category:"p",emoji_order:"585"},{name:"bow",unicode:"1f647",shortname:":bow:",code_decimal:"&#128583;",category:"p",emoji_order:"603"},{name:"massage",unicode:"1f486",shortname:":massage:",code_decimal:"&#128134;",category:"p",emoji_order:"657"},{name:"haircut",unicode:"1f487",shortname:":haircut:",code_decimal:"&#128135;",category:"p",emoji_order:"675"},{name:"walking",unicode:"1f6b6",shortname:":walking:",code_decimal:"&#128694;",category:"p",emoji_order:"693"},{name:"runner",unicode:"1f3c3",shortname:":runner:",code_decimal:"&#127939;",category:"p",emoji_order:"711"},{name:"dancer",unicode:"1f483",shortname:":dancer:",code_decimal:"&#128131;",category:"p",emoji_order:"729"},{name:"dancers",unicode:"1f46f",shortname:":dancers:",code_decimal:"&#128111;",category:"p",emoji_order:"741"},{name:"man_in_business_suit_levitating",unicode:"1f574",shortname:":levitate:",code_decimal:"&#128372;",category:"a",emoji_order:"759"},{name:"speaking_head_in_silhouette",unicode:"1f5e3",shortname:":speaking_head:",code_decimal:"&#128483;",category:"p",emoji_order:"765"},{name:"bust_in_silhouette",unicode:"1f464",shortname:":bust_in_silhouette:",code_decimal:"&#128100;",category:"p",emoji_order:"766"},{name:"busts_in_silhouette",unicode:"1f465",shortname:":busts_in_silhouette:",code_decimal:"&#128101;",category:"p",emoji_order:"767"},{name:"horse_racing",unicode:"1f3c7",shortname:":horse_racing:",code_decimal:"&#127943;",category:"a",emoji_order:"769"},{name:"skier",unicode:"26f7",shortname:":skier:",code_decimal:"&#9975;",category:"a",emoji_order:"775"},{name:"snowboarder",unicode:"1f3c2",shortname:":snowboarder:",code_decimal:"&#127938;",category:"a",emoji_order:"776"},{name:"golfer",unicode:"1f3cc",shortname:":golfer:",code_decimal:"&#127948;",category:"a",emoji_order:"782"},{name:"surfer",unicode:"1f3c4",shortname:":surfer:",code_decimal:"&#127940;",category:"a",emoji_order:"800"},{name:"rowboat",unicode:"1f6a3",shortname:":rowboat:",code_decimal:"&#128675;",category:"a",emoji_order:"818"},{name:"swimmer",unicode:"1f3ca",shortname:":swimmer:",code_decimal:"&#127946;",category:"a",emoji_order:"836"},{name:"person_with_ball",unicode:"26f9",shortname:":basketball_player:",code_decimal:"&#9977;",category:"a",emoji_order:"854"},{name:"weight_lifter",unicode:"1f3cb",shortname:":lifter:",code_decimal:"&#127947;",category:"a",emoji_order:"872"},{name:"bicyclist",unicode:"1f6b4",shortname:":bicyclist:",code_decimal:"&#128692;",category:"a",emoji_order:"890"},{name:"mountain_bicyclist",unicode:"1f6b5",shortname:":mountain_bicyclist:",code_decimal:"&#128693;",category:"a",emoji_order:"908"},{name:"racing_car",unicode:"1f3ce",shortname:":race_car:",code_decimal:"&#127950;",category:"t",emoji_order:"926"},{name:"racing_motorcycle",unicode:"1f3cd",shortname:":motorcycle:",code_decimal:"&#127949;",category:"t",emoji_order:"927"},{name:"couple",unicode:"1f46b",shortname:":couple:",code_decimal:"&#128107;",category:"p",emoji_order:"1018"},{name:"two_men_holding_hands",unicode:"1f46c",shortname:":two_men_holding_hands:",code_decimal:"&#128108;",category:"p",emoji_order:"1024"},{name:"two_women_holding_hands",unicode:"1f46d",shortname:":two_women_holding_hands:",code_decimal:"&#128109;",category:"p",emoji_order:"1030"},{name:"couplekiss",unicode:"1f48f",shortname:":couplekiss:",code_decimal:"&#128143;",category:"p",emoji_order:"1036"},{name:"couple_with_heart",unicode:"1f491",shortname:":couple_with_heart:",code_decimal:"&#128145;",category:"p",emoji_order:"1040"},{name:"family",unicode:"1f46a",shortname:":family:",code_decimal:"&#128106;",category:"p",emoji_order:"1044"},{name:"muscle",unicode:"1f4aa",shortname:":muscle:",code_decimal:"&#128170;",category:"p",emoji_order:"1080"},{name:"point_left",unicode:"1f448",shortname:":point_left:",code_decimal:"&#128072;",category:"p",emoji_order:"1092"},{name:"point_right",unicode:"1f449",shortname:":point_right:",code_decimal:"&#128073;",category:"p",emoji_order:"1098"},{name:"point_up",unicode:"261d",shortname:":point_up:",code_decimal:"&#9757;",category:"p",emoji_order:"1104"},{name:"point_up_2",unicode:"1f446",shortname:":point_up_2:",code_decimal:"&#128070;",category:"p",emoji_order:"1110"},{name:"middle_finger",unicode:"1f595",shortname:":middle_finger:",code_decimal:"&#128405;",category:"p",emoji_order:"1116"},{name:"point_down",unicode:"1f447",shortname:":point_down:",code_decimal:"&#128071;",category:"p",emoji_order:"1122"},{name:"v",unicode:"270c",shortname:":v:",code_decimal:"&#9996;",category:"p",emoji_order:"1128"},{name:"the_horns",unicode:"1f918",shortname:":metal_tone2:",code_decimal:"&#129304;",category:"p",emoji_order:"1146"},{name:"raised_hand_with_fingers_splayed",unicode:"1f590",shortname:":hand_splayed:",code_decimal:"&#128400;",category:"p",emoji_order:"1158"},{name:"ok_hand",unicode:"1f44c",shortname:":ok_hand:",code_decimal:"&#128076;",category:"p",emoji_order:"1170"},{name:"thumbsup",unicode:"1f44d",shortname:":thumbsup:",code_decimal:"&#128077;",category:"p",emoji_order:"1176"},{name:"thumbsdown",unicode:"1f44e",shortname:":thumbsdown:",code_decimal:"&#128078;",category:"p",emoji_order:"1182"},{name:"fist",unicode:"270a",shortname:":fist:",code_decimal:"&#9994;",category:"p",emoji_order:"1188"},{name:"facepunch",unicode:"1f44a",shortname:":punch:",code_decimal:"&#128074;",category:"p",emoji_order:"1194"},{name:"wave",unicode:"1f44b",shortname:":wave:",code_decimal:"&#128075;",category:"p",emoji_order:"1218"},{name:"clap",unicode:"1f44f",shortname:":clap:",code_decimal:"&#128079;",category:"p",emoji_order:"1224"},{name:"writing_hand",unicode:"270d",shortname:":writing_hand:",code_decimal:"&#9997;",category:"p",emoji_order:"1230"},{name:"open_hands",unicode:"1f450",shortname:":open_hands:",code_decimal:"&#128080;",category:"p",emoji_order:"1236"},{name:"raised_hands",unicode:"1f64c",shortname:":raised_hands:",code_decimal:"&#128588;",category:"p",emoji_order:"1242"},{name:"pray",unicode:"1f64f",shortname:":pray:",code_decimal:"&#128591;",category:"p",emoji_order:"1248"},{name:"nail_care",unicode:"1f485",shortname:":nail_care:",code_decimal:"&#128133;",category:"p",emoji_order:"1260"},{name:"ear",unicode:"1f442",shortname:":ear:",code_decimal:"&#128066;",category:"p",emoji_order:"1266"},{name:"nose",unicode:"1f443",shortname:":nose:",code_decimal:"&#128067;",category:"p",emoji_order:"1272"},{name:"footprints",unicode:"1f463",shortname:":footprints:",code_decimal:"&#128099;",category:"p",emoji_order:"1278"},{name:"eyes",unicode:"1f440",shortname:":eyes:",code_decimal:"&#128064;",category:"p",emoji_order:"1279"},{name:"eye",unicode:"1f441",shortname:":eye:",code_decimal:"&#128065;",category:"p",emoji_order:"1280"},{name:"tongue",unicode:"1f445",shortname:":tongue:",code_decimal:"&#128069;",category:"p",emoji_order:"1282"},{name:"lips",unicode:"1f444",shortname:":lips:",code_decimal:"&#128068;",category:"p",emoji_order:"1283"},{name:"kiss",unicode:"1f48b",shortname:":kiss:",code_decimal:"&#128139;",category:"p",emoji_order:"1284"},{name:"cupid",unicode:"1f498",shortname:":cupid:",code_decimal:"&#128152;",category:"s",emoji_order:"1285"},{name:"heart",unicode:"2764",shortname:":heart:",code_decimal:"&#10084;",category:"s",emoji_order:"1286"},{name:"heartbeat",unicode:"1f493",shortname:":heartbeat:",code_decimal:"&#128147;",category:"s",emoji_order:"1287"},{name:"broken_heart",unicode:"1f494",shortname:":broken_heart:",code_decimal:"&#128148;",category:"s",emoji_order:"1288"},{name:"two_hearts",unicode:"1f495",shortname:":two_hearts:",code_decimal:"&#128149;",category:"s",emoji_order:"1289"},{name:"sparkling_heart",unicode:"1f496",shortname:":sparkling_heart:",code_decimal:"&#128150;",category:"s",emoji_order:"1290"},{name:"heartpulse",unicode:"1f497",shortname:":heartpulse:",code_decimal:"&#128151;",category:"s",emoji_order:"1291"},{name:"blue_heart",unicode:"1f499",shortname:":blue_heart:",code_decimal:"&#128153;",category:"s",emoji_order:"1292"},{name:"green_heart",unicode:"1f49a",shortname:":green_heart:",code_decimal:"&#128154;",category:"s",emoji_order:"1293"},{name:"yellow_heart",unicode:"1f49b",shortname:":yellow_heart:",code_decimal:"&#128155;",category:"s",emoji_order:"1294"},{name:"purple_heart",unicode:"1f49c",shortname:":purple_heart:",code_decimal:"&#128156;",category:"s",emoji_order:"1295"},{name:"gift_heart",unicode:"1f49d",shortname:":gift_heart:",code_decimal:"&#128157;",category:"s",emoji_order:"1297"},{name:"revolving_hearts",unicode:"1f49e",shortname:":revolving_hearts:",code_decimal:"&#128158;",category:"s",emoji_order:"1298"},{name:"heart_decoration",unicode:"1f49f",shortname:":heart_decoration:",code_decimal:"&#128159;",category:"s",emoji_order:"1299"},{name:"heart_exclamation",unicode:"2763",shortname:":heart_exclamation:",code_decimal:"&#10083;",category:"s",emoji_order:"1300"},{name:"love_letter",unicode:"1f48c",shortname:":love_letter:",code_decimal:"&#128140;",category:"o",emoji_order:"1301"},{name:"zzz",unicode:"1f4a4",shortname:":zzz:",code_decimal:"&#128164;",category:"p",emoji_order:"1302"},{name:"anger",unicode:"1f4a2",shortname:":anger:",code_decimal:"&#128162;",category:"s",emoji_order:"1303"},{name:"bomb",unicode:"1f4a3",shortname:":bomb:",code_decimal:"&#128163;",category:"o",emoji_order:"1304"},{name:"boom",unicode:"1f4a5",shortname:":boom:",code_decimal:"&#128165;",category:"s",emoji_order:"1305"},{name:"sweat_drops",unicode:"1f4a6",shortname:":sweat_drops:",code_decimal:"&#128166;",category:"n",emoji_order:"1306"},{name:"dash",unicode:"1f4a8",shortname:":dash:",code_decimal:"&#128168;",category:"n",emoji_order:"1307"},{name:"dizzy",unicode:"1f4ab",shortname:":dizzy:",code_decimal:"&#128171;",category:"s",emoji_order:"1308"},{name:"speech_balloon",unicode:"1f4ac",shortname:":speech_balloon:",code_decimal:"&#128172;",category:"s",emoji_order:"1309"},{name:"left_speech_bubble",unicode:"1f5e8",shortname:":speech_left:",code_decimal:"&#128488;",category:"s",emoji_order:"1310"},{name:"right_anger_bubble",unicode:"1f5ef",shortname:":anger_right:",code_decimal:"&#128495;",category:"s",emoji_order:"1311"},{name:"thought_balloon",unicode:"1f4ad",shortname:":thought_balloon:",code_decimal:"&#128173;",category:"s",emoji_order:"1312"},{name:"hole",unicode:"1f573",shortname:":hole:",code_decimal:"&#128371;",category:"o",emoji_order:"1313"},{name:"eyeglasses",unicode:"1f453",shortname:":eyeglasses:",code_decimal:"&#128083;",category:"p",emoji_order:"1314"},{name:"dark_sunglasses",unicode:"1f576",shortname:":dark_sunglasses:",code_decimal:"&#128374;",category:"p",emoji_order:"1315"},{name:"necktie",unicode:"1f454",shortname:":necktie:",code_decimal:"&#128084;",category:"p",emoji_order:"1316"},{name:"shirt",unicode:"1f455",shortname:":shirt:",code_decimal:"&#128085;",category:"p",emoji_order:"1317"},{name:"jeans",unicode:"1f456",shortname:":jeans:",code_decimal:"&#128086;",category:"p",emoji_order:"1318"},{name:"dress",unicode:"1f457",shortname:":dress:",code_decimal:"&#128087;",category:"p",emoji_order:"1319"},{name:"kimono",unicode:"1f458",shortname:":kimono:",code_decimal:"&#128088;",category:"p",emoji_order:"1320"},{name:"bikini",unicode:"1f459",shortname:":bikini:",code_decimal:"&#128089;",category:"p",emoji_order:"1321"},{name:"womans_clothes",unicode:"1f45a",shortname:":womans_clothes:",code_decimal:"&#128090;",category:"p",emoji_order:"1322"},{name:"purse",unicode:"1f45b",shortname:":purse:",code_decimal:"&#128091;",category:"p",emoji_order:"1323"},{name:"handbag",unicode:"1f45c",shortname:":handbag:",code_decimal:"&#128092;",category:"p",emoji_order:"1324"},{name:"pouch",unicode:"1f45d",shortname:":pouch:",code_decimal:"&#128093;",category:"p",emoji_order:"1325"},{name:"shopping_bags",unicode:"1f6cd",shortname:":shopping_bags:",code_decimal:"&#128717;",category:"o",emoji_order:"1326"},{name:"school_satchel",unicode:"1f392",shortname:":school_satchel:",code_decimal:"&#127890;",category:"p",emoji_order:"1327"},{name:"mans_shoe",unicode:"1f45e",shortname:":mans_shoe:",code_decimal:"&#128094;",category:"p",emoji_order:"1328"},{name:"athletic_shoe",unicode:"1f45f",shortname:":athletic_shoe:",code_decimal:"&#128095;",category:"p",emoji_order:"1329"},{name:"high_heel",unicode:"1f460",shortname:":high_heel:",code_decimal:"&#128096;",category:"p",emoji_order:"1330"},{name:"sandal",unicode:"1f461",shortname:":sandal:",code_decimal:"&#128097;",category:"p",emoji_order:"1331"},{name:"boot",unicode:"1f462",shortname:":boot:",code_decimal:"&#128098;",category:"p",emoji_order:"1332"},{name:"crown",unicode:"1f451",shortname:":crown:",code_decimal:"&#128081;",category:"p",emoji_order:"1333"},{name:"womans_hat",unicode:"1f452",shortname:":womans_hat:",code_decimal:"&#128082;",category:"p",emoji_order:"1334"},{name:"tophat",unicode:"1f3a9",shortname:":tophat:",code_decimal:"&#127913;",category:"p",emoji_order:"1335"},{name:"mortar_board",unicode:"1f393",shortname:":mortar_board:",code_decimal:"&#127891;",category:"p",emoji_order:"1336"},{name:"helmet_with_white_cross",unicode:"26d1",shortname:":helmet_with_cross:",code_decimal:"&#9937;",category:"p",emoji_order:"1337"},{name:"prayer_beads",unicode:"1f4ff",shortname:":prayer_beads:",code_decimal:"&#128255;",category:"o",emoji_order:"1338"},{name:"lipstick",unicode:"1f484",shortname:":lipstick:",code_decimal:"&#128132;",category:"p",emoji_order:"1339"},{name:"ring",unicode:"1f48d",shortname:":ring:",code_decimal:"&#128141;",category:"p",emoji_order:"1340"},{name:"gem",unicode:"1f48e",shortname:":gem:",code_decimal:"&#128142;",category:"o",emoji_order:"1341"},{name:"monkey_face",unicode:"1f435",shortname:":monkey_face:",code_decimal:"&#128053;",category:"n",emoji_order:"1342"},{name:"monkey",unicode:"1f412",shortname:":monkey:",code_decimal:"&#128018;",category:"n",emoji_order:"1343"},{name:"dog",unicode:"1f436",shortname:":dog:",code_decimal:"&#128054;",category:"n",emoji_order:"1345"},{name:"dog2",unicode:"1f415",shortname:":dog2:",code_decimal:"&#128021;",category:"n",emoji_order:"1346"},{name:"poodle",unicode:"1f429",shortname:":poodle:",code_decimal:"&#128041;",category:"n",emoji_order:"1347"},{name:"wolf",unicode:"1f43a",shortname:":wolf:",code_decimal:"&#128058;",category:"n",emoji_order:"1348"},{name:"cat",unicode:"1f431",shortname:":cat:",code_decimal:"&#128049;",category:"n",emoji_order:"1350"},{name:"cat2",unicode:"1f408",shortname:":cat2:",code_decimal:"&#128008;",category:"n",emoji_order:"1351"},{name:"lion_face",unicode:"1f981",shortname:":lion_face:",code_decimal:"&#129409;",category:"n",emoji_order:"1352"},{name:"tiger",unicode:"1f42f",shortname:":tiger:",code_decimal:"&#128047;",category:"n",emoji_order:"1353"},{name:"tiger2",unicode:"1f405",shortname:":tiger2:",code_decimal:"&#128005;",category:"n",emoji_order:"1354"},{name:"leopard",unicode:"1f406",shortname:":leopard:",code_decimal:"&#128006;",category:"n",emoji_order:"1355"},{name:"horse",unicode:"1f434",shortname:":horse:",code_decimal:"&#128052;",category:"n",emoji_order:"1356"},{name:"racehorse",unicode:"1f40e",shortname:":racehorse:",code_decimal:"&#128014;",category:"n",emoji_order:"1357"},{name:"unicorn_face",unicode:"1f984",shortname:":unicorn:",code_decimal:"&#129412;",category:"n",emoji_order:"1359"},{name:"cow",unicode:"1f42e",shortname:":cow:",code_decimal:"&#128046;",category:"n",emoji_order:"1360"},{name:"ox",unicode:"1f402",shortname:":ox:",code_decimal:"&#128002;",category:"n",emoji_order:"1361"},{name:"water_buffalo",unicode:"1f403",shortname:":water_buffalo:",code_decimal:"&#128003;",category:"n",emoji_order:"1362"},{name:"cow2",unicode:"1f404",shortname:":cow2:",code_decimal:"&#128004;",category:"n",emoji_order:"1363"},{name:"pig",unicode:"1f437",shortname:":pig:",code_decimal:"&#128055;",category:"n",emoji_order:"1364"},{name:"pig2",unicode:"1f416",shortname:":pig2:",code_decimal:"&#128022;",category:"n",emoji_order:"1365"},{name:"boar",unicode:"1f417",shortname:":boar:",code_decimal:"&#128023;",category:"n",emoji_order:"1366"},{name:"pig_nose",unicode:"1f43d",shortname:":pig_nose:",code_decimal:"&#128061;",category:"n",emoji_order:"1367"},{name:"ram",unicode:"1f40f",shortname:":ram:",code_decimal:"&#128015;",category:"n",emoji_order:"1368"},{name:"sheep",unicode:"1f411",shortname:":sheep:",code_decimal:"&#128017;",category:"n",emoji_order:"1369"},{name:"goat",unicode:"1f410",shortname:":goat:",code_decimal:"&#128016;",category:"n",emoji_order:"1370"},{name:"dromedary_camel",unicode:"1f42a",shortname:":dromedary_camel:",code_decimal:"&#128042;",category:"n",emoji_order:"1371"},{name:"camel",unicode:"1f42b",shortname:":camel:",code_decimal:"&#128043;",category:"n",emoji_order:"1372"},{name:"elephant",unicode:"1f418",shortname:":elephant:",code_decimal:"&#128024;",category:"n",emoji_order:"1373"},{name:"mouse",unicode:"1f42d",shortname:":mouse:",code_decimal:"&#128045;",category:"n",emoji_order:"1375"},{name:"mouse2",unicode:"1f401",shortname:":mouse2:",code_decimal:"&#128001;",category:"n",emoji_order:"1376"},{name:"rat",unicode:"1f400",shortname:":rat:",code_decimal:"&#128000;",category:"n",emoji_order:"1377"},{name:"hamster",unicode:"1f439",shortname:":hamster:",code_decimal:"&#128057;",category:"n",emoji_order:"1378"},{name:"rabbit",unicode:"1f430",shortname:":rabbit:",code_decimal:"&#128048;",category:"n",emoji_order:"1379"},{name:"rabbit2",unicode:"1f407",shortname:":rabbit2:",code_decimal:"&#128007;",category:"n",emoji_order:"1380"},{name:"chipmunk",unicode:"1f43f",shortname:":chipmunk:",code_decimal:"&#128063;",category:"n",emoji_order:"1381"},{name:"bear",unicode:"1f43b",shortname:":bear:",code_decimal:"&#128059;",category:"n",emoji_order:"1383"},{name:"koala",unicode:"1f428",shortname:":koala:",code_decimal:"&#128040;",category:"n",emoji_order:"1384"},{name:"panda_face",unicode:"1f43c",shortname:":panda_face:",code_decimal:"&#128060;",category:"n",emoji_order:"1385"},{name:"feet",unicode:"1f43e",shortname:":feet:",code_decimal:"&#128062;",category:"n",emoji_order:"1386"},{name:"turkey",unicode:"1f983",shortname:":turkey:",code_decimal:"&#129411;",category:"n",emoji_order:"1387"},{name:"chicken",unicode:"1f414",shortname:":chicken:",code_decimal:"&#128020;",category:"n",emoji_order:"1388"},{name:"rooster",unicode:"1f413",shortname:":rooster:",code_decimal:"&#128019;",category:"n",emoji_order:"1389"},{name:"hatching_chick",unicode:"1f423",shortname:":hatching_chick:",code_decimal:"&#128035;",category:"n",emoji_order:"1390"},{name:"baby_chick",unicode:"1f424",shortname:":baby_chick:",code_decimal:"&#128036;",category:"n",emoji_order:"1391"},{name:"hatched_chick",unicode:"1f425",shortname:":hatched_chick:",code_decimal:"&#128037;",category:"n",emoji_order:"1392"},{name:"bird",unicode:"1f426",shortname:":bird:",code_decimal:"&#128038;",category:"n",emoji_order:"1393"},{name:"penguin",unicode:"1f427",shortname:":penguin:",code_decimal:"&#128039;",category:"n",emoji_order:"1394"},{name:"dove_of_peace",unicode:"1f54a",shortname:":dove:",code_decimal:"&#128330;",category:"n",emoji_order:"1395"},{name:"frog",unicode:"1f438",shortname:":frog:",code_decimal:"&#128056;",category:"n",emoji_order:"1399"},{name:"crocodile",unicode:"1f40a",shortname:":crocodile:",code_decimal:"&#128010;",category:"n",emoji_order:"1400"},{name:"turtle",unicode:"1f422",shortname:":turtle:",code_decimal:"&#128034;",category:"n",emoji_order:"1401"},{name:"snake",unicode:"1f40d",shortname:":snake:",code_decimal:"&#128013;",category:"n",emoji_order:"1403"},{name:"dragon_face",unicode:"1f432",shortname:":dragon_face:",code_decimal:"&#128050;",category:"n",emoji_order:"1404"},{name:"dragon",unicode:"1f409",shortname:":dragon:",code_decimal:"&#128009;",category:"n",emoji_order:"1405"},{name:"whale",unicode:"1f433",shortname:":whale:",code_decimal:"&#128051;",category:"n",emoji_order:"1406"},{name:"whale2",unicode:"1f40b",shortname:":whale2:",code_decimal:"&#128011;",category:"n",emoji_order:"1407"},{name:"dolphin",unicode:"1f42c",shortname:":dolphin:",code_decimal:"&#128044;",category:"n",emoji_order:"1408"},{name:"fish",unicode:"1f41f",shortname:":fish:",code_decimal:"&#128031;",category:"n",emoji_order:"1409"},{name:"tropical_fish",unicode:"1f420",shortname:":tropical_fish:",code_decimal:"&#128032;",category:"n",emoji_order:"1410"},{name:"blowfish",unicode:"1f421",shortname:":blowfish:",code_decimal:"&#128033;",category:"n",emoji_order:"1411"},{name:"octopus",unicode:"1f419",shortname:":octopus:",code_decimal:"&#128025;",category:"n",emoji_order:"1413"},{name:"shell",unicode:"1f41a",shortname:":shell:",code_decimal:"&#128026;",category:"n",emoji_order:"1414"},{name:"crab",unicode:"1f980",shortname:":crab:",code_decimal:"&#129408;",category:"n",emoji_order:"1415"},{name:"snail",unicode:"1f40c",shortname:":snail:",code_decimal:"&#128012;",category:"n",emoji_order:"1419"},{name:"bug",unicode:"1f41b",shortname:":bug:",code_decimal:"&#128027;",category:"n",emoji_order:"1420"},{name:"ant",unicode:"1f41c",shortname:":ant:",code_decimal:"&#128028;",category:"n",emoji_order:"1421"},{name:"bee",unicode:"1f41d",shortname:":bee:",code_decimal:"&#128029;",category:"n",emoji_order:"1422"},{name:"beetle",unicode:"1f41e",shortname:":beetle:",code_decimal:"&#128030;",category:"n",emoji_order:"1423"},{name:"spider",unicode:"1f577",shortname:":spider:",code_decimal:"&#128375;",category:"n",emoji_order:"1424"},{name:"spider_web",unicode:"1f578",shortname:":spider_web:",code_decimal:"&#128376;",category:"n",emoji_order:"1425"},{name:"scorpion",unicode:"1f982",shortname:":scorpion:",code_decimal:"&#129410;",category:"n",emoji_order:"1426"},{name:"bouquet",unicode:"1f490",shortname:":bouquet:",code_decimal:"&#128144;",category:"n",emoji_order:"1427"},{name:"cherry_blossom",unicode:"1f338",shortname:":cherry_blossom:",code_decimal:"&#127800;",category:"n",emoji_order:"1428"},{name:"white_flower",unicode:"1f4ae",shortname:":white_flower:",code_decimal:"&#128174;",category:"s",emoji_order:"1429"},{name:"rosette",unicode:"1f3f5",shortname:":rosette:",code_decimal:"&#127989;",category:"n",emoji_order:"1430"},{name:"rose",unicode:"1f339",shortname:":rose:",code_decimal:"&#127801;",category:"n",emoji_order:"1431"},{name:"hibiscus",unicode:"1f33a",shortname:":hibiscus:",code_decimal:"&#127802;",category:"n",emoji_order:"1433"},{name:"sunflower",unicode:"1f33b",shortname:":sunflower:",code_decimal:"&#127803;",category:"n",emoji_order:"1434"},{name:"blossom",unicode:"1f33c",shortname:":blossom:",code_decimal:"&#127804;",category:"n",emoji_order:"1435"},{name:"tulip",unicode:"1f337",shortname:":tulip:",code_decimal:"&#127799;",category:"n",emoji_order:"1436"},{name:"seedling",unicode:"1f331",shortname:":seedling:",code_decimal:"&#127793;",category:"n",emoji_order:"1437"},{name:"evergreen_tree",unicode:"1f332",shortname:":evergreen_tree:",code_decimal:"&#127794;",category:"n",emoji_order:"1438"},{name:"deciduous_tree",unicode:"1f333",shortname:":deciduous_tree:",code_decimal:"&#127795;",category:"n",emoji_order:"1439"},{name:"palm_tree",unicode:"1f334",shortname:":palm_tree:",code_decimal:"&#127796;",category:"n",emoji_order:"1440"},{name:"cactus",unicode:"1f335",shortname:":cactus:",code_decimal:"&#127797;",category:"n",emoji_order:"1441"},{name:"ear_of_rice",unicode:"1f33e",shortname:":ear_of_rice:",code_decimal:"&#127806;",category:"n",emoji_order:"1442"},{name:"herb",unicode:"1f33f",shortname:":herb:",code_decimal:"&#127807;",category:"n",emoji_order:"1443"},{name:"shamrock",unicode:"2618",shortname:":shamrock:",code_decimal:"&#9752;",category:"n",emoji_order:"1444"},{name:"four_leaf_clover",unicode:"1f340",shortname:":four_leaf_clover:",code_decimal:"&#127808;",category:"n",emoji_order:"1445"},{name:"maple_leaf",unicode:"1f341",shortname:":maple_leaf:",code_decimal:"&#127809;",category:"n",emoji_order:"1446"},{name:"fallen_leaf",unicode:"1f342",shortname:":fallen_leaf:",code_decimal:"&#127810;",category:"n",emoji_order:"1447"},{name:"leaves",unicode:"1f343",shortname:":leaves:",code_decimal:"&#127811;",category:"n",emoji_order:"1448"},{name:"grapes",unicode:"1f347",shortname:":grapes:",code_decimal:"&#127815;",category:"d",emoji_order:"1449"},{name:"melon",unicode:"1f348",shortname:":melon:",code_decimal:"&#127816;",category:"d",emoji_order:"1450"},{name:"watermelon",unicode:"1f349",shortname:":watermelon:",code_decimal:"&#127817;",category:"d",emoji_order:"1451"},{name:"tangerine",unicode:"1f34a",shortname:":tangerine:",code_decimal:"&#127818;",category:"d",emoji_order:"1452"},{name:"lemon",unicode:"1f34b",shortname:":lemon:",code_decimal:"&#127819;",category:"d",emoji_order:"1453"},{name:"banana",unicode:"1f34c",shortname:":banana:",code_decimal:"&#127820;",category:"d",emoji_order:"1454"},{name:"pineapple",unicode:"1f34d",shortname:":pineapple:",code_decimal:"&#127821;",category:"d",emoji_order:"1455"},{name:"apple",unicode:"1f34e",shortname:":apple:",code_decimal:"&#127822;",category:"d",emoji_order:"1456"},{name:"green_apple",unicode:"1f34f",shortname:":green_apple:",code_decimal:"&#127823;",category:"d",emoji_order:"1457"},{name:"pear",unicode:"1f350",shortname:":pear:",code_decimal:"&#127824;",category:"d",emoji_order:"1458"},{name:"peach",unicode:"1f351",shortname:":peach:",code_decimal:"&#127825;",category:"d",emoji_order:"1459"},{name:"cherries",unicode:"1f352",shortname:":cherries:",code_decimal:"&#127826;",category:"d",emoji_order:"1460"},{name:"strawberry",unicode:"1f353",shortname:":strawberry:",code_decimal:"&#127827;",category:"d",emoji_order:"1461"},{name:"tomato",unicode:"1f345",shortname:":tomato:",code_decimal:"&#127813;",category:"d",emoji_order:"1463"},{name:"eggplant",unicode:"1f346",shortname:":eggplant:",code_decimal:"&#127814;",category:"d",emoji_order:"1465"},{name:"corn",unicode:"1f33d",shortname:":corn:",code_decimal:"&#127805;",category:"d",emoji_order:"1468"},{name:"hot_pepper",unicode:"1f336",shortname:":hot_pepper:",code_decimal:"&#127798;",category:"d",emoji_order:"1469"},{name:"mushroom",unicode:"1f344",shortname:":mushroom:",code_decimal:"&#127812;",category:"n",emoji_order:"1471"},{name:"chestnut",unicode:"1f330",shortname:":chestnut:",code_decimal:"&#127792;",category:"n",emoji_order:"1473"},{name:"bread",unicode:"1f35e",shortname:":bread:",code_decimal:"&#127838;",category:"d",emoji_order:"1474"},{name:"cheese_wedge",unicode:"1f9c0",shortname:":cheese:",code_decimal:"&#129472;",category:"d",emoji_order:"1478"},{name:"meat_on_bone",unicode:"1f356",shortname:":meat_on_bone:",code_decimal:"&#127830;",category:"d",emoji_order:"1479"},{name:"poultry_leg",unicode:"1f357",shortname:":poultry_leg:",code_decimal:"&#127831;",category:"d",emoji_order:"1480"},{name:"hamburger",unicode:"1f354",shortname:":hamburger:",code_decimal:"&#127828;",category:"d",emoji_order:"1482"},{name:"fries",unicode:"1f35f",shortname:":fries:",code_decimal:"&#127839;",category:"d",emoji_order:"1483"},{name:"pizza",unicode:"1f355",shortname:":pizza:",code_decimal:"&#127829;",category:"d",emoji_order:"1484"},{name:"hotdog",unicode:"1f32d",shortname:":hotdog:",code_decimal:"&#127789;",category:"d",emoji_order:"1485"},{name:"taco",unicode:"1f32e",shortname:":taco:",code_decimal:"&#127790;",category:"d",emoji_order:"1486"},{name:"burrito",unicode:"1f32f",shortname:":burrito:",code_decimal:"&#127791;",category:"d",emoji_order:"1487"},{name:"egg",unicode:"1f95a",shortname:":egg:",code_decimal:"&#129370;",category:"d",emoji_order:"1489"},{name:"stew",unicode:"1f372",shortname:":stew:",code_decimal:"&#127858;",category:"d",emoji_order:"1492"},{name:"popcorn",unicode:"1f37f",shortname:":popcorn:",code_decimal:"&#127871;",category:"d",emoji_order:"1494"},{name:"bento",unicode:"1f371",shortname:":bento:",code_decimal:"&#127857;",category:"d",emoji_order:"1495"},{name:"rice_cracker",unicode:"1f358",shortname:":rice_cracker:",code_decimal:"&#127832;",category:"d",emoji_order:"1496"},{name:"rice_ball",unicode:"1f359",shortname:":rice_ball:",code_decimal:"&#127833;",category:"d",emoji_order:"1497"},{name:"rice",unicode:"1f35a",shortname:":rice:",code_decimal:"&#127834;",category:"d",emoji_order:"1498"},{name:"curry",unicode:"1f35b",shortname:":curry:",code_decimal:"&#127835;",category:"d",emoji_order:"1499"},{name:"ramen",unicode:"1f35c",shortname:":ramen:",code_decimal:"&#127836;",category:"d",emoji_order:"1500"},{name:"spaghetti",unicode:"1f35d",shortname:":spaghetti:",code_decimal:"&#127837;",category:"d",emoji_order:"1501"},{name:"sweet_potato",unicode:"1f360",shortname:":sweet_potato:",code_decimal:"&#127840;",category:"d",emoji_order:"1502"},{name:"oden",unicode:"1f362",shortname:":oden:",code_decimal:"&#127842;",category:"d",emoji_order:"1503"},{name:"sushi",unicode:"1f363",shortname:":sushi:",code_decimal:"&#127843;",category:"d",emoji_order:"1504"},{name:"fried_shrimp",unicode:"1f364",shortname:":fried_shrimp:",code_decimal:"&#127844;",category:"d",emoji_order:"1505"},{name:"fish_cake",unicode:"1f365",shortname:":fish_cake:",code_decimal:"&#127845;",category:"d",emoji_order:"1506"},{name:"dango",unicode:"1f361",shortname:":dango:",code_decimal:"&#127841;",category:"d",emoji_order:"1507"},{name:"icecream",unicode:"1f366",shortname:":icecream:",code_decimal:"&#127846;",category:"d",emoji_order:"1508"},{name:"shaved_ice",unicode:"1f367",shortname:":shaved_ice:",code_decimal:"&#127847;",category:"d",emoji_order:"1509"},{name:"ice_cream",unicode:"1f368",shortname:":ice_cream:",code_decimal:"&#127848;",category:"d",emoji_order:"1510"},{name:"doughnut",unicode:"1f369",shortname:":doughnut:",code_decimal:"&#127849;",category:"d",emoji_order:"1511"},{name:"cookie",unicode:"1f36a",shortname:":cookie:",code_decimal:"&#127850;",category:"d",emoji_order:"1512"},{name:"birthday",unicode:"1f382",shortname:":birthday:",code_decimal:"&#127874;",category:"d",emoji_order:"1513"},{name:"cake",unicode:"1f370",shortname:":cake:",code_decimal:"&#127856;",category:"d",emoji_order:"1514"},{name:"chocolate_bar",unicode:"1f36b",shortname:":chocolate_bar:",code_decimal:"&#127851;",category:"d",emoji_order:"1515"},{name:"candy",unicode:"1f36c",shortname:":candy:",code_decimal:"&#127852;",category:"d",emoji_order:"1516"},{name:"lollipop",unicode:"1f36d",shortname:":lollipop:",code_decimal:"&#127853;",category:"d",emoji_order:"1517"},{name:"custard",unicode:"1f36e",shortname:":custard:",code_decimal:"&#127854;",category:"d",emoji_order:"1518"},{name:"honey_pot",unicode:"1f36f",shortname:":honey_pot:",code_decimal:"&#127855;",category:"d",emoji_order:"1519"},{name:"baby_bottle",unicode:"1f37c",shortname:":baby_bottle:",code_decimal:"&#127868;",category:"d",emoji_order:"1520"},{name:"coffee",unicode:"2615",shortname:":coffee:",code_decimal:"&#9749;",category:"d",emoji_order:"1522"},{name:"tea",unicode:"1f375",shortname:":tea:",code_decimal:"&#127861;",category:"d",emoji_order:"1523"},{name:"sake",unicode:"1f376",shortname:":sake:",code_decimal:"&#127862;",category:"d",emoji_order:"1524"},{name:"champagne",unicode:"1f37e",shortname:":champagne:",code_decimal:"&#127870;",category:"d",emoji_order:"1525"},{name:"wine_glass",unicode:"1f377",shortname:":wine_glass:",code_decimal:"&#127863;",category:"d",emoji_order:"1526"},{name:"cocktail",unicode:"1f378",shortname:":cocktail:",code_decimal:"&#127864;",category:"d",emoji_order:"1527"},{name:"tropical_drink",unicode:"1f379",shortname:":tropical_drink:",code_decimal:"&#127865;",category:"d",emoji_order:"1528"},{name:"beer",unicode:"1f37a",shortname:":beer:",code_decimal:"&#127866;",category:"d",emoji_order:"1529"},{name:"beers",unicode:"1f37b",shortname:":beers:",code_decimal:"&#127867;",category:"d",emoji_order:"1530"},{name:"knife_fork_plate",unicode:"1f37d",shortname:":fork_knife_plate:",code_decimal:"&#127869;",category:"d",emoji_order:"1533"},{name:"fork_and_knife",unicode:"1f374",shortname:":fork_and_knife:",code_decimal:"&#127860;",category:"d",emoji_order:"1534"},{name:"amphora",unicode:"1f3fa",shortname:":amphora:",code_decimal:"&#127994;",category:"o",emoji_order:"1537"},{name:"earth_africa",unicode:"1f30d",shortname:":earth_africa:",code_decimal:"&#127757;",category:"n",emoji_order:"1538"},{name:"earth_americas",unicode:"1f30e",shortname:":earth_americas:",code_decimal:"&#127758;",category:"n",emoji_order:"1539"},{name:"earth_asia",unicode:"1f30f",shortname:":earth_asia:",code_decimal:"&#127759;",category:"n",emoji_order:"1540"},{name:"globe_with_meridians",unicode:"1f310",shortname:":globe_with_meridians:",code_decimal:"&#127760;",category:"s",emoji_order:"1541"},{name:"world_map",unicode:"1f5fa",shortname:":map:",code_decimal:"&#128506;",category:"o",emoji_order:"1542"},{name:"japan",unicode:"1f5fe",shortname:":japan:",code_decimal:"&#128510;",category:"t",emoji_order:"1543"},{name:"snow_capped_mountain",unicode:"1f3d4",shortname:":mountain_snow:",code_decimal:"&#127956;",category:"t",emoji_order:"1544"},{name:"mountain",unicode:"26f0",shortname:":mountain:",code_decimal:"&#9968;",category:"t",emoji_order:"1545"},{name:"volcano",unicode:"1f30b",shortname:":volcano:",code_decimal:"&#127755;",category:"t",emoji_order:"1546"},{name:"mount_fuji",unicode:"1f5fb",shortname:":mount_fuji:",code_decimal:"&#128507;",category:"t",emoji_order:"1547"},{name:"camping",unicode:"1f3d5",shortname:":camping:",code_decimal:"&#127957;",category:"t",emoji_order:"1548"},{name:"beach_with_umbrella",unicode:"1f3d6",shortname:":beach:",code_decimal:"&#127958;",category:"t",emoji_order:"1549"},{name:"desert",unicode:"1f3dc",shortname:":desert:",code_decimal:"&#127964;",category:"t",emoji_order:"1550"},{name:"desert_island",unicode:"1f3dd",shortname:":island:",code_decimal:"&#127965;",category:"t",emoji_order:"1551"},{name:"national_park",unicode:"1f3de",shortname:":park:",code_decimal:"&#127966;",category:"t",emoji_order:"1552"},{name:"stadium",unicode:"1f3df",shortname:":stadium:",code_decimal:"&#127967;",category:"t",emoji_order:"1553"},{name:"classical_building",unicode:"1f3db",shortname:":classical_building:",code_decimal:"&#127963;",category:"t",emoji_order:"1554"},{name:"building_construction",unicode:"1f3d7",shortname:":construction_site:",code_decimal:"&#127959;",category:"t",emoji_order:"1555"},{name:"house_buildings",unicode:"1f3d8",shortname:":homes:",code_decimal:"&#127960;",category:"t",emoji_order:"1556"},{name:"cityscape",unicode:"1f3d9",shortname:":cityscape:",code_decimal:"&#127961;",category:"t",emoji_order:"1557"},{name:"derelict_house_building",unicode:"1f3da",shortname:":house_abandoned:",code_decimal:"&#127962;",category:"t",emoji_order:"1558"},{name:"house",unicode:"1f3e0",shortname:":house:",code_decimal:"&#127968;",category:"t",emoji_order:"1559"},{name:"house_with_garden",unicode:"1f3e1",shortname:":house_with_garden:",code_decimal:"&#127969;",category:"t",emoji_order:"1560"},{name:"office",unicode:"1f3e2",shortname:":office:",code_decimal:"&#127970;",category:"t",emoji_order:"1561"},{name:"post_office",unicode:"1f3e3",shortname:":post_office:",code_decimal:"&#127971;",category:"t",emoji_order:"1562"},{name:"european_post_office",unicode:"1f3e4",shortname:":european_post_office:",code_decimal:"&#127972;",category:"t",emoji_order:"1563"},{name:"hospital",unicode:"1f3e5",shortname:":hospital:",code_decimal:"&#127973;",category:"t",emoji_order:"1564"},{name:"bank",unicode:"1f3e6",shortname:":bank:",code_decimal:"&#127974;",category:"t",emoji_order:"1565"},{name:"hotel",unicode:"1f3e8",shortname:":hotel:",code_decimal:"&#127976;",category:"t",emoji_order:"1566"},{name:"love_hotel",unicode:"1f3e9",shortname:":love_hotel:",code_decimal:"&#127977;",category:"t",emoji_order:"1567"},{name:"convenience_store",unicode:"1f3ea",shortname:":convenience_store:",code_decimal:"&#127978;",category:"t",emoji_order:"1568"},{name:"school",unicode:"1f3eb",shortname:":school:",code_decimal:"&#127979;",category:"t",emoji_order:"1569"},{name:"department_store",unicode:"1f3ec",shortname:":department_store:",code_decimal:"&#127980;",category:"t",emoji_order:"1570"},{name:"factory",unicode:"1f3ed",shortname:":factory:",code_decimal:"&#127981;",category:"t",emoji_order:"1571"},{name:"japanese_castle",unicode:"1f3ef",shortname:":japanese_castle:",code_decimal:"&#127983;",category:"t",emoji_order:"1572"},{name:"european_castle",unicode:"1f3f0",shortname:":european_castle:",code_decimal:"&#127984;",category:"t",emoji_order:"1573"},{name:"wedding",unicode:"1f492",shortname:":wedding:",code_decimal:"&#128146;",category:"t",emoji_order:"1574"},{name:"tokyo_tower",unicode:"1f5fc",shortname:":tokyo_tower:",code_decimal:"&#128508;",category:"t",emoji_order:"1575"},{name:"statue_of_liberty",unicode:"1f5fd",shortname:":statue_of_liberty:",code_decimal:"&#128509;",category:"t",emoji_order:"1576"},{name:"church",unicode:"26ea",shortname:":church:",code_decimal:"&#9962;",category:"t",emoji_order:"1577"},{name:"mosque",unicode:"1f54c",shortname:":mosque:",code_decimal:"&#128332;",category:"t",emoji_order:"1578"},{name:"synagogue",unicode:"1f54d",shortname:":synagogue:",code_decimal:"&#128333;",category:"t",emoji_order:"1579"},{name:"shinto_shrine",unicode:"26e9",shortname:":shinto_shrine:",code_decimal:"&#9961;",category:"t",emoji_order:"1580"},{name:"kaaba",unicode:"1f54b",shortname:":kaaba:",code_decimal:"&#128331;",category:"t",emoji_order:"1581"},{name:"fountain",unicode:"26f2",shortname:":fountain:",code_decimal:"&#9970;",category:"t",emoji_order:"1582"},{name:"tent",unicode:"26fa",shortname:":tent:",code_decimal:"&#9978;",category:"t",emoji_order:"1583"},{name:"foggy",unicode:"1f301",shortname:":foggy:",code_decimal:"&#127745;",category:"t",emoji_order:"1584"},{name:"night_with_stars",unicode:"1f303",shortname:":night_with_stars:",code_decimal:"&#127747;",category:"t",emoji_order:"1585"},{name:"sunrise_over_mountains",unicode:"1f304",shortname:":sunrise_over_mountains:",code_decimal:"&#127748;",category:"t",emoji_order:"1586"},{name:"sunrise",unicode:"1f305",shortname:":sunrise:",code_decimal:"&#127749;",category:"t",emoji_order:"1587"},{name:"city_sunset",unicode:"1f307",shortname:":city_sunset:",code_decimal:"&#127751;",category:"t",emoji_order:"1589"},{name:"bridge_at_night",unicode:"1f309",shortname:":bridge_at_night:",code_decimal:"&#127753;",category:"t",emoji_order:"1590"},{name:"hotsprings",unicode:"2668",shortname:":hotsprings:",code_decimal:"&#9832;",category:"s",emoji_order:"1591"},{name:"milky_way",unicode:"1f30c",shortname:":milky_way:",code_decimal:"&#127756;",category:"t",emoji_order:"1592"},{name:"carousel_horse",unicode:"1f3a0",shortname:":carousel_horse:",code_decimal:"&#127904;",category:"t",emoji_order:"1593"},{name:"ferris_wheel",unicode:"1f3a1",shortname:":ferris_wheel:",code_decimal:"&#127905;",category:"t",emoji_order:"1594"},{name:"roller_coaster",unicode:"1f3a2",shortname:":roller_coaster:",code_decimal:"&#127906;",category:"t",emoji_order:"1595"},{name:"barber",unicode:"1f488",shortname:":barber:",code_decimal:"&#128136;",category:"o",emoji_order:"1596"},{name:"circus_tent",unicode:"1f3aa",shortname:":circus_tent:",code_decimal:"&#127914;",category:"a",emoji_order:"1597"},{name:"performing_arts",unicode:"1f3ad",shortname:":performing_arts:",code_decimal:"&#127917;",category:"a",emoji_order:"1598"},{name:"frame_with_picture",unicode:"1f5bc",shortname:":frame_photo:",code_decimal:"&#128444;",category:"o",emoji_order:"1599"},{name:"art",unicode:"1f3a8",shortname:":art:",code_decimal:"&#127912;",category:"a",emoji_order:"1600"},{name:"slot_machine",unicode:"1f3b0",shortname:":slot_machine:",code_decimal:"&#127920;",category:"a",emoji_order:"1601"},{name:"steam_locomotive",unicode:"1f682",shortname:":steam_locomotive:",code_decimal:"&#128642;",category:"t",emoji_order:"1602"},{name:"railway_car",unicode:"1f683",shortname:":railway_car:",code_decimal:"&#128643;",category:"t",emoji_order:"1603"},{name:"bullettrain_side",unicode:"1f684",shortname:":bullettrain_side:",code_decimal:"&#128644;",category:"t",emoji_order:"1604"},{name:"bullettrain_front",unicode:"1f685",shortname:":bullettrain_front:",code_decimal:"&#128645;",category:"t",emoji_order:"1605"},{name:"train2",unicode:"1f686",shortname:":train2:",code_decimal:"&#128646;",category:"t",emoji_order:"1606"},{name:"metro",unicode:"1f687",shortname:":metro:",code_decimal:"&#128647;",category:"t",emoji_order:"1607"},{name:"light_rail",unicode:"1f688",shortname:":light_rail:",code_decimal:"&#128648;",category:"t",emoji_order:"1608"},{name:"station",unicode:"1f689",shortname:":station:",code_decimal:"&#128649;",category:"t",emoji_order:"1609"},{name:"tram",unicode:"1f68a",shortname:":tram:",code_decimal:"&#128650;",category:"t",emoji_order:"1610"},{name:"monorail",unicode:"1f69d",shortname:":monorail:",code_decimal:"&#128669;",category:"t",emoji_order:"1611"},{name:"mountain_railway",unicode:"1f69e",shortname:":mountain_railway:",code_decimal:"&#128670;",category:"t",emoji_order:"1612"},{name:"train",unicode:"1f68b",shortname:":train:",code_decimal:"&#128651;",category:"t",emoji_order:"1613"},{name:"bus",unicode:"1f68c",shortname:":bus:",code_decimal:"&#128652;",category:"t",emoji_order:"1614"},{name:"oncoming_bus",unicode:"1f68d",shortname:":oncoming_bus:",code_decimal:"&#128653;",category:"t",emoji_order:"1615"},{name:"trolleybus",unicode:"1f68e",shortname:":trolleybus:",code_decimal:"&#128654;",category:"t",emoji_order:"1616"},{name:"minibus",unicode:"1f690",shortname:":minibus:",code_decimal:"&#128656;",category:"t",emoji_order:"1617"},{name:"ambulance",unicode:"1f691",shortname:":ambulance:",code_decimal:"&#128657;",category:"t",emoji_order:"1618"},{name:"fire_engine",unicode:"1f692",shortname:":fire_engine:",code_decimal:"&#128658;",category:"t",emoji_order:"1619"},{name:"police_car",unicode:"1f693",shortname:":police_car:",code_decimal:"&#128659;",category:"t",emoji_order:"1620"},{name:"oncoming_police_car",unicode:"1f694",shortname:":oncoming_police_car:",code_decimal:"&#128660;",category:"t",emoji_order:"1621"},{name:"taxi",unicode:"1f695",shortname:":taxi:",code_decimal:"&#128661;",category:"t",emoji_order:"1622"},{name:"oncoming_taxi",unicode:"1f696",shortname:":oncoming_taxi:",code_decimal:"&#128662;",category:"t",emoji_order:"1623"},{name:"car",unicode:"1f697",shortname:":red_car:",code_decimal:"&#128663;",category:"t",emoji_order:"1624"},{name:"oncoming_automobile",unicode:"1f698",shortname:":oncoming_automobile:",code_decimal:"&#128664;",category:"t",emoji_order:"1625"},{name:"blue_car",unicode:"1f699",shortname:":blue_car:",code_decimal:"&#128665;",category:"t",emoji_order:"1626"},{name:"truck",unicode:"1f69a",shortname:":truck:",code_decimal:"&#128666;",category:"t",emoji_order:"1627"},{name:"articulated_lorry",unicode:"1f69b",shortname:":articulated_lorry:",code_decimal:"&#128667;",category:"t",emoji_order:"1628"},{name:"tractor",unicode:"1f69c",shortname:":tractor:",code_decimal:"&#128668;",category:"t",emoji_order:"1629"},{name:"bike",unicode:"1f6b2",shortname:":bike:",code_decimal:"&#128690;",category:"t",emoji_order:"1630"},{name:"busstop",unicode:"1f68f",shortname:":busstop:",code_decimal:"&#128655;",category:"t",emoji_order:"1633"},{name:"motorway",unicode:"1f6e3",shortname:":motorway:",code_decimal:"&#128739;",category:"t",emoji_order:"1634"},{name:"railway_track",unicode:"1f6e4",shortname:":railway_track:",code_decimal:"&#128740;",category:"t",emoji_order:"1635"},{name:"fuelpump",unicode:"26fd",shortname:":fuelpump:",code_decimal:"&#9981;",category:"t",emoji_order:"1636"},{name:"rotating_light",unicode:"1f6a8",shortname:":rotating_light:",code_decimal:"&#128680;",category:"t",emoji_order:"1637"},{name:"traffic_light",unicode:"1f6a5",shortname:":traffic_light:",code_decimal:"&#128677;",category:"t",emoji_order:"1638"},{name:"vertical_traffic_light",unicode:"1f6a6",shortname:":vertical_traffic_light:",code_decimal:"&#128678;",category:"t",emoji_order:"1639"},{name:"construction",unicode:"1f6a7",shortname:":construction:",code_decimal:"&#128679;",category:"t",emoji_order:"1640"},{name:"octagonal_sign",unicode:"1f6d1",shortname:":octagonal_sign:",code_decimal:"&#128721;",category:"s",emoji_order:"1641"},{name:"anchor",unicode:"2693",shortname:":anchor:",code_decimal:"&#9875;",category:"t",emoji_order:"1642"},{name:"boat",unicode:"26f5",shortname:":sailboat:",code_decimal:"&#9973;",category:"t",emoji_order:"1643"},{name:"speedboat",unicode:"1f6a4",shortname:":speedboat:",code_decimal:"&#128676;",category:"t",emoji_order:"1645"},{name:"passenger_ship",unicode:"1f6f3",shortname:":cruise_ship:",code_decimal:"&#128755;",category:"t",emoji_order:"1646"},{name:"ferry",unicode:"26f4",shortname:":ferry:",code_decimal:"&#9972;",category:"t",emoji_order:"1647"},{name:"motor_boat",unicode:"1f6e5",shortname:":motorboat:",code_decimal:"&#128741;",category:"t",emoji_order:"1648"},{name:"ship",unicode:"1f6a2",shortname:":ship:",code_decimal:"&#128674;",category:"t",emoji_order:"1649"},{name:"airplane",unicode:"2708",shortname:":airplane:",code_decimal:"&#9992;",category:"t",emoji_order:"1650"},{name:"small_airplane",unicode:"1f6e9",shortname:":airplane_small:",code_decimal:"&#128745;",category:"t",emoji_order:"1651"},{name:"airplane_departure",unicode:"1f6eb",shortname:":airplane_departure:",code_decimal:"&#128747;",category:"t",emoji_order:"1652"},{name:"airplane_arriving",unicode:"1f6ec",shortname:":airplane_arriving:",code_decimal:"&#128748;",category:"t",emoji_order:"1653"},{name:"seat",unicode:"1f4ba",shortname:":seat:",code_decimal:"&#128186;",category:"t",emoji_order:"1654"},{name:"helicopter",unicode:"1f681",shortname:":helicopter:",code_decimal:"&#128641;",category:"t",emoji_order:"1655"},{name:"suspension_railway",unicode:"1f69f",shortname:":suspension_railway:",code_decimal:"&#128671;",category:"t",emoji_order:"1656"},{name:"mountain_cableway",unicode:"1f6a0",shortname:":mountain_cableway:",code_decimal:"&#128672;",category:"t",emoji_order:"1657"},{name:"aerial_tramway",unicode:"1f6a1",shortname:":aerial_tramway:",code_decimal:"&#128673;",category:"t",emoji_order:"1658"},{name:"rocket",unicode:"1f680",shortname:":rocket:",code_decimal:"&#128640;",category:"t",emoji_order:"1659"},{name:"satellite",unicode:"1f6f0",shortname:":satellite_orbital:",code_decimal:"&#128752;",category:"t",emoji_order:"1660"},{name:"bellhop_bell",unicode:"1f6ce",shortname:":bellhop:",code_decimal:"&#128718;",category:"o",emoji_order:"1661"},{name:"door",unicode:"1f6aa",shortname:":door:",code_decimal:"&#128682;",category:"o",emoji_order:"1662"},{name:"sleeping_accommodation",unicode:"1f6cc",shortname:":sleeping_accommodation:",code_decimal:"&#128716;",category:"o",emoji_order:"1663"},{name:"bed",unicode:"1f6cf",shortname:":bed:",code_decimal:"&#128719;",category:"o",emoji_order:"1669"},{name:"couch_and_lamp",unicode:"1f6cb",shortname:":couch:",code_decimal:"&#128715;",category:"o",emoji_order:"1670"},{name:"toilet",unicode:"1f6bd",shortname:":toilet:",code_decimal:"&#128701;",category:"o",emoji_order:"1671"},{name:"shower",unicode:"1f6bf",shortname:":shower:",code_decimal:"&#128703;",category:"o",emoji_order:"1672"},{name:"bath",unicode:"1f6c0",shortname:":bath:",code_decimal:"&#128704;",category:"a",emoji_order:"1673"},{name:"bathtub",unicode:"1f6c1",shortname:":bathtub:",code_decimal:"&#128705;",category:"o",emoji_order:"1679"},{name:"hourglass",unicode:"231b",shortname:":hourglass:",code_decimal:"&#8987;",category:"o",emoji_order:"1680"},{name:"hourglass_flowing_sand",unicode:"23f3",shortname:":hourglass_flowing_sand:",code_decimal:"&#9203;",category:"o",emoji_order:"1681"},{name:"watch",unicode:"231a",shortname:":watch:",code_decimal:"&#8986;",category:"o",emoji_order:"1682"},{name:"alarm_clock",unicode:"23f0",shortname:":alarm_clock:",code_decimal:"&#9200;",category:"o",emoji_order:"1683"},{name:"stopwatch",unicode:"23f1",shortname:":stopwatch:",code_decimal:"&#9201;",category:"o",emoji_order:"1684"},{name:"timer_clock",unicode:"23f2",shortname:":timer:",code_decimal:"&#9202;",category:"o",emoji_order:"1685"},{name:"mantelpiece_clock",unicode:"1f570",shortname:":clock:",code_decimal:"&#128368;",category:"o",emoji_order:"1686"},{name:"clock12",unicode:"1f55b",shortname:":clock12:",code_decimal:"&#128347;",category:"s",emoji_order:"1687"},{name:"clock1230",unicode:"1f567",shortname:":clock1230:",code_decimal:"&#128359;",category:"s",emoji_order:"1688"},{name:"clock1",unicode:"1f550",shortname:":clock1:",code_decimal:"&#128336;",category:"s",emoji_order:"1689"},{name:"clock130",unicode:"1f55c",shortname:":clock130:",code_decimal:"&#128348;",category:"s",emoji_order:"1690"},{name:"clock2",unicode:"1f551",shortname:":clock2:",code_decimal:"&#128337;",category:"s",emoji_order:"1691"},{name:"clock230",unicode:"1f55d",shortname:":clock230:",code_decimal:"&#128349;",category:"s",emoji_order:"1692"},{name:"clock3",unicode:"1f552",shortname:":clock3:",code_decimal:"&#128338;",category:"s",emoji_order:"1693"},{name:"clock330",unicode:"1f55e",shortname:":clock330:",code_decimal:"&#128350;",category:"s",emoji_order:"1694"},{name:"clock4",unicode:"1f553",shortname:":clock4:",code_decimal:"&#128339;",category:"s",emoji_order:"1695"},{name:"clock430",unicode:"1f55f",shortname:":clock430:",code_decimal:"&#128351;",category:"s",emoji_order:"1696"},{name:"clock5",unicode:"1f554",shortname:":clock5:",code_decimal:"&#128340;",category:"s",emoji_order:"1697"},{name:"clock530",unicode:"1f560",shortname:":clock530:",code_decimal:"&#128352;",category:"s",emoji_order:"1698"},{name:"clock6",unicode:"1f555",shortname:":clock6:",code_decimal:"&#128341;",category:"s",emoji_order:"1699"},{name:"clock630",unicode:"1f561",shortname:":clock630:",code_decimal:"&#128353;",category:"s",emoji_order:"1700"},{name:"clock7",unicode:"1f556",shortname:":clock7:",code_decimal:"&#128342;",category:"s",emoji_order:"1701"},{name:"clock730",unicode:"1f562",shortname:":clock730:",code_decimal:"&#128354;",category:"s",emoji_order:"1702"},{name:"clock8",unicode:"1f557",shortname:":clock8:",code_decimal:"&#128343;",category:"s",emoji_order:"1703"},{name:"clock830",unicode:"1f563",shortname:":clock830:",code_decimal:"&#128355;",category:"s",emoji_order:"1704"},{name:"clock9",unicode:"1f558",shortname:":clock9:",code_decimal:"&#128344;",category:"s",emoji_order:"1705"},{name:"clock930",unicode:"1f564",shortname:":clock930:",code_decimal:"&#128356;",category:"s",emoji_order:"1706"},{name:"clock10",unicode:"1f559",shortname:":clock10:",code_decimal:"&#128345;",category:"s",emoji_order:"1707"},{name:"clock1030",unicode:"1f565",shortname:":clock1030:",code_decimal:"&#128357;",category:"s",emoji_order:"1708"},{name:"clock11",unicode:"1f55a",shortname:":clock11:",code_decimal:"&#128346;",category:"s",emoji_order:"1709"},{name:"clock1130",unicode:"1f566",shortname:":clock1130:",code_decimal:"&#128358;",category:"s",emoji_order:"1710"},{name:"new_moon",unicode:"1f311",shortname:":new_moon:",code_decimal:"&#127761;",category:"n",emoji_order:"1711"},{name:"waxing_crescent_moon",unicode:"1f312",shortname:":waxing_crescent_moon:",code_decimal:"&#127762;",category:"n",emoji_order:"1712"},{name:"first_quarter_moon",unicode:"1f313",shortname:":first_quarter_moon:",code_decimal:"&#127763;",category:"n",emoji_order:"1713"},{name:"full_moon",unicode:"1f315",shortname:":full_moon:",code_decimal:"&#127765;",category:"n",emoji_order:"1715"},{name:"waning_gibbous_moon",unicode:"1f316",shortname:":waning_gibbous_moon:",code_decimal:"&#127766;",category:"n",emoji_order:"1716"},{name:"last_quarter_moon",unicode:"1f317",shortname:":last_quarter_moon:",code_decimal:"&#127767;",category:"n",emoji_order:"1717"},{name:"waning_crescent_moon",unicode:"1f318",shortname:":waning_crescent_moon:",code_decimal:"&#127768;",category:"n",emoji_order:"1718"},{name:"crescent_moon",unicode:"1f319",shortname:":crescent_moon:",code_decimal:"&#127769;",category:"n",emoji_order:"1719"},{name:"new_moon_with_face",unicode:"1f31a",shortname:":new_moon_with_face:",code_decimal:"&#127770;",category:"n",emoji_order:"1720"},{name:"first_quarter_moon_with_face",unicode:"1f31b",shortname:":first_quarter_moon_with_face:",code_decimal:"&#127771;",category:"n",emoji_order:"1721"},{name:"last_quarter_moon_with_face",unicode:"1f31c",shortname:":last_quarter_moon_with_face:",code_decimal:"&#127772;",category:"n",emoji_order:"1722"},{name:"thermometer",unicode:"1f321",shortname:":thermometer:",code_decimal:"&#127777;",category:"o",emoji_order:"1723"},{name:"sunny",unicode:"2600",shortname:":sunny:",code_decimal:"&#9728;",category:"n",emoji_order:"1724"},{name:"full_moon_with_face",unicode:"1f31d",shortname:":full_moon_with_face:",code_decimal:"&#127773;",category:"n",emoji_order:"1725"},{name:"sun_with_face",unicode:"1f31e",shortname:":sun_with_face:",code_decimal:"&#127774;",category:"n",emoji_order:"1726"},{name:"star",unicode:"2b50",shortname:":star:",code_decimal:"&#11088;",category:"n",emoji_order:"1727"},{name:"star2",unicode:"1f31f",shortname:":star2:",code_decimal:"&#127775;",category:"n",emoji_order:"1728"},{name:"stars",unicode:"1f320",shortname:":stars:",code_decimal:"&#127776;",category:"t",emoji_order:"1729"},{name:"cloud",unicode:"2601",shortname:":cloud:",code_decimal:"&#9729;",category:"n",emoji_order:"1730"},{name:"partly_sunny",unicode:"26c5",shortname:":partly_sunny:",code_decimal:"&#9925;",category:"n",emoji_order:"1731"},{name:"thunder_cloud_and_rain",unicode:"26c8",shortname:":thunder_cloud_rain:",code_decimal:"&#9928;",category:"n",emoji_order:"1732"},{name:"rain_cloud",unicode:"1f327",shortname:":cloud_rain:",code_decimal:"&#127783;",category:"n",emoji_order:"1736"},{name:"snow_cloud",unicode:"1f328",shortname:":cloud_snow:",code_decimal:"&#127784;",category:"n",emoji_order:"1737"},{name:"fog",unicode:"1f32b",shortname:":fog:",code_decimal:"&#127787;",category:"n",emoji_order:"1740"},{name:"wind_blowing_face",unicode:"1f32c",shortname:":wind_blowing_face:",code_decimal:"&#127788;",category:"n",emoji_order:"1741"},{name:"cyclone",unicode:"1f300",shortname:":cyclone:",code_decimal:"&#127744;",category:"s",emoji_order:"1742"},{name:"rainbow",unicode:"1f308",shortname:":rainbow:",code_decimal:"&#127752;",category:"t",emoji_order:"1743"},{name:"closed_umbrella",unicode:"1f302",shortname:":closed_umbrella:",code_decimal:"&#127746;",category:"p",emoji_order:"1744"},{name:"umbrella",unicode:"2602",shortname:":umbrella2:",code_decimal:"&#9730;",category:"n",emoji_order:"1745"},{name:"umbrella_with_rain_drops",unicode:"2614",shortname:":umbrella:",code_decimal:"&#9748;",category:"n",emoji_order:"1746"},{name:"beach_umbrella",unicode:"26f1",shortname:":beach_umbrella:",code_decimal:"&#9969;",category:"o",emoji_order:"1747"},{name:"zap",unicode:"26a1",shortname:":zap:",code_decimal:"&#9889;",category:"n",emoji_order:"1748"},{name:"snowflake",unicode:"2744",shortname:":snowflake:",code_decimal:"&#10052;",category:"n",emoji_order:"1749"},{name:"snowman",unicode:"2603",shortname:":snowman2:",code_decimal:"&#9731;",category:"n",emoji_order:"1750"},{name:"snowman_without_snow",unicode:"26c4",shortname:":snowman:",code_decimal:"&#9924;",category:"n",emoji_order:"1751"},{name:"comet",unicode:"2604",shortname:":comet:",code_decimal:"&#9732;",category:"n",emoji_order:"1752"},{name:"fire",unicode:"1f525",shortname:":fire:",code_decimal:"&#128293;",category:"n",emoji_order:"1753"},{name:"droplet",unicode:"1f4a7",shortname:":droplet:",code_decimal:"&#128167;",category:"n",emoji_order:"1754"},{name:"ocean",unicode:"1f30a",shortname:":ocean:",code_decimal:"&#127754;",category:"n",emoji_order:"1755"},{name:"jack_o_lantern",unicode:"1f383",shortname:":jack_o_lantern:",code_decimal:"&#127875;",category:"n",emoji_order:"1756"},{name:"christmas_tree",unicode:"1f384",shortname:":christmas_tree:",code_decimal:"&#127876;",category:"n",emoji_order:"1757"},{name:"fireworks",unicode:"1f386",shortname:":fireworks:",code_decimal:"&#127878;",category:"t",emoji_order:"1758"},{name:"sparkler",unicode:"1f387",shortname:":sparkler:",code_decimal:"&#127879;",category:"t",emoji_order:"1759"},{name:"sparkles",unicode:"2728",shortname:":sparkles:",code_decimal:"&#10024;",category:"n",emoji_order:"1760"},{name:"balloon",unicode:"1f388",shortname:":balloon:",code_decimal:"&#127880;",category:"o",emoji_order:"1761"},{name:"tada",unicode:"1f389",shortname:":tada:",code_decimal:"&#127881;",category:"o",emoji_order:"1762"},{name:"confetti_ball",unicode:"1f38a",shortname:":confetti_ball:",code_decimal:"&#127882;",category:"o",emoji_order:"1763"},{name:"tanabata_tree",unicode:"1f38b",shortname:":tanabata_tree:",code_decimal:"&#127883;",category:"n",emoji_order:"1764"},{name:"bamboo",unicode:"1f38d",shortname:":bamboo:",code_decimal:"&#127885;",category:"n",emoji_order:"1765"},{name:"dolls",unicode:"1f38e",shortname:":dolls:",code_decimal:"&#127886;",category:"o",emoji_order:"1766"},{name:"f",unicode:"1f38f",shortname:":flags:",code_decimal:"&#127887;",category:"o",emoji_order:"1767"},{name:"wind_chime",unicode:"1f390",shortname:":wind_chime:",code_decimal:"&#127888;",category:"o",emoji_order:"1768"},{name:"rice_scene",unicode:"1f391",shortname:":rice_scene:",code_decimal:"&#127889;",category:"t",emoji_order:"1769"},{name:"ribbon",unicode:"1f380",shortname:":ribbon:",code_decimal:"&#127872;",category:"o",emoji_order:"1770"},{name:"gift",unicode:"1f381",shortname:":gift:",code_decimal:"&#127873;",category:"o",emoji_order:"1771"},{name:"reminder_ribbon",unicode:"1f397",shortname:":reminder_ribbon:",code_decimal:"&#127895;",category:"a",emoji_order:"1772"},{name:"admission_tickets",unicode:"1f39f",shortname:":tickets:",code_decimal:"&#127903;",category:"a",emoji_order:"1773"},{name:"ticket",unicode:"1f3ab",shortname:":ticket:",code_decimal:"&#127915;",category:"a",emoji_order:"1774"},{name:"medal",unicode:"1f396",shortname:":military_medal:",code_decimal:"&#127894;",category:"a",emoji_order:"1775"},{name:"trophy",unicode:"1f3c6",shortname:":trophy:",code_decimal:"&#127942;",category:"a",emoji_order:"1776"},{name:"sports_medal",unicode:"1f3c5",shortname:":medal:",code_decimal:"&#127941;",category:"a",emoji_order:"1777"},{name:"soccer",unicode:"26bd",shortname:":soccer:",code_decimal:"&#9917;",category:"a",emoji_order:"1781"},{name:"baseball",unicode:"26be",shortname:":baseball:",code_decimal:"&#9918;",category:"a",emoji_order:"1782"},{name:"basketball",unicode:"1f3c0",shortname:":basketball:",code_decimal:"&#127936;",category:"a",emoji_order:"1783"},{name:"volleyball",unicode:"1f3d0",shortname:":volleyball:",code_decimal:"&#127952;",category:"a",emoji_order:"1784"},{name:"football",unicode:"1f3c8",shortname:":football:",code_decimal:"&#127944;",category:"a",emoji_order:"1785"},{name:"rugby_football",unicode:"1f3c9",shortname:":rugby_football:",code_decimal:"&#127945;",category:"a",emoji_order:"1786"},{name:"tennis",unicode:"1f3be",shortname:":tennis:",code_decimal:"&#127934;",category:"a",emoji_order:"1787"},{name:"8ball",unicode:"1f3b1",shortname:":8ball:",code_decimal:"&#127921;",category:"a",emoji_order:"1788"},{name:"bowling",unicode:"1f3b3",shortname:":bowling:",code_decimal:"&#127923;",category:"a",emoji_order:"1789"},{name:"cricket_bat_and_ball",unicode:"1f3cf",shortname:":cricket_game:",code_decimal:"&#127951;",category:"a",emoji_order:"1790"},{name:"field_hockey_stick_and_ball",unicode:"1f3d1",shortname:":field_hockey:",code_decimal:"&#127953;",category:"a",emoji_order:"1791"},{name:"ice_hockey_stick_and_puck",unicode:"1f3d2",shortname:":hockey:",code_decimal:"&#127954;",category:"a",emoji_order:"1792"},{name:"table_tennis_paddle_and_ball",unicode:"1f3d3",shortname:":ping_pong:",code_decimal:"&#127955;",category:"a",emoji_order:"1793"},{name:"badminton_racquet_and_shuttlecock",unicode:"1f3f8",shortname:":badminton:",code_decimal:"&#127992;",category:"a",emoji_order:"1794"},{name:"dart",unicode:"1f3af",shortname:":dart:",code_decimal:"&#127919;",category:"a",emoji_order:"1798"},{name:"golf",unicode:"26f3",shortname:":golf:",code_decimal:"&#9971;",category:"a",emoji_order:"1799"},{name:"ice_skate",unicode:"26f8",shortname:":ice_skate:",code_decimal:"&#9976;",category:"a",emoji_order:"1800"},{name:"fishing_pole_and_fish",unicode:"1f3a3",shortname:":fishing_pole_and_fish:",code_decimal:"&#127907;",category:"a",emoji_order:"1801"},{name:"running_shirt_with_sash",unicode:"1f3bd",shortname:":running_shirt_with_sash:",code_decimal:"&#127933;",category:"a",emoji_order:"1802"},{name:"ski",unicode:"1f3bf",shortname:":ski:",code_decimal:"&#127935;",category:"a",emoji_order:"1803"},{name:"video_game",unicode:"1f3ae",shortname:":video_game:",code_decimal:"&#127918;",category:"a",emoji_order:"1804"},{name:"joystick",unicode:"1f579",shortname:":joystick:",code_decimal:"&#128377;",category:"o",emoji_order:"1805"},{name:"game_die",unicode:"1f3b2",shortname:":game_die:",code_decimal:"&#127922;",category:"a",emoji_order:"1806"},{name:"spades",unicode:"2660",shortname:":spades:",code_decimal:"&spades;",category:"s",emoji_order:"1807"},{name:"hearts",unicode:"2665",shortname:":hearts:",code_decimal:"&hearts;",category:"s",emoji_order:"1808"},{name:"diamonds",unicode:"2666",shortname:":diamonds:",code_decimal:"&diams;",category:"s",emoji_order:"1809"},{name:"clubs",unicode:"2663",shortname:":clubs:",code_decimal:"&clubs;",category:"s",emoji_order:"1810"},{name:"black_joker",unicode:"1f0cf",shortname:":black_joker:",code_decimal:"&#127183;",category:"s",emoji_order:"1811"},{name:"mahjong",unicode:"1f004",shortname:":mahjong:",code_decimal:"&#126980;",category:"s",emoji_order:"1812"},{name:"flower_playing_cards",unicode:"1f3b4",shortname:":flower_playing_cards:",code_decimal:"&#127924;",category:"s",emoji_order:"1813"},{name:"mute",unicode:"1f507",shortname:":mute:",code_decimal:"&#128263;",category:"s",emoji_order:"1814"},{name:"speaker",unicode:"1f508",shortname:":speaker:",code_decimal:"&#128264;",category:"s",emoji_order:"1815"},{name:"sound",unicode:"1f509",shortname:":sound:",code_decimal:"&#128265;",category:"s",emoji_order:"1816"},{name:"loud_sound",unicode:"1f50a",shortname:":loud_sound:",code_decimal:"&#128266;",category:"s",emoji_order:"1817"},{name:"loudspeaker",unicode:"1f4e2",shortname:":loudspeaker:",code_decimal:"&#128226;",category:"s",emoji_order:"1818"},{name:"mega",unicode:"1f4e3",shortname:":mega:",code_decimal:"&#128227;",category:"s",emoji_order:"1819"},{name:"postal_horn",unicode:"1f4ef",shortname:":postal_horn:",code_decimal:"&#128239;",category:"o",emoji_order:"1820"},{name:"bell",unicode:"1f514",shortname:":bell:",code_decimal:"&#128276;",category:"s",emoji_order:"1821"},{name:"no_bell",unicode:"1f515",shortname:":no_bell:",code_decimal:"&#128277;",category:"s",emoji_order:"1822"},{name:"musical_score",unicode:"1f3bc",shortname:":musical_score:",code_decimal:"&#127932;",category:"a",emoji_order:"1823"},{name:"musical_note",unicode:"1f3b5",shortname:":musical_note:",code_decimal:"&#127925;",category:"s",emoji_order:"1824"},{name:"notes",unicode:"1f3b6",shortname:":notes:",code_decimal:"&#127926;",category:"s",emoji_order:"1825"},{name:"studio_microphone",unicode:"1f399",shortname:":microphone2:",code_decimal:"&#127897;",category:"o",emoji_order:"1826"},{name:"level_slider",unicode:"1f39a",shortname:":level_slider:",code_decimal:"&#127898;",category:"o",emoji_order:"1827"},{name:"control_knobs",unicode:"1f39b",shortname:":control_knobs:",code_decimal:"&#127899;",category:"o",emoji_order:"1828"},{name:"microphone",unicode:"1f3a4",shortname:":microphone:",code_decimal:"&#127908;",category:"a",emoji_order:"1829"},{name:"headphones",unicode:"1f3a7",shortname:":headphones:",code_decimal:"&#127911;",category:"a",emoji_order:"1830"},{name:"radio",unicode:"1f4fb",shortname:":radio:",code_decimal:"&#128251;",category:"o",emoji_order:"1831"},{name:"saxophone",unicode:"1f3b7",shortname:":saxophone:",code_decimal:"&#127927;",category:"a",emoji_order:"1832"},{name:"guitar",unicode:"1f3b8",shortname:":guitar:",code_decimal:"&#127928;",category:"a",emoji_order:"1833"},{name:"musical_keyboard",unicode:"1f3b9",shortname:":musical_keyboard:",code_decimal:"&#127929;",category:"a",emoji_order:"1834"},{name:"trumpet",unicode:"1f3ba",shortname:":trumpet:",code_decimal:"&#127930;",category:"a",emoji_order:"1835"},{name:"violin",unicode:"1f3bb",shortname:":violin:",code_decimal:"&#127931;",category:"a",emoji_order:"1836"},{name:"iphone",unicode:"1f4f1",shortname:":iphone:",code_decimal:"&#128241;",category:"o",emoji_order:"1838"},{name:"calling",unicode:"1f4f2",shortname:":calling:",code_decimal:"&#128242;",category:"o",emoji_order:"1839"},{name:"telephone",unicode:"260e",shortname:":telephone:",code_decimal:"&#9742;",category:"o",emoji_order:"1840"},{name:"telephone_receiver",unicode:"1f4de",shortname:":telephone_receiver:",code_decimal:"&#128222;",category:"o",emoji_order:"1841"},{name:"pager",unicode:"1f4df",shortname:":pager:",code_decimal:"&#128223;",category:"o",emoji_order:"1842"},{name:"fax",unicode:"1f4e0",shortname:":fax:",code_decimal:"&#128224;",category:"o",emoji_order:"1843"},{name:"battery",unicode:"1f50b",shortname:":battery:",code_decimal:"&#128267;",category:"o",emoji_order:"1844"},{name:"electric_plug",unicode:"1f50c",shortname:":electric_plug:",code_decimal:"&#128268;",category:"o",emoji_order:"1845"},{name:"computer",unicode:"1f4bb",shortname:":computer:",code_decimal:"&#128187;",category:"o",emoji_order:"1846"},{name:"desktop_computer",unicode:"1f5a5",shortname:":desktop:",code_decimal:"&#128421;",category:"o",emoji_order:"1847"},{name:"printer",unicode:"1f5a8",shortname:":printer:",code_decimal:"&#128424;",category:"o",emoji_order:"1848"},{name:"keyboard",unicode:"2328",shortname:":keyboard:",code_decimal:"&#9000;",category:"o",emoji_order:"1849"},{name:"three_button_mouse",unicode:"1f5b1",shortname:":mouse_three_button:",code_decimal:"&#128433;",category:"o",emoji_order:"1850"},{name:"trackball",unicode:"1f5b2",shortname:":trackball:",code_decimal:"&#128434;",category:"o",emoji_order:"1851"},{name:"minidisc",unicode:"1f4bd",shortname:":minidisc:",code_decimal:"&#128189;",category:"o",emoji_order:"1852"},{name:"floppy_disk",unicode:"1f4be",shortname:":floppy_disk:",code_decimal:"&#128190;",category:"o",emoji_order:"1853"},{name:"cd",unicode:"1f4bf",shortname:":cd:",code_decimal:"&#128191;",category:"o",emoji_order:"1854"},{name:"dvd",unicode:"1f4c0",shortname:":dvd:",code_decimal:"&#128192;",category:"o",emoji_order:"1855"},{name:"movie_camera",unicode:"1f3a5",shortname:":movie_camera:",code_decimal:"&#127909;",category:"o",emoji_order:"1856"},{name:"film_frames",unicode:"1f39e",shortname:":film_frames:",code_decimal:"&#127902;",category:"o",emoji_order:"1857"},{name:"film_projector",unicode:"1f4fd",shortname:":projector:",code_decimal:"&#128253;",category:"o",emoji_order:"1858"},{name:"clapper",unicode:"1f3ac",shortname:":clapper:",code_decimal:"&#127916;",category:"a",emoji_order:"1859"},{name:"tv",unicode:"1f4fa",shortname:":tv:",code_decimal:"&#128250;",category:"o",emoji_order:"1860"},{name:"camera",unicode:"1f4f7",shortname:":camera:",code_decimal:"&#128247;",category:"o",emoji_order:"1861"},{name:"camera_with_flash",unicode:"1f4f8",shortname:":camera_with_flash:",code_decimal:"&#128248;",category:"o",emoji_order:"1862"},{name:"video_camera",unicode:"1f4f9",shortname:":video_camera:",code_decimal:"&#128249;",category:"o",emoji_order:"1863"},{name:"vhs",unicode:"1f4fc",shortname:":vhs:",code_decimal:"&#128252;",category:"o",emoji_order:"1864"},{name:"mag",unicode:"1f50d",shortname:":mag:",code_decimal:"&#128269;",category:"o",emoji_order:"1865"},{name:"mag_right",unicode:"1f50e",shortname:":mag_right:",code_decimal:"&#128270;",category:"o",emoji_order:"1866"},{name:"microscope",unicode:"1f52c",shortname:":microscope:",code_decimal:"&#128300;",category:"o",emoji_order:"1867"},{name:"telescope",unicode:"1f52d",shortname:":telescope:",code_decimal:"&#128301;",category:"o",emoji_order:"1868"},{name:"satellite_antenna",unicode:"1f4e1",shortname:":satellite:",code_decimal:"&#128225;",category:"o",emoji_order:"1869"},{name:"candle",unicode:"1f56f",shortname:":candle:",code_decimal:"&#128367;",category:"o",emoji_order:"1870"},{name:"bulb",unicode:"1f4a1",shortname:":bulb:",code_decimal:"&#128161;",category:"o",emoji_order:"1871"},{name:"flashlight",unicode:"1f526",shortname:":flashlight:",code_decimal:"&#128294;",category:"o",emoji_order:"1872"},{name:"izakaya_lantern",unicode:"1f3ee",shortname:":izakaya_lantern:",code_decimal:"&#127982;",category:"o",emoji_order:"1873"},{name:"notebook_with_decorative_cover",unicode:"1f4d4",shortname:":notebook_with_decorative_cover:",code_decimal:"&#128212;",category:"o",emoji_order:"1874"},{name:"closed_book",unicode:"1f4d5",shortname:":closed_book:",code_decimal:"&#128213;",category:"o",emoji_order:"1875"},{name:"book",unicode:"1f4d6",shortname:":book:",code_decimal:"&#128214;",category:"o",emoji_order:"1876"},{name:"green_book",unicode:"1f4d7",shortname:":green_book:",code_decimal:"&#128215;",category:"o",emoji_order:"1877"},{name:"blue_book",unicode:"1f4d8",shortname:":blue_book:",code_decimal:"&#128216;",category:"o",emoji_order:"1878"},{name:"orange_book",unicode:"1f4d9",shortname:":orange_book:",code_decimal:"&#128217;",category:"o",emoji_order:"1879"},{name:"books",unicode:"1f4da",shortname:":books:",code_decimal:"&#128218;",category:"o",emoji_order:"1880"},{name:"notebook",unicode:"1f4d3",shortname:":notebook:",code_decimal:"&#128211;",category:"o",emoji_order:"1881"},{name:"ledger",unicode:"1f4d2",shortname:":ledger:",code_decimal:"&#128210;",category:"o",emoji_order:"1882"},{name:"page_with_curl",unicode:"1f4c3",shortname:":page_with_curl:",code_decimal:"&#128195;",category:"o",emoji_order:"1883"},{name:"scroll",unicode:"1f4dc",shortname:":scroll:",code_decimal:"&#128220;",category:"o",emoji_order:"1884"},{name:"page_facing_up",unicode:"1f4c4",shortname:":page_facing_up:",code_decimal:"&#128196;",category:"o",emoji_order:"1885"},{name:"newspaper",unicode:"1f4f0",shortname:":newspaper:",code_decimal:"&#128240;",category:"o",emoji_order:"1886"},{name:"rolled_up_newspaper",unicode:"1f5de",shortname:":newspaper2:",code_decimal:"&#128478;",category:"o",emoji_order:"1887"},{name:"bookmark_tabs",unicode:"1f4d1",shortname:":bookmark_tabs:",code_decimal:"&#128209;",category:"o",emoji_order:"1888"},{name:"bookmark",unicode:"1f516",shortname:":bookmark:",code_decimal:"&#128278;",category:"o",emoji_order:"1889"},{name:"label",unicode:"1f3f7",shortname:":label:",code_decimal:"&#127991;",category:"o",emoji_order:"1890"},{name:"moneybag",unicode:"1f4b0",shortname:":moneybag:",code_decimal:"&#128176;",category:"o",emoji_order:"1891"},{name:"yen",unicode:"1f4b4",shortname:":yen:",code_decimal:"&#128180;",category:"o",emoji_order:"1892"},{name:"dollar",unicode:"1f4b5",shortname:":dollar:",code_decimal:"&#128181;",category:"o",emoji_order:"1893"},{name:"euro",unicode:"1f4b6",shortname:":euro:",code_decimal:"&#128182;",category:"o",emoji_order:"1894"},{name:"pound",unicode:"1f4b7",shortname:":pound:",code_decimal:"&#128183;",category:"o",emoji_order:"1895"},{name:"money_with_wings",unicode:"1f4b8",shortname:":money_with_wings:",code_decimal:"&#128184;",category:"o",emoji_order:"1896"},{name:"credit_card",unicode:"1f4b3",shortname:":credit_card:",code_decimal:"&#128179;",category:"o",emoji_order:"1897"},{name:"chart",unicode:"1f4b9",shortname:":chart:",code_decimal:"&#128185;",category:"s",emoji_order:"1898"},{name:"currency_exchange",unicode:"1f4b1",shortname:":currency_exchange:",code_decimal:"&#128177;",category:"s",emoji_order:"1899"},{name:"heavy_dollar_sign",unicode:"1f4b2",shortname:":heavy_dollar_sign:",code_decimal:"&#128178;",category:"s",emoji_order:"1900"},{name:"e-mail",unicode:"1f4e7",shortname:":e-mail:",code_decimal:"&#128231;",category:"o",emoji_order:"1902"},{name:"incoming_envelope",unicode:"1f4e8",shortname:":incoming_envelope:",code_decimal:"&#128232;",category:"o",emoji_order:"1903"},{name:"envelope_with_arrow",unicode:"1f4e9",shortname:":envelope_with_arrow:",code_decimal:"&#128233;",category:"o",emoji_order:"1904"},{name:"outbox_tray",unicode:"1f4e4",shortname:":outbox_tray:",code_decimal:"&#128228;",category:"o",emoji_order:"1905"},{name:"inbox_tray",unicode:"1f4e5",shortname:":inbox_tray:",code_decimal:"&#128229;",category:"o",emoji_order:"1906"},{name:"package",unicode:"1f4e6",shortname:":package:",code_decimal:"&#128230;",category:"o",emoji_order:"1907"},{name:"mailbox",unicode:"1f4eb",shortname:":mailbox:",code_decimal:"&#128235;",category:"o",emoji_order:"1908"},{name:"mailbox_closed",unicode:"1f4ea",shortname:":mailbox_closed:",code_decimal:"&#128234;",category:"o",emoji_order:"1909"},{name:"mailbox_with_mail",unicode:"1f4ec",shortname:":mailbox_with_mail:",code_decimal:"&#128236;",category:"o",emoji_order:"1910"},{name:"mailbox_with_no_mail",unicode:"1f4ed",shortname:":mailbox_with_no_mail:",code_decimal:"&#128237;",category:"o",emoji_order:"1911"},{name:"postbox",unicode:"1f4ee",shortname:":postbox:",code_decimal:"&#128238;",category:"o",emoji_order:"1912"},{name:"ballot_box_with_ballot",unicode:"1f5f3",shortname:":ballot_box:",code_decimal:"&#128499;",category:"o",emoji_order:"1913"},{name:"pencil2",unicode:"270f",shortname:":pencil2:",code_decimal:"&#9999;",category:"o",emoji_order:"1914"},{name:"black_nib",unicode:"2712",shortname:":black_nib:",code_decimal:"&#10002;",category:"o",emoji_order:"1915"},{name:"lower_left_fountain_pen",unicode:"1f58b",shortname:":pen_fountain:",code_decimal:"&#128395;",category:"o",emoji_order:"1916"},{name:"lower_left_ballpoint_pen",unicode:"1f58a",shortname:":pen_ballpoint:",code_decimal:"&#128394;",category:"o",emoji_order:"1917"},{name:"lower_left_paintbrush",unicode:"1f58c",shortname:":paintbrush:",code_decimal:"&#128396;",category:"o",emoji_order:"1918"},{name:"lower_left_crayon",unicode:"1f58d",shortname:":crayon:",code_decimal:"&#128397;",category:"o",emoji_order:"1919"},{name:"memo",unicode:"1f4dd",shortname:":pencil:",code_decimal:"&#128221;",category:"o",emoji_order:"1920"},{name:"briefcase",unicode:"1f4bc",shortname:":briefcase:",code_decimal:"&#128188;",category:"p",emoji_order:"1921"},{name:"file_folder",unicode:"1f4c1",shortname:":file_folder:",code_decimal:"&#128193;",category:"o",emoji_order:"1922"},{name:"open_file_folder",unicode:"1f4c2",shortname:":open_file_folder:",code_decimal:"&#128194;",category:"o",emoji_order:"1923"},{name:"card_index_dividers",unicode:"1f5c2",shortname:":dividers:",code_decimal:"&#128450;",category:"o",emoji_order:"1924"},{name:"date",unicode:"1f4c5",shortname:":date:",code_decimal:"&#128197;",category:"o",emoji_order:"1925"},{name:"calendar",unicode:"1f4c6",shortname:":calendar:",code_decimal:"&#128198;",category:"o",emoji_order:"1926"},{name:"spiral_note_pad",unicode:"1f5d2",shortname:":notepad_spiral:",code_decimal:"&#128466;",category:"o",emoji_order:"1927"},{name:"spiral_calendar_pad",unicode:"1f5d3",shortname:":calendar_spiral:",code_decimal:"&#128467;",category:"o",emoji_order:"1928"},{name:"card_index",unicode:"1f4c7",shortname:":card_index:",code_decimal:"&#128199;",category:"o",emoji_order:"1929"},{name:"chart_with_upwards_trend",unicode:"1f4c8",shortname:":chart_with_upwards_trend:",code_decimal:"&#128200;",category:"o",emoji_order:"1930"},{name:"chart_with_downwards_trend",unicode:"1f4c9",shortname:":chart_with_downwards_trend:",code_decimal:"&#128201;",category:"o",emoji_order:"1931"},{name:"bar_chart",unicode:"1f4ca",shortname:":bar_chart:",code_decimal:"&#128202;",category:"o",emoji_order:"1932"},{name:"clipboard",unicode:"1f4cb",shortname:":clipboard:",code_decimal:"&#128203;",category:"o",emoji_order:"1933"},{name:"pushpin",unicode:"1f4cc",shortname:":pushpin:",code_decimal:"&#128204;",category:"o",emoji_order:"1934"},{name:"round_pushpin",unicode:"1f4cd",shortname:":round_pushpin:",code_decimal:"&#128205;",category:"o",emoji_order:"1935"},{name:"paperclip",unicode:"1f4ce",shortname:":paperclip:",code_decimal:"&#128206;",category:"o",emoji_order:"1936"},{name:"linked_paperclips",unicode:"1f587",shortname:":paperclips:",code_decimal:"&#128391;",category:"o",emoji_order:"1937"},{name:"straight_ruler",unicode:"1f4cf",shortname:":straight_ruler:",code_decimal:"&#128207;",category:"o",emoji_order:"1938"},{name:"triangular_ruler",unicode:"1f4d0",shortname:":triangular_ruler:",code_decimal:"&#128208;",category:"o",emoji_order:"1939"},{name:"scissors",unicode:"2702",shortname:":scissors:",code_decimal:"&#9986;",category:"o",emoji_order:"1940"},{name:"card_file_box",unicode:"1f5c3",shortname:":card_box:",code_decimal:"&#128451;",category:"o",emoji_order:"1941"},{name:"file_cabinet",unicode:"1f5c4",shortname:":file_cabinet:",code_decimal:"&#128452;",category:"o",emoji_order:"1942"},{name:"wastebasket",unicode:"1f5d1",shortname:":wastebasket:",code_decimal:"&#128465;",category:"o",emoji_order:"1943"},{name:"lock",unicode:"1f512",shortname:":lock:",code_decimal:"&#128274;",category:"o",emoji_order:"1944"},{name:"unlock",unicode:"1f513",shortname:":unlock:",code_decimal:"&#128275;",category:"o",emoji_order:"1945"},{name:"lock_with_ink_pen",unicode:"1f50f",shortname:":lock_with_ink_pen:",code_decimal:"&#128271;",category:"o",emoji_order:"1946"},{name:"closed_lock_with_key",unicode:"1f510",shortname:":closed_lock_with_key:",code_decimal:"&#128272;",category:"o",emoji_order:"1947"},{name:"key",unicode:"1f511",shortname:":key:",code_decimal:"&#128273;",category:"o",emoji_order:"1948"},{name:"old_key",unicode:"1f5dd",shortname:":key2:",code_decimal:"&#128477;",category:"o",emoji_order:"1949"},{name:"hammer",unicode:"1f528",shortname:":hammer:",code_decimal:"&#128296;",category:"o",emoji_order:"1950"},{name:"pick",unicode:"26cf",shortname:":pick:",code_decimal:"&#9935;",category:"o",emoji_order:"1951"},{name:"hammer_and_pick",unicode:"2692",shortname:":hammer_pick:",code_decimal:"&#9874;",category:"o",emoji_order:"1952"},{name:"hammer_and_wrench",unicode:"1f6e0",shortname:":tools:",code_decimal:"&#128736;",category:"o",emoji_order:"1953"},{name:"dagger_knife",unicode:"1f5e1",shortname:":dagger:",code_decimal:"&#128481;",category:"o",emoji_order:"1954"},{name:"crossed_swords",unicode:"2694",shortname:":crossed_swords:",code_decimal:"&#9876;",category:"o",emoji_order:"1955"},{name:"gun",unicode:"1f52b",shortname:":gun:",code_decimal:"&#128299;",category:"o",emoji_order:"1956"},{name:"bow_and_arrow",unicode:"1f3f9",shortname:":bow_and_arrow:",code_decimal:"&#127993;",category:"a",emoji_order:"1957"},{name:"shield",unicode:"1f6e1",shortname:":shield:",code_decimal:"&#128737;",category:"o",emoji_order:"1958"},{name:"wrench",unicode:"1f527",shortname:":wrench:",code_decimal:"&#128295;",category:"o",emoji_order:"1959"},{name:"nut_and_bolt",unicode:"1f529",shortname:":nut_and_bolt:",code_decimal:"&#128297;",category:"o",emoji_order:"1960"},{name:"gear",unicode:"2699",shortname:":gear:",code_decimal:"&#9881;",category:"o",emoji_order:"1961"},{name:"compression",unicode:"1f5dc",shortname:":compression:",code_decimal:"&#128476;",category:"o",emoji_order:"1962"},{name:"alembic",unicode:"2697",shortname:":alembic:",code_decimal:"&#9879;",category:"o",emoji_order:"1963"},{name:"scales",unicode:"2696",shortname:":scales:",code_decimal:"&#9878;",category:"o",emoji_order:"1964"},{name:"link",unicode:"1f517",shortname:":link:",code_decimal:"&#128279;",category:"o",emoji_order:"1965"},{name:"chains",unicode:"26d3",shortname:":chains:",code_decimal:"&#9939;",category:"o",emoji_order:"1966"},{name:"syringe",unicode:"1f489",shortname:":syringe:",code_decimal:"&#128137;",category:"o",emoji_order:"1967"},{name:"pill",unicode:"1f48a",shortname:":pill:",code_decimal:"&#128138;",category:"o",emoji_order:"1968"},{name:"smoking",unicode:"1f6ac",shortname:":smoking:",code_decimal:"&#128684;",category:"o",emoji_order:"1969"},{name:"coffin",unicode:"26b0",shortname:":coffin:",code_decimal:"&#9904;",category:"o",emoji_order:"1970"},{name:"funeral_urn",unicode:"26b1",shortname:":urn:",code_decimal:"&#9905;",category:"o",emoji_order:"1971"},{name:"moyai",unicode:"1f5ff",shortname:":moyai:",code_decimal:"&#128511;",category:"o",emoji_order:"1972"},{name:"oil_drum",unicode:"1f6e2",shortname:":oil:",code_decimal:"&#128738;",category:"o",emoji_order:"1973"},{name:"crystal_ball",unicode:"1f52e",shortname:":crystal_ball:",code_decimal:"&#128302;",category:"o",emoji_order:"1974"},{name:"atm",unicode:"1f3e7",shortname:":atm:",code_decimal:"&#127975;",category:"s",emoji_order:"1976"},{name:"put_litter_in_its_place",unicode:"1f6ae",shortname:":put_litter_in_its_place:",code_decimal:"&#128686;",category:"s",emoji_order:"1977"},{name:"potable_water",unicode:"1f6b0",shortname:":potable_water:",code_decimal:"&#128688;",category:"s",emoji_order:"1978"},{name:"wheelchair",unicode:"267f",shortname:":wheelchair:",code_decimal:"&#9855;",category:"s",emoji_order:"1979"},{name:"mens",unicode:"1f6b9",shortname:":mens:",code_decimal:"&#128697;",category:"s",emoji_order:"1980"},{name:"womens",unicode:"1f6ba",shortname:":womens:",code_decimal:"&#128698;",category:"s",emoji_order:"1981"},{name:"restroom",unicode:"1f6bb",shortname:":restroom:",code_decimal:"&#128699;",category:"s",emoji_order:"1982"},{name:"baby_symbol",unicode:"1f6bc",shortname:":baby_symbol:",code_decimal:"&#128700;",category:"s",emoji_order:"1983"},{name:"wc",unicode:"1f6be",shortname:":wc:",code_decimal:"&#128702;",category:"s",emoji_order:"1984"},{name:"passport_control",unicode:"1f6c2",shortname:":passport_control:",code_decimal:"&#128706;",category:"s",emoji_order:"1985"},{name:"customs",unicode:"1f6c3",shortname:":customs:",code_decimal:"&#128707;",category:"s",emoji_order:"1986"},{name:"baggage_claim",unicode:"1f6c4",shortname:":baggage_claim:",code_decimal:"&#128708;",category:"s",emoji_order:"1987"},{name:"left_luggage",unicode:"1f6c5",shortname:":left_luggage:",code_decimal:"&#128709;",category:"s",emoji_order:"1988"},{name:"warning",unicode:"26a0",shortname:":warning:",code_decimal:"&#9888;",category:"s",emoji_order:"1989"},{name:"children_crossing",unicode:"1f6b8",shortname:":children_crossing:",code_decimal:"&#128696;",category:"s",emoji_order:"1990"},{name:"no_entry",unicode:"26d4",shortname:":no_entry:",code_decimal:"&#9940;",category:"s",emoji_order:"1991"},{name:"no_entry_sign",unicode:"1f6ab",shortname:":no_entry_sign:",code_decimal:"&#128683;",category:"s",emoji_order:"1992"},{name:"no_bicycles",unicode:"1f6b3",shortname:":no_bicycles:",code_decimal:"&#128691;",category:"s",emoji_order:"1993"},{name:"no_smoking",unicode:"1f6ad",shortname:":no_smoking:",code_decimal:"&#128685;",category:"s",emoji_order:"1994"},{name:"do_not_litter",unicode:"1f6af",shortname:":do_not_litter:",code_decimal:"&#128687;",category:"s",emoji_order:"1995"},{name:"non-potable_water",unicode:"1f6b1",shortname:":non-potable_water:",code_decimal:"&#128689;",category:"s",emoji_order:"1996"},{name:"no_pedestrians",unicode:"1f6b7",shortname:":no_pedestrians:",code_decimal:"&#128695;",category:"s",emoji_order:"1997"},{name:"no_mobile_phones",unicode:"1f4f5",shortname:":no_mobile_phones:",code_decimal:"&#128245;",category:"s",emoji_order:"1998"},{name:"underage",unicode:"1f51e",shortname:":underage:",code_decimal:"&#128286;",category:"s",emoji_order:"1999"},{name:"radioactive",unicode:"2622",shortname:":radioactive:",code_decimal:"&#9762;",category:"s",emoji_order:"2000"},{name:"biohazard",unicode:"2623",shortname:":biohazard:",code_decimal:"&#9763;",category:"s",emoji_order:"2001"},{name:"arrow_up",unicode:"2b06",shortname:":arrow_up:",code_decimal:"&#11014;",category:"s",emoji_order:"2002"},{name:"arrow_upper_right",unicode:"2197",shortname:":arrow_upper_right:",code_decimal:"&#8599;",category:"s",emoji_order:"2003"},{name:"arrow_right",unicode:"27a1",shortname:":arrow_right:",code_decimal:"&#10145;",category:"s",emoji_order:"2004"},{name:"arrow_lower_right",unicode:"2198",shortname:":arrow_lower_right:",code_decimal:"&#8600;",category:"s",emoji_order:"2005"},{name:"arrow_down",unicode:"2b07",shortname:":arrow_down:",code_decimal:"&#11015;",category:"s",emoji_order:"2006"},{name:"arrow_lower_left",unicode:"2199",shortname:":arrow_lower_left:",code_decimal:"&#8601;",category:"s",emoji_order:"2007"},{name:"arrow_left",unicode:"2b05",shortname:":arrow_left:",code_decimal:"&#11013;",category:"s",emoji_order:"2008"},{name:"arrow_upper_left",unicode:"2196",shortname:":arrow_upper_left:",code_decimal:"&#8598;",category:"s",emoji_order:"2009"},{name:"arrow_up_down",unicode:"2195",shortname:":arrow_up_down:",code_decimal:"&#8597;",category:"s",emoji_order:"2010"},{name:"left_right_arrow",unicode:"2194",shortname:":left_right_arrow:",code_decimal:"&harr;",category:"s",emoji_order:"2011"},{name:"leftwards_arrow_with_hook",unicode:"21a9",shortname:":leftwards_arrow_with_hook:",code_decimal:"&#8617;",category:"s",emoji_order:"2012"},{name:"arrow_right_hook",unicode:"21aa",shortname:":arrow_right_hook:",code_decimal:"&#8618;",category:"s",emoji_order:"2013"},{name:"arrow_heading_up",unicode:"2934",shortname:":arrow_heading_up:",code_decimal:"&#10548;",category:"s",emoji_order:"2014"},{name:"arrow_heading_down",unicode:"2935",shortname:":arrow_heading_down:",code_decimal:"&#10549;",category:"s",emoji_order:"2015"},{name:"arrows_clockwise",unicode:"1f503",shortname:":arrows_clockwise:",code_decimal:"&#128259;",category:"s",emoji_order:"2016"},{name:"arrows_counterclockwise",unicode:"1f504",shortname:":arrows_counterclockwise:",code_decimal:"&#128260;",category:"s",emoji_order:"2017"},{name:"back",unicode:"1f519",shortname:":back:",code_decimal:"&#128281;",category:"s",emoji_order:"2018"},{name:"end",unicode:"1f51a",shortname:":end:",code_decimal:"&#128282;",category:"s",emoji_order:"2019"},{name:"on",unicode:"1f51b",shortname:":on:",code_decimal:"&#128283;",category:"s",emoji_order:"2020"},{name:"soon",unicode:"1f51c",shortname:":soon:",code_decimal:"&#128284;",category:"s",emoji_order:"2021"},{name:"top",unicode:"1f51d",shortname:":top:",code_decimal:"&#128285;",category:"s",emoji_order:"2022"},{name:"place_of_worship",unicode:"1f6d0",shortname:":place_of_worship:",code_decimal:"&#128720;",category:"s",emoji_order:"2023"},{name:"atom_symbol",unicode:"269b",shortname:":atom:",code_decimal:"&#9883;",category:"s",emoji_order:"2024"},{name:"om_symbol",unicode:"1f549",shortname:":om_symbol:",code_decimal:"&#128329;",category:"s",emoji_order:"2025"},{name:"star_of_david",unicode:"2721",shortname:":star_of_david:",code_decimal:"&#10017;",category:"s",emoji_order:"2026"},{name:"wheel_of_dharma",unicode:"2638",shortname:":wheel_of_dharma:",code_decimal:"&#9784;",category:"s",emoji_order:"2027"},{name:"yin_yang",unicode:"262f",shortname:":yin_yang:",code_decimal:"&#9775;",category:"s",emoji_order:"2028"},{name:"latin_cross",unicode:"271d",shortname:":cross:",code_decimal:"&#10013;",category:"s",emoji_order:"2029"},{name:"orthodox_cross",unicode:"2626",shortname:":orthodox_cross:",code_decimal:"&#9766;",category:"s",emoji_order:"2030"},{name:"star_and_crescent",unicode:"262a",shortname:":star_and_crescent:",code_decimal:"&#9770;",category:"s",emoji_order:"2031"},{name:"peace_symbol",unicode:"262e",shortname:":peace:",code_decimal:"&#9774;",category:"s",emoji_order:"2032"},{name:"menorah_with_nine_branches",unicode:"1f54e",shortname:":menorah:",code_decimal:"&#128334;",category:"s",emoji_order:"2033"},{name:"six_pointed_star",unicode:"1f52f",shortname:":six_pointed_star:",code_decimal:"&#128303;",category:"s",emoji_order:"2034"},{name:"aries",unicode:"2648",shortname:":aries:",code_decimal:"&#9800;",category:"s",emoji_order:"2035"},{name:"taurus",unicode:"2649",shortname:":taurus:",code_decimal:"&#9801;",category:"s",emoji_order:"2036"},{name:"gemini",unicode:"264a",shortname:":gemini:",code_decimal:"&#9802;",category:"s",emoji_order:"2037"},{name:"cancer",unicode:"264b",shortname:":cancer:",code_decimal:"&#9803;",category:"s",emoji_order:"2038"},{name:"leo",unicode:"264c",shortname:":leo:",code_decimal:"&#9804;",category:"s",emoji_order:"2039"},{name:"virgo",unicode:"264d",shortname:":virgo:",code_decimal:"&#9805;",category:"s",emoji_order:"2040"},{name:"libra",unicode:"264e",shortname:":libra:",code_decimal:"&#9806;",category:"s",emoji_order:"2041"},{name:"scorpius",unicode:"264f",shortname:":scorpius:",code_decimal:"&#9807;",category:"s",emoji_order:"2042"},{name:"sagittarius",unicode:"2650",shortname:":sagittarius:",code_decimal:"&#9808;",category:"s",emoji_order:"2043"},{name:"capricorn",unicode:"2651",shortname:":capricorn:",code_decimal:"&#9809;",category:"s",emoji_order:"2044"},{name:"aquarius",unicode:"2652",shortname:":aquarius:",code_decimal:"&#9810;",category:"s",emoji_order:"2045"},{name:"pisces",unicode:"2653",shortname:":pisces:",code_decimal:"&#9811;",category:"s",emoji_order:"2046"},{name:"ophiuchus",unicode:"26ce",shortname:":ophiuchus:",code_decimal:"&#9934;",category:"s",emoji_order:"2047"},{name:"twisted_rightwards_arrows",unicode:"1f500",shortname:":twisted_rightwards_arrows:",code_decimal:"&#128256;",category:"s",emoji_order:"2048"},{name:"repeat",unicode:"1f501",shortname:":repeat:",code_decimal:"&#128257;",category:"s",emoji_order:"2049"},{name:"repeat_one",unicode:"1f502",shortname:":repeat_one:",code_decimal:"&#128258;",category:"s",emoji_order:"2050"},{name:"arrow_forward",unicode:"25b6",shortname:":arrow_forward:",code_decimal:"&#9654;",category:"s",emoji_order:"2051"},{name:"fast_forward",unicode:"23e9",shortname:":fast_forward:",code_decimal:"&#9193;",category:"s",emoji_order:"2052"},{name:"black_right_pointing_double_triangle_with_vertical_bar",unicode:"23ed",shortname:":track_next:",code_decimal:"&#9197;",category:"s",emoji_order:"2053"},{name:"black_right_pointing_triangle_with_double_vertical_bar",unicode:"23ef",shortname:":play_pause:",code_decimal:"&#9199;",category:"s",emoji_order:"2054"},{name:"arrow_backward",unicode:"25c0",shortname:":arrow_backward:",code_decimal:"&#9664;",category:"s",emoji_order:"2055"},{name:"rewind",unicode:"23ea",shortname:":rewind:",code_decimal:"&#9194;",category:"s",emoji_order:"2056"},{name:"black_left_pointing_double_triangle_with_vertical_bar",unicode:"23ee",shortname:":track_previous:",code_decimal:"&#9198;",category:"s",emoji_order:"2057"},{name:"arrow_up_small",unicode:"1f53c",shortname:":arrow_up_small:",code_decimal:"&#128316;",category:"s",emoji_order:"2058"},{name:"arrow_double_up",unicode:"23eb",shortname:":arrow_double_up:",code_decimal:"&#9195;",category:"s",emoji_order:"2059"},{name:"arrow_down_small",unicode:"1f53d",shortname:":arrow_down_small:",code_decimal:"&#128317;",category:"s",emoji_order:"2060"},{name:"arrow_double_down",unicode:"23ec",shortname:":arrow_double_down:",code_decimal:"&#9196;",category:"s",emoji_order:"2061"},{name:"double_vertical_bar",unicode:"23f8",shortname:":pause_button:",code_decimal:"&#9208;",category:"s",emoji_order:"2062"},{name:"black_square_for_stop",unicode:"23f9",shortname:":stop_button:",code_decimal:"&#9209;",category:"s",emoji_order:"2063"},{name:"black_circle_for_record",unicode:"23fa",shortname:":record_button:",code_decimal:"&#9210;",category:"s",emoji_order:"2064"},{name:"cinema",unicode:"1f3a6",shortname:":cinema:",code_decimal:"&#127910;",category:"s",emoji_order:"2066"},{name:"low_brightness",unicode:"1f505",shortname:":low_brightness:",code_decimal:"&#128261;",category:"s",emoji_order:"2067"},{name:"high_brightness",unicode:"1f506",shortname:":high_brightness:",code_decimal:"&#128262;",category:"s",emoji_order:"2068"},{name:"signal_strength",unicode:"1f4f6",shortname:":signal_strength:",code_decimal:"&#128246;",category:"s",emoji_order:"2069"},{name:"vibration_mode",unicode:"1f4f3",shortname:":vibration_mode:",code_decimal:"&#128243;",category:"s",emoji_order:"2070"},{name:"mobile_phone_off",unicode:"1f4f4",shortname:":mobile_phone_off:",code_decimal:"&#128244;",category:"s",emoji_order:"2071"},{name:"recycle",unicode:"267b",shortname:":recycle:",code_decimal:"&#9851;",category:"s",emoji_order:"2072"},{name:"name_badge",unicode:"1f4db",shortname:":name_badge:",code_decimal:"&#128219;",category:"s",emoji_order:"2073"},{name:"fleur_de_lis",unicode:"269c",shortname:":fleur-de-lis:",code_decimal:"&#9884;",category:"s",emoji_order:"2074"},{name:"beginner",unicode:"1f530",shortname:":beginner:",code_decimal:"&#128304;",category:"s",emoji_order:"2075"},{name:"trident",unicode:"1f531",shortname:":trident:",code_decimal:"&#128305;",category:"s",emoji_order:"2076"},{name:"o",unicode:"2b55",shortname:":o:",code_decimal:"&#11093;",category:"s",emoji_order:"2077"},{name:"white_check_mark",unicode:"2705",shortname:":white_check_mark:",code_decimal:"&#9989;",category:"s",emoji_order:"2078"},{name:"ballot_box_with_check",unicode:"2611",shortname:":ballot_box_with_check:",code_decimal:"&#9745;",category:"s",emoji_order:"2079"},{name:"heavy_check_mark",unicode:"2714",shortname:":heavy_check_mark:",code_decimal:"&#10004;",category:"s",emoji_order:"2080"},{name:"heavy_multiplication_x",unicode:"2716",shortname:":heavy_multiplication_x:",code_decimal:"&#10006;",category:"s",emoji_order:"2081"},{name:"x",unicode:"274c",shortname:":x:",code_decimal:"&#10060;",category:"s",emoji_order:"2082"},{name:"negative_squared_cross_mark",unicode:"274e",shortname:":negative_squared_cross_mark:",code_decimal:"&#10062;",category:"s",emoji_order:"2083"},{name:"heavy_plus_sign",unicode:"2795",shortname:":heavy_plus_sign:",code_decimal:"&#10133;",category:"s",emoji_order:"2084"},{name:"heavy_minus_sign",unicode:"2796",shortname:":heavy_minus_sign:",code_decimal:"&#10134;",category:"s",emoji_order:"2088"},{name:"heavy_division_sign",unicode:"2797",shortname:":heavy_division_sign:",code_decimal:"&#10135;",category:"s",emoji_order:"2089"},{name:"curly_loop",unicode:"27b0",shortname:":curly_loop:",code_decimal:"&#10160;",category:"s",emoji_order:"2090"},{name:"loop",unicode:"27bf",shortname:":loop:",code_decimal:"&#10175;",category:"s",emoji_order:"2091"},{name:"part_alternation_mark",unicode:"303d",shortname:":part_alternation_mark:",code_decimal:"&#12349;",category:"s",emoji_order:"2092"},{name:"eight_spoked_asterisk",unicode:"2733",shortname:":eight_spoked_asterisk:",code_decimal:"&#10035;",category:"s",emoji_order:"2093"},{name:"eight_pointed_black_star",unicode:"2734",shortname:":eight_pointed_black_star:",code_decimal:"&#10036;",category:"s",emoji_order:"2094"},{name:"sparkle",unicode:"2747",shortname:":sparkle:",code_decimal:"&#10055;",category:"s",emoji_order:"2095"},{name:"bangbang",unicode:"203c",shortname:":bangbang:",code_decimal:"&#8252;",category:"s",emoji_order:"2096"},{name:"interrobang",unicode:"2049",shortname:":interrobang:",code_decimal:"&#8265;",category:"s",emoji_order:"2097"},{name:"question",unicode:"2753",shortname:":question:",code_decimal:"&#10067;",category:"s",emoji_order:"2098"},{name:"grey_question",unicode:"2754",shortname:":grey_question:",code_decimal:"&#10068;",category:"s",emoji_order:"2099"},{name:"grey_exclamation",unicode:"2755",shortname:":grey_exclamation:",code_decimal:"&#10069;",category:"s",emoji_order:"2100"},{name:"exclamation",unicode:"2757",shortname:":exclamation:",code_decimal:"&#10071;",category:"s",emoji_order:"2101"},{name:"wavy_dash",unicode:"3030",shortname:":wavy_dash:",code_decimal:"&#12336;",category:"s",emoji_order:"2102"},{name:"copyright",unicode:"00a9",shortname:":copyright:",code_decimal:"&copy;",category:"s",emoji_order:"2103"},{name:"registered",unicode:"00ae",shortname:":registered:",code_decimal:"&reg;",category:"s",emoji_order:"2104"},{name:"tm",unicode:"2122",shortname:":tm:",code_decimal:"&trade;",category:"s",emoji_order:"2105"},{name:"hash",unicode:"0023-20e3",shortname:":hash:",code_decimal:"#&#8419;",category:"s",emoji_order:"2106"},{name:"keycap_star",unicode:"002a-20e3",shortname:":asterisk:",code_decimal:"*&#8419;",category:"s",emoji_order:"2107"},{name:"zero",unicode:"0030-20e3",shortname:":zero:",code_decimal:"0&#8419;",category:"s",emoji_order:"2108"},{name:"one",unicode:"0031-20e3",shortname:":one:",code_decimal:"1&#8419;",category:"s",emoji_order:"2109"},{name:"two",unicode:"0032-20e3",shortname:":two:",code_decimal:"2&#8419;",category:"s",emoji_order:"2110"},{name:"three",unicode:"0033-20e3",shortname:":three:",code_decimal:"3&#8419;",category:"s",emoji_order:"2111"},{name:"four",unicode:"0034-20e3",shortname:":four:",code_decimal:"4&#8419;",category:"s",emoji_order:"2112"},{name:"five",unicode:"0035-20e3",shortname:":five:",code_decimal:"5&#8419;",category:"s",emoji_order:"2113"},{name:"six",unicode:"0036-20e3",shortname:":six:",code_decimal:"6&#8419;",category:"s",emoji_order:"2114"},{name:"seven",unicode:"0037-20e3",shortname:":seven:",code_decimal:"7&#8419;",category:"s",emoji_order:"2115"},{name:"eight",unicode:"0038-20e3",shortname:":eight:",code_decimal:"8&#8419;",category:"s",emoji_order:"2116"},{name:"nine",unicode:"0039-20e3",shortname:":nine:",code_decimal:"9&#8419;",category:"s",emoji_order:"2117"},{name:"keycap_ten",unicode:"1f51f",shortname:":keycap_ten:",code_decimal:"&#128287;",category:"s",emoji_order:"2118"},{name:"capital_abcd",unicode:"1f520",shortname:":capital_abcd:",code_decimal:"&#128288;",category:"s",emoji_order:"2120"},{name:"abcd",unicode:"1f521",shortname:":abcd:",code_decimal:"&#128289;",category:"s",emoji_order:"2121"},{name:"s",unicode:"1f523",shortname:":s:",code_decimal:"&#128291;",category:"s",emoji_order:"2123"},{name:"abc",unicode:"1f524",shortname:":abc:",code_decimal:"&#128292;",category:"s",emoji_order:"2124"},{name:"a",unicode:"1f170",shortname:":a:",code_decimal:"&#127344;",category:"s",emoji_order:"2125"},{name:"ab",unicode:"1f18e",shortname:":ab:",code_decimal:"&#127374;",category:"s",emoji_order:"2126"},{name:"b",unicode:"1f171",shortname:":b:",code_decimal:"&#127345;",category:"s",emoji_order:"2127"},{name:"cl",unicode:"1f191",shortname:":cl:",code_decimal:"&#127377;",category:"s",emoji_order:"2128"},{name:"cool",unicode:"1f192",shortname:":cool:",code_decimal:"&#127378;",category:"s",emoji_order:"2129"},{name:"free",unicode:"1f193",shortname:":free:",code_decimal:"&#127379;",category:"s",emoji_order:"2130"},{name:"information_source",unicode:"2139",shortname:":information_source:",code_decimal:"&#8505;",category:"s",emoji_order:"2131"},{name:"id",unicode:"1f194",shortname:":id:",code_decimal:"&#127380;",category:"s",emoji_order:"2132"},{name:"m",unicode:"24c2",shortname:":m:",code_decimal:"&#9410;",category:"s",emoji_order:"2133"},{name:"new",unicode:"1f195",shortname:":new:",code_decimal:"&#127381;",category:"s",emoji_order:"2134"},{name:"ng",unicode:"1f196",shortname:":ng:",code_decimal:"&#127382;",category:"s",emoji_order:"2135"},{name:"o2",unicode:"1f17e",shortname:":o2:",code_decimal:"&#127358;",category:"s",emoji_order:"2136"},{name:"ok",unicode:"1f197",shortname:":ok:",code_decimal:"&#127383;",category:"s",emoji_order:"2137"},{name:"parking",unicode:"1f17f",shortname:":parking:",code_decimal:"&#127359;",category:"s",emoji_order:"2138"},{name:"sos",unicode:"1f198",shortname:":sos:",code_decimal:"&#127384;",category:"s",emoji_order:"2139"},{name:"up",unicode:"1f199",shortname:":up:",code_decimal:"&#127385;",category:"s",emoji_order:"2140"},{name:"vs",unicode:"1f19a",shortname:":vs:",code_decimal:"&#127386;",category:"s",emoji_order:"2141"},{name:"koko",unicode:"1f201",shortname:":koko:",code_decimal:"&#127489;",category:"s",emoji_order:"2142"},{name:"sa",unicode:"1f202",shortname:":sa:",code_decimal:"&#127490;",category:"s",emoji_order:"2143"},{name:"u6708",unicode:"1f237",shortname:":u6708:",code_decimal:"&#127543;",category:"s",emoji_order:"2144"},{name:"u6709",unicode:"1f236",shortname:":u6709:",code_decimal:"&#127542;",category:"s",emoji_order:"2145"},{name:"u6307",unicode:"1f22f",shortname:":u6307:",code_decimal:"&#127535;",category:"s",emoji_order:"2146"},{name:"ideograph_advantage",unicode:"1f250",shortname:":ideograph_advantage:",code_decimal:"&#127568;",category:"s",emoji_order:"2147"},{name:"u5272",unicode:"1f239",shortname:":u5272:",code_decimal:"&#127545;",category:"s",emoji_order:"2148"},{name:"u7121",unicode:"1f21a",shortname:":u7121:",code_decimal:"&#127514;",category:"s",emoji_order:"2149"},{name:"u7981",unicode:"1f232",shortname:":u7981:",code_decimal:"&#127538;",category:"s",emoji_order:"2150"},{name:"accept",unicode:"1f251",shortname:":accept:",code_decimal:"&#127569;",category:"s",emoji_order:"2151"},{name:"u7533",unicode:"1f238",shortname:":u7533:",code_decimal:"&#127544;",category:"s",emoji_order:"2152"},{name:"u5408",unicode:"1f234",shortname:":u5408:",code_decimal:"&#127540;",category:"s",emoji_order:"2153"},{name:"u7a7a",unicode:"1f233",shortname:":u7a7a:",code_decimal:"&#127539;",category:"s",emoji_order:"2154"},{name:"congratulations",unicode:"3297",shortname:":congratulations:",code_decimal:"&#12951;",category:"s",emoji_order:"2155"},{name:"secret",unicode:"3299",shortname:":secret:",code_decimal:"&#12953;",category:"s",emoji_order:"2156"},{name:"u55b6",unicode:"1f23a",shortname:":u55b6:",code_decimal:"&#127546;",category:"s",emoji_order:"2157"},{name:"u6e80",unicode:"1f235",shortname:":u6e80:",code_decimal:"&#127541;",category:"s",emoji_order:"2158"},{name:"black_small_square",unicode:"25aa",shortname:":black_small_square:",code_decimal:"&#9642;",category:"s",emoji_order:"2159"},{name:"white_small_square",unicode:"25ab",shortname:":white_small_square:",code_decimal:"&#9643;",category:"s",emoji_order:"2160"},{name:"white_medium_square",unicode:"25fb",shortname:":white_medium_square:",code_decimal:"&#9723;",category:"s",emoji_order:"2161"},{name:"black_medium_square",unicode:"25fc",shortname:":black_medium_square:",code_decimal:"&#9724;",category:"s",emoji_order:"2162"},{name:"white_medium_small_square",unicode:"25fd",shortname:":white_medium_small_square:",code_decimal:"&#9725;",category:"s",emoji_order:"2163"},{name:"black_medium_small_square",unicode:"25fe",shortname:":black_medium_small_square:",code_decimal:"&#9726;",category:"s",emoji_order:"2164"},{name:"black_large_square",unicode:"2b1b",shortname:":black_large_square:",code_decimal:"&#11035;",category:"s",emoji_order:"2165"},{name:"white_large_square",unicode:"2b1c",shortname:":white_large_square:",code_decimal:"&#11036;",category:"s",emoji_order:"2166"},{name:"large_orange_diamond",unicode:"1f536",shortname:":large_orange_diamond:",code_decimal:"&#128310;",category:"s",emoji_order:"2167"},{name:"large_blue_diamond",unicode:"1f537",shortname:":large_blue_diamond:",code_decimal:"&#128311;",category:"s",emoji_order:"2168"},{name:"small_orange_diamond",unicode:"1f538",shortname:":small_orange_diamond:",code_decimal:"&#128312;",category:"s",emoji_order:"2169"},{name:"small_blue_diamond",unicode:"1f539",shortname:":small_blue_diamond:",code_decimal:"&#128313;",category:"s",emoji_order:"2170"},{name:"small_red_triangle",unicode:"1f53a",shortname:":small_red_triangle:",code_decimal:"&#128314;",category:"s",emoji_order:"2171"},{name:"small_red_triangle_down",unicode:"1f53b",shortname:":small_red_triangle_down:",code_decimal:"&#128315;",category:"s",emoji_order:"2172"},{name:"diamond_shape_with_a_dot_inside",unicode:"1f4a0",shortname:":diamond_shape_with_a_dot_inside:",code_decimal:"&#128160;",category:"s",emoji_order:"2173"},{name:"radio_button",unicode:"1f518",shortname:":radio_button:",code_decimal:"&#128280;",category:"s",emoji_order:"2174"},{name:"black_square_button",unicode:"1f532",shortname:":black_square_button:",code_decimal:"&#128306;",category:"s",emoji_order:"2175"},{name:"white_square_button",unicode:"1f533",shortname:":white_square_button:",code_decimal:"&#128307;",category:"s",emoji_order:"2176"},{name:"white_circle",unicode:"26aa",shortname:":white_circle:",code_decimal:"&#9898;",category:"s",emoji_order:"2177"},{name:"black_circle",unicode:"26ab",shortname:":black_circle:",code_decimal:"&#9899;",category:"s",emoji_order:"2178"},{name:"red_circle",unicode:"1f534",shortname:":red_circle:",code_decimal:"&#128308;",category:"s",emoji_order:"2179"},{name:"large_blue_circle",unicode:"1f535",shortname:":blue_circle:",code_decimal:"&#128309;",category:"s",emoji_order:"2180"},{name:"checkered_flag",unicode:"1f3c1",shortname:":checkered_flag:",code_decimal:"&#127937;",category:"t",emoji_order:"2181"},{name:"triangular_flag_on_post",unicode:"1f6a9",shortname:":triangular_flag_on_post:",code_decimal:"&#128681;",category:"o",emoji_order:"2182"},{name:"crossed_flags",unicode:"1f38c",shortname:":crossed_flags:",code_decimal:"&#127884;",category:"o",emoji_order:"2183"},{name:"waving_black_flag",unicode:"1f3f4",shortname:":flag_black:",code_decimal:"&#127988;",category:"o",emoji_order:"2184"},{name:"waving_white_flag",unicode:"1f3f3",shortname:":flag_white:",code_decimal:"&#127987;",category:"o",emoji_order:"2185"},{name:"flag-ac",unicode:"1f1e6-1f1e8",shortname:":flag_ac:",code_decimal:"&#127462;&#127464;",category:"f",emoji_order:"2187"},{name:"flag-ad",unicode:"1f1e6-1f1e9",shortname:":flag_ad:",code_decimal:"&#127462;&#127465;",category:"f",emoji_order:"2188"},{name:"flag-ae",unicode:"1f1e6-1f1ea",shortname:":flag_ae:",code_decimal:"&#127462;&#127466;",category:"f",emoji_order:"2189"},{name:"flag-af",unicode:"1f1e6-1f1eb",shortname:":flag_af:",code_decimal:"&#127462;&#127467;",category:"f",emoji_order:"2190"},{name:"flag-ag",unicode:"1f1e6-1f1ec",shortname:":flag_ag:",code_decimal:"&#127462;&#127468;",category:"f",emoji_order:"2191"},{name:"flag-ai",unicode:"1f1e6-1f1ee",shortname:":flag_ai:",code_decimal:"&#127462;&#127470;",category:"f",emoji_order:"2192"},{name:"flag-al",unicode:"1f1e6-1f1f1",shortname:":flag_al:",code_decimal:"&#127462;&#127473;",category:"f",emoji_order:"2193"},{name:"flag-am",unicode:"1f1e6-1f1f2",shortname:":flag_am:",code_decimal:"&#127462;&#127474;",category:"f",emoji_order:"2194"},{name:"flag-ao",unicode:"1f1e6-1f1f4",shortname:":flag-ao:",code_decimal:"&#127462;&#127476;",category:"f",emoji_order:"2195"},{name:"flag-aq",unicode:"1f1e6-1f1f6",shortname:":flag-aq:",code_decimal:"&#127462;&#127478;",category:"f",emoji_order:"2196"},{name:"flag-ar",unicode:"1f1e6-1f1f7",shortname:":flag-ar:",code_decimal:"&#127462;&#127479;",category:"f",emoji_order:"2197"},{name:"flag-as",unicode:"1f1e6-1f1f8",shortname:":flag-as:",code_decimal:"&#127462;&#127480;",category:"f",emoji_order:"2198"},{name:"flag-at",unicode:"1f1e6-1f1f9",shortname:":flag-at:",code_decimal:"&#127462;&#127481;",category:"f",emoji_order:"2199"},{name:"flag-au",unicode:"1f1e6-1f1fa",shortname:":flag-au:",code_decimal:"&#127462;&#127482;",category:"f",emoji_order:"2200"},{name:"flag-aw",unicode:"1f1e6-1f1fc",shortname:":flag-aw:",code_decimal:"&#127462;&#127484;",category:"f",emoji_order:"2201"},{name:"flag-ax",unicode:"1f1e6-1f1fd",shortname:":flag-ax:",code_decimal:"&#127462;&#127485;",category:"f",emoji_order:"2202"},{name:"flag-az",unicode:"1f1e6-1f1ff",shortname:":flag-az:",code_decimal:"&#127462;&#127487;",category:"f",emoji_order:"2203"},{name:"flag-ba",unicode:"1f1e7-1f1e6",shortname:":flag-ba:",code_decimal:"&#127463;&#127462;",category:"f",emoji_order:"2204"},{name:"flag-bb",unicode:"1f1e7-1f1e7",shortname:":flag-bb:",code_decimal:"&#127463;&#127463;",category:"f",emoji_order:"2205"},{name:"flag-bd",unicode:"1f1e7-1f1e9",shortname:":flag-bd:",code_decimal:"&#127463;&#127465;",category:"f",emoji_order:"2206"},{name:"flag-be",unicode:"1f1e7-1f1ea",shortname:":flag-be:",code_decimal:"&#127463;&#127466;",category:"f",emoji_order:"2207"},{name:"flag-bf",unicode:"1f1e7-1f1eb",shortname:":flag-bf:",code_decimal:"&#127463;&#127467;",category:"f",emoji_order:"2208"},{name:"flag-bg",unicode:"1f1e7-1f1ec",shortname:":flag-bg:",code_decimal:"&#127463;&#127468;",category:"f",emoji_order:"2209"},{name:"flag-bh",unicode:"1f1e7-1f1ed",shortname:":flag-bh:",code_decimal:"&#127463;&#127469;",category:"f",emoji_order:"2210"},{name:"flag-bi",unicode:"1f1e7-1f1ee",shortname:":flag-bi:",code_decimal:"&#127463;&#127470;",category:"f",emoji_order:"2211"},{name:"flag-bj",unicode:"1f1e7-1f1ef",shortname:":flag-bj:",code_decimal:"&#127463;&#127471;",category:"f",emoji_order:"2212"},{name:"flag-bl",unicode:"1f1e7-1f1f1",shortname:":flag-bl:",code_decimal:"&#127463;&#127473;",category:"f",emoji_order:"2213"},{name:"flag-bm",unicode:"1f1e7-1f1f2",shortname:":flag-bm:",code_decimal:"&#127463;&#127474;",category:"f",emoji_order:"2214"},{name:"flag-bn",unicode:"1f1e7-1f1f3",shortname:":flag-bn:",code_decimal:"&#127463;&#127475;",category:"f",emoji_order:"2215"},{name:"flag-bo",unicode:"1f1e7-1f1f4",shortname:":flag-bo:",code_decimal:"&#127463;&#127476;",category:"f",emoji_order:"2216"},{name:"flag-bq",unicode:"1f1e7-1f1f6",shortname:":flag-bq:",code_decimal:"&#127463;&#127478;",category:"f",emoji_order:"2217"},{name:"flag-br",unicode:"1f1e7-1f1f7",shortname:":flag-br:",code_decimal:"&#127463;&#127479;",category:"f",emoji_order:"2218"},{name:"flag-bs",unicode:"1f1e7-1f1f8",shortname:":flag-bs:",code_decimal:"&#127463;&#127480;",category:"f",emoji_order:"2219"},{name:"flag-bt",unicode:"1f1e7-1f1f9",shortname:":flag-bt:",code_decimal:"&#127463;&#127481;",category:"f",emoji_order:"2220"},{name:"flag-bv",unicode:"1f1e7-1f1fb",shortname:":flag-bv:",code_decimal:"&#127463;&#127483;",category:"f",emoji_order:"2221"},{name:"flag-bw",unicode:"1f1e7-1f1fc",shortname:":flag-bw:",code_decimal:"&#127463;&#127484;",category:"f",emoji_order:"2222"},{name:"flag-by",unicode:"1f1e7-1f1fe",shortname:":flag-by:",code_decimal:"&#127463;&#127486;",category:"f",emoji_order:"2223"},{name:"flag-bz",unicode:"1f1e7-1f1ff",shortname:":flag-bz:",code_decimal:"&#127463;&#127487;",category:"f",emoji_order:"2224"},{name:"flag-ca",unicode:"1f1e8-1f1e6",shortname:":flag-ca:",code_decimal:"&#127464;&#127462;",category:"f",emoji_order:"2225"},{name:"flag-cc",unicode:"1f1e8-1f1e8",shortname:":flag-cc:",code_decimal:"&#127464;&#127464;",category:"f",emoji_order:"2226"},{name:"flag-cd",unicode:"1f1e8-1f1e9",shortname:":flag-cd:",code_decimal:"&#127464;&#127465;",category:"f",emoji_order:"2227"},{name:"flag-cf",unicode:"1f1e8-1f1eb",shortname:":flag-cf:",code_decimal:"&#127464;&#127467;",category:"f",emoji_order:"2228"},{name:"flag-cg",unicode:"1f1e8-1f1ec",shortname:":flag-cg:",code_decimal:"&#127464;&#127468;",category:"f",emoji_order:"2229"},{name:"flag-ch",unicode:"1f1e8-1f1ed",shortname:":flag-ch:",code_decimal:"&#127464;&#127469;",category:"f",emoji_order:"2230"},{name:"flag-ci",unicode:"1f1e8-1f1ee",shortname:":flag-ci:",code_decimal:"&#127464;&#127470;",category:"f",emoji_order:"2231"},{name:"flag-ck",unicode:"1f1e8-1f1f0",shortname:":flag-ck:",code_decimal:"&#127464;&#127472;",category:"f",emoji_order:"2232"},{name:"flag-cl",unicode:"1f1e8-1f1f1",shortname:":flag-cl:",code_decimal:"&#127464;&#127473;",category:"f",emoji_order:"2233"},{name:"flag-cm",unicode:"1f1e8-1f1f2",shortname:":flag-cm:",code_decimal:"&#127464;&#127474;",category:"f",emoji_order:"2234"},{name:"flag-cn",unicode:"1f1e8-1f1f3",shortname:":flag-cn:",code_decimal:"&#127464;&#127475;",category:"f",emoji_order:"2235"},{name:"flag-co",unicode:"1f1e8-1f1f4",shortname:":flag-co:",code_decimal:"&#127464;&#127476;",category:"f",emoji_order:"2236"},{name:"flag-cp",unicode:"1f1e8-1f1f5",shortname:":flag-cp:",code_decimal:"&#127464;&#127477;",category:"f",emoji_order:"2237"},{name:"flag-cr",unicode:"1f1e8-1f1f7",shortname:":flag-cr:",code_decimal:"&#127464;&#127479;",category:"f",emoji_order:"2238"},{name:"flag-cu",unicode:"1f1e8-1f1fa",shortname:":flag-cu:",code_decimal:"&#127464;&#127482;",category:"f",emoji_order:"2239"},{name:"flag-cv",unicode:"1f1e8-1f1fb",shortname:":flag-cv:",code_decimal:"&#127464;&#127483;",category:"f",emoji_order:"2240"},{name:"flag-cw",unicode:"1f1e8-1f1fc",shortname:":flag-cw:",code_decimal:"&#127464;&#127484;",category:"f",emoji_order:"2241"},{name:"flag-cx",unicode:"1f1e8-1f1fd",shortname:":flag-cx:",code_decimal:"&#127464;&#127485;",category:"f",emoji_order:"2242"},{name:"flag-cy",unicode:"1f1e8-1f1fe",shortname:":flag-cy:",code_decimal:"&#127464;&#127486;",category:"f",emoji_order:"2243"},{name:"flag-cz",unicode:"1f1e8-1f1ff",shortname:":flag-cz:",code_decimal:"&#127464;&#127487;",category:"f",emoji_order:"2244"},{name:"flag-de",unicode:"1f1e9-1f1ea",shortname:":flag-de:",code_decimal:"&#127465;&#127466;",category:"f",emoji_order:"2245"},{name:"flag-dg",unicode:"1f1e9-1f1ec",shortname:":flag-dg:",code_decimal:"&#127465;&#127468;",category:"f",emoji_order:"2246"},{name:"flag-dj",unicode:"1f1e9-1f1ef",shortname:":flag-dj:",code_decimal:"&#127465;&#127471;",category:"f",emoji_order:"2247"},{name:"flag-dk",unicode:"1f1e9-1f1f0",shortname:":flag-dk:",code_decimal:"&#127465;&#127472;",category:"f",emoji_order:"2248"},{name:"flag-dm",unicode:"1f1e9-1f1f2",shortname:":flag-dm:",code_decimal:"&#127465;&#127474;",category:"f",emoji_order:"2249"},{name:"flag-do",unicode:"1f1e9-1f1f4",shortname:":flag-do:",code_decimal:"&#127465;&#127476;",category:"f",emoji_order:"2250"},{name:"flag-dz",unicode:"1f1e9-1f1ff",shortname:":flag-dz:",code_decimal:"&#127465;&#127487;",category:"f",emoji_order:"2251"},{name:"flag-ea",unicode:"1f1ea-1f1e6",shortname:":flag-ea:",code_decimal:"&#127466;&#127462;",category:"f",emoji_order:"2252"},{name:"flag-ec",unicode:"1f1ea-1f1e8",shortname:":flag-ec:",code_decimal:"&#127466;&#127464;",category:"f",emoji_order:"2253"},{name:"flag-ee",unicode:"1f1ea-1f1ea",shortname:":flag-ee:",code_decimal:"&#127466;&#127466;",category:"f",emoji_order:"2254"},{name:"flag-eg",unicode:"1f1ea-1f1ec",shortname:":flag-eg:",code_decimal:"&#127466;&#127468;",category:"f",emoji_order:"2255"},{name:"flag-eh",unicode:"1f1ea-1f1ed",shortname:":flag-eh:",code_decimal:"&#127466;&#127469;",category:"f",emoji_order:"2256"},{name:"flag-er",unicode:"1f1ea-1f1f7",shortname:":flag-er:",code_decimal:"&#127466;&#127479;",category:"f",emoji_order:"2257"},{name:"flag-es",unicode:"1f1ea-1f1f8",shortname:":flag-es:",code_decimal:"&#127466;&#127480;",category:"f",emoji_order:"2258"},{name:"flag-et",unicode:"1f1ea-1f1f9",shortname:":flag-et:",code_decimal:"&#127466;&#127481;",category:"f",emoji_order:"2259"},{name:"flag-eu",unicode:"1f1ea-1f1fa",shortname:":flag-eu:",code_decimal:"&#127466;&#127482;",category:"f",emoji_order:"2260"},{name:"flag-fi",unicode:"1f1eb-1f1ee",shortname:":flag-fi:",code_decimal:"&#127467;&#127470;",category:"f",emoji_order:"2261"},{name:"flag-fj",unicode:"1f1eb-1f1ef",shortname:":flag-fj:",code_decimal:"&#127467;&#127471;",category:"f",emoji_order:"2262"},{name:"flag-fk",unicode:"1f1eb-1f1f0",shortname:":flag-fk:",code_decimal:"&#127467;&#127472;",category:"f",emoji_order:"2263"},{name:"flag-fm",unicode:"1f1eb-1f1f2",shortname:":flag-fm:",code_decimal:"&#127467;&#127474;",category:"f",emoji_order:"2264"},{name:"flag-fo",unicode:"1f1eb-1f1f4",shortname:":flag-fo:",code_decimal:"&#127467;&#127476;",category:"f",emoji_order:"2265"},{name:"flag-fr",unicode:"1f1eb-1f1f7",shortname:":flag-fr:",code_decimal:"&#127467;&#127479;",category:"f",emoji_order:"2266"},{name:"flag-ga",unicode:"1f1ec-1f1e6",shortname:":flag-ga:",code_decimal:"&#127468;&#127462;",category:"f",emoji_order:"2267"},{name:"flag-gb",unicode:"1f1ec-1f1e7",shortname:":flag-gb:",code_decimal:"&#127468;&#127463;",category:"f",emoji_order:"2268"},{name:"flag-gd",unicode:"1f1ec-1f1e9",shortname:":flag-gd:",code_decimal:"&#127468;&#127465;",category:"f",emoji_order:"2269"},{name:"flag-ge",unicode:"1f1ec-1f1ea",shortname:":flag-ge:",code_decimal:"&#127468;&#127466;",category:"f",emoji_order:"2270"},{name:"flag-gf",unicode:"1f1ec-1f1eb",shortname:":flag-gf:",code_decimal:"&#127468;&#127467;",category:"f",emoji_order:"2271"},{name:"flag-gg",unicode:"1f1ec-1f1ec",shortname:":flag-gg:",code_decimal:"&#127468;&#127468;",category:"f",emoji_order:"2272"},{name:"flag-gh",unicode:"1f1ec-1f1ed",shortname:":flag-gh:",code_decimal:"&#127468;&#127469;",category:"f",emoji_order:"2273"},{name:"flag-gi",unicode:"1f1ec-1f1ee",shortname:":flag-gi:",code_decimal:"&#127468;&#127470;",category:"f",emoji_order:"2274"},{name:"flag-gl",unicode:"1f1ec-1f1f1",shortname:":flag-gl:",code_decimal:"&#127468;&#127473;",category:"f",emoji_order:"2275"},{name:"flag-gm",unicode:"1f1ec-1f1f2",shortname:":flag-gm:",code_decimal:"&#127468;&#127474;",category:"f",emoji_order:"2276"},{name:"flag-gn",unicode:"1f1ec-1f1f3",shortname:":flag-gn:",code_decimal:"&#127468;&#127475;",category:"f",emoji_order:"2277"},{name:"flag-gp",unicode:"1f1ec-1f1f5",shortname:":flag-gp:",code_decimal:"&#127468;&#127477;",category:"f",emoji_order:"2278"},{name:"flag-gq",unicode:"1f1ec-1f1f6",shortname:":flag-gq:",code_decimal:"&#127468;&#127478;",category:"f",emoji_order:"2279"},{name:"flag-gr",unicode:"1f1ec-1f1f7",shortname:":flag-gr:",code_decimal:"&#127468;&#127479;",category:"f",emoji_order:"2280"},{name:"flag-gs",unicode:"1f1ec-1f1f8",shortname:":flag-gs:",code_decimal:"&#127468;&#127480;",category:"f",emoji_order:"2281"},{name:"flag-gt",unicode:"1f1ec-1f1f9",shortname:":flag-gt:",code_decimal:"&#127468;&#127481;",category:"f",emoji_order:"2282"},{name:"flag-gu",unicode:"1f1ec-1f1fa",shortname:":flag-gu:",code_decimal:"&#127468;&#127482;",category:"f",emoji_order:"2283"},{name:"flag-gw",unicode:"1f1ec-1f1fc",shortname:":flag-gw:",code_decimal:"&#127468;&#127484;",category:"f",emoji_order:"2284"},{name:"flag-gy",unicode:"1f1ec-1f1fe",shortname:":flag-gy:",code_decimal:"&#127468;&#127486;",category:"f",emoji_order:"2285"},{name:"flag-hk",unicode:"1f1ed-1f1f0",shortname:":flag-hk:",code_decimal:"&#127469;&#127472;",category:"f",emoji_order:"2286"},{name:"flag-hm",unicode:"1f1ed-1f1f2",shortname:":flag-hm:",code_decimal:"&#127469;&#127474;",category:"f",emoji_order:"2287"},{name:"flag-hn",unicode:"1f1ed-1f1f3",shortname:":flag-hn:",code_decimal:"&#127469;&#127475;",category:"f",emoji_order:"2288"},{name:"flag-hr",unicode:"1f1ed-1f1f7",shortname:":flag-hr:",code_decimal:"&#127469;&#127479;",category:"f",emoji_order:"2289"},{name:"flag-ht",unicode:"1f1ed-1f1f9",shortname:":flag-ht:",code_decimal:"&#127469;&#127481;",category:"f",emoji_order:"2290"},{name:"flag-hu",unicode:"1f1ed-1f1fa",shortname:":flag-hu:",code_decimal:"&#127469;&#127482;",category:"f",emoji_order:"2291"},{name:"flag-ic",unicode:"1f1ee-1f1e8",shortname:":flag-ic:",code_decimal:"&#127470;&#127464;",category:"f",emoji_order:"2292"},{name:"flag-id",unicode:"1f1ee-1f1e9",shortname:":flag-id:",code_decimal:"&#127470;&#127465;",category:"f",emoji_order:"2293"},{name:"flag-ie",unicode:"1f1ee-1f1ea",shortname:":flag-ie:",code_decimal:"&#127470;&#127466;",category:"f",emoji_order:"2294"},{name:"flag-il",unicode:"1f1ee-1f1f1",shortname:":flag-il:",code_decimal:"&#127470;&#127473;",category:"f",emoji_order:"2295"},{name:"flag-im",unicode:"1f1ee-1f1f2",shortname:":flag-im:",code_decimal:"&#127470;&#127474;",category:"f",emoji_order:"2296"},{name:"flag-in",unicode:"1f1ee-1f1f3",shortname:":flag-in:",code_decimal:"&#127470;&#127475;",category:"f",emoji_order:"2297"},{name:"flag-io",unicode:"1f1ee-1f1f4",shortname:":flag-io:",code_decimal:"&#127470;&#127476;",category:"f",emoji_order:"2298"},{name:"flag-iq",unicode:"1f1ee-1f1f6",shortname:":flag-iq:",code_decimal:"&#127470;&#127478;",category:"f",emoji_order:"2299"},{name:"flag-ir",unicode:"1f1ee-1f1f7",shortname:":flag-ir:",code_decimal:"&#127470;&#127479;",category:"f",emoji_order:"2300"},{name:"flag-is",unicode:"1f1ee-1f1f8",shortname:":flag-is:",code_decimal:"&#127470;&#127480;",category:"f",emoji_order:"2301"},{name:"flag-it",unicode:"1f1ee-1f1f9",shortname:":flag-it:",code_decimal:"&#127470;&#127481;",category:"f",emoji_order:"2302"},{name:"flag-je",unicode:"1f1ef-1f1ea",shortname:":flag-je:",code_decimal:"&#127471;&#127466;",category:"f",emoji_order:"2303"},{name:"flag-jm",unicode:"1f1ef-1f1f2",shortname:":flag-jm:",code_decimal:"&#127471;&#127474;",category:"f",emoji_order:"2304"},{name:"flag-jo",unicode:"1f1ef-1f1f4",shortname:":flag-jo:",code_decimal:"&#127471;&#127476;",category:"f",emoji_order:"2305"},{name:"flag-jp",unicode:"1f1ef-1f1f5",shortname:":flag-jp:",code_decimal:"&#127471;&#127477;",category:"f",emoji_order:"2306"},{name:"flag-ke",unicode:"1f1f0-1f1ea",shortname:":flag-ke:",code_decimal:"&#127472;&#127466;",category:"f",emoji_order:"2307"},{name:"flag-kg",unicode:"1f1f0-1f1ec",shortname:":flag-kg:",code_decimal:"&#127472;&#127468;",category:"f",emoji_order:"2308"},{name:"flag-kh",unicode:"1f1f0-1f1ed",shortname:":flag-kh:",code_decimal:"&#127472;&#127469;",category:"f",emoji_order:"2309"},{name:"flag-ki",unicode:"1f1f0-1f1ee",shortname:":flag-ki:",code_decimal:"&#127472;&#127470;",category:"f",emoji_order:"2310"},{name:"flag-km",unicode:"1f1f0-1f1f2",shortname:":flag-km:",code_decimal:"&#127472;&#127474;",category:"f",emoji_order:"2311"},{name:"flag-kn",unicode:"1f1f0-1f1f3",shortname:":flag-kn:",code_decimal:"&#127472;&#127475;",category:"f",emoji_order:"2312"},{name:"flag-kp",unicode:"1f1f0-1f1f5",shortname:":flag-kp:",code_decimal:"&#127472;&#127477;",category:"f",emoji_order:"2313"},{name:"flag-kr",unicode:"1f1f0-1f1f7",shortname:":flag-kr:",code_decimal:"&#127472;&#127479;",category:"f",emoji_order:"2314"},{name:"flag-kw",unicode:"1f1f0-1f1fc",shortname:":flag-kw:",code_decimal:"&#127472;&#127484;",category:"f",emoji_order:"2315"},{name:"flag-ky",unicode:"1f1f0-1f1fe",shortname:":flag-ky:",code_decimal:"&#127472;&#127486;",category:"f",emoji_order:"2316"},{name:"flag-kz",unicode:"1f1f0-1f1ff",shortname:":flag-kz:",code_decimal:"&#127472;&#127487;",category:"f",emoji_order:"2317"},{name:"flag-la",unicode:"1f1f1-1f1e6",shortname:":flag-la:",code_decimal:"&#127473;&#127462;",category:"f",emoji_order:"2318"},{name:"flag-lb",unicode:"1f1f1-1f1e7",shortname:":flag-lb:",code_decimal:"&#127473;&#127463;",category:"f",emoji_order:"2319"},{name:"flag-lc",unicode:"1f1f1-1f1e8",shortname:":flag-lc:",code_decimal:"&#127473;&#127464;",category:"f",emoji_order:"2320"},{name:"flag-li",unicode:"1f1f1-1f1ee",shortname:":flag-li:",code_decimal:"&#127473;&#127470;",category:"f",emoji_order:"2321"},{name:"flag-lk",unicode:"1f1f1-1f1f0",shortname:":flag-lk:",code_decimal:"&#127473;&#127472;",category:"f",emoji_order:"2322"},{name:"flag-lr",unicode:"1f1f1-1f1f7",shortname:":flag-lr:",code_decimal:"&#127473;&#127479;",category:"f",emoji_order:"2323"},{name:"flag-ls",unicode:"1f1f1-1f1f8",shortname:":flag-ls:",code_decimal:"&#127473;&#127480;",category:"f",emoji_order:"2324"},{name:"flag-lt",unicode:"1f1f1-1f1f9",shortname:":flag-lt:",code_decimal:"&#127473;&#127481;",category:"f",emoji_order:"2325"},{name:"flag-lu",unicode:"1f1f1-1f1fa",shortname:":flag-lu:",code_decimal:"&#127473;&#127482;",category:"f",emoji_order:"2326"},{name:"flag-lv",unicode:"1f1f1-1f1fb",shortname:":flag-lv:",code_decimal:"&#127473;&#127483;",category:"f",emoji_order:"2327"},{name:"flag-ly",unicode:"1f1f1-1f1fe",shortname:":flag-ly:",code_decimal:"&#127473;&#127486;",category:"f",emoji_order:"2328"},{name:"flag-ma",unicode:"1f1f2-1f1e6",shortname:":flag-ma:",code_decimal:"&#127474;&#127462;",category:"f",emoji_order:"2329"},{name:"flag-mc",unicode:"1f1f2-1f1e8",shortname:":flag-mc:",code_decimal:"&#127474;&#127464;",category:"f",emoji_order:"2330"},{name:"flag-md",unicode:"1f1f2-1f1e9",shortname:":flag-md:",code_decimal:"&#127474;&#127465;",category:"f",emoji_order:"2331"},{name:"flag-me",unicode:"1f1f2-1f1ea",shortname:":flag-me:",code_decimal:"&#127474;&#127466;",category:"f",emoji_order:"2332"},{name:"flag-mf",unicode:"1f1f2-1f1eb",shortname:":flag-mf:",code_decimal:"&#127474;&#127467;",category:"f",emoji_order:"2333"},{name:"flag-mg",unicode:"1f1f2-1f1ec",shortname:":flag-mg:",code_decimal:"&#127474;&#127468;",category:"f",emoji_order:"2334"},{name:"flag-mh",unicode:"1f1f2-1f1ed",shortname:":flag-mh:",code_decimal:"&#127474;&#127469;",category:"f",emoji_order:"2335"},{name:"flag-mk",unicode:"1f1f2-1f1f0",shortname:":flag-mk:",code_decimal:"&#127474;&#127472;",category:"f",emoji_order:"2336"},{name:"flag-ml",unicode:"1f1f2-1f1f1",shortname:":flag-ml:",code_decimal:"&#127474;&#127473;",category:"f",emoji_order:"2337"},{name:"flag-mm",unicode:"1f1f2-1f1f2",shortname:":flag-mm:",code_decimal:"&#127474;&#127474;",category:"f",emoji_order:"2338"},{name:"flag-mn",unicode:"1f1f2-1f1f3",shortname:":flag-mn:",code_decimal:"&#127474;&#127475;",category:"f",emoji_order:"2339"},{name:"flag-mo",unicode:"1f1f2-1f1f4",shortname:":flag-mo:",code_decimal:"&#127474;&#127476;",category:"f",emoji_order:"2340"},{name:"flag-mp",unicode:"1f1f2-1f1f5",shortname:":flag-mp:",code_decimal:"&#127474;&#127477;",category:"f",emoji_order:"2341"},{name:"flag-mq",unicode:"1f1f2-1f1f6",shortname:":flag-mq:",code_decimal:"&#127474;&#127478;",category:"f",emoji_order:"2342"},{name:"flag-mr",unicode:"1f1f2-1f1f7",shortname:":flag-mr:",code_decimal:"&#127474;&#127479;",category:"f",emoji_order:"2343"},{name:"flag-ms",unicode:"1f1f2-1f1f8",shortname:":flag-ms:",code_decimal:"&#127474;&#127480;",category:"f",emoji_order:"2344"},{name:"flag-mt",unicode:"1f1f2-1f1f9",shortname:":flag-mt:",code_decimal:"&#127474;&#127481;",category:"f",emoji_order:"2345"},{name:"flag-mu",unicode:"1f1f2-1f1fa",shortname:":flag-mu:",code_decimal:"&#127474;&#127482;",category:"f",emoji_order:"2346"},{name:"flag-mv",unicode:"1f1f2-1f1fb",shortname:":flag-mv:",code_decimal:"&#127474;&#127483;",category:"f",emoji_order:"2347"},{name:"flag-mw",unicode:"1f1f2-1f1fc",shortname:":flag-mw:",code_decimal:"&#127474;&#127484;",category:"f",emoji_order:"2348"},{name:"flag-mx",unicode:"1f1f2-1f1fd",shortname:":flag-mx:",code_decimal:"&#127474;&#127485;",category:"f",emoji_order:"2349"},{name:"flag-my",unicode:"1f1f2-1f1fe",shortname:":flag-my:",code_decimal:"&#127474;&#127486;",category:"f",emoji_order:"2350"},{name:"flag-mz",unicode:"1f1f2-1f1ff",shortname:":flag-mz:",code_decimal:"&#127474;&#127487;",category:"f",emoji_order:"2351"},{name:"flag-na",unicode:"1f1f3-1f1e6",shortname:":flag-na:",code_decimal:"&#127475;&#127462;",category:"f",emoji_order:"2352"},{name:"flag-nc",unicode:"1f1f3-1f1e8",shortname:":flag-nc:",code_decimal:"&#127475;&#127464;",category:"f",emoji_order:"2353"},{name:"flag-ne",unicode:"1f1f3-1f1ea",shortname:":flag-ne:",code_decimal:"&#127475;&#127466;",category:"f",emoji_order:"2354"},{name:"flag-nf",unicode:"1f1f3-1f1eb",shortname:":flag-nf:",code_decimal:"&#127475;&#127467;",category:"f",emoji_order:"2355"},{name:"flag-ng",unicode:"1f1f3-1f1ec",shortname:":flag-ng:",code_decimal:"&#127475;&#127468;",category:"f",emoji_order:"2356"},{name:"flag-ni",unicode:"1f1f3-1f1ee",shortname:":flag-ni:",code_decimal:"&#127475;&#127470;",category:"f",emoji_order:"2357"},{name:"flag-nl",unicode:"1f1f3-1f1f1",shortname:":flag-nl:",code_decimal:"&#127475;&#127473;",category:"f",emoji_order:"2358"},{name:"flag-no",unicode:"1f1f3-1f1f4",shortname:":flag-no:",code_decimal:"&#127475;&#127476;",category:"f",emoji_order:"2359"},{name:"flag-np",unicode:"1f1f3-1f1f5",shortname:":flag-np:",code_decimal:"&#127475;&#127477;",category:"f",emoji_order:"2360"},{name:"flag-nr",unicode:"1f1f3-1f1f7",shortname:":flag-nr:",code_decimal:"&#127475;&#127479;",category:"f",emoji_order:"2361"},{name:"flag-nu",unicode:"1f1f3-1f1fa",shortname:":flag-nu:",code_decimal:"&#127475;&#127482;",category:"f",emoji_order:"2362"},{name:"flag-nz",unicode:"1f1f3-1f1ff",shortname:":flag-nz:",code_decimal:"&#127475;&#127487;",category:"f",emoji_order:"2363"},{name:"flag-om",unicode:"1f1f4-1f1f2",shortname:":flag-om:",code_decimal:"&#127476;&#127474;",category:"f",emoji_order:"2364"},{name:"flag-pa",unicode:"1f1f5-1f1e6",shortname:":flag-pa:",code_decimal:"&#127477;&#127462;",category:"f",emoji_order:"2365"},{name:"flag-pe",unicode:"1f1f5-1f1ea",shortname:":flag-pe:",code_decimal:"&#127477;&#127466;",category:"f",emoji_order:"2366"},{name:"flag-pf",unicode:"1f1f5-1f1eb",shortname:":flag-pf:",code_decimal:"&#127477;&#127467;",category:"f",emoji_order:"2367"},{name:"flag-pg",unicode:"1f1f5-1f1ec",shortname:":flag-pg:",code_decimal:"&#127477;&#127468;",category:"f",emoji_order:"2368"},{name:"flag-ph",unicode:"1f1f5-1f1ed",shortname:":flag-ph:",code_decimal:"&#127477;&#127469;",category:"f",emoji_order:"2369"},{name:"flag-pk",unicode:"1f1f5-1f1f0",shortname:":flag-pk:",code_decimal:"&#127477;&#127472;",category:"f",emoji_order:"2370"},{name:"flag-pl",unicode:"1f1f5-1f1f1",shortname:":flag-pl:",code_decimal:"&#127477;&#127473;",category:"f",emoji_order:"2371"},{name:"flag-pm",unicode:"1f1f5-1f1f2",shortname:":flag-pm:",code_decimal:"&#127477;&#127474;",category:"f",emoji_order:"2372"},{name:"flag-pn",unicode:"1f1f5-1f1f3",shortname:":flag-pn:",code_decimal:"&#127477;&#127475;",category:"f",emoji_order:"2373"},{name:"flag-pr",unicode:"1f1f5-1f1f7",shortname:":flag-pr:",code_decimal:"&#127477;&#127479;",category:"f",emoji_order:"2374"},{name:"flag-ps",unicode:"1f1f5-1f1f8",shortname:":flag-ps:",code_decimal:"&#127477;&#127480;",category:"f",emoji_order:"2375"},{name:"flag-pt",unicode:"1f1f5-1f1f9",shortname:":flag-pt:",code_decimal:"&#127477;&#127481;",category:"f",emoji_order:"2376"},{name:"flag-pw",unicode:"1f1f5-1f1fc",shortname:":flag-pw:",code_decimal:"&#127477;&#127484;",category:"f",emoji_order:"2377"},{name:"flag-py",unicode:"1f1f5-1f1fe",shortname:":flag-py:",code_decimal:"&#127477;&#127486;",category:"f",emoji_order:"2378"},{name:"flag-qa",unicode:"1f1f6-1f1e6",shortname:":flag-qa:",code_decimal:"&#127478;&#127462;",category:"f",emoji_order:"2379"},{name:"flag-re",unicode:"1f1f7-1f1ea",shortname:":flag-re:",code_decimal:"&#127479;&#127466;",category:"f",emoji_order:"2380"},{name:"flag-ro",unicode:"1f1f7-1f1f4",shortname:":flag-ro:",code_decimal:"&#127479;&#127476;",category:"f",emoji_order:"2381"},{name:"flag-rs",unicode:"1f1f7-1f1f8",shortname:":flag-rs:",code_decimal:"&#127479;&#127480;",category:"f",emoji_order:"2382"},{name:"flag-ru",unicode:"1f1f7-1f1fa",shortname:":flag-ru:",code_decimal:"&#127479;&#127482;",category:"f",emoji_order:"2383"},{name:"flag-rw",unicode:"1f1f7-1f1fc",shortname:":flag-rw:",code_decimal:"&#127479;&#127484;",category:"f",emoji_order:"2384"},{name:"flag-sa",unicode:"1f1f8-1f1e6",shortname:":flag-sa:",code_decimal:"&#127480;&#127462;",category:"f",emoji_order:"2385"},{name:"flag-sb",unicode:"1f1f8-1f1e7",shortname:":flag-sb:",code_decimal:"&#127480;&#127463;",category:"f",emoji_order:"2386"},{name:"flag-sc",unicode:"1f1f8-1f1e8",shortname:":flag-sc:",code_decimal:"&#127480;&#127464;",category:"f",emoji_order:"2387"},{name:"flag-sd",unicode:"1f1f8-1f1e9",shortname:":flag-sd:",code_decimal:"&#127480;&#127465;",category:"f",emoji_order:"2388"},{name:"flag-se",unicode:"1f1f8-1f1ea",shortname:":flag-se:",code_decimal:"&#127480;&#127466;",category:"f",emoji_order:"2389"},{name:"flag-sg",unicode:"1f1f8-1f1ec",shortname:":flag-sg:",code_decimal:"&#127480;&#127468;",category:"f",emoji_order:"2390"},{name:"flag-sh",unicode:"1f1f8-1f1ed",shortname:":flag-sh:",code_decimal:"&#127480;&#127469;",category:"f",emoji_order:"2391"},{name:"flag-si",unicode:"1f1f8-1f1ee",shortname:":flag-si:",code_decimal:"&#127480;&#127470;",category:"f",emoji_order:"2392"},{name:"flag-sj",unicode:"1f1f8-1f1ef",shortname:":flag-sj:",code_decimal:"&#127480;&#127471;",category:"f",emoji_order:"2393"},{name:"flag-sk",unicode:"1f1f8-1f1f0",shortname:":flag-sk:",code_decimal:"&#127480;&#127472;",category:"f",emoji_order:"2394"},{name:"flag-sl",unicode:"1f1f8-1f1f1",shortname:":flag-sl:",code_decimal:"&#127480;&#127473;",category:"f",emoji_order:"2395"},{name:"flag-sm",unicode:"1f1f8-1f1f2",shortname:":flag-sm:",code_decimal:"&#127480;&#127474;",category:"f",emoji_order:"2396"},{name:"flag-sn",unicode:"1f1f8-1f1f3",shortname:":flag-sn:",code_decimal:"&#127480;&#127475;",category:"f",emoji_order:"2397"},{name:"flag-so",unicode:"1f1f8-1f1f4",shortname:":flag-so:",code_decimal:"&#127480;&#127476;",category:"f",emoji_order:"2398"},{name:"flag-sr",unicode:"1f1f8-1f1f7",shortname:":flag-sr:",code_decimal:"&#127480;&#127479;",category:"f",emoji_order:"2399"},{name:"flag-ss",unicode:"1f1f8-1f1f8",shortname:":flag-ss:",code_decimal:"&#127480;&#127480;",category:"f",emoji_order:"2400"},{name:"flag-st",unicode:"1f1f8-1f1f9",shortname:":flag-st:",code_decimal:"&#127480;&#127481;",category:"f",emoji_order:"2401"},{name:"flag-sv",unicode:"1f1f8-1f1fb",shortname:":flag-sv:",code_decimal:"&#127480;&#127483;",category:"f",emoji_order:"2402"},{name:"flag-sx",unicode:"1f1f8-1f1fd",shortname:":flag-sx:",code_decimal:"&#127480;&#127485;",category:"f",emoji_order:"2403"},{name:"flag-sy",unicode:"1f1f8-1f1fe",shortname:":flag-sy:",code_decimal:"&#127480;&#127486;",category:"f",emoji_order:"2404"},{name:"flag-sz",unicode:"1f1f8-1f1ff",shortname:":flag-sz:",code_decimal:"&#127480;&#127487;",category:"f",emoji_order:"2405"},{name:"flag-ta",unicode:"1f1f9-1f1e6",shortname:":flag-ta:",code_decimal:"&#127481;&#127462;",category:"f",emoji_order:"2406"},{name:"flag-tc",unicode:"1f1f9-1f1e8",shortname:":flag-tc:",code_decimal:"&#127481;&#127464;",category:"f",emoji_order:"2407"},{name:"flag-td",unicode:"1f1f9-1f1e9",shortname:":flag-td:",code_decimal:"&#127481;&#127465;",category:"f",emoji_order:"2408"},{name:"flag-tf",unicode:"1f1f9-1f1eb",shortname:":flag-tf:",code_decimal:"&#127481;&#127467;",category:"f",emoji_order:"2409"},{name:"flag-tg",unicode:"1f1f9-1f1ec",shortname:":flag-tg:",code_decimal:"&#127481;&#127468;",category:"f",emoji_order:"2410"},{name:"flag-th",unicode:"1f1f9-1f1ed",shortname:":flag-th:",code_decimal:"&#127481;&#127469;",category:"f",emoji_order:"2411"},{name:"flag-tj",unicode:"1f1f9-1f1ef",shortname:":flag-tj:",code_decimal:"&#127481;&#127471;",category:"f",emoji_order:"2412"},{name:"flag-tk",unicode:"1f1f9-1f1f0",shortname:":flag-tk:",code_decimal:"&#127481;&#127472;",category:"f",emoji_order:"2413"},{name:"flag-tl",unicode:"1f1f9-1f1f1",shortname:":flag-tl:",code_decimal:"&#127481;&#127473;",category:"f",emoji_order:"2414"},{name:"flag-tm",unicode:"1f1f9-1f1f2",shortname:":flag-tm:",code_decimal:"&#127481;&#127474;",category:"f",emoji_order:"2415"},{name:"flag-tn",unicode:"1f1f9-1f1f3",shortname:":flag-tn:",code_decimal:"&#127481;&#127475;",category:"f",emoji_order:"2416"},{name:"flag-to",unicode:"1f1f9-1f1f4",shortname:":flag-to:",code_decimal:"&#127481;&#127476;",category:"f",emoji_order:"2417"},{name:"flag-tr",unicode:"1f1f9-1f1f7",shortname:":flag-tr:",code_decimal:"&#127481;&#127479;",category:"f",emoji_order:"2418"},{name:"flag-tt",unicode:"1f1f9-1f1f9",shortname:":flag-tt:",code_decimal:"&#127481;&#127481;",category:"f",emoji_order:"2419"},{name:"flag-tv",unicode:"1f1f9-1f1fb",shortname:":flag-tv:",code_decimal:"&#127481;&#127483;",category:"f",emoji_order:"2420"},{name:"flag-tw",unicode:"1f1f9-1f1fc",shortname:":flag-tw:",code_decimal:"&#127481;&#127484;",category:"f",emoji_order:"2421"},{name:"flag-tz",unicode:"1f1f9-1f1ff",shortname:":flag-tz:",code_decimal:"&#127481;&#127487;",category:"f",emoji_order:"2422"},{name:"flag-ua",unicode:"1f1fa-1f1e6",shortname:":flag-ua:",code_decimal:"&#127482;&#127462;",category:"f",emoji_order:"2423"},{name:"flag-ug",unicode:"1f1fa-1f1ec",shortname:":flag-ug:",code_decimal:"&#127482;&#127468;",category:"f",emoji_order:"2424"},{name:"flag-um",unicode:"1f1fa-1f1f2",shortname:":flag-um:",code_decimal:"&#127482;&#127474;",category:"f",emoji_order:"2425"},{name:"flag-us",unicode:"1f1fa-1f1f8",shortname:":flag-us:",code_decimal:"&#127482;&#127480;",category:"f",emoji_order:"2427"},{name:"flag-uy",unicode:"1f1fa-1f1fe",shortname:":flag-uy:",code_decimal:"&#127482;&#127486;",category:"f",emoji_order:"2428"},{name:"flag-uz",unicode:"1f1fa-1f1ff",shortname:":flag-uz:",code_decimal:"&#127482;&#127487;",category:"f",emoji_order:"2429"},{name:"flag-va",unicode:"1f1fb-1f1e6",shortname:":flag-va:",code_decimal:"&#127483;&#127462;",category:"f",emoji_order:"2430"},{name:"flag-vc",unicode:"1f1fb-1f1e8",shortname:":flag-vc:",code_decimal:"&#127483;&#127464;",category:"f",emoji_order:"2431"},{name:"flag-ve",unicode:"1f1fb-1f1ea",shortname:":flag-ve:",code_decimal:"&#127483;&#127466;",category:"f",emoji_order:"2432"},{name:"flag-vg",unicode:"1f1fb-1f1ec",shortname:":flag-vg:",code_decimal:"&#127483;&#127468;",category:"f",emoji_order:"2433"},{name:"flag-vi",unicode:"1f1fb-1f1ee",shortname:":flag-vi:",code_decimal:"&#127483;&#127470;",category:"f",emoji_order:"2434"},{name:"flag-vn",unicode:"1f1fb-1f1f3",shortname:":flag-vn:",code_decimal:"&#127483;&#127475;",category:"f",emoji_order:"2435"},{name:"flag-vu",unicode:"1f1fb-1f1fa",shortname:":flag_vu:",code_decimal:"&#127483;&#127482;",category:"f",emoji_order:"2436"},{name:"flag-wf",unicode:"1f1fc-1f1eb",shortname:":flag_wf:",code_decimal:"&#127484;&#127467;",category:"f",emoji_order:"2437"},{name:"flag-ws",unicode:"1f1fc-1f1f8",shortname:":flag_ws:",code_decimal:"&#127484;&#127480;",category:"f",emoji_order:"2438"},{name:"flag-xk",unicode:"1f1fd-1f1f0",shortname:":flag_xk:",code_decimal:"&#127485;&#127472;",category:"f",emoji_order:"2439"},{name:"flag-ye",unicode:"1f1fe-1f1ea",shortname:":flag_ye:",code_decimal:"&#127486;&#127466;",category:"f",emoji_order:"2440"},{name:"flag-yt",unicode:"1f1fe-1f1f9",shortname:":flag_yt:",code_decimal:"&#127486;&#127481;",category:"f",emoji_order:"2441"},{name:"flag-za",unicode:"1f1ff-1f1e6",shortname:":flag_za:",code_decimal:"&#127487;&#127462;",category:"f",emoji_order:"2442"},{name:"flag-zm",unicode:"1f1ff-1f1f2",shortname:":flag_zm:",code_decimal:"&#127487;&#127474;",category:"f",emoji_order:"2443"},{name:"flag-zw",unicode:"1f1ff-1f1fc",shortname:":flag_zw:",code_decimal:"&#127487;&#127484;",category:"f",emoji_order:"2444"},{name:"speech",unicode:"1f600",shortname:":speech:",code_decimal:"&#128172;",category:"p",emoji_order:"1"}],n={};c.forEach(function(e){n[e.name]=e});var d=n;function i(e){return function(e){if(Array.isArray(e)){for(var o=0,a=new Array(e.length);o<e.length;o++)a[o]=e[o];return a}}(e)||function(e){if(Symbol.iterator in Object(e)||"[object Arguments]"===Object.prototype.toString.call(e))return Array.from(e)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance")}()}function t(e){return(t="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function _(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function l(e,o){return!o||"object"!==t(o)&&"function"!=typeof o?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):o}function s(e,o,a){return(s="undefined"!=typeof Reflect&&Reflect.get?Reflect.get:function(e,o,a){var r=function(e,o){for(;!Object.prototype.hasOwnProperty.call(e,o)&&null!==(e=f(e)););return e}(e,o);if(r){var c=Object.getOwnPropertyDescriptor(r,o);return c.get?c.get.call(a):c.value}})(e,o,a||e)}function f(e){return(f=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function g(e,o){return(g=Object.setPrototypeOf||function(e,o){return e.__proto__=o,e})(e,o)}var u=m.a.import("blots/embed"),h=function(e){function r(){return function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,r),l(this,f(r).apply(this,arguments))}var o,a,c;return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),o&&g(e,o)}(r,u),o=r,c=[{key:"create",value:function(e){var o=s(f(r),"create",this).call(this);if("object"===t(e))r.buildSpan(e,o);else if("string"==typeof e){var a=d[e];a&&r.buildSpan(a,o)}return o}},{key:"value",value:function(e){return e.dataset.name}},{key:"buildSpan",value:function(e,o){o.setAttribute("data-name",e.name);var a=document.createElement("span");a.classList.add(this.emojiClass),a.classList.add(this.emojiPrefix+e.name),a.innerText=String.fromCodePoint.apply(String,i(r.parseUnicode(e.unicode))),o.appendChild(a)}},{key:"parseUnicode",value:function(e){return e.split("-").map(function(e){return parseInt(e,16)})}}],(a=null)&&_(o.prototype,a),c&&_(o,c),r}();h.blotName="emoji",h.className="ql-emojiblot",h.tagName="span",h.emojiClass="ap",h.emojiPrefix="ap-";var y=h,j=a(1),p=a.n(j);function b(e){return(b="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function v(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function k(e){return(k=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function w(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function x(e,o){return(x=Object.setPrototypeOf||function(e,o){return e.__proto__=o,e})(e,o)}var S=m.a.import("core/module"),q=function(e){function n(e,o){var a,r,c;return function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,n),r=this,(a=!(c=k(n).call(this,e,o))||"object"!==b(c)&&"function"!=typeof c?w(r):c).emojiList=o.emojiList,a.fuse=new p.a(o.emojiList,o.fuse),a.quill=e,a.onClose=o.onClose,a.onOpen=o.onOpen,a.container=document.createElement("ul"),a.container.classList.add("emoji_completions"),a.quill.container.appendChild(a.container),a.container.style.position="absolute",a.container.style.display="none",a.onSelectionChange=a.maybeUnfocus.bind(w(a)),a.onTextChange=a.update.bind(w(a)),a.open=!1,a.atIndex=null,a.focusedButton=null,a.isWhiteSpace=function(e){var o=!1;return/\s/.test(e)&&(o=!0),o},e.keyboard.addBinding({key:186,shiftKey:!0},a.triggerPicker.bind(w(a))),e.keyboard.addBinding({key:59,shiftKey:!0},a.triggerPicker.bind(w(a))),e.keyboard.addBinding({key:39,collapsed:!0},a.handleArrow.bind(w(a))),e.keyboard.addBinding({key:40,collapsed:!0},a.handleArrow.bind(w(a))),a}var o,a,r;return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),o&&x(e,o)}(n,S),o=n,(a=[{key:"triggerPicker",value:function(e,o){if(this.open)return!0;0<e.length&&this.quill.deleteText(e.index,e.length,m.a.sources.USER),this.quill.insertText(e.index,":","emoji-shortname",m.a.sources.USER);var a=this.quill.getBounds(e.index);this.quill.setSelection(e.index+1,m.a.sources.SILENT),this.atIndex=e.index,a.left+250>this.quill.container.offsetWidth?this.container.style.left=a.left-250+"px":this.container.style.left=a.left+"px",this.container.style.top=a.top+a.height+"px",this.open=!0,this.quill.on("text-change",this.onTextChange),this.quill.once("selection-change",this.onSelectionChange),this.onOpen&&this.onOpen()}},{key:"handleArrow",value:function(){if(!this.open)return!0;this.buttons[0].classList.remove("emoji-active"),this.buttons[0].focus(),1<this.buttons.length&&this.buttons[1].focus()}},{key:"update",value:function(){var e=this.quill.getSelection().index;if(this.atIndex>=e)return this.close(null);this.query=this.quill.getText(this.atIndex+1,e-this.atIndex-1);try{if(event&&this.isWhiteSpace(this.query))return void this.close(null)}catch(e){console.warn(e)}this.query=this.query.trim();var o=this.fuse.search(this.query);o.sort(function(e,o){return e.emoji_order-o.emoji_order}),this.query.length<this.options.fuse.minMatchCharLength||0===o.length?this.container.style.display="none":(15<o.length&&(o=o.slice(0,15)),this.renderCompletions(o))}},{key:"maybeUnfocus",value:function(){this.container.querySelector("*:focus")||this.close(null)}},{key:"renderCompletions",value:function(e){var n=this;try{if(event){if("Enter"===event.key||13===event.keyCode)return this.close(e[0],1),void(this.container.style.display="none");if("Tab"===event.key||9===event.keyCode)return this.quill.disable(),this.buttons[0].classList.remove("emoji-active"),void this.buttons[1].focus()}}catch(e){console.warn(e)}for(;this.container.firstChild;)this.container.removeChild(this.container.firstChild);var d=Array(e.length);this.buttons=d;if(e.forEach(function(e,o){var a,r,c=E("li",{},E("button",{type:"button"},E("span",{className:"button-emoji ap ap-"+e.name,innerHTML:e.code_decimal}),E("span",{className:"unmatched"},e.shortname)));n.container.appendChild(c),d[o]=c.firstChild,d[o].addEventListener("keydown",(a=o,r=e,function(e){if("ArrowRight"===e.key||39===e.keyCode)e.preventDefault(),d[Math.min(d.length-1,a+1)].focus();else if("Tab"===e.key||9===e.keyCode){if(e.preventDefault(),a+1===d.length)return void d[0].focus();d[Math.min(d.length-1,a+1)].focus()}else"ArrowLeft"===e.key||37===e.keyCode?(e.preventDefault(),d[Math.max(0,a-1)].focus()):"ArrowDown"===e.key||40===e.keyCode?(e.preventDefault(),d[Math.min(d.length-1,a+1)].focus()):"ArrowUp"===e.key||38===e.keyCode?(e.preventDefault(),d[Math.max(0,a-1)].focus()):"Enter"!==e.key&&13!==e.keyCode&&" "!==e.key&&32!==e.keyCode&&"Tab"!==e.key&&9!==e.keyCode||(e.preventDefault(),n.quill.enable(),n.close(r))})),d[o].addEventListener("mousedown",function(){return n.close(e)}),d[o].addEventListener("focus",function(){return n.focusedButton=o}),d[o].addEventListener("unfocus",function(){return n.focusedButton=null})}),this.container.style.display="block",this.quill.container.classList.contains("top-emoji")){var o,a=this.container.querySelectorAll("li");for(o=0;o<a.length;o++)a[o].style.display="block";window.innerHeight/2<this.quill.container.getBoundingClientRect().top&&0<this.container.offsetHeight&&(this.container.style.top="-"+this.container.offsetHeight+"px")}d[0].classList.add("emoji-active")}},{key:"close",value:function(e){var o=this,a=1<arguments.length&&void 0!==arguments[1]?arguments[1]:0;for(this.quill.enable(),this.container.style.display="none";this.container.firstChild;)this.container.removeChild(this.container.firstChild);this.quill.off("selection-change",this.onSelectionChange),this.quill.off("text-change",this.onTextChange),e&&(this.quill.deleteText(this.atIndex,this.query.length+1+a,m.a.sources.USER),this.quill.insertEmbed(this.atIndex,"emoji",e,m.a.sources.USER),setTimeout(function(){return o.quill.setSelection(o.atIndex+1)},0)),this.quill.focus(),this.open=!1,this.onClose&&this.onClose(e)}}])&&v(o.prototype,a),r&&v(o,r),n}();function E(e,o){var a=document.createElement(e);Object.keys(o).forEach(function(e){return a[e]=o[e]});for(var r=arguments.length,c=new Array(2<r?r-2:0),n=2;n<r;n++)c[n-2]=arguments[n];return c.forEach(function(e){"string"==typeof e&&(e=document.createTextNode(e)),a.appendChild(e)}),a}q.DEFAULTS={emojiList:c,fuse:{shouldSort:!0,threshold:.1,location:0,distance:100,maxPatternLength:32,minMatchCharLength:1,keys:["shortname"]}};var C=q;function L(e){return(L="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function O(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function M(e,o){return!o||"object"!==L(o)&&"function"!=typeof o?function(e){if(void 0!==e)return e;throw new ReferenceError("this hasn't been initialised - super() hasn't been called")}(e):o}function z(e){return(z=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function T(e,o){return(T=Object.setPrototypeOf||function(e,o){return e.__proto__=o,e})(e,o)}m.a.import("delta");var P=m.a.import("core/module"),A=function(e){function c(e,o){var a;!function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,c),(a=M(this,z(c).call(this,e,o))).quill=e,a.toolbar=e.getModule("toolbar"),void 0!==a.toolbar&&a.toolbar.addHandler("emoji",a.checkPalatteExist);var r=document.getElementsByClassName("ql-emoji");return r&&[].slice.call(r).forEach(function(e){e.innerHTML=o.buttonIcon}),a}var o,a,r;return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),o&&T(e,o)}(c,P),o=c,(a=[{key:"checkPalatteExist",value:function(){var e,o,r=this.quill;e=r,(o=document.getElementById("emoji-palette"))?o.remove():function(c){var e=document.createElement("div"),o=(document.querySelector(".ql-toolbar"),c.getSelection()),a=c.getBounds(o.index);c.container.appendChild(e);var r=c.container.offsetWidth/2,n=c.container.offsetHeight/2,d=(a.left+a.right)/2,i=(a.top+a.bottom)/2;a.left,e.id="emoji-palette",e.style.top=10+a.top+a.height+"px",e.style.left=d<r?d+"px":d-250+"px",e.style.top=i<n?i+"px":i-250+"px";var m=document.createElement("div");m.id="tab-toolbar",e.appendChild(m);var t=document.createElement("div");t.id="tab-panel",e.appendChild(t);var _=document.createElement("ul");if(m.appendChild(_),null===document.getElementById("emoji-close-div")){var l=document.createElement("div");l.id="emoji-close-div",l.addEventListener("click",I,!1),document.getElementsByTagName("body")[0].appendChild(l)}else document.getElementById("emoji-close-div").style.display="block";[{type:"p",name:"people",content:'<div class="i-people"></div>'},{type:"n",name:"nature",content:'<div class="i-nature"></div>'},{type:"d",name:"food",content:'<div class="i-food"></div>'},{type:"s",name:"symbols",content:'<div class="i-symbols"></div>'},{type:"a",name:"activity",content:'<div class="i-activity"></div>'},{type:"t",name:"travel",content:'<div class="i-travel"></div>'},{type:"o",name:"objects",content:'<div class="i-objects"></div>'},{type:"f",name:"flags",content:'<div class="i-flags"></div>'}].map(function(e){var o=document.createElement("li");o.classList.add("emoji-tab"),o.classList.add("filter-"+e.name);var a=e.content;o.innerHTML=a,o.dataset.filter=e.type,_.appendChild(o);var r=document.querySelector(".filter-"+e.name);r.addEventListener("click",function(){var e=document.querySelector(".active");e&&e.classList.remove("active"),r.classList.toggle("active"),function(e,o,a){for(;o.firstChild;)o.removeChild(o.firstChild);H(e.dataset.filter,o,a)}(r,t,c)})}),H("p",t,c),document.querySelector(".filter-people").classList.add("active")}(e),this.quill.on("text-change",function(e,o,a){"user"===a&&(I(),B(r))})}}])&&O(o.prototype,a),r&&O(o,r),c}();function I(){var e=document.getElementById("emoji-palette");document.getElementById("emoji-close-div").style.display="none",e&&e.remove()}function B(e){return e.getSelection()}function H(e,n,d){var o=new p.a(c,{shouldSort:!0,matchAllTokens:!0,threshold:.3,location:0,distance:100,maxPatternLength:32,minMatchCharLength:3,keys:["category"]}).search(e);o.sort(function(e,o){return e.emoji_order-o.emoji_order}),d.focus();var i=B(d);o.map(function(e){var o=document.createElement("span"),a=document.createTextNode(e.shortname);o.appendChild(a),o.classList.add("bem"),o.classList.add("bem-"+e.name),o.classList.add("ap"),o.classList.add("ap-"+e.name);var r=""+e.code_decimal;o.innerHTML=r+" ",n.appendChild(o);var c=document.querySelector(".bem-"+e.name);c&&c.addEventListener("click",function(){(function(e,o){var a=document.createElement(e);Object.keys(o).forEach(function(e){return a[e]=o[e]});for(var r=arguments.length,c=new Array(2<r?r-2:0),n=2;n<r;n++)c[n-2]=arguments[n];return c.forEach(function(e){"string"==typeof e&&(e=document.createTextNode(e)),a.appendChild(e)}),a})("span",{className:"ico",innerHTML:e.code_decimal+" "}).innerHTML;d.insertEmbed(i.index,"emoji",e,m.a.sources.USER),setTimeout(function(){return d.setSelection(i.index+1)},0),I()})})}A.DEFAULTS={buttonIcon:'<svg viewbox="0 0 18 18"><circle class="ql-fill" cx="7" cy="7" r="1"></circle><circle class="ql-fill" cx="11" cy="7" r="1"></circle><path class="ql-stroke" d="M7,10a2,2,0,0,0,4,0H7Z"></path><circle class="ql-stroke" cx="9" cy="9" r="6"></circle></svg>'};var R=A;function N(e){return(N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e})(e)}function U(e,o){for(var a=0;a<o.length;a++){var r=o[a];r.enumerable=r.enumerable||!1,r.configurable=!0,"value"in r&&(r.writable=!0),Object.defineProperty(e,r.key,r)}}function D(e){return(D=Object.setPrototypeOf?Object.getPrototypeOf:function(e){return e.__proto__||Object.getPrototypeOf(e)})(e)}function F(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function K(e,o){return(K=Object.setPrototypeOf||function(e,o){return e.__proto__=o,e})(e,o)}m.a.import("delta");var W=m.a.import("core/module"),Q=function(e){function n(e,o){var a,r,c;return function(e,o){if(!(e instanceof o))throw new TypeError("Cannot call a class as a function")}(this,n),r=this,(a=!(c=D(n).call(this,e,o))||"object"!==N(c)&&"function"!=typeof c?F(r):c).quill=e,a.container=document.createElement("div"),a.container.classList.add("textarea-emoji-control"),a.container.style.position="absolute",a.container.innerHTML=o.buttonIcon,a.quill.container.appendChild(a.container),a.container.addEventListener("click",a.checkEmojiBoxExist.bind(F(a)),!1),a}var o,a,r;return function(e,o){if("function"!=typeof o&&null!==o)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(o&&o.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),o&&K(e,o)}(n,W),o=n,(a=[{key:"checkEmojiBoxExist",value:function(){var e,o,a=document.getElementById("textarea-emoji");if(a)a.remove();else{var r=document.createElement("div");r.id="textarea-emoji",this.quill.container.appendChild(r);var c=document.createElement("div");c.id="tab-toolbar",r.appendChild(c);var n=document.createElement("ul");if(c.appendChild(n),null===document.getElementById("emoji-close-div")){var d=document.createElement("div");d.id="emoji-close-div",d.addEventListener("click",Z,!1),document.getElementsByTagName("body")[0].appendChild(d)}else document.getElementById("emoji-close-div").style.display="block";var i=document.createElement("div");i.id="tab-panel",r.appendChild(i);var m=this.quill;[{type:"p",name:"people",content:'<div class="i-people"></div>'},{type:"n",name:"nature",content:'<div class="i-nature"></div>'},{type:"d",name:"food",content:'<div class="i-food"></div>'},{type:"s",name:"symbols",content:'<div class="i-symbols"></div>'},{type:"a",name:"activity",content:'<div class="i-activity"></div>'},{type:"t",name:"travel",content:'<div class="i-travel"></div>'},{type:"o",name:"objects",content:'<div class="i-objects"></div>'},{type:"f",name:"flags",content:'<div class="i-flags"></div>'}].map(function(e){var o=document.createElement("li");o.classList.add("emoji-tab"),o.classList.add("filter-"+e.name);var a=e.content;o.innerHTML=a,o.dataset.filter=e.type,n.appendChild(o);var r=document.querySelector(".filter-"+e.name);r.addEventListener("click",function(){var e=document.getElementById("textarea-emoji"),o=e&&e.querySelector(".active");for(o&&o.classList.remove("active"),r.classList.toggle("active");i.firstChild;)i.removeChild(i.firstChild);$(r.dataset.filter,i,m)})}),window.innerHeight/2<this.quill.container.getBoundingClientRect().top&&(r.style.top="-250px"),e=i,o=this.quill,$("p",e,o),document.querySelector(".filter-people").classList.add("active")}}}])&&U(o.prototype,a),r&&U(o,r),n}();function Z(){var e=document.getElementById("textarea-emoji");document.getElementById("emoji-close-div").style.display="none",e&&e.remove()}function $(e,n,d){var o=new p.a(c,{shouldSort:!0,matchAllTokens:!0,threshold:.3,location:0,distance:100,maxPatternLength:32,minMatchCharLength:3,keys:["category"]}).search(e);o.sort(function(e,o){return e.emoji_order-o.emoji_order}),d.focus();var i=d.getSelection();o.map(function(e){var o=document.createElement("span"),a=document.createTextNode(e.shortname);o.appendChild(a),o.classList.add("bem"),o.classList.add("bem-"+e.name),o.classList.add("ap"),o.classList.add("ap-"+e.name);var r=""+e.code_decimal;o.innerHTML=r+" ",n.appendChild(o);var c=document.querySelector(".bem-"+e.name);c&&c.addEventListener("click",function(){d.insertEmbed(i.index,"emoji",e,m.a.sources.USER),setTimeout(function(){return d.setSelection(i.index+1)},0),Z()})})}Q.DEFAULTS={buttonIcon:'<svg viewbox="0 0 18 18"><circle class="ql-fill" cx="7" cy="7" r="1"></circle><circle class="ql-fill" cx="11" cy="7" r="1"></circle><path class="ql-stroke" d="M7,10a2,2,0,0,0,4,0H7Z"></path><circle class="ql-stroke" cx="9" cy="9" r="6"></circle></svg>'};var J=Q;a(2);m.a.register({"formats/emoji":y,"modules/emoji-shortname":C,"modules/emoji-toolbar":R,"modules/emoji-textarea":J},!0);o.default={EmojiBlot:y,ShortNameEmoji:C,ToolbarEmoji:R,TextAreaEmoji:J}}])});

/***/ }),

/***/ 6095:
/***/ (function(module) {

/*!
 * Quill Editor v1.3.7
 * https://quilljs.com/
 * Copyright (c) 2014, Jason Chen
 * Copyright (c) 2013, salesforce.com
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(true)
		module.exports = factory();
	else {}
})(typeof self !== 'undefined' ? self : this, function() {
return /******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __nested_webpack_require_697__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __nested_webpack_require_697__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__nested_webpack_require_697__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__nested_webpack_require_697__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__nested_webpack_require_697__.d = function(exports, name, getter) {
/******/ 		if(!__nested_webpack_require_697__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__nested_webpack_require_697__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__nested_webpack_require_697__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__nested_webpack_require_697__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__nested_webpack_require_697__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __nested_webpack_require_697__(__nested_webpack_require_697__.s = 109);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __nested_webpack_require_2976__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __nested_webpack_require_2976__(17);
var format_1 = __nested_webpack_require_2976__(18);
var leaf_1 = __nested_webpack_require_2976__(19);
var scroll_1 = __nested_webpack_require_2976__(45);
var inline_1 = __nested_webpack_require_2976__(46);
var block_1 = __nested_webpack_require_2976__(47);
var embed_1 = __nested_webpack_require_2976__(48);
var text_1 = __nested_webpack_require_2976__(49);
var attributor_1 = __nested_webpack_require_2976__(12);
var class_1 = __nested_webpack_require_2976__(32);
var style_1 = __nested_webpack_require_2976__(33);
var store_1 = __nested_webpack_require_2976__(31);
var Registry = __nested_webpack_require_2976__(1);
var Parchment = {
    Scope: Registry.Scope,
    create: Registry.create,
    find: Registry.find,
    query: Registry.query,
    register: Registry.register,
    Container: container_1.default,
    Format: format_1.default,
    Leaf: leaf_1.default,
    Embed: embed_1.default,
    Scroll: scroll_1.default,
    Block: block_1.default,
    Inline: inline_1.default,
    Text: text_1.default,
    Attributor: {
        Attribute: attributor_1.default,
        Class: class_1.default,
        Style: style_1.default,
        Store: store_1.default,
    },
};
exports.default = Parchment;


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var ParchmentError = /** @class */ (function (_super) {
    __extends(ParchmentError, _super);
    function ParchmentError(message) {
        var _this = this;
        message = '[Parchment] ' + message;
        _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _this.constructor.name;
        return _this;
    }
    return ParchmentError;
}(Error));
exports.ParchmentError = ParchmentError;
var attributes = {};
var classes = {};
var tags = {};
var types = {};
exports.DATA_KEY = '__blot';
var Scope;
(function (Scope) {
    Scope[Scope["TYPE"] = 3] = "TYPE";
    Scope[Scope["LEVEL"] = 12] = "LEVEL";
    Scope[Scope["ATTRIBUTE"] = 13] = "ATTRIBUTE";
    Scope[Scope["BLOT"] = 14] = "BLOT";
    Scope[Scope["INLINE"] = 7] = "INLINE";
    Scope[Scope["BLOCK"] = 11] = "BLOCK";
    Scope[Scope["BLOCK_BLOT"] = 10] = "BLOCK_BLOT";
    Scope[Scope["INLINE_BLOT"] = 6] = "INLINE_BLOT";
    Scope[Scope["BLOCK_ATTRIBUTE"] = 9] = "BLOCK_ATTRIBUTE";
    Scope[Scope["INLINE_ATTRIBUTE"] = 5] = "INLINE_ATTRIBUTE";
    Scope[Scope["ANY"] = 15] = "ANY";
})(Scope = exports.Scope || (exports.Scope = {}));
function create(input, value) {
    var match = query(input);
    if (match == null) {
        throw new ParchmentError("Unable to create " + input + " blot");
    }
    var BlotClass = match;
    var node = 
    // @ts-ignore
    input instanceof Node || input['nodeType'] === Node.TEXT_NODE ? input : BlotClass.create(value);
    return new BlotClass(node, value);
}
exports.create = create;
function find(node, bubble) {
    if (bubble === void 0) { bubble = false; }
    if (node == null)
        return null;
    // @ts-ignore
    if (node[exports.DATA_KEY] != null)
        return node[exports.DATA_KEY].blot;
    if (bubble)
        return find(node.parentNode, bubble);
    return null;
}
exports.find = find;
function query(query, scope) {
    if (scope === void 0) { scope = Scope.ANY; }
    var match;
    if (typeof query === 'string') {
        match = types[query] || attributes[query];
        // @ts-ignore
    }
    else if (query instanceof Text || query['nodeType'] === Node.TEXT_NODE) {
        match = types['text'];
    }
    else if (typeof query === 'number') {
        if (query & Scope.LEVEL & Scope.BLOCK) {
            match = types['block'];
        }
        else if (query & Scope.LEVEL & Scope.INLINE) {
            match = types['inline'];
        }
    }
    else if (query instanceof HTMLElement) {
        var names = (query.getAttribute('class') || '').split(/\s+/);
        for (var i in names) {
            match = classes[names[i]];
            if (match)
                break;
        }
        match = match || tags[query.tagName];
    }
    if (match == null)
        return null;
    // @ts-ignore
    if (scope & Scope.LEVEL & match.scope && scope & Scope.TYPE & match.scope)
        return match;
    return null;
}
exports.query = query;
function register() {
    var Definitions = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        Definitions[_i] = arguments[_i];
    }
    if (Definitions.length > 1) {
        return Definitions.map(function (d) {
            return register(d);
        });
    }
    var Definition = Definitions[0];
    if (typeof Definition.blotName !== 'string' && typeof Definition.attrName !== 'string') {
        throw new ParchmentError('Invalid definition');
    }
    else if (Definition.blotName === 'abstract') {
        throw new ParchmentError('Cannot register abstract class');
    }
    types[Definition.blotName || Definition.attrName] = Definition;
    if (typeof Definition.keyName === 'string') {
        attributes[Definition.keyName] = Definition;
    }
    else {
        if (Definition.className != null) {
            classes[Definition.className] = Definition;
        }
        if (Definition.tagName != null) {
            if (Array.isArray(Definition.tagName)) {
                Definition.tagName = Definition.tagName.map(function (tagName) {
                    return tagName.toUpperCase();
                });
            }
            else {
                Definition.tagName = Definition.tagName.toUpperCase();
            }
            var tagNames = Array.isArray(Definition.tagName) ? Definition.tagName : [Definition.tagName];
            tagNames.forEach(function (tag) {
                if (tags[tag] == null || Definition.className == null) {
                    tags[tag] = Definition;
                }
            });
        }
    }
    return Definition;
}
exports.register = register;


/***/ }),
/* 2 */
/***/ (function(module, exports, __nested_webpack_require_9445__) {

var diff = __nested_webpack_require_9445__(51);
var equal = __nested_webpack_require_9445__(11);
var extend = __nested_webpack_require_9445__(3);
var op = __nested_webpack_require_9445__(20);


var NULL_CHARACTER = String.fromCharCode(0);  // Placeholder char for embed in diff()


var Delta = function (ops) {
  // Assume we are given a well formed ops
  if (Array.isArray(ops)) {
    this.ops = ops;
  } else if (ops != null && Array.isArray(ops.ops)) {
    this.ops = ops.ops;
  } else {
    this.ops = [];
  }
};


Delta.prototype.insert = function (text, attributes) {
  var newOp = {};
  if (text.length === 0) return this;
  newOp.insert = text;
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype['delete'] = function (length) {
  if (length <= 0) return this;
  return this.push({ 'delete': length });
};

Delta.prototype.retain = function (length, attributes) {
  if (length <= 0) return this;
  var newOp = { retain: length };
  if (attributes != null && typeof attributes === 'object' && Object.keys(attributes).length > 0) {
    newOp.attributes = attributes;
  }
  return this.push(newOp);
};

Delta.prototype.push = function (newOp) {
  var index = this.ops.length;
  var lastOp = this.ops[index - 1];
  newOp = extend(true, {}, newOp);
  if (typeof lastOp === 'object') {
    if (typeof newOp['delete'] === 'number' && typeof lastOp['delete'] === 'number') {
      this.ops[index - 1] = { 'delete': lastOp['delete'] + newOp['delete'] };
      return this;
    }
    // Since it does not matter if we insert before or after deleting at the same index,
    // always prefer to insert first
    if (typeof lastOp['delete'] === 'number' && newOp.insert != null) {
      index -= 1;
      lastOp = this.ops[index - 1];
      if (typeof lastOp !== 'object') {
        this.ops.unshift(newOp);
        return this;
      }
    }
    if (equal(newOp.attributes, lastOp.attributes)) {
      if (typeof newOp.insert === 'string' && typeof lastOp.insert === 'string') {
        this.ops[index - 1] = { insert: lastOp.insert + newOp.insert };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      } else if (typeof newOp.retain === 'number' && typeof lastOp.retain === 'number') {
        this.ops[index - 1] = { retain: lastOp.retain + newOp.retain };
        if (typeof newOp.attributes === 'object') this.ops[index - 1].attributes = newOp.attributes
        return this;
      }
    }
  }
  if (index === this.ops.length) {
    this.ops.push(newOp);
  } else {
    this.ops.splice(index, 0, newOp);
  }
  return this;
};

Delta.prototype.chop = function () {
  var lastOp = this.ops[this.ops.length - 1];
  if (lastOp && lastOp.retain && !lastOp.attributes) {
    this.ops.pop();
  }
  return this;
};

Delta.prototype.filter = function (predicate) {
  return this.ops.filter(predicate);
};

Delta.prototype.forEach = function (predicate) {
  this.ops.forEach(predicate);
};

Delta.prototype.map = function (predicate) {
  return this.ops.map(predicate);
};

Delta.prototype.partition = function (predicate) {
  var passed = [], failed = [];
  this.forEach(function(op) {
    var target = predicate(op) ? passed : failed;
    target.push(op);
  });
  return [passed, failed];
};

Delta.prototype.reduce = function (predicate, initial) {
  return this.ops.reduce(predicate, initial);
};

Delta.prototype.changeLength = function () {
  return this.reduce(function (length, elem) {
    if (elem.insert) {
      return length + op.length(elem);
    } else if (elem.delete) {
      return length - elem.delete;
    }
    return length;
  }, 0);
};

Delta.prototype.length = function () {
  return this.reduce(function (length, elem) {
    return length + op.length(elem);
  }, 0);
};

Delta.prototype.slice = function (start, end) {
  start = start || 0;
  if (typeof end !== 'number') end = Infinity;
  var ops = [];
  var iter = op.iterator(this.ops);
  var index = 0;
  while (index < end && iter.hasNext()) {
    var nextOp;
    if (index < start) {
      nextOp = iter.next(start - index);
    } else {
      nextOp = iter.next(end - index);
      ops.push(nextOp);
    }
    index += op.length(nextOp);
  }
  return new Delta(ops);
};


Delta.prototype.compose = function (other) {
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var ops = [];
  var firstOther = otherIter.peek();
  if (firstOther != null && typeof firstOther.retain === 'number' && firstOther.attributes == null) {
    var firstLeft = firstOther.retain;
    while (thisIter.peekType() === 'insert' && thisIter.peekLength() <= firstLeft) {
      firstLeft -= thisIter.peekLength();
      ops.push(thisIter.next());
    }
    if (firstOther.retain - firstLeft > 0) {
      otherIter.next(firstOther.retain - firstLeft);
    }
  }
  var delta = new Delta(ops);
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else if (thisIter.peekType() === 'delete') {
      delta.push(thisIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (typeof otherOp.retain === 'number') {
        var newOp = {};
        if (typeof thisOp.retain === 'number') {
          newOp.retain = length;
        } else {
          newOp.insert = thisOp.insert;
        }
        // Preserve null when composing with a retain, otherwise remove it for inserts
        var attributes = op.attributes.compose(thisOp.attributes, otherOp.attributes, typeof thisOp.retain === 'number');
        if (attributes) newOp.attributes = attributes;
        delta.push(newOp);

        // Optimization if rest of other is just retain
        if (!otherIter.hasNext() && equal(delta.ops[delta.ops.length - 1], newOp)) {
          var rest = new Delta(thisIter.rest());
          return delta.concat(rest).chop();
        }

      // Other op should be delete, we could be an insert or retain
      // Insert + delete cancels out
      } else if (typeof otherOp['delete'] === 'number' && typeof thisOp.retain === 'number') {
        delta.push(otherOp);
      }
    }
  }
  return delta.chop();
};

Delta.prototype.concat = function (other) {
  var delta = new Delta(this.ops.slice());
  if (other.ops.length > 0) {
    delta.push(other.ops[0]);
    delta.ops = delta.ops.concat(other.ops.slice(1));
  }
  return delta;
};

Delta.prototype.diff = function (other, index) {
  if (this.ops === other.ops) {
    return new Delta();
  }
  var strings = [this, other].map(function (delta) {
    return delta.map(function (op) {
      if (op.insert != null) {
        return typeof op.insert === 'string' ? op.insert : NULL_CHARACTER;
      }
      var prep = (delta === other) ? 'on' : 'with';
      throw new Error('diff() called ' + prep + ' non-document');
    }).join('');
  });
  var delta = new Delta();
  var diffResult = diff(strings[0], strings[1], index);
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  diffResult.forEach(function (component) {
    var length = component[1].length;
    while (length > 0) {
      var opLength = 0;
      switch (component[0]) {
        case diff.INSERT:
          opLength = Math.min(otherIter.peekLength(), length);
          delta.push(otherIter.next(opLength));
          break;
        case diff.DELETE:
          opLength = Math.min(length, thisIter.peekLength());
          thisIter.next(opLength);
          delta['delete'](opLength);
          break;
        case diff.EQUAL:
          opLength = Math.min(thisIter.peekLength(), otherIter.peekLength(), length);
          var thisOp = thisIter.next(opLength);
          var otherOp = otherIter.next(opLength);
          if (equal(thisOp.insert, otherOp.insert)) {
            delta.retain(opLength, op.attributes.diff(thisOp.attributes, otherOp.attributes));
          } else {
            delta.push(otherOp)['delete'](opLength);
          }
          break;
      }
      length -= opLength;
    }
  });
  return delta.chop();
};

Delta.prototype.eachLine = function (predicate, newline) {
  newline = newline || '\n';
  var iter = op.iterator(this.ops);
  var line = new Delta();
  var i = 0;
  while (iter.hasNext()) {
    if (iter.peekType() !== 'insert') return;
    var thisOp = iter.peek();
    var start = op.length(thisOp) - iter.peekLength();
    var index = typeof thisOp.insert === 'string' ?
      thisOp.insert.indexOf(newline, start) - start : -1;
    if (index < 0) {
      line.push(iter.next());
    } else if (index > 0) {
      line.push(iter.next(index));
    } else {
      if (predicate(line, iter.next(1).attributes || {}, i) === false) {
        return;
      }
      i += 1;
      line = new Delta();
    }
  }
  if (line.length() > 0) {
    predicate(line, {}, i);
  }
};

Delta.prototype.transform = function (other, priority) {
  priority = !!priority;
  if (typeof other === 'number') {
    return this.transformPosition(other, priority);
  }
  var thisIter = op.iterator(this.ops);
  var otherIter = op.iterator(other.ops);
  var delta = new Delta();
  while (thisIter.hasNext() || otherIter.hasNext()) {
    if (thisIter.peekType() === 'insert' && (priority || otherIter.peekType() !== 'insert')) {
      delta.retain(op.length(thisIter.next()));
    } else if (otherIter.peekType() === 'insert') {
      delta.push(otherIter.next());
    } else {
      var length = Math.min(thisIter.peekLength(), otherIter.peekLength());
      var thisOp = thisIter.next(length);
      var otherOp = otherIter.next(length);
      if (thisOp['delete']) {
        // Our delete either makes their delete redundant or removes their retain
        continue;
      } else if (otherOp['delete']) {
        delta.push(otherOp);
      } else {
        // We retain either their retain or insert
        delta.retain(length, op.attributes.transform(thisOp.attributes, otherOp.attributes, priority));
      }
    }
  }
  return delta.chop();
};

Delta.prototype.transformPosition = function (index, priority) {
  priority = !!priority;
  var thisIter = op.iterator(this.ops);
  var offset = 0;
  while (thisIter.hasNext() && offset <= index) {
    var length = thisIter.peekLength();
    var nextType = thisIter.peekType();
    thisIter.next();
    if (nextType === 'delete') {
      index -= Math.min(length, index - offset);
      continue;
    } else if (nextType === 'insert' && (offset < index || !priority)) {
      index += length;
    }
    offset += length;
  }
  return index;
};


module.exports = Delta;


/***/ }),
/* 3 */
/***/ (function(module, exports) {

'use strict';

var hasOwn = Object.prototype.hasOwnProperty;
var toStr = Object.prototype.toString;
var defineProperty = Object.defineProperty;
var gOPD = Object.getOwnPropertyDescriptor;

var isArray = function isArray(arr) {
	if (typeof Array.isArray === 'function') {
		return Array.isArray(arr);
	}

	return toStr.call(arr) === '[object Array]';
};

var isPlainObject = function isPlainObject(obj) {
	if (!obj || toStr.call(obj) !== '[object Object]') {
		return false;
	}

	var hasOwnConstructor = hasOwn.call(obj, 'constructor');
	var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, 'isPrototypeOf');
	// Not own constructor property must be Object
	if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
		return false;
	}

	// Own properties are enumerated firstly, so to speed up,
	// if last one is own, then all properties are own.
	var key;
	for (key in obj) { /**/ }

	return typeof key === 'undefined' || hasOwn.call(obj, key);
};

// If name is '__proto__', and Object.defineProperty is available, define __proto__ as an own property on target
var setProperty = function setProperty(target, options) {
	if (defineProperty && options.name === '__proto__') {
		defineProperty(target, options.name, {
			enumerable: true,
			configurable: true,
			value: options.newValue,
			writable: true
		});
	} else {
		target[options.name] = options.newValue;
	}
};

// Return undefined instead of __proto__ if '__proto__' is not an own property
var getProperty = function getProperty(obj, name) {
	if (name === '__proto__') {
		if (!hasOwn.call(obj, name)) {
			return void 0;
		} else if (gOPD) {
			// In early versions of node, obj['__proto__'] is buggy when obj has
			// __proto__ as an own property. Object.getOwnPropertyDescriptor() works.
			return gOPD(obj, name).value;
		}
	}

	return obj[name];
};

module.exports = function extend() {
	var options, name, src, copy, copyIsArray, clone;
	var target = arguments[0];
	var i = 1;
	var length = arguments.length;
	var deep = false;

	// Handle a deep copy situation
	if (typeof target === 'boolean') {
		deep = target;
		target = arguments[1] || {};
		// skip the boolean and the target
		i = 2;
	}
	if (target == null || (typeof target !== 'object' && typeof target !== 'function')) {
		target = {};
	}

	for (; i < length; ++i) {
		options = arguments[i];
		// Only deal with non-null/undefined values
		if (options != null) {
			// Extend the base object
			for (name in options) {
				src = getProperty(target, name);
				copy = getProperty(options, name);

				// Prevent never-ending loop
				if (target !== copy) {
					// Recurse if we're merging plain objects or arrays
					if (deep && copy && (isPlainObject(copy) || (copyIsArray = isArray(copy)))) {
						if (copyIsArray) {
							copyIsArray = false;
							clone = src && isArray(src) ? src : [];
						} else {
							clone = src && isPlainObject(src) ? src : {};
						}

						// Never move original objects, clone them
						setProperty(target, { name: name, newValue: extend(deep, clone, copy) });

					// Don't bring in undefined values
					} else if (typeof copy !== 'undefined') {
						setProperty(target, { name: name, newValue: copy });
					}
				}
			}
		}
	}

	// Return the modified object
	return target;
};


/***/ }),
/* 4 */
/***/ (function(module, exports, __nested_webpack_require_23616__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlockEmbed = exports.bubbleFormats = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __nested_webpack_require_23616__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __nested_webpack_require_23616__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __nested_webpack_require_23616__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _break = __nested_webpack_require_23616__(16);

var _break2 = _interopRequireDefault(_break);

var _inline = __nested_webpack_require_23616__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __nested_webpack_require_23616__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NEWLINE_LENGTH = 1;

var BlockEmbed = function (_Parchment$Embed) {
  _inherits(BlockEmbed, _Parchment$Embed);

  function BlockEmbed() {
    _classCallCheck(this, BlockEmbed);

    return _possibleConstructorReturn(this, (BlockEmbed.__proto__ || Object.getPrototypeOf(BlockEmbed)).apply(this, arguments));
  }

  _createClass(BlockEmbed, [{
    key: 'attach',
    value: function attach() {
      _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'attach', this).call(this);
      this.attributes = new _parchment2.default.Attributor.Store(this.domNode);
    }
  }, {
    key: 'delta',
    value: function delta() {
      return new _quillDelta2.default().insert(this.value(), (0, _extend2.default)(this.formats(), this.attributes.values()));
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var attribute = _parchment2.default.query(name, _parchment2.default.Scope.BLOCK_ATTRIBUTE);
      if (attribute != null) {
        this.attributes.attribute(attribute, value);
      }
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      this.format(name, value);
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (typeof value === 'string' && value.endsWith('\n')) {
        var block = _parchment2.default.create(Block.blotName);
        this.parent.insertBefore(block, index === 0 ? this : this.next);
        block.insertAt(0, value.slice(0, -1));
      } else {
        _get(BlockEmbed.prototype.__proto__ || Object.getPrototypeOf(BlockEmbed.prototype), 'insertAt', this).call(this, index, value, def);
      }
    }
  }]);

  return BlockEmbed;
}(_parchment2.default.Embed);

BlockEmbed.scope = _parchment2.default.Scope.BLOCK_BLOT;
// It is important for cursor behavior BlockEmbeds use tags that are block level elements


var Block = function (_Parchment$Block) {
  _inherits(Block, _Parchment$Block);

  function Block(domNode) {
    _classCallCheck(this, Block);

    var _this2 = _possibleConstructorReturn(this, (Block.__proto__ || Object.getPrototypeOf(Block)).call(this, domNode));

    _this2.cache = {};
    return _this2;
  }

  _createClass(Block, [{
    key: 'delta',
    value: function delta() {
      if (this.cache.delta == null) {
        this.cache.delta = this.descendants(_parchment2.default.Leaf).reduce(function (delta, leaf) {
          if (leaf.length() === 0) {
            return delta;
          } else {
            return delta.insert(leaf.value(), bubbleFormats(leaf));
          }
        }, new _quillDelta2.default()).insert('\n', bubbleFormats(this));
      }
      return this.cache.delta;
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'deleteAt', this).call(this, index, length);
      this.cache = {};
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length <= 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
        if (index + length === this.length()) {
          this.format(name, value);
        }
      } else {
        _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'formatAt', this).call(this, index, Math.min(length, this.length() - index - 1), name, value);
      }
      this.cache = {};
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, index, value, def);
      if (value.length === 0) return;
      var lines = value.split('\n');
      var text = lines.shift();
      if (text.length > 0) {
        if (index < this.length() - 1 || this.children.tail == null) {
          _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertAt', this).call(this, Math.min(index, this.length() - 1), text);
        } else {
          this.children.tail.insertAt(this.children.tail.length(), text);
        }
        this.cache = {};
      }
      var block = this;
      lines.reduce(function (index, line) {
        block = block.split(index, true);
        block.insertAt(0, line);
        return line.length;
      }, index + text.length);
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      var head = this.children.head;
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'insertBefore', this).call(this, blot, ref);
      if (head instanceof _break2.default) {
        head.remove();
      }
      this.cache = {};
    }
  }, {
    key: 'length',
    value: function length() {
      if (this.cache.length == null) {
        this.cache.length = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'length', this).call(this) + NEWLINE_LENGTH;
      }
      return this.cache.length;
    }
  }, {
    key: 'moveChildren',
    value: function moveChildren(target, ref) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'moveChildren', this).call(this, target, ref);
      this.cache = {};
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'optimize', this).call(this, context);
      this.cache = {};
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'path', this).call(this, index, true);
    }
  }, {
    key: 'removeChild',
    value: function removeChild(child) {
      _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'removeChild', this).call(this, child);
      this.cache = {};
    }
  }, {
    key: 'split',
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (force && (index === 0 || index >= this.length() - NEWLINE_LENGTH)) {
        var clone = this.clone();
        if (index === 0) {
          this.parent.insertBefore(clone, this);
          return this;
        } else {
          this.parent.insertBefore(clone, this.next);
          return clone;
        }
      } else {
        var next = _get(Block.prototype.__proto__ || Object.getPrototypeOf(Block.prototype), 'split', this).call(this, index, force);
        this.cache = {};
        return next;
      }
    }
  }]);

  return Block;
}(_parchment2.default.Block);

Block.blotName = 'block';
Block.tagName = 'P';
Block.defaultChild = 'break';
Block.allowedChildren = [_inline2.default, _parchment2.default.Embed, _text2.default];

function bubbleFormats(blot) {
  var formats = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (blot == null) return formats;
  if (typeof blot.formats === 'function') {
    formats = (0, _extend2.default)(formats, blot.formats());
  }
  if (blot.parent == null || blot.parent.blotName == 'scroll' || blot.parent.statics.scope !== blot.statics.scope) {
    return formats;
  }
  return bubbleFormats(blot.parent, formats);
}

exports.bubbleFormats = bubbleFormats;
exports.BlockEmbed = BlockEmbed;
exports.default = Block;

/***/ }),
/* 5 */
/***/ (function(module, exports, __nested_webpack_require_33760__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.overload = exports.expandConfig = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

__nested_webpack_require_33760__(50);

var _quillDelta = __nested_webpack_require_33760__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _editor = __nested_webpack_require_33760__(14);

var _editor2 = _interopRequireDefault(_editor);

var _emitter3 = __nested_webpack_require_33760__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _module = __nested_webpack_require_33760__(9);

var _module2 = _interopRequireDefault(_module);

var _parchment = __nested_webpack_require_33760__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _selection = __nested_webpack_require_33760__(15);

var _selection2 = _interopRequireDefault(_selection);

var _extend = __nested_webpack_require_33760__(3);

var _extend2 = _interopRequireDefault(_extend);

var _logger = __nested_webpack_require_33760__(10);

var _logger2 = _interopRequireDefault(_logger);

var _theme = __nested_webpack_require_33760__(34);

var _theme2 = _interopRequireDefault(_theme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill');

var Quill = function () {
  _createClass(Quill, null, [{
    key: 'debug',
    value: function debug(limit) {
      if (limit === true) {
        limit = 'log';
      }
      _logger2.default.level(limit);
    }
  }, {
    key: 'find',
    value: function find(node) {
      return node.__quill || _parchment2.default.find(node);
    }
  }, {
    key: 'import',
    value: function _import(name) {
      if (this.imports[name] == null) {
        debug.error('Cannot import ' + name + '. Are you sure it was registered?');
      }
      return this.imports[name];
    }
  }, {
    key: 'register',
    value: function register(path, target) {
      var _this = this;

      var overwrite = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      if (typeof path !== 'string') {
        var name = path.attrName || path.blotName;
        if (typeof name === 'string') {
          // register(Blot | Attributor, overwrite)
          this.register('formats/' + name, path, target);
        } else {
          Object.keys(path).forEach(function (key) {
            _this.register(key, path[key], target);
          });
        }
      } else {
        if (this.imports[path] != null && !overwrite) {
          debug.warn('Overwriting ' + path + ' with', target);
        }
        this.imports[path] = target;
        if ((path.startsWith('blots/') || path.startsWith('formats/')) && target.blotName !== 'abstract') {
          _parchment2.default.register(target);
        } else if (path.startsWith('modules') && typeof target.register === 'function') {
          target.register();
        }
      }
    }
  }]);

  function Quill(container) {
    var _this2 = this;

    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, Quill);

    this.options = expandConfig(container, options);
    this.container = this.options.container;
    if (this.container == null) {
      return debug.error('Invalid Quill container', container);
    }
    if (this.options.debug) {
      Quill.debug(this.options.debug);
    }
    var html = this.container.innerHTML.trim();
    this.container.classList.add('ql-container');
    this.container.innerHTML = '';
    this.container.__quill = this;
    this.root = this.addContainer('ql-editor');
    this.root.classList.add('ql-blank');
    this.root.setAttribute('data-gramm', false);
    this.scrollingContainer = this.options.scrollingContainer || this.root;
    this.emitter = new _emitter4.default();
    this.scroll = _parchment2.default.create(this.root, {
      emitter: this.emitter,
      whitelist: this.options.formats
    });
    this.editor = new _editor2.default(this.scroll);
    this.selection = new _selection2.default(this.scroll, this.emitter);
    this.theme = new this.options.theme(this, this.options);
    this.keyboard = this.theme.addModule('keyboard');
    this.clipboard = this.theme.addModule('clipboard');
    this.history = this.theme.addModule('history');
    this.theme.init();
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type) {
      if (type === _emitter4.default.events.TEXT_CHANGE) {
        _this2.root.classList.toggle('ql-blank', _this2.editor.isBlank());
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_UPDATE, function (source, mutations) {
      var range = _this2.selection.lastRange;
      var index = range && range.length === 0 ? range.index : undefined;
      modify.call(_this2, function () {
        return _this2.editor.update(null, mutations, index);
      }, source);
    });
    var contents = this.clipboard.convert('<div class=\'ql-editor\' style="white-space: normal;">' + html + '<p><br></p></div>');
    this.setContents(contents);
    this.history.clear();
    if (this.options.placeholder) {
      this.root.setAttribute('data-placeholder', this.options.placeholder);
    }
    if (this.options.readOnly) {
      this.disable();
    }
  }

  _createClass(Quill, [{
    key: 'addContainer',
    value: function addContainer(container) {
      var refNode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      if (typeof container === 'string') {
        var className = container;
        container = document.createElement('div');
        container.classList.add(className);
      }
      this.container.insertBefore(container, refNode);
      return container;
    }
  }, {
    key: 'blur',
    value: function blur() {
      this.selection.setRange(null);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length, source) {
      var _this3 = this;

      var _overload = overload(index, length, source);

      var _overload2 = _slicedToArray(_overload, 4);

      index = _overload2[0];
      length = _overload2[1];
      source = _overload2[3];

      return modify.call(this, function () {
        return _this3.editor.deleteText(index, length);
      }, source, index, -1 * length);
    }
  }, {
    key: 'disable',
    value: function disable() {
      this.enable(false);
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.scroll.enable(enabled);
      this.container.classList.toggle('ql-disabled', !enabled);
    }
  }, {
    key: 'focus',
    value: function focus() {
      var scrollTop = this.scrollingContainer.scrollTop;
      this.selection.focus();
      this.scrollingContainer.scrollTop = scrollTop;
      this.scrollIntoView();
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      var _this4 = this;

      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        var range = _this4.getSelection(true);
        var change = new _quillDelta2.default();
        if (range == null) {
          return change;
        } else if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK)) {
          change = _this4.editor.formatLine(range.index, range.length, _defineProperty({}, name, value));
        } else if (range.length === 0) {
          _this4.selection.format(name, value);
          return change;
        } else {
          change = _this4.editor.formatText(range.index, range.length, _defineProperty({}, name, value));
        }
        _this4.setSelection(range, _emitter4.default.sources.SILENT);
        return change;
      }, source);
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length, name, value, source) {
      var _this5 = this;

      var formats = void 0;

      var _overload3 = overload(index, length, name, value, source);

      var _overload4 = _slicedToArray(_overload3, 4);

      index = _overload4[0];
      length = _overload4[1];
      formats = _overload4[2];
      source = _overload4[3];

      return modify.call(this, function () {
        return _this5.editor.formatLine(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length, name, value, source) {
      var _this6 = this;

      var formats = void 0;

      var _overload5 = overload(index, length, name, value, source);

      var _overload6 = _slicedToArray(_overload5, 4);

      index = _overload6[0];
      length = _overload6[1];
      formats = _overload6[2];
      source = _overload6[3];

      return modify.call(this, function () {
        return _this6.editor.formatText(index, length, formats);
      }, source, index, 0);
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var bounds = void 0;
      if (typeof index === 'number') {
        bounds = this.selection.getBounds(index, length);
      } else {
        bounds = this.selection.getBounds(index.index, index.length);
      }
      var containerBounds = this.container.getBoundingClientRect();
      return {
        bottom: bounds.bottom - containerBounds.top,
        height: bounds.height,
        left: bounds.left - containerBounds.left,
        right: bounds.right - containerBounds.left,
        top: bounds.top - containerBounds.top,
        width: bounds.width
      };
    }
  }, {
    key: 'getContents',
    value: function getContents() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload7 = overload(index, length);

      var _overload8 = _slicedToArray(_overload7, 2);

      index = _overload8[0];
      length = _overload8[1];

      return this.editor.getContents(index, length);
    }
  }, {
    key: 'getFormat',
    value: function getFormat() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.getSelection(true);
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      if (typeof index === 'number') {
        return this.editor.getFormat(index, length);
      } else {
        return this.editor.getFormat(index.index, index.length);
      }
    }
  }, {
    key: 'getIndex',
    value: function getIndex(blot) {
      return blot.offset(this.scroll);
    }
  }, {
    key: 'getLength',
    value: function getLength() {
      return this.scroll.length();
    }
  }, {
    key: 'getLeaf',
    value: function getLeaf(index) {
      return this.scroll.leaf(index);
    }
  }, {
    key: 'getLine',
    value: function getLine(index) {
      return this.scroll.line(index);
    }
  }, {
    key: 'getLines',
    value: function getLines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      if (typeof index !== 'number') {
        return this.scroll.lines(index.index, index.length);
      } else {
        return this.scroll.lines(index, length);
      }
    }
  }, {
    key: 'getModule',
    value: function getModule(name) {
      return this.theme.modules[name];
    }
  }, {
    key: 'getSelection',
    value: function getSelection() {
      var focus = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (focus) this.focus();
      this.update(); // Make sure we access getRange with editor in consistent state
      return this.selection.getRange()[0];
    }
  }, {
    key: 'getText',
    value: function getText() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.getLength() - index;

      var _overload9 = overload(index, length);

      var _overload10 = _slicedToArray(_overload9, 2);

      index = _overload10[0];
      length = _overload10[1];

      return this.editor.getText(index, length);
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return this.selection.hasFocus();
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      var _this7 = this;

      var source = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : Quill.sources.API;

      return modify.call(this, function () {
        return _this7.editor.insertEmbed(index, embed, value);
      }, source, index);
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text, name, value, source) {
      var _this8 = this;

      var formats = void 0;

      var _overload11 = overload(index, 0, name, value, source);

      var _overload12 = _slicedToArray(_overload11, 4);

      index = _overload12[0];
      formats = _overload12[2];
      source = _overload12[3];

      return modify.call(this, function () {
        return _this8.editor.insertText(index, text, formats);
      }, source, index, text.length);
    }
  }, {
    key: 'isEnabled',
    value: function isEnabled() {
      return !this.container.classList.contains('ql-disabled');
    }
  }, {
    key: 'off',
    value: function off() {
      return this.emitter.off.apply(this.emitter, arguments);
    }
  }, {
    key: 'on',
    value: function on() {
      return this.emitter.on.apply(this.emitter, arguments);
    }
  }, {
    key: 'once',
    value: function once() {
      return this.emitter.once.apply(this.emitter, arguments);
    }
  }, {
    key: 'pasteHTML',
    value: function pasteHTML(index, html, source) {
      this.clipboard.dangerouslyPasteHTML(index, html, source);
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length, source) {
      var _this9 = this;

      var _overload13 = overload(index, length, source);

      var _overload14 = _slicedToArray(_overload13, 4);

      index = _overload14[0];
      length = _overload14[1];
      source = _overload14[3];

      return modify.call(this, function () {
        return _this9.editor.removeFormat(index, length);
      }, source, index);
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView() {
      this.selection.scrollIntoView(this.scrollingContainer);
    }
  }, {
    key: 'setContents',
    value: function setContents(delta) {
      var _this10 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        var length = _this10.getLength();
        var deleted = _this10.editor.deleteText(0, length);
        var applied = _this10.editor.applyDelta(delta);
        var lastOp = applied.ops[applied.ops.length - 1];
        if (lastOp != null && typeof lastOp.insert === 'string' && lastOp.insert[lastOp.insert.length - 1] === '\n') {
          _this10.editor.deleteText(_this10.getLength() - 1, 1);
          applied.delete(1);
        }
        var ret = deleted.compose(applied);
        return ret;
      }, source);
    }
  }, {
    key: 'setSelection',
    value: function setSelection(index, length, source) {
      if (index == null) {
        this.selection.setRange(null, length || Quill.sources.API);
      } else {
        var _overload15 = overload(index, length, source);

        var _overload16 = _slicedToArray(_overload15, 4);

        index = _overload16[0];
        length = _overload16[1];
        source = _overload16[3];

        this.selection.setRange(new _selection.Range(index, length), source);
        if (source !== _emitter4.default.sources.SILENT) {
          this.selection.scrollIntoView(this.scrollingContainer);
        }
      }
    }
  }, {
    key: 'setText',
    value: function setText(text) {
      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      var delta = new _quillDelta2.default().insert(text);
      return this.setContents(delta, source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var change = this.scroll.update(source); // Will update selection before selection.update() does if text changes
      this.selection.update(source);
      return change;
    }
  }, {
    key: 'updateContents',
    value: function updateContents(delta) {
      var _this11 = this;

      var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _emitter4.default.sources.API;

      return modify.call(this, function () {
        delta = new _quillDelta2.default(delta);
        return _this11.editor.applyDelta(delta, source);
      }, source, true);
    }
  }]);

  return Quill;
}();

Quill.DEFAULTS = {
  bounds: null,
  formats: null,
  modules: {},
  placeholder: '',
  readOnly: false,
  scrollingContainer: null,
  strict: true,
  theme: 'default'
};
Quill.events = _emitter4.default.events;
Quill.sources = _emitter4.default.sources;
// eslint-disable-next-line no-undef
Quill.version =   false ? 0 : "1.3.7";

Quill.imports = {
  'delta': _quillDelta2.default,
  'parchment': _parchment2.default,
  'core/module': _module2.default,
  'core/theme': _theme2.default
};

function expandConfig(container, userConfig) {
  userConfig = (0, _extend2.default)(true, {
    container: container,
    modules: {
      clipboard: true,
      keyboard: true,
      history: true
    }
  }, userConfig);
  if (!userConfig.theme || userConfig.theme === Quill.DEFAULTS.theme) {
    userConfig.theme = _theme2.default;
  } else {
    userConfig.theme = Quill.import('themes/' + userConfig.theme);
    if (userConfig.theme == null) {
      throw new Error('Invalid theme ' + userConfig.theme + '. Did you register it?');
    }
  }
  var themeConfig = (0, _extend2.default)(true, {}, userConfig.theme.DEFAULTS);
  [themeConfig, userConfig].forEach(function (config) {
    config.modules = config.modules || {};
    Object.keys(config.modules).forEach(function (module) {
      if (config.modules[module] === true) {
        config.modules[module] = {};
      }
    });
  });
  var moduleNames = Object.keys(themeConfig.modules).concat(Object.keys(userConfig.modules));
  var moduleConfig = moduleNames.reduce(function (config, name) {
    var moduleClass = Quill.import('modules/' + name);
    if (moduleClass == null) {
      debug.error('Cannot load ' + name + ' module. Are you sure you registered it?');
    } else {
      config[name] = moduleClass.DEFAULTS || {};
    }
    return config;
  }, {});
  // Special case toolbar shorthand
  if (userConfig.modules != null && userConfig.modules.toolbar && userConfig.modules.toolbar.constructor !== Object) {
    userConfig.modules.toolbar = {
      container: userConfig.modules.toolbar
    };
  }
  userConfig = (0, _extend2.default)(true, {}, Quill.DEFAULTS, { modules: moduleConfig }, themeConfig, userConfig);
  ['bounds', 'container', 'scrollingContainer'].forEach(function (key) {
    if (typeof userConfig[key] === 'string') {
      userConfig[key] = document.querySelector(userConfig[key]);
    }
  });
  userConfig.modules = Object.keys(userConfig.modules).reduce(function (config, name) {
    if (userConfig.modules[name]) {
      config[name] = userConfig.modules[name];
    }
    return config;
  }, {});
  return userConfig;
}

// Handle selection preservation and TEXT_CHANGE emission
// common to modification APIs
function modify(modifier, source, index, shift) {
  if (this.options.strict && !this.isEnabled() && source === _emitter4.default.sources.USER) {
    return new _quillDelta2.default();
  }
  var range = index == null ? null : this.getSelection();
  var oldDelta = this.editor.delta;
  var change = modifier();
  if (range != null) {
    if (index === true) index = range.index;
    if (shift == null) {
      range = shiftRange(range, change, source);
    } else if (shift !== 0) {
      range = shiftRange(range, index, shift, source);
    }
    this.setSelection(range, _emitter4.default.sources.SILENT);
  }
  if (change.length() > 0) {
    var _emitter;

    var args = [_emitter4.default.events.TEXT_CHANGE, change, oldDelta, source];
    (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
    if (source !== _emitter4.default.sources.SILENT) {
      var _emitter2;

      (_emitter2 = this.emitter).emit.apply(_emitter2, args);
    }
  }
  return change;
}

function overload(index, length, name, value, source) {
  var formats = {};
  if (typeof index.index === 'number' && typeof index.length === 'number') {
    // Allow for throwaway end (used by insertText/insertEmbed)
    if (typeof length !== 'number') {
      source = value, value = name, name = length, length = index.length, index = index.index;
    } else {
      length = index.length, index = index.index;
    }
  } else if (typeof length !== 'number') {
    source = value, value = name, name = length, length = 0;
  }
  // Handle format being object, two format name/value strings or excluded
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    formats = name;
    source = value;
  } else if (typeof name === 'string') {
    if (value != null) {
      formats[name] = value;
    } else {
      source = name;
    }
  }
  // Handle optional source
  source = source || _emitter4.default.sources.API;
  return [index, length, formats, source];
}

function shiftRange(range, index, length, source) {
  if (range == null) return null;
  var start = void 0,
      end = void 0;
  if (index instanceof _quillDelta2.default) {
    var _map = [range.index, range.index + range.length].map(function (pos) {
      return index.transformPosition(pos, source !== _emitter4.default.sources.USER);
    });

    var _map2 = _slicedToArray(_map, 2);

    start = _map2[0];
    end = _map2[1];
  } else {
    var _map3 = [range.index, range.index + range.length].map(function (pos) {
      if (pos < index || pos === index && source === _emitter4.default.sources.USER) return pos;
      if (length >= 0) {
        return pos + length;
      } else {
        return Math.max(index, pos + length);
      }
    });

    var _map4 = _slicedToArray(_map3, 2);

    start = _map4[0];
    end = _map4[1];
  }
  return new _selection.Range(start, end - start);
}

exports.expandConfig = expandConfig;
exports.overload = overload;
exports.default = Quill;

/***/ }),
/* 6 */
/***/ (function(module, exports, __nested_webpack_require_58401__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _text = __nested_webpack_require_58401__(7);

var _text2 = _interopRequireDefault(_text);

var _parchment = __nested_webpack_require_58401__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Inline = function (_Parchment$Inline) {
  _inherits(Inline, _Parchment$Inline);

  function Inline() {
    _classCallCheck(this, Inline);

    return _possibleConstructorReturn(this, (Inline.__proto__ || Object.getPrototypeOf(Inline)).apply(this, arguments));
  }

  _createClass(Inline, [{
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (Inline.compare(this.statics.blotName, name) < 0 && _parchment2.default.query(name, _parchment2.default.Scope.BLOT)) {
        var blot = this.isolate(index, length);
        if (value) {
          blot.wrap(name, value);
        }
      } else {
        _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'formatAt', this).call(this, index, length, name, value);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(Inline.prototype.__proto__ || Object.getPrototypeOf(Inline.prototype), 'optimize', this).call(this, context);
      if (this.parent instanceof Inline && Inline.compare(this.statics.blotName, this.parent.statics.blotName) > 0) {
        var parent = this.parent.isolate(this.offset(), this.length());
        this.moveChildren(parent);
        parent.wrap(this);
      }
    }
  }], [{
    key: 'compare',
    value: function compare(self, other) {
      var selfIndex = Inline.order.indexOf(self);
      var otherIndex = Inline.order.indexOf(other);
      if (selfIndex >= 0 || otherIndex >= 0) {
        return selfIndex - otherIndex;
      } else if (self === other) {
        return 0;
      } else if (self < other) {
        return -1;
      } else {
        return 1;
      }
    }
  }]);

  return Inline;
}(_parchment2.default.Inline);

Inline.allowedChildren = [Inline, _parchment2.default.Embed, _text2.default];
// Lower index means deeper in the DOM tree, since not found (-1) is for embeds
Inline.order = ['cursor', 'inline', // Must be lower
'underline', 'strike', 'italic', 'bold', 'script', 'link', 'code' // Must be higher
];

exports.default = Inline;

/***/ }),
/* 7 */
/***/ (function(module, exports, __nested_webpack_require_62823__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __nested_webpack_require_62823__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TextBlot = function (_Parchment$Text) {
  _inherits(TextBlot, _Parchment$Text);

  function TextBlot() {
    _classCallCheck(this, TextBlot);

    return _possibleConstructorReturn(this, (TextBlot.__proto__ || Object.getPrototypeOf(TextBlot)).apply(this, arguments));
  }

  return TextBlot;
}(_parchment2.default.Text);

exports.default = TextBlot;

/***/ }),
/* 8 */
/***/ (function(module, exports, __nested_webpack_require_64422__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _eventemitter = __nested_webpack_require_64422__(54);

var _eventemitter2 = _interopRequireDefault(_eventemitter);

var _logger = __nested_webpack_require_64422__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:events');

var EVENTS = ['selectionchange', 'mousedown', 'mouseup', 'click'];

EVENTS.forEach(function (eventName) {
  document.addEventListener(eventName, function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    [].slice.call(document.querySelectorAll('.ql-container')).forEach(function (node) {
      // TODO use WeakMap
      if (node.__quill && node.__quill.emitter) {
        var _node$__quill$emitter;

        (_node$__quill$emitter = node.__quill.emitter).handleDOM.apply(_node$__quill$emitter, args);
      }
    });
  });
});

var Emitter = function (_EventEmitter) {
  _inherits(Emitter, _EventEmitter);

  function Emitter() {
    _classCallCheck(this, Emitter);

    var _this = _possibleConstructorReturn(this, (Emitter.__proto__ || Object.getPrototypeOf(Emitter)).call(this));

    _this.listeners = {};
    _this.on('error', debug.error);
    return _this;
  }

  _createClass(Emitter, [{
    key: 'emit',
    value: function emit() {
      debug.log.apply(debug, arguments);
      _get(Emitter.prototype.__proto__ || Object.getPrototypeOf(Emitter.prototype), 'emit', this).apply(this, arguments);
    }
  }, {
    key: 'handleDOM',
    value: function handleDOM(event) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      (this.listeners[event.type] || []).forEach(function (_ref) {
        var node = _ref.node,
            handler = _ref.handler;

        if (event.target === node || node.contains(event.target)) {
          handler.apply(undefined, [event].concat(args));
        }
      });
    }
  }, {
    key: 'listenDOM',
    value: function listenDOM(eventName, node, handler) {
      if (!this.listeners[eventName]) {
        this.listeners[eventName] = [];
      }
      this.listeners[eventName].push({ node: node, handler: handler });
    }
  }]);

  return Emitter;
}(_eventemitter2.default);

Emitter.events = {
  EDITOR_CHANGE: 'editor-change',
  SCROLL_BEFORE_UPDATE: 'scroll-before-update',
  SCROLL_OPTIMIZE: 'scroll-optimize',
  SCROLL_UPDATE: 'scroll-update',
  SELECTION_CHANGE: 'selection-change',
  TEXT_CHANGE: 'text-change'
};
Emitter.sources = {
  API: 'api',
  SILENT: 'silent',
  USER: 'user'
};

exports.default = Emitter;

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Module = function Module(quill) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  _classCallCheck(this, Module);

  this.quill = quill;
  this.options = options;
};

Module.DEFAULTS = {};

exports.default = Module;

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var levels = ['error', 'warn', 'log', 'info'];
var level = 'warn';

function debug(method) {
  if (levels.indexOf(method) <= levels.indexOf(level)) {
    var _console;

    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    (_console = console)[method].apply(_console, args); // eslint-disable-line no-console
  }
}

function namespace(ns) {
  return levels.reduce(function (logger, method) {
    logger[method] = debug.bind(console, method, ns);
    return logger;
  }, {});
}

debug.level = namespace.level = function (newLevel) {
  level = newLevel;
};

exports.default = namespace;

/***/ }),
/* 11 */
/***/ (function(module, exports, __nested_webpack_require_70685__) {

var pSlice = Array.prototype.slice;
var objectKeys = __nested_webpack_require_70685__(52);
var isArguments = __nested_webpack_require_70685__(53);

var deepEqual = module.exports = function (actual, expected, opts) {
  if (!opts) opts = {};
  // 7.1. All identical values are equivalent, as determined by ===.
  if (actual === expected) {
    return true;

  } else if (actual instanceof Date && expected instanceof Date) {
    return actual.getTime() === expected.getTime();

  // 7.3. Other pairs that do not both pass typeof value == 'object',
  // equivalence is determined by ==.
  } else if (!actual || !expected || typeof actual != 'object' && typeof expected != 'object') {
    return opts.strict ? actual === expected : actual == expected;

  // 7.4. For all other Object pairs, including Array objects, equivalence is
  // determined by having the same number of owned properties (as verified
  // with Object.prototype.hasOwnProperty.call), the same set of keys
  // (although not necessarily the same order), equivalent values for every
  // corresponding key, and an identical 'prototype' property. Note: this
  // accounts for both named and indexed properties on Arrays.
  } else {
    return objEquiv(actual, expected, opts);
  }
}

function isUndefinedOrNull(value) {
  return value === null || value === undefined;
}

function isBuffer (x) {
  if (!x || typeof x !== 'object' || typeof x.length !== 'number') return false;
  if (typeof x.copy !== 'function' || typeof x.slice !== 'function') {
    return false;
  }
  if (x.length > 0 && typeof x[0] !== 'number') return false;
  return true;
}

function objEquiv(a, b, opts) {
  var i, key;
  if (isUndefinedOrNull(a) || isUndefinedOrNull(b))
    return false;
  // an identical 'prototype' property.
  if (a.prototype !== b.prototype) return false;
  //~~~I've managed to break Object.keys through screwy arguments passing.
  //   Converting to array solves the problem.
  if (isArguments(a)) {
    if (!isArguments(b)) {
      return false;
    }
    a = pSlice.call(a);
    b = pSlice.call(b);
    return deepEqual(a, b, opts);
  }
  if (isBuffer(a)) {
    if (!isBuffer(b)) {
      return false;
    }
    if (a.length !== b.length) return false;
    for (i = 0; i < a.length; i++) {
      if (a[i] !== b[i]) return false;
    }
    return true;
  }
  try {
    var ka = objectKeys(a),
        kb = objectKeys(b);
  } catch (e) {//happens when one is a string literal and the other isn't
    return false;
  }
  // having the same number of owned properties (keys incorporates
  // hasOwnProperty)
  if (ka.length != kb.length)
    return false;
  //the same set of keys (although not necessarily the same order),
  ka.sort();
  kb.sort();
  //~~~cheap key test
  for (i = ka.length - 1; i >= 0; i--) {
    if (ka[i] != kb[i])
      return false;
  }
  //equivalent values for every corresponding key, and
  //~~~possibly expensive deep test
  for (i = ka.length - 1; i >= 0; i--) {
    key = ka[i];
    if (!deepEqual(a[key], b[key], opts)) return false;
  }
  return typeof a === typeof b;
}


/***/ }),
/* 12 */
/***/ (function(module, exports, __nested_webpack_require_73804__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __nested_webpack_require_73804__(1);
var Attributor = /** @class */ (function () {
    function Attributor(attrName, keyName, options) {
        if (options === void 0) { options = {}; }
        this.attrName = attrName;
        this.keyName = keyName;
        var attributeBit = Registry.Scope.TYPE & Registry.Scope.ATTRIBUTE;
        if (options.scope != null) {
            // Ignore type bits, force attribute bit
            this.scope = (options.scope & Registry.Scope.LEVEL) | attributeBit;
        }
        else {
            this.scope = Registry.Scope.ATTRIBUTE;
        }
        if (options.whitelist != null)
            this.whitelist = options.whitelist;
    }
    Attributor.keys = function (node) {
        return [].map.call(node.attributes, function (item) {
            return item.name;
        });
    };
    Attributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        node.setAttribute(this.keyName, value);
        return true;
    };
    Attributor.prototype.canAdd = function (node, value) {
        var match = Registry.query(node, Registry.Scope.BLOT & (this.scope | Registry.Scope.TYPE));
        if (match == null)
            return false;
        if (this.whitelist == null)
            return true;
        if (typeof value === 'string') {
            return this.whitelist.indexOf(value.replace(/["']/g, '')) > -1;
        }
        else {
            return this.whitelist.indexOf(value) > -1;
        }
    };
    Attributor.prototype.remove = function (node) {
        node.removeAttribute(this.keyName);
    };
    Attributor.prototype.value = function (node) {
        var value = node.getAttribute(this.keyName);
        if (this.canAdd(node, value) && value) {
            return value;
        }
        return '';
    };
    return Attributor;
}());
exports.default = Attributor;


/***/ }),
/* 13 */
/***/ (function(module, exports, __nested_webpack_require_75851__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Code = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _quillDelta = __nested_webpack_require_75851__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __nested_webpack_require_75851__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __nested_webpack_require_75851__(4);

var _block2 = _interopRequireDefault(_block);

var _inline = __nested_webpack_require_75851__(6);

var _inline2 = _interopRequireDefault(_inline);

var _text = __nested_webpack_require_75851__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Code = function (_Inline) {
  _inherits(Code, _Inline);

  function Code() {
    _classCallCheck(this, Code);

    return _possibleConstructorReturn(this, (Code.__proto__ || Object.getPrototypeOf(Code)).apply(this, arguments));
  }

  return Code;
}(_inline2.default);

Code.blotName = 'code';
Code.tagName = 'CODE';

var CodeBlock = function (_Block) {
  _inherits(CodeBlock, _Block);

  function CodeBlock() {
    _classCallCheck(this, CodeBlock);

    return _possibleConstructorReturn(this, (CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock)).apply(this, arguments));
  }

  _createClass(CodeBlock, [{
    key: 'delta',
    value: function delta() {
      var _this3 = this;

      var text = this.domNode.textContent;
      if (text.endsWith('\n')) {
        // Should always be true
        text = text.slice(0, -1);
      }
      return text.split('\n').reduce(function (delta, frag) {
        return delta.insert(frag).insert('\n', _this3.formats());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (name === this.statics.blotName && value) return;

      var _descendant = this.descendant(_text2.default, this.length() - 1),
          _descendant2 = _slicedToArray(_descendant, 1),
          text = _descendant2[0];

      if (text != null) {
        text.deleteAt(text.length() - 1, 1);
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'format', this).call(this, name, value);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, name, value) {
      if (length === 0) return;
      if (_parchment2.default.query(name, _parchment2.default.Scope.BLOCK) == null || name === this.statics.blotName && value === this.statics.formats(this.domNode)) {
        return;
      }
      var nextNewline = this.newlineIndex(index);
      if (nextNewline < 0 || nextNewline >= index + length) return;
      var prevNewline = this.newlineIndex(index, true) + 1;
      var isolateLength = nextNewline - prevNewline + 1;
      var blot = this.isolate(prevNewline, isolateLength);
      var next = blot.next;
      blot.format(name, value);
      if (next instanceof CodeBlock) {
        next.formatAt(0, index - prevNewline + length - isolateLength, name, value);
      }
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null) return;

      var _descendant3 = this.descendant(_text2.default, index),
          _descendant4 = _slicedToArray(_descendant3, 2),
          text = _descendant4[0],
          offset = _descendant4[1];

      text.insertAt(offset, value);
    }
  }, {
    key: 'length',
    value: function length() {
      var length = this.domNode.textContent.length;
      if (!this.domNode.textContent.endsWith('\n')) {
        return length + 1;
      }
      return length;
    }
  }, {
    key: 'newlineIndex',
    value: function newlineIndex(searchIndex) {
      var reverse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (!reverse) {
        var offset = this.domNode.textContent.slice(searchIndex).indexOf('\n');
        return offset > -1 ? searchIndex + offset : -1;
      } else {
        return this.domNode.textContent.slice(0, searchIndex).lastIndexOf('\n');
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      if (!this.domNode.textContent.endsWith('\n')) {
        this.appendChild(_parchment2.default.create('text', '\n'));
      }
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && this.statics.formats(this.domNode) === next.statics.formats(next.domNode)) {
        next.optimize(context);
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      _get(CodeBlock.prototype.__proto__ || Object.getPrototypeOf(CodeBlock.prototype), 'replace', this).call(this, target);
      [].slice.call(this.domNode.querySelectorAll('*')).forEach(function (node) {
        var blot = _parchment2.default.find(node);
        if (blot == null) {
          node.parentNode.removeChild(node);
        } else if (blot instanceof _parchment2.default.Embed) {
          blot.remove();
        } else {
          blot.unwrap();
        }
      });
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var domNode = _get(CodeBlock.__proto__ || Object.getPrototypeOf(CodeBlock), 'create', this).call(this, value);
      domNode.setAttribute('spellcheck', false);
      return domNode;
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return CodeBlock;
}(_block2.default);

CodeBlock.blotName = 'code-block';
CodeBlock.tagName = 'PRE';
CodeBlock.TAB = '  ';

exports.Code = Code;
exports.default = CodeBlock;

/***/ }),
/* 14 */
/***/ (function(module, exports, __nested_webpack_require_84272__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __nested_webpack_require_84272__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __nested_webpack_require_84272__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __nested_webpack_require_84272__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _code = __nested_webpack_require_84272__(13);

var _code2 = _interopRequireDefault(_code);

var _cursor = __nested_webpack_require_84272__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _block = __nested_webpack_require_84272__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __nested_webpack_require_84272__(16);

var _break2 = _interopRequireDefault(_break);

var _clone = __nested_webpack_require_84272__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __nested_webpack_require_84272__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __nested_webpack_require_84272__(3);

var _extend2 = _interopRequireDefault(_extend);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var ASCII = /^[ -~]*$/;

var Editor = function () {
  function Editor(scroll) {
    _classCallCheck(this, Editor);

    this.scroll = scroll;
    this.delta = this.getDelta();
  }

  _createClass(Editor, [{
    key: 'applyDelta',
    value: function applyDelta(delta) {
      var _this = this;

      var consumeNextNewline = false;
      this.scroll.update();
      var scrollLength = this.scroll.length();
      this.scroll.batchStart();
      delta = normalizeDelta(delta);
      delta.reduce(function (index, op) {
        var length = op.retain || op.delete || op.insert.length || 1;
        var attributes = op.attributes || {};
        if (op.insert != null) {
          if (typeof op.insert === 'string') {
            var text = op.insert;
            if (text.endsWith('\n') && consumeNextNewline) {
              consumeNextNewline = false;
              text = text.slice(0, -1);
            }
            if (index >= scrollLength && !text.endsWith('\n')) {
              consumeNextNewline = true;
            }
            _this.scroll.insertAt(index, text);

            var _scroll$line = _this.scroll.line(index),
                _scroll$line2 = _slicedToArray(_scroll$line, 2),
                line = _scroll$line2[0],
                offset = _scroll$line2[1];

            var formats = (0, _extend2.default)({}, (0, _block.bubbleFormats)(line));
            if (line instanceof _block2.default) {
              var _line$descendant = line.descendant(_parchment2.default.Leaf, offset),
                  _line$descendant2 = _slicedToArray(_line$descendant, 1),
                  leaf = _line$descendant2[0];

              formats = (0, _extend2.default)(formats, (0, _block.bubbleFormats)(leaf));
            }
            attributes = _op2.default.attributes.diff(formats, attributes) || {};
          } else if (_typeof(op.insert) === 'object') {
            var key = Object.keys(op.insert)[0]; // There should only be one key
            if (key == null) return index;
            _this.scroll.insertAt(index, key, op.insert[key]);
          }
          scrollLength += length;
        }
        Object.keys(attributes).forEach(function (name) {
          _this.scroll.formatAt(index, length, name, attributes[name]);
        });
        return index + length;
      }, 0);
      delta.reduce(function (index, op) {
        if (typeof op.delete === 'number') {
          _this.scroll.deleteAt(index, op.delete);
          return index;
        }
        return index + (op.retain || op.insert.length || 1);
      }, 0);
      this.scroll.batchEnd();
      return this.update(delta);
    }
  }, {
    key: 'deleteText',
    value: function deleteText(index, length) {
      this.scroll.deleteAt(index, length);
      return this.update(new _quillDelta2.default().retain(index).delete(length));
    }
  }, {
    key: 'formatLine',
    value: function formatLine(index, length) {
      var _this2 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      this.scroll.update();
      Object.keys(formats).forEach(function (format) {
        if (_this2.scroll.whitelist != null && !_this2.scroll.whitelist[format]) return;
        var lines = _this2.scroll.lines(index, Math.max(length, 1));
        var lengthRemaining = length;
        lines.forEach(function (line) {
          var lineLength = line.length();
          if (!(line instanceof _code2.default)) {
            line.format(format, formats[format]);
          } else {
            var codeIndex = index - line.offset(_this2.scroll);
            var codeLength = line.newlineIndex(codeIndex + lengthRemaining) - codeIndex + 1;
            line.formatAt(codeIndex, codeLength, format, formats[format]);
          }
          lengthRemaining -= lineLength;
        });
      });
      this.scroll.optimize();
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'formatText',
    value: function formatText(index, length) {
      var _this3 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      Object.keys(formats).forEach(function (format) {
        _this3.scroll.formatAt(index, length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).retain(length, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'getContents',
    value: function getContents(index, length) {
      return this.delta.slice(index, index + length);
    }
  }, {
    key: 'getDelta',
    value: function getDelta() {
      return this.scroll.lines().reduce(function (delta, line) {
        return delta.concat(line.delta());
      }, new _quillDelta2.default());
    }
  }, {
    key: 'getFormat',
    value: function getFormat(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var lines = [],
          leaves = [];
      if (length === 0) {
        this.scroll.path(index).forEach(function (path) {
          var _path = _slicedToArray(path, 1),
              blot = _path[0];

          if (blot instanceof _block2.default) {
            lines.push(blot);
          } else if (blot instanceof _parchment2.default.Leaf) {
            leaves.push(blot);
          }
        });
      } else {
        lines = this.scroll.lines(index, length);
        leaves = this.scroll.descendants(_parchment2.default.Leaf, index, length);
      }
      var formatsArr = [lines, leaves].map(function (blots) {
        if (blots.length === 0) return {};
        var formats = (0, _block.bubbleFormats)(blots.shift());
        while (Object.keys(formats).length > 0) {
          var blot = blots.shift();
          if (blot == null) return formats;
          formats = combineFormats((0, _block.bubbleFormats)(blot), formats);
        }
        return formats;
      });
      return _extend2.default.apply(_extend2.default, formatsArr);
    }
  }, {
    key: 'getText',
    value: function getText(index, length) {
      return this.getContents(index, length).filter(function (op) {
        return typeof op.insert === 'string';
      }).map(function (op) {
        return op.insert;
      }).join('');
    }
  }, {
    key: 'insertEmbed',
    value: function insertEmbed(index, embed, value) {
      this.scroll.insertAt(index, embed, value);
      return this.update(new _quillDelta2.default().retain(index).insert(_defineProperty({}, embed, value)));
    }
  }, {
    key: 'insertText',
    value: function insertText(index, text) {
      var _this4 = this;

      var formats = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      text = text.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      this.scroll.insertAt(index, text);
      Object.keys(formats).forEach(function (format) {
        _this4.scroll.formatAt(index, text.length, format, formats[format]);
      });
      return this.update(new _quillDelta2.default().retain(index).insert(text, (0, _clone2.default)(formats)));
    }
  }, {
    key: 'isBlank',
    value: function isBlank() {
      if (this.scroll.children.length == 0) return true;
      if (this.scroll.children.length > 1) return false;
      var block = this.scroll.children.head;
      if (block.statics.blotName !== _block2.default.blotName) return false;
      if (block.children.length > 1) return false;
      return block.children.head instanceof _break2.default;
    }
  }, {
    key: 'removeFormat',
    value: function removeFormat(index, length) {
      var text = this.getText(index, length);

      var _scroll$line3 = this.scroll.line(index + length),
          _scroll$line4 = _slicedToArray(_scroll$line3, 2),
          line = _scroll$line4[0],
          offset = _scroll$line4[1];

      var suffixLength = 0,
          suffix = new _quillDelta2.default();
      if (line != null) {
        if (!(line instanceof _code2.default)) {
          suffixLength = line.length() - offset;
        } else {
          suffixLength = line.newlineIndex(offset) - offset + 1;
        }
        suffix = line.delta().slice(offset, offset + suffixLength - 1).insert('\n');
      }
      var contents = this.getContents(index, length + suffixLength);
      var diff = contents.diff(new _quillDelta2.default().insert(text).concat(suffix));
      var delta = new _quillDelta2.default().retain(index).concat(diff);
      return this.applyDelta(delta);
    }
  }, {
    key: 'update',
    value: function update(change) {
      var mutations = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var cursorIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

      var oldDelta = this.delta;
      if (mutations.length === 1 && mutations[0].type === 'characterData' && mutations[0].target.data.match(ASCII) && _parchment2.default.find(mutations[0].target)) {
        // Optimization for character changes
        var textBlot = _parchment2.default.find(mutations[0].target);
        var formats = (0, _block.bubbleFormats)(textBlot);
        var index = textBlot.offset(this.scroll);
        var oldValue = mutations[0].oldValue.replace(_cursor2.default.CONTENTS, '');
        var oldText = new _quillDelta2.default().insert(oldValue);
        var newText = new _quillDelta2.default().insert(textBlot.value());
        var diffDelta = new _quillDelta2.default().retain(index).concat(oldText.diff(newText, cursorIndex));
        change = diffDelta.reduce(function (delta, op) {
          if (op.insert) {
            return delta.insert(op.insert, formats);
          } else {
            return delta.push(op);
          }
        }, new _quillDelta2.default());
        this.delta = oldDelta.compose(change);
      } else {
        this.delta = this.getDelta();
        if (!change || !(0, _deepEqual2.default)(oldDelta.compose(change), this.delta)) {
          change = oldDelta.diff(this.delta, cursorIndex);
        }
      }
      return change;
    }
  }]);

  return Editor;
}();

function combineFormats(formats, combined) {
  return Object.keys(combined).reduce(function (merged, name) {
    if (formats[name] == null) return merged;
    if (combined[name] === formats[name]) {
      merged[name] = combined[name];
    } else if (Array.isArray(combined[name])) {
      if (combined[name].indexOf(formats[name]) < 0) {
        merged[name] = combined[name].concat([formats[name]]);
      }
    } else {
      merged[name] = [combined[name], formats[name]];
    }
    return merged;
  }, {});
}

function normalizeDelta(delta) {
  return delta.reduce(function (delta, op) {
    if (op.insert === 1) {
      var attributes = (0, _clone2.default)(op.attributes);
      delete attributes['image'];
      return delta.insert({ image: op.attributes.image }, attributes);
    }
    if (op.attributes != null && (op.attributes.list === true || op.attributes.bullet === true)) {
      op = (0, _clone2.default)(op);
      if (op.attributes.list) {
        op.attributes.list = 'ordered';
      } else {
        op.attributes.list = 'bullet';
        delete op.attributes.bullet;
      }
    }
    if (typeof op.insert === 'string') {
      var text = op.insert.replace(/\r\n/g, '\n').replace(/\r/g, '\n');
      return delta.insert(text, op.attributes);
    }
    return delta.push(op);
  }, new _quillDelta2.default());
}

exports.default = Editor;

/***/ }),
/* 15 */
/***/ (function(module, exports, __nested_webpack_require_98688__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Range = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __nested_webpack_require_98688__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _clone = __nested_webpack_require_98688__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __nested_webpack_require_98688__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _emitter3 = __nested_webpack_require_98688__(8);

var _emitter4 = _interopRequireDefault(_emitter3);

var _logger = __nested_webpack_require_98688__(10);

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var debug = (0, _logger2.default)('quill:selection');

var Range = function Range(index) {
  var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  _classCallCheck(this, Range);

  this.index = index;
  this.length = length;
};

var Selection = function () {
  function Selection(scroll, emitter) {
    var _this = this;

    _classCallCheck(this, Selection);

    this.emitter = emitter;
    this.scroll = scroll;
    this.composing = false;
    this.mouseDown = false;
    this.root = this.scroll.domNode;
    this.cursor = _parchment2.default.create('cursor', this);
    // savedRange is last non-null range
    this.lastRange = this.savedRange = new Range(0, 0);
    this.handleComposition();
    this.handleDragging();
    this.emitter.listenDOM('selectionchange', document, function () {
      if (!_this.mouseDown) {
        setTimeout(_this.update.bind(_this, _emitter4.default.sources.USER), 1);
      }
    });
    this.emitter.on(_emitter4.default.events.EDITOR_CHANGE, function (type, delta) {
      if (type === _emitter4.default.events.TEXT_CHANGE && delta.length() > 0) {
        _this.update(_emitter4.default.sources.SILENT);
      }
    });
    this.emitter.on(_emitter4.default.events.SCROLL_BEFORE_UPDATE, function () {
      if (!_this.hasFocus()) return;
      var native = _this.getNativeRange();
      if (native == null) return;
      if (native.start.node === _this.cursor.textNode) return; // cursor.restore() will handle
      // TODO unclear if this has negative side effects
      _this.emitter.once(_emitter4.default.events.SCROLL_UPDATE, function () {
        try {
          _this.setNativeRange(native.start.node, native.start.offset, native.end.node, native.end.offset);
        } catch (ignored) {}
      });
    });
    this.emitter.on(_emitter4.default.events.SCROLL_OPTIMIZE, function (mutations, context) {
      if (context.range) {
        var _context$range = context.range,
            startNode = _context$range.startNode,
            startOffset = _context$range.startOffset,
            endNode = _context$range.endNode,
            endOffset = _context$range.endOffset;

        _this.setNativeRange(startNode, startOffset, endNode, endOffset);
      }
    });
    this.update(_emitter4.default.sources.SILENT);
  }

  _createClass(Selection, [{
    key: 'handleComposition',
    value: function handleComposition() {
      var _this2 = this;

      this.root.addEventListener('compositionstart', function () {
        _this2.composing = true;
      });
      this.root.addEventListener('compositionend', function () {
        _this2.composing = false;
        if (_this2.cursor.parent) {
          var range = _this2.cursor.restore();
          if (!range) return;
          setTimeout(function () {
            _this2.setNativeRange(range.startNode, range.startOffset, range.endNode, range.endOffset);
          }, 1);
        }
      });
    }
  }, {
    key: 'handleDragging',
    value: function handleDragging() {
      var _this3 = this;

      this.emitter.listenDOM('mousedown', document.body, function () {
        _this3.mouseDown = true;
      });
      this.emitter.listenDOM('mouseup', document.body, function () {
        _this3.mouseDown = false;
        _this3.update(_emitter4.default.sources.USER);
      });
    }
  }, {
    key: 'focus',
    value: function focus() {
      if (this.hasFocus()) return;
      this.root.focus();
      this.setRange(this.savedRange);
    }
  }, {
    key: 'format',
    value: function format(_format, value) {
      if (this.scroll.whitelist != null && !this.scroll.whitelist[_format]) return;
      this.scroll.update();
      var nativeRange = this.getNativeRange();
      if (nativeRange == null || !nativeRange.native.collapsed || _parchment2.default.query(_format, _parchment2.default.Scope.BLOCK)) return;
      if (nativeRange.start.node !== this.cursor.textNode) {
        var blot = _parchment2.default.find(nativeRange.start.node, false);
        if (blot == null) return;
        // TODO Give blot ability to not split
        if (blot instanceof _parchment2.default.Leaf) {
          var after = blot.split(nativeRange.start.offset);
          blot.parent.insertBefore(this.cursor, after);
        } else {
          blot.insertBefore(this.cursor, nativeRange.start.node); // Should never happen
        }
        this.cursor.attach();
      }
      this.cursor.format(_format, value);
      this.scroll.optimize();
      this.setNativeRange(this.cursor.textNode, this.cursor.textNode.data.length);
      this.update();
    }
  }, {
    key: 'getBounds',
    value: function getBounds(index) {
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var scrollLength = this.scroll.length();
      index = Math.min(index, scrollLength - 1);
      length = Math.min(index + length, scrollLength - 1) - index;
      var node = void 0,
          _scroll$leaf = this.scroll.leaf(index),
          _scroll$leaf2 = _slicedToArray(_scroll$leaf, 2),
          leaf = _scroll$leaf2[0],
          offset = _scroll$leaf2[1];
      if (leaf == null) return null;

      var _leaf$position = leaf.position(offset, true);

      var _leaf$position2 = _slicedToArray(_leaf$position, 2);

      node = _leaf$position2[0];
      offset = _leaf$position2[1];

      var range = document.createRange();
      if (length > 0) {
        range.setStart(node, offset);

        var _scroll$leaf3 = this.scroll.leaf(index + length);

        var _scroll$leaf4 = _slicedToArray(_scroll$leaf3, 2);

        leaf = _scroll$leaf4[0];
        offset = _scroll$leaf4[1];

        if (leaf == null) return null;

        var _leaf$position3 = leaf.position(offset, true);

        var _leaf$position4 = _slicedToArray(_leaf$position3, 2);

        node = _leaf$position4[0];
        offset = _leaf$position4[1];

        range.setEnd(node, offset);
        return range.getBoundingClientRect();
      } else {
        var side = 'left';
        var rect = void 0;
        if (node instanceof Text) {
          if (offset < node.data.length) {
            range.setStart(node, offset);
            range.setEnd(node, offset + 1);
          } else {
            range.setStart(node, offset - 1);
            range.setEnd(node, offset);
            side = 'right';
          }
          rect = range.getBoundingClientRect();
        } else {
          rect = leaf.domNode.getBoundingClientRect();
          if (offset > 0) side = 'right';
        }
        return {
          bottom: rect.top + rect.height,
          height: rect.height,
          left: rect[side],
          right: rect[side],
          top: rect.top,
          width: 0
        };
      }
    }
  }, {
    key: 'getNativeRange',
    value: function getNativeRange() {
      var selection = document.getSelection();
      if (selection == null || selection.rangeCount <= 0) return null;
      var nativeRange = selection.getRangeAt(0);
      if (nativeRange == null) return null;
      var range = this.normalizeNative(nativeRange);
      debug.info('getNativeRange', range);
      return range;
    }
  }, {
    key: 'getRange',
    value: function getRange() {
      var normalized = this.getNativeRange();
      if (normalized == null) return [null, null];
      var range = this.normalizedToRange(normalized);
      return [range, normalized];
    }
  }, {
    key: 'hasFocus',
    value: function hasFocus() {
      return document.activeElement === this.root;
    }
  }, {
    key: 'normalizedToRange',
    value: function normalizedToRange(range) {
      var _this4 = this;

      var positions = [[range.start.node, range.start.offset]];
      if (!range.native.collapsed) {
        positions.push([range.end.node, range.end.offset]);
      }
      var indexes = positions.map(function (position) {
        var _position = _slicedToArray(position, 2),
            node = _position[0],
            offset = _position[1];

        var blot = _parchment2.default.find(node, true);
        var index = blot.offset(_this4.scroll);
        if (offset === 0) {
          return index;
        } else if (blot instanceof _parchment2.default.Container) {
          return index + blot.length();
        } else {
          return index + blot.index(node, offset);
        }
      });
      var end = Math.min(Math.max.apply(Math, _toConsumableArray(indexes)), this.scroll.length() - 1);
      var start = Math.min.apply(Math, [end].concat(_toConsumableArray(indexes)));
      return new Range(start, end - start);
    }
  }, {
    key: 'normalizeNative',
    value: function normalizeNative(nativeRange) {
      if (!contains(this.root, nativeRange.startContainer) || !nativeRange.collapsed && !contains(this.root, nativeRange.endContainer)) {
        return null;
      }
      var range = {
        start: { node: nativeRange.startContainer, offset: nativeRange.startOffset },
        end: { node: nativeRange.endContainer, offset: nativeRange.endOffset },
        native: nativeRange
      };
      [range.start, range.end].forEach(function (position) {
        var node = position.node,
            offset = position.offset;
        while (!(node instanceof Text) && node.childNodes.length > 0) {
          if (node.childNodes.length > offset) {
            node = node.childNodes[offset];
            offset = 0;
          } else if (node.childNodes.length === offset) {
            node = node.lastChild;
            offset = node instanceof Text ? node.data.length : node.childNodes.length + 1;
          } else {
            break;
          }
        }
        position.node = node, position.offset = offset;
      });
      return range;
    }
  }, {
    key: 'rangeToNative',
    value: function rangeToNative(range) {
      var _this5 = this;

      var indexes = range.collapsed ? [range.index] : [range.index, range.index + range.length];
      var args = [];
      var scrollLength = this.scroll.length();
      indexes.forEach(function (index, i) {
        index = Math.min(scrollLength - 1, index);
        var node = void 0,
            _scroll$leaf5 = _this5.scroll.leaf(index),
            _scroll$leaf6 = _slicedToArray(_scroll$leaf5, 2),
            leaf = _scroll$leaf6[0],
            offset = _scroll$leaf6[1];
        var _leaf$position5 = leaf.position(offset, i !== 0);

        var _leaf$position6 = _slicedToArray(_leaf$position5, 2);

        node = _leaf$position6[0];
        offset = _leaf$position6[1];

        args.push(node, offset);
      });
      if (args.length < 2) {
        args = args.concat(args);
      }
      return args;
    }
  }, {
    key: 'scrollIntoView',
    value: function scrollIntoView(scrollingContainer) {
      var range = this.lastRange;
      if (range == null) return;
      var bounds = this.getBounds(range.index, range.length);
      if (bounds == null) return;
      var limit = this.scroll.length() - 1;

      var _scroll$line = this.scroll.line(Math.min(range.index, limit)),
          _scroll$line2 = _slicedToArray(_scroll$line, 1),
          first = _scroll$line2[0];

      var last = first;
      if (range.length > 0) {
        var _scroll$line3 = this.scroll.line(Math.min(range.index + range.length, limit));

        var _scroll$line4 = _slicedToArray(_scroll$line3, 1);

        last = _scroll$line4[0];
      }
      if (first == null || last == null) return;
      var scrollBounds = scrollingContainer.getBoundingClientRect();
      if (bounds.top < scrollBounds.top) {
        scrollingContainer.scrollTop -= scrollBounds.top - bounds.top;
      } else if (bounds.bottom > scrollBounds.bottom) {
        scrollingContainer.scrollTop += bounds.bottom - scrollBounds.bottom;
      }
    }
  }, {
    key: 'setNativeRange',
    value: function setNativeRange(startNode, startOffset) {
      var endNode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : startNode;
      var endOffset = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : startOffset;
      var force = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;

      debug.info('setNativeRange', startNode, startOffset, endNode, endOffset);
      if (startNode != null && (this.root.parentNode == null || startNode.parentNode == null || endNode.parentNode == null)) {
        return;
      }
      var selection = document.getSelection();
      if (selection == null) return;
      if (startNode != null) {
        if (!this.hasFocus()) this.root.focus();
        var native = (this.getNativeRange() || {}).native;
        if (native == null || force || startNode !== native.startContainer || startOffset !== native.startOffset || endNode !== native.endContainer || endOffset !== native.endOffset) {

          if (startNode.tagName == "BR") {
            startOffset = [].indexOf.call(startNode.parentNode.childNodes, startNode);
            startNode = startNode.parentNode;
          }
          if (endNode.tagName == "BR") {
            endOffset = [].indexOf.call(endNode.parentNode.childNodes, endNode);
            endNode = endNode.parentNode;
          }
          var range = document.createRange();
          range.setStart(startNode, startOffset);
          range.setEnd(endNode, endOffset);
          selection.removeAllRanges();
          selection.addRange(range);
        }
      } else {
        selection.removeAllRanges();
        this.root.blur();
        document.body.focus(); // root.blur() not enough on IE11+Travis+SauceLabs (but not local VMs)
      }
    }
  }, {
    key: 'setRange',
    value: function setRange(range) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _emitter4.default.sources.API;

      if (typeof force === 'string') {
        source = force;
        force = false;
      }
      debug.info('setRange', range);
      if (range != null) {
        var args = this.rangeToNative(range);
        this.setNativeRange.apply(this, _toConsumableArray(args).concat([force]));
      } else {
        this.setNativeRange(null);
      }
      this.update(source);
    }
  }, {
    key: 'update',
    value: function update() {
      var source = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _emitter4.default.sources.USER;

      var oldRange = this.lastRange;

      var _getRange = this.getRange(),
          _getRange2 = _slicedToArray(_getRange, 2),
          lastRange = _getRange2[0],
          nativeRange = _getRange2[1];

      this.lastRange = lastRange;
      if (this.lastRange != null) {
        this.savedRange = this.lastRange;
      }
      if (!(0, _deepEqual2.default)(oldRange, this.lastRange)) {
        var _emitter;

        if (!this.composing && nativeRange != null && nativeRange.native.collapsed && nativeRange.start.node !== this.cursor.textNode) {
          this.cursor.restore();
        }
        var args = [_emitter4.default.events.SELECTION_CHANGE, (0, _clone2.default)(this.lastRange), (0, _clone2.default)(oldRange), source];
        (_emitter = this.emitter).emit.apply(_emitter, [_emitter4.default.events.EDITOR_CHANGE].concat(args));
        if (source !== _emitter4.default.sources.SILENT) {
          var _emitter2;

          (_emitter2 = this.emitter).emit.apply(_emitter2, args);
        }
      }
    }
  }]);

  return Selection;
}();

function contains(parent, descendant) {
  try {
    // Firefox inserts inaccessible nodes around video elements
    descendant.parentNode;
  } catch (e) {
    return false;
  }
  // IE11 has bug with Text nodes
  // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
  if (descendant instanceof Text) {
    descendant = descendant.parentNode;
  }
  return parent.contains(descendant);
}

exports.Range = Range;
exports.default = Selection;

/***/ }),
/* 16 */
/***/ (function(module, exports, __nested_webpack_require_116908__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_116908__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Break = function (_Parchment$Embed) {
  _inherits(Break, _Parchment$Embed);

  function Break() {
    _classCallCheck(this, Break);

    return _possibleConstructorReturn(this, (Break.__proto__ || Object.getPrototypeOf(Break)).apply(this, arguments));
  }

  _createClass(Break, [{
    key: 'insertInto',
    value: function insertInto(parent, ref) {
      if (parent.children.length === 0) {
        _get(Break.prototype.__proto__ || Object.getPrototypeOf(Break.prototype), 'insertInto', this).call(this, parent, ref);
      } else {
        this.remove();
      }
    }
  }, {
    key: 'length',
    value: function length() {
      return 0;
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }], [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  return Break;
}(_parchment2.default.Embed);

Break.blotName = 'break';
Break.tagName = 'BR';

exports.default = Break;

/***/ }),
/* 17 */
/***/ (function(module, exports, __nested_webpack_require_120162__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var linked_list_1 = __nested_webpack_require_120162__(44);
var shadow_1 = __nested_webpack_require_120162__(30);
var Registry = __nested_webpack_require_120162__(1);
var ContainerBlot = /** @class */ (function (_super) {
    __extends(ContainerBlot, _super);
    function ContainerBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.build();
        return _this;
    }
    ContainerBlot.prototype.appendChild = function (other) {
        this.insertBefore(other);
    };
    ContainerBlot.prototype.attach = function () {
        _super.prototype.attach.call(this);
        this.children.forEach(function (child) {
            child.attach();
        });
    };
    ContainerBlot.prototype.build = function () {
        var _this = this;
        this.children = new linked_list_1.default();
        // Need to be reversed for if DOM nodes already in order
        [].slice
            .call(this.domNode.childNodes)
            .reverse()
            .forEach(function (node) {
            try {
                var child = makeBlot(node);
                _this.insertBefore(child, _this.children.head || undefined);
            }
            catch (err) {
                if (err instanceof Registry.ParchmentError)
                    return;
                else
                    throw err;
            }
        });
    };
    ContainerBlot.prototype.deleteAt = function (index, length) {
        if (index === 0 && length === this.length()) {
            return this.remove();
        }
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.deleteAt(offset, length);
        });
    };
    ContainerBlot.prototype.descendant = function (criteria, index) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if ((criteria.blotName == null && criteria(child)) ||
            (criteria.blotName != null && child instanceof criteria)) {
            return [child, offset];
        }
        else if (child instanceof ContainerBlot) {
            return child.descendant(criteria, offset);
        }
        else {
            return [null, -1];
        }
    };
    ContainerBlot.prototype.descendants = function (criteria, index, length) {
        if (index === void 0) { index = 0; }
        if (length === void 0) { length = Number.MAX_VALUE; }
        var descendants = [];
        var lengthLeft = length;
        this.children.forEachAt(index, length, function (child, index, length) {
            if ((criteria.blotName == null && criteria(child)) ||
                (criteria.blotName != null && child instanceof criteria)) {
                descendants.push(child);
            }
            if (child instanceof ContainerBlot) {
                descendants = descendants.concat(child.descendants(criteria, index, lengthLeft));
            }
            lengthLeft -= length;
        });
        return descendants;
    };
    ContainerBlot.prototype.detach = function () {
        this.children.forEach(function (child) {
            child.detach();
        });
        _super.prototype.detach.call(this);
    };
    ContainerBlot.prototype.formatAt = function (index, length, name, value) {
        this.children.forEachAt(index, length, function (child, offset, length) {
            child.formatAt(offset, length, name, value);
        });
    };
    ContainerBlot.prototype.insertAt = function (index, value, def) {
        var _a = this.children.find(index), child = _a[0], offset = _a[1];
        if (child) {
            child.insertAt(offset, value, def);
        }
        else {
            var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
            this.appendChild(blot);
        }
    };
    ContainerBlot.prototype.insertBefore = function (childBlot, refBlot) {
        if (this.statics.allowedChildren != null &&
            !this.statics.allowedChildren.some(function (child) {
                return childBlot instanceof child;
            })) {
            throw new Registry.ParchmentError("Cannot insert " + childBlot.statics.blotName + " into " + this.statics.blotName);
        }
        childBlot.insertInto(this, refBlot);
    };
    ContainerBlot.prototype.length = function () {
        return this.children.reduce(function (memo, child) {
            return memo + child.length();
        }, 0);
    };
    ContainerBlot.prototype.moveChildren = function (targetParent, refNode) {
        this.children.forEach(function (child) {
            targetParent.insertBefore(child, refNode);
        });
    };
    ContainerBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        if (this.children.length === 0) {
            if (this.statics.defaultChild != null) {
                var child = Registry.create(this.statics.defaultChild);
                this.appendChild(child);
                child.optimize(context);
            }
            else {
                this.remove();
            }
        }
    };
    ContainerBlot.prototype.path = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var _a = this.children.find(index, inclusive), child = _a[0], offset = _a[1];
        var position = [[this, index]];
        if (child instanceof ContainerBlot) {
            return position.concat(child.path(offset, inclusive));
        }
        else if (child != null) {
            position.push([child, offset]);
        }
        return position;
    };
    ContainerBlot.prototype.removeChild = function (child) {
        this.children.remove(child);
    };
    ContainerBlot.prototype.replace = function (target) {
        if (target instanceof ContainerBlot) {
            target.moveChildren(this);
        }
        _super.prototype.replace.call(this, target);
    };
    ContainerBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = this.clone();
        this.parent.insertBefore(after, this.next);
        this.children.forEachAt(index, this.length(), function (child, offset, length) {
            child = child.split(offset, force);
            after.appendChild(child);
        });
        return after;
    };
    ContainerBlot.prototype.unwrap = function () {
        this.moveChildren(this.parent, this.next);
        this.remove();
    };
    ContainerBlot.prototype.update = function (mutations, context) {
        var _this = this;
        var addedNodes = [];
        var removedNodes = [];
        mutations.forEach(function (mutation) {
            if (mutation.target === _this.domNode && mutation.type === 'childList') {
                addedNodes.push.apply(addedNodes, mutation.addedNodes);
                removedNodes.push.apply(removedNodes, mutation.removedNodes);
            }
        });
        removedNodes.forEach(function (node) {
            // Check node has actually been removed
            // One exception is Chrome does not immediately remove IFRAMEs
            // from DOM but MutationRecord is correct in its reported removal
            if (node.parentNode != null &&
                // @ts-ignore
                node.tagName !== 'IFRAME' &&
                document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
                return;
            }
            var blot = Registry.find(node);
            if (blot == null)
                return;
            if (blot.domNode.parentNode == null || blot.domNode.parentNode === _this.domNode) {
                blot.detach();
            }
        });
        addedNodes
            .filter(function (node) {
            return node.parentNode == _this.domNode;
        })
            .sort(function (a, b) {
            if (a === b)
                return 0;
            if (a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING) {
                return 1;
            }
            return -1;
        })
            .forEach(function (node) {
            var refBlot = null;
            if (node.nextSibling != null) {
                refBlot = Registry.find(node.nextSibling);
            }
            var blot = makeBlot(node);
            if (blot.next != refBlot || blot.next == null) {
                if (blot.parent != null) {
                    blot.parent.removeChild(_this);
                }
                _this.insertBefore(blot, refBlot || undefined);
            }
        });
    };
    return ContainerBlot;
}(shadow_1.default));
function makeBlot(node) {
    var blot = Registry.find(node);
    if (blot == null) {
        try {
            blot = Registry.create(node);
        }
        catch (e) {
            blot = Registry.create(Registry.Scope.INLINE);
            [].slice.call(node.childNodes).forEach(function (child) {
                // @ts-ignore
                blot.domNode.appendChild(child);
            });
            if (node.parentNode) {
                node.parentNode.replaceChild(blot.domNode, node);
            }
            blot.attach();
        }
    }
    return blot;
}
exports.default = ContainerBlot;


/***/ }),
/* 18 */
/***/ (function(module, exports, __nested_webpack_require_130088__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __nested_webpack_require_130088__(12);
var store_1 = __nested_webpack_require_130088__(31);
var container_1 = __nested_webpack_require_130088__(17);
var Registry = __nested_webpack_require_130088__(1);
var FormatBlot = /** @class */ (function (_super) {
    __extends(FormatBlot, _super);
    function FormatBlot(domNode) {
        var _this = _super.call(this, domNode) || this;
        _this.attributes = new store_1.default(_this.domNode);
        return _this;
    }
    FormatBlot.formats = function (domNode) {
        if (typeof this.tagName === 'string') {
            return true;
        }
        else if (Array.isArray(this.tagName)) {
            return domNode.tagName.toLowerCase();
        }
        return undefined;
    };
    FormatBlot.prototype.format = function (name, value) {
        var format = Registry.query(name);
        if (format instanceof attributor_1.default) {
            this.attributes.attribute(format, value);
        }
        else if (value) {
            if (format != null && (name !== this.statics.blotName || this.formats()[name] !== value)) {
                this.replaceWith(name, value);
            }
        }
    };
    FormatBlot.prototype.formats = function () {
        var formats = this.attributes.values();
        var format = this.statics.formats(this.domNode);
        if (format != null) {
            formats[this.statics.blotName] = format;
        }
        return formats;
    };
    FormatBlot.prototype.replaceWith = function (name, value) {
        var replacement = _super.prototype.replaceWith.call(this, name, value);
        this.attributes.copy(replacement);
        return replacement;
    };
    FormatBlot.prototype.update = function (mutations, context) {
        var _this = this;
        _super.prototype.update.call(this, mutations, context);
        if (mutations.some(function (mutation) {
            return mutation.target === _this.domNode && mutation.type === 'attributes';
        })) {
            this.attributes.build();
        }
    };
    FormatBlot.prototype.wrap = function (name, value) {
        var wrapper = _super.prototype.wrap.call(this, name, value);
        if (wrapper instanceof FormatBlot && wrapper.statics.scope === this.statics.scope) {
            this.attributes.move(wrapper);
        }
        return wrapper;
    };
    return FormatBlot;
}(container_1.default));
exports.default = FormatBlot;


/***/ }),
/* 19 */
/***/ (function(module, exports, __nested_webpack_require_133111__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var shadow_1 = __nested_webpack_require_133111__(30);
var Registry = __nested_webpack_require_133111__(1);
var LeafBlot = /** @class */ (function (_super) {
    __extends(LeafBlot, _super);
    function LeafBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LeafBlot.value = function (domNode) {
        return true;
    };
    LeafBlot.prototype.index = function (node, offset) {
        if (this.domNode === node ||
            this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) {
            return Math.min(offset, 1);
        }
        return -1;
    };
    LeafBlot.prototype.position = function (index, inclusive) {
        var offset = [].indexOf.call(this.parent.domNode.childNodes, this.domNode);
        if (index > 0)
            offset += 1;
        return [this.parent.domNode, offset];
    };
    LeafBlot.prototype.value = function () {
        var _a;
        return _a = {}, _a[this.statics.blotName] = this.statics.value(this.domNode) || true, _a;
    };
    LeafBlot.scope = Registry.Scope.INLINE_BLOT;
    return LeafBlot;
}(shadow_1.default));
exports.default = LeafBlot;


/***/ }),
/* 20 */
/***/ (function(module, exports, __nested_webpack_require_134898__) {

var equal = __nested_webpack_require_134898__(11);
var extend = __nested_webpack_require_134898__(3);


var lib = {
  attributes: {
    compose: function (a, b, keepNull) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = extend(true, {}, b);
      if (!keepNull) {
        attributes = Object.keys(attributes).reduce(function (copy, key) {
          if (attributes[key] != null) {
            copy[key] = attributes[key];
          }
          return copy;
        }, {});
      }
      for (var key in a) {
        if (a[key] !== undefined && b[key] === undefined) {
          attributes[key] = a[key];
        }
      }
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    diff: function(a, b) {
      if (typeof a !== 'object') a = {};
      if (typeof b !== 'object') b = {};
      var attributes = Object.keys(a).concat(Object.keys(b)).reduce(function (attributes, key) {
        if (!equal(a[key], b[key])) {
          attributes[key] = b[key] === undefined ? null : b[key];
        }
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    },

    transform: function (a, b, priority) {
      if (typeof a !== 'object') return b;
      if (typeof b !== 'object') return undefined;
      if (!priority) return b;  // b simply overwrites us without priority
      var attributes = Object.keys(b).reduce(function (attributes, key) {
        if (a[key] === undefined) attributes[key] = b[key];  // null is a valid value
        return attributes;
      }, {});
      return Object.keys(attributes).length > 0 ? attributes : undefined;
    }
  },

  iterator: function (ops) {
    return new Iterator(ops);
  },

  length: function (op) {
    if (typeof op['delete'] === 'number') {
      return op['delete'];
    } else if (typeof op.retain === 'number') {
      return op.retain;
    } else {
      return typeof op.insert === 'string' ? op.insert.length : 1;
    }
  }
};


function Iterator(ops) {
  this.ops = ops;
  this.index = 0;
  this.offset = 0;
};

Iterator.prototype.hasNext = function () {
  return this.peekLength() < Infinity;
};

Iterator.prototype.next = function (length) {
  if (!length) length = Infinity;
  var nextOp = this.ops[this.index];
  if (nextOp) {
    var offset = this.offset;
    var opLength = lib.length(nextOp)
    if (length >= opLength - offset) {
      length = opLength - offset;
      this.index += 1;
      this.offset = 0;
    } else {
      this.offset += length;
    }
    if (typeof nextOp['delete'] === 'number') {
      return { 'delete': length };
    } else {
      var retOp = {};
      if (nextOp.attributes) {
        retOp.attributes = nextOp.attributes;
      }
      if (typeof nextOp.retain === 'number') {
        retOp.retain = length;
      } else if (typeof nextOp.insert === 'string') {
        retOp.insert = nextOp.insert.substr(offset, length);
      } else {
        // offset should === 0, length should === 1
        retOp.insert = nextOp.insert;
      }
      return retOp;
    }
  } else {
    return { retain: Infinity };
  }
};

Iterator.prototype.peek = function () {
  return this.ops[this.index];
};

Iterator.prototype.peekLength = function () {
  if (this.ops[this.index]) {
    // Should never return 0 if our index is being managed correctly
    return lib.length(this.ops[this.index]) - this.offset;
  } else {
    return Infinity;
  }
};

Iterator.prototype.peekType = function () {
  if (this.ops[this.index]) {
    if (typeof this.ops[this.index]['delete'] === 'number') {
      return 'delete';
    } else if (typeof this.ops[this.index].retain === 'number') {
      return 'retain';
    } else {
      return 'insert';
    }
  }
  return 'retain';
};

Iterator.prototype.rest = function () {
  if (!this.hasNext()) {
    return [];
  } else if (this.offset === 0) {
    return this.ops.slice(this.index);
  } else {
    var offset = this.offset;
    var index = this.index;
    var next = this.next();
    var rest = this.ops.slice(this.index);
    this.offset = offset;
    this.index = index;
    return [next].concat(rest);
  }
};


module.exports = lib;


/***/ }),
/* 21 */
/***/ (function(module, exports) {

var clone = (function() {
'use strict';

function _instanceof(obj, type) {
  return type != null && obj instanceof type;
}

var nativeMap;
try {
  nativeMap = Map;
} catch(_) {
  // maybe a reference error because no `Map`. Give it a dummy value that no
  // value will ever be an instanceof.
  nativeMap = function() {};
}

var nativeSet;
try {
  nativeSet = Set;
} catch(_) {
  nativeSet = function() {};
}

var nativePromise;
try {
  nativePromise = Promise;
} catch(_) {
  nativePromise = function() {};
}

/**
 * Clones (copies) an Object using deep copying.
 *
 * This function supports circular references by default, but if you are certain
 * there are no circular references in your object, you can save some CPU time
 * by calling clone(obj, false).
 *
 * Caution: if `circular` is false and `parent` contains circular references,
 * your program may enter an infinite loop and crash.
 *
 * @param `parent` - the object to be cloned
 * @param `circular` - set to true if the object to be cloned may contain
 *    circular references. (optional - true by default)
 * @param `depth` - set to a number if the object is only to be cloned to
 *    a particular depth. (optional - defaults to Infinity)
 * @param `prototype` - sets the prototype to be used when cloning an object.
 *    (optional - defaults to parent prototype).
 * @param `includeNonEnumerable` - set to true if the non-enumerable properties
 *    should be cloned as well. Non-enumerable properties on the prototype
 *    chain will be ignored. (optional - false by default)
*/
function clone(parent, circular, depth, prototype, includeNonEnumerable) {
  if (typeof circular === 'object') {
    depth = circular.depth;
    prototype = circular.prototype;
    includeNonEnumerable = circular.includeNonEnumerable;
    circular = circular.circular;
  }
  // maintain two arrays for circular references, where corresponding parents
  // and children have the same index
  var allParents = [];
  var allChildren = [];

  var useBuffer = typeof Buffer != 'undefined';

  if (typeof circular == 'undefined')
    circular = true;

  if (typeof depth == 'undefined')
    depth = Infinity;

  // recurse this function so we don't reset allParents and allChildren
  function _clone(parent, depth) {
    // cloning null always returns null
    if (parent === null)
      return null;

    if (depth === 0)
      return parent;

    var child;
    var proto;
    if (typeof parent != 'object') {
      return parent;
    }

    if (_instanceof(parent, nativeMap)) {
      child = new nativeMap();
    } else if (_instanceof(parent, nativeSet)) {
      child = new nativeSet();
    } else if (_instanceof(parent, nativePromise)) {
      child = new nativePromise(function (resolve, reject) {
        parent.then(function(value) {
          resolve(_clone(value, depth - 1));
        }, function(err) {
          reject(_clone(err, depth - 1));
        });
      });
    } else if (clone.__isArray(parent)) {
      child = [];
    } else if (clone.__isRegExp(parent)) {
      child = new RegExp(parent.source, __getRegExpFlags(parent));
      if (parent.lastIndex) child.lastIndex = parent.lastIndex;
    } else if (clone.__isDate(parent)) {
      child = new Date(parent.getTime());
    } else if (useBuffer && Buffer.isBuffer(parent)) {
      if (Buffer.allocUnsafe) {
        // Node.js >= 4.5.0
        child = Buffer.allocUnsafe(parent.length);
      } else {
        // Older Node.js versions
        child = new Buffer(parent.length);
      }
      parent.copy(child);
      return child;
    } else if (_instanceof(parent, Error)) {
      child = Object.create(parent);
    } else {
      if (typeof prototype == 'undefined') {
        proto = Object.getPrototypeOf(parent);
        child = Object.create(proto);
      }
      else {
        child = Object.create(prototype);
        proto = prototype;
      }
    }

    if (circular) {
      var index = allParents.indexOf(parent);

      if (index != -1) {
        return allChildren[index];
      }
      allParents.push(parent);
      allChildren.push(child);
    }

    if (_instanceof(parent, nativeMap)) {
      parent.forEach(function(value, key) {
        var keyChild = _clone(key, depth - 1);
        var valueChild = _clone(value, depth - 1);
        child.set(keyChild, valueChild);
      });
    }
    if (_instanceof(parent, nativeSet)) {
      parent.forEach(function(value) {
        var entryChild = _clone(value, depth - 1);
        child.add(entryChild);
      });
    }

    for (var i in parent) {
      var attrs;
      if (proto) {
        attrs = Object.getOwnPropertyDescriptor(proto, i);
      }

      if (attrs && attrs.set == null) {
        continue;
      }
      child[i] = _clone(parent[i], depth - 1);
    }

    if (Object.getOwnPropertySymbols) {
      var symbols = Object.getOwnPropertySymbols(parent);
      for (var i = 0; i < symbols.length; i++) {
        // Don't need to worry about cloning a symbol because it is a primitive,
        // like a number or string.
        var symbol = symbols[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, symbol);
        if (descriptor && !descriptor.enumerable && !includeNonEnumerable) {
          continue;
        }
        child[symbol] = _clone(parent[symbol], depth - 1);
        if (!descriptor.enumerable) {
          Object.defineProperty(child, symbol, {
            enumerable: false
          });
        }
      }
    }

    if (includeNonEnumerable) {
      var allPropertyNames = Object.getOwnPropertyNames(parent);
      for (var i = 0; i < allPropertyNames.length; i++) {
        var propertyName = allPropertyNames[i];
        var descriptor = Object.getOwnPropertyDescriptor(parent, propertyName);
        if (descriptor && descriptor.enumerable) {
          continue;
        }
        child[propertyName] = _clone(parent[propertyName], depth - 1);
        Object.defineProperty(child, propertyName, {
          enumerable: false
        });
      }
    }

    return child;
  }

  return _clone(parent, depth);
}

/**
 * Simple flat clone using prototype, accepts only objects, usefull for property
 * override on FLAT configuration object (no nested props).
 *
 * USE WITH CAUTION! This may not behave as you wish if you do not know how this
 * works.
 */
clone.clonePrototype = function clonePrototype(parent) {
  if (parent === null)
    return null;

  var c = function () {};
  c.prototype = parent;
  return new c();
};

// private utility functions

function __objToStr(o) {
  return Object.prototype.toString.call(o);
}
clone.__objToStr = __objToStr;

function __isDate(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Date]';
}
clone.__isDate = __isDate;

function __isArray(o) {
  return typeof o === 'object' && __objToStr(o) === '[object Array]';
}
clone.__isArray = __isArray;

function __isRegExp(o) {
  return typeof o === 'object' && __objToStr(o) === '[object RegExp]';
}
clone.__isRegExp = __isRegExp;

function __getRegExpFlags(re) {
  var flags = '';
  if (re.global) flags += 'g';
  if (re.ignoreCase) flags += 'i';
  if (re.multiline) flags += 'm';
  return flags;
}
clone.__getRegExpFlags = __getRegExpFlags;

return clone;
})();

if (typeof module === 'object' && module.exports) {
  module.exports = clone;
}


/***/ }),
/* 22 */
/***/ (function(module, exports, __nested_webpack_require_146497__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_146497__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _emitter = __nested_webpack_require_146497__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _block = __nested_webpack_require_146497__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __nested_webpack_require_146497__(16);

var _break2 = _interopRequireDefault(_break);

var _code = __nested_webpack_require_146497__(13);

var _code2 = _interopRequireDefault(_code);

var _container = __nested_webpack_require_146497__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function isLine(blot) {
  return blot instanceof _block2.default || blot instanceof _block.BlockEmbed;
}

var Scroll = function (_Parchment$Scroll) {
  _inherits(Scroll, _Parchment$Scroll);

  function Scroll(domNode, config) {
    _classCallCheck(this, Scroll);

    var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, domNode));

    _this.emitter = config.emitter;
    if (Array.isArray(config.whitelist)) {
      _this.whitelist = config.whitelist.reduce(function (whitelist, format) {
        whitelist[format] = true;
        return whitelist;
      }, {});
    }
    // Some reason fixes composition issues with character languages in Windows/Chrome, Safari
    _this.domNode.addEventListener('DOMNodeInserted', function () {});
    _this.optimize();
    _this.enable();
    return _this;
  }

  _createClass(Scroll, [{
    key: 'batchStart',
    value: function batchStart() {
      this.batch = true;
    }
  }, {
    key: 'batchEnd',
    value: function batchEnd() {
      this.batch = false;
      this.optimize();
    }
  }, {
    key: 'deleteAt',
    value: function deleteAt(index, length) {
      var _line = this.line(index),
          _line2 = _slicedToArray(_line, 2),
          first = _line2[0],
          offset = _line2[1];

      var _line3 = this.line(index + length),
          _line4 = _slicedToArray(_line3, 1),
          last = _line4[0];

      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'deleteAt', this).call(this, index, length);
      if (last != null && first !== last && offset > 0) {
        if (first instanceof _block.BlockEmbed || last instanceof _block.BlockEmbed) {
          this.optimize();
          return;
        }
        if (first instanceof _code2.default) {
          var newlineIndex = first.newlineIndex(first.length(), true);
          if (newlineIndex > -1) {
            first = first.split(newlineIndex + 1);
            if (first === last) {
              this.optimize();
              return;
            }
          }
        } else if (last instanceof _code2.default) {
          var _newlineIndex = last.newlineIndex(0);
          if (_newlineIndex > -1) {
            last.split(_newlineIndex + 1);
          }
        }
        var ref = last.children.head instanceof _break2.default ? null : last.children.head;
        first.moveChildren(last, ref);
        first.remove();
      }
      this.optimize();
    }
  }, {
    key: 'enable',
    value: function enable() {
      var enabled = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      this.domNode.setAttribute('contenteditable', enabled);
    }
  }, {
    key: 'formatAt',
    value: function formatAt(index, length, format, value) {
      if (this.whitelist != null && !this.whitelist[format]) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'formatAt', this).call(this, index, length, format, value);
      this.optimize();
    }
  }, {
    key: 'insertAt',
    value: function insertAt(index, value, def) {
      if (def != null && this.whitelist != null && !this.whitelist[value]) return;
      if (index >= this.length()) {
        if (def == null || _parchment2.default.query(value, _parchment2.default.Scope.BLOCK) == null) {
          var blot = _parchment2.default.create(this.statics.defaultChild);
          this.appendChild(blot);
          if (def == null && value.endsWith('\n')) {
            value = value.slice(0, -1);
          }
          blot.insertAt(0, value, def);
        } else {
          var embed = _parchment2.default.create(value, def);
          this.appendChild(embed);
        }
      } else {
        _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertAt', this).call(this, index, value, def);
      }
      this.optimize();
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot.statics.scope === _parchment2.default.Scope.INLINE_BLOT) {
        var wrapper = _parchment2.default.create(this.statics.defaultChild);
        wrapper.appendChild(blot);
        blot = wrapper;
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'insertBefore', this).call(this, blot, ref);
    }
  }, {
    key: 'leaf',
    value: function leaf(index) {
      return this.path(index).pop() || [null, -1];
    }
  }, {
    key: 'line',
    value: function line(index) {
      if (index === this.length()) {
        return this.line(index - 1);
      }
      return this.descendant(isLine, index);
    }
  }, {
    key: 'lines',
    value: function lines() {
      var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var length = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Number.MAX_VALUE;

      var getLines = function getLines(blot, index, length) {
        var lines = [],
            lengthLeft = length;
        blot.children.forEachAt(index, length, function (child, index, length) {
          if (isLine(child)) {
            lines.push(child);
          } else if (child instanceof _parchment2.default.Container) {
            lines = lines.concat(getLines(child, index, lengthLeft));
          }
          lengthLeft -= length;
        });
        return lines;
      };
      return getLines(this, index, length);
    }
  }, {
    key: 'optimize',
    value: function optimize() {
      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      if (this.batch === true) return;
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'optimize', this).call(this, mutations, context);
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_OPTIMIZE, mutations, context);
      }
    }
  }, {
    key: 'path',
    value: function path(index) {
      return _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'path', this).call(this, index).slice(1); // Exclude self
    }
  }, {
    key: 'update',
    value: function update(mutations) {
      if (this.batch === true) return;
      var source = _emitter2.default.sources.USER;
      if (typeof mutations === 'string') {
        source = mutations;
      }
      if (!Array.isArray(mutations)) {
        mutations = this.observer.takeRecords();
      }
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_BEFORE_UPDATE, source, mutations);
      }
      _get(Scroll.prototype.__proto__ || Object.getPrototypeOf(Scroll.prototype), 'update', this).call(this, mutations.concat([])); // pass copy
      if (mutations.length > 0) {
        this.emitter.emit(_emitter2.default.events.SCROLL_UPDATE, source, mutations);
      }
    }
  }]);

  return Scroll;
}(_parchment2.default.Scroll);

Scroll.blotName = 'scroll';
Scroll.className = 'ql-editor';
Scroll.tagName = 'DIV';
Scroll.defaultChild = 'block';
Scroll.allowedChildren = [_block2.default, _block.BlockEmbed, _container2.default];

exports.default = Scroll;

/***/ }),
/* 23 */
/***/ (function(module, exports, __nested_webpack_require_157111__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SHORTKEY = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _clone = __nested_webpack_require_157111__(21);

var _clone2 = _interopRequireDefault(_clone);

var _deepEqual = __nested_webpack_require_157111__(11);

var _deepEqual2 = _interopRequireDefault(_deepEqual);

var _extend = __nested_webpack_require_157111__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __nested_webpack_require_157111__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _op = __nested_webpack_require_157111__(20);

var _op2 = _interopRequireDefault(_op);

var _parchment = __nested_webpack_require_157111__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_157111__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __nested_webpack_require_157111__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __nested_webpack_require_157111__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:keyboard');

var SHORTKEY = /Mac/i.test(navigator.platform) ? 'metaKey' : 'ctrlKey';

var Keyboard = function (_Module) {
  _inherits(Keyboard, _Module);

  _createClass(Keyboard, null, [{
    key: 'match',
    value: function match(evt, binding) {
      binding = normalize(binding);
      if (['altKey', 'ctrlKey', 'metaKey', 'shiftKey'].some(function (key) {
        return !!binding[key] !== evt[key] && binding[key] !== null;
      })) {
        return false;
      }
      return binding.key === (evt.which || evt.keyCode);
    }
  }]);

  function Keyboard(quill, options) {
    _classCallCheck(this, Keyboard);

    var _this = _possibleConstructorReturn(this, (Keyboard.__proto__ || Object.getPrototypeOf(Keyboard)).call(this, quill, options));

    _this.bindings = {};
    Object.keys(_this.options.bindings).forEach(function (name) {
      if (name === 'list autofill' && quill.scroll.whitelist != null && !quill.scroll.whitelist['list']) {
        return;
      }
      if (_this.options.bindings[name]) {
        _this.addBinding(_this.options.bindings[name]);
      }
    });
    _this.addBinding({ key: Keyboard.keys.ENTER, shiftKey: null }, handleEnter);
    _this.addBinding({ key: Keyboard.keys.ENTER, metaKey: null, ctrlKey: null, altKey: null }, function () {});
    if (/Firefox/i.test(navigator.userAgent)) {
      // Need to handle delete and backspace for Firefox in the general case #1171
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true }, handleDelete);
    } else {
      _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: true, prefix: /^.?$/ }, handleBackspace);
      _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: true, suffix: /^.?$/ }, handleDelete);
    }
    _this.addBinding({ key: Keyboard.keys.BACKSPACE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.DELETE }, { collapsed: false }, handleDeleteRange);
    _this.addBinding({ key: Keyboard.keys.BACKSPACE, altKey: null, ctrlKey: null, metaKey: null, shiftKey: null }, { collapsed: true, offset: 0 }, handleBackspace);
    _this.listen();
    return _this;
  }

  _createClass(Keyboard, [{
    key: 'addBinding',
    value: function addBinding(key) {
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var handler = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

      var binding = normalize(key);
      if (binding == null || binding.key == null) {
        return debug.warn('Attempted to add invalid keyboard binding', binding);
      }
      if (typeof context === 'function') {
        context = { handler: context };
      }
      if (typeof handler === 'function') {
        handler = { handler: handler };
      }
      binding = (0, _extend2.default)(binding, context, handler);
      this.bindings[binding.key] = this.bindings[binding.key] || [];
      this.bindings[binding.key].push(binding);
    }
  }, {
    key: 'listen',
    value: function listen() {
      var _this2 = this;

      this.quill.root.addEventListener('keydown', function (evt) {
        if (evt.defaultPrevented) return;
        var which = evt.which || evt.keyCode;
        var bindings = (_this2.bindings[which] || []).filter(function (binding) {
          return Keyboard.match(evt, binding);
        });
        if (bindings.length === 0) return;
        var range = _this2.quill.getSelection();
        if (range == null || !_this2.quill.hasFocus()) return;

        var _quill$getLine = _this2.quill.getLine(range.index),
            _quill$getLine2 = _slicedToArray(_quill$getLine, 2),
            line = _quill$getLine2[0],
            offset = _quill$getLine2[1];

        var _quill$getLeaf = _this2.quill.getLeaf(range.index),
            _quill$getLeaf2 = _slicedToArray(_quill$getLeaf, 2),
            leafStart = _quill$getLeaf2[0],
            offsetStart = _quill$getLeaf2[1];

        var _ref = range.length === 0 ? [leafStart, offsetStart] : _this2.quill.getLeaf(range.index + range.length),
            _ref2 = _slicedToArray(_ref, 2),
            leafEnd = _ref2[0],
            offsetEnd = _ref2[1];

        var prefixText = leafStart instanceof _parchment2.default.Text ? leafStart.value().slice(0, offsetStart) : '';
        var suffixText = leafEnd instanceof _parchment2.default.Text ? leafEnd.value().slice(offsetEnd) : '';
        var curContext = {
          collapsed: range.length === 0,
          empty: range.length === 0 && line.length() <= 1,
          format: _this2.quill.getFormat(range),
          offset: offset,
          prefix: prefixText,
          suffix: suffixText
        };
        var prevented = bindings.some(function (binding) {
          if (binding.collapsed != null && binding.collapsed !== curContext.collapsed) return false;
          if (binding.empty != null && binding.empty !== curContext.empty) return false;
          if (binding.offset != null && binding.offset !== curContext.offset) return false;
          if (Array.isArray(binding.format)) {
            // any format is present
            if (binding.format.every(function (name) {
              return curContext.format[name] == null;
            })) {
              return false;
            }
          } else if (_typeof(binding.format) === 'object') {
            // all formats must match
            if (!Object.keys(binding.format).every(function (name) {
              if (binding.format[name] === true) return curContext.format[name] != null;
              if (binding.format[name] === false) return curContext.format[name] == null;
              return (0, _deepEqual2.default)(binding.format[name], curContext.format[name]);
            })) {
              return false;
            }
          }
          if (binding.prefix != null && !binding.prefix.test(curContext.prefix)) return false;
          if (binding.suffix != null && !binding.suffix.test(curContext.suffix)) return false;
          return binding.handler.call(_this2, range, curContext) !== true;
        });
        if (prevented) {
          evt.preventDefault();
        }
      });
    }
  }]);

  return Keyboard;
}(_module2.default);

Keyboard.keys = {
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  ESCAPE: 27,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46
};

Keyboard.DEFAULTS = {
  bindings: {
    'bold': makeFormatHandler('bold'),
    'italic': makeFormatHandler('italic'),
    'underline': makeFormatHandler('underline'),
    'indent': {
      // highlight tab or tab at beginning of list, indent or blockquote
      key: Keyboard.keys.TAB,
      format: ['blockquote', 'indent', 'list'],
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '+1', _quill2.default.sources.USER);
      }
    },
    'outdent': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      format: ['blockquote', 'indent', 'list'],
      // highlight tab or tab at beginning of list, indent or blockquote
      handler: function handler(range, context) {
        if (context.collapsed && context.offset !== 0) return true;
        this.quill.format('indent', '-1', _quill2.default.sources.USER);
      }
    },
    'outdent backspace': {
      key: Keyboard.keys.BACKSPACE,
      collapsed: true,
      shiftKey: null,
      metaKey: null,
      ctrlKey: null,
      altKey: null,
      format: ['indent', 'list'],
      offset: 0,
      handler: function handler(range, context) {
        if (context.format.indent != null) {
          this.quill.format('indent', '-1', _quill2.default.sources.USER);
        } else if (context.format.list != null) {
          this.quill.format('list', false, _quill2.default.sources.USER);
        }
      }
    },
    'indent code-block': makeCodeBlockHandler(true),
    'outdent code-block': makeCodeBlockHandler(false),
    'remove tab': {
      key: Keyboard.keys.TAB,
      shiftKey: true,
      collapsed: true,
      prefix: /\t$/,
      handler: function handler(range) {
        this.quill.deleteText(range.index - 1, 1, _quill2.default.sources.USER);
      }
    },
    'tab': {
      key: Keyboard.keys.TAB,
      handler: function handler(range) {
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index).delete(range.length).insert('\t');
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
      }
    },
    'list empty enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['list'],
      empty: true,
      handler: function handler(range, context) {
        this.quill.format('list', false, _quill2.default.sources.USER);
        if (context.format.indent) {
          this.quill.format('indent', false, _quill2.default.sources.USER);
        }
      }
    },
    'checklist enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: { list: 'checked' },
      handler: function handler(range) {
        var _quill$getLine3 = this.quill.getLine(range.index),
            _quill$getLine4 = _slicedToArray(_quill$getLine3, 2),
            line = _quill$getLine4[0],
            offset = _quill$getLine4[1];

        var formats = (0, _extend2.default)({}, line.formats(), { list: 'checked' });
        var delta = new _quillDelta2.default().retain(range.index).insert('\n', formats).retain(line.length() - offset - 1).retain(1, { list: 'unchecked' });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'header enter': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['header'],
      suffix: /^$/,
      handler: function handler(range, context) {
        var _quill$getLine5 = this.quill.getLine(range.index),
            _quill$getLine6 = _slicedToArray(_quill$getLine5, 2),
            line = _quill$getLine6[0],
            offset = _quill$getLine6[1];

        var delta = new _quillDelta2.default().retain(range.index).insert('\n', context.format).retain(line.length() - offset - 1).retain(1, { header: null });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
        this.quill.scrollIntoView();
      }
    },
    'list autofill': {
      key: ' ',
      collapsed: true,
      format: { list: false },
      prefix: /^\s*?(\d+\.|-|\*|\[ ?\]|\[x\])$/,
      handler: function handler(range, context) {
        var length = context.prefix.length;

        var _quill$getLine7 = this.quill.getLine(range.index),
            _quill$getLine8 = _slicedToArray(_quill$getLine7, 2),
            line = _quill$getLine8[0],
            offset = _quill$getLine8[1];

        if (offset > length) return true;
        var value = void 0;
        switch (context.prefix.trim()) {
          case '[]':case '[ ]':
            value = 'unchecked';
            break;
          case '[x]':
            value = 'checked';
            break;
          case '-':case '*':
            value = 'bullet';
            break;
          default:
            value = 'ordered';
        }
        this.quill.insertText(range.index, ' ', _quill2.default.sources.USER);
        this.quill.history.cutoff();
        var delta = new _quillDelta2.default().retain(range.index - offset).delete(length + 1).retain(line.length() - 2 - offset).retain(1, { list: value });
        this.quill.updateContents(delta, _quill2.default.sources.USER);
        this.quill.history.cutoff();
        this.quill.setSelection(range.index - length, _quill2.default.sources.SILENT);
      }
    },
    'code exit': {
      key: Keyboard.keys.ENTER,
      collapsed: true,
      format: ['code-block'],
      prefix: /\n\n$/,
      suffix: /^\s+$/,
      handler: function handler(range) {
        var _quill$getLine9 = this.quill.getLine(range.index),
            _quill$getLine10 = _slicedToArray(_quill$getLine9, 2),
            line = _quill$getLine10[0],
            offset = _quill$getLine10[1];

        var delta = new _quillDelta2.default().retain(range.index + line.length() - offset - 2).retain(1, { 'code-block': null }).delete(1);
        this.quill.updateContents(delta, _quill2.default.sources.USER);
      }
    },
    'embed left': makeEmbedArrowHandler(Keyboard.keys.LEFT, false),
    'embed left shift': makeEmbedArrowHandler(Keyboard.keys.LEFT, true),
    'embed right': makeEmbedArrowHandler(Keyboard.keys.RIGHT, false),
    'embed right shift': makeEmbedArrowHandler(Keyboard.keys.RIGHT, true)
  }
};

function makeEmbedArrowHandler(key, shiftKey) {
  var _ref3;

  var where = key === Keyboard.keys.LEFT ? 'prefix' : 'suffix';
  return _ref3 = {
    key: key,
    shiftKey: shiftKey,
    altKey: null
  }, _defineProperty(_ref3, where, /^$/), _defineProperty(_ref3, 'handler', function handler(range) {
    var index = range.index;
    if (key === Keyboard.keys.RIGHT) {
      index += range.length + 1;
    }

    var _quill$getLeaf3 = this.quill.getLeaf(index),
        _quill$getLeaf4 = _slicedToArray(_quill$getLeaf3, 1),
        leaf = _quill$getLeaf4[0];

    if (!(leaf instanceof _parchment2.default.Embed)) return true;
    if (key === Keyboard.keys.LEFT) {
      if (shiftKey) {
        this.quill.setSelection(range.index - 1, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index - 1, _quill2.default.sources.USER);
      }
    } else {
      if (shiftKey) {
        this.quill.setSelection(range.index, range.length + 1, _quill2.default.sources.USER);
      } else {
        this.quill.setSelection(range.index + range.length + 1, _quill2.default.sources.USER);
      }
    }
    return false;
  }), _ref3;
}

function handleBackspace(range, context) {
  if (range.index === 0 || this.quill.getLength() <= 1) return;

  var _quill$getLine11 = this.quill.getLine(range.index),
      _quill$getLine12 = _slicedToArray(_quill$getLine11, 1),
      line = _quill$getLine12[0];

  var formats = {};
  if (context.offset === 0) {
    var _quill$getLine13 = this.quill.getLine(range.index - 1),
        _quill$getLine14 = _slicedToArray(_quill$getLine13, 1),
        prev = _quill$getLine14[0];

    if (prev != null && prev.length() > 1) {
      var curFormats = line.formats();
      var prevFormats = this.quill.getFormat(range.index - 1, 1);
      formats = _op2.default.attributes.diff(curFormats, prevFormats) || {};
    }
  }
  // Check for astral symbols
  var length = /[\uD800-\uDBFF][\uDC00-\uDFFF]$/.test(context.prefix) ? 2 : 1;
  this.quill.deleteText(range.index - length, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index - length, length, formats, _quill2.default.sources.USER);
  }
  this.quill.focus();
}

function handleDelete(range, context) {
  // Check for astral symbols
  var length = /^[\uD800-\uDBFF][\uDC00-\uDFFF]/.test(context.suffix) ? 2 : 1;
  if (range.index >= this.quill.getLength() - length) return;
  var formats = {},
      nextLength = 0;

  var _quill$getLine15 = this.quill.getLine(range.index),
      _quill$getLine16 = _slicedToArray(_quill$getLine15, 1),
      line = _quill$getLine16[0];

  if (context.offset >= line.length() - 1) {
    var _quill$getLine17 = this.quill.getLine(range.index + 1),
        _quill$getLine18 = _slicedToArray(_quill$getLine17, 1),
        next = _quill$getLine18[0];

    if (next) {
      var curFormats = line.formats();
      var nextFormats = this.quill.getFormat(range.index, 1);
      formats = _op2.default.attributes.diff(curFormats, nextFormats) || {};
      nextLength = next.length();
    }
  }
  this.quill.deleteText(range.index, length, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index + nextLength - 1, length, formats, _quill2.default.sources.USER);
  }
}

function handleDeleteRange(range) {
  var lines = this.quill.getLines(range);
  var formats = {};
  if (lines.length > 1) {
    var firstFormats = lines[0].formats();
    var lastFormats = lines[lines.length - 1].formats();
    formats = _op2.default.attributes.diff(lastFormats, firstFormats) || {};
  }
  this.quill.deleteText(range, _quill2.default.sources.USER);
  if (Object.keys(formats).length > 0) {
    this.quill.formatLine(range.index, 1, formats, _quill2.default.sources.USER);
  }
  this.quill.setSelection(range.index, _quill2.default.sources.SILENT);
  this.quill.focus();
}

function handleEnter(range, context) {
  var _this3 = this;

  if (range.length > 0) {
    this.quill.scroll.deleteAt(range.index, range.length); // So we do not trigger text-change
  }
  var lineFormats = Object.keys(context.format).reduce(function (lineFormats, format) {
    if (_parchment2.default.query(format, _parchment2.default.Scope.BLOCK) && !Array.isArray(context.format[format])) {
      lineFormats[format] = context.format[format];
    }
    return lineFormats;
  }, {});
  this.quill.insertText(range.index, '\n', lineFormats, _quill2.default.sources.USER);
  // Earlier scroll.deleteAt might have messed up our selection,
  // so insertText's built in selection preservation is not reliable
  this.quill.setSelection(range.index + 1, _quill2.default.sources.SILENT);
  this.quill.focus();
  Object.keys(context.format).forEach(function (name) {
    if (lineFormats[name] != null) return;
    if (Array.isArray(context.format[name])) return;
    if (name === 'link') return;
    _this3.quill.format(name, context.format[name], _quill2.default.sources.USER);
  });
}

function makeCodeBlockHandler(indent) {
  return {
    key: Keyboard.keys.TAB,
    shiftKey: !indent,
    format: { 'code-block': true },
    handler: function handler(range) {
      var CodeBlock = _parchment2.default.query('code-block');
      var index = range.index,
          length = range.length;

      var _quill$scroll$descend = this.quill.scroll.descendant(CodeBlock, index),
          _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
          block = _quill$scroll$descend2[0],
          offset = _quill$scroll$descend2[1];

      if (block == null) return;
      var scrollIndex = this.quill.getIndex(block);
      var start = block.newlineIndex(offset, true) + 1;
      var end = block.newlineIndex(scrollIndex + offset + length);
      var lines = block.domNode.textContent.slice(start, end).split('\n');
      offset = 0;
      lines.forEach(function (line, i) {
        if (indent) {
          block.insertAt(start + offset, CodeBlock.TAB);
          offset += CodeBlock.TAB.length;
          if (i === 0) {
            index += CodeBlock.TAB.length;
          } else {
            length += CodeBlock.TAB.length;
          }
        } else if (line.startsWith(CodeBlock.TAB)) {
          block.deleteAt(start + offset, CodeBlock.TAB.length);
          offset -= CodeBlock.TAB.length;
          if (i === 0) {
            index -= CodeBlock.TAB.length;
          } else {
            length -= CodeBlock.TAB.length;
          }
        }
        offset += line.length + 1;
      });
      this.quill.update(_quill2.default.sources.USER);
      this.quill.setSelection(index, length, _quill2.default.sources.SILENT);
    }
  };
}

function makeFormatHandler(format) {
  return {
    key: format[0].toUpperCase(),
    shortKey: true,
    handler: function handler(range, context) {
      this.quill.format(format, !context.format[format], _quill2.default.sources.USER);
    }
  };
}

function normalize(binding) {
  if (typeof binding === 'string' || typeof binding === 'number') {
    return normalize({ key: binding });
  }
  if ((typeof binding === 'undefined' ? 'undefined' : _typeof(binding)) === 'object') {
    binding = (0, _clone2.default)(binding, false);
  }
  if (typeof binding.key === 'string') {
    if (Keyboard.keys[binding.key.toUpperCase()] != null) {
      binding.key = Keyboard.keys[binding.key.toUpperCase()];
    } else if (binding.key.length === 1) {
      binding.key = binding.key.toUpperCase().charCodeAt(0);
    } else {
      return null;
    }
  }
  if (binding.shortKey) {
    binding[SHORTKEY] = binding.shortKey;
    delete binding.shortKey;
  }
  return binding;
}

exports.default = Keyboard;
exports.SHORTKEY = SHORTKEY;

/***/ }),
/* 24 */
/***/ (function(module, exports, __nested_webpack_require_181454__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __nested_webpack_require_181454__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __nested_webpack_require_181454__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Cursor = function (_Parchment$Embed) {
  _inherits(Cursor, _Parchment$Embed);

  _createClass(Cursor, null, [{
    key: 'value',
    value: function value() {
      return undefined;
    }
  }]);

  function Cursor(domNode, selection) {
    _classCallCheck(this, Cursor);

    var _this = _possibleConstructorReturn(this, (Cursor.__proto__ || Object.getPrototypeOf(Cursor)).call(this, domNode));

    _this.selection = selection;
    _this.textNode = document.createTextNode(Cursor.CONTENTS);
    _this.domNode.appendChild(_this.textNode);
    _this._length = 0;
    return _this;
  }

  _createClass(Cursor, [{
    key: 'detach',
    value: function detach() {
      // super.detach() will also clear domNode.__blot
      if (this.parent != null) this.parent.removeChild(this);
    }
  }, {
    key: 'format',
    value: function format(name, value) {
      if (this._length !== 0) {
        return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'format', this).call(this, name, value);
      }
      var target = this,
          index = 0;
      while (target != null && target.statics.scope !== _parchment2.default.Scope.BLOCK_BLOT) {
        index += target.offset(target.parent);
        target = target.parent;
      }
      if (target != null) {
        this._length = Cursor.CONTENTS.length;
        target.optimize();
        target.formatAt(index, Cursor.CONTENTS.length, name, value);
        this._length = 0;
      }
    }
  }, {
    key: 'index',
    value: function index(node, offset) {
      if (node === this.textNode) return 0;
      return _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'length',
    value: function length() {
      return this._length;
    }
  }, {
    key: 'position',
    value: function position() {
      return [this.textNode, this.textNode.data.length];
    }
  }, {
    key: 'remove',
    value: function remove() {
      _get(Cursor.prototype.__proto__ || Object.getPrototypeOf(Cursor.prototype), 'remove', this).call(this);
      this.parent = null;
    }
  }, {
    key: 'restore',
    value: function restore() {
      if (this.selection.composing || this.parent == null) return;
      var textNode = this.textNode;
      var range = this.selection.getNativeRange();
      var restoreText = void 0,
          start = void 0,
          end = void 0;
      if (range != null && range.start.node === textNode && range.end.node === textNode) {
        var _ref = [textNode, range.start.offset, range.end.offset];
        restoreText = _ref[0];
        start = _ref[1];
        end = _ref[2];
      }
      // Link format will insert text outside of anchor tag
      while (this.domNode.lastChild != null && this.domNode.lastChild !== this.textNode) {
        this.domNode.parentNode.insertBefore(this.domNode.lastChild, this.domNode);
      }
      if (this.textNode.data !== Cursor.CONTENTS) {
        var text = this.textNode.data.split(Cursor.CONTENTS).join('');
        if (this.next instanceof _text2.default) {
          restoreText = this.next.domNode;
          this.next.insertAt(0, text);
          this.textNode.data = Cursor.CONTENTS;
        } else {
          this.textNode.data = text;
          this.parent.insertBefore(_parchment2.default.create(this.textNode), this);
          this.textNode = document.createTextNode(Cursor.CONTENTS);
          this.domNode.appendChild(this.textNode);
        }
      }
      this.remove();
      if (start != null) {
        var _map = [start, end].map(function (offset) {
          return Math.max(0, Math.min(restoreText.data.length, offset - 1));
        });

        var _map2 = _slicedToArray(_map, 2);

        start = _map2[0];
        end = _map2[1];

        return {
          startNode: restoreText,
          startOffset: start,
          endNode: restoreText,
          endOffset: end
        };
      }
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      if (mutations.some(function (mutation) {
        return mutation.type === 'characterData' && mutation.target === _this2.textNode;
      })) {
        var range = this.restore();
        if (range) context.range = range;
      }
    }
  }, {
    key: 'value',
    value: function value() {
      return '';
    }
  }]);

  return Cursor;
}(_parchment2.default.Embed);

Cursor.blotName = 'cursor';
Cursor.className = 'ql-cursor';
Cursor.tagName = 'span';
Cursor.CONTENTS = '\uFEFF'; // Zero width no break space


exports.default = Cursor;

/***/ }),
/* 25 */
/***/ (function(module, exports, __nested_webpack_require_189100__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __nested_webpack_require_189100__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __nested_webpack_require_189100__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Container = function (_Parchment$Container) {
  _inherits(Container, _Parchment$Container);

  function Container() {
    _classCallCheck(this, Container);

    return _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).apply(this, arguments));
  }

  return Container;
}(_parchment2.default.Container);

Container.allowedChildren = [_block2.default, _block.BlockEmbed, Container];

exports.default = Container;

/***/ }),
/* 26 */
/***/ (function(module, exports, __nested_webpack_require_190886__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ColorStyle = exports.ColorClass = exports.ColorAttributor = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_190886__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorAttributor = function (_Parchment$Attributor) {
  _inherits(ColorAttributor, _Parchment$Attributor);

  function ColorAttributor() {
    _classCallCheck(this, ColorAttributor);

    return _possibleConstructorReturn(this, (ColorAttributor.__proto__ || Object.getPrototypeOf(ColorAttributor)).apply(this, arguments));
  }

  _createClass(ColorAttributor, [{
    key: 'value',
    value: function value(domNode) {
      var value = _get(ColorAttributor.prototype.__proto__ || Object.getPrototypeOf(ColorAttributor.prototype), 'value', this).call(this, domNode);
      if (!value.startsWith('rgb(')) return value;
      value = value.replace(/^[^\d]+/, '').replace(/[^\d]+$/, '');
      return '#' + value.split(',').map(function (component) {
        return ('00' + parseInt(component).toString(16)).slice(-2);
      }).join('');
    }
  }]);

  return ColorAttributor;
}(_parchment2.default.Attributor.Style);

var ColorClass = new _parchment2.default.Attributor.Class('color', 'ql-color', {
  scope: _parchment2.default.Scope.INLINE
});
var ColorStyle = new ColorAttributor('color', 'color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.ColorAttributor = ColorAttributor;
exports.ColorClass = ColorClass;
exports.ColorStyle = ColorStyle;

/***/ }),
/* 27 */
/***/ (function(module, exports, __nested_webpack_require_194529__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sanitize = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __nested_webpack_require_194529__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Link = function (_Inline) {
  _inherits(Link, _Inline);

  function Link() {
    _classCallCheck(this, Link);

    return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
  }

  _createClass(Link, [{
    key: 'format',
    value: function format(name, value) {
      if (name !== this.statics.blotName || !value) return _get(Link.prototype.__proto__ || Object.getPrototypeOf(Link.prototype), 'format', this).call(this, name, value);
      value = this.constructor.sanitize(value);
      this.domNode.setAttribute('href', value);
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Link.__proto__ || Object.getPrototypeOf(Link), 'create', this).call(this, value);
      value = this.sanitize(value);
      node.setAttribute('href', value);
      node.setAttribute('rel', 'noopener noreferrer');
      node.setAttribute('target', '_blank');
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return domNode.getAttribute('href');
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _sanitize(url, this.PROTOCOL_WHITELIST) ? url : this.SANITIZED_URL;
    }
  }]);

  return Link;
}(_inline2.default);

Link.blotName = 'link';
Link.tagName = 'A';
Link.SANITIZED_URL = 'about:blank';
Link.PROTOCOL_WHITELIST = ['http', 'https', 'mailto', 'tel'];

function _sanitize(url, protocols) {
  var anchor = document.createElement('a');
  anchor.href = url;
  var protocol = anchor.href.slice(0, anchor.href.indexOf(':'));
  return protocols.indexOf(protocol) > -1;
}

exports.default = Link;
exports.sanitize = _sanitize;

/***/ }),
/* 28 */
/***/ (function(module, exports, __nested_webpack_require_198559__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _keyboard = __nested_webpack_require_198559__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _dropdown = __nested_webpack_require_198559__(107);

var _dropdown2 = _interopRequireDefault(_dropdown);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var optionsCounter = 0;

function toggleAriaAttribute(element, attribute) {
  element.setAttribute(attribute, !(element.getAttribute(attribute) === 'true'));
}

var Picker = function () {
  function Picker(select) {
    var _this = this;

    _classCallCheck(this, Picker);

    this.select = select;
    this.container = document.createElement('span');
    this.buildPicker();
    this.select.style.display = 'none';
    this.select.parentNode.insertBefore(this.container, this.select);

    this.label.addEventListener('mousedown', function () {
      _this.togglePicker();
    });
    this.label.addEventListener('keydown', function (event) {
      switch (event.keyCode) {
        // Allows the "Enter" key to open the picker
        case _keyboard2.default.keys.ENTER:
          _this.togglePicker();
          break;

        // Allows the "Escape" key to close the picker
        case _keyboard2.default.keys.ESCAPE:
          _this.escape();
          event.preventDefault();
          break;
        default:
      }
    });
    this.select.addEventListener('change', this.update.bind(this));
  }

  _createClass(Picker, [{
    key: 'togglePicker',
    value: function togglePicker() {
      this.container.classList.toggle('ql-expanded');
      // Toggle aria-expanded and aria-hidden to make the picker accessible
      toggleAriaAttribute(this.label, 'aria-expanded');
      toggleAriaAttribute(this.options, 'aria-hidden');
    }
  }, {
    key: 'buildItem',
    value: function buildItem(option) {
      var _this2 = this;

      var item = document.createElement('span');
      item.tabIndex = '0';
      item.setAttribute('role', 'button');

      item.classList.add('ql-picker-item');
      if (option.hasAttribute('value')) {
        item.setAttribute('data-value', option.getAttribute('value'));
      }
      if (option.textContent) {
        item.setAttribute('data-label', option.textContent);
      }
      item.addEventListener('click', function () {
        _this2.selectItem(item, true);
      });
      item.addEventListener('keydown', function (event) {
        switch (event.keyCode) {
          // Allows the "Enter" key to select an item
          case _keyboard2.default.keys.ENTER:
            _this2.selectItem(item, true);
            event.preventDefault();
            break;

          // Allows the "Escape" key to close the picker
          case _keyboard2.default.keys.ESCAPE:
            _this2.escape();
            event.preventDefault();
            break;
          default:
        }
      });

      return item;
    }
  }, {
    key: 'buildLabel',
    value: function buildLabel() {
      var label = document.createElement('span');
      label.classList.add('ql-picker-label');
      label.innerHTML = _dropdown2.default;
      label.tabIndex = '0';
      label.setAttribute('role', 'button');
      label.setAttribute('aria-expanded', 'false');
      this.container.appendChild(label);
      return label;
    }
  }, {
    key: 'buildOptions',
    value: function buildOptions() {
      var _this3 = this;

      var options = document.createElement('span');
      options.classList.add('ql-picker-options');

      // Don't want screen readers to read this until options are visible
      options.setAttribute('aria-hidden', 'true');
      options.tabIndex = '-1';

      // Need a unique id for aria-controls
      options.id = 'ql-picker-options-' + optionsCounter;
      optionsCounter += 1;
      this.label.setAttribute('aria-controls', options.id);

      this.options = options;

      [].slice.call(this.select.options).forEach(function (option) {
        var item = _this3.buildItem(option);
        options.appendChild(item);
        if (option.selected === true) {
          _this3.selectItem(item);
        }
      });
      this.container.appendChild(options);
    }
  }, {
    key: 'buildPicker',
    value: function buildPicker() {
      var _this4 = this;

      [].slice.call(this.select.attributes).forEach(function (item) {
        _this4.container.setAttribute(item.name, item.value);
      });
      this.container.classList.add('ql-picker');
      this.label = this.buildLabel();
      this.buildOptions();
    }
  }, {
    key: 'escape',
    value: function escape() {
      var _this5 = this;

      // Close menu and return focus to trigger label
      this.close();
      // Need setTimeout for accessibility to ensure that the browser executes
      // focus on the next process thread and after any DOM content changes
      setTimeout(function () {
        return _this5.label.focus();
      }, 1);
    }
  }, {
    key: 'close',
    value: function close() {
      this.container.classList.remove('ql-expanded');
      this.label.setAttribute('aria-expanded', 'false');
      this.options.setAttribute('aria-hidden', 'true');
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item) {
      var trigger = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var selected = this.container.querySelector('.ql-selected');
      if (item === selected) return;
      if (selected != null) {
        selected.classList.remove('ql-selected');
      }
      if (item == null) return;
      item.classList.add('ql-selected');
      this.select.selectedIndex = [].indexOf.call(item.parentNode.children, item);
      if (item.hasAttribute('data-value')) {
        this.label.setAttribute('data-value', item.getAttribute('data-value'));
      } else {
        this.label.removeAttribute('data-value');
      }
      if (item.hasAttribute('data-label')) {
        this.label.setAttribute('data-label', item.getAttribute('data-label'));
      } else {
        this.label.removeAttribute('data-label');
      }
      if (trigger) {
        if (typeof Event === 'function') {
          this.select.dispatchEvent(new Event('change'));
        } else if ((typeof Event === 'undefined' ? 'undefined' : _typeof(Event)) === 'object') {
          // IE11
          var event = document.createEvent('Event');
          event.initEvent('change', true, true);
          this.select.dispatchEvent(event);
        }
        this.close();
      }
    }
  }, {
    key: 'update',
    value: function update() {
      var option = void 0;
      if (this.select.selectedIndex > -1) {
        var item = this.container.querySelector('.ql-picker-options').children[this.select.selectedIndex];
        option = this.select.options[this.select.selectedIndex];
        this.selectItem(item);
      } else {
        this.selectItem(null);
      }
      var isActive = option != null && option !== this.select.querySelector('option[selected]');
      this.label.classList.toggle('ql-active', isActive);
    }
  }]);

  return Picker;
}();

exports.default = Picker;

/***/ }),
/* 29 */
/***/ (function(module, exports, __nested_webpack_require_206753__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _parchment = __nested_webpack_require_206753__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_206753__(5);

var _quill2 = _interopRequireDefault(_quill);

var _block = __nested_webpack_require_206753__(4);

var _block2 = _interopRequireDefault(_block);

var _break = __nested_webpack_require_206753__(16);

var _break2 = _interopRequireDefault(_break);

var _container = __nested_webpack_require_206753__(25);

var _container2 = _interopRequireDefault(_container);

var _cursor = __nested_webpack_require_206753__(24);

var _cursor2 = _interopRequireDefault(_cursor);

var _embed = __nested_webpack_require_206753__(35);

var _embed2 = _interopRequireDefault(_embed);

var _inline = __nested_webpack_require_206753__(6);

var _inline2 = _interopRequireDefault(_inline);

var _scroll = __nested_webpack_require_206753__(22);

var _scroll2 = _interopRequireDefault(_scroll);

var _text = __nested_webpack_require_206753__(7);

var _text2 = _interopRequireDefault(_text);

var _clipboard = __nested_webpack_require_206753__(55);

var _clipboard2 = _interopRequireDefault(_clipboard);

var _history = __nested_webpack_require_206753__(42);

var _history2 = _interopRequireDefault(_history);

var _keyboard = __nested_webpack_require_206753__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_quill2.default.register({
  'blots/block': _block2.default,
  'blots/block/embed': _block.BlockEmbed,
  'blots/break': _break2.default,
  'blots/container': _container2.default,
  'blots/cursor': _cursor2.default,
  'blots/embed': _embed2.default,
  'blots/inline': _inline2.default,
  'blots/scroll': _scroll2.default,
  'blots/text': _text2.default,

  'modules/clipboard': _clipboard2.default,
  'modules/history': _history2.default,
  'modules/keyboard': _keyboard2.default
});

_parchment2.default.register(_block2.default, _break2.default, _cursor2.default, _inline2.default, _scroll2.default, _text2.default);

exports.default = _quill2.default;

/***/ }),
/* 30 */
/***/ (function(module, exports, __nested_webpack_require_208833__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var Registry = __nested_webpack_require_208833__(1);
var ShadowBlot = /** @class */ (function () {
    function ShadowBlot(domNode) {
        this.domNode = domNode;
        // @ts-ignore
        this.domNode[Registry.DATA_KEY] = { blot: this };
    }
    Object.defineProperty(ShadowBlot.prototype, "statics", {
        // Hack for accessing inherited static methods
        get: function () {
            return this.constructor;
        },
        enumerable: true,
        configurable: true
    });
    ShadowBlot.create = function (value) {
        if (this.tagName == null) {
            throw new Registry.ParchmentError('Blot definition missing tagName');
        }
        var node;
        if (Array.isArray(this.tagName)) {
            if (typeof value === 'string') {
                value = value.toUpperCase();
                if (parseInt(value).toString() === value) {
                    value = parseInt(value);
                }
            }
            if (typeof value === 'number') {
                node = document.createElement(this.tagName[value - 1]);
            }
            else if (this.tagName.indexOf(value) > -1) {
                node = document.createElement(value);
            }
            else {
                node = document.createElement(this.tagName[0]);
            }
        }
        else {
            node = document.createElement(this.tagName);
        }
        if (this.className) {
            node.classList.add(this.className);
        }
        return node;
    };
    ShadowBlot.prototype.attach = function () {
        if (this.parent != null) {
            this.scroll = this.parent.scroll;
        }
    };
    ShadowBlot.prototype.clone = function () {
        var domNode = this.domNode.cloneNode(false);
        return Registry.create(domNode);
    };
    ShadowBlot.prototype.detach = function () {
        if (this.parent != null)
            this.parent.removeChild(this);
        // @ts-ignore
        delete this.domNode[Registry.DATA_KEY];
    };
    ShadowBlot.prototype.deleteAt = function (index, length) {
        var blot = this.isolate(index, length);
        blot.remove();
    };
    ShadowBlot.prototype.formatAt = function (index, length, name, value) {
        var blot = this.isolate(index, length);
        if (Registry.query(name, Registry.Scope.BLOT) != null && value) {
            blot.wrap(name, value);
        }
        else if (Registry.query(name, Registry.Scope.ATTRIBUTE) != null) {
            var parent = Registry.create(this.statics.scope);
            blot.wrap(parent);
            parent.format(name, value);
        }
    };
    ShadowBlot.prototype.insertAt = function (index, value, def) {
        var blot = def == null ? Registry.create('text', value) : Registry.create(value, def);
        var ref = this.split(index);
        this.parent.insertBefore(blot, ref);
    };
    ShadowBlot.prototype.insertInto = function (parentBlot, refBlot) {
        if (refBlot === void 0) { refBlot = null; }
        if (this.parent != null) {
            this.parent.children.remove(this);
        }
        var refDomNode = null;
        parentBlot.children.insertBefore(this, refBlot);
        if (refBlot != null) {
            refDomNode = refBlot.domNode;
        }
        if (this.domNode.parentNode != parentBlot.domNode ||
            this.domNode.nextSibling != refDomNode) {
            parentBlot.domNode.insertBefore(this.domNode, refDomNode);
        }
        this.parent = parentBlot;
        this.attach();
    };
    ShadowBlot.prototype.isolate = function (index, length) {
        var target = this.split(index);
        target.split(length);
        return target;
    };
    ShadowBlot.prototype.length = function () {
        return 1;
    };
    ShadowBlot.prototype.offset = function (root) {
        if (root === void 0) { root = this.parent; }
        if (this.parent == null || this == root)
            return 0;
        return this.parent.children.offset(this) + this.parent.offset(root);
    };
    ShadowBlot.prototype.optimize = function (context) {
        // TODO clean up once we use WeakMap
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY] != null) {
            // @ts-ignore
            delete this.domNode[Registry.DATA_KEY].mutations;
        }
    };
    ShadowBlot.prototype.remove = function () {
        if (this.domNode.parentNode != null) {
            this.domNode.parentNode.removeChild(this.domNode);
        }
        this.detach();
    };
    ShadowBlot.prototype.replace = function (target) {
        if (target.parent == null)
            return;
        target.parent.insertBefore(this, target.next);
        target.remove();
    };
    ShadowBlot.prototype.replaceWith = function (name, value) {
        var replacement = typeof name === 'string' ? Registry.create(name, value) : name;
        replacement.replace(this);
        return replacement;
    };
    ShadowBlot.prototype.split = function (index, force) {
        return index === 0 ? this : this.next;
    };
    ShadowBlot.prototype.update = function (mutations, context) {
        // Nothing to do by default
    };
    ShadowBlot.prototype.wrap = function (name, value) {
        var wrapper = typeof name === 'string' ? Registry.create(name, value) : name;
        if (this.parent != null) {
            this.parent.insertBefore(wrapper, this.next);
        }
        wrapper.appendChild(this);
        return wrapper;
    };
    ShadowBlot.blotName = 'abstract';
    return ShadowBlot;
}());
exports.default = ShadowBlot;


/***/ }),
/* 31 */
/***/ (function(module, exports, __nested_webpack_require_214530__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __nested_webpack_require_214530__(12);
var class_1 = __nested_webpack_require_214530__(32);
var style_1 = __nested_webpack_require_214530__(33);
var Registry = __nested_webpack_require_214530__(1);
var AttributorStore = /** @class */ (function () {
    function AttributorStore(domNode) {
        this.attributes = {};
        this.domNode = domNode;
        this.build();
    }
    AttributorStore.prototype.attribute = function (attribute, value) {
        // verb
        if (value) {
            if (attribute.add(this.domNode, value)) {
                if (attribute.value(this.domNode) != null) {
                    this.attributes[attribute.attrName] = attribute;
                }
                else {
                    delete this.attributes[attribute.attrName];
                }
            }
        }
        else {
            attribute.remove(this.domNode);
            delete this.attributes[attribute.attrName];
        }
    };
    AttributorStore.prototype.build = function () {
        var _this = this;
        this.attributes = {};
        var attributes = attributor_1.default.keys(this.domNode);
        var classes = class_1.default.keys(this.domNode);
        var styles = style_1.default.keys(this.domNode);
        attributes
            .concat(classes)
            .concat(styles)
            .forEach(function (name) {
            var attr = Registry.query(name, Registry.Scope.ATTRIBUTE);
            if (attr instanceof attributor_1.default) {
                _this.attributes[attr.attrName] = attr;
            }
        });
    };
    AttributorStore.prototype.copy = function (target) {
        var _this = this;
        Object.keys(this.attributes).forEach(function (key) {
            var value = _this.attributes[key].value(_this.domNode);
            target.format(key, value);
        });
    };
    AttributorStore.prototype.move = function (target) {
        var _this = this;
        this.copy(target);
        Object.keys(this.attributes).forEach(function (key) {
            _this.attributes[key].remove(_this.domNode);
        });
        this.attributes = {};
    };
    AttributorStore.prototype.values = function () {
        var _this = this;
        return Object.keys(this.attributes).reduce(function (attributes, name) {
            attributes[name] = _this.attributes[name].value(_this.domNode);
            return attributes;
        }, {});
    };
    return AttributorStore;
}());
exports.default = AttributorStore;


/***/ }),
/* 32 */
/***/ (function(module, exports, __nested_webpack_require_217128__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __nested_webpack_require_217128__(12);
function match(node, prefix) {
    var className = node.getAttribute('class') || '';
    return className.split(/\s+/).filter(function (name) {
        return name.indexOf(prefix + "-") === 0;
    });
}
var ClassAttributor = /** @class */ (function (_super) {
    __extends(ClassAttributor, _super);
    function ClassAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClassAttributor.keys = function (node) {
        return (node.getAttribute('class') || '').split(/\s+/).map(function (name) {
            return name
                .split('-')
                .slice(0, -1)
                .join('-');
        });
    };
    ClassAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        this.remove(node);
        node.classList.add(this.keyName + "-" + value);
        return true;
    };
    ClassAttributor.prototype.remove = function (node) {
        var matches = match(node, this.keyName);
        matches.forEach(function (name) {
            node.classList.remove(name);
        });
        if (node.classList.length === 0) {
            node.removeAttribute('class');
        }
    };
    ClassAttributor.prototype.value = function (node) {
        var result = match(node, this.keyName)[0] || '';
        var value = result.slice(this.keyName.length + 1); // +1 for hyphen
        return this.canAdd(node, value) ? value : '';
    };
    return ClassAttributor;
}(attributor_1.default));
exports.default = ClassAttributor;


/***/ }),
/* 33 */
/***/ (function(module, exports, __nested_webpack_require_219372__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var attributor_1 = __nested_webpack_require_219372__(12);
function camelize(name) {
    var parts = name.split('-');
    var rest = parts
        .slice(1)
        .map(function (part) {
        return part[0].toUpperCase() + part.slice(1);
    })
        .join('');
    return parts[0] + rest;
}
var StyleAttributor = /** @class */ (function (_super) {
    __extends(StyleAttributor, _super);
    function StyleAttributor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StyleAttributor.keys = function (node) {
        return (node.getAttribute('style') || '').split(';').map(function (value) {
            var arr = value.split(':');
            return arr[0].trim();
        });
    };
    StyleAttributor.prototype.add = function (node, value) {
        if (!this.canAdd(node, value))
            return false;
        // @ts-ignore
        node.style[camelize(this.keyName)] = value;
        return true;
    };
    StyleAttributor.prototype.remove = function (node) {
        // @ts-ignore
        node.style[camelize(this.keyName)] = '';
        if (!node.getAttribute('style')) {
            node.removeAttribute('style');
        }
    };
    StyleAttributor.prototype.value = function (node) {
        // @ts-ignore
        var value = node.style[camelize(this.keyName)];
        return this.canAdd(node, value) ? value : '';
    };
    return StyleAttributor;
}(attributor_1.default));
exports.default = StyleAttributor;


/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Theme = function () {
  function Theme(quill, options) {
    _classCallCheck(this, Theme);

    this.quill = quill;
    this.options = options;
    this.modules = {};
  }

  _createClass(Theme, [{
    key: 'init',
    value: function init() {
      var _this = this;

      Object.keys(this.options.modules).forEach(function (name) {
        if (_this.modules[name] == null) {
          _this.addModule(name);
        }
      });
    }
  }, {
    key: 'addModule',
    value: function addModule(name) {
      var moduleClass = this.quill.constructor.import('modules/' + name);
      this.modules[name] = new moduleClass(this.quill, this.options.modules[name] || {});
      return this.modules[name];
    }
  }]);

  return Theme;
}();

Theme.DEFAULTS = {
  modules: {}
};
Theme.themes = {
  'default': Theme
};

exports.default = Theme;

/***/ }),
/* 35 */
/***/ (function(module, exports, __nested_webpack_require_223199__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_223199__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _text = __nested_webpack_require_223199__(7);

var _text2 = _interopRequireDefault(_text);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GUARD_TEXT = '\uFEFF';

var Embed = function (_Parchment$Embed) {
  _inherits(Embed, _Parchment$Embed);

  function Embed(node) {
    _classCallCheck(this, Embed);

    var _this = _possibleConstructorReturn(this, (Embed.__proto__ || Object.getPrototypeOf(Embed)).call(this, node));

    _this.contentNode = document.createElement('span');
    _this.contentNode.setAttribute('contenteditable', false);
    [].slice.call(_this.domNode.childNodes).forEach(function (childNode) {
      _this.contentNode.appendChild(childNode);
    });
    _this.leftGuard = document.createTextNode(GUARD_TEXT);
    _this.rightGuard = document.createTextNode(GUARD_TEXT);
    _this.domNode.appendChild(_this.leftGuard);
    _this.domNode.appendChild(_this.contentNode);
    _this.domNode.appendChild(_this.rightGuard);
    return _this;
  }

  _createClass(Embed, [{
    key: 'index',
    value: function index(node, offset) {
      if (node === this.leftGuard) return 0;
      if (node === this.rightGuard) return 1;
      return _get(Embed.prototype.__proto__ || Object.getPrototypeOf(Embed.prototype), 'index', this).call(this, node, offset);
    }
  }, {
    key: 'restore',
    value: function restore(node) {
      var range = void 0,
          textNode = void 0;
      var text = node.data.split(GUARD_TEXT).join('');
      if (node === this.leftGuard) {
        if (this.prev instanceof _text2.default) {
          var prevLength = this.prev.length();
          this.prev.insertAt(prevLength, text);
          range = {
            startNode: this.prev.domNode,
            startOffset: prevLength + text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      } else if (node === this.rightGuard) {
        if (this.next instanceof _text2.default) {
          this.next.insertAt(0, text);
          range = {
            startNode: this.next.domNode,
            startOffset: text.length
          };
        } else {
          textNode = document.createTextNode(text);
          this.parent.insertBefore(_parchment2.default.create(textNode), this.next);
          range = {
            startNode: textNode,
            startOffset: text.length
          };
        }
      }
      node.data = GUARD_TEXT;
      return range;
    }
  }, {
    key: 'update',
    value: function update(mutations, context) {
      var _this2 = this;

      mutations.forEach(function (mutation) {
        if (mutation.type === 'characterData' && (mutation.target === _this2.leftGuard || mutation.target === _this2.rightGuard)) {
          var range = _this2.restore(mutation.target);
          if (range) context.range = range;
        }
      });
    }
  }]);

  return Embed;
}(_parchment2.default.Embed);

exports.default = Embed;

/***/ }),
/* 36 */
/***/ (function(module, exports, __nested_webpack_require_228527__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AlignStyle = exports.AlignClass = exports.AlignAttribute = undefined;

var _parchment = __nested_webpack_require_228527__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['right', 'center', 'justify']
};

var AlignAttribute = new _parchment2.default.Attributor.Attribute('align', 'align', config);
var AlignClass = new _parchment2.default.Attributor.Class('align', 'ql-align', config);
var AlignStyle = new _parchment2.default.Attributor.Style('align', 'text-align', config);

exports.AlignAttribute = AlignAttribute;
exports.AlignClass = AlignClass;
exports.AlignStyle = AlignStyle;

/***/ }),
/* 37 */
/***/ (function(module, exports, __nested_webpack_require_229442__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BackgroundStyle = exports.BackgroundClass = undefined;

var _parchment = __nested_webpack_require_229442__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _color = __nested_webpack_require_229442__(26);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var BackgroundClass = new _parchment2.default.Attributor.Class('background', 'ql-bg', {
  scope: _parchment2.default.Scope.INLINE
});
var BackgroundStyle = new _color.ColorAttributor('background', 'background-color', {
  scope: _parchment2.default.Scope.INLINE
});

exports.BackgroundClass = BackgroundClass;
exports.BackgroundStyle = BackgroundStyle;

/***/ }),
/* 38 */
/***/ (function(module, exports, __nested_webpack_require_230249__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DirectionStyle = exports.DirectionClass = exports.DirectionAttribute = undefined;

var _parchment = __nested_webpack_require_230249__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var config = {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: ['rtl']
};

var DirectionAttribute = new _parchment2.default.Attributor.Attribute('direction', 'dir', config);
var DirectionClass = new _parchment2.default.Attributor.Class('direction', 'ql-direction', config);
var DirectionStyle = new _parchment2.default.Attributor.Style('direction', 'direction', config);

exports.DirectionAttribute = DirectionAttribute;
exports.DirectionClass = DirectionClass;
exports.DirectionStyle = DirectionStyle;

/***/ }),
/* 39 */
/***/ (function(module, exports, __nested_webpack_require_231202__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FontClass = exports.FontStyle = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_231202__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var config = {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['serif', 'monospace']
};

var FontClass = new _parchment2.default.Attributor.Class('font', 'ql-font', config);

var FontStyleAttributor = function (_Parchment$Attributor) {
  _inherits(FontStyleAttributor, _Parchment$Attributor);

  function FontStyleAttributor() {
    _classCallCheck(this, FontStyleAttributor);

    return _possibleConstructorReturn(this, (FontStyleAttributor.__proto__ || Object.getPrototypeOf(FontStyleAttributor)).apply(this, arguments));
  }

  _createClass(FontStyleAttributor, [{
    key: 'value',
    value: function value(node) {
      return _get(FontStyleAttributor.prototype.__proto__ || Object.getPrototypeOf(FontStyleAttributor.prototype), 'value', this).call(this, node).replace(/["']/g, '');
    }
  }]);

  return FontStyleAttributor;
}(_parchment2.default.Attributor.Style);

var FontStyle = new FontStyleAttributor('font', 'font-family', config);

exports.FontStyle = FontStyle;
exports.FontClass = FontClass;

/***/ }),
/* 40 */
/***/ (function(module, exports, __nested_webpack_require_234578__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SizeStyle = exports.SizeClass = undefined;

var _parchment = __nested_webpack_require_234578__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SizeClass = new _parchment2.default.Attributor.Class('size', 'ql-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['small', 'large', 'huge']
});
var SizeStyle = new _parchment2.default.Attributor.Style('size', 'font-size', {
  scope: _parchment2.default.Scope.INLINE,
  whitelist: ['10px', '18px', '32px']
});

exports.SizeClass = SizeClass;
exports.SizeStyle = SizeStyle;

/***/ }),
/* 41 */
/***/ (function(module, exports, __nested_webpack_require_235375__) {

"use strict";


module.exports = {
  'align': {
    '': __nested_webpack_require_235375__(76),
    'center': __nested_webpack_require_235375__(77),
    'right': __nested_webpack_require_235375__(78),
    'justify': __nested_webpack_require_235375__(79)
  },
  'background': __nested_webpack_require_235375__(80),
  'blockquote': __nested_webpack_require_235375__(81),
  'bold': __nested_webpack_require_235375__(82),
  'clean': __nested_webpack_require_235375__(83),
  'code': __nested_webpack_require_235375__(58),
  'code-block': __nested_webpack_require_235375__(58),
  'color': __nested_webpack_require_235375__(84),
  'direction': {
    '': __nested_webpack_require_235375__(85),
    'rtl': __nested_webpack_require_235375__(86)
  },
  'float': {
    'center': __nested_webpack_require_235375__(87),
    'full': __nested_webpack_require_235375__(88),
    'left': __nested_webpack_require_235375__(89),
    'right': __nested_webpack_require_235375__(90)
  },
  'formula': __nested_webpack_require_235375__(91),
  'header': {
    '1': __nested_webpack_require_235375__(92),
    '2': __nested_webpack_require_235375__(93)
  },
  'italic': __nested_webpack_require_235375__(94),
  'image': __nested_webpack_require_235375__(95),
  'indent': {
    '+1': __nested_webpack_require_235375__(96),
    '-1': __nested_webpack_require_235375__(97)
  },
  'link': __nested_webpack_require_235375__(98),
  'list': {
    'ordered': __nested_webpack_require_235375__(99),
    'bullet': __nested_webpack_require_235375__(100),
    'check': __nested_webpack_require_235375__(101)
  },
  'script': {
    'sub': __nested_webpack_require_235375__(102),
    'super': __nested_webpack_require_235375__(103)
  },
  'strike': __nested_webpack_require_235375__(104),
  'underline': __nested_webpack_require_235375__(105),
  'video': __nested_webpack_require_235375__(106)
};

/***/ }),
/* 42 */
/***/ (function(module, exports, __nested_webpack_require_236844__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLastChangeIndex = exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _parchment = __nested_webpack_require_236844__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_236844__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __nested_webpack_require_236844__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var History = function (_Module) {
  _inherits(History, _Module);

  function History(quill, options) {
    _classCallCheck(this, History);

    var _this = _possibleConstructorReturn(this, (History.__proto__ || Object.getPrototypeOf(History)).call(this, quill, options));

    _this.lastRecorded = 0;
    _this.ignoreChange = false;
    _this.clear();
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (eventName, delta, oldDelta, source) {
      if (eventName !== _quill2.default.events.TEXT_CHANGE || _this.ignoreChange) return;
      if (!_this.options.userOnly || source === _quill2.default.sources.USER) {
        _this.record(delta, oldDelta);
      } else {
        _this.transform(delta);
      }
    });
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true }, _this.undo.bind(_this));
    _this.quill.keyboard.addBinding({ key: 'Z', shortKey: true, shiftKey: true }, _this.redo.bind(_this));
    if (/Win/i.test(navigator.platform)) {
      _this.quill.keyboard.addBinding({ key: 'Y', shortKey: true }, _this.redo.bind(_this));
    }
    return _this;
  }

  _createClass(History, [{
    key: 'change',
    value: function change(source, dest) {
      if (this.stack[source].length === 0) return;
      var delta = this.stack[source].pop();
      this.stack[dest].push(delta);
      this.lastRecorded = 0;
      this.ignoreChange = true;
      this.quill.updateContents(delta[source], _quill2.default.sources.USER);
      this.ignoreChange = false;
      var index = getLastChangeIndex(delta[source]);
      this.quill.setSelection(index);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.stack = { undo: [], redo: [] };
    }
  }, {
    key: 'cutoff',
    value: function cutoff() {
      this.lastRecorded = 0;
    }
  }, {
    key: 'record',
    value: function record(changeDelta, oldDelta) {
      if (changeDelta.ops.length === 0) return;
      this.stack.redo = [];
      var undoDelta = this.quill.getContents().diff(oldDelta);
      var timestamp = Date.now();
      if (this.lastRecorded + this.options.delay > timestamp && this.stack.undo.length > 0) {
        var delta = this.stack.undo.pop();
        undoDelta = undoDelta.compose(delta.undo);
        changeDelta = delta.redo.compose(changeDelta);
      } else {
        this.lastRecorded = timestamp;
      }
      this.stack.undo.push({
        redo: changeDelta,
        undo: undoDelta
      });
      if (this.stack.undo.length > this.options.maxStack) {
        this.stack.undo.shift();
      }
    }
  }, {
    key: 'redo',
    value: function redo() {
      this.change('redo', 'undo');
    }
  }, {
    key: 'transform',
    value: function transform(delta) {
      this.stack.undo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
      this.stack.redo.forEach(function (change) {
        change.undo = delta.transform(change.undo, true);
        change.redo = delta.transform(change.redo, true);
      });
    }
  }, {
    key: 'undo',
    value: function undo() {
      this.change('undo', 'redo');
    }
  }]);

  return History;
}(_module2.default);

History.DEFAULTS = {
  delay: 1000,
  maxStack: 100,
  userOnly: false
};

function endsWithNewlineChange(delta) {
  var lastOp = delta.ops[delta.ops.length - 1];
  if (lastOp == null) return false;
  if (lastOp.insert != null) {
    return typeof lastOp.insert === 'string' && lastOp.insert.endsWith('\n');
  }
  if (lastOp.attributes != null) {
    return Object.keys(lastOp.attributes).some(function (attr) {
      return _parchment2.default.query(attr, _parchment2.default.Scope.BLOCK) != null;
    });
  }
  return false;
}

function getLastChangeIndex(delta) {
  var deleteLength = delta.reduce(function (length, op) {
    length += op.delete || 0;
    return length;
  }, 0);
  var changeIndex = delta.length() - deleteLength;
  if (endsWithNewlineChange(delta)) {
    changeIndex -= 1;
  }
  return changeIndex;
}

exports.default = History;
exports.getLastChangeIndex = getLastChangeIndex;

/***/ }),
/* 43 */
/***/ (function(module, exports, __nested_webpack_require_242979__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BaseTooltip = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _extend = __nested_webpack_require_242979__(3);

var _extend2 = _interopRequireDefault(_extend);

var _quillDelta = __nested_webpack_require_242979__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _emitter = __nested_webpack_require_242979__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _keyboard = __nested_webpack_require_242979__(23);

var _keyboard2 = _interopRequireDefault(_keyboard);

var _theme = __nested_webpack_require_242979__(34);

var _theme2 = _interopRequireDefault(_theme);

var _colorPicker = __nested_webpack_require_242979__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __nested_webpack_require_242979__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _picker = __nested_webpack_require_242979__(28);

var _picker2 = _interopRequireDefault(_picker);

var _tooltip = __nested_webpack_require_242979__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ALIGNS = [false, 'center', 'right', 'justify'];

var COLORS = ["#000000", "#e60000", "#ff9900", "#ffff00", "#008a00", "#0066cc", "#9933ff", "#ffffff", "#facccc", "#ffebcc", "#ffffcc", "#cce8cc", "#cce0f5", "#ebd6ff", "#bbbbbb", "#f06666", "#ffc266", "#ffff66", "#66b966", "#66a3e0", "#c285ff", "#888888", "#a10000", "#b26b00", "#b2b200", "#006100", "#0047b2", "#6b24b2", "#444444", "#5c0000", "#663d00", "#666600", "#003700", "#002966", "#3d1466"];

var FONTS = [false, 'serif', 'monospace'];

var HEADERS = ['1', '2', '3', false];

var SIZES = ['small', false, 'large', 'huge'];

var BaseTheme = function (_Theme) {
  _inherits(BaseTheme, _Theme);

  function BaseTheme(quill, options) {
    _classCallCheck(this, BaseTheme);

    var _this = _possibleConstructorReturn(this, (BaseTheme.__proto__ || Object.getPrototypeOf(BaseTheme)).call(this, quill, options));

    var listener = function listener(e) {
      if (!document.body.contains(quill.root)) {
        return document.body.removeEventListener('click', listener);
      }
      if (_this.tooltip != null && !_this.tooltip.root.contains(e.target) && document.activeElement !== _this.tooltip.textbox && !_this.quill.hasFocus()) {
        _this.tooltip.hide();
      }
      if (_this.pickers != null) {
        _this.pickers.forEach(function (picker) {
          if (!picker.container.contains(e.target)) {
            picker.close();
          }
        });
      }
    };
    quill.emitter.listenDOM('click', document.body, listener);
    return _this;
  }

  _createClass(BaseTheme, [{
    key: 'addModule',
    value: function addModule(name) {
      var module = _get(BaseTheme.prototype.__proto__ || Object.getPrototypeOf(BaseTheme.prototype), 'addModule', this).call(this, name);
      if (name === 'toolbar') {
        this.extendToolbar(module);
      }
      return module;
    }
  }, {
    key: 'buildButtons',
    value: function buildButtons(buttons, icons) {
      buttons.forEach(function (button) {
        var className = button.getAttribute('class') || '';
        className.split(/\s+/).forEach(function (name) {
          if (!name.startsWith('ql-')) return;
          name = name.slice('ql-'.length);
          if (icons[name] == null) return;
          if (name === 'direction') {
            button.innerHTML = icons[name][''] + icons[name]['rtl'];
          } else if (typeof icons[name] === 'string') {
            button.innerHTML = icons[name];
          } else {
            var value = button.value || '';
            if (value != null && icons[name][value]) {
              button.innerHTML = icons[name][value];
            }
          }
        });
      });
    }
  }, {
    key: 'buildPickers',
    value: function buildPickers(selects, icons) {
      var _this2 = this;

      this.pickers = selects.map(function (select) {
        if (select.classList.contains('ql-align')) {
          if (select.querySelector('option') == null) {
            fillSelect(select, ALIGNS);
          }
          return new _iconPicker2.default(select, icons.align);
        } else if (select.classList.contains('ql-background') || select.classList.contains('ql-color')) {
          var format = select.classList.contains('ql-background') ? 'background' : 'color';
          if (select.querySelector('option') == null) {
            fillSelect(select, COLORS, format === 'background' ? '#ffffff' : '#000000');
          }
          return new _colorPicker2.default(select, icons[format]);
        } else {
          if (select.querySelector('option') == null) {
            if (select.classList.contains('ql-font')) {
              fillSelect(select, FONTS);
            } else if (select.classList.contains('ql-header')) {
              fillSelect(select, HEADERS);
            } else if (select.classList.contains('ql-size')) {
              fillSelect(select, SIZES);
            }
          }
          return new _picker2.default(select);
        }
      });
      var update = function update() {
        _this2.pickers.forEach(function (picker) {
          picker.update();
        });
      };
      this.quill.on(_emitter2.default.events.EDITOR_CHANGE, update);
    }
  }]);

  return BaseTheme;
}(_theme2.default);

BaseTheme.DEFAULTS = (0, _extend2.default)(true, {}, _theme2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        formula: function formula() {
          this.quill.theme.tooltip.edit('formula');
        },
        image: function image() {
          var _this3 = this;

          var fileInput = this.container.querySelector('input.ql-image[type=file]');
          if (fileInput == null) {
            fileInput = document.createElement('input');
            fileInput.setAttribute('type', 'file');
            fileInput.setAttribute('accept', 'image/png, image/gif, image/jpeg, image/bmp, image/x-icon');
            fileInput.classList.add('ql-image');
            fileInput.addEventListener('change', function () {
              if (fileInput.files != null && fileInput.files[0] != null) {
                var reader = new FileReader();
                reader.onload = function (e) {
                  var range = _this3.quill.getSelection(true);
                  _this3.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert({ image: e.target.result }), _emitter2.default.sources.USER);
                  _this3.quill.setSelection(range.index + 1, _emitter2.default.sources.SILENT);
                  fileInput.value = "";
                };
                reader.readAsDataURL(fileInput.files[0]);
              }
            });
            this.container.appendChild(fileInput);
          }
          fileInput.click();
        },
        video: function video() {
          this.quill.theme.tooltip.edit('video');
        }
      }
    }
  }
});

var BaseTooltip = function (_Tooltip) {
  _inherits(BaseTooltip, _Tooltip);

  function BaseTooltip(quill, boundsContainer) {
    _classCallCheck(this, BaseTooltip);

    var _this4 = _possibleConstructorReturn(this, (BaseTooltip.__proto__ || Object.getPrototypeOf(BaseTooltip)).call(this, quill, boundsContainer));

    _this4.textbox = _this4.root.querySelector('input[type="text"]');
    _this4.listen();
    return _this4;
  }

  _createClass(BaseTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this5 = this;

      this.textbox.addEventListener('keydown', function (event) {
        if (_keyboard2.default.match(event, 'enter')) {
          _this5.save();
          event.preventDefault();
        } else if (_keyboard2.default.match(event, 'escape')) {
          _this5.cancel();
          event.preventDefault();
        }
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.hide();
    }
  }, {
    key: 'edit',
    value: function edit() {
      var mode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'link';
      var preview = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

      this.root.classList.remove('ql-hidden');
      this.root.classList.add('ql-editing');
      if (preview != null) {
        this.textbox.value = preview;
      } else if (mode !== this.root.getAttribute('data-mode')) {
        this.textbox.value = '';
      }
      this.position(this.quill.getBounds(this.quill.selection.savedRange));
      this.textbox.select();
      this.textbox.setAttribute('placeholder', this.textbox.getAttribute('data-' + mode) || '');
      this.root.setAttribute('data-mode', mode);
    }
  }, {
    key: 'restoreFocus',
    value: function restoreFocus() {
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.quill.focus();
      this.quill.scrollingContainer.scrollTop = scrollTop;
    }
  }, {
    key: 'save',
    value: function save() {
      var value = this.textbox.value;
      switch (this.root.getAttribute('data-mode')) {
        case 'link':
          {
            var scrollTop = this.quill.root.scrollTop;
            if (this.linkRange) {
              this.quill.formatText(this.linkRange, 'link', value, _emitter2.default.sources.USER);
              delete this.linkRange;
            } else {
              this.restoreFocus();
              this.quill.format('link', value, _emitter2.default.sources.USER);
            }
            this.quill.root.scrollTop = scrollTop;
            break;
          }
        case 'video':
          {
            value = extractVideoUrl(value);
          } // eslint-disable-next-line no-fallthrough
        case 'formula':
          {
            if (!value) break;
            var range = this.quill.getSelection(true);
            if (range != null) {
              var index = range.index + range.length;
              this.quill.insertEmbed(index, this.root.getAttribute('data-mode'), value, _emitter2.default.sources.USER);
              if (this.root.getAttribute('data-mode') === 'formula') {
                this.quill.insertText(index + 1, ' ', _emitter2.default.sources.USER);
              }
              this.quill.setSelection(index + 2, _emitter2.default.sources.USER);
            }
            break;
          }
        default:
      }
      this.textbox.value = '';
      this.hide();
    }
  }]);

  return BaseTooltip;
}(_tooltip2.default);

function extractVideoUrl(url) {
  var match = url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtube\.com\/watch.*v=([a-zA-Z0-9_-]+)/) || url.match(/^(?:(https?):\/\/)?(?:(?:www|m)\.)?youtu\.be\/([a-zA-Z0-9_-]+)/);
  if (match) {
    return (match[1] || 'https') + '://www.youtube.com/embed/' + match[2] + '?showinfo=0';
  }
  if (match = url.match(/^(?:(https?):\/\/)?(?:www\.)?vimeo\.com\/(\d+)/)) {
    // eslint-disable-line no-cond-assign
    return (match[1] || 'https') + '://player.vimeo.com/video/' + match[2] + '/';
  }
  return url;
}

function fillSelect(select, values) {
  var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value === defaultValue) {
      option.setAttribute('selected', 'selected');
    } else {
      option.setAttribute('value', value);
    }
    select.appendChild(option);
  });
}

exports.BaseTooltip = BaseTooltip;
exports.default = BaseTheme;

/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var LinkedList = /** @class */ (function () {
    function LinkedList() {
        this.head = this.tail = null;
        this.length = 0;
    }
    LinkedList.prototype.append = function () {
        var nodes = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            nodes[_i] = arguments[_i];
        }
        this.insertBefore(nodes[0], null);
        if (nodes.length > 1) {
            this.append.apply(this, nodes.slice(1));
        }
    };
    LinkedList.prototype.contains = function (node) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            if (cur === node)
                return true;
        }
        return false;
    };
    LinkedList.prototype.insertBefore = function (node, refNode) {
        if (!node)
            return;
        node.next = refNode;
        if (refNode != null) {
            node.prev = refNode.prev;
            if (refNode.prev != null) {
                refNode.prev.next = node;
            }
            refNode.prev = node;
            if (refNode === this.head) {
                this.head = node;
            }
        }
        else if (this.tail != null) {
            this.tail.next = node;
            node.prev = this.tail;
            this.tail = node;
        }
        else {
            node.prev = null;
            this.head = this.tail = node;
        }
        this.length += 1;
    };
    LinkedList.prototype.offset = function (target) {
        var index = 0, cur = this.head;
        while (cur != null) {
            if (cur === target)
                return index;
            index += cur.length();
            cur = cur.next;
        }
        return -1;
    };
    LinkedList.prototype.remove = function (node) {
        if (!this.contains(node))
            return;
        if (node.prev != null)
            node.prev.next = node.next;
        if (node.next != null)
            node.next.prev = node.prev;
        if (node === this.head)
            this.head = node.next;
        if (node === this.tail)
            this.tail = node.prev;
        this.length -= 1;
    };
    LinkedList.prototype.iterator = function (curNode) {
        if (curNode === void 0) { curNode = this.head; }
        // TODO use yield when we can
        return function () {
            var ret = curNode;
            if (curNode != null)
                curNode = curNode.next;
            return ret;
        };
    };
    LinkedList.prototype.find = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        var cur, next = this.iterator();
        while ((cur = next())) {
            var length = cur.length();
            if (index < length ||
                (inclusive && index === length && (cur.next == null || cur.next.length() !== 0))) {
                return [cur, index];
            }
            index -= length;
        }
        return [null, 0];
    };
    LinkedList.prototype.forEach = function (callback) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            callback(cur);
        }
    };
    LinkedList.prototype.forEachAt = function (index, length, callback) {
        if (length <= 0)
            return;
        var _a = this.find(index), startNode = _a[0], offset = _a[1];
        var cur, curIndex = index - offset, next = this.iterator(startNode);
        while ((cur = next()) && curIndex < index + length) {
            var curLength = cur.length();
            if (index > curIndex) {
                callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index));
            }
            else {
                callback(cur, 0, Math.min(curLength, index + length - curIndex));
            }
            curIndex += curLength;
        }
    };
    LinkedList.prototype.map = function (callback) {
        return this.reduce(function (memo, cur) {
            memo.push(callback(cur));
            return memo;
        }, []);
    };
    LinkedList.prototype.reduce = function (callback, memo) {
        var cur, next = this.iterator();
        while ((cur = next())) {
            memo = callback(memo, cur);
        }
        return memo;
    };
    return LinkedList;
}());
exports.default = LinkedList;


/***/ }),
/* 45 */
/***/ (function(module, exports, __nested_webpack_require_260796__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var container_1 = __nested_webpack_require_260796__(17);
var Registry = __nested_webpack_require_260796__(1);
var OBSERVER_CONFIG = {
    attributes: true,
    characterData: true,
    characterDataOldValue: true,
    childList: true,
    subtree: true,
};
var MAX_OPTIMIZE_ITERATIONS = 100;
var ScrollBlot = /** @class */ (function (_super) {
    __extends(ScrollBlot, _super);
    function ScrollBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.scroll = _this;
        _this.observer = new MutationObserver(function (mutations) {
            _this.update(mutations);
        });
        _this.observer.observe(_this.domNode, OBSERVER_CONFIG);
        _this.attach();
        return _this;
    }
    ScrollBlot.prototype.detach = function () {
        _super.prototype.detach.call(this);
        this.observer.disconnect();
    };
    ScrollBlot.prototype.deleteAt = function (index, length) {
        this.update();
        if (index === 0 && length === this.length()) {
            this.children.forEach(function (child) {
                child.remove();
            });
        }
        else {
            _super.prototype.deleteAt.call(this, index, length);
        }
    };
    ScrollBlot.prototype.formatAt = function (index, length, name, value) {
        this.update();
        _super.prototype.formatAt.call(this, index, length, name, value);
    };
    ScrollBlot.prototype.insertAt = function (index, value, def) {
        this.update();
        _super.prototype.insertAt.call(this, index, value, def);
    };
    ScrollBlot.prototype.optimize = function (mutations, context) {
        var _this = this;
        if (mutations === void 0) { mutations = []; }
        if (context === void 0) { context = {}; }
        _super.prototype.optimize.call(this, context);
        // We must modify mutations directly, cannot make copy and then modify
        var records = [].slice.call(this.observer.takeRecords());
        // Array.push currently seems to be implemented by a non-tail recursive function
        // so we cannot just mutations.push.apply(mutations, this.observer.takeRecords());
        while (records.length > 0)
            mutations.push(records.pop());
        // TODO use WeakMap
        var mark = function (blot, markParent) {
            if (markParent === void 0) { markParent = true; }
            if (blot == null || blot === _this)
                return;
            if (blot.domNode.parentNode == null)
                return;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [];
            }
            if (markParent)
                mark(blot.parent);
        };
        var optimize = function (blot) {
            // Post-order traversal
            if (
            // @ts-ignore
            blot.domNode[Registry.DATA_KEY] == null ||
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations == null) {
                return;
            }
            if (blot instanceof container_1.default) {
                blot.children.forEach(optimize);
            }
            blot.optimize(context);
        };
        var remaining = mutations;
        for (var i = 0; remaining.length > 0; i += 1) {
            if (i >= MAX_OPTIMIZE_ITERATIONS) {
                throw new Error('[Parchment] Maximum optimize iterations reached');
            }
            remaining.forEach(function (mutation) {
                var blot = Registry.find(mutation.target, true);
                if (blot == null)
                    return;
                if (blot.domNode === mutation.target) {
                    if (mutation.type === 'childList') {
                        mark(Registry.find(mutation.previousSibling, false));
                        [].forEach.call(mutation.addedNodes, function (node) {
                            var child = Registry.find(node, false);
                            mark(child, false);
                            if (child instanceof container_1.default) {
                                child.children.forEach(function (grandChild) {
                                    mark(grandChild, false);
                                });
                            }
                        });
                    }
                    else if (mutation.type === 'attributes') {
                        mark(blot.prev);
                    }
                }
                mark(blot);
            });
            this.children.forEach(optimize);
            remaining = [].slice.call(this.observer.takeRecords());
            records = remaining.slice();
            while (records.length > 0)
                mutations.push(records.pop());
        }
    };
    ScrollBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (context === void 0) { context = {}; }
        mutations = mutations || this.observer.takeRecords();
        // TODO use WeakMap
        mutations
            .map(function (mutation) {
            var blot = Registry.find(mutation.target, true);
            if (blot == null)
                return null;
            // @ts-ignore
            if (blot.domNode[Registry.DATA_KEY].mutations == null) {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations = [mutation];
                return blot;
            }
            else {
                // @ts-ignore
                blot.domNode[Registry.DATA_KEY].mutations.push(mutation);
                return null;
            }
        })
            .forEach(function (blot) {
            if (blot == null ||
                blot === _this ||
                //@ts-ignore
                blot.domNode[Registry.DATA_KEY] == null)
                return;
            // @ts-ignore
            blot.update(blot.domNode[Registry.DATA_KEY].mutations || [], context);
        });
        // @ts-ignore
        if (this.domNode[Registry.DATA_KEY].mutations != null) {
            // @ts-ignore
            _super.prototype.update.call(this, this.domNode[Registry.DATA_KEY].mutations, context);
        }
        this.optimize(mutations, context);
    };
    ScrollBlot.blotName = 'scroll';
    ScrollBlot.defaultChild = 'block';
    ScrollBlot.scope = Registry.Scope.BLOCK_BLOT;
    ScrollBlot.tagName = 'DIV';
    return ScrollBlot;
}(container_1.default));
exports.default = ScrollBlot;


/***/ }),
/* 46 */
/***/ (function(module, exports, __nested_webpack_require_267910__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __nested_webpack_require_267910__(18);
var Registry = __nested_webpack_require_267910__(1);
// Shallow object comparison
function isEqual(obj1, obj2) {
    if (Object.keys(obj1).length !== Object.keys(obj2).length)
        return false;
    // @ts-ignore
    for (var prop in obj1) {
        // @ts-ignore
        if (obj1[prop] !== obj2[prop])
            return false;
    }
    return true;
}
var InlineBlot = /** @class */ (function (_super) {
    __extends(InlineBlot, _super);
    function InlineBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InlineBlot.formats = function (domNode) {
        if (domNode.tagName === InlineBlot.tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    InlineBlot.prototype.format = function (name, value) {
        var _this = this;
        if (name === this.statics.blotName && !value) {
            this.children.forEach(function (child) {
                if (!(child instanceof format_1.default)) {
                    child = child.wrap(InlineBlot.blotName, true);
                }
                _this.attributes.copy(child);
            });
            this.unwrap();
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    InlineBlot.prototype.formatAt = function (index, length, name, value) {
        if (this.formats()[name] != null || Registry.query(name, Registry.Scope.ATTRIBUTE)) {
            var blot = this.isolate(index, length);
            blot.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    InlineBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        var formats = this.formats();
        if (Object.keys(formats).length === 0) {
            return this.unwrap(); // unformatted span
        }
        var next = this.next;
        if (next instanceof InlineBlot && next.prev === this && isEqual(formats, next.formats())) {
            next.moveChildren(this);
            next.remove();
        }
    };
    InlineBlot.blotName = 'inline';
    InlineBlot.scope = Registry.Scope.INLINE_BLOT;
    InlineBlot.tagName = 'SPAN';
    return InlineBlot;
}(format_1.default));
exports.default = InlineBlot;


/***/ }),
/* 47 */
/***/ (function(module, exports, __nested_webpack_require_270902__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var format_1 = __nested_webpack_require_270902__(18);
var Registry = __nested_webpack_require_270902__(1);
var BlockBlot = /** @class */ (function (_super) {
    __extends(BlockBlot, _super);
    function BlockBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BlockBlot.formats = function (domNode) {
        var tagName = Registry.query(BlockBlot.blotName).tagName;
        if (domNode.tagName === tagName)
            return undefined;
        return _super.formats.call(this, domNode);
    };
    BlockBlot.prototype.format = function (name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) == null) {
            return;
        }
        else if (name === this.statics.blotName && !value) {
            this.replaceWith(BlockBlot.blotName);
        }
        else {
            _super.prototype.format.call(this, name, value);
        }
    };
    BlockBlot.prototype.formatAt = function (index, length, name, value) {
        if (Registry.query(name, Registry.Scope.BLOCK) != null) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    BlockBlot.prototype.insertAt = function (index, value, def) {
        if (def == null || Registry.query(value, Registry.Scope.INLINE) != null) {
            // Insert text or inline
            _super.prototype.insertAt.call(this, index, value, def);
        }
        else {
            var after = this.split(index);
            var blot = Registry.create(value, def);
            after.parent.insertBefore(blot, after);
        }
    };
    BlockBlot.prototype.update = function (mutations, context) {
        if (navigator.userAgent.match(/Trident/)) {
            this.build();
        }
        else {
            _super.prototype.update.call(this, mutations, context);
        }
    };
    BlockBlot.blotName = 'block';
    BlockBlot.scope = Registry.Scope.BLOCK_BLOT;
    BlockBlot.tagName = 'P';
    return BlockBlot;
}(format_1.default));
exports.default = BlockBlot;


/***/ }),
/* 48 */
/***/ (function(module, exports, __nested_webpack_require_273610__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __nested_webpack_require_273610__(19);
var EmbedBlot = /** @class */ (function (_super) {
    __extends(EmbedBlot, _super);
    function EmbedBlot() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EmbedBlot.formats = function (domNode) {
        return undefined;
    };
    EmbedBlot.prototype.format = function (name, value) {
        // super.formatAt wraps, which is what we want in general,
        // but this allows subclasses to overwrite for formats
        // that just apply to particular embeds
        _super.prototype.formatAt.call(this, 0, this.length(), name, value);
    };
    EmbedBlot.prototype.formatAt = function (index, length, name, value) {
        if (index === 0 && length === this.length()) {
            this.format(name, value);
        }
        else {
            _super.prototype.formatAt.call(this, index, length, name, value);
        }
    };
    EmbedBlot.prototype.formats = function () {
        return this.statics.formats(this.domNode);
    };
    return EmbedBlot;
}(leaf_1.default));
exports.default = EmbedBlot;


/***/ }),
/* 49 */
/***/ (function(module, exports, __nested_webpack_require_275351__) {

"use strict";

var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var leaf_1 = __nested_webpack_require_275351__(19);
var Registry = __nested_webpack_require_275351__(1);
var TextBlot = /** @class */ (function (_super) {
    __extends(TextBlot, _super);
    function TextBlot(node) {
        var _this = _super.call(this, node) || this;
        _this.text = _this.statics.value(_this.domNode);
        return _this;
    }
    TextBlot.create = function (value) {
        return document.createTextNode(value);
    };
    TextBlot.value = function (domNode) {
        var text = domNode.data;
        // @ts-ignore
        if (text['normalize'])
            text = text['normalize']();
        return text;
    };
    TextBlot.prototype.deleteAt = function (index, length) {
        this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    };
    TextBlot.prototype.index = function (node, offset) {
        if (this.domNode === node) {
            return offset;
        }
        return -1;
    };
    TextBlot.prototype.insertAt = function (index, value, def) {
        if (def == null) {
            this.text = this.text.slice(0, index) + value + this.text.slice(index);
            this.domNode.data = this.text;
        }
        else {
            _super.prototype.insertAt.call(this, index, value, def);
        }
    };
    TextBlot.prototype.length = function () {
        return this.text.length;
    };
    TextBlot.prototype.optimize = function (context) {
        _super.prototype.optimize.call(this, context);
        this.text = this.statics.value(this.domNode);
        if (this.text.length === 0) {
            this.remove();
        }
        else if (this.next instanceof TextBlot && this.next.prev === this) {
            this.insertAt(this.length(), this.next.value());
            this.next.remove();
        }
    };
    TextBlot.prototype.position = function (index, inclusive) {
        if (inclusive === void 0) { inclusive = false; }
        return [this.domNode, index];
    };
    TextBlot.prototype.split = function (index, force) {
        if (force === void 0) { force = false; }
        if (!force) {
            if (index === 0)
                return this;
            if (index === this.length())
                return this.next;
        }
        var after = Registry.create(this.domNode.splitText(index));
        this.parent.insertBefore(after, this.next);
        this.text = this.statics.value(this.domNode);
        return after;
    };
    TextBlot.prototype.update = function (mutations, context) {
        var _this = this;
        if (mutations.some(function (mutation) {
            return mutation.type === 'characterData' && mutation.target === _this.domNode;
        })) {
            this.text = this.statics.value(this.domNode);
        }
    };
    TextBlot.prototype.value = function () {
        return this.text;
    };
    TextBlot.blotName = 'text';
    TextBlot.scope = Registry.Scope.INLINE_BLOT;
    return TextBlot;
}(leaf_1.default));
exports.default = TextBlot;


/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var elem = document.createElement('div');
elem.classList.toggle('test-class', false);
if (elem.classList.contains('test-class')) {
  var _toggle = DOMTokenList.prototype.toggle;
  DOMTokenList.prototype.toggle = function (token, force) {
    if (arguments.length > 1 && !this.contains(token) === !force) {
      return force;
    } else {
      return _toggle.call(this, token);
    }
  };
}

if (!String.prototype.startsWith) {
  String.prototype.startsWith = function (searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
  };
}

if (!String.prototype.endsWith) {
  String.prototype.endsWith = function (searchString, position) {
    var subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
      position = subjectString.length;
    }
    position -= searchString.length;
    var lastIndex = subjectString.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
  };
}

if (!Array.prototype.find) {
  Object.defineProperty(Array.prototype, "find", {
    value: function value(predicate) {
      if (this === null) {
        throw new TypeError('Array.prototype.find called on null or undefined');
      }
      if (typeof predicate !== 'function') {
        throw new TypeError('predicate must be a function');
      }
      var list = Object(this);
      var length = list.length >>> 0;
      var thisArg = arguments[1];
      var value;

      for (var i = 0; i < length; i++) {
        value = list[i];
        if (predicate.call(thisArg, value, i, list)) {
          return value;
        }
      }
      return undefined;
    }
  });
}

document.addEventListener("DOMContentLoaded", function () {
  // Disable resizing in Firefox
  document.execCommand("enableObjectResizing", false, false);
  // Disable automatic linkifying in IE11
  document.execCommand("autoUrlDetect", false, false);
});

/***/ }),
/* 51 */
/***/ (function(module, exports) {

/**
 * This library modifies the diff-patch-match library by Neil Fraser
 * by removing the patch and match functionality and certain advanced
 * options in the diff function. The original license is as follows:
 *
 * ===
 *
 * Diff Match and Patch
 *
 * Copyright 2006 Google Inc.
 * http://code.google.com/p/google-diff-match-patch/
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


/**
 * The data structure representing a diff is an array of tuples:
 * [[DIFF_DELETE, 'Hello'], [DIFF_INSERT, 'Goodbye'], [DIFF_EQUAL, ' world.']]
 * which means: delete 'Hello', add 'Goodbye' and keep ' world.'
 */
var DIFF_DELETE = -1;
var DIFF_INSERT = 1;
var DIFF_EQUAL = 0;


/**
 * Find the differences between two texts.  Simplifies the problem by stripping
 * any common prefix or suffix off the texts before diffing.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {Int} cursor_pos Expected edit position in text1 (optional)
 * @return {Array} Array of diff tuples.
 */
function diff_main(text1, text2, cursor_pos) {
  // Check for equality (speedup).
  if (text1 == text2) {
    if (text1) {
      return [[DIFF_EQUAL, text1]];
    }
    return [];
  }

  // Check cursor_pos within bounds
  if (cursor_pos < 0 || text1.length < cursor_pos) {
    cursor_pos = null;
  }

  // Trim off common prefix (speedup).
  var commonlength = diff_commonPrefix(text1, text2);
  var commonprefix = text1.substring(0, commonlength);
  text1 = text1.substring(commonlength);
  text2 = text2.substring(commonlength);

  // Trim off common suffix (speedup).
  commonlength = diff_commonSuffix(text1, text2);
  var commonsuffix = text1.substring(text1.length - commonlength);
  text1 = text1.substring(0, text1.length - commonlength);
  text2 = text2.substring(0, text2.length - commonlength);

  // Compute the diff on the middle block.
  var diffs = diff_compute_(text1, text2);

  // Restore the prefix and suffix.
  if (commonprefix) {
    diffs.unshift([DIFF_EQUAL, commonprefix]);
  }
  if (commonsuffix) {
    diffs.push([DIFF_EQUAL, commonsuffix]);
  }
  diff_cleanupMerge(diffs);
  if (cursor_pos != null) {
    diffs = fix_cursor(diffs, cursor_pos);
  }
  diffs = fix_emoji(diffs);
  return diffs;
};


/**
 * Find the differences between two texts.  Assumes that the texts do not
 * have any common prefix or suffix.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 */
function diff_compute_(text1, text2) {
  var diffs;

  if (!text1) {
    // Just add some text (speedup).
    return [[DIFF_INSERT, text2]];
  }

  if (!text2) {
    // Just delete some text (speedup).
    return [[DIFF_DELETE, text1]];
  }

  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  var i = longtext.indexOf(shorttext);
  if (i != -1) {
    // Shorter text is inside the longer text (speedup).
    diffs = [[DIFF_INSERT, longtext.substring(0, i)],
             [DIFF_EQUAL, shorttext],
             [DIFF_INSERT, longtext.substring(i + shorttext.length)]];
    // Swap insertions for deletions if diff is reversed.
    if (text1.length > text2.length) {
      diffs[0][0] = diffs[2][0] = DIFF_DELETE;
    }
    return diffs;
  }

  if (shorttext.length == 1) {
    // Single character string.
    // After the previous speedup, the character can't be an equality.
    return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
  }

  // Check to see if the problem can be split in two.
  var hm = diff_halfMatch_(text1, text2);
  if (hm) {
    // A half-match was found, sort out the return data.
    var text1_a = hm[0];
    var text1_b = hm[1];
    var text2_a = hm[2];
    var text2_b = hm[3];
    var mid_common = hm[4];
    // Send both pairs off for separate processing.
    var diffs_a = diff_main(text1_a, text2_a);
    var diffs_b = diff_main(text1_b, text2_b);
    // Merge the results.
    return diffs_a.concat([[DIFF_EQUAL, mid_common]], diffs_b);
  }

  return diff_bisect_(text1, text2);
};


/**
 * Find the 'middle snake' of a diff, split the problem in two
 * and return the recursively constructed diff.
 * See Myers 1986 paper: An O(ND) Difference Algorithm and Its Variations.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @return {Array} Array of diff tuples.
 * @private
 */
function diff_bisect_(text1, text2) {
  // Cache the text lengths to prevent multiple calls.
  var text1_length = text1.length;
  var text2_length = text2.length;
  var max_d = Math.ceil((text1_length + text2_length) / 2);
  var v_offset = max_d;
  var v_length = 2 * max_d;
  var v1 = new Array(v_length);
  var v2 = new Array(v_length);
  // Setting all elements to -1 is faster in Chrome & Firefox than mixing
  // integers and undefined.
  for (var x = 0; x < v_length; x++) {
    v1[x] = -1;
    v2[x] = -1;
  }
  v1[v_offset + 1] = 0;
  v2[v_offset + 1] = 0;
  var delta = text1_length - text2_length;
  // If the total number of characters is odd, then the front path will collide
  // with the reverse path.
  var front = (delta % 2 != 0);
  // Offsets for start and end of k loop.
  // Prevents mapping of space beyond the grid.
  var k1start = 0;
  var k1end = 0;
  var k2start = 0;
  var k2end = 0;
  for (var d = 0; d < max_d; d++) {
    // Walk the front path one step.
    for (var k1 = -d + k1start; k1 <= d - k1end; k1 += 2) {
      var k1_offset = v_offset + k1;
      var x1;
      if (k1 == -d || (k1 != d && v1[k1_offset - 1] < v1[k1_offset + 1])) {
        x1 = v1[k1_offset + 1];
      } else {
        x1 = v1[k1_offset - 1] + 1;
      }
      var y1 = x1 - k1;
      while (x1 < text1_length && y1 < text2_length &&
             text1.charAt(x1) == text2.charAt(y1)) {
        x1++;
        y1++;
      }
      v1[k1_offset] = x1;
      if (x1 > text1_length) {
        // Ran off the right of the graph.
        k1end += 2;
      } else if (y1 > text2_length) {
        // Ran off the bottom of the graph.
        k1start += 2;
      } else if (front) {
        var k2_offset = v_offset + delta - k1;
        if (k2_offset >= 0 && k2_offset < v_length && v2[k2_offset] != -1) {
          // Mirror x2 onto top-left coordinate system.
          var x2 = text1_length - v2[k2_offset];
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }

    // Walk the reverse path one step.
    for (var k2 = -d + k2start; k2 <= d - k2end; k2 += 2) {
      var k2_offset = v_offset + k2;
      var x2;
      if (k2 == -d || (k2 != d && v2[k2_offset - 1] < v2[k2_offset + 1])) {
        x2 = v2[k2_offset + 1];
      } else {
        x2 = v2[k2_offset - 1] + 1;
      }
      var y2 = x2 - k2;
      while (x2 < text1_length && y2 < text2_length &&
             text1.charAt(text1_length - x2 - 1) ==
             text2.charAt(text2_length - y2 - 1)) {
        x2++;
        y2++;
      }
      v2[k2_offset] = x2;
      if (x2 > text1_length) {
        // Ran off the left of the graph.
        k2end += 2;
      } else if (y2 > text2_length) {
        // Ran off the top of the graph.
        k2start += 2;
      } else if (!front) {
        var k1_offset = v_offset + delta - k2;
        if (k1_offset >= 0 && k1_offset < v_length && v1[k1_offset] != -1) {
          var x1 = v1[k1_offset];
          var y1 = v_offset + x1 - k1_offset;
          // Mirror x2 onto top-left coordinate system.
          x2 = text1_length - x2;
          if (x1 >= x2) {
            // Overlap detected.
            return diff_bisectSplit_(text1, text2, x1, y1);
          }
        }
      }
    }
  }
  // Diff took too long and hit the deadline or
  // number of diffs equals number of characters, no commonality at all.
  return [[DIFF_DELETE, text1], [DIFF_INSERT, text2]];
};


/**
 * Given the location of the 'middle snake', split the diff in two parts
 * and recurse.
 * @param {string} text1 Old string to be diffed.
 * @param {string} text2 New string to be diffed.
 * @param {number} x Index of split point in text1.
 * @param {number} y Index of split point in text2.
 * @return {Array} Array of diff tuples.
 */
function diff_bisectSplit_(text1, text2, x, y) {
  var text1a = text1.substring(0, x);
  var text2a = text2.substring(0, y);
  var text1b = text1.substring(x);
  var text2b = text2.substring(y);

  // Compute both diffs serially.
  var diffs = diff_main(text1a, text2a);
  var diffsb = diff_main(text1b, text2b);

  return diffs.concat(diffsb);
};


/**
 * Determine the common prefix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the start of each
 *     string.
 */
function diff_commonPrefix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 || text1.charAt(0) != text2.charAt(0)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerstart = 0;
  while (pointermin < pointermid) {
    if (text1.substring(pointerstart, pointermid) ==
        text2.substring(pointerstart, pointermid)) {
      pointermin = pointermid;
      pointerstart = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Determine the common suffix of two strings.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {number} The number of characters common to the end of each string.
 */
function diff_commonSuffix(text1, text2) {
  // Quick check for common null cases.
  if (!text1 || !text2 ||
      text1.charAt(text1.length - 1) != text2.charAt(text2.length - 1)) {
    return 0;
  }
  // Binary search.
  // Performance analysis: http://neil.fraser.name/news/2007/10/09/
  var pointermin = 0;
  var pointermax = Math.min(text1.length, text2.length);
  var pointermid = pointermax;
  var pointerend = 0;
  while (pointermin < pointermid) {
    if (text1.substring(text1.length - pointermid, text1.length - pointerend) ==
        text2.substring(text2.length - pointermid, text2.length - pointerend)) {
      pointermin = pointermid;
      pointerend = pointermin;
    } else {
      pointermax = pointermid;
    }
    pointermid = Math.floor((pointermax - pointermin) / 2 + pointermin);
  }
  return pointermid;
};


/**
 * Do the two texts share a substring which is at least half the length of the
 * longer text?
 * This speedup can produce non-minimal diffs.
 * @param {string} text1 First string.
 * @param {string} text2 Second string.
 * @return {Array.<string>} Five element Array, containing the prefix of
 *     text1, the suffix of text1, the prefix of text2, the suffix of
 *     text2 and the common middle.  Or null if there was no match.
 */
function diff_halfMatch_(text1, text2) {
  var longtext = text1.length > text2.length ? text1 : text2;
  var shorttext = text1.length > text2.length ? text2 : text1;
  if (longtext.length < 4 || shorttext.length * 2 < longtext.length) {
    return null;  // Pointless.
  }

  /**
   * Does a substring of shorttext exist within longtext such that the substring
   * is at least half the length of longtext?
   * Closure, but does not reference any external variables.
   * @param {string} longtext Longer string.
   * @param {string} shorttext Shorter string.
   * @param {number} i Start index of quarter length substring within longtext.
   * @return {Array.<string>} Five element Array, containing the prefix of
   *     longtext, the suffix of longtext, the prefix of shorttext, the suffix
   *     of shorttext and the common middle.  Or null if there was no match.
   * @private
   */
  function diff_halfMatchI_(longtext, shorttext, i) {
    // Start with a 1/4 length substring at position i as a seed.
    var seed = longtext.substring(i, i + Math.floor(longtext.length / 4));
    var j = -1;
    var best_common = '';
    var best_longtext_a, best_longtext_b, best_shorttext_a, best_shorttext_b;
    while ((j = shorttext.indexOf(seed, j + 1)) != -1) {
      var prefixLength = diff_commonPrefix(longtext.substring(i),
                                           shorttext.substring(j));
      var suffixLength = diff_commonSuffix(longtext.substring(0, i),
                                           shorttext.substring(0, j));
      if (best_common.length < suffixLength + prefixLength) {
        best_common = shorttext.substring(j - suffixLength, j) +
            shorttext.substring(j, j + prefixLength);
        best_longtext_a = longtext.substring(0, i - suffixLength);
        best_longtext_b = longtext.substring(i + prefixLength);
        best_shorttext_a = shorttext.substring(0, j - suffixLength);
        best_shorttext_b = shorttext.substring(j + prefixLength);
      }
    }
    if (best_common.length * 2 >= longtext.length) {
      return [best_longtext_a, best_longtext_b,
              best_shorttext_a, best_shorttext_b, best_common];
    } else {
      return null;
    }
  }

  // First check if the second quarter is the seed for a half-match.
  var hm1 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 4));
  // Check again based on the third quarter.
  var hm2 = diff_halfMatchI_(longtext, shorttext,
                             Math.ceil(longtext.length / 2));
  var hm;
  if (!hm1 && !hm2) {
    return null;
  } else if (!hm2) {
    hm = hm1;
  } else if (!hm1) {
    hm = hm2;
  } else {
    // Both matched.  Select the longest.
    hm = hm1[4].length > hm2[4].length ? hm1 : hm2;
  }

  // A half-match was found, sort out the return data.
  var text1_a, text1_b, text2_a, text2_b;
  if (text1.length > text2.length) {
    text1_a = hm[0];
    text1_b = hm[1];
    text2_a = hm[2];
    text2_b = hm[3];
  } else {
    text2_a = hm[0];
    text2_b = hm[1];
    text1_a = hm[2];
    text1_b = hm[3];
  }
  var mid_common = hm[4];
  return [text1_a, text1_b, text2_a, text2_b, mid_common];
};


/**
 * Reorder and merge like edit sections.  Merge equalities.
 * Any edit section can move as long as it doesn't cross an equality.
 * @param {Array} diffs Array of diff tuples.
 */
function diff_cleanupMerge(diffs) {
  diffs.push([DIFF_EQUAL, '']);  // Add a dummy entry at the end.
  var pointer = 0;
  var count_delete = 0;
  var count_insert = 0;
  var text_delete = '';
  var text_insert = '';
  var commonlength;
  while (pointer < diffs.length) {
    switch (diffs[pointer][0]) {
      case DIFF_INSERT:
        count_insert++;
        text_insert += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_DELETE:
        count_delete++;
        text_delete += diffs[pointer][1];
        pointer++;
        break;
      case DIFF_EQUAL:
        // Upon reaching an equality, check for prior redundancies.
        if (count_delete + count_insert > 1) {
          if (count_delete !== 0 && count_insert !== 0) {
            // Factor out any common prefixies.
            commonlength = diff_commonPrefix(text_insert, text_delete);
            if (commonlength !== 0) {
              if ((pointer - count_delete - count_insert) > 0 &&
                  diffs[pointer - count_delete - count_insert - 1][0] ==
                  DIFF_EQUAL) {
                diffs[pointer - count_delete - count_insert - 1][1] +=
                    text_insert.substring(0, commonlength);
              } else {
                diffs.splice(0, 0, [DIFF_EQUAL,
                                    text_insert.substring(0, commonlength)]);
                pointer++;
              }
              text_insert = text_insert.substring(commonlength);
              text_delete = text_delete.substring(commonlength);
            }
            // Factor out any common suffixies.
            commonlength = diff_commonSuffix(text_insert, text_delete);
            if (commonlength !== 0) {
              diffs[pointer][1] = text_insert.substring(text_insert.length -
                  commonlength) + diffs[pointer][1];
              text_insert = text_insert.substring(0, text_insert.length -
                  commonlength);
              text_delete = text_delete.substring(0, text_delete.length -
                  commonlength);
            }
          }
          // Delete the offending records and add the merged ones.
          if (count_delete === 0) {
            diffs.splice(pointer - count_insert,
                count_delete + count_insert, [DIFF_INSERT, text_insert]);
          } else if (count_insert === 0) {
            diffs.splice(pointer - count_delete,
                count_delete + count_insert, [DIFF_DELETE, text_delete]);
          } else {
            diffs.splice(pointer - count_delete - count_insert,
                count_delete + count_insert, [DIFF_DELETE, text_delete],
                [DIFF_INSERT, text_insert]);
          }
          pointer = pointer - count_delete - count_insert +
                    (count_delete ? 1 : 0) + (count_insert ? 1 : 0) + 1;
        } else if (pointer !== 0 && diffs[pointer - 1][0] == DIFF_EQUAL) {
          // Merge this equality with the previous one.
          diffs[pointer - 1][1] += diffs[pointer][1];
          diffs.splice(pointer, 1);
        } else {
          pointer++;
        }
        count_insert = 0;
        count_delete = 0;
        text_delete = '';
        text_insert = '';
        break;
    }
  }
  if (diffs[diffs.length - 1][1] === '') {
    diffs.pop();  // Remove the dummy entry at the end.
  }

  // Second pass: look for single edits surrounded on both sides by equalities
  // which can be shifted sideways to eliminate an equality.
  // e.g: A<ins>BA</ins>C -> <ins>AB</ins>AC
  var changes = false;
  pointer = 1;
  // Intentionally ignore the first and last element (don't need checking).
  while (pointer < diffs.length - 1) {
    if (diffs[pointer - 1][0] == DIFF_EQUAL &&
        diffs[pointer + 1][0] == DIFF_EQUAL) {
      // This is a single edit surrounded by equalities.
      if (diffs[pointer][1].substring(diffs[pointer][1].length -
          diffs[pointer - 1][1].length) == diffs[pointer - 1][1]) {
        // Shift the edit over the previous equality.
        diffs[pointer][1] = diffs[pointer - 1][1] +
            diffs[pointer][1].substring(0, diffs[pointer][1].length -
                                        diffs[pointer - 1][1].length);
        diffs[pointer + 1][1] = diffs[pointer - 1][1] + diffs[pointer + 1][1];
        diffs.splice(pointer - 1, 1);
        changes = true;
      } else if (diffs[pointer][1].substring(0, diffs[pointer + 1][1].length) ==
          diffs[pointer + 1][1]) {
        // Shift the edit over the next equality.
        diffs[pointer - 1][1] += diffs[pointer + 1][1];
        diffs[pointer][1] =
            diffs[pointer][1].substring(diffs[pointer + 1][1].length) +
            diffs[pointer + 1][1];
        diffs.splice(pointer + 1, 1);
        changes = true;
      }
    }
    pointer++;
  }
  // If shifts were made, the diff needs reordering and another shift sweep.
  if (changes) {
    diff_cleanupMerge(diffs);
  }
};


var diff = diff_main;
diff.INSERT = DIFF_INSERT;
diff.DELETE = DIFF_DELETE;
diff.EQUAL = DIFF_EQUAL;

module.exports = diff;

/*
 * Modify a diff such that the cursor position points to the start of a change:
 * E.g.
 *   cursor_normalize_diff([[DIFF_EQUAL, 'abc']], 1)
 *     => [1, [[DIFF_EQUAL, 'a'], [DIFF_EQUAL, 'bc']]]
 *   cursor_normalize_diff([[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xyz']], 2)
 *     => [2, [[DIFF_INSERT, 'new'], [DIFF_DELETE, 'xy'], [DIFF_DELETE, 'z']]]
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} A tuple [cursor location in the modified diff, modified diff]
 */
function cursor_normalize_diff (diffs, cursor_pos) {
  if (cursor_pos === 0) {
    return [DIFF_EQUAL, diffs];
  }
  for (var current_pos = 0, i = 0; i < diffs.length; i++) {
    var d = diffs[i];
    if (d[0] === DIFF_DELETE || d[0] === DIFF_EQUAL) {
      var next_pos = current_pos + d[1].length;
      if (cursor_pos === next_pos) {
        return [i + 1, diffs];
      } else if (cursor_pos < next_pos) {
        // copy to prevent side effects
        diffs = diffs.slice();
        // split d into two diff changes
        var split_pos = cursor_pos - current_pos;
        var d_left = [d[0], d[1].slice(0, split_pos)];
        var d_right = [d[0], d[1].slice(split_pos)];
        diffs.splice(i, 1, d_left, d_right);
        return [i + 1, diffs];
      } else {
        current_pos = next_pos;
      }
    }
  }
  throw new Error('cursor_pos is out of bounds!')
}

/*
 * Modify a diff such that the edit position is "shifted" to the proposed edit location (cursor_position).
 *
 * Case 1)
 *   Check if a naive shift is possible:
 *     [0, X], [ 1, Y] -> [ 1, Y], [0, X]    (if X + Y === Y + X)
 *     [0, X], [-1, Y] -> [-1, Y], [0, X]    (if X + Y === Y + X) - holds same result
 * Case 2)
 *   Check if the following shifts are possible:
 *     [0, 'pre'], [ 1, 'prefix'] -> [ 1, 'pre'], [0, 'pre'], [ 1, 'fix']
 *     [0, 'pre'], [-1, 'prefix'] -> [-1, 'pre'], [0, 'pre'], [-1, 'fix']
 *         ^            ^
 *         d          d_next
 *
 * @param {Array} diffs Array of diff tuples
 * @param {Int} cursor_pos Suggested edit position. Must not be out of bounds!
 * @return {Array} Array of diff tuples
 */
function fix_cursor (diffs, cursor_pos) {
  var norm = cursor_normalize_diff(diffs, cursor_pos);
  var ndiffs = norm[1];
  var cursor_pointer = norm[0];
  var d = ndiffs[cursor_pointer];
  var d_next = ndiffs[cursor_pointer + 1];

  if (d == null) {
    // Text was deleted from end of original string,
    // cursor is now out of bounds in new string
    return diffs;
  } else if (d[0] !== DIFF_EQUAL) {
    // A modification happened at the cursor location.
    // This is the expected outcome, so we can return the original diff.
    return diffs;
  } else {
    if (d_next != null && d[1] + d_next[1] === d_next[1] + d[1]) {
      // Case 1)
      // It is possible to perform a naive shift
      ndiffs.splice(cursor_pointer, 2, d_next, d)
      return merge_tuples(ndiffs, cursor_pointer, 2)
    } else if (d_next != null && d_next[1].indexOf(d[1]) === 0) {
      // Case 2)
      // d[1] is a prefix of d_next[1]
      // We can assume that d_next[0] !== 0, since d[0] === 0
      // Shift edit locations..
      ndiffs.splice(cursor_pointer, 2, [d_next[0], d[1]], [0, d[1]]);
      var suffix = d_next[1].slice(d[1].length);
      if (suffix.length > 0) {
        ndiffs.splice(cursor_pointer + 2, 0, [d_next[0], suffix]);
      }
      return merge_tuples(ndiffs, cursor_pointer, 3)
    } else {
      // Not possible to perform any modification
      return diffs;
    }
  }
}

/*
 * Check diff did not split surrogate pairs.
 * Ex. [0, '\uD83D'], [-1, '\uDC36'], [1, '\uDC2F'] -> [-1, '\uD83D\uDC36'], [1, '\uD83D\uDC2F']
 *     '\uD83D\uDC36' === '🐶', '\uD83D\uDC2F' === '🐯'
 *
 * @param {Array} diffs Array of diff tuples
 * @return {Array} Array of diff tuples
 */
function fix_emoji (diffs) {
  var compact = false;
  var starts_with_pair_end = function(str) {
    return str.charCodeAt(0) >= 0xDC00 && str.charCodeAt(0) <= 0xDFFF;
  }
  var ends_with_pair_start = function(str) {
    return str.charCodeAt(str.length-1) >= 0xD800 && str.charCodeAt(str.length-1) <= 0xDBFF;
  }
  for (var i = 2; i < diffs.length; i += 1) {
    if (diffs[i-2][0] === DIFF_EQUAL && ends_with_pair_start(diffs[i-2][1]) &&
        diffs[i-1][0] === DIFF_DELETE && starts_with_pair_end(diffs[i-1][1]) &&
        diffs[i][0] === DIFF_INSERT && starts_with_pair_end(diffs[i][1])) {
      compact = true;

      diffs[i-1][1] = diffs[i-2][1].slice(-1) + diffs[i-1][1];
      diffs[i][1] = diffs[i-2][1].slice(-1) + diffs[i][1];

      diffs[i-2][1] = diffs[i-2][1].slice(0, -1);
    }
  }
  if (!compact) {
    return diffs;
  }
  var fixed_diffs = [];
  for (var i = 0; i < diffs.length; i += 1) {
    if (diffs[i][1].length > 0) {
      fixed_diffs.push(diffs[i]);
    }
  }
  return fixed_diffs;
}

/*
 * Try to merge tuples with their neigbors in a given range.
 * E.g. [0, 'a'], [0, 'b'] -> [0, 'ab']
 *
 * @param {Array} diffs Array of diff tuples.
 * @param {Int} start Position of the first element to merge (diffs[start] is also merged with diffs[start - 1]).
 * @param {Int} length Number of consecutive elements to check.
 * @return {Array} Array of merged diff tuples.
 */
function merge_tuples (diffs, start, length) {
  // Check from (start-1) to (start+length).
  for (var i = start + length - 1; i >= 0 && i >= start - 1; i--) {
    if (i + 1 < diffs.length) {
      var left_d = diffs[i];
      var right_d = diffs[i+1];
      if (left_d[0] === right_d[1]) {
        diffs.splice(i, 2, [left_d[0], left_d[1] + right_d[1]]);
      }
    }
  }
  return diffs;
}


/***/ }),
/* 52 */
/***/ (function(module, exports) {

exports = module.exports = typeof Object.keys === 'function'
  ? Object.keys : shim;

exports.shim = shim;
function shim (obj) {
  var keys = [];
  for (var key in obj) keys.push(key);
  return keys;
}


/***/ }),
/* 53 */
/***/ (function(module, exports) {

var supportsArgumentsClass = (function(){
  return Object.prototype.toString.call(arguments)
})() == '[object Arguments]';

exports = module.exports = supportsArgumentsClass ? supported : unsupported;

exports.supported = supported;
function supported(object) {
  return Object.prototype.toString.call(object) == '[object Arguments]';
};

exports.unsupported = unsupported;
function unsupported(object){
  return object &&
    typeof object == 'object' &&
    typeof object.length == 'number' &&
    Object.prototype.hasOwnProperty.call(object, 'callee') &&
    !Object.prototype.propertyIsEnumerable.call(object, 'callee') ||
    false;
};


/***/ }),
/* 54 */
/***/ (function(module, exports) {

'use strict';

var has = Object.prototype.hasOwnProperty
  , prefix = '~';

/**
 * Constructor to create a storage for our `EE` objects.
 * An `Events` instance is a plain object whose properties are event names.
 *
 * @constructor
 * @api private
 */
function Events() {}

//
// We try to not inherit from `Object.prototype`. In some engines creating an
// instance in this way is faster than calling `Object.create(null)` directly.
// If `Object.create(null)` is not supported we prefix the event names with a
// character to make sure that the built-in object properties are not
// overridden or used as an attack vector.
//
if (Object.create) {
  Events.prototype = Object.create(null);

  //
  // This hack is needed because the `__proto__` property is still inherited in
  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
  //
  if (!new Events().__proto__) prefix = false;
}

/**
 * Representation of a single event listener.
 *
 * @param {Function} fn The listener function.
 * @param {Mixed} context The context to invoke the listener with.
 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
 * @constructor
 * @api private
 */
function EE(fn, context, once) {
  this.fn = fn;
  this.context = context;
  this.once = once || false;
}

/**
 * Minimal `EventEmitter` interface that is molded against the Node.js
 * `EventEmitter` interface.
 *
 * @constructor
 * @api public
 */
function EventEmitter() {
  this._events = new Events();
  this._eventsCount = 0;
}

/**
 * Return an array listing the events for which the emitter has registered
 * listeners.
 *
 * @returns {Array}
 * @api public
 */
EventEmitter.prototype.eventNames = function eventNames() {
  var names = []
    , events
    , name;

  if (this._eventsCount === 0) return names;

  for (name in (events = this._events)) {
    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
  }

  if (Object.getOwnPropertySymbols) {
    return names.concat(Object.getOwnPropertySymbols(events));
  }

  return names;
};

/**
 * Return the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Boolean} exists Only check if there are listeners.
 * @returns {Array|Boolean}
 * @api public
 */
EventEmitter.prototype.listeners = function listeners(event, exists) {
  var evt = prefix ? prefix + event : event
    , available = this._events[evt];

  if (exists) return !!available;
  if (!available) return [];
  if (available.fn) return [available.fn];

  for (var i = 0, l = available.length, ee = new Array(l); i < l; i++) {
    ee[i] = available[i].fn;
  }

  return ee;
};

/**
 * Calls each of the listeners registered for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @returns {Boolean} `true` if the event had listeners, else `false`.
 * @api public
 */
EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return false;

  var listeners = this._events[evt]
    , len = arguments.length
    , args
    , i;

  if (listeners.fn) {
    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);

    switch (len) {
      case 1: return listeners.fn.call(listeners.context), true;
      case 2: return listeners.fn.call(listeners.context, a1), true;
      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
    }

    for (i = 1, args = new Array(len -1); i < len; i++) {
      args[i - 1] = arguments[i];
    }

    listeners.fn.apply(listeners.context, args);
  } else {
    var length = listeners.length
      , j;

    for (i = 0; i < length; i++) {
      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);

      switch (len) {
        case 1: listeners[i].fn.call(listeners[i].context); break;
        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
        default:
          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
            args[j - 1] = arguments[j];
          }

          listeners[i].fn.apply(listeners[i].context, args);
      }
    }
  }

  return true;
};

/**
 * Add a listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.on = function on(event, fn, context) {
  var listener = new EE(fn, context || this)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Add a one-time listener for a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn The listener function.
 * @param {Mixed} [context=this] The context to invoke the listener with.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.once = function once(event, fn, context) {
  var listener = new EE(fn, context || this, true)
    , evt = prefix ? prefix + event : event;

  if (!this._events[evt]) this._events[evt] = listener, this._eventsCount++;
  else if (!this._events[evt].fn) this._events[evt].push(listener);
  else this._events[evt] = [this._events[evt], listener];

  return this;
};

/**
 * Remove the listeners of a given event.
 *
 * @param {String|Symbol} event The event name.
 * @param {Function} fn Only remove the listeners that match this function.
 * @param {Mixed} context Only remove the listeners that have this context.
 * @param {Boolean} once Only remove one-time listeners.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
  var evt = prefix ? prefix + event : event;

  if (!this._events[evt]) return this;
  if (!fn) {
    if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
    return this;
  }

  var listeners = this._events[evt];

  if (listeners.fn) {
    if (
         listeners.fn === fn
      && (!once || listeners.once)
      && (!context || listeners.context === context)
    ) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
      if (
           listeners[i].fn !== fn
        || (once && !listeners[i].once)
        || (context && listeners[i].context !== context)
      ) {
        events.push(listeners[i]);
      }
    }

    //
    // Reset the array, or remove it completely if we have no more listeners.
    //
    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
    else if (--this._eventsCount === 0) this._events = new Events();
    else delete this._events[evt];
  }

  return this;
};

/**
 * Remove all listeners, or those of the specified event.
 *
 * @param {String|Symbol} [event] The event name.
 * @returns {EventEmitter} `this`.
 * @api public
 */
EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
  var evt;

  if (event) {
    evt = prefix ? prefix + event : event;
    if (this._events[evt]) {
      if (--this._eventsCount === 0) this._events = new Events();
      else delete this._events[evt];
    }
  } else {
    this._events = new Events();
    this._eventsCount = 0;
  }

  return this;
};

//
// Alias methods names because people roll like that.
//
EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
EventEmitter.prototype.addListener = EventEmitter.prototype.on;

//
// This function doesn't apply anymore.
//
EventEmitter.prototype.setMaxListeners = function setMaxListeners() {
  return this;
};

//
// Expose the prefix.
//
EventEmitter.prefixed = prefix;

//
// Allow `EventEmitter` to be imported as module namespace.
//
EventEmitter.EventEmitter = EventEmitter;

//
// Expose the module.
//
if ('undefined' !== typeof module) {
  module.exports = EventEmitter;
}


/***/ }),
/* 55 */
/***/ (function(module, exports, __nested_webpack_require_316416__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.matchText = exports.matchSpacing = exports.matchNewline = exports.matchBlot = exports.matchAttributor = exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend2 = __nested_webpack_require_316416__(3);

var _extend3 = _interopRequireDefault(_extend2);

var _quillDelta = __nested_webpack_require_316416__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __nested_webpack_require_316416__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_316416__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __nested_webpack_require_316416__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __nested_webpack_require_316416__(9);

var _module2 = _interopRequireDefault(_module);

var _align = __nested_webpack_require_316416__(36);

var _background = __nested_webpack_require_316416__(37);

var _code = __nested_webpack_require_316416__(13);

var _code2 = _interopRequireDefault(_code);

var _color = __nested_webpack_require_316416__(26);

var _direction = __nested_webpack_require_316416__(38);

var _font = __nested_webpack_require_316416__(39);

var _size = __nested_webpack_require_316416__(40);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:clipboard');

var DOM_KEY = '__ql-matcher';

var CLIPBOARD_CONFIG = [[Node.TEXT_NODE, matchText], [Node.TEXT_NODE, matchNewline], ['br', matchBreak], [Node.ELEMENT_NODE, matchNewline], [Node.ELEMENT_NODE, matchBlot], [Node.ELEMENT_NODE, matchSpacing], [Node.ELEMENT_NODE, matchAttributor], [Node.ELEMENT_NODE, matchStyles], ['li', matchIndent], ['b', matchAlias.bind(matchAlias, 'bold')], ['i', matchAlias.bind(matchAlias, 'italic')], ['style', matchIgnore]];

var ATTRIBUTE_ATTRIBUTORS = [_align.AlignAttribute, _direction.DirectionAttribute].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var STYLE_ATTRIBUTORS = [_align.AlignStyle, _background.BackgroundStyle, _color.ColorStyle, _direction.DirectionStyle, _font.FontStyle, _size.SizeStyle].reduce(function (memo, attr) {
  memo[attr.keyName] = attr;
  return memo;
}, {});

var Clipboard = function (_Module) {
  _inherits(Clipboard, _Module);

  function Clipboard(quill, options) {
    _classCallCheck(this, Clipboard);

    var _this = _possibleConstructorReturn(this, (Clipboard.__proto__ || Object.getPrototypeOf(Clipboard)).call(this, quill, options));

    _this.quill.root.addEventListener('paste', _this.onPaste.bind(_this));
    _this.container = _this.quill.addContainer('ql-clipboard');
    _this.container.setAttribute('contenteditable', true);
    _this.container.setAttribute('tabindex', -1);
    _this.matchers = [];
    CLIPBOARD_CONFIG.concat(_this.options.matchers).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          selector = _ref2[0],
          matcher = _ref2[1];

      if (!options.matchVisual && matcher === matchSpacing) return;
      _this.addMatcher(selector, matcher);
    });
    return _this;
  }

  _createClass(Clipboard, [{
    key: 'addMatcher',
    value: function addMatcher(selector, matcher) {
      this.matchers.push([selector, matcher]);
    }
  }, {
    key: 'convert',
    value: function convert(html) {
      if (typeof html === 'string') {
        this.container.innerHTML = html.replace(/\>\r?\n +\</g, '><'); // Remove spaces between tags
        return this.convert();
      }
      var formats = this.quill.getFormat(this.quill.selection.savedRange.index);
      if (formats[_code2.default.blotName]) {
        var text = this.container.innerText;
        this.container.innerHTML = '';
        return new _quillDelta2.default().insert(text, _defineProperty({}, _code2.default.blotName, formats[_code2.default.blotName]));
      }

      var _prepareMatching = this.prepareMatching(),
          _prepareMatching2 = _slicedToArray(_prepareMatching, 2),
          elementMatchers = _prepareMatching2[0],
          textMatchers = _prepareMatching2[1];

      var delta = traverse(this.container, elementMatchers, textMatchers);
      // Remove trailing newline
      if (deltaEndsWith(delta, '\n') && delta.ops[delta.ops.length - 1].attributes == null) {
        delta = delta.compose(new _quillDelta2.default().retain(delta.length() - 1).delete(1));
      }
      debug.log('convert', this.container.innerHTML, delta);
      this.container.innerHTML = '';
      return delta;
    }
  }, {
    key: 'dangerouslyPasteHTML',
    value: function dangerouslyPasteHTML(index, html) {
      var source = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : _quill2.default.sources.API;

      if (typeof index === 'string') {
        this.quill.setContents(this.convert(index), html);
        this.quill.setSelection(0, _quill2.default.sources.SILENT);
      } else {
        var paste = this.convert(html);
        this.quill.updateContents(new _quillDelta2.default().retain(index).concat(paste), source);
        this.quill.setSelection(index + paste.length(), _quill2.default.sources.SILENT);
      }
    }
  }, {
    key: 'onPaste',
    value: function onPaste(e) {
      var _this2 = this;

      if (e.defaultPrevented || !this.quill.isEnabled()) return;
      var range = this.quill.getSelection();
      var delta = new _quillDelta2.default().retain(range.index);
      var scrollTop = this.quill.scrollingContainer.scrollTop;
      this.container.focus();
      this.quill.selection.update(_quill2.default.sources.SILENT);
      setTimeout(function () {
        delta = delta.concat(_this2.convert()).delete(range.length);
        _this2.quill.updateContents(delta, _quill2.default.sources.USER);
        // range.length contributes to delta.length()
        _this2.quill.setSelection(delta.length() - range.length, _quill2.default.sources.SILENT);
        _this2.quill.scrollingContainer.scrollTop = scrollTop;
        _this2.quill.focus();
      }, 1);
    }
  }, {
    key: 'prepareMatching',
    value: function prepareMatching() {
      var _this3 = this;

      var elementMatchers = [],
          textMatchers = [];
      this.matchers.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            selector = _pair[0],
            matcher = _pair[1];

        switch (selector) {
          case Node.TEXT_NODE:
            textMatchers.push(matcher);
            break;
          case Node.ELEMENT_NODE:
            elementMatchers.push(matcher);
            break;
          default:
            [].forEach.call(_this3.container.querySelectorAll(selector), function (node) {
              // TODO use weakmap
              node[DOM_KEY] = node[DOM_KEY] || [];
              node[DOM_KEY].push(matcher);
            });
            break;
        }
      });
      return [elementMatchers, textMatchers];
    }
  }]);

  return Clipboard;
}(_module2.default);

Clipboard.DEFAULTS = {
  matchers: [],
  matchVisual: true
};

function applyFormat(delta, format, value) {
  if ((typeof format === 'undefined' ? 'undefined' : _typeof(format)) === 'object') {
    return Object.keys(format).reduce(function (delta, key) {
      return applyFormat(delta, key, format[key]);
    }, delta);
  } else {
    return delta.reduce(function (delta, op) {
      if (op.attributes && op.attributes[format]) {
        return delta.push(op);
      } else {
        return delta.insert(op.insert, (0, _extend3.default)({}, _defineProperty({}, format, value), op.attributes));
      }
    }, new _quillDelta2.default());
  }
}

function computeStyle(node) {
  if (node.nodeType !== Node.ELEMENT_NODE) return {};
  var DOM_KEY = '__ql-computed-style';
  return node[DOM_KEY] || (node[DOM_KEY] = window.getComputedStyle(node));
}

function deltaEndsWith(delta, text) {
  var endText = "";
  for (var i = delta.ops.length - 1; i >= 0 && endText.length < text.length; --i) {
    var op = delta.ops[i];
    if (typeof op.insert !== 'string') break;
    endText = op.insert + endText;
  }
  return endText.slice(-1 * text.length) === text;
}

function isLine(node) {
  if (node.childNodes.length === 0) return false; // Exclude embed blocks
  var style = computeStyle(node);
  return ['block', 'list-item'].indexOf(style.display) > -1;
}

function traverse(node, elementMatchers, textMatchers) {
  // Post-order
  if (node.nodeType === node.TEXT_NODE) {
    return textMatchers.reduce(function (delta, matcher) {
      return matcher(node, delta);
    }, new _quillDelta2.default());
  } else if (node.nodeType === node.ELEMENT_NODE) {
    return [].reduce.call(node.childNodes || [], function (delta, childNode) {
      var childrenDelta = traverse(childNode, elementMatchers, textMatchers);
      if (childNode.nodeType === node.ELEMENT_NODE) {
        childrenDelta = elementMatchers.reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
        childrenDelta = (childNode[DOM_KEY] || []).reduce(function (childrenDelta, matcher) {
          return matcher(childNode, childrenDelta);
        }, childrenDelta);
      }
      return delta.concat(childrenDelta);
    }, new _quillDelta2.default());
  } else {
    return new _quillDelta2.default();
  }
}

function matchAlias(format, node, delta) {
  return applyFormat(delta, format, true);
}

function matchAttributor(node, delta) {
  var attributes = _parchment2.default.Attributor.Attribute.keys(node);
  var classes = _parchment2.default.Attributor.Class.keys(node);
  var styles = _parchment2.default.Attributor.Style.keys(node);
  var formats = {};
  attributes.concat(classes).concat(styles).forEach(function (name) {
    var attr = _parchment2.default.query(name, _parchment2.default.Scope.ATTRIBUTE);
    if (attr != null) {
      formats[attr.attrName] = attr.value(node);
      if (formats[attr.attrName]) return;
    }
    attr = ATTRIBUTE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      formats[attr.attrName] = attr.value(node) || undefined;
    }
    attr = STYLE_ATTRIBUTORS[name];
    if (attr != null && (attr.attrName === name || attr.keyName === name)) {
      attr = STYLE_ATTRIBUTORS[name];
      formats[attr.attrName] = attr.value(node) || undefined;
    }
  });
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  return delta;
}

function matchBlot(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null) return delta;
  if (match.prototype instanceof _parchment2.default.Embed) {
    var embed = {};
    var value = match.value(node);
    if (value != null) {
      embed[match.blotName] = value;
      delta = new _quillDelta2.default().insert(embed, match.formats(node));
    }
  } else if (typeof match.formats === 'function') {
    delta = applyFormat(delta, match.blotName, match.formats(node));
  }
  return delta;
}

function matchBreak(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    delta.insert('\n');
  }
  return delta;
}

function matchIgnore() {
  return new _quillDelta2.default();
}

function matchIndent(node, delta) {
  var match = _parchment2.default.query(node);
  if (match == null || match.blotName !== 'list-item' || !deltaEndsWith(delta, '\n')) {
    return delta;
  }
  var indent = -1,
      parent = node.parentNode;
  while (!parent.classList.contains('ql-clipboard')) {
    if ((_parchment2.default.query(parent) || {}).blotName === 'list') {
      indent += 1;
    }
    parent = parent.parentNode;
  }
  if (indent <= 0) return delta;
  return delta.compose(new _quillDelta2.default().retain(delta.length() - 1).retain(1, { indent: indent }));
}

function matchNewline(node, delta) {
  if (!deltaEndsWith(delta, '\n')) {
    if (isLine(node) || delta.length() > 0 && node.nextSibling && isLine(node.nextSibling)) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchSpacing(node, delta) {
  if (isLine(node) && node.nextElementSibling != null && !deltaEndsWith(delta, '\n\n')) {
    var nodeHeight = node.offsetHeight + parseFloat(computeStyle(node).marginTop) + parseFloat(computeStyle(node).marginBottom);
    if (node.nextElementSibling.offsetTop > node.offsetTop + nodeHeight * 1.5) {
      delta.insert('\n');
    }
  }
  return delta;
}

function matchStyles(node, delta) {
  var formats = {};
  var style = node.style || {};
  if (style.fontStyle && computeStyle(node).fontStyle === 'italic') {
    formats.italic = true;
  }
  if (style.fontWeight && (computeStyle(node).fontWeight.startsWith('bold') || parseInt(computeStyle(node).fontWeight) >= 700)) {
    formats.bold = true;
  }
  if (Object.keys(formats).length > 0) {
    delta = applyFormat(delta, formats);
  }
  if (parseFloat(style.textIndent || 0) > 0) {
    // Could be 0.5in
    delta = new _quillDelta2.default().insert('\t').concat(delta);
  }
  return delta;
}

function matchText(node, delta) {
  var text = node.data;
  // Word represents empty line with <o:p>&nbsp;</o:p>
  if (node.parentNode.tagName === 'O:P') {
    return delta.insert(text.trim());
  }
  if (text.trim().length === 0 && node.parentNode.classList.contains('ql-clipboard')) {
    return delta;
  }
  if (!computeStyle(node.parentNode).whiteSpace.startsWith('pre')) {
    // eslint-disable-next-line func-style
    var replacer = function replacer(collapse, match) {
      match = match.replace(/[^\u00a0]/g, ''); // \u00a0 is nbsp;
      return match.length < 1 && collapse ? ' ' : match;
    };
    text = text.replace(/\r\n/g, ' ').replace(/\n/g, ' ');
    text = text.replace(/\s\s+/g, replacer.bind(replacer, true)); // collapse whitespace
    if (node.previousSibling == null && isLine(node.parentNode) || node.previousSibling != null && isLine(node.previousSibling)) {
      text = text.replace(/^\s+/, replacer.bind(replacer, false));
    }
    if (node.nextSibling == null && isLine(node.parentNode) || node.nextSibling != null && isLine(node.nextSibling)) {
      text = text.replace(/\s+$/, replacer.bind(replacer, false));
    }
  }
  return delta.insert(text);
}

exports.default = Clipboard;
exports.matchAttributor = matchAttributor;
exports.matchBlot = matchBlot;
exports.matchNewline = matchNewline;
exports.matchSpacing = matchSpacing;
exports.matchText = matchText;

/***/ }),
/* 56 */
/***/ (function(module, exports, __nested_webpack_require_333274__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __nested_webpack_require_333274__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Bold = function (_Inline) {
  _inherits(Bold, _Inline);

  function Bold() {
    _classCallCheck(this, Bold);

    return _possibleConstructorReturn(this, (Bold.__proto__ || Object.getPrototypeOf(Bold)).apply(this, arguments));
  }

  _createClass(Bold, [{
    key: 'optimize',
    value: function optimize(context) {
      _get(Bold.prototype.__proto__ || Object.getPrototypeOf(Bold.prototype), 'optimize', this).call(this, context);
      if (this.domNode.tagName !== this.statics.tagName[0]) {
        this.replaceWith(this.statics.blotName);
      }
    }
  }], [{
    key: 'create',
    value: function create() {
      return _get(Bold.__proto__ || Object.getPrototypeOf(Bold), 'create', this).call(this);
    }
  }, {
    key: 'formats',
    value: function formats() {
      return true;
    }
  }]);

  return Bold;
}(_inline2.default);

Bold.blotName = 'bold';
Bold.tagName = ['STRONG', 'B'];

exports.default = Bold;

/***/ }),
/* 57 */
/***/ (function(module, exports, __nested_webpack_require_336502__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addControls = exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _quillDelta = __nested_webpack_require_336502__(2);

var _quillDelta2 = _interopRequireDefault(_quillDelta);

var _parchment = __nested_webpack_require_336502__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_336502__(5);

var _quill2 = _interopRequireDefault(_quill);

var _logger = __nested_webpack_require_336502__(10);

var _logger2 = _interopRequireDefault(_logger);

var _module = __nested_webpack_require_336502__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var debug = (0, _logger2.default)('quill:toolbar');

var Toolbar = function (_Module) {
  _inherits(Toolbar, _Module);

  function Toolbar(quill, options) {
    _classCallCheck(this, Toolbar);

    var _this = _possibleConstructorReturn(this, (Toolbar.__proto__ || Object.getPrototypeOf(Toolbar)).call(this, quill, options));

    if (Array.isArray(_this.options.container)) {
      var container = document.createElement('div');
      addControls(container, _this.options.container);
      quill.container.parentNode.insertBefore(container, quill.container);
      _this.container = container;
    } else if (typeof _this.options.container === 'string') {
      _this.container = document.querySelector(_this.options.container);
    } else {
      _this.container = _this.options.container;
    }
    if (!(_this.container instanceof HTMLElement)) {
      var _ret;

      return _ret = debug.error('Container required for toolbar', _this.options), _possibleConstructorReturn(_this, _ret);
    }
    _this.container.classList.add('ql-toolbar');
    _this.controls = [];
    _this.handlers = {};
    Object.keys(_this.options.handlers).forEach(function (format) {
      _this.addHandler(format, _this.options.handlers[format]);
    });
    [].forEach.call(_this.container.querySelectorAll('button, select'), function (input) {
      _this.attach(input);
    });
    _this.quill.on(_quill2.default.events.EDITOR_CHANGE, function (type, range) {
      if (type === _quill2.default.events.SELECTION_CHANGE) {
        _this.update(range);
      }
    });
    _this.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      var _this$quill$selection = _this.quill.selection.getRange(),
          _this$quill$selection2 = _slicedToArray(_this$quill$selection, 1),
          range = _this$quill$selection2[0]; // quill.getSelection triggers update


      _this.update(range);
    });
    return _this;
  }

  _createClass(Toolbar, [{
    key: 'addHandler',
    value: function addHandler(format, handler) {
      this.handlers[format] = handler;
    }
  }, {
    key: 'attach',
    value: function attach(input) {
      var _this2 = this;

      var format = [].find.call(input.classList, function (className) {
        return className.indexOf('ql-') === 0;
      });
      if (!format) return;
      format = format.slice('ql-'.length);
      if (input.tagName === 'BUTTON') {
        input.setAttribute('type', 'button');
      }
      if (this.handlers[format] == null) {
        if (this.quill.scroll.whitelist != null && this.quill.scroll.whitelist[format] == null) {
          debug.warn('ignoring attaching to disabled format', format, input);
          return;
        }
        if (_parchment2.default.query(format) == null) {
          debug.warn('ignoring attaching to nonexistent format', format, input);
          return;
        }
      }
      var eventName = input.tagName === 'SELECT' ? 'change' : 'click';
      input.addEventListener(eventName, function (e) {
        var value = void 0;
        if (input.tagName === 'SELECT') {
          if (input.selectedIndex < 0) return;
          var selected = input.options[input.selectedIndex];
          if (selected.hasAttribute('selected')) {
            value = false;
          } else {
            value = selected.value || false;
          }
        } else {
          if (input.classList.contains('ql-active')) {
            value = false;
          } else {
            value = input.value || !input.hasAttribute('value');
          }
          e.preventDefault();
        }
        _this2.quill.focus();

        var _quill$selection$getR = _this2.quill.selection.getRange(),
            _quill$selection$getR2 = _slicedToArray(_quill$selection$getR, 1),
            range = _quill$selection$getR2[0];

        if (_this2.handlers[format] != null) {
          _this2.handlers[format].call(_this2, value);
        } else if (_parchment2.default.query(format).prototype instanceof _parchment2.default.Embed) {
          value = prompt('Enter ' + format);
          if (!value) return;
          _this2.quill.updateContents(new _quillDelta2.default().retain(range.index).delete(range.length).insert(_defineProperty({}, format, value)), _quill2.default.sources.USER);
        } else {
          _this2.quill.format(format, value, _quill2.default.sources.USER);
        }
        _this2.update(range);
      });
      // TODO use weakmap
      this.controls.push([format, input]);
    }
  }, {
    key: 'update',
    value: function update(range) {
      var formats = range == null ? {} : this.quill.getFormat(range);
      this.controls.forEach(function (pair) {
        var _pair = _slicedToArray(pair, 2),
            format = _pair[0],
            input = _pair[1];

        if (input.tagName === 'SELECT') {
          var option = void 0;
          if (range == null) {
            option = null;
          } else if (formats[format] == null) {
            option = input.querySelector('option[selected]');
          } else if (!Array.isArray(formats[format])) {
            var value = formats[format];
            if (typeof value === 'string') {
              value = value.replace(/\"/g, '\\"');
            }
            option = input.querySelector('option[value="' + value + '"]');
          }
          if (option == null) {
            input.value = ''; // TODO make configurable?
            input.selectedIndex = -1;
          } else {
            option.selected = true;
          }
        } else {
          if (range == null) {
            input.classList.remove('ql-active');
          } else if (input.hasAttribute('value')) {
            // both being null should match (default values)
            // '1' should match with 1 (headers)
            var isActive = formats[format] === input.getAttribute('value') || formats[format] != null && formats[format].toString() === input.getAttribute('value') || formats[format] == null && !input.getAttribute('value');
            input.classList.toggle('ql-active', isActive);
          } else {
            input.classList.toggle('ql-active', formats[format] != null);
          }
        }
      });
    }
  }]);

  return Toolbar;
}(_module2.default);

Toolbar.DEFAULTS = {};

function addButton(container, format, value) {
  var input = document.createElement('button');
  input.setAttribute('type', 'button');
  input.classList.add('ql-' + format);
  if (value != null) {
    input.value = value;
  }
  container.appendChild(input);
}

function addControls(container, groups) {
  if (!Array.isArray(groups[0])) {
    groups = [groups];
  }
  groups.forEach(function (controls) {
    var group = document.createElement('span');
    group.classList.add('ql-formats');
    controls.forEach(function (control) {
      if (typeof control === 'string') {
        addButton(group, control);
      } else {
        var format = Object.keys(control)[0];
        var value = control[format];
        if (Array.isArray(value)) {
          addSelect(group, format, value);
        } else {
          addButton(group, format, value);
        }
      }
    });
    container.appendChild(group);
  });
}

function addSelect(container, format, values) {
  var input = document.createElement('select');
  input.classList.add('ql-' + format);
  values.forEach(function (value) {
    var option = document.createElement('option');
    if (value !== false) {
      option.setAttribute('value', value);
    } else {
      option.setAttribute('selected', 'selected');
    }
    input.appendChild(option);
  });
  container.appendChild(input);
}

Toolbar.DEFAULTS = {
  container: null,
  handlers: {
    clean: function clean() {
      var _this3 = this;

      var range = this.quill.getSelection();
      if (range == null) return;
      if (range.length == 0) {
        var formats = this.quill.getFormat();
        Object.keys(formats).forEach(function (name) {
          // Clean functionality in existing apps only clean inline formats
          if (_parchment2.default.query(name, _parchment2.default.Scope.INLINE) != null) {
            _this3.quill.format(name, false);
          }
        });
      } else {
        this.quill.removeFormat(range, _quill2.default.sources.USER);
      }
    },
    direction: function direction(value) {
      var align = this.quill.getFormat()['align'];
      if (value === 'rtl' && align == null) {
        this.quill.format('align', 'right', _quill2.default.sources.USER);
      } else if (!value && align === 'right') {
        this.quill.format('align', false, _quill2.default.sources.USER);
      }
      this.quill.format('direction', value, _quill2.default.sources.USER);
    },
    indent: function indent(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      var indent = parseInt(formats.indent || 0);
      if (value === '+1' || value === '-1') {
        var modifier = value === '+1' ? 1 : -1;
        if (formats.direction === 'rtl') modifier *= -1;
        this.quill.format('indent', indent + modifier, _quill2.default.sources.USER);
      }
    },
    link: function link(value) {
      if (value === true) {
        value = prompt('Enter link URL:');
      }
      this.quill.format('link', value, _quill2.default.sources.USER);
    },
    list: function list(value) {
      var range = this.quill.getSelection();
      var formats = this.quill.getFormat(range);
      if (value === 'check') {
        if (formats['list'] === 'checked' || formats['list'] === 'unchecked') {
          this.quill.format('list', false, _quill2.default.sources.USER);
        } else {
          this.quill.format('list', 'unchecked', _quill2.default.sources.USER);
        }
      } else {
        this.quill.format('list', value, _quill2.default.sources.USER);
      }
    }
  }
};

exports.default = Toolbar;
exports.addControls = addControls;

/***/ }),
/* 58 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polyline class=\"ql-even ql-stroke\" points=\"5 7 3 9 5 11\"></polyline> <polyline class=\"ql-even ql-stroke\" points=\"13 7 15 9 13 11\"></polyline> <line class=ql-stroke x1=10 x2=8 y1=5 y2=13></line> </svg>";

/***/ }),
/* 59 */
/***/ (function(module, exports, __nested_webpack_require_349781__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __nested_webpack_require_349781__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ColorPicker = function (_Picker) {
  _inherits(ColorPicker, _Picker);

  function ColorPicker(select, label) {
    _classCallCheck(this, ColorPicker);

    var _this = _possibleConstructorReturn(this, (ColorPicker.__proto__ || Object.getPrototypeOf(ColorPicker)).call(this, select));

    _this.label.innerHTML = label;
    _this.container.classList.add('ql-color-picker');
    [].slice.call(_this.container.querySelectorAll('.ql-picker-item'), 0, 7).forEach(function (item) {
      item.classList.add('ql-primary');
    });
    return _this;
  }

  _createClass(ColorPicker, [{
    key: 'buildItem',
    value: function buildItem(option) {
      var item = _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'buildItem', this).call(this, option);
      item.style.backgroundColor = option.getAttribute('value') || '';
      return item;
    }
  }, {
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(ColorPicker.prototype.__proto__ || Object.getPrototypeOf(ColorPicker.prototype), 'selectItem', this).call(this, item, trigger);
      var colorLabel = this.label.querySelector('.ql-color-label');
      var value = item ? item.getAttribute('data-value') || '' : '';
      if (colorLabel) {
        if (colorLabel.tagName === 'line') {
          colorLabel.style.stroke = value;
        } else {
          colorLabel.style.fill = value;
        }
      }
    }
  }]);

  return ColorPicker;
}(_picker2.default);

exports.default = ColorPicker;

/***/ }),
/* 60 */
/***/ (function(module, exports, __nested_webpack_require_353592__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _picker = __nested_webpack_require_353592__(28);

var _picker2 = _interopRequireDefault(_picker);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IconPicker = function (_Picker) {
  _inherits(IconPicker, _Picker);

  function IconPicker(select, icons) {
    _classCallCheck(this, IconPicker);

    var _this = _possibleConstructorReturn(this, (IconPicker.__proto__ || Object.getPrototypeOf(IconPicker)).call(this, select));

    _this.container.classList.add('ql-icon-picker');
    [].forEach.call(_this.container.querySelectorAll('.ql-picker-item'), function (item) {
      item.innerHTML = icons[item.getAttribute('data-value') || ''];
    });
    _this.defaultItem = _this.container.querySelector('.ql-selected');
    _this.selectItem(_this.defaultItem);
    return _this;
  }

  _createClass(IconPicker, [{
    key: 'selectItem',
    value: function selectItem(item, trigger) {
      _get(IconPicker.prototype.__proto__ || Object.getPrototypeOf(IconPicker.prototype), 'selectItem', this).call(this, item, trigger);
      item = item || this.defaultItem;
      this.label.innerHTML = item.innerHTML;
    }
  }]);

  return IconPicker;
}(_picker2.default);

exports.default = IconPicker;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Tooltip = function () {
  function Tooltip(quill, boundsContainer) {
    var _this = this;

    _classCallCheck(this, Tooltip);

    this.quill = quill;
    this.boundsContainer = boundsContainer || document.body;
    this.root = quill.addContainer('ql-tooltip');
    this.root.innerHTML = this.constructor.TEMPLATE;
    if (this.quill.root === this.quill.scrollingContainer) {
      this.quill.root.addEventListener('scroll', function () {
        _this.root.style.marginTop = -1 * _this.quill.root.scrollTop + 'px';
      });
    }
    this.hide();
  }

  _createClass(Tooltip, [{
    key: 'hide',
    value: function hide() {
      this.root.classList.add('ql-hidden');
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var left = reference.left + reference.width / 2 - this.root.offsetWidth / 2;
      // root.scrollTop should be 0 if scrollContainer !== root
      var top = reference.bottom + this.quill.root.scrollTop;
      this.root.style.left = left + 'px';
      this.root.style.top = top + 'px';
      this.root.classList.remove('ql-flip');
      var containerBounds = this.boundsContainer.getBoundingClientRect();
      var rootBounds = this.root.getBoundingClientRect();
      var shift = 0;
      if (rootBounds.right > containerBounds.right) {
        shift = containerBounds.right - rootBounds.right;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.left < containerBounds.left) {
        shift = containerBounds.left - rootBounds.left;
        this.root.style.left = left + shift + 'px';
      }
      if (rootBounds.bottom > containerBounds.bottom) {
        var height = rootBounds.bottom - rootBounds.top;
        var verticalShift = reference.bottom - reference.top + height;
        this.root.style.top = top - verticalShift + 'px';
        this.root.classList.add('ql-flip');
      }
      return shift;
    }
  }, {
    key: 'show',
    value: function show() {
      this.root.classList.remove('ql-editing');
      this.root.classList.remove('ql-hidden');
    }
  }]);

  return Tooltip;
}();

exports.default = Tooltip;

/***/ }),
/* 62 */
/***/ (function(module, exports, __nested_webpack_require_359932__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __nested_webpack_require_359932__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __nested_webpack_require_359932__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __nested_webpack_require_359932__(43);

var _base2 = _interopRequireDefault(_base);

var _link = __nested_webpack_require_359932__(27);

var _link2 = _interopRequireDefault(_link);

var _selection = __nested_webpack_require_359932__(15);

var _icons = __nested_webpack_require_359932__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [[{ header: ['1', '2', '3', false] }], ['bold', 'italic', 'underline', 'link'], [{ list: 'ordered' }, { list: 'bullet' }], ['clean']];

var SnowTheme = function (_BaseTheme) {
  _inherits(SnowTheme, _BaseTheme);

  function SnowTheme(quill, options) {
    _classCallCheck(this, SnowTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (SnowTheme.__proto__ || Object.getPrototypeOf(SnowTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-snow');
    return _this;
  }

  _createClass(SnowTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      toolbar.container.classList.add('ql-snow');
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
      this.tooltip = new SnowTooltip(this.quill, this.options.bounds);
      if (toolbar.container.querySelector('.ql-link')) {
        this.quill.keyboard.addBinding({ key: 'K', shortKey: true }, function (range, context) {
          toolbar.handlers['link'].call(toolbar, !context.format.link);
        });
      }
    }
  }]);

  return SnowTheme;
}(_base2.default);

SnowTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (value) {
            var range = this.quill.getSelection();
            if (range == null || range.length == 0) return;
            var preview = this.quill.getText(range);
            if (/^\S+@\S+\.\S+$/.test(preview) && preview.indexOf('mailto:') !== 0) {
              preview = 'mailto:' + preview;
            }
            var tooltip = this.quill.theme.tooltip;
            tooltip.edit('link', preview);
          } else {
            this.quill.format('link', false);
          }
        }
      }
    }
  }
});

var SnowTooltip = function (_BaseTooltip) {
  _inherits(SnowTooltip, _BaseTooltip);

  function SnowTooltip(quill, bounds) {
    _classCallCheck(this, SnowTooltip);

    var _this2 = _possibleConstructorReturn(this, (SnowTooltip.__proto__ || Object.getPrototypeOf(SnowTooltip)).call(this, quill, bounds));

    _this2.preview = _this2.root.querySelector('a.ql-preview');
    return _this2;
  }

  _createClass(SnowTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('a.ql-action').addEventListener('click', function (event) {
        if (_this3.root.classList.contains('ql-editing')) {
          _this3.save();
        } else {
          _this3.edit('link', _this3.preview.textContent);
        }
        event.preventDefault();
      });
      this.root.querySelector('a.ql-remove').addEventListener('click', function (event) {
        if (_this3.linkRange != null) {
          var range = _this3.linkRange;
          _this3.restoreFocus();
          _this3.quill.formatText(range, 'link', false, _emitter2.default.sources.USER);
          delete _this3.linkRange;
        }
        event.preventDefault();
        _this3.hide();
      });
      this.quill.on(_emitter2.default.events.SELECTION_CHANGE, function (range, oldRange, source) {
        if (range == null) return;
        if (range.length === 0 && source === _emitter2.default.sources.USER) {
          var _quill$scroll$descend = _this3.quill.scroll.descendant(_link2.default, range.index),
              _quill$scroll$descend2 = _slicedToArray(_quill$scroll$descend, 2),
              link = _quill$scroll$descend2[0],
              offset = _quill$scroll$descend2[1];

          if (link != null) {
            _this3.linkRange = new _selection.Range(range.index - offset, link.length());
            var preview = _link2.default.formats(link.domNode);
            _this3.preview.textContent = preview;
            _this3.preview.setAttribute('href', preview);
            _this3.show();
            _this3.position(_this3.quill.getBounds(_this3.linkRange));
            return;
          }
        } else {
          delete _this3.linkRange;
        }
        _this3.hide();
      });
    }
  }, {
    key: 'show',
    value: function show() {
      _get(SnowTooltip.prototype.__proto__ || Object.getPrototypeOf(SnowTooltip.prototype), 'show', this).call(this);
      this.root.removeAttribute('data-mode');
    }
  }]);

  return SnowTooltip;
}(_base.BaseTooltip);

SnowTooltip.TEMPLATE = ['<a class="ql-preview" rel="noopener noreferrer" target="_blank" href="about:blank"></a>', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-action"></a>', '<a class="ql-remove"></a>'].join('');

exports.default = SnowTheme;

/***/ }),
/* 63 */
/***/ (function(module, exports, __nested_webpack_require_368316__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _core = __nested_webpack_require_368316__(29);

var _core2 = _interopRequireDefault(_core);

var _align = __nested_webpack_require_368316__(36);

var _direction = __nested_webpack_require_368316__(38);

var _indent = __nested_webpack_require_368316__(64);

var _blockquote = __nested_webpack_require_368316__(65);

var _blockquote2 = _interopRequireDefault(_blockquote);

var _header = __nested_webpack_require_368316__(66);

var _header2 = _interopRequireDefault(_header);

var _list = __nested_webpack_require_368316__(67);

var _list2 = _interopRequireDefault(_list);

var _background = __nested_webpack_require_368316__(37);

var _color = __nested_webpack_require_368316__(26);

var _font = __nested_webpack_require_368316__(39);

var _size = __nested_webpack_require_368316__(40);

var _bold = __nested_webpack_require_368316__(56);

var _bold2 = _interopRequireDefault(_bold);

var _italic = __nested_webpack_require_368316__(68);

var _italic2 = _interopRequireDefault(_italic);

var _link = __nested_webpack_require_368316__(27);

var _link2 = _interopRequireDefault(_link);

var _script = __nested_webpack_require_368316__(69);

var _script2 = _interopRequireDefault(_script);

var _strike = __nested_webpack_require_368316__(70);

var _strike2 = _interopRequireDefault(_strike);

var _underline = __nested_webpack_require_368316__(71);

var _underline2 = _interopRequireDefault(_underline);

var _image = __nested_webpack_require_368316__(72);

var _image2 = _interopRequireDefault(_image);

var _video = __nested_webpack_require_368316__(73);

var _video2 = _interopRequireDefault(_video);

var _code = __nested_webpack_require_368316__(13);

var _code2 = _interopRequireDefault(_code);

var _formula = __nested_webpack_require_368316__(74);

var _formula2 = _interopRequireDefault(_formula);

var _syntax = __nested_webpack_require_368316__(75);

var _syntax2 = _interopRequireDefault(_syntax);

var _toolbar = __nested_webpack_require_368316__(57);

var _toolbar2 = _interopRequireDefault(_toolbar);

var _icons = __nested_webpack_require_368316__(41);

var _icons2 = _interopRequireDefault(_icons);

var _picker = __nested_webpack_require_368316__(28);

var _picker2 = _interopRequireDefault(_picker);

var _colorPicker = __nested_webpack_require_368316__(59);

var _colorPicker2 = _interopRequireDefault(_colorPicker);

var _iconPicker = __nested_webpack_require_368316__(60);

var _iconPicker2 = _interopRequireDefault(_iconPicker);

var _tooltip = __nested_webpack_require_368316__(61);

var _tooltip2 = _interopRequireDefault(_tooltip);

var _bubble = __nested_webpack_require_368316__(108);

var _bubble2 = _interopRequireDefault(_bubble);

var _snow = __nested_webpack_require_368316__(62);

var _snow2 = _interopRequireDefault(_snow);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_core2.default.register({
  'attributors/attribute/direction': _direction.DirectionAttribute,

  'attributors/class/align': _align.AlignClass,
  'attributors/class/background': _background.BackgroundClass,
  'attributors/class/color': _color.ColorClass,
  'attributors/class/direction': _direction.DirectionClass,
  'attributors/class/font': _font.FontClass,
  'attributors/class/size': _size.SizeClass,

  'attributors/style/align': _align.AlignStyle,
  'attributors/style/background': _background.BackgroundStyle,
  'attributors/style/color': _color.ColorStyle,
  'attributors/style/direction': _direction.DirectionStyle,
  'attributors/style/font': _font.FontStyle,
  'attributors/style/size': _size.SizeStyle
}, true);

_core2.default.register({
  'formats/align': _align.AlignClass,
  'formats/direction': _direction.DirectionClass,
  'formats/indent': _indent.IndentClass,

  'formats/background': _background.BackgroundStyle,
  'formats/color': _color.ColorStyle,
  'formats/font': _font.FontClass,
  'formats/size': _size.SizeClass,

  'formats/blockquote': _blockquote2.default,
  'formats/code-block': _code2.default,
  'formats/header': _header2.default,
  'formats/list': _list2.default,

  'formats/bold': _bold2.default,
  'formats/code': _code.Code,
  'formats/italic': _italic2.default,
  'formats/link': _link2.default,
  'formats/script': _script2.default,
  'formats/strike': _strike2.default,
  'formats/underline': _underline2.default,

  'formats/image': _image2.default,
  'formats/video': _video2.default,

  'formats/list/item': _list.ListItem,

  'modules/formula': _formula2.default,
  'modules/syntax': _syntax2.default,
  'modules/toolbar': _toolbar2.default,

  'themes/bubble': _bubble2.default,
  'themes/snow': _snow2.default,

  'ui/icons': _icons2.default,
  'ui/picker': _picker2.default,
  'ui/icon-picker': _iconPicker2.default,
  'ui/color-picker': _colorPicker2.default,
  'ui/tooltip': _tooltip2.default
}, true);

exports.default = _core2.default;

/***/ }),
/* 64 */
/***/ (function(module, exports, __nested_webpack_require_372903__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IndentClass = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_372903__(0);

var _parchment2 = _interopRequireDefault(_parchment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IdentAttributor = function (_Parchment$Attributor) {
  _inherits(IdentAttributor, _Parchment$Attributor);

  function IdentAttributor() {
    _classCallCheck(this, IdentAttributor);

    return _possibleConstructorReturn(this, (IdentAttributor.__proto__ || Object.getPrototypeOf(IdentAttributor)).apply(this, arguments));
  }

  _createClass(IdentAttributor, [{
    key: 'add',
    value: function add(node, value) {
      if (value === '+1' || value === '-1') {
        var indent = this.value(node) || 0;
        value = value === '+1' ? indent + 1 : indent - 1;
      }
      if (value === 0) {
        this.remove(node);
        return true;
      } else {
        return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'add', this).call(this, node, value);
      }
    }
  }, {
    key: 'canAdd',
    value: function canAdd(node, value) {
      return _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, value) || _get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'canAdd', this).call(this, node, parseInt(value));
    }
  }, {
    key: 'value',
    value: function value(node) {
      return parseInt(_get(IdentAttributor.prototype.__proto__ || Object.getPrototypeOf(IdentAttributor.prototype), 'value', this).call(this, node)) || undefined; // Don't return NaN
    }
  }]);

  return IdentAttributor;
}(_parchment2.default.Attributor.Class);

var IndentClass = new IdentAttributor('indent', 'ql-indent', {
  scope: _parchment2.default.Scope.BLOCK,
  whitelist: [1, 2, 3, 4, 5, 6, 7, 8]
});

exports.IndentClass = IndentClass;

/***/ }),
/* 65 */
/***/ (function(module, exports, __nested_webpack_require_376943__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _block = __nested_webpack_require_376943__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Blockquote = function (_Block) {
  _inherits(Blockquote, _Block);

  function Blockquote() {
    _classCallCheck(this, Blockquote);

    return _possibleConstructorReturn(this, (Blockquote.__proto__ || Object.getPrototypeOf(Blockquote)).apply(this, arguments));
  }

  return Blockquote;
}(_block2.default);

Blockquote.blotName = 'blockquote';
Blockquote.tagName = 'blockquote';

exports.default = Blockquote;

/***/ }),
/* 66 */
/***/ (function(module, exports, __nested_webpack_require_378592__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _block = __nested_webpack_require_378592__(4);

var _block2 = _interopRequireDefault(_block);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = function (_Block) {
  _inherits(Header, _Block);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, null, [{
    key: 'formats',
    value: function formats(domNode) {
      return this.tagName.indexOf(domNode.tagName) + 1;
    }
  }]);

  return Header;
}(_block2.default);

Header.blotName = 'header';
Header.tagName = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

exports.default = Header;

/***/ }),
/* 67 */
/***/ (function(module, exports, __nested_webpack_require_380948__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ListItem = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_380948__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _block = __nested_webpack_require_380948__(4);

var _block2 = _interopRequireDefault(_block);

var _container = __nested_webpack_require_380948__(25);

var _container2 = _interopRequireDefault(_container);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ListItem = function (_Block) {
  _inherits(ListItem, _Block);

  function ListItem() {
    _classCallCheck(this, ListItem);

    return _possibleConstructorReturn(this, (ListItem.__proto__ || Object.getPrototypeOf(ListItem)).apply(this, arguments));
  }

  _createClass(ListItem, [{
    key: 'format',
    value: function format(name, value) {
      if (name === List.blotName && !value) {
        this.replaceWith(_parchment2.default.create(this.statics.scope));
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'format', this).call(this, name, value);
      }
    }
  }, {
    key: 'remove',
    value: function remove() {
      if (this.prev == null && this.next == null) {
        this.parent.remove();
      } else {
        _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'remove', this).call(this);
      }
    }
  }, {
    key: 'replaceWith',
    value: function replaceWith(name, value) {
      this.parent.isolate(this.offset(this.parent), this.length());
      if (name === this.parent.statics.blotName) {
        this.parent.replaceWith(name, value);
        return this;
      } else {
        this.parent.unwrap();
        return _get(ListItem.prototype.__proto__ || Object.getPrototypeOf(ListItem.prototype), 'replaceWith', this).call(this, name, value);
      }
    }
  }], [{
    key: 'formats',
    value: function formats(domNode) {
      return domNode.tagName === this.tagName ? undefined : _get(ListItem.__proto__ || Object.getPrototypeOf(ListItem), 'formats', this).call(this, domNode);
    }
  }]);

  return ListItem;
}(_block2.default);

ListItem.blotName = 'list-item';
ListItem.tagName = 'LI';

var List = function (_Container) {
  _inherits(List, _Container);

  _createClass(List, null, [{
    key: 'create',
    value: function create(value) {
      var tagName = value === 'ordered' ? 'OL' : 'UL';
      var node = _get(List.__proto__ || Object.getPrototypeOf(List), 'create', this).call(this, tagName);
      if (value === 'checked' || value === 'unchecked') {
        node.setAttribute('data-checked', value === 'checked');
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'OL') return 'ordered';
      if (domNode.tagName === 'UL') {
        if (domNode.hasAttribute('data-checked')) {
          return domNode.getAttribute('data-checked') === 'true' ? 'checked' : 'unchecked';
        } else {
          return 'bullet';
        }
      }
      return undefined;
    }
  }]);

  function List(domNode) {
    _classCallCheck(this, List);

    var _this2 = _possibleConstructorReturn(this, (List.__proto__ || Object.getPrototypeOf(List)).call(this, domNode));

    var listEventHandler = function listEventHandler(e) {
      if (e.target.parentNode !== domNode) return;
      var format = _this2.statics.formats(domNode);
      var blot = _parchment2.default.find(e.target);
      if (format === 'checked') {
        blot.format('list', 'unchecked');
      } else if (format === 'unchecked') {
        blot.format('list', 'checked');
      }
    };

    domNode.addEventListener('touchstart', listEventHandler);
    domNode.addEventListener('mousedown', listEventHandler);
    return _this2;
  }

  _createClass(List, [{
    key: 'format',
    value: function format(name, value) {
      if (this.children.length > 0) {
        this.children.tail.format(name, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats() {
      // We don't inherit from FormatBlot
      return _defineProperty({}, this.statics.blotName, this.statics.formats(this.domNode));
    }
  }, {
    key: 'insertBefore',
    value: function insertBefore(blot, ref) {
      if (blot instanceof ListItem) {
        _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'insertBefore', this).call(this, blot, ref);
      } else {
        var index = ref == null ? this.length() : ref.offset(this);
        var after = this.split(index);
        after.parent.insertBefore(blot, after);
      }
    }
  }, {
    key: 'optimize',
    value: function optimize(context) {
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'optimize', this).call(this, context);
      var next = this.next;
      if (next != null && next.prev === this && next.statics.blotName === this.statics.blotName && next.domNode.tagName === this.domNode.tagName && next.domNode.getAttribute('data-checked') === this.domNode.getAttribute('data-checked')) {
        next.moveChildren(this);
        next.remove();
      }
    }
  }, {
    key: 'replace',
    value: function replace(target) {
      if (target.statics.blotName !== this.statics.blotName) {
        var item = _parchment2.default.create(this.statics.defaultChild);
        target.moveChildren(item);
        this.appendChild(item);
      }
      _get(List.prototype.__proto__ || Object.getPrototypeOf(List.prototype), 'replace', this).call(this, target);
    }
  }]);

  return List;
}(_container2.default);

List.blotName = 'list';
List.scope = _parchment2.default.Scope.BLOCK_BLOT;
List.tagName = ['OL', 'UL'];
List.defaultChild = 'list-item';
List.allowedChildren = [ListItem];

exports.ListItem = ListItem;
exports.default = List;

/***/ }),
/* 68 */
/***/ (function(module, exports, __nested_webpack_require_389000__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _bold = __nested_webpack_require_389000__(56);

var _bold2 = _interopRequireDefault(_bold);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Italic = function (_Bold) {
  _inherits(Italic, _Bold);

  function Italic() {
    _classCallCheck(this, Italic);

    return _possibleConstructorReturn(this, (Italic.__proto__ || Object.getPrototypeOf(Italic)).apply(this, arguments));
  }

  return Italic;
}(_bold2.default);

Italic.blotName = 'italic';
Italic.tagName = ['EM', 'I'];

exports.default = Italic;

/***/ }),
/* 69 */
/***/ (function(module, exports, __nested_webpack_require_390599__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _inline = __nested_webpack_require_390599__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Script = function (_Inline) {
  _inherits(Script, _Inline);

  function Script() {
    _classCallCheck(this, Script);

    return _possibleConstructorReturn(this, (Script.__proto__ || Object.getPrototypeOf(Script)).apply(this, arguments));
  }

  _createClass(Script, null, [{
    key: 'create',
    value: function create(value) {
      if (value === 'super') {
        return document.createElement('sup');
      } else if (value === 'sub') {
        return document.createElement('sub');
      } else {
        return _get(Script.__proto__ || Object.getPrototypeOf(Script), 'create', this).call(this, value);
      }
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      if (domNode.tagName === 'SUB') return 'sub';
      if (domNode.tagName === 'SUP') return 'super';
      return undefined;
    }
  }]);

  return Script;
}(_inline2.default);

Script.blotName = 'script';
Script.tagName = ['SUB', 'SUP'];

exports.default = Script;

/***/ }),
/* 70 */
/***/ (function(module, exports, __nested_webpack_require_393860__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __nested_webpack_require_393860__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Strike = function (_Inline) {
  _inherits(Strike, _Inline);

  function Strike() {
    _classCallCheck(this, Strike);

    return _possibleConstructorReturn(this, (Strike.__proto__ || Object.getPrototypeOf(Strike)).apply(this, arguments));
  }

  return Strike;
}(_inline2.default);

Strike.blotName = 'strike';
Strike.tagName = 'S';

exports.default = Strike;

/***/ }),
/* 71 */
/***/ (function(module, exports, __nested_webpack_require_395462__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _inline = __nested_webpack_require_395462__(6);

var _inline2 = _interopRequireDefault(_inline);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Underline = function (_Inline) {
  _inherits(Underline, _Inline);

  function Underline() {
    _classCallCheck(this, Underline);

    return _possibleConstructorReturn(this, (Underline.__proto__ || Object.getPrototypeOf(Underline)).apply(this, arguments));
  }

  return Underline;
}(_inline2.default);

Underline.blotName = 'underline';
Underline.tagName = 'U';

exports.default = Underline;

/***/ }),
/* 72 */
/***/ (function(module, exports, __nested_webpack_require_397097__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_397097__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _link = __nested_webpack_require_397097__(27);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['alt', 'height', 'width'];

var Image = function (_Parchment$Embed) {
  _inherits(Image, _Parchment$Embed);

  function Image() {
    _classCallCheck(this, Image);

    return _possibleConstructorReturn(this, (Image.__proto__ || Object.getPrototypeOf(Image)).apply(this, arguments));
  }

  _createClass(Image, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Image.prototype.__proto__ || Object.getPrototypeOf(Image.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Image.__proto__ || Object.getPrototypeOf(Image), 'create', this).call(this, value);
      if (typeof value === 'string') {
        node.setAttribute('src', this.sanitize(value));
      }
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'match',
    value: function match(url) {
      return (/\.(jpe?g|gif|png)$/.test(url) || /^data:image\/.+;base64/.test(url)
      );
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return (0, _link.sanitize)(url, ['http', 'https', 'data']) ? url : '//:0';
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Image;
}(_parchment2.default.Embed);

Image.blotName = 'image';
Image.tagName = 'IMG';

exports.default = Image;

/***/ }),
/* 73 */
/***/ (function(module, exports, __nested_webpack_require_401311__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _block = __nested_webpack_require_401311__(4);

var _link = __nested_webpack_require_401311__(27);

var _link2 = _interopRequireDefault(_link);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ATTRIBUTES = ['height', 'width'];

var Video = function (_BlockEmbed) {
  _inherits(Video, _BlockEmbed);

  function Video() {
    _classCallCheck(this, Video);

    return _possibleConstructorReturn(this, (Video.__proto__ || Object.getPrototypeOf(Video)).apply(this, arguments));
  }

  _createClass(Video, [{
    key: 'format',
    value: function format(name, value) {
      if (ATTRIBUTES.indexOf(name) > -1) {
        if (value) {
          this.domNode.setAttribute(name, value);
        } else {
          this.domNode.removeAttribute(name);
        }
      } else {
        _get(Video.prototype.__proto__ || Object.getPrototypeOf(Video.prototype), 'format', this).call(this, name, value);
      }
    }
  }], [{
    key: 'create',
    value: function create(value) {
      var node = _get(Video.__proto__ || Object.getPrototypeOf(Video), 'create', this).call(this, value);
      node.setAttribute('frameborder', '0');
      node.setAttribute('allowfullscreen', true);
      node.setAttribute('src', this.sanitize(value));
      return node;
    }
  }, {
    key: 'formats',
    value: function formats(domNode) {
      return ATTRIBUTES.reduce(function (formats, attribute) {
        if (domNode.hasAttribute(attribute)) {
          formats[attribute] = domNode.getAttribute(attribute);
        }
        return formats;
      }, {});
    }
  }, {
    key: 'sanitize',
    value: function sanitize(url) {
      return _link2.default.sanitize(url);
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('src');
    }
  }]);

  return Video;
}(_block.BlockEmbed);

Video.blotName = 'video';
Video.className = 'ql-video';
Video.tagName = 'IFRAME';

exports.default = Video;

/***/ }),
/* 74 */
/***/ (function(module, exports, __nested_webpack_require_405371__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.FormulaBlot = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _embed = __nested_webpack_require_405371__(35);

var _embed2 = _interopRequireDefault(_embed);

var _quill = __nested_webpack_require_405371__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __nested_webpack_require_405371__(9);

var _module2 = _interopRequireDefault(_module);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var FormulaBlot = function (_Embed) {
  _inherits(FormulaBlot, _Embed);

  function FormulaBlot() {
    _classCallCheck(this, FormulaBlot);

    return _possibleConstructorReturn(this, (FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot)).apply(this, arguments));
  }

  _createClass(FormulaBlot, null, [{
    key: 'create',
    value: function create(value) {
      var node = _get(FormulaBlot.__proto__ || Object.getPrototypeOf(FormulaBlot), 'create', this).call(this, value);
      if (typeof value === 'string') {
        window.katex.render(value, node, {
          throwOnError: false,
          errorColor: '#f00'
        });
        node.setAttribute('data-value', value);
      }
      return node;
    }
  }, {
    key: 'value',
    value: function value(domNode) {
      return domNode.getAttribute('data-value');
    }
  }]);

  return FormulaBlot;
}(_embed2.default);

FormulaBlot.blotName = 'formula';
FormulaBlot.className = 'ql-formula';
FormulaBlot.tagName = 'SPAN';

var Formula = function (_Module) {
  _inherits(Formula, _Module);

  _createClass(Formula, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(FormulaBlot, true);
    }
  }]);

  function Formula() {
    _classCallCheck(this, Formula);

    var _this2 = _possibleConstructorReturn(this, (Formula.__proto__ || Object.getPrototypeOf(Formula)).call(this));

    if (window.katex == null) {
      throw new Error('Formula module requires KaTeX.');
    }
    return _this2;
  }

  return Formula;
}(_module2.default);

exports.FormulaBlot = FormulaBlot;
exports.default = Formula;

/***/ }),
/* 75 */
/***/ (function(module, exports, __nested_webpack_require_409500__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CodeToken = exports.CodeBlock = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _parchment = __nested_webpack_require_409500__(0);

var _parchment2 = _interopRequireDefault(_parchment);

var _quill = __nested_webpack_require_409500__(5);

var _quill2 = _interopRequireDefault(_quill);

var _module = __nested_webpack_require_409500__(9);

var _module2 = _interopRequireDefault(_module);

var _code = __nested_webpack_require_409500__(13);

var _code2 = _interopRequireDefault(_code);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SyntaxCodeBlock = function (_CodeBlock) {
  _inherits(SyntaxCodeBlock, _CodeBlock);

  function SyntaxCodeBlock() {
    _classCallCheck(this, SyntaxCodeBlock);

    return _possibleConstructorReturn(this, (SyntaxCodeBlock.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock)).apply(this, arguments));
  }

  _createClass(SyntaxCodeBlock, [{
    key: 'replaceWith',
    value: function replaceWith(block) {
      this.domNode.textContent = this.domNode.textContent;
      this.attach();
      _get(SyntaxCodeBlock.prototype.__proto__ || Object.getPrototypeOf(SyntaxCodeBlock.prototype), 'replaceWith', this).call(this, block);
    }
  }, {
    key: 'highlight',
    value: function highlight(_highlight) {
      var text = this.domNode.textContent;
      if (this.cachedText !== text) {
        if (text.trim().length > 0 || this.cachedText == null) {
          this.domNode.innerHTML = _highlight(text);
          this.domNode.normalize();
          this.attach();
        }
        this.cachedText = text;
      }
    }
  }]);

  return SyntaxCodeBlock;
}(_code2.default);

SyntaxCodeBlock.className = 'ql-syntax';

var CodeToken = new _parchment2.default.Attributor.Class('token', 'hljs', {
  scope: _parchment2.default.Scope.INLINE
});

var Syntax = function (_Module) {
  _inherits(Syntax, _Module);

  _createClass(Syntax, null, [{
    key: 'register',
    value: function register() {
      _quill2.default.register(CodeToken, true);
      _quill2.default.register(SyntaxCodeBlock, true);
    }
  }]);

  function Syntax(quill, options) {
    _classCallCheck(this, Syntax);

    var _this2 = _possibleConstructorReturn(this, (Syntax.__proto__ || Object.getPrototypeOf(Syntax)).call(this, quill, options));

    if (typeof _this2.options.highlight !== 'function') {
      throw new Error('Syntax module requires highlight.js. Please include the library on the page before Quill.');
    }
    var timer = null;
    _this2.quill.on(_quill2.default.events.SCROLL_OPTIMIZE, function () {
      clearTimeout(timer);
      timer = setTimeout(function () {
        _this2.highlight();
        timer = null;
      }, _this2.options.interval);
    });
    _this2.highlight();
    return _this2;
  }

  _createClass(Syntax, [{
    key: 'highlight',
    value: function highlight() {
      var _this3 = this;

      if (this.quill.selection.composing) return;
      this.quill.update(_quill2.default.sources.USER);
      var range = this.quill.getSelection();
      this.quill.scroll.descendants(SyntaxCodeBlock).forEach(function (code) {
        code.highlight(_this3.options.highlight);
      });
      this.quill.update(_quill2.default.sources.SILENT);
      if (range != null) {
        this.quill.setSelection(range, _quill2.default.sources.SILENT);
      }
    }
  }]);

  return Syntax;
}(_module2.default);

Syntax.DEFAULTS = {
  highlight: function () {
    if (window.hljs == null) return null;
    return function (text) {
      var result = window.hljs.highlightAuto(text);
      return result.value;
    };
  }(),
  interval: 1000
};

exports.CodeBlock = SyntaxCodeBlock;
exports.CodeToken = CodeToken;
exports.default = Syntax;

/***/ }),
/* 76 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=13 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 77 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=14 x2=4 y1=14 y2=14></line> <line class=ql-stroke x1=12 x2=6 y1=4 y2=4></line> </svg>";

/***/ }),
/* 78 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=5 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=9 y1=4 y2=4></line> </svg>";

/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=15 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=15 x2=3 y1=14 y2=14></line> <line class=ql-stroke x1=15 x2=3 y1=4 y2=4></line> </svg>";

/***/ }),
/* 80 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <g class=\"ql-fill ql-color-label\"> <polygon points=\"6 6.868 6 6 5 6 5 7 5.942 7 6 6.868\"></polygon> <rect height=1 width=1 x=4 y=4></rect> <polygon points=\"6.817 5 6 5 6 6 6.38 6 6.817 5\"></polygon> <rect height=1 width=1 x=2 y=6></rect> <rect height=1 width=1 x=3 y=5></rect> <rect height=1 width=1 x=4 y=7></rect> <polygon points=\"4 11.439 4 11 3 11 3 12 3.755 12 4 11.439\"></polygon> <rect height=1 width=1 x=2 y=12></rect> <rect height=1 width=1 x=2 y=9></rect> <rect height=1 width=1 x=2 y=15></rect> <polygon points=\"4.63 10 4 10 4 11 4.192 11 4.63 10\"></polygon> <rect height=1 width=1 x=3 y=8></rect> <path d=M10.832,4.2L11,4.582V4H10.708A1.948,1.948,0,0,1,10.832,4.2Z></path> <path d=M7,4.582L7.168,4.2A1.929,1.929,0,0,1,7.292,4H7V4.582Z></path> <path d=M8,13H7.683l-0.351.8a1.933,1.933,0,0,1-.124.2H8V13Z></path> <rect height=1 width=1 x=12 y=2></rect> <rect height=1 width=1 x=11 y=3></rect> <path d=M9,3H8V3.282A1.985,1.985,0,0,1,9,3Z></path> <rect height=1 width=1 x=2 y=3></rect> <rect height=1 width=1 x=6 y=2></rect> <rect height=1 width=1 x=3 y=2></rect> <rect height=1 width=1 x=5 y=3></rect> <rect height=1 width=1 x=9 y=2></rect> <rect height=1 width=1 x=15 y=14></rect> <polygon points=\"13.447 10.174 13.469 10.225 13.472 10.232 13.808 11 14 11 14 10 13.37 10 13.447 10.174\"></polygon> <rect height=1 width=1 x=13 y=7></rect> <rect height=1 width=1 x=15 y=5></rect> <rect height=1 width=1 x=14 y=6></rect> <rect height=1 width=1 x=15 y=8></rect> <rect height=1 width=1 x=14 y=9></rect> <path d=M3.775,14H3v1H4V14.314A1.97,1.97,0,0,1,3.775,14Z></path> <rect height=1 width=1 x=14 y=3></rect> <polygon points=\"12 6.868 12 6 11.62 6 12 6.868\"></polygon> <rect height=1 width=1 x=15 y=2></rect> <rect height=1 width=1 x=12 y=5></rect> <rect height=1 width=1 x=13 y=4></rect> <polygon points=\"12.933 9 13 9 13 8 12.495 8 12.933 9\"></polygon> <rect height=1 width=1 x=9 y=14></rect> <rect height=1 width=1 x=8 y=15></rect> <path d=M6,14.926V15H7V14.316A1.993,1.993,0,0,1,6,14.926Z></path> <rect height=1 width=1 x=5 y=15></rect> <path d=M10.668,13.8L10.317,13H10v1h0.792A1.947,1.947,0,0,1,10.668,13.8Z></path> <rect height=1 width=1 x=11 y=15></rect> <path d=M14.332,12.2a1.99,1.99,0,0,1,.166.8H15V12H14.245Z></path> <rect height=1 width=1 x=14 y=15></rect> <rect height=1 width=1 x=15 y=11></rect> </g> <polyline class=ql-stroke points=\"5.5 13 9 5 12.5 13\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=11 y2=11></line> </svg>";

/***/ }),
/* 81 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=4 y=5></rect> <rect class=\"ql-fill ql-stroke\" height=3 width=3 x=11 y=5></rect> <path class=\"ql-even ql-fill ql-stroke\" d=M7,8c0,4.031-3,5-3,5></path> <path class=\"ql-even ql-fill ql-stroke\" d=M14,8c0,4.031-3,5-3,5></path> </svg>";

/***/ }),
/* 82 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,4H9.5A2.5,2.5,0,0,1,12,6.5v0A2.5,2.5,0,0,1,9.5,9H5A0,0,0,0,1,5,9V4A0,0,0,0,1,5,4Z></path> <path class=ql-stroke d=M5,9h5.5A2.5,2.5,0,0,1,13,11.5v0A2.5,2.5,0,0,1,10.5,14H5a0,0,0,0,1,0,0V9A0,0,0,0,1,5,9Z></path> </svg>";

/***/ }),
/* 83 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=5 x2=13 y1=3 y2=3></line> <line class=ql-stroke x1=6 x2=9.35 y1=12 y2=3></line> <line class=ql-stroke x1=11 x2=15 y1=11 y2=15></line> <line class=ql-stroke x1=15 x2=11 y1=11 y2=15></line> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=7 x=2 y=14></rect> </svg>";

/***/ }),
/* 84 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-color-label ql-stroke ql-transparent\" x1=3 x2=15 y1=15 y2=15></line> <polyline class=ql-stroke points=\"5.5 11 9 3 12.5 11\"></polyline> <line class=ql-stroke x1=11.63 x2=6.38 y1=9 y2=9></line> </svg>";

/***/ }),
/* 85 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"3 11 5 9 3 7 3 11\"></polygon> <line class=\"ql-stroke ql-fill\" x1=15 x2=11 y1=4 y2=4></line> <path class=ql-fill d=M11,3a3,3,0,0,0,0,6h1V3H11Z></path> <rect class=ql-fill height=11 width=1 x=11 y=4></rect> <rect class=ql-fill height=11 width=1 x=13 y=4></rect> </svg>";

/***/ }),
/* 86 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=\"ql-stroke ql-fill\" points=\"15 12 13 10 15 8 15 12\"></polygon> <line class=\"ql-stroke ql-fill\" x1=9 x2=5 y1=4 y2=4></line> <path class=ql-fill d=M5,3A3,3,0,0,0,5,9H6V3H5Z></path> <rect class=ql-fill height=11 width=1 x=5 y=4></rect> <rect class=ql-fill height=11 width=1 x=7 y=4></rect> </svg>";

/***/ }),
/* 87 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M14,16H4a1,1,0,0,1,0-2H14A1,1,0,0,1,14,16Z /> <path class=ql-fill d=M14,4H4A1,1,0,0,1,4,2H14A1,1,0,0,1,14,4Z /> <rect class=ql-fill x=3 y=6 width=12 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 88 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M13,16H5a1,1,0,0,1,0-2h8A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H5A1,1,0,0,1,5,2h8A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=2 y=6 width=14 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 89 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15,8H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,8Z /> <path class=ql-fill d=M15,12H13a1,1,0,0,1,0-2h2A1,1,0,0,1,15,12Z /> <path class=ql-fill d=M15,16H5a1,1,0,0,1,0-2H15A1,1,0,0,1,15,16Z /> <path class=ql-fill d=M15,4H5A1,1,0,0,1,5,2H15A1,1,0,0,1,15,4Z /> <rect class=ql-fill x=2 y=6 width=8 height=6 rx=1 ry=1 /> </svg>";

/***/ }),
/* 90 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M5,8H3A1,1,0,0,1,3,6H5A1,1,0,0,1,5,8Z /> <path class=ql-fill d=M5,12H3a1,1,0,0,1,0-2H5A1,1,0,0,1,5,12Z /> <path class=ql-fill d=M13,16H3a1,1,0,0,1,0-2H13A1,1,0,0,1,13,16Z /> <path class=ql-fill d=M13,4H3A1,1,0,0,1,3,2H13A1,1,0,0,1,13,4Z /> <rect class=ql-fill x=8 y=6 width=8 height=6 rx=1 ry=1 transform=\"translate(24 18) rotate(-180)\"/> </svg>";

/***/ }),
/* 91 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M11.759,2.482a2.561,2.561,0,0,0-3.53.607A7.656,7.656,0,0,0,6.8,6.2C6.109,9.188,5.275,14.677,4.15,14.927a1.545,1.545,0,0,0-1.3-.933A0.922,0.922,0,0,0,2,15.036S1.954,16,4.119,16s3.091-2.691,3.7-5.553c0.177-.826.36-1.726,0.554-2.6L8.775,6.2c0.381-1.421.807-2.521,1.306-2.676a1.014,1.014,0,0,0,1.02.56A0.966,0.966,0,0,0,11.759,2.482Z></path> <rect class=ql-fill height=1.6 rx=0.8 ry=0.8 width=5 x=5.15 y=6.2></rect> <path class=ql-fill d=M13.663,12.027a1.662,1.662,0,0,1,.266-0.276q0.193,0.069.456,0.138a2.1,2.1,0,0,0,.535.069,1.075,1.075,0,0,0,.767-0.3,1.044,1.044,0,0,0,.314-0.8,0.84,0.84,0,0,0-.238-0.619,0.8,0.8,0,0,0-.594-0.239,1.154,1.154,0,0,0-.781.3,4.607,4.607,0,0,0-.781,1q-0.091.15-.218,0.346l-0.246.38c-0.068-.288-0.137-0.582-0.212-0.885-0.459-1.847-2.494-.984-2.941-0.8-0.482.2-.353,0.647-0.094,0.529a0.869,0.869,0,0,1,1.281.585c0.217,0.751.377,1.436,0.527,2.038a5.688,5.688,0,0,1-.362.467,2.69,2.69,0,0,1-.264.271q-0.221-.08-0.471-0.147a2.029,2.029,0,0,0-.522-0.066,1.079,1.079,0,0,0-.768.3A1.058,1.058,0,0,0,9,15.131a0.82,0.82,0,0,0,.832.852,1.134,1.134,0,0,0,.787-0.3,5.11,5.11,0,0,0,.776-0.993q0.141-.219.215-0.34c0.046-.076.122-0.194,0.223-0.346a2.786,2.786,0,0,0,.918,1.726,2.582,2.582,0,0,0,2.376-.185c0.317-.181.212-0.565,0-0.494A0.807,0.807,0,0,1,14.176,15a5.159,5.159,0,0,1-.913-2.446l0,0Q13.487,12.24,13.663,12.027Z></path> </svg>";

/***/ }),
/* 92 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M10,4V14a1,1,0,0,1-2,0V10H3v4a1,1,0,0,1-2,0V4A1,1,0,0,1,3,4V8H8V4a1,1,0,0,1,2,0Zm6.06787,9.209H14.98975V7.59863a.54085.54085,0,0,0-.605-.60547h-.62744a1.01119,1.01119,0,0,0-.748.29688L11.645,8.56641a.5435.5435,0,0,0-.022.8584l.28613.30762a.53861.53861,0,0,0,.84717.0332l.09912-.08789a1.2137,1.2137,0,0,0,.2417-.35254h.02246s-.01123.30859-.01123.60547V13.209H12.041a.54085.54085,0,0,0-.605.60547v.43945a.54085.54085,0,0,0,.605.60547h4.02686a.54085.54085,0,0,0,.605-.60547v-.43945A.54085.54085,0,0,0,16.06787,13.209Z /> </svg>";

/***/ }),
/* 93 */
/***/ (function(module, exports) {

module.exports = "<svg viewBox=\"0 0 18 18\"> <path class=ql-fill d=M16.73975,13.81445v.43945a.54085.54085,0,0,1-.605.60547H11.855a.58392.58392,0,0,1-.64893-.60547V14.0127c0-2.90527,3.39941-3.42187,3.39941-4.55469a.77675.77675,0,0,0-.84717-.78125,1.17684,1.17684,0,0,0-.83594.38477c-.2749.26367-.561.374-.85791.13184l-.4292-.34082c-.30811-.24219-.38525-.51758-.1543-.81445a2.97155,2.97155,0,0,1,2.45361-1.17676,2.45393,2.45393,0,0,1,2.68408,2.40918c0,2.45312-3.1792,2.92676-3.27832,3.93848h2.79443A.54085.54085,0,0,1,16.73975,13.81445ZM9,3A.99974.99974,0,0,0,8,4V8H3V4A1,1,0,0,0,1,4V14a1,1,0,0,0,2,0V10H8v4a1,1,0,0,0,2,0V4A.99974.99974,0,0,0,9,3Z /> </svg>";

/***/ }),
/* 94 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=13 y1=4 y2=4></line> <line class=ql-stroke x1=5 x2=11 y1=14 y2=14></line> <line class=ql-stroke x1=8 x2=10 y1=14 y2=4></line> </svg>";

/***/ }),
/* 95 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=10 width=12 x=3 y=4></rect> <circle class=ql-fill cx=6 cy=7 r=1></circle> <polyline class=\"ql-even ql-fill\" points=\"5 12 5 11 7 9 8 10 11 7 13 9 13 12 5 12\"></polyline> </svg>";

/***/ }),
/* 96 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=\"ql-fill ql-stroke\" points=\"3 7 3 11 5 9 3 7\"></polyline> </svg>";

/***/ }),
/* 97 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=3 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"5 7 5 11 3 9 5 7\"></polyline> </svg>";

/***/ }),
/* 98 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=11 y1=7 y2=11></line> <path class=\"ql-even ql-stroke\" d=M8.9,4.577a3.476,3.476,0,0,1,.36,4.679A3.476,3.476,0,0,1,4.577,8.9C3.185,7.5,2.035,6.4,4.217,4.217S7.5,3.185,8.9,4.577Z></path> <path class=\"ql-even ql-stroke\" d=M13.423,9.1a3.476,3.476,0,0,0-4.679-.36,3.476,3.476,0,0,0,.36,4.679c1.392,1.392,2.5,2.542,4.679.36S14.815,10.5,13.423,9.1Z></path> </svg>";

/***/ }),
/* 99 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=7 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=7 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=7 x2=15 y1=14 y2=14></line> <line class=\"ql-stroke ql-thin\" x1=2.5 x2=4.5 y1=5.5 y2=5.5></line> <path class=ql-fill d=M3.5,6A0.5,0.5,0,0,1,3,5.5V3.085l-0.276.138A0.5,0.5,0,0,1,2.053,3c-0.124-.247-0.023-0.324.224-0.447l1-.5A0.5,0.5,0,0,1,4,2.5v3A0.5,0.5,0,0,1,3.5,6Z></path> <path class=\"ql-stroke ql-thin\" d=M4.5,10.5h-2c0-.234,1.85-1.076,1.85-2.234A0.959,0.959,0,0,0,2.5,8.156></path> <path class=\"ql-stroke ql-thin\" d=M2.5,14.846a0.959,0.959,0,0,0,1.85-.109A0.7,0.7,0,0,0,3.75,14a0.688,0.688,0,0,0,.6-0.736,0.959,0.959,0,0,0-1.85-.109></path> </svg>";

/***/ }),
/* 100 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=6 x2=15 y1=4 y2=4></line> <line class=ql-stroke x1=6 x2=15 y1=9 y2=9></line> <line class=ql-stroke x1=6 x2=15 y1=14 y2=14></line> <line class=ql-stroke x1=3 x2=3 y1=4 y2=4></line> <line class=ql-stroke x1=3 x2=3 y1=9 y2=9></line> <line class=ql-stroke x1=3 x2=3 y1=14 y2=14></line> </svg>";

/***/ }),
/* 101 */
/***/ (function(module, exports) {

module.exports = "<svg class=\"\" viewbox=\"0 0 18 18\"> <line class=ql-stroke x1=9 x2=15 y1=4 y2=4></line> <polyline class=ql-stroke points=\"3 4 4 5 6 3\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=14 y2=14></line> <polyline class=ql-stroke points=\"3 14 4 15 6 13\"></polyline> <line class=ql-stroke x1=9 x2=15 y1=9 y2=9></line> <polyline class=ql-stroke points=\"3 9 4 10 6 8\"></polyline> </svg>";

/***/ }),
/* 102 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,15H13.861a3.858,3.858,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.921,1.921,0,0,0,12.021,11.7a0.50013,0.50013,0,1,0,.957.291h0a0.914,0.914,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.076-1.16971,1.86982-1.93971,2.43082A1.45639,1.45639,0,0,0,12,15.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,15Z /> <path class=ql-fill d=M9.65,5.241a1,1,0,0,0-1.409.108L6,7.964,3.759,5.349A1,1,0,0,0,2.192,6.59178Q2.21541,6.6213,2.241,6.649L4.684,9.5,2.241,12.35A1,1,0,0,0,3.71,13.70722q0.02557-.02768.049-0.05722L6,11.036,8.241,13.65a1,1,0,1,0,1.567-1.24277Q9.78459,12.3777,9.759,12.35L7.316,9.5,9.759,6.651A1,1,0,0,0,9.65,5.241Z /> </svg>";

/***/ }),
/* 103 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-fill d=M15.5,7H13.861a4.015,4.015,0,0,0,1.914-2.975,1.8,1.8,0,0,0-1.6-1.751A1.922,1.922,0,0,0,12.021,3.7a0.5,0.5,0,1,0,.957.291,0.917,0.917,0,0,1,1.053-.725,0.81,0.81,0,0,1,.744.762c0,1.077-1.164,1.925-1.934,2.486A1.423,1.423,0,0,0,12,7.5a0.5,0.5,0,0,0,.5.5h3A0.5,0.5,0,0,0,15.5,7Z /> <path class=ql-fill d=M9.651,5.241a1,1,0,0,0-1.41.108L6,7.964,3.759,5.349a1,1,0,1,0-1.519,1.3L4.683,9.5,2.241,12.35a1,1,0,1,0,1.519,1.3L6,11.036,8.241,13.65a1,1,0,0,0,1.519-1.3L7.317,9.5,9.759,6.651A1,1,0,0,0,9.651,5.241Z /> </svg>";

/***/ }),
/* 104 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <line class=\"ql-stroke ql-thin\" x1=15.5 x2=2.5 y1=8.5 y2=9.5></line> <path class=ql-fill d=M9.007,8C6.542,7.791,6,7.519,6,6.5,6,5.792,7.283,5,9,5c1.571,0,2.765.679,2.969,1.309a1,1,0,0,0,1.9-.617C13.356,4.106,11.354,3,9,3,6.2,3,4,4.538,4,6.5a3.2,3.2,0,0,0,.5,1.843Z></path> <path class=ql-fill d=M8.984,10C11.457,10.208,12,10.479,12,11.5c0,0.708-1.283,1.5-3,1.5-1.571,0-2.765-.679-2.969-1.309a1,1,0,1,0-1.9.617C4.644,13.894,6.646,15,9,15c2.8,0,5-1.538,5-3.5a3.2,3.2,0,0,0-.5-1.843Z></path> </svg>";

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <path class=ql-stroke d=M5,3V9a4.012,4.012,0,0,0,4,4H9a4.012,4.012,0,0,0,4-4V3></path> <rect class=ql-fill height=1 rx=0.5 ry=0.5 width=12 x=3 y=15></rect> </svg>";

/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <rect class=ql-stroke height=12 width=12 x=3 y=3></rect> <rect class=ql-fill height=12 width=1 x=5 y=3></rect> <rect class=ql-fill height=12 width=1 x=12 y=3></rect> <rect class=ql-fill height=2 width=8 x=5 y=8></rect> <rect class=ql-fill height=1 width=3 x=3 y=5></rect> <rect class=ql-fill height=1 width=3 x=3 y=7></rect> <rect class=ql-fill height=1 width=3 x=3 y=10></rect> <rect class=ql-fill height=1 width=3 x=3 y=12></rect> <rect class=ql-fill height=1 width=3 x=12 y=5></rect> <rect class=ql-fill height=1 width=3 x=12 y=7></rect> <rect class=ql-fill height=1 width=3 x=12 y=10></rect> <rect class=ql-fill height=1 width=3 x=12 y=12></rect> </svg>";

/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = "<svg viewbox=\"0 0 18 18\"> <polygon class=ql-stroke points=\"7 11 9 13 11 11 7 11\"></polygon> <polygon class=ql-stroke points=\"7 7 9 5 11 7 7 7\"></polygon> </svg>";

/***/ }),
/* 108 */
/***/ (function(module, exports, __nested_webpack_require_432266__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BubbleTooltip = undefined;

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extend = __nested_webpack_require_432266__(3);

var _extend2 = _interopRequireDefault(_extend);

var _emitter = __nested_webpack_require_432266__(8);

var _emitter2 = _interopRequireDefault(_emitter);

var _base = __nested_webpack_require_432266__(43);

var _base2 = _interopRequireDefault(_base);

var _selection = __nested_webpack_require_432266__(15);

var _icons = __nested_webpack_require_432266__(41);

var _icons2 = _interopRequireDefault(_icons);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TOOLBAR_CONFIG = [['bold', 'italic', 'link'], [{ header: 1 }, { header: 2 }, 'blockquote']];

var BubbleTheme = function (_BaseTheme) {
  _inherits(BubbleTheme, _BaseTheme);

  function BubbleTheme(quill, options) {
    _classCallCheck(this, BubbleTheme);

    if (options.modules.toolbar != null && options.modules.toolbar.container == null) {
      options.modules.toolbar.container = TOOLBAR_CONFIG;
    }

    var _this = _possibleConstructorReturn(this, (BubbleTheme.__proto__ || Object.getPrototypeOf(BubbleTheme)).call(this, quill, options));

    _this.quill.container.classList.add('ql-bubble');
    return _this;
  }

  _createClass(BubbleTheme, [{
    key: 'extendToolbar',
    value: function extendToolbar(toolbar) {
      this.tooltip = new BubbleTooltip(this.quill, this.options.bounds);
      this.tooltip.root.appendChild(toolbar.container);
      this.buildButtons([].slice.call(toolbar.container.querySelectorAll('button')), _icons2.default);
      this.buildPickers([].slice.call(toolbar.container.querySelectorAll('select')), _icons2.default);
    }
  }]);

  return BubbleTheme;
}(_base2.default);

BubbleTheme.DEFAULTS = (0, _extend2.default)(true, {}, _base2.default.DEFAULTS, {
  modules: {
    toolbar: {
      handlers: {
        link: function link(value) {
          if (!value) {
            this.quill.format('link', false);
          } else {
            this.quill.theme.tooltip.edit();
          }
        }
      }
    }
  }
});

var BubbleTooltip = function (_BaseTooltip) {
  _inherits(BubbleTooltip, _BaseTooltip);

  function BubbleTooltip(quill, bounds) {
    _classCallCheck(this, BubbleTooltip);

    var _this2 = _possibleConstructorReturn(this, (BubbleTooltip.__proto__ || Object.getPrototypeOf(BubbleTooltip)).call(this, quill, bounds));

    _this2.quill.on(_emitter2.default.events.EDITOR_CHANGE, function (type, range, oldRange, source) {
      if (type !== _emitter2.default.events.SELECTION_CHANGE) return;
      if (range != null && range.length > 0 && source === _emitter2.default.sources.USER) {
        _this2.show();
        // Lock our width so we will expand beyond our offsetParent boundaries
        _this2.root.style.left = '0px';
        _this2.root.style.width = '';
        _this2.root.style.width = _this2.root.offsetWidth + 'px';
        var lines = _this2.quill.getLines(range.index, range.length);
        if (lines.length === 1) {
          _this2.position(_this2.quill.getBounds(range));
        } else {
          var lastLine = lines[lines.length - 1];
          var index = _this2.quill.getIndex(lastLine);
          var length = Math.min(lastLine.length() - 1, range.index + range.length - index);
          var _bounds = _this2.quill.getBounds(new _selection.Range(index, length));
          _this2.position(_bounds);
        }
      } else if (document.activeElement !== _this2.textbox && _this2.quill.hasFocus()) {
        _this2.hide();
      }
    });
    return _this2;
  }

  _createClass(BubbleTooltip, [{
    key: 'listen',
    value: function listen() {
      var _this3 = this;

      _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'listen', this).call(this);
      this.root.querySelector('.ql-close').addEventListener('click', function () {
        _this3.root.classList.remove('ql-editing');
      });
      this.quill.on(_emitter2.default.events.SCROLL_OPTIMIZE, function () {
        // Let selection be restored by toolbar handlers before repositioning
        setTimeout(function () {
          if (_this3.root.classList.contains('ql-hidden')) return;
          var range = _this3.quill.getSelection();
          if (range != null) {
            _this3.position(_this3.quill.getBounds(range));
          }
        }, 1);
      });
    }
  }, {
    key: 'cancel',
    value: function cancel() {
      this.show();
    }
  }, {
    key: 'position',
    value: function position(reference) {
      var shift = _get(BubbleTooltip.prototype.__proto__ || Object.getPrototypeOf(BubbleTooltip.prototype), 'position', this).call(this, reference);
      var arrow = this.root.querySelector('.ql-tooltip-arrow');
      arrow.style.marginLeft = '';
      if (shift === 0) return shift;
      arrow.style.marginLeft = -1 * shift - arrow.offsetWidth / 2 + 'px';
    }
  }]);

  return BubbleTooltip;
}(_base.BaseTooltip);

BubbleTooltip.TEMPLATE = ['<span class="ql-tooltip-arrow"></span>', '<div class="ql-tooltip-editor">', '<input type="text" data-formula="e=mc^2" data-link="https://quilljs.com" data-video="Embed URL">', '<a class="ql-close"></a>', '</div>'].join('');

exports.BubbleTooltip = BubbleTooltip;
exports.default = BubbleTheme;

/***/ }),
/* 109 */
/***/ (function(module, exports, __nested_webpack_require_439588__) {

module.exports = __nested_webpack_require_439588__(63);


/***/ })
/******/ ])["default"];
});

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/amd options */
/******/ 	!function() {
/******/ 		__webpack_require__.amdO = {};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/create fake namespace object */
/******/ 	!function() {
/******/ 		var getProto = Object.getPrototypeOf ? function(obj) { return Object.getPrototypeOf(obj); } : function(obj) { return obj.__proto__; };
/******/ 		var leafPrototypes;
/******/ 		// create a fake namespace object
/******/ 		// mode & 1: value is a module id, require it
/******/ 		// mode & 2: merge all properties of value into the ns
/******/ 		// mode & 4: return value when already ns object
/******/ 		// mode & 16: return value when it's Promise-like
/******/ 		// mode & 8|1: behave like require
/******/ 		__webpack_require__.t = function(value, mode) {
/******/ 			if(mode & 1) value = this(value);
/******/ 			if(mode & 8) return value;
/******/ 			if(typeof value === 'object' && value) {
/******/ 				if((mode & 4) && value.__esModule) return value;
/******/ 				if((mode & 16) && typeof value.then === 'function') return value;
/******/ 			}
/******/ 			var ns = Object.create(null);
/******/ 			__webpack_require__.r(ns);
/******/ 			var def = {};
/******/ 			leafPrototypes = leafPrototypes || [null, getProto({}), getProto([]), getProto(getProto)];
/******/ 			for(var current = mode & 2 && value; typeof current == 'object' && !~leafPrototypes.indexOf(current); current = getProto(current)) {
/******/ 				Object.getOwnPropertyNames(current).forEach(function(key) { def[key] = function() { return value[key]; }; });
/******/ 			}
/******/ 			def['default'] = function() { return value; };
/******/ 			__webpack_require__.d(ns, def);
/******/ 			return ns;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  Accordion: function() { return /* reexport */ Accordion; },
  ActivityMessage: function() { return /* reexport */ ActivityMessage; },
  AnnotationInputCard: function() { return /* reexport */ AnnotationInputCard; },
  AutoCompleteInput: function() { return /* reexport */ AutoCompleteInput; },
  Avatar: function() { return /* reexport */ Avatar; },
  Badge: function() { return /* reexport */ Badge; },
  BigToast: function() { return /* reexport */ BigToast; },
  Button: function() { return /* reexport */ components_Button; },
  ButtonDropdown: function() { return /* reexport */ ButtonDropdown; },
  Card: function() { return /* reexport */ Card_Card; },
  Checkbox: function() { return /* reexport */ Checkbox; },
  CollapsibleMenu: function() { return /* reexport */ CollapsibleMenu; },
  CustomLink: function() { return /* reexport */ CustomLink; },
  DrawerNotes: function() { return /* reexport */ NotesDrawer; },
  DropDownMenu: function() { return /* reexport */ components_DropDownMenu; },
  DropDownMenuOption: function() { return /* reexport */ DropDownMenuOption; },
  Dropdown: function() { return /* reexport */ Dropdown; },
  DropdownMenuMobile: function() { return /* reexport */ DropdownMenuMobile; },
  FileDownloadBox: function() { return /* reexport */ FileDownloadBox; },
  FileUploadBox: function() { return /* reexport */ FileUploadBox; },
  FloatingActionButton: function() { return /* reexport */ components_FloatingActionButton; },
  HeroImage: function() { return /* reexport */ HeroImage; },
  HoverSubtitle: function() { return /* reexport */ HoverSubtitle; },
  Icon: function() { return /* reexport */ Icon; },
  IconButton: function() { return /* reexport */ IconButton; },
  InfiniteScroll: function() { return /* reexport */ InfiniteScroll; },
  InfoStats: function() { return /* reexport */ InfoStats; },
  InformationModal: function() { return /* reexport */ InformationModal; },
  LessonDetailsCard: function() { return /* reexport */ LessonDetailsCard; },
  Link: function() { return /* reexport */ Link_Link; },
  Loading: function() { return /* reexport */ Loading; },
  Logo: function() { return /* reexport */ Logo; },
  MaskImage: function() { return /* reexport */ MaskImage; },
  MenuButton: function() { return /* reexport */ MenuButton; },
  MenuTree: function() { return /* reexport */ MenuTree; },
  Modal: function() { return /* reexport */ components_Modal; },
  ModalActions: function() { return /* reexport */ ModalActions; },
  ModalPagination: function() { return /* reexport */ ModalPagination; },
  ModalTitle: function() { return /* reexport */ ModalTitle; },
  Navbar: function() { return /* reexport */ Navbar; },
  NavigationTabMobile: function() { return /* reexport */ NavigationTabMobile; },
  NotificationBigModal: function() { return /* reexport */ NotificationBigModal; },
  NotificationCard: function() { return /* reexport */ NotificationCard; },
  NotificationModal: function() { return /* reexport */ NotificationModal; },
  NotificationOptions: function() { return /* reexport */ NotificationOptions; },
  Outline: function() { return /* reexport */ Outline_Outline; },
  OutlinedSelect: function() { return /* reexport */ OutlinedSelect; },
  OutlinedTextInput: function() { return /* reexport */ OutlinedTextInput; },
  PipelineMenu: function() { return /* reexport */ PipelineMenu; },
  Popup: function() { return /* reexport */ components_Popup; },
  PopupActions: function() { return /* reexport */ PopupActions; },
  PopupDescription: function() { return /* reexport */ PopupDescription; },
  PopupImage: function() { return /* reexport */ PopupImage; },
  PopupTitle: function() { return /* reexport */ PopupTitle; },
  ProfileProgress: function() { return /* reexport */ ProfileProgress; },
  ProgressCircular: function() { return /* reexport */ ProgressCircular; },
  RadioButton: function() { return /* reexport */ RadioButton; },
  RangeSlider: function() { return /* reexport */ RangeSlider; },
  SearchCard: function() { return /* reexport */ SearchCard; },
  Select: function() { return /* reexport */ Select; },
  SelectBox: function() { return /* reexport */ SelectBox; },
  SelectGrouped: function() { return /* reexport */ SelectGrouped; },
  Tab: function() { return /* reexport */ Tab; },
  Tabs: function() { return /* reexport */ Tabs; },
  Tags: function() { return /* reexport */ Tags; },
  TermsOfUse: function() { return /* reexport */ TermsOfUse; },
  TextInput: function() { return /* reexport */ TextInput; },
  TextSizeButtons: function() { return /* reexport */ TextSizeButtons; },
  Timeline: function() { return /* reexport */ Timeline; },
  TimelineItem: function() { return /* reexport */ TimelineItem; },
  Toast: function() { return /* reexport */ Toast; },
  ToggleSwitch: function() { return /* reexport */ ToggleSwitch; },
  Tooltip: function() { return /* reexport */ Tooltip; },
  UserSettingsModal: function() { return /* reexport */ UserSettingsModal; },
  WhatsNewTag: function() { return /* reexport */ WhatsNewTag; }
});

;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (true) {
    var getCurrentScript = __webpack_require__(7679)
    currentScript = getCurrentScript()

    // for backward compatibility, because previously we directly included the polyfill
    if (!('currentScript' in document)) {
      Object.defineProperty(document, 'currentScript', { get: getCurrentScript })
    }
  }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Accordion/Accordion.vue?vue&type=template&id=4906770a&scoped=true&
var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "accordion"
  }, [_c('div', {
    staticClass: "accordion-header",
    on: {
      "click": _vm.clickHandler
    }
  }, [_c('span', {
    staticClass: "accordion-header--title"
  }, [_vm._v(_vm._s(_vm.title))]), _c('Icon', {
    staticClass: "accordion-header--icon",
    class: {
      'accordion-header--icon---rotate': _vm.showContent
    },
    attrs: {
      "name": "chevronDown"
    }
  })], 1), _c('transition', {
    on: {
      "before-enter": _vm.beforeEnterAndLeave,
      "enter": _vm.enter,
      "leave": _vm.beforeEnterAndLeave
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showContent,
      expression: "showContent"
    }],
    staticClass: "accordion-content"
  }, [_vm._t("default")], 2)])], 1);
};
var staticRenderFns = [];

;// CONCATENATED MODULE: external {"commonjs":"vue","commonjs2":"vue","root":"Vue"}
var external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject = require("vue");
var external_commonjs_vue_commonjs2_vue_root_Vue_default = /*#__PURE__*/__webpack_require__.n(external_commonjs_vue_commonjs2_vue_root_Vue_namespaceObject);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.function.name.js
var es_function_name = __webpack_require__(8309);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/Icon.vue?vue&type=template&id=58fabfe0&

var Iconvue_type_template_id_58fabfe0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    staticClass: "icon-svg",
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "viewBox": "0 0 24 24"
    }
  }, [_c(_vm.icon, {
    key: _vm.name,
    tag: "component"
  })], 1);
};
var Iconvue_type_template_id_58fabfe0_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Icon/Icon.vue?vue&type=template&id=58fabfe0&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.number.constructor.js
var es_number_constructor = __webpack_require__(9653);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/AccountCircle.vue?vue&type=template&id=029b47cf&
var AccountCirclevue_type_template_id_029b47cf_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C17.9342 1.25 22.75 6.06579 22.75 12C22.75 17.9342 17.9342 22.75 12 22.75C6.06579 22.75 1.25 17.9342 1.25 12C1.25 6.06579 6.06579 1.25 12 1.25ZM14.3313 17.7179H9.65586C8.36573 17.7179 7.19488 18.3982 6.54571 19.4687C8.07546 20.5891 9.96106 21.25 12 21.25C14.035 21.25 15.9172 20.5917 17.4451 19.4766C16.7967 18.4008 15.6239 17.7179 14.3313 17.7179ZM12 2.75C6.89421 2.75 2.75 6.89421 2.75 12C2.75 14.5223 3.76135 16.8099 5.40037 18.4792C6.33812 17.0893 7.92061 16.2179 9.65586 16.2179H14.3313C16.0695 16.2179 17.6544 17.0922 18.5927 18.4852C20.2358 16.8163 21.25 14.5258 21.25 12C21.25 6.89421 17.1058 2.75 12 2.75ZM12 7C14.2087 7 16 8.79127 16 11C16 13.2087 14.2087 15 12 15C9.79127 15 8 13.2087 8 11C8 8.79127 9.79127 7 12 7ZM12 8.5C10.6197 8.5 9.5 9.6197 9.5 11C9.5 12.3803 10.6197 13.5 12 13.5C13.3803 13.5 14.5 12.3803 14.5 11C14.5 9.6197 13.3803 8.5 12 8.5Z"
    }
  });
};
var AccountCirclevue_type_template_id_029b47cf_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/AccountCircle.vue?vue&type=script&lang=ts&

/* harmony default export */ var AccountCirclevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/AccountCircle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_AccountCirclevue_type_script_lang_ts_ = (AccountCirclevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}

;// CONCATENATED MODULE: ./src/components/Icon/icons/AccountCircle.vue





/* normalize component */
;
var component = normalizeComponent(
  icons_AccountCirclevue_type_script_lang_ts_,
  AccountCirclevue_type_template_id_029b47cf_render,
  AccountCirclevue_type_template_id_029b47cf_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AccountCircle = (component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Add.vue?vue&type=template&id=3aea30e7&
var Addvue_type_template_id_3aea30e7_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 4.25c.4142 0 .75.33579.75.75v6.25H19c.3797 0 .6935.2822.7432.6482L19.75 12c0 .4142-.3358.75-.75.75h-6.25V19c0 .3797-.2822.6935-.6482.7432L12 19.75c-.4142 0-.75-.3358-.75-.75v-6.25H5c-.3797 0-.69349-.2822-.74315-.6482L4.25 12c0-.4142.33579-.75.75-.75h6.25V5c0-.3797.2822-.69349.6482-.74315L12 4.25z"
    }
  });
};
var Addvue_type_template_id_3aea30e7_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Add.vue?vue&type=script&lang=ts&

/* harmony default export */ var Addvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Add.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Addvue_type_script_lang_ts_ = (Addvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Add.vue





/* normalize component */
;
var Add_component = normalizeComponent(
  icons_Addvue_type_script_lang_ts_,
  Addvue_type_template_id_3aea30e7_render,
  Addvue_type_template_id_3aea30e7_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Add = (Add_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Alarm.vue?vue&type=template&id=5cce561f&
var Alarmvue_type_template_id_5cce561f_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 3.00001C17.3867 3.00001 21.75 7.3633 21.75 12.75C21.75 18.1367 17.3867 22.5 12 22.5C6.6133 22.5 2.25001 18.1367 2.25001 12.75C2.25001 7.3633 6.6133 3.00001 12 3.00001ZM12 4.50001C7.44172 4.50001 3.75001 8.19172 3.75001 12.75C3.75001 17.3083 7.44172 21 12 21C16.5583 21 20.25 17.3083 20.25 12.75C20.25 8.19172 16.5583 4.50001 12 4.50001ZM12.1344 8.50001C12.5486 8.50001 12.8844 8.8358 12.8844 9.25001V12.8987L15.6145 15.1738C15.9327 15.439 15.9757 15.9119 15.7106 16.2301C15.4454 16.5484 14.9725 16.5913 14.6543 16.3262L11.6543 13.8262C11.4833 13.6837 11.3844 13.4726 11.3844 13.25V9.25001C11.3844 8.8358 11.7202 8.50001 12.1344 8.50001ZM17.4356 1.75613C17.7083 1.4444 18.1822 1.41282 18.4939 1.68558L22.4939 5.18558C22.8056 5.45834 22.8372 5.93216 22.5644 6.24389C22.2917 6.55562 21.8179 6.5872 21.5061 6.31444L17.5061 2.81444C17.1944 2.54168 17.1628 2.06786 17.4356 1.75613ZM6.56444 1.75613C6.8372 2.06786 6.80562 2.54168 6.49389 2.81444L2.49389 6.31444C2.18216 6.5872 1.70834 6.55562 1.43558 6.24389C1.16282 5.93216 1.1944 5.45834 1.50613 5.18558L5.50613 1.68558C5.81786 1.41282 6.29168 1.4444 6.56444 1.75613Z"
    }
  });
};
var Alarmvue_type_template_id_5cce561f_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Alarm.vue?vue&type=script&lang=ts&

/* harmony default export */ var Alarmvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Alarm.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Alarmvue_type_script_lang_ts_ = (Alarmvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Alarm.vue





/* normalize component */
;
var Alarm_component = normalizeComponent(
  icons_Alarmvue_type_script_lang_ts_,
  Alarmvue_type_template_id_5cce561f_render,
  Alarmvue_type_template_id_5cce561f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Alarm = (Alarm_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Annotation.vue?vue&type=template&id=486caaa3&
var Annotationvue_type_template_id_486caaa3_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M8.95487 15.2683C9.36641 15.2683 9.70004 15.5959 9.70004 16C9.70004 16.4041 9.36641 16.7317 8.95487 16.7317H7.21615C6.80461 16.7317 6.47099 16.4041 6.47099 16C6.47099 15.5959 6.80461 15.2683 7.21615 15.2683H8.95487Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.9782 11.3659C11.3897 11.3659 11.7234 11.6935 11.7234 12.0976C11.7234 12.5017 11.3897 12.8293 10.9782 12.8293H7.21615C6.80461 12.8293 6.47099 12.5017 6.47099 12.0976C6.47099 11.6935 6.80461 11.3659 7.21615 11.3659H10.9782Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.2163 7.21951C13.6278 7.21951 13.9614 7.54711 13.9614 7.95122C13.9614 8.35533 13.6278 8.68293 13.2163 8.68293H7.21615C6.80461 8.68293 6.47099 8.35533 6.47099 7.95122C6.47099 7.54711 6.80461 7.21951 7.21615 7.21951H13.2163Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M17.6485 2C19.1575 2 20.3807 3.20119 20.3807 4.68293V4.80036L22.3938 5.85141C22.6614 5.9911 22.8615 6.22944 22.9501 6.514C23.0387 6.79856 23.0085 7.10602 22.8663 7.36875L20.3807 11.9589V19.3171C20.3807 20.7988 19.1575 22 17.6485 22H4.73227C3.22328 22 2 20.7988 2 19.3171V4.68293C2 3.20119 3.22328 2 4.73227 2H17.6485ZM19.8842 9.96658L17.4806 8.71147L13.6464 15.7923L14.2092 17.5999L16.0501 17.0473L19.8842 9.96658ZM18.8904 14.7112V19.3171C18.8904 19.9906 18.3344 20.5366 17.6485 20.5366H4.73227C4.04637 20.5366 3.49033 19.9906 3.49033 19.3171V4.68293C3.49033 4.00941 4.04637 3.46341 4.73227 3.46341H17.6485C18.1807 3.46341 18.6347 3.79212 18.8114 4.25406C18.7676 4.26186 18.7241 4.2722 18.6811 4.28512C18.3913 4.37212 18.1485 4.56859 18.0063 4.83132L12.3716 15.2372C12.3001 15.3682 12.2558 15.5119 12.2414 15.6599C12.2269 15.8079 12.2426 15.9573 12.2874 16.0993L12.9529 18.2367C12.996 18.3775 13.067 18.5085 13.1619 18.6221C13.2568 18.7357 13.3738 18.8297 13.5059 18.8987C13.6381 18.9677 13.7828 19.0103 13.9318 19.0241C14.0808 19.0378 14.2312 19.0224 14.3741 18.9787L16.5509 18.3252C16.6958 18.2823 16.8307 18.2116 16.9475 18.117C17.0644 18.0225 17.1609 17.9061 17.2316 17.7746L18.8904 14.7112ZM18.1383 7.49687L20.542 8.75185L21.5308 6.92566L20.3807 6.32519V6.34743L19.1179 5.68807L18.1383 7.49687Z"
    }
  })]);
};
var Annotationvue_type_template_id_486caaa3_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Annotation.vue?vue&type=script&lang=ts&

/* harmony default export */ var Annotationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Annotation.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Annotationvue_type_script_lang_ts_ = (Annotationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Annotation.vue





/* normalize component */
;
var Annotation_component = normalizeComponent(
  icons_Annotationvue_type_script_lang_ts_,
  Annotationvue_type_template_id_486caaa3_render,
  Annotationvue_type_template_id_486caaa3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Annotation = (Annotation_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Apps.vue?vue&type=template&id=3531df34&
var Appsvue_type_template_id_3531df34_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M5.25 16C6.76878 16 8 17.2312 8 18.75C8 20.2688 6.76878 21.5 5.25 21.5C3.73122 21.5 2.5 20.2688 2.5 18.75C2.5 17.2312 3.73122 16 5.25 16ZM5.25 17.5C4.55964 17.5 4 18.0596 4 18.75C4 19.4404 4.55964 20 5.25 20C5.94036 20 6.5 19.4404 6.5 18.75C6.5 18.0596 5.94036 17.5 5.25 17.5ZM5.25 9.25C6.76878 9.25 8 10.4812 8 12C8 13.5188 6.76878 14.75 5.25 14.75C3.73122 14.75 2.5 13.5188 2.5 12C2.5 10.4812 3.73122 9.25 5.25 9.25ZM5.25 10.75C4.55964 10.75 4 11.3096 4 12C4 12.6904 4.55964 13.25 5.25 13.25C5.94036 13.25 6.5 12.6904 6.5 12C6.5 11.3096 5.94036 10.75 5.25 10.75ZM5.25 2.5C6.76878 2.5 8 3.73122 8 5.25C8 6.76878 6.76878 8 5.25 8C3.73122 8 2.5 6.76878 2.5 5.25C2.5 3.73122 3.73122 2.5 5.25 2.5ZM5.25 4C4.55964 4 4 4.55964 4 5.25C4 5.94036 4.55964 6.5 5.25 6.5C5.94036 6.5 6.5 5.94036 6.5 5.25C6.5 4.55964 5.94036 4 5.25 4Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 16C13.5188 16 14.75 17.2312 14.75 18.75C14.75 20.2688 13.5188 21.5 12 21.5C10.4812 21.5 9.25 20.2688 9.25 18.75C9.25 17.2312 10.4812 16 12 16ZM12 17.5C11.3096 17.5 10.75 18.0596 10.75 18.75C10.75 19.4404 11.3096 20 12 20C12.6904 20 13.25 19.4404 13.25 18.75C13.25 18.0596 12.6904 17.5 12 17.5ZM12 9.25C13.5188 9.25 14.75 10.4812 14.75 12C14.75 13.5188 13.5188 14.75 12 14.75C10.4812 14.75 9.25 13.5188 9.25 12C9.25 10.4812 10.4812 9.25 12 9.25ZM12 10.75C11.3096 10.75 10.75 11.3096 10.75 12C10.75 12.6904 11.3096 13.25 12 13.25C12.6904 13.25 13.25 12.6904 13.25 12C13.25 11.3096 12.6904 10.75 12 10.75ZM12 2.5C13.5188 2.5 14.75 3.73122 14.75 5.25C14.75 6.76878 13.5188 8 12 8C10.4812 8 9.25 6.76878 9.25 5.25C9.25 3.73122 10.4812 2.5 12 2.5ZM12 4C11.3096 4 10.75 4.55964 10.75 5.25C10.75 5.94036 11.3096 6.5 12 6.5C12.6904 6.5 13.25 5.94036 13.25 5.25C13.25 4.55964 12.6904 4 12 4Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.75 16C20.2688 16 21.5 17.2312 21.5 18.75C21.5 20.2688 20.2688 21.5 18.75 21.5C17.2312 21.5 16 20.2688 16 18.75C16 17.2312 17.2312 16 18.75 16ZM18.75 17.5C18.0596 17.5 17.5 18.0596 17.5 18.75C17.5 19.4404 18.0596 20 18.75 20C19.4404 20 20 19.4404 20 18.75C20 18.0596 19.4404 17.5 18.75 17.5ZM18.75 9.25C20.2688 9.25 21.5 10.4812 21.5 12C21.5 13.5188 20.2688 14.75 18.75 14.75C17.2312 14.75 16 13.5188 16 12C16 10.4812 17.2312 9.25 18.75 9.25ZM18.75 10.75C18.0596 10.75 17.5 11.3096 17.5 12C17.5 12.6904 18.0596 13.25 18.75 13.25C19.4404 13.25 20 12.6904 20 12C20 11.3096 19.4404 10.75 18.75 10.75ZM18.75 2.5C20.2688 2.5 21.5 3.73122 21.5 5.25C21.5 6.76878 20.2688 8 18.75 8C17.2312 8 16 6.76878 16 5.25C16 3.73122 17.2312 2.5 18.75 2.5ZM18.75 4C18.0596 4 17.5 4.55964 17.5 5.25C17.5 5.94036 18.0596 6.5 18.75 6.5C19.4404 6.5 20 5.94036 20 5.25C20 4.55964 19.4404 4 18.75 4Z"
    }
  })]);
};
var Appsvue_type_template_id_3531df34_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Apps.vue?vue&type=script&lang=ts&

/* harmony default export */ var Appsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Apps.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Appsvue_type_script_lang_ts_ = (Appsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Apps.vue





/* normalize component */
;
var Apps_component = normalizeComponent(
  icons_Appsvue_type_script_lang_ts_,
  Appsvue_type_template_id_3531df34_render,
  Appsvue_type_template_id_3531df34_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Apps = (Apps_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowBack.vue?vue&type=template&id=8b1f7664&
var ArrowBackvue_type_template_id_8b1f7664_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.47 4.47a.75.75 0 011.06 1.06l-5.72 5.72H20c.38 0 .7.28.74.65l.01.1c0 .41-.34.75-.75.75H5.81l5.72 5.72c.27.27.3.68.07.98l-.07.08c-.3.3-.77.3-1.06 0l-7-7a.75.75 0 010-1.06z"
    }
  });
};
var ArrowBackvue_type_template_id_8b1f7664_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowBack.vue?vue&type=script&lang=ts&

/* harmony default export */ var ArrowBackvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowBack.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ArrowBackvue_type_script_lang_ts_ = (ArrowBackvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowBack.vue





/* normalize component */
;
var ArrowBack_component = normalizeComponent(
  icons_ArrowBackvue_type_script_lang_ts_,
  ArrowBackvue_type_template_id_8b1f7664_render,
  ArrowBackvue_type_template_id_8b1f7664_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ArrowBack = (ArrowBack_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowDown.vue?vue&type=template&id=19d26c99&
var ArrowDownvue_type_template_id_19d26c99_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4.47 13.53a.75.75 0 011.06-1.06l5.72 5.72V4c0-.38.28-.7.65-.74l.1-.01c.41 0 .75.34.75.75v14.19l5.72-5.72a.75.75 0 01.98-.07l.08.07c.3.3.3.77 0 1.06l-7 7c-.3.3-.77.3-1.06 0z"
    }
  });
};
var ArrowDownvue_type_template_id_19d26c99_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowDown.vue?vue&type=script&lang=ts&

/* harmony default export */ var ArrowDownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowDown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ArrowDownvue_type_script_lang_ts_ = (ArrowDownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowDown.vue





/* normalize component */
;
var ArrowDown_component = normalizeComponent(
  icons_ArrowDownvue_type_script_lang_ts_,
  ArrowDownvue_type_template_id_19d26c99_render,
  ArrowDownvue_type_template_id_19d26c99_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ArrowDown = (ArrowDown_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowForward.vue?vue&type=template&id=91eb5d98&
var ArrowForwardvue_type_template_id_91eb5d98_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M13.53 4.47l7 7c.3.3.3.77 0 1.06l-7 7a.75.75 0 01-1.06-1.06l5.72-5.72H4a.75.75 0 110-1.5h14.19l-5.72-5.72a.75.75 0 011.06-1.06z"
    }
  });
};
var ArrowForwardvue_type_template_id_91eb5d98_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowForward.vue?vue&type=script&lang=ts&

/* harmony default export */ var ArrowForwardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowForward.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ArrowForwardvue_type_script_lang_ts_ = (ArrowForwardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowForward.vue





/* normalize component */
;
var ArrowForward_component = normalizeComponent(
  icons_ArrowForwardvue_type_script_lang_ts_,
  ArrowForwardvue_type_template_id_91eb5d98_render,
  ArrowForwardvue_type_template_id_91eb5d98_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ArrowForward = (ArrowForward_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowUp.vue?vue&type=template&id=387297b0&
var ArrowUpvue_type_template_id_387297b0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19.53 10.47a.75.75 0 01-1.06 1.06l-5.72-5.72V20c0 .38-.28.7-.65.74l-.1.01a.75.75 0 01-.75-.75V5.81l-5.72 5.72a.75.75 0 01-.98.07l-.08-.07a.75.75 0 010-1.06l7-7c.3-.3.77-.3 1.06 0z"
    }
  });
};
var ArrowUpvue_type_template_id_387297b0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ArrowUp.vue?vue&type=script&lang=ts&

/* harmony default export */ var ArrowUpvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowUp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ArrowUpvue_type_script_lang_ts_ = (ArrowUpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ArrowUp.vue





/* normalize component */
;
var ArrowUp_component = normalizeComponent(
  icons_ArrowUpvue_type_script_lang_ts_,
  ArrowUpvue_type_template_id_387297b0_render,
  ArrowUpvue_type_template_id_387297b0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ArrowUp = (ArrowUp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Assessment.vue?vue&type=template&id=3dc266e8&
var Assessmentvue_type_template_id_3dc266e8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20 1.25A2.75 2.75 0 0122.75 4v16A2.75 2.75 0 0120 22.75H4A2.75 2.75 0 011.25 20V4A2.75 2.75 0 014 1.25h16zm0 1.5H4c-.69 0-1.25.56-1.25 1.25v16c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25V4c0-.69-.56-1.25-1.25-1.25zm-3.5 5.5c.41 0 .75.34.75.75v8a.75.75 0 11-1.5 0V9c0-.41.34-.75.75-.75zm-9 3c.41 0 .75.34.75.75v5a.75.75 0 11-1.5 0v-5c0-.41.34-.75.75-.75zm4.5-5c.41 0 .75.34.75.75v10a.75.75 0 11-1.5 0V7c0-.41.34-.75.75-.75z"
    }
  });
};
var Assessmentvue_type_template_id_3dc266e8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Assessment.vue?vue&type=script&lang=ts&

/* harmony default export */ var Assessmentvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Assessment.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Assessmentvue_type_script_lang_ts_ = (Assessmentvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Assessment.vue





/* normalize component */
;
var Assessment_component = normalizeComponent(
  icons_Assessmentvue_type_script_lang_ts_,
  Assessmentvue_type_template_id_3dc266e8_render,
  Assessmentvue_type_template_id_3dc266e8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Assessment = (Assessment_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/BarChart.vue?vue&type=template&id=7181fd93&
var BarChartvue_type_template_id_7181fd93_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M5 9.2H8V19H5V9.2ZM10.6 5H13.4V19H10.6V5ZM16.2 13H19V19H16.2V13Z"
    }
  });
};
var BarChartvue_type_template_id_7181fd93_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/BarChart.vue?vue&type=script&lang=ts&

/* harmony default export */ var BarChartvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/BarChart.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_BarChartvue_type_script_lang_ts_ = (BarChartvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/BarChart.vue





/* normalize component */
;
var BarChart_component = normalizeComponent(
  icons_BarChartvue_type_script_lang_ts_,
  BarChartvue_type_template_id_7181fd93_render,
  BarChartvue_type_template_id_7181fd93_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BarChart = (BarChart_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/BulletList.vue?vue&type=template&id=6cded62c&
var BulletListvue_type_template_id_6cded62c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4 10.5C3.17 10.5 2.5 11.17 2.5 12C2.5 12.83 3.17 13.5 4 13.5C4.83 13.5 5.5 12.83 5.5 12C5.5 11.17 4.83 10.5 4 10.5ZM4 4.5C3.17 4.5 2.5 5.17 2.5 6C2.5 6.83 3.17 7.5 4 7.5C4.83 7.5 5.5 6.83 5.5 6C5.5 5.17 4.83 4.5 4 4.5ZM4 16.5C3.17 16.5 2.5 17.18 2.5 18C2.5 18.82 3.18 19.5 4 19.5C4.82 19.5 5.5 18.82 5.5 18C5.5 17.18 4.83 16.5 4 16.5ZM7 19H21V17H7V19ZM7 13H21V11H7V13ZM7 5V7H21V5H7Z"
    }
  });
};
var BulletListvue_type_template_id_6cded62c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/BulletList.vue?vue&type=script&lang=ts&

/* harmony default export */ var BulletListvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/BulletList.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_BulletListvue_type_script_lang_ts_ = (BulletListvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/BulletList.vue





/* normalize component */
;
var BulletList_component = normalizeComponent(
  icons_BulletListvue_type_script_lang_ts_,
  BulletListvue_type_template_id_6cded62c_render,
  BulletListvue_type_template_id_6cded62c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var BulletList = (BulletList_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Bold.vue?vue&type=template&id=c3a9b16e&
var Boldvue_type_template_id_c3a9b16e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M6.25,3.5 C6.25,3.08578644 6.58578644,2.75 7,2.75 L14,2.75 C16.6233526,2.75 18.75,4.87664744 18.75,7.5 C18.75,9.05577146 18.0020479,10.4368493 16.846113,11.3032644 C18.5677681,12.1634623 19.75,13.9436686 19.75,16 C19.75,18.8994949 17.3994949,21.25 14.5,21.25 L7,21.25 C6.58578644,21.25 6.25,20.9142136 6.25,20.5 L6.25,3.5 Z M14.5,12.25 L7.75,12.25 L7.75,19.75 L14.5,19.75 C16.5710678,19.75 18.25,18.0710678 18.25,16 C18.25,13.9289322 16.5710678,12.25 14.5,12.25 Z M14,4.25 L7.75,4.25 L7.75,10.75 L14,10.75 C15.7949254,10.75 17.25,9.29492544 17.25,7.5 C17.25,5.70507456 15.7949254,4.25 14,4.25 Z"
    }
  });
};
var Boldvue_type_template_id_c3a9b16e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Bold.vue?vue&type=script&lang=ts&

/* harmony default export */ var Boldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Bold.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Boldvue_type_script_lang_ts_ = (Boldvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Bold.vue





/* normalize component */
;
var Bold_component = normalizeComponent(
  icons_Boldvue_type_script_lang_ts_,
  Boldvue_type_template_id_c3a9b16e_render,
  Boldvue_type_template_id_c3a9b16e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Bold = (Bold_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Calendar.vue?vue&type=template&id=12c57a80&
var Calendarvue_type_template_id_12c57a80_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.75 0.75C16.75 0.335786 16.4142 0 16 0L15.8982 0.00684662C15.5322 0.056509 15.25 0.370304 15.25 0.75V2H6.75V0.75C6.75 0.335786 6.41421 0 6 0L5.89823 0.00684662C5.53215 0.056509 5.25 0.370304 5.25 0.75V2H3C1.48122 2 0.25 3.23122 0.25 4.75V19.75C0.25 21.2688 1.48122 22.5 3 22.5H19C20.5188 22.5 21.75 21.2688 21.75 19.75V4.75C21.75 3.23122 20.5188 2 19 2H16.75V0.75ZM6.75 3.5H15.25V4.75C15.25 5.16421 15.5858 5.5 16 5.5L16.1018 5.49315C16.4678 5.44349 16.75 5.1297 16.75 4.75V3.5H19C19.6904 3.5 20.25 4.05964 20.25 4.75V19.75C20.25 20.4404 19.6904 21 19 21H3C2.30964 21 1.75 20.4404 1.75 19.75V4.75C1.75 4.05964 2.30964 3.5 3 3.5H5.25V4.75C5.25 5.16421 5.58579 5.5 6 5.5L6.10177 5.49315C6.46785 5.44349 6.75 5.1297 6.75 4.75V3.5ZM13.772 14.04C13.772 15.54 12.512 16.656 10.82 16.656C9.644 16.656 8.696 16.176 8.084 15.264L9.152 14.196C9.764 14.904 10.1 15.132 10.844 15.132C11.516 15.132 12.032 14.868 12.032 14.16C12.032 13.62 11.648 13.092 10.46 13.092C10.196 13.092 9.836 13.116 9.644 13.14V11.82C10.064 11.856 10.1 11.856 10.376 11.856C11.192 11.856 11.732 11.412 11.732 10.716C11.732 10.188 11.276 9.82802 10.616 9.82802C10.052 9.82802 9.488 10.164 9.032 10.764L8 9.70802C8.852 8.71202 9.632 8.30402 10.76 8.30402C12.284 8.30402 13.34 9.18002 13.34 10.428C13.34 11.256 13.004 11.88 12.392 12.252C13.256 12.612 13.772 13.248 13.772 14.04Z"
    }
  });
};
var Calendarvue_type_template_id_12c57a80_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Calendar.vue?vue&type=script&lang=ts&

/* harmony default export */ var Calendarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Calendar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Calendarvue_type_script_lang_ts_ = (Calendarvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Calendar.vue





/* normalize component */
;
var Calendar_component = normalizeComponent(
  icons_Calendarvue_type_script_lang_ts_,
  Calendarvue_type_template_id_12c57a80_render,
  Calendarvue_type_template_id_12c57a80_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Calendar = (Calendar_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CalendarCheck.vue?vue&type=template&id=5e9a3dfc&
var CalendarCheckvue_type_template_id_5e9a3dfc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M17 0C17.4142 0 17.75 0.335786 17.75 0.75V2H20C21.5188 2 22.75 3.23122 22.75 4.75V19.75C22.75 21.2688 21.5188 22.5 20 22.5H4C2.48122 22.5 1.25 21.2688 1.25 19.75V4.75C1.25 3.23122 2.48122 2 4 2H6.25V0.75C6.25 0.370304 6.53215 0.056509 6.89823 0.00684662L7 0C7.41421 0 7.75 0.335786 7.75 0.75V2H16.25V0.75C16.25 0.370304 16.5322 0.056509 16.8982 0.00684662L17 0ZM16.25 3.5H7.75V4.75C7.75 5.1297 7.46785 5.44349 7.10177 5.49315L7 5.5C6.58579 5.5 6.25 5.16421 6.25 4.75V3.5H4C3.30964 3.5 2.75 4.05964 2.75 4.75V19.75C2.75 20.4404 3.30964 21 4 21H20C20.6904 21 21.25 20.4404 21.25 19.75V4.75C21.25 4.05964 20.6904 3.5 20 3.5H17.75V4.75C17.75 5.1297 17.4678 5.44349 17.1018 5.49315L17 5.5C16.5858 5.5 16.25 5.16421 16.25 4.75V3.5ZM16.444 7.49669C16.7219 7.1896 17.1962 7.16599 17.5033 7.44396C17.8104 7.72193 17.834 8.19622 17.556 8.50331L10.6854 16.0938L10.5975 16.1817C10.0857 16.6449 9.29517 16.6056 8.83189 16.0938L6.44396 13.4557C6.16599 13.1486 6.1896 12.6743 6.49669 12.3963C6.80378 12.1184 7.27807 12.142 7.55604 12.4491L9.75862 14.8824L16.444 7.49669Z"
    }
  });
};
var CalendarCheckvue_type_template_id_5e9a3dfc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CalendarCheck.vue?vue&type=script&lang=ts&

/* harmony default export */ var CalendarCheckvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/CalendarCheck.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CalendarCheckvue_type_script_lang_ts_ = (CalendarCheckvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/CalendarCheck.vue





/* normalize component */
;
var CalendarCheck_component = normalizeComponent(
  icons_CalendarCheckvue_type_script_lang_ts_,
  CalendarCheckvue_type_template_id_5e9a3dfc_render,
  CalendarCheckvue_type_template_id_5e9a3dfc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarCheck = (CalendarCheck_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Camera.vue?vue&type=template&id=7353fdb4&
var Cameravue_type_template_id_7353fdb4_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M14.4386 2.75C15.0488 2.75 15.6149 3.06779 15.9326 3.58867L17.1779 5.63019C17.2233 5.7046 17.3042 5.75 17.3914 5.75H20C21.5142 5.75 22.75 6.98579 22.75 8.5V18.5C22.75 20.0142 21.5142 21.25 20 21.25H4C2.48579 21.25 1.25 20.0142 1.25 18.5V8.5C1.25 6.98579 2.48579 5.75 4 5.75H6.60863C6.6958 5.75 6.77667 5.7046 6.82206 5.63019L8.06739 3.58867L8.15188 3.46275C8.47978 3.01703 9.00207 2.75 9.56137 2.75H14.4386ZM14.4386 4.25H9.56137C9.4742 4.25 9.39333 4.2954 9.34794 4.36981L8.10261 6.41133C7.78488 6.93221 7.21878 7.25 6.60863 7.25H4C3.31421 7.25 2.75 7.81421 2.75 8.5V18.5C2.75 19.1858 3.31421 19.75 4 19.75H20C20.6858 19.75 21.25 19.1858 21.25 18.5V8.5C21.25 7.81421 20.6858 7.25 20 7.25H17.3914C16.7812 7.25 16.2151 6.93221 15.8974 6.41133L14.6521 4.36981C14.6067 4.2954 14.5258 4.25 14.4386 4.25ZM12 9C14.2087 9 16 10.7913 16 13C16 15.2087 14.2087 17 12 17C9.79127 17 8 15.2087 8 13C8 10.7913 9.79127 9 12 9ZM12 10.5C10.6197 10.5 9.5 11.6197 9.5 13C9.5 14.3803 10.6197 15.5 12 15.5C13.3803 15.5 14.5 14.3803 14.5 13C14.5 11.6197 13.3803 10.5 12 10.5Z"
    }
  });
};
var Cameravue_type_template_id_7353fdb4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Camera.vue?vue&type=script&lang=ts&

/* harmony default export */ var Cameravue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Camera.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Cameravue_type_script_lang_ts_ = (Cameravue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Camera.vue





/* normalize component */
;
var Camera_component = normalizeComponent(
  icons_Cameravue_type_script_lang_ts_,
  Cameravue_type_template_id_7353fdb4_render,
  Cameravue_type_template_id_7353fdb4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Camera = (Camera_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Card.vue?vue&type=template&id=47aa0912&
var Cardvue_type_template_id_47aa0912_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21 2.75C22.5188 2.75 23.75 3.98122 23.75 5.5V18.5C23.75 20.0188 22.5188 21.25 21 21.25H3C1.48122 21.25 0.25 20.0188 0.25 18.5V5.5C0.25 3.98122 1.48122 2.75 3 2.75H21ZM22.25 11.75H1.75V18.5C1.75 19.1904 2.30964 19.75 3 19.75H21C21.6904 19.75 22.25 19.1904 22.25 18.5V11.75ZM11 15.75C11.4142 15.75 11.75 16.0858 11.75 16.5C11.75 16.9142 11.4142 17.25 11 17.25H6C5.58579 17.25 5.25 16.9142 5.25 16.5C5.25 16.0858 5.58579 15.75 6 15.75H11ZM22.25 8.25H1.75V10.25H22.25V8.25ZM21 4.25H3C2.30964 4.25 1.75 4.80964 1.75 5.5V6.75H22.25V5.5C22.25 4.80964 21.6904 4.25 21 4.25Z"
    }
  });
};
var Cardvue_type_template_id_47aa0912_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Card.vue?vue&type=script&lang=ts&

/* harmony default export */ var Cardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Card.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Cardvue_type_script_lang_ts_ = (Cardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Card.vue





/* normalize component */
;
var Card_component = normalizeComponent(
  icons_Cardvue_type_script_lang_ts_,
  Cardvue_type_template_id_47aa0912_render,
  Cardvue_type_template_id_47aa0912_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Card = (Card_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Cart.vue?vue&type=template&id=51b82912&
var Cartvue_type_template_id_51b82912_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M7.25 17.75c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25S5 21.243 5 20s1.007-2.25 2.25-2.25zm11 0c1.243 0 2.25 1.007 2.25 2.25s-1.007 2.25-2.25 2.25S16 21.243 16 20s1.007-2.25 2.25-2.25zm-11 1.5c-.414 0-.75.336-.75.75s.336.75.75.75S8 20.414 8 20s-.336-.75-.75-.75zm11 0c-.414 0-.75.336-.75.75s.336.75.75.75.75-.336.75-.75-.336-.75-.75-.75zM3.291.48l.024.027.035.043.024.033.035.058.015.03c.011.023.021.046.03.07l.005.014.004.012c.007.022.014.045.019.069l.003.017.406 2.032h17.224c1.242 0 2.25 1.008 2.25 2.25l-.008.186-.023.184-.67 4.019c-.36 2.161-2.148 3.786-4.315 3.954l-.217.012-12.043.387.075.368c.108.543.558.944 1.1.999l.126.006h12.86c.414 0 .75.336.75.75 0 .38-.282.694-.648.743l-.102.007H7.39c-1.254 0-2.341-.846-2.659-2.045l-.038-.165L2.135 1.75H.75C.336 1.75 0 1.414 0 1 0 .62.282.307.648.257L.75.25h2.032l.054.005L2.75.25c.052 0 .104.005.153.016l.033.007c.03.008.06.017.087.028l.008.004c.02.007.037.015.055.024.053.027.103.06.148.099.016.013.032.027.046.042l.011.01zm17.824 3.905H4.19l1.6 8.002.018-.001 12.274-.395c1.487-.048 2.743-1.096 3.066-2.532l.036-.182.67-4.018c.006-.041.01-.082.01-.124 0-.38-.282-.693-.649-.743l-.101-.007z"
    }
  });
};
var Cartvue_type_template_id_51b82912_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Cart.vue?vue&type=script&lang=ts&

/* harmony default export */ var Cartvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Cart.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Cartvue_type_script_lang_ts_ = (Cartvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Cart.vue





/* normalize component */
;
var Cart_component = normalizeComponent(
  icons_Cartvue_type_script_lang_ts_,
  Cartvue_type_template_id_51b82912_render,
  Cartvue_type_template_id_51b82912_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Cart = (Cart_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Chat.vue?vue&type=template&id=3e247174&
var Chatvue_type_template_id_3e247174_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2Z"
    }
  });
};
var Chatvue_type_template_id_3e247174_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Chat.vue?vue&type=script&lang=ts&

/* harmony default export */ var Chatvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Chat.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Chatvue_type_script_lang_ts_ = (Chatvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Chat.vue





/* normalize component */
;
var Chat_component = normalizeComponent(
  icons_Chatvue_type_script_lang_ts_,
  Chatvue_type_template_id_3e247174_render,
  Chatvue_type_template_id_3e247174_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Chat = (Chat_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChatAlert.vue?vue&type=template&id=4c2ab140&
var ChatAlertvue_type_template_id_4c2ab140_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19.9998 1.75C21.514 1.75 22.7498 2.98579 22.7498 4.5V16.5C22.7498 18.0142 21.514 19.25 19.9998 19.25H7.26291L4.09419 21.785C3.33948 22.3887 2.23822 22.2664 1.63446 21.5117C1.38601 21.2011 1.25076 20.8152 1.25098 20.4175L1.25982 4.5C1.25982 2.98503 2.48634 1.75 3.99982 1.75H19.9998ZM19.9998 3.25H3.99982C3.35977 3.25 2.82997 3.74319 2.76625 4.37244L2.75982 4.50042L2.75098 20.4183C2.75098 20.4751 2.77027 20.5303 2.80576 20.5746C2.89201 20.6824 3.04934 20.6999 3.15715 20.6137L6.73673 17.75H19.9998C20.6856 17.75 21.2498 17.1858 21.2498 16.5V4.5C21.2498 3.81421 20.6856 3.25 19.9998 3.25ZM11.9998 12.5C12.5521 12.5 12.9998 12.9477 12.9998 13.5C12.9998 14.0523 12.5521 14.5 11.9998 14.5C11.4475 14.5 10.9998 14.0523 10.9998 13.5C10.9998 12.9477 11.4475 12.5 11.9998 12.5ZM12.0004 5.75C12.4146 5.75 12.7504 6.08579 12.7504 6.5V10.5C12.7504 10.9142 12.4146 11.25 12.0004 11.25C11.5862 11.25 11.2504 10.9142 11.2504 10.5V6.5C11.2504 6.08579 11.5862 5.75 12.0004 5.75Z"
    }
  });
};
var ChatAlertvue_type_template_id_4c2ab140_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChatAlert.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChatAlertvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChatAlert.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChatAlertvue_type_script_lang_ts_ = (ChatAlertvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChatAlert.vue





/* normalize component */
;
var ChatAlert_component = normalizeComponent(
  icons_ChatAlertvue_type_script_lang_ts_,
  ChatAlertvue_type_template_id_4c2ab140_render,
  ChatAlertvue_type_template_id_4c2ab140_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChatAlert = (ChatAlert_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChatOutline.vue?vue&type=template&id=c3432990&
var ChatOutlinevue_type_template_id_c3432990_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20 2H4C2.9 2 2 2.9 2 4V22L6 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H6L4 18V4H20V16Z"
    }
  });
};
var ChatOutlinevue_type_template_id_c3432990_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChatOutline.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChatOutlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChatOutline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChatOutlinevue_type_script_lang_ts_ = (ChatOutlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChatOutline.vue





/* normalize component */
;
var ChatOutline_component = normalizeComponent(
  icons_ChatOutlinevue_type_script_lang_ts_,
  ChatOutlinevue_type_template_id_c3432990_render,
  ChatOutlinevue_type_template_id_c3432990_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChatOutline = (ChatOutline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Check.vue?vue&type=template&id=5737cb64&
var Checkvue_type_template_id_5737cb64_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M8.97 17.9l-4.42-4.74a.75.75 0 10-1.1 1.02l4.6 4.94c.47.5 1.26.53 1.77.06l.06-.06 12.67-13.6a.75.75 0 00-1.1-1.03L8.97 17.89z"
    }
  });
};
var Checkvue_type_template_id_5737cb64_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Check.vue?vue&type=script&lang=ts&

/* harmony default export */ var Checkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Check.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Checkvue_type_script_lang_ts_ = (Checkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Check.vue





/* normalize component */
;
var Check_component = normalizeComponent(
  icons_Checkvue_type_script_lang_ts_,
  Checkvue_type_template_id_5737cb64_render,
  Checkvue_type_template_id_5737cb64_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Check = (Check_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CheckCircle.vue?vue&type=template&id=6064571e&
var CheckCirclevue_type_template_id_6064571e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25a10.75 10.75 0 110 21.5 10.75 10.75 0 010-21.5zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm4.44 4.75a.75.75 0 011.12 1l-6.87 7.6-.1.08c-.5.46-1.3.43-1.76-.09l-2.39-2.63a.75.75 0 111.12-1.01l2.2 2.43z"
    }
  });
};
var CheckCirclevue_type_template_id_6064571e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CheckCircle.vue?vue&type=script&lang=ts&

/* harmony default export */ var CheckCirclevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/CheckCircle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CheckCirclevue_type_script_lang_ts_ = (CheckCirclevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/CheckCircle.vue





/* normalize component */
;
var CheckCircle_component = normalizeComponent(
  icons_CheckCirclevue_type_script_lang_ts_,
  CheckCirclevue_type_template_id_6064571e_render,
  CheckCirclevue_type_template_id_6064571e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CheckCircle = (CheckCircle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Chevron.vue?vue&type=template&id=1efc386b&
var Chevronvue_type_template_id_1efc386b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9.47 6.53a.75.75 0 011.06-1.06l6 6c.3.3.3.77 0 1.06l-6 6a.75.75 0 01-1.06-1.06L14.94 12 9.47 6.53z"
    }
  });
};
var Chevronvue_type_template_id_1efc386b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Chevron.vue?vue&type=script&lang=ts&

/* harmony default export */ var Chevronvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Chevron.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Chevronvue_type_script_lang_ts_ = (Chevronvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Chevron.vue





/* normalize component */
;
var Chevron_component = normalizeComponent(
  icons_Chevronvue_type_script_lang_ts_,
  Chevronvue_type_template_id_1efc386b_render,
  Chevronvue_type_template_id_1efc386b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Chevron = (Chevron_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronDown.vue?vue&type=template&id=9d08cb2c&
var ChevronDownvue_type_template_id_9d08cb2c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M17.47 9.47a.75.75 0 011.06 1.06l-6 6c-.3.3-.77.3-1.06 0l-6-6a.75.75 0 011.06-1.06L12 14.94l5.47-5.47z"
    }
  });
};
var ChevronDownvue_type_template_id_9d08cb2c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronDown.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChevronDownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronDown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChevronDownvue_type_script_lang_ts_ = (ChevronDownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronDown.vue





/* normalize component */
;
var ChevronDown_component = normalizeComponent(
  icons_ChevronDownvue_type_script_lang_ts_,
  ChevronDownvue_type_template_id_9d08cb2c_render,
  ChevronDownvue_type_template_id_9d08cb2c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChevronDown = (ChevronDown_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronLeft.vue?vue&type=template&id=722f3ddc&
var ChevronLeftvue_type_template_id_722f3ddc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9.06 12l5.47-5.47a.75.75 0 00-1.06-1.06l-6 6c-.3.3-.3.77 0 1.06l6 6a.75.75 0 001.06-1.06L9.06 12z"
    }
  });
};
var ChevronLeftvue_type_template_id_722f3ddc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronLeft.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChevronLeftvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronLeft.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChevronLeftvue_type_script_lang_ts_ = (ChevronLeftvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronLeft.vue





/* normalize component */
;
var ChevronLeft_component = normalizeComponent(
  icons_ChevronLeftvue_type_script_lang_ts_,
  ChevronLeftvue_type_template_id_722f3ddc_render,
  ChevronLeftvue_type_template_id_722f3ddc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChevronLeft = (ChevronLeft_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronRight.vue?vue&type=template&id=fb1b53d2&
var ChevronRightvue_type_template_id_fb1b53d2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9.47 6.53a.75.75 0 011.06-1.06l6 6c.3.3.3.77 0 1.06l-6 6a.75.75 0 01-1.06-1.06L14.94 12 9.47 6.53z"
    }
  });
};
var ChevronRightvue_type_template_id_fb1b53d2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronRight.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChevronRightvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronRight.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChevronRightvue_type_script_lang_ts_ = (ChevronRightvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronRight.vue





/* normalize component */
;
var ChevronRight_component = normalizeComponent(
  icons_ChevronRightvue_type_script_lang_ts_,
  ChevronRightvue_type_template_id_fb1b53d2_render,
  ChevronRightvue_type_template_id_fb1b53d2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChevronRight = (ChevronRight_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronUp.vue?vue&type=template&id=9ebb9fc6&
var ChevronUpvue_type_template_id_9ebb9fc6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M6.53 14.53a.75.75 0 01-1.06-1.06l6-6c.3-.3.77-.3 1.06 0l6 6a.75.75 0 01-1.06 1.06L12 9.06l-5.47 5.47z"
    }
  });
};
var ChevronUpvue_type_template_id_9ebb9fc6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ChevronUp.vue?vue&type=script&lang=ts&

/* harmony default export */ var ChevronUpvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronUp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ChevronUpvue_type_script_lang_ts_ = (ChevronUpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ChevronUp.vue





/* normalize component */
;
var ChevronUp_component = normalizeComponent(
  icons_ChevronUpvue_type_script_lang_ts_,
  ChevronUpvue_type_template_id_9ebb9fc6_render,
  ChevronUpvue_type_template_id_9ebb9fc6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ChevronUp = (ChevronUp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Classroom.vue?vue&type=template&id=1ef8dd40&
var Classroomvue_type_template_id_1ef8dd40_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z"
    }
  });
};
var Classroomvue_type_template_id_1ef8dd40_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Classroom.vue?vue&type=script&lang=ts&

/* harmony default export */ var Classroomvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Classroom.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Classroomvue_type_script_lang_ts_ = (Classroomvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Classroom.vue





/* normalize component */
;
var Classroom_component = normalizeComponent(
  icons_Classroomvue_type_script_lang_ts_,
  Classroomvue_type_template_id_1ef8dd40_render,
  Classroomvue_type_template_id_1ef8dd40_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Classroom = (Classroom_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Close.vue?vue&type=template&id=397e0f23&
var Closevue_type_template_id_397e0f23_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M6.53 5.47L12 10.94l5.47-5.47a.75.75 0 01.98-.07l.08.07c.3.3.3.77 0 1.06L13.06 12l5.47 5.47a.75.75 0 01-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 011.06-1.06z"
    }
  });
};
var Closevue_type_template_id_397e0f23_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Close.vue?vue&type=script&lang=ts&

/* harmony default export */ var Closevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Close.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Closevue_type_script_lang_ts_ = (Closevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Close.vue





/* normalize component */
;
var Close_component = normalizeComponent(
  icons_Closevue_type_script_lang_ts_,
  Closevue_type_template_id_397e0f23_render,
  Closevue_type_template_id_397e0f23_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Close = (Close_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Copy.vue?vue&type=template&id=325c0dec&
var Copyvue_type_template_id_325c0dec_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M22.5996 3.75C22.5996 2.23122 21.3684 1 19.8496 1H7.84961C6.33083 1 5.09961 2.23122 5.09961 3.75V16.75C5.09961 18.2688 6.33083 19.5 7.84961 19.5H19.8496C21.3684 19.5 22.5996 18.2688 22.5996 16.75V3.75ZM2.84961 6.5C2.84961 6.08579 2.51382 5.75 2.09961 5.75C1.6854 5.75 1.34961 6.08579 1.34961 6.5V20C1.34961 21.7949 2.80468 23.25 4.59961 23.25H17.0996C17.5138 23.25 17.8496 22.9142 17.8496 22.5C17.8496 22.0858 17.5138 21.75 17.0996 21.75H4.59961C3.63311 21.75 2.84961 20.9665 2.84961 20V6.5ZM7.84961 2.5L12.1052 2.49985L13.5639 2.5H17.1353H18.5956H19.8496C20.54 2.5 21.0996 3.05965 21.0996 3.75V16.75C21.0996 17.4404 20.54 18 19.8496 18H7.84961C7.15925 18 6.59961 17.4404 6.59961 16.75V3.75C6.59961 3.05965 7.15925 2.5 7.84961 2.5ZM13.7495 6.5C14.1637 6.5 14.4995 6.83579 14.4995 7.25V9.5H16.7495C17.1292 9.5 17.443 9.78215 17.4927 10.1482L17.4995 10.25C17.4995 10.6642 17.1637 11 16.7495 11H14.4995V13.25C14.4995 13.6297 14.2174 13.9435 13.8513 13.9932L13.7495 14C13.3353 14 12.9995 13.6642 12.9995 13.25V11H10.7495C10.3698 11 10.056 10.7178 10.0064 10.3518L9.99951 10.25C9.99951 9.83579 10.3353 9.5 10.7495 9.5H12.9995V7.25C12.9995 6.8703 13.2817 6.55651 13.6477 6.50685L13.7495 6.5Z"
    }
  });
};
var Copyvue_type_template_id_325c0dec_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Copy.vue?vue&type=script&lang=ts&

/* harmony default export */ var Copyvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Copy.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Copyvue_type_script_lang_ts_ = (Copyvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Copy.vue





/* normalize component */
;
var Copy_component = normalizeComponent(
  icons_Copyvue_type_script_lang_ts_,
  Copyvue_type_template_id_325c0dec_render,
  Copyvue_type_template_id_325c0dec_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Copy = (Copy_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CloseCircle.vue?vue&type=template&id=549aec25&
var CloseCirclevue_type_template_id_549aec25_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9 .04A8.96 8.96 0 0117.96 9 8.96 8.96 0 019 17.96 8.96 8.96 0 01.04 9 8.96 8.96 0 019 .04zm3.56 5.27a.63.63 0 00-.81.06L9 8.12 6.25 5.37l-.07-.06a.63.63 0 00-.81.06l-.06.07a.63.63 0 00.06.81L8.12 9l-2.75 2.75-.06.07a.63.63 0 00.06.81l.07.06a.63.63 0 00.81-.06L9 9.88l2.75 2.75.07.06a.63.63 0 00.81-.06l.06-.07a.63.63 0 00-.06-.81L9.88 9l2.75-2.75.06-.07a.63.63 0 00-.06-.81l-.07-.06z"
    }
  });
};
var CloseCirclevue_type_template_id_549aec25_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CloseCircle.vue?vue&type=script&lang=ts&

/* harmony default export */ var CloseCirclevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/CloseCircle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CloseCirclevue_type_script_lang_ts_ = (CloseCirclevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/CloseCircle.vue





/* normalize component */
;
var CloseCircle_component = normalizeComponent(
  icons_CloseCirclevue_type_script_lang_ts_,
  CloseCirclevue_type_template_id_549aec25_render,
  CloseCirclevue_type_template_id_549aec25_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CloseCircle = (CloseCircle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CodeBar.vue?vue&type=template&id=ba73e4be&
var CodeBarvue_type_template_id_ba73e4be_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21 2.75C22.5188 2.75 23.75 3.98122 23.75 5.5V18.5C23.75 20.0188 22.5188 21.25 21 21.25H3C1.48122 21.25 0.25 20.0188 0.25 18.5V5.5C0.25 3.98122 1.48122 2.75 3 2.75H21ZM21 4.25H3C2.30964 4.25 1.75 4.80964 1.75 5.5V18.5C1.75 19.1904 2.30964 19.75 3 19.75H21C21.6904 19.75 22.25 19.1904 22.25 18.5V5.5C22.25 4.80964 21.6904 4.25 21 4.25ZM5 6.75C5.41421 6.75 5.75 7.08579 5.75 7.5V16.5C5.75 16.9142 5.41421 17.25 5 17.25C4.58579 17.25 4.25 16.9142 4.25 16.5V7.5C4.25 7.08579 4.58579 6.75 5 6.75ZM19 6.75C19.4142 6.75 19.75 7.08579 19.75 7.5V16.5C19.75 16.9142 19.4142 17.25 19 17.25C18.5858 17.25 18.25 16.9142 18.25 16.5V7.5C18.25 7.08579 18.5858 6.75 19 6.75ZM12 6.75C12.4142 6.75 12.75 7.08579 12.75 7.5V15.5C12.75 15.9142 12.4142 16.25 12 16.25C11.5858 16.25 11.25 15.9142 11.25 15.5V7.5C11.25 7.08579 11.5858 6.75 12 6.75ZM8.5 6.75C8.91421 6.75 9.25 7.08579 9.25 7.5V13.5C9.25 13.9142 8.91421 14.25 8.5 14.25C8.08579 14.25 7.75 13.9142 7.75 13.5V7.5C7.75 7.08579 8.08579 6.75 8.5 6.75ZM15.5 6.75C15.9142 6.75 16.25 7.08579 16.25 7.5V12.5C16.25 12.9142 15.9142 13.25 15.5 13.25C15.0858 13.25 14.75 12.9142 14.75 12.5V7.5C14.75 7.08579 15.0858 6.75 15.5 6.75Z"
    }
  });
};
var CodeBarvue_type_template_id_ba73e4be_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CodeBar.vue?vue&type=script&lang=ts&

/* harmony default export */ var CodeBarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/CodeBar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CodeBarvue_type_script_lang_ts_ = (CodeBarvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/CodeBar.vue





/* normalize component */
;
var CodeBar_component = normalizeComponent(
  icons_CodeBarvue_type_script_lang_ts_,
  CodeBarvue_type_template_id_ba73e4be_render,
  CodeBarvue_type_template_id_ba73e4be_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CodeBar = (CodeBar_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CollectionsBookmark.vue?vue&type=template&id=ec7e6b10&
var CollectionsBookmarkvue_type_template_id_ec7e6b10_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M2.1 5.75c.41 0 .75.34.75.75V20c0 .97.78 1.75 1.75 1.75h12.5a.75.75 0 110 1.5H4.6A3.25 3.25 0 011.35 20V6.5c0-.41.34-.75.75-.75zM19.85 1a2.75 2.75 0 012.75 2.75v13a2.75 2.75 0 01-2.75 2.75h-12a2.75 2.75 0 01-2.75-2.75v-13A2.75 2.75 0 017.85 1h12zm-7.74 1.5H7.85c-.69 0-1.25.56-1.25 1.25v13c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-13c0-.69-.56-1.25-1.25-1.25H18.6v6.18a1 1 0 01-1.67.75l-1.58-1.42-1.58 1.42a1 1 0 01-1.67-.74v-6.1-.09zm5.03 0h-3.58c.04 0 .04 0 .04.02v5.05l1.25-1.13a.75.75 0 011 0l1.25 1.13V2.58c0-.06-.01-.08.04-.08z"
    }
  });
};
var CollectionsBookmarkvue_type_template_id_ec7e6b10_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/CollectionsBookmark.vue?vue&type=script&lang=ts&

/* harmony default export */ var CollectionsBookmarkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/CollectionsBookmark.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_CollectionsBookmarkvue_type_script_lang_ts_ = (CollectionsBookmarkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/CollectionsBookmark.vue





/* normalize component */
;
var CollectionsBookmark_component = normalizeComponent(
  icons_CollectionsBookmarkvue_type_script_lang_ts_,
  CollectionsBookmarkvue_type_template_id_ec7e6b10_render,
  CollectionsBookmarkvue_type_template_id_ec7e6b10_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CollectionsBookmark = (CollectionsBookmark_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Comment.vue?vue&type=template&id=3ca69421&
var Commentvue_type_template_id_3ca69421_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4 1.75A2.76 2.76 0 001.25 4.5v12A2.76 2.76 0 004 19.25h12.74l3.17 2.53a1.75 1.75 0 002.84-1.36L22.74 4.5A2.75 2.75 0 0020 1.75H4zm0 1.5h16c.64 0 1.17.5 1.23 1.12l.01.13v15.92a.25.25 0 01-.4.2l-3.58-2.87H4c-.69 0-1.25-.56-1.25-1.25v-12c0-.69.56-1.25 1.25-1.25zm8 8.5a.75.75 0 100 1.5h4a.75.75 0 100-1.5zm-4-4a.75.75 0 100 1.5h8a.75.75 0 000-1.5z"
    }
  });
};
var Commentvue_type_template_id_3ca69421_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Comment.vue?vue&type=script&lang=ts&

/* harmony default export */ var Commentvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Comment.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Commentvue_type_script_lang_ts_ = (Commentvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Comment.vue





/* normalize component */
;
var Comment_component = normalizeComponent(
  icons_Commentvue_type_script_lang_ts_,
  Commentvue_type_template_id_3ca69421_render,
  Commentvue_type_template_id_3ca69421_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Comment = (Comment_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Configuration.vue?vue&type=template&id=19e7849c&
var Configurationvue_type_template_id_19e7849c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M17.94 8.1c.514 0 .961.351 1.076.834l.02.114.195 1.365.134.07.133.074.13.078.134.086 1.285-.515a1.03 1.03 0 01.176-.053l.09-.014.136-.008c.354 0 .69.164.896.445l.072.11 1.354 2.344c.24.439.163.98-.19 1.33l-.094.083-1.084.847.007.13.003.18v.09l-.003.09-.007.13 1.087.85c.357.282.494.743.375 1.174l-.044.128-.06.125-1.34 2.319a1.108 1.108 0 01-1.26.523l-.115-.036-1.287-.516-.146.094-.26.152-.12.06-.194 1.355a1.1 1.1 0 01-.85.934l-.123.02-.127.008h-2.69c-.514 0-.961-.351-1.076-.834l-.02-.114-.197-1.366-.132-.068-.133-.075-.13-.078-.135-.087-1.284.516c-.057.023-.117.04-.176.053l-.09.014-.136.008c-.354 0-.69-.164-.896-.445l-.072-.11-1.354-2.344a1.117 1.117 0 01.19-1.33l.094-.083 1.084-.848-.005-.07-.006-.239.002-.119.005-.12.004-.07-1.087-.85a1.109 1.109 0 01-.373-1.2l.043-.116.058-.112 1.34-2.319a1.109 1.109 0 011.261-.523l.115.036 1.286.515.146-.093.261-.152.12-.062.194-1.353a1.1 1.1 0 01.85-.934l.123-.02.127-.008h2.69zm-.385 1.552h-1.923l-.2 1.398a.776.776 0 01-.275.49l-.094.066-.104.052c-.324.133-.642.32-.965.562a.776.776 0 01-.645.134l-.11-.035-1.313-.529-.964 1.668 1.114.872c.154.12.254.291.287.478l.011.114-.006.115a4.526 4.526 0 00-.04.563l.002.126.008.135.03.302a.776.776 0 01-.206.63l-.086.077-1.114.871.963 1.667 1.314-.527a.776.776 0 01.56-.007l.105.048.097.064c.303.233.62.418.958.556.223.091.388.28.453.508l.02.1.2 1.398h1.923l.201-1.398a.776.776 0 01.276-.49l.094-.066.104-.052c.324-.133.642-.32.965-.562a.776.776 0 01.645-.134l.11.035 1.312.528.964-1.668-1.113-.87a.776.776 0 01-.287-.479l-.011-.114.006-.115c.027-.224.04-.395.04-.563l-.002-.127-.007-.134-.031-.302a.776.776 0 01.206-.63l.085-.077 1.114-.872-.963-1.667-1.313.528a.776.776 0 01-.56.007l-.105-.048-.097-.064a4.134 4.134 0 00-.958-.556.776.776 0 01-.453-.508l-.02-.1-.202-1.398zM6.775 19.5a.75.75 0 01.102 1.493L6.775 21h-4a.75.75 0 01-.101-1.493l.101-.007h4zm9.82-6.59a2.689 2.689 0 110 5.38 2.689 2.689 0 110-5.38zm0 1.552a1.137 1.137 0 10-.002 2.274 1.137 1.137 0 00.001-2.274zm-9.82-.629a.75.75 0 01.102 1.493l-.102.007h-4a.75.75 0 01-.101-1.493l.101-.007h4zm0-5.666a.75.75 0 01.102 1.493l-.102.007h-4a.75.75 0 01-.101-1.493l.101-.007h4zm14.5-5.667a.75.75 0 01.102 1.493L21.275 4h-18.5a.75.75 0 01-.101-1.493l.101-.007h18.5z"
    }
  });
};
var Configurationvue_type_template_id_19e7849c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Configuration.vue?vue&type=script&lang=ts&

/* harmony default export */ var Configurationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Configuration.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Configurationvue_type_script_lang_ts_ = (Configurationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Configuration.vue





/* normalize component */
;
var Configuration_component = normalizeComponent(
  icons_Configurationvue_type_script_lang_ts_,
  Configurationvue_type_template_id_19e7849c_render,
  Configurationvue_type_template_id_19e7849c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Configuration = (Configuration_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DarkMode.vue?vue&type=template&id=4f3e8783&
var DarkModevue_type_template_id_4f3e8783_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M12.1023 12.063C10.0025 8.004 11.6517 4.431 12.5799 3C7.7496 3.171 3.88358 7.122 3.88358 11.991C3.88358 12.117 3.9016 12.243 3.9016 12.369C4.46033 12.126 5.06411 11.991 5.70394 11.991C7.19989 11.991 8.56967 12.738 9.39875 13.926C10.9037 14.358 12.0121 15.744 12.0121 17.391C12.0121 18.759 11.2281 19.938 10.1017 20.55C10.9848 20.838 11.931 21 12.9043 21C16.0584 21 18.834 19.38 20.4471 16.932C18.3204 17.139 14.1569 16.059 12.1023 12.063Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.40703 15.591H8.24482C7.86633 14.547 6.87504 13.791 5.70352 13.791C4.20757 13.791 3 14.997 3 16.491C3 17.985 4.20757 19.191 5.70352 19.191C6.26224 19.191 7.94743 19.191 8.40703 19.191C9.39832 19.191 10.2094 18.381 10.2094 17.391C10.2094 16.401 9.39832 15.591 8.40703 15.591Z"
    }
  })]);
};
var DarkModevue_type_template_id_4f3e8783_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DarkMode.vue?vue&type=script&lang=ts&

/* harmony default export */ var DarkModevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/DarkMode.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_DarkModevue_type_script_lang_ts_ = (DarkModevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/DarkMode.vue





/* normalize component */
;
var DarkMode_component = normalizeComponent(
  icons_DarkModevue_type_script_lang_ts_,
  DarkModevue_type_template_id_4f3e8783_render,
  DarkModevue_type_template_id_4f3e8783_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DarkMode = (DarkMode_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Delete.vue?vue&type=template&id=5904a314&
var Deletevue_type_template_id_5904a314_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M14.5 1.25c.414 0 .75.336.75.75v2.25H21c.38 0 .693.282.743.648L21.75 5c0 .414-.336.75-.75.75h-.75V20c0 1.463-1.142 2.658-2.582 2.745l-.168.005h-11c-1.519 0-2.75-1.231-2.75-2.75V5.75H3c-.38 0-.693-.282-.743-.648L2.25 5c0-.414.336-.75.75-.75h5.75V2c0-.38.282-.693.648-.743L9.5 1.25zm-9.25 4.5V20c0 .69.56 1.25 1.25 1.25h11c.69 0 1.25-.56 1.25-1.25V5.75H5.25zm4.25 3.5c.414 0 .75.336.75.75v7c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-7c0-.414.336-.75.75-.75zm5 0c.414 0 .75.336.75.75v7c0 .414-.336.75-.75.75s-.75-.336-.75-.75v-7c0-.414.336-.75.75-.75zm-.75-6.5h-3.5v1.5h3.5v-1.5z"
    }
  });
};
var Deletevue_type_template_id_5904a314_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Delete.vue?vue&type=script&lang=ts&

/* harmony default export */ var Deletevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Delete.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Deletevue_type_script_lang_ts_ = (Deletevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Delete.vue





/* normalize component */
;
var Delete_component = normalizeComponent(
  icons_Deletevue_type_script_lang_ts_,
  Deletevue_type_template_id_5904a314_render,
  Deletevue_type_template_id_5904a314_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Delete = (Delete_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Drag.vue?vue&type=template&id=5dde2718&
var Dragvue_type_template_id_5dde2718_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M11 18C11 19.1 10.1 20 9 20C7.9 20 7 19.1 7 18C7 16.9 7.9 16 9 16C10.1 16 11 16.9 11 18ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 8C16.1 8 17 7.1 17 6C17 4.9 16.1 4 15 4C13.9 4 13 4.9 13 6C13 7.1 13.9 8 15 8ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16Z"
    }
  });
};
var Dragvue_type_template_id_5dde2718_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Drag.vue?vue&type=script&lang=ts&

/* harmony default export */ var Dragvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Drag.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Dragvue_type_script_lang_ts_ = (Dragvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Drag.vue





/* normalize component */
;
var Drag_component = normalizeComponent(
  icons_Dragvue_type_script_lang_ts_,
  Dragvue_type_template_id_5dde2718_render,
  Dragvue_type_template_id_5dde2718_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Drag = (Drag_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Disciplines.vue?vue&type=template&id=51275540&
var Disciplinesvue_type_template_id_51275540_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M9 13.25C9.9665 13.25 10.75 14.0335 10.75 15V20C10.75 20.9665 9.9665 21.75 9 21.75H4C3.0335 21.75 2.25 20.9665 2.25 20V15C2.25 14.0335 3.0335 13.25 4 13.25H9ZM20 13.25C20.9665 13.25 21.75 14.0335 21.75 15V20C21.75 20.9665 20.9665 21.75 20 21.75H15C14.0335 21.75 13.25 20.9665 13.25 20V15C13.25 14.0335 14.0335 13.25 15 13.25H20ZM9 14.75H4C3.86193 14.75 3.75 14.8619 3.75 15V20C3.75 20.1381 3.86193 20.25 4 20.25H9C9.13807 20.25 9.25 20.1381 9.25 20V15C9.25 14.8619 9.13807 14.75 9 14.75ZM20 14.75H15C14.8619 14.75 14.75 14.8619 14.75 15V20C14.75 20.1381 14.8619 20.25 15 20.25H20C20.1381 20.25 20.25 20.1381 20.25 20V15C20.25 14.8619 20.1381 14.75 20 14.75ZM9 2.25C9.9665 2.25 10.75 3.0335 10.75 4V9C10.75 9.9665 9.9665 10.75 9 10.75H4C3.0335 10.75 2.25 9.9665 2.25 9V4C2.25 3.0335 3.0335 2.25 4 2.25H9ZM20 2.25C20.9665 2.25 21.75 3.0335 21.75 4V9C21.75 9.9665 20.9665 10.75 20 10.75H15C14.0335 10.75 13.25 9.9665 13.25 9V4C13.25 3.0335 14.0335 2.25 15 2.25H20ZM9 3.75H4C3.86193 3.75 3.75 3.86193 3.75 4V9C3.75 9.13807 3.86193 9.25 4 9.25H9C9.13807 9.25 9.25 9.13807 9.25 9V4C9.25 3.86193 9.13807 3.75 9 3.75ZM20 3.75H15C14.8619 3.75 14.75 3.86193 14.75 4V9C14.75 9.13807 14.8619 9.25 15 9.25H20C20.1381 9.25 20.25 9.13807 20.25 9V4C20.25 3.86193 20.1381 3.75 20 3.75Z"
    }
  });
};
var Disciplinesvue_type_template_id_51275540_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Disciplines.vue?vue&type=script&lang=ts&

/* harmony default export */ var Disciplinesvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Disciplines.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Disciplinesvue_type_script_lang_ts_ = (Disciplinesvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Disciplines.vue





/* normalize component */
;
var Disciplines_component = normalizeComponent(
  icons_Disciplinesvue_type_script_lang_ts_,
  Disciplinesvue_type_template_id_51275540_render,
  Disciplinesvue_type_template_id_51275540_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Disciplines = (Disciplines_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DropDown.vue?vue&type=template&id=62fa8c63&
var DropDownvue_type_template_id_62fa8c63_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M8.20723 10C7.76178 10 7.53869 10.5386 7.85368 10.8536L11.6466 14.6464C11.8418 14.8417 12.1584 14.8417 12.3537 14.6464L16.1466 10.8536C16.4615 10.5386 16.2385 10 15.793 10H8.20723Z"
    }
  });
};
var DropDownvue_type_template_id_62fa8c63_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DropDown.vue?vue&type=script&lang=ts&

/* harmony default export */ var DropDownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/DropDown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_DropDownvue_type_script_lang_ts_ = (DropDownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/DropDown.vue





/* normalize component */
;
var DropDown_component = normalizeComponent(
  icons_DropDownvue_type_script_lang_ts_,
  DropDownvue_type_template_id_62fa8c63_render,
  DropDownvue_type_template_id_62fa8c63_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DropDown = (DropDown_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DropUp.vue?vue&type=template&id=22830790&
var DropUpvue_type_template_id_22830790_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M7 10L12 15 17 10z",
      "transform": "rotate(180 12 12)"
    }
  });
};
var DropUpvue_type_template_id_22830790_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/DropUp.vue?vue&type=script&lang=ts&

/* harmony default export */ var DropUpvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/DropUp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_DropUpvue_type_script_lang_ts_ = (DropUpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/DropUp.vue





/* normalize component */
;
var DropUp_component = normalizeComponent(
  icons_DropUpvue_type_script_lang_ts_,
  DropUpvue_type_template_id_22830790_render,
  DropUpvue_type_template_id_22830790_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var DropUp = (DropUp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Download.vue?vue&type=template&id=624f3234&
var Downloadvue_type_template_id_624f3234_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M5 1.75C5.41421 1.75 5.75 2.08579 5.75 2.5C5.75 2.91421 5.41421 3.25 5 3.25H4C3.30128 3.25 2.75 3.77372 2.75 4.4V19.6C2.75 20.2263 3.30128 20.75 4 20.75H20C20.6987 20.75 21.25 20.2263 21.25 19.6V4.4C21.25 3.77372 20.6987 3.25 20 3.25H19C18.5858 3.25 18.25 2.91421 18.25 2.5C18.25 2.08579 18.5858 1.75 19 1.75H20C21.5104 1.75 22.75 2.9276 22.75 4.4V19.6C22.75 21.0724 21.5104 22.25 20 22.25H4C2.48958 22.25 1.25 21.0724 1.25 19.6V4.4C1.25 2.9276 2.48958 1.75 4 1.75H5ZM16 15.75C16.4142 15.75 16.75 16.0858 16.75 16.5C16.75 16.9142 16.4142 17.25 16 17.25H8C7.58579 17.25 7.25 16.9142 7.25 16.5C7.25 16.0858 7.58579 15.75 8 15.75H16ZM12 1.75467C12.4142 1.75467 12.75 2.09046 12.75 2.50467V10.689L14.9697 8.46967C15.2359 8.2034 15.6526 8.1792 15.9462 8.39705L16.0303 8.46967C16.3232 8.76256 16.3232 9.23744 16.0303 9.53033L12.8839 12.6768C12.3957 13.1649 11.6043 13.1649 11.1161 12.6768L7.96967 9.53033C7.67678 9.23744 7.67678 8.76256 7.96967 8.46967C8.26256 8.17678 8.73744 8.17678 9.03033 8.46967L11.25 10.689V2.50467C11.25 2.12497 11.5322 1.81118 11.8982 1.76152L12 1.75467Z"
    }
  });
};
var Downloadvue_type_template_id_624f3234_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Download.vue?vue&type=script&lang=ts&

/* harmony default export */ var Downloadvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Download.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Downloadvue_type_script_lang_ts_ = (Downloadvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Download.vue





/* normalize component */
;
var Download_component = normalizeComponent(
  icons_Downloadvue_type_script_lang_ts_,
  Downloadvue_type_template_id_624f3234_render,
  Downloadvue_type_template_id_624f3234_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Download = (Download_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Edit.vue?vue&type=template&id=167cc02e&
var Editvue_type_template_id_167cc02e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.131 1.94c.586-.586 1.536-.586 2.121 0l3.809 3.808c.585.585.585 1.535 0 2.12L7.869 22.062c-.281.281-.663.439-1.06.439H3c-.828 0-1.5-.672-1.5-1.5v-3.808c0-.398.158-.78.44-1.06zm-3.066 5.186L3 17.192V21h3.808l10.066-10.065-3.809-3.809zM17.192 3l-3.066 3.065 3.809 3.809L21 6.808 17.192 3z"
    }
  });
};
var Editvue_type_template_id_167cc02e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Edit.vue?vue&type=script&lang=ts&

/* harmony default export */ var Editvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Edit.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Editvue_type_script_lang_ts_ = (Editvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Edit.vue





/* normalize component */
;
var Edit_component = normalizeComponent(
  icons_Editvue_type_script_lang_ts_,
  Editvue_type_template_id_167cc02e_render,
  Editvue_type_template_id_167cc02e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Edit = (Edit_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Ellipse.vue?vue&type=template&id=68ad154c&
var Ellipsevue_type_template_id_68ad154c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M 11.5 7.5 a 4 4 0 0 1 -9 7 a 2.8 2.8 0 0 1 19 -5 h 0 a 3.8 3.8 0 0 1 -19 5 z z z z"
    }
  });
};
var Ellipsevue_type_template_id_68ad154c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Ellipse.vue?vue&type=script&lang=ts&

/* harmony default export */ var Ellipsevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Ellipse.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Ellipsevue_type_script_lang_ts_ = (Ellipsevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Ellipse.vue





/* normalize component */
;
var Ellipse_component = normalizeComponent(
  icons_Ellipsevue_type_script_lang_ts_,
  Ellipsevue_type_template_id_68ad154c_render,
  Ellipsevue_type_template_id_68ad154c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Ellipse = (Ellipse_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Email.vue?vue&type=template&id=4c6fec5c&
var Emailvue_type_template_id_4c6fec5c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20 3.25C21.5188 3.25 22.75 4.48122 22.75 6V18C22.75 19.5188 21.5188 20.75 20 20.75H4C2.48122 20.75 1.25 19.5188 1.25 18V6C1.25 4.48122 2.48122 3.25 4 3.25H20ZM2.75 6.072V18C2.75 18.6904 3.30964 19.25 4 19.25H20C20.6904 19.25 21.25 18.6904 21.25 18V6.164L13.1514 12.644C12.5548 13.1213 11.7239 13.1531 11.0962 12.7395L10.9649 12.644L2.75 6.072ZM20 4.75H4C3.85518 4.75 3.7161 4.77463 3.58674 4.81993L11.902 11.4727C11.9933 11.5458 12.123 11.5458 12.2143 11.4727L20.4917 4.85042C20.3408 4.78578 20.1746 4.75 20 4.75Z"
    }
  });
};
var Emailvue_type_template_id_4c6fec5c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Email.vue?vue&type=script&lang=ts&

/* harmony default export */ var Emailvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Email.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Emailvue_type_script_lang_ts_ = (Emailvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Email.vue





/* normalize component */
;
var Email_component = normalizeComponent(
  icons_Emailvue_type_script_lang_ts_,
  Emailvue_type_template_id_4c6fec5c_render,
  Emailvue_type_template_id_4c6fec5c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Email = (Email_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Error.vue?vue&type=template&id=a17b219a&
var Errorvue_type_template_id_a17b219a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C17.9392 1.25 22.75 6.06079 22.75 12C22.75 17.9392 17.9392 22.75 12 22.75C6.06079 22.75 1.25 17.9392 1.25 12C1.25 6.06079 6.06079 1.25 12 1.25ZM12 2.75C6.88921 2.75 2.75 6.88921 2.75 12C2.75 17.1108 6.88921 21.25 12 21.25C17.1108 21.25 21.25 17.1108 21.25 12C21.25 6.88921 17.1108 2.75 12 2.75ZM12 15C12.5523 15 13 15.4477 13 16C13 16.5523 12.5523 17 12 17C11.4477 17 11 16.5523 11 16C11 15.4477 11.4477 15 12 15ZM12.0006 7.25C12.4148 7.25 12.7506 7.58579 12.7506 8V13C12.7506 13.4142 12.4148 13.75 12.0006 13.75C11.5864 13.75 11.2506 13.4142 11.2506 13V8C11.2506 7.58579 11.5864 7.25 12.0006 7.25Z"
    }
  });
};
var Errorvue_type_template_id_a17b219a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Error.vue?vue&type=script&lang=ts&

/* harmony default export */ var Errorvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Error.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Errorvue_type_script_lang_ts_ = (Errorvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Error.vue





/* normalize component */
;
var Error_component = normalizeComponent(
  icons_Errorvue_type_script_lang_ts_,
  Errorvue_type_template_id_a17b219a_render,
  Errorvue_type_template_id_a17b219a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var icons_Error = (Error_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exclamation.vue?vue&type=template&id=73f668ff&
var Exclamationvue_type_template_id_73f668ff_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 15a1 1 0 1 1 0 2 1 1 0 0 1 0-2zm0-7.75a.75.75 0 0 1 .75.75v5a.75.75 0 0 1-1.5 0V8a.75.75 0 0 1 .75-.75z"
    }
  });
};
var Exclamationvue_type_template_id_73f668ff_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exclamation.vue?vue&type=script&lang=ts&

/* harmony default export */ var Exclamationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exclamation.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Exclamationvue_type_script_lang_ts_ = (Exclamationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exclamation.vue





/* normalize component */
;
var Exclamation_component = normalizeComponent(
  icons_Exclamationvue_type_script_lang_ts_,
  Exclamationvue_type_template_id_73f668ff_render,
  Exclamationvue_type_template_id_73f668ff_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Exclamation = (Exclamation_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exercise.vue?vue&type=template&id=11e9c62e&
var Exercisevue_type_template_id_11e9c62e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0V0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 15h7v2H7zm0-4h10v2H7zm0-4h10v2H7zm12-4h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-.14 0-.27.01-.4.04-.39.08-.74.28-1.01.55-.18.18-.33.4-.43.64-.1.23-.16.49-.16.77v14c0 .27.06.54.16.78s.25.45.43.64c.27.27.62.47 1.01.55.13.02.26.03.4.03h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7-.25c.41 0 .75.34.75.75s-.34.75-.75.75-.75-.34-.75-.75.34-.75.75-.75zM19 19H5V5h14v14z"
    }
  })]);
};
var Exercisevue_type_template_id_11e9c62e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exercise.vue?vue&type=script&lang=ts&

/* harmony default export */ var Exercisevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exercise.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Exercisevue_type_script_lang_ts_ = (Exercisevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exercise.vue





/* normalize component */
;
var Exercise_component = normalizeComponent(
  icons_Exercisevue_type_script_lang_ts_,
  Exercisevue_type_template_id_11e9c62e_render,
  Exercisevue_type_template_id_11e9c62e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Exercise = (Exercise_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exit.vue?vue&type=template&id=30b43b8c&
var Exitvue_type_template_id_30b43b8c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18 1.25A2.75 2.75 0 0120.75 4v1.5a.75.75 0 11-1.5 0V4c0-.69-.56-1.25-1.25-1.25H6c-.69 0-1.25.56-1.25 1.25v16c0 .69.56 1.25 1.25 1.25h12c.69 0 1.25-.56 1.25-1.25v-1.5a.75.75 0 111.5 0V20A2.75 2.75 0 0118 22.75H6A2.75 2.75 0 013.25 20V4A2.75 2.75 0 016 1.25h12zm-5.63 6.62a.75.75 0 011.06 1.06l-2.33 2.32H20c.38 0 .7.28.74.65v.1c0 .42-.33.75-.74.75H11.3l2.12 2.12c.26.26.29.68.07.97l-.07.09c-.3.29-.77.29-1.06 0l-3.15-3.15a1.25 1.25 0 010-1.77z"
    }
  });
};
var Exitvue_type_template_id_30b43b8c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Exit.vue?vue&type=script&lang=ts&

/* harmony default export */ var Exitvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exit.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Exitvue_type_script_lang_ts_ = (Exitvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Exit.vue





/* normalize component */
;
var Exit_component = normalizeComponent(
  icons_Exitvue_type_script_lang_ts_,
  Exitvue_type_template_id_30b43b8c_render,
  Exitvue_type_template_id_30b43b8c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Exit = (Exit_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Explore.vue?vue&type=template&id=0fd2dea6&
var Explorevue_type_template_id_0fd2dea6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 17.5L14.01 14.01L17.5 6.5L9.99 9.99L6.5 17.5ZM12 10.9C12.61 10.9 13.1 11.39 13.1 12C13.1 12.61 12.61 13.1 12 13.1C11.39 13.1 10.9 12.61 10.9 12C10.9 11.39 11.39 10.9 12 10.9Z"
    }
  });
};
var Explorevue_type_template_id_0fd2dea6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Explore.vue?vue&type=script&lang=ts&

/* harmony default export */ var Explorevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Explore.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Explorevue_type_script_lang_ts_ = (Explorevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Explore.vue





/* normalize component */
;
var Explore_component = normalizeComponent(
  icons_Explorevue_type_script_lang_ts_,
  Explorevue_type_template_id_0fd2dea6_render,
  Explorevue_type_template_id_0fd2dea6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Explore = (Explore_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Facebook.vue?vue&type=template&id=98ec3130&
var Facebookvue_type_template_id_98ec3130_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25c5.937 0 10.75 4.813 10.75 10.75S17.937 22.75 12 22.75 1.25 17.937 1.25 12 6.063 1.25 12 1.25zm0 1.5c-5.109 0-9.25 4.141-9.25 9.25 0 4.856 3.742 8.839 8.5 9.22v-6.97H9.5c-.38 0-.693-.282-.743-.648L8.75 13.5c0-.414.336-.75.75-.75h1.75V10c0-2.071 1.679-3.75 3.75-3.75h1c.414 0 .75.336.75.75s-.336.75-.75.75h-1c-1.243 0-2.25 1.007-2.25 2.25v2.75h1.75c.38 0 .693.282.743.648l.007.102c0 .414-.336.75-.75.75h-1.75v6.97c4.67-.375 8.362-4.218 8.496-8.952L21.25 12c0-5.109-4.141-9.25-9.25-9.25z"
    }
  });
};
var Facebookvue_type_template_id_98ec3130_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Facebook.vue?vue&type=script&lang=ts&

/* harmony default export */ var Facebookvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Facebook.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Facebookvue_type_script_lang_ts_ = (Facebookvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Facebook.vue





/* normalize component */
;
var Facebook_component = normalizeComponent(
  icons_Facebookvue_type_script_lang_ts_,
  Facebookvue_type_template_id_98ec3130_render,
  Facebookvue_type_template_id_98ec3130_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Facebook = (Facebook_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Favorite.vue?vue&type=template&id=6a8e5168&
var Favoritevue_type_template_id_6a8e5168_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z"
    }
  });
};
var Favoritevue_type_template_id_6a8e5168_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Favorite.vue?vue&type=script&lang=ts&

/* harmony default export */ var Favoritevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Favorite.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Favoritevue_type_script_lang_ts_ = (Favoritevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Favorite.vue





/* normalize component */
;
var Favorite_component = normalizeComponent(
  icons_Favoritevue_type_script_lang_ts_,
  Favoritevue_type_template_id_6a8e5168_render,
  Favoritevue_type_template_id_6a8e5168_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Favorite = (Favorite_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/FeedbackSolution.vue?vue&type=template&id=3184b85e&
var FeedbackSolutionvue_type_template_id_3184b85e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0V0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H5.17l-.59.59-.58.58V4h16v12zm-9-4h2v2h-2zm0-6h2v4h-2z"
    }
  })]);
};
var FeedbackSolutionvue_type_template_id_3184b85e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/FeedbackSolution.vue?vue&type=script&lang=ts&

/* harmony default export */ var FeedbackSolutionvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/FeedbackSolution.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_FeedbackSolutionvue_type_script_lang_ts_ = (FeedbackSolutionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/FeedbackSolution.vue





/* normalize component */
;
var FeedbackSolution_component = normalizeComponent(
  icons_FeedbackSolutionvue_type_script_lang_ts_,
  FeedbackSolutionvue_type_template_id_3184b85e_render,
  FeedbackSolutionvue_type_template_id_3184b85e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FeedbackSolution = (FeedbackSolution_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/File.vue?vue&type=template&id=fea24216&
var Filevue_type_template_id_fea24216_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18.5 1.75a2.75 2.75 0 012.75 2.75v15a2.75 2.75 0 01-2.75 2.75h-13a2.75 2.75 0 01-2.75-2.75v-15A2.75 2.75 0 015.5 1.75h13zm0 1.5h-13c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h13c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25zM12 15.35a.75.75 0 110 1.5H8a.75.75 0 110-1.5zm4-4a.75.75 0 110 1.5H8a.75.75 0 110-1.5zm0-4.25a.75.75 0 110 1.5H8a.75.75 0 010-1.5z"
    }
  });
};
var Filevue_type_template_id_fea24216_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/File.vue?vue&type=script&lang=ts&

/* harmony default export */ var Filevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/File.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Filevue_type_script_lang_ts_ = (Filevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/File.vue





/* normalize component */
;
var File_component = normalizeComponent(
  icons_Filevue_type_script_lang_ts_,
  Filevue_type_template_id_fea24216_render,
  Filevue_type_template_id_fea24216_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var File = (File_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/FilledCalendar.vue?vue&type=template&id=ee7d55fa&
var FilledCalendarvue_type_template_id_ee7d55fa_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M17 0C17.4142 0 17.75 0.335786 17.75 0.75V2H20C21.5188 2 22.75 3.23122 22.75 4.75V19.75C22.75 21.2688 21.5188 22.5 20 22.5H4C2.48122 22.5 1.25 21.2688 1.25 19.75V4.75C1.25 3.23122 2.48122 2 4 2H6.25V0.75C6.25 0.370304 6.53215 0.056509 6.89823 0.00684662L7 0C7.41421 0 7.75 0.335786 7.75 0.75V2H16.25V0.75C16.25 0.370304 16.5322 0.056509 16.8982 0.00684662L17 0ZM16.25 3.5H7.75V4.75C7.75 5.1297 7.46785 5.44349 7.10177 5.49315L7 5.5C6.58579 5.5 6.25 5.16421 6.25 4.75V3.5H4C3.30964 3.5 2.75 4.05964 2.75 4.75V19.75C2.75 20.4404 3.30964 21 4 21H20C20.6904 21 21.25 20.4404 21.25 19.75V4.75C21.25 4.05964 20.6904 3.5 20 3.5H17.75V4.75C17.75 5.1297 17.4678 5.44349 17.1018 5.49315L17 5.5C16.5858 5.5 16.25 5.16421 16.25 4.75V3.5ZM12 15.5C12.5523 15.5 13 15.9477 13 16.5C13 17.0523 12.5523 17.5 12 17.5C11.4477 17.5 11 17.0523 11 16.5C11 15.9477 11.4477 15.5 12 15.5ZM7 15.5C7.55228 15.5 8 15.9477 8 16.5C8 17.0523 7.55228 17.5 7 17.5C6.44772 17.5 6 17.0523 6 16.5C6 15.9477 6.44772 15.5 7 15.5ZM17 11.5C17.5523 11.5 18 11.9477 18 12.5C18 13.0523 17.5523 13.5 17 13.5C16.4477 13.5 16 13.0523 16 12.5C16 11.9477 16.4477 11.5 17 11.5ZM12 11.5C12.5523 11.5 13 11.9477 13 12.5C13 13.0523 12.5523 13.5 12 13.5C11.4477 13.5 11 13.0523 11 12.5C11 11.9477 11.4477 11.5 12 11.5ZM7 11.5C7.55228 11.5 8 11.9477 8 12.5C8 13.0523 7.55228 13.5 7 13.5C6.44772 13.5 6 13.0523 6 12.5C6 11.9477 6.44772 11.5 7 11.5ZM17 7.5C17.5523 7.5 18 7.94772 18 8.5C18 9.05229 17.5523 9.5 17 9.5C16.4477 9.5 16 9.05229 16 8.5C16 7.94772 16.4477 7.5 17 7.5ZM12 7.5C12.5523 7.5 13 7.94772 13 8.5C13 9.05229 12.5523 9.5 12 9.5C11.4477 9.5 11 9.05229 11 8.5C11 7.94772 11.4477 7.5 12 7.5ZM7 7.5C7.55228 7.5 8 7.94772 8 8.5C8 9.05229 7.55228 9.5 7 9.5C6.44772 9.5 6 9.05229 6 8.5C6 7.94772 6.44772 7.5 7 7.5Z"
    }
  });
};
var FilledCalendarvue_type_template_id_ee7d55fa_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/FilledCalendar.vue?vue&type=script&lang=ts&

/* harmony default export */ var FilledCalendarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/FilledCalendar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_FilledCalendarvue_type_script_lang_ts_ = (FilledCalendarvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/FilledCalendar.vue





/* normalize component */
;
var FilledCalendar_component = normalizeComponent(
  icons_FilledCalendarvue_type_script_lang_ts_,
  FilledCalendarvue_type_template_id_ee7d55fa_render,
  FilledCalendarvue_type_template_id_ee7d55fa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FilledCalendar = (FilledCalendar_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Folder.vue?vue&type=template&id=284cc7bc&
var Foldervue_type_template_id_284cc7bc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12.32 4.88L10.84 3.3c-.33-.35-.79-.55-1.27-.55H4a2.81 2.81 0 00-2.74 2.88l-.01 12.74A2.82 2.82 0 004 21.25h16c1.52 0 2.75-1.3 2.75-2.88V7.76A2.82 2.82 0 0020 4.87h-7.68zm-2.75-.63c.07 0 .13.03.18.08l1.56 1.65c.23.25.56.4.9.4H20c.68 0 1.25.6 1.25 1.37v10.63c0 .76-.57 1.37-1.25 1.37H4c-.68 0-1.25-.61-1.25-1.38l.01-12.74c0-.77.57-1.38 1.24-1.38h5.57z"
    }
  });
};
var Foldervue_type_template_id_284cc7bc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Folder.vue?vue&type=script&lang=ts&

/* harmony default export */ var Foldervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Folder.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Foldervue_type_script_lang_ts_ = (Foldervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Folder.vue





/* normalize component */
;
var Folder_component = normalizeComponent(
  icons_Foldervue_type_script_lang_ts_,
  Foldervue_type_template_id_284cc7bc_render,
  Foldervue_type_template_id_284cc7bc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Folder = (Folder_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Forum.vue?vue&type=template&id=77ab414e&
var Forumvue_type_template_id_77ab414e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M23.1001 6.25C23.5143 6.25 23.8501 6.58579 23.8501 7V21.975C23.8501 22.6712 23.2988 23.25 22.6001 23.25C22.3439 23.25 22.0947 23.1698 21.8857 23.0213L18.2245 20.4211H6.8501C6.43588 20.4211 6.1001 20.0854 6.1001 19.6711C6.1001 19.2569 6.43588 18.9211 6.8501 18.9211H18.4637C18.6194 18.9211 18.7711 18.9696 18.898 19.0597L22.3501 21.5114V7C22.3501 6.58579 22.6859 6.25 23.1001 6.25ZM17.3501 1.25C18.8689 1.25 20.1001 2.48122 20.1001 4V13.7528C20.1001 15.2716 18.8689 16.5028 17.3501 16.5028H6.1268L2.69305 18.8427C2.41768 19.0303 2.09216 19.1307 1.75893 19.1307C0.84278 19.1307 0.100098 18.388 0.100098 17.4719V4C0.100098 2.48122 1.33131 1.25 2.8501 1.25H17.3501ZM17.3501 2.75H2.8501C2.15974 2.75 1.6001 3.30964 1.6001 4V17.4719C1.6001 17.5596 1.67121 17.6307 1.75893 17.6307C1.79083 17.6307 1.822 17.6211 1.84837 17.6031L5.47321 15.133C5.59771 15.0482 5.74489 15.0028 5.89555 15.0028H17.3501C18.0405 15.0028 18.6001 14.4431 18.6001 13.7528V4C18.6001 3.30964 18.0405 2.75 17.3501 2.75ZM10.3501 10.25C10.7643 10.25 11.1001 10.5858 11.1001 11C11.1001 11.4142 10.7643 11.75 10.3501 11.75H6.3501C5.93588 11.75 5.6001 11.4142 5.6001 11C5.6001 10.5858 5.93588 10.25 6.3501 10.25H10.3501ZM13.8501 6.25C14.2643 6.25 14.6001 6.58579 14.6001 7C14.6001 7.41421 14.2643 7.75 13.8501 7.75H6.3501C5.93588 7.75 5.6001 7.41421 5.6001 7C5.6001 6.58579 5.93588 6.25 6.3501 6.25H13.8501Z"
    }
  });
};
var Forumvue_type_template_id_77ab414e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Forum.vue?vue&type=script&lang=ts&

/* harmony default export */ var Forumvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Forum.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Forumvue_type_script_lang_ts_ = (Forumvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Forum.vue





/* normalize component */
;
var Forum_component = normalizeComponent(
  icons_Forumvue_type_script_lang_ts_,
  Forumvue_type_template_id_77ab414e_render,
  Forumvue_type_template_id_77ab414e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Forum = (Forum_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ForumUserIcon.vue?vue&type=template&id=0039df5c&
var ForumUserIconvue_type_template_id_0039df5c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 24 24"
    }
  }, [_c('path', {
    attrs: {
      "d": "M12,4h0A3.75,3.75,0,0,0,8.25,7.75h0A3.75,3.75,0,0,0,12,11.5h0a3.75,3.75,0,0,0,3.75-3.75h0A3.75,3.75,0,0,0,12,4Zm.09,5.72H12a2,2,0,1,1,.09,0Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M12,12.44h0c-2.5,0-7.5,1.25-7.5,3.75V19h15V16.19C19.5,13.69,14.5,12.44,12,12.44Zm5.72,4.78H6.28v-1c0-.6,2.94-2,5.72-2h0c2.78,0,5.72,1.37,5.72,2Z"
    }
  })]);
};
var ForumUserIconvue_type_template_id_0039df5c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ForumUserIcon.vue?vue&type=script&lang=ts&

/* harmony default export */ var ForumUserIconvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ForumUserIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ForumUserIconvue_type_script_lang_ts_ = (ForumUserIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ForumUserIcon.vue





/* normalize component */
;
var ForumUserIcon_component = normalizeComponent(
  icons_ForumUserIconvue_type_script_lang_ts_,
  ForumUserIconvue_type_template_id_0039df5c_render,
  ForumUserIconvue_type_template_id_0039df5c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ForumUserIcon = (ForumUserIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ForumValidateIcon.vue?vue&type=template&id=2acfa0c6&
var ForumValidateIconvue_type_template_id_2acfa0c6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.54,9.25H14l.69-3.43,0-.24a1.17,1.17,0,0,0-.32-.79L13.58,4,8.78,8.94A1.53,1.53,0,0,0,8.36,10v7.5A1.48,1.48,0,0,0,9.82,19h6.54a1.45,1.45,0,0,0,1.34-.92l2.2-5.28a1.68,1.68,0,0,0,.1-.55v-1.5A1.48,1.48,0,0,0,18.54,9.25Zm0,3L16.36,17.5H9.82V10L13,6.74l-1,4h6.54Z"
    }
  }), _c('rect', {
    attrs: {
      "x": "4",
      "y": "10",
      "width": "2.91",
      "height": "9"
    }
  })]);
};
var ForumValidateIconvue_type_template_id_2acfa0c6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ForumValidateIcon.vue?vue&type=script&lang=ts&

/* harmony default export */ var ForumValidateIconvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ForumValidateIcon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ForumValidateIconvue_type_script_lang_ts_ = (ForumValidateIconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ForumValidateIcon.vue





/* normalize component */
;
var ForumValidateIcon_component = normalizeComponent(
  icons_ForumValidateIconvue_type_script_lang_ts_,
  ForumValidateIconvue_type_template_id_2acfa0c6_render,
  ForumValidateIconvue_type_template_id_2acfa0c6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ForumValidateIcon = (ForumValidateIcon_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Friends.vue?vue&type=template&id=66e0d460&
var Friendsvue_type_template_id_66e0d460_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M6.57577 3.925C4.80553 3.925 3.37047 5.30732 3.37047 7.0125C3.37047 8.71768 4.80553 10.1 6.57577 10.1C8.346 10.1 9.78106 8.71768 9.78106 7.0125C9.78106 5.30732 8.346 3.925 6.57577 3.925ZM1.8911 7.0125C1.8911 4.52031 3.9885 2.5 6.57577 2.5C9.16303 2.5 11.2604 4.52031 11.2604 7.0125C11.2604 9.50468 9.16303 11.525 6.57577 11.525C3.9885 11.525 1.8911 9.50468 1.8911 7.0125ZM4.86136 13.425C2.55074 13.425 0.585206 15.0478 0.231817 17.2473L0.0324963 18.4879C-0.22188 20.0712 1.04953 21.5 2.71276 21.5H10.9315C11.3128 21.5 11.6736 21.4249 12.0001 21.29C12.3266 21.4249 12.6874 21.5 13.0687 21.5H21.2874C22.9507 21.5 24.2221 20.0712 23.9677 18.4879L23.7684 17.2473C23.415 15.0478 21.4495 13.425 19.1388 13.425H15.2173C13.9816 13.425 12.8446 13.8891 12.0001 14.6574C11.1556 13.8891 10.0186 13.425 8.78286 13.425H4.86136ZM12.9076 15.7967C13.1549 16.2387 13.3288 16.7269 13.4124 17.2473L13.6117 18.4879C13.7031 19.0565 13.5976 19.6052 13.3479 20.075H21.2874C22.0434 20.075 22.6214 19.4255 22.5057 18.7059L22.3064 17.4653C22.0646 15.9603 20.7198 14.85 19.1388 14.85H15.2173C14.3177 14.85 13.4945 15.2095 12.9076 15.7967ZM1.69378 17.4653C1.93557 15.9603 3.28041 14.85 4.86136 14.85H8.78286C10.3638 14.85 11.7087 15.9603 11.9504 17.4653L12.1498 18.7059C12.2654 19.4255 11.6875 20.075 10.9315 20.075H2.71276C1.95675 20.075 1.37883 19.4255 1.49446 18.7059L1.69378 17.4653ZM14.4657 7.96248C14.4657 6.78198 15.4592 5.82498 16.6847 5.82498C17.9103 5.82498 18.9038 6.78198 18.9038 7.96248C18.9038 9.14299 17.9103 10.1 16.6847 10.1C15.4592 10.1 14.4657 9.14299 14.4657 7.96248ZM16.6847 4.39998C14.6422 4.39998 12.9863 5.99497 12.9863 7.96248C12.9863 9.93 14.6422 11.525 16.6847 11.525C18.7273 11.525 20.3832 9.93 20.3832 7.96248C20.3832 5.99497 18.7273 4.39998 16.6847 4.39998Z"
    }
  });
};
var Friendsvue_type_template_id_66e0d460_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Friends.vue?vue&type=script&lang=ts&

/* harmony default export */ var Friendsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Friends.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Friendsvue_type_script_lang_ts_ = (Friendsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Friends.vue





/* normalize component */
;
var Friends_component = normalizeComponent(
  icons_Friendsvue_type_script_lang_ts_,
  Friendsvue_type_template_id_66e0d460_render,
  Friendsvue_type_template_id_66e0d460_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Friends = (Friends_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/GestureZoom.vue?vue&type=template&id=5dcd128e&
var GestureZoomvue_type_template_id_5dcd128e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12.9244 9.27273C12.9244 9.03162 13.0203 8.80039 13.191 8.6299C13.3617 8.45942 13.5933 8.36364 13.8347 8.36364C14.0762 8.36364 14.3077 8.45942 14.4785 8.6299C14.6492 8.80039 14.7451 9.03162 14.7451 9.27273V13.3364L15.8466 13.4545L20.3438 15.4545C20.8172 15.6727 21.1176 16.1455 21.1176 16.6727V20.6364C21.0903 21.3818 20.4986 21.9727 19.7521 22H13.8347C13.4888 22 13.1611 21.8636 12.9244 21.6091L8.46359 17.7909L9.13726 17.0909C9.31022 16.9 9.55602 16.8 9.81092 16.8H10.0112L12.9244 18.3636V9.27273ZM13.8347 5.63636C15.1275 5.63636 16.3291 6.32727 16.9755 7.45455C17.986 9.18182 17.3943 11.4091 15.6555 12.4182V11.3C16.2381 10.7909 16.5658 10.0455 16.5658 9.27273C16.5658 8.54941 16.2781 7.85572 15.7659 7.34425C15.2537 6.83279 14.5591 6.54545 13.8347 6.54545C13.1104 6.54545 12.4157 6.83279 11.9036 7.34425C11.3914 7.85572 11.1036 8.54941 11.1036 9.27273C11.1036 10.0455 11.4314 10.7909 12.014 11.3V12.4182C10.8943 11.7727 10.1933 10.5727 10.1933 9.27273C10.1933 8.3083 10.5769 7.38338 11.2598 6.70143C11.9427 6.01948 12.869 5.63636 13.8347 5.63636ZM4.73109 9.27273L7.46218 12H5.64146V14.7273H3.82073V12H2L4.73109 9.27273ZM4.73109 7.45455L2 4.72727H3.82073V2H5.64146V4.72727H7.46218L4.73109 7.45455ZM9.28291 13.8182C9.94748 13.8182 10.5665 13.9909 11.1036 14.3091V15.4182C10.6211 14.9909 9.98389 14.7273 9.28291 14.7273C8.55858 14.7273 7.86392 15.0146 7.35174 15.5261C6.83956 16.0375 6.55182 16.7312 6.55182 17.4545C6.55182 18.3636 7.007 19.1545 7.66246 19.6545L9.56513 21.0909H9.28291C8.31714 21.0909 7.39092 20.7078 6.70801 20.0258C6.02511 19.3439 5.64146 18.419 5.64146 17.4545C5.64146 16.4901 6.02511 15.5652 6.70801 14.8832C7.39092 14.2013 8.31714 13.8182 9.28291 13.8182Z"
    }
  });
};
var GestureZoomvue_type_template_id_5dcd128e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/GestureZoom.vue?vue&type=script&lang=ts&

/* harmony default export */ var GestureZoomvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/GestureZoom.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_GestureZoomvue_type_script_lang_ts_ = (GestureZoomvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/GestureZoom.vue





/* normalize component */
;
var GestureZoom_component = normalizeComponent(
  icons_GestureZoomvue_type_script_lang_ts_,
  GestureZoomvue_type_template_id_5dcd128e_render,
  GestureZoomvue_type_template_id_5dcd128e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GestureZoom = (GestureZoom_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Gift.vue?vue&type=template&id=69d3c86f&
var Giftvue_type_template_id_69d3c86f_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill": "#666",
      "fill-rule": "evenodd",
      "d": "M10.267 1.841c.846.643 1.639 1.509 2.243 2.389.604-.88 1.397-1.746 2.242-2.389.609-.462 1.285-.84 1.974-1.004.701-.166 1.453-.116 2.12.343.506.347.847.802 1.023 1.322.173.51.171 1.034.074 1.508a3.73 3.73 0 0 1-.325.922h1.062c1.557 0 2.82 1.324 2.82 2.957v1.424c0 .905-.388 1.716-1 2.258v8.223c0 1.633-1.263 2.956-2.82 2.956H5.32c-1.557 0-2.82-1.323-2.82-2.956V11.57a3.009 3.009 0 0 1-1-2.258V7.889c0-1.633 1.263-2.957 2.82-2.957h1.081a3.73 3.73 0 0 1-.324-.922 2.88 2.88 0 0 1 .074-1.508c.176-.52.516-.975 1.022-1.322C6.84.72 7.592.67 8.293.837c.69.164 1.366.542 1.974 1.004ZM7.318 4.932c-.332-.245-.67-.74-.775-1.253a1.243 1.243 0 0 1 .021-.651c.059-.174.18-.361.432-.534.244-.168.554-.222.966-.124.424.1.914.355 1.424.743a9.008 9.008 0 0 1 1.754 1.82H7.318Zm10.383 0H13.88a9.012 9.012 0 0 1 1.753-1.819c.51-.388 1-.643 1.424-.743.412-.098.722-.044.967.124.251.173.372.36.431.534.062.182.073.402.022.651-.106.513-.444 1.008-.776 1.253ZM7.237 6.505H4.321C3.59 6.505 3 7.125 3 7.889v1.424c0 .764.591 1.384 1.32 1.384h7.43V6.509H7.355c-.038 0-.077-.002-.118-.004Zm6.013.004v4.188h7.43c.729 0 1.32-.62 1.32-1.384V7.889c0-.765-.591-1.384-1.32-1.384h-2.898c-.04.002-.08.004-.118.004H13.25Zm0 14.574v-8.814h7.43c.108 0 .215-.006.32-.019v7.544c0 .764-.591 1.384-1.32 1.384h-6.435v-.005a.84.84 0 0 0 .005-.09Zm-1.5 0c0 .032.002.064.005.095H5.321c-.73 0-1.321-.62-1.321-1.384V12.25c.105.013.212.02.32.02h7.43v8.813Z",
      "clip-rule": "evenodd"
    }
  });
};
var Giftvue_type_template_id_69d3c86f_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Gift.vue?vue&type=script&lang=ts&

/* harmony default export */ var Giftvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Gift.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Giftvue_type_script_lang_ts_ = (Giftvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Gift.vue





/* normalize component */
;
var Gift_component = normalizeComponent(
  icons_Giftvue_type_script_lang_ts_,
  Giftvue_type_template_id_69d3c86f_render,
  Giftvue_type_template_id_69d3c86f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Gift = (Gift_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Help.vue?vue&type=template&id=6d71037a&
var Helpvue_type_template_id_6d71037a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0V0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z"
    }
  })]);
};
var Helpvue_type_template_id_6d71037a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Help.vue?vue&type=script&lang=ts&

/* harmony default export */ var Helpvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Help.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Helpvue_type_script_lang_ts_ = (Helpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Help.vue





/* normalize component */
;
var Help_component = normalizeComponent(
  icons_Helpvue_type_script_lang_ts_,
  Helpvue_type_template_id_6d71037a_render,
  Helpvue_type_template_id_6d71037a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Help = (Help_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/HelpCenter.vue?vue&type=template&id=3007f5cd&
var HelpCentervue_type_template_id_3007f5cd_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "m23 3.11594c0-1.69866-1.281-3.1055188-2.9115-3.1055188v-.0104212h-16.17705c-1.63041 0-2.91145 1.41728-2.91145 3.10552v17.77858c0 1.6986 1.28104 3.1055 2.91145 3.1055h5.65034c.48701 0 .88931-.3856.88931-.8754 0-.4794-.3917-.8754-.88931-.8754h-5.63975c-.60346 0-1.13282-.5836-1.13282-1.3443v-17.78898c0-.76075.52936-1.34434 1.12223-1.34434h16.17705c.6035 0 1.1329.58359 1.1329 1.34434v5.91611c0 .47937.4023.87538.8893.87538s.8893-.38559.8893-.87538z"
    }
  }), _c('path', {
    attrs: {
      "d": "m15.6293 8.4c2.6935 0 4.8764 2.2304 4.8764 4.9826 0 1.6826-1.1617 3.1044-3.319 4.3044-.3575.1956-.5873.587-.5873 1.0043l-.0127.1305c-.0639.4826-.4724.8609-.9702.8609-.5362 0-.9702-.4435-.9702-.9914 0-1.1478.6128-2.2043 1.5957-2.7521 1.5957-.887 2.2978-1.7609 2.2978-2.5566 0-1.6565-1.3149-2.9869-2.9233-2.9869-1.6085 0-2.9233 1.3434-2.9233 2.9869 0 .5479-.434.9913-.9702.9913-.5361 0-.9702-.4434-.9702-.9913 0-2.7522 2.1829-4.9826 4.8765-4.9826z"
    }
  }), _c('path', {
    attrs: {
      "d": "m15.6297 24c.7191 0 1.302-.5957 1.302-1.3304 0-.7348-.5829-1.3305-1.302-1.3305-.7192 0-1.3021.5957-1.3021 1.3305 0 .7347.5829 1.3304 1.3021 1.3304z"
    }
  }), _c('path', {
    attrs: {
      "d": "m17.0602 4.8c.5636 0 1.0073.40714 1.0073.9s-.4557.9-1.0073.9h-10.17652c-.56359 0-1.00726-.40714-1.00726-.9s.45567-.9 1.00726-.9z"
    }
  }), _c('path', {
    attrs: {
      "d": "m9.53374 9.3c0-.49286-.44368-.9-1.00727-.9h-1.64279c-.55159 0-1.00726.40714-1.00726.9s.44367.9 1.00726.9h1.64279c.5516 0 1.00727-.40714 1.00727-.9z"
    }
  })]);
};
var HelpCentervue_type_template_id_3007f5cd_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/HelpCenter.vue?vue&type=script&lang=ts&

/* harmony default export */ var HelpCentervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/HelpCenter.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_HelpCentervue_type_script_lang_ts_ = (HelpCentervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/HelpCenter.vue





/* normalize component */
;
var HelpCenter_component = normalizeComponent(
  icons_HelpCentervue_type_script_lang_ts_,
  HelpCentervue_type_template_id_3007f5cd_render,
  HelpCentervue_type_template_id_3007f5cd_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HelpCenter = (HelpCenter_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Home.vue?vue&type=template&id=2a4edb8b&
var Homevue_type_template_id_2a4edb8b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M11.79 0h.02a.75.75 0 01.39.15l.01.01 9.16 7.21 1.84 1.46A.75.75 0 1122.3 10l-.91-.72v9.09a2.75 2.75 0 01-2.59 2.74H5.63a2.75 2.75 0 01-2.75-2.74V8.7L1.2 10c-.3.24-.7.22-.97-.04l-.08-.08A.75.75 0 01.3 8.83l11-8.67a.76.76 0 01.46-.16h.04zm-.04 1.7L4.37 7.53v10.86c0 .64.5 1.17 1.13 1.24h3.38v-5a3.25 3.25 0 016.5 0v5h3.25c.64 0 1.17-.49 1.24-1.12V8.11l-8.12-6.4zm.38 11.18c-.97 0-1.75.78-1.75 1.75v5h3.5v-5c0-.97-.79-1.75-1.75-1.75z"
    }
  });
};
var Homevue_type_template_id_2a4edb8b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Home.vue?vue&type=script&lang=ts&

/* harmony default export */ var Homevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Home.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Homevue_type_script_lang_ts_ = (Homevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Home.vue





/* normalize component */
;
var Home_component = normalizeComponent(
  icons_Homevue_type_script_lang_ts_,
  Homevue_type_template_id_2a4edb8b_render,
  Homevue_type_template_id_2a4edb8b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Home = (Home_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/HomeOutline.vue?vue&type=template&id=7d788f1e&
var HomeOutlinevue_type_template_id_7d788f1e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5 12H2L12 3L22 12H19V20H13V14H11V20H5V12ZM17 10.19L12 5.69L7 10.19V18H9V12H15V18H17V10.19Z"
    }
  });
};
var HomeOutlinevue_type_template_id_7d788f1e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/HomeOutline.vue?vue&type=script&lang=ts&

/* harmony default export */ var HomeOutlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/HomeOutline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_HomeOutlinevue_type_script_lang_ts_ = (HomeOutlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/HomeOutline.vue





/* normalize component */
;
var HomeOutline_component = normalizeComponent(
  icons_HomeOutlinevue_type_script_lang_ts_,
  HomeOutlinevue_type_template_id_7d788f1e_render,
  HomeOutlinevue_type_template_id_7d788f1e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var HomeOutline = (HomeOutline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Info.vue?vue&type=template&id=f754143e&
var Infovue_type_template_id_f754143e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C17.9392 1.25 22.75 6.06079 22.75 12C22.75 17.9392 17.9392 22.75 12 22.75C6.06079 22.75 1.25 17.9392 1.25 12C1.25 6.06079 6.06079 1.25 12 1.25ZM12 2.75C6.88921 2.75 2.75 6.88921 2.75 12C2.75 17.1108 6.88921 21.25 12 21.25C17.1108 21.25 21.25 17.1108 21.25 12C21.25 6.88921 17.1108 2.75 12 2.75ZM12.0006 10.25C12.4148 10.25 12.7506 10.5858 12.7506 11V16C12.7506 16.4142 12.4148 16.75 12.0006 16.75C11.5864 16.75 11.2506 16.4142 11.2506 16V11C11.2506 10.5858 11.5864 10.25 12.0006 10.25ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
    }
  });
};
var Infovue_type_template_id_f754143e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Info.vue?vue&type=script&lang=ts&

/* harmony default export */ var Infovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Info.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Infovue_type_script_lang_ts_ = (Infovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Info.vue





/* normalize component */
;
var Info_component = normalizeComponent(
  icons_Infovue_type_script_lang_ts_,
  Infovue_type_template_id_f754143e_render,
  Infovue_type_template_id_f754143e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Info = (Info_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Image.vue?vue&type=template&id=160feceb&
var Imagevue_type_template_id_160feceb_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M15.8334 2.66659C15.8334 1.65406 15.0126 0.833252 14.0001 0.833252H2.00008C0.987559 0.833252 0.166748 1.65406 0.166748 2.66659V11.3333C0.166748 12.3458 0.987559 13.1666 2.00008 13.1666H14.0001C15.0126 13.1666 15.8334 12.3458 15.8334 11.3333V2.66659ZM2.00008 1.83325H14.0001C14.4603 1.83325 14.8334 2.20635 14.8334 2.66659V9.35225L13.0504 7.21264C12.3289 6.34685 11.0044 6.33089 10.2623 7.17905L9.23049 8.35824L6.37325 5.37677C5.62636 4.59742 4.37114 4.62883 3.66417 5.44456L1.16675 8.3262V2.66659C1.16675 2.20635 1.53984 1.83325 2.00008 1.83325ZM12.8801 12.1666L9.92507 9.08303L11.0149 7.83756C11.3522 7.45203 11.9542 7.45928 12.2822 7.85283L14.8334 10.9143V11.3333C14.8334 11.7935 14.4603 12.1666 14.0001 12.1666H12.8801ZM5.65126 6.06868L11.4951 12.1666H2.00008C1.53984 12.1666 1.16675 11.7935 1.16675 11.3333V9.85308L4.41986 6.09949C4.74121 5.7287 5.31176 5.71443 5.65126 6.06868ZM11.6667 5.33325C12.127 5.33325 12.5001 4.96016 12.5001 4.49992C12.5001 4.03968 12.127 3.66658 11.6667 3.66658C11.2065 3.66658 10.8334 4.03968 10.8334 4.49992C10.8334 4.96016 11.2065 5.33325 11.6667 5.33325Z",
      "transform": "scale(1.25) translate(1.5, 2.5)"
    }
  });
};
var Imagevue_type_template_id_160feceb_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Image.vue?vue&type=script&lang=ts&

/* harmony default export */ var Imagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Image.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Imagevue_type_script_lang_ts_ = (Imagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Image.vue





/* normalize component */
;
var Image_component = normalizeComponent(
  icons_Imagevue_type_script_lang_ts_,
  Imagevue_type_template_id_160feceb_render,
  Imagevue_type_template_id_160feceb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Image = (Image_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertEmoji.vue?vue&type=template&id=5792fd31&
var InsertEmojivue_type_template_id_5792fd31_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C17.9392 1.25 22.75 6.06079 22.75 12C22.75 17.9392 17.9392 22.75 12 22.75C6.06079 22.75 1.25 17.9392 1.25 12C1.25 6.06079 6.06079 1.25 12 1.25ZM12 2.75C6.88921 2.75 2.75 6.88921 2.75 12C2.75 17.1108 6.88921 21.25 12 21.25C17.1108 21.25 21.25 17.1108 21.25 12C21.25 6.88921 17.1108 2.75 12 2.75ZM9.77297 14.2945C11.0428 15.5643 13.0994 15.5643 14.3692 14.2945C14.6621 14.0016 15.1369 14.0016 15.4298 14.2945C15.7227 14.5874 15.7227 15.0623 15.4298 15.3552C13.5742 17.2108 10.5679 17.2108 8.71231 15.3552C8.41942 15.0623 8.41942 14.5874 8.71231 14.2945C9.0052 14.0016 9.48008 14.0016 9.77297 14.2945ZM9 9C9.55228 9 10 9.44772 10 10C10 10.5523 9.55228 11 9 11C8.44772 11 8 10.5523 8 10C8 9.44772 8.44772 9 9 9ZM15 9C15.5523 9 16 9.44772 16 10C16 10.5523 15.5523 11 15 11C14.4477 11 14 10.5523 14 10C14 9.44772 14.4477 9 15 9Z"
    }
  });
};
var InsertEmojivue_type_template_id_5792fd31_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertEmoji.vue?vue&type=script&lang=ts&

/* harmony default export */ var InsertEmojivue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertEmoji.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_InsertEmojivue_type_script_lang_ts_ = (InsertEmojivue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertEmoji.vue





/* normalize component */
;
var InsertEmoji_component = normalizeComponent(
  icons_InsertEmojivue_type_script_lang_ts_,
  InsertEmojivue_type_template_id_5792fd31_render,
  InsertEmojivue_type_template_id_5792fd31_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InsertEmoji = (InsertEmoji_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertLink.vue?vue&type=template&id=e38bccdc&
var InsertLinkvue_type_template_id_e38bccdc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M6.52976 9.36895C6.82217 9.0769 7.29624 9.0769 7.58864 9.36896C7.88105 9.66101 7.88105 10.1345 7.58864 10.4266L5.11792 12.8944C3.46098 14.5494 3.46098 17.2326 5.11792 18.8876C6.77487 20.5426 9.4613 20.5426 11.1182 18.8876L13.589 16.4198C13.8814 16.1278 14.3554 16.1278 14.6478 16.4198C14.9403 16.7119 14.9403 17.1854 14.6478 17.4774L12.1771 19.9452C9.93538 22.1843 6.30079 22.1843 4.05904 19.9452C1.8173 17.7061 1.8173 14.0758 4.05904 11.8368L6.52976 9.36895ZM11.8242 4.08082C14.0659 1.84172 17.7005 1.84172 19.9423 4.08082C22.184 6.31991 22.184 9.9502 19.9423 12.1893L17.4715 14.6571C17.1791 14.9491 16.7051 14.9491 16.4127 14.6571C16.1202 14.365 16.1202 13.8915 16.4127 13.5995L18.8834 11.1317C20.5403 9.47669 20.5403 6.79343 18.8834 5.13845C17.2264 3.48346 14.54 3.48346 12.883 5.13845L10.4123 7.60624C10.1199 7.8983 9.64585 7.8983 9.35345 7.60624C9.06104 7.31419 9.06104 6.84067 9.35345 6.54862L11.8242 4.08082ZM15.0008 7.95879C15.2932 7.66673 15.7673 7.66673 16.0597 7.95879C16.3521 8.25084 16.3521 8.72436 16.0597 9.01641L9.00049 16.0673C8.70808 16.3593 8.23401 16.3593 7.9416 16.0673C7.6492 15.7752 7.6492 15.3017 7.9416 15.0096L15.0008 7.95879Z"
    }
  });
};
var InsertLinkvue_type_template_id_e38bccdc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertLink.vue?vue&type=script&lang=ts&

/* harmony default export */ var InsertLinkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertLink.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_InsertLinkvue_type_script_lang_ts_ = (InsertLinkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertLink.vue





/* normalize component */
;
var InsertLink_component = normalizeComponent(
  icons_InsertLinkvue_type_script_lang_ts_,
  InsertLinkvue_type_template_id_e38bccdc_render,
  InsertLinkvue_type_template_id_e38bccdc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InsertLink = (InsertLink_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertQuote.vue?vue&type=template&id=36309034&
var InsertQuotevue_type_template_id_36309034_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M10.2857 3.5C10.6802 3.5 11 3.8372 11 4.25316V13.5494C11 13.6634 10.9754 13.776 10.9281 13.8786L8.07098 20.0761C7.95144 20.3354 7.702 20.5 7.42857 20.5H3.14286C2.61535 20.5 2.26983 19.9178 2.50045 19.4176L4.8581 14.3024L1.71429 14.3025C1.35267 14.3025 1.05382 14.0192 1.00652 13.6516L1 13.5494V4.25316C1 3.8372 1.3198 3.5 1.71429 3.5H10.2857ZM22.2857 3.5C22.6802 3.5 23 3.8372 23 4.25316V13.5494C23 13.6634 22.9754 13.776 22.9281 13.8786L20.071 20.0761C19.9514 20.3354 19.702 20.5 19.4286 20.5H15.1429C14.6154 20.5 14.2698 19.9178 14.5005 19.4176L16.8581 14.3024L13.7143 14.3025C13.3527 14.3025 13.0538 14.0192 13.0065 13.6516L13 13.5494V4.25316C13 3.8372 13.3198 3.5 13.7143 3.5H22.2857ZM9.57143 5.00633H2.42857V12.7961L6 12.7962C6.49454 12.7962 6.82913 13.3079 6.67899 13.7841L6.64241 13.8786L4.28381 18.9931H6.98095L9.57143 13.3745V5.00633ZM21.5714 5.00633H14.4286V12.7961L18 12.7962C18.4945 12.7962 18.8291 13.3079 18.679 13.7841L18.6424 13.8786L16.2838 18.9931H18.981L21.5714 13.3745V5.00633Z"
    }
  });
};
var InsertQuotevue_type_template_id_36309034_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/InsertQuote.vue?vue&type=script&lang=ts&

/* harmony default export */ var InsertQuotevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertQuote.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_InsertQuotevue_type_script_lang_ts_ = (InsertQuotevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/InsertQuote.vue





/* normalize component */
;
var InsertQuote_component = normalizeComponent(
  icons_InsertQuotevue_type_script_lang_ts_,
  InsertQuotevue_type_template_id_36309034_render,
  InsertQuotevue_type_template_id_36309034_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var InsertQuote = (InsertQuote_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Instagram.vue?vue&type=template&id=d86a62f2&
var Instagramvue_type_template_id_d86a62f2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.5 1.75c3.176 0 5.75 2.574 5.75 5.75v9c0 3.176-2.574 5.75-5.75 5.75h-9c-3.176 0-5.75-2.574-5.75-5.75v-9c0-3.176 2.574-5.75 5.75-5.75h9zm0 1.5h-9c-2.347 0-4.25 1.903-4.25 4.25v9c0 2.347 1.903 4.25 4.25 4.25h9c2.347 0 4.25-1.903 4.25-4.25v-9c0-2.347-1.903-4.25-4.25-4.25zm-4.5 4c2.623 0 4.75 2.127 4.75 4.75s-2.127 4.75-4.75 4.75S7.25 14.623 7.25 12 9.377 7.25 12 7.25zm0 1.5c-1.795 0-3.25 1.455-3.25 3.25s1.455 3.25 3.25 3.25 3.25-1.455 3.25-3.25S13.795 8.75 12 8.75zm5.5-3.25c.552 0 1 .448 1 1s-.448 1-1 1-1-.448-1-1 .448-1 1-1z"
    }
  });
};
var Instagramvue_type_template_id_d86a62f2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Instagram.vue?vue&type=script&lang=ts&

/* harmony default export */ var Instagramvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Instagram.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Instagramvue_type_script_lang_ts_ = (Instagramvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Instagram.vue





/* normalize component */
;
var Instagram_component = normalizeComponent(
  icons_Instagramvue_type_script_lang_ts_,
  Instagramvue_type_template_id_d86a62f2_render,
  Instagramvue_type_template_id_d86a62f2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Instagram = (Instagram_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Italic.vue?vue&type=template&id=7e97f2b9&
var Italicvue_type_template_id_7e97f2b9_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18.5,2.75 C18.9142136,2.75 19.25,3.08578644 19.25,3.5 C19.25,3.91421356 18.9142136,4.25 18.5,4.25 L18.5,4.25 L15.766,4.24979756 L9.839,19.7497976 L12.5,19.75 C12.8796958,19.75 13.193491,20.0321539 13.2431534,20.3982294 L13.25,20.5 C13.25,20.9142136 12.9142136,21.25 12.5,21.25 L12.5,21.25 L5.5,21.25 C5.08578644,21.25 4.75,20.9142136 4.75,20.5 C4.75,20.0857864 5.08578644,19.75 5.5,19.75 L5.5,19.75 L8.233,19.7497976 L14.16,4.24979756 L11.5,4.25 C11.1203042,4.25 10.806509,3.96784612 10.7568466,3.60177056 L10.75,3.5 C10.75,3.08578644 11.0857864,2.75 11.5,2.75 L11.5,2.75 Z"
    }
  });
};
var Italicvue_type_template_id_7e97f2b9_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Italic.vue?vue&type=script&lang=ts&

/* harmony default export */ var Italicvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Italic.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Italicvue_type_script_lang_ts_ = (Italicvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Italic.vue





/* normalize component */
;
var Italic_component = normalizeComponent(
  icons_Italicvue_type_script_lang_ts_,
  Italicvue_type_template_id_7e97f2b9_render,
  Italicvue_type_template_id_7e97f2b9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Italic = (Italic_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/KeyboardVoice.vue?vue&type=template&id=74dc399c&
var KeyboardVoicevue_type_template_id_74dc399c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19 12.25C19.4142 12.25 19.75 12.5858 19.75 13C19.75 16.5325 16.6597 19.3913 12.7504 19.7187L12.75 22.5C12.75 22.9142 12.4142 23.25 12 23.25C11.5858 23.25 11.25 22.9142 11.25 22.5L11.2506 19.7188C7.34082 19.3918 4.25 16.5328 4.25 13C4.25 12.5858 4.58579 12.25 5 12.25C5.41421 12.25 5.75 12.5858 5.75 13C5.75 15.8716 8.52476 18.25 12 18.25C15.4752 18.25 18.25 15.8716 18.25 13C18.25 12.5858 18.5858 12.25 19 12.25ZM12 0.75C14.3472 0.75 16.25 2.65279 16.25 5V11.5C16.25 13.8472 14.3472 15.75 12 15.75C9.65279 15.75 7.75 13.8472 7.75 11.5V5C7.75 2.65279 9.65279 0.75 12 0.75ZM12 2.25C10.4812 2.25 9.25 3.48122 9.25 5V11.5C9.25 13.0188 10.4812 14.25 12 14.25C13.5188 14.25 14.75 13.0188 14.75 11.5V5C14.75 3.48122 13.5188 2.25 12 2.25Z"
    }
  });
};
var KeyboardVoicevue_type_template_id_74dc399c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/KeyboardVoice.vue?vue&type=script&lang=ts&

/* harmony default export */ var KeyboardVoicevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/KeyboardVoice.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_KeyboardVoicevue_type_script_lang_ts_ = (KeyboardVoicevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/KeyboardVoice.vue





/* normalize component */
;
var KeyboardVoice_component = normalizeComponent(
  icons_KeyboardVoicevue_type_script_lang_ts_,
  KeyboardVoicevue_type_template_id_74dc399c_render,
  KeyboardVoicevue_type_template_id_74dc399c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var KeyboardVoice = (KeyboardVoice_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Lamp.vue?vue&type=template&id=19d5236c&
var Lampvue_type_template_id_19d5236c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M14 20.75c.414 0 .75.336.75.75s-.336.75-.75.75h-4c-.414 0-.75-.336-.75-.75s.336-.75.75-.75zm-2.063-19.5c4.516 0 8.188 3.672 8.188 8.188 0 2.57-1.197 4.935-3.188 6.477v2.023c0 .998-.813 1.812-1.812 1.812H8.75c-.999 0-1.813-.814-1.813-1.813v-2.022l-.226-.182C4.856 14.19 3.75 11.91 3.75 9.437c0-4.515 3.672-8.187 8.188-8.187zm0 1.5c-3.687 0-6.687 3-6.687 6.688 0 2.21 1.082 4.23 2.868 5.484.2.14.32.37.32.614v2.402c0 .17.142.312.312.312h6.375c.17 0 .313-.142.313-.313v-2.4c0-.245.119-.474.319-.615 1.786-1.253 2.868-3.275 2.868-5.485 0-3.687-3-6.687-6.688-6.687z"
    }
  });
};
var Lampvue_type_template_id_19d5236c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Lamp.vue?vue&type=script&lang=ts&

/* harmony default export */ var Lampvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Lamp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Lampvue_type_script_lang_ts_ = (Lampvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Lamp.vue





/* normalize component */
;
var Lamp_component = normalizeComponent(
  icons_Lampvue_type_script_lang_ts_,
  Lampvue_type_template_id_19d5236c_render,
  Lampvue_type_template_id_19d5236c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Lamp = (Lamp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Language.vue?vue&type=template&id=6c06c63d&
var Languagevue_type_template_id_6c06c63d_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4.77756 1.22266C4.96166 1.22266 5.11089 1.37189 5.11089 1.55599V2.55599H6.77H6.78343H8.33312C8.51721 2.55599 8.66645 2.70523 8.66645 2.88932C8.66645 3.07342 8.51721 3.22266 8.33312 3.22266H7.04682C6.8742 3.89575 6.41348 4.87346 5.20102 6.28837C5.59525 6.70804 6.04404 7.13142 6.53732 7.51508C6.68263 7.6281 6.70881 7.83753 6.59579 7.98284C6.48276 8.12816 6.27334 8.15434 6.12802 8.04131C5.62312 7.64861 5.1631 7.21772 4.75682 6.789C4.12753 7.47557 3.33327 8.25489 2.33099 9.13925C2.19295 9.26105 1.9823 9.24789 1.8605 9.10985C1.7387 8.97181 1.75186 8.76116 1.88991 8.63936C2.90398 7.74459 3.69324 6.96652 4.30771 6.29213C3.63028 5.50683 3.15191 4.78365 2.93017 4.38452C2.84077 4.22359 2.89875 4.02066 3.05968 3.93125C3.2206 3.84185 3.42354 3.89983 3.51294 4.06076C3.70963 4.4148 4.14095 5.06821 4.75257 5.78673C5.76539 4.59245 6.18057 3.76862 6.35346 3.22266H1.22201C1.03791 3.22266 0.888672 3.07342 0.888672 2.88932C0.888672 2.70523 1.03791 2.55599 1.22201 2.55599H4.44423V1.55599C4.44423 1.37189 4.59347 1.22266 4.77756 1.22266ZM9.19403 5.27167C9.04983 4.88715 8.50593 4.88715 8.36173 5.27167L6.46577 10.3276C6.40113 10.4999 6.48846 10.6921 6.66084 10.7567C6.83321 10.8214 7.02535 10.734 7.08999 10.5617L7.67555 9.00017H9.88021L10.4658 10.5617C10.5304 10.734 10.7225 10.8214 10.8949 10.7567C11.0673 10.6921 11.1546 10.4999 11.09 10.3276L9.19403 5.27167ZM8.77788 6.06062L9.63021 8.3335H7.92555L8.77788 6.06062Z",
      "transform": "scale(2, 2)"
    }
  });
};
var Languagevue_type_template_id_6c06c63d_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Language.vue?vue&type=script&lang=ts&

/* harmony default export */ var Languagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Language.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Languagevue_type_script_lang_ts_ = (Languagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Language.vue





/* normalize component */
;
var Language_component = normalizeComponent(
  icons_Languagevue_type_script_lang_ts_,
  Languagevue_type_template_id_6c06c63d_render,
  Languagevue_type_template_id_6c06c63d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Language = (Language_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Library.vue?vue&type=template&id=fd6cbae4&
var Libraryvue_type_template_id_fd6cbae4_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M2.1001 5.75C2.51431 5.75 2.8501 6.08579 2.8501 6.5V20C2.8501 20.9665 3.6336 21.75 4.6001 21.75H17.1001C17.5143 21.75 17.8501 22.0858 17.8501 22.5C17.8501 22.9142 17.5143 23.25 17.1001 23.25H4.6001C2.80517 23.25 1.3501 21.7949 1.3501 20V6.5C1.3501 6.08579 1.68588 5.75 2.1001 5.75ZM19.8501 1C21.3689 1 22.6001 2.23122 22.6001 3.75V16.75C22.6001 18.2688 21.3689 19.5 19.8501 19.5H7.8501C6.33131 19.5 5.1001 18.2688 5.1001 16.75V3.75C5.1001 2.23122 6.33131 1 7.8501 1H19.8501ZM12.1057 2.49984L7.8501 2.5C7.15974 2.5 6.6001 3.05964 6.6001 3.75V16.75C6.6001 17.4404 7.15974 18 7.8501 18H19.8501C20.5405 18 21.1001 17.4404 21.1001 16.75V3.75C21.1001 3.05964 20.5405 2.5 19.8501 2.5H18.5961L18.6001 2.58333V8.68866C18.6001 8.9357 18.5087 9.174 18.3434 9.35762C17.9739 9.76813 17.3416 9.80141 16.9311 9.43195L15.3501 8.00902L13.7694 9.43168C13.5856 9.59707 13.3471 9.68852 13.0999 9.68839C12.5476 9.68809 12.1001 9.24014 12.1004 8.68785L12.1037 2.58333C12.1037 2.55537 12.1043 2.52753 12.1057 2.49984ZM17.1358 2.5H13.5644C13.5951 2.5 13.6031 2.50505 13.6046 2.52415L13.601 7.56517L14.8484 6.44253C15.1336 6.18582 15.5666 6.18582 15.8518 6.44253L17.1001 7.56598V2.58333C17.1001 2.51576 17.0866 2.5 17.1358 2.5Z"
    }
  });
};
var Libraryvue_type_template_id_fd6cbae4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Library.vue?vue&type=script&lang=ts&

/* harmony default export */ var Libraryvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Library.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Libraryvue_type_script_lang_ts_ = (Libraryvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Library.vue





/* normalize component */
;
var Library_component = normalizeComponent(
  icons_Libraryvue_type_script_lang_ts_,
  Libraryvue_type_template_id_fd6cbae4_render,
  Libraryvue_type_template_id_fd6cbae4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Library = (Library_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LikeActive.vue?vue&type=template&id=4cb7ac04&
var LikeActivevue_type_template_id_4cb7ac04_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12.2188 3.83321C13.4078 2.83203 14.938 2.25 16.5 2.25C19.9956 2.25 22.75 5.02693 22.75 8.54496C22.75 9.80441 22.4189 11.017 21.7636 12.2465L21.5786 12.5831C20.5401 14.4138 19.1196 15.9518 15.4818 19.3272L13.8569 20.8231C12.8045 21.7817 11.1945 21.7787 10.1457 20.8161L8.80941 19.5892C4.94106 16.0185 3.4735 14.4466 2.40262 12.5491L2.24471 12.2617C1.58388 11.0272 1.25 9.80974 1.25 8.54496C1.25 5.02693 4.00441 2.25 7.5 2.25C9.06196 2.25 10.5922 2.83203 11.7812 3.83321L12 4.0258L12.2188 3.83321Z",
      "fill": "#111111"
    }
  });
};
var LikeActivevue_type_template_id_4cb7ac04_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LikeActive.vue?vue&type=script&lang=ts&

/* harmony default export */ var LikeActivevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/LikeActive.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_LikeActivevue_type_script_lang_ts_ = (LikeActivevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/LikeActive.vue





/* normalize component */
;
var LikeActive_component = normalizeComponent(
  icons_LikeActivevue_type_script_lang_ts_,
  LikeActivevue_type_template_id_4cb7ac04_render,
  LikeActivevue_type_template_id_4cb7ac04_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LikeActive = (LikeActive_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LikeDefault.vue?vue&type=template&id=1bd6ae8a&
var LikeDefaultvue_type_template_id_1bd6ae8a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12.2188 3.83321C13.4078 2.83203 14.938 2.25 16.5 2.25C19.9956 2.25 22.75 5.02693 22.75 8.54496C22.75 9.80441 22.4189 11.017 21.7636 12.2465L21.5786 12.5831C20.5401 14.4138 19.1196 15.9518 15.4818 19.3272L13.8569 20.8231C12.8045 21.7817 11.1945 21.7787 10.1457 20.8161L8.80941 19.5892C4.94106 16.0185 3.4735 14.4466 2.40262 12.5491L2.24471 12.2617C1.58388 11.0272 1.25 9.80974 1.25 8.54496C1.25 5.02693 4.00441 2.25 7.5 2.25C9.06196 2.25 10.5922 2.83203 11.7812 3.83321L12 4.0258L12.2188 3.83321ZM11.1599 19.711C11.6366 20.1485 12.3685 20.1499 12.8469 19.7142L13.8587 18.7851C17.8403 15.1131 19.3003 13.5685 20.2971 11.8014L20.4399 11.541C20.9842 10.5197 21.25 9.54626 21.25 8.54496C21.25 5.85263 19.1644 3.75 16.5 3.75C15.0097 3.75 13.5396 4.44661 12.573 5.59104C12.2733 5.94577 11.7267 5.94577 11.427 5.59104C10.4604 4.44661 8.99031 3.75 7.5 3.75C4.83559 3.75 2.75 5.85263 2.75 8.54496C2.75 9.55054 3.01807 10.528 3.56717 11.5538L3.72989 11.8483C4.70281 13.5528 6.12565 15.07 9.83459 18.4941L11.1599 19.711Z",
      "fill": "#666666"
    }
  });
};
var LikeDefaultvue_type_template_id_1bd6ae8a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LikeDefault.vue?vue&type=script&lang=ts&

/* harmony default export */ var LikeDefaultvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/LikeDefault.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_LikeDefaultvue_type_script_lang_ts_ = (LikeDefaultvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/LikeDefault.vue





/* normalize component */
;
var LikeDefault_component = normalizeComponent(
  icons_LikeDefaultvue_type_script_lang_ts_,
  LikeDefaultvue_type_template_id_1bd6ae8a_render,
  LikeDefaultvue_type_template_id_1bd6ae8a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LikeDefault = (LikeDefault_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/List.vue?vue&type=template&id=a8059ff6&
var Listvue_type_template_id_a8059ff6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M19 5v14H5V5h14m1.1-2H3.9c-.5 0-.9.4-.9.9v16.2c0 .4.4.9.9.9h16.2c.4 0 .9-.5.9-.9V3.9c0-.5-.5-.9-.9-.9zM11 7h6v2h-6V7zm0 4h6v2h-6v-2zm0 4h6v2h-6zM7 7h2v2H7zm0 4h2v2H7zm0 4h2v2H7z"
    }
  }), _c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0z"
    }
  })]);
};
var Listvue_type_template_id_a8059ff6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/List.vue?vue&type=script&lang=ts&

/* harmony default export */ var Listvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/List.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Listvue_type_script_lang_ts_ = (Listvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/List.vue





/* normalize component */
;
var List_component = normalizeComponent(
  icons_Listvue_type_script_lang_ts_,
  Listvue_type_template_id_a8059ff6_render,
  Listvue_type_template_id_a8059ff6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var List = (List_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListAlt.vue?vue&type=template&id=1c4a2384&
var ListAltvue_type_template_id_1c4a2384_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.5 3.5H18.5C19.0523 3.5 19.5 3.94772 19.5 4.5V19.5C19.5 20.0523 19.0523 20.5 18.5 20.5H5.5C4.94772 20.5 4.5 20.0523 4.5 19.5V4.5C4.5 3.94772 4.94772 3.5 5.5 3.5ZM3 4.5C3 3.11929 4.11929 2 5.5 2H18.5C19.8807 2 21 3.11929 21 4.5V19.5C21 20.8807 19.8807 22 18.5 22H5.5C4.11929 22 3 20.8807 3 19.5V4.5ZM8.25 6.5C8.802 6.5 9.25 6.947 9.25 7.5C9.25 8.053 8.802 8.5 8.25 8.5C7.698 8.5 7.25 8.053 7.25 7.5C7.25 6.947 7.698 6.5 8.25 6.5ZM16 6.75C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H12C11.5858 8.25 11.25 7.91421 11.25 7.5C11.25 7.08579 11.5858 6.75 12 6.75H16ZM8.25 11C8.802 11 9.25 11.447 9.25 12C9.25 12.553 8.802 13 8.25 13C7.698 13 7.25 12.553 7.25 12C7.25 11.447 7.698 11 8.25 11ZM16 11.25C16.4142 11.25 16.75 11.5858 16.75 12C16.75 12.4142 16.4142 12.75 16 12.75H12C11.5858 12.75 11.25 12.4142 11.25 12C11.25 11.5858 11.5858 11.25 12 11.25H16ZM9.25 16.5C9.25 15.947 8.802 15.5 8.25 15.5C7.698 15.5 7.25 15.947 7.25 16.5C7.25 17.053 7.698 17.5 8.25 17.5C8.802 17.5 9.25 17.053 9.25 16.5ZM16.75 16.5C16.75 16.0858 16.4142 15.75 16 15.75H12C11.5858 15.75 11.25 16.0858 11.25 16.5C11.25 16.9142 11.5858 17.25 12 17.25H16C16.4142 17.25 16.75 16.9142 16.75 16.5Z"
    }
  })]);
};
var ListAltvue_type_template_id_1c4a2384_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListAlt.vue?vue&type=script&lang=ts&

/* harmony default export */ var ListAltvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListAlt.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ListAltvue_type_script_lang_ts_ = (ListAltvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListAlt.vue





/* normalize component */
;
var ListAlt_component = normalizeComponent(
  icons_ListAltvue_type_script_lang_ts_,
  ListAltvue_type_template_id_1c4a2384_render,
  ListAltvue_type_template_id_1c4a2384_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ListAlt = (ListAlt_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListBullet.vue?vue&type=template&id=8af54f6e&
var ListBulletvue_type_template_id_8af54f6e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4,18 C4.55228475,18 5,18.4477153 5,19 C5,19.5522847 4.55228475,20 4,20 C3.44771525,20 3,19.5522847 3,19 C3,18.4477153 3.44771525,18 4,18 Z M21,18.25 C21.4142136,18.25 21.75,18.5857864 21.75,19 C21.75,19.4142136 21.4142136,19.75 21,19.75 L21,19.75 L9,19.75 C8.58578644,19.75 8.25,19.4142136 8.25,19 C8.25,18.5857864 8.58578644,18.25 9,18.25 L9,18.25 Z M4,11 C4.55228475,11 5,11.4477153 5,12 C5,12.5522847 4.55228475,13 4,13 C3.44771525,13 3,12.5522847 3,12 C3,11.4477153 3.44771525,11 4,11 Z M21,11.25 C21.4142136,11.25 21.75,11.5857864 21.75,12 C21.75,12.4142136 21.4142136,12.75 21,12.75 L21,12.75 L9,12.75 C8.58578644,12.75 8.25,12.4142136 8.25,12 C8.25,11.5857864 8.58578644,11.25 9,11.25 L9,11.25 Z M4,4 C4.55228475,4 5,4.44771525 5,5 C5,5.55228475 4.55228475,6 4,6 C3.44771525,6 3,5.55228475 3,5 C3,4.44771525 3.44771525,4 4,4 Z M21,4.25 C21.4142136,4.25 21.75,4.58578644 21.75,5 C21.75,5.41421356 21.4142136,5.75 21,5.75 L21,5.75 L9,5.75 C8.58578644,5.75 8.25,5.41421356 8.25,5 C8.25,4.58578644 8.58578644,4.25 9,4.25 L9,4.25 Z"
    }
  });
};
var ListBulletvue_type_template_id_8af54f6e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListBullet.vue?vue&type=script&lang=ts&

/* harmony default export */ var ListBulletvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListBullet.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ListBulletvue_type_script_lang_ts_ = (ListBulletvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListBullet.vue





/* normalize component */
;
var ListBullet_component = normalizeComponent(
  icons_ListBulletvue_type_script_lang_ts_,
  ListBulletvue_type_template_id_8af54f6e_render,
  ListBulletvue_type_template_id_8af54f6e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ListBullet = (ListBullet_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListNumber.vue?vue&type=template&id=6923830b&
var ListNumbervue_type_template_id_6923830b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M5.75,17 C5.88807119,17 6,17.1119288 6,17.25 L6,17.25 L6,20.75 C6,20.8880712 5.88807119,21 5.75,21 L5.75,21 L3.5,21 C3.22385763,21 3,20.7761424 3,20.5 C3,20.2238576 3.22385763,20 3.5,20 L3.5,20 L5,20 L5,19.5 L4.5,19.5 C4.22385763,19.5 4,19.2761424 4,19 C4,18.7238576 4.22385763,18.5 4.5,18.5 L4.5,18.5 L5,18.5 L5,18 L3.5,18 C3.22385763,18 3,17.7761424 3,17.5 C3,17.2238576 3.22385763,17 3.5,17 L3.5,17 Z M21,18.25 C21.4142136,18.25 21.75,18.5857864 21.75,19 C21.75,19.4142136 21.4142136,19.75 21,19.75 L21,19.75 L9,19.75 C8.58578644,19.75 8.25,19.4142136 8.25,19 C8.25,18.5857864 8.58578644,18.25 9,18.25 L9,18.25 Z M5.75,10 C5.88807119,10 6,10.1119288 6,10.25 L6,10.25 L6,10.807519 C6,10.8671968 5.97865196,10.924906 5.93981415,10.9702168 L5.93981415,10.9702168 L4.2,13 L5.5,13 C5.77614237,13 6,13.2238576 6,13.5 C6,13.7761424 5.77614237,14 5.5,14 L5.5,14 L3.25,14 C3.11192881,14 3,13.8880712 3,13.75 L3,13.75 L3,13.192481 C3,13.1328032 3.02134804,13.075094 3.06018585,13.0297832 L3.06018585,13.0297832 L4.8,11 L3.5,11 C3.22385763,11 3,10.7761424 3,10.5 C3,10.2238576 3.22385763,10 3.5,10 L3.5,10 Z M21,11.25 C21.4142136,11.25 21.75,11.5857864 21.75,12 C21.75,12.4142136 21.4142136,12.75 21,12.75 L21,12.75 L9,12.75 C8.58578644,12.75 8.25,12.4142136 8.25,12 C8.25,11.5857864 8.58578644,11.25 9,11.25 L9,11.25 Z M4.75,3 C4.88807119,3 5,3.11192881 5,3.25 L5,3.25 L5,6.5 C5,6.77614237 4.77614237,7 4.5,7 C4.22385763,7 4,6.77614237 4,6.5 L4,6.5 L4,4 L3.5,4 C3.22385763,4 3,3.77614237 3,3.5 C3,3.22385763 3.22385763,3 3.5,3 L3.5,3 Z M21,4.25 C21.4142136,4.25 21.75,4.58578644 21.75,5 C21.75,5.41421356 21.4142136,5.75 21,5.75 L21,5.75 L9,5.75 C8.58578644,5.75 8.25,5.41421356 8.25,5 C8.25,4.58578644 8.58578644,4.25 9,4.25 L9,4.25 Z"
    }
  });
};
var ListNumbervue_type_template_id_6923830b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListNumber.vue?vue&type=script&lang=ts&

/* harmony default export */ var ListNumbervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListNumber.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ListNumbervue_type_script_lang_ts_ = (ListNumbervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListNumber.vue





/* normalize component */
;
var ListNumber_component = normalizeComponent(
  icons_ListNumbervue_type_script_lang_ts_,
  ListNumbervue_type_template_id_6923830b_render,
  ListNumbervue_type_template_id_6923830b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ListNumber = (ListNumber_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Link.vue?vue&type=template&id=ad6f6db8&
var Linkvue_type_template_id_ad6f6db8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.0208153,6.27081528 C10.4350288,6.27081528 10.7708153,6.60660172 10.7708153,7.02081528 C10.7708153,7.43502884 10.4350288,7.77081528 10.0208153,7.77081528 L6.52081528,7.77081528 C4.17360509,7.77081528 2.27081528,9.67360509 2.27081528,12.0208153 C2.27081528,14.3680255 4.17360509,16.2708153 6.52081528,16.2708153 L10.0208153,16.2708153 C10.4350288,16.2708153 10.7708153,16.6066017 10.7708153,17.0208153 C10.7708153,17.4350288 10.4350288,17.7708153 10.0208153,17.7708153 L6.52081528,17.7708153 C3.34517797,17.7708153 0.77081528,15.1964526 0.77081528,12.0208153 C0.77081528,8.84517797 3.34517797,6.27081528 6.52081528,6.27081528 L10.0208153,6.27081528 Z M17.5208153,6.27081528 C20.6964526,6.27081528 23.2708153,8.84517797 23.2708153,12.0208153 C23.2708153,15.1964526 20.6964526,17.7708153 17.5208153,17.7708153 L17.5208153,17.7708153 L14.0208153,17.7708153 C13.6066017,17.7708153 13.2708153,17.4350288 13.2708153,17.0208153 C13.2708153,16.6066017 13.6066017,16.2708153 14.0208153,16.2708153 L14.0208153,16.2708153 L17.5208153,16.2708153 C19.8680255,16.2708153 21.7708153,14.3680255 21.7708153,12.0208153 C21.7708153,9.67360509 19.8680255,7.77081528 17.5208153,7.77081528 L17.5208153,7.77081528 L14.0208153,7.77081528 C13.6066017,7.77081528 13.2708153,7.43502884 13.2708153,7.02081528 C13.2708153,6.60660172 13.6066017,6.27081528 14.0208153,6.27081528 L14.0208153,6.27081528 Z M17.0208153,11.2708153 C17.4350288,11.2708153 17.7708153,11.6066017 17.7708153,12.0208153 C17.7708153,12.4350288 17.4350288,12.7708153 17.0208153,12.7708153 L17.0208153,12.7708153 L7.02081528,12.7708153 C6.60660172,12.7708153 6.27081528,12.4350288 6.27081528,12.0208153 C6.27081528,11.6066017 6.60660172,11.2708153 7.02081528,11.2708153 L7.02081528,11.2708153 Z",
      "transform": "translate(12.020815, 12.020815) rotate(-45.000000) translate(-12.020815, -12.020815)"
    }
  });
};
var Linkvue_type_template_id_ad6f6db8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Link.vue?vue&type=script&lang=ts&

/* harmony default export */ var Linkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Link.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Linkvue_type_script_lang_ts_ = (Linkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Link.vue





/* normalize component */
;
var Link_component = normalizeComponent(
  icons_Linkvue_type_script_lang_ts_,
  Linkvue_type_template_id_ad6f6db8_render,
  Linkvue_type_template_id_ad6f6db8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Link = (Link_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Linkedin.vue?vue&type=template&id=b31b2dc8&
var Linkedinvue_type_template_id_b31b2dc8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M22.25 7.5C22.25 4.32436 19.6756 1.75 16.5 1.75H7.5C4.32436 1.75 1.75 4.32436 1.75 7.5V16.5C1.75 19.6756 4.32436 22.25 7.5 22.25H16.5C19.6756 22.25 22.25 19.6756 22.25 16.5V7.5ZM7.5 3.25H16.5C18.8472 3.25 20.75 5.15279 20.75 7.5V16.5C20.75 18.8472 18.8472 20.75 16.5 20.75H7.5C5.15279 20.75 3.25 18.8472 3.25 16.5V7.5C3.25 5.15279 5.15279 3.25 7.5 3.25ZM7.5 6.5C8.05228 6.5 8.5 6.94772 8.5 7.5C8.5 8.05228 8.05228 8.5 7.5 8.5C6.94772 8.5 6.5 8.05228 6.5 7.5C6.5 6.94772 6.94772 6.5 7.5 6.5ZM6.75 10.5C6.75 10.0858 7.08579 9.75 7.5 9.75C7.91421 9.75 8.25 10.0858 8.25 10.5V16.5C8.25 16.9142 7.91421 17.25 7.5 17.25C7.08579 17.25 6.75 16.9142 6.75 16.5V10.5ZM13.5 9.75C11.4289 9.75 9.75 11.4289 9.75 13.5V16.5C9.75 16.9142 10.0858 17.25 10.5 17.25C10.9142 17.25 11.25 16.9142 11.25 16.5V13.5C11.25 12.2574 12.2574 11.25 13.5 11.25C14.7426 11.25 15.75 12.2574 15.75 13.5V16.5C15.75 16.9142 16.0858 17.25 16.5 17.25C16.9142 17.25 17.25 16.9142 17.25 16.5V13.5C17.25 11.4289 15.5711 9.75 13.5 9.75Z"
    }
  });
};
var Linkedinvue_type_template_id_b31b2dc8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Linkedin.vue?vue&type=script&lang=ts&

/* harmony default export */ var Linkedinvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Linkedin.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Linkedinvue_type_script_lang_ts_ = (Linkedinvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Linkedin.vue





/* normalize component */
;
var Linkedin_component = normalizeComponent(
  icons_Linkedinvue_type_script_lang_ts_,
  Linkedinvue_type_template_id_b31b2dc8_render,
  Linkedinvue_type_template_id_b31b2dc8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Linkedin = (Linkedin_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LinkedinFilled.vue?vue&type=template&id=08b27f98&
var LinkedinFilledvue_type_template_id_08b27f98_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M5.5 6.33673C5.5 5.98221 5.64083 5.64221 5.89152 5.39152C6.1422 5.14084 6.48221 5 6.83673 5H20.1618C20.3375 4.99971 20.5115 5.03408 20.6739 5.10114C20.8363 5.1682 20.9839 5.26663 21.1082 5.39079C21.2325 5.51496 21.3311 5.66242 21.3983 5.82474C21.4655 5.98705 21.5001 6.16104 21.5 6.33673V19.6618C21.5002 19.8375 21.4657 20.0116 21.3986 20.174C21.3315 20.3364 21.233 20.4839 21.1087 20.6082C20.9845 20.7325 20.837 20.8311 20.6746 20.8983C20.5123 20.9655 20.3383 21.0001 20.1625 21H6.83673C6.66112 21 6.48724 20.9654 6.32502 20.8982C6.16279 20.831 6.0154 20.7324 5.89126 20.6082C5.76713 20.484 5.66868 20.3366 5.60154 20.1743C5.53441 20.012 5.4999 19.8381 5.5 19.6625V6.33673ZM11.8331 11.1004H13.9996V12.1884C14.3124 11.5629 15.1124 11 16.3145 11C18.6193 11 19.1655 12.2458 19.1655 14.5316V18.7658H16.8331V15.0524C16.8331 13.7505 16.5204 13.016 15.7262 13.016C14.6244 13.016 14.1662 13.808 14.1662 15.0524V18.7658H11.8331V11.1004ZM7.83309 18.6662H10.1662V11H7.83309V18.6655V18.6662ZM10.5 8.49964C10.5044 8.6994 10.4689 8.89803 10.3954 9.08387C10.322 9.2697 10.2123 9.43901 10.0725 9.58184C9.93281 9.72468 9.76596 9.83816 9.58179 9.91564C9.39761 9.99312 9.19981 10.033 9 10.033C8.80019 10.033 8.60239 9.99312 8.41821 9.91564C8.23404 9.83816 8.06719 9.72468 7.92747 9.58184C7.78774 9.43901 7.67796 9.2697 7.60455 9.08387C7.53115 8.89803 7.4956 8.6994 7.5 8.49964C7.50863 8.10753 7.67046 7.7344 7.95083 7.46014C8.23119 7.18588 8.6078 7.03231 9 7.03231C9.3922 7.03231 9.76881 7.18588 10.0492 7.46014C10.3295 7.7344 10.4914 8.10753 10.5 8.49964Z"
    }
  });
};
var LinkedinFilledvue_type_template_id_08b27f98_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/LinkedinFilled.vue?vue&type=script&lang=ts&

/* harmony default export */ var LinkedinFilledvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/LinkedinFilled.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_LinkedinFilledvue_type_script_lang_ts_ = (LinkedinFilledvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/LinkedinFilled.vue





/* normalize component */
;
var LinkedinFilled_component = normalizeComponent(
  icons_LinkedinFilledvue_type_script_lang_ts_,
  LinkedinFilledvue_type_template_id_08b27f98_render,
  LinkedinFilledvue_type_template_id_08b27f98_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var LinkedinFilled = (LinkedinFilled_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListCheck.vue?vue&type=template&id=a78d7f36&
var ListCheckvue_type_template_id_a78d7f36_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18.8 1.75c1.37 0 2.45 1.2 2.45 2.65v7.1a.75.75 0 11-1.5 0V4.4c0-.65-.45-1.15-.95-1.15H5.2c-.5 0-.95.5-.95 1.15v15.2c0 .65.45 1.15.95 1.15H12a.75.75 0 110 1.5H5.2c-1.37 0-2.45-1.2-2.45-2.65V4.4c0-1.45 1.08-2.65 2.45-2.65zm3.9 11.74a.75.75 0 011.1 1.02l-6.15 6.6-.07.07c-.5.47-1.3.44-1.76-.06l-2.12-2.28a.75.75 0 111.1-1.02l1.93 2.08zM8.25 10.5a1 1 0 110 2 1 1 0 010-2zm7.75.25a.75.75 0 110 1.5h-4a.75.75 0 110-1.5zM8.25 6.5a1 1 0 110 2 1 1 0 010-2zm7.75.25a.75.75 0 110 1.5h-4a.75.75 0 110-1.5z"
    }
  });
};
var ListCheckvue_type_template_id_a78d7f36_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ListCheck.vue?vue&type=script&lang=ts&

/* harmony default export */ var ListCheckvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListCheck.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ListCheckvue_type_script_lang_ts_ = (ListCheckvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ListCheck.vue





/* normalize component */
;
var ListCheck_component = normalizeComponent(
  icons_ListCheckvue_type_script_lang_ts_,
  ListCheckvue_type_template_id_a78d7f36_render,
  ListCheckvue_type_template_id_a78d7f36_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ListCheck = (ListCheck_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Live.vue?vue&type=template&id=3e2ae061&
var Livevue_type_template_id_3e2ae061_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M3.51407 3.47474C3.80693 3.18182 4.2818 3.18176 4.57473 3.47462C4.86766 3.76748 4.86771 4.24235 4.57485 4.53528C0.475049 8.63604 0.475049 15.2846 4.57485 19.3853C4.86771 19.6782 4.86766 20.1531 4.57473 20.446C4.2818 20.7388 3.80693 20.7388 3.51407 20.4458C-1.17136 15.7593 -1.17136 8.16126 3.51407 3.47474ZM19.3444 3.46967C19.6373 3.17678 20.1122 3.17678 20.4051 3.46967C25.0916 8.1562 25.0916 15.7544 20.4051 20.4409C20.1122 20.7338 19.6373 20.7338 19.3444 20.4409C19.0515 20.148 19.0515 19.6731 19.3444 19.3802C23.4452 15.2795 23.4452 8.63107 19.3444 4.53033C19.0515 4.23744 19.0515 3.76256 19.3444 3.46967ZM6.65573 5.80905C6.95372 5.52134 7.42852 5.52967 7.71623 5.82765C8.00394 6.12564 7.99561 6.60044 7.69762 6.88815C4.76746 9.71728 4.76746 14.2929 7.69762 17.122C7.99561 17.4098 8.00394 17.8846 7.71623 18.1825C7.42852 18.4805 6.95372 18.4889 6.65573 18.2012C3.11476 14.7823 3.11476 9.22792 6.65573 5.80905ZM16.2023 5.82177C16.4901 5.52383 16.9649 5.51557 17.2628 5.80333C20.8037 9.22319 20.8037 14.7764 17.2628 18.1963C16.9649 18.484 16.4901 18.4758 16.2023 18.1778C15.9146 17.8799 15.9228 17.4051 16.2208 17.1173C19.1511 14.2872 19.1511 9.71241 16.2208 6.88227C15.9228 6.59451 15.9146 6.11971 16.2023 5.82177ZM12 8C14.2087 8 16 9.79127 16 12C16 14.2087 14.2087 16 12 16C9.79127 16 8 14.2087 8 12C8 9.79127 9.79127 8 12 8ZM12 9.5C10.6197 9.5 9.5 10.6197 9.5 12C9.5 13.3803 10.6197 14.5 12 14.5C13.3803 14.5 14.5 13.3803 14.5 12C14.5 10.6197 13.3803 9.5 12 9.5Z"
    }
  });
};
var Livevue_type_template_id_3e2ae061_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Live.vue?vue&type=script&lang=ts&

/* harmony default export */ var Livevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Live.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Livevue_type_script_lang_ts_ = (Livevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Live.vue





/* normalize component */
;
var Live_component = normalizeComponent(
  icons_Livevue_type_script_lang_ts_,
  Livevue_type_template_id_3e2ae061_render,
  Livevue_type_template_id_3e2ae061_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Live = (Live_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Local.vue?vue&type=template&id=513bb92a&
var Localvue_type_template_id_513bb92a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C16.8325 1.25 20.75 5.16751 20.75 10C20.75 12.8932 18.5087 16.8059 14.0619 21.8447L13.9445 21.9696L13.8197 22.087C12.6809 23.0919 10.9431 22.9835 9.93812 21.8447C5.49126 16.8059 3.25 12.8932 3.25 10C3.25 5.16751 7.16751 1.25 12 1.25ZM12 2.75C7.99594 2.75 4.75 5.99594 4.75 10C4.75 12.2932 6.63328 15.6986 10.4303 20.1254L11.0628 20.8522C11.5196 21.3698 12.3095 21.4191 12.8271 20.9623L12.9372 20.8522C17.1576 16.07 19.25 12.4171 19.25 10C19.25 5.99594 16.0041 2.75 12 2.75ZM12 6C14.2087 6 16 7.79127 16 10C16 12.2087 14.2087 14 12 14C9.79127 14 8 12.2087 8 10C8 7.79127 9.79127 6 12 6ZM12 7.5C10.6197 7.5 9.5 8.6197 9.5 10C9.5 11.3803 10.6197 12.5 12 12.5C13.3803 12.5 14.5 11.3803 14.5 10C14.5 8.6197 13.3803 7.5 12 7.5Z"
    }
  });
};
var Localvue_type_template_id_513bb92a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Local.vue?vue&type=script&lang=ts&

/* harmony default export */ var Localvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Local.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Localvue_type_script_lang_ts_ = (Localvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Local.vue





/* normalize component */
;
var Local_component = normalizeComponent(
  icons_Localvue_type_script_lang_ts_,
  Localvue_type_template_id_513bb92a_render,
  Localvue_type_template_id_513bb92a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Local = (Local_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Locked.vue?vue&type=template&id=c6e829f6&
var Lockedvue_type_template_id_c6e829f6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M11.9998 0.75C14.6232 0.75 16.7498 2.87665 16.7498 5.5L16.7494 8.75H18.9952C20.514 8.75 21.7452 9.98122 21.7452 11.5L21.6352 20.5336C21.6168 22.0391 20.3911 23.25 18.8854 23.25H5.11419C3.60849 23.25 2.38276 22.0391 2.36439 20.5335L2.2546 11.5335C2.23676 10.0711 3.3638 8.86141 4.80341 8.75727L5.0044 8.75H7.24939L7.24983 5.5C7.24983 2.87665 9.37647 0.75 11.9998 0.75ZM18.9952 10.25H5.0044L4.86143 10.2581C4.23194 10.3298 3.7466 10.8681 3.7544 11.5152L3.86428 20.5152C3.87263 21.1996 4.42978 21.75 5.11419 21.75H18.8854C19.5698 21.75 20.127 21.1996 20.1353 20.5153L20.2451 11.5153L20.2388 11.3722C20.1748 10.7419 19.6424 10.25 18.9952 10.25ZM11.9998 13.25C12.414 13.25 12.7498 13.5858 12.7498 14V18C12.7498 18.4142 12.414 18.75 11.9998 18.75C11.5856 18.75 11.2498 18.4142 11.2498 18V14C11.2498 13.5858 11.5856 13.25 11.9998 13.25ZM11.9998 2.25C10.2049 2.25 8.74983 3.70507 8.74983 5.5V8.75H15.2498V5.5C15.2498 3.70507 13.7948 2.25 11.9998 2.25Z"
    }
  });
};
var Lockedvue_type_template_id_c6e829f6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Locked.vue?vue&type=script&lang=ts&

/* harmony default export */ var Lockedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Locked.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Lockedvue_type_script_lang_ts_ = (Lockedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Locked.vue





/* normalize component */
;
var Locked_component = normalizeComponent(
  icons_Lockedvue_type_script_lang_ts_,
  Lockedvue_type_template_id_c6e829f6_render,
  Lockedvue_type_template_id_c6e829f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Locked = (Locked_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Locker.vue?vue&type=template&id=41ed6aa9&
var Lockervue_type_template_id_41ed6aa9_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 .75a4.75 4.75 0 014.75 4.75v3.25H19a2.75 2.75 0 012.75 2.75l-.11 9.03a2.75 2.75 0 01-2.75 2.72H5.1a2.75 2.75 0 01-2.75-2.72l-.1-9A2.75 2.75 0 014.8 8.76l.2-.01h2.25V5.5A4.75 4.75 0 0112 .75zm7 9.5H4.86c-.63.08-1.11.62-1.1 1.27l.1 9c.01.68.57 1.23 1.25 1.23H18.9c.68 0 1.24-.55 1.25-1.23l.1-9v-.15A1.25 1.25 0 0019 10.25zm-7 3c.41 0 .75.34.75.75v4a.75.75 0 11-1.5 0v-4c0-.41.34-.75.75-.75zm0-11A3.25 3.25 0 008.75 5.5v3.25h6.5V5.5c0-1.8-1.46-3.25-3.25-3.25z"
    }
  });
};
var Lockervue_type_template_id_41ed6aa9_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Locker.vue?vue&type=script&lang=ts&

/* harmony default export */ var Lockervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Locker.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Lockervue_type_script_lang_ts_ = (Lockervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Locker.vue





/* normalize component */
;
var Locker_component = normalizeComponent(
  icons_Lockervue_type_script_lang_ts_,
  Lockervue_type_template_id_41ed6aa9_render,
  Lockervue_type_template_id_41ed6aa9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Locker = (Locker_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Location.vue?vue&type=template&id=382a020c&
var Locationvue_type_template_id_382a020c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C16.8325 1.25 20.75 5.16751 20.75 10C20.75 12.8932 18.5087 16.8059 14.0619 21.8447L13.9445 21.9696L13.8197 22.087C12.6809 23.0919 10.9431 22.9835 9.93812 21.8447C5.49126 16.8059 3.25 12.8932 3.25 10C3.25 5.16751 7.16751 1.25 12 1.25ZM12 2.75C7.99594 2.75 4.75 5.99594 4.75 10C4.75 12.2932 6.63328 15.6986 10.4303 20.1254L11.0628 20.8522C11.5196 21.3698 12.3095 21.4191 12.8271 20.9623L12.9372 20.8522C17.1576 16.07 19.25 12.4171 19.25 10C19.25 5.99594 16.0041 2.75 12 2.75ZM12 6C14.2087 6 16 7.79127 16 10C16 12.2087 14.2087 14 12 14C9.79127 14 8 12.2087 8 10C8 7.79127 9.79127 6 12 6ZM12 7.5C10.6197 7.5 9.5 8.6197 9.5 10C9.5 11.3803 10.6197 12.5 12 12.5C13.3803 12.5 14.5 11.3803 14.5 10C14.5 8.6197 13.3803 7.5 12 7.5Z"
    }
  });
};
var Locationvue_type_template_id_382a020c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Location.vue?vue&type=script&lang=ts&

/* harmony default export */ var Locationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Location.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Locationvue_type_script_lang_ts_ = (Locationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Location.vue





/* normalize component */
;
var Location_component = normalizeComponent(
  icons_Locationvue_type_script_lang_ts_,
  Locationvue_type_template_id_382a020c_render,
  Locationvue_type_template_id_382a020c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Location = (Location_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Menu.vue?vue&type=template&id=dcbe7be6&
var Menuvue_type_template_id_dcbe7be6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21 17.75C21.4142 17.75 21.75 18.0858 21.75 18.5C21.75 18.9142 21.4142 19.25 21 19.25H3C2.58579 19.25 2.25 18.9142 2.25 18.5C2.25 18.0858 2.58579 17.75 3 17.75H21ZM21 11.25C21.4142 11.25 21.75 11.5858 21.75 12C21.75 12.4142 21.4142 12.75 21 12.75H3C2.58579 12.75 2.25 12.4142 2.25 12C2.25 11.5858 2.58579 11.25 3 11.25H21ZM21 4.75C21.4142 4.75 21.75 5.08579 21.75 5.5C21.75 5.91421 21.4142 6.25 21 6.25H3C2.58579 6.25 2.25 5.91421 2.25 5.5C2.25 5.08579 2.58579 4.75 3 4.75H21Z"
    }
  });
};
var Menuvue_type_template_id_dcbe7be6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Menu.vue?vue&type=script&lang=ts&

/* harmony default export */ var Menuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Menu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Menuvue_type_script_lang_ts_ = (Menuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Menu.vue





/* normalize component */
;
var Menu_component = normalizeComponent(
  icons_Menuvue_type_script_lang_ts_,
  Menuvue_type_template_id_dcbe7be6_render,
  Menuvue_type_template_id_dcbe7be6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Menu = (Menu_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Microcertificate.vue?vue&type=template&id=628ed3e2&
var Microcertificatevue_type_template_id_628ed3e2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "m17.806 5-11.682.02A2.146 2.146 0 0 0 4.15 6.352c-.1.26-.15.537-.15.816v3.013l.06 7.02a2.18 2.18 0 0 0 1.343 1.96c.254.102.526.155.801.158h4.679a.594.594 0 0 0 .41-.179.547.547 0 0 0 .171-.407.575.575 0 0 0-.581-.577H6.244a.906.906 0 0 1-.36-.08 1 1 0 0 1-.441-.348.92.92 0 0 1-.17-.527l-.08-8.75V7.118a.89.89 0 0 1 .07-.368.994.994 0 0 1 .21-.318c.181-.179.425-.282.681-.288h11.682a.947.947 0 0 1 .801.417.989.989 0 0 1 .17.537v7.12a.535.535 0 0 0 .171.398.59.59 0 0 0 .657.133.59.59 0 0 0 .322-.325.584.584 0 0 0 .043-.226v-7.12a2.098 2.098 0 0 0-.37-1.183 2.249 2.249 0 0 0-.762-.676A2.106 2.106 0 0 0 17.882 5h-.076Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.969 9.057H7.737a.595.595 0 0 0-.42.17.583.583 0 0 0 0 .825.634.634 0 0 0 .42.169h6.232a.633.633 0 0 0 .41-.17.588.588 0 0 0 0-.825.583.583 0 0 0-.41-.169Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M15.191 11.573a2.74 2.74 0 0 0-1.512.457c-.448.298-.797.72-1.003 1.214a2.596 2.596 0 0 0-.15 1.56c.086.45.288.867.584 1.214L12.436 21l2.755-1.114L17.956 21l-.682-4.97a2.69 2.69 0 0 0 .652-1.752 2.619 2.619 0 0 0-.21-.995 2.694 2.694 0 0 0-1.473-1.471 2.904 2.904 0 0 0-1.052-.239Zm1.168 5.15a2.785 2.785 0 0 1-1.7.21 2.809 2.809 0 0 1-.635-.215l-.366 2.71 1.533-.616 1.543.617-.375-2.706Zm-1.168-.904a1.59 1.59 0 0 1-.862-.258 1.503 1.503 0 0 1-.57-.696 1.51 1.51 0 0 1 .34-1.68c.213-.22.49-.37.791-.428.303-.06.617-.03.902.089.283.12.526.316.701.567a1.563 1.563 0 0 1 .142 1.457 1.541 1.541 0 0 1-.847.835c-.19.077-.392.115-.597.114Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.737 12.15h3.116a.575.575 0 0 1 .581.577.582.582 0 0 1-.17.417.633.633 0 0 1-.411.17H7.737a.634.634 0 0 1-.42-.17.585.585 0 0 1 0-.825.591.591 0 0 1 .42-.169Z"
    }
  })]);
};
var Microcertificatevue_type_template_id_628ed3e2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Microcertificate.vue?vue&type=script&lang=ts&

/* harmony default export */ var Microcertificatevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Microcertificate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Microcertificatevue_type_script_lang_ts_ = (Microcertificatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Microcertificate.vue





/* normalize component */
;
var Microcertificate_component = normalizeComponent(
  icons_Microcertificatevue_type_script_lang_ts_,
  Microcertificatevue_type_template_id_628ed3e2_render,
  Microcertificatevue_type_template_id_628ed3e2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Microcertificate = (Microcertificate_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/MicroCertifield.vue?vue&type=template&id=46297d4a&
var MicroCertifieldvue_type_template_id_46297d4a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "width": "30",
      "height": "30",
      "viewBox": "0 0 149 149",
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('rect', {
    attrs: {
      "x": "19.5",
      "y": "33",
      "width": "77",
      "height": "50",
      "stroke": "#00E88F",
      "stroke-width": "8"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M97.5 30H18.5C17.3954 30 16.5 30.8954 16.5 32V84C16.5 85.1046 17.3954 86 18.5 86H97.5C98.6046 86 99.5 85.1046 99.5 84V32C99.5 30.8954 98.6046 30 97.5 30ZM18.5 26C15.1863 26 12.5 28.6863 12.5 32V84C12.5 87.3137 15.1863 90 18.5 90H97.5C100.814 90 103.5 87.3137 103.5 84V32C103.5 28.6863 100.814 26 97.5 26H18.5ZM57.5489 43.9271C57.8483 43.0057 59.1517 43.0057 59.4511 43.9271L62.3167 52.7467C62.4506 53.1587 62.8346 53.4377 63.2678 53.4377H72.5413C73.5101 53.4377 73.9128 54.6773 73.1291 55.2467L65.6267 60.6976C65.2762 60.9522 65.1295 61.4036 65.2634 61.8156L68.1291 70.6353C68.4284 71.5566 67.374 72.3227 66.5902 71.7533L59.0878 66.3024C58.7373 66.0478 58.2627 66.0478 57.9122 66.3024L50.4098 71.7533C49.626 72.3227 48.5716 71.5566 48.8709 70.6353L51.7366 61.8156C51.8705 61.4036 51.7238 60.9522 51.3733 60.6976L43.8709 55.2467C43.0872 54.6773 43.4899 53.4377 44.4587 53.4377H53.7322C54.1654 53.4377 54.5494 53.1587 54.6833 52.7467L57.5489 43.9271ZM28.5 38H87.5C88.6046 38 89.5 38.8954 89.5 40V77C89.5 78.1046 88.6046 79 87.5 79H28.5C27.3954 79 26.5 78.1046 26.5 77V40C26.5 38.8954 27.3954 38 28.5 38ZM22.5 40C22.5 36.6863 25.1863 34 28.5 34H87.5C90.8137 34 93.5 36.6863 93.5 40V77C93.5 80.3137 90.8137 83 87.5 83H28.5C25.1863 83 22.5 80.3137 22.5 77V40ZM31.6679 42.4453C31.9743 41.9858 32.5952 41.8616 33.0547 42.1679L40.5547 47.1679C41.0142 47.4743 41.1384 48.0952 40.8321 48.5547C40.5257 49.0142 39.9048 49.1384 39.4453 48.8321L31.9453 43.8321C31.4858 43.5257 31.3616 42.9048 31.6679 42.4453ZM31.7494 57.4718C31.1972 57.4683 30.7466 57.9132 30.7432 58.4655C30.7397 59.0178 31.1846 59.4683 31.7369 59.4718L38.2351 59.5124C38.7873 59.5159 39.2378 59.071 39.2413 58.5187C39.2448 57.9664 38.7999 57.5159 38.2476 57.5125L31.7494 57.4718ZM77.5 58.4655C77.5035 57.9132 77.954 57.4683 78.5063 57.4718L85.0044 57.5125C85.5567 57.5159 86.0016 57.9664 85.9981 58.5187C85.9947 59.071 85.5442 59.5159 84.9919 59.5124L78.4937 59.4718C77.9415 59.4683 77.4966 59.0178 77.5 58.4655ZM33.0547 74.8321C32.5952 75.1384 31.9743 75.0142 31.6679 74.5547C31.3616 74.0952 31.4858 73.4743 31.9453 73.1679L39.4453 68.1679C39.9048 67.8616 40.5257 67.9858 40.8321 68.4453C41.1384 68.9048 41.0142 69.5257 40.5547 69.8321L33.0547 74.8321ZM75.6679 68.4453C75.9743 67.9858 76.5952 67.8616 77.0547 68.1679L84.5547 73.1679C85.0142 73.4743 85.1384 74.0952 84.832 74.5547C84.5257 75.0142 83.9048 75.1384 83.4453 74.8321L75.9453 69.8321C75.4858 69.5257 75.3616 68.9048 75.6679 68.4453ZM77.0547 48.8321C76.5952 49.1384 75.9743 49.0142 75.6679 48.5547C75.3616 48.0952 75.4858 47.4743 75.9453 47.1679L83.4453 42.1679C83.9048 41.8616 84.5257 41.9858 84.832 42.4453C85.1384 42.9048 85.0142 43.5257 84.5547 43.8321L77.0547 48.8321Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M57.5489 43.9271C57.8483 43.0057 59.1517 43.0057 59.4511 43.9271L62.3167 52.7467C62.4506 53.1587 62.8346 53.4377 63.2678 53.4377H72.5413C73.5101 53.4377 73.9128 54.6773 73.1291 55.2467L65.6267 60.6976C65.2762 60.9522 65.1295 61.4036 65.2634 61.8156L68.1291 70.6353C68.4284 71.5566 67.374 72.3227 66.5902 71.7533L59.0878 66.3024C58.7373 66.0478 58.2627 66.0478 57.9122 66.3024L50.4098 71.7533C49.6261 72.3227 48.5716 71.5566 48.8709 70.6353L51.7366 61.8156C51.8705 61.4036 51.7238 60.9522 51.3733 60.6976L43.8709 55.2467C43.0872 54.6773 43.4899 53.4377 44.4587 53.4377H53.7322C54.1654 53.4377 54.5494 53.1587 54.6833 52.7467L57.5489 43.9271Z",
      "fill": "#00E88F",
      "stroke": "black",
      "stroke-width": "2"
    }
  })]);
};
var MicroCertifieldvue_type_template_id_46297d4a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/MicroCertifield.vue?vue&type=script&lang=ts&

/* harmony default export */ var MicroCertifieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/MicroCertifield.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_MicroCertifieldvue_type_script_lang_ts_ = (MicroCertifieldvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/MicroCertifield.vue





/* normalize component */
;
var MicroCertifield_component = normalizeComponent(
  icons_MicroCertifieldvue_type_script_lang_ts_,
  MicroCertifieldvue_type_template_id_46297d4a_render,
  MicroCertifieldvue_type_template_id_46297d4a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MicroCertifield = (MicroCertifield_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/MockTest.vue?vue&type=template&id=4acbfc4a&
var MockTestvue_type_template_id_4acbfc4a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('mask', {
    attrs: {
      "id": "MockTest",
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.5 13C19.8545 13 21.0946 13.4896 22.053 14.3015L22.5303 13.8232C22.8232 13.5303 23.2981 13.5303 23.591 13.8232C23.8839 14.1161 23.8839 14.591 23.591 14.8839L23.056 15.418C23.6519 16.2972 24 17.3579 24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5C13 15.4624 15.4624 13 18.5 13ZM18.5 14.5C16.2909 14.5 14.5 16.2909 14.5 18.5C14.5 20.7091 16.2909 22.5 18.5 22.5C20.7091 22.5 22.5 20.7091 22.5 18.5C22.5 16.2909 20.7091 14.5 18.5 14.5ZM18.8 1.75C20.1728 1.75 21.25 2.95389 21.25 4.4V7.5C21.25 7.91421 20.9142 8.25 20.5 8.25C20.0858 8.25 19.75 7.91421 19.75 7.5V4.4C19.75 3.74743 19.3049 3.25 18.8 3.25H5.2C4.69507 3.25 4.25 3.74743 4.25 4.4V19.6C4.25 20.2526 4.69507 20.75 5.2 20.75H9.8C10.2142 20.75 10.55 21.0858 10.55 21.5C10.55 21.9142 10.2142 22.25 9.8 22.25H5.2C3.82716 22.25 2.75 21.0461 2.75 19.6V4.4C2.75 2.95389 3.82716 1.75 5.2 1.75H18.8ZM18.5 16.25C18.9142 16.25 19.25 16.5858 19.25 17V19C19.25 19.4142 18.9142 19.75 18.5 19.75C18.0858 19.75 17.75 19.4142 17.75 19V17C17.75 16.5858 18.0858 16.25 18.5 16.25ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5C12.75 11.9142 12.4142 12.25 12 12.25H8C7.58579 12.25 7.25 11.9142 7.25 11.5C7.25 11.0858 7.58579 10.75 8 10.75H12ZM19.5 10.75C19.9142 10.75 20.25 11.0858 20.25 11.5C20.25 11.9142 19.9142 12.25 19.5 12.25H17.5C17.0858 12.25 16.75 11.9142 16.75 11.5C16.75 11.0858 17.0858 10.75 17.5 10.75H19.5ZM16 6.75C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H8C7.58579 8.25 7.25 7.91421 7.25 7.5C7.25 7.08579 7.58579 6.75 8 6.75H16Z"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#MockTest)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M18.5 13C19.8545 13 21.0946 13.4896 22.053 14.3015L22.5303 13.8232C22.8232 13.5303 23.2981 13.5303 23.591 13.8232C23.8839 14.1161 23.8839 14.591 23.591 14.8839L23.056 15.418C23.6519 16.2972 24 17.3579 24 18.5C24 21.5376 21.5376 24 18.5 24C15.4624 24 13 21.5376 13 18.5C13 15.4624 15.4624 13 18.5 13ZM18.5 14.5C16.2909 14.5 14.5 16.2909 14.5 18.5C14.5 20.7091 16.2909 22.5 18.5 22.5C20.7091 22.5 22.5 20.7091 22.5 18.5C22.5 16.2909 20.7091 14.5 18.5 14.5ZM18.8 1.75C20.1728 1.75 21.25 2.95389 21.25 4.4V7.5C21.25 7.91421 20.9142 8.25 20.5 8.25C20.0858 8.25 19.75 7.91421 19.75 7.5V4.4C19.75 3.74743 19.3049 3.25 18.8 3.25H5.2C4.69507 3.25 4.25 3.74743 4.25 4.4V19.6C4.25 20.2526 4.69507 20.75 5.2 20.75H9.8C10.2142 20.75 10.55 21.0858 10.55 21.5C10.55 21.9142 10.2142 22.25 9.8 22.25H5.2C3.82716 22.25 2.75 21.0461 2.75 19.6V4.4C2.75 2.95389 3.82716 1.75 5.2 1.75H18.8ZM18.5 16.25C18.9142 16.25 19.25 16.5858 19.25 17V19C19.25 19.4142 18.9142 19.75 18.5 19.75C18.0858 19.75 17.75 19.4142 17.75 19V17C17.75 16.5858 18.0858 16.25 18.5 16.25ZM12 10.75C12.4142 10.75 12.75 11.0858 12.75 11.5C12.75 11.9142 12.4142 12.25 12 12.25H8C7.58579 12.25 7.25 11.9142 7.25 11.5C7.25 11.0858 7.58579 10.75 8 10.75H12ZM19.5 10.75C19.9142 10.75 20.25 11.0858 20.25 11.5C20.25 11.9142 19.9142 12.25 19.5 12.25H17.5C17.0858 12.25 16.75 11.9142 16.75 11.5C16.75 11.0858 17.0858 10.75 17.5 10.75H19.5ZM16 6.75C16.4142 6.75 16.75 7.08579 16.75 7.5C16.75 7.91421 16.4142 8.25 16 8.25H8C7.58579 8.25 7.25 7.91421 7.25 7.5C7.25 7.08579 7.58579 6.75 8 6.75H16Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0 0H24V24H0V0Z"
    }
  })])]);
};
var MockTestvue_type_template_id_4acbfc4a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/MockTest.vue?vue&type=script&lang=ts&

/* harmony default export */ var MockTestvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/MockTest.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_MockTestvue_type_script_lang_ts_ = (MockTestvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/MockTest.vue





/* normalize component */
;
var MockTest_component = normalizeComponent(
  icons_MockTestvue_type_script_lang_ts_,
  MockTestvue_type_template_id_4acbfc4a_render,
  MockTestvue_type_template_id_4acbfc4a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MockTest = (MockTest_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/More.vue?vue&type=template&id=5aa3fc1d&
var Morevue_type_template_id_5aa3fc1d_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 16c1.519 0 2.75 1.231 2.75 2.75S13.519 21.5 12 21.5s-2.75-1.231-2.75-2.75S10.481 16 12 16zm0 1.5c-.69 0-1.25.56-1.25 1.25S11.31 20 12 20s1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm0-8.25c1.519 0 2.75 1.231 2.75 2.75s-1.231 2.75-2.75 2.75S9.25 13.519 9.25 12 10.481 9.25 12 9.25zm0 1.5c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm0-8.25c1.519 0 2.75 1.231 2.75 2.75S13.519 8 12 8 9.25 6.769 9.25 5.25 10.481 2.5 12 2.5zM12 4c-.69 0-1.25.56-1.25 1.25S11.31 6.5 12 6.5s1.25-.56 1.25-1.25S12.69 4 12 4z"
    }
  });
};
var Morevue_type_template_id_5aa3fc1d_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/More.vue?vue&type=script&lang=ts&

/* harmony default export */ var Morevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/More.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Morevue_type_script_lang_ts_ = (Morevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/More.vue





/* normalize component */
;
var More_component = normalizeComponent(
  icons_Morevue_type_script_lang_ts_,
  Morevue_type_template_id_5aa3fc1d_render,
  Morevue_type_template_id_5aa3fc1d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var More = (More_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Notes.vue?vue&type=template&id=74d837e9&
var Notesvue_type_template_id_74d837e9_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19.5 21.25C19.9142 21.25 20.25 21.5858 20.25 22C20.25 22.4142 19.9142 22.75 19.5 22.75H3.5C3.08579 22.75 2.75 22.4142 2.75 22C2.75 21.5858 3.08579 21.25 3.5 21.25H19.5ZM15.1682 1.94492C15.9492 1.16387 17.2155 1.16387 17.9966 1.94492L20.5551 4.50344C21.3362 5.28448 21.3362 6.55081 20.5551 7.33186L8.88523 19.0017C8.51016 19.3768 8.00145 19.5875 7.47102 19.5875H4.6625C3.696 19.5875 2.9125 18.804 2.9125 17.8375V15.029L2.92024 14.8532C2.96135 14.3872 3.16489 13.9482 3.49829 13.6148L15.1682 1.94492ZM12.625 6.60913L4.55895 14.6755C4.46518 14.7692 4.4125 14.8964 4.4125 15.029V17.8375C4.4125 17.9756 4.52443 18.0875 4.6625 18.0875H7.47102C7.60363 18.0875 7.7308 18.0348 7.82457 17.9411L15.89 9.87413L12.625 6.60913ZM16.9359 3.00558C16.7407 2.81032 16.4241 2.81032 16.2288 3.00558L13.686 5.54813L16.951 8.81313L19.4944 6.2712C19.668 6.09764 19.6873 5.82821 19.5523 5.63334L19.4944 5.5641L16.9359 3.00558Z"
    }
  });
};
var Notesvue_type_template_id_74d837e9_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Notes.vue?vue&type=script&lang=ts&

/* harmony default export */ var Notesvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Notes.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Notesvue_type_script_lang_ts_ = (Notesvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Notes.vue





/* normalize component */
;
var Notes_component = normalizeComponent(
  icons_Notesvue_type_script_lang_ts_,
  Notesvue_type_template_id_74d837e9_render,
  Notesvue_type_template_id_74d837e9_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notes = (Notes_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Notification.vue?vue&type=template&id=3c3a21aa&
var Notificationvue_type_template_id_3c3a21aa_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.01 21.01C10.01 22.11 10.9 23 12 23C13.1 23 13.99 22.11 13.99 21.01H10.01ZM12 6C14.76 6 17 8.24 17 11V18H7V11C7 8.24 9.24 6 12 6ZM12 1.5C11.17 1.5 10.5 2.17 10.5 3V4.17C7.36 4.85 5 7.65 5 11V17L3 19V20H21V19L19 17V11C19 7.65 16.64 4.85 13.5 4.17V3C13.5 2.17 12.83 1.5 12 1.5Z"
    }
  });
};
var Notificationvue_type_template_id_3c3a21aa_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Notification.vue?vue&type=script&lang=ts&

/* harmony default export */ var Notificationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Notification.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Notificationvue_type_script_lang_ts_ = (Notificationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Notification.vue





/* normalize component */
;
var Notification_component = normalizeComponent(
  icons_Notificationvue_type_script_lang_ts_,
  Notificationvue_type_template_id_3c3a21aa_render,
  Notificationvue_type_template_id_3c3a21aa_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notification = (Notification_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/NotificationAlt.vue?vue&type=template&id=ab6e55d6&
var NotificationAltvue_type_template_id_ab6e55d6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 3c4.2 0 7.7 3.3 7.9 7.5l.1 3.1.5.5a4 4 0 011 3.8 2.8 2.8 0 01-2.7 2.1h-3a3.8 3.8 0 01-7.5 0H5.2c-1.3 0-2.4-.9-2.7-2.1a4 4 0 011-3.8l.5-.5.1-3.1A7.9 7.9 0 0112 3zm2.2 17H9.8a2.3 2.3 0 004.4 0zM12 4.5a6.4 6.4 0 00-6.4 6l-.1 3.2c0 .3-.2.7-.4 1l-.5.5c-.6.6-.8 1.5-.6 2.3 0 .6.6 1 1.2 1h13.6c.6 0 1.1-.4 1.2-1 .2-.8 0-1.7-.6-2.3l-.5-.6c-.2-.2-.4-.6-.4-1l-.1-3c-.2-3.4-3-6.1-6.4-6.1zm2-3.8a.8.8 0 010 1.6h-4a.8.8 0 010-1.5h4z"
    }
  });
};
var NotificationAltvue_type_template_id_ab6e55d6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/NotificationAlt.vue?vue&type=script&lang=ts&

/* harmony default export */ var NotificationAltvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/NotificationAlt.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_NotificationAltvue_type_script_lang_ts_ = (NotificationAltvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/NotificationAlt.vue





/* normalize component */
;
var NotificationAlt_component = normalizeComponent(
  icons_NotificationAltvue_type_script_lang_ts_,
  NotificationAltvue_type_template_id_ab6e55d6_render,
  NotificationAltvue_type_template_id_ab6e55d6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationAlt = (NotificationAlt_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/NotificationAltSelected.vue?vue&type=template&id=6b3d9545&
var NotificationAltSelectedvue_type_template_id_6b3d9545_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "m12 2.4c4.5 0 8.3 3.6 8.5 8.1l0.1 3.3 0.5 0.5c1 1.1 1.4 2.6 1.1 4-0.3 1.3-1.5 2.3-2.9 2.3h-3.3c-0.2 1.9-2 3.4-4 3.4s-3.8-1.5-4-3.4h-3.3c-1.4 0-2.6-1-2.9-2.3-0.3-1.4 0.1-2.9 1.1-4l0.5-0.5 0.1-3.3c0.3-4.6 4-8.1 8.5-8.1zm2.4 18.4h-4.8c0.2 1.1 1.2 1.8 2.4 1.8s2.2-0.8 2.4-1.8zm-0.2-20.8c0.4 0 0.8 0.3 0.8 0.9 0 0.4-0.3 0.9-0.9 0.9h-4.3c-0.4-0.1-0.8-0.4-0.8-0.9 0.1-0.6 0.4-0.9 0.8-0.9h4.4z"
    }
  });
};
var NotificationAltSelectedvue_type_template_id_6b3d9545_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/NotificationAltSelected.vue?vue&type=script&lang=ts&

/* harmony default export */ var NotificationAltSelectedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/NotificationAltSelected.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_NotificationAltSelectedvue_type_script_lang_ts_ = (NotificationAltSelectedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/NotificationAltSelected.vue





/* normalize component */
;
var NotificationAltSelected_component = normalizeComponent(
  icons_NotificationAltSelectedvue_type_script_lang_ts_,
  NotificationAltSelectedvue_type_template_id_6b3d9545_render,
  NotificationAltSelectedvue_type_template_id_6b3d9545_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotificationAltSelected = (NotificationAltSelected_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Outline.vue?vue&type=template&id=1495b72f&
var Outlinevue_type_template_id_1495b72f_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25C17.9392 1.25 22.75 6.06079 22.75 12C22.75 17.9392 17.9392 22.75 12 22.75C6.06079 22.75 1.25 17.9392 1.25 12C1.25 6.06079 6.06079 1.25 12 1.25ZM12 2.75C6.88921 2.75 2.75 6.88921 2.75 12C2.75 17.1108 6.88921 21.25 12 21.25C17.1108 21.25 21.25 17.1108 21.25 12C21.25 6.88921 17.1108 2.75 12 2.75ZM12.0006 10.25C12.4148 10.25 12.7506 10.5858 12.7506 11V16C12.7506 16.4142 12.4148 16.75 12.0006 16.75C11.5864 16.75 11.2506 16.4142 11.2506 16V11C11.2506 10.5858 11.5864 10.25 12.0006 10.25ZM12 7C12.5523 7 13 7.44772 13 8C13 8.55228 12.5523 9 12 9C11.4477 9 11 8.55228 11 8C11 7.44772 11.4477 7 12 7Z"
    }
  });
};
var Outlinevue_type_template_id_1495b72f_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Outline.vue?vue&type=script&lang=ts&

/* harmony default export */ var Outlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Outline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Outlinevue_type_script_lang_ts_ = (Outlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Outline.vue





/* normalize component */
;
var Outline_component = normalizeComponent(
  icons_Outlinevue_type_script_lang_ts_,
  Outlinevue_type_template_id_1495b72f_render,
  Outlinevue_type_template_id_1495b72f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Outline = (Outline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/OpenInNew.vue?vue&type=template&id=7f44ed6b&
var OpenInNewvue_type_template_id_7f44ed6b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21.73 7.377a.647.647 0 0 1-.643.666.675.675 0 0 1-.67-.662l-.059-2.913-5.396 5.587a.65.65 0 0 1-.86.062l-.069-.059a.67.67 0 0 1-.02-.94l5.268-5.454-2.618.008a.674.674 0 0 1-.661-.564l-.01-.099a.647.647 0 0 1 .644-.666l3.897-.011a1.125 1.125 0 0 1 1.117 1.104l.08 3.941ZM6.448 4.433h5.618a.68.68 0 0 0 0-1.36H6.447c-1.475 0-2.67 1.116-2.67 2.492v12.009c0 1.376 1.195 2.492 2.67 2.492h11.652c1.475 0 2.67-1.116 2.67-2.492V11.94c0-.376-.326-.68-.728-.68-.402 0-.728.304-.728.68v5.634c0 .626-.544 1.133-1.214 1.133H6.447c-.67 0-1.214-.507-1.214-1.133V5.565c0-.625.543-1.132 1.214-1.132ZM.772 6.654c.427 0 .773.342.773.765v13.11c0 .986.807 1.784 1.802 1.784h12.874c.426 0 .772.343.772.765a.768.768 0 0 1-.772.764H3.347C1.5 23.842 0 22.36 0 20.53V7.42c0-.423.346-.765.772-.765Z"
    }
  });
};
var OpenInNewvue_type_template_id_7f44ed6b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/OpenInNew.vue?vue&type=script&lang=ts&

/* harmony default export */ var OpenInNewvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/OpenInNew.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_OpenInNewvue_type_script_lang_ts_ = (OpenInNewvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/OpenInNew.vue





/* normalize component */
;
var OpenInNew_component = normalizeComponent(
  icons_OpenInNewvue_type_script_lang_ts_,
  OpenInNewvue_type_template_id_7f44ed6b_render,
  OpenInNewvue_type_template_id_7f44ed6b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var OpenInNew = (OpenInNew_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Pdf.vue?vue&type=template&id=d45ddc36&
var Pdfvue_type_template_id_d45ddc36_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM20 16H8V4H20V16ZM4 6H2V20C2 21.1 2.9 22 4 22H18V20H4V6ZM16 12V9C16 8.45 15.55 8 15 8H13V13H15C15.55 13 16 12.55 16 12ZM14 9H15V12H14V9ZM18 11H19V10H18V9H19V8H17V13H18V11ZM10 11H11C11.55 11 12 10.55 12 10V9C12 8.45 11.55 8 11 8H9V13H10V11ZM10 9H11V10H10V9Z"
    }
  });
};
var Pdfvue_type_template_id_d45ddc36_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Pdf.vue?vue&type=script&lang=ts&

/* harmony default export */ var Pdfvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Pdf.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Pdfvue_type_script_lang_ts_ = (Pdfvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Pdf.vue





/* normalize component */
;
var Pdf_component = normalizeComponent(
  icons_Pdfvue_type_script_lang_ts_,
  Pdfvue_type_template_id_d45ddc36_render,
  Pdfvue_type_template_id_d45ddc36_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Pdf = (Pdf_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PdfFile.vue?vue&type=template&id=609e9e0a&
var PdfFilevue_type_template_id_609e9e0a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.39 1.333c.31 0 .607.123.825.342l3.277 3.276c.218.219.341.516.341.825v7.39C14.833 14.18 14.013 15 13 15H4.333A1.833 1.833 0 0 1 2.5 13.167v-10c0-1.013.82-1.834 1.833-1.834h6.057zm-.723 1H4.333a.833.833 0 0 0-.833.834v10c0 .46.373.833.833.833H13c.46 0 .833-.373.833-.833V6.333H10.5a.833.833 0 0 1-.829-.748L9.667 5.5V2.333zm3.792 3l-2.792-2.792v2.792h2.792z M4.5 7.333v3.342h.7V9.74h.509c.742 0 1.241-.466 1.241-1.204 0-.737-.495-1.204-1.237-1.204H4.5zm.7 1.736V8.005h.457c.36 0 .579.182.579.532 0 .34-.22.532-.583.532H5.2zM7.348 7.333v3.342h1.158c1.026 0 1.684-.612 1.684-1.666 0-1.046-.653-1.676-1.68-1.676H7.348zm.7 2.67V8.005h.416c.597 0 1.008.322 1.008 1.004 0 .695-.416.994-1.013.994h-.41zM12.693 7.333h-2.095v3.342h.7v-1.28h1.143v-.671h-1.143v-.719h1.395v-.672z",
      "transform": "scale(1.5) translate(-0.5)"
    }
  });
};
var PdfFilevue_type_template_id_609e9e0a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PdfFile.vue?vue&type=script&lang=ts&

/* harmony default export */ var PdfFilevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/PdfFile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_PdfFilevue_type_script_lang_ts_ = (PdfFilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/PdfFile.vue





/* normalize component */
;
var PdfFile_component = normalizeComponent(
  icons_PdfFilevue_type_script_lang_ts_,
  PdfFilevue_type_template_id_609e9e0a_render,
  PdfFilevue_type_template_id_609e9e0a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PdfFile = (PdfFile_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Pix.vue?vue&type=template&id=6ae3d3a0&
var Pixvue_type_template_id_6ae3d3a0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.7173 18.4577C17.7735 18.4577 16.8879 18.1011 16.22 17.4449L12.6193 13.9069C12.3724 13.6644 11.9223 13.6644 11.6755 13.9069L8.06027 17.4591C7.39239 18.1154 6.50674 18.472 5.563 18.472H4.85156L9.41055 22.9515C10.8334 24.3495 13.1419 24.3495 14.5648 22.9515L19.1383 18.4577H18.7173Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.57192 5.528C6.51566 5.528 7.40132 5.88464 8.06919 6.54086L11.6844 10.093C11.9458 10.3498 12.3668 10.3498 12.6282 10.093L16.2289 6.55513C16.8968 5.89891 17.7824 5.54226 18.7262 5.54226H19.1618L14.5883 1.04854C13.1654 -0.349512 10.8569 -0.349512 9.43399 1.04854L4.875 5.528H5.57192Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M22.9329 9.47312L20.1742 6.76262C20.1162 6.79115 20.0436 6.80542 19.971 6.80542H18.7078C18.0544 6.80542 17.4156 7.0622 16.9655 7.51871L13.3648 11.0566C13.0309 11.3847 12.5808 11.5559 12.1452 11.5559C11.7096 11.5559 11.2595 11.3847 10.9256 11.0566L7.31034 7.50445C6.84573 7.04794 6.22141 6.79116 5.56806 6.79116H4.02904C3.95645 6.79116 3.89837 6.77689 3.8403 6.74836L1.06715 9.47312C-0.355717 10.8712 -0.355717 13.1394 1.06715 14.5375L3.8403 17.2622C3.89837 17.2337 3.95645 17.2194 4.02904 17.2194H5.56806C6.22141 17.2194 6.84573 16.9627 7.31034 16.5062L10.9256 12.954C11.5789 12.312 12.7114 12.312 13.3648 12.954L16.9655 16.4919C17.4301 16.9484 18.0544 17.2052 18.7078 17.2052H19.971C20.0436 17.2052 20.1016 17.2194 20.1742 17.248L22.9329 14.5375C24.3557 13.1394 24.3557 10.8712 22.9329 9.47312Z"
    }
  })]);
};
var Pixvue_type_template_id_6ae3d3a0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Pix.vue?vue&type=script&lang=ts&

/* harmony default export */ var Pixvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Pix.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Pixvue_type_script_lang_ts_ = (Pixvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Pix.vue





/* normalize component */
;
var Pix_component = normalizeComponent(
  icons_Pixvue_type_script_lang_ts_,
  Pixvue_type_template_id_6ae3d3a0_render,
  Pixvue_type_template_id_6ae3d3a0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Pix = (Pix_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Play.vue?vue&type=template&id=21f41628&
var Playvue_type_template_id_21f41628_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25a10.75 10.75 0 110 21.5 10.75 10.75 0 010-21.5zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm-1.5 4.5c.27 0 .53.09.75.25l4.67 3.5a1.25 1.25 0 010 2l-4.67 3.5a1.25 1.25 0 01-2-.87V8.5c0-.69.56-1.25 1.25-1.25zM10.75 9v6l4-3-4-3z"
    }
  });
};
var Playvue_type_template_id_21f41628_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Play.vue?vue&type=script&lang=ts&

/* harmony default export */ var Playvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Play.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Playvue_type_script_lang_ts_ = (Playvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Play.vue





/* normalize component */
;
var Play_component = normalizeComponent(
  icons_Playvue_type_script_lang_ts_,
  Playvue_type_template_id_21f41628_render,
  Playvue_type_template_id_21f41628_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Play = (Play_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Phone.vue?vue&type=template&id=f380c3f8&
var Phonevue_type_template_id_f380c3f8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21.7296 20.1411L21.8677 19.9911C23.0496 18.7718 23.0455 17.0714 21.8484 15.8799L19.3637 13.4066C18.8092 12.8236 18.0891 12.4985 17.3056 12.4985C16.549 12.4985 15.8367 12.82 15.2474 13.4066L14.2013 14.448L13.8649 14.2655C12.6818 13.5256 11.5225 12.4724 10.4083 11.1092C10.0211 10.6274 9.7368 10.216 9.52284 9.82426L10.5717 8.78601C11.166 8.19447 11.5094 7.46091 11.5094 6.70868C11.5094 5.94783 11.1818 5.23856 10.5717 4.63135L9.09371 3.13008L8.9931 3.01677C8.7925 2.79812 8.59137 2.59159 8.38986 2.39634L8.08735 2.11184C7.54161 1.56761 6.82787 1.25 6.07668 1.25C5.33286 1.25 4.62642 1.56071 4.03309 2.12022L2.46561 3.6801C1.76255 4.37992 1.35484 5.23586 1.2681 6.2144C1.17869 7.43688 1.40693 8.52169 1.88168 9.86063C2.6327 11.9041 3.7759 13.8086 5.45267 15.8213C7.49467 18.2458 9.93945 20.1481 12.7498 21.5097C14.2315 22.23 15.5587 22.6605 16.9969 22.7486L17.3295 22.75C18.4855 22.75 19.5083 22.341 20.2992 21.5594L20.4627 21.3901C20.7069 21.1032 20.9357 20.8703 21.2275 20.604C21.3801 20.4883 21.5486 20.3323 21.7296 20.1411ZM13.6437 15.8442L13.9585 16.0089C14.2529 16.1848 14.6291 16.1385 14.8722 15.8966L16.3056 14.4697C16.6252 14.1516 16.9644 13.9985 17.3056 13.9985C17.6676 13.9985 17.999 14.1481 18.2913 14.4552L20.7902 16.943C21.3663 17.5164 21.4023 18.2248 20.8926 18.8341L20.7599 18.9796C20.5784 19.1829 20.4226 19.3332 20.2629 19.4569C19.9427 19.7463 19.6989 19.9884 19.4842 20.231L19.3806 20.3507C18.8305 20.9556 18.1497 21.25 17.3295 21.25H17.0428C15.8817 21.1775 14.7264 20.8027 13.4047 20.1602C10.7831 18.8901 8.50637 17.1185 6.60254 14.8581C5.03324 12.9744 3.97813 11.2166 3.29252 9.35125C2.88427 8.19972 2.69328 7.29195 2.76318 6.33527C2.81748 5.72366 3.06873 5.19619 3.52382 4.74321L5.07675 3.19743C5.38992 2.90248 5.7366 2.75 6.07668 2.75C6.41569 2.75 6.75486 2.90093 7.05273 3.19743C7.34696 3.46685 7.61825 3.73689 7.86633 4.00628L7.94269 4.09423L8.21413 4.37708L8.29385 4.45661L9.50839 5.68929C9.85407 6.03343 10.0094 6.36965 10.0094 6.70868C10.0094 7.03588 9.83982 7.39812 9.51353 7.72291L8.55071 8.67727C8.38408 8.8398 8.24845 8.96894 8.09868 9.10808C7.86722 9.32312 7.79533 9.66016 7.91892 9.95093C8.20689 10.6284 8.61839 11.2765 9.24302 12.0537C10.4607 13.5436 11.7418 14.7073 13.1346 15.5738L13.3836 15.711C13.4818 15.7657 13.5603 15.8066 13.6437 15.8442Z"
    }
  });
};
var Phonevue_type_template_id_f380c3f8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Phone.vue?vue&type=script&lang=ts&

/* harmony default export */ var Phonevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Phone.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Phonevue_type_script_lang_ts_ = (Phonevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Phone.vue





/* normalize component */
;
var Phone_component = normalizeComponent(
  icons_Phonevue_type_script_lang_ts_,
  Phonevue_type_template_id_f380c3f8_render,
  Phonevue_type_template_id_f380c3f8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Phone = (Phone_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Playlist.vue?vue&type=template&id=534f35da&
var Playlistvue_type_template_id_534f35da_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "id": "prefix__a",
      "d": "M21 9.25c1.519 0 2.75 1.231 2.75 2.75v8c0 1.519-1.231\n2.75-2.75 2.75H3C1.481 22.75.25 21.519.25 20v-8c0-1.519 1.231-2.75\n2.75-2.75h18zm0 1.5H3c-.69 0-1.25.56-1.25 1.25v8c0 .69.56 1.25 1.25\n1.25h18c.69 0 1.25-.56 1.25-1.25v-8c0-.69-.56-1.25-1.25-1.25zm-2-5.5c.414 0\n.75.336.75.75s-.336.75-.75.75H5c-.414\n0-.75-.336-.75-.75s.336-.75.75-.75zm-3-4c.414 0\n.75.336.75.75s-.336.75-.75.75H8c-.414 0-.75-.336-.75-.75s.336-.75.75-.75z"
    }
  });
};
var Playlistvue_type_template_id_534f35da_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Playlist.vue?vue&type=script&lang=ts&

/* harmony default export */ var Playlistvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Playlist.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Playlistvue_type_script_lang_ts_ = (Playlistvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Playlist.vue





/* normalize component */
;
var Playlist_component = normalizeComponent(
  icons_Playlistvue_type_script_lang_ts_,
  Playlistvue_type_template_id_534f35da_render,
  Playlistvue_type_template_id_534f35da_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Playlist = (Playlist_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PlayArrow.vue?vue&type=template&id=641134e4&
var PlayArrowvue_type_template_id_641134e4_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M5.3 4.7v14.6a2.25 2.25 0 003.43 1.9l11.67-7.3a2.25 2.25 0 000-3.8L8.73 2.8A2.25 2.25 0 005.3 4.53v.18zm1.5 0a.75.75 0 011.14-.63l11.67 7.3a.75.75 0 010 1.27L7.94 19.93a.75.75 0 01-1.15-.64V4.71z"
    }
  });
};
var PlayArrowvue_type_template_id_641134e4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PlayArrow.vue?vue&type=script&lang=ts&

/* harmony default export */ var PlayArrowvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/PlayArrow.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_PlayArrowvue_type_script_lang_ts_ = (PlayArrowvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/PlayArrow.vue





/* normalize component */
;
var PlayArrow_component = normalizeComponent(
  icons_PlayArrowvue_type_script_lang_ts_,
  PlayArrowvue_type_template_id_641134e4_render,
  PlayArrowvue_type_template_id_641134e4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlayArrow = (PlayArrow_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/QuestionsAndAnswers.vue?vue&type=template&id=53029f14&
var QuestionsAndAnswersvue_type_template_id_53029f14_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6ZM17 12V3C17 2.45 16.55 2 16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12Z"
    }
  });
};
var QuestionsAndAnswersvue_type_template_id_53029f14_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/QuestionsAndAnswers.vue?vue&type=script&lang=ts&

/* harmony default export */ var QuestionsAndAnswersvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/QuestionsAndAnswers.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_QuestionsAndAnswersvue_type_script_lang_ts_ = (QuestionsAndAnswersvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/QuestionsAndAnswers.vue





/* normalize component */
;
var QuestionsAndAnswers_component = normalizeComponent(
  icons_QuestionsAndAnswersvue_type_script_lang_ts_,
  QuestionsAndAnswersvue_type_template_id_53029f14_render,
  QuestionsAndAnswersvue_type_template_id_53029f14_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var QuestionsAndAnswers = (QuestionsAndAnswers_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Replay.vue?vue&type=template&id=1291629c&
var Replayvue_type_template_id_1291629c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.1 2.46A9.75 9.75 0 113.6 16.7a.75.75 0 111.3-.72 8.25 8.25 0 10-.76-6.02l.01-.05 2.2-1.02a.75.75 0 01.94.27l.05.09c.18.38.02.82-.36 1l-3.84 1.79a.75.75 0 01-1-.36L.34 7.83a.75.75 0 111.37-.63l1.02 2.2a9.75 9.75 0 017.38-6.94z"
    }
  });
};
var Replayvue_type_template_id_1291629c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Replay.vue?vue&type=script&lang=ts&

/* harmony default export */ var Replayvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Replay.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Replayvue_type_script_lang_ts_ = (Replayvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Replay.vue





/* normalize component */
;
var Replay_component = normalizeComponent(
  icons_Replayvue_type_script_lang_ts_,
  Replayvue_type_template_id_1291629c_render,
  Replayvue_type_template_id_1291629c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Replay = (Replay_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Reply.vue?vue&type=template&id=1c19db34&
var Replyvue_type_template_id_1c19db34_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z"
    }
  });
};
var Replyvue_type_template_id_1c19db34_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Reply.vue?vue&type=script&lang=ts&

/* harmony default export */ var Replyvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Reply.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Replyvue_type_script_lang_ts_ = (Replyvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Reply.vue





/* normalize component */
;
var Reply_component = normalizeComponent(
  icons_Replyvue_type_script_lang_ts_,
  Replyvue_type_template_id_1c19db34_render,
  Replyvue_type_template_id_1c19db34_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Reply = (Reply_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Report.vue?vue&type=template&id=1b0ff867&
var Reportvue_type_template_id_1b0ff867_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M3.75 21.5C3.75 21.9142 3.41421 22.25 3 22.25C2.58579 22.25 2.25 21.9142 2.25 21.5V3.66667C2.25 2.61079 3.11079 1.75 4.16667 1.75H12.5433C13.4588 1.75 14.2482 2.39746 14.4221 3.28625L14.5815 4.08333H19.3333C20.3892 4.08333 21.25 4.94412 21.25 6V15.3333C21.25 16.3892 20.3892 17.25 19.3333 17.25H13.29C12.3704 17.25 11.5828 16.6097 11.4112 15.7138L11.2518 14.9167L3.75 14.916V21.5ZM3.75 13.4167H11.4568C12.0526 13.4167 12.5656 13.8372 12.6825 14.4215L12.8833 15.4256C12.9197 15.6157 13.0849 15.75 13.29 15.75H19.3333C19.5608 15.75 19.75 15.5608 19.75 15.3333V6C19.75 5.77255 19.5608 5.58333 19.3333 5.58333H14.3766C13.7807 5.58333 13.2677 5.16276 13.1508 4.57848L12.9506 3.57734C12.9141 3.39068 12.7426 3.25 12.5433 3.25H4.16667C3.93921 3.25 3.75 3.43921 3.75 3.66667V13.4167Z"
    }
  });
};
var Reportvue_type_template_id_1b0ff867_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Report.vue?vue&type=script&lang=ts&

/* harmony default export */ var Reportvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Report.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Reportvue_type_script_lang_ts_ = (Reportvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Report.vue





/* normalize component */
;
var Report_component = normalizeComponent(
  icons_Reportvue_type_script_lang_ts_,
  Reportvue_type_template_id_1b0ff867_render,
  Reportvue_type_template_id_1b0ff867_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Report = (Report_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Schedule.vue?vue&type=template&id=e33baec8&
var Schedulevue_type_template_id_e33baec8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 1.25a10.75 10.75 0 110 21.5 10.75 10.75 0 010-21.5zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zm.13 4.5c.42 0 .75.34.75.75v3.65l2.73 2.27a.75.75 0 01-.96 1.16l-3-2.5a.75.75 0 01-.27-.58V8c0-.41.34-.75.75-.75z"
    }
  });
};
var Schedulevue_type_template_id_e33baec8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Schedule.vue?vue&type=script&lang=ts&

/* harmony default export */ var Schedulevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Schedule.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Schedulevue_type_script_lang_ts_ = (Schedulevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Schedule.vue





/* normalize component */
;
var Schedule_component = normalizeComponent(
  icons_Schedulevue_type_script_lang_ts_,
  Schedulevue_type_template_id_e33baec8_render,
  Schedulevue_type_template_id_e33baec8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Schedule = (Schedule_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/School.vue?vue&type=template&id=769a46a6&
var Schoolvue_type_template_id_769a46a6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M11.1351 1.23821C11.6736 0.920596 12.3264 0.920596 12.8649 1.23821L23.3372 7.41562C24.2209 7.93692 24.2209 9.29723 23.3372 9.81854L20.2655 11.6305V17.2493C20.2655 17.9356 19.9236 18.5697 19.3686 18.9126L13.4079 22.5962C12.5366 23.1346 11.4634 23.1346 10.5921 22.5962L4.63136 18.9126C4.07641 18.5697 3.7345 17.9356 3.7345 17.2493V11.6305L0.662815 9.81854C-0.220941 9.29723 -0.220936 7.93692 0.662816 7.41562L11.1351 1.23821ZM5.27118 12.5369V17.2493C5.27118 17.3474 5.32003 17.438 5.39931 17.487L11.36 21.1705C11.7561 21.4152 12.2439 21.4152 12.64 21.1705L18.6007 17.487C18.68 17.438 18.7288 17.3474 18.7288 17.2493V12.5369L12.8649 15.9959C12.3264 16.3136 11.6736 16.3136 11.1351 15.9959L5.27118 12.5369ZM12.1236 2.67997C12.0466 2.63459 11.9534 2.63459 11.8764 2.67997L1.81148 8.61708L11.8764 14.5542C11.9534 14.5996 12.0466 14.5996 12.1236 14.5542L22.1885 8.61708L12.1236 2.67997Z"
    }
  });
};
var Schoolvue_type_template_id_769a46a6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/School.vue?vue&type=script&lang=ts&

/* harmony default export */ var Schoolvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/School.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Schoolvue_type_script_lang_ts_ = (Schoolvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/School.vue





/* normalize component */
;
var School_component = normalizeComponent(
  icons_Schoolvue_type_script_lang_ts_,
  Schoolvue_type_template_id_769a46a6_render,
  Schoolvue_type_template_id_769a46a6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var School = (School_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Search.vue?vue&type=template&id=0f7408fb&
var Searchvue_type_template_id_0f7408fb_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M10.4628 1.5C15.4129 1.5 19.4257 5.47543 19.4257 10.3794C19.4257 11.8835 19.0482 13.3002 18.3819 14.5417L21.5428 17.7022C22.6994 18.8588 22.8135 20.6727 21.7269 21.7592C20.6403 22.8458 18.8264 22.7318 17.6698 21.5752L14.4357 18.341C13.2384 18.9285 11.8895 19.2588 10.4628 19.2588C5.5128 19.2588 1.5 15.2833 1.5 10.3794C1.5 5.47543 5.5128 1.5 10.4628 1.5ZM17.5472 15.8194C17.0341 16.4742 16.4305 17.0561 15.755 17.5464L18.7261 20.5189C19.3338 21.1267 20.2114 21.1819 20.6804 20.7128C21.1495 20.2437 21.0943 19.3662 20.4865 18.7584L17.5472 15.8194ZM10.4628 2.9799C6.33781 2.9799 2.99381 6.29276 2.99381 10.3794C2.99381 14.466 6.33781 17.7789 10.4628 17.7789C14.5879 17.7789 17.9319 14.466 17.9319 10.3794C17.9319 6.29276 14.5879 2.9799 10.4628 2.9799Z"
    }
  });
};
var Searchvue_type_template_id_0f7408fb_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Search.vue?vue&type=script&lang=ts&

/* harmony default export */ var Searchvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Search.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Searchvue_type_script_lang_ts_ = (Searchvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Search.vue





/* normalize component */
;
var Search_component = normalizeComponent(
  icons_Searchvue_type_script_lang_ts_,
  Searchvue_type_template_id_0f7408fb_render,
  Searchvue_type_template_id_0f7408fb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Search = (Search_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Secretary.vue?vue&type=template&id=de1350a4&
var Secretaryvue_type_template_id_de1350a4_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M20.5 18.25c.69 0 1.25.56 1.25 1.25v2c0 .69-.56 1.25-1.25 1.25h-17c-.69 0-1.25-.56-1.25-1.25v-2c0-.69.56-1.25 1.25-1.25h17zm-.25 1.5H3.75v1.5h16.5v-1.5zM9.5 10.25c.41 0 .75.34.75.75v5a.75.75 0 11-1.5 0v-5c0-.41.34-.75.75-.75zm5 0c.41 0 .75.34.75.75v5a.75.75 0 11-1.5 0v-5c0-.41.34-.75.75-.75zm-10 0c.41 0 .75.34.75.75v5a.75.75 0 11-1.5 0v-5c0-.41.34-.75.75-.75zm15 0c.41 0 .75.34.75.75v5a.75.75 0 11-1.5 0v-5c0-.41.34-.75.75-.75zM12.4.86l8.76 3.89a1 1 0 01.59.91v2.09a1 1 0 01-1 1H3.25a1 1 0 01-1-1V5.66a1 1 0 01.48-.85l.11-.06L11.6.86a1 1 0 01.82 0zM12 2.32L3.75 6v1.26h16.5V5.99L12 2.32z"
    }
  });
};
var Secretaryvue_type_template_id_de1350a4_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Secretary.vue?vue&type=script&lang=ts&

/* harmony default export */ var Secretaryvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Secretary.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Secretaryvue_type_script_lang_ts_ = (Secretaryvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Secretary.vue





/* normalize component */
;
var Secretary_component = normalizeComponent(
  icons_Secretaryvue_type_script_lang_ts_,
  Secretaryvue_type_template_id_de1350a4_render,
  Secretaryvue_type_template_id_de1350a4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Secretary = (Secretary_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Send.vue?vue&type=template&id=69988ebe&
var Sendvue_type_template_id_69988ebe_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M4.01 6.03L11.52 9.25L4 8.25L4.01 6.03ZM11.51 14.75L4 17.97V15.75L11.51 14.75ZM2.01 3L2 10L17 12L2 14L2.01 21L23 12L2.01 3Z"
    }
  });
};
var Sendvue_type_template_id_69988ebe_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Send.vue?vue&type=script&lang=ts&

/* harmony default export */ var Sendvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Send.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Sendvue_type_script_lang_ts_ = (Sendvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Send.vue





/* normalize component */
;
var Send_component = normalizeComponent(
  icons_Sendvue_type_script_lang_ts_,
  Sendvue_type_template_id_69988ebe_render,
  Sendvue_type_template_id_69988ebe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Send = (Send_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Settings.vue?vue&type=template&id=0ec62930&
var Settingsvue_type_template_id_0ec62930_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "id": "prefix__a",
      "d": "M14 1.25c.624 0 1.157.457 1.232 1.064l.322 2.239c.385.184.755.4 1.112.646l2.105-.845c.143-.057.296-.084.449-.084.45 0 .87.234 1.09.625l2.008 3.476c.293.536.168 1.208-.316 1.59l-1.782 1.393c.02.225.03.433.03.646 0 .213-.01.421-.03.646l1.785 1.395c.48.38.606 1.052.304 1.604l-1.995 3.453c-.223.395-.641.632-1.084.632-.142 0-.282-.023-.46-.084l-2.107-.847c-.364.25-.732.466-1.11.647l-.319 2.227c-.077.62-.61 1.077-1.234 1.077h-4c-.624 0-1.157-.457-1.232-1.064l-.322-2.239c-.385-.184-.755-.4-1.112-.646l-2.105.845c-.143.057-.296.084-.449.084-.45 0-.87-.234-1.09-.625L1.683 15.63c-.293-.536-.168-1.208.316-1.59l1.782-1.393c-.02-.226-.03-.438-.03-.646 0-.208.01-.42.03-.646L1.995 9.96c-.486-.384-.621-1.069-.304-1.604l1.995-3.453c.223-.395.641-.632 1.084-.632.142 0 .282.023.46.084l2.107.847c.364-.25.732-.466 1.11-.647l.319-2.227c.077-.62.61-1.077 1.234-1.077zm-.22 1.5h-3.56l-.348 2.426c-.037.264-.212.487-.458.588-.515.211-1.017.506-1.524.886-.21.157-.486.194-.73.096L4.883 5.83 3.098 8.917l1.934 1.512c.208.163.315.422.282.684-.042.341-.064.624-.064.887s.022.546.064.887c.033.262-.074.521-.282.684l-1.934 1.512 1.784 3.086 2.278-.915c.247-.099.527-.06.737.102.479.368.982.66 1.517.88.246.1.42.324.458.588l.348 2.426h3.56l.348-2.426c.037-.264.212-.487.458-.588.515-.211 1.017-.506 1.524-.886.21-.157.486-.194.73-.096l2.277.916 1.785-3.087-1.934-1.512c-.208-.163-.315-.422-.282-.684.043-.348.064-.617.064-.887s-.02-.54-.064-.887c-.033-.262.074-.521.282-.684l1.934-1.512-1.784-3.086-2.278.915c-.247.099-.527.06-.737-.102-.479-.368-.982-.66-1.517-.88-.246-.1-.42-.324-.458-.588L13.78 2.75zM12 8c2.21 0 4 1.79 4 4s-1.79 4-4 4-4-1.79-4-4 1.79-4 4-4zm0 1.5c-1.382 0-2.5 1.118-2.5 2.5s1.118 2.5 2.5 2.5 2.5-1.118 2.5-2.5-1.118-2.5-2.5-2.5z"
    }
  });
};
var Settingsvue_type_template_id_0ec62930_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Settings.vue?vue&type=script&lang=ts&

/* harmony default export */ var Settingsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Settings.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Settingsvue_type_script_lang_ts_ = (Settingsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Settings.vue





/* normalize component */
;
var Settings_component = normalizeComponent(
  icons_Settingsvue_type_script_lang_ts_,
  Settingsvue_type_template_id_0ec62930_render,
  Settingsvue_type_template_id_0ec62930_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Settings = (Settings_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Share.vue?vue&type=template&id=30b6508d&
var Sharevue_type_template_id_30b6508d_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08ZM18 4C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6C17.45 6 17 5.55 17 5C17 4.45 17.45 4 18 4ZM6 13C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11C6.55 11 7 11.45 7 12C7 12.55 6.55 13 6 13ZM18 20.02C17.45 20.02 17 19.57 17 19.02C17 18.47 17.45 18.02 18 18.02C18.55 18.02 19 18.47 19 19.02C19 19.57 18.55 20.02 18 20.02Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 5C21 6.65685 19.6569 8 18 8C16.3431 8 15 6.65685 15 5C15 3.34315 16.3431 2 18 2C19.6569 2 21 3.34315 21 5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 19C21 20.6569 19.6569 22 18 22C16.3431 22 15 20.6569 15 19C15 17.3431 16.3431 16 18 16C19.6569 16 21 17.3431 21 19Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M9 12C9 13.6569 7.65685 15 6 15C4.34315 15 3 13.6569 3 12C3 10.3431 4.34315 9 6 9C7.65685 9 9 10.3431 9 12Z"
    }
  })]);
};
var Sharevue_type_template_id_30b6508d_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Share.vue?vue&type=script&lang=ts&

/* harmony default export */ var Sharevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Share.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Sharevue_type_script_lang_ts_ = (Sharevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Share.vue





/* normalize component */
;
var Share_component = normalizeComponent(
  icons_Sharevue_type_script_lang_ts_,
  Sharevue_type_template_id_30b6508d_render,
  Sharevue_type_template_id_30b6508d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Share = (Share_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ShareAlt.vue?vue&type=template&id=7342e396&
var ShareAltvue_type_template_id_7342e396_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "id": "kkJtfVa",
      "d": "M17.5,1.25 C19.5710678,1.25 21.25,2.92893219 21.25,5 C21.25,7.07106781 19.5710678,8.75 17.5,8.75 C16.4000781,8.75 15.4107603,8.27644737 14.7248047,7.52210018 L9.04338693,10.7693204 C9.17726094,11.1548218 9.25,11.5689163 9.25,12 C9.25,12.4310837 9.17726094,12.8451782 9.04338693,13.2306796 L14.7248047,16.4778998 C15.4107603,15.7235526 16.4000781,15.25 17.5,15.25 C19.5710678,15.25 21.25,16.9289322 21.25,19 C21.25,21.0710678 19.5710678,22.75 17.5,22.75 C15.4289322,22.75 13.75,21.0710678 13.75,19 C13.75,18.5689163 13.8227391,18.1548218 13.9566131,17.7693204 L8.27519535,14.5221002 C7.58923974,15.2764474 6.59992194,15.75 5.5,15.75 C3.42893219,15.75 1.75,14.0710678 1.75,12 C1.75,9.92893219 3.42893219,8.25 5.5,8.25 C6.59992194,8.25 7.58923974,8.72355263 8.27519535,9.47789982 L13.9566131,6.23067957 C13.8227391,5.84517824 13.75,5.43108368 13.75,5 C13.75,2.92893219 15.4289322,1.25 17.5,1.25 Z M17.5,16.75 C16.2573593,16.75 15.25,17.7573593 15.25,19 C15.25,20.2426407 16.2573593,21.25 17.5,21.25 C18.7426407,21.25 19.75,20.2426407 19.75,19 C19.75,17.7573593 18.7426407,16.75 17.5,16.75 Z M5.5,9.75 C4.25735931,9.75 3.25,10.7573593 3.25,12 C3.25,13.2426407 4.25735931,14.25 5.5,14.25 C6.74264069,14.25 7.75,13.2426407 7.75,12 C7.75,10.7573593 6.74264069,9.75 5.5,9.75 Z M17.5,2.75 C16.2573593,2.75 15.25,3.75735931 15.25,5 C15.25,6.24264069 16.2573593,7.25 17.5,7.25 C18.7426407,7.25 19.75,6.24264069 19.75,5 C19.75,3.75735931 18.7426407,2.75 17.5,2.75 Z"
    }
  })]);
};
var ShareAltvue_type_template_id_7342e396_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ShareAlt.vue?vue&type=script&lang=ts&

/* harmony default export */ var ShareAltvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ShareAlt.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ShareAltvue_type_script_lang_ts_ = (ShareAltvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ShareAlt.vue





/* normalize component */
;
var ShareAlt_component = normalizeComponent(
  icons_ShareAltvue_type_script_lang_ts_,
  ShareAltvue_type_template_id_7342e396_render,
  ShareAltvue_type_template_id_7342e396_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ShareAlt = (ShareAlt_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Shop.vue?vue&type=template&id=f193e6fc&
var Shopvue_type_template_id_f193e6fc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M11.9998 0.25C14.6232 0.25 16.7498 2.37665 16.7498 5L16.7492 6.25H20.3833C21.626 6.25 22.6333 7.25736 22.6333 8.5C22.6333 8.55912 22.631 8.61821 22.6263 8.67715L21.715 20.2165C21.602 21.6469 20.4083 22.75 18.9735 22.75H5.02607C3.59125 22.75 2.39757 21.6469 2.28461 20.2165L1.37331 8.67714C1.27548 7.43835 2.2004 6.35481 3.43919 6.25698L3.52769 6.25175L7.24921 6.251L7.24983 5C7.24983 2.37665 9.37648 0.25 11.9998 0.25ZM20.3833 7.75L3.58678 7.75058L3.55728 7.75233C3.14435 7.78494 2.83604 8.14612 2.86865 8.55905L3.77995 20.0984C3.8313 20.7486 4.37388 21.25 5.02607 21.25H18.9735C19.6257 21.25 20.1683 20.7486 20.2196 20.0984L21.131 8.55905L21.1333 8.5C21.1333 8.08579 20.7975 7.75 20.3833 7.75ZM15.9998 9.25C16.414 9.25 16.7498 9.58579 16.7498 10V11C16.7498 13.6234 14.6232 15.75 11.9998 15.75C9.37648 15.75 7.24983 13.6234 7.24983 11V10C7.24983 9.58579 7.58561 9.25 7.99983 9.25C8.41404 9.25 8.74983 9.58579 8.74983 10V11C8.74983 12.7949 10.2049 14.25 11.9998 14.25C13.7948 14.25 15.2498 12.7949 15.2498 11V10C15.2498 9.58579 15.5856 9.25 15.9998 9.25ZM11.9998 1.75C10.2049 1.75 8.74983 3.20507 8.74983 5V6.25H15.2498V5C15.2498 3.20507 13.7948 1.75 11.9998 1.75Z"
    }
  });
};
var Shopvue_type_template_id_f193e6fc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Shop.vue?vue&type=script&lang=ts&

/* harmony default export */ var Shopvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Shop.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Shopvue_type_script_lang_ts_ = (Shopvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Shop.vue





/* normalize component */
;
var Shop_component = normalizeComponent(
  icons_Shopvue_type_script_lang_ts_,
  Shopvue_type_template_id_f193e6fc_render,
  Shopvue_type_template_id_f193e6fc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Shop = (Shop_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Show.vue?vue&type=template&id=78d3854e&
var Showvue_type_template_id_78d3854e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 5C7.45455 5 3.57273 7.82727 2 11.8182C3.57273 15.8091 7.45455 18.6364 12 18.6364C16.5455 18.6364 20.4273 15.8091 22 11.8182C20.4273 7.82727 16.5455 5 12 5ZM12 16.3636C9.49091 16.3636 7.45455 14.3273 7.45455 11.8182C7.45455 9.30909 9.49091 7.27273 12 7.27273C14.5091 7.27273 16.5455 9.30909 16.5455 11.8182C16.5455 14.3273 14.5091 16.3636 12 16.3636ZM12 9.09091C10.4909 9.09091 9.27273 10.3091 9.27273 11.8182C9.27273 13.3273 10.4909 14.5455 12 14.5455C13.5091 14.5455 14.7273 13.3273 14.7273 11.8182C14.7273 10.3091 13.5091 9.09091 12 9.09091Z"
    }
  });
};
var Showvue_type_template_id_78d3854e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Show.vue?vue&type=script&lang=ts&

/* harmony default export */ var Showvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Show.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Showvue_type_script_lang_ts_ = (Showvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Show.vue





/* normalize component */
;
var Show_component = normalizeComponent(
  icons_Showvue_type_script_lang_ts_,
  Showvue_type_template_id_78d3854e_render,
  Showvue_type_template_id_78d3854e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Show = (Show_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Star.vue?vue&type=template&id=2262b517&
var Starvue_type_template_id_2262b517_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.77 22.24c.84.5 1.93.24 2.44-.59.24-.4.32-.86.22-1.31l-1.27-5.43 4.23-3.66c.74-.64.82-1.76.17-2.5-.3-.34-.73-.55-1.19-.59l-5.56-.47-2.17-5.11a1.79 1.79 0 00-3.28 0L8.19 7.69l-5.56.47a1.76 1.76 0 00-1.02 3.09l4.23 3.66-1.27 5.43c-.22.95.38 1.9 1.34 2.11.45.1.93.03 1.32-.2L12 19.36l4.77 2.87z"
    }
  });
};
var Starvue_type_template_id_2262b517_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Star.vue?vue&type=script&lang=ts&

/* harmony default export */ var Starvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Star.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Starvue_type_script_lang_ts_ = (Starvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Star.vue





/* normalize component */
;
var Star_component = normalizeComponent(
  icons_Starvue_type_script_lang_ts_,
  Starvue_type_template_id_2262b517_render,
  Starvue_type_template_id_2262b517_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Star = (Star_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/StarOutline.vue?vue&type=template&id=77297809&
var StarOutlinevue_type_template_id_77297809_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16.7675 21.7432C17.6075 22.2491 18.7022 21.9844 19.2126 21.1519C19.454 20.7582 19.5304 20.2866 19.4255 19.8378L18.156 14.4074L22.3901 10.7471C23.1308 10.1068 23.2076 8.99259 22.5615 8.25848C22.2581 7.9138 21.8316 7.69939 21.3718 7.66046L15.8105 7.18964L13.6403 2.07998C13.259 1.18214 12.2155 0.760678 11.3096 1.13862C10.881 1.31739 10.5401 1.65527 10.3597 2.07998L8.18954 7.18964L2.62833 7.66046C1.64899 7.74337 0.922904 8.59742 1.00656 9.56802C1.04584 10.0237 1.26218 10.4465 1.60995 10.7471L5.84406 14.4074L4.57456 19.8378C4.3527 20.7868 4.94909 21.7343 5.90662 21.9542C6.35945 22.0582 6.83535 21.9825 7.23257 21.7432L12 18.8718L16.7675 21.7432ZM11.3399 17.5003L6.44036 20.4512C6.38362 20.4854 6.31563 20.4962 6.25094 20.4814C6.11415 20.45 6.02895 20.3146 6.06065 20.179L7.36459 14.6013C7.4706 14.1479 7.31571 13.6734 6.96179 13.3675L2.61268 9.60779C2.563 9.56484 2.53209 9.50445 2.52648 9.43935C2.51453 9.30069 2.61826 9.17868 2.75816 9.16684L8.47246 8.68306C8.9431 8.64321 9.35264 8.34802 9.5359 7.91654L11.7657 2.66654C11.7915 2.60587 11.8402 2.5576 11.9014 2.53206C12.0308 2.47807 12.1799 2.53828 12.2344 2.66654L14.4642 7.91654C14.6474 8.34802 15.057 8.64321 15.5276 8.68306L21.2419 9.16684C21.3076 9.1724 21.3685 9.20303 21.4119 9.25227C21.5042 9.35714 21.4932 9.51631 21.3874 9.60779L17.0383 13.3675C16.6844 13.6734 16.5295 14.1479 16.6355 14.6013L17.9394 20.179C17.9544 20.2431 17.9435 20.3105 17.909 20.3668C17.8361 20.4857 17.6797 20.5235 17.5597 20.4512L12.6602 17.5003C12.2546 17.256 11.7455 17.256 11.3399 17.5003Z"
    }
  });
};
var StarOutlinevue_type_template_id_77297809_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/StarOutline.vue?vue&type=script&lang=ts&

/* harmony default export */ var StarOutlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/StarOutline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_StarOutlinevue_type_script_lang_ts_ = (StarOutlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/StarOutline.vue





/* normalize component */
;
var StarOutline_component = normalizeComponent(
  icons_StarOutlinevue_type_script_lang_ts_,
  StarOutlinevue_type_template_id_77297809_render,
  StarOutlinevue_type_template_id_77297809_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StarOutline = (StarOutline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Stopwatch.vue?vue&type=template&id=4091d86d&
var Stopwatchvue_type_template_id_4091d86d_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 3.25C14.3904 3.25 16.5792 4.1092 18.2747 5.53575L19.0303 4.78033C19.3232 4.48744 19.7981 4.48744 20.091 4.78033C20.3839 5.07322 20.3839 5.5481 20.091 5.84099L19.3452 6.58655C20.8429 8.30053 21.75 10.5439 21.75 13C21.75 18.3867 17.3867 22.75 12 22.75C6.61329 22.75 2.25 18.3867 2.25 13C2.25 7.61329 6.61329 3.25 12 3.25ZM12 4.75C7.44171 4.75 3.75 8.44171 3.75 13C3.75 17.5583 7.44171 21.25 12 21.25C16.5583 21.25 20.25 17.5583 20.25 13C20.25 8.44171 16.5583 4.75 12 4.75ZM12.1344 8.75C12.5486 8.75 12.8844 9.08579 12.8844 9.5V13.1487L15.6145 15.4238C15.9327 15.689 15.9757 16.1619 15.7106 16.4801C15.4454 16.7983 14.9725 16.8413 14.6543 16.5762L11.6543 14.0762C11.4833 13.9337 11.3844 13.7226 11.3844 13.5V9.5C11.3844 9.08579 11.7202 8.75 12.1344 8.75ZM14 1C14.4142 1 14.75 1.33579 14.75 1.75C14.75 2.16421 14.4142 2.5 14 2.5H10C9.58579 2.5 9.25 2.16421 9.25 1.75C9.25 1.33579 9.58579 1 10 1H14Z"
    }
  });
};
var Stopwatchvue_type_template_id_4091d86d_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Stopwatch.vue?vue&type=script&lang=ts&

/* harmony default export */ var Stopwatchvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Stopwatch.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Stopwatchvue_type_script_lang_ts_ = (Stopwatchvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Stopwatch.vue





/* normalize component */
;
var Stopwatch_component = normalizeComponent(
  icons_Stopwatchvue_type_script_lang_ts_,
  Stopwatchvue_type_template_id_4091d86d_render,
  Stopwatchvue_type_template_id_4091d86d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Stopwatch = (Stopwatch_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Strike.vue?vue&type=template&id=3d3b9c9c&
var Strikevue_type_template_id_3d3b9c9c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18.0012 4.24805H12.7512V8.74805C12.7512 9.16226 12.4154 9.49805 12.0012 9.49805C11.587 9.49805 11.2512 9.16226 11.2512 8.74805V4.24805H6.00117C5.58696 4.24805 5.25117 3.91226 5.25117 3.49805C5.25117 3.08383 5.58696 2.74805 6.00117 2.74805H12.0012H18.0012C18.4154 2.74805 18.7512 3.08383 18.7512 3.49805C18.7512 3.91226 18.4154 4.24805 18.0012 4.24805ZM4.00195 12.7488C3.58774 12.7488 3.25195 12.413 3.25195 11.9988C3.25195 11.5846 3.58774 11.2488 4.00195 11.2488H20.002C20.4162 11.2488 20.752 11.5846 20.752 11.9988C20.752 12.413 20.4162 12.7488 20.002 12.7488H4.00195ZM11.2512 20.4973V15.2473C11.2512 14.8331 11.587 14.4973 12.0012 14.4973C12.4154 14.4973 12.7512 14.8331 12.7512 15.2473V20.4973C12.7512 20.9115 12.4154 21.2473 12.0012 21.2473C11.587 21.2473 11.2512 20.9115 11.2512 20.4973Z"
    }
  });
};
var Strikevue_type_template_id_3d3b9c9c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Strike.vue?vue&type=script&lang=ts&

/* harmony default export */ var Strikevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Strike.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Strikevue_type_script_lang_ts_ = (Strikevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Strike.vue





/* normalize component */
;
var Strike_component = normalizeComponent(
  icons_Strikevue_type_script_lang_ts_,
  Strikevue_type_template_id_3d3b9c9c_render,
  Strikevue_type_template_id_3d3b9c9c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Strike = (Strike_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/StudyPlan.vue?vue&type=template&id=d2b3127c&
var StudyPlanvue_type_template_id_d2b3127c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('mask', {
    attrs: {
      "id": "StudyPlan",
      "mask-type": "alpha",
      "maskUnits": "userSpaceOnUse"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 0C17.4142 0 17.75 0.335786 17.75 0.75V2H20C21.5188 2 22.75 3.23122 22.75 4.75V19.75C22.75 21.2688 21.5188 22.5 20 22.5H4C2.48122 22.5 1.25 21.2688 1.25 19.75V4.75C1.25 3.23122 2.48122 2 4 2H6.25V0.75C6.25 0.370304 6.53215 0.056509 6.89823 0.00684662L7 0C7.41421 0 7.75 0.335786 7.75 0.75V2H16.25V0.75C16.25 0.370304 16.5322 0.056509 16.8982 0.00684662L17 0ZM16.25 3.5H7.75V4.75C7.75 5.1297 7.46785 5.44349 7.10177 5.49315L7 5.5C6.58579 5.5 6.25 5.16421 6.25 4.75V3.5H4C3.30964 3.5 2.75 4.05964 2.75 4.75V19.75C2.75 20.4404 3.30964 21 4 21H20C20.6904 21 21.25 20.4404 21.25 19.75V4.75C21.25 4.05964 20.6904 3.5 20 3.5H17.75V4.75C17.75 5.1297 17.4678 5.44349 17.1018 5.49315L17 5.5C16.5858 5.5 16.25 5.16421 16.25 4.75V3.5Z"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#StudyPlan)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M17 0C17.4142 0 17.75 0.335786 17.75 0.75V2H20C21.5188 2 22.75 3.23122 22.75 4.75V19.75C22.75 21.2688 21.5188 22.5 20 22.5H4C2.48122 22.5 1.25 21.2688 1.25 19.75V4.75C1.25 3.23122 2.48122 2 4 2H6.25V0.75C6.25 0.370304 6.53215 0.056509 6.89823 0.00684662L7 0C7.41421 0 7.75 0.335786 7.75 0.75V2H16.25V0.75C16.25 0.370304 16.5322 0.056509 16.8982 0.00684662L17 0ZM16.25 3.5H7.75V4.75C7.75 5.1297 7.46785 5.44349 7.10177 5.49315L7 5.5C6.58579 5.5 6.25 5.16421 6.25 4.75V3.5H4C3.30964 3.5 2.75 4.05964 2.75 4.75V19.75C2.75 20.4404 3.30964 21 4 21H20C20.6904 21 21.25 20.4404 21.25 19.75V4.75C21.25 4.05964 20.6904 3.5 20 3.5H17.75V4.75C17.75 5.1297 17.4678 5.44349 17.1018 5.49315L17 5.5C16.5858 5.5 16.25 5.16421 16.25 4.75V3.5Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0 0H24V24H0V0Z"
    }
  })]), _c('path', {
    attrs: {
      "d": "M10.51 12.14C10.51 12.54 10.4133 12.9033 10.22 13.23C10.0333 13.5567 9.75333 13.94 9.38 14.38L7.96 16.06H10.64V17H6.57V16.18L8.43 14.01C8.63667 13.7767 8.81 13.5767 8.95 13.41C9.09 13.2433 9.2 13.0967 9.28 12.97C9.36667 12.8433 9.42667 12.7233 9.46 12.61C9.5 12.4967 9.52 12.37 9.52 12.23C9.52 11.95 9.42333 11.7367 9.23 11.59C9.04333 11.4367 8.83 11.36 8.59 11.36C8.34333 11.36 8.10333 11.43 7.87 11.57C7.63667 11.71 7.39333 11.9667 7.14 12.34L6.4 11.82C6.65333 11.4 6.95667 11.06 7.31 10.8C7.66333 10.54 8.09 10.4067 8.59 10.4C8.85667 10.4 9.10667 10.4467 9.34 10.54C9.58 10.6267 9.78333 10.75 9.95 10.91C10.1233 11.0633 10.26 11.2467 10.36 11.46C10.46 11.6667 10.51 11.8933 10.51 12.14ZM12.5179 14.55L11.8179 14.36V10.5H15.5879V11.46H12.7679V13.24C12.9146 13.1333 13.0812 13.05 13.2679 12.99C13.4612 12.9233 13.6612 12.89 13.8679 12.89C14.1412 12.89 14.4012 12.94 14.6479 13.04C14.9012 13.1333 15.1246 13.27 15.3179 13.45C15.5112 13.63 15.6646 13.85 15.7779 14.11C15.8912 14.37 15.9479 14.66 15.9479 14.98C15.9479 15.2867 15.8879 15.5733 15.7679 15.84C15.6546 16.1 15.5012 16.3267 15.3079 16.52C15.1146 16.7133 14.8879 16.8667 14.6279 16.98C14.3746 17.0867 14.1046 17.14 13.8179 17.14C13.3112 17.14 12.8979 17.04 12.5779 16.84C12.2646 16.64 12.0012 16.37 11.7879 16.03L12.5179 15.46C12.6846 15.7067 12.8646 15.8867 13.0579 16C13.2512 16.1133 13.4579 16.17 13.6779 16.17C14.0579 16.17 14.3612 16.0633 14.5879 15.85C14.8146 15.63 14.9279 15.34 14.9279 14.98C14.9279 14.6533 14.8179 14.3933 14.5979 14.2C14.3779 14.0067 14.0946 13.91 13.7479 13.91C13.5146 13.91 13.2879 13.97 13.0679 14.09C12.8479 14.21 12.6646 14.3633 12.5179 14.55Z"
    }
  })]);
};
var StudyPlanvue_type_template_id_d2b3127c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/StudyPlan.vue?vue&type=script&lang=ts&

/* harmony default export */ var StudyPlanvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/StudyPlan.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_StudyPlanvue_type_script_lang_ts_ = (StudyPlanvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/StudyPlan.vue





/* normalize component */
;
var StudyPlan_component = normalizeComponent(
  icons_StudyPlanvue_type_script_lang_ts_,
  StudyPlanvue_type_template_id_d2b3127c_render,
  StudyPlanvue_type_template_id_d2b3127c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var StudyPlan = (StudyPlan_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/SwapVertical.vue?vue&type=template&id=a0683996&
var SwapVerticalvue_type_template_id_a0683996_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z"
    }
  });
};
var SwapVerticalvue_type_template_id_a0683996_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/SwapVertical.vue?vue&type=script&lang=ts&

/* harmony default export */ var SwapVerticalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/SwapVertical.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_SwapVerticalvue_type_script_lang_ts_ = (SwapVerticalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/SwapVertical.vue





/* normalize component */
;
var SwapVertical_component = normalizeComponent(
  icons_SwapVerticalvue_type_script_lang_ts_,
  SwapVerticalvue_type_template_id_a0683996_render,
  SwapVerticalvue_type_template_id_a0683996_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SwapVertical = (SwapVertical_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ThumbDown.vue?vue&type=template&id=d703c430&
var ThumbDownvue_type_template_id_d703c430_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0V0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v2c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.58-6.59c.37-.36.59-.86.59-1.41V5c0-1.1-.9-2-2-2zm0 12l-4.34 4.34L11.77 14H3v-2l3-7h9v10zm4-12h4v12h-4z"
    }
  })]);
};
var ThumbDownvue_type_template_id_d703c430_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ThumbDown.vue?vue&type=script&lang=ts&

/* harmony default export */ var ThumbDownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ThumbDown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ThumbDownvue_type_script_lang_ts_ = (ThumbDownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ThumbDown.vue





/* normalize component */
;
var ThumbDown_component = normalizeComponent(
  icons_ThumbDownvue_type_script_lang_ts_,
  ThumbDownvue_type_template_id_d703c430_render,
  ThumbDownvue_type_template_id_d703c430_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ThumbDown = (ThumbDown_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ThumbUp.vue?vue&type=template&id=25a99aad&
var ThumbUpvue_type_template_id_25a99aad_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "fill": "none",
      "d": "M0 0h24v24H0V0z"
    }
  }), _c('path', {
    attrs: {
      "d": "M21 8h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-2c0-1.1-.9-2-2-2zm0 4l-3 7H9V9l4.34-4.34L12.23 10H21v2zM1 9h4v12H1z"
    }
  })]);
};
var ThumbUpvue_type_template_id_25a99aad_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ThumbUp.vue?vue&type=script&lang=ts&

/* harmony default export */ var ThumbUpvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ThumbUp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ThumbUpvue_type_script_lang_ts_ = (ThumbUpvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ThumbUp.vue





/* normalize component */
;
var ThumbUp_component = normalizeComponent(
  icons_ThumbUpvue_type_script_lang_ts_,
  ThumbUpvue_type_template_id_25a99aad_render,
  ThumbUpvue_type_template_id_25a99aad_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ThumbUp = (ThumbUp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Terms.vue?vue&type=template&id=4b3476fe&
var Termsvue_type_template_id_4b3476fe_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M14.5858 1.75C15.0499 1.75 15.495 1.93437 15.8232 2.26256L20.7374 7.17678C21.0656 7.50497 21.25 7.95008 21.25 8.41421V12C21.25 12.4142 20.9142 12.75 20.5 12.75C20.0858 12.75 19.75 12.4142 19.75 12V9.25H14.75C14.1028 9.25 13.5705 8.75813 13.5065 8.12781L13.5 8V3.25H5.5C4.85279 3.25 4.32047 3.74187 4.25645 4.37219L4.25 4.5V19.5C4.25 20.1904 4.80964 20.75 5.5 20.75H12C12.4142 20.75 12.75 21.0858 12.75 21.5C12.75 21.9142 12.4142 22.25 12 22.25H5.5C3.98122 22.25 2.75 21.0188 2.75 19.5V4.5C2.75 2.98122 3.98122 1.75 5.5 1.75H14.5858ZM22.7011 13.4889C22.9833 13.1858 23.4579 13.1688 23.7611 13.4511C24.0642 13.7333 24.0812 14.2079 23.7989 14.5111L17.6476 21.118L17.5845 21.1811C17.0793 21.6515 16.2883 21.6233 15.8179 21.118L13.7011 18.8444C13.4188 18.5412 13.4358 18.0667 13.7389 17.7844C14.0421 17.5022 14.5167 17.5191 14.7989 17.8223L16.7328 19.8994L22.7011 13.4889ZM12 15.75C12.4142 15.75 12.75 16.0858 12.75 16.5C12.75 16.9142 12.4142 17.25 12 17.25H8C7.58579 17.25 7.25 16.9142 7.25 16.5C7.25 16.0858 7.58579 15.75 8 15.75H12ZM16 11.75C16.4142 11.75 16.75 12.0858 16.75 12.5C16.75 12.9142 16.4142 13.25 16 13.25H8C7.58579 13.25 7.25 12.9142 7.25 12.5C7.25 12.0858 7.58579 11.75 8 11.75H16ZM15 3.561V7.75H19.189L15 3.561Z"
    }
  });
};
var Termsvue_type_template_id_4b3476fe_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Terms.vue?vue&type=script&lang=ts&

/* harmony default export */ var Termsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Terms.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Termsvue_type_script_lang_ts_ = (Termsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Terms.vue





/* normalize component */
;
var Terms_component = normalizeComponent(
  icons_Termsvue_type_script_lang_ts_,
  Termsvue_type_template_id_4b3476fe_render,
  Termsvue_type_template_id_4b3476fe_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Terms = (Terms_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/TextField.vue?vue&type=template&id=0eb10e3b&
var TextFieldvue_type_template_id_0eb10e3b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('mask', {
    staticStyle: {
      "mask-type": "alpha"
    },
    attrs: {
      "id": "mask0_2135_9466",
      "maskUnits": "userSpaceOnUse",
      "x": "2",
      "y": "2",
      "width": "20",
      "height": "20"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H8.25V20.5C8.25 20.8797 8.53215 21.1935 8.89823 21.2432L9 21.25C9.41421 21.25 9.75 20.9142 9.75 20.5V4.25H15C15.3797 4.25 15.6935 3.96785 15.7432 3.60177L15.75 3.5C15.75 3.08579 15.4142 2.75 15 2.75H3ZM13 9.75C12.5858 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 12.5858 11.25 13 11.25H16.25V20.5C16.25 20.8797 16.5322 21.1935 16.8982 21.2432L17 21.25C17.4142 21.25 17.75 20.9142 17.75 20.5V11.25H21C21.3797 11.25 21.6935 10.9678 21.7432 10.6018L21.75 10.5C21.75 10.0858 21.4142 9.75 21 9.75H13Z"
    }
  })]), _c('g', {
    attrs: {
      "mask": "url(#mask0_2135_9466)"
    }
  }, [_c('path', {
    attrs: {
      "d": "M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H8.25V20.5C8.25 20.8797 8.53215 21.1935 8.89823 21.2432L9 21.25C9.41421 21.25 9.75 20.9142 9.75 20.5V4.25H15C15.3797 4.25 15.6935 3.96785 15.7432 3.60177L15.75 3.5C15.75 3.08579 15.4142 2.75 15 2.75H3ZM13 9.75C12.5858 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 12.5858 11.25 13 11.25H16.25V20.5C16.25 20.8797 16.5322 21.1935 16.8982 21.2432L17 21.25C17.4142 21.25 17.75 20.9142 17.75 20.5V11.25H21C21.3797 11.25 21.6935 10.9678 21.7432 10.6018L21.75 10.5C21.75 10.0858 21.4142 9.75 21 9.75H13Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M24 0H0V24H24V0Z"
    }
  })])]);
};
var TextFieldvue_type_template_id_0eb10e3b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/TextField.vue?vue&type=script&lang=ts&

/* harmony default export */ var TextFieldvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/TextField.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_TextFieldvue_type_script_lang_ts_ = (TextFieldvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/TextField.vue





/* normalize component */
;
var TextField_component = normalizeComponent(
  icons_TextFieldvue_type_script_lang_ts_,
  TextFieldvue_type_template_id_0eb10e3b_render,
  TextFieldvue_type_template_id_0eb10e3b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextField = (TextField_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/TextSms.vue?vue&type=template&id=5f11627a&
var TextSmsvue_type_template_id_5f11627a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19.9998 1.75C21.514 1.75 22.7498 2.98579 22.7498 4.5V16.5C22.7498 18.0142 21.514 19.25 19.9998 19.25H7.26291L4.09419 21.785C3.33948 22.3887 2.23822 22.2664 1.63446 21.5117C1.38601 21.2011 1.25076 20.8152 1.25098 20.4175L1.25982 4.5C1.25982 2.98503 2.48634 1.75 3.99982 1.75H19.9998ZM19.9998 3.25H3.99982C3.35977 3.25 2.82997 3.74319 2.76625 4.37244L2.75982 4.50042L2.75098 20.4183C2.75098 20.4751 2.77027 20.5303 2.80576 20.5746C2.89201 20.6824 3.04934 20.6999 3.15715 20.6137L6.73673 17.75H19.9998C20.6856 17.75 21.2498 17.1858 21.2498 16.5V4.5C21.2498 3.81421 20.6856 3.25 19.9998 3.25ZM16.4998 9.5C17.0521 9.5 17.4998 9.94772 17.4998 10.5C17.4998 11.0523 17.0521 11.5 16.4998 11.5C15.9475 11.5 15.4998 11.0523 15.4998 10.5C15.4998 9.94772 15.9475 9.5 16.4998 9.5ZM11.9998 9.5C12.5521 9.5 12.9998 9.94772 12.9998 10.5C12.9998 11.0523 12.5521 11.5 11.9998 11.5C11.4475 11.5 10.9998 11.0523 10.9998 10.5C10.9998 9.94772 11.4475 9.5 11.9998 9.5ZM7.49982 9.5C8.05211 9.5 8.49982 9.94772 8.49982 10.5C8.49982 11.0523 8.05211 11.5 7.49982 11.5C6.94754 11.5 6.49982 11.0523 6.49982 10.5C6.49982 9.94772 6.94754 9.5 7.49982 9.5Z",
      "fill": "#666666"
    }
  });
};
var TextSmsvue_type_template_id_5f11627a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/TextSms.vue?vue&type=script&lang=ts&

/* harmony default export */ var TextSmsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/TextSms.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_TextSmsvue_type_script_lang_ts_ = (TextSmsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/TextSms.vue





/* normalize component */
;
var TextSms_component = normalizeComponent(
  icons_TextSmsvue_type_script_lang_ts_,
  TextSmsvue_type_template_id_5f11627a_render,
  TextSmsvue_type_template_id_5f11627a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TextSms = (TextSms_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Timer.vue?vue&type=template&id=2c9b349d&
var Timervue_type_template_id_2c9b349d_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M14.4286 2H8.71429V3.90476H14.4286V2ZM10.619 14.381H12.5238V8.66667H10.619V14.381ZM18.2667 8.08571L19.619 6.73333C19.2095 6.24762 18.7619 5.79048 18.2762 5.39048L16.9238 6.74286C15.4476 5.5619 13.5905 4.85714 11.5714 4.85714C6.8381 4.85714 3 8.69524 3 13.4286C3 18.1619 6.82857 22 11.5714 22C16.3143 22 20.1429 18.1619 20.1429 13.4286C20.1429 11.4095 19.4381 9.55238 18.2667 8.08571ZM11.5714 20.0952C7.88571 20.0952 4.90476 17.1143 4.90476 13.4286C4.90476 9.74286 7.88571 6.7619 11.5714 6.7619C15.2571 6.7619 18.2381 9.74286 18.2381 13.4286C18.2381 17.1143 15.2571 20.0952 11.5714 20.0952Z"
    }
  });
};
var Timervue_type_template_id_2c9b349d_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Timer.vue?vue&type=script&lang=ts&

/* harmony default export */ var Timervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Timer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Timervue_type_script_lang_ts_ = (Timervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Timer.vue





/* normalize component */
;
var Timer_component = normalizeComponent(
  icons_Timervue_type_script_lang_ts_,
  Timervue_type_template_id_2c9b349d_render,
  Timervue_type_template_id_2c9b349d_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Timer = (Timer_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Tuttoring.vue?vue&type=template&id=9c9ca578&
var Tuttoringvue_type_template_id_9c9ca578_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M21 2.75C22.5188 2.75 23.75 3.98122 23.75 5.5V18.5C23.75 20.0188 22.5188 21.25 21 21.25H2.75L2.75019 21.2388C1.34848 21.1126 0.25 19.9346 0.25 18.5V5.5C0.25 3.98122 1.48122 2.75 3 2.75H21ZM10.3654 17.75H6.13462C5.08881 17.75 4.25 18.5761 4.25 19.5833V19.75H12.25V19.5833C12.25 18.5761 11.4112 17.75 10.3654 17.75ZM21 4.25H3C2.30964 4.25 1.75 4.80964 1.75 5.5V18.5C1.75 19.1048 2.17947 19.6092 2.75005 19.725L2.75 19.5833C2.75 17.7425 4.26546 16.25 6.13462 16.25H10.3654C12.2345 16.25 13.75 17.7425 13.75 19.5833V19.75H21C21.6904 19.75 22.25 19.1904 22.25 18.5V5.5C22.25 4.80964 21.6904 4.25 21 4.25ZM8 7.5C9.933 7.5 11.5 9.067 11.5 11C11.5 12.933 9.933 14.5 8 14.5C6.067 14.5 4.5 12.933 4.5 11C4.5 9.067 6.067 7.5 8 7.5ZM17 12.25C17.4142 12.25 17.75 12.5858 17.75 13C17.75 13.4142 17.4142 13.75 17 13.75H14C13.5858 13.75 13.25 13.4142 13.25 13C13.25 12.5858 13.5858 12.25 14 12.25H17ZM8 9C6.89543 9 6 9.89543 6 11C6 12.1046 6.89543 13 8 13C9.10457 13 10 12.1046 10 11C10 9.89543 9.10457 9 8 9ZM19 8.25C19.4142 8.25 19.75 8.58579 19.75 9C19.75 9.41421 19.4142 9.75 19 9.75H14C13.5858 9.75 13.25 9.41421 13.25 9C13.25 8.58579 13.5858 8.25 14 8.25H19Z"
    }
  });
};
var Tuttoringvue_type_template_id_9c9ca578_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Tuttoring.vue?vue&type=script&lang=ts&

/* harmony default export */ var Tuttoringvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Tuttoring.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Tuttoringvue_type_script_lang_ts_ = (Tuttoringvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Tuttoring.vue





/* normalize component */
;
var Tuttoring_component = normalizeComponent(
  icons_Tuttoringvue_type_script_lang_ts_,
  Tuttoringvue_type_template_id_9c9ca578_render,
  Tuttoringvue_type_template_id_9c9ca578_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Tuttoring = (Tuttoring_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Twitter.vue?vue&type=template&id=2cf330a8&
var Twittervue_type_template_id_2cf330a8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M23.734 3.278c-.037-.555-.645-.878-1.126-.598-.728.423-1.515.738-2.337.934-1.675-1.487-4.136-1.8-6.153-.741-1.846.968-2.93 2.879-2.85 4.878C8.093 7.367 5.18 5.796 3.15 3.35c-.379-.456-1.112-.314-1.292.251-2.08 6.532.28 11.948 4.239 13.713-1.225.63-2.594.964-3.993.962-.34 0-.68-.02-1.018-.06-.793-.093-1.163.954-.486 1.38 2.241 1.41 4.848 2.157 7.51 2.153 8.07.004 13.79-6.231 13.945-13.382l.001-.623c1.34-1.594 1.791-2.74 1.677-4.465zM8.323 17.67c.517-.398.314-1.22-.328-1.333-3.716-.653-6.414-5.088-5.057-11.005 2.43 2.39 5.691 3.824 9.16 3.994.498.025.881-.436.766-.922-.395-1.668.402-3.39 1.95-4.203 1.556-.816 3.478-.507 4.685.75.176.183.433.265.683.217.684-.132 1.35-.334 1.99-.6-.164.761-.596 1.446-1.442 2.42-.13.15-.196.346-.182.544l.007.14.004.396c0 6.48-5.132 12.183-12.448 12.18-1.231.002-2.449-.176-3.614-.522l-.434-.138c1.545-.3 3.006-.953 4.26-1.918z"
    }
  });
};
var Twittervue_type_template_id_2cf330a8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Twitter.vue?vue&type=script&lang=ts&

/* harmony default export */ var Twittervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Twitter.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Twittervue_type_script_lang_ts_ = (Twittervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Twitter.vue





/* normalize component */
;
var Twitter_component = normalizeComponent(
  icons_Twittervue_type_script_lang_ts_,
  Twittervue_type_template_id_2cf330a8_render,
  Twittervue_type_template_id_2cf330a8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Twitter = (Twitter_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Underline.vue?vue&type=template&id=918fdf84&
var Underlinevue_type_template_id_918fdf84_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M19,19.75 C19.4142136,19.75 19.75,20.0857864 19.75,20.5 C19.75,20.9142136 19.4142136,21.25 19,21.25 L19,21.25 L5,21.25 C4.58578644,21.25 4.25,20.9142136 4.25,20.5 C4.25,20.0857864 4.58578644,19.75 5,19.75 L5,19.75 Z M18,2.75 C18.4142136,2.75 18.75,3.08578644 18.75,3.5 L18.75,3.5 L18.75,11.5 C18.75,15.2279221 15.7279221,18.25 12,18.25 C8.27207794,18.25 5.25,15.2279221 5.25,11.5 L5.25,11.5 L5.25,3.5 C5.25,3.08578644 5.58578644,2.75 6,2.75 C6.41421356,2.75 6.75,3.08578644 6.75,3.5 L6.75,3.5 L6.75,11.5 C6.75,14.3994949 9.10050506,16.75 12,16.75 C14.8994949,16.75 17.25,14.3994949 17.25,11.5 L17.25,11.5 L17.25,3.5 C17.25,3.08578644 17.5857864,2.75 18,2.75 Z"
    }
  });
};
var Underlinevue_type_template_id_918fdf84_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Underline.vue?vue&type=script&lang=ts&

/* harmony default export */ var Underlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Underline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Underlinevue_type_script_lang_ts_ = (Underlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Underline.vue





/* normalize component */
;
var Underline_component = normalizeComponent(
  icons_Underlinevue_type_script_lang_ts_,
  Underlinevue_type_template_id_918fdf84_render,
  Underlinevue_type_template_id_918fdf84_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Underline = (Underline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Unlock.vue?vue&type=template&id=1c8ac6ff&
var Unlockvue_type_template_id_1c8ac6ff_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M11.9998 0.75C14.6048 0.75 16.7498 2.6567 16.7498 5.05556L16.7494 8.75H18.9952C20.514 8.75 21.7452 9.98122 21.7452 11.5L21.6352 20.5336C21.6168 22.0391 20.3911 23.25 18.8854 23.25H5.11419C3.60849 23.25 2.38276 22.0391 2.36439 20.5335L2.2546 11.5335C2.23676 10.0711 3.3638 8.86141 4.80341 8.75727L5.0044 8.75H15.2498V5.05556C15.2498 3.52705 13.8131 2.25 11.9998 2.25C10.1865 2.25 8.74983 3.52705 8.74983 5.05556C8.74983 5.46977 8.41404 5.80556 7.99983 5.80556C7.58561 5.80556 7.24983 5.46977 7.24983 5.05556C7.24983 2.6567 9.39486 0.75 11.9998 0.75ZM18.9952 10.25H5.0044L4.86143 10.2581C4.23194 10.3298 3.7466 10.8681 3.7544 11.5152L3.86428 20.5152C3.87263 21.1996 4.42978 21.75 5.11419 21.75H18.8854C19.5698 21.75 20.127 21.1996 20.1353 20.5153L20.2451 11.5153L20.2388 11.3722C20.1748 10.7419 19.6424 10.25 18.9952 10.25ZM13.9998 15.25C14.414 15.25 14.7498 15.5858 14.7498 16C14.7498 16.4142 14.414 16.75 13.9998 16.75H9.99983C9.58561 16.75 9.24983 16.4142 9.24983 16C9.24983 15.5858 9.58561 15.25 9.99983 15.25H13.9998Z"
    }
  });
};
var Unlockvue_type_template_id_1c8ac6ff_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Unlock.vue?vue&type=script&lang=ts&

/* harmony default export */ var Unlockvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Unlock.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Unlockvue_type_script_lang_ts_ = (Unlockvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Unlock.vue





/* normalize component */
;
var Unlock_component = normalizeComponent(
  icons_Unlockvue_type_script_lang_ts_,
  Unlockvue_type_template_id_1c8ac6ff_render,
  Unlockvue_type_template_id_1c8ac6ff_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Unlock = (Unlock_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Upload.vue?vue&type=template&id=09d8b5bc&
var Uploadvue_type_template_id_09d8b5bc_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M5 1.75C5.41421 1.75 5.75 2.08579 5.75 2.5C5.75 2.91421 5.41421 3.25 5 3.25H4C3.30128 3.25 2.75 3.77372 2.75 4.4V19.6C2.75 20.2263 3.30128 20.75 4 20.75H20C20.6987 20.75 21.25 20.2263 21.25 19.6V4.4C21.25 3.77372 20.6987 3.25 20 3.25H19C18.5858 3.25 18.25 2.91421 18.25 2.5C18.25 2.08579 18.5858 1.75 19 1.75H20C21.5104 1.75 22.75 2.9276 22.75 4.4V19.6C22.75 21.0724 21.5104 22.25 20 22.25H4C2.48958 22.25 1.25 21.0724 1.25 19.6V4.4C1.25 2.9276 2.48958 1.75 4 1.75H5ZM16 15.75C16.4142 15.75 16.75 16.0858 16.75 16.5C16.75 16.9142 16.4142 17.25 16 17.25H8C7.58579 17.25 7.25 16.9142 7.25 16.5C7.25 16.0858 7.58579 15.75 8 15.75H16ZM12.8839 2.11612L16.0303 5.26256C16.3232 5.55546 16.3232 6.03033 16.0303 6.32322C15.7374 6.61612 15.2626 6.61612 14.9697 6.32322L12.75 4.103V12.5C12.75 12.9142 12.4142 13.25 12 13.25C11.5858 13.25 11.25 12.9142 11.25 12.5V4.103L9.03033 6.32322C8.73744 6.61612 8.26256 6.61612 7.96967 6.32322C7.67678 6.03033 7.67678 5.55546 7.96967 5.26256L11.1161 2.11612C11.6043 1.62796 12.3957 1.62796 12.8839 2.11612Z"
    }
  });
};
var Uploadvue_type_template_id_09d8b5bc_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Upload.vue?vue&type=script&lang=ts&

/* harmony default export */ var Uploadvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Upload.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Uploadvue_type_script_lang_ts_ = (Uploadvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Upload.vue





/* normalize component */
;
var Upload_component = normalizeComponent(
  icons_Uploadvue_type_script_lang_ts_,
  Uploadvue_type_template_id_09d8b5bc_render,
  Uploadvue_type_template_id_09d8b5bc_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Upload = (Upload_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Verified.vue?vue&type=template&id=d725a574&
var Verifiedvue_type_template_id_d725a574_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M19.4412 1.05512C21.399 0.7032 23.0008 2.06343 23 4.36395V19.778C23 21.8602 21.4005 23.313 19.4459 22.9421L3.39523 19.8927C2.07817 19.6428 1 18.3759 1 16.7768V7.0322C1 5.4719 2.07975 4.17652 3.39918 3.93927L19.4412 1.05512ZM21.5 19.778C21.5 21.0434 20.6385 21.6414 19.7259 21.4685L3.67485 18.419C3.11986 18.3137 2.5 17.7118 2.5 16.7768V7.0322C2.5 6.12878 3.12577 5.51251 3.66464 5.4156L19.7066 2.53145C20.2661 2.43089 20.6759 2.5804 20.9487 2.82718C21.2288 3.08064 21.5003 3.56449 21.5 4.36395V19.778ZM17.7533 6.69397C17.4462 6.416 16.9719 6.4396 16.694 6.7467L10.0086 14.1324L7.80604 11.6991C7.52807 11.392 7.05379 11.3684 6.7467 11.6463C6.4396 11.9243 6.416 12.3986 6.69397 12.7057L9.0819 15.3438C9.54518 15.8556 10.3357 15.895 10.8475 15.4317L10.9354 15.3438L17.806 7.75332C18.084 7.44622 18.0604 6.97194 17.7533 6.69397Z"
    }
  });
};
var Verifiedvue_type_template_id_d725a574_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Verified.vue?vue&type=script&lang=ts&

/* harmony default export */ var Verifiedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Verified.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Verifiedvue_type_script_lang_ts_ = (Verifiedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Verified.vue





/* normalize component */
;
var Verified_component = normalizeComponent(
  icons_Verifiedvue_type_script_lang_ts_,
  Verifiedvue_type_template_id_d725a574_render,
  Verifiedvue_type_template_id_d725a574_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Verified = (Verified_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Videos.vue?vue&type=template&id=eec94e6c&
var Videosvue_type_template_id_eec94e6c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M6 2H18V4H6V2Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M4 6H20V8H4V6Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M10 19.26V12.73L16 16L10 19.26Z"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M4 10H20C21.1 10 22 10.9 22 12V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V12C2 10.9 2.9 10 4 10ZM20 20H4V12H20V20Z"
    }
  })]);
};
var Videosvue_type_template_id_eec94e6c_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Videos.vue?vue&type=script&lang=ts&

/* harmony default export */ var Videosvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Videos.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Videosvue_type_script_lang_ts_ = (Videosvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Videos.vue





/* normalize component */
;
var Videos_component = normalizeComponent(
  icons_Videosvue_type_script_lang_ts_,
  Videosvue_type_template_id_eec94e6c_render,
  Videosvue_type_template_id_eec94e6c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Videos = (Videos_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ViewSplitHorizontal.vue?vue&type=template&id=152f301e&
var ViewSplitHorizontalvue_type_template_id_152f301e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M3,5H21V7H3V5M3,11V9H21V11H3M3,19V13H21V19H3Z"
    }
  });
};
var ViewSplitHorizontalvue_type_template_id_152f301e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ViewSplitHorizontal.vue?vue&type=script&lang=ts&

/* harmony default export */ var ViewSplitHorizontalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ViewSplitHorizontal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ViewSplitHorizontalvue_type_script_lang_ts_ = (ViewSplitHorizontalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ViewSplitHorizontal.vue





/* normalize component */
;
var ViewSplitHorizontal_component = normalizeComponent(
  icons_ViewSplitHorizontalvue_type_script_lang_ts_,
  ViewSplitHorizontalvue_type_template_id_152f301e_render,
  ViewSplitHorizontalvue_type_template_id_152f301e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ViewSplitHorizontal = (ViewSplitHorizontal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Whatsapp.vue?vue&type=template&id=5c8d79de&
var Whatsappvue_type_template_id_5c8d79de_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12.006 0.800049L12.351 0.805323C15.2167 0.891999 17.8982 2.04416 19.9319 4.07049C22.0472 6.1781 23.2133 8.98386 23.2122 11.964C23.2097 18.117 18.1815 23.1196 12.0016 23.1196C10.2292 23.119 8.48419 22.7005 6.91351 21.902L2.90885 22.9475C2.65398 23.014 2.38607 23.0123 2.13209 22.9424C1.33334 22.7227 0.863943 21.897 1.08367 21.0983L2.14071 17.2558L1.95843 16.9047C1.19651 15.3711 0.7991 13.6802 0.799806 11.955C0.802281 5.80271 5.82939 0.800049 12.006 0.800049ZM12.0058 2.30005L11.73 2.3039C6.50716 2.44983 2.30191 6.72482 2.29981 11.9556C2.29911 13.6559 2.74488 15.3164 3.59437 16.7815C3.69525 16.9555 3.72202 17.1627 3.66868 17.3567L2.52995 21.4961L6.81564 20.3773C6.99989 20.3292 7.19553 20.353 7.36289 20.4438C8.78171 21.214 10.3785 21.619 12.0018 21.6196C17.3549 21.6196 21.71 17.2866 21.7122 11.9634C21.7131 9.38251 20.706 6.95927 18.8732 5.13308C17.0394 3.30595 14.6043 2.30111 12.0058 2.30005ZM8.95423 5.55005C9.46013 5.55005 9.93696 5.76224 10.2876 6.11225L10.4615 6.27586C10.5778 6.38866 10.6953 6.50958 10.817 6.64262L10.8657 6.6971L11.6646 7.50809C12.0608 7.90241 12.2797 8.37645 12.2797 8.88982C12.2797 9.39918 12.0518 9.88618 11.6646 10.2716L11.2758 10.6581C11.3634 10.7925 11.4692 10.9363 11.598 11.0965C12.1803 11.809 12.7819 12.3581 13.364 12.7287L13.76 12.3345C14.1449 11.9514 14.6205 11.7367 15.1301 11.7367C15.6559 11.7367 16.1394 11.955 16.5002 12.3345L17.8668 13.6948C18.6552 14.4796 18.6595 15.623 17.8863 16.4252L17.7835 16.5358C17.6831 16.6402 17.5906 16.7251 17.5147 16.7815C17.3666 16.9167 17.2521 17.0331 17.1105 17.197L16.9622 17.3475C16.4708 17.808 15.8425 18.05 15.1433 18.05L14.9397 18.0486C14.0967 17.997 13.3281 17.7477 12.4773 17.3341C10.8889 16.5646 9.50649 15.4889 8.35172 14.1178C7.4059 12.9825 6.75732 11.902 6.32889 10.7362C6.05347 9.95942 5.91956 9.32294 5.97333 8.58817C6.02813 7.97001 6.28757 7.42534 6.73005 6.98491L7.59871 6.12063C7.9848 5.75654 8.45429 5.55005 8.95423 5.55005ZM8.95423 7.05005C8.85803 7.05005 8.7483 7.09831 8.64237 7.19783L7.78825 8.04801C7.59375 8.24162 7.49077 8.45782 7.46841 8.70904C7.43414 9.17801 7.53081 9.63745 7.73972 10.2268C8.10275 11.2145 8.66324 12.1483 9.50159 13.1546C10.5182 14.3616 11.7326 15.3065 13.1322 15.9846C13.8229 16.3204 14.4197 16.514 14.9856 16.55H15.1433C15.4917 16.55 15.77 16.4333 16.0153 16.1731L16.103 16.0729C16.2238 15.9392 16.3625 15.803 16.55 15.6345C16.6198 15.5805 16.6912 15.5116 16.7783 15.414L16.8648 15.3168C17.012 15.1252 16.9916 14.9401 16.8086 14.7579L15.4278 13.3831C15.3292 13.2795 15.2344 13.2367 15.1301 13.2367C15.0359 13.2367 14.9333 13.2831 14.8183 13.3976L14.0298 14.1824C13.7868 14.4243 13.4106 14.4706 13.1162 14.2947L12.8894 14.1794L12.6578 14.0522C11.8585 13.555 11.1266 12.89 10.4326 12.041C10.0711 11.5912 9.82872 11.2094 9.65685 10.8051C9.53327 10.5143 9.60515 10.1773 9.83662 9.96223L10.0349 9.77406L10.6064 9.20845C10.7256 9.08983 10.7797 8.97415 10.7797 8.88982C10.7797 8.79826 10.7331 8.69728 10.6013 8.56604L9.7601 7.71156L9.69027 7.63213C9.56045 7.49116 9.41818 7.34954 9.25296 7.19783C9.15021 7.09555 9.04795 7.05005 8.95423 7.05005Z"
    }
  });
};
var Whatsappvue_type_template_id_5c8d79de_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Whatsapp.vue?vue&type=script&lang=ts&

/* harmony default export */ var Whatsappvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Whatsapp.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Whatsappvue_type_script_lang_ts_ = (Whatsappvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Whatsapp.vue





/* normalize component */
;
var Whatsapp_component = normalizeComponent(
  icons_Whatsappvue_type_script_lang_ts_,
  Whatsappvue_type_template_id_5c8d79de_render,
  Whatsappvue_type_template_id_5c8d79de_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Whatsapp = (Whatsapp_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomIn.vue?vue&type=template&id=250ff43e&
var ZoomInvue_type_template_id_250ff43e_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M14.71 14H15.5L20.49 19L19 20.49L14 15.5V14.71L13.73 14.43C12.59 15.41 11.11 16 9.5 16C5.91 16 3 13.09 3 9.5C3 5.91 5.91 3 9.5 3C13.09 3 16 5.91 16 9.5C16 11.11 15.41 12.59 14.43 13.73L14.71 14ZM5 9.5C5 11.99 7.01 14 9.5 14C11.99 14 14 11.99 14 9.5C14 7.01 11.99 5 9.5 5C7.01 5 5 7.01 5 9.5ZM10 10H12V9H10V7H9V9H7V10H9V12H10V10Z"
    }
  });
};
var ZoomInvue_type_template_id_250ff43e_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomIn.vue?vue&type=script&lang=ts&

/* harmony default export */ var ZoomInvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomIn.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ZoomInvue_type_script_lang_ts_ = (ZoomInvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomIn.vue





/* normalize component */
;
var ZoomIn_component = normalizeComponent(
  icons_ZoomInvue_type_script_lang_ts_,
  ZoomInvue_type_template_id_250ff43e_render,
  ZoomInvue_type_template_id_250ff43e_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ZoomIn = (ZoomIn_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomInAlt.vue?vue&type=template&id=7583c000&
var ZoomInAltvue_type_template_id_7583c000_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.1881 8.64948c0-4.08662-3.344-7.39948-7.46906-7.39948C4.594 1.25 1.25 4.56286 1.25 8.64948S4.594 16.049 8.71904 16.049c1.18891 0 2.31296-.2752 3.31076-.7648l2.695 2.6951c.9639.9639 2.4754 1.0589 3.3809.1534s.8105-2.4171-.1534-3.3809l-2.634-2.6337c.5552-1.0346.8698-2.2152.8698-3.46862zM13.1292 14.622c.5629-.4086 1.0659-.8935 1.4934-1.4392l2.4495 2.4492c.5065.5065.5525 1.2378.1616 1.6287-.3909.3908-1.1222.3449-1.6287-.1616l-2.4758-2.4771zM2.49484 8.64948c0-3.40552 2.78667-6.16623 6.2242-6.16623 3.43756 0 6.22416 2.76071 6.22416 6.16623 0 3.40552-2.7866 6.16622-6.22416 6.16622-3.43753 0-6.2242-2.7607-6.2242-6.16622zm6.2557 3.36472c-.30682 0-.55555-.2488-.55555-.5556V9.23611H5.97222c-.30682 0-.55555-.24873-.55555-.55555 0-.30683.24873-.55556.55555-.55556h2.22277V5.90305c0-.30683.24873-.55556.55555-.55556.30683 0 .55556.24873.55556.55556V8.125h2.2217c.3068 0 .5555.24873.5555.55556 0 .30682-.2487.55555-.5555.55555H9.3061v2.22249c0 .3068-.24873.5556-.55556.5556z"
    }
  });
};
var ZoomInAltvue_type_template_id_7583c000_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomInAlt.vue?vue&type=script&lang=ts&

/* harmony default export */ var ZoomInAltvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomInAlt.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ZoomInAltvue_type_script_lang_ts_ = (ZoomInAltvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomInAlt.vue





/* normalize component */
;
var ZoomInAlt_component = normalizeComponent(
  icons_ZoomInAltvue_type_script_lang_ts_,
  ZoomInAltvue_type_template_id_7583c000_render,
  ZoomInAltvue_type_template_id_7583c000_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ZoomInAlt = (ZoomInAlt_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomOutAlt.vue?vue&type=template&id=5caffaf6&
var ZoomOutAltvue_type_template_id_5caffaf6_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M16.1881 8.64948c0-4.08662-3.344-7.39948-7.46906-7.39948C4.594 1.25 1.25 4.56286 1.25 8.64948S4.594 16.049 8.71904 16.049c1.18891 0 2.31296-.2752 3.31076-.7648l2.695 2.6951c.9639.9639 2.4754 1.0589 3.3809.1534s.8105-2.4171-.1534-3.3809l-2.634-2.6337c.5552-1.0346.8698-2.2152.8698-3.46862zM13.1292 14.622c.5629-.4086 1.0659-.8935 1.4934-1.4392l2.4495 2.4492c.5065.5065.5525 1.2378.1616 1.6287-.3909.3908-1.1222.3449-1.6287-.1616l-2.4758-2.4771zM2.49484 8.64948c0-3.40552 2.78667-6.16623 6.2242-6.16623 3.43756 0 6.22416 2.76071 6.22416 6.16623 0 3.40552-2.7866 6.16622-6.22416 6.16622-3.43753 0-6.2242-2.7607-6.2242-6.16622zM5.97222 8.125c-.30682 0-.55555.24873-.55555.55556 0 .30682.24873.55555.55555.55555h5.55558c.3068 0 .5555-.24873.5555-.55555 0-.30683-.2487-.55556-.5555-.55556H5.97222z"
    }
  });
};
var ZoomOutAltvue_type_template_id_5caffaf6_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/ZoomOutAlt.vue?vue&type=script&lang=ts&

/* harmony default export */ var ZoomOutAltvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomOutAlt.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_ZoomOutAltvue_type_script_lang_ts_ = (ZoomOutAltvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/ZoomOutAlt.vue





/* normalize component */
;
var ZoomOutAlt_component = normalizeComponent(
  icons_ZoomOutAltvue_type_script_lang_ts_,
  ZoomOutAltvue_type_template_id_5caffaf6_render,
  ZoomOutAltvue_type_template_id_5caffaf6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ZoomOutAlt = (ZoomOutAlt_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Work.vue?vue&type=template&id=3a2ba809&
var Workvue_type_template_id_3a2ba809_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "id": "prefix__a",
      "d": "M12 .25c2.623 0 4.75 2.127 4.75 4.75v1.25h3.644c1.191 0 2.166.925 2.245 2.096l.005.154-.006.162-.256 3.537c-.01.15-.034.298-.068.441l-.599 7.577c-.113 1.43-1.306 2.533-2.741 2.533H5.026c-1.435 0-2.628-1.103-2.741-2.533l-.6-7.582c-.034-.141-.057-.287-.067-.436l-.256-3.537c-.086-1.187.766-2.226 1.928-2.39l.153-.016.03-.002.055-.002.045-.001.033-.001H7.25V5C7.25 2.377 9.377.25 12 .25zm7.64 14.5h-6.784V16c0 .38-.282.693-.648.743l-.102.007c-.414 0-.75-.336-.75-.75v-1.25H4.36c-.359 0-.702-.069-1.018-.195l.438 5.543c.051.65.594 1.152 1.246 1.152h13.948c.652 0 1.194-.501 1.246-1.152l.439-5.543c-.316.126-.66.195-1.02.195zm.743-7l-16.811.001-.015.001c-.412.033-.72.394-.688.807l.3 3.823c.163.506.637.868 1.191.868h6.996V12c0-.38.282-.693.648-.743l.102-.007c.414 0 .75.336.75.75v1.25h6.784c.554 0 1.03-.363 1.19-.87l.301-3.821.002-.059c0-.414-.335-.75-.75-.75zM12 1.75c-1.795 0-3.25 1.455-3.25 3.25v1.25h6.5V5c0-1.795-1.455-3.25-3.25-3.25z"
    }
  });
};
var Workvue_type_template_id_3a2ba809_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Work.vue?vue&type=script&lang=ts&

/* harmony default export */ var Workvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Work.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Workvue_type_script_lang_ts_ = (Workvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Work.vue





/* normalize component */
;
var Work_component = normalizeComponent(
  icons_Workvue_type_script_lang_ts_,
  Workvue_type_template_id_3a2ba809_render,
  Workvue_type_template_id_3a2ba809_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Work = (Work_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PracticalExercises.vue?vue&type=template&id=7e3d3620&
var PracticalExercisesvue_type_template_id_7e3d3620_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M18.75 12.75a5.25 5.25 0 110 10.5 5.25 5.25 0 010-10.5zm-9.75.5c.97 0 1.75.78 1.75 1.75v6c0 .97-.78 1.75-1.75 1.75H3c-.97 0-1.75-.78-1.75-1.75v-6c0-.97.78-1.75 1.75-1.75h6zm9.75 1a3.75 3.75 0 100 7.5 3.75 3.75 0 000-7.5zm-9.75.5H3a.25.25 0 00-.25.25v6c0 .14.11.25.25.25h6c.14 0 .25-.11.25-.25v-6a.25.25 0 00-.25-.25zM12.6.94c.17.09.31.21.42.36l.07.12 4.15 7.47a1.25 1.25 0 01-1.09 1.86h-8.3a1.25 1.25 0 01-1.1-1.86l4.16-7.47c.33-.6 1.1-.82 1.7-.48zm-.6 1.6L8.27 9.25h7.46L12 2.55z"
    }
  });
};
var PracticalExercisesvue_type_template_id_7e3d3620_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PracticalExercises.vue?vue&type=script&lang=ts&

/* harmony default export */ var PracticalExercisesvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/PracticalExercises.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_PracticalExercisesvue_type_script_lang_ts_ = (PracticalExercisesvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/PracticalExercises.vue





/* normalize component */
;
var PracticalExercises_component = normalizeComponent(
  icons_PracticalExercisesvue_type_script_lang_ts_,
  PracticalExercisesvue_type_template_id_7e3d3620_render,
  PracticalExercisesvue_type_template_id_7e3d3620_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PracticalExercises = (PracticalExercises_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Accessibility.vue?vue&type=template&id=049a51e3&
var Accessibilityvue_type_template_id_049a51e3_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "d": "M12 0C18.6298 0 24 5.37018 24 12C24 18.6298 18.6298 24 12 24C5.37018 24 0 18.6298 0 12C0 5.37018 5.37018 0 12 0ZM12 1.67442C6.29494 1.67442 1.67442 6.29494 1.67442 12C1.67442 17.7051 6.29494 22.3256 12 22.3256C17.7051 22.3256 22.3256 17.7051 22.3256 12C22.3256 6.29494 17.7051 1.67442 12 1.67442Z M10.4082 18.6167L11.9317 14.2501H11.9232L12.0934 13.9358L12.2636 14.2589L13.7923 18.6167C13.8298 18.7262 13.8879 18.8267 13.9633 18.9125C14.0387 18.9983 14.1299 19.0676 14.2315 19.1164C14.3841 19.1906 14.5545 19.2162 14.7211 19.1898C14.8877 19.1635 15.043 19.0864 15.1674 18.9684C15.2917 18.8504 15.3795 18.6968 15.4195 18.527C15.4596 18.3572 15.4502 18.1789 15.3924 18.0146L14.3523 15.0305C14.2502 14.7357 14.1838 14.4902 14.1157 14.2501C14.0476 14.01 13.9983 13.7592 13.9455 13.4467C13.8638 12.9717 13.7855 12.4526 13.7259 11.9635C13.6748 11.5468 13.6357 11.1477 13.6221 10.814C13.6033 10.3567 13.7565 10.3284 14.0664 10.2737C14.1447 10.2613 14.2332 10.2454 14.3319 10.2225L17.3007 9.64331C17.4107 9.62207 17.5156 9.57855 17.6093 9.51522C17.7031 9.4519 17.7839 9.37002 17.8471 9.27428C17.9116 9.17832 17.9571 9.07003 17.9809 8.95569C18.0046 8.84136 18.0063 8.72326 17.9857 8.60827C17.9651 8.49327 17.9227 8.38366 17.8609 8.28581C17.7991 8.18796 17.7192 8.10382 17.6258 8.03827C17.4374 7.91057 17.2079 7.86549 16.9875 7.9129L13.8808 8.51678C13.7361 8.5309 13.5914 8.55033 13.4382 8.56799C12.9334 8.63648 12.4254 8.67598 11.9164 8.68629C11.5075 8.68154 11.0993 8.65029 10.6941 8.59271C10.5597 8.57681 10.432 8.56092 10.3009 8.54856L7.00869 7.9076C6.84315 7.87526 6.67208 7.8946 6.51714 7.96317C6.3622 8.03173 6.23036 8.14645 6.13831 8.29279C6.04626 8.43912 5.99814 8.6105 6.00005 8.78522C6.00196 8.95994 6.05381 9.13014 6.14904 9.27428C6.21313 9.36942 6.29469 9.45052 6.38904 9.51293C6.48339 9.57535 6.58867 9.61785 6.69887 9.63802L9.76299 10.2366L9.83789 10.2543C10.1971 10.3425 10.3179 10.3726 10.3026 10.8369C10.2907 11.2095 10.2754 11.6598 10.2532 12.1242C10.2311 12.5885 10.2022 13.0724 10.1613 13.5191C10.143 13.7666 10.1123 14.0129 10.0694 14.2572C10.0211 14.4977 9.95453 14.7338 9.87023 14.9634L8.80801 18.0146C8.75027 18.1789 8.74084 18.3572 8.78091 18.527C8.82098 18.6968 8.90875 18.8504 9.03309 18.9684C9.15743 19.0864 9.31275 19.1635 9.47936 19.1898C9.64597 19.2162 9.81637 19.1906 9.96896 19.1164C10.0705 19.0676 10.1617 18.9983 10.2371 18.9125C10.3126 18.8267 10.3707 18.7262 10.4082 18.6167Z M12.952 5.15302C12.683 4.92441 12.3459 4.79962 11.9981 4.79993C11.8007 4.79972 11.6052 4.84001 11.4229 4.9185C11.2406 4.99699 11.0751 5.11212 10.9359 5.25725C10.6901 5.51248 10.5373 5.84821 10.5034 6.20722C10.4695 6.56624 10.5567 6.92633 10.7501 7.22613C10.9435 7.52594 11.2312 7.7469 11.564 7.85138C11.8969 7.95585 12.2544 7.93737 12.5756 7.79908C12.8968 7.66079 13.1618 7.41126 13.3255 7.09299C13.4892 6.77473 13.5415 6.40743 13.4734 6.05369C13.4053 5.69994 13.221 5.38164 12.952 5.15302Z"
    }
  });
};
var Accessibilityvue_type_template_id_049a51e3_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/Accessibility.vue?vue&type=script&lang=ts&

/* harmony default export */ var Accessibilityvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/Accessibility.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_Accessibilityvue_type_script_lang_ts_ = (Accessibilityvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/Accessibility.vue





/* normalize component */
;
var Accessibility_component = normalizeComponent(
  icons_Accessibilityvue_type_script_lang_ts_,
  Accessibilityvue_type_template_id_049a51e3_render,
  Accessibilityvue_type_template_id_049a51e3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Accessibility = (Accessibility_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PastDue.vue?vue&type=template&id=0abaf254&
var PastDuevue_type_template_id_0abaf254_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M17 0a.75.75 0 0 1 .75.75V2H20a2.75 2.75 0 0 1 2.75 2.75v15A2.75 2.75 0 0 1 20 22.5H4a2.75 2.75 0 0 1-2.75-2.75v-15A2.75 2.75 0 0 1 4 2h2.25V.75a.75.75 0 0 1 .648-.743L7 0a.75.75 0 0 1 .75.75V2h8.5V.75a.75.75 0 0 1 .648-.743L17 0Zm-.75 3.5h-8.5v1.25a.75.75 0 0 1-.648.743L7 5.5a.75.75 0 0 1-.75-.75V3.5H4c-.69 0-1.25.56-1.25 1.25v15c0 .69.56 1.25 1.25 1.25h16c.69 0 1.25-.56 1.25-1.25v-15c0-.69-.56-1.25-1.25-1.25h-2.25v1.25a.75.75 0 0 1-.648.743L17 5.5a.75.75 0 0 1-.75-.75V3.5Z"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.652 8.902a.75.75 0 0 1 0 1.06l-2.591 2.591 2.59 2.591a.75.75 0 0 1 .068.984l-.067.077a.75.75 0 0 1-1.061 0L12 13.614l-2.591 2.591a.75.75 0 0 1-.984.067l-.077-.067a.75.75 0 0 1 0-1.06l2.591-2.592-2.59-2.59a.75.75 0 0 1-.068-.985l.067-.076a.75.75 0 0 1 1.061 0L12 11.492l2.591-2.59a.75.75 0 0 1 .984-.067l.077.067Z"
    }
  })]);
};
var PastDuevue_type_template_id_0abaf254_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons/PastDue.vue?vue&type=script&lang=ts&

/* harmony default export */ var PastDuevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons/PastDue.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_PastDuevue_type_script_lang_ts_ = (PastDuevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons/PastDue.vue





/* normalize component */
;
var PastDue_component = normalizeComponent(
  icons_PastDuevue_type_script_lang_ts_,
  PastDuevue_type_template_id_0abaf254_render,
  PastDuevue_type_template_id_0abaf254_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PastDue = (PastDue_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/CalendarDate.vue?vue&type=template&id=992b9f1a&
var CalendarDatevue_type_template_id_992b9f1a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.652 6.21594H5.05205C4.99901 6.21594 4.94814 6.23701 4.91063 6.27452C4.87312 6.31203 4.85205 6.3629 4.85205 6.41594V18.7999C4.85205 18.853 4.87312 18.9039 4.91063 18.9414C4.94814 18.9789 4.99901 18.9999 5.05205 18.9999H18.652C18.7051 18.9999 18.756 18.9789 18.7935 18.9414C18.831 18.9039 18.852 18.853 18.852 18.7999V6.39994C18.8471 6.35006 18.824 6.30373 18.7871 6.26979C18.7503 6.23585 18.7022 6.21668 18.652 6.21594ZM18.052 17.2559C18.052 17.5105 17.9509 17.7547 17.7709 17.9348C17.5908 18.1148 17.3467 18.2159 17.092 18.2159H6.61205C6.48583 18.2165 6.36076 18.192 6.24405 18.1439C6.12734 18.0959 6.0213 18.0252 5.93205 17.9359C5.8428 17.8467 5.77211 17.7407 5.72405 17.6239C5.67599 17.5072 5.65152 17.3822 5.65205 17.2559V7.97594C5.65205 7.72133 5.75319 7.47715 5.93323 7.29712C6.11326 7.11708 6.35744 7.01594 6.61205 7.01594H17.092C17.3463 7.017 17.5899 7.11848 17.7697 7.29828C17.9495 7.47809 18.051 7.72166 18.052 7.97594V17.2559Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.6522 18.8001V6.40008C19.6522 6.13486 19.5469 5.88051 19.3594 5.69297C19.1718 5.50544 18.9175 5.40008 18.6522 5.40008H16.4682V4.20008C16.4672 3.93519 16.3615 3.68144 16.1742 3.49414C15.9869 3.30683 15.7331 3.20113 15.4682 3.20008H15.0682C14.803 3.20008 14.5487 3.30544 14.3611 3.49297C14.1736 3.68051 14.0682 3.93486 14.0682 4.20008V5.40008H9.66825V4.20008C9.66826 4.0674 9.64188 3.93604 9.59063 3.81366C9.53937 3.69128 9.46428 3.58033 9.36972 3.48725C9.27516 3.39418 9.16302 3.32086 9.03985 3.27156C8.91667 3.22225 8.78491 3.19796 8.65225 3.20008H8.25225C7.98703 3.20008 7.73268 3.30544 7.54514 3.49297C7.3576 3.68051 7.25225 3.93486 7.25225 4.20008V5.40008H5.05225C4.78703 5.40008 4.53268 5.50544 4.34514 5.69297C4.1576 5.88051 4.05225 6.13486 4.05225 6.40008V18.8001C4.05225 19.0653 4.1576 19.3196 4.34514 19.5072C4.53268 19.6947 4.78703 19.8001 5.05225 19.8001H18.6522C18.7836 19.8001 18.9136 19.7742 19.0349 19.724C19.1563 19.6737 19.2665 19.6 19.3594 19.5072C19.4522 19.4143 19.5259 19.3041 19.5761 19.1828C19.6264 19.0614 19.6522 18.9314 19.6522 18.8001ZM14.8522 4.19208C14.8522 4.13904 14.8733 4.08816 14.9108 4.05066C14.9483 4.01315 14.9992 3.99208 15.0522 3.99208H15.4522C15.5053 3.99208 15.5562 4.01315 15.5937 4.05066C15.6312 4.08816 15.6522 4.13904 15.6522 4.19208V5.20008H14.8522V4.19208ZM8.05225 4.19208C8.05225 4.13904 8.07332 4.08816 8.11083 4.05066C8.14833 4.01315 8.1992 3.99208 8.25225 3.99208H8.65225C8.70529 3.99208 8.75616 4.01315 8.79367 4.05066C8.83117 4.08816 8.85225 4.13904 8.85225 4.19208V5.20008H8.05225V4.19208ZM4.85225 18.8001V6.40008C4.85225 6.34704 4.87332 6.29616 4.91082 6.25866C4.94833 6.22115 4.9992 6.20008 5.05225 6.20008H18.6522C18.705 6.2011 18.7552 6.2225 18.7925 6.25979C18.8298 6.29708 18.8512 6.34736 18.8522 6.40008V18.8001C18.8522 18.8531 18.8312 18.904 18.7937 18.9415C18.7562 18.979 18.7053 19.0001 18.6522 19.0001H5.05225C4.9992 19.0001 4.94833 18.979 4.91082 18.9415C4.87332 18.904 4.85225 18.8531 4.85225 18.8001Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.0924 7.01599H6.61235C6.35774 7.01599 6.11356 7.11713 5.93353 7.29717C5.75349 7.4772 5.65235 7.72138 5.65235 7.97599V17.256C5.65182 17.3822 5.67629 17.5073 5.72435 17.624C5.77241 17.7407 5.8431 17.8467 5.93235 17.936C6.0216 18.0252 6.12764 18.0959 6.24435 18.144C6.36106 18.192 6.48614 18.2165 6.61235 18.216H17.0924C17.347 18.216 17.5911 18.1148 17.7712 17.9348C17.9512 17.7548 18.0524 17.5106 18.0524 17.256V7.97599C18.0513 7.72171 17.9498 7.47814 17.77 7.29833C17.5902 7.11852 17.3466 7.01704 17.0924 7.01599ZM17.2524 17.256C17.2524 17.2984 17.2355 17.3391 17.2055 17.3691C17.1755 17.3991 17.1348 17.416 17.0924 17.416H6.61235C6.56992 17.416 6.52922 17.3991 6.49922 17.3691C6.46921 17.3391 6.45235 17.2984 6.45235 17.256V7.97599C6.45235 7.93356 6.46921 7.89286 6.49922 7.86285C6.52922 7.83285 6.56992 7.81599 6.61235 7.81599H17.0924C17.1348 7.81599 17.1755 7.83285 17.2055 7.86285C17.2355 7.89286 17.2524 7.93356 17.2524 7.97599V17.256Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M21.1517 18.8C21.0456 18.8 20.9439 18.8422 20.8689 18.9172C20.7939 18.9922 20.7517 19.094 20.7517 19.2C20.7517 19.344 20.6757 20.592 18.8557 20.8C18.7496 20.8064 18.6504 20.8547 18.5799 20.9342C18.5094 21.0137 18.4734 21.118 18.4797 21.224C18.4861 21.3301 18.5343 21.4293 18.6139 21.4999C18.6934 21.5704 18.7976 21.6064 18.9037 21.6H18.9477C21.0077 21.356 21.5517 19.924 21.5517 19.2C21.5517 19.094 21.5096 18.9922 21.4346 18.9172C21.3596 18.8422 21.2578 18.8 21.1517 18.8Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.1959 11.02H8.9959C9.10199 11.02 9.20373 10.9778 9.27874 10.9028C9.35376 10.8278 9.3959 10.7261 9.3959 10.62C9.3959 10.5139 9.35376 10.4121 9.27874 10.3371C9.20373 10.2621 9.10199 10.22 8.9959 10.22H8.1959C8.08981 10.22 7.98807 10.2621 7.91306 10.3371C7.83804 10.4121 7.7959 10.5139 7.7959 10.62C7.7959 10.7261 7.83804 10.8278 7.91306 10.9028C7.98807 10.9778 8.08981 11.02 8.1959 11.02Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.3082 11.02H11.1082C11.2143 11.02 11.316 10.9778 11.391 10.9028C11.4661 10.8278 11.5082 10.7261 11.5082 10.62C11.5082 10.5139 11.4661 10.4121 11.391 10.3371C11.316 10.2621 11.2143 10.22 11.1082 10.22H10.3082C10.2021 10.22 10.1004 10.2621 10.0254 10.3371C9.95035 10.4121 9.9082 10.5139 9.9082 10.62C9.9082 10.7261 9.95035 10.8278 10.0254 10.9028C10.1004 10.9778 10.2021 11.02 10.3082 11.02Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.5958 11.02H13.3958C13.5019 11.02 13.6036 10.9778 13.6786 10.9028C13.7537 10.8278 13.7958 10.7261 13.7958 10.62C13.7958 10.5139 13.7537 10.4121 13.6786 10.3371C13.6036 10.2621 13.5019 10.22 13.3958 10.22H12.5958C12.4897 10.22 12.388 10.2621 12.313 10.3371C12.2379 10.4121 12.1958 10.5139 12.1958 10.62C12.1958 10.7261 12.2379 10.8278 12.313 10.9028C12.388 10.9778 12.4897 11.02 12.5958 11.02Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.7081 11.02H15.5081C15.6142 11.02 15.7159 10.9778 15.791 10.9028C15.866 10.8278 15.9081 10.7261 15.9081 10.62C15.9081 10.5139 15.866 10.4121 15.791 10.3371C15.7159 10.2621 15.6142 10.22 15.5081 10.22H14.7081C14.602 10.22 14.5003 10.2621 14.4253 10.3371C14.3502 10.4121 14.3081 10.5139 14.3081 10.62C14.3081 10.7261 14.3502 10.8278 14.4253 10.9028C14.5003 10.9778 14.602 11.02 14.7081 11.02Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.9959 11.8201H8.1959C8.08981 11.8201 7.98807 11.8622 7.91306 11.9372C7.83804 12.0122 7.7959 12.114 7.7959 12.2201C7.7959 12.3262 7.83804 12.4279 7.91306 12.5029C7.98807 12.5779 8.08981 12.6201 8.1959 12.6201H8.9959C9.10199 12.6201 9.20373 12.5779 9.27874 12.5029C9.35376 12.4279 9.3959 12.3262 9.3959 12.2201C9.3959 12.114 9.35376 12.0122 9.27874 11.9372C9.20373 11.8622 9.10199 11.8201 8.9959 11.8201Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.1082 11.8201H10.3082C10.2021 11.8201 10.1004 11.8622 10.0254 11.9372C9.95035 12.0122 9.9082 12.114 9.9082 12.2201C9.9082 12.3262 9.95035 12.4279 10.0254 12.5029C10.1004 12.5779 10.2021 12.6201 10.3082 12.6201H11.1082C11.2143 12.6201 11.316 12.5779 11.391 12.5029C11.4661 12.4279 11.5082 12.3262 11.5082 12.2201C11.5082 12.114 11.4661 12.0122 11.391 11.9372C11.316 11.8622 11.2143 11.8201 11.1082 11.8201Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.5958 12.6201H13.3958C13.5019 12.6201 13.6036 12.5779 13.6786 12.5029C13.7537 12.4279 13.7958 12.3262 13.7958 12.2201C13.7958 12.114 13.7537 12.0122 13.6786 11.9372C13.6036 11.8622 13.5019 11.8201 13.3958 11.8201H12.5958C12.4897 11.8201 12.388 11.8622 12.313 11.9372C12.2379 12.0122 12.1958 12.114 12.1958 12.2201C12.1958 12.3262 12.2379 12.4279 12.313 12.5029C12.388 12.5779 12.4897 12.6201 12.5958 12.6201Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.5081 11.8201H14.7081C14.602 11.8201 14.5003 11.8622 14.4253 11.9372C14.3502 12.0122 14.3081 12.114 14.3081 12.2201C14.3081 12.3262 14.3502 12.4279 14.4253 12.5029C14.5003 12.5779 14.602 12.6201 14.7081 12.6201H15.5081C15.6142 12.6201 15.7159 12.5779 15.791 12.5029C15.866 12.4279 15.9081 12.3262 15.9081 12.2201C15.9081 12.114 15.866 12.0122 15.791 11.9372C15.7159 11.8622 15.6142 11.8201 15.5081 11.8201Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.9959 13.4199H8.1959C8.08981 13.4199 7.98807 13.4621 7.91306 13.5371C7.83804 13.6121 7.7959 13.7138 7.7959 13.8199C7.7959 13.926 7.83804 14.0277 7.91306 14.1028C7.98807 14.1778 8.08981 14.2199 8.1959 14.2199H8.9959C9.10199 14.2199 9.20373 14.1778 9.27874 14.1028C9.35376 14.0277 9.3959 13.926 9.3959 13.8199C9.3959 13.7138 9.35376 13.6121 9.27874 13.5371C9.20373 13.4621 9.10199 13.4199 8.9959 13.4199Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.1082 13.4199H10.3082C10.2021 13.4199 10.1004 13.4621 10.0254 13.5371C9.95035 13.6121 9.9082 13.7138 9.9082 13.8199C9.9082 13.926 9.95035 14.0277 10.0254 14.1028C10.1004 14.1778 10.2021 14.2199 10.3082 14.2199H11.1082C11.2143 14.2199 11.316 14.1778 11.391 14.1028C11.4661 14.0277 11.5082 13.926 11.5082 13.8199C11.5082 13.7138 11.4661 13.6121 11.391 13.5371C11.316 13.4621 11.2143 13.4199 11.1082 13.4199Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.3958 13.4199H12.5958C12.4897 13.4199 12.388 13.4621 12.313 13.5371C12.2379 13.6121 12.1958 13.7138 12.1958 13.8199C12.1958 13.926 12.2379 14.0277 12.313 14.1028C12.388 14.1778 12.4897 14.2199 12.5958 14.2199H13.3958C13.5019 14.2199 13.6036 14.1778 13.6786 14.1028C13.7537 14.0277 13.7958 13.926 13.7958 13.8199C13.7958 13.7138 13.7537 13.6121 13.6786 13.5371C13.6036 13.4621 13.5019 13.4199 13.3958 13.4199Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.5081 13.4199H14.7081C14.602 13.4199 14.5003 13.4621 14.4253 13.5371C14.3502 13.6121 14.3081 13.7138 14.3081 13.8199C14.3081 13.926 14.3502 14.0277 14.4253 14.1028C14.5003 14.1778 14.602 14.2199 14.7081 14.2199H15.5081C15.6142 14.2199 15.7159 14.1778 15.791 14.1028C15.866 14.0277 15.9081 13.926 15.9081 13.8199C15.9081 13.7138 15.866 13.6121 15.791 13.5371C15.7159 13.4621 15.6142 13.4199 15.5081 13.4199Z",
      "fill": "black"
    }
  })]);
};
var CalendarDatevue_type_template_id_992b9f1a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/CalendarDate.vue?vue&type=script&lang=ts&

/* harmony default export */ var CalendarDatevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/CalendarDate.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_CalendarDatevue_type_script_lang_ts_ = (CalendarDatevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/CalendarDate.vue





/* normalize component */
;
var CalendarDate_component = normalizeComponent(
  icons_notifications_CalendarDatevue_type_script_lang_ts_,
  CalendarDatevue_type_template_id_992b9f1a_render,
  CalendarDatevue_type_template_id_992b9f1a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CalendarDate = (CalendarDate_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Certified.vue?vue&type=template&id=7b56c292&
var Certifiedvue_type_template_id_7b56c292_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M14.436 9.83993L15.02 9.25593C15.0574 9.21886 15.1017 9.18953 15.1505 9.16962C15.1992 9.14972 15.2514 9.13963 15.304 9.13993C15.409 9.14037 15.5095 9.18203 15.584 9.25593L16.168 9.83993V6.45593H14.436V9.83993Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.9718 5.73206H4.02783C3.76294 5.73311 3.5092 5.8388 3.32189 6.02611C3.13458 6.21342 3.02889 6.46716 3.02783 6.73206V17.2681C3.02889 17.5329 3.13458 17.7867 3.32189 17.974C3.5092 18.1613 3.76294 18.267 4.02783 18.2681H19.9718C20.2367 18.267 20.4905 18.1613 20.6778 17.974C20.8651 17.7867 20.9708 17.5329 20.9718 17.2681V6.73206C20.9708 6.46716 20.8651 6.21342 20.6778 6.02611C20.4905 5.8388 20.2367 5.73311 19.9718 5.73206ZM14.4358 8.00006V6.45606H16.1678V9.84006L15.5998 9.25606C15.5253 9.18216 15.4248 9.1405 15.3198 9.14006C15.2672 9.13975 15.215 9.14984 15.1663 9.16975C15.1175 9.18965 15.0732 9.21898 15.0358 9.25606L14.4358 9.84006V8.00006ZM13.8798 11.1761C13.9296 11.195 13.9825 11.2045 14.0358 11.2041C14.1408 11.2036 14.2413 11.162 14.3158 11.0881L15.3038 10.1041L16.2878 11.0881C16.344 11.1431 16.4151 11.1804 16.4923 11.1952C16.5696 11.2101 16.6494 11.2018 16.722 11.1715C16.7945 11.1412 16.8566 11.0902 16.9003 11.0248C16.944 10.9595 16.9675 10.8827 16.9678 10.8041V8.00006H18.1198C18.1623 8.00006 18.203 8.01691 18.233 8.04692C18.263 8.07692 18.2798 8.11762 18.2798 8.16006V15.8401C18.2798 15.8825 18.263 15.9232 18.233 15.9532C18.203 15.9832 18.1623 16.0001 18.1198 16.0001H5.87983C5.8374 16.0001 5.7967 15.9832 5.76669 15.9532C5.73669 15.9232 5.71983 15.8825 5.71983 15.8401V8.16006C5.71983 8.11762 5.73669 8.07692 5.76669 8.04692C5.7967 8.01691 5.8374 8.00006 5.87983 8.00006H13.6358V10.8001C13.6343 10.8799 13.6567 10.9584 13.7002 11.0254C13.7437 11.0925 13.8063 11.1449 13.8798 11.1761ZM20.1718 17.2681C20.1708 17.3208 20.1494 17.3711 20.1121 17.4083C20.0748 17.4456 20.0246 17.467 19.9718 17.4681H4.02783C3.97511 17.467 3.92483 17.4456 3.88754 17.4083C3.85026 17.3711 3.82886 17.3208 3.82783 17.2681V6.73206C3.82886 6.67933 3.85026 6.62905 3.88754 6.59177C3.92483 6.55448 3.97511 6.53308 4.02783 6.53206H13.6278V7.20006H5.87983C5.62555 7.20111 5.38198 7.30259 5.20217 7.4824C5.02237 7.6622 4.92088 7.90577 4.91983 8.16006V15.8401C4.92088 16.0943 5.02237 16.3379 5.20217 16.5177C5.38198 16.6975 5.62555 16.799 5.87983 16.8001H18.1198C18.3741 16.799 18.6177 16.6975 18.7975 16.5177C18.9773 16.3379 19.0788 16.0943 19.0798 15.8401V8.16006C19.0788 7.90577 18.9773 7.6622 18.7975 7.4824C18.6177 7.30259 18.3741 7.20111 18.1198 7.20006H16.9678V6.53206H19.9718C20.0246 6.53308 20.0748 6.55448 20.1121 6.59177C20.1494 6.62905 20.1708 6.67933 20.1718 6.73206V17.2681Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.89219 11.2H11.6362C11.7423 11.2 11.844 11.1579 11.919 11.0829C11.994 11.0079 12.0362 10.9061 12.0362 10.8C12.0362 10.6939 11.994 10.5922 11.919 10.5172C11.844 10.4422 11.7423 10.4 11.6362 10.4H7.89219C7.7861 10.4 7.68436 10.4422 7.60935 10.5172C7.53433 10.5922 7.49219 10.6939 7.49219 10.8C7.49219 10.9061 7.53433 11.0079 7.60935 11.0829C7.68436 11.1579 7.7861 11.2 7.89219 11.2Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.7082 12.8H7.89219C7.7861 12.8 7.68436 12.8422 7.60935 12.9172C7.53433 12.9922 7.49219 13.094 7.49219 13.2C7.49219 13.3061 7.53433 13.4079 7.60935 13.4829C7.68436 13.5579 7.7861 13.6 7.89219 13.6H11.7082C11.8143 13.6 11.916 13.5579 11.991 13.4829C12.066 13.4079 12.1082 13.3061 12.1082 13.2C12.1082 13.094 12.066 12.9922 11.991 12.9172C11.916 12.8422 11.8143 12.8 11.7082 12.8Z",
      "fill": "black"
    }
  })]);
};
var Certifiedvue_type_template_id_7b56c292_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Certified.vue?vue&type=script&lang=ts&

/* harmony default export */ var Certifiedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Certified.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_Certifiedvue_type_script_lang_ts_ = (Certifiedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Certified.vue





/* normalize component */
;
var Certified_component = normalizeComponent(
  icons_notifications_Certifiedvue_type_script_lang_ts_,
  Certifiedvue_type_template_id_7b56c292_render,
  Certifiedvue_type_template_id_7b56c292_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Certified = (Certified_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/NotebookPlay.vue?vue&type=template&id=f621fe42&
var NotebookPlayvue_type_template_id_f621fe42_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M20.3998 17.672H19.5998V8.07197C19.5998 7.8598 19.5155 7.65632 19.3655 7.50629C19.2155 7.35626 19.012 7.27197 18.7998 7.27197H5.1998C4.98763 7.27197 4.78415 7.35626 4.63412 7.50629C4.48409 7.65632 4.3998 7.8598 4.3998 8.07197V17.672H3.5998C3.38763 17.672 3.18415 17.7563 3.03412 17.9063C2.88409 18.0563 2.7998 18.2598 2.7998 18.472V19.36C2.7998 19.5721 2.88409 19.7756 3.03412 19.9257C3.18415 20.0757 3.38763 20.16 3.5998 20.16H20.3998C20.612 20.16 20.8155 20.0757 20.9655 19.9257C21.1155 19.7756 21.1998 19.5721 21.1998 19.36V18.472C21.1998 18.2598 21.1155 18.0563 20.9655 17.9063C20.8155 17.7563 20.612 17.672 20.3998 17.672ZM5.1998 8.07197H18.7998V17.672H5.1998V8.07197ZM20.3998 19.36H3.5998V18.472H20.3998V19.36Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 8.87207C11.2089 8.87207 10.4355 9.10667 9.77772 9.54619C9.11992 9.98572 8.60723 10.6104 8.30448 11.3413C8.00173 12.0722 7.92252 12.8765 8.07686 13.6524C8.2312 14.4284 8.61216 15.1411 9.17157 15.7005C9.73099 16.2599 10.4437 16.6409 11.2196 16.7952C11.9956 16.9496 12.7998 16.8703 13.5307 16.5676C14.2616 16.2648 14.8864 15.7521 15.3259 15.0944C15.7654 14.4366 16 13.6632 16 12.8721C16 11.8112 15.5786 10.7938 14.8284 10.0436C14.0783 9.2935 13.0609 8.87207 12 8.87207ZM12 16.0721C11.3671 16.0721 10.7484 15.8844 10.2222 15.5328C9.69594 15.1812 9.28579 14.6814 9.04359 14.0967C8.80139 13.5119 8.73802 12.8685 8.86149 12.2478C8.98496 11.627 9.28973 11.0569 9.73726 10.6093C10.1848 10.1618 10.755 9.85703 11.3757 9.73356C11.9965 9.61008 12.6399 9.67345 13.2246 9.91566C13.8093 10.1579 14.3091 10.568 14.6607 11.0942C15.0123 11.6205 15.2 12.2392 15.2 12.8721C15.2 13.7208 14.8629 14.5347 14.2627 15.1348C13.6626 15.7349 12.8487 16.0721 12 16.0721Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.2922 12.192L12.0482 11.416C11.9287 11.3421 11.7918 11.301 11.6514 11.2967C11.511 11.2925 11.3719 11.3254 11.2482 11.392C11.1255 11.4628 11.0238 11.5649 10.9536 11.6879C10.8833 11.8109 10.8469 11.9503 10.8482 12.092V13.648C10.8469 13.7896 10.8833 13.9291 10.9536 14.0521C11.0238 14.175 11.1255 14.2772 11.2482 14.348C11.3711 14.4142 11.5086 14.4486 11.6482 14.448C11.7986 14.4488 11.9459 14.4057 12.0722 14.324L13.3162 13.548C13.4311 13.476 13.5258 13.3761 13.5914 13.2575C13.6571 13.1389 13.6915 13.0055 13.6915 12.87C13.6915 12.7344 13.6571 12.6011 13.5914 12.4825C13.5258 12.3639 13.4311 12.2639 13.3162 12.192H13.2922ZM11.6242 13.648V12.092L12.8682 12.872L11.6242 13.648Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12 4.64799C11.4705 4.64885 10.9466 4.75544 10.4589 4.9615C9.97123 5.16757 9.5296 5.46896 9.15996 5.84799C9.11308 5.88227 9.07423 5.92635 9.04611 5.97717C9.01799 6.02798 9.00127 6.08431 8.99712 6.14224C8.99296 6.20017 9.00147 6.25831 9.02206 6.31261C9.04264 6.36692 9.0748 6.41609 9.11631 6.45672C9.15782 6.49734 9.20767 6.52844 9.26241 6.54785C9.31714 6.56726 9.37545 6.57452 9.43328 6.56912C9.4911 6.56372 9.54706 6.54579 9.59726 6.51659C9.64746 6.48738 9.69069 6.44759 9.72396 6.39999C10.0215 6.09859 10.3758 5.85925 10.7665 5.69583C11.1572 5.53241 11.5765 5.44817 12 5.44799C12.4252 5.44813 12.8463 5.5323 13.239 5.69568C13.6316 5.85905 13.9881 6.09841 14.288 6.39999C14.3629 6.47449 14.4643 6.5163 14.57 6.5163C14.6756 6.5163 14.777 6.47449 14.852 6.39999C14.9265 6.32504 14.9683 6.22366 14.9683 6.11799C14.9683 6.01231 14.9265 5.91093 14.852 5.83599C14.4801 5.4566 14.0364 5.15509 13.5467 4.94905C13.057 4.74302 12.5312 4.63659 12 4.63599V4.64799Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.86397 5.13601C9.69686 4.30649 10.8245 3.84076 12 3.84076C13.1755 3.84076 14.3031 4.30649 15.136 5.13601C15.2109 5.21051 15.3123 5.25232 15.418 5.25232C15.5236 5.25232 15.625 5.21051 15.7 5.13601C15.7745 5.06106 15.8163 4.95968 15.8163 4.85401C15.8163 4.74833 15.7745 4.64695 15.7 4.57201C14.7177 3.59252 13.3871 3.04248 12 3.04248C10.6128 3.04248 9.28224 3.59252 8.29997 4.57201C8.2581 4.60787 8.22409 4.65199 8.20008 4.70162C8.17607 4.75125 8.16258 4.8053 8.16045 4.86039C8.15833 4.91547 8.16761 4.97041 8.18772 5.02174C8.20783 5.07307 8.23833 5.11969 8.27731 5.15867C8.3163 5.19765 8.36291 5.22815 8.41424 5.24826C8.46557 5.26837 8.52051 5.27765 8.57559 5.27553C8.63068 5.2734 8.68474 5.25991 8.73436 5.2359C8.78399 5.21189 8.82811 5.17788 8.86397 5.13601Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.2002 8.07202V17.672H18.8002V8.07202H5.2002ZM12.0002 16.872C11.2091 16.872 10.4357 16.6374 9.77792 16.1979C9.12012 15.7584 8.60743 15.1337 8.30468 14.4028C8.00193 13.6719 7.92271 12.8676 8.07705 12.0917C8.2314 11.3157 8.61236 10.603 9.17177 10.0436C9.73118 9.48418 10.4439 9.10322 11.2198 8.94888C11.9958 8.79454 12.8 8.87375 13.5309 9.1765C14.2618 9.47925 14.8865 9.99194 15.3261 10.6497C15.7656 11.3075 16.0002 12.0809 16.0002 12.872C16.0002 13.9329 15.5788 14.9503 14.8286 15.7004C14.0785 16.4506 13.0611 16.872 12.0002 16.872Z",
      "fill": "#00E88F"
    }
  })]);
};
var NotebookPlayvue_type_template_id_f621fe42_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/NotebookPlay.vue?vue&type=script&lang=ts&

/* harmony default export */ var NotebookPlayvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/NotebookPlay.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_NotebookPlayvue_type_script_lang_ts_ = (NotebookPlayvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/NotebookPlay.vue





/* normalize component */
;
var NotebookPlay_component = normalizeComponent(
  icons_notifications_NotebookPlayvue_type_script_lang_ts_,
  NotebookPlayvue_type_template_id_f621fe42_render,
  NotebookPlayvue_type_template_id_f621fe42_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotebookPlay = (NotebookPlay_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Phone24h.vue?vue&type=template&id=62585f32&
var Phone24hvue_type_template_id_62585f32_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.3761 7.34797C17.9267 7.34943 17.4951 7.17248 17.1761 6.85597C17.0259 6.70741 16.9076 6.52974 16.8285 6.33385C16.7493 6.13796 16.711 5.92798 16.7159 5.71677C16.7208 5.50556 16.7687 5.29756 16.8568 5.10553C16.9448 4.91349 17.0712 4.74146 17.2281 4.59998C16.7842 4.65055 16.374 4.86126 16.0743 5.19261C15.7746 5.52397 15.606 5.95323 15.6001 6.39997C15.6106 6.88942 15.8149 7.35471 16.1681 7.69368C16.5213 8.03266 16.9946 8.21762 17.4841 8.20797C17.8418 8.2104 18.1929 8.11135 18.4967 7.92232C18.8004 7.73329 19.0443 7.46202 19.2001 7.13997C18.9469 7.27651 18.6638 7.34798 18.3761 7.34797Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.39987 15.8001C7.26843 15.7996 7.1382 15.8252 7.01668 15.8753C6.89517 15.9254 6.78478 15.9991 6.69187 16.0921C6.50573 16.2807 6.40137 16.535 6.40137 16.8001C6.40137 17.0651 6.50573 17.3194 6.69187 17.5081C6.88 17.6952 7.13454 17.8002 7.39987 17.8002C7.6652 17.8002 7.91975 17.6952 8.10787 17.5081C8.29401 17.3194 8.39838 17.0651 8.39838 16.8001C8.39838 16.535 8.29401 16.2807 8.10787 16.0921C8.01497 15.9991 7.90457 15.9254 7.78306 15.8753C7.66155 15.8252 7.53131 15.7996 7.39987 15.8001Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.7478 6.55607C19.5993 6.41699 19.4033 6.33975 19.1998 6.34007C19.0604 6.33665 18.9225 6.36975 18.7998 6.43607C18.6284 6.52929 18.4317 6.56557 18.2383 6.53969C18.0449 6.5138 17.8647 6.42708 17.7238 6.29207C17.6498 6.2199 17.5914 6.13333 17.5522 6.0377C17.513 5.94206 17.4938 5.83941 17.4958 5.73607C17.5028 5.63303 17.5305 5.53245 17.5772 5.44035C17.6239 5.34826 17.6888 5.26653 17.7678 5.20007C17.8907 5.09176 17.9773 4.94835 18.0161 4.7892C18.0549 4.63005 18.0438 4.46285 17.9845 4.31018C17.9252 4.1575 17.8204 4.02672 17.6844 3.93549C17.5483 3.84426 17.3876 3.79699 17.2238 3.80007H17.1198C16.4836 3.87859 15.8977 4.18554 15.4709 4.66381C15.0441 5.14208 14.8056 5.7591 14.7998 6.40007C14.8009 6.74742 14.8724 7.09095 15.0099 7.40994C15.1474 7.72893 15.348 8.01676 15.5998 8.25607C15.9101 8.5501 16.2853 8.76707 16.6949 8.88949C17.1045 9.01191 17.5371 9.03635 17.9579 8.96083C18.3787 8.88532 18.7759 8.71196 19.1173 8.45475C19.4588 8.19753 19.7351 7.86367 19.9238 7.48007C19.9958 7.3272 20.0176 7.15546 19.9859 6.98947C19.9543 6.82348 19.871 6.67176 19.7478 6.55607ZM17.4838 8.20007C16.9957 8.20974 16.5236 8.02587 16.1706 7.68861C15.8176 7.35135 15.6124 6.88812 15.5998 6.40007C15.6075 5.95533 15.7764 5.5285 16.0751 5.19891C16.3738 4.86931 16.782 4.65936 17.2238 4.60807C17.0674 4.74987 16.9415 4.92201 16.8538 5.11401C16.766 5.30601 16.7183 5.51386 16.7134 5.7249C16.7086 5.93595 16.7467 6.14577 16.8255 6.34161C16.9043 6.53745 17.0221 6.71521 17.1718 6.86407C17.4908 7.18057 17.9224 7.35753 18.3718 7.35607C18.6615 7.35428 18.9462 7.28003 19.1998 7.14007C19.0429 7.46062 18.7985 7.73024 18.4948 7.9178C18.1912 8.10537 17.8407 8.20322 17.4838 8.20007Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.72828 13.2C4.74532 13.2932 4.79487 13.3773 4.86812 13.4374C4.94137 13.4974 5.03356 13.5295 5.12828 13.528H5.20028C5.25203 13.5188 5.30146 13.4995 5.34576 13.4713C5.39006 13.443 5.42834 13.4062 5.45843 13.3631C5.48852 13.32 5.50982 13.2714 5.52112 13.2201C5.53242 13.1688 5.53349 13.1157 5.52428 13.064C5.46504 12.7429 5.42763 12.4181 5.41228 12.092V11.908C5.39798 11.0146 5.55988 10.1272 5.88872 9.29648C6.21756 8.46574 6.70689 7.70793 7.32874 7.06639C7.9506 6.42485 8.69278 5.91215 9.51288 5.55758C10.333 5.20302 11.2149 5.01355 12.1083 5C12.5019 4.99596 12.8952 5.02405 13.2843 5.084C13.4403 5.112 13.5923 5.14 13.7443 5.176L13.9403 5.224C14.0401 5.24394 14.1439 5.22503 14.2303 5.17113C14.3167 5.11723 14.3793 5.0324 14.4053 4.93393C14.4313 4.83546 14.4188 4.73078 14.3703 4.64123C14.3218 4.55167 14.241 4.484 14.1443 4.452L13.9243 4.4C13.7563 4.36 13.5843 4.328 13.4083 4.3C12.9743 4.2318 12.5355 4.19969 12.0963 4.204C10.0813 4.2314 8.15964 5.05795 6.75395 6.5019C5.34825 7.94585 4.57358 9.88898 4.60028 11.904V12.104C4.61633 12.4719 4.65911 12.8382 4.72828 13.2Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.4956 9.67203C19.4809 9.62161 19.4564 9.57457 19.4236 9.53361C19.3907 9.49265 19.35 9.45857 19.304 9.43331C19.2579 9.40805 19.2073 9.39211 19.1551 9.3864C19.1029 9.38069 19.0501 9.38532 18.9996 9.40003C18.9492 9.41474 18.9022 9.43924 18.8612 9.47212C18.8203 9.50501 18.7862 9.54564 18.7609 9.5917C18.7357 9.63776 18.7197 9.68834 18.714 9.74056C18.7083 9.79277 18.7129 9.84561 18.7276 9.89603C18.7896 10.1011 18.8403 10.3094 18.8796 10.52C18.9525 10.9161 18.9926 11.3174 18.9996 11.72C19.021 13.5215 18.3266 15.2578 17.0689 16.5477C15.8112 17.8377 14.0931 18.5758 12.2916 18.6C11.8899 18.6053 11.4884 18.5759 11.0916 18.512C11.0391 18.5036 10.9854 18.5057 10.9337 18.518C10.882 18.5303 10.8331 18.5527 10.7901 18.5839C10.747 18.6151 10.7105 18.6545 10.6826 18.6998C10.6547 18.7451 10.6361 18.7955 10.6276 18.848C10.6192 18.9006 10.6213 18.9542 10.6336 19.006C10.6459 19.0577 10.6683 19.1065 10.6995 19.1496C10.7307 19.1927 10.7701 19.2292 10.8154 19.2571C10.8608 19.285 10.9111 19.3036 10.9636 19.312C11.3695 19.3797 11.7802 19.4132 12.1916 19.412H12.2956C13.2954 19.3995 14.2829 19.1899 15.2015 18.7951C16.1201 18.4002 16.9518 17.8281 17.6489 17.1113C18.346 16.3945 18.8948 15.5472 19.2638 14.618C19.6329 13.6887 19.815 12.6958 19.7996 11.696C19.7924 11.2503 19.7469 10.806 19.6636 10.368C19.6204 10.1331 19.5643 9.90079 19.4956 9.67203Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.5721 15.4C14.107 15.3962 14.634 15.2698 15.1124 15.0306C15.5909 14.7914 16.0081 14.4456 16.3321 14.02L16.4481 13.864C16.5377 13.7464 16.5881 13.6036 16.5924 13.4559C16.5967 13.3081 16.5547 13.1627 16.4721 13.04C15.9723 12.2867 15.2091 11.7475 14.3321 11.528L14.1761 11.492C14.0568 11.4627 13.9319 11.4646 13.8135 11.4975C13.6951 11.5304 13.5872 11.5933 13.5001 11.68L13.0441 12.08L11.8961 10.88L12.2961 10.48C12.3845 10.3932 12.4484 10.2847 12.4814 10.1653C12.5145 10.0459 12.5154 9.91987 12.4841 9.80001L12.4441 9.64401C12.2302 8.77636 11.7013 8.01928 10.9601 7.52001C10.8375 7.43747 10.692 7.39541 10.5443 7.39971C10.3965 7.40402 10.2538 7.45448 10.1361 7.54401L9.98012 7.66001C9.55448 7.98401 9.20876 8.40126 8.96954 8.87971C8.73031 9.35817 8.60393 9.88509 8.60012 10.42C8.59681 11.3349 8.95642 12.2138 9.60012 12.864L11.1361 14.4C11.7843 15.0417 12.66 15.4012 13.5721 15.4ZM9.40012 10.424C9.4018 10.0123 9.4983 9.60659 9.68213 9.23824C9.86596 8.8699 10.1322 8.54885 10.4601 8.30001L10.5681 8.22001C11.1292 8.60881 11.5289 9.18918 11.6921 9.85201L11.7201 9.96401L11.3201 10.364C11.1667 10.5197 11.0807 10.7295 11.0807 10.948C11.0807 11.1666 11.1667 11.3763 11.3201 11.532L12.4681 12.68C12.6243 12.8325 12.8339 12.9178 13.0521 12.9178C13.2704 12.9178 13.48 12.8325 13.6361 12.68L14.0361 12.3L14.1481 12.324C14.81 12.4916 15.3894 12.892 15.7801 13.452L15.7001 13.56C15.4513 13.888 15.1302 14.1542 14.7619 14.338C14.3935 14.5218 13.9878 14.6183 13.5761 14.62C12.8756 14.6174 12.2043 14.3386 11.7081 13.844L10.1801 12.316C9.93127 12.068 9.73417 11.7731 9.60027 11.4483C9.46637 11.1235 9.39833 10.7753 9.40012 10.424Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.67173 15.528C8.42008 15.276 8.09936 15.1044 7.75013 15.0348C7.4009 14.9651 7.03887 15.0006 6.70983 15.1368C6.38079 15.273 6.09954 15.5037 5.90165 15.7997C5.70377 16.0958 5.59814 16.4439 5.59814 16.8C5.59814 17.1561 5.70377 17.5042 5.90165 17.8003C6.09954 18.0963 6.38079 18.327 6.70983 18.4632C7.03887 18.5994 7.4009 18.6349 7.75013 18.5652C8.09936 18.4956 8.42008 18.324 8.67173 18.072C8.84008 17.9057 8.97374 17.7076 9.06496 17.4893C9.15619 17.2709 9.20316 17.0366 9.20316 16.8C9.20316 16.5634 9.15619 16.3291 9.06496 16.1107C8.97374 15.8924 8.84008 15.6943 8.67173 15.528ZM8.10773 17.528C7.9196 17.7151 7.66506 17.8201 7.39973 17.8201C7.1344 17.8201 6.87986 17.7151 6.69173 17.528C6.50559 17.3394 6.40122 17.085 6.40122 16.82C6.40122 16.555 6.50559 16.3006 6.69173 16.112C6.87986 15.9249 7.1344 15.8199 7.39973 15.8199C7.66506 15.8199 7.9196 15.9249 8.10773 16.112C8.2879 16.2997 8.3885 16.5498 8.3885 16.81C8.3885 17.0702 8.2879 17.3203 8.10773 17.508V17.528Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.2802 18.3559L4.9962 18.6399C4.9217 18.7149 4.87988 18.8163 4.87988 18.9219C4.87988 19.0276 4.9217 19.129 4.9962 19.2039C5.07114 19.2784 5.17253 19.3203 5.2782 19.3203C5.38387 19.3203 5.48526 19.2784 5.5602 19.2039L5.8442 18.9199C5.90973 18.8434 5.94397 18.745 5.94009 18.6443C5.9362 18.5437 5.89446 18.4482 5.82323 18.3769C5.75199 18.3057 5.65649 18.264 5.55582 18.2601C5.45515 18.2562 5.35672 18.2904 5.2802 18.3559Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.23616 14.3999L8.95616 14.6839C8.88166 14.7589 8.83984 14.8603 8.83984 14.9659C8.83984 15.0716 8.88166 15.173 8.95616 15.2479C9.03111 15.3224 9.13249 15.3643 9.23816 15.3643C9.34383 15.3643 9.44522 15.3224 9.52016 15.2479L9.80416 14.9639C9.87866 14.889 9.92048 14.7876 9.92048 14.6819C9.92048 14.5763 9.87866 14.4749 9.80416 14.3999C9.76697 14.3624 9.72273 14.3327 9.67399 14.3124C9.62525 14.2921 9.57296 14.2816 9.52016 14.2816C9.46736 14.2816 9.41507 14.2921 9.36633 14.3124C9.31759 14.3327 9.27335 14.3624 9.23616 14.3999Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.9962 14.4C4.9217 14.475 4.87988 14.5763 4.87988 14.682C4.87988 14.7877 4.9217 14.8891 4.9962 14.964L5.2802 15.248C5.35514 15.3225 5.45653 15.3643 5.5622 15.3643C5.66787 15.3643 5.76925 15.3225 5.8442 15.248C5.9187 15.1731 5.96052 15.0717 5.96052 14.966C5.96052 14.8603 5.9187 14.759 5.8442 14.684L5.5602 14.4C5.48525 14.3255 5.38387 14.2837 5.2782 14.2837C5.17253 14.2837 5.07114 14.3255 4.9962 14.4Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.51974 18.356C9.48388 18.3141 9.43975 18.2801 9.39012 18.2561C9.3405 18.2321 9.28645 18.2186 9.23136 18.2165C9.17627 18.2144 9.12134 18.2236 9.07001 18.2437C9.01868 18.2639 8.97206 18.2944 8.93308 18.3333C8.89409 18.3723 8.86359 18.4189 8.84348 18.4703C8.82337 18.5216 8.81409 18.5765 8.81622 18.6316C8.81834 18.6867 8.83184 18.7408 8.85585 18.7904C8.87985 18.84 8.91386 18.8841 8.95574 18.92L9.23974 19.204C9.31424 19.2779 9.4148 19.3196 9.51974 19.32C9.57238 19.3203 9.62456 19.3102 9.6733 19.2903C9.72203 19.2704 9.76636 19.2411 9.80374 19.204C9.87824 19.1291 9.92005 19.0277 9.92005 18.922C9.92005 18.8163 9.87824 18.7149 9.80374 18.64L9.51974 18.356Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7 13.8V14.2C7 14.3061 7.04214 14.4079 7.11716 14.4829C7.19217 14.5579 7.29391 14.6 7.4 14.6C7.50609 14.6 7.60783 14.5579 7.68284 14.4829C7.75786 14.4079 7.8 14.3061 7.8 14.2V13.8C7.8 13.6939 7.75786 13.5922 7.68284 13.5172C7.60783 13.4422 7.50609 13.4 7.4 13.4C7.29391 13.4 7.19217 13.4422 7.11716 13.5172C7.04214 13.5922 7 13.6939 7 13.8Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.4 19C7.29391 19 7.19217 19.0421 7.11716 19.1172C7.04214 19.1922 7 19.2939 7 19.4V19.8C7 19.9061 7.04214 20.0078 7.11716 20.0828C7.19217 20.1579 7.29391 20.2 7.4 20.2C7.50609 20.2 7.60783 20.1579 7.68284 20.0828C7.75786 20.0078 7.8 19.9061 7.8 19.8V19.4C7.8 19.2939 7.75786 19.1922 7.68284 19.1172C7.60783 19.0421 7.50609 19 7.4 19Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.8001 16.8C10.8001 16.6939 10.758 16.5922 10.6829 16.5172C10.6079 16.4422 10.5062 16.4 10.4001 16.4H10.0001C9.89401 16.4 9.79227 16.4422 9.71725 16.5172C9.64224 16.5922 9.6001 16.6939 9.6001 16.8C9.6001 16.9061 9.64224 17.0079 9.71725 17.0829C9.79227 17.1579 9.89401 17.2 10.0001 17.2H10.4001C10.5062 17.2 10.6079 17.1579 10.6829 17.0829C10.758 17.0079 10.8001 16.9061 10.8001 16.8Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M5.2 16.8C5.2 16.6939 5.15786 16.5922 5.08284 16.5172C5.00783 16.4422 4.90609 16.4 4.8 16.4H4.4C4.29391 16.4 4.19217 16.4422 4.11716 16.5172C4.04214 16.5922 4 16.6939 4 16.8C4 16.9061 4.04214 17.0079 4.11716 17.0829C4.19217 17.1579 4.29391 17.2 4.4 17.2H4.8C4.90609 17.2 5.00783 17.1579 5.08284 17.0829C5.15786 17.0079 5.2 16.9061 5.2 16.8Z",
      "fill": "black"
    }
  })]);
};
var Phone24hvue_type_template_id_62585f32_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Phone24h.vue?vue&type=script&lang=ts&

/* harmony default export */ var Phone24hvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Phone24h.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_Phone24hvue_type_script_lang_ts_ = (Phone24hvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Phone24h.vue





/* normalize component */
;
var Phone24h_component = normalizeComponent(
  icons_notifications_Phone24hvue_type_script_lang_ts_,
  Phone24hvue_type_template_id_62585f32_render,
  Phone24hvue_type_template_id_62585f32_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Phone24h = (Phone24h_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/PlanningPerson.vue?vue&type=template&id=6babd1b8&
var PlanningPersonvue_type_template_id_6babd1b8_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M10 4.43201V11.632H20.4V4.43201H10ZM13.8 9.63201H12.6V8.43201H13.8V9.63201ZM15.8 9.63201H14.6V6.43201H15.8V9.63201ZM17.8 9.63201H16.6V7.63201H17.8V9.63201Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.4001 11.2321C6.7561 11.2321 7.10412 11.1265 7.40012 10.9287C7.69613 10.7309 7.92684 10.4498 8.06308 10.1209C8.19932 9.792 8.23496 9.43008 8.16551 9.08092C8.09606 8.73175 7.92462 8.41102 7.67289 8.15929C7.42115 7.90755 7.10043 7.73612 6.75126 7.66667C6.40209 7.59721 6.04017 7.63286 5.71127 7.7691C5.38236 7.90534 5.10124 8.13605 4.90345 8.43205C4.70567 8.72806 4.6001 9.07607 4.6001 9.43208C4.60115 9.90915 4.79114 10.3664 5.12847 10.7037C5.46581 11.041 5.92303 11.231 6.4001 11.2321ZM6.4001 8.43208C6.59788 8.43208 6.79122 8.49073 6.95567 8.60061C7.12012 8.71049 7.24829 8.86667 7.32398 9.0494C7.39966 9.23212 7.41947 9.43319 7.38088 9.62717C7.3423 9.82115 7.24706 9.99934 7.1072 10.1392C6.96735 10.279 6.78917 10.3743 6.59519 10.4129C6.40121 10.4515 6.20014 10.4316 6.01741 10.356C5.83469 10.2803 5.67851 10.1521 5.56863 9.98765C5.45875 9.8232 5.4001 9.62986 5.4001 9.43208C5.4001 9.16686 5.50545 8.91251 5.69299 8.72497C5.88053 8.53744 6.13488 8.43208 6.4001 8.43208Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.5121 11.568H7.2521L7.0441 11.716L6.4001 12.18L5.7561 11.716L5.5481 11.568H5.2881C5.07218 11.5621 4.85723 11.5989 4.65553 11.6761C4.45382 11.7534 4.26932 11.8696 4.11256 12.0182C3.9558 12.1668 3.82985 12.3448 3.74192 12.5421C3.65399 12.7394 3.6058 12.9521 3.6001 13.168V17.168H4.4001V20.368C4.4001 20.5802 4.48438 20.7836 4.63441 20.9337C4.78444 21.0837 4.98792 21.168 5.2001 21.168H7.6001C7.81227 21.168 8.01575 21.0837 8.16578 20.9337C8.31581 20.7836 8.4001 20.5802 8.4001 20.368V17.168H9.2001V13.168C9.1944 12.9521 9.1462 12.7394 9.05827 12.5421C8.97034 12.3448 8.8444 12.1668 8.68764 12.0182C8.53087 11.8696 8.34637 11.7534 8.14466 11.6761C7.94296 11.5989 7.72801 11.5621 7.5121 11.568ZM7.6001 20.368H6.8001V17.968C6.8001 17.8619 6.75795 17.7602 6.68294 17.6851C6.60793 17.6101 6.50618 17.568 6.4001 17.568C6.29401 17.568 6.19227 17.6101 6.11725 17.6851C6.04224 17.7602 6.0001 17.8619 6.0001 17.968V20.368H5.2001V17.168H7.6001V20.368ZM8.4001 16.368H4.4001V13.168C4.40573 13.0571 4.43318 12.9484 4.48088 12.8482C4.52859 12.7479 4.5956 12.658 4.67809 12.5837C4.76058 12.5094 4.85693 12.4521 4.9616 12.4151C5.06628 12.3781 5.17723 12.3621 5.2881 12.368L6.4001 13.168L7.5121 12.368C7.62297 12.3621 7.73392 12.3781 7.83859 12.4151C7.94327 12.4521 8.03961 12.5094 8.1221 12.5837C8.20459 12.658 8.27161 12.7479 8.31931 12.8482C8.36701 12.9484 8.39447 13.0571 8.4001 13.168V16.368Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.4002 3.63208H10.0002C9.78802 3.63208 9.58454 3.71637 9.43451 3.86639C9.28448 4.01642 9.2002 4.21991 9.2002 4.43208V11.6321C9.2002 11.8443 9.28448 12.0477 9.43451 12.1978C9.58454 12.3478 9.78802 12.4321 10.0002 12.4321H13.6002V16.4321H12.0322C11.9261 16.4321 11.8244 16.4742 11.7494 16.5492C11.6743 16.6243 11.6322 16.726 11.6322 16.8321C11.6322 16.9382 11.6743 17.0399 11.7494 17.1149C11.8244 17.1899 11.9261 17.2321 12.0322 17.2321H14.2402C14.2934 17.2382 14.347 17.2382 14.4002 17.2321H16.0002C16.0534 17.2382 16.107 17.2382 16.1602 17.2321H18.4322C18.5383 17.2321 18.64 17.1899 18.715 17.1149C18.7901 17.0399 18.8322 16.9382 18.8322 16.8321C18.8322 16.726 18.7901 16.6243 18.715 16.5492C18.64 16.4742 18.5383 16.4321 18.4322 16.4321H16.8002V12.4321H20.4002C20.6124 12.4321 20.8159 12.3478 20.9659 12.1978C21.1159 12.0477 21.2002 11.8443 21.2002 11.6321V4.43208C21.2002 4.21991 21.1159 4.01642 20.9659 3.86639C20.8159 3.71637 20.6124 3.63208 20.4002 3.63208ZM16.0002 16.4321H14.4002V12.4321H16.0002V16.4321ZM20.4002 11.6321H10.0002V4.43208H20.4002V11.6321Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.8042 10.036C11.8042 10.1421 11.8463 10.2438 11.9214 10.3188C11.9964 10.3938 12.0981 10.436 12.2042 10.436H18.2042C18.3103 10.436 18.412 10.3938 18.487 10.3188C18.5621 10.2438 18.6042 10.1421 18.6042 10.036V9.63599V7.63599C18.6042 7.42381 18.5199 7.22033 18.3699 7.0703C18.2199 6.92027 18.0164 6.83599 17.8042 6.83599H16.6042V6.43599C16.6042 6.22381 16.5199 6.02033 16.3699 5.8703C16.2199 5.72027 16.0164 5.63599 15.8042 5.63599H14.6042C14.392 5.63599 14.1885 5.72027 14.0385 5.8703C13.8885 6.02033 13.8042 6.22381 13.8042 6.43599V7.63599H12.6042C12.392 7.63599 12.1885 7.72027 12.0385 7.8703C11.8885 8.02033 11.8042 8.22381 11.8042 8.43599V9.63599C11.8042 9.63599 11.8042 9.63599 11.8042 9.65999V10.036ZM16.6042 7.63599H17.8042V9.63599H16.6042V7.63599ZM14.6042 8.43599V6.43599H15.8042V9.63599H14.6042V8.43599ZM12.6042 8.43599H13.8042V9.63599H12.6042V8.43599Z",
      "fill": "black"
    }
  })]);
};
var PlanningPersonvue_type_template_id_6babd1b8_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/PlanningPerson.vue?vue&type=script&lang=ts&

/* harmony default export */ var PlanningPersonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/PlanningPerson.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_PlanningPersonvue_type_script_lang_ts_ = (PlanningPersonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/PlanningPerson.vue





/* normalize component */
;
var PlanningPerson_component = normalizeComponent(
  icons_notifications_PlanningPersonvue_type_script_lang_ts_,
  PlanningPersonvue_type_template_id_6babd1b8_render,
  PlanningPersonvue_type_template_id_6babd1b8_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var PlanningPerson = (PlanningPerson_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/ReadBook.vue?vue&type=template&id=e44b91b2&
var ReadBookvue_type_template_id_e44b91b2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M19.8881 6.244H18.5881V4.94C18.5887 4.88241 18.5778 4.82528 18.5561 4.77192C18.5344 4.71856 18.5024 4.67002 18.4619 4.62911C18.4213 4.5882 18.3731 4.55573 18.3199 4.53357C18.2668 4.51141 18.2097 4.5 18.1521 4.5H15.4361C14.1609 4.50325 12.9339 4.9875 12.0001 5.856C11.0664 4.9875 9.83936 4.50325 8.56415 4.5H5.84815C5.73251 4.5 5.62162 4.54594 5.53985 4.6277C5.45808 4.70947 5.41215 4.82037 5.41215 4.936V6.244H4.11215C3.93848 6.24399 3.77181 6.31242 3.64826 6.43447C3.52472 6.55652 3.45425 6.72235 3.45215 6.896V17.244C3.45215 17.419 3.52168 17.5869 3.64546 17.7107C3.76923 17.8345 3.93711 17.904 4.11215 17.904H8.44015C8.806 17.9052 9.16749 17.9835 9.50106 18.1337C9.83464 18.284 10.1328 18.5028 10.3761 18.776L10.4401 18.84C10.5183 18.9222 10.6026 18.9984 10.6921 19.068L10.8001 19.14C10.88 19.1927 10.9628 19.2408 11.0481 19.284H11.0921C11.1377 19.3064 11.1845 19.3264 11.2321 19.344L11.4121 19.4L11.5761 19.44C11.671 19.4599 11.7673 19.4719 11.8641 19.476H12.0001C12.1439 19.4754 12.2873 19.4607 12.4281 19.432C12.4721 19.4272 12.5151 19.4164 12.5561 19.4C12.628 19.3829 12.6988 19.3615 12.7681 19.336H12.8001L12.9081 19.288H12.9401C13.0342 19.2437 13.1251 19.1929 13.2121 19.136L13.3001 19.072C13.3971 18.995 13.4868 18.9093 13.5681 18.816L13.6001 18.8L13.6361 18.76C13.8765 18.4885 14.1723 18.2717 14.5034 18.124C14.8346 17.9764 15.1936 17.9014 15.5561 17.904H19.8881C20.0632 17.904 20.2311 17.8345 20.3548 17.7107C20.4786 17.5869 20.5481 17.419 20.5481 17.244V6.896C20.546 6.72235 20.4756 6.55652 20.352 6.43447C20.2285 6.31242 20.0618 6.24399 19.8881 6.244ZM12.4361 6.644C12.8243 6.23973 13.2901 5.91799 13.8056 5.69804C14.3211 5.4781 14.8757 5.36448 15.4361 5.364H17.7161V15.064H15.4361C14.3563 15.0648 13.3051 15.411 12.4361 16.052V6.644ZM6.28415 5.364H8.56415C9.12435 5.36373 9.67884 5.47662 10.1943 5.69588C10.7099 5.91515 11.1758 6.23627 11.5641 6.64V16.052C10.6952 15.411 9.64395 15.0648 8.56415 15.064H6.28415V5.364ZM19.6761 17.04H15.5601C15.0719 17.0373 14.5888 17.1391 14.1431 17.3385C13.6974 17.5378 13.2995 17.8302 12.9761 18.196C12.9225 18.2482 12.865 18.2964 12.8041 18.34L12.7521 18.38C12.701 18.4132 12.6476 18.4426 12.5921 18.468H12.5641L12.4961 18.5L12.3641 18.54H12.2881C12.2066 18.5574 12.1235 18.5668 12.0401 18.568H11.9641C11.905 18.5639 11.8462 18.5559 11.7881 18.544C11.754 18.5398 11.7205 18.5317 11.6881 18.52L11.5801 18.488L11.5041 18.452H11.4681C11.4154 18.4279 11.3646 18.3999 11.3161 18.368H11.2001C11.1435 18.3268 11.0912 18.2799 11.0441 18.228L11.0081 18.192C10.683 17.8281 10.2849 17.5367 9.83966 17.3369C9.39445 17.137 8.91215 17.0331 8.42415 17.032H4.32415V7.116H5.41215V15.516C5.41215 15.6316 5.45808 15.7425 5.53985 15.8243C5.62162 15.9061 5.73251 15.952 5.84815 15.952H8.56415C9.151 15.9521 9.73121 16.0762 10.2668 16.3161C10.8024 16.556 11.2813 16.9062 11.6721 17.344C11.7102 17.3868 11.7563 17.4218 11.8079 17.4468C11.8595 17.4718 11.9155 17.4864 11.9727 17.4897C12.0299 17.4931 12.0872 17.4851 12.1413 17.4663C12.1955 17.4474 12.2454 17.4181 12.2881 17.38L12.3241 17.344C12.7159 16.9063 13.1956 16.5562 13.7318 16.3163C14.268 16.0765 14.8487 15.9523 15.4361 15.952H18.1521C18.2094 15.952 18.2661 15.9407 18.319 15.9188C18.3719 15.8969 18.42 15.8648 18.4604 15.8243C18.5009 15.7838 18.533 15.7357 18.555 15.6828C18.5769 15.63 18.5881 15.5733 18.5881 15.516V7.116H19.6761V17.04Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.51998 7.60005H8.24399C8.8784 7.59245 9.50623 7.72923 10.08 8.00005C10.1862 8.04591 10.3061 8.04812 10.4139 8.0062C10.5217 7.96428 10.6087 7.88159 10.656 7.77605C10.7004 7.67673 10.7058 7.56429 10.6709 7.46122C10.636 7.35814 10.5636 7.27201 10.468 7.22004C9.77412 6.87623 9.01036 6.69692 8.23598 6.69604H7.51998C7.40435 6.69604 7.29345 6.74198 7.21169 6.82375C7.12992 6.90551 7.08398 7.01641 7.08398 7.13205C7.08398 7.24768 7.12992 7.35858 7.21169 7.44034C7.29345 7.52211 7.40435 7.56805 7.51998 7.56805V7.60005Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M7.51998 9.892H8.24398C8.88112 9.89238 9.50952 10.0402 10.08 10.324C10.1861 10.377 10.3089 10.3858 10.4214 10.3483C10.5339 10.3108 10.6269 10.2301 10.68 10.124C10.733 10.0179 10.7418 9.8951 10.7042 9.78258C10.6667 9.67006 10.5861 9.57704 10.48 9.524C9.78544 9.18207 9.02213 9.00286 8.24799 9H7.51998C7.40435 9 7.29345 9.04594 7.21169 9.1277C7.12992 9.20947 7.08398 9.32037 7.08398 9.436C7.08398 9.55163 7.12992 9.66253 7.21169 9.7443C7.29345 9.82606 7.40435 9.872 7.51998 9.872V9.892Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.656 12.3999C10.6995 12.3005 10.7043 12.1884 10.6695 12.0856C10.6348 11.9828 10.5629 11.8966 10.468 11.8439C9.77412 11.5001 9.01036 11.3208 8.23598 11.3199H7.51998C7.40435 11.3199 7.29345 11.3659 7.21169 11.4476C7.12992 11.5294 7.08398 11.6403 7.08398 11.7559C7.08398 11.8716 7.12992 11.9825 7.21169 12.0642C7.29345 12.146 7.40435 12.1919 7.51998 12.1919H8.24398C8.88066 12.1963 9.50818 12.3439 10.08 12.6239C10.1324 12.6478 10.1891 12.6608 10.2466 12.6624C10.3042 12.664 10.3615 12.6541 10.4151 12.6332C10.4688 12.6123 10.5178 12.581 10.5591 12.5409C10.6005 12.5008 10.6334 12.4529 10.656 12.3999Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.688 8.0599C13.7545 8.05953 13.82 8.04451 13.88 8.0159C14.4573 7.73705 15.091 7.59472 15.732 7.5999H16.456C16.5717 7.5999 16.6826 7.55397 16.7643 7.4722C16.8461 7.39044 16.892 7.27954 16.892 7.16391C16.892 7.04827 16.8461 6.93737 16.7643 6.85561C16.6826 6.77384 16.5717 6.72791 16.456 6.72791H15.732C15.1371 6.72775 14.5469 6.832 13.988 7.03591C13.82 7.09991 13.656 7.1719 13.492 7.2519C13.4052 7.29642 13.3358 7.36879 13.2949 7.45743C13.2541 7.54607 13.2441 7.64586 13.2667 7.74081C13.2893 7.83576 13.3431 7.92039 13.4195 7.98114C13.4959 8.0419 13.5904 8.07526 13.688 8.0759V8.0599Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.6878 10.3719C13.7542 10.3716 13.8198 10.3565 13.8798 10.3279C14.4545 10.0441 15.0868 9.89633 15.7278 9.89593H16.4518C16.5674 9.89593 16.6783 9.84999 16.7601 9.76822C16.8418 9.68646 16.8878 9.57556 16.8878 9.45993C16.8878 9.34429 16.8418 9.23339 16.7601 9.15163C16.6783 9.06986 16.5674 9.02393 16.4518 9.02393H15.7318C15.1369 9.02377 14.5466 9.12802 13.9878 9.33193C13.8198 9.39593 13.6558 9.46393 13.4918 9.54393C13.4027 9.58728 13.331 9.65967 13.2886 9.74918C13.2462 9.8387 13.2355 9.93999 13.2583 10.0364C13.2811 10.1328 13.3361 10.2185 13.4142 10.2795C13.4922 10.3405 13.5887 10.3731 13.6878 10.3719Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.4558 12.204C16.5714 12.204 16.6823 12.1581 16.7641 12.0763C16.8458 11.9946 16.8918 11.8837 16.8918 11.768C16.8918 11.6524 16.8458 11.5415 16.7641 11.4597C16.6823 11.378 16.5714 11.332 16.4558 11.332H15.7318C15.1365 11.3313 14.5459 11.437 13.9878 11.644C13.8186 11.7055 13.6531 11.7762 13.4918 11.856C13.4027 11.8994 13.331 11.9718 13.2886 12.0613C13.2462 12.1508 13.2355 12.2521 13.2583 12.3485C13.2811 12.4449 13.3361 12.5306 13.4142 12.5916C13.4922 12.6526 13.5887 12.6852 13.6878 12.684C13.7545 12.6823 13.8201 12.6659 13.8798 12.636C14.4545 12.3522 15.0868 12.2044 15.7278 12.204H16.4558Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.6757 17.032V7.11597H18.6197V15.564H18.5757C18.5669 15.6712 18.5187 15.7714 18.4404 15.8452C18.3621 15.9191 18.2593 15.9614 18.1517 15.964H15.4357C14.8483 15.9643 14.2676 16.0884 13.7314 16.3283C13.1952 16.5681 12.7155 16.9183 12.3237 17.356L12.2877 17.392C12.2449 17.4301 12.1951 17.4594 12.1409 17.4782C12.0868 17.4971 12.0295 17.505 11.9723 17.5017C11.9151 17.4983 11.8591 17.4837 11.8075 17.4587C11.7559 17.4337 11.7098 17.3988 11.6717 17.356C11.2809 16.9182 10.802 16.5679 10.2664 16.3281C9.73079 16.0882 9.15058 15.9641 8.56373 15.964H5.84773C5.7321 15.964 5.6212 15.918 5.53943 15.8363C5.45767 15.7545 5.41173 15.6436 5.41173 15.528V7.12797H4.32373V17.032H8.43973C8.92812 17.0331 9.41076 17.1374 9.85606 17.338C10.3014 17.5386 10.6993 17.8309 11.0237 18.196L11.0597 18.228C11.1068 18.2798 11.1591 18.3267 11.2157 18.368L11.2757 18.412C11.3242 18.4438 11.375 18.4719 11.4277 18.496H11.4637L11.5397 18.532L11.6477 18.564C11.6801 18.5757 11.7136 18.5838 11.7477 18.588C11.8058 18.5999 11.8646 18.6079 11.9237 18.612H11.9997C12.0831 18.6108 12.1662 18.6014 12.2477 18.584H12.3237L12.4557 18.544L12.5237 18.512H12.5517C12.6071 18.4866 12.6606 18.4572 12.7117 18.424L12.7637 18.384C12.8246 18.3403 12.8821 18.2922 12.9357 18.24C13.2594 17.861 13.6619 17.5573 14.1152 17.3501C14.5684 17.1428 15.0614 17.037 15.5597 17.04H17.5597H18.6277L19.6757 17.032Z",
      "fill": "#00E88F"
    }
  })]);
};
var ReadBookvue_type_template_id_e44b91b2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/ReadBook.vue?vue&type=script&lang=ts&

/* harmony default export */ var ReadBookvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/ReadBook.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_ReadBookvue_type_script_lang_ts_ = (ReadBookvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/ReadBook.vue





/* normalize component */
;
var ReadBook_component = normalizeComponent(
  icons_notifications_ReadBookvue_type_script_lang_ts_,
  ReadBookvue_type_template_id_e44b91b2_render,
  ReadBookvue_type_template_id_e44b91b2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ReadBook = (ReadBook_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendChat.vue?vue&type=template&id=732e620a&
var SendChatvue_type_template_id_732e620a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M20.176 5.24403H9.02399C8.99396 5.24162 8.96376 5.24575 8.93549 5.25616C8.90722 5.26656 8.88154 5.28298 8.86024 5.30428C8.83894 5.32558 8.82252 5.35126 8.81211 5.37953C8.80171 5.40781 8.79757 5.438 8.79999 5.46803V6.44403H14.976C15.1109 6.44242 15.2448 6.46781 15.3698 6.5187C15.4947 6.56959 15.6082 6.64496 15.7037 6.74037C15.7991 6.83578 15.8744 6.9493 15.9253 7.07427C15.9762 7.19923 16.0016 7.33311 16 7.46803V14.436L17.724 15.728V14.4C17.7229 14.3108 17.7397 14.2222 17.7732 14.1395C17.8067 14.0568 17.8564 13.9816 17.9194 13.9182C17.9823 13.8549 18.0572 13.8048 18.1397 13.7708C18.2223 13.7367 18.3107 13.7195 18.4 13.72H20.184C20.2137 13.7224 20.2435 13.7183 20.2715 13.7082C20.2994 13.698 20.3249 13.6819 20.3461 13.6611C20.3674 13.6402 20.3839 13.6151 20.3945 13.5873C20.4052 13.5595 20.4098 13.5297 20.408 13.5V5.46803C20.4106 5.43726 20.4063 5.4063 20.3954 5.3774C20.3846 5.34849 20.3674 5.32237 20.3452 5.30092C20.323 5.27947 20.2963 5.26324 20.267 5.2534C20.2377 5.24356 20.2066 5.24036 20.176 5.24403Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.1759 4.44404H9.02388C8.88896 4.44243 8.75508 4.46782 8.63011 4.51871C8.50515 4.5696 8.39162 4.64497 8.29621 4.74038C8.2008 4.83579 8.12544 4.94931 8.07455 5.07428C8.02366 5.19924 7.99827 5.33312 7.99988 5.46804V6.44404H3.82388C3.68896 6.44243 3.55508 6.46782 3.43011 6.51871C3.30515 6.5696 3.19162 6.64497 3.09621 6.74038C3.0008 6.83579 2.92544 6.94931 2.87455 7.07428C2.82365 7.19924 2.79827 7.33312 2.79988 7.46804V15.5C2.7988 15.6346 2.82459 15.7681 2.87572 15.8926C2.92685 16.0171 3.0023 16.1301 3.09765 16.2251C3.19301 16.3201 3.30635 16.3951 3.43105 16.4457C3.55575 16.4964 3.6893 16.5216 3.82388 16.52H5.47588V17.72C5.47588 17.9322 5.56016 18.1357 5.71019 18.2857C5.86022 18.4358 6.0637 18.52 6.27588 18.52C6.44897 18.52 6.6174 18.4639 6.75588 18.36L9.19988 16.52H14.9599C15.0958 16.5238 15.2311 16.5001 15.3576 16.4505C15.4842 16.4008 15.5995 16.3261 15.6965 16.2309C15.7936 16.1357 15.8705 16.0219 15.9226 15.8964C15.9747 15.7708 16.001 15.636 15.9999 15.5V15.436L17.2439 16.368C17.3824 16.4719 17.5508 16.528 17.7239 16.528C17.9361 16.528 18.1395 16.4438 18.2896 16.2937C18.4396 16.1437 18.5239 15.9402 18.5239 15.728V14.528H20.1759C20.3111 14.5297 20.4454 14.5041 20.5706 14.453C20.6958 14.4019 20.8095 14.3261 20.905 14.2303C21.0005 14.1345 21.0757 14.0205 21.1264 13.895C21.177 13.7696 21.202 13.6353 21.1999 13.5V5.46804C21.2015 5.33312 21.1761 5.19924 21.1252 5.07428C21.0743 4.94931 20.999 4.83579 20.9035 4.74038C20.8081 4.64497 20.6946 4.5696 20.5696 4.51871C20.4447 4.46782 20.3108 4.44243 20.1759 4.44404ZM15.1999 13.84V15.5C15.2017 15.5297 15.1971 15.5595 15.1864 15.5873C15.1758 15.6151 15.1592 15.6402 15.138 15.6611C15.1168 15.6819 15.0913 15.698 15.0633 15.7082C15.0354 15.7183 15.0055 15.7224 14.9759 15.72H9.17188C9.02798 15.7209 8.88801 15.7671 8.77188 15.852L6.27588 17.728V16.4C6.27694 16.3108 6.26021 16.2222 6.22667 16.1395C6.19312 16.0568 6.14343 15.9816 6.0805 15.9183C6.01757 15.855 5.94265 15.8048 5.86013 15.7708C5.77761 15.7368 5.68914 15.7195 5.59988 15.72H3.82388C3.79421 15.7224 3.76438 15.7183 3.73641 15.7082C3.70844 15.698 3.68298 15.6819 3.66174 15.6611C3.64051 15.6402 3.624 15.6151 3.61333 15.5873C3.60265 15.5595 3.59807 15.5297 3.59988 15.5V7.46804C3.59746 7.43801 3.6016 7.40782 3.612 7.37954C3.62241 7.35127 3.63883 7.3256 3.66013 7.30429C3.68143 7.28299 3.70711 7.26657 3.73538 7.25617C3.76365 7.24576 3.79385 7.24163 3.82388 7.24404H14.9759C15.0059 7.24163 15.0361 7.24576 15.0644 7.25617C15.0926 7.26657 15.1183 7.28299 15.1396 7.30429C15.1609 7.3256 15.1773 7.35127 15.1878 7.37954C15.1982 7.40782 15.2023 7.43801 15.1999 7.46804V13.84ZM20.3999 13.5C20.4017 13.5297 20.3971 13.5595 20.3864 13.5873C20.3758 13.6151 20.3592 13.6402 20.338 13.6611C20.3168 13.6819 20.2913 13.698 20.2633 13.7082C20.2354 13.7183 20.2055 13.7224 20.1759 13.72H18.3999C18.3106 13.7195 18.2221 13.7368 18.1396 13.7708C18.0571 13.8048 17.9822 13.855 17.9193 13.9183C17.8563 13.9816 17.8066 14.0568 17.7731 14.1395C17.7395 14.2222 17.7228 14.3108 17.7239 14.4V15.736L15.9999 14.436V7.46804C16.0015 7.33312 15.9761 7.19924 15.9252 7.07428C15.8743 6.94931 15.799 6.83579 15.7035 6.74038C15.6081 6.64497 15.4946 6.5696 15.3696 6.51871C15.2447 6.46782 15.1108 6.44243 14.9759 6.44404H8.79988V5.46804C8.79746 5.43801 8.8016 5.40782 8.812 5.37955C8.82241 5.35127 8.83883 5.3256 8.86013 5.30429C8.88143 5.28299 8.90711 5.26657 8.93538 5.25617C8.96365 5.24577 8.99385 5.24163 9.02388 5.24404H20.1759C20.2059 5.24163 20.2361 5.24577 20.2644 5.25617C20.2926 5.26657 20.3183 5.28299 20.3396 5.30429C20.3609 5.3256 20.3773 5.35127 20.3878 5.37955C20.3982 5.40782 20.4023 5.43801 20.3999 5.46804V13.5Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.9997 17.308H9.47174L7.33974 18.832C7.25414 18.8938 7.19643 18.9869 7.1792 19.091C7.16196 19.1952 7.1866 19.3019 7.24774 19.388C7.28494 19.4402 7.33415 19.4828 7.39124 19.512C7.44832 19.5412 7.5116 19.5563 7.57574 19.556C7.6591 19.5554 7.74021 19.5289 7.80774 19.48L9.72774 18.108H11.9997C12.1058 18.108 12.2076 18.0658 12.2826 17.9908C12.3576 17.9158 12.3997 17.8141 12.3997 17.708C12.3997 17.6019 12.3576 17.5002 12.2826 17.4251C12.2076 17.3501 12.1058 17.308 11.9997 17.308Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.0237 10.0441H6.22373C6.11764 10.0441 6.0159 10.0862 5.94089 10.1612C5.86587 10.2362 5.82373 10.338 5.82373 10.4441C5.82373 10.5502 5.86587 10.6519 5.94089 10.7269C6.0159 10.8019 6.11764 10.8441 6.22373 10.8441H11.0237C11.1298 10.8441 11.2316 10.8019 11.3066 10.7269C11.3816 10.6519 11.4237 10.5502 11.4237 10.4441C11.4237 10.338 11.3816 10.2362 11.3066 10.1612C11.2316 10.0862 11.1298 10.0441 11.0237 10.0441Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.62373 12.1279H6.22373C6.11764 12.1279 6.0159 12.1701 5.94089 12.2451C5.86587 12.3201 5.82373 12.4218 5.82373 12.5279C5.82373 12.634 5.86587 12.7358 5.94089 12.8108C6.0159 12.8858 6.11764 12.9279 6.22373 12.9279H8.62373C8.72982 12.9279 8.83156 12.8858 8.90657 12.8108C8.98159 12.7358 9.02373 12.634 9.02373 12.5279C9.02373 12.4218 8.98159 12.3201 8.90657 12.2451C8.83156 12.1701 8.72982 12.1279 8.62373 12.1279Z",
      "fill": "black"
    }
  })]);
};
var SendChatvue_type_template_id_732e620a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendChat.vue?vue&type=script&lang=ts&

/* harmony default export */ var SendChatvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendChat.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_SendChatvue_type_script_lang_ts_ = (SendChatvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendChat.vue





/* normalize component */
;
var SendChat_component = normalizeComponent(
  icons_notifications_SendChatvue_type_script_lang_ts_,
  SendChatvue_type_template_id_732e620a_render,
  SendChatvue_type_template_id_732e620a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendChat = (SendChat_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendFile.vue?vue&type=template&id=6740f4a1&
var SendFilevue_type_template_id_6740f4a1_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.2402 13.4761H16.0682C16.025 13.4776 15.9838 13.4947 15.9522 13.5241L14.0482 15.4321C14.0161 15.4603 13.9749 15.476 13.9322 15.4761H10.0682C10.0254 15.476 9.98419 15.4603 9.95215 15.4321L8.04815 13.5241C8.0165 13.4947 7.97532 13.4776 7.93215 13.4761H5.76015C5.71772 13.4761 5.67702 13.4929 5.64701 13.5229C5.61701 13.5529 5.60015 13.5936 5.60015 13.6361V18.1161C5.5996 18.1372 5.60336 18.1583 5.61121 18.1779C5.61906 18.1976 5.63082 18.2155 5.64579 18.2304C5.66076 18.2454 5.67862 18.2572 5.69828 18.265C5.71794 18.2729 5.73899 18.2766 5.76015 18.2761H18.2402C18.2613 18.2766 18.2824 18.2729 18.302 18.265C18.3217 18.2572 18.3395 18.2454 18.3545 18.2304C18.3695 18.2155 18.3812 18.1976 18.3891 18.1779C18.3969 18.1583 18.4007 18.1372 18.4002 18.1161V13.6361C18.4002 13.6151 18.396 13.5943 18.388 13.5748C18.3799 13.5554 18.3681 13.5378 18.3533 13.5229C18.3384 13.5081 18.3208 13.4963 18.3014 13.4883C18.282 13.4802 18.2612 13.4761 18.2402 13.4761Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.2999 8.12402C14.406 8.12402 14.5077 8.08188 14.5827 8.00687C14.6578 7.93185 14.6999 7.83011 14.6999 7.72402V4.52402C14.6999 4.41794 14.6578 4.3162 14.5827 4.24118C14.5077 4.16617 14.406 4.12402 14.2999 4.12402C14.1938 4.12402 14.0921 4.16617 14.0171 4.24118C13.942 4.3162 13.8999 4.41794 13.8999 4.52402V7.72402C13.8999 7.83011 13.942 7.93185 14.0171 8.00687C14.0921 8.08188 14.1938 8.12402 14.2999 8.12402Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.6998 8.1241C9.80589 8.1241 9.90763 8.08196 9.98265 8.00694C10.0577 7.93193 10.0998 7.83018 10.0998 7.7241V5.7241C10.0998 5.61801 10.0577 5.51627 9.98265 5.44125C9.90763 5.36624 9.80589 5.3241 9.6998 5.3241C9.59372 5.3241 9.49198 5.36624 9.41696 5.44125C9.34195 5.51627 9.2998 5.61801 9.2998 5.7241V7.7241C9.2998 7.83018 9.34195 7.93193 9.41696 8.00694C9.49198 8.08196 9.59372 8.1241 9.6998 8.1241Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.0001 4.92397C12.1062 4.92397 12.2079 4.88183 12.2829 4.80682C12.358 4.7318 12.4001 4.63006 12.4001 4.52397V3.72397C12.4001 3.61789 12.358 3.51615 12.2829 3.44113C12.2079 3.36612 12.1062 3.32397 12.0001 3.32397C11.894 3.32397 11.7923 3.36612 11.7173 3.44113C11.6422 3.51615 11.6001 3.61789 11.6001 3.72397V4.52397C11.6001 4.63006 11.6422 4.7318 11.7173 4.80682C11.7923 4.88183 11.894 4.92397 12.0001 4.92397Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.81602 9.92002C9.74152 9.99497 9.69971 10.0963 9.69971 10.202C9.69971 10.3077 9.74152 10.4091 9.81602 10.484L11.716 12.4C11.7532 12.4375 11.7974 12.4673 11.8462 12.4876C11.8949 12.5079 11.9472 12.5183 12 12.5183C12.0528 12.5183 12.1051 12.5079 12.1539 12.4876C12.2026 12.4673 12.2468 12.4375 12.284 12.4L14.184 10.5C14.2585 10.4251 14.3003 10.3237 14.3003 10.218C14.3003 10.1123 14.2585 10.011 14.184 9.93602C14.1468 9.89853 14.1026 9.86877 14.0539 9.84846C14.0051 9.82816 13.9528 9.8177 13.9 9.8177C13.8472 9.8177 13.7949 9.82816 13.7462 9.84846C13.6974 9.86877 13.6532 9.89853 13.616 9.93602L12.416 11.136V6.52402C12.416 6.41794 12.3739 6.31619 12.2989 6.24118C12.2239 6.16617 12.1221 6.12402 12.016 6.12402C11.9099 6.12402 11.8082 6.16617 11.7332 6.24118C11.6582 6.31619 11.616 6.41794 11.616 6.52402V11.136L10.416 9.93602C10.3796 9.89244 10.3344 9.8571 10.2833 9.83236C10.2322 9.80762 10.1764 9.79404 10.1196 9.79252C10.0629 9.79101 10.0065 9.8016 9.9541 9.82358C9.90175 9.84556 9.85468 9.87844 9.81602 9.92002Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.2 13.476C19.2272 13.3942 19.2272 13.3058 19.2 13.224L17.812 9.968C17.7814 9.8957 17.7302 9.83401 17.6647 9.79062C17.5993 9.74723 17.5225 9.72406 17.444 9.724H16.236C16.1299 9.724 16.0282 9.76614 15.9532 9.84116C15.8782 9.91617 15.836 10.0179 15.836 10.124C15.836 10.2301 15.8782 10.3318 15.9532 10.4068C16.0282 10.4819 16.1299 10.524 16.236 10.524H17.152L18.068 12.676H16.068C15.9414 12.6751 15.8159 12.6998 15.699 12.7486C15.5822 12.7974 15.4764 12.8693 15.388 12.96L13.668 14.676H10.332L8.61203 12.96C8.52366 12.8693 8.41787 12.7974 8.30102 12.7486C8.18417 12.6998 8.05866 12.6751 7.93203 12.676H5.93203L6.84803 10.524H7.76403C7.87011 10.524 7.97186 10.4819 8.04687 10.4068C8.12189 10.3318 8.16403 10.2301 8.16403 10.124C8.16403 10.0179 8.12189 9.91617 8.04687 9.84116C7.97186 9.76614 7.87011 9.724 7.76403 9.724H6.56403C6.48551 9.72406 6.40875 9.74723 6.34331 9.79062C6.27787 9.83401 6.22665 9.8957 6.19603 9.968L4.81203 13.224C4.78662 13.3033 4.78662 13.3886 4.81203 13.468C4.8081 13.5239 4.8081 13.5801 4.81203 13.636V18.116C4.81203 18.3706 4.91317 18.6148 5.09321 18.7948C5.27324 18.9749 5.51742 19.076 5.77203 19.076H18.24C18.4946 19.076 18.7388 18.9749 18.9189 18.7948C19.0989 18.6148 19.2 18.3706 19.2 18.116V13.636C19.2038 13.5827 19.2038 13.5293 19.2 13.476ZM18.4 18.116C18.4006 18.1372 18.3968 18.1582 18.389 18.1779C18.3811 18.1975 18.3694 18.2154 18.3544 18.2304C18.3394 18.2453 18.3216 18.2571 18.3019 18.2649C18.2822 18.2728 18.2612 18.2765 18.24 18.276H5.76003C5.73887 18.2765 5.71781 18.2728 5.69815 18.2649C5.67849 18.2571 5.66063 18.2453 5.64567 18.2304C5.6307 18.2154 5.61893 18.1975 5.61109 18.1779C5.60324 18.1582 5.59948 18.1372 5.60003 18.116V13.636C5.60003 13.5936 5.61688 13.5529 5.64689 13.5229C5.6769 13.4929 5.71759 13.476 5.76003 13.476H7.93203C7.9752 13.4776 8.01637 13.4946 8.04803 13.524L9.95203 15.432C9.98407 15.4603 10.0253 15.4759 10.068 15.476H13.932C13.9748 15.4759 14.016 15.4603 14.048 15.432L15.952 13.524C15.9837 13.4946 16.0249 13.4776 16.068 13.476H18.24C18.2825 13.476 18.3232 13.4929 18.3532 13.5229C18.3832 13.5529 18.4 13.5936 18.4 13.636V18.116Z",
      "fill": "black"
    }
  })]);
};
var SendFilevue_type_template_id_6740f4a1_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendFile.vue?vue&type=script&lang=ts&

/* harmony default export */ var SendFilevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendFile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_SendFilevue_type_script_lang_ts_ = (SendFilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendFile.vue





/* normalize component */
;
var SendFile_component = normalizeComponent(
  icons_notifications_SendFilevue_type_script_lang_ts_,
  SendFilevue_type_template_id_6740f4a1_render,
  SendFilevue_type_template_id_6740f4a1_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendFile = (SendFile_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendMail.vue?vue&type=template&id=1a96fbb2&
var SendMailvue_type_template_id_1a96fbb2_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M15.512 6.90806V6.33606H8.31201V10.4521L9.89201 11.8601C9.91408 11.8808 9.93417 11.9036 9.95201 11.9281L11.464 10.5681C11.5383 10.4968 11.6251 10.4398 11.72 10.4001C11.9002 10.3307 12.0998 10.3307 12.28 10.4001C12.3738 10.435 12.4605 10.4865 12.536 10.5521L14.048 11.9121C14.0659 11.8876 14.0859 11.8648 14.108 11.8441L15.512 10.5921V6.90806Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.5118 18.22C17.4057 18.22 17.304 18.2621 17.229 18.3371C17.154 18.4121 17.1118 18.5139 17.1118 18.62V19.82C17.1118 19.9261 17.154 20.0278 17.229 20.1028C17.304 20.1778 17.4057 20.22 17.5118 20.22C17.6179 20.22 17.7196 20.1778 17.7947 20.1028C17.8697 20.0278 17.9118 19.9261 17.9118 19.82V18.62C17.9118 18.5139 17.8697 18.4121 17.7947 18.3371C17.7196 18.2621 17.6179 18.22 17.5118 18.22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M6.31211 18.22C6.20602 18.22 6.10428 18.2621 6.02927 18.3371C5.95425 18.4121 5.91211 18.5139 5.91211 18.62V19.82C5.91211 19.9261 5.95425 20.0278 6.02927 20.1028C6.10428 20.1778 6.20602 20.22 6.31211 20.22C6.4182 20.22 6.51994 20.1778 6.59495 20.1028C6.66997 20.0278 6.71211 19.9261 6.71211 19.82V18.62C6.71211 18.5674 6.70176 18.5154 6.68166 18.4669C6.66156 18.4184 6.6321 18.3743 6.59495 18.3371C6.55781 18.3 6.51371 18.2705 6.46518 18.2504C6.41665 18.2303 6.36464 18.22 6.31211 18.22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.9117 18.22C11.8056 18.22 11.7039 18.2621 11.6289 18.3371C11.5539 18.4121 11.5117 18.5139 11.5117 18.62V20.62C11.5117 20.7261 11.5539 20.8278 11.6289 20.9028C11.7039 20.9778 11.8056 21.02 11.9117 21.02C12.0178 21.02 12.1195 20.9778 12.1946 20.9028C12.2696 20.8278 12.3117 20.7261 12.3117 20.62V18.62C12.3117 18.5139 12.2696 18.4121 12.1946 18.3371C12.1195 18.2621 12.0178 18.22 11.9117 18.22Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.1998 9.10396C19.1997 8.90946 19.1523 8.71791 19.0617 8.5458C18.9711 8.37369 18.8401 8.22617 18.6798 8.11596L16.3118 6.48796V6.33596C16.3118 6.12379 16.2275 5.9203 16.0775 5.77027C15.9275 5.62024 15.724 5.53596 15.5118 5.53596H14.9238L12.6798 3.99996C12.4797 3.86236 12.2426 3.7887 11.9998 3.7887C11.757 3.7887 11.5199 3.86236 11.3198 3.99996L9.07581 5.54396H8.31181C8.09963 5.54396 7.89615 5.62825 7.74612 5.77827C7.59609 5.9283 7.51181 6.13179 7.51181 6.34396V6.61596L5.3198 8.11596C5.15955 8.22617 5.02849 8.37369 4.9379 8.5458C4.84732 8.71791 4.79992 8.90946 4.7998 9.10396V16.148C4.7998 16.4662 4.92623 16.7714 5.15128 16.9965C5.37632 17.2215 5.68154 17.348 5.9998 17.348H17.9998C18.3181 17.348 18.6233 17.2215 18.8483 16.9965C19.0734 16.7714 19.1998 16.4662 19.1998 16.148V9.10396ZM16.3118 7.45996L17.8558 8.51996L16.3118 9.89596V7.45996ZM11.7718 4.65996C11.8388 4.61351 11.9183 4.58862 11.9998 4.58862C12.0813 4.58862 12.1608 4.61351 12.2278 4.65996L13.5118 5.54396H10.4878L11.7718 4.65996ZM8.31181 7.03996V6.33596H15.5118V10.608L14.1078 11.86C14.0857 11.8807 14.0656 11.9035 14.0478 11.928L12.5358 10.568C12.4615 10.4967 12.3748 10.4397 12.2798 10.4C12.0996 10.3306 11.9 10.3306 11.7198 10.4C11.6261 10.4349 11.5394 10.4864 11.4638 10.552L9.9518 11.912C9.93396 11.8875 9.91387 11.8647 9.8918 11.844L8.31181 10.436V7.03996ZM7.51181 7.58796V9.74396L6.1438 8.54396L7.51181 7.58796ZM5.5998 15.832V9.10396L9.3598 12.456L9.3358 12.48L5.5998 15.832ZM6.3358 16.548L8.5878 14.336L9.8838 13.064L11.9998 11.164L12.5438 11.652L14.1158 13.064L17.6638 16.548H6.3358ZM18.3998 15.832L14.7678 12.576L14.6638 12.48L14.6398 12.456L18.3998 9.10396V15.832Z",
      "fill": "black"
    }
  })]);
};
var SendMailvue_type_template_id_1a96fbb2_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendMail.vue?vue&type=script&lang=ts&

/* harmony default export */ var SendMailvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendMail.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_SendMailvue_type_script_lang_ts_ = (SendMailvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendMail.vue





/* normalize component */
;
var SendMail_component = normalizeComponent(
  icons_notifications_SendMailvue_type_script_lang_ts_,
  SendMailvue_type_template_id_1a96fbb2_render,
  SendMailvue_type_template_id_1a96fbb2_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendMail = (SendMail_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendMessage.vue?vue&type=template&id=330c9958&
var SendMessagevue_type_template_id_330c9958_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.9803 6.37195H7.82428C7.68955 6.36981 7.55576 6.39469 7.43081 6.44514C7.30587 6.49559 7.1923 6.57058 7.09684 6.66567C7.00137 6.76076 6.92594 6.87403 6.875 6.99878C6.82407 7.12352 6.79866 7.25722 6.80028 7.39195V7.93195C5.43945 8.12007 4.19245 8.79367 3.28906 9.82864C2.38568 10.8636 1.88677 12.1902 1.88428 13.564C1.89027 14.2719 2.02584 14.9728 2.28428 15.632C2.48522 16.1295 2.75447 16.5967 3.08428 17.02L2.32428 18.82C2.28286 18.8938 2.26596 18.979 2.27602 19.0631C2.28609 19.1472 2.32259 19.2259 2.38028 19.288C2.42495 19.3419 2.48127 19.3851 2.545 19.4142C2.60874 19.4433 2.67823 19.4576 2.74828 19.456L5.74428 18.936C6.33847 19.1485 6.96524 19.2554 7.59628 19.252C8.58553 19.252 9.55764 18.9937 10.4164 18.5026C11.2751 18.0115 11.9907 17.3046 12.4923 16.452H13.6003L16.0563 18.3C16.1753 18.3896 16.317 18.4442 16.4654 18.4576C16.6139 18.4711 16.7631 18.4428 16.8963 18.376C17.0288 18.3092 17.1402 18.2068 17.2179 18.0804C17.2956 17.9539 17.3366 17.8084 17.3363 17.66V16.46H18.9923C19.1269 16.4595 19.26 16.4321 19.3839 16.3795C19.5079 16.3269 19.62 16.2502 19.7139 16.1537C19.8078 16.0572 19.8814 15.943 19.9306 15.8177C19.9798 15.6924 20.0035 15.5585 20.0003 15.424V7.39195C20.0013 7.25771 19.9757 7.12459 19.9248 7.00036C19.8739 6.87613 19.7988 6.76326 19.7039 6.66833C19.609 6.5734 19.4961 6.49831 19.3719 6.44743C19.2476 6.39654 19.1145 6.37089 18.9803 6.37195ZM11.8603 15.648C11.725 15.9304 11.5615 16.1984 11.3723 16.448C10.9291 17.0358 10.3556 17.5129 9.69702 17.8419C9.03839 18.1709 8.31249 18.3427 7.57628 18.344C7.01233 18.341 6.45324 18.2395 5.92428 18.044C5.87239 18.0204 5.81699 18.0055 5.76028 18L5.09628 18.116L3.49628 18.392L3.97628 17.268L4.03628 17.124C4.07166 17.0455 4.08368 16.9585 4.07091 16.8734C4.05814 16.7882 4.02112 16.7086 3.96428 16.644C3.62692 16.239 3.35681 15.7826 3.16428 15.292C2.90706 14.6343 2.79977 13.9276 2.85022 13.2232C2.90067 12.5189 3.1076 11.8347 3.45592 11.2204C3.80425 10.6062 4.2852 10.0773 4.86375 9.67244C5.44229 9.26756 6.10387 8.99682 6.80028 8.87995C7.05641 8.83272 7.3159 8.80597 7.57628 8.79995H7.60028C8.40672 8.80185 9.19943 9.00878 9.90391 9.40129C10.6084 9.7938 11.2015 10.359 11.6275 11.0438C12.0534 11.7285 12.2983 12.5103 12.339 13.3158C12.3798 14.1212 12.215 14.9237 11.8603 15.648ZM19.2003 15.424C19.2027 15.454 19.1986 15.4842 19.1882 15.5125C19.1777 15.5407 19.1613 15.5664 19.14 15.5877C19.1187 15.609 19.0931 15.6254 19.0648 15.6358C19.0365 15.6462 19.0063 15.6504 18.9763 15.648H17.2003C17.0227 15.648 16.8524 15.7182 16.7265 15.8434C16.6006 15.9685 16.5293 16.1384 16.5283 16.316V17.656L14.0323 15.78C13.9177 15.6921 13.7767 15.6456 13.6323 15.648H12.8683C13.21 14.7873 13.3361 13.8561 13.2356 12.9355C13.1351 12.0149 12.811 11.1328 12.2916 10.3662C11.7722 9.59949 11.0732 8.97143 10.2556 8.5367C9.4379 8.10198 8.52633 7.87377 7.60028 7.87195V7.39195C7.59853 7.36261 7.60302 7.33322 7.61346 7.30574C7.6239 7.27826 7.64004 7.2533 7.66083 7.23251C7.68162 7.21172 7.70658 7.19557 7.73406 7.18514C7.76155 7.1747 7.79093 7.17021 7.82028 7.17195H18.9803C19.0099 7.16961 19.0398 7.17366 19.0677 7.18383C19.0957 7.194 19.1212 7.21006 19.1424 7.23091C19.1636 7.25176 19.1802 7.27693 19.1908 7.30472C19.2015 7.3325 19.2061 7.36225 19.2043 7.39195L19.2003 15.424Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.6998 4.54407C19.5937 4.54407 19.492 4.58621 19.417 4.66122C19.3419 4.73624 19.2998 4.83798 19.2998 4.94407C19.2998 5.05015 19.3419 5.1519 19.417 5.22691C19.492 5.30192 19.5937 5.34407 19.6998 5.34407C19.8438 5.34407 21.0958 5.40407 21.3278 7.22407C21.3405 7.3209 21.3882 7.40975 21.4619 7.47386C21.5356 7.53796 21.6301 7.57289 21.7278 7.57207H21.7798C21.8321 7.56564 21.8827 7.54894 21.9285 7.52292C21.9744 7.49689 22.0146 7.46206 22.047 7.42043C22.0793 7.37879 22.1031 7.33118 22.117 7.28032C22.1308 7.22946 22.1345 7.17636 22.1278 7.12407C21.8478 5.08007 20.4278 4.54407 19.6998 4.54407Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.91202 14.716C9.78402 14.652 9.15602 14.34 9.04002 14.316C8.92402 14.292 8.83602 14.252 8.75202 14.38C8.66802 14.508 8.42002 14.78 8.35202 14.88C8.28402 14.98 8.20402 14.976 8.07602 14.912C7.69899 14.7613 7.35111 14.5461 7.04802 14.276C6.76825 14.0182 6.5283 13.7202 6.33602 13.392C6.26002 13.264 6.33602 13.196 6.39202 13.132C6.44802 13.068 6.52002 12.98 6.58402 12.908C6.63653 12.8423 6.67961 12.7696 6.71202 12.692C6.73093 12.6577 6.74085 12.6191 6.74085 12.58C6.74085 12.5408 6.73093 12.5023 6.71202 12.468C6.68002 12.404 6.42402 11.776 6.31202 11.52C6.20002 11.264 6.10002 11.304 6.02402 11.3H5.78002C5.71478 11.3016 5.65057 11.3167 5.59139 11.3442C5.53221 11.3717 5.47933 11.4111 5.43602 11.46C5.29129 11.5971 5.17671 11.7629 5.09958 11.9468C5.02245 12.1307 4.98446 12.3286 4.98802 12.528C5.02982 13.0097 5.212 13.4687 5.51202 13.848C6.0595 14.671 6.81231 15.337 7.69602 15.78C7.93322 15.8835 8.17631 15.973 8.42402 16.048C8.68303 16.1272 8.95694 16.145 9.22402 16.1C9.40214 16.0636 9.57083 15.9908 9.7195 15.8862C9.86818 15.7815 9.99364 15.6473 10.088 15.492C10.1699 15.3004 10.1949 15.0893 10.16 14.884C10.124 14.8 10.04 14.8 9.91202 14.716Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.9799 7.17202H7.82388C7.79454 7.17028 7.76515 7.17477 7.73767 7.18521C7.71018 7.19564 7.68523 7.21179 7.66444 7.23258C7.64365 7.25337 7.6275 7.27832 7.61707 7.30581C7.60663 7.33329 7.60214 7.36268 7.60388 7.39202V7.87202C8.5296 7.87449 9.44068 8.10317 10.2578 8.53817C11.075 8.97317 11.7734 9.6013 12.2924 10.3679C12.8113 11.1345 13.135 12.0163 13.2353 12.9365C13.3356 13.8568 13.2095 14.7876 12.8679 15.648H13.6319C13.7763 15.6456 13.9173 15.6922 14.0319 15.78L16.5279 17.656V16.316C16.5289 16.1385 16.6002 15.9686 16.7261 15.8434C16.852 15.7183 17.0223 15.648 17.1999 15.648H18.9839C19.0139 15.6504 19.0441 15.6463 19.0724 15.6359C19.1007 15.6255 19.1263 15.6091 19.1476 15.5878C19.1689 15.5665 19.1854 15.5408 19.1958 15.5125C19.2062 15.4842 19.2103 15.4541 19.2079 15.424V7.39202C19.2098 7.36195 19.2051 7.33183 19.1942 7.30374C19.1833 7.27565 19.1664 7.25026 19.1447 7.22934C19.123 7.20842 19.0971 7.19245 19.0686 7.18256C19.0401 7.17266 19.0099 7.16907 18.9799 7.17202Z",
      "fill": "#00E88F"
    }
  })]);
};
var SendMessagevue_type_template_id_330c9958_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/SendMessage.vue?vue&type=script&lang=ts&

/* harmony default export */ var SendMessagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_SendMessagevue_type_script_lang_ts_ = (SendMessagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/SendMessage.vue





/* normalize component */
;
var SendMessage_component = normalizeComponent(
  icons_notifications_SendMessagevue_type_script_lang_ts_,
  SendMessagevue_type_template_id_330c9958_render,
  SendMessagevue_type_template_id_330c9958_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var SendMessage = (SendMessage_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Shake.vue?vue&type=template&id=33e29974&
var Shakevue_type_template_id_33e29974_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.9642 4.19604C18.8037 4.49237 18.5605 4.7356 18.2642 4.89605C18.5606 5.05813 18.8038 5.30266 18.9642 5.60005C19.1258 5.30561 19.3688 5.06398 19.6642 4.90405C19.3667 4.74145 19.1234 4.49533 18.9642 4.19604Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.27988 17.42L8.87988 19.02H13.6799L13.2799 17.42H9.27988Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.6398 4.53599C20.5918 4.51549 20.5401 4.50462 20.4878 4.50399C20.3389 4.50399 20.1913 4.47458 20.0537 4.41744C19.9161 4.3603 19.7912 4.27656 19.686 4.17102C19.5808 4.06548 19.4975 3.94022 19.4409 3.80242C19.3842 3.66461 19.3553 3.51698 19.3558 3.36799C19.3574 3.31034 19.3465 3.25303 19.3238 3.19999C19.3034 3.154 19.275 3.11201 19.2398 3.07599C19.1657 3.00452 19.0668 2.9644 18.9638 2.96399C18.8609 2.9644 18.762 3.00452 18.6879 3.07599C18.6527 3.11201 18.6243 3.154 18.6038 3.19999C18.5847 3.24835 18.5752 3.29998 18.5758 3.35199C18.5758 3.65328 18.4562 3.94222 18.2431 4.15526C18.0301 4.3683 17.7411 4.48799 17.4399 4.48799C17.3875 4.48772 17.3357 4.49863 17.2879 4.51999C17.2175 4.55066 17.1575 4.60091 17.115 4.66474C17.0724 4.72857 17.0491 4.80329 17.0479 4.87999C17.0485 4.93226 17.0594 4.9839 17.0799 5.03199C17.1111 5.10155 17.1616 5.16073 17.2254 5.20254C17.2892 5.24436 17.3636 5.26706 17.4399 5.26799C17.7408 5.26904 18.0291 5.38907 18.242 5.60188C18.4548 5.81469 18.5748 6.10303 18.5758 6.40399C18.5758 6.51008 18.618 6.61182 18.693 6.68683C18.768 6.76185 18.8698 6.80399 18.9758 6.80399C19.0788 6.80358 19.1777 6.76346 19.2518 6.69199C19.3248 6.61847 19.3664 6.51954 19.3678 6.41599C19.3673 6.267 19.3962 6.11937 19.4529 5.98156C19.5095 5.84376 19.5928 5.7185 19.698 5.61296C19.8032 5.50742 19.9281 5.42368 20.0657 5.36654C20.2033 5.3094 20.3509 5.27999 20.4998 5.27999C20.5761 5.27906 20.6505 5.25636 20.7143 5.21454C20.7781 5.17273 20.8286 5.11355 20.8598 5.04399C20.8803 4.9959 20.8912 4.94426 20.8918 4.89199C20.8888 4.81463 20.8634 4.73981 20.8186 4.67662C20.7739 4.61343 20.7118 4.56458 20.6398 4.53599ZM18.9638 5.59999C18.8022 5.30556 18.5592 5.06392 18.2639 4.90399C18.5602 4.74354 18.8034 4.50032 18.9638 4.20399C19.1243 4.50032 19.3675 4.74354 19.6638 4.90399C19.3685 5.06392 19.1255 5.30556 18.9638 5.59999Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.2479 19.512C8.32283 19.6081 8.41872 19.6858 8.52825 19.7391C8.63778 19.7925 8.75805 19.8202 8.8799 19.82H13.6799C13.8012 19.8199 13.921 19.7922 14.03 19.739C14.1391 19.6858 14.2346 19.6085 14.3094 19.5129C14.3842 19.4173 14.4362 19.306 14.4616 19.1873C14.487 19.0687 14.485 18.9458 14.4559 18.828L14.0559 17.228C14.013 17.0546 13.9133 16.9005 13.7727 16.7903C13.632 16.6801 13.4586 16.6201 13.2799 16.62H9.2799C9.10123 16.6201 8.92775 16.6801 8.78712 16.7903C8.64648 16.9005 8.54677 17.0546 8.50389 17.228L8.10389 18.828C8.07457 18.9455 8.07229 19.0681 8.09724 19.1866C8.12218 19.305 8.1737 19.4163 8.2479 19.512ZM9.2799 17.42H13.2799L13.6799 19.02H8.8799L9.2799 17.42Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.2801 4.97998H7.28008C6.96182 4.97998 6.65659 5.10641 6.43155 5.33145C6.20651 5.5565 6.08008 5.86172 6.08008 6.17998C6.08008 6.49824 6.20651 6.80346 6.43155 7.02851C6.65659 7.25355 6.96182 7.37998 7.28008 7.37998V10.98C7.28058 11.7599 7.53438 12.5186 8.00328 13.1419C8.47218 13.7652 9.13081 14.2193 9.88008 14.436V15.42H8.40008C8.1213 15.4218 7.85184 15.5205 7.63798 15.6994C7.42411 15.8782 7.27918 16.1259 7.22808 16.4L6.58808 19.6C6.5534 19.7758 6.55854 19.9571 6.60311 20.1307C6.64768 20.3042 6.73055 20.4656 6.84564 20.6029C6.96073 20.7403 7.10512 20.8501 7.2682 20.9243C7.43128 20.9986 7.60892 21.0354 7.78808 21.032H14.8001C14.9774 21.0324 15.1525 20.9935 15.313 20.9181C15.4734 20.8427 15.6152 20.7327 15.7281 20.596C15.8391 20.458 15.9182 20.2971 15.9597 20.1249C16.0012 19.9527 16.0041 19.7734 15.9681 19.6L15.3281 16.4C15.2744 16.1275 15.1278 15.882 14.9133 15.7055C14.6989 15.529 14.4298 15.4323 14.1521 15.432H12.6801V14.436C13.4293 14.2193 14.088 13.7652 14.5569 13.1419C15.0258 12.5186 15.2796 11.7599 15.2801 10.98V7.37998C15.5983 7.37998 15.9036 7.25355 16.1286 7.02851C16.3536 6.80346 16.4801 6.49824 16.4801 6.17998C16.4801 5.86172 16.3536 5.5565 16.1286 5.33145C15.9036 5.10641 15.5983 4.97998 15.2801 4.97998ZM14.1521 16.22C14.2462 16.2183 14.338 16.2498 14.4111 16.3091C14.4843 16.3684 14.5342 16.4515 14.5521 16.544L15.1921 19.744C15.2034 19.8025 15.2015 19.8628 15.1866 19.9205C15.1716 19.9781 15.1439 20.0318 15.1056 20.0774C15.0673 20.123 15.0192 20.1595 14.965 20.1842C14.9107 20.2088 14.8517 20.2211 14.7921 20.22H7.76808C7.7085 20.2211 7.64942 20.2088 7.59518 20.1842C7.54093 20.1595 7.49289 20.123 7.45455 20.0774C7.41621 20.0318 7.38855 19.9781 7.37359 19.9205C7.35863 19.8628 7.35675 19.8025 7.36808 19.744L8.00808 16.544C8.02595 16.4515 8.07587 16.3684 8.14904 16.3091C8.2222 16.2498 8.31393 16.2183 8.40808 16.22H14.1521ZM10.6801 15.42V14.568C10.7441 14.568 10.8121 14.568 10.8801 14.568H11.6801H11.8801V15.42H10.6801ZM15.2801 6.57998H14.8801C14.774 6.57998 14.6722 6.62212 14.5972 6.69714C14.5222 6.77215 14.4801 6.87389 14.4801 6.97998V10.98C14.4801 11.7226 14.1851 12.4348 13.66 12.9599C13.1349 13.485 12.4227 13.78 11.6801 13.78H10.8801C10.1375 13.78 9.42528 13.485 8.90018 12.9599C8.37508 12.4348 8.08008 11.7226 8.08008 10.98V7.37998H11.2801C11.3862 7.37998 11.4879 7.33784 11.5629 7.26282C11.6379 7.18781 11.6801 7.08607 11.6801 6.97998C11.6801 6.87389 11.6379 6.77215 11.5629 6.69714C11.4879 6.62212 11.3862 6.57998 11.2801 6.57998H7.28008C7.17399 6.57998 7.07225 6.53784 6.99724 6.46282C6.92222 6.38781 6.88008 6.28607 6.88008 6.17998C6.88008 6.07389 6.92222 5.97215 6.99724 5.89714C7.07225 5.82212 7.17399 5.77998 7.28008 5.77998H15.2801C15.3862 5.77998 15.4879 5.82212 15.5629 5.89714C15.6379 5.97215 15.6801 6.07389 15.6801 6.17998C15.6801 6.28607 15.6379 6.38781 15.5629 6.46282C15.4879 6.53784 15.3862 6.57998 15.2801 6.57998Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.4719 12.104C9.57587 12.024 9.47587 10.932 9.47187 10.904V9.78C9.47187 9.67392 9.42973 9.57218 9.35472 9.49716C9.2797 9.42215 9.17796 9.38 9.07187 9.38C8.96579 9.38 8.86405 9.42215 8.78903 9.49716C8.71402 9.57218 8.67188 9.67392 8.67188 9.78V10.948C8.71987 11.576 9.14387 12.788 10.3999 12.9H10.4359C10.542 12.9048 10.6456 12.8672 10.724 12.7956C10.8024 12.7239 10.8491 12.6241 10.8539 12.518C10.8586 12.4119 10.8211 12.3083 10.7494 12.2299C10.6778 12.1515 10.578 12.1048 10.4719 12.1V12.104Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.7199 15.4919C18.6425 15.4919 18.5682 15.4612 18.5134 15.4064C18.4587 15.3516 18.4279 15.2774 18.4279 15.1999C18.4279 15.1257 18.3984 15.0544 18.3459 15.0019C18.2934 14.9494 18.2222 14.9199 18.1479 14.9199C18.0736 14.9199 18.0024 14.9494 17.9499 15.0019C17.8974 15.0544 17.8679 15.1257 17.8679 15.1999C17.8679 15.2774 17.8371 15.3516 17.7824 15.4064C17.7276 15.4612 17.6533 15.4919 17.5759 15.4919C17.5016 15.4919 17.4304 15.5214 17.3779 15.5739C17.3254 15.6264 17.2959 15.6977 17.2959 15.7719C17.2959 15.8462 17.3254 15.9174 17.3779 15.9699C17.4304 16.0224 17.5016 16.0519 17.5759 16.0519C17.6533 16.0519 17.7276 16.0827 17.7824 16.1374C17.8371 16.1922 17.8679 16.2665 17.8679 16.3439C17.8679 16.4182 17.8974 16.4894 17.9499 16.5419C18.0024 16.5944 18.0736 16.6239 18.1479 16.6239C18.2222 16.6239 18.2934 16.5944 18.3459 16.5419C18.3984 16.4894 18.4279 16.4182 18.4279 16.3439C18.4279 16.2665 18.4587 16.1922 18.5134 16.1374C18.5682 16.0827 18.6425 16.0519 18.7199 16.0519C18.7942 16.0519 18.8654 16.0224 18.9179 15.9699C18.9704 15.9174 18.9999 15.8462 18.9999 15.7719C18.9999 15.6977 18.9704 15.6264 18.9179 15.5739C18.8654 15.5214 18.7942 15.4919 18.7199 15.4919Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.89612 9.81199C4.83485 9.81252 4.77408 9.80091 4.71732 9.77783C4.66057 9.75475 4.60894 9.72065 4.56543 9.67751C4.52192 9.63437 4.48738 9.58304 4.46382 9.52649C4.44025 9.46993 4.42812 9.40926 4.42812 9.34799C4.42812 9.27373 4.39862 9.20251 4.34611 9.15C4.2936 9.09749 4.22238 9.06799 4.14812 9.06799C4.07386 9.06799 4.00264 9.09749 3.95013 9.15C3.89762 9.20251 3.86812 9.27373 3.86812 9.34799C3.86812 9.40926 3.85599 9.46993 3.83242 9.52649C3.80885 9.58304 3.77431 9.63437 3.7308 9.67751C3.68729 9.72065 3.63567 9.75475 3.57891 9.77783C3.52215 9.80091 3.46139 9.81252 3.40012 9.81199C3.32586 9.81199 3.25464 9.84149 3.20213 9.894C3.14962 9.94651 3.12012 10.0177 3.12012 10.092C3.12012 10.1663 3.14962 10.2375 3.20213 10.29C3.25464 10.3425 3.32586 10.372 3.40012 10.372C3.52424 10.372 3.64328 10.4213 3.73104 10.5091C3.81881 10.5968 3.86812 10.7159 3.86812 10.84C3.86812 10.9143 3.89762 10.9855 3.95013 11.038C4.00264 11.0905 4.07386 11.12 4.14812 11.12C4.22238 11.12 4.2936 11.0905 4.34611 11.038C4.39862 10.9855 4.42812 10.9143 4.42812 10.84C4.42812 10.7159 4.47742 10.5968 4.56519 10.5091C4.65296 10.4213 4.772 10.372 4.89612 10.372C4.97038 10.372 5.0416 10.3425 5.09411 10.29C5.14662 10.2375 5.17612 10.1663 5.17612 10.092C5.17612 10.0177 5.14662 9.94651 5.09411 9.894C5.0416 9.84149 4.97038 9.81199 4.89612 9.81199Z",
      "fill": "black"
    }
  })]);
};
var Shakevue_type_template_id_33e29974_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Shake.vue?vue&type=script&lang=ts&

/* harmony default export */ var Shakevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Shake.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_Shakevue_type_script_lang_ts_ = (Shakevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Shake.vue





/* normalize component */
;
var Shake_component = normalizeComponent(
  icons_notifications_Shakevue_type_script_lang_ts_,
  Shakevue_type_template_id_33e29974_render,
  Shakevue_type_template_id_33e29974_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Shake = (Shake_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Contract.vue?vue&type=template&id=26d1bb92&
var Contractvue_type_template_id_26d1bb92_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M19.9721 6.53198H4.02812C3.9754 6.53301 3.92512 6.55441 3.88784 6.59169C3.85055 6.62898 3.82915 6.67926 3.82812 6.73198V17.268C3.82915 17.3207 3.85055 17.371 3.88784 17.4083C3.92512 17.4456 3.9754 17.467 4.02812 17.468H19.9721C20.0248 17.467 20.0751 17.4456 20.1124 17.4083C20.1497 17.371 20.1711 17.3207 20.1721 17.268V6.73198C20.1711 6.67926 20.1497 6.62898 20.1124 6.59169C20.0751 6.55441 20.0248 6.53301 19.9721 6.53198ZM19.0801 15.84C19.0791 16.0943 18.9776 16.3378 18.7978 16.5176C18.618 16.6974 18.3744 16.7989 18.1201 16.8H5.88012C5.62584 16.7989 5.38227 16.6974 5.20247 16.5176C5.02266 16.3378 4.92118 16.0943 4.92013 15.84V8.15998C4.92118 7.9057 5.02266 7.66213 5.20247 7.48232C5.38227 7.30252 5.62584 7.20104 5.88012 7.19998H18.1201C18.3744 7.20104 18.618 7.30252 18.7978 7.48232C18.9776 7.66213 19.0791 7.9057 19.0801 8.15998V15.84Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.9718 5.73206H4.02783C3.76294 5.73311 3.5092 5.8388 3.32189 6.02611C3.13458 6.21342 3.02889 6.46716 3.02783 6.73206V17.2681C3.02889 17.5329 3.13458 17.7867 3.32189 17.974C3.5092 18.1613 3.76294 18.267 4.02783 18.2681H19.9718C20.2367 18.267 20.4905 18.1613 20.6778 17.974C20.8651 17.7867 20.9708 17.5329 20.9718 17.2681V6.73206C20.9708 6.46716 20.8651 6.21342 20.6778 6.02611C20.4905 5.8388 20.2367 5.73311 19.9718 5.73206ZM20.1718 17.2681C20.1708 17.3208 20.1494 17.3711 20.1121 17.4083C20.0748 17.4456 20.0246 17.467 19.9718 17.4681H4.02783C3.97511 17.467 3.92483 17.4456 3.88754 17.4083C3.85026 17.3711 3.82886 17.3208 3.82783 17.2681V6.73206C3.82886 6.67933 3.85026 6.62905 3.88754 6.59177C3.92483 6.55448 3.97511 6.53308 4.02783 6.53206H19.9718C20.0246 6.53308 20.0748 6.55448 20.1121 6.59177C20.1494 6.62905 20.1708 6.67933 20.1718 6.73206V17.2681Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.1199 7.19995H5.87992C5.62564 7.201 5.38207 7.30248 5.20226 7.48229C5.02246 7.6621 4.92097 7.90567 4.91992 8.15995V15.8399C4.92097 16.0942 5.02246 16.3378 5.20226 16.5176C5.38207 16.6974 5.62564 16.7989 5.87992 16.7999H18.1199C18.3742 16.7989 18.6178 16.6974 18.7976 16.5176C18.9774 16.3378 19.0789 16.0942 19.0799 15.8399V8.15995C19.0789 7.90567 18.9774 7.6621 18.7976 7.48229C18.6178 7.30248 18.3742 7.201 18.1199 7.19995ZM18.2799 15.8399C18.2799 15.8824 18.2631 15.9231 18.2331 15.9531C18.2031 15.9831 18.1624 16 18.1199 16H5.87992C5.83749 16 5.79679 15.9831 5.76678 15.9531C5.73678 15.9231 5.71992 15.8824 5.71992 15.8399V8.15995C5.71992 8.11752 5.73678 8.07682 5.76678 8.04681C5.79679 8.01681 5.83749 7.99995 5.87992 7.99995H18.1199C18.1624 7.99995 18.2031 8.01681 18.2331 8.04681C18.2631 8.07682 18.2799 8.11752 18.2799 8.15995V15.8399Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M9.52793 10.316H14.4719C14.578 10.316 14.6798 10.2738 14.7548 10.1988C14.8298 10.1238 14.8719 10.0221 14.8719 9.91599C14.8719 9.8099 14.8298 9.70816 14.7548 9.63315C14.6798 9.55813 14.578 9.51599 14.4719 9.51599H9.52793C9.42184 9.51599 9.3201 9.55813 9.24509 9.63315C9.17007 9.70816 9.12793 9.8099 9.12793 9.91599C9.12793 10.0221 9.17007 10.1238 9.24509 10.1988C9.3201 10.2738 9.42184 10.316 9.52793 10.316Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.6481 14.328H10.3521C10.2461 14.328 10.1443 14.3701 10.0693 14.4452C9.99429 14.5202 9.95215 14.6219 9.95215 14.728C9.95215 14.8341 9.99429 14.9358 10.0693 15.0108C10.1443 15.0859 10.2461 15.128 10.3521 15.128H13.6481C13.7542 15.128 13.856 15.0859 13.931 15.0108C14.006 14.9358 14.0481 14.8341 14.0481 14.728C14.0481 14.6219 14.006 14.5202 13.931 14.4452C13.856 14.3701 13.7542 14.328 13.6481 14.328Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.7081 11.9199H8.29209C8.186 11.9199 8.08426 11.9621 8.00925 12.0371C7.93423 12.1121 7.89209 12.2138 7.89209 12.3199C7.89209 12.426 7.93423 12.5278 8.00925 12.6028C8.08426 12.6778 8.186 12.7199 8.29209 12.7199H15.7081C15.8142 12.7199 15.9159 12.6778 15.9909 12.6028C16.0659 12.5278 16.1081 12.426 16.1081 12.3199C16.1081 12.2138 16.0659 12.1121 15.9909 12.0371C15.9159 11.9621 15.8142 11.9199 15.7081 11.9199Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.3162 9.37207C17.2334 9.37207 17.1541 9.3392 17.0956 9.28069C17.037 9.22217 17.0042 9.14282 17.0042 9.06007C17.0042 8.99642 16.9789 8.93537 16.9339 8.89036C16.8889 8.84535 16.8278 8.82007 16.7642 8.82007C16.7005 8.82007 16.6395 8.84535 16.5945 8.89036C16.5495 8.93537 16.5242 8.99642 16.5242 9.06007C16.5242 9.14282 16.4913 9.22217 16.4328 9.28069C16.3743 9.3392 16.2949 9.37207 16.2122 9.37207C16.1807 9.37207 16.1494 9.37828 16.1203 9.39034C16.0912 9.4024 16.0647 9.42008 16.0425 9.44236C16.0202 9.46465 16.0025 9.49111 15.9904 9.52022C15.9784 9.54934 15.9722 9.58055 15.9722 9.61207C15.9722 9.64359 15.9784 9.67479 15.9904 9.70391C16.0025 9.73303 16.0202 9.75949 16.0425 9.78177C16.0647 9.80406 16.0912 9.82174 16.1203 9.8338C16.1494 9.84586 16.1807 9.85207 16.2122 9.85207C16.2949 9.85207 16.3743 9.88494 16.4328 9.94345C16.4913 10.002 16.5242 10.0813 16.5242 10.1641C16.5242 10.2277 16.5495 10.2888 16.5945 10.3338C16.6395 10.3788 16.7005 10.4041 16.7642 10.4041C16.8278 10.4041 16.8889 10.3788 16.9339 10.3338C16.9789 10.2888 17.0042 10.2277 17.0042 10.1641C17.0042 10.0813 17.037 10.002 17.0956 9.94345C17.1541 9.88494 17.2334 9.85207 17.3162 9.85207C17.3798 9.85207 17.4409 9.82678 17.4859 9.78177C17.5309 9.73677 17.5562 9.67572 17.5562 9.61207C17.5562 9.54842 17.5309 9.48737 17.4859 9.44236C17.4409 9.39735 17.3798 9.37207 17.3162 9.37207Z",
      "fill": "black"
    }
  })]);
};
var Contractvue_type_template_id_26d1bb92_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Contract.vue?vue&type=script&lang=ts&

/* harmony default export */ var Contractvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Contract.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_Contractvue_type_script_lang_ts_ = (Contractvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Contract.vue





/* normalize component */
;
var Contract_component = normalizeComponent(
  icons_notifications_Contractvue_type_script_lang_ts_,
  Contractvue_type_template_id_26d1bb92_render,
  Contractvue_type_template_id_26d1bb92_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Contract = (Contract_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/FileVerified.vue?vue&type=template&id=51310284&
var FileVerifiedvue_type_template_id_51310284_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.3562 18.092V5.69202C18.3562 5.4268 18.2508 5.17245 18.0633 4.98491C17.8757 4.79737 17.6214 4.69202 17.3562 4.69202H6.55615C6.29094 4.69202 6.03658 4.79737 5.84905 4.98491C5.66151 5.17245 5.55615 5.4268 5.55615 5.69202V18.092C5.55615 18.3572 5.66151 18.6116 5.84905 18.7991C6.03658 18.9867 6.29094 19.092 6.55615 19.092H17.3562C17.6214 19.092 17.8757 18.9867 18.0633 18.7991C18.2508 18.6116 18.3562 18.3572 18.3562 18.092ZM10.3562 6.29202V5.49202H13.5562V6.49202C13.5562 6.54506 13.5351 6.59593 13.4976 6.63344C13.4601 6.67095 13.4092 6.69202 13.3562 6.69202H10.5562C10.5031 6.69202 10.4522 6.67095 10.4147 6.63344C10.3772 6.59593 10.3562 6.54506 10.3562 6.49202V6.29202ZM9.76415 7.09202C9.85619 7.21739 9.97675 7.31905 10.1159 7.38861C10.255 7.45816 10.4086 7.49361 10.5642 7.49202H13.3642C13.5196 7.49296 13.673 7.45723 13.812 7.38773C13.951 7.31823 14.0717 7.21691 14.1642 7.09202H15.8082C15.8506 7.09202 15.8913 7.10887 15.9213 7.13888C15.9513 7.16888 15.9682 7.20958 15.9682 7.25202V16.532C15.9682 16.5745 15.9513 16.6151 15.9213 16.6452C15.8913 16.6752 15.8506 16.692 15.8082 16.692H8.11615C8.07372 16.692 8.03302 16.6752 8.00301 16.6452C7.97301 16.6151 7.95615 16.5745 7.95615 16.532V7.25202C7.95615 7.20958 7.97301 7.16888 8.00301 7.13888C8.03302 7.10887 8.07372 7.09202 8.11615 7.09202H9.76415ZM6.35615 18.092V5.69202C6.35718 5.63929 6.37858 5.58902 6.41586 5.55173C6.45315 5.51444 6.50343 5.49304 6.55615 5.49202H9.55615V6.29202H8.11615C7.86187 6.29307 7.6183 6.39455 7.43849 6.57436C7.25869 6.75416 7.1572 6.99773 7.15615 7.25202V16.532C7.15615 16.7866 7.25729 17.0308 7.43733 17.2108C7.61736 17.3909 7.86154 17.492 8.11615 17.492H15.7962C15.9224 17.4925 16.0474 17.4681 16.1642 17.42C16.2809 17.372 16.3869 17.3013 16.4762 17.212C16.5654 17.1228 16.6361 17.0167 16.6842 16.9C16.7322 16.7833 16.7567 16.6582 16.7562 16.532V7.25202C16.7562 6.99741 16.655 6.75323 16.475 6.57319C16.2949 6.39316 16.0508 6.29202 15.7962 6.29202H14.3562V5.49202H17.3562C17.4092 5.49202 17.4601 5.51309 17.4976 5.5506C17.5351 5.5881 17.5562 5.63897 17.5562 5.69202V18.092C17.5562 18.1451 17.5351 18.1959 17.4976 18.2334C17.4601 18.2709 17.4092 18.292 17.3562 18.292H6.55615C6.50311 18.292 6.45224 18.2709 6.41473 18.2334C6.37722 18.1959 6.35615 18.1451 6.35615 18.092Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.1563 10.208H12.5563C12.6624 10.208 12.7642 10.1658 12.8392 10.0908C12.9142 10.0158 12.9563 9.91405 12.9563 9.80796C12.9563 9.70187 12.9142 9.60013 12.8392 9.52512C12.7642 9.4501 12.6624 9.40796 12.5563 9.40796H10.1563C10.0503 9.40796 9.94852 9.4501 9.87351 9.52512C9.79849 9.60013 9.75635 9.70187 9.75635 9.80796C9.75635 9.91405 9.79849 10.0158 9.87351 10.0908C9.94852 10.1658 10.0503 10.208 10.1563 10.208Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.1563 14.3759H11.7563C11.8624 14.3759 11.9642 14.3338 12.0392 14.2588C12.1142 14.1838 12.1563 14.082 12.1563 13.9759C12.1563 13.8698 12.1142 13.7681 12.0392 13.6931C11.9642 13.6181 11.8624 13.5759 11.7563 13.5759H10.1563C10.0503 13.5759 9.94852 13.6181 9.87351 13.6931C9.79849 13.7681 9.75635 13.8698 9.75635 13.9759C9.75635 14.082 9.79849 14.1838 9.87351 14.2588C9.94852 14.3338 10.0503 14.3759 10.1563 14.3759Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M10.1563 12.2921H13.7563C13.8624 12.2921 13.9642 12.2499 14.0392 12.1749C14.1142 12.0999 14.1563 11.9982 14.1563 11.8921C14.1563 11.786 14.1142 11.6842 14.0392 11.6092C13.9642 11.5342 13.8624 11.4921 13.7563 11.4921H10.1563C10.0503 11.4921 9.94852 11.5342 9.87351 11.6092C9.79849 11.6842 9.75635 11.786 9.75635 11.8921C9.75635 11.9982 9.79849 12.0999 9.87351 12.1749C9.94852 12.2499 10.0503 12.2921 10.1563 12.2921Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.6479 18.1079C19.5418 18.1079 19.4401 18.1501 19.3651 18.2251C19.2901 18.3001 19.2479 18.4018 19.2479 18.5079C19.2479 18.6479 19.1679 19.8999 17.3479 20.1079C17.2418 20.1143 17.1426 20.1625 17.0721 20.242C17.0016 20.3216 16.9655 20.4258 16.9719 20.5319C16.9783 20.638 17.0265 20.7372 17.106 20.8077C17.1856 20.8782 17.2898 20.9143 17.3959 20.9079H17.4439C19.5039 20.6639 20.0479 19.2319 20.0479 18.5079C20.0479 18.4018 20.0058 18.3001 19.9308 18.2251C19.8557 18.1501 19.754 18.1079 19.6479 18.1079Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.356 18.2921C17.409 18.2921 17.4599 18.271 17.4974 18.2335C17.5349 18.196 17.556 18.1451 17.556 18.0921V5.69207C17.556 5.63902 17.5349 5.58815 17.4974 5.55064C17.4599 5.51314 17.409 5.49207 17.356 5.49207H14.356V6.29207H15.796C16.0506 6.29207 16.2947 6.39321 16.4748 6.57324C16.6548 6.75328 16.756 6.99746 16.756 7.25206V16.5321C16.7565 16.6583 16.732 16.7834 16.684 16.9001C16.6359 17.0168 16.5652 17.1228 16.476 17.2121C16.3867 17.3013 16.2807 17.372 16.164 17.4201C16.0472 17.4681 15.9222 17.4926 15.796 17.4921H8.11596C7.86135 17.4921 7.61717 17.3909 7.43713 17.2109C7.2571 17.0308 7.15596 16.7867 7.15596 16.5321V7.25206C7.15701 6.99778 7.25849 6.75421 7.4383 6.57441C7.6181 6.3946 7.86167 6.29312 8.11596 6.29207H9.55596V5.49207H6.55596C6.50323 5.49309 6.45296 5.51449 6.41567 5.55178C6.37838 5.58906 6.35698 5.63934 6.35596 5.69207V18.0921C6.35596 18.1451 6.37703 18.196 6.41454 18.2335C6.45204 18.271 6.50291 18.2921 6.55596 18.2921H17.356Z",
      "fill": "#00E88F"
    }
  })]);
};
var FileVerifiedvue_type_template_id_51310284_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/FileVerified.vue?vue&type=script&lang=ts&

/* harmony default export */ var FileVerifiedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/FileVerified.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_FileVerifiedvue_type_script_lang_ts_ = (FileVerifiedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/FileVerified.vue





/* normalize component */
;
var FileVerified_component = normalizeComponent(
  icons_notifications_FileVerifiedvue_type_script_lang_ts_,
  FileVerifiedvue_type_template_id_51310284_render,
  FileVerifiedvue_type_template_id_51310284_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var FileVerified = (FileVerified_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/GraduateComplete.vue?vue&type=template&id=7a08f6d0&
var GraduateCompletevue_type_template_id_7a08f6d0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M11.9963 7.33606L4.07227 10.3521L11.9963 13.3641L19.9203 10.3521L11.9963 7.33606Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.3999 6.05203C18.5265 5.85204 18.6959 5.68264 18.8959 5.55603C18.6964 5.42715 18.5272 5.25657 18.3999 5.05603C18.2712 5.25675 18.1006 5.42731 17.8999 5.55603C18.1013 5.68217 18.2721 5.85161 18.3999 6.05203Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M21.0202 14.884V10.616C21.0644 10.5682 21.0963 10.5103 21.113 10.4474C21.1298 10.3845 21.1309 10.3184 21.1163 10.2549C21.1017 10.1915 21.0719 10.1325 21.0294 10.0832C20.9868 10.0339 20.9329 9.99574 20.8722 9.97202L12.1482 6.52402C12.0498 6.48988 11.9427 6.48988 11.8442 6.52402L3.12025 9.97202C3.04165 9.99922 2.97349 10.0502 2.92524 10.118C2.877 10.1857 2.85107 10.2668 2.85107 10.35C2.85107 10.4332 2.877 10.5143 2.92524 10.582C2.97349 10.6498 3.04165 10.7008 3.12025 10.728L6.11225 11.928V16.852C6.12821 17.0492 6.1887 17.2402 6.28916 17.4107C6.38962 17.5811 6.52744 17.7265 6.69225 17.836C7.07653 18.1413 7.50557 18.3855 7.96424 18.56C9.2521 19.0534 10.6212 19.3003 12.0002 19.288C13.3766 19.2993 14.7429 19.0524 16.0282 18.56C16.4869 18.3855 16.916 18.1413 17.3002 17.836C17.465 17.7265 17.6029 17.5811 17.7033 17.4107C17.8038 17.2402 17.8643 17.0492 17.8802 16.852V11.912L20.2202 10.984V14.884C20.1512 14.9722 20.112 15.0801 20.1082 15.192C20.1019 15.2633 20.1106 15.3352 20.1335 15.403C20.1565 15.4708 20.1933 15.5331 20.2417 15.5859C20.29 15.6387 20.3488 15.6808 20.4143 15.7097C20.4798 15.7385 20.5507 15.7534 20.6222 15.7534C20.6938 15.7534 20.7646 15.7385 20.8302 15.7097C20.8957 15.6808 20.9545 15.6387 21.0028 15.5859C21.0512 15.5331 21.088 15.4708 21.111 15.403C21.1339 15.3352 21.1425 15.2633 21.1362 15.192C21.1331 15.0793 21.0923 14.9708 21.0202 14.884ZM17.0682 16.852C17.0131 16.9907 16.9203 17.1113 16.8002 17.2C16.4757 17.4482 16.1174 17.6489 15.7362 17.796C14.544 18.253 13.277 18.4836 12.0002 18.476C10.7298 18.4867 9.46849 18.2616 8.28025 17.812C7.89256 17.6613 7.52878 17.4551 7.20024 17.2C7.07038 17.1098 6.97016 16.9831 6.91225 16.836V12.232L11.8322 14.176C11.9296 14.216 12.0389 14.216 12.1362 14.176L17.0562 12.232L17.0682 16.852ZM12.0002 13.364L4.07225 10.352L12.0002 7.33602L19.9202 10.352L12.0002 13.364Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.2 5.86398C17.4387 5.86398 17.6677 5.95881 17.8364 6.12759C18.0052 6.29637 18.1 6.52529 18.1 6.76398C18.1 6.84673 18.1329 6.92609 18.1914 6.9846C18.2499 7.04311 18.3293 7.07598 18.412 7.07598C18.4528 7.07599 18.4932 7.06789 18.5308 7.05216C18.5685 7.03643 18.6026 7.01339 18.6313 6.98436C18.6599 6.95534 18.6825 6.92091 18.6978 6.88308C18.713 6.84525 18.7206 6.80477 18.72 6.76398C18.72 6.52871 18.8121 6.30278 18.9765 6.13456C19.141 5.96634 19.3648 5.86921 19.6 5.86398C19.6607 5.86458 19.7202 5.847 19.7708 5.81349C19.8215 5.77998 19.8609 5.73209 19.884 5.67598C19.9013 5.63824 19.9108 5.59745 19.912 5.55598C19.9162 5.52948 19.9162 5.50249 19.912 5.47598C19.8961 5.41037 19.8587 5.35195 19.8058 5.30995C19.7529 5.26794 19.6876 5.24473 19.62 5.24398C19.3813 5.24398 19.1524 5.14916 18.9836 4.98038C18.8149 4.8116 18.72 4.58268 18.72 4.34398C18.7206 4.3032 18.713 4.26272 18.6978 4.22489C18.6825 4.18706 18.6599 4.15263 18.6313 4.1236C18.6026 4.09458 18.5685 4.07153 18.5308 4.0558C18.4932 4.04008 18.4528 4.03198 18.412 4.03198C18.3293 4.03198 18.2499 4.06485 18.1914 4.12337C18.1329 4.18188 18.1 4.26123 18.1 4.34398C18.1 4.58268 18.0052 4.8116 17.8364 4.98038C17.6677 5.14916 17.4387 5.24398 17.2 5.24398C17.1322 5.2452 17.0666 5.26851 17.0132 5.31037C16.9597 5.35224 16.9214 5.41038 16.904 5.47598C16.9018 5.5026 16.9018 5.52937 16.904 5.55598C16.9053 5.59745 16.9148 5.63824 16.932 5.67598C16.9541 5.72962 16.9911 5.77583 17.0386 5.80914C17.0861 5.84245 17.1421 5.86148 17.2 5.86398ZM18.4 5.06398C18.5273 5.26452 18.6965 5.4351 18.896 5.56398C18.6975 5.689 18.5283 5.85547 18.4 6.05198C18.2712 5.85247 18.1006 5.68326 17.9 5.55598C18.1008 5.42726 18.2713 5.2567 18.4 5.05598V5.06398Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M4.34783 13.708C4.27039 13.708 4.19611 13.6772 4.14135 13.6225C4.08659 13.5677 4.05583 13.4934 4.05583 13.416C4.05583 13.3417 4.02633 13.2705 3.97382 13.218C3.92131 13.1655 3.85009 13.136 3.77583 13.136C3.70157 13.136 3.63035 13.1655 3.57784 13.218C3.52533 13.2705 3.49583 13.3417 3.49583 13.416C3.49583 13.4934 3.46506 13.5677 3.4103 13.6225C3.35554 13.6772 3.28127 13.708 3.20383 13.708C3.12957 13.708 3.05835 13.7375 3.00584 13.79C2.95333 13.8425 2.92383 13.9137 2.92383 13.988C2.92383 14.0622 2.95333 14.1335 3.00584 14.186C3.05835 14.2385 3.12957 14.268 3.20383 14.268C3.28127 14.268 3.35554 14.2988 3.4103 14.3535C3.46506 14.4083 3.49583 14.4825 3.49583 14.56C3.49583 14.6342 3.52533 14.7055 3.57784 14.758C3.63035 14.8105 3.70157 14.84 3.77583 14.84C3.85009 14.84 3.92131 14.8105 3.97382 14.758C4.02633 14.7055 4.05583 14.6342 4.05583 14.56C4.05583 14.4825 4.08659 14.4083 4.14135 14.3535C4.19611 14.2988 4.27039 14.268 4.34783 14.268C4.42209 14.268 4.49331 14.2385 4.54582 14.186C4.59833 14.1335 4.62783 14.0622 4.62783 13.988C4.62783 13.9137 4.59833 13.8425 4.54582 13.79C4.49331 13.7375 4.42209 13.708 4.34783 13.708Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.5005 18.66C20.3764 18.66 20.2574 18.6107 20.1696 18.5229C20.0818 18.4351 20.0325 18.3161 20.0325 18.192C20.0325 18.1177 20.003 18.0465 19.9505 17.994C19.898 17.9415 19.8268 17.912 19.7525 17.912C19.6783 17.912 19.607 17.9415 19.5545 17.994C19.502 18.0465 19.4725 18.1177 19.4725 18.192C19.473 18.2533 19.4614 18.314 19.4383 18.3708C19.4153 18.4275 19.3812 18.4792 19.338 18.5227C19.2949 18.5662 19.2436 18.6007 19.187 18.6243C19.1305 18.6479 19.0698 18.66 19.0085 18.66C18.9343 18.66 18.863 18.6895 18.8105 18.742C18.758 18.7945 18.7285 18.8657 18.7285 18.94C18.7285 19.0142 18.758 19.0855 18.8105 19.138C18.863 19.1905 18.9343 19.22 19.0085 19.22C19.0698 19.22 19.1305 19.2321 19.187 19.2557C19.2436 19.2793 19.2949 19.3138 19.338 19.3573C19.3812 19.4008 19.4153 19.4524 19.4383 19.5092C19.4614 19.566 19.473 19.6267 19.4725 19.688C19.4725 19.7622 19.502 19.8335 19.5545 19.886C19.607 19.9385 19.6783 19.968 19.7525 19.968C19.8268 19.968 19.898 19.9385 19.9505 19.886C20.003 19.8335 20.0325 19.7622 20.0325 19.688C20.0325 19.5639 20.0818 19.4448 20.1696 19.3571C20.2574 19.2693 20.3764 19.22 20.5005 19.22C20.5748 19.22 20.646 19.1905 20.6985 19.138C20.751 19.0855 20.7805 19.0142 20.7805 18.94C20.7805 18.8657 20.751 18.7945 20.6985 18.742C20.646 18.6895 20.5748 18.66 20.5005 18.66Z",
      "fill": "black"
    }
  })]);
};
var GraduateCompletevue_type_template_id_7a08f6d0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/GraduateComplete.vue?vue&type=script&lang=ts&

/* harmony default export */ var GraduateCompletevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/GraduateComplete.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_GraduateCompletevue_type_script_lang_ts_ = (GraduateCompletevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/GraduateComplete.vue





/* normalize component */
;
var GraduateComplete_component = normalizeComponent(
  icons_notifications_GraduateCompletevue_type_script_lang_ts_,
  GraduateCompletevue_type_template_id_7a08f6d0_render,
  GraduateCompletevue_type_template_id_7a08f6d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var GraduateComplete = (GraduateComplete_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MapPin.vue?vue&type=template&id=723a322a&
var MapPinvue_type_template_id_723a322a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M14.14 15.132C13.6669 15.6785 13.1663 16.2006 12.64 16.696C12.4914 16.8351 12.2955 16.9123 12.092 16.912C11.8904 16.9124 11.6961 16.8367 11.548 16.7L11.148 16.3C10.844 16 10.536 15.676 10.236 15.344L10.04 15.124C8.192 15.368 6.896 15.924 6.896 16.592C6.896 17.476 9.224 18.192 12.096 18.192C14.968 18.192 17.296 17.476 17.296 16.592C17.292 15.944 16 15.38 14.14 15.132Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.7518 14.4C15.1468 13.9075 15.514 13.3934 15.8518 12.86C16.1568 12.3689 16.4242 11.8554 16.6518 11.324C16.8583 10.8594 17.0191 10.3758 17.1318 9.88C17.2214 9.48601 17.271 9.08397 17.2798 8.68C17.2888 8.23013 17.2391 7.781 17.1318 7.344C17.0227 6.89074 16.8518 6.45465 16.6238 6.048C16.2226 5.32731 15.6557 4.7124 14.9699 4.25406C14.2841 3.79571 13.4991 3.50708 12.6798 3.412C12.4818 3.39075 12.2829 3.38007 12.0838 3.38H11.8238C11.6198 3.38 11.4478 3.41201 11.2918 3.43601C10.2731 3.59593 9.32486 4.05515 8.56774 4.75528C7.81063 5.45542 7.27878 6.36486 7.0398 7.368C6.93381 7.80517 6.8854 8.2543 6.8958 8.704C6.90251 9.10812 6.95212 9.51037 7.0438 9.904C7.2494 10.7647 7.57955 11.5907 8.0238 12.356C8.30539 12.8542 8.61662 13.3351 8.9558 13.796C9.1038 14.004 9.2678 14.196 9.4358 14.424C7.5998 14.732 6.0918 15.408 6.0918 16.616C6.0918 18.388 9.3238 19.016 12.0918 19.016C14.8598 19.016 18.0918 18.388 18.0918 16.616C18.0918 15.396 16.5878 14.72 14.7518 14.4ZM8.7198 11.952C8.31445 11.254 8.01263 10.5008 7.8238 9.716C7.74531 9.37876 7.7024 9.0342 7.6958 8.688C7.6757 7.88659 7.87635 7.09507 8.2758 6.4C8.76531 5.54908 9.52371 4.88495 10.4318 4.512C10.7513 4.38377 11.084 4.29121 11.4238 4.236C11.5718 4.216 11.7198 4.2 11.8678 4.192H12.0918C12.6078 4.18989 13.12 4.28067 13.6038 4.46C14.5942 4.82824 15.4209 5.53731 15.9358 6.46C16.3167 7.13972 16.5087 7.90902 16.4918 8.688C16.4852 9.0342 16.4423 9.37876 16.3638 9.716C16.2603 10.1618 16.1157 10.597 15.9318 11.016C15.7128 11.5108 15.4588 11.9893 15.1718 12.448C14.7589 13.1021 14.3004 13.7263 13.7998 14.316C13.2669 14.9483 12.6965 15.548 12.0918 16.112C11.9638 15.992 11.8318 15.868 11.6918 15.74C11.3878 15.444 11.0958 15.136 10.8118 14.82C10.7198 14.72 10.6318 14.62 10.5438 14.516L10.4998 14.456C10.479 14.429 10.4548 14.4048 10.4278 14.384C10.1358 14.036 9.85179 13.684 9.58379 13.316C9.27189 12.8769 8.98348 12.4216 8.7198 11.952ZM12.0918 18.204C9.2198 18.204 6.8918 17.488 6.8918 16.604C6.8918 15.944 8.1878 15.38 10.0358 15.136L10.2318 15.356C10.5318 15.688 10.8398 16.012 11.1438 16.312L11.5438 16.712C11.6919 16.8487 11.8862 16.9244 12.0878 16.924C12.2913 16.9243 12.4872 16.8471 12.6358 16.708C13.1621 16.2125 13.6627 15.6905 14.1358 15.144C15.9918 15.392 17.2878 15.944 17.2878 16.616C17.2918 17.488 14.9638 18.204 12.0918 18.204Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.4517 19.5319C9.13975 20.4639 6.57575 18.5919 6.54775 18.5719C6.46387 18.5074 6.35784 18.4788 6.25288 18.4923C6.14792 18.5058 6.05258 18.5603 5.98775 18.6439C5.92492 18.7281 5.89767 18.8335 5.91189 18.9375C5.92611 19.0415 5.98065 19.1358 6.06375 19.1999C6.15175 19.2679 7.92775 20.5879 11.5717 20.5879C12.5832 20.5833 13.5923 20.4909 14.5877 20.3119C14.6403 20.303 14.6905 20.2838 14.7356 20.2555C14.7808 20.2271 14.8198 20.1902 14.8507 20.1467C14.8815 20.1033 14.9035 20.0541 14.9153 20.0022C14.9272 19.9503 14.9287 19.8965 14.9197 19.8439C14.9108 19.7914 14.8916 19.7412 14.8633 19.6961C14.8349 19.6509 14.798 19.6119 14.7545 19.581C14.711 19.5502 14.6619 19.5282 14.61 19.5164C14.558 19.5045 14.5043 19.503 14.4517 19.5119V19.5319Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.0919 11.004C12.198 11.004 12.2997 10.9618 12.3747 10.8868C12.4498 10.8118 12.4919 10.7101 12.4919 10.604C12.4919 10.4979 12.4498 10.3962 12.3747 10.3211C12.2997 10.2461 12.198 10.204 12.0919 10.204C11.7754 10.204 11.4661 10.1101 11.203 9.93433C10.9399 9.75852 10.7348 9.50864 10.6137 9.21628C10.4926 8.92391 10.4609 8.60221 10.5226 8.29184C10.5844 7.98147 10.7368 7.69637 10.9605 7.47261C11.1843 7.24885 11.4694 7.09646 11.7798 7.03472C12.0901 6.97299 12.4118 7.00467 12.7042 7.12577C12.9966 7.24687 13.2464 7.45195 13.4222 7.71507C13.5981 7.97819 13.6919 8.28753 13.6919 8.60398C13.6919 8.71007 13.734 8.81181 13.8091 8.88682C13.8841 8.96184 13.9858 9.00398 14.0919 9.00398C14.198 9.00398 14.2997 8.96184 14.3747 8.88682C14.4498 8.81181 14.4919 8.71007 14.4919 8.60398C14.4919 8.12931 14.3511 7.66529 14.0874 7.27061C13.8237 6.87593 13.4489 6.56832 13.0103 6.38667C12.5718 6.20502 12.0892 6.15749 11.6237 6.2501C11.1581 6.3427 10.7305 6.57128 10.3948 6.90692C10.0592 7.24257 9.83062 7.67021 9.73801 8.13576C9.64541 8.60132 9.69293 9.08388 9.87458 9.52242C10.0562 9.96097 10.3638 10.3358 10.7585 10.5995C11.1532 10.8632 11.6172 11.004 12.0919 11.004Z",
      "fill": "black"
    }
  })]);
};
var MapPinvue_type_template_id_723a322a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MapPin.vue?vue&type=script&lang=ts&

/* harmony default export */ var MapPinvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MapPin.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_MapPinvue_type_script_lang_ts_ = (MapPinvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MapPin.vue





/* normalize component */
;
var MapPin_component = normalizeComponent(
  icons_notifications_MapPinvue_type_script_lang_ts_,
  MapPinvue_type_template_id_723a322a_render,
  MapPinvue_type_template_id_723a322a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MapPin = (MapPin_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Medic.vue?vue&type=template&id=11fa9e76&
var Medicvue_type_template_id_11fa9e76_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M4.22803 8.85192C4.22803 8.99195 4.28366 9.12625 4.38268 9.22527C4.48169 9.32429 4.61599 9.37992 4.75603 9.37992H8.28003C8.39823 9.39079 8.5081 9.44543 8.58809 9.53312C8.66809 9.62081 8.71244 9.73522 8.71244 9.85392C8.71244 9.97261 8.66809 10.087 8.58809 10.1747C8.5081 10.2624 8.39823 10.317 8.28003 10.3279H6.84003C6.72211 10.3572 6.61737 10.425 6.54252 10.5207C6.46766 10.6164 6.42699 10.7344 6.42699 10.8559C6.42699 10.9774 6.46766 11.0954 6.54252 11.1911C6.61737 11.2868 6.72211 11.3547 6.84003 11.3839H11.528V8.39992C11.5257 8.38266 11.5257 8.36518 11.528 8.34792H4.75603C4.61976 8.34678 4.48841 8.39877 4.38984 8.49286C4.29126 8.58695 4.23322 8.71575 4.22803 8.85192Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.2442 8.328H12.4722C12.4745 8.34526 12.4745 8.36275 12.4722 8.38V11.388H17.1602C17.2781 11.3588 17.3828 11.2909 17.4577 11.1952C17.5325 11.0995 17.5732 10.9815 17.5732 10.86C17.5732 10.7385 17.5325 10.6205 17.4577 10.5248C17.3828 10.4291 17.2781 10.3613 17.1602 10.332H15.1602C15.042 10.3211 14.9321 10.2665 14.8521 10.1788C14.7721 10.0911 14.7278 9.9767 14.7278 9.858C14.7278 9.73931 14.7721 9.62489 14.8521 9.5372C14.9321 9.44951 15.042 9.39487 15.1602 9.384H19.2442C19.3171 9.39037 19.3906 9.3815 19.4599 9.35796C19.5292 9.33441 19.5929 9.29671 19.6468 9.24725C19.7008 9.19779 19.7439 9.13764 19.7734 9.07063C19.8029 9.00362 19.8181 8.93121 19.8181 8.858C19.8181 8.7848 19.8029 8.71239 19.7734 8.64538C19.7439 8.57837 19.7008 8.51822 19.6468 8.46876C19.5929 8.41929 19.5292 8.38159 19.4599 8.35805C19.3906 8.33451 19.3171 8.32564 19.2442 8.332V8.328Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.9998 6.64004C12.4928 6.64351 12.9717 6.47606 13.355 6.16617C13.7384 5.85629 14.0026 5.42314 14.1025 4.94043C14.2025 4.45772 14.1321 3.95529 13.9033 3.51864C13.6745 3.08199 13.3015 2.73812 12.8477 2.54553C12.394 2.35295 11.8875 2.32356 11.4145 2.46237C10.9415 2.60118 10.5312 2.89961 10.2534 3.30687C9.97569 3.71413 9.84766 4.20505 9.89112 4.69608C9.93458 5.18711 10.1469 5.6479 10.4918 6.00004C10.6887 6.20071 10.9232 6.36053 11.182 6.47036C11.4408 6.58018 11.7187 6.63785 11.9998 6.64004ZM11.1638 3.67205C11.3302 3.50071 11.5439 3.38292 11.7777 3.33375C12.0114 3.28458 12.2545 3.30628 12.4758 3.39605C12.6971 3.48583 12.8866 3.63961 13.02 3.83771C13.1534 4.03581 13.2247 4.26921 13.2247 4.50805C13.2247 4.74688 13.1534 4.98028 13.02 5.17838C12.8866 5.37648 12.6971 5.53026 12.4758 5.62004C12.2545 5.70981 12.0114 5.73151 11.7777 5.68234C11.5439 5.63318 11.3302 5.51538 11.1638 5.34404C11.0533 5.23468 10.9655 5.10449 10.9056 4.96099C10.8457 4.81749 10.8149 4.66354 10.8149 4.50805C10.8149 4.35255 10.8457 4.1986 10.9056 4.0551C10.9655 3.9116 11.0533 3.78141 11.1638 3.67205Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M19.2439 7.38005H4.75594C4.55591 7.36963 4.35585 7.40003 4.16795 7.46939C3.98005 7.53876 3.80823 7.64565 3.66296 7.78355C3.51768 7.92145 3.402 8.08747 3.32295 8.27151C3.24389 8.45555 3.20312 8.65375 3.20312 8.85405C3.20312 9.05435 3.24389 9.25255 3.32295 9.43659C3.402 9.62063 3.51768 9.78665 3.66296 9.92455C3.80823 10.0625 3.98005 10.1693 4.16795 10.2387C4.35585 10.3081 4.55591 10.3385 4.75594 10.3281H5.55594C5.49759 10.4994 5.46786 10.6791 5.46794 10.8601C5.45384 11.2358 5.58892 11.6019 5.8437 11.8784C6.09849 12.1549 6.4523 12.3194 6.82794 12.3361H11.5279V13.9361H9.00394C8.77455 13.9249 8.54529 13.9605 8.33006 14.0406C8.11483 14.1207 7.9181 14.2436 7.75182 14.402C7.58553 14.5604 7.45315 14.751 7.36269 14.962C7.27224 15.1731 7.2256 15.4004 7.2256 15.6301C7.2256 15.8597 7.27224 16.087 7.36269 16.2981C7.45315 16.5092 7.58553 16.6997 7.75182 16.8581C7.9181 17.0165 8.11483 17.1394 8.33006 17.2195C8.54529 17.2996 8.77455 17.3352 9.00394 17.3241H11.5279V18.84H10.5039C10.3857 18.8509 10.2759 18.9056 10.1959 18.9932C10.1159 19.0809 10.0715 19.1954 10.0715 19.3141C10.0715 19.4327 10.1159 19.5472 10.1959 19.6349C10.2759 19.7225 10.3857 19.7772 10.5039 19.7881H11.5279V21.1521C11.5388 21.2702 11.5934 21.3801 11.6811 21.4601C11.7688 21.5401 11.8832 21.5845 12.0019 21.5845C12.1206 21.5845 12.2351 21.5401 12.3227 21.4601C12.4104 21.3801 12.4651 21.2702 12.4759 21.1521V19.7881H14.9959C15.4457 19.7881 15.8771 19.6094 16.1952 19.2913C16.5133 18.9732 16.6919 18.5419 16.6919 18.0921C16.6919 17.6422 16.5133 17.2109 16.1952 16.8928C15.8771 16.5747 15.4457 16.3961 14.9959 16.3961H12.4759V14.8961H14.9959C15.4457 14.8961 15.8771 14.7174 16.1952 14.3993C16.5133 14.0812 16.6919 13.6499 16.6919 13.2001C16.6948 12.8952 16.6116 12.5957 16.4519 12.3361H17.1599C17.5356 12.3194 17.8894 12.1549 18.1442 11.8784C18.399 11.6019 18.534 11.2358 18.5199 10.8601C18.5207 10.6787 18.4895 10.4986 18.4279 10.3281H19.2279C19.428 10.3385 19.628 10.3081 19.8159 10.2387C20.0038 10.1693 20.1756 10.0625 20.3209 9.92455C20.4662 9.78665 20.5819 9.62063 20.6609 9.43659C20.74 9.25255 20.7808 9.05435 20.7808 8.85405C20.7808 8.65375 20.74 8.45555 20.6609 8.27151C20.5819 8.08747 20.4662 7.92145 20.3209 7.78355C20.1756 7.64565 20.0038 7.53876 19.8159 7.46939C19.628 7.40003 19.428 7.36963 19.2279 7.38005H19.2439ZM11.5279 16.4001H9.00394C8.81449 16.3862 8.6373 16.3012 8.50796 16.1621C8.37863 16.0229 8.30675 15.84 8.30675 15.6501C8.30675 15.4601 8.37863 15.2772 8.50796 15.1381C8.6373 14.9989 8.81449 14.9139 9.00394 14.9001H11.5279V16.4001ZM11.5279 8.40005V11.4081H6.83994C6.72202 11.3788 6.61728 11.3109 6.54243 11.2152C6.46757 11.1195 6.4269 11.0015 6.4269 10.8801C6.4269 10.7586 6.46757 10.6406 6.54243 10.5449C6.61728 10.4492 6.72202 10.3813 6.83994 10.3521H8.27994C8.39814 10.3412 8.50801 10.2865 8.588 10.1989C8.668 10.1112 8.71235 9.99675 8.71235 9.87805C8.71235 9.75935 8.668 9.64494 8.588 9.55725C8.50801 9.46956 8.39814 9.41492 8.27994 9.40405H4.75594C4.68301 9.41042 4.60955 9.40155 4.54023 9.378C4.47091 9.35446 4.40724 9.31676 4.35327 9.2673C4.2993 9.21783 4.25621 9.15769 4.22673 9.09068C4.19725 9.02367 4.18202 8.95126 4.18202 8.87805C4.18202 8.80484 4.19725 8.73244 4.22673 8.66543C4.25621 8.59842 4.2993 8.53827 4.35327 8.4888C4.40724 8.43934 4.47091 8.40164 4.54023 8.3781C4.60955 8.35456 4.68301 8.34569 4.75594 8.35205H11.5319C11.5286 8.36783 11.5273 8.38395 11.5279 8.40005ZM14.9959 17.3601C15.1854 17.3739 15.3626 17.4589 15.4919 17.5981C15.6212 17.7372 15.6931 17.9201 15.6931 18.1101C15.6931 18.3 15.6212 18.4829 15.4919 18.6221C15.3626 18.7612 15.1854 18.8462 14.9959 18.8601H12.4759V17.34L14.9959 17.3601ZM14.9959 13.9721H12.4759V12.4521H14.9959C15.1854 12.4659 15.3626 12.5509 15.4919 12.6901C15.6212 12.8292 15.6931 13.0121 15.6931 13.2021C15.6931 13.392 15.6212 13.5749 15.4919 13.7141C15.3626 13.8532 15.1854 13.9382 14.9959 13.9521V13.9721ZM19.2439 9.38005H15.1519C15.0337 9.39092 14.9239 9.44556 14.8439 9.53325C14.7639 9.62094 14.7195 9.73535 14.7195 9.85405C14.7195 9.97275 14.7639 10.0872 14.8439 10.1749C14.9239 10.2625 15.0337 10.3172 15.1519 10.3281H17.1519C17.2699 10.3573 17.3746 10.4252 17.4494 10.5209C17.5243 10.6166 17.565 10.7346 17.565 10.8561C17.565 10.9775 17.5243 11.0955 17.4494 11.1912C17.3746 11.2869 17.2699 11.3548 17.1519 11.3841H12.4759V8.40005C12.4782 8.3828 12.4782 8.36531 12.4759 8.34805H19.2439C19.3169 8.34169 19.3903 8.35056 19.4596 8.3741C19.529 8.39764 19.5926 8.43534 19.6466 8.4848C19.7006 8.53427 19.7437 8.59442 19.7731 8.66143C19.8026 8.72844 19.8179 8.80084 19.8179 8.87405C19.8179 8.94726 19.8026 9.01967 19.7731 9.08668C19.7437 9.15369 19.7006 9.21383 19.6466 9.2633C19.5926 9.31276 19.529 9.35046 19.4596 9.374C19.3903 9.39755 19.3169 9.40642 19.2439 9.40005V9.38005Z",
      "fill": "black"
    }
  })]);
};
var Medicvue_type_template_id_11fa9e76_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/Medic.vue?vue&type=script&lang=ts&

/* harmony default export */ var Medicvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Medic.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_Medicvue_type_script_lang_ts_ = (Medicvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/Medic.vue





/* normalize component */
;
var Medic_component = normalizeComponent(
  icons_notifications_Medicvue_type_script_lang_ts_,
  Medicvue_type_template_id_11fa9e76_render,
  Medicvue_type_template_id_11fa9e76_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Medic = (Medic_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MessageCall.vue?vue&type=template&id=60bdbb3b&
var MessageCallvue_type_template_id_60bdbb3b_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M18.7604 4.72803H13.5604C13.5073 4.72803 13.4564 4.7491 13.4189 4.78661C13.3814 4.82411 13.3604 4.87498 13.3604 4.92803V9.52803L14.9004 8.47603L14.9684 8.44403C15.0003 8.44126 15.0324 8.44126 15.0644 8.44403H18.7604C18.8131 8.44301 18.8634 8.42161 18.9006 8.38432C18.9379 8.34703 18.9593 8.29675 18.9604 8.24403V4.92803C18.9604 4.87498 18.9393 4.82411 18.9018 4.78661C18.8643 4.7491 18.8134 4.72803 18.7604 4.72803Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M18.7601 3.92798H13.5601C13.2948 3.92798 13.0405 4.03334 12.853 4.22087C12.6654 4.40841 12.5601 4.66276 12.5601 4.92798V9.52798C12.5597 9.67338 12.599 9.81613 12.6737 9.94087C12.7484 10.0656 12.8557 10.1676 12.9841 10.236C13.1004 10.2959 13.2292 10.3275 13.3601 10.328C13.52 10.3272 13.6761 10.2784 13.8081 10.188L15.2201 9.23198H18.7601C19.025 9.23093 19.2787 9.12523 19.466 8.93792C19.6533 8.75061 19.759 8.49687 19.7601 8.23198V4.92798C19.7601 4.66276 19.6547 4.40841 19.4672 4.22087C19.2796 4.03334 19.0253 3.92798 18.7601 3.92798ZM18.9601 8.23198C18.959 8.2847 18.9376 8.33498 18.9004 8.37227C18.8631 8.40956 18.8128 8.43096 18.7601 8.43198H15.0641C15.0321 8.42921 15 8.42921 14.9681 8.43198L14.9001 8.46398L13.3601 9.52798V4.92798C13.3601 4.87494 13.3811 4.82406 13.4186 4.78656C13.4561 4.74905 13.507 4.72798 13.5601 4.72798H18.7601C18.8131 4.72798 18.864 4.74905 18.9015 4.78656C18.939 4.82406 18.9601 4.87494 18.9601 4.92798V8.23198Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.8883 18.548C13.7829 18.5465 14.6648 18.3376 15.465 17.9379C16.2652 17.5381 16.9619 16.9583 17.5003 16.244L17.7243 15.948C17.7935 15.8474 17.8305 15.7281 17.8305 15.606C17.8305 15.4839 17.7935 15.3647 17.7243 15.264C16.882 13.9999 15.5983 13.0956 14.1243 12.728L13.8283 12.656C13.7827 12.6435 13.7357 12.6368 13.6883 12.636C13.6105 12.6356 13.5333 12.6507 13.4612 12.6802C13.3891 12.7097 13.3236 12.7531 13.2683 12.808L12.4683 13.608C12.394 13.683 12.3055 13.7425 12.208 13.7831C12.1105 13.8237 12.006 13.8447 11.9003 13.8447C11.7947 13.8447 11.6902 13.8237 11.5927 13.7831C11.4952 13.7425 11.4067 13.683 11.3323 13.608L9.20035 11.432C9.12536 11.3576 9.06585 11.2692 9.02523 11.1717C8.98462 11.0742 8.96371 10.9696 8.96371 10.864C8.96371 10.7584 8.98462 10.6538 9.02523 10.5564C9.06585 10.4589 9.12536 10.3704 9.20035 10.296L10.0003 9.49601C10.0733 9.42296 10.1261 9.3322 10.1534 9.23263C10.1808 9.13306 10.1818 9.02809 10.1563 8.92801L10.0843 8.63201C9.71326 7.15862 8.80804 5.87563 7.54435 5.03201C7.44831 4.96801 7.33575 4.93327 7.22035 4.93201C7.09165 4.93141 6.96641 4.97363 6.86435 5.05201L6.56835 5.27601C5.90004 5.76956 5.34632 6.40174 4.94512 7.12925C4.54393 7.85676 4.30475 8.6624 4.24396 9.49097C4.18318 10.3195 4.30223 11.1515 4.59296 11.9297C4.88368 12.708 5.33922 13.4142 5.92835 14L8.80035 16.86C9.33289 17.3956 9.96615 17.8205 10.6636 18.1102C11.3611 18.3999 12.1091 18.5487 12.8643 18.548H12.8883ZM9.37635 16.296L6.49235 13.412C5.56485 12.4798 5.04301 11.219 5.04035 9.90401C5.05014 8.8168 5.41069 7.76181 6.06835 6.89601C6.69044 7.42418 7.20047 8.07157 7.56835 8.80001C7.59897 8.87231 7.65019 8.934 7.71563 8.97739C7.78107 9.02078 7.85783 9.04395 7.93635 9.04401C7.98987 9.04302 8.04275 9.03217 8.09235 9.01201C8.14114 8.99152 8.18537 8.96154 8.22249 8.92382C8.25961 8.8861 8.28888 8.84139 8.3086 8.79228C8.32832 8.74317 8.3381 8.69064 8.33737 8.63772C8.33664 8.58481 8.32541 8.53256 8.30435 8.48401C7.88937 7.6452 7.30828 6.89944 6.59635 6.29201C6.73392 6.162 6.87811 6.03917 7.02835 5.92401L7.20435 5.79201C8.23984 6.52564 8.97897 7.60526 9.28835 8.83601L9.33235 9.02001L8.62435 9.72801C8.47558 9.87661 8.35757 10.0531 8.27705 10.2473C8.19653 10.4415 8.15509 10.6497 8.15509 10.86C8.15509 11.0703 8.19653 11.2785 8.27705 11.4727C8.35757 11.667 8.47558 11.8434 8.62435 11.992L10.8003 14.168C10.949 14.3174 11.1257 14.4359 11.3203 14.5168C11.5149 14.5976 11.7236 14.6393 11.9343 14.6393C12.1451 14.6393 12.3538 14.5976 12.5484 14.5168C12.743 14.4359 12.9197 14.3174 13.0683 14.168L13.7723 13.464L13.9523 13.508C15.1843 13.817 16.2636 14.5597 16.9923 15.6L16.8643 15.776C16.3969 16.3952 15.7926 16.8979 15.0987 17.2448C14.4048 17.5917 13.6401 17.7736 12.8643 17.776C11.5519 17.7624 10.2981 17.2304 9.37635 16.296Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M17.3878 17.5679C15.1718 19.7479 12.7358 19.2279 12.6318 19.1999C12.5793 19.1879 12.5249 19.1862 12.4718 19.1952C12.4186 19.2041 12.3677 19.2234 12.322 19.252C12.2764 19.2806 12.2368 19.318 12.2055 19.3619C12.1742 19.4058 12.1519 19.4554 12.1398 19.5079C12.1278 19.5605 12.1261 19.6149 12.1351 19.668C12.144 19.7212 12.1633 19.772 12.1919 19.8177C12.2205 19.8634 12.2579 19.903 12.3018 19.9343C12.3457 19.9655 12.3953 19.9879 12.4478 19.9999C12.766 20.067 13.0907 20.0979 13.4158 20.0919C14.2621 20.0858 15.0987 19.9119 15.8773 19.5803C16.6559 19.2486 17.361 18.7659 17.9518 18.1599C18.0277 18.0851 18.0707 17.9833 18.0715 17.8768C18.0722 17.7702 18.0306 17.6678 17.9558 17.5919C17.881 17.5161 17.7792 17.4731 17.6727 17.4723C17.5661 17.4715 17.4637 17.5131 17.3878 17.5879V17.5679Z",
      "fill": "black"
    }
  })]);
};
var MessageCallvue_type_template_id_60bdbb3b_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MessageCall.vue?vue&type=script&lang=ts&

/* harmony default export */ var MessageCallvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MessageCall.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_MessageCallvue_type_script_lang_ts_ = (MessageCallvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MessageCall.vue





/* normalize component */
;
var MessageCall_component = normalizeComponent(
  icons_notifications_MessageCallvue_type_script_lang_ts_,
  MessageCallvue_type_template_id_60bdbb3b_render,
  MessageCallvue_type_template_id_60bdbb3b_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MessageCall = (MessageCall_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MobilePhone.vue?vue&type=template&id=70ef1f0a&
var MobilePhonevue_type_template_id_70ef1f0a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M13.7716 8.09998H10.0916C10.0033 8.09998 9.93164 8.17161 9.93164 8.25998V15.14C9.93164 15.2283 10.0033 15.3 10.0916 15.3H13.7716C13.86 15.3 13.9316 15.2283 13.9316 15.14V8.25998C13.9316 8.17161 13.86 8.09998 13.7716 8.09998Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.3317 5.69995H8.53174C8.26652 5.69995 8.01217 5.80531 7.82463 5.99284C7.6371 6.18038 7.53174 6.43473 7.53174 6.69995V18.3C7.53174 18.5652 7.6371 18.8195 7.82463 19.0071C8.01217 19.1946 8.26652 19.3 8.53174 19.3H15.3317C15.597 19.3 15.8513 19.1946 16.0388 19.0071C16.2264 18.8195 16.3317 18.5652 16.3317 18.3V6.69995C16.3317 6.43473 16.2264 6.18038 16.0388 5.99284C15.8513 5.80531 15.597 5.69995 15.3317 5.69995ZM15.5317 18.3C15.5317 18.353 15.5107 18.4039 15.4732 18.4414C15.4356 18.4789 15.3848 18.5 15.3317 18.5H8.53174C8.47869 18.5 8.42782 18.4789 8.39032 18.4414C8.35281 18.4039 8.33174 18.353 8.33174 18.3V6.69995C8.33174 6.64691 8.35281 6.59604 8.39032 6.55853C8.42782 6.52102 8.47869 6.49995 8.53174 6.49995H15.3317C15.3848 6.49995 15.4356 6.52102 15.4732 6.55853C15.5107 6.59604 15.5317 6.64691 15.5317 6.69995V18.3Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M13.7718 7.30005H10.0918C9.83755 7.3011 9.59398 7.40258 9.41418 7.58239C9.23437 7.7622 9.13289 8.00577 9.13184 8.26005V15.14C9.13289 15.3943 9.23437 15.6379 9.41418 15.8177C9.59398 15.9975 9.83755 16.099 10.0918 16.1001H13.7718C14.0264 16.1001 14.2706 15.9989 14.4507 15.8189C14.6307 15.6388 14.7318 15.3947 14.7318 15.14V8.26005C14.7318 8.00544 14.6307 7.76126 14.4507 7.58123C14.2706 7.40119 14.0264 7.30005 13.7718 7.30005ZM13.9318 15.14C13.9318 15.1825 13.915 15.2232 13.885 15.2532C13.855 15.2832 13.8143 15.3001 13.7718 15.3001H10.0918C10.0494 15.3001 10.0087 15.2832 9.9787 15.2532C9.94869 15.2232 9.93184 15.1825 9.93184 15.14V8.26005C9.93184 8.21761 9.94869 8.17692 9.9787 8.14691C10.0087 8.11691 10.0494 8.10005 10.0918 8.10005H13.7718C13.8143 8.10005 13.855 8.11691 13.885 8.14691C13.915 8.17692 13.9318 8.21761 13.9318 8.26005V15.14Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.3318 16.944H11.5318C11.4257 16.944 11.324 16.9861 11.249 17.0611C11.174 17.1361 11.1318 17.2379 11.1318 17.344C11.1318 17.4501 11.174 17.5518 11.249 17.6268C11.324 17.7018 11.4257 17.744 11.5318 17.744H12.3318C12.4379 17.744 12.5397 17.7018 12.6147 17.6268C12.6897 17.5518 12.7318 17.4501 12.7318 17.344C12.7318 17.2379 12.6897 17.1361 12.6147 17.0611C12.5397 16.9861 12.4379 16.944 12.3318 16.944Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M15.652 3.90002C15.5459 3.90002 15.4441 3.94217 15.3691 4.01718C15.2941 4.0922 15.252 4.19394 15.252 4.30002C15.252 4.40611 15.2941 4.50785 15.3691 4.58287C15.4441 4.65788 15.5459 4.70002 15.652 4.70002C15.696 4.70002 17.036 4.70002 17.276 6.58002C17.2886 6.67686 17.3363 6.76571 17.41 6.82982C17.4837 6.89392 17.5783 6.92885 17.676 6.92802H17.728C17.8329 6.91408 17.9281 6.8591 17.9925 6.77512C18.057 6.69114 18.0856 6.58502 18.072 6.48002C17.8 4.43602 16.4 3.90002 15.652 3.90002Z",
      "fill": "black"
    }
  })]);
};
var MobilePhonevue_type_template_id_70ef1f0a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/MobilePhone.vue?vue&type=script&lang=ts&

/* harmony default export */ var MobilePhonevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MobilePhone.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_MobilePhonevue_type_script_lang_ts_ = (MobilePhonevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/MobilePhone.vue





/* normalize component */
;
var MobilePhone_component = normalizeComponent(
  icons_notifications_MobilePhonevue_type_script_lang_ts_,
  MobilePhonevue_type_template_id_70ef1f0a_render,
  MobilePhonevue_type_template_id_70ef1f0a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MobilePhone = (MobilePhone_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/NotebookMessage.vue?vue&type=template&id=64f6e554&
var NotebookMessagevue_type_template_id_64f6e554_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('g', [_c('path', {
    attrs: {
      "d": "M5.2002 8.47192V18.0719H18.8002V8.47192H5.2002ZM15.1162 15.1999C15.1174 15.216 15.1151 15.2321 15.1095 15.2472C15.1039 15.2623 15.0951 15.276 15.0837 15.2874C15.0723 15.2988 15.0586 15.3076 15.0435 15.3132C15.0284 15.3188 15.0123 15.3211 14.9962 15.3199H11.8762C11.7997 15.3211 11.7255 15.3462 11.6642 15.3919L10.3202 16.3999V15.6799C10.3202 15.5851 10.2828 15.4942 10.2162 15.4268C10.1495 15.3594 10.059 15.321 9.9642 15.3199H9.0042C8.98813 15.3211 8.972 15.3188 8.9569 15.3132C8.9418 15.3076 8.92808 15.2988 8.91669 15.2874C8.9053 15.276 8.8965 15.2623 8.89089 15.2472C8.88529 15.2321 8.883 15.216 8.8842 15.1999V10.8719C8.883 10.8559 8.88529 10.8397 8.89089 10.8246C8.8965 10.8095 8.9053 10.7958 8.91669 10.7844C8.92808 10.773 8.9418 10.7642 8.9569 10.7586C8.972 10.753 8.98813 10.7507 9.0042 10.7519H15.0042C15.0203 10.7507 15.0364 10.753 15.0515 10.7586C15.0666 10.7642 15.0803 10.773 15.0917 10.7844C15.1031 10.7958 15.1119 10.8095 15.1175 10.8246C15.1231 10.8397 15.1254 10.8559 15.1242 10.8719L15.1162 15.1999Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.3998 18.072H19.5998V8.472C19.5998 8.25982 19.5155 8.05634 19.3655 7.90631C19.2155 7.75628 19.012 7.672 18.7998 7.672H5.1998C4.98763 7.672 4.78415 7.75628 4.63412 7.90631C4.48409 8.05634 4.3998 8.25982 4.3998 8.472V18.072H3.5998C3.38763 18.072 3.18415 18.1563 3.03412 18.3063C2.88409 18.4563 2.7998 18.6598 2.7998 18.872V19.76C2.7998 19.9722 2.88409 20.1757 3.03412 20.3257C3.18415 20.4757 3.38763 20.56 3.5998 20.56H20.3998C20.612 20.56 20.8155 20.4757 20.9655 20.3257C21.1155 20.1757 21.1998 19.9722 21.1998 19.76V18.872C21.1998 18.6598 21.1155 18.4563 20.9655 18.3063C20.8155 18.1563 20.612 18.072 20.3998 18.072ZM5.1998 8.472H18.7998V18.072H5.1998V8.472ZM20.3998 19.76H3.5998V18.872H20.3998V19.76Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.9998 5.04798C11.4704 5.04884 10.9465 5.15544 10.4588 5.3615C9.97109 5.56756 9.52947 5.86895 9.15982 6.24798C9.12233 6.28517 9.09257 6.32941 9.07227 6.37815C9.05196 6.42689 9.0415 6.47918 9.0415 6.53198C9.0415 6.58479 9.05196 6.63707 9.07227 6.68581C9.09257 6.73456 9.12233 6.7788 9.15982 6.81598C9.1972 6.85305 9.24153 6.88238 9.29026 6.90229C9.339 6.9222 9.39118 6.93229 9.44382 6.93198C9.49675 6.93176 9.5491 6.92104 9.59785 6.90044C9.6466 6.87984 9.69078 6.84978 9.72782 6.81198C10.0239 6.5089 10.3771 6.26761 10.7671 6.10213C11.1572 5.93665 11.5762 5.85026 11.9998 5.84798C12.4253 5.84657 12.8469 5.93004 13.2397 6.09351C13.6326 6.25697 13.9889 6.49715 14.2878 6.79998C14.3628 6.87448 14.4641 6.9163 14.5698 6.9163C14.6755 6.9163 14.7769 6.87448 14.8518 6.79998C14.8893 6.7628 14.9191 6.71856 14.9394 6.66981C14.9597 6.62107 14.9701 6.56879 14.9701 6.51598C14.9701 6.46318 14.9597 6.41089 14.9394 6.36215C14.9191 6.31341 14.8893 6.26917 14.8518 6.23198C14.4799 5.85259 14.0362 5.55108 13.5466 5.34505C13.0569 5.13902 12.5311 5.03259 11.9998 5.03198V5.04798Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M8.86397 5.53603C9.69686 4.70652 10.8245 4.24078 12 4.24078C13.1755 4.24078 14.3031 4.70652 15.136 5.53603C15.2109 5.61053 15.3123 5.65235 15.418 5.65235C15.5236 5.65235 15.625 5.61053 15.7 5.53603C15.7745 5.46109 15.8163 5.35971 15.8163 5.25403C15.8163 5.14836 15.7745 5.04698 15.7 4.97203C14.7177 3.99254 13.3871 3.4425 12 3.4425C10.6128 3.4425 9.28223 3.99254 8.29997 4.97203C8.2581 5.00789 8.22409 5.05202 8.20008 5.10164C8.17607 5.15127 8.16258 5.20532 8.16045 5.26041C8.15833 5.3155 8.16761 5.37043 8.18772 5.42176C8.20783 5.47309 8.23833 5.51971 8.27731 5.55869C8.3163 5.59767 8.36291 5.62818 8.41424 5.64829C8.46557 5.6684 8.52051 5.67768 8.57559 5.67555C8.63068 5.67342 8.68474 5.65993 8.73436 5.63592C8.78399 5.61191 8.82811 5.5779 8.86397 5.53603Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M14.9957 9.95206H8.99572C8.87461 9.95099 8.75449 9.97406 8.64239 10.0199C8.53029 10.0658 8.42845 10.1335 8.3428 10.2191C8.25716 10.3048 8.18943 10.4066 8.14358 10.5187C8.09772 10.6308 8.07465 10.7509 8.07572 10.8721V15.2001C8.07465 15.3212 8.09772 15.4413 8.14358 15.5534C8.18943 15.6655 8.25716 15.7673 8.3428 15.853C8.42845 15.9386 8.53029 16.0064 8.64239 16.0522C8.75449 16.0981 8.87461 16.1211 8.99572 16.1201H9.51972V16.4001C9.51972 16.6122 9.604 16.8157 9.75403 16.9658C9.90406 17.1158 10.1075 17.2001 10.3197 17.2001C10.4939 17.1992 10.6634 17.1432 10.8037 17.0401L12.0037 16.1201H14.9757C15.0968 16.1211 15.2169 16.0981 15.329 16.0522C15.4411 16.0064 15.543 15.9386 15.6286 15.853C15.7143 15.7673 15.782 15.6655 15.8279 15.5534C15.8737 15.4413 15.8968 15.3212 15.8957 15.2001V10.8721C15.8979 10.6309 15.8044 10.3986 15.6357 10.2262C15.467 10.0538 15.2369 9.95523 14.9957 9.95206ZM15.1157 15.2001C15.1169 15.2161 15.1146 15.2323 15.109 15.2474C15.1034 15.2625 15.0946 15.2762 15.0832 15.2876C15.0718 15.299 15.0581 15.3078 15.043 15.3134C15.0279 15.319 15.0118 15.3213 14.9957 15.3201H11.8757C11.7992 15.3212 11.7251 15.3464 11.6637 15.3921L10.3197 16.4001V15.6801C10.3197 15.5853 10.2823 15.4943 10.2157 15.4269C10.149 15.3595 10.0585 15.3211 9.96372 15.3201H9.00372C8.98765 15.3213 8.97152 15.319 8.95642 15.3134C8.94132 15.3078 8.92761 15.299 8.91621 15.2876C8.90482 15.2762 8.89602 15.2625 8.89042 15.2474C8.88481 15.2323 8.88252 15.2161 8.88372 15.2001V10.8721C8.88252 10.856 8.88481 10.8399 8.89042 10.8248C8.89602 10.8097 8.90482 10.7959 8.91621 10.7846C8.92761 10.7732 8.94132 10.7644 8.95642 10.7588C8.97152 10.7532 8.98765 10.7509 9.00372 10.7521H15.0037C15.0198 10.7509 15.0359 10.7532 15.051 10.7588C15.0661 10.7644 15.0798 10.7732 15.0912 10.7846C15.1026 10.7959 15.1114 10.8097 15.117 10.8248C15.1226 10.8399 15.1249 10.856 15.1237 10.8721L15.1157 15.2001Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M12.8715 12.068H10.2955C10.1894 12.068 10.0877 12.1101 10.0127 12.1852C9.93765 12.2602 9.89551 12.3619 9.89551 12.468C9.89551 12.5741 9.93765 12.6758 10.0127 12.7508C10.0877 12.8259 10.1894 12.868 10.2955 12.868H12.8715C12.9776 12.868 13.0793 12.8259 13.1544 12.7508C13.2294 12.6758 13.2715 12.5741 13.2715 12.468C13.2715 12.3619 13.2294 12.2602 13.1544 12.1852C13.0793 12.1101 12.9776 12.068 12.8715 12.068Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M11.5995 13.2H10.2955C10.1894 13.2 10.0877 13.2421 10.0127 13.3171C9.93765 13.3921 9.89551 13.4939 9.89551 13.6C9.89551 13.706 9.93765 13.8078 10.0127 13.8828C10.0877 13.9578 10.1894 14 10.2955 14H11.5995C11.7056 14 11.8073 13.9578 11.8824 13.8828C11.9574 13.8078 11.9995 13.706 11.9995 13.6C11.9995 13.4939 11.9574 13.3921 11.8824 13.3171C11.8073 13.2421 11.7056 13.2 11.5995 13.2Z",
      "fill": "black"
    }
  })]);
};
var NotebookMessagevue_type_template_id_64f6e554_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/icons-notifications/NotebookMessage.vue?vue&type=script&lang=ts&

/* harmony default export */ var NotebookMessagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/NotebookMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var icons_notifications_NotebookMessagevue_type_script_lang_ts_ = (NotebookMessagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/icons-notifications/NotebookMessage.vue





/* normalize component */
;
var NotebookMessage_component = normalizeComponent(
  icons_notifications_NotebookMessagevue_type_script_lang_ts_,
  NotebookMessagevue_type_template_id_64f6e554_render,
  NotebookMessagevue_type_template_id_64f6e554_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var NotebookMessage = (NotebookMessage_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledOne.vue?vue&type=template&id=8e77c750&
var CircledOnevue_type_template_id_8e77c750_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.23 6.9H13.182V16H11.782V9.21C11.418 9.476 10.844 9.672 10.046 9.672V8.328C11.236 8.328 11.95 7.768 12.23 6.9Z"
    }
  });
};
var CircledOnevue_type_template_id_8e77c750_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledOne.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledOnevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledOne.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledOnevue_type_script_lang_ts_ = (CircledOnevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledOne.vue





/* normalize component */
;
var CircledOne_component = normalizeComponent(
  circled_numbers_CircledOnevue_type_script_lang_ts_,
  CircledOnevue_type_template_id_8e77c750_render,
  CircledOnevue_type_template_id_8e77c750_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledOne = (CircledOne_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledTwo.vue?vue&type=template&id=6178ff76&
var CircledTwovue_type_template_id_6178ff76_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.0645 6.76C13.5765 6.774 14.7525 7.824 14.7525 9.196C14.7525 10.33 14.2205 11.1 13.1705 12.332L11.1825 14.684H14.9345V16H9.23648V14.852L11.8405 11.814C11.9202 11.7217 11.9962 11.6339 12.0686 11.5503C13.0391 10.4296 13.3665 10.0516 13.3665 9.322C13.3665 8.538 12.7365 8.104 12.0645 8.104C11.3785 8.104 10.7485 8.426 10.0345 9.476L8.99848 8.748C9.71248 7.572 10.6505 6.774 12.0645 6.76Z"
    }
  });
};
var CircledTwovue_type_template_id_6178ff76_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledTwo.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledTwovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledTwo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledTwovue_type_script_lang_ts_ = (CircledTwovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledTwo.vue





/* normalize component */
;
var CircledTwo_component = normalizeComponent(
  circled_numbers_CircledTwovue_type_script_lang_ts_,
  CircledTwovue_type_template_id_6178ff76_render,
  CircledTwovue_type_template_id_6178ff76_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledTwo = (CircledTwo_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledThree.vue?vue&type=template&id=c9455250&
var CircledThreevue_type_template_id_c9455250_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM14.7801 13.438C14.7801 14.88 13.6601 16.14 11.9241 16.14C10.7341 16.14 9.92215 15.664 9.08215 14.712L9.97815 13.788C10.6921 14.502 11.1681 14.768 11.9101 14.768C12.8901 14.768 13.3661 14.152 13.3661 13.312C13.3661 12.248 12.4981 11.94 11.5041 11.94C11.2801 11.94 11.0001 11.954 10.8321 11.968V10.736C11.1541 10.75 11.1961 10.75 11.4061 10.75C12.5261 10.75 13.1981 10.26 13.1981 9.336C13.1981 8.664 12.6101 8.132 11.7841 8.132C11.0421 8.132 10.5521 8.412 10.0061 9.07L9.13815 8.216C10.0481 7.152 10.7901 6.76 11.8121 6.76C13.4501 6.76 14.5141 7.74 14.5141 9.21C14.5141 10.12 14.0941 10.848 13.4361 11.282C14.2481 11.674 14.7801 12.388 14.7801 13.438Z"
    }
  });
};
var CircledThreevue_type_template_id_c9455250_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledThree.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledThreevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledThree.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledThreevue_type_script_lang_ts_ = (CircledThreevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledThree.vue





/* normalize component */
;
var CircledThree_component = normalizeComponent(
  circled_numbers_CircledThreevue_type_script_lang_ts_,
  CircledThreevue_type_template_id_c9455250_render,
  CircledThreevue_type_template_id_c9455250_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledThree = (CircledThree_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledFour.vue?vue&type=template&id=eba17990&
var CircledFourvue_type_template_id_eba17990_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.7457 13.774H8.68566V12.906L10.7017 6.9H12.1297L10.3237 12.43H12.5357L13.1517 10.134H14.1737V12.43H15.5177V13.774H14.1737V16H12.7457V13.774Z"
    }
  });
};
var CircledFourvue_type_template_id_eba17990_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledFour.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledFourvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledFour.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledFourvue_type_script_lang_ts_ = (CircledFourvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledFour.vue





/* normalize component */
;
var CircledFour_component = normalizeComponent(
  circled_numbers_CircledFourvue_type_script_lang_ts_,
  CircledFourvue_type_template_id_eba17990_render,
  CircledFourvue_type_template_id_eba17990_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledFour = (CircledFour_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledFive.vue?vue&type=template&id=1817ce1f&
var CircledFivevue_type_template_id_1817ce1f_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.0052 11.674C11.3472 11.674 10.7032 12.038 10.2832 12.57L9.30325 12.304V6.9H14.5813V8.244H10.6333V10.736C11.0533 10.442 11.5992 10.246 12.1733 10.246C13.6993 10.246 15.0853 11.366 15.0853 13.172C15.0853 14.88 13.6993 16.196 12.1033 16.196C10.6753 16.196 9.86325 15.594 9.26125 14.642L10.2832 13.844C10.7452 14.53 11.2913 14.838 11.9073 14.838C12.9713 14.838 13.6573 14.18 13.6573 13.172C13.6573 12.262 12.9853 11.674 12.0052 11.674Z"
    }
  });
};
var CircledFivevue_type_template_id_1817ce1f_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledFive.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledFivevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledFive.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledFivevue_type_script_lang_ts_ = (CircledFivevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledFive.vue





/* normalize component */
;
var CircledFive_component = normalizeComponent(
  circled_numbers_CircledFivevue_type_script_lang_ts_,
  CircledFivevue_type_template_id_1817ce1f_render,
  CircledFivevue_type_template_id_1817ce1f_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledFive = (CircledFive_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledSix.vue?vue&type=template&id=46e18f1a&
var CircledSixvue_type_template_id_46e18f1a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM12.2524 16.14C10.1664 16.14 8.82238 14.586 8.82238 11.576C8.82238 8.902 10.3344 6.76 12.5744 6.76C13.7504 6.76 14.3804 6.956 15.2764 7.67L14.5204 8.72C13.8484 8.244 13.3024 8.076 12.5884 8.076C11.3844 8.076 10.4884 9 10.2084 11.072C10.8104 10.526 11.6784 10.204 12.5464 10.204C13.9604 10.204 15.3884 11.492 15.3884 13.046C15.3884 14.866 14.0864 16.14 12.2524 16.14ZM12.1544 11.548C11.0624 11.548 10.3344 12.22 10.3344 13.2C10.3344 14.166 11.0624 14.824 12.1544 14.824C13.2184 14.824 13.9324 14.166 13.9324 13.2C13.9324 12.22 13.2184 11.548 12.1544 11.548Z"
    }
  });
};
var CircledSixvue_type_template_id_46e18f1a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledSix.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledSixvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledSix.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledSixvue_type_script_lang_ts_ = (CircledSixvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledSix.vue





/* normalize component */
;
var CircledSix_component = normalizeComponent(
  circled_numbers_CircledSixvue_type_script_lang_ts_,
  CircledSixvue_type_template_id_46e18f1a_render,
  CircledSixvue_type_template_id_46e18f1a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledSix = (CircledSix_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledSeven.vue?vue&type=template&id=7ef19430&
var CircledSevenvue_type_template_id_7ef19430_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.2202 16H9.77821L13.6002 8.244H9.03621V6.9H15.1682V8.09L11.2202 16Z"
    }
  });
};
var CircledSevenvue_type_template_id_7ef19430_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledSeven.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledSevenvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledSeven.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledSevenvue_type_script_lang_ts_ = (CircledSevenvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledSeven.vue





/* normalize component */
;
var CircledSeven_component = normalizeComponent(
  circled_numbers_CircledSevenvue_type_script_lang_ts_,
  CircledSevenvue_type_template_id_7ef19430_render,
  CircledSevenvue_type_template_id_7ef19430_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledSeven = (CircledSeven_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledEight.vue?vue&type=template&id=a0797760&
var CircledEightvue_type_template_id_a0797760_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM13.583 11.296C14.493 11.702 15.067 12.43 15.067 13.48C15.067 14.922 13.989 16.14 12.001 16.14C10.013 16.14 8.93504 14.922 8.93504 13.48C8.93504 12.43 9.52304 11.716 10.405 11.31C9.69104 10.876 9.24304 10.204 9.24304 9.35C9.24304 7.796 10.181 6.76 12.029 6.76C13.821 6.76 14.759 7.796 14.759 9.35C14.759 10.204 14.311 10.876 13.583 11.296ZM12.001 10.54C12.813 10.54 13.429 10.022 13.429 9.336C13.429 8.65 12.813 8.132 12.001 8.132C11.189 8.132 10.573 8.65 10.573 9.336C10.573 10.022 11.189 10.54 12.001 10.54ZM12.001 11.856C11.007 11.856 10.349 12.444 10.349 13.34C10.349 14.208 11.007 14.768 12.001 14.768C12.995 14.768 13.653 14.208 13.653 13.34C13.653 12.444 12.995 11.856 12.001 11.856Z"
    }
  });
};
var CircledEightvue_type_template_id_a0797760_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledEight.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledEightvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledEight.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledEightvue_type_script_lang_ts_ = (CircledEightvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledEight.vue





/* normalize component */
;
var CircledEight_component = normalizeComponent(
  circled_numbers_CircledEightvue_type_script_lang_ts_,
  CircledEightvue_type_template_id_a0797760_render,
  CircledEightvue_type_template_id_a0797760_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledEight = (CircledEight_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledNine.vue?vue&type=template&id=18bf56e0&
var CircledNinevue_type_template_id_18bf56e0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM11.7484 6.76C13.8344 6.76 15.1784 8.314 15.1784 11.324C15.1784 13.998 13.6664 16.14 11.4264 16.14C10.2504 16.14 9.62038 15.944 8.72438 15.23L9.48038 14.18C10.1524 14.656 10.6984 14.824 11.4124 14.824C12.6164 14.824 13.5124 13.9 13.7924 11.828C13.1904 12.374 12.3224 12.696 11.4544 12.696C10.0404 12.696 8.61238 11.408 8.61238 9.854C8.61238 8.034 9.91438 6.76 11.7484 6.76ZM11.8464 11.352C12.9384 11.352 13.6664 10.68 13.6664 9.7C13.6664 8.734 12.9384 8.076 11.8464 8.076C10.7824 8.076 10.0684 8.734 10.0684 9.7C10.0684 10.68 10.7824 11.352 11.8464 11.352Z"
    }
  });
};
var CircledNinevue_type_template_id_18bf56e0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledNine.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledNinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledNine.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledNinevue_type_script_lang_ts_ = (CircledNinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledNine.vue





/* normalize component */
;
var CircledNine_component = normalizeComponent(
  circled_numbers_CircledNinevue_type_script_lang_ts_,
  CircledNinevue_type_template_id_18bf56e0_render,
  CircledNinevue_type_template_id_18bf56e0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledNine = (CircledNine_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledZero.vue?vue&type=template&id=81007126&
var CircledZerovue_type_template_id_81007126_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M20.5 12C20.5 16.6944 16.6944 20.5 12 20.5C7.30558 20.5 3.5 16.6944 3.5 12C3.5 7.30558 7.30558 3.5 12 3.5C16.6944 3.5 20.5 7.30558 20.5 12ZM22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12ZM15.25 11.478C15.25 14.39 14.004 16.182 12.002 16.182C10 16.182 8.75402 14.39 8.75402 11.478C8.75402 8.566 10 6.76 12.002 6.76C14.004 6.76 15.25 8.566 15.25 11.478ZM10.154 11.478C10.154 13.354 10.672 14.838 12.002 14.838C13.276 14.838 13.836 13.354 13.836 11.478C13.836 9.77 13.276 8.104 12.002 8.104C10.672 8.104 10.154 9.77 10.154 11.478Z"
    }
  });
};
var CircledZerovue_type_template_id_81007126_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/circled-numbers/CircledZero.vue?vue&type=script&lang=ts&

/* harmony default export */ var CircledZerovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledZero.vue?vue&type=script&lang=ts&
 /* harmony default export */ var circled_numbers_CircledZerovue_type_script_lang_ts_ = (CircledZerovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/circled-numbers/CircledZero.vue





/* normalize component */
;
var CircledZero_component = normalizeComponent(
  circled_numbers_CircledZerovue_type_script_lang_ts_,
  CircledZerovue_type_template_id_81007126_render,
  CircledZerovue_type_template_id_81007126_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CircledZero = (CircledZero_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Icon/Icon.vue?vue&type=script&lang=ts&




























































































































































// icons Notifications



















// Circled Numbers










var icons = {
  accessibility: Accessibility,
  accountCircle: AccountCircle,
  add: Add,
  alarm: Alarm,
  annotation: Annotation,
  apps: Apps,
  arrowBack: ArrowBack,
  arrowDown: ArrowDown,
  arrowForward: ArrowForward,
  arrowUp: ArrowUp,
  assessment: Assessment,
  barchart: BarChart,
  bold: Bold,
  bulletList: BulletList,
  calendar: Calendar,
  calendarCheck: CalendarCheck,
  camera: Camera,
  card: Card,
  cart: Cart,
  chat: Chat,
  chatAlert: ChatAlert,
  chatOutline: ChatOutline,
  check: Check,
  checkCircle: CheckCircle,
  chevron: Chevron,
  chevronDown: ChevronDown,
  chevronLeft: ChevronLeft,
  chevronRight: ChevronRight,
  chevronUp: ChevronUp,
  classroom: Classroom,
  close: Close,
  closeCircle: CloseCircle,
  codeBar: CodeBar,
  collectionsBookmark: CollectionsBookmark,
  comment: Comment,
  configuration: Configuration,
  copy: Copy,
  darkMode: DarkMode,
  delete: Delete,
  drag: Drag,
  disciplines: Disciplines,
  dropdown: DropDown,
  dropup: DropUp,
  download: Download,
  edit: Edit,
  ellipse: Ellipse,
  email: Email,
  error: icons_Error,
  exclamation: Exclamation,
  exercise: Exercise,
  exit: Exit,
  explore: Explore,
  facebook: Facebook,
  favorite: Favorite,
  feedbackSolution: FeedbackSolution,
  file: File,
  filledCalendar: FilledCalendar,
  folder: Folder,
  forum: Forum,
  forumUserIcon: ForumUserIcon,
  forumValidateIcon: ForumValidateIcon,
  friends: Friends,
  gestureZoom: GestureZoom,
  gift: Gift,
  help: Help,
  helpCenter: HelpCenter,
  home: Home,
  homeOutline: HomeOutline,
  image: Image,
  info: Info,
  insertEmoji: InsertEmoji,
  insertLink: InsertLink,
  insertQuote: InsertQuote,
  instagram: Instagram,
  italic: Italic,
  keyboardVoice: KeyboardVoice,
  lamp: Lamp,
  language: Language,
  library: Library,
  likeDefault: LikeDefault,
  likeActive: LikeActive,
  link: Link,
  linkedin: Linkedin,
  linkedinFilled: LinkedinFilled,
  list: List,
  listAlt: ListAlt,
  listBullet: ListBullet,
  listCheck: ListCheck,
  listNumber: ListNumber,
  locker: Locker,
  live: Live,
  local: Local,
  location: Location,
  locked: Locked,
  menu: Menu,
  microcertificate: Microcertificate,
  microCertifield: MicroCertifield,
  mockTest: MockTest,
  more: More,
  notes: Notes,
  notification: Notification,
  notificationAlt: NotificationAlt,
  notificationAltSelected: NotificationAltSelected,
  outline: Outline,
  openInNew: OpenInNew,
  pdf: Pdf,
  pdfFile: PdfFile,
  phone: Phone,
  pix: Pix,
  play: Play,
  playArrow: PlayArrow,
  playlist: Playlist,
  practicalExercises: PracticalExercises,
  questionsAndAnswers: QuestionsAndAnswers,
  replay: Replay,
  reply: Reply,
  report: Report,
  schedule: Schedule,
  school: School,
  search: Search,
  secretary: Secretary,
  send: Send,
  settings: Settings,
  share: Share,
  shareAlt: ShareAlt,
  shop: Shop,
  show: Show,
  star: Star,
  starOutline: StarOutline,
  stopwatch: Stopwatch,
  studyPlan: StudyPlan,
  strike: Strike,
  swapVertical: SwapVertical,
  terms: Terms,
  textField: TextField,
  textSms: TextSms,
  thumbDown: ThumbDown,
  thumbUp: ThumbUp,
  timer: Timer,
  tuttoring: Tuttoring,
  twitter: Twitter,
  underline: Underline,
  unlock: Unlock,
  upload: Upload,
  verified: Verified,
  videos: Videos,
  viewSplitHorizontal: ViewSplitHorizontal,
  whatsapp: Whatsapp,
  work: Work,
  zoomIn: ZoomIn,
  zoomInAlt: ZoomInAlt,
  zoomOutAlt: ZoomOutAlt,
  calendarDate: CalendarDate,
  certified: Certified,
  notebookPlay: NotebookPlay,
  phone24h: Phone24h,
  planningPerson: PlanningPerson,
  readBook: ReadBook,
  sendChat: SendChat,
  sendFile: SendFile,
  sendMail: SendMail,
  sendMessage: SendMessage,
  shake: Shake,
  contract: Contract,
  fileVerified: FileVerified,
  graduateComplete: GraduateComplete,
  mapPin: MapPin,
  medic: Medic,
  messageCall: MessageCall,
  mobilePhone: MobilePhone,
  notebookMessage: NotebookMessage,
  circledOne: CircledOne,
  circledTwo: CircledTwo,
  circledThree: CircledThree,
  circledFour: CircledFour,
  circledFive: CircledFive,
  circledSix: CircledSix,
  circledSeven: CircledSeven,
  circledEight: CircledEight,
  circledNine: CircledNine,
  circledZero: CircledZero,
  pastDue: PastDue
};
/* harmony default export */ var Iconvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    name: {
      type: String,
      required: true
    },
    size: {
      type: Number,
      default: 24
    }
  },
  data: function data() {
    return {
      icons: icons
    };
  },
  computed: {
    icon: function icon() {
      return this.icons[this.name];
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Icon/Icon.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Icon_Iconvue_type_script_lang_ts_ = (Iconvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Icon/Icon.vue





/* normalize component */
;
var Icon_component = normalizeComponent(
  Icon_Iconvue_type_script_lang_ts_,
  Iconvue_type_template_id_58fabfe0_render,
  Iconvue_type_template_id_58fabfe0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Icon = (Icon_component.exports);
;// CONCATENATED MODULE: ./src/components/Icon/index.ts

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Accordion/Accordion.vue?vue&type=script&lang=ts&


/* harmony default export */ var Accordionvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showContent: this.isOpen
    };
  },
  watch: {
    isOpen: function isOpen() {
      this.showContent = this.isOpen;
    }
  },
  methods: {
    clickHandler: function clickHandler() {
      this.showContent = !this.showContent;
      if (this.showContent) this.$emit('hasOpened');
    },
    beforeEnterAndLeave: function beforeEnterAndLeave(element) {
      element.style.height = '0';
    },
    enter: function enter(element) {
      element.style.height = "".concat(element.scrollHeight, "px");
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Accordion_Accordionvue_type_script_lang_ts_ = (Accordionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Accordion/Accordion.vue?vue&type=style&index=0&id=4906770a&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue?vue&type=style&index=0&id=4906770a&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Accordion/Accordion.vue



;


/* normalize component */

var Accordion_component = normalizeComponent(
  Accordion_Accordionvue_type_script_lang_ts_,
  render,
  staticRenderFns,
  false,
  null,
  "4906770a",
  null
  
)

/* harmony default export */ var Accordion = (Accordion_component.exports);
;// CONCATENATED MODULE: ./src/components/Accordion/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ActivityMessage/ActivityMessage.vue?vue&type=template&id=e62b28bc&scoped=true&
var ActivityMessagevue_type_template_id_e62b28bc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "wrapper",
    class: {
      'wrapper--pastDue': _vm.isPastDue,
      'wrapper--border': _vm.border
    }
  }, [_c('div', {
    staticClass: "wrapper__iconBox",
    class: {
      'wrapper__iconBox--pastDue': _vm.isPastDue
    }
  }, [_c('Icon', {
    staticClass: "wrapper__iconBox__icon",
    class: {
      'wrapper__iconBox__icon--pastDue': _vm.isPastDue
    },
    attrs: {
      "name": _vm.iconName
    }
  })], 1), _c('p', {
    staticClass: "wrapper__message"
  }, [_vm._v(_vm._s(_vm.message))])]);
};
var ActivityMessagevue_type_template_id_e62b28bc_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ActivityMessage/ActivityMessage.vue?vue&type=script&lang=ts&


var ActivityMessageStatus;
(function (ActivityMessageStatus) {
  ActivityMessageStatus["done"] = "done";
  ActivityMessageStatus["pending"] = "pending";
  ActivityMessageStatus["waitingGrading"] = "waitingGrading";
})(ActivityMessageStatus || (ActivityMessageStatus = {}));
/* harmony default export */ var ActivityMessagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    status: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    isPastDue: {
      type: Boolean,
      required: true
    },
    border: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    iconName: function iconName() {
      var iconNameMapper = {
        done: 'check',
        pending: 'listAlt',
        waitingGrading: 'schedule'
      };
      return iconNameMapper[this.status];
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ActivityMessage/ActivityMessage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ActivityMessage_ActivityMessagevue_type_script_lang_ts_ = (ActivityMessagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ActivityMessage/ActivityMessage.vue?vue&type=style&index=0&id=e62b28bc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ActivityMessage/ActivityMessage.vue?vue&type=style&index=0&id=e62b28bc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ActivityMessage/ActivityMessage.vue



;


/* normalize component */

var ActivityMessage_component = normalizeComponent(
  ActivityMessage_ActivityMessagevue_type_script_lang_ts_,
  ActivityMessagevue_type_template_id_e62b28bc_scoped_true_render,
  ActivityMessagevue_type_template_id_e62b28bc_scoped_true_staticRenderFns,
  false,
  null,
  "e62b28bc",
  null
  
)

/* harmony default export */ var ActivityMessage = (ActivityMessage_component.exports);
;// CONCATENATED MODULE: ./src/components/ActivityMessage/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=template&id=97c2a1c8&scoped=true&
var AnnotationInputCardvue_type_template_id_97c2a1c8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "card-annotation",
    class: {
      'card-annotation--short': _vm.short && !_vm.isOpenInput,
      'card-annotation--only-content': _vm.onlyContent,
      'card-annotation--large': _vm.withTextEditor,
      'card-annotation--medium': _vm.onlyContent && _vm.withTextEditor
    },
    on: {
      "mouseover": _vm.onMouseOver,
      "mouseleave": _vm.onMouseLeave,
      "click": function click($event) {
        return _vm.openInput();
      }
    }
  }, [_c('div', {
    staticClass: "info",
    on: {
      "click": function click($event) {
        return _vm.openInput();
      }
    }
  }, [_c('div', {
    staticClass: "info__placeholder subtitle-1",
    class: {
      'info__placeholder--visible': _vm.isOpenInput
    }
  }, [_c('Icon', {
    staticClass: "info__placeholder__icon",
    attrs: {
      "size": 24,
      "name": "add"
    }
  }), _vm._v(" " + _vm._s(_vm.placeholder) + " ")], 1), _c('div', {
    staticClass: "info__card"
  }, [_c('p', {
    staticClass: "info__card__time",
    class: {
      'info__card__time--visible': !_vm.isOpenInput
    }
  }, [_vm._v(" " + _vm._s(_vm.videoTimeStamp) + " ")]), _vm.isOpenInput && _vm.isDraft ? _c('p', {
    staticClass: "info__card__draft"
  }, [_vm._v(" Salvo como rascunho ")]) : _vm._e(), _vm.isOpenInput && !_vm.isDraft && !_vm.isLoading && _vm.profileName ? _c('p', {
    staticClass: "info__card__profile-name"
  }, [_vm._v(" " + _vm._s(_vm.profileName) + " ")]) : _vm._e(), _vm.isLikable ? _c('div', {
    staticClass: "info__card__like"
  }, [_c('button', {
    staticClass: "info__card__like__button",
    on: {
      "click": _vm.onLikeClick
    }
  }, [_c('Icon', {
    staticClass: "info__card__like__icon",
    class: {
      active: _vm.isLiked
    },
    attrs: {
      "name": _vm.isLiked ? 'likeActive' : 'likeDefault'
    }
  }), _c('span', {
    staticClass: "visually-hidden"
  }, [_vm._v(" " + _vm._s(_vm.isLiked ? _vm.unlikeButtonScreenReaderText : _vm.likeButtonScreenReaderText) + " ")])], 1), _c('p', {
    staticClass: "subtitle-1 info__card__like__counter"
  }, [_vm._v(_vm._s(_vm.totalLikes))])]) : _vm._e(), _vm.isLoading ? _c('ProgressCircular', {
    staticClass: "info__card__loading",
    attrs: {
      "font-size": "7px"
    }
  }) : _vm._e(), _vm.showMoreButton ? _c('Icon', {
    staticClass: "info__card__more",
    attrs: {
      "size": 24,
      "name": "more"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.toggleMoreOptions.apply(null, arguments);
      }
    }
  }) : _vm._e(), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOptionsOpened,
      expression: "isOptionsOpened"
    }],
    staticClass: "info__card__options-menu"
  }, _vm._l(_vm.optionsItems, function (item) {
    return _c('li', {
      key: item.label,
      on: {
        "click": item.clickHandler
      }
    }, [_c('p', {
      staticClass: "subtitle-1 info__card__options-menu__label"
    }, [_vm._v(" " + _vm._s(item.label) + " ")])]);
  }), 0)], 1)]), !_vm.withTextEditor ? _c('textarea', {
    ref: "annotation",
    tag: "component",
    staticClass: "input subtitle-1",
    class: {
      'input--visible': !_vm.isOpenInput,
      'input--only-content': _vm.onlyContent
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.blurHandler,
      "focus": _vm.focusHandler,
      "input": _vm.inputHandler
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }, [_vm._v(_vm._s(_vm.showInternalValue))]) : _vm._e(), _vm.withTextEditor ? _c('VueEditor', {
    ref: "editor",
    staticClass: "quillWrapper--small",
    class: {
      'input--visible': !_vm.isOpenInput,
      'input--only-content': !_vm.withTextEditor && _vm.onlyContent,
      'input--hide-toolbar': _vm.disabled || _vm.onlyContent || _vm.hideToolbar,
      'quill--should-show-editor': _vm.shouldShowEditor,
      'quill--should-close-editor': !_vm.shouldShowEditor
    },
    attrs: {
      "editor-options": _vm.editorSettings,
      "use-custom-image-handler": "",
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.blurHandler,
      "focus": _vm.focusHandler,
      "input": _vm.inputHandler
    },
    model: {
      value: _vm.internalValue,
      callback: function callback($$v) {
        _vm.internalValue = $$v;
      },
      expression: "internalValue"
    }
  }) : _vm._e(), _vm.disabled && !_vm.onlyContent ? _c('div', {
    staticClass: "card-annotation__actions",
    class: {
      'card-annotation__actions--hide': !_vm.isHoverCard
    }
  }, [_c('span', {
    staticClass: "card-annotation__actions--edit",
    on: {
      "click": _vm.onEditClick
    }
  }, [_vm._v(" " + _vm._s(_vm.editButtonLabel) + " ")]), _c('span', {
    staticClass: "card-annotation__actions--delete",
    on: {
      "click": _vm.onDeleteClick
    }
  }, [_vm._v(" " + _vm._s(_vm.deleteButtonLabel) + " ")])]) : _vm._e(), _c('div', {
    staticClass: "card-annotation__actions",
    class: {
      'card-annotation__actions--with-editor': _vm.withTextEditor
    }
  }, [_vm.showSaveButton ? _c('Button', {
    staticClass: "card-annotation__actions--save",
    class: {
      'card-annotation__actions--save-with-editor': _vm.withTextEditor
    },
    attrs: {
      "mini": "",
      "primary": "",
      "disabled": _vm.isSaveDisabled
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onSaveClick.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.saveButtonLabel))]) : _vm._e(), _vm.showSaveButton ? _c('Button', {
    staticClass: "card-annotation__actions--cancel",
    class: {
      'card-annotation__actions--cancel-with-editor': _vm.withTextEditor
    },
    attrs: {
      "mini": "",
      "secondary": "",
      "disabled": _vm.isSaveDisabled
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onCancelClick.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.cancelButtonLabel))]) : _vm._e(), _vm.showAddButton ? _c('Button', {
    staticClass: "card-annotation__actions--add",
    class: {
      'card-annotation__actions--add-with-editor': _vm.withTextEditor
    },
    attrs: {
      "mini": "",
      "primary": "",
      "disabled": _vm.isSaveDisabled
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onAddClick.apply(null, arguments);
      }
    }
  }, [_vm._v(_vm._s(_vm.addButtonLabel))]) : _vm._e()], 1)], 1);
};
var AnnotationInputCardvue_type_template_id_97c2a1c8_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayLikeToArray.js
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/arrayWithoutHoles.js

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.js
var es_symbol = __webpack_require__(2526);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.description.js
var es_symbol_description = __webpack_require__(1817);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.to-string.js
var es_object_to_string = __webpack_require__(1539);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.iterator.js
var es_symbol_iterator = __webpack_require__(2165);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.iterator.js
var es_array_iterator = __webpack_require__(6992);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.iterator.js
var es_string_iterator = __webpack_require__(8783);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.iterator.js
var web_dom_collections_iterator = __webpack_require__(3948);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.from.js
var es_array_from = __webpack_require__(1038);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/iterableToArray.js








function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.slice.js
var es_array_slice = __webpack_require__(7042);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.to-string.js
var es_regexp_to_string = __webpack_require__(9714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.exec.js
var es_regexp_exec = __webpack_require__(4916);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.test.js
var es_regexp_test = __webpack_require__(7601);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/unsupportedIterableToArray.js









function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.error.cause.js
var es_error_cause = __webpack_require__(1703);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/nonIterableSpread.js

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toConsumableArray.js




function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.concat.js
var es_array_concat = __webpack_require__(2222);
// EXTERNAL MODULE: ./node_modules/quill/dist/quill.js
var dist_quill = __webpack_require__(6095);
var quill_default = /*#__PURE__*/__webpack_require__.n(dist_quill);
;// CONCATENATED MODULE: ./node_modules/vue2-editor/dist/vue2-editor.esm.js
/*!
 * vue2-editor v2.10.3 
 * (c) 2021 David Royer
 * Released under the MIT License.
 */



var defaultToolbar = [[{
  header: [false, 1, 2, 3, 4, 5, 6]
}], ["bold", "italic", "underline", "strike"], // toggled buttons
[{
  align: ""
}, {
  align: "center"
}, {
  align: "right"
}, {
  align: "justify"
}], ["blockquote", "code-block"], [{
  list: "ordered"
}, {
  list: "bullet"
}, {
  list: "check"
}], [{
  indent: "-1"
}, {
  indent: "+1"
}], // outdent/indent
[{
  color: []
}, {
  background: []
}], // dropdown with defaults from theme
["link", "image", "video"], ["clean"] // remove formatting button
];

var oldApi = {
  props: {
    customModules: Array
  },
  methods: {
    registerCustomModules: function registerCustomModules(Quill) {
      if (this.customModules !== undefined) {
        this.customModules.forEach(function (customModule) {
          Quill.register("modules/" + customModule.alias, customModule.module);
        });
      }
    }
  }
};

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _arr = [];
  var _n = true;
  var _d = false;
  var _e = undefined;

  try {
    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance");
}

/**
 * Performs a deep merge of `source` into `target`.
 * Mutates `target` only but not its objects and arrays.
 *
 */
function mergeDeep(target, source) {
  var isObject = function isObject(obj) {
    return obj && _typeof(obj) === "object";
  };

  if (!isObject(target) || !isObject(source)) {
    return source;
  }

  Object.keys(source).forEach(function (key) {
    var targetValue = target[key];
    var sourceValue = source[key];

    if (Array.isArray(targetValue) && Array.isArray(sourceValue)) {
      target[key] = targetValue.concat(sourceValue);
    } else if (isObject(targetValue) && isObject(sourceValue)) {
      target[key] = mergeDeep(Object.assign({}, targetValue), sourceValue);
    } else {
      target[key] = sourceValue;
    }
  });
  return target;
}

var BlockEmbed = quill_default()["import"]("blots/block/embed");

var HorizontalRule =
/*#__PURE__*/
function (_BlockEmbed) {
  _inherits(HorizontalRule, _BlockEmbed);

  function HorizontalRule() {
    _classCallCheck(this, HorizontalRule);

    return _possibleConstructorReturn(this, _getPrototypeOf(HorizontalRule).apply(this, arguments));
  }

  return HorizontalRule;
}(BlockEmbed);

HorizontalRule.blotName = "hr";
HorizontalRule.tagName = "hr";
quill_default().register("formats/horizontal", HorizontalRule);

var MarkdownShortcuts =
/*#__PURE__*/
function () {
  function MarkdownShortcuts(quill, options) {
    var _this = this;

    _classCallCheck(this, MarkdownShortcuts);

    this.quill = quill;
    this.options = options;
    this.ignoreTags = ["PRE"];
    this.matches = [{
      name: "header",
      pattern: /^(#){1,6}\s/g,
      action: function action(text, selection, pattern) {
        var match = pattern.exec(text);
        if (!match) return;
        var size = match[0].length; // Need to defer this action https://github.com/quilljs/quill/issues/1134

        setTimeout(function () {
          _this.quill.formatLine(selection.index, 0, "header", size - 1);

          _this.quill.deleteText(selection.index - size, size);
        }, 0);
      }
    }, {
      name: "blockquote",
      pattern: /^(>)\s/g,
      action: function action(_text, selection) {
        // Need to defer this action https://github.com/quilljs/quill/issues/1134
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "blockquote", true);

          _this.quill.deleteText(selection.index - 2, 2);
        }, 0);
      }
    }, {
      name: "code-block",
      pattern: /^`{3}(?:\s|\n)/g,
      action: function action(_text, selection) {
        // Need to defer this action https://github.com/quilljs/quill/issues/1134
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "code-block", true);

          _this.quill.deleteText(selection.index - 4, 4);
        }, 0);
      }
    }, {
      name: "bolditalic",
      pattern: /(?:\*|_){3}(.+?)(?:\*|_){3}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            bold: true,
            italic: true
          });

          _this.quill.format("bold", false);
        }, 0);
      }
    }, {
      name: "bold",
      pattern: /(?:\*|_){2}(.+?)(?:\*|_){2}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            bold: true
          });

          _this.quill.format("bold", false);
        }, 0);
      }
    }, {
      name: "italic",
      pattern: /(?:\*|_){1}(.+?)(?:\*|_){1}/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            italic: true
          });

          _this.quill.format("italic", false);
        }, 0);
      }
    }, {
      name: "strikethrough",
      pattern: /(?:~~)(.+?)(?:~~)/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            strike: true
          });

          _this.quill.format("strike", false);
        }, 0);
      }
    }, {
      name: "code",
      pattern: /(?:`)(.+?)(?:`)/g,
      action: function action(text, _selection, pattern, lineStart) {
        var match = pattern.exec(text);
        var annotatedText = match[0];
        var matchedText = match[1];
        var startIndex = lineStart + match.index;
        if (text.match(/^([*_ \n]+)$/g)) return;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, annotatedText.length);

          _this.quill.insertText(startIndex, matchedText, {
            code: true
          });

          _this.quill.format("code", false);

          _this.quill.insertText(_this.quill.getSelection(), " ");
        }, 0);
      }
    }, {
      name: "hr",
      pattern: /^([-*]\s?){3}/g,
      action: function action(text, selection) {
        var startIndex = selection.index - text.length;
        setTimeout(function () {
          _this.quill.deleteText(startIndex, text.length);

          _this.quill.insertEmbed(startIndex + 1, "hr", true, (quill_default()).sources.USER);

          _this.quill.insertText(startIndex + 2, "\n", (quill_default()).sources.SILENT);

          _this.quill.setSelection(startIndex + 2, (quill_default()).sources.SILENT);
        }, 0);
      }
    }, {
      name: "asterisk-ul",
      pattern: /^(\*|\+)\s$/g,
      // eslint-disable-next-line no-unused-vars
      action: function action(_text, selection, _pattern) {
        setTimeout(function () {
          _this.quill.formatLine(selection.index, 1, "list", "unordered");

          _this.quill.deleteText(selection.index - 2, 2);
        }, 0);
      }
    }, {
      name: "image",
      pattern: /(?:!\[(.+?)\])(?:\((.+?)\))/g,
      action: function action(text, selection, pattern) {
        var startIndex = text.search(pattern);
        var matchedText = text.match(pattern)[0]; // const hrefText = text.match(/(?:!\[(.*?)\])/g)[0]

        var hrefLink = text.match(/(?:\((.*?)\))/g)[0];
        var start = selection.index - matchedText.length - 1;

        if (startIndex !== -1) {
          setTimeout(function () {
            _this.quill.deleteText(start, matchedText.length);

            _this.quill.insertEmbed(start, "image", hrefLink.slice(1, hrefLink.length - 1));
          }, 0);
        }
      }
    }, {
      name: "link",
      pattern: /(?:\[(.+?)\])(?:\((.+?)\))/g,
      action: function action(text, selection, pattern) {
        var startIndex = text.search(pattern);
        var matchedText = text.match(pattern)[0];
        var hrefText = text.match(/(?:\[(.*?)\])/g)[0];
        var hrefLink = text.match(/(?:\((.*?)\))/g)[0];
        var start = selection.index - matchedText.length - 1;

        if (startIndex !== -1) {
          setTimeout(function () {
            _this.quill.deleteText(start, matchedText.length);

            _this.quill.insertText(start, hrefText.slice(1, hrefText.length - 1), "link", hrefLink.slice(1, hrefLink.length - 1));
          }, 0);
        }
      }
    }]; // Handler that looks for insert deltas that match specific characters
    // eslint-disable-next-line no-unused-vars

    this.quill.on("text-change", function (delta, _oldContents, _source) {
      for (var i = 0; i < delta.ops.length; i++) {
        if (delta.ops[i].hasOwnProperty("insert")) {
          if (delta.ops[i].insert === " ") {
            _this.onSpace();
          } else if (delta.ops[i].insert === "\n") {
            _this.onEnter();
          }
        }
      }
    });
  }

  _createClass(MarkdownShortcuts, [{
    key: "isValid",
    value: function isValid(text, tagName) {
      return typeof text !== "undefined" && text && this.ignoreTags.indexOf(tagName) === -1;
    }
  }, {
    key: "onSpace",
    value: function onSpace() {
      var selection = this.quill.getSelection();
      if (!selection) return;

      var _this$quill$getLine = this.quill.getLine(selection.index),
          _this$quill$getLine2 = _slicedToArray(_this$quill$getLine, 2),
          line = _this$quill$getLine2[0],
          offset = _this$quill$getLine2[1];

      var text = line.domNode.textContent;
      var lineStart = selection.index - offset;

      if (this.isValid(text, line.domNode.tagName)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = this.matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var match = _step.value;
            var matchedText = text.match(match.pattern);

            if (matchedText) {
              // We need to replace only matched text not the whole line
              console.log("matched:", match.name, text);
              match.action(text, selection, match.pattern, lineStart);
              return;
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
    }
  }, {
    key: "onEnter",
    value: function onEnter() {
      var selection = this.quill.getSelection();
      if (!selection) return;

      var _this$quill$getLine3 = this.quill.getLine(selection.index),
          _this$quill$getLine4 = _slicedToArray(_this$quill$getLine3, 2),
          line = _this$quill$getLine4[0],
          offset = _this$quill$getLine4[1];

      var text = line.domNode.textContent + " ";
      var lineStart = selection.index - offset;
      selection.length = selection.index++;

      if (this.isValid(text, line.domNode.tagName)) {
        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = this.matches[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var match = _step2.value;
            var matchedText = text.match(match.pattern);

            if (matchedText) {
              console.log("matched", match.name, text);
              match.action(text, selection, match.pattern, lineStart);
              return;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }
      }
    }
  }]);

  return MarkdownShortcuts;
}(); // module.exports = MarkdownShortcuts;

//
var script = {
  name: "VueEditor",
  mixins: [oldApi],
  props: {
    id: {
      type: String,
      default: "quill-container"
    },
    placeholder: {
      type: String,
      default: ""
    },
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean
    },
    editorToolbar: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    editorOptions: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    useCustomImageHandler: {
      type: Boolean,
      default: false
    },
    useMarkdownShortcuts: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      quill: null
    };
  },
  watch: {
    value: function value(val) {
      if (val != this.quill.root.innerHTML && !this.quill.hasFocus()) {
        this.quill.root.innerHTML = val;
      }
    },
    disabled: function disabled(status) {
      this.quill.enable(!status);
    }
  },
  mounted: function mounted() {
    this.registerCustomModules((quill_default()));
    this.registerPrototypes();
    this.initializeEditor();
  },
  beforeDestroy: function beforeDestroy() {
    this.quill = null;
    delete this.quill;
  },
  methods: {
    initializeEditor: function initializeEditor() {
      this.setupQuillEditor();
      this.checkForCustomImageHandler();
      this.handleInitialContent();
      this.registerEditorEventListeners();
      this.$emit("ready", this.quill);
    },
    setupQuillEditor: function setupQuillEditor() {
      var editorConfig = {
        debug: false,
        modules: this.setModules(),
        theme: "snow",
        placeholder: this.placeholder ? this.placeholder : "",
        readOnly: this.disabled ? this.disabled : false
      };
      this.prepareEditorConfig(editorConfig);
      this.quill = new (quill_default())(this.$refs.quillContainer, editorConfig);
    },
    setModules: function setModules() {
      var modules = {
        toolbar: this.editorToolbar.length ? this.editorToolbar : defaultToolbar
      };

      if (this.useMarkdownShortcuts) {
        quill_default().register("modules/markdownShortcuts", MarkdownShortcuts, true);
        modules["markdownShortcuts"] = {};
      }

      return modules;
    },
    prepareEditorConfig: function prepareEditorConfig(editorConfig) {
      if (Object.keys(this.editorOptions).length > 0 && this.editorOptions.constructor === Object) {
        if (this.editorOptions.modules && typeof this.editorOptions.modules.toolbar !== "undefined") {
          // We don't want to merge default toolbar with provided toolbar.
          delete editorConfig.modules.toolbar;
        }

        mergeDeep(editorConfig, this.editorOptions);
      }
    },
    registerPrototypes: function registerPrototypes() {
      (quill_default()).prototype.getHTML = function () {
        return this.container.querySelector(".ql-editor").innerHTML;
      };

      (quill_default()).prototype.getWordCount = function () {
        return this.container.querySelector(".ql-editor").innerText.length;
      };
    },
    registerEditorEventListeners: function registerEditorEventListeners() {
      this.quill.on("text-change", this.handleTextChange);
      this.quill.on("selection-change", this.handleSelectionChange);
      this.listenForEditorEvent("text-change");
      this.listenForEditorEvent("selection-change");
      this.listenForEditorEvent("editor-change");
    },
    listenForEditorEvent: function listenForEditorEvent(type) {
      var _this = this;

      this.quill.on(type, function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this.$emit.apply(_this, [type].concat(args));
      });
    },
    handleInitialContent: function handleInitialContent() {
      if (this.value) this.quill.root.innerHTML = this.value; // Set initial editor content
    },
    handleSelectionChange: function handleSelectionChange(range, oldRange) {
      if (!range && oldRange) this.$emit("blur", this.quill);else if (range && !oldRange) this.$emit("focus", this.quill);
    },
    handleTextChange: function handleTextChange(delta, oldContents) {
      var editorContent = this.quill.getHTML() === "<p><br></p>" ? "" : this.quill.getHTML();
      this.$emit("input", editorContent);
      if (this.useCustomImageHandler) this.handleImageRemoved(delta, oldContents);
    },
    handleImageRemoved: function handleImageRemoved(delta, oldContents) {
      var _this2 = this;

      var currrentContents = this.quill.getContents();
      var deletedContents = currrentContents.diff(oldContents);
      var operations = deletedContents.ops;
      operations.map(function (operation) {
        if (operation.insert && operation.insert.hasOwnProperty("image")) {
          var image = operation.insert.image;

          _this2.$emit("image-removed", image);
        }
      });
    },
    checkForCustomImageHandler: function checkForCustomImageHandler() {
      this.useCustomImageHandler === true ? this.setupCustomImageHandler() : "";
    },
    setupCustomImageHandler: function setupCustomImageHandler() {
      var toolbar = this.quill.getModule("toolbar");
      toolbar.addHandler("image", this.customImageHandler);
    },
    customImageHandler: function customImageHandler() {
      this.$refs.fileInput.click();
    },
    emitImageInfo: function emitImageInfo($event) {
      var resetUploader = function resetUploader() {
        var uploader = document.getElementById("file-upload");
        uploader.value = "";
      };

      var file = $event.target.files[0];
      var Editor = this.quill;
      var range = Editor.getSelection();
      var cursorLocation = range.index;
      this.$emit("image-added", file, Editor, cursorLocation, resetUploader);
    }
  }
};

function vue2_editor_esm_normalizeComponent(template, style, script, scopeId, isFunctionalTemplate, moduleIdentifier
/* server only */
, shadowMode, createInjector, createInjectorSSR, createInjectorShadow) {
  if (typeof shadowMode !== 'boolean') {
    createInjectorSSR = createInjector;
    createInjector = shadowMode;
    shadowMode = false;
  } // Vue.extend constructor export interop.


  var options = typeof script === 'function' ? script.options : script; // render functions

  if (template && template.render) {
    options.render = template.render;
    options.staticRenderFns = template.staticRenderFns;
    options._compiled = true; // functional template

    if (isFunctionalTemplate) {
      options.functional = true;
    }
  } // scopedId


  if (scopeId) {
    options._scopeId = scopeId;
  }

  var hook;

  if (moduleIdentifier) {
    // server build
    hook = function hook(context) {
      // 2.3 injection
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext; // functional
      // 2.2 with runInNewContext: true

      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__;
      } // inject component styles


      if (style) {
        style.call(this, createInjectorSSR(context));
      } // register component module identifier for async chunk inference


      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    }; // used by ssr in case component is cached and beforeCreate
    // never gets called


    options._ssrRegister = hook;
  } else if (style) {
    hook = shadowMode ? function () {
      style.call(this, createInjectorShadow(this.$root.$options.shadowRoot));
    } : function (context) {
      style.call(this, createInjector(context));
    };
  }

  if (hook) {
    if (options.functional) {
      // register for functional component in vue file
      var originalRender = options.render;

      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }

  return script;
}

var normalizeComponent_1 = vue2_editor_esm_normalizeComponent;

var isOldIE = typeof navigator !== 'undefined' && /msie [6-9]\\b/.test(navigator.userAgent.toLowerCase());

function createInjector(context) {
  return function (id, style) {
    return addStyle(id, style);
  };
}

var HEAD;
var styles = {};

function addStyle(id, css) {
  var group = isOldIE ? css.media || 'default' : id;
  var style = styles[group] || (styles[group] = {
    ids: new Set(),
    styles: []
  });

  if (!style.ids.has(id)) {
    style.ids.add(id);
    var code = css.source;

    if (css.map) {
      // https://developer.chrome.com/devtools/docs/javascript-debugging
      // this makes source maps inside style tags work properly in Chrome
      code += '\n/*# sourceURL=' + css.map.sources[0] + ' */'; // http://stackoverflow.com/a/26603875

      code += '\n/*# sourceMappingURL=data:application/json;base64,' + btoa(unescape(encodeURIComponent(JSON.stringify(css.map)))) + ' */';
    }

    if (!style.element) {
      style.element = document.createElement('style');
      style.element.type = 'text/css';
      if (css.media) style.element.setAttribute('media', css.media);

      if (HEAD === undefined) {
        HEAD = document.head || document.getElementsByTagName('head')[0];
      }

      HEAD.appendChild(style.element);
    }

    if ('styleSheet' in style.element) {
      style.styles.push(code);
      style.element.styleSheet.cssText = style.styles.filter(Boolean).join('\n');
    } else {
      var index = style.ids.size - 1;
      var textNode = document.createTextNode(code);
      var nodes = style.element.childNodes;
      if (nodes[index]) style.element.removeChild(nodes[index]);
      if (nodes.length) style.element.insertBefore(textNode, nodes[index]);else style.element.appendChild(textNode);
    }
  }
}

var browser = createInjector;

/* script */
const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"quillWrapper"},[_vm._t("toolbar"),_vm._v(" "),_c('div',{ref:"quillContainer",attrs:{"id":_vm.id}}),_vm._v(" "),(_vm.useCustomImageHandler)?_c('input',{ref:"fileInput",staticStyle:{"display":"none"},attrs:{"id":"file-upload","type":"file","accept":"image/*"},on:{"change":function($event){return _vm.emitImageInfo($event)}}}):_vm._e()],2)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-776e788e_0", { source: "/*!\n * Quill Editor v1.3.6\n * https://quilljs.com/\n * Copyright (c) 2014, Jason Chen\n * Copyright (c) 2013, salesforce.com\n */.ql-container{box-sizing:border-box;font-family:Helvetica,Arial,sans-serif;font-size:13px;height:100%;margin:0;position:relative}.ql-container.ql-disabled .ql-tooltip{visibility:hidden}.ql-container.ql-disabled .ql-editor ul[data-checked]>li::before{pointer-events:none}.ql-clipboard{left:-100000px;height:1px;overflow-y:hidden;position:absolute;top:50%}.ql-clipboard p{margin:0;padding:0}.ql-editor{box-sizing:border-box;line-height:1.42;height:100%;outline:0;overflow-y:auto;padding:12px 15px;tab-size:4;-moz-tab-size:4;text-align:left;white-space:pre-wrap;word-wrap:break-word}.ql-editor>*{cursor:text}.ql-editor blockquote,.ql-editor h1,.ql-editor h2,.ql-editor h3,.ql-editor h4,.ql-editor h5,.ql-editor h6,.ql-editor ol,.ql-editor p,.ql-editor pre,.ql-editor ul{margin:0;padding:0;counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol,.ql-editor ul{padding-left:1.5em}.ql-editor ol>li,.ql-editor ul>li{list-style-type:none}.ql-editor ul>li::before{content:'\\2022'}.ql-editor ul[data-checked=false],.ql-editor ul[data-checked=true]{pointer-events:none}.ql-editor ul[data-checked=false]>li *,.ql-editor ul[data-checked=true]>li *{pointer-events:all}.ql-editor ul[data-checked=false]>li::before,.ql-editor ul[data-checked=true]>li::before{color:#777;cursor:pointer;pointer-events:all}.ql-editor ul[data-checked=true]>li::before{content:'\\2611'}.ql-editor ul[data-checked=false]>li::before{content:'\\2610'}.ql-editor li::before{display:inline-block;white-space:nowrap;width:1.2em}.ql-editor li:not(.ql-direction-rtl)::before{margin-left:-1.5em;margin-right:.3em;text-align:right}.ql-editor li.ql-direction-rtl::before{margin-left:.3em;margin-right:-1.5em}.ql-editor ol li:not(.ql-direction-rtl),.ql-editor ul li:not(.ql-direction-rtl){padding-left:1.5em}.ql-editor ol li.ql-direction-rtl,.ql-editor ul li.ql-direction-rtl{padding-right:1.5em}.ql-editor ol li{counter-reset:list-1 list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9;counter-increment:list-0}.ql-editor ol li:before{content:counter(list-0,decimal) '. '}.ql-editor ol li.ql-indent-1{counter-increment:list-1}.ql-editor ol li.ql-indent-1:before{content:counter(list-1,lower-alpha) '. '}.ql-editor ol li.ql-indent-1{counter-reset:list-2 list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-2{counter-increment:list-2}.ql-editor ol li.ql-indent-2:before{content:counter(list-2,lower-roman) '. '}.ql-editor ol li.ql-indent-2{counter-reset:list-3 list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-3{counter-increment:list-3}.ql-editor ol li.ql-indent-3:before{content:counter(list-3,decimal) '. '}.ql-editor ol li.ql-indent-3{counter-reset:list-4 list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-4{counter-increment:list-4}.ql-editor ol li.ql-indent-4:before{content:counter(list-4,lower-alpha) '. '}.ql-editor ol li.ql-indent-4{counter-reset:list-5 list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-5{counter-increment:list-5}.ql-editor ol li.ql-indent-5:before{content:counter(list-5,lower-roman) '. '}.ql-editor ol li.ql-indent-5{counter-reset:list-6 list-7 list-8 list-9}.ql-editor ol li.ql-indent-6{counter-increment:list-6}.ql-editor ol li.ql-indent-6:before{content:counter(list-6,decimal) '. '}.ql-editor ol li.ql-indent-6{counter-reset:list-7 list-8 list-9}.ql-editor ol li.ql-indent-7{counter-increment:list-7}.ql-editor ol li.ql-indent-7:before{content:counter(list-7,lower-alpha) '. '}.ql-editor ol li.ql-indent-7{counter-reset:list-8 list-9}.ql-editor ol li.ql-indent-8{counter-increment:list-8}.ql-editor ol li.ql-indent-8:before{content:counter(list-8,lower-roman) '. '}.ql-editor ol li.ql-indent-8{counter-reset:list-9}.ql-editor ol li.ql-indent-9{counter-increment:list-9}.ql-editor ol li.ql-indent-9:before{content:counter(list-9,decimal) '. '}.ql-editor .ql-indent-1:not(.ql-direction-rtl){padding-left:3em}.ql-editor li.ql-indent-1:not(.ql-direction-rtl){padding-left:4.5em}.ql-editor .ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:3em}.ql-editor li.ql-indent-1.ql-direction-rtl.ql-align-right{padding-right:4.5em}.ql-editor .ql-indent-2:not(.ql-direction-rtl){padding-left:6em}.ql-editor li.ql-indent-2:not(.ql-direction-rtl){padding-left:7.5em}.ql-editor .ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:6em}.ql-editor li.ql-indent-2.ql-direction-rtl.ql-align-right{padding-right:7.5em}.ql-editor .ql-indent-3:not(.ql-direction-rtl){padding-left:9em}.ql-editor li.ql-indent-3:not(.ql-direction-rtl){padding-left:10.5em}.ql-editor .ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:9em}.ql-editor li.ql-indent-3.ql-direction-rtl.ql-align-right{padding-right:10.5em}.ql-editor .ql-indent-4:not(.ql-direction-rtl){padding-left:12em}.ql-editor li.ql-indent-4:not(.ql-direction-rtl){padding-left:13.5em}.ql-editor .ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:12em}.ql-editor li.ql-indent-4.ql-direction-rtl.ql-align-right{padding-right:13.5em}.ql-editor .ql-indent-5:not(.ql-direction-rtl){padding-left:15em}.ql-editor li.ql-indent-5:not(.ql-direction-rtl){padding-left:16.5em}.ql-editor .ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:15em}.ql-editor li.ql-indent-5.ql-direction-rtl.ql-align-right{padding-right:16.5em}.ql-editor .ql-indent-6:not(.ql-direction-rtl){padding-left:18em}.ql-editor li.ql-indent-6:not(.ql-direction-rtl){padding-left:19.5em}.ql-editor .ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:18em}.ql-editor li.ql-indent-6.ql-direction-rtl.ql-align-right{padding-right:19.5em}.ql-editor .ql-indent-7:not(.ql-direction-rtl){padding-left:21em}.ql-editor li.ql-indent-7:not(.ql-direction-rtl){padding-left:22.5em}.ql-editor .ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:21em}.ql-editor li.ql-indent-7.ql-direction-rtl.ql-align-right{padding-right:22.5em}.ql-editor .ql-indent-8:not(.ql-direction-rtl){padding-left:24em}.ql-editor li.ql-indent-8:not(.ql-direction-rtl){padding-left:25.5em}.ql-editor .ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:24em}.ql-editor li.ql-indent-8.ql-direction-rtl.ql-align-right{padding-right:25.5em}.ql-editor .ql-indent-9:not(.ql-direction-rtl){padding-left:27em}.ql-editor li.ql-indent-9:not(.ql-direction-rtl){padding-left:28.5em}.ql-editor .ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:27em}.ql-editor li.ql-indent-9.ql-direction-rtl.ql-align-right{padding-right:28.5em}.ql-editor .ql-video{display:block;max-width:100%}.ql-editor .ql-video.ql-align-center{margin:0 auto}.ql-editor .ql-video.ql-align-right{margin:0 0 0 auto}.ql-editor .ql-bg-black{background-color:#000}.ql-editor .ql-bg-red{background-color:#e60000}.ql-editor .ql-bg-orange{background-color:#f90}.ql-editor .ql-bg-yellow{background-color:#ff0}.ql-editor .ql-bg-green{background-color:#008a00}.ql-editor .ql-bg-blue{background-color:#06c}.ql-editor .ql-bg-purple{background-color:#93f}.ql-editor .ql-color-white{color:#fff}.ql-editor .ql-color-red{color:#e60000}.ql-editor .ql-color-orange{color:#f90}.ql-editor .ql-color-yellow{color:#ff0}.ql-editor .ql-color-green{color:#008a00}.ql-editor .ql-color-blue{color:#06c}.ql-editor .ql-color-purple{color:#93f}.ql-editor .ql-font-serif{font-family:Georgia,Times New Roman,serif}.ql-editor .ql-font-monospace{font-family:Monaco,Courier New,monospace}.ql-editor .ql-size-small{font-size:.75em}.ql-editor .ql-size-large{font-size:1.5em}.ql-editor .ql-size-huge{font-size:2.5em}.ql-editor .ql-direction-rtl{direction:rtl;text-align:inherit}.ql-editor .ql-align-center{text-align:center}.ql-editor .ql-align-justify{text-align:justify}.ql-editor .ql-align-right{text-align:right}.ql-editor.ql-blank::before{color:rgba(0,0,0,.6);content:attr(data-placeholder);font-style:italic;left:15px;pointer-events:none;position:absolute;right:15px}.ql-snow .ql-toolbar:after,.ql-snow.ql-toolbar:after{clear:both;content:'';display:table}.ql-snow .ql-toolbar button,.ql-snow.ql-toolbar button{background:0 0;border:none;cursor:pointer;display:inline-block;float:left;height:24px;padding:3px 5px;width:28px}.ql-snow .ql-toolbar button svg,.ql-snow.ql-toolbar button svg{float:left;height:100%}.ql-snow .ql-toolbar button:active:hover,.ql-snow.ql-toolbar button:active:hover{outline:0}.ql-snow .ql-toolbar input.ql-image[type=file],.ql-snow.ql-toolbar input.ql-image[type=file]{display:none}.ql-snow .ql-toolbar .ql-picker-item.ql-selected,.ql-snow .ql-toolbar .ql-picker-item:hover,.ql-snow .ql-toolbar .ql-picker-label.ql-active,.ql-snow .ql-toolbar .ql-picker-label:hover,.ql-snow .ql-toolbar button.ql-active,.ql-snow .ql-toolbar button:focus,.ql-snow .ql-toolbar button:hover,.ql-snow.ql-toolbar .ql-picker-item.ql-selected,.ql-snow.ql-toolbar .ql-picker-item:hover,.ql-snow.ql-toolbar .ql-picker-label.ql-active,.ql-snow.ql-toolbar .ql-picker-label:hover,.ql-snow.ql-toolbar button.ql-active,.ql-snow.ql-toolbar button:focus,.ql-snow.ql-toolbar button:hover{color:#06c}.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-fill,.ql-snow .ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:focus .ql-fill,.ql-snow .ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow .ql-toolbar button:hover .ql-fill,.ql-snow .ql-toolbar button:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-fill,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-fill,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-fill,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke.ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-fill,.ql-snow.ql-toolbar button.ql-active .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:focus .ql-fill,.ql-snow.ql-toolbar button:focus .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover .ql-fill,.ql-snow.ql-toolbar button:hover .ql-stroke.ql-fill{fill:#06c}.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow .ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow .ql-toolbar button.ql-active .ql-stroke,.ql-snow .ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow .ql-toolbar button:focus .ql-stroke,.ql-snow .ql-toolbar button:focus .ql-stroke-miter,.ql-snow .ql-toolbar button:hover .ql-stroke,.ql-snow .ql-toolbar button:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item.ql-selected .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-item:hover .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke,.ql-snow.ql-toolbar .ql-picker-label:hover .ql-stroke-miter,.ql-snow.ql-toolbar button.ql-active .ql-stroke,.ql-snow.ql-toolbar button.ql-active .ql-stroke-miter,.ql-snow.ql-toolbar button:focus .ql-stroke,.ql-snow.ql-toolbar button:focus .ql-stroke-miter,.ql-snow.ql-toolbar button:hover .ql-stroke,.ql-snow.ql-toolbar button:hover .ql-stroke-miter{stroke:#06c}@media (pointer:coarse){.ql-snow .ql-toolbar button:hover:not(.ql-active),.ql-snow.ql-toolbar button:hover:not(.ql-active){color:#444}.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-fill,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow .ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke,.ql-snow.ql-toolbar button:hover:not(.ql-active) .ql-stroke-miter{stroke:#444}}.ql-snow{box-sizing:border-box}.ql-snow *{box-sizing:border-box}.ql-snow .ql-hidden{display:none}.ql-snow .ql-out-bottom,.ql-snow .ql-out-top{visibility:hidden}.ql-snow .ql-tooltip{position:absolute;transform:translateY(10px)}.ql-snow .ql-tooltip a{cursor:pointer;text-decoration:none}.ql-snow .ql-tooltip.ql-flip{transform:translateY(-10px)}.ql-snow .ql-formats{display:inline-block;vertical-align:middle}.ql-snow .ql-formats:after{clear:both;content:'';display:table}.ql-snow .ql-stroke{fill:none;stroke:#444;stroke-linecap:round;stroke-linejoin:round;stroke-width:2}.ql-snow .ql-stroke-miter{fill:none;stroke:#444;stroke-miterlimit:10;stroke-width:2}.ql-snow .ql-fill,.ql-snow .ql-stroke.ql-fill{fill:#444}.ql-snow .ql-empty{fill:none}.ql-snow .ql-even{fill-rule:evenodd}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1}.ql-snow .ql-transparent{opacity:.4}.ql-snow .ql-direction svg:last-child{display:none}.ql-snow .ql-direction.ql-active svg:last-child{display:inline}.ql-snow .ql-direction.ql-active svg:first-child{display:none}.ql-snow .ql-editor h1{font-size:2em}.ql-snow .ql-editor h2{font-size:1.5em}.ql-snow .ql-editor h3{font-size:1.17em}.ql-snow .ql-editor h4{font-size:1em}.ql-snow .ql-editor h5{font-size:.83em}.ql-snow .ql-editor h6{font-size:.67em}.ql-snow .ql-editor a{text-decoration:underline}.ql-snow .ql-editor blockquote{border-left:4px solid #ccc;margin-bottom:5px;margin-top:5px;padding-left:16px}.ql-snow .ql-editor code,.ql-snow .ql-editor pre{background-color:#f0f0f0;border-radius:3px}.ql-snow .ql-editor pre{white-space:pre-wrap;margin-bottom:5px;margin-top:5px;padding:5px 10px}.ql-snow .ql-editor code{font-size:85%;padding:2px 4px}.ql-snow .ql-editor pre.ql-syntax{background-color:#23241f;color:#f8f8f2;overflow:visible}.ql-snow .ql-editor img{max-width:100%}.ql-snow .ql-picker{color:#444;display:inline-block;float:left;font-size:14px;font-weight:500;height:24px;position:relative;vertical-align:middle}.ql-snow .ql-picker-label{cursor:pointer;display:inline-block;height:100%;padding-left:8px;padding-right:2px;position:relative;width:100%}.ql-snow .ql-picker-label::before{display:inline-block;line-height:22px}.ql-snow .ql-picker-options{background-color:#fff;display:none;min-width:100%;padding:4px 8px;position:absolute;white-space:nowrap}.ql-snow .ql-picker-options .ql-picker-item{cursor:pointer;display:block;padding-bottom:5px;padding-top:5px}.ql-snow .ql-picker.ql-expanded .ql-picker-label{color:#ccc;z-index:2}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-fill{fill:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-label .ql-stroke{stroke:#ccc}.ql-snow .ql-picker.ql-expanded .ql-picker-options{display:block;margin-top:-1px;top:100%;z-index:1}.ql-snow .ql-color-picker,.ql-snow .ql-icon-picker{width:28px}.ql-snow .ql-color-picker .ql-picker-label,.ql-snow .ql-icon-picker .ql-picker-label{padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-label svg,.ql-snow .ql-icon-picker .ql-picker-label svg{right:4px}.ql-snow .ql-icon-picker .ql-picker-options{padding:4px 0}.ql-snow .ql-icon-picker .ql-picker-item{height:24px;width:24px;padding:2px 4px}.ql-snow .ql-color-picker .ql-picker-options{padding:3px 5px;width:152px}.ql-snow .ql-color-picker .ql-picker-item{border:1px solid transparent;float:left;height:16px;margin:2px;padding:0;width:16px}.ql-snow .ql-picker:not(.ql-color-picker):not(.ql-icon-picker) svg{position:absolute;margin-top:-9px;right:0;top:50%;width:18px}.ql-snow .ql-picker.ql-font .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-header .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-size .ql-picker-item[data-label]:not([data-label=''])::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-label]:not([data-label=''])::before{content:attr(data-label)}.ql-snow .ql-picker.ql-header{width:98px}.ql-snow .ql-picker.ql-header .ql-picker-item::before,.ql-snow .ql-picker.ql-header .ql-picker-label::before{content:'Normal'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"1\"]::before{content:'Heading 1'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"2\"]::before{content:'Heading 2'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"3\"]::before{content:'Heading 3'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"4\"]::before{content:'Heading 4'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"5\"]::before{content:'Heading 5'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before,.ql-snow .ql-picker.ql-header .ql-picker-label[data-value=\"6\"]::before{content:'Heading 6'}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"1\"]::before{font-size:2em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"2\"]::before{font-size:1.5em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"3\"]::before{font-size:1.17em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"4\"]::before{font-size:1em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"5\"]::before{font-size:.83em}.ql-snow .ql-picker.ql-header .ql-picker-item[data-value=\"6\"]::before{font-size:.67em}.ql-snow .ql-picker.ql-font{width:108px}.ql-snow .ql-picker.ql-font .ql-picker-item::before,.ql-snow .ql-picker.ql-font .ql-picker-label::before{content:'Sans Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before{content:'Serif'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before,.ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before{content:'Monospace'}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before{font-family:Georgia,Times New Roman,serif}.ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before{font-family:Monaco,Courier New,monospace}.ql-snow .ql-picker.ql-size{width:98px}.ql-snow .ql-picker.ql-size .ql-picker-item::before,.ql-snow .ql-picker.ql-size .ql-picker-label::before{content:'Normal'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before{content:'Small'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before{content:'Large'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before,.ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before{content:'Huge'}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before{font-size:10px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before{font-size:18px}.ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before{font-size:32px}.ql-snow .ql-color-picker.ql-background .ql-picker-item{background-color:#fff}.ql-snow .ql-color-picker.ql-color .ql-picker-item{background-color:#000}.ql-toolbar.ql-snow{border:1px solid #ccc;box-sizing:border-box;font-family:'Helvetica Neue',Helvetica,Arial,sans-serif;padding:8px}.ql-toolbar.ql-snow .ql-formats{margin-right:15px}.ql-toolbar.ql-snow .ql-picker-label{border:1px solid transparent}.ql-toolbar.ql-snow .ql-picker-options{border:1px solid transparent;box-shadow:rgba(0,0,0,.2) 0 2px 8px}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-label{border-color:#ccc}.ql-toolbar.ql-snow .ql-picker.ql-expanded .ql-picker-options{border-color:#ccc}.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item.ql-selected,.ql-toolbar.ql-snow .ql-color-picker .ql-picker-item:hover{border-color:#000}.ql-toolbar.ql-snow+.ql-container.ql-snow{border-top:0}.ql-snow .ql-tooltip{background-color:#fff;border:1px solid #ccc;box-shadow:0 0 5px #ddd;color:#444;padding:5px 12px;white-space:nowrap}.ql-snow .ql-tooltip::before{content:\"Visit URL:\";line-height:26px;margin-right:8px}.ql-snow .ql-tooltip input[type=text]{display:none;border:1px solid #ccc;font-size:13px;height:26px;margin:0;padding:3px 5px;width:170px}.ql-snow .ql-tooltip a.ql-preview{display:inline-block;max-width:200px;overflow-x:hidden;text-overflow:ellipsis;vertical-align:top}.ql-snow .ql-tooltip a.ql-action::after{border-right:1px solid #ccc;content:'Edit';margin-left:16px;padding-right:8px}.ql-snow .ql-tooltip a.ql-remove::before{content:'Remove';margin-left:8px}.ql-snow .ql-tooltip a{line-height:26px}.ql-snow .ql-tooltip.ql-editing a.ql-preview,.ql-snow .ql-tooltip.ql-editing a.ql-remove{display:none}.ql-snow .ql-tooltip.ql-editing input[type=text]{display:inline-block}.ql-snow .ql-tooltip.ql-editing a.ql-action::after{border-right:0;content:'Save';padding-right:0}.ql-snow .ql-tooltip[data-mode=link]::before{content:\"Enter link:\"}.ql-snow .ql-tooltip[data-mode=formula]::before{content:\"Enter formula:\"}.ql-snow .ql-tooltip[data-mode=video]::before{content:\"Enter video:\"}.ql-snow a{color:#06c}.ql-container.ql-snow{border:1px solid #ccc}", map: undefined, media: undefined })
,inject("data-v-776e788e_1", { source: ".ql-editor{min-height:200px;font-size:16px}.ql-snow .ql-stroke.ql-thin,.ql-snow .ql-thin{stroke-width:1px!important}.quillWrapper .ql-snow.ql-toolbar{padding-top:8px;padding-bottom:4px}.quillWrapper .ql-snow.ql-toolbar .ql-formats{margin-bottom:10px}.ql-snow .ql-toolbar button svg,.quillWrapper .ql-snow.ql-toolbar button svg{width:22px;height:22px}.quillWrapper .ql-editor ul[data-checked=false]>li::before,.quillWrapper .ql-editor ul[data-checked=true]>li::before{font-size:1.35em;vertical-align:baseline;bottom:-.065em;font-weight:900;color:#222}.quillWrapper .ql-snow .ql-stroke{stroke:rgba(63,63,63,.95);stroke-linecap:square;stroke-linejoin:initial;stroke-width:1.7px}.quillWrapper .ql-picker-label{font-size:15px}.quillWrapper .ql-snow .ql-active .ql-stroke{stroke-width:2.25px}.quillWrapper .ql-toolbar.ql-snow .ql-formats{vertical-align:top}.ql-picker:not(.ql-background){position:relative;top:2px}.ql-picker.ql-color-picker svg{width:22px!important;height:22px!important}.quillWrapper .imageResizeActive img{display:block;cursor:pointer}.quillWrapper .imageResizeActive~div svg{cursor:pointer}", map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = undefined;
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  

  
  var VueEditor = normalizeComponent_1(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    browser,
    undefined
  );

var version = "2.10.3"; // Declare install function executed by Vue.use()

function install(Vue) {
  if (install.installed) return;
  install.installed = true;
  Vue.component("VueEditor", VueEditor);
}
var VPlugin = {
  install: install,
  version: version,
  Quill: (quill_default()),
  VueEditor: VueEditor
}; // Auto-install when vue is found (eg. in browser via <script> tag)

var GlobalVue = null;

if (typeof window !== "undefined") {
  GlobalVue = window.Vue;
} else if (typeof __webpack_require__.g !== "undefined") {
  GlobalVue = __webpack_require__.g.Vue;
}

if (GlobalVue) {
  GlobalVue.use(VPlugin);
}
/*************************************************/

/* harmony default export */ var vue2_editor_esm = ((/* unused pure expression or super */ null && (VPlugin)));


// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.small.js
var es_string_small = __webpack_require__(7268);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/Button.vue?vue&type=template&id=fc76b89c&

var Buttonvue_type_template_id_fc76b89c_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('button', {
    staticClass: "btn",
    class: {
      'btn-disabled': _vm.disabled,
      'btn-primary': _vm.primary,
      'btn-secondary': _vm.secondary,
      'btn-campaign': _vm.campaign,
      'btn-small': _vm.small,
      'btn-mini': _vm.mini,
      'btn-medium': _vm.medium,
      'btn-large': _vm.large,
      'btn-x-large': _vm.xLarge,
      'btn-wide': _vm.wide,
      'subtitle-1': _vm.large || _vm.medium,
      'subtitle-2': _vm.small,
      'btn-border': _vm.border,
      'btn-no-border': _vm.noBorder,
      h5: _vm.wide
    },
    attrs: {
      "disabled": _vm.disabled
    }
  }, [_vm._t("default")], 2);
};
var Buttonvue_type_template_id_fc76b89c_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Button/Button.vue?vue&type=template&id=fc76b89c&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/Button.vue?vue&type=script&lang=ts&

/* harmony default export */ var Buttonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    wide: Boolean,
    mini: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xLarge: Boolean,
    primary: Boolean,
    secondary: Boolean,
    campaign: Boolean,
    disabled: Boolean,
    border: Boolean,
    noBorder: Boolean
  }
}));
;// CONCATENATED MODULE: ./src/components/Button/Button.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Button_Buttonvue_type_script_lang_ts_ = (Buttonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Button/Button.vue





/* normalize component */
;
var Button_component = normalizeComponent(
  Button_Buttonvue_type_script_lang_ts_,
  Buttonvue_type_template_id_fc76b89c_render,
  Buttonvue_type_template_id_fc76b89c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Button = (Button_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/MenuButton.vue?vue&type=template&id=615d8132&scoped=true&
var MenuButtonvue_type_template_id_615d8132_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "menu-button",
    class: {
      'menu-button__element-style': _vm.isElementStyle,
      'menu-button--border': _vm.isBorder,
      'menu-button--collapsed': _vm.isCollapsed,
      'menu-button--actived': _vm.isActived,
      'menu-button--hovered': _vm.isHovered
    },
    style: {
      'grid-template-columns': "".concat(_vm.gap, "px auto")
    }
  }, [_vm.icon ? _c('Icon', {
    staticClass: "menu-button__icon",
    class: {
      'menu-button__icon--active': _vm.isActived && _vm.isCollapsed
    },
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm.label || _vm.tag ? _c('p', {
    staticClass: "menu-button__text subtitle-1"
  }, [_vm.label ? _c('span', [_vm._v(" " + _vm._s(_vm.label))]) : _vm._e(), _vm.tag ? _c('span', {
    staticClass: "menu-button__text__tag",
    class: {
      'menu-button__text__tag--has-chevron': _vm.hasChevron
    }
  }, [_vm._v(_vm._s(_vm.tag))]) : _vm._e()]) : _vm._e(), _vm.hasChevron ? _c('Icon', {
    staticClass: "menu-button__icon menu-button__icon--right",
    attrs: {
      "name": "chevron"
    }
  }) : _vm._e(), _vm._t("default")], 2), _vm.subtitle ? _c('HoverSubtitle', {
    staticClass: "button-subtitle",
    attrs: {
      "label": _vm.subtitle
    }
  }) : _vm._e()], 1);
};
var MenuButtonvue_type_template_id_615d8132_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HoverSubtitle/HoverSubtitle.vue?vue&type=template&id=834ab840&scoped=true&
var HoverSubtitlevue_type_template_id_834ab840_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    staticClass: "hover-subtitle caption"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]);
};
var HoverSubtitlevue_type_template_id_834ab840_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HoverSubtitle/HoverSubtitle.vue?vue&type=script&lang=ts&

/* harmony default export */ var HoverSubtitlevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    label: {
      type: String,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/HoverSubtitle/HoverSubtitle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var HoverSubtitle_HoverSubtitlevue_type_script_lang_ts_ = (HoverSubtitlevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HoverSubtitle/HoverSubtitle.vue?vue&type=style&index=0&id=834ab840&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HoverSubtitle/HoverSubtitle.vue?vue&type=style&index=0&id=834ab840&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/HoverSubtitle/HoverSubtitle.vue



;


/* normalize component */

var HoverSubtitle_component = normalizeComponent(
  HoverSubtitle_HoverSubtitlevue_type_script_lang_ts_,
  HoverSubtitlevue_type_template_id_834ab840_scoped_true_render,
  HoverSubtitlevue_type_template_id_834ab840_scoped_true_staticRenderFns,
  false,
  null,
  "834ab840",
  null
  
)

/* harmony default export */ var HoverSubtitle = (HoverSubtitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/MenuButton.vue?vue&type=script&lang=ts&




/* harmony default export */ var MenuButtonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    HoverSubtitle: HoverSubtitle
  },
  props: {
    isElementStyle: {
      type: Boolean,
      default: true
    },
    isHovered: {
      type: Boolean,
      default: false
    },
    isActived: {
      type: Boolean,
      default: false
    },
    isCollapsed: {
      type: Boolean,
      default: false
    },
    isBorder: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 41
    },
    icon: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    hasChevron: {
      type: Boolean,
      default: false
    },
    subtitle: {
      type: String,
      default: null
    },
    tag: {
      type: String,
      default: null
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Button/MenuButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Button_MenuButtonvue_type_script_lang_ts_ = (MenuButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/MenuButton.vue?vue&type=style&index=0&id=615d8132&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Button/MenuButton.vue?vue&type=style&index=0&id=615d8132&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Button/MenuButton.vue



;


/* normalize component */

var MenuButton_component = normalizeComponent(
  Button_MenuButtonvue_type_script_lang_ts_,
  MenuButtonvue_type_template_id_615d8132_scoped_true_render,
  MenuButtonvue_type_template_id_615d8132_scoped_true_staticRenderFns,
  false,
  null,
  "615d8132",
  null
  
)

/* harmony default export */ var MenuButton = (MenuButton_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/IconButton.vue?vue&type=template&id=ae396522&scoped=true&
var IconButtonvue_type_template_id_ae396522_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "button"
  }, [_c('span', {
    staticClass: "icon-button",
    class: {
      'icon-button--actived': _vm.isActived,
      'icon-button--hovered': _vm.isHovered
    },
    style: {
      'grid-template-columns': "".concat(_vm.gap, "px auto")
    }
  }, [_vm.icon ? _c('Icon', {
    staticClass: "icon-button__icon",
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._t("default")], 2), _vm.subtitle ? _c('HoverSubtitle', {
    staticClass: "button-subtitle",
    attrs: {
      "label": _vm.subtitle
    }
  }) : _vm._e()], 1);
};
var IconButtonvue_type_template_id_ae396522_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/IconButton.vue?vue&type=script&lang=ts&




/* harmony default export */ var IconButtonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    HoverSubtitle: HoverSubtitle
  },
  props: {
    isHovered: {
      type: Boolean,
      default: false
    },
    isActived: {
      type: Boolean,
      default: false
    },
    gap: {
      type: Number,
      default: 41
    },
    icon: {
      type: String,
      default: null
    },
    subtitle: {
      type: String,
      default: null
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Button/IconButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Button_IconButtonvue_type_script_lang_ts_ = (IconButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Button/IconButton.vue?vue&type=style&index=0&id=ae396522&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Button/IconButton.vue?vue&type=style&index=0&id=ae396522&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Button/IconButton.vue



;


/* normalize component */

var IconButton_component = normalizeComponent(
  Button_IconButtonvue_type_script_lang_ts_,
  IconButtonvue_type_template_id_ae396522_scoped_true_render,
  IconButtonvue_type_template_id_ae396522_scoped_true_staticRenderFns,
  false,
  null,
  "ae396522",
  null
  
)

/* harmony default export */ var IconButton = (IconButton_component.exports);
;// CONCATENATED MODULE: ./src/components/Button/index.ts



/* harmony default export */ var components_Button = (Button);

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProgressCircular/ProgressCircular.vue?vue&type=template&id=de185a10&scoped=true&
var ProgressCircularvue_type_template_id_de185a10_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('progress', {
    staticClass: "progress-circular",
    style: {
      'font-size': "".concat(_vm.fontSize)
    }
  })]);
};
var ProgressCircularvue_type_template_id_de185a10_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProgressCircular/ProgressCircular.vue?vue&type=script&lang=ts&

/* harmony default export */ var ProgressCircularvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    fontSize: {
      type: String,
      default: '16px'
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ProgressCircular/ProgressCircular.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ProgressCircular_ProgressCircularvue_type_script_lang_ts_ = (ProgressCircularvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProgressCircular/ProgressCircular.vue?vue&type=style&index=0&id=de185a10&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProgressCircular/ProgressCircular.vue?vue&type=style&index=0&id=de185a10&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ProgressCircular/ProgressCircular.vue



;


/* normalize component */

var ProgressCircular_component = normalizeComponent(
  ProgressCircular_ProgressCircularvue_type_script_lang_ts_,
  ProgressCircularvue_type_template_id_de185a10_scoped_true_render,
  ProgressCircularvue_type_template_id_de185a10_scoped_true_staticRenderFns,
  false,
  null,
  "de185a10",
  null
  
)

/* harmony default export */ var ProgressCircular = (ProgressCircular_component.exports);
;// CONCATENATED MODULE: ./src/components/ProgressCircular/index.ts

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js

function classCallCheck_classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/typeof.js







function typeof_typeof(o) {
  "@babel/helpers - typeof";

  return typeof_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, typeof_typeof(o);
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-primitive.js
var es_symbol_to_primitive = __webpack_require__(6649);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.date.to-primitive.js
var es_date_to_primitive = __webpack_require__(6078);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPrimitive.js








function _toPrimitive(input, hint) {
  if (typeof_typeof(input) !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof_typeof(res) !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/toPropertyKey.js


function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof_typeof(key) === "symbol" ? key : String(key);
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js

function createClass_defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
  }
}
function createClass_createClass(Constructor, protoProps, staticProps) {
  if (protoProps) createClass_defineProperties(Constructor.prototype, protoProps);
  if (staticProps) createClass_defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.starts-with.js
var es_string_starts_with = __webpack_require__(6755);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.bold.js
var es_string_bold = __webpack_require__(915);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.strike.js
var es_string_strike = __webpack_require__(7397);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.italics.js
var es_string_italics = __webpack_require__(8734);
// EXTERNAL MODULE: ./node_modules/quill-emoji/dist/quill-emoji.js
var quill_emoji = __webpack_require__(364);
var quill_emoji_default = /*#__PURE__*/__webpack_require__.n(quill_emoji);
;// CONCATENATED MODULE: ./src/helpers/vue2editor.ts








var Vue2Editor = /*#__PURE__*/function () {
  function Vue2Editor() {
    classCallCheck_classCallCheck(this, Vue2Editor);
  }
  createClass_createClass(Vue2Editor, null, [{
    key: "init",
    value: function init() {
      this.setupEmojis();
      this.setupLinks();
      this.setupIcons();
    }
  }, {
    key: "setupLinks",
    value: function setupLinks() {
      var Link = quill_default().import('formats/link');
      Link.sanitize = function (url) {
        if (!url.startsWith('http') && !url.startsWith('https') && !url.startsWith('//')) return "//".concat(url);
        return url;
      };
    }
  }, {
    key: "setupEmojis",
    value: function setupEmojis() {
      (quill_emoji_default()).ToolbarEmoji.DEFAULTS = {
        buttonIcon: '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M12 1.25a10.75 10.75 0 110 21.5 10.75 10.75 0 010-21.5zm0 1.5a9.25 9.25 0 100 18.5 9.25 9.25 0 000-18.5zM9.77 14.29a3.25 3.25 0 004.6 0 .75.75 0 111.06 1.07 4.75 4.75 0 01-6.72 0 .75.75 0 111.06-1.06zM9 9a1 1 0 110 2 1 1 0 010-2zm6 0a1 1 0 110 2 1 1 0 010-2z"/></svg>'
      };
      quill_default().register({
        'formats/emoji': (quill_emoji_default()).EmojiBlot,
        'modules/short_name_emoji': (quill_emoji_default()).ShortNameEmoji,
        'modules/toolbar_emoji': (quill_emoji_default()).ToolbarEmoji
      }, true);
    }
  }, {
    key: "setupIcons",
    value: function setupIcons() {
      var icons = quill_default().import('ui/icons');
      icons.openEditor = '<svg width="24" height="24" viewBox="0 0 24 24"><g><mask id="mask0_2135_9466" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="2" y="2" width="20" height="20"><path d="M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H8.25V20.5C8.25 20.8797 8.53215 21.1935 8.89823 21.2432L9 21.25C9.41421 21.25 9.75 20.9142 9.75 20.5V4.25H15C15.3797 4.25 15.6935 3.96785 15.7432 3.60177L15.75 3.5C15.75 3.08579 15.4142 2.75 15 2.75H3ZM13 9.75C12.5858 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 12.5858 11.25 13 11.25H16.25V20.5C16.25 20.8797 16.5322 21.1935 16.8982 21.2432L17 21.25C17.4142 21.25 17.75 20.9142 17.75 20.5V11.25H21C21.3797 11.25 21.6935 10.9678 21.7432 10.6018L21.75 10.5C21.75 10.0858 21.4142 9.75 21 9.75H13Z" /></mask><g><path d="M3 2.75C2.58579 2.75 2.25 3.08579 2.25 3.5C2.25 3.91421 2.58579 4.25 3 4.25H8.25V20.5C8.25 20.8797 8.53215 21.1935 8.89823 21.2432L9 21.25C9.41421 21.25 9.75 20.9142 9.75 20.5V4.25H15C15.3797 4.25 15.6935 3.96785 15.7432 3.60177L15.75 3.5C15.75 3.08579 15.4142 2.75 15 2.75H3ZM13 9.75C12.5858 9.75 12.25 10.0858 12.25 10.5C12.25 10.9142 12.5858 11.25 13 11.25H16.25V20.5C16.25 20.8797 16.5322 21.1935 16.8982 21.2432L17 21.25C17.4142 21.25 17.75 20.9142 17.75 20.5V11.25H21C21.3797 11.25 21.6935 10.9678 21.7432 10.6018L21.75 10.5C21.75 10.0858 21.4142 9.75 21 9.75H13Z" /></g></g></svg>';
      icons.closeEditor = '<svg width="24" height="24" viewBox="0 0 24 24"> <path d="M6.53 5.47L12 10.94l5.47-5.47a.75.75 0 01.98-.07l.08.07c.3.3.3.77 0 1.06L13.06 12l5.47 5.47a.75.75 0 01-1.06 1.06L12 13.06l-5.47 5.47a.75.75 0 01-1.06-1.06L10.94 12 5.47 6.53a.75.75 0 011.06-1.06z" /></svg>';
      icons.bold = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M6.25,3.5 C6.25,3.08578644 6.58578644,2.75 7,2.75 L14,2.75 C16.6233526,2.75 18.75,4.87664744 18.75,7.5 C18.75,9.05577146 18.0020479,10.4368493 16.846113,11.3032644 C18.5677681,12.1634623 19.75,13.9436686 19.75,16 C19.75,18.8994949 17.3994949,21.25 14.5,21.25 L7,21.25 C6.58578644,21.25 6.25,20.9142136 6.25,20.5 L6.25,3.5 Z M14.5,12.25 L7.75,12.25 L7.75,19.75 L14.5,19.75 C16.5710678,19.75 18.25,18.0710678 18.25,16 C18.25,13.9289322 16.5710678,12.25 14.5,12.25 Z M14,4.25 L7.75,4.25 L7.75,10.75 L14,10.75 C15.7949254,10.75 17.25,9.29492544 17.25,7.5 C17.25,5.70507456 15.7949254,4.25 14,4.25 Z" /></svg>';
      icons.strike = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M18.0012 4.24805H12.7512V8.74805C12.7512 9.16226 12.4154 9.49805 12.0012 9.49805C11.587 9.49805 11.2512 9.16226 11.2512 8.74805V4.24805H6.00117C5.58696 4.24805 5.25117 3.91226 5.25117 3.49805C5.25117 3.08383 5.58696 2.74805 6.00117 2.74805H12.0012H18.0012C18.4154 2.74805 18.7512 3.08383 18.7512 3.49805C18.7512 3.91226 18.4154 4.24805 18.0012 4.24805ZM4.00195 12.7488C3.58774 12.7488 3.25195 12.413 3.25195 11.9988C3.25195 11.5846 3.58774 11.2488 4.00195 11.2488H20.002C20.4162 11.2488 20.752 11.5846 20.752 11.9988C20.752 12.413 20.4162 12.7488 20.002 12.7488H4.00195ZM11.2512 20.4973V15.2473C11.2512 14.8331 11.587 14.4973 12.0012 14.4973C12.4154 14.4973 12.7512 14.8331 12.7512 15.2473V20.4973C12.7512 20.9115 12.4154 21.2473 12.0012 21.2473C11.587 21.2473 11.2512 20.9115 11.2512 20.4973Z" /></svg>';
      icons.list.ordered = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M5.75,17 C5.88807119,17 6,17.1119288 6,17.25 L6,17.25 L6,20.75 C6,20.8880712 5.88807119,21 5.75,21 L5.75,21 L3.5,21 C3.22385763,21 3,20.7761424 3,20.5 C3,20.2238576 3.22385763,20 3.5,20 L3.5,20 L5,20 L5,19.5 L4.5,19.5 C4.22385763,19.5 4,19.2761424 4,19 C4,18.7238576 4.22385763,18.5 4.5,18.5 L4.5,18.5 L5,18.5 L5,18 L3.5,18 C3.22385763,18 3,17.7761424 3,17.5 C3,17.2238576 3.22385763,17 3.5,17 L3.5,17 Z M21,18.25 C21.4142136,18.25 21.75,18.5857864 21.75,19 C21.75,19.4142136 21.4142136,19.75 21,19.75 L21,19.75 L9,19.75 C8.58578644,19.75 8.25,19.4142136 8.25,19 C8.25,18.5857864 8.58578644,18.25 9,18.25 L9,18.25 Z M5.75,10 C5.88807119,10 6,10.1119288 6,10.25 L6,10.25 L6,10.807519 C6,10.8671968 5.97865196,10.924906 5.93981415,10.9702168 L5.93981415,10.9702168 L4.2,13 L5.5,13 C5.77614237,13 6,13.2238576 6,13.5 C6,13.7761424 5.77614237,14 5.5,14 L5.5,14 L3.25,14 C3.11192881,14 3,13.8880712 3,13.75 L3,13.75 L3,13.192481 C3,13.1328032 3.02134804,13.075094 3.06018585,13.0297832 L3.06018585,13.0297832 L4.8,11 L3.5,11 C3.22385763,11 3,10.7761424 3,10.5 C3,10.2238576 3.22385763,10 3.5,10 L3.5,10 Z M21,11.25 C21.4142136,11.25 21.75,11.5857864 21.75,12 C21.75,12.4142136 21.4142136,12.75 21,12.75 L21,12.75 L9,12.75 C8.58578644,12.75 8.25,12.4142136 8.25,12 C8.25,11.5857864 8.58578644,11.25 9,11.25 L9,11.25 Z M4.75,3 C4.88807119,3 5,3.11192881 5,3.25 L5,3.25 L5,6.5 C5,6.77614237 4.77614237,7 4.5,7 C4.22385763,7 4,6.77614237 4,6.5 L4,6.5 L4,4 L3.5,4 C3.22385763,4 3,3.77614237 3,3.5 C3,3.22385763 3.22385763,3 3.5,3 L3.5,3 Z M21,4.25 C21.4142136,4.25 21.75,4.58578644 21.75,5 C21.75,5.41421356 21.4142136,5.75 21,5.75 L21,5.75 L9,5.75 C8.58578644,5.75 8.25,5.41421356 8.25,5 C8.25,4.58578644 8.58578644,4.25 9,4.25 L9,4.25 Z" /></svg>';
      icons.list.bullet = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M4,18 C4.55228475,18 5,18.4477153 5,19 C5,19.5522847 4.55228475,20 4,20 C3.44771525,20 3,19.5522847 3,19 C3,18.4477153 3.44771525,18 4,18 Z M21,18.25 C21.4142136,18.25 21.75,18.5857864 21.75,19 C21.75,19.4142136 21.4142136,19.75 21,19.75 L21,19.75 L9,19.75 C8.58578644,19.75 8.25,19.4142136 8.25,19 C8.25,18.5857864 8.58578644,18.25 9,18.25 L9,18.25 Z M4,11 C4.55228475,11 5,11.4477153 5,12 C5,12.5522847 4.55228475,13 4,13 C3.44771525,13 3,12.5522847 3,12 C3,11.4477153 3.44771525,11 4,11 Z M21,11.25 C21.4142136,11.25 21.75,11.5857864 21.75,12 C21.75,12.4142136 21.4142136,12.75 21,12.75 L21,12.75 L9,12.75 C8.58578644,12.75 8.25,12.4142136 8.25,12 C8.25,11.5857864 8.58578644,11.25 9,11.25 L9,11.25 Z M4,4 C4.55228475,4 5,4.44771525 5,5 C5,5.55228475 4.55228475,6 4,6 C3.44771525,6 3,5.55228475 3,5 C3,4.44771525 3.44771525,4 4,4 Z M21,4.25 C21.4142136,4.25 21.75,4.58578644 21.75,5 C21.75,5.41421356 21.4142136,5.75 21,5.75 L21,5.75 L9,5.75 C8.58578644,5.75 8.25,5.41421356 8.25,5 C8.25,4.58578644 8.58578644,4.25 9,4.25 L9,4.25 Z" /></svg>';
      icons.underline = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M19,19.75 C19.4142136,19.75 19.75,20.0857864 19.75,20.5 C19.75,20.9142136 19.4142136,21.25 19,21.25 L19,21.25 L5,21.25 C4.58578644,21.25 4.25,20.9142136 4.25,20.5 C4.25,20.0857864 4.58578644,19.75 5,19.75 L5,19.75 Z M18,2.75 C18.4142136,2.75 18.75,3.08578644 18.75,3.5 L18.75,3.5 L18.75,11.5 C18.75,15.2279221 15.7279221,18.25 12,18.25 C8.27207794,18.25 5.25,15.2279221 5.25,11.5 L5.25,11.5 L5.25,3.5 C5.25,3.08578644 5.58578644,2.75 6,2.75 C6.41421356,2.75 6.75,3.08578644 6.75,3.5 L6.75,3.5 L6.75,11.5 C6.75,14.3994949 9.10050506,16.75 12,16.75 C14.8994949,16.75 17.25,14.3994949 17.25,11.5 L17.25,11.5 L17.25,3.5 C17.25,3.08578644 17.5857864,2.75 18,2.75 Z" /></svg>';
      icons.italic = '<svg width="24" height="24" viewBox="0 0 24 24"><path d="M18.5,2.75 C18.9142136,2.75 19.25,3.08578644 19.25,3.5 C19.25,3.91421356 18.9142136,4.25 18.5,4.25 L18.5,4.25 L15.766,4.24979756 L9.839,19.7497976 L12.5,19.75 C12.8796958,19.75 13.193491,20.0321539 13.2431534,20.3982294 L13.25,20.5 C13.25,20.9142136 12.9142136,21.25 12.5,21.25 L12.5,21.25 L5.5,21.25 C5.08578644,21.25 4.75,20.9142136 4.75,20.5 C4.75,20.0857864 5.08578644,19.75 5.5,19.75 L5.5,19.75 L8.233,19.7497976 L14.16,4.24979756 L11.5,4.25 C11.1203042,4.25 10.806509,3.96784612 10.7568466,3.60177056 L10.75,3.5 C10.75,3.08578644 11.0857864,2.75 11.5,2.75 L11.5,2.75 Z" /></svg>';
    }
  }]);
  return Vue2Editor;
}();

function getEditorSettings() {
  Vue2Editor.init();
  var toolbar = ['bold', 'strike', {
    list: 'ordered'
  }, {
    list: 'bullet'
  }, 'underline', 'italic', 'emoji'];
  return {
    modules: {
      short_name_emoji: true,
      toolbar_emoji: true,
      toolbar: toolbar
    }
  };
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=script&lang=ts&









/* harmony default export */ var AnnotationInputCardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Button: components_Button,
    VueEditor: VueEditor,
    ProgressCircular: ProgressCircular
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    value: {
      type: String,
      required: true
    },
    videoTimeStamp: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: 'Escreva sua anotação...'
    },
    addButtonLabel: {
      type: String,
      default: 'Adicionar'
    },
    editButtonLabel: {
      type: String,
      default: 'Editar'
    },
    saveButtonLabel: {
      type: String,
      default: 'Salvar'
    },
    cancelButtonLabel: {
      type: String,
      default: 'Cancelar'
    },
    deleteButtonLabel: {
      type: String,
      default: 'Excluir'
    },
    short: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    isEditing: {
      type: Boolean,
      default: false
    },
    isAdding: {
      type: Boolean,
      default: false
    },
    isSaveDisabled: {
      type: Boolean,
      default: false
    },
    onlyContent: {
      type: Boolean,
      default: false
    },
    withTextEditor: {
      type: Boolean,
      default: false
    },
    isDraft: {
      type: Boolean,
      default: false
    },
    activeModal: {
      type: Boolean,
      default: false
    },
    deleteDraftLabel: {
      type: String,
      default: 'Excluir rascunho'
    },
    canCopyNote: {
      type: Boolean,
      default: false
    },
    copyNoteLabel: {
      type: String,
      default: 'Copiar para minhas notas'
    },
    closeButtonLabel: {
      type: String,
      default: 'Fechar'
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    profileName: {
      type: String,
      default: ''
    },
    isLikable: {
      type: Boolean,
      default: false
    },
    isLiked: {
      type: Boolean,
      default: false
    },
    totalLikes: {
      type: Number,
      default: 0
    },
    likeButtonScreenReaderText: {
      type: String,
      default: 'Curtir'
    },
    unlikeButtonScreenReaderText: {
      type: String,
      default: 'Descurtir'
    }
  },
  data: function data() {
    return {
      internalValue: this.value,
      isOpenInput: !!this.value,
      isHoverCard: false,
      editorSettings: {},
      hideToolbar: false,
      shouldShowEditor: true,
      isOptionsOpened: false
    };
  },
  created: function created() {
    if (this.withTextEditor) Vue2Editor.init();
    this.editorSettings = this.getEditorSettings();
  },
  computed: {
    showInternalValue: function showInternalValue() {
      return this.internalValue;
    },
    showAddButton: function showAddButton() {
      return this.isAdding && !!this.value;
    },
    showSaveButton: function showSaveButton() {
      return this.isEditing && !!this.value;
    },
    showMoreButton: function showMoreButton() {
      var isDraft = this.isOpenInput && this.isAdding && this.isDraft;
      return isDraft || this.canCopyNote;
    },
    optionsItems: function optionsItems() {
      return [].concat(_toConsumableArray(this.isDraft ? [{
        label: this.deleteDraftLabel,
        clickHandler: this.deleteDraft
      }] : []), _toConsumableArray(this.canCopyNote ? [{
        label: this.copyNoteLabel,
        clickHandler: this.onCopyNote
      }] : []));
    }
  },
  watch: {
    value: function value(newValue) {
      !this.withTextEditor && this.forceValueUpdate(newValue);
      this.internalValue = newValue;
    }
  },
  methods: {
    openInput: function openInput() {
      var _this$$refs$annotatio, _this$$refs$editor;
      this.isOpenInput = true;
      (_this$$refs$annotatio = this.$refs.annotation) === null || _this$$refs$annotatio === void 0 || _this$$refs$annotatio.focus();
      (_this$$refs$editor = this.$refs.editor) === null || _this$$refs$editor === void 0 || _this$$refs$editor.quill.focus();
    },
    blurHandler: function blurHandler(e) {
      this.isOpenInput = this.isEditing ? true : !!this.internalValue;
      this.isOptionsOpened = this.isOpenInput && this.isOptionsOpened;
      this.withTextEditor ? this.$emit('blur', e) : this.$emit('blur', e.target.value);
    },
    focusHandler: function focusHandler(e) {
      this.withTextEditor ? this.$emit('focus', e) : this.$emit('focus', e.target.value);
    },
    inputHandler: function inputHandler(e) {
      this.internalValue = this.withTextEditor ? e : e.target.value;
      this.withTextEditor ? this.$emit('input', e) : this.$emit('input', e.target.value);
      this.blurHandler(e);
    },
    onMouseOver: function onMouseOver() {
      this.isHoverCard = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.isHoverCard = false;
    },
    onEditClick: function onEditClick() {
      this.$emit('onEditClick');
    },
    onDeleteClick: function onDeleteClick() {
      this.$emit('onDeleteClick');
    },
    onSaveClick: function onSaveClick() {
      this.$emit('onSaveClick');
    },
    onCancelClick: function onCancelClick() {
      this.$emit('onCancelClick');
    },
    onAddClick: function onAddClick() {
      this.$emit('onAddClick');
    },
    forceValueUpdate: function forceValueUpdate(value) {
      var inputRef = this.$refs.annotation;
      inputRef.value = value;
      inputRef.dispatchEvent(new Event('input', {
        bubbles: true
      }));
    },
    getEditorSettings: function getEditorSettings() {
      var _this = this;
      return {
        modules: {
          toolbar: {
            container: ['openEditor', 'closeEditor', 'bold', 'strike', {
              list: 'ordered'
            }, {
              list: 'bullet'
            }, 'underline', 'italic', 'emoji'],
            handlers: {
              openEditor: function openEditor() {
                _this.shouldShowEditor = false;
              },
              closeEditor: function closeEditor() {
                _this.shouldShowEditor = true;
              }
            }
          }
        }
      };
    },
    toggleMoreOptions: function toggleMoreOptions() {
      this.isOptionsOpened = this.isOpenInput && !this.isOptionsOpened;
    },
    deleteDraft: function deleteDraft() {
      this.isOptionsOpened = false;
      this.$emit('onDeleteDraftOptionClick');
    },
    onCopyNote: function onCopyNote() {
      this.isOptionsOpened = false;
      this.$emit('onCopyNoteClick');
    },
    onLikeClick: function onLikeClick() {
      this.$emit('onLikeClick');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var AnnotationInputCard_AnnotationInputCardvue_type_script_lang_ts_ = (AnnotationInputCardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=style&index=0&id=97c2a1c8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=style&index=0&id=97c2a1c8&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=style&index=1&id=97c2a1c8&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AnnotationInputCard/AnnotationInputCard.vue?vue&type=style&index=1&id=97c2a1c8&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/AnnotationInputCard/AnnotationInputCard.vue



;



/* normalize component */

var AnnotationInputCard_component = normalizeComponent(
  AnnotationInputCard_AnnotationInputCardvue_type_script_lang_ts_,
  AnnotationInputCardvue_type_template_id_97c2a1c8_scoped_true_render,
  AnnotationInputCardvue_type_template_id_97c2a1c8_scoped_true_staticRenderFns,
  false,
  null,
  "97c2a1c8",
  null
  
)

/* harmony default export */ var AnnotationInputCard = (AnnotationInputCard_component.exports);
;// CONCATENATED MODULE: ./src/components/AnnotationInputCard/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInput.vue?vue&type=template&id=0c7bddc2&scoped=true&
var AutoCompleteInputvue_type_template_id_0c7bddc2_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "autocomplete",
    on: {
      "click": _vm.displayDropDown
    }
  }, [_c('OutlinedTextInput', {
    staticClass: "autocomplete__input",
    attrs: {
      "label": _vm.label,
      "large": _vm.large,
      "required": _vm.required,
      "placeholder": _vm.placeholder,
      "disabled": _vm.disabled
    },
    on: {
      "blur": _vm.isInputBlur,
      "focus": _vm.isInputFocus
    },
    nativeOn: {
      "input": function input($event) {
        return _vm.inputHandler.apply(null, arguments);
      }
    },
    model: {
      value: _vm.input,
      callback: function callback($$v) {
        _vm.input = $$v;
      },
      expression: "input"
    }
  }, [_vm.selected.img && _vm.selected.value === _vm.input ? _c('img', {
    staticClass: "autocomplete__input__img",
    attrs: {
      "src": _vm.selected.img
    }
  }) : _vm.iconTextInput ? _c('Icon', {
    staticClass: "autocomplete__input__icon",
    attrs: {
      "name": _vm.iconTextInput
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "autocomplete__options"
  }, [_c('AutoCompleteInputOptions', {
    attrs: {
      "highlighted-text": _vm.input,
      "value": _vm.selected,
      "focused": _vm.dropDownEnabled && _vm.inputFocus,
      "options": _vm.inputArray
    },
    on: {
      "selected": _vm.selectOption
    }
  })], 1)], 1);
};
var AutoCompleteInputvue_type_template_id_0c7bddc2_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.filter.js
var es_array_filter = __webpack_require__(7327);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.includes.js
var es_array_includes = __webpack_require__(6699);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.includes.js
var es_string_includes = __webpack_require__(2023);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue?vue&type=template&id=30d871ec&scoped=true&
var AutoCompleteInputOptionsvue_type_template_id_30d871ec_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "dropdown-animation"
    }
  }, [_vm.focused ? _c('ol', {
    staticClass: "dropdown"
  }, _vm._l(_vm.options, function (option) {
    return _c('li', {
      key: option.key,
      staticClass: "dropdown__item subtitle-1",
      class: {
        'dropdown__item--selected': _vm.isOptionSelected(option)
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectOption(option);
        },
        "mousedown": function mousedown($event) {
          return _vm.selectOption(option);
        }
      }
    }, [_vm.selectedMark && _vm.isOptionSelected(option) ? _c('span', {
      staticClass: "dropdown__item__selected"
    }) : _vm._e(), !!option.img ? _c('img', {
      staticClass: "dropdown__item__img",
      attrs: {
        "src": option.img
      }
    }) : _vm._e(), _c('span', {
      staticClass: "dropdown__item__value",
      domProps: {
        "innerHTML": _vm._s(_vm.itemValueHtml(option))
      }
    })]);
  }), 0) : _vm._e()]);
};
var AutoCompleteInputOptionsvue_type_template_id_30d871ec_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.constructor.js
var es_regexp_constructor = __webpack_require__(4603);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.dot-all.js
var es_regexp_dot_all = __webpack_require__(8450);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.regexp.sticky.js
var es_regexp_sticky = __webpack_require__(8386);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.replace.js
var es_string_replace = __webpack_require__(5306);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue?vue&type=script&lang=ts&








/* harmony default export */ var AutoCompleteInputOptionsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    value: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    selectedMark: {
      type: Boolean,
      default: false
    },
    highlightedText: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    var selected = this.value;
    return {
      selected: selected
    };
  },
  watch: {
    value: function value(newValue) {
      this.selected = newValue;
    }
  },
  methods: {
    selectOption: function selectOption(option) {
      this.selected = option;
      this.$emit('selected', this.selected);
    },
    isOptionSelected: function isOptionSelected(option) {
      return this.selected.value === option.value;
    },
    itemValueHtml: function itemValueHtml(option) {
      var regex = new RegExp(this.highlightedText, 'i');
      return option.value.replace(regex, function (substring) {
        return substring.bold();
      });
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var AutoCompleteInput_AutoCompleteInputOptionsvue_type_script_lang_ts_ = (AutoCompleteInputOptionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue?vue&type=style&index=0&id=30d871ec&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue?vue&type=style&index=0&id=30d871ec&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInputOptions.vue



;


/* normalize component */

var AutoCompleteInputOptions_component = normalizeComponent(
  AutoCompleteInput_AutoCompleteInputOptionsvue_type_script_lang_ts_,
  AutoCompleteInputOptionsvue_type_template_id_30d871ec_scoped_true_render,
  AutoCompleteInputOptionsvue_type_template_id_30d871ec_scoped_true_staticRenderFns,
  false,
  null,
  "30d871ec",
  null
  
)

/* harmony default export */ var AutoCompleteInputOptions = (AutoCompleteInputOptions_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedTextInput/OutlinedTextInput.vue?vue&type=template&id=a242a76e&scoped=true&
var OutlinedTextInputvue_type_template_id_a242a76e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "outlined-text-input",
    class: {
      'outlined-text-input--disabled': _vm.disabled,
      'outlined-text-input--enabled': !_vm.disabled
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.hoverHandler(true);
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hoverHandler(false);
      }
    }
  }, [!!_vm.icon ? _c('Icon', {
    staticClass: "outlined-text-input__icon",
    attrs: {
      "name": _vm.icon
    }
  }) : _vm._e(), _vm._t("default"), _c(_vm.inputElement, {
    ref: "input",
    tag: "component",
    staticClass: "input",
    class: {
      'subtitle-1': !_vm.large,
      'input--large': _vm.large,
      h6: _vm.large
    },
    attrs: {
      "type": "text",
      "disabled": _vm.disabled,
      "placeholder": _vm.placeholderText,
      "readonly": _vm.readonly,
      "value": _vm.internalValue,
      "maxlength": _vm.maxlength
    },
    on: {
      "blur": _vm.blurHandler,
      "focus": _vm.focusHandler,
      "input": _vm.inputHandler
    }
  }, [_vm._v(_vm._s(_vm.inputElement === 'textarea' ? _vm.internalValue : null))]), _vm.outline ? _c('Outline', {
    attrs: {
      "disabled": _vm.disabled,
      "focused": _vm.isFocused,
      "has-content": _vm.hasContent,
      "has-error": _vm.hasError,
      "hovering": _vm.isHovering,
      "label": _vm.label,
      "label-left-offset": _vm.outlineLabelOffset,
      "large": _vm.large,
      "required": _vm.required
    }
  }) : _vm._e()], 2);
};
var OutlinedTextInputvue_type_template_id_a242a76e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Outline/Outline.vue?vue&type=template&id=6c5a9701&scoped=true&
var Outlinevue_type_template_id_6c5a9701_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "outline",
    class: {
      'outline--error': _vm.hasError,
      'outline--focused': _vm.focused,
      'outline--hovering': _vm.hovering
    }
  }, [_c('div', {
    staticClass: "outline__left"
  }), _c('div', {
    staticClass: "outline__center",
    class: {
      'outline__center--notch': _vm.shouldMinimizeLabel
    }
  }, [_vm.label ? _c('label', {
    staticClass: "label",
    class: {
      'label--disabled': _vm.disabled,
      'label--error': _vm.hasError,
      'label--focused': _vm.focused,
      'label--minified': _vm.shouldMinimizeLabel,
      'subtitle-1': !_vm.large,
      h6: _vm.large
    },
    style: _vm.labelInlineStyle
  }, [_vm._v(" " + _vm._s(_vm.label)), _vm.required ? _c('span', {
    staticClass: "label__required"
  }, [_vm._v("*")]) : _vm._e()]) : _vm._e()]), _c('div', {
    staticClass: "outline__right"
  })]);
};
var Outlinevue_type_template_id_6c5a9701_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Outline/Outline.vue?vue&type=script&lang=ts&


/* harmony default export */ var Outline_Outlinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    focused: {
      type: Boolean,
      default: false
    },
    hasContent: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    hovering: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    labelLeftOffset: {
      type: Number,
      default: 0
    },
    large: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    labelInlineStyle: function labelInlineStyle() {
      return {
        marginLeft: this.labelLeftOffset ? "".concat(this.labelLeftOffset, "px") : undefined,
        marginTop: this.large ? '22px' : '12px'
      };
    },
    shouldMinimizeLabel: function shouldMinimizeLabel() {
      return this.focused || this.hasContent;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Outline/Outline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Outline_Outlinevue_type_script_lang_ts_ = (Outline_Outlinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Outline/Outline.vue?vue&type=style&index=0&id=6c5a9701&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Outline/Outline.vue?vue&type=style&index=0&id=6c5a9701&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Outline/Outline.vue



;


/* normalize component */

var Outline_Outline_component = normalizeComponent(
  components_Outline_Outlinevue_type_script_lang_ts_,
  Outlinevue_type_template_id_6c5a9701_scoped_true_render,
  Outlinevue_type_template_id_6c5a9701_scoped_true_staticRenderFns,
  false,
  null,
  "6c5a9701",
  null
  
)

/* harmony default export */ var Outline_Outline = (Outline_Outline_component.exports);
;// CONCATENATED MODULE: ./src/components/Outline/index.ts

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedTextInput/OutlinedTextInput.vue?vue&type=script&lang=ts&




/* harmony default export */ var OutlinedTextInputvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Outline: Outline_Outline
  },
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String,
      default: ''
    },
    inputElement: {
      type: String,
      default: 'input'
    },
    label: {
      type: String,
      default: ''
    },
    large: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      required: true
    },
    maskFormatter: {
      type: Function,
      default: null
    },
    outline: {
      type: Boolean,
      default: true
    },
    readonly: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
      required: false
    }
  },
  data: function data() {
    return {
      internalValue: this.maskFormatter !== null ? this.maskFormatter(this.value) : this.value,
      isFocused: false,
      isHovering: false
    };
  },
  computed: {
    hasContent: function hasContent() {
      return !!this.value;
    },
    outlineLabelOffset: function outlineLabelOffset() {
      var offset = this.large ? 38 : 24;
      return this.icon ? offset : null;
    },
    placeholderText: function placeholderText() {
      return this.isFocused ? this.placeholder : '';
    }
  },
  watch: {
    value: function value(newValue) {
      var updatedValue = newValue;
      if (this.maskFormatter !== null) {
        updatedValue = this.maskFormatter(updatedValue);
      }
      this.forceValueUpdate(updatedValue);
      this.internalValue = updatedValue;
    }
  },
  methods: {
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e.target.value);
    },
    focusHandler: function focusHandler(e) {
      this.isFocused = true;
      this.$emit('focus', e.target.value);
    },
    inputHandler: function inputHandler(e) {
      this.$emit('input', e.target.value);
    },
    forceValueUpdate: function forceValueUpdate(value) {
      var inputRef = this.$refs.input;
      inputRef.value = value;
      var event = document.createEvent('HTMLEvents');
      event.initEvent('input', true, true);
      inputRef.dispatchEvent(event);
    },
    hoverHandler: function hoverHandler(hovering) {
      this.isHovering = hovering;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/OutlinedTextInput/OutlinedTextInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var OutlinedTextInput_OutlinedTextInputvue_type_script_lang_ts_ = (OutlinedTextInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedTextInput/OutlinedTextInput.vue?vue&type=style&index=0&id=a242a76e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/OutlinedTextInput/OutlinedTextInput.vue?vue&type=style&index=0&id=a242a76e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/OutlinedTextInput/OutlinedTextInput.vue



;


/* normalize component */

var OutlinedTextInput_component = normalizeComponent(
  OutlinedTextInput_OutlinedTextInputvue_type_script_lang_ts_,
  OutlinedTextInputvue_type_template_id_a242a76e_scoped_true_render,
  OutlinedTextInputvue_type_template_id_a242a76e_scoped_true_staticRenderFns,
  false,
  null,
  "a242a76e",
  null
  
)

/* harmony default export */ var OutlinedTextInput = (OutlinedTextInput_component.exports);
;// CONCATENATED MODULE: ./src/components/OutlinedTextInput/index.ts

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInput.vue?vue&type=script&lang=ts&








/* harmony default export */ var AutoCompleteInputvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    AutoCompleteInputOptions: AutoCompleteInputOptions,
    OutlinedTextInput: OutlinedTextInput,
    Icon: Icon
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    options: {
      type: Array,
      required: true
    },
    fallbackOption: {
      type: Object,
      required: false
    },
    iconTextInput: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    openDropDownAtFirstClick: {
      type: Boolean,
      default: false
    },
    label: {
      type: String,
      default: ''
    },
    placeholder: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      input: this.value.value || '',
      dropDownEnabled: false,
      inputArray: this.options,
      selected: this.value,
      inputFocus: false,
      internalOptions: this.options
    };
  },
  computed: {
    hasContent: function hasContent() {
      return this.input.length > (this.openDropDownAtFirstClick ? -1 : 0);
    }
  },
  watch: {
    value: function value(newValue) {
      this.input = newValue.value;
      this.selected = newValue;
    },
    options: function options(value) {
      this.internalOptions = value;
      this.filterOptions();
    }
  },
  methods: {
    filterOptions: function filterOptions() {
      var _this = this;
      this.inputArray = this.internalOptions.filter(function (item) {
        return item.value.toLowerCase().includes(_this.input.toLowerCase());
      });
      if (this.fallbackOption && this.inputArray.length === 0) this.inputArray = [this.fallbackOption];
    },
    displayDropDown: function displayDropDown() {
      this.dropDownEnabled = this.hasContent;
      if (this.hasContent) this.filterOptions();
    },
    inputHandler: function inputHandler() {
      this.$emit('input', this.input);
      this.displayDropDown();
    },
    closeDropDown: function closeDropDown() {
      this.dropDownEnabled = false;
    },
    selectOption: function selectOption(event) {
      this.selected = event;
      this.$emit('selected', this.selected);
      this.closeDropDown();
    },
    isInputFocus: function isInputFocus() {
      this.input = this.selected.value || '';
      this.inputFocus = true;
    },
    isInputBlur: function isInputBlur() {
      this.input = this.selected.value || '';
      this.inputFocus = false;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var AutoCompleteInput_AutoCompleteInputvue_type_script_lang_ts_ = (AutoCompleteInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutoCompleteInput/AutoCompleteInput.vue?vue&type=style&index=0&id=0c7bddc2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInput.vue?vue&type=style&index=0&id=0c7bddc2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/AutoCompleteInput.vue



;


/* normalize component */

var AutoCompleteInput_component = normalizeComponent(
  AutoCompleteInput_AutoCompleteInputvue_type_script_lang_ts_,
  AutoCompleteInputvue_type_template_id_0c7bddc2_scoped_true_render,
  AutoCompleteInputvue_type_template_id_0c7bddc2_scoped_true_staticRenderFns,
  false,
  null,
  "0c7bddc2",
  null
  
)

/* harmony default export */ var AutoCompleteInput = (AutoCompleteInput_component.exports);
;// CONCATENATED MODULE: ./src/components/AutoCompleteInput/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Avatar/Avatar.vue?vue&type=template&id=54e4ee4e&scoped=true&
var Avatarvue_type_template_id_54e4ee4e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.src ? _c('img', {
    staticClass: "img",
    attrs: {
      "width": _vm.size,
      "height": _vm.size,
      "src": _vm.src,
      "alt": _vm.alt,
      "title": _vm.title
    }
  }) : _c('Icon', {
    attrs: {
      "name": "accountCircle",
      "size": _vm.size
    }
  });
};
var Avatarvue_type_template_id_54e4ee4e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Avatar/Avatar.vue?vue&type=script&lang=ts&



/* harmony default export */ var Avatarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    src: {
      type: String,
      default: ''
    },
    size: {
      type: Number,
      default: 24
    },
    alt: {
      type: String,
      default: 'avatar'
    },
    title: {
      type: String,
      default: 'avatar'
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Avatar_Avatarvue_type_script_lang_ts_ = (Avatarvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Avatar/Avatar.vue?vue&type=style&index=0&id=54e4ee4e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue?vue&type=style&index=0&id=54e4ee4e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Avatar/Avatar.vue



;


/* normalize component */

var Avatar_component = normalizeComponent(
  Avatar_Avatarvue_type_script_lang_ts_,
  Avatarvue_type_template_id_54e4ee4e_scoped_true_render,
  Avatarvue_type_template_id_54e4ee4e_scoped_true_staticRenderFns,
  false,
  null,
  "54e4ee4e",
  null
  
)

/* harmony default export */ var Avatar = (Avatar_component.exports);
;// CONCATENATED MODULE: ./src/components/Avatar/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Badge/Badge.vue?vue&type=template&id=3ada9b1c&scoped=true&

var Badgevue_type_template_id_3ada9b1c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('button', {
    staticClass: "badge",
    class: {
      'badge-mini': _vm.mini,
      'badge-small': _vm.small,
      'badge-medium': _vm.medium,
      'badge-large': _vm.large,
      'badge-x-large': _vm.xLarge,
      'badge-secondary': _vm.secondary,
      'badge-success': _vm.success,
      'badge-danger': _vm.danger,
      'badge-warning': _vm.warning,
      'subtitle-1': _vm.large || _vm.medium,
      'subtitle-2': _vm.small
    },
    attrs: {
      "role": "presentation"
    }
  }, [_vm._t("default")], 2);
};
var Badgevue_type_template_id_3ada9b1c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=template&id=3ada9b1c&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Badge/Badge.vue?vue&type=script&lang=ts&

/* harmony default export */ var Badgevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    mini: Boolean,
    small: Boolean,
    medium: Boolean,
    large: Boolean,
    xLarge: Boolean,
    secondary: Boolean,
    success: Boolean,
    danger: Boolean,
    warning: Boolean
  }
}));
;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Badge_Badgevue_type_script_lang_ts_ = (Badgevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Badge/Badge.vue?vue&type=style&index=0&id=3ada9b1c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue?vue&type=style&index=0&id=3ada9b1c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Badge/Badge.vue



;


/* normalize component */

var Badge_component = normalizeComponent(
  Badge_Badgevue_type_script_lang_ts_,
  Badgevue_type_template_id_3ada9b1c_scoped_true_render,
  Badgevue_type_template_id_3ada9b1c_scoped_true_staticRenderFns,
  false,
  null,
  "3ada9b1c",
  null
  
)

/* harmony default export */ var Badge = (Badge_component.exports);
;// CONCATENATED MODULE: ./src/components/Badge/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BigToast/BigToast.vue?vue&type=template&id=11cb3836&scoped=true&
var BigToastvue_type_template_id_11cb3836_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "big-toast"
  }, [_c('button', {
    staticClass: "big-toast__close",
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.closeBigToast
    }
  }, [_c('Icon', {
    staticClass: "big-toast__close__icon",
    attrs: {
      "name": "close",
      "size": 32
    }
  })], 1), _c('Icon', {
    staticClass: "big-toast__icon hide-for-small",
    attrs: {
      "name": _vm.icon,
      "size": 24
    }
  }), _c('div', {
    staticClass: "big-toast__content"
  }, [_c('span', {
    staticClass: "h6 big-toast__description"
  }, [_vm._t("description")], 2), _vm.ctaLink ? _c('a', {
    staticClass: "h6 big-toast__cta",
    attrs: {
      "href": _vm.ctaLink,
      "target": "#"
    }
  }, [_vm._t("cta")], 2) : _vm._e()])], 1) : _vm._e()]);
};
var BigToastvue_type_template_id_11cb3836_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BigToast/BigToast.vue?vue&type=script&lang=ts&


/* harmony default export */ var BigToastvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    icon: {
      type: String
    },
    ctaLink: {
      type: String
    }
  },
  methods: {
    closeBigToast: function closeBigToast() {
      this.$emit('update:visible', false);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/BigToast/BigToast.vue?vue&type=script&lang=ts&
 /* harmony default export */ var BigToast_BigToastvue_type_script_lang_ts_ = (BigToastvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/BigToast/BigToast.vue?vue&type=style&index=0&id=11cb3836&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/BigToast/BigToast.vue?vue&type=style&index=0&id=11cb3836&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/BigToast/BigToast.vue



;


/* normalize component */

var BigToast_component = normalizeComponent(
  BigToast_BigToastvue_type_script_lang_ts_,
  BigToastvue_type_template_id_11cb3836_scoped_true_render,
  BigToastvue_type_template_id_11cb3836_scoped_true_staticRenderFns,
  false,
  null,
  "11cb3836",
  null
  
)

/* harmony default export */ var BigToast = (BigToast_component.exports);
;// CONCATENATED MODULE: ./src/components/BigToast/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ButtonDropdown/ButtonDropdown.vue?vue&type=template&id=2616d6fb&
var ButtonDropdownvue_type_template_id_2616d6fb_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "button-dropdown",
    on: {
      "click": _vm.toggleDropdown
    }
  }, [_c('div', {
    staticClass: "button-dropdown__title",
    class: {
      'button-dropdown__title--opened': _vm.showDropdown
    }
  }, [_vm._v(" " + _vm._s(_vm.title) + " "), _c('Icon', {
    staticClass: "icon",
    class: {
      'icon--opened': _vm.showDropdown
    },
    attrs: {
      "name": "chevronDown",
      "size": 14
    }
  })], 1), _c('div', {
    staticClass: "button-dropdown__list",
    class: {
      'button-dropdown__list--opened': _vm.showDropdown
    }
  }, _vm._l(_vm.contents, function (content, index) {
    return _c('div', {
      key: index,
      staticClass: "button-dropdown__list__element",
      on: {
        "click": function click($event) {
          return _vm.emitOptionClicked(content);
        }
      }
    }, [_vm._v(" " + _vm._s(content.title) + " ")]);
  }), 0)]);
};
var ButtonDropdownvue_type_template_id_2616d6fb_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ButtonDropdown/ButtonDropdown.vue?vue&type=script&lang=ts&


/* harmony default export */ var ButtonDropdownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    contents: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      showDropdown: false
    };
  },
  methods: {
    emitOptionClicked: function emitOptionClicked(content) {
      this.$emit('optionClicked', content);
    },
    toggleDropdown: function toggleDropdown() {
      this.showDropdown = !this.showDropdown;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ButtonDropdown/ButtonDropdown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ButtonDropdown_ButtonDropdownvue_type_script_lang_ts_ = (ButtonDropdownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ButtonDropdown/ButtonDropdown.vue?vue&type=style&index=0&id=2616d6fb&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ButtonDropdown/ButtonDropdown.vue?vue&type=style&index=0&id=2616d6fb&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/ButtonDropdown/ButtonDropdown.vue



;


/* normalize component */

var ButtonDropdown_component = normalizeComponent(
  ButtonDropdown_ButtonDropdownvue_type_script_lang_ts_,
  ButtonDropdownvue_type_template_id_2616d6fb_render,
  ButtonDropdownvue_type_template_id_2616d6fb_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ButtonDropdown = (ButtonDropdown_component.exports);
;// CONCATENATED MODULE: ./src/components/ButtonDropdown/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Card/Card.vue?vue&type=template&id=2b001704&scoped=true&
var Cardvue_type_template_id_2b001704_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "card",
    class: {
      'card--outline': _vm.outline,
      'card--hover': _vm.enableHover
    }
  }, [_vm._t("default")], 2);
};
var Cardvue_type_template_id_2b001704_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Card/Card.vue?vue&type=script&lang=ts&

/* harmony default export */ var Card_Cardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    outline: {
      type: Boolean,
      default: false
    },
    enableHover: {
      type: Boolean,
      default: false
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Card/Card.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Card_Cardvue_type_script_lang_ts_ = (Card_Cardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Card/Card.vue?vue&type=style&index=0&id=2b001704&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Card/Card.vue?vue&type=style&index=0&id=2b001704&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/Card/Card.vue



;


/* normalize component */

var Card_Card_component = normalizeComponent(
  components_Card_Cardvue_type_script_lang_ts_,
  Cardvue_type_template_id_2b001704_scoped_true_render,
  Cardvue_type_template_id_2b001704_scoped_true_staticRenderFns,
  false,
  null,
  "2b001704",
  null
  
)

/* harmony default export */ var Card_Card = (Card_Card_component.exports);
;// CONCATENATED MODULE: ./src/components/Card/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=template&id=0f8f2208&scoped=true&

var CollapsibleMenuvue_type_template_id_0f8f2208_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "menu hide-for-small",
    on: {
      "mouseleave": _vm.toggleMenu,
      "mouseenter": _vm.toggleMenu
    }
  }, [_c('div', [_c('ul', {
    staticClass: "menu__list"
  }, [_vm.currentCourse ? _c('li', {
    staticClass: "menu__list__first-item"
  }, [_c('span', {
    class: _vm.isOpened,
    on: {
      "mouseleave": _vm.leaveSubMenu,
      "mouseenter": function mouseenter($event) {
        return _vm.openSubCourseMenu(_vm.myCourses);
      }
    }
  }, [_c('MenuButton', {
    attrs: {
      "is-element-style": false,
      "gap": 0,
      "is-border": "",
      "has-chevron": ""
    }
  }, [_c('span', {
    staticClass: "course"
  }, [_c('Logo'), _c('div', {
    staticClass: "current_course h6",
    class: {
      'current_course--hover': _vm.isOpened
    }
  }, [_vm._v(" " + _vm._s(_vm.currentCourse) + " ")])], 1)])], 1)]) : _c('li', {
    staticClass: "menu__list__first-item"
  }, [_c('span', {
    staticClass: "logo",
    class: _vm.isOpened
  }, [_c('CustomLink', {
    attrs: {
      "src": _vm.logo.src,
      "target": _vm.logo.target,
      "router-path": _vm.logo.routerPath,
      "router-name": _vm.logo.routerName
    }
  }, [_c('Logo'), _vm.isOpened ? _c('Logo', {
    staticClass: "college-name",
    attrs: {
      "name": "collegeName",
      "width": 115
    }
  }) : _vm._e()], 1)], 1)]), _vm._l(_vm.menuVisibleOptions, function (option) {
    return _c('li', {
      key: option.label,
      staticClass: "menu__item",
      class: {
        'menu__item--nolink': !option.routerPath && !option.routerName
      },
      on: {
        "mouseleave": _vm.leaveSubMenu,
        "mouseenter": function mouseenter($event) {
          return _vm.openSubMenu(option);
        }
      }
    }, [_c('CustomLink', {
      attrs: {
        "src": option.src,
        "target": option.target,
        "router-path": option.routerPath,
        "router-name": option.routerName,
        "on-click-handler": option.onClickHandler
      }
    }, [_c('MenuButton', {
      attrs: {
        "is-border": "",
        "icon": option.icon,
        "label": option.label,
        "is-collapsed": !_vm.isOpened,
        "has-chevron": !!option.options.length,
        "is-actived": option.active,
        "is-hovered": _vm.selectedOptions === option.options,
        "tag": option.tag
      }
    })], 1)], 1);
  })], 2)]), _vm.subCourseMenu ? _c('div', {
    staticClass: "menu__multiple-courses__container",
    class: {
      'menu__multiple-courses__container--visible': _vm.selectedOptions.length
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.clearTimeout(_vm.closeSubMenuTimeout);
      },
      "mouseleave": _vm.leaveSubMenu
    }
  }, [_c('p', {
    staticClass: "menu__multiple-courses menu__multiple-courses__title h5",
    style: {
      'animation-delay': 220
    }
  }, [_vm._v(" Seus cursos ")]), _c('div', {
    staticClass: "menu__multiple-courses__items"
  }, _vm._l(_vm.selectedOptions, function (option, i) {
    return _c('div', {
      key: option.category
    }, [_c('p', {
      staticClass: "menu__multiple-courses menu__multiple-courses__category subtitle-2",
      style: {
        'animation-delay': "calc((".concat(i, " * 70ms) + 150ms)")
      }
    }, [_vm._v(" " + _vm._s(option.category) + " ")]), _c('ul', _vm._l(option.courses, function (course, e) {
      return _c('li', {
        key: course.name,
        staticClass: "menu__multiple-courses",
        style: {
          'animation-delay': "calc((".concat(e, " * 70ms) + 50ms)")
        }
      }, [_c('CustomLink', {
        staticClass: "menu__link",
        attrs: {
          "src": course.src,
          "target": course.target,
          "router-path": course.routerPath,
          "router-name": course.routerName,
          "on-click-handler": course.onClickHandler
        }
      }, [_c('div', {
        staticClass: "subcourses-menu"
      }, [_c('div', {
        staticClass: "checkmark",
        class: {
          'checkmark--checked': _vm.currentCourse === course.name
        }
      }), _c('div', {
        staticClass: "menu__multiple-courses__course",
        class: {
          'menu__multiple-courses__course--checked': _vm.currentCourse === course.name
        }
      }, [_vm._v(" " + _vm._s(course.name) + " ")])])])], 1);
    }), 0)]);
  }), 0)]) : _c('div', {
    staticClass: "menu__sublist__container",
    class: {
      'menu__sublist__container--visible': _vm.selectedOptions.length
    },
    on: {
      "mouseenter": function mouseenter($event) {
        return _vm.clearTimeout(_vm.closeSubMenuTimeout);
      },
      "mouseleave": _vm.leaveSubMenu
    }
  }, [_c('ul', {
    staticClass: "menu__sublist"
  }, _vm._l(_vm.selectedOptions, function (option, i) {
    return _c('li', {
      key: option.label,
      staticClass: "menu__sublist__item",
      style: {
        'animation-delay': "calc((".concat(i, " * 70ms) + 50ms)")
      }
    }, [_c('CustomLink', {
      staticClass: "menu__link",
      attrs: {
        "src": option.src,
        "target": option.target,
        "router-path": option.routerPath,
        "router-name": option.routerName,
        "on-click-handler": option.onClickHandler
      }
    }, [_vm._v(" " + _vm._s(option.label) + " ")])], 1);
  }), 0)])]);
};
var CollapsibleMenuvue_type_template_id_0f8f2208_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=template&id=0f8f2208&scoped=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomLink/CustomLink.vue?vue&type=template&id=9d2589ae&scoped=true&
var CustomLinkvue_type_template_id_9d2589ae_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _vm.routerName || _vm.routerPath ? _c('router-link', {
    attrs: {
      "to": {
        name: _vm.routerName,
        path: _vm.routerPath
      }
    }
  }, [_vm._t("default")], 2) : _c('a', {
    staticClass: "link",
    on: {
      "click": _vm.clickHandler
    }
  }, [_vm._t("default")], 2);
};
var CustomLinkvue_type_template_id_9d2589ae_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomLink/CustomLink.vue?vue&type=script&lang=ts&

/* harmony default export */ var CustomLinkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    src: {
      type: String,
      default: ''
    },
    target: {
      type: String,
      default: ''
    },
    routerName: {
      type: String,
      default: ''
    },
    routerPath: {
      type: String,
      default: ''
    },
    onClickHandler: {
      type: Function,
      default: null
    }
  },
  methods: {
    clickHandler: function clickHandler() {
      if (this.src) window.open(this.src, this.target);
      if (this.onClickHandler) this.onClickHandler();
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/CustomLink/CustomLink.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CustomLink_CustomLinkvue_type_script_lang_ts_ = (CustomLinkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CustomLink/CustomLink.vue?vue&type=style&index=0&id=9d2589ae&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CustomLink/CustomLink.vue?vue&type=style&index=0&id=9d2589ae&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/CustomLink/CustomLink.vue



;


/* normalize component */

var CustomLink_component = normalizeComponent(
  CustomLink_CustomLinkvue_type_script_lang_ts_,
  CustomLinkvue_type_template_id_9d2589ae_scoped_true_render,
  CustomLinkvue_type_template_id_9d2589ae_scoped_true_staticRenderFns,
  false,
  null,
  "9d2589ae",
  null
  
)

/* harmony default export */ var CustomLink = (CustomLink_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/Logo.vue?vue&type=template&id=1bd73792&

var Logovue_type_template_id_1bd73792_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c(_vm.logo, {
    key: _vm.name,
    tag: "component",
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "alt": "logo descomplica",
      "title": "logo descomplica"
    }
  });
};
var Logovue_type_template_id_1bd73792_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Logo/Logo.vue?vue&type=template&id=1bd73792&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeLogo.vue?vue&type=template&id=d27670d0&
var CollegeLogovue_type_template_id_d27670d0_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox,
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M25.9338 1.9232L3.95375 5.87592C2.14593 6.20106 0.666504 7.97637 0.666504 10.1148V23.4697C0.666504 25.6612 2.14376 27.3975 3.94833 27.74L25.9403 31.9192C28.6184 32.4275 30.8099 30.4365 30.8099 27.5828V6.45793C30.811 3.30508 28.6162 1.44089 25.9338 1.9232Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "d": "M20.4616 23.2329C19.1675 24.7015 17.4193 25.6802 15.321 25.6802C10.5652 25.6802 7.10449 21.8337 7.10449 16.4839C7.10449 11.1688 10.5662 7.28765 15.321 7.28765C17.1743 7.28765 18.748 7.98672 19.9717 9.14099L20.0215 0H24.5671L24.5173 25.2261H20.8106L20.4616 23.2329ZM11.7194 16.485C11.7194 19.5967 13.3625 21.6245 15.8456 21.6245C18.5378 21.6245 19.9717 19.5967 19.9717 16.485C19.9717 13.3733 18.5378 11.3444 15.8456 11.3444C13.3636 11.3444 11.7194 13.3733 11.7194 16.485Z",
      "fill": "black"
    }
  })]);
};
var CollegeLogovue_type_template_id_d27670d0_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeLogo.vue?vue&type=script&lang=ts&



/* harmony default export */ var CollegeLogovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    width: {
      type: Number,
      default: 32
    },
    height: {
      type: Number,
      default: 32
    }
  },
  computed: {
    viewBox: function viewBox() {
      return "0 0 ".concat(this.width, " ").concat(this.height);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeLogo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var logos_CollegeLogovue_type_script_lang_ts_ = (CollegeLogovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeLogo.vue





/* normalize component */
;
var CollegeLogo_component = normalizeComponent(
  logos_CollegeLogovue_type_script_lang_ts_,
  CollegeLogovue_type_template_id_d27670d0_render,
  CollegeLogovue_type_template_id_d27670d0_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CollegeLogo = (CollegeLogo_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeName.vue?vue&type=template&id=115a4746&
var CollegeNamevue_type_template_id_115a4746_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox,
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      "d": "M0.0673828 5.75871H1.52868V12.1583H3.73718V5.75871H5.60548V3.86738H3.73718V3.66474C3.73718 2.58398 4.05988 2.04361 4.92618 2.04361C5.23248 2.04361 5.48728 2.09375 5.62298 2.14493V0.237228C5.43598 0.152282 4.97758 0.0683594 4.50178 0.0683594C2.64988 0.0683594 1.52868 1.28421 1.52868 3.15814V3.86738H0.0673828V5.75871ZM11.602 11.4153L11.7037 12.1583H13.4364V6.88965C13.4364 4.77931 12.2813 3.49591 9.98748 3.49591C8.69678 3.49591 7.76258 3.76508 6.67528 4.32285L7.30428 5.94399C8.20448 5.45478 8.98548 5.33606 9.61448 5.33606C10.6678 5.33606 11.2279 5.82629 11.2279 6.51814V7.39625C10.8035 7.00837 10.192 6.67063 9.27428 6.67063C7.45738 6.67063 5.96208 7.75139 5.96208 9.54139C5.96208 11.1789 7.45738 12.3947 9.15608 12.3947C10.0903 12.3947 10.9905 12.0058 11.602 11.4153ZM9.61448 10.6559C8.83348 10.6559 8.20448 10.2169 8.20448 9.54139C8.20448 8.86592 8.83238 8.40946 9.61448 8.41048C10.4294 8.41048 11.0244 8.86592 11.0244 9.54139C11.007 10.2169 10.413 10.6559 9.61448 10.6559ZM16.6972 7.93765C16.6972 9.44007 17.4443 10.4195 18.6672 10.4195C19.4822 10.4195 20.1111 10.0818 20.6208 9.13611L22.4563 10.0306C21.7431 11.6343 20.3156 12.3773 18.6169 12.3773C16.1875 12.3773 14.4548 10.5372 14.4548 7.93663C14.4548 5.33606 16.1875 3.49591 18.6169 3.49591C20.3156 3.49591 21.742 4.23893 22.4563 5.84267L20.6219 6.73715C20.1121 5.79149 19.4842 5.45376 18.6683 5.45376C17.4443 5.45478 16.6972 6.43422 16.6972 7.93765ZM23.4573 3.71588V8.88222C23.4573 10.6385 23.7974 12.3783 26.4468 12.3793C27.3645 12.3793 28.3665 12.0078 29.0972 11.3661L29.2503 12.1593H31.0508V3.71588H28.8423V9.62627C28.3161 10.1165 27.6194 10.4368 26.974 10.4368C26.0223 10.4368 25.6657 10.1155 25.6657 8.95079V3.71588H23.4573ZM35.0937 12.2433C33.5646 12.2433 32.6643 11.4501 32.6643 9.67646V0.338562H34.8728V9.20363C34.8728 9.89548 35.1277 10.1667 35.7052 10.1667V12.2095C35.5356 12.2259 35.3311 12.2433 35.0937 12.2433ZM42.6357 0.338562V4.3914C42.0407 3.83362 41.2761 3.49588 40.3769 3.49793C38.0667 3.49793 36.3854 5.37186 36.3854 7.93865C36.3854 10.5218 38.0667 12.3794 40.3769 12.3794C41.3963 12.3794 42.2452 11.9065 42.8741 11.1973L43.0437 12.1593H44.8442V0.338562H42.6357ZM40.6307 10.4195C39.4253 10.4195 38.6268 9.44004 38.6268 7.93763C38.6268 6.43419 39.4253 5.45475 40.6307 5.45578C41.9389 5.45578 42.6357 6.43521 42.6357 7.93763C42.6357 9.44004 41.9389 10.4195 40.6307 10.4195ZM51.9444 12.1583L51.8427 11.4153C51.2312 12.0058 50.331 12.3947 49.3968 12.3947C47.6981 12.3947 46.2028 11.1789 46.2028 9.54139C46.2028 7.75139 47.6981 6.67063 49.515 6.67063C50.4327 6.67063 51.0442 7.00837 51.4686 7.39625V6.51814C51.4686 5.82629 50.9085 5.33606 49.8552 5.33606C49.2262 5.33606 48.4452 5.45478 47.5449 5.94399L46.916 4.32285C48.0033 3.76508 48.9374 3.49591 50.2282 3.49591C52.522 3.49591 53.6771 4.77931 53.6771 6.88965V12.1583H51.9444ZM48.4441 9.54139C48.4441 10.2169 49.0731 10.6559 49.8541 10.6559C50.6526 10.6559 51.2466 10.2169 51.2641 9.54139C51.2641 8.86592 50.6691 8.41048 49.8541 8.41048C49.0731 8.40946 48.4441 8.86592 48.4441 9.54139ZM60.9468 0.338562V4.3914C60.3528 3.83362 59.5882 3.49588 58.688 3.49793C56.3778 3.49793 54.6965 5.37186 54.6965 7.93865C54.6965 10.5218 56.3778 12.3794 58.688 12.3794C59.7075 12.3794 60.5563 11.9065 61.1853 11.1973L61.3548 12.1593H63.1553V0.338562H60.9468ZM58.9418 10.4195C57.7364 10.4195 56.9379 9.44004 56.9379 7.93763C56.9379 6.43419 57.7364 5.45475 58.9418 5.45578C60.2501 5.45578 60.9468 6.43521 60.9468 7.93763C60.9468 9.44004 60.2501 10.4195 58.9418 10.4195ZM64.5139 7.93761C64.5139 5.26949 66.213 3.49689 68.744 3.49689C71.343 3.49689 72.821 5.23572 72.821 7.59987C72.821 7.92021 72.803 8.34289 72.735 8.697H66.79C66.977 9.79413 67.724 10.4696 68.913 10.4532C69.627 10.4532 70.425 10.0991 70.969 9.20361L72.735 10.1155C71.851 11.6353 70.73 12.3783 68.913 12.3783C66.4 12.3783 64.5139 10.5208 64.5139 7.93761ZM66.841 6.97455H70.578C70.493 5.87742 69.831 5.21832 68.726 5.21832C67.657 5.21832 67.028 5.87742 66.841 6.97455ZM6.50578 17.2254V21.2782C5.91078 20.7205 5.14718 20.3827 4.24698 20.3848C1.93678 20.3848 0.255482 22.2587 0.255482 24.8255C0.255482 27.4086 1.93678 29.2662 4.24698 29.2662C5.26638 29.2662 6.11528 28.7934 6.74418 28.0841L6.91378 29.0461H8.71428V17.2254H6.50578ZM4.50078 27.3063C3.29528 27.3063 2.49678 26.3269 2.49678 24.8244C2.49678 23.321 3.29528 22.3416 4.50078 22.3426C5.80898 22.3426 6.50578 23.322 6.50578 24.8244C6.50578 26.3269 5.80898 27.3063 4.50078 27.3063ZM10.0728 24.8245C10.0728 22.1564 11.7716 20.3838 14.3027 20.3838C16.9017 20.3838 18.3795 22.1226 18.3795 24.4868C18.3795 24.8071 18.3621 25.2298 18.2942 25.5839H12.3491C12.5362 26.681 13.2833 27.3565 14.4723 27.3401C15.1855 27.3401 15.984 26.986 16.5277 26.0905L18.2942 27.0024C17.4104 28.5222 16.2892 29.2652 14.4723 29.2652C11.9586 29.2652 10.0728 27.4077 10.0728 24.8245ZM12.3995 23.8614H16.1371C16.0518 22.7643 15.39 22.1052 14.2853 22.1052C13.2155 22.1052 12.5865 22.7643 12.3995 23.8614ZM25.4622 21.8012C24.9011 21.0244 23.8817 20.3489 22.4892 20.3489C20.5027 20.3489 19.2962 21.5484 19.2962 22.9833C19.2962 24.5205 20.1461 25.2799 21.5386 25.5838C23.0164 25.9052 23.56 26.158 23.56 26.7322C23.56 27.1876 23.1356 27.4915 22.558 27.4915C21.7595 27.4915 21.2333 27.2377 20.4348 26.3095L19.0588 27.424C19.8737 28.6562 20.9446 29.2641 22.3032 29.2641C24.1376 29.2641 25.5475 28.2346 25.5475 26.6134C25.5475 25.0435 24.4777 24.368 22.7111 23.9627C21.5221 23.6925 21.2498 23.4223 21.2498 22.9833C21.2498 22.4767 21.6917 22.1901 22.371 22.1901C23.2034 22.1901 23.8149 22.6118 24.1036 23.0171L25.4622 21.8012ZM28.5536 24.8245C28.5536 26.3269 29.3007 27.3063 30.5236 27.3063C31.3386 27.3063 31.9675 26.9686 32.4772 26.023L34.3116 26.9185C33.5984 28.5222 32.171 29.2652 30.4722 29.2652C28.0428 29.2652 26.3101 27.4251 26.3101 24.8245C26.3101 22.2239 28.0428 20.3838 30.4722 20.3838C32.171 20.3838 33.5984 21.1268 34.3116 22.7305L32.4772 23.625C31.9675 22.6794 31.3396 22.3416 30.5236 22.3416C29.3017 22.3416 28.5536 23.3211 28.5536 24.8245ZM39.2208 29.2652C41.8373 29.2652 43.6378 27.4077 43.6378 24.8245C43.6378 22.2577 41.8363 20.3838 39.2208 20.3838C36.6054 20.3838 34.8214 22.2577 34.8214 24.8245C34.8214 27.4077 36.6044 29.2652 39.2208 29.2652ZM39.2208 22.3427C40.5804 22.3427 41.3954 23.3559 41.3954 24.8245C41.3954 26.3095 40.5804 27.3063 39.2208 27.3063C37.8787 27.3063 37.0638 26.3105 37.0638 24.8245C37.0638 23.3559 37.8787 22.3427 39.2208 22.3427ZM52.0801 21.5822C52.8273 20.8054 53.8981 20.3838 54.9514 20.3838C57.4487 20.3838 57.8053 22.1226 57.8053 23.8788V29.0462H55.5968V23.8113C55.5968 22.6466 55.2567 22.3253 54.4243 22.3253C53.7275 22.3253 52.9968 22.663 52.4881 23.1696C52.5056 23.406 52.5056 23.6423 52.5056 23.8787V23.8788V29.0462H50.2971V23.8113C50.2971 22.6466 49.957 22.3253 49.1246 22.3253C48.4278 22.3253 47.7321 22.663 47.2049 23.1358V29.0462H44.9964V20.6028H46.7969L46.95 21.4134C47.6807 20.7553 48.6662 20.3838 49.6507 20.3838C50.959 20.3828 51.6896 20.8556 52.0801 21.5822ZM61.4566 20.6028H59.6561V32.0009H61.8646V28.3707C62.4586 28.9275 63.2232 29.2652 64.1234 29.2652C66.435 29.2652 68.116 27.3913 68.116 24.8245C68.116 22.2413 66.434 20.3838 64.1234 20.3838C63.1039 20.3838 62.2551 20.8566 61.6261 21.5659L61.4566 20.6028ZM63.8675 22.3427C65.074 22.3427 65.873 23.3221 65.873 24.8245C65.873 26.3269 65.075 27.3063 63.8675 27.3063C62.5593 27.3063 61.8625 26.3269 61.8625 24.8245C61.8625 23.3221 62.5593 22.3427 63.8675 22.3427ZM71.564 29.1301C70.035 29.1301 69.134 28.3369 69.134 26.5633V17.2254H71.343V26.0904C71.343 26.7823 71.598 27.0535 72.175 27.0535V29.0963C72.005 29.1127 71.801 29.1301 71.564 29.1301ZM75.945 18.0195C75.945 17.2428 75.333 16.6174 74.552 16.6174C73.789 16.6174 73.16 17.2417 73.16 18.0195C73.16 18.7626 73.788 19.3869 74.552 19.3869C75.333 19.3869 75.945 18.7626 75.945 18.0195ZM73.449 20.6017V29.0451H75.657V20.6017H73.449ZM79.258 24.8245C79.258 26.3269 80.005 27.3063 81.228 27.3063C82.043 27.3063 82.672 26.9686 83.182 26.023L85.016 26.9185C84.303 28.5222 82.875 29.2652 81.177 29.2652C78.747 29.2652 77.015 27.4251 77.015 24.8245C77.015 22.2239 78.747 20.3838 81.177 20.3838C82.875 20.3838 84.302 21.1268 85.016 22.7305L83.182 23.625C82.672 22.6794 82.044 22.3416 81.228 22.3416C80.005 22.3416 79.258 23.3211 79.258 24.8245ZM91.166 28.3022L91.267 29.0452H93V23.7765C93 21.6661 91.845 20.3828 89.551 20.3828C88.26 20.3828 87.326 20.6519 86.239 21.2097L86.868 22.8308C87.768 22.3416 88.549 22.2229 89.178 22.2229C90.231 22.2229 90.792 22.7131 90.792 23.405V24.2831C90.367 23.8952 89.756 23.5575 88.838 23.5575C87.021 23.5575 85.526 24.6382 85.526 26.4282C85.526 28.0657 87.021 29.2816 88.72 29.2816C89.654 29.2816 90.554 28.8927 91.166 28.3022ZM89.178 27.5428C88.397 27.5428 87.768 27.1037 87.768 26.4282C87.768 25.7528 88.396 25.2963 89.178 25.2973C89.993 25.2973 90.588 25.7528 90.588 26.4282C90.571 27.1037 89.977 27.5428 89.178 27.5428Z",
      "fill": "#111111"
    }
  })]);
};
var CollegeNamevue_type_template_id_115a4746_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeName.vue?vue&type=script&lang=ts&



/* harmony default export */ var CollegeNamevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    width: {
      type: Number,
      default: 93
    },
    height: {
      type: Number,
      default: 32
    }
  },
  computed: {
    viewBox: function viewBox() {
      return "0 0 ".concat(this.width, " ").concat(this.height);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeName.vue?vue&type=script&lang=ts&
 /* harmony default export */ var logos_CollegeNamevue_type_script_lang_ts_ = (CollegeNamevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeName.vue





/* normalize component */
;
var CollegeName_component = normalizeComponent(
  logos_CollegeNamevue_type_script_lang_ts_,
  CollegeNamevue_type_template_id_115a4746_render,
  CollegeNamevue_type_template_id_115a4746_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CollegeName = (CollegeName_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeNameWithLogo.vue?vue&type=template&id=6e35ee04&
var CollegeNameWithLogovue_type_template_id_6e35ee04_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox,
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "d": "M19.2263 0.0597196L2.58889 3.20695C1.18023 3.47562 0 4.89572 0 6.58448V17.216C0 18.9431 1.18023 20.3248 2.58889 20.5935L19.2644 23.9327C21.3583 24.3548 23.1096 22.7428 23.1096 20.4784V3.66753C23.0715 1.17277 21.3583 -0.32409 19.2263 0.0597196Z",
      "fill": "#00E88F"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M4.68326 15.5659C5.52084 15.5659 6.20614 15.1821 6.70107 14.6064L6.85336 15.4124H8.30009V5.77881H6.51071V9.07957C6.01578 8.619 5.40663 8.35033 4.68326 8.35033C2.85582 8.35033 1.48523 9.84719 1.48523 11.9581C1.48523 14.0691 2.81774 15.5659 4.68326 15.5659ZM4.87405 13.9924C3.92225 13.9924 3.27503 13.1864 3.27503 11.9582C3.27503 10.7301 3.92225 9.92406 4.87405 9.92406C5.90199 9.92406 6.47307 10.7301 6.47307 11.9582C6.47307 13.1864 5.94006 13.9924 4.87405 13.9924Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M9.44275 11.958C9.44275 14.069 10.9656 15.5658 12.9834 15.5658C14.4302 15.5658 15.3439 14.9517 15.9911 13.6852L14.5824 12.9559C14.1637 13.6852 13.5164 13.9922 12.9454 13.9922C11.9936 14.0306 11.3844 13.4549 11.2321 12.5721H16.0292C16.1053 12.3035 16.1053 11.958 16.1053 11.6894C16.1053 9.77031 14.9251 8.35022 12.8311 8.35022C10.8133 8.35022 9.44275 9.77031 9.44275 11.958ZM14.3164 11.1521H11.3087C11.461 10.2694 11.956 9.73206 12.8316 9.73206C13.7073 9.73206 14.2403 10.2694 14.3164 11.1521Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M16.7898 10.4228C16.7898 9.23296 17.7416 8.27344 19.3787 8.27344C20.4828 8.27344 21.3204 8.81077 21.7772 9.46325L20.6732 10.4611C20.4447 10.1157 19.9498 9.77029 19.2645 9.77029C18.7315 9.77029 18.3508 10.0006 18.3508 10.4228C18.3508 10.7682 18.5031 10.9985 19.531 11.2671C20.9397 11.6126 21.8153 12.1115 21.8153 13.4165C21.8153 14.7214 20.6732 15.5658 19.1884 15.5658C18.0843 15.5658 17.2467 15.0669 16.5614 14.069L17.6655 13.1478C18.3127 13.9154 18.7315 14.1073 19.3787 14.1073C19.8356 14.1073 20.1782 13.8771 20.1782 13.4932C20.1782 13.0327 19.7214 12.8024 18.5411 12.5337C17.4751 12.2651 16.7898 11.6893 16.7898 10.4228Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M27.6023 15.565C25.5465 15.565 24.0997 14.0681 24.0997 11.9572C24.0997 9.84622 25.5465 8.34937 27.6023 8.34937C29.011 8.34937 30.1151 8.8867 30.8004 10.1916L29.3156 10.9593C28.8587 10.1916 28.3638 9.92298 27.6404 9.92298C26.5744 9.92298 25.9272 10.729 25.9272 11.9572C25.9272 13.1854 26.5744 13.9914 27.6404 13.9914C28.3638 13.9914 28.8587 13.7227 29.3156 12.9551L30.8004 13.7227C30.1532 15.0276 29.0491 15.565 27.6023 15.565Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M34.7976 15.565C36.8916 15.565 38.3383 14.0681 38.3383 11.9572C38.3383 9.84622 36.8916 8.34937 34.7976 8.34937C32.7037 8.34937 31.257 9.84622 31.257 11.9572C31.257 14.0681 32.7037 15.565 34.7976 15.565ZM34.7604 9.92325C35.8645 9.92325 36.5117 10.7676 36.5117 11.9574C36.5117 13.1472 35.8645 13.9532 34.7604 13.9916C33.6563 13.9916 33.0091 13.1856 33.0091 11.9574C33.0091 10.7676 33.6944 9.92325 34.7604 9.92325Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M41.27 10.5753V15.4113H39.4806V8.5027H40.9273L41.0415 9.15517C41.6126 8.61784 42.4121 8.31079 43.2116 8.31079C44.2776 8.31079 44.8487 8.6946 45.1533 9.27031C45.7624 8.61784 46.6 8.31079 47.4757 8.31079C49.4935 8.31079 49.76 9.73089 49.76 11.151V15.3729H47.9706V11.1126C47.9706 10.1531 47.7041 9.88441 47.0188 9.88441C46.4477 9.88441 45.8767 10.1531 45.4579 10.5753C45.4579 10.7672 45.4579 10.9591 45.4579 11.151V15.3729H43.6685V11.1126C43.6685 10.1531 43.402 9.88441 42.7167 9.88441C42.2598 9.88441 41.6888 10.1915 41.27 10.5753Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M53.1093 17.7909V14.8355C53.6043 15.2961 54.2134 15.5648 54.9368 15.5264C56.7642 15.5264 58.1348 14.0295 58.1348 11.9186C58.1348 9.80765 56.8023 8.31079 54.9368 8.31079C54.0992 8.31079 53.4139 8.6946 52.919 9.27031L52.7667 8.5027H51.3199V17.7909H53.1093ZM54.7466 9.92299C55.6984 9.92299 56.3456 10.729 56.3456 11.9572C56.3456 13.1854 55.6984 13.953 54.7466 13.9914C53.7187 13.9914 53.1476 13.1854 53.1476 11.9572C53.1476 10.729 53.6806 9.92299 54.7466 9.92299Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M61.4875 15.4112C61.3352 15.4112 61.1829 15.4496 60.9926 15.4496C59.7743 15.4496 59.0509 14.7972 59.0509 13.3387V5.73926H60.8403V12.9549C60.8403 13.5306 61.0306 13.7225 61.5256 13.7225L61.4875 15.4112V15.4112Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M64.5693 6.39191C64.5693 5.73943 64.1125 5.24048 63.4653 5.24048C62.8561 5.24048 62.3231 5.73943 62.3612 6.39191C62.3612 7.006 62.8561 7.50495 63.4653 7.50495C64.0744 7.50495 64.5693 7.006 64.5693 6.39191ZM62.5907 8.46428V15.3728H64.38V8.46428H62.5907Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "d": "M69.0247 15.565C66.9688 15.565 65.5221 14.0681 65.5221 11.9572C65.5221 9.84622 66.9688 8.34937 69.0247 8.34937C70.4334 8.34937 71.5374 8.8867 72.2227 10.1916L70.7379 10.9593C70.2811 10.1916 69.7861 9.92298 69.0628 9.92298C67.9968 9.92298 67.3495 10.729 67.3495 11.9572C67.3495 13.1854 67.9968 13.9914 69.0628 13.9914C69.7861 13.9914 70.2811 13.7227 70.7379 12.9551L72.2227 13.7227C71.5374 15.0276 70.4334 15.565 69.0247 15.565Z",
      "fill": "black"
    }
  }), _c('path', {
    attrs: {
      "fillRule": "evenodd",
      "clipRule": "evenodd",
      "d": "M75.2304 15.6034C75.9918 15.6034 76.7152 15.2964 77.2101 14.7974L77.2482 15.3731H78.6568V11.0745C78.6568 9.34732 77.705 8.31104 75.8776 8.31104C74.8496 8.31104 74.0882 8.54132 73.2126 9.00189L73.7075 10.3068C74.4309 9.92303 75.0781 9.80789 75.573 9.80789C76.3344 9.80789 76.8675 10.1917 76.8675 10.7674V11.4967C76.5248 11.1896 76.0299 10.9209 75.3065 10.9209C73.8598 10.9209 72.6415 11.8037 72.6415 13.2622C72.6415 14.6055 73.8598 15.6034 75.2304 15.6034ZM76.7533 13.2237C76.7153 13.7994 76.2965 14.1449 75.6493 14.1449C75.002 14.1449 74.469 13.7994 74.469 13.2237C74.469 12.6864 75.002 12.3026 75.6493 12.3026C76.3345 12.3026 76.7533 12.6864 76.7533 13.2237Z",
      "fill": "black"
    }
  })]);
};
var CollegeNameWithLogovue_type_template_id_6e35ee04_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/CollegeNameWithLogo.vue?vue&type=script&lang=ts&



/* harmony default export */ var CollegeNameWithLogovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    width: {
      type: Number,
      default: 93
    },
    height: {
      type: Number,
      default: 32
    }
  },
  computed: {
    viewBox: function viewBox() {
      return "0 0 ".concat(this.width, " ").concat(this.height);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeNameWithLogo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var logos_CollegeNameWithLogovue_type_script_lang_ts_ = (CollegeNameWithLogovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Logo/logos/CollegeNameWithLogo.vue





/* normalize component */
;
var CollegeNameWithLogo_component = normalizeComponent(
  logos_CollegeNameWithLogovue_type_script_lang_ts_,
  CollegeNameWithLogovue_type_template_id_6e35ee04_render,
  CollegeNameWithLogovue_type_template_id_6e35ee04_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CollegeNameWithLogo = (CollegeNameWithLogo_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/Logo.vue?vue&type=script&lang=ts&






var logos = {
  collegeName: CollegeName,
  collegeLogo: CollegeLogo,
  CollegeNameWithLogo: CollegeNameWithLogo
};
/* harmony default export */ var Logovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    height: {
      type: Number,
      default: 32
    },
    name: {
      type: String,
      default: 'collegeLogo'
    },
    width: {
      type: Number,
      default: 32
    }
  },
  data: function data() {
    return {
      logo: logos[this.name]
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Logo/Logo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Logo_Logovue_type_script_lang_ts_ = (Logovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Logo/Logo.vue





/* normalize component */
;
var Logo_component = normalizeComponent(
  Logo_Logovue_type_script_lang_ts_,
  Logovue_type_template_id_1bd73792_render,
  Logovue_type_template_id_1bd73792_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Logo = (Logo_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=script&lang=ts&






/* harmony default export */ var CollapsibleMenuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    CustomLink: CustomLink,
    MenuButton: MenuButton,
    Logo: Logo
  },
  props: {
    menuOptions: {
      type: Array,
      required: true
    },
    logo: {
      type: Object,
      default: function _default() {
        return {
          routerName: 'home'
        };
      }
    },
    myCourses: {
      type: Array
    },
    currentCourse: {
      type: String,
      required: false
    }
  },
  data: function data() {
    return {
      isOpened: false,
      selectedOptions: [],
      subCourseMenu: false
    };
  },
  computed: {
    menuVisibleOptions: function menuVisibleOptions() {
      return this.menuOptions.filter(function (option) {
        return !option.hideDesktop;
      });
    }
  },
  methods: {
    toggleMenu: function toggleMenu() {
      this.isOpened = !this.isOpened;
      this.closeSubMenu();
    },
    leaveSubMenu: function leaveSubMenu() {
      var _this = this;
      this.clearTimeout(this.openSubMenuTimeout);
      this.closeSubMenuTimeout = window.setTimeout(function () {
        _this.closeSubMenu();
      }, 200);
    },
    openSubMenu: function openSubMenu(option) {
      var _this2 = this;
      this.subCourseMenu = false;
      this.clearTimeout(this.closeSubMenuTimeout);
      this.openSubMenuTimeout = window.setTimeout(function () {
        _this2.selectedOptions = option.options;
      }, 200);
    },
    openSubCourseMenu: function openSubCourseMenu(courses) {
      var _this3 = this;
      this.clearTimeout(this.closeSubMenuTimeout);
      this.subCourseMenu = true;
      this.openSubMenuTimeout = window.setTimeout(function () {
        _this3.selectedOptions = courses;
      }, 200);
    },
    closeSubMenu: function closeSubMenu() {
      this.subCourseMenu = false;
      this.selectedOptions = [];
    },
    clearTimeout: function clearTimeout(timeout) {
      if (timeout) window.clearTimeout(timeout);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var CollapsibleMenu_CollapsibleMenuvue_type_script_lang_ts_ = (CollapsibleMenuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=style&index=0&id=0f8f2208&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/CollapsibleMenu/CollapsibleMenu.vue?vue&type=style&index=0&id=0f8f2208&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/CollapsibleMenu/CollapsibleMenu.vue



;


/* normalize component */

var CollapsibleMenu_component = normalizeComponent(
  CollapsibleMenu_CollapsibleMenuvue_type_script_lang_ts_,
  CollapsibleMenuvue_type_template_id_0f8f2208_scoped_true_render,
  CollapsibleMenuvue_type_template_id_0f8f2208_scoped_true_staticRenderFns,
  false,
  null,
  "0f8f2208",
  null
  
)

/* harmony default export */ var CollapsibleMenu = (CollapsibleMenu_component.exports);
;// CONCATENATED MODULE: ./src/components/CollapsibleMenu/index.ts

;// CONCATENATED MODULE: ./src/components/CustomLink/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DrawerNotes/NotesDrawer.vue?vue&type=template&id=063b231f&scoped=true&
var NotesDrawervue_type_template_id_063b231f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('div', {
    staticClass: "drawer",
    class: {
      'drawer--visible': _vm.toggleShowDrawer
    }
  }, [_c('div', {
    staticClass: "drawer__title"
  }, [_c('h2', {
    staticClass: "h5"
  }, [_vm._v(_vm._s(_vm.title))]), _c('div', {
    staticClass: "drawer__title__actions"
  }, [_vm.shouldShowShareButton ? _c('Button', {
    staticClass: "drawer__share-button",
    class: {
      'drawer__contents__notes--collapsed': !_vm.toggleShowSlotContents
    },
    attrs: {
      "small": "",
      "no-border": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.showShare.apply(null, arguments);
      }
    }
  }, [_c('Icon', {
    staticClass: "drawer__share-button__icon",
    attrs: {
      "name": "shareAlt",
      "size": 15
    }
  }), _c('p', {
    staticClass: "drawer__share-button__text"
  }, [_vm._v("Compartilhar")])], 1) : _vm._e(), _c('div', {
    staticClass: "drawer__title__actions__close"
  }, [_c('Icon', {
    staticClass: "drawer__close-icon",
    class: {
      'hide-for-small': _vm.shouldShowUserSettings
    },
    attrs: {
      "name": "close"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeDrawer.apply(null, arguments);
      }
    }
  }), _vm.shouldShowUserSettings ? _c('UserSettingsModal', {
    class: {
      'drawer__contents__notes--collapsed': !_vm.toggleShowSlotContents
    },
    attrs: {
      "config-button-label": "Configuração das anotações",
      "activeModal": _vm.configurationModal
    },
    on: {
      "closeParentComponent": _vm.closeDrawer,
      "update:activeModal": _vm.toggleModal
    },
    scopedSlots: _vm._u([{
      key: "toggleSwitch",
      fn: function fn() {
        return [_vm._t("settings")];
      },
      proxy: true
    }], null, true)
  }) : _vm._e()], 1)], 1)]), _c('div', {
    staticClass: "drawer__contents"
  }, [_vm.isLoading ? _c('CardSkeleton', {
    staticClass: "drawer__contents__loading"
  }, _vm._l(4, function (line) {
    return _c('div', {
      key: line
    }, [_c('LineSkeleton', {
      staticClass: "drawer__contents__loading--cards",
      attrs: {
        "width": "auto",
        "height": "168px"
      }
    })], 1);
  }), 0) : _c('div', {
    staticClass: "drawer__contents__box"
  }, [_vm.shouldShowTabs ? _c('div', {
    staticClass: "drawer__tabs"
  }, [_c('Tabs', {
    staticClass: "drawer__tabs__names",
    attrs: {
      "v2": "",
      "spaced": ""
    }
  }, _vm._l(_vm.tabs, function (tab, i) {
    return _c('Tab', {
      key: i,
      staticClass: "drawer__tabs__tab-content",
      attrs: {
        "name": tab,
        "is-selected": _vm.isTabSelected(i)
      }
    }, [_vm._t("content-tab-".concat(i))], 2);
  }), 1)], 1) : _c('div', {
    staticClass: "drawer__contents__notes",
    class: {
      'drawer__contents__notes--collapsed': !_vm.toggleShowSlotContents
    }
  }, [_c('div', {
    staticClass: "drawer__actions__share",
    class: {
      'drawer__actions__share--visible': _vm.shouldShowShareModal
    }
  }, [_c('Icon', {
    staticClass: "drawer__actions__share__close",
    attrs: {
      "name": "close"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.closeShareModal.apply(null, arguments);
      }
    }
  }), _c('div', {
    staticClass: "drawer__actions__share__box"
  }, [_c('img', {
    staticClass: "drawer__actions__share__icon hide-for-small",
    attrs: {
      "src": "/img/share-annotations.svg"
    }
  }), _c('div', {
    staticClass: "drawer__actions__share__box__content"
  }, [_c('b', {
    staticClass: "drawer__actions__share__box__content--title"
  }, [_vm._v("Compartilhe suas anotações!")]), _c('p', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Envie o link abaixo para compartilhar suas anotações. ")])])]), _c('div', {
    staticClass: "drawer__actions__share__link hide-for-small",
    on: {
      "click": _vm.copyHandler
    }
  }, [_c('Icon', {
    staticClass: "drawer__actions__share__link--icon",
    attrs: {
      "name": "insertLink"
    }
  }), _vm.isShareLinkCopied ? _c('span', {
    staticClass: "drawer__actions__share__link--copied"
  }, [_vm._v(" Link copiado ")]) : _c('div', {
    staticClass: "drawer__actions__share__link__box"
  }, [_c('span', {
    staticClass: "drawer__actions__share__link--url"
  }, [_vm._v(_vm._s(_vm.shareableUrl) + " ")])])], 1), _c('div', {
    staticClass: "drawer__actions__share__link hide-for-medium-up",
    on: {
      "click": _vm.shareHandler
    }
  }, [_c('Icon', {
    staticClass: "drawer__actions__share__link--icon",
    attrs: {
      "name": "insertLink"
    }
  }), _c('div', {
    staticClass: "drawer__actions__share__link__box"
  }, [_c('span', {
    staticClass: "drawer__actions__share__link--url"
  }, [_vm._v(_vm._s(_vm.shareableUrl) + " ")])])], 1)], 1), _vm._t("contents")], 2), _c('div', {
    staticClass: "drawer__contents__empty-notes",
    class: {
      'drawer__contents__empty-notes--collapsed': _vm.toggleShowSlotContents
    }
  }, [_c('div', {
    staticClass: "drawer__contents__empty-notes__descriptions"
  }, [_c('img', {
    staticClass: "drawer__contents__empty-notes__descriptions__icon",
    attrs: {
      "src": "/img/init-notes.svg"
    }
  }), _c('p', {
    staticClass: "h6 drawer__contents__empty-notes__descriptions__title"
  }, [_vm._v(" Conheça as anotações ")]), _c('p', {
    staticClass: "subtitle-2"
  }, [_vm._v(" Agora você pode adicionar lembretes em suas aulas, do mesmo jeito que você faz no seu caderno ")])]), _c('Button', {
    staticClass: "button--wide",
    attrs: {
      "wide": "",
      "primary": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.showSlotContents.apply(null, arguments);
      }
    }
  }, [_vm._v(" Começar a anotar")])], 1)])], 1)])]);
};
var NotesDrawervue_type_template_id_063b231f_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.async-iterator.js
var es_symbol_async_iterator = __webpack_require__(2443);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.symbol.to-string-tag.js
var es_symbol_to_string_tag = __webpack_require__(9341);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.json.to-string-tag.js
var es_json_to_string_tag = __webpack_require__(3706);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.math.to-string-tag.js
var es_math_to_string_tag = __webpack_require__(408);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-prototype-of.js
var es_object_get_prototype_of = __webpack_require__(489);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(7658);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-collections.for-each.js
var web_dom_collections_for_each = __webpack_require__(4747);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.set-prototype-of.js
var es_object_set_prototype_of = __webpack_require__(8304);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.proto.js
var es_object_proto = __webpack_require__(7987);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.promise.js
var es_promise = __webpack_require__(8674);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js





















function _regeneratorRuntime() {
  "use strict";

  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */
  _regeneratorRuntime = function _regeneratorRuntime() {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function define(t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof_typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function value(t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof_typeof(e) + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function reset(e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function stop() {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function dispatchException(e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function abrupt(t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function complete(t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function finish(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    "catch": function _catch(t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function delegateYield(e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js


function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.map.js
var es_array_map = __webpack_require__(1249);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=template&id=88eb3672&scoped=true&
var UserSettingsModalvue_type_template_id_88eb3672_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "user-settings",
    class: {
      'user-settings--active': _vm.activeModal
    }
  }, [_c('transition', {
    attrs: {
      "name": "user-settings__modal-animation"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.activeModal,
      expression: "activeModal"
    }],
    staticClass: "user-settings__modal"
  }, [_c('div', {
    staticClass: "hide-for-small user-settings__modal__contents"
  }, [_c('a', {
    staticClass: "user-settings__modal__contents__close",
    on: {
      "click": function click($event) {
        return _vm.closeModal();
      }
    }
  }, [_c('Icon', {
    staticClass: "user-settings__modal__contents__close__icon",
    attrs: {
      "name": "close",
      "size": 16
    }
  })], 1), _vm._t("toggleSwitch")], 2)])]), _c('Modal', {
    staticClass: "show-for-small user-settings__modal-mobile",
    attrs: {
      "active": _vm.activeModal,
      "has-close-button": false,
      "clickOutsideToClose": true,
      "modal-in-bottom": "",
      "wihout-padding": ""
    },
    on: {
      "update:active": _vm.closeModal
    }
  }, [_c('a', {
    staticClass: "user-settings__modal__contents__close",
    on: {
      "click": function click($event) {
        return _vm.closeModal();
      }
    }
  }, [_c('Icon', {
    staticClass: "user-settings__modal__contents__close__icon",
    attrs: {
      "name": "close",
      "size": 16
    }
  })], 1), _vm._t("toggleSwitch")], 2), _c('Button', {
    staticClass: "user-settings__button hide-for-small",
    class: {
      'user-settings__button__without-label': !_vm.configButtonLabel
    },
    attrs: {
      "small": "",
      "border": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.openModal.apply(null, arguments);
      }
    }
  }, [_c('Icon', {
    staticClass: "user-settings__button__icon",
    attrs: {
      "name": "settings",
      "size": 16
    }
  }), _vm.configButtonLabel ? _c('p', {
    staticClass: "user-settings__button__label"
  }, [_vm._v(" " + _vm._s(_vm.configButtonLabel) + " ")]) : _vm._e()], 1), _c('IconButton', {
    staticClass: "show-for-small user-settings__button-mobile",
    attrs: {
      "is-actived": _vm.isOptionsOpened,
      "icon": "more"
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.toggleOptions.apply(null, arguments);
      }
    }
  }), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOptionsOpened,
      expression: "isOptionsOpened"
    }],
    staticClass: "show-for-small user-settings__options-menu"
  }, _vm._l(_vm.optionsItems, function (item) {
    return _c('li', {
      key: item.label,
      on: {
        "click": item.clickHandler
      }
    }, [_c('p', {
      staticClass: "subtitle-1 user-settings__options-menu__label",
      on: {
        "click": item.clickHandler
      }
    }, [_vm._v(" " + _vm._s(item.label || 'Configuração das anotações') + " ")])]);
  }), 0)], 1);
};
var UserSettingsModalvue_type_template_id_88eb3672_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/Modal.vue?vue&type=template&id=ce50073c&scoped=true&
var Modalvue_type_template_id_ce50073c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "modal-animation"
    }
  }, [_vm.active ? _c('div', {
    ref: "modal",
    staticClass: "modal",
    class: {
      'modal--no-scroll': _vm.contentScroll
    },
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.onEsc.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "modal__overlay",
    class: {
      'modal__overlay--mobile-short-modal': _vm.shortMobileModal,
      'modal__overlay--padding': _vm.overlayPadding
    },
    on: {
      "click": _vm.onOverlayClick
    }
  }, [_c('div', {
    class: {
      modal__container: !_vm.modalInBottom,
      'modal__container--bottom': _vm.modalInBottom,
      'modal__container--no-margin': _vm.withoutMargin,
      'modal__container--no-padding': _vm.wihoutPadding,
      'modal__container--mobile-short-modal': _vm.shortMobileModal,
      'modal__container--scroll': _vm.contentScroll,
      'modal__container--slide-animation': _vm.slideAnimation
    },
    style: {
      '--width': _vm.widthPercent ? "".concat(_vm.widthPercent, "%") : "".concat(_vm.width, "px"),
      'border-radius': "".concat(_vm.borderRadius, "px")
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.hasCloseButton ? _c('button', {
    staticClass: "modal__close",
    class: {
      'modal__close--border-radius': _vm.closeBorderRadius
    },
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.onCloseClick
    }
  }, [_c('Icon', {
    staticClass: "modal__close__icon",
    attrs: {
      "name": "close",
      "size": 26
    }
  }), _c('div', {
    staticClass: "modal__close__bar"
  })], 1) : _vm._e(), _c('div', {
    ref: "content",
    staticClass: "modal__content"
  }, [_vm._t("default")], 2)])])]) : _vm._e()]);
};
var Modalvue_type_template_id_ce50073c_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/debounce/index.js
var debounce = __webpack_require__(296);
var debounce_default = /*#__PURE__*/__webpack_require__.n(debounce);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/Modal.vue?vue&type=script&lang=ts&






/* harmony default export */ var Modalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    additionalOverlayClickHandler: {
      type: Function,
      required: false
    },
    clickOutsideToClose: {
      type: Boolean,
      default: true
    },
    hasCloseButton: {
      type: Boolean,
      default: true
    },
    modalInBottom: {
      type: Boolean,
      default: false
    },
    withoutMargin: {
      type: Boolean,
      default: false
    },
    wihoutPadding: {
      type: Boolean,
      default: false
    },
    width: {
      type: Number,
      default: 813
    },
    borderRadius: {
      type: Number,
      default: 4
    },
    closeBorderRadius: {
      type: Boolean,
      default: false
    },
    widthPercent: {
      type: String,
      default: ''
    },
    shortMobileModal: {
      type: Boolean,
      default: false
    },
    contentScroll: {
      type: Boolean,
      default: false
    },
    overlayPadding: {
      type: Boolean,
      default: false
    },
    contentScrollPosition: {
      type: Object,
      default: function _default() {
        return {};
      }
    },
    slideAnimation: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      contentScrollTrackFunction: function contentScrollTrackFunction() {}
    };
  },
  watch: {
    active: function active(_active) {
      this.toggleModalEventAndBodyScroll(_active);
    },
    contentScrollPosition: function contentScrollPosition(newPosition, oldPosition) {
      var top = newPosition.top,
        left = newPosition.left;
      if (top !== oldPosition.top && left !== oldPosition.left) {
        var _this$content;
        (_this$content = this.content) === null || _this$content === void 0 || _this$content.scrollTo({
          left: left,
          top: top,
          behavior: 'smooth'
        });
      }
    }
  },
  computed: {
    body: function body() {
      return document.querySelector('body');
    },
    content: function content() {
      return this.$refs.content;
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:active', false);
    },
    onOverlayClick: function onOverlayClick() {
      if (this.clickOutsideToClose) {
        this.closeDialog();
      }
      if (this.additionalOverlayClickHandler) {
        this.additionalOverlayClickHandler();
      }
    },
    onCloseClick: function onCloseClick() {
      if (this.hasCloseButton) {
        this.closeDialog();
      }
    },
    onEsc: function onEsc() {
      if (this.closeOnEsc) {
        this.closeDialog();
      }
    },
    disableBodyScroll: function disableBodyScroll() {
      if (this.body) this.body.classList.add('no-scroll');
    },
    enableBodyScroll: function enableBodyScroll() {
      if (this.body) this.body.classList.remove('no-scroll');
    },
    toggleModalEventAndBodyScroll: function toggleModalEventAndBodyScroll(active) {
      if (active) {
        this.disableBodyScroll();
        this.$emit('md-opened');
      } else {
        this.enableBodyScroll();
        this.$emit('md-closed');
      }
    },
    trackContentScroll: function trackContentScroll() {
      var content = this.content;
      if (!content) return;
      this.contentScrollTrackFunction = debounce_default()(this.updateContentScroll);
      content.addEventListener('scroll', this.contentScrollTrackFunction);
    },
    untrackContentScroll: function untrackContentScroll() {
      if (!this.content) return;
      this.content.removeEventListener('scroll', this.contentScrollTrackFunction);
    },
    updateContentScroll: function updateContentScroll() {
      if (!this.content) return;
      var position = {
        top: this.content.scrollTop,
        left: this.content.scrollLeft
      };
      this.$emit('update:contentScrollPosition', position);
    }
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var modal;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            modal = _this.$refs.modal;
            modal && modal.focus();
            _this.toggleModalEventAndBodyScroll(_this.active);
            _context.next = 5;
            return _this.$nextTick();
          case 5:
            _this.trackContentScroll();
          case 6:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  destroyed: function destroyed() {
    this.enableBodyScroll();
    this.untrackContentScroll();
  }
}));
;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Modal_Modalvue_type_script_lang_ts_ = (Modalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/Modal.vue?vue&type=style&index=0&id=ce50073c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=style&index=0&id=ce50073c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/Modal.vue?vue&type=style&index=1&id=ce50073c&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue?vue&type=style&index=1&id=ce50073c&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Modal/Modal.vue



;



/* normalize component */

var Modal_component = normalizeComponent(
  Modal_Modalvue_type_script_lang_ts_,
  Modalvue_type_template_id_ce50073c_scoped_true_render,
  Modalvue_type_template_id_ce50073c_scoped_true_staticRenderFns,
  false,
  null,
  "ce50073c",
  null
  
)

/* harmony default export */ var Modal = (Modal_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=script&lang=ts&





/* harmony default export */ var UserSettingsModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Button: Button,
    Icon: Icon,
    Modal: Modal,
    IconButton: IconButton
  },
  props: {
    activeModal: {
      type: Boolean,
      default: false
    },
    configButtonLabel: {
      type: String,
      default: ''
    },
    closeButtonLabel: {
      type: String,
      default: 'Fechar'
    }
  },
  computed: {
    optionsItems: function optionsItems() {
      return [{
        label: this.configButtonLabel,
        clickHandler: this.openModal
      }, {
        label: this.closeButtonLabel,
        clickHandler: this.closeParentComponent
      }];
    }
  },
  data: function data() {
    return {
      isOptionsOpened: false
    };
  },
  methods: {
    openModal: function openModal() {
      this.isOptionsOpened = false;
      this.$emit('update:activeModal', true);
    },
    closeModal: function closeModal() {
      this.$emit('update:activeModal', false);
    },
    closeParentComponent: function closeParentComponent() {
      this.isOptionsOpened = false;
      this.$emit('closeParentComponent', true);
    },
    toggleOptions: function toggleOptions() {
      this.isOptionsOpened = !this.isOptionsOpened;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var UserSettingsModal_UserSettingsModalvue_type_script_lang_ts_ = (UserSettingsModalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=style&index=0&id=88eb3672&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=style&index=0&id=88eb3672&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=style&index=1&id=88eb3672&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/UserSettingsModal/UserSettingsModal.vue?vue&type=style&index=1&id=88eb3672&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/UserSettingsModal/UserSettingsModal.vue



;



/* normalize component */

var UserSettingsModal_component = normalizeComponent(
  UserSettingsModal_UserSettingsModalvue_type_script_lang_ts_,
  UserSettingsModalvue_type_template_id_88eb3672_scoped_true_render,
  UserSettingsModalvue_type_template_id_88eb3672_scoped_true_staticRenderFns,
  false,
  null,
  "88eb3672",
  null
  
)

/* harmony default export */ var UserSettingsModal = (UserSettingsModal_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/CardSkeleton.vue?vue&type=template&id=6b724e09&scoped=true&
var CardSkeletonvue_type_template_id_6b724e09_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "skeleton-card"
  }, [_vm._t("default")], 2);
};
var CardSkeletonvue_type_template_id_6b724e09_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/CardSkeleton.vue?vue&type=script&lang=ts&

/* harmony default export */ var CardSkeletonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend());
;// CONCATENATED MODULE: ./src/components/Skeleton/CardSkeleton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Skeleton_CardSkeletonvue_type_script_lang_ts_ = (CardSkeletonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/CardSkeleton.vue?vue&type=style&index=0&id=6b724e09&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Skeleton/CardSkeleton.vue?vue&type=style&index=0&id=6b724e09&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Skeleton/CardSkeleton.vue



;


/* normalize component */

var CardSkeleton_component = normalizeComponent(
  Skeleton_CardSkeletonvue_type_script_lang_ts_,
  CardSkeletonvue_type_template_id_6b724e09_scoped_true_render,
  CardSkeletonvue_type_template_id_6b724e09_scoped_true_staticRenderFns,
  false,
  null,
  "6b724e09",
  null
  
)

/* harmony default export */ var CardSkeleton = (CardSkeleton_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/LineSkeleton.vue?vue&type=template&id=65b9378e&scoped=true&
var LineSkeletonvue_type_template_id_65b9378e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('span', {
    staticClass: "skeleton-line",
    style: {
      width: _vm.width,
      height: _vm.height
    }
  });
};
var LineSkeletonvue_type_template_id_65b9378e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/LineSkeleton.vue?vue&type=script&lang=ts&

/* harmony default export */ var LineSkeletonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '15px'
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Skeleton/LineSkeleton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Skeleton_LineSkeletonvue_type_script_lang_ts_ = (LineSkeletonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Skeleton/LineSkeleton.vue?vue&type=style&index=0&id=65b9378e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Skeleton/LineSkeleton.vue?vue&type=style&index=0&id=65b9378e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Skeleton/LineSkeleton.vue



;


/* normalize component */

var LineSkeleton_component = normalizeComponent(
  Skeleton_LineSkeletonvue_type_script_lang_ts_,
  LineSkeletonvue_type_template_id_65b9378e_scoped_true_render,
  LineSkeletonvue_type_template_id_65b9378e_scoped_true_staticRenderFns,
  false,
  null,
  "65b9378e",
  null
  
)

/* harmony default export */ var LineSkeleton = (LineSkeleton_component.exports);
;// CONCATENATED MODULE: ./src/components/Skeleton/index.ts



;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tabs.vue?vue&type=template&id=15641e86&scoped=true&

var Tabsvue_type_template_id_15641e86_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: {
      v2: _vm.v2
    }
  }, [_c('div', {
    staticClass: "tabs-wrapper"
  }, [_c('ul', {
    staticClass: "tabs",
    class: {
      'tabs--spaced': _vm.spaced
    }
  }, [_vm._l(_vm.tabs, function (tab, i) {
    return _c('li', {
      key: i,
      staticClass: "tab",
      class: {
        'tab--active': tab.isActive,
        'tab--locked': tab.isLocked
      },
      on: {
        "click": function click($event) {
          !tab.isLocked && _vm.selectTab(tab);
        }
      }
    }, [tab.isLocked ? _c('Icon', {
      staticClass: "tab__icon",
      attrs: {
        "size": 20,
        "name": "locker"
      }
    }) : _vm._e(), _c('span', {
      staticClass: "tab__label"
    }, [tab.icon && !tab.isLocked ? _c('Icon', {
      staticClass: "tab__icon",
      attrs: {
        "size": 20,
        "name": tab.icon
      }
    }) : _vm._e(), _vm._v(" " + _vm._s(tab.name) + " ")], 1)], 1);
  }), _vm._t("tab-button")], 2)]), _c('div', [_vm._t("default")], 2)]);
};
var Tabsvue_type_template_id_15641e86_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue?vue&type=template&id=15641e86&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tabs.vue?vue&type=script&lang=ts&






/* harmony default export */ var Tabsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    v2: {
      type: Boolean,
      default: false
    },
    spaced: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      tabs: []
    };
  },
  methods: {
    selectTab: function selectTab(selectedTab) {
      this.tabs.forEach(function (tab) {
        tab.isActive = tab.name == selectedTab.name;
      });
      this.$emit('selected', selectedTab.name);
    },
    addTab: function addTab(item) {
      this.tabs.push(item);
    }
  },
  provide: function provide() {
    return {
      addTab: this.addTab
    };
  }
}));
;// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Tabs_Tabsvue_type_script_lang_ts_ = (Tabsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tabs.vue?vue&type=style&index=0&id=15641e86&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue?vue&type=style&index=0&id=15641e86&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Tabs/Tabs.vue



;


/* normalize component */

var Tabs_component = normalizeComponent(
  Tabs_Tabsvue_type_script_lang_ts_,
  Tabsvue_type_template_id_15641e86_scoped_true_render,
  Tabsvue_type_template_id_15641e86_scoped_true_staticRenderFns,
  false,
  null,
  "15641e86",
  null
  
)

/* harmony default export */ var Tabs = (Tabs_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tab.vue?vue&type=template&id=b611e71c&scoped=true&
var Tabvue_type_template_id_b611e71c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isActive,
      expression: "isActive"
    }]
  }, [_vm._t("default")], 2);
};
var Tabvue_type_template_id_b611e71c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tabs/Tab.vue?vue&type=script&lang=ts&

/* harmony default export */ var Tabvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    icon: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      required: true
    },
    isSelected: {
      type: Boolean,
      default: false
    },
    isLocked: {
      type: Boolean,
      default: false
    },
    tooltip: {
      type: Object,
      default: function _default() {}
    }
  },
  data: function data() {
    return {
      isActive: false
    };
  },
  inject: {
    addTab: {
      from: 'addTab',
      // eslint-disable-next-line
      default: function _default(a) {}
    }
  },
  mounted: function mounted() {
    this.isActive = this.isSelected;
    // TODO investigate how we can remove this ignore
    // @ts-ignore
    this.addTab(this);
  }
}));
;// CONCATENATED MODULE: ./src/components/Tabs/Tab.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Tabs_Tabvue_type_script_lang_ts_ = (Tabvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Tabs/Tab.vue





/* normalize component */
;
var Tab_component = normalizeComponent(
  Tabs_Tabvue_type_script_lang_ts_,
  Tabvue_type_template_id_b611e71c_scoped_true_render,
  Tabvue_type_template_id_b611e71c_scoped_true_staticRenderFns,
  false,
  null,
  "b611e71c",
  null
  
)

/* harmony default export */ var Tab = (Tab_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DrawerNotes/NotesDrawer.vue?vue&type=script&lang=ts&











/* harmony default export */ var NotesDrawervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Button: components_Button,
    UserSettingsModal: UserSettingsModal,
    CardSkeleton: CardSkeleton,
    LineSkeleton: LineSkeleton,
    Tabs: Tabs,
    Tab: Tab
  },
  props: {
    title: {
      type: String,
      default: 'Anotações'
    },
    toggleShowDrawer: {
      type: Boolean,
      default: false
    },
    toggleShowSlotContents: {
      type: Boolean,
      default: false
    },
    toggleShowShareModal: {
      type: Boolean,
      default: true
    },
    shouldShowUserSettings: {
      type: Boolean,
      default: false
    },
    shouldShowShareButton: {
      type: Boolean,
      default: false
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    shareableUrl: {
      type: String,
      default: ''
    },
    tabs: {
      type: Array,
      default: undefined
    }
  },
  data: function data() {
    return {
      configurationModal: false,
      isShareLinkCopied: false,
      timeouts: [],
      selectedTab: 0
    };
  },
  computed: {
    shouldShowShareModal: function shouldShowShareModal() {
      return this.toggleShowShareModal && this.toggleShowSlotContents && this.shareableUrl.length > 1;
    },
    shouldShowTabs: function shouldShowTabs() {
      var _this$tabs;
      return ((_this$tabs = this.tabs) === null || _this$tabs === void 0 ? void 0 : _this$tabs.length) > 0;
    }
  },
  beforeDestroy: function beforeDestroy() {
    var _window = window,
      clearTimeout = _window.clearTimeout;
    this.timeouts.map(function (timeout) {
      return clearTimeout(timeout);
    });
  },
  methods: {
    closeDrawer: function closeDrawer() {
      this.$emit('update:toggleShowDrawer', false);
    },
    closeShareModal: function closeShareModal() {
      this.$emit('update:toggleShowShareModal', false);
    },
    showSlotContents: function showSlotContents() {
      this.$emit('update:toggleShowSlotContents', true);
    },
    showShare: function showShare() {
      this.$emit('update:toggleShowShare', true);
    },
    toggleModal: function toggleModal(active) {
      this.configurationModal = active;
    },
    copyHandler: function copyHandler() {
      var _this = this;
      this.isShareLinkCopied = true;
      this.$emit('linkCopied');
      var _window2 = window,
        setTimeout = _window2.setTimeout;
      this.timeouts.push(setTimeout(function () {
        _this.isShareLinkCopied = false;
      }, 2000));
    },
    shareHandler: function shareHandler() {
      var _this2 = this;
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this2.$emit('shareClicked');
            case 1:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }))();
    },
    isTabSelected: function isTabSelected(i) {
      return this.selectedTab === i;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DrawerNotes/NotesDrawer.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DrawerNotes_NotesDrawervue_type_script_lang_ts_ = (NotesDrawervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DrawerNotes/NotesDrawer.vue?vue&type=style&index=0&id=063b231f&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DrawerNotes/NotesDrawer.vue?vue&type=style&index=0&id=063b231f&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/DrawerNotes/NotesDrawer.vue



;


/* normalize component */

var NotesDrawer_component = normalizeComponent(
  DrawerNotes_NotesDrawervue_type_script_lang_ts_,
  NotesDrawervue_type_template_id_063b231f_scoped_true_render,
  NotesDrawervue_type_template_id_063b231f_scoped_true_staticRenderFns,
  false,
  null,
  "063b231f",
  null
  
)

/* harmony default export */ var NotesDrawer = (NotesDrawer_component.exports);
;// CONCATENATED MODULE: ./src/components/DrawerNotes/index.ts

;// CONCATENATED MODULE: ./src/components/UserSettingsModal/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dropdown/Dropdown.vue?vue&type=template&id=44423c10&scoped=true&
var Dropdownvue_type_template_id_44423c10_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "dropdown__list"
  }, [_c('div', {
    staticClass: "dropdown__search"
  }, [_vm.isSearchable ? _c('div', {
    staticClass: "dropdown__textbar"
  }, [_c('Icon', {
    staticClass: "dropdown__search-icon",
    attrs: {
      "name": "search"
    }
  }), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.searchTerm,
      expression: "searchTerm"
    }],
    attrs: {
      "type": "search",
      "placeholder": _vm.placeholder
    },
    domProps: {
      "value": _vm.searchTerm
    },
    on: {
      "input": function input($event) {
        if ($event.target.composing) return;
        _vm.searchTerm = $event.target.value;
      }
    }
  })], 1) : _vm._e()]), _vm.topicTitle ? _c('div', {
    staticClass: "multi_topic subtitle-2"
  }, [_vm._v(" " + _vm._s(_vm.topicTitle) + " "), _c('div', {
    staticClass: "multi_topic__line"
  })]) : _vm._e(), _c('ul', _vm._l(_vm.sortedItems, function (item) {
    return _c('li', {
      key: item.value,
      staticClass: "dropdown__item h6",
      class: {
        'dropdown__item--current': _vm.itemIsSelected(item)
      },
      on: {
        "click": function click($event) {
          return _vm.selectItem(item);
        }
      }
    }, [_c('p', [_vm._v(_vm._s(item))]), _c('Icon', {
      staticClass: "dropdown__check",
      attrs: {
        "name": "check"
      }
    })], 1);
  }), 0), _vm.slotHasContent ? _c('div', {
    staticClass: "dropdown__slot"
  }, [_vm._t("default")], 2) : _vm._e()]);
};
var Dropdownvue_type_template_id_44423c10_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.sort.js
var es_array_sort = __webpack_require__(2707);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.search.js
var es_string_search = __webpack_require__(4765);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.splice.js
var es_array_splice = __webpack_require__(561);
// EXTERNAL MODULE: ./node_modules/fuse.js/dist/fuse.js
var fuse = __webpack_require__(4070);
var fuse_default = /*#__PURE__*/__webpack_require__.n(fuse);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dropdown/Dropdown.vue?vue&type=script&lang=ts&















var fuzzyOptions = {
  caseSensitive: false,
  shouldSort: true,
  location: 0,
  minMatchCharLength: 1
};
/* harmony default export */ var Dropdownvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  model: {
    prop: 'selected',
    event: 'input'
  },
  components: {
    Icon: Icon
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    selected: {
      type: [String, Array],
      default: ''
    },
    isMultiSelect: {
      type: Boolean,
      default: false
    },
    isSearchable: {
      type: Boolean,
      default: false
    },
    topicTitle: {
      type: String,
      default: ''
    },
    fuzzyFilter: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: 'Digite uma palavra chave'
    },
    searchString: {
      type: String,
      default: ''
    },
    selectedFirst: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      searchTerm: this.searchString,
      current: this.selected || (this.isMultiSelect ? [] : ''),
      fuzzyComparer: new (fuse_default())(this.items, fuzzyOptions)
    };
  },
  computed: {
    sortedItems: function sortedItems() {
      var _this = this;
      if (!this.selectedFirst) return this.itemsList;
      return this.itemsList.concat().sort(function (A, B) {
        if (_this.itemIsSelected(A)) return -1;
        if (_this.itemIsSelected(B)) return 1;
        return 0;
      });
    },
    itemsList: function itemsList() {
      var _this2 = this;
      if (this.searchTerm == '') return this.items;
      if (this.fuzzyFilter) return this.fuzzySearch;
      return this.items.filter(function (element) {
        var itemtoSearch = _this2.processString(_this2.searchTerm);
        var elementNormalized = _this2.processString(element);
        return elementNormalized.includes(itemtoSearch);
      });
    },
    fuzzySearch: function fuzzySearch() {
      var _this3 = this;
      return this.fuzzyComparer.search(this.searchTerm).map(function (_value, index) {
        return _this3.items[+index];
      });
    },
    slotHasContent: function slotHasContent() {
      return !!this.$slots.default;
    }
  },
  methods: {
    selectItem: function selectItem(item) {
      if (this.isMultiSelect) {
        if (this.current.includes(item)) {
          this.current.splice(this.current.indexOf(item), 1);
        } else {
          this.current.push(item);
        }
      } else {
        this.current = item;
      }
      this.$emit('input', this.current);
    },
    processString: function processString(item) {
      return item.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase();
    },
    itemIsSelected: function itemIsSelected(item) {
      if (this.isMultiSelect) return this.current.includes(item);
      return this.current === item;
    }
  },
  watch: {
    selected: function selected(newValue) {
      this.current = newValue;
    },
    items: function items(newValue) {
      this.fuzzyComparer = new (fuse_default())(newValue, fuzzyOptions);
    },
    searchString: function searchString(newValue) {
      this.searchTerm = newValue;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Dropdown_Dropdownvue_type_script_lang_ts_ = (Dropdownvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Dropdown/Dropdown.vue?vue&type=style&index=0&id=44423c10&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue?vue&type=style&index=0&id=44423c10&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Dropdown/Dropdown.vue



;


/* normalize component */

var Dropdown_component = normalizeComponent(
  Dropdown_Dropdownvue_type_script_lang_ts_,
  Dropdownvue_type_template_id_44423c10_scoped_true_render,
  Dropdownvue_type_template_id_44423c10_scoped_true_staticRenderFns,
  false,
  null,
  "44423c10",
  null
  
)

/* harmony default export */ var Dropdown = (Dropdown_component.exports);
;// CONCATENATED MODULE: ./src/components/Dropdown/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenu.vue?vue&type=template&id=30a055bf&scoped=true&
var DropDownMenuvue_type_template_id_30a055bf_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('DropdownMenuHeader', {
    staticClass: "dropdown-menu__header",
    attrs: {
      "user-name": _vm.userName,
      "user-photo": _vm.userPhoto,
      "profile-link": _vm.profileLink
    }
  }), _c('div', {
    staticClass: "dropdown-menu__line"
  }, [_c('ul', {
    staticClass: "subtitle-1"
  }, [_vm._t("default"), _c('DropdownMenuDefaultOptions', _vm._g({
    attrs: {
      "customer-service-url": _vm.customerServiceUrl,
      "logoutUser": _vm.logoutUser
    }
  }, _vm.$listeners))], 2)])], 1);
};
var DropDownMenuvue_type_template_id_30a055bf_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue?vue&type=template&id=64fb33ae&scoped=true&
var DropdownMenuDefaultOptionsvue_type_template_id_64fb33ae_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_vm.customerServiceUrl ? _c('li', {
    staticClass: "dropdown-bottom",
    on: {
      "click": function click($event) {
        return _vm.openHelpCenter();
      }
    }
  }, [_c('Icon', {
    staticClass: "dropdown-bottom__icon",
    attrs: {
      "name": "help"
    }
  }), _vm._v(" Central de Ajuda ")], 1) : _vm._e(), _c('li', {
    staticClass: "dropdown-bottom",
    on: {
      "click": _vm.logoutUser
    }
  }, [_c('Icon', {
    staticClass: "dropdown-bottom__icon",
    attrs: {
      "name": "exit"
    }
  }), _vm._v(" Sair ")], 1)]);
};
var DropdownMenuDefaultOptionsvue_type_template_id_64fb33ae_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue?vue&type=script&lang=ts&


/* harmony default export */ var DropdownMenuDefaultOptionsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    customerServiceUrl: {
      type: String,
      default: ''
    },
    logoutUser: {
      type: Function,
      default: function _default() {
        return window.location.reload();
      }
    }
  },
  methods: {
    openHelpCenter: function openHelpCenter() {
      this.$emit('onClickCustomerService');
      window.open(this.customerServiceUrl, '_blank');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DropDownMenu_DropdownMenuDefaultOptionsvue_type_script_lang_ts_ = (DropdownMenuDefaultOptionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue?vue&type=style&index=0&id=64fb33ae&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue?vue&type=style&index=0&id=64fb33ae&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuDefaultOptions.vue



;


/* normalize component */

var DropdownMenuDefaultOptions_component = normalizeComponent(
  DropDownMenu_DropdownMenuDefaultOptionsvue_type_script_lang_ts_,
  DropdownMenuDefaultOptionsvue_type_template_id_64fb33ae_scoped_true_render,
  DropdownMenuDefaultOptionsvue_type_template_id_64fb33ae_scoped_true_staticRenderFns,
  false,
  null,
  "64fb33ae",
  null
  
)

/* harmony default export */ var DropdownMenuDefaultOptions = (DropdownMenuDefaultOptions_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuHeader.vue?vue&type=template&id=65b7ed18&scoped=true&
var DropdownMenuHeadervue_type_template_id_65b7ed18_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    class: _vm.isMobile ? 'dropdown-top--mobile' : 'dropdown-top'
  }, [_c('Avatar', {
    class: _vm.isMobile ? 'photo--mobile' : 'photo',
    attrs: {
      "src": _vm.userPhoto
    }
  }), _c('p', {
    class: _vm.isMobile ? 'name--mobile h2' : 'h6 name'
  }, [_vm._v(" " + _vm._s(_vm.getFirstName) + " ")]), _c('p', {
    staticClass: "subtitle-2 viewprofile",
    on: {
      "click": function click($event) {
        return _vm.openProfile();
      }
    }
  }, [_vm._v(" Visualizar perfil ")])], 1);
};
var DropdownMenuHeadervue_type_template_id_65b7ed18_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuHeader.vue?vue&type=script&lang=ts&


/* harmony default export */ var DropdownMenuHeadervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Avatar: Avatar
  },
  props: {
    userName: {
      type: String,
      default: 'Aluno do Descomplica'
    },
    userPhoto: {
      type: String,
      default: ''
    },
    isMobile: {
      type: Boolean,
      default: false
    },
    profileLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    getFirstName: function getFirstName() {
      return this.userName && this.userName.split(' ')[0];
    }
  },
  methods: {
    openProfile: function openProfile() {
      window.open(this.profileLink, '_self');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuHeader.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DropDownMenu_DropdownMenuHeadervue_type_script_lang_ts_ = (DropdownMenuHeadervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuHeader.vue?vue&type=style&index=0&id=65b7ed18&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuHeader.vue?vue&type=style&index=0&id=65b7ed18&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuHeader.vue



;


/* normalize component */

var DropdownMenuHeader_component = normalizeComponent(
  DropDownMenu_DropdownMenuHeadervue_type_script_lang_ts_,
  DropdownMenuHeadervue_type_template_id_65b7ed18_scoped_true_render,
  DropdownMenuHeadervue_type_template_id_65b7ed18_scoped_true_staticRenderFns,
  false,
  null,
  "65b7ed18",
  null
  
)

/* harmony default export */ var DropdownMenuHeader = (DropdownMenuHeader_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenu.vue?vue&type=script&lang=ts&



/* harmony default export */ var DropDownMenuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    DropdownMenuDefaultOptions: DropdownMenuDefaultOptions,
    DropdownMenuHeader: DropdownMenuHeader
  },
  props: {
    userPhoto: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: 'Aluno do Descomplica'
    },
    customerServiceUrl: {
      type: String,
      default: ''
    },
    logoutUser: {
      type: Function,
      default: function _default() {
        return window.location.reload();
      }
    },
    profileLink: {
      type: String,
      default: ''
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DropDownMenu_DropDownMenuvue_type_script_lang_ts_ = (DropDownMenuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenu.vue?vue&type=style&index=0&id=30a055bf&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenu.vue?vue&type=style&index=0&id=30a055bf&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenu.vue



;


/* normalize component */

var DropDownMenu_component = normalizeComponent(
  DropDownMenu_DropDownMenuvue_type_script_lang_ts_,
  DropDownMenuvue_type_template_id_30a055bf_scoped_true_render,
  DropDownMenuvue_type_template_id_30a055bf_scoped_true_staticRenderFns,
  false,
  null,
  "30a055bf",
  null
  
)

/* harmony default export */ var DropDownMenu = (DropDownMenu_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=template&id=7b37a6ca&scoped=true&

var DropdownMenuMobilevue_type_template_id_7b37a6ca_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('Modal', {
    staticClass: "show-for-small modal",
    attrs: {
      "active": _vm.mobileModal,
      "modal-in-bottom": _vm.isMobile,
      "has-close-button": !_vm.multiCourseShow
    },
    on: {
      "update:active": _vm.onClose
    }
  }, [_vm.multiCourseShow ? _c('div', [_c('ul', {
    staticClass: "subtitle subcourses-menu"
  }, [_c('CustomLink', {
    staticClass: "dropdown-bottom__link subcourses-menu__items",
    attrs: {
      "on-click-handler": _vm.closeMultipleCourses
    }
  }, [_c('li', {
    staticClass: "multiple-courses__title"
  }, [_c('Icon', {
    staticClass: "dropdown-bottom__icon",
    attrs: {
      "name": "arrowBack"
    }
  }), _c('p', {
    staticClass: "h5"
  }, [_vm._v("Seus cursos")])], 1)]), _vm._l(_vm.userCoursesGroupedByCategory, function (coursesByCategory) {
    return _c('li', {
      key: coursesByCategory.category,
      staticClass: "multiple-courses subcourses-menu__items"
    }, [_c('p', {
      staticClass: "multiple-courses__category subtitle-2"
    }, [_vm._v(" " + _vm._s(coursesByCategory.category) + " ")]), _c('ul', _vm._l(coursesByCategory.courses, function (course) {
      return _c('li', {
        key: course.name
      }, [_c('CustomLink', {
        staticClass: "multiple-courses__link",
        attrs: {
          "src": course.src,
          "target": course.target,
          "router-path": course.routerPath,
          "router-name": course.routerName,
          "on-click-handler": course.onClickHandler
        }
      }, [_c('div', {
        staticClass: "subcourses-menu__courses"
      }, [_c('div', {
        staticClass: "checkmark",
        class: {
          'checkmark--checked': _vm.currentCourse === course.name
        }
      }), _c('div', {
        staticClass: "h5 multiple-courses__course",
        class: {
          'multiple-courses__course--checked h5': _vm.currentCourse === course.name
        }
      }, [_vm._v(" " + _vm._s(course.name) + " ")])])])], 1);
    }), 0)]);
  })], 2)]) : _c('div', {
    staticClass: "dropdown-menu"
  }, [_c('DropdownMenuHeader', {
    staticClass: "dropdown-menu__header",
    attrs: {
      "userPhoto": _vm.profileUserPhoto,
      "userName": _vm.profileUserName || _vm.user.name,
      "profile-link": _vm.profileLink,
      "is-mobile": ""
    }
  }), _c('ul', {
    staticClass: "subtitle-1 dropdown-menu__line"
  }, [_vm.currentCourse ? _c('li', {
    staticClass: "dropdown-bottom",
    on: {
      "click": _vm.openMultiCourseMenu
    }
  }, [_c('Icon', {
    staticClass: "dropdown-bottom__icon",
    attrs: {
      "name": "apps"
    }
  }), _vm._v(" Seus Cursos ")], 1) : _vm._e(), _c('li', [_vm._t("default"), _c('DropdownMenuDefaultOptions', _vm._g({
    attrs: {
      "customer-service-url": _vm.customerServiceUrl,
      "logoutUser": _vm.logoutUser
    }
  }, _vm.$listeners))], 2)])], 1)]);
};
var DropdownMenuMobilevue_type_template_id_7b37a6ca_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=template&id=7b37a6ca&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=script&lang=ts&






/* harmony default export */ var DropdownMenuMobilevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Modal: Modal,
    DropdownMenuHeader: DropdownMenuHeader,
    Icon: Icon,
    CustomLink: CustomLink,
    DropdownMenuDefaultOptions: DropdownMenuDefaultOptions
  },
  props: {
    user: {
      type: Object,
      required: true
    },
    profileUserName: {
      type: String,
      default: ''
    },
    profileUserPhoto: {
      type: String,
      default: ''
    },
    userCoursesGroupedByCategory: {
      type: Array,
      default: undefined
    },
    currentCourse: {
      type: String,
      default: undefined
    },
    mobileModal: {
      type: Boolean,
      default: false
    },
    logoutUser: {
      type: Function,
      default: function _default() {
        return window.location.reload();
      }
    },
    profileLink: {
      type: String,
      default: ''
    },
    customerServiceUrl: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      multiCourseShow: false,
      isMobile: true
    };
  },
  methods: {
    openMultiCourseMenu: function openMultiCourseMenu() {
      this.multiCourseShow = true;
    },
    onClose: function onClose() {
      this.closeMultipleCourses();
      this.$emit('onClose');
    },
    closeMultipleCourses: function closeMultipleCourses() {
      this.multiCourseShow = false;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DropDownMenu_DropdownMenuMobilevue_type_script_lang_ts_ = (DropdownMenuMobilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=style&index=0&id=7b37a6ca&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuMobile.vue?vue&type=style&index=0&id=7b37a6ca&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropdownMenuMobile.vue



;


/* normalize component */

var DropdownMenuMobile_component = normalizeComponent(
  DropDownMenu_DropdownMenuMobilevue_type_script_lang_ts_,
  DropdownMenuMobilevue_type_template_id_7b37a6ca_scoped_true_render,
  DropdownMenuMobilevue_type_template_id_7b37a6ca_scoped_true_staticRenderFns,
  false,
  null,
  "7b37a6ca",
  null
  
)

/* harmony default export */ var DropdownMenuMobile = (DropdownMenuMobile_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenuOption.vue?vue&type=template&id=7ab703dd&scoped=true&
var DropDownMenuOptionvue_type_template_id_7ab703dd_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('li', {
    staticClass: "dropdown-bottom",
    on: {
      "click": function click($event) {
        return _vm.action();
      }
    }
  }, [_vm._t("default")], 2);
};
var DropDownMenuOptionvue_type_template_id_7ab703dd_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenuOption.vue?vue&type=script&lang=ts&

/* harmony default export */ var DropDownMenuOptionvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    action: {
      type: Function,
      default: function _default() {}
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenuOption.vue?vue&type=script&lang=ts&
 /* harmony default export */ var DropDownMenu_DropDownMenuOptionvue_type_script_lang_ts_ = (DropDownMenuOptionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/DropDownMenu/DropDownMenuOption.vue?vue&type=style&index=0&id=7ab703dd&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenuOption.vue?vue&type=style&index=0&id=7ab703dd&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/DropDownMenu/DropDownMenuOption.vue



;


/* normalize component */

var DropDownMenuOption_component = normalizeComponent(
  DropDownMenu_DropDownMenuOptionvue_type_script_lang_ts_,
  DropDownMenuOptionvue_type_template_id_7ab703dd_scoped_true_render,
  DropDownMenuOptionvue_type_template_id_7ab703dd_scoped_true_staticRenderFns,
  false,
  null,
  "7ab703dd",
  null
  
)

/* harmony default export */ var DropDownMenuOption = (DropDownMenuOption_component.exports);
;// CONCATENATED MODULE: ./src/components/DropDownMenu/index.ts



/* harmony default export */ var components_DropDownMenu = (DropDownMenu);

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileUploadBox/FileUploadBox.vue?vue&type=template&id=f5dff128&scoped=true&
var FileUploadBoxvue_type_template_id_f5dff128_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "file-upload-box-wrapper"
  }, [_c('label', {
    staticClass: "file-upload-box",
    class: {
      'file-upload-box--error': !!_vm.errorMessage
    },
    style: {
      'border-width': "".concat(_vm.borderWidth, "px")
    }
  }, [_c('p', {
    staticClass: "file-upload-box__upper-title subtitle-1",
    class: {
      'file-upload-box__upper-title--hidden': _vm.hideUpperTitle
    }
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]), _c('div', {
    staticClass: "file-upload-box__label"
  }, [_c('input', {
    ref: "inputFile",
    staticClass: "input",
    attrs: {
      "type": "file",
      "accept": _vm.accept
    },
    on: {
      "change": _vm.changeHandler
    }
  }), _vm.isDone ? _c('p', {
    staticClass: "file-upload-box__label__title subtitle-2"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")]) : _vm._e(), _c('p', {
    staticClass: "h6"
  }, [_vm._v(_vm._s(_vm.title))])]), _c('Icon', {
    staticClass: "file-upload-box__icon",
    class: {
      'file-upload-box__icon--green': _vm.icon === 'check'
    },
    attrs: {
      "name": _vm.icon
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.actionIconHandler.apply(null, arguments);
      }
    }
  }), _vm.isLoading ? _c('div', {
    staticClass: "file-upload-box__progress"
  }, [_c('div', {
    staticClass: "file-upload-box__progress__fill",
    style: {
      width: "".concat(_vm.progress, "%")
    }
  })]) : _vm._e()], 1), _vm.errorMessage ? _c('span', {
    staticClass: "error-message subtitle-2"
  }, [_vm._v(_vm._s(_vm.errorMessage))]) : _vm._e()]);
};
var FileUploadBoxvue_type_template_id_f5dff128_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileUploadBox/FileUploadBox.vue?vue&type=script&lang=ts&





/* harmony default export */ var FileUploadBoxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    accept: {
      type: String,
      default: null
    },
    done: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    fileName: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      required: true
    },
    maxFileSize: {
      type: Number,
      default: 0
    },
    borderWidth: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      file: {},
      icon: this.done ? 'delete' : 'upload',
      isDone: this.done,
      progress: 0,
      progressInterval: null
    };
  },
  watch: {
    done: function done(value) {
      this.isDone = value;
    }
  },
  computed: {
    hideUpperTitle: function hideUpperTitle() {
      return this.isDone || !this.fileName;
    },
    isLoading: function isLoading() {
      return ['', 'check'].includes(this.icon);
    },
    title: function title() {
      return this.fileName || this.label;
    }
  },
  methods: {
    actionIconHandler: function actionIconHandler(event) {
      if (this.icon === 'delete') {
        event.preventDefault();
        this.icon = 'upload';
        this.$refs.inputFile.value = '';
        this.$emit('delete');
      }
    },
    changeHandler: function changeHandler(event) {
      var _this = this;
      var file = event.target.files[0];
      if (!file) return;
      if (this.accept && (!file.type || !this.accept.includes(file.type))) {
        this.$emit('error', 'type', file.type);
        return;
      }
      if (this.maxFileSize && file.size > this.maxFileSize) {
        this.$emit('error', 'size', file.size);
        return;
      }
      this.icon = '';
      this.progress = 0;
      this.progressInterval = setInterval(function () {
        return _this.progressIntervalCallback();
      }, 200);
      this.$emit('change', file);
    },
    progressIntervalCallback: function progressIntervalCallback() {
      var _this2 = this;
      if (this.isDone) {
        clearInterval(this.progressInterval);
        this.progress = 100;
        this.icon = 'check';
        setTimeout(function () {
          return _this2.icon = 'delete';
        }, 500);
      } else if (this.progress < 90) {
        this.progress += 10;
      }
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/FileUploadBox/FileUploadBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FileUploadBox_FileUploadBoxvue_type_script_lang_ts_ = (FileUploadBoxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileUploadBox/FileUploadBox.vue?vue&type=style&index=0&id=f5dff128&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FileUploadBox/FileUploadBox.vue?vue&type=style&index=0&id=f5dff128&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/FileUploadBox/FileUploadBox.vue



;


/* normalize component */

var FileUploadBox_component = normalizeComponent(
  FileUploadBox_FileUploadBoxvue_type_script_lang_ts_,
  FileUploadBoxvue_type_template_id_f5dff128_scoped_true_render,
  FileUploadBoxvue_type_template_id_f5dff128_scoped_true_staticRenderFns,
  false,
  null,
  "f5dff128",
  null
  
)

/* harmony default export */ var FileUploadBox = (FileUploadBox_component.exports);
;// CONCATENATED MODULE: ./src/components/FileUploadBox/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FloatingActionButton/FloatingActionButton.vue?vue&type=template&id=3b337fb4&scoped=true&
var FloatingActionButtonvue_type_template_id_3b337fb4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('Button', {
    class: ['fab-button', "".concat(_vm.fabPosition.corner)],
    style: {
      '--horizontal-desktop': "".concat(_vm.fabPosition.desktop.horizontal, "px"),
      '--vertical-desktop': "".concat(_vm.fabPosition.desktop.vertical, "px"),
      '--horizontal-mobile': "".concat(_vm.fabPosition.mobile.horizontal, "px"),
      '--vertical-mobile': "".concat(_vm.fabPosition.mobile.vertical, "px")
    },
    attrs: {
      "medium": "",
      "title": _vm.title
    }
  }, [_c('Icon', {
    staticClass: "fab-button__icon",
    attrs: {
      "name": _vm.icon,
      "size": 22
    }
  }), _c('span', {
    staticClass: "fab-button__title"
  }, [_vm._v(_vm._s(_vm.title))])], 1), _vm.badgeCount ? _c('span', {
    class: ['fab-badge', "".concat(_vm.badgePosition.corner)],
    style: {
      '--horizontal-desktop': "".concat(_vm.badgePosition.desktop.horizontal, "px"),
      '--vertical-desktop': "".concat(_vm.badgePosition.desktop.vertical, "px"),
      '--horizontal-mobile': "".concat(_vm.badgePosition.mobile.horizontal, "px"),
      '--vertical-mobile': "".concat(_vm.badgePosition.mobile.vertical, "px")
    }
  }, [_vm._v(" " + _vm._s(_vm.badgeCounter) + " ")]) : _vm._e()], 1);
};
var FloatingActionButtonvue_type_template_id_3b337fb4_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FloatingActionButton/FloatingActionButton.vue?vue&type=script&lang=ts&




/* harmony default export */ var FloatingActionButtonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Button: Button
  },
  props: {
    title: {
      type: String
    },
    badgeCount: {
      type: Number,
      default: null
    },
    icon: {
      type: String
    },
    fabPosition: {
      type: Object,
      default: function _default() {
        return {
          corner: 'bottom-right',
          desktop: {
            horizontal: 40,
            vertical: 60
          },
          mobile: {
            horizontal: 40,
            vertical: 30
          }
        };
      }
    },
    badgePosition: {
      type: Object,
      default: function _default() {
        return {
          corner: 'bottom-right',
          desktop: {
            horizontal: 40,
            vertical: 90
          },
          mobile: {
            horizontal: 45,
            vertical: 60
          }
        };
      }
    }
  },
  computed: {
    badgeCounter: function badgeCounter() {
      return this.badgeCount && this.badgeCount <= 9 ? this.badgeCount : '9+';
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/FloatingActionButton/FloatingActionButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FloatingActionButton_FloatingActionButtonvue_type_script_lang_ts_ = (FloatingActionButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FloatingActionButton/FloatingActionButton.vue?vue&type=style&index=0&id=3b337fb4&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FloatingActionButton/FloatingActionButton.vue?vue&type=style&index=0&id=3b337fb4&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/FloatingActionButton/FloatingActionButton.vue



;


/* normalize component */

var FloatingActionButton_component = normalizeComponent(
  FloatingActionButton_FloatingActionButtonvue_type_script_lang_ts_,
  FloatingActionButtonvue_type_template_id_3b337fb4_scoped_true_render,
  FloatingActionButtonvue_type_template_id_3b337fb4_scoped_true_staticRenderFns,
  false,
  null,
  "3b337fb4",
  null
  
)

/* harmony default export */ var FloatingActionButton = (FloatingActionButton_component.exports);
;// CONCATENATED MODULE: ./src/components/FloatingActionButton/index.ts

/* harmony default export */ var components_FloatingActionButton = (FloatingActionButton);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeroImage/HeroImage.vue?vue&type=template&id=708c3a7d&scoped=true&
var HeroImagevue_type_template_id_708c3a7d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "image",
    class: {
      'image--icon': _vm.iconSrc
    }
  }, [_vm.background ? _c('img', {
    staticClass: "image__background",
    attrs: {
      "src": _vm.backgroundSrc,
      "alt": ""
    }
  }) : _vm._e(), _c('img', {
    staticClass: "image__component",
    class: {
      'image__component--background': _vm.background
    },
    style: {
      '--maskUrl': "url('".concat(_vm.maskUrl, "')")
    },
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    }
  }), _vm.iconSrc ? _c('img', {
    staticClass: "image__icon",
    attrs: {
      "src": _vm.iconSrc,
      "alt": ""
    }
  }) : _vm._e(), _vm.videoIcon ? _c('div', {
    staticClass: "image__video-player",
    attrs: {
      "target": "_blank"
    },
    on: {
      "click": _vm.emitPlayVideo
    }
  }, [_c('Icon', {
    staticClass: "image__video-player__arrow",
    attrs: {
      "name": "playArrow"
    }
  })], 1) : _vm._e()]);
};
var HeroImagevue_type_template_id_708c3a7d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeroImage/HeroImage.vue?vue&type=script&lang=ts&


/* harmony default export */ var HeroImagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    background: {
      type: Boolean,
      default: false
    },
    iconSrc: {
      type: String,
      default: ''
    },
    videoIcon: {
      type: Boolean,
      default: false
    },
    backgroundSrc: {
      type: String,
      default: ''
    },
    maskUrl: {
      type: String,
      default: ''
    }
  },
  methods: {
    emitPlayVideo: function emitPlayVideo() {
      this.$emit('playVideo');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/HeroImage/HeroImage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var HeroImage_HeroImagevue_type_script_lang_ts_ = (HeroImagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/HeroImage/HeroImage.vue?vue&type=style&index=0&id=708c3a7d&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/HeroImage/HeroImage.vue?vue&type=style&index=0&id=708c3a7d&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/HeroImage/HeroImage.vue



;


/* normalize component */

var HeroImage_component = normalizeComponent(
  HeroImage_HeroImagevue_type_script_lang_ts_,
  HeroImagevue_type_template_id_708c3a7d_scoped_true_render,
  HeroImagevue_type_template_id_708c3a7d_scoped_true_staticRenderFns,
  false,
  null,
  "708c3a7d",
  null
  
)

/* harmony default export */ var HeroImage = (HeroImage_component.exports);
;// CONCATENATED MODULE: ./src/components/HeroImage/index.ts

;// CONCATENATED MODULE: ./src/components/HoverSubtitle/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=template&id=3d14cb6f&scoped=true&
var InfiniteScrollvue_type_template_id_3d14cb6f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    ref: "infinitescrolltrigger",
    staticClass: "footer__scroll-trigger",
    attrs: {
      "id": "scroll-trigger"
    }
  }), _c('Loading', {
    attrs: {
      "is-loading": _vm.showLoader,
      "width": 50,
      "height": 50
    }
  })], 1);
};
var InfiniteScrollvue_type_template_id_3d14cb6f_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loading/Loading.vue?vue&type=template&id=f06ba326&scoped=true&
var Loadingvue_type_template_id_f06ba326_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('Lottie', {
    staticClass: "logo",
    class: {
      'logo--visible': _vm.isLoading
    },
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "options": this.options
    },
    on: {
      "animCreated": _vm.setAnimationController
    }
  });
};
var Loadingvue_type_template_id_f06ba326_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Lottie/Lottie.vue?vue&type=template&id=60c36824&
var Lottievue_type_template_id_60c36824_render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    ref: "lavContainer",
    style: _vm.style
  });
};
var Lottievue_type_template_id_60c36824_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/lottie-web/build/player/lottie.js
var lottie = __webpack_require__(1248);
var lottie_default = /*#__PURE__*/__webpack_require__.n(lottie);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Lottie/Lottie.vue?vue&type=script&lang=js&


/* harmony default export */ var Lottievue_type_script_lang_js_ = ({
  props: {
    options: {
      type: Object,
      required: true
    },
    height: {
      type: Number,
      default: 0
    },
    width: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      style: {
        width: this.width ? "".concat(this.width, "px") : '100%',
        height: this.height ? "".concat(this.height, "px") : '100%',
        overflow: 'hidden',
        margin: '0 auto'
      }
    };
  },
  mounted: function mounted() {
    this.anim = lottie_default().loadAnimation({
      container: this.$refs.lavContainer,
      renderer: 'svg',
      loop: this.options.loop,
      autoplay: this.options.autoplay,
      animationData: this.options.animationData.default,
      rendererSettings: this.options.rendererSettings
    });
    this.$emit('animCreated', this.anim);
  }
});
;// CONCATENATED MODULE: ./src/components/Lottie/Lottie.vue?vue&type=script&lang=js&
 /* harmony default export */ var Lottie_Lottievue_type_script_lang_js_ = (Lottievue_type_script_lang_js_); 
;// CONCATENATED MODULE: ./src/components/Lottie/Lottie.vue





/* normalize component */
;
var Lottie_component = normalizeComponent(
  Lottie_Lottievue_type_script_lang_js_,
  Lottievue_type_template_id_60c36824_render,
  Lottievue_type_template_id_60c36824_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Lottie = (Lottie_component.exports);
;// CONCATENATED MODULE: ./src/assets/animations/logo.v2.json
var logo_v2_namespaceObject = JSON.parse('{"v":"5.7.5","fr":23.9759979248047,"ip":0,"op":330.999971350949,"w":160,"h":160,"nm":"loading","ddd":0,"assets":[{"id":"comp_0","layers":[{"ddd":0,"ind":1,"ty":4,"nm":"Shape Layer 7","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":0,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":71,"s":[616]},{"t":155.999986497728,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0,0.909803921569,0.541176470588,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0,"op":199.999982689395,"st":0,"bm":0},{"ddd":0,"ind":2,"ty":4,"nm":"Shape Layer 8","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":1,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":72,"s":[616]},{"t":156.999986411175,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.658823529412,0.431372578939,0.949019667682,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":0.99999991344698,"op":199.999982689395,"st":0.99999991344698,"bm":0},{"ddd":0,"ind":3,"ty":4,"nm":"Shape Layer 9","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":2,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":73,"s":[616]},{"t":157.999986324622,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.972549079446,0.835294177485,0.282352941176,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":1.99999982689395,"op":199.999982689395,"st":1.99999982689395,"bm":0},{"ddd":0,"ind":4,"ty":4,"nm":"Shape Layer 10","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":3,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":74,"s":[616]},{"t":158.999986238069,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.925490255917,0.505882352941,0.192156877705,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":2.99999974034093,"op":199.999982689395,"st":2.99999974034093,"bm":0},{"ddd":0,"ind":5,"ty":4,"nm":"Shape Layer 11","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":4,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":75,"s":[616]},{"t":159.999986151516,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.290196078431,0.623529411765,0.949019667682,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":3.9999996537879,"op":199.999982689395,"st":3.9999996537879,"bm":0},{"ddd":0,"ind":6,"ty":4,"nm":"Shape Layer 12","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":1,"k":[{"i":{"x":[0.223],"y":[1]},"o":{"x":[0.566],"y":[0]},"t":5,"s":[-90]},{"i":{"x":[0.547],"y":[1]},"o":{"x":[0.604],"y":[0]},"t":76,"s":[616]},{"t":160.999986064963,"s":[-90]}],"ix":10},"p":{"a":0,"k":[960,539.787,0],"ix":2,"l":2},"a":{"a":0,"k":[0,-0.213,0],"ix":1,"l":2},"s":{"a":0,"k":[100,100,100],"ix":6,"l":2}},"ao":0,"shapes":[{"ty":"gr","it":[{"ind":0,"ty":"sh","ix":1,"ks":{"a":0,"k":{"i":[[29.843,-5.309],[0,0],[4.742,-23.873],[0,0],[-41.497,0.336],[0,0],[0,31.325],[0,0]],"o":[[0,0],[-37.497,-0.151],[0,0],[0,23.892],[0,0],[34.371,-0.567],[0,0],[-5.742,-31.522]],"v":[[65.384,-168.385],[-84.503,-167.849],[-137.742,-121.127],[-181.742,116.941],[-118.503,163.664],[107.917,164.855],[161.742,117.071],[119.742,-122.478]],"c":true},"ix":2},"nm":"Path 1","mn":"ADBE Vector Shape - Group","hd":false},{"ty":"fl","c":{"a":0,"k":[0.917647118662,0.400000029919,0.36862745098,1],"ix":4},"o":{"a":0,"k":100,"ix":5},"r":1,"bm":0,"nm":"Fill 1","mn":"ADBE Vector Graphic - Fill","hd":false},{"ty":"tr","p":{"a":0,"k":[0,0],"ix":2},"a":{"a":0,"k":[0,0],"ix":1},"s":{"a":0,"k":[100,100],"ix":3},"r":{"a":0,"k":0,"ix":6},"o":{"a":0,"k":100,"ix":7},"sk":{"a":0,"k":0,"ix":4},"sa":{"a":0,"k":0,"ix":5},"nm":"Transform"}],"nm":"Shape 1","np":3,"cix":2,"bm":0,"ix":1,"mn":"ADBE Vector Group","hd":false}],"ip":4.99999956723488,"op":199.999982689395,"st":4.99999956723488,"bm":0}]}],"layers":[{"ddd":0,"ind":1,"ty":0,"nm":"Comp 2","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[80,79,0],"ix":2,"l":2},"a":{"a":0,"k":[960,540,0],"ix":1,"l":2},"s":{"a":0,"k":[35,35,100],"ix":6,"l":2}},"ao":0,"w":1920,"h":1080,"ip":164.999985718751,"op":330.999971350949,"st":164.999985718751,"bm":0},{"ddd":0,"ind":2,"ty":0,"nm":"Comp 2","refId":"comp_0","sr":1,"ks":{"o":{"a":0,"k":100,"ix":11},"r":{"a":0,"k":0,"ix":10},"p":{"a":0,"k":[80,79,0],"ix":2,"l":2},"a":{"a":0,"k":[960,540,0],"ix":1,"l":2},"s":{"a":0,"k":[35,35,100],"ix":6,"l":2}},"ao":0,"w":1920,"h":1080,"ip":0,"op":165.999985632198,"st":0,"bm":0}],"markers":[]}');
var animations_logo_v2_namespaceObject = /*#__PURE__*/__webpack_require__.t(logo_v2_namespaceObject, 2);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loading/Loading.vue?vue&type=script&lang=ts&




/* harmony default export */ var Loadingvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Lottie: Lottie
  },
  props: {
    setAnimationController: {
      type: Function,
      default: function _default() {}
    },
    width: {
      type: Number,
      default: 90
    },
    height: {
      type: Number,
      default: 90
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    options: function options() {
      return {
        loop: true,
        autoplay: true,
        animationData: animations_logo_v2_namespaceObject
      };
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Loading/Loading.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Loading_Loadingvue_type_script_lang_ts_ = (Loadingvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Loading/Loading.vue?vue&type=style&index=0&id=f06ba326&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Loading/Loading.vue?vue&type=style&index=0&id=f06ba326&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Loading/Loading.vue



;


/* normalize component */

var Loading_component = normalizeComponent(
  Loading_Loadingvue_type_script_lang_ts_,
  Loadingvue_type_template_id_f06ba326_scoped_true_render,
  Loadingvue_type_template_id_f06ba326_scoped_true_staticRenderFns,
  false,
  null,
  "f06ba326",
  null
  
)

/* harmony default export */ var Loading = (Loading_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=script&lang=ts&




/* harmony default export */ var InfiniteScrollvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Loading: Loading
  },
  props: {
    showLoader: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    this.scrollTrigger();
  },
  methods: {
    scrollTrigger: function scrollTrigger() {
      var observer = new IntersectionObserver(this.intersectionObserver);
      observer.observe(this.$refs.infinitescrolltrigger);
    },
    intersectionObserver: function intersectionObserver(entries) {
      var _this = this;
      entries.forEach(function (entry) {
        if (entry.intersectionRatio > 0) {
          _this.$emit('onInfinite');
        }
      });
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=script&lang=ts&
 /* harmony default export */ var InfiniteScroll_InfiniteScrollvue_type_script_lang_ts_ = (InfiniteScrollvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=style&index=0&id=3d14cb6f&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=style&index=0&id=3d14cb6f&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=style&index=1&id=3d14cb6f&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InfiniteScroll/InfiniteScroll.vue?vue&type=style&index=1&id=3d14cb6f&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/InfiniteScroll/InfiniteScroll.vue



;



/* normalize component */

var InfiniteScroll_component = normalizeComponent(
  InfiniteScroll_InfiniteScrollvue_type_script_lang_ts_,
  InfiniteScrollvue_type_template_id_3d14cb6f_scoped_true_render,
  InfiniteScrollvue_type_template_id_3d14cb6f_scoped_true_staticRenderFns,
  false,
  null,
  "3d14cb6f",
  null
  
)

/* harmony default export */ var InfiniteScroll = (InfiniteScroll_component.exports);
;// CONCATENATED MODULE: ./src/components/InfiniteScroll/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InformationModal/InformationModal.vue?vue&type=template&id=68c31039&scoped=true&
var InformationModalvue_type_template_id_68c31039_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "modal"
  }, [_c('header', [_c('div', {
    staticClass: "h2"
  }, [_vm._t("modal-header")], 2), _c('div', {
    staticClass: "button-close",
    on: {
      "click": _vm.emitOnClose
    }
  }, [_c('Icon', {
    staticClass: "button-close__icon",
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1)]), _c('div', [_c('div', {
    staticClass: "modal-info"
  }, [_c('h3', [_vm._v(_vm._s(_vm.modalTexts.infoTitle))]), _c('p', {
    staticClass: "subtitle-1"
  }, [_vm._v(" " + _vm._s(_vm.modalTexts.infoSubtitle) + " ")])]), _vm._t("modal-content")], 2), _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "subtitle-1 footer-info"
  }, [_c('div', {
    staticClass: "footer-line",
    class: {
      'footer-line-danger': _vm.isDangerLineInFooter
    }
  }), _vm._t("footer-text")], 2), _vm.modalTexts.buttonLabel ? _c('Button', {
    staticClass: "button",
    attrs: {
      "medium": "",
      "primary": "",
      "disabled": _vm.disabled
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.emitButtonClicked.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.modalTexts.buttonLabel) + " ")]) : _vm._e()], 1)]);
};
var InformationModalvue_type_template_id_68c31039_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InformationModal/InformationModal.vue?vue&type=script&lang=ts&



/* harmony default export */ var InformationModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Button: components_Button
  },
  props: {
    modalTexts: {
      type: Object,
      required: true
    },
    disabled: {
      type: Boolean,
      default: true
    },
    isDangerLineInFooter: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    emitOnClose: function emitOnClose() {
      this.$emit('onClose');
    },
    emitButtonClicked: function emitButtonClicked() {
      this.$emit('buttonClicked');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/InformationModal/InformationModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var InformationModal_InformationModalvue_type_script_lang_ts_ = (InformationModalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InformationModal/InformationModal.vue?vue&type=style&index=0&id=68c31039&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InformationModal/InformationModal.vue?vue&type=style&index=0&id=68c31039&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/InformationModal/InformationModal.vue



;


/* normalize component */

var InformationModal_component = normalizeComponent(
  InformationModal_InformationModalvue_type_script_lang_ts_,
  InformationModalvue_type_template_id_68c31039_scoped_true_render,
  InformationModalvue_type_template_id_68c31039_scoped_true_staticRenderFns,
  false,
  null,
  "68c31039",
  null
  
)

/* harmony default export */ var InformationModal = (InformationModal_component.exports);
;// CONCATENATED MODULE: ./src/components/InformationModal/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfoStats/InfoStats.vue?vue&type=template&id=4a1053fc&scoped=true&
var InfoStatsvue_type_template_id_4a1053fc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "items"
  }, _vm._l(_vm.items, function (item) {
    return _c('div', {
      key: item.label,
      staticClass: "item"
    }, [_c('div', [_c('span', {
      staticClass: "item__quantity",
      class: {
        item__unset: item.quantity === null || item.quantity === undefined
      }
    }, [_vm._v(" " + _vm._s(item.quantity || 0) + " ")]), _c('Icon', {
      attrs: {
        "name": item.icon
      }
    })], 1), _c('span', {
      staticClass: "item__label"
    }, [_vm._v(_vm._s(item.label))])]);
  }), 0);
};
var InfoStatsvue_type_template_id_4a1053fc_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfoStats/InfoStats.vue?vue&type=script&lang=ts&


/* harmony default export */ var InfoStatsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    items: {
      type: Array,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/InfoStats/InfoStats.vue?vue&type=script&lang=ts&
 /* harmony default export */ var InfoStats_InfoStatsvue_type_script_lang_ts_ = (InfoStatsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/InfoStats/InfoStats.vue?vue&type=style&index=0&id=4a1053fc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/InfoStats/InfoStats.vue?vue&type=style&index=0&id=4a1053fc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/InfoStats/InfoStats.vue



;


/* normalize component */

var InfoStats_component = normalizeComponent(
  InfoStats_InfoStatsvue_type_script_lang_ts_,
  InfoStatsvue_type_template_id_4a1053fc_scoped_true_render,
  InfoStatsvue_type_template_id_4a1053fc_scoped_true_staticRenderFns,
  false,
  null,
  "4a1053fc",
  null
  
)

/* harmony default export */ var InfoStats = (InfoStats_component.exports);
;// CONCATENATED MODULE: ./src/components/InfoStats/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MaskImage/MaskImage.vue?vue&type=template&id=371f21e4&scoped=true&
var MaskImagevue_type_template_id_371f21e4_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('img', {
    staticClass: "mask-image",
    style: {
      '--maskUrl': "url('".concat(_vm.maskUrl, "')")
    },
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    }
  });
};
var MaskImagevue_type_template_id_371f21e4_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MaskImage/MaskImage.vue?vue&type=script&lang=ts&

/* harmony default export */ var MaskImagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    maskUrl: {
      type: String,
      default: ''
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/MaskImage/MaskImage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var MaskImage_MaskImagevue_type_script_lang_ts_ = (MaskImagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MaskImage/MaskImage.vue?vue&type=style&index=0&id=371f21e4&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/MaskImage/MaskImage.vue?vue&type=style&index=0&id=371f21e4&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/MaskImage/MaskImage.vue



;


/* normalize component */

var MaskImage_component = normalizeComponent(
  MaskImage_MaskImagevue_type_script_lang_ts_,
  MaskImagevue_type_template_id_371f21e4_scoped_true_render,
  MaskImagevue_type_template_id_371f21e4_scoped_true_staticRenderFns,
  false,
  null,
  "371f21e4",
  null
  
)

/* harmony default export */ var MaskImage = (MaskImage_component.exports);
;// CONCATENATED MODULE: ./src/components/MaskImage/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalTitle.vue?vue&type=template&id=b536eb68&scoped=true&
var ModalTitlevue_type_template_id_b536eb68_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('strong', {
    staticClass: "title"
  }, [_vm._t("default")], 2);
};
var ModalTitlevue_type_template_id_b536eb68_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalTitle.vue?vue&type=script&lang=ts&

/* harmony default export */ var ModalTitlevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({}));
;// CONCATENATED MODULE: ./src/components/Modal/ModalTitle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Modal_ModalTitlevue_type_script_lang_ts_ = (ModalTitlevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalTitle.vue?vue&type=style&index=0&id=b536eb68&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/ModalTitle.vue?vue&type=style&index=0&id=b536eb68&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Modal/ModalTitle.vue



;


/* normalize component */

var ModalTitle_component = normalizeComponent(
  Modal_ModalTitlevue_type_script_lang_ts_,
  ModalTitlevue_type_template_id_b536eb68_scoped_true_render,
  ModalTitlevue_type_template_id_b536eb68_scoped_true_staticRenderFns,
  false,
  null,
  "b536eb68",
  null
  
)

/* harmony default export */ var ModalTitle = (ModalTitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalActions.vue?vue&type=template&id=5775f10d&scoped=true&
var ModalActionsvue_type_template_id_5775f10d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "actions"
  }, [_vm._t("default")], 2);
};
var ModalActionsvue_type_template_id_5775f10d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalActions.vue?vue&type=script&lang=ts&

/* harmony default export */ var ModalActionsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({}));
;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Modal_ModalActionsvue_type_script_lang_ts_ = (ModalActionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalActions.vue?vue&type=style&index=0&id=5775f10d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.vue?vue&type=style&index=0&id=5775f10d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Modal/ModalActions.vue



;


/* normalize component */

var ModalActions_component = normalizeComponent(
  Modal_ModalActionsvue_type_script_lang_ts_,
  ModalActionsvue_type_template_id_5775f10d_scoped_true_render,
  ModalActionsvue_type_template_id_5775f10d_scoped_true_staticRenderFns,
  false,
  null,
  "5775f10d",
  null
  
)

/* harmony default export */ var ModalActions = (ModalActions_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalPagination/ModalPagination.vue?vue&type=template&id=c4ea9970&scoped=true&
var ModalPaginationvue_type_template_id_c4ea9970_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "pagination_modal"
  }, [_vm._l(_vm.createArrayWithNumber(), function (number) {
    return _c('div', {
      key: number
    }, [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: _vm.verifyValueIsCurrentPage(number),
        expression: "verifyValueIsCurrentPage(number)"
      }]
    }, [_vm._t("page".concat(number))], 2)]);
  }), _c('div', {
    staticClass: "footer"
  }, [_c('Button', {
    attrs: {
      "medium": "",
      "disabled": _vm.verifyValueIsCurrentPage(0)
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.previousPage.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "button"
  }, [_c('Icon', {
    class: {
      'icon--disabled': _vm.verifyValueIsCurrentPage(0)
    },
    attrs: {
      "name": "chevronLeft",
      "size": 15
    }
  }), _c('p', [_vm._v("Voltar")])], 1)]), _vm.shouldShowBulletPoints ? _c('div', {
    staticClass: "bullet_steps"
  }, _vm._l(_vm.createArrayWithNumber(), function (number) {
    return _c('div', {
      key: 'span' + number,
      staticClass: "step",
      class: {
        'step--selected': _vm.verifyValueIsCurrentPage(number)
      }
    });
  }), 0) : _c('div', [_c('p', {
    staticClass: "current_page subtitle-2"
  }, [_vm._v(" " + _vm._s(_vm.currentPage + 1) + "/" + _vm._s(_vm.numberOfPages) + " ")])]), _c('Button', {
    attrs: {
      "primary": "",
      "medium": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.nextPage.apply(null, arguments);
      }
    }
  }, [_vm.verifyValueIsCurrentPage(_vm.numberOfPages - 1) ? _c('div', {
    staticClass: "button"
  }, [_c('p', [_vm._v("Fechar")])]) : _c('div', {
    staticClass: "button"
  }, [_c('p', [_vm._v("Próximo")]), _c('Icon', {
    attrs: {
      "name": "chevronRight",
      "size": 15
    }
  })], 1)])], 1)], 2);
};
var ModalPaginationvue_type_template_id_c4ea9970_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalPagination/ModalPagination.vue?vue&type=script&lang=ts&






var MAX_BULLET_POINTS = 4;
/* harmony default export */ var ModalPaginationvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Button: components_Button,
    Icon: Icon
  },
  props: {
    numberOfPages: {
      type: Number,
      default: 1
    }
  },
  data: function data() {
    return {
      currentPage: 0
    };
  },
  computed: {
    shouldShowBulletPoints: function shouldShowBulletPoints() {
      return this.numberOfPages < MAX_BULLET_POINTS;
    }
  },
  methods: {
    nextPage: function nextPage() {
      if (this.verifyValueIsCurrentPage(this.numberOfPages - 1)) {
        this.$emit('onModalClose');
        return;
      }
      this.currentPage += 1;
    },
    previousPage: function previousPage() {
      if (this.currentPage === 0) return;
      this.currentPage -= 1;
    },
    verifyValueIsCurrentPage: function verifyValueIsCurrentPage(valueToVerify) {
      return this.currentPage === valueToVerify;
    },
    createArrayWithNumber: function createArrayWithNumber() {
      var arrayWithNumberOfPages = Array.from({
        length: this.numberOfPages
      }, function (x, i) {
        return i;
      });
      return arrayWithNumberOfPages;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Modal/ModalPagination/ModalPagination.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ModalPagination_ModalPaginationvue_type_script_lang_ts_ = (ModalPaginationvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Modal/ModalPagination/ModalPagination.vue?vue&type=style&index=0&id=c4ea9970&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Modal/ModalPagination/ModalPagination.vue?vue&type=style&index=0&id=c4ea9970&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Modal/ModalPagination/ModalPagination.vue



;


/* normalize component */

var ModalPagination_component = normalizeComponent(
  ModalPagination_ModalPaginationvue_type_script_lang_ts_,
  ModalPaginationvue_type_template_id_c4ea9970_scoped_true_render,
  ModalPaginationvue_type_template_id_c4ea9970_scoped_true_staticRenderFns,
  false,
  null,
  "c4ea9970",
  null
  
)

/* harmony default export */ var ModalPagination = (ModalPagination_component.exports);
;// CONCATENATED MODULE: ./src/components/Modal/index.ts




/* harmony default export */ var components_Modal = (Modal);

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Navbar/Navbar.vue?vue&type=template&id=1baf63e0&scoped=true&
var Navbarvue_type_template_id_1baf63e0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll",
      value: _vm.handlerScroll,
      expression: "handlerScroll"
    }],
    staticClass: "navbar",
    class: {
      'navbar--scroll': _vm.isScrolling
    }
  }, [_c('CustomLink', {
    staticClass: "custom-logo",
    attrs: {
      "src": _vm.logo.src,
      "target": _vm.logo.target,
      "router-path": _vm.logo.routerPath,
      "router-name": _vm.logo.routerName
    }
  }, [_c('Logo')], 1), _c('ul', {
    staticClass: "right-menu"
  }, [_vm.backofficeAdminUrl ? _c('li', {
    staticClass: "option"
  }, [_c('CustomLink', {
    attrs: {
      "id": "backoffice-admin-link",
      "src": _vm.backofficeAdminUrl
    }
  }, [_c('IconButton', {
    attrs: {
      "gap": 32,
      "icon": "secretary",
      "subtitle": "Secretaria"
    }
  })], 1)], 1) : _vm._e(), _vm._t("iconActions"), _c('li', {
    staticClass: "option",
    class: {
      'hide-for-small': _vm.mobileVersion
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.toggleDropdown,
      "focusout": function focusout($event) {
        return _vm.hideDropDown();
      }
    }
  }, [_c('IconButton', {
    attrs: {
      "gap": 32,
      "is-actived": _vm.showDropDownMenu,
      "subtitle": "Perfil"
    }
  }, [_c('Avatar', {
    staticClass: "icon-button__icon",
    attrs: {
      "src": _vm.userPhoto
    }
  })], 1), _vm.showDropDownMenu ? _c('DropDownMenu', _vm._g({
    staticClass: "dropdown-menu",
    attrs: {
      "user-name": _vm.userName,
      "user-photo": _vm.userPhoto,
      "customer-service-url": _vm.customerServiceUrl,
      "logoutUser": _vm.logoutUser,
      "profile-link": _vm.profileLink
    }
  }, _vm.$listeners), [_vm._t("customDropDownMenuOptions")], 2) : _vm._e()], 1), _c('li', {
    staticClass: "option hide-for-medium-up",
    class: {
      'hide-for-small': !_vm.mobileVersion
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "click": _vm.showMobileDropdown
    }
  }, [_c('IconButton', {
    attrs: {
      "gap": 32
    }
  }, [_c('Avatar', {
    staticClass: "icon-button__icon",
    attrs: {
      "src": _vm.userPhoto
    }
  })], 1)], 1)], 2)], 1);
};
var Navbarvue_type_template_id_1baf63e0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/directives/scroll.ts

var fn;
/* harmony default export */ var directives_scroll = ({
  bind: function bind(el, binding) {
    fn = debounce_default()(function (evt) {
      binding.value(evt);
    }, 100);
    window.addEventListener('scroll', fn);
  },
  unbind: function unbind() {
    window.removeEventListener('scroll', fn);
  }
});
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Navbar/Navbar.vue?vue&type=script&lang=ts&







/* harmony default export */ var Navbarvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    IconButton: IconButton,
    Avatar: Avatar,
    CustomLink: CustomLink,
    DropDownMenu: DropDownMenu,
    Logo: Logo
  },
  directives: {
    scroll: directives_scroll
  },
  props: {
    logo: {
      type: Object,
      required: true
    },
    backofficeAdminUrl: {
      type: String,
      default: ''
    },
    userPhoto: {
      type: String,
      default: ''
    },
    userName: {
      type: String,
      default: 'Aluno do Descomplica'
    },
    customerServiceUrl: {
      type: String,
      default: ''
    },
    logoutUser: {
      type: Function,
      default: function _default() {
        return window.location.reload();
      }
    },
    mobileVersion: {
      type: Boolean,
      default: false
    },
    profileLink: {
      type: String,
      default: ''
    }
  },
  computed: {
    secretary: function secretary() {
      return 'Secretaria';
    },
    profile: function profile() {
      return 'Perfil';
    }
  },
  data: function data() {
    return {
      isScrolling: false,
      showDropDownMenu: false,
      mobileDropdown: false
    };
  },
  methods: {
    toggleDropdown: function toggleDropdown() {
      this.showDropDownMenu = !this.showDropDownMenu;
    },
    showMobileDropdown: function showMobileDropdown() {
      this.$emit('mobileDropdown', true);
    },
    hideDropDown: function hideDropDown() {
      this.showDropDownMenu = false;
    },
    handlerScroll: function handlerScroll() {
      this.isScrolling = window.scrollY > 0;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Navbar/Navbar.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Navbar_Navbarvue_type_script_lang_ts_ = (Navbarvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Navbar/Navbar.vue?vue&type=style&index=0&id=1baf63e0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Navbar/Navbar.vue?vue&type=style&index=0&id=1baf63e0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Navbar/Navbar.vue?vue&type=style&index=1&id=1baf63e0&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Navbar/Navbar.vue?vue&type=style&index=1&id=1baf63e0&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/Navbar/Navbar.vue



;



/* normalize component */

var Navbar_component = normalizeComponent(
  Navbar_Navbarvue_type_script_lang_ts_,
  Navbarvue_type_template_id_1baf63e0_scoped_true_render,
  Navbarvue_type_template_id_1baf63e0_scoped_true_staticRenderFns,
  false,
  null,
  "1baf63e0",
  null
  
)

/* harmony default export */ var Navbar = (Navbar_component.exports);
;// CONCATENATED MODULE: ./src/components/Navbar/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NavigationTabMobile/NavigationTabMobile.vue?vue&type=template&id=164f288f&scoped=true&
var NavigationTabMobilevue_type_template_id_164f288f_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('ul', {
    staticClass: "navigation__tab"
  }, _vm._l(_vm.menuVisibleOptions, function (option) {
    return _c('li', {
      key: option.label
    }, [_c('custom-link', {
      staticClass: "navigation__item",
      class: {
        'navigation__item--active': option.active
      },
      attrs: {
        "src": option.src,
        "target": option.target,
        "router-name": option.routerName,
        "router-path": option.routerPath,
        "on-click-handler": option.onClickHandler
      }
    }, [_c('Icon', {
      staticClass: "navigation__icon",
      attrs: {
        "name": option.icon,
        "size": 24
      }
    }), _c('span', {
      staticClass: "hide-message caption"
    }, [_vm._v(_vm._s(option.label))])], 1)], 1);
  }), 0);
};
var NavigationTabMobilevue_type_template_id_164f288f_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NavigationTabMobile/NavigationTabMobile.vue?vue&type=script&lang=ts&





/* harmony default export */ var NavigationTabMobilevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  name: 'NavigationTabMobile',
  components: {
    Icon: Icon,
    CustomLink: CustomLink
  },
  computed: {
    menuVisibleOptions: function menuVisibleOptions() {
      return this.menuOptions.filter(function (option) {
        return !option.hideMobile;
      });
    }
  },
  props: {
    menuOptions: {
      type: Array,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/NavigationTabMobile/NavigationTabMobile.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NavigationTabMobile_NavigationTabMobilevue_type_script_lang_ts_ = (NavigationTabMobilevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NavigationTabMobile/NavigationTabMobile.vue?vue&type=style&index=0&id=164f288f&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NavigationTabMobile/NavigationTabMobile.vue?vue&type=style&index=0&id=164f288f&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/NavigationTabMobile/NavigationTabMobile.vue



;


/* normalize component */

var NavigationTabMobile_component = normalizeComponent(
  NavigationTabMobile_NavigationTabMobilevue_type_script_lang_ts_,
  NavigationTabMobilevue_type_template_id_164f288f_scoped_true_render,
  NavigationTabMobilevue_type_template_id_164f288f_scoped_true_staticRenderFns,
  false,
  null,
  "164f288f",
  null
  
)

/* harmony default export */ var NavigationTabMobile = (NavigationTabMobile_component.exports);
;// CONCATENATED MODULE: ./src/components/NavigationTabMobile/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=template&id=cf28670c&scoped=true&


var NotificationBigModalvue_type_template_id_cf28670c_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "big-modal"
    }
  }, [_vm.active ? _c('div', {
    ref: "bigModal",
    staticClass: "big-modal",
    attrs: {
      "tabindex": "-1"
    }
  }, [_c('div', {
    class: {
      'big-modal__overlay--without': !_vm.overlay,
      'big-modal__overlay': _vm.overlay
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('div', {
    staticClass: "big-modal__container",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_c('button', {
    staticClass: "big-modal__close",
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.onClose
    }
  }, [_c('Icon', {
    staticClass: "big-modal__close__icon",
    attrs: {
      "name": "close",
      "size": 24
    }
  })], 1), _c('div', {
    staticClass: "big-modal__content"
  }, [_vm.notification.imageSrc ? _c('MaskImage', {
    staticClass: "big-modal__image",
    attrs: {
      "img-src": _vm.notification.imageSrc,
      "mask-url": _vm.maskUrl
    }
  }) : _vm._e(), _c('div', {
    staticClass: "big-modal__information"
  }, [_c('strong', {
    staticClass: "big-modal__information__title"
  }, [_vm._v(" " + _vm._s(_vm.notification.title) + " ")]), _c('span', {
    staticClass: "big-modal__information__description"
  }, [_vm._v(" " + _vm._s(_vm.notification.description) + " ")]), _vm.callToAction.text ? _c('Button', {
    staticClass: "big-modal__information__button",
    attrs: {
      "primary": "",
      "small": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.callToAction.action.apply(null, arguments);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.callToAction.text) + " ")]) : _vm._e()], 1)], 1)])])]) : _vm._e()]);
};
var NotificationBigModalvue_type_template_id_cf28670c_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=template&id=cf28670c&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/web.btoa.js
var web_btoa = __webpack_require__(7479);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.constructor.js
var web_dom_exception_constructor = __webpack_require__(7714);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.stack.js
var web_dom_exception_stack = __webpack_require__(2801);
// EXTERNAL MODULE: ./node_modules/core-js/modules/web.dom-exception.to-string-tag.js
var web_dom_exception_to_string_tag = __webpack_require__(1174);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/MaskLogo.vue?vue&type=template&id=b0a7806a&
var MaskLogovue_type_template_id_b0a7806a_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('svg', {
    attrs: {
      "width": _vm.width,
      "height": _vm.height,
      "viewBox": _vm.viewBox,
      "fill": "none",
      "xmlns": "http://www.w3.org/2000/svg"
    }
  }, [_c('path', {
    attrs: {
      "fill": "#000",
      "d": "m94.31336,1.42025l-79.99787,14.38264c-6.57973,1.1831 -11.96419,7.64286 -11.96419,15.42378l0,48.59422c0,7.97395 5.37657,14.29198 11.94446,15.5381l80.04128,15.20691c9.74736,1.8496 17.72344,-5.3952 17.72344,-15.77882l0,-76.86642c0.00395,-11.4722 -7.98397,-18.25535 -17.74712,-16.50041z"
    }
  })]);
};
var MaskLogovue_type_template_id_b0a7806a_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Logo/logos/MaskLogo.vue?vue&type=script&lang=ts&



/* harmony default export */ var MaskLogovue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    width: {
      type: Number,
      default: 112
    },
    height: {
      type: Number,
      default: 112
    }
  },
  computed: {
    viewBox: function viewBox() {
      return "0 0 ".concat(this.width, " ").concat(this.height);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Logo/logos/MaskLogo.vue?vue&type=script&lang=ts&
 /* harmony default export */ var logos_MaskLogovue_type_script_lang_ts_ = (MaskLogovue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Logo/logos/MaskLogo.vue





/* normalize component */
;
var MaskLogo_component = normalizeComponent(
  logos_MaskLogovue_type_script_lang_ts_,
  MaskLogovue_type_template_id_b0a7806a_render,
  MaskLogovue_type_template_id_b0a7806a_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MaskLogo = (MaskLogo_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=script&lang=ts&









/* harmony default export */ var NotificationBigModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Button: components_Button,
    Icon: Icon,
    MaskImage: MaskImage
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    notification: {
      type: Object,
      required: true
    },
    callToAction: {
      type: Object,
      required: false
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    maskUrl: function maskUrl() {
      var logoConstructor = MaskLogo.extend();
      var logoInstance = new logoConstructor();
      logoInstance.$mount();
      var encodedSvg = btoa(logoInstance.$el.outerHTML);
      return "data:image/svg+xml;base64,".concat(encodedSvg);
    }
  },
  methods: {
    closeBigModal: function closeBigModal() {
      this.$emit('update:active', false);
    },
    onClose: function onClose() {
      this.closeBigModal();
    }
  },
  mounted: function mounted() {
    var bigModal = this.$refs.bigModal;
    bigModal && bigModal.focus();
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NotificationBigModal_NotificationBigModalvue_type_script_lang_ts_ = (NotificationBigModalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=style&index=0&id=cf28670c&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationBigModal/NotificationBigModal.vue?vue&type=style&index=0&id=cf28670c&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/NotificationBigModal/NotificationBigModal.vue



;


/* normalize component */

var NotificationBigModal_component = normalizeComponent(
  NotificationBigModal_NotificationBigModalvue_type_script_lang_ts_,
  NotificationBigModalvue_type_template_id_cf28670c_scoped_true_render,
  NotificationBigModalvue_type_template_id_cf28670c_scoped_true_staticRenderFns,
  false,
  null,
  "cf28670c",
  null
  
)

/* harmony default export */ var NotificationBigModal = (NotificationBigModal_component.exports);
;// CONCATENATED MODULE: ./src/components/NotificationBigModal/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationCard/NotificationCard.vue?vue&type=template&id=039b2c7b&scoped=true&
var NotificationCardvue_type_template_id_039b2c7b_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "notification-card",
    class: {
      'notification-card--old': !_vm.notRead,
      'notification-card--new': _vm.notRead
    },
    on: {
      "click": function click($event) {
        return _vm.cardClickHandler(_vm.value);
      }
    }
  }, [_c('ul', {
    staticClass: "notification-card__item"
  }, [_c('li', [_vm.notification.icon ? _c('Icon', {
    attrs: {
      "name": _vm.notification.icon,
      "size": 56
    }
  }) : _vm._e(), !_vm.notification.icon && _vm.notification.imageUrl ? _c('img', {
    staticClass: "notification-card__item__image",
    attrs: {
      "src": _vm.notification.imageUrl
    }
  }) : _vm._e()], 1), _c('li', {
    staticClass: "notification-card__item__contents"
  }, [_c('ul', [_vm.notification.title ? _c('li', {
    staticClass: "subtitle-2 notification-card__item__contents__title"
  }, [_c('p', [_vm._v(" " + _vm._s(_vm.notification.title) + " ")])]) : _vm._e(), _c('li', {
    staticClass: "subtitle-2",
    class: {
      'notification-card__item__contents__description': _vm.limitDescription
    }
  }, [_vm.shortDescription ? _c('p', [_vm._v(" " + _vm._s(_vm.notification.shortDescription) + " ")]) : _c('p', [_vm._v(" " + _vm._s(_vm.notification.longDescription) + " ")])]), _vm.notification.callToActionText ? _c('li', {
    staticClass: "notification-card__item__contents__action"
  }, [_c('p', {
    staticClass: "subtitle-2 notification-card__item__contents__action--title",
    on: {
      "click": function click($event) {
        return _vm.actionClickHandler(_vm.value);
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.notification.callToActionText) + " ")])]) : _vm._e()])]), _c('li', {
    staticClass: "notification-card__item__time"
  }, [_vm.notRead ? _c('Icon', {
    staticClass: "notification-card__item__time__icon",
    attrs: {
      "name": "ellipse",
      "size": 12
    }
  }) : _vm._e(), _c('p', {
    staticClass: "subtitle-2"
  }, [_vm._v(_vm._s(_vm.getDiffDate))])], 1)])]);
};
var NotificationCardvue_type_template_id_039b2c7b_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
;// CONCATENATED MODULE: ./src/helpers/dateDiff.ts

function getDateDiffToStr(currentDate, pastDate) {
  var now = moment_default()(currentDate);
  var past = moment_default()(pastDate);
  var duration = moment_default().duration(now.diff(past));
  var seconds = duration.asSeconds();
  var minutes = duration.asMinutes();
  var hours = duration.asHours();
  var days = duration.asDays();
  var months = duration.asMonths();
  var years = duration.asYears();
  if (seconds <= 60) return "".concat(Math.round(seconds * 1) / 1, " seg");
  if (minutes <= 60) return "".concat(Math.round(minutes * 1) / 1, " min");
  if (hours <= 24) return "".concat(Math.round(hours * 1) / 1, " h");
  if (days <= 28) return "".concat(Math.round(days * 1) / 1, " d");
  if (months <= 12) return "".concat(Math.round(months * 1) / 1, " m");
  return "".concat(Math.round(years * 1) / 1, " a");
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationCard/NotificationCard.vue?vue&type=script&lang=ts&




var NotificationPriority;
(function (NotificationPriority) {
  NotificationPriority["urgent"] = "urgent";
  NotificationPriority["important"] = "important";
  NotificationPriority["normal"] = "normal";
  NotificationPriority["low"] = "low";
})(NotificationPriority || (NotificationPriority = {}));
/* harmony default export */ var NotificationCardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    shortDescription: {
      type: Boolean,
      default: false
    },
    limitDescription: {
      type: Boolean,
      default: true
    },
    actionHandler: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    notification: function notification() {
      return this.value.inAppNotification;
    },
    notRead: function notRead() {
      return !this.value.viewedAt;
    },
    target: function target() {
      return this.value.inAppNotification.callToActionUrl.startsWith('/') ? '_top' : '_blank';
    },
    getDiffDate: function getDiffDate() {
      var currentDate = new Date();
      return getDateDiffToStr(currentDate, this.value.createdAt);
    }
  },
  methods: {
    cardClickHandler: function cardClickHandler(value) {
      this.$emit('onCard', value);
    },
    actionClickHandler: function actionClickHandler(value) {
      if (this.actionHandler) {
        this.actionHandler(value);
      } else {
        window.open(value.inAppNotification.callToActionUrl, this.target);
      }
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationCard/NotificationCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NotificationCard_NotificationCardvue_type_script_lang_ts_ = (NotificationCardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationCard/NotificationCard.vue?vue&type=style&index=0&id=039b2c7b&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationCard/NotificationCard.vue?vue&type=style&index=0&id=039b2c7b&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/NotificationCard/NotificationCard.vue



;


/* normalize component */

var NotificationCard_component = normalizeComponent(
  NotificationCard_NotificationCardvue_type_script_lang_ts_,
  NotificationCardvue_type_template_id_039b2c7b_scoped_true_render,
  NotificationCardvue_type_template_id_039b2c7b_scoped_true_staticRenderFns,
  false,
  null,
  "039b2c7b",
  null
  
)

/* harmony default export */ var NotificationCard = (NotificationCard_component.exports);
;// CONCATENATED MODULE: ./src/components/NotificationCard/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationModal/NotificationModal.vue?vue&type=template&id=b799ab78&scoped=true&
var NotificationModalvue_type_template_id_b799ab78_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "notification-modal"
  }, [_c('div', {
    staticClass: "notification-modal__header"
  }, [_c('ul', {
    staticClass: "notification-modal__header__contents"
  }, [_c('li', {
    staticClass: "notification-modal__header__contents__title h6"
  }, [_c('p', [_vm._v(_vm._s(_vm.title))])]), _c('li', {
    on: {
      "click": function click($event) {
        return _vm.closeClickHandler();
      }
    }
  }, [_c('Icon', {
    staticClass: "notification-modal__header__contents__icon",
    attrs: {
      "name": "close",
      "size": 26
    }
  })], 1)])]), _c('div', {
    staticClass: "notification-modal__items"
  }, _vm._l(_vm.optionsFilter, function (option) {
    return _c('NotificationCard', {
      key: option.id,
      attrs: {
        "value": option,
        "short-description": "",
        "action-handler": _vm.actionHandler
      },
      on: {
        "onCard": _vm.cardClickHandler
      }
    });
  }), 1), _c('div', {
    staticClass: "notification-modal__action subtitle-2",
    on: {
      "click": _vm.actionButtonClickHandler
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.textActionButton))])])]);
};
var NotificationModalvue_type_template_id_b799ab78_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationModal/NotificationModal.vue?vue&type=script&lang=ts&





/* harmony default export */ var NotificationModalvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    NotificationCard: NotificationCard
  },
  props: {
    options: {
      type: Array,
      required: true
    },
    title: {
      type: String,
      default: 'Notificações'
    },
    textActionButton: {
      type: String,
      default: 'Todas as notificações'
    },
    numberOptions: {
      type: Number,
      default: 3
    },
    actionHandler: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    optionsFilter: function optionsFilter() {
      return this.options.slice(0, this.numberOptions);
    }
  },
  methods: {
    closeClickHandler: function closeClickHandler() {
      this.$emit('onClose', true);
    },
    actionButtonClickHandler: function actionButtonClickHandler() {
      this.$emit('onActionButton', true);
    },
    cardClickHandler: function cardClickHandler(value) {
      this.$emit('onCard', value);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationModal/NotificationModal.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NotificationModal_NotificationModalvue_type_script_lang_ts_ = (NotificationModalvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationModal/NotificationModal.vue?vue&type=style&index=0&id=b799ab78&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationModal/NotificationModal.vue?vue&type=style&index=0&id=b799ab78&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/NotificationModal/NotificationModal.vue



;


/* normalize component */

var NotificationModal_component = normalizeComponent(
  NotificationModal_NotificationModalvue_type_script_lang_ts_,
  NotificationModalvue_type_template_id_b799ab78_scoped_true_render,
  NotificationModalvue_type_template_id_b799ab78_scoped_true_staticRenderFns,
  false,
  null,
  "b799ab78",
  null
  
)

/* harmony default export */ var NotificationModal = (NotificationModal_component.exports);
;// CONCATENATED MODULE: ./src/components/NotificationModal/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationOptions/NotificationOptions.vue?vue&type=template&id=8453b634&scoped=true&
var NotificationOptionsvue_type_template_id_8453b634_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "notification-menu",
    class: {
      'notification-menu--actived': _vm.opened
    }
  }, [_c('div', {
    on: {
      "click": _vm.toggleNotificationMenu
    }
  }, [_vm.opened ? _c('CustomLink', [_c('IconButton', {
    attrs: {
      "gap": 32,
      "is-actived": _vm.opened,
      "icon": "notificationAltSelected",
      "subtitle": "Notificações"
    }
  })], 1) : _c('CustomLink', [_c('IconButton', {
    attrs: {
      "gap": 32,
      "is-actived": _vm.active,
      "icon": _vm.active ? 'notificationAltSelected' : 'notificationAlt',
      "subtitle": "Notificações"
    }
  })], 1), _vm.hasNewNotifications ? _c('Icon', {
    staticClass: "notification-menu__icon",
    class: {
      'notification-menu__icon--actived': _vm.opened
    },
    attrs: {
      "name": "ellipse",
      "size": 16
    }
  }) : _vm._e()], 1), _c('modal', {
    attrs: {
      "active": _vm.opened,
      "hasCloseButton": false,
      "wihoutPadding": true
    }
  }, [_c('NotificationModal', {
    attrs: {
      "options": _vm.options,
      "actionHandler": _vm.actionHandler
    },
    on: {
      "onClose": _vm.toggleNotificationMenu,
      "onCard": _vm.cardClickHandler,
      "onActionButton": _vm.actionButtonClickHandler
    }
  })], 1)], 1);
};
var NotificationOptionsvue_type_template_id_8453b634_scoped_true_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.array.find.js
var es_array_find = __webpack_require__(9826);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationOptions/NotificationOptions.vue?vue&type=script&lang=ts&








/* harmony default export */ var NotificationOptionsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    CustomLink: CustomLink,
    IconButton: IconButton,
    Icon: Icon,
    Modal: Modal,
    NotificationModal: NotificationModal
  },
  props: {
    opened: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      required: true
    },
    active: {
      type: Boolean,
      default: false
    },
    actionHandler: {
      type: Function,
      default: undefined
    }
  },
  computed: {
    hasNewNotifications: function hasNewNotifications() {
      return !!this.options.find(function (item) {
        return !item.viewedAt;
      });
    }
  },
  methods: {
    toggleNotificationMenu: function toggleNotificationMenu() {
      this.$emit('update:opened', !this.opened);
    },
    actionButtonClickHandler: function actionButtonClickHandler() {
      this.$emit('onActionButton', true);
    },
    cardClickHandler: function cardClickHandler(value) {
      this.$emit('onCard', value);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/NotificationOptions/NotificationOptions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var NotificationOptions_NotificationOptionsvue_type_script_lang_ts_ = (NotificationOptionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationOptions/NotificationOptions.vue?vue&type=style&index=0&id=8453b634&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationOptions/NotificationOptions.vue?vue&type=style&index=0&id=8453b634&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/NotificationOptions/NotificationOptions.vue?vue&type=style&index=1&id=8453b634&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/NotificationOptions/NotificationOptions.vue?vue&type=style&index=1&id=8453b634&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/NotificationOptions/NotificationOptions.vue



;



/* normalize component */

var NotificationOptions_component = normalizeComponent(
  NotificationOptions_NotificationOptionsvue_type_script_lang_ts_,
  NotificationOptionsvue_type_template_id_8453b634_scoped_true_render,
  NotificationOptionsvue_type_template_id_8453b634_scoped_true_staticRenderFns,
  false,
  null,
  "8453b634",
  null
  
)

/* harmony default export */ var NotificationOptions = (NotificationOptions_component.exports);
;// CONCATENATED MODULE: ./src/components/NotificationOptions/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedSelect/OutlinedSelect.vue?vue&type=template&id=3efb62f2&scoped=true&
var OutlinedSelectvue_type_template_id_3efb62f2_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "outlined-select",
    class: {
      'outlined-select--disabled': _vm.isDisabled,
      'outlined-select--large': _vm.large
    },
    on: {
      "click": function click($event) {
        return _vm.toggleDropdown();
      },
      "mouseenter": function mouseenter($event) {
        return _vm.hoverHandler(true);
      },
      "mouseleave": function mouseleave($event) {
        return _vm.hoverHandler(false);
      }
    }
  }, [_c('div', {
    staticClass: "outlined-select__header",
    attrs: {
      "tabindex": "0"
    },
    on: {
      "blur": function blur($event) {
        return _vm.hideDropdown();
      }
    }
  }, [_c('Outline', {
    attrs: {
      "label": _vm.label,
      "large": _vm.large,
      "focused": _vm.isFocused,
      "disabled": _vm.isDisabled,
      "hovering": _vm.isHovering,
      "has-error": false,
      "has-content": _vm.hasContent()
    }
  }), _c('transition', {
    attrs: {
      "name": "placeholder"
    }
  }, [_vm.isFocused && !_vm.hasContent() ? _c('p', {
    class: {
      'subtitle-1': !_vm.large,
      h6: _vm.large
    }
  }, [_vm._v(" " + _vm._s(_vm.placeholder) + " ")]) : _vm._e()]), _c('p', {
    staticClass: "outlined-select__header__selected",
    class: {
      'outlined-select__header__placeholder--disabled': _vm.isDisabled,
      'subtitle-1': !_vm.large,
      h6: _vm.large
    }
  }, [_vm._v(" " + _vm._s(_vm.selected) + " ")]), _c('Icon', {
    staticClass: "icon",
    class: {
      'icon--focused': _vm.isFocused,
      'icon--disabled': _vm.isDisabled
    },
    attrs: {
      "name": _vm.isFocused ? 'dropup' : 'dropdown'
    }
  })], 1), _c('transition', {
    attrs: {
      "name": "dropdown-animation"
    }
  }, [_vm.isFocused ? _c('ol', {
    staticClass: "dropdown",
    class: {
      'dropdown--large': _vm.large
    }
  }, _vm._l(_vm.options, function (option) {
    return _c('li', {
      key: option,
      staticClass: "dropdown__item subtitle-1",
      class: {
        h6: _vm.large,
        'dropdown__item--large': _vm.large,
        'dropdown__item--hoverless': _vm.withRadio,
        'dropdown__item--selected': option === _vm.selected
      },
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.selectHandler(option);
        },
        "mousedown": function mousedown($event) {
          return _vm.selectHandler(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option) + " "), _vm.withRadio ? _c('span', {
      staticClass: "radio-circle__checkmark",
      class: {
        'radio-circle__checked': option === _vm.selected
      }
    }) : _vm._e()]);
  }), 0) : _vm._e()])], 1);
};
var OutlinedSelectvue_type_template_id_3efb62f2_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedSelect/OutlinedSelect.vue?vue&type=script&lang=ts&



/* harmony default export */ var OutlinedSelectvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon,
    Outline: Outline_Outline
  },
  model: {
    prop: 'value',
    event: 'selected'
  },
  props: {
    value: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true
    },
    required: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    large: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    withRadio: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      selected: this.$props.value,
      isDisabled: this.disabled,
      isFocused: false,
      isHovering: false
    };
  },
  methods: {
    hideDropdown: function hideDropdown() {
      this.isFocused = false;
    },
    toggleDropdown: function toggleDropdown() {
      if (!this.isDisabled && !this.readonly) {
        this.isFocused = !this.isFocused;
      }
    },
    selectHandler: function selectHandler(option) {
      this.selected = option;
      this.$emit('selected', option);
      this.hideDropdown();
    },
    hasContent: function hasContent() {
      return Boolean(this.selected);
    },
    hoverHandler: function hoverHandler(hovering) {
      this.isHovering = hovering;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/OutlinedSelect/OutlinedSelect.vue?vue&type=script&lang=ts&
 /* harmony default export */ var OutlinedSelect_OutlinedSelectvue_type_script_lang_ts_ = (OutlinedSelectvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/OutlinedSelect/OutlinedSelect.vue?vue&type=style&index=0&id=3efb62f2&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/OutlinedSelect/OutlinedSelect.vue?vue&type=style&index=0&id=3efb62f2&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/OutlinedSelect/OutlinedSelect.vue



;


/* normalize component */

var OutlinedSelect_component = normalizeComponent(
  OutlinedSelect_OutlinedSelectvue_type_script_lang_ts_,
  OutlinedSelectvue_type_template_id_3efb62f2_scoped_true_render,
  OutlinedSelectvue_type_template_id_3efb62f2_scoped_true_staticRenderFns,
  false,
  null,
  "3efb62f2",
  null
  
)

/* harmony default export */ var OutlinedSelect = (OutlinedSelect_component.exports);
;// CONCATENATED MODULE: ./src/components/OutlinedSelect/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RadioButton/RadioButton.vue?vue&type=template&id=555e765e&scoped=true&
var RadioButtonvue_type_template_id_555e765e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "radio-button"
  }, [_c('label', {
    staticClass: "radio-circle"
  }, [_c('input', {
    attrs: {
      "type": "radio"
    },
    domProps: {
      "value": _vm.radioValue,
      "checked": _vm.radioButtonChecked
    },
    on: {
      "change": _vm.selectRadioButton
    }
  }), _c('span', {
    staticClass: "radio-circle__checkmark"
  }), _c('div', {
    staticClass: "subtitle-1 item-label"
  }, [_vm._v(" " + _vm._s(_vm.label) + " ")])])]);
};
var RadioButtonvue_type_template_id_555e765e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RadioButton/RadioButton.vue?vue&type=script&lang=ts&

/* harmony default export */ var RadioButtonvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  model: {
    prop: 'radioModel',
    event: 'input'
  },
  components: {},
  props: {
    radioValue: {
      type: String,
      required: true
    },
    radioModel: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    }
  },
  computed: {
    radioButtonChecked: function radioButtonChecked() {
      return this.radioValue === this.radioModel;
    }
  },
  methods: {
    selectRadioButton: function selectRadioButton() {
      this.$emit('input', this.radioValue);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue?vue&type=script&lang=ts&
 /* harmony default export */ var RadioButton_RadioButtonvue_type_script_lang_ts_ = (RadioButtonvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RadioButton/RadioButton.vue?vue&type=style&index=0&id=555e765e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue?vue&type=style&index=0&id=555e765e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/RadioButton/RadioButton.vue



;


/* normalize component */

var RadioButton_component = normalizeComponent(
  RadioButton_RadioButtonvue_type_script_lang_ts_,
  RadioButtonvue_type_template_id_555e765e_scoped_true_render,
  RadioButtonvue_type_template_id_555e765e_scoped_true_staticRenderFns,
  false,
  null,
  "555e765e",
  null
  
)

/* harmony default export */ var RadioButton = (RadioButton_component.exports);
;// CONCATENATED MODULE: ./src/components/RadioButton/index.ts

;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/defineProperty.js

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchCard/SearchCard.vue?vue&type=template&id=5f1b68e2&scoped=true&



var SearchCardvue_type_template_id_5f1b68e2_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [!_vm.searchDisabled ? _c('OutlinedTextInput', {
    attrs: {
      "large": "",
      "label": _vm.label,
      "placeholder": _vm.searchTitle,
      "value": _vm.input,
      "icon": "search"
    },
    on: {
      "input": _vm.searchInputHandler,
      "focus": _vm.searchInputFocusHandler,
      "blur": _vm.searchInputBlurHandler
    }
  }) : _vm._e(), _c('div', {
    staticClass: "search-box"
  }, _vm._l(_vm.filtredList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "search-card"
    }, [_c('Card', {
      attrs: {
        "outline": "",
        "enable-hover": ""
      }
    }, [_c('div', {
      staticClass: "card-action",
      class: {
        'card-action-height': !_vm.hasCardInfoData
      }
    }, [_c('transition', {
      attrs: {
        "name": "card-action__fade",
        "mode": "out-in"
      }
    }, [_c('div', {
      staticClass: "card-action__content",
      class: {
        'card-action__content--active': _vm.activeCard === item.key
      },
      on: {
        "click": function click($event) {
          return _vm.cardClickHandler(item.key);
        }
      }
    }, [_c('div', {
      staticClass: "card-action__content__header",
      class: {
        'card-action__content__header--to-top': _vm.hasCardInfoData
      }
    }, [_c('h5', {
      class: _defineProperty({
        h5: !item.content.titleSize && _vm.hasCardInfoData,
        h4: !item.content.titleSize && !_vm.hasCardInfoData
      }, item.content.titleSize, !!item.content.titleSize)
    }, [_vm._v(" " + _vm._s(item.content.title) + " ")]), _c('span', {
      class: {
        'card-action__content__icon--active': _vm.activeCard === item.key
      }
    }), item.content.icon && _vm.activeCard !== item.key ? _c('Icon', {
      staticClass: "card-action__content__icon",
      attrs: {
        "name": item.content.icon
      }
    }) : _vm._e()], 1), item.content.data || item.content.description ? _c('div', {
      staticClass: "card-action__content__body"
    }, [item.content.description ? _c('p', {
      staticClass: "subtitle-1"
    }, [_vm._v(" " + _vm._s(item.content.description) + " ")]) : _vm._e(), _vm._l(item.content.data, function (dataItem, dataIndex) {
      return _c('div', {
        key: dataIndex
      }, [_c('p', {
        staticClass: "h6"
      }, [dataItem.icon ? _c('Icon', {
        staticClass: "card-action__content__icon-data",
        attrs: {
          "name": dataItem.icon
        }
      }) : _vm._e(), _vm._v(" " + _vm._s(dataItem.text) + " ")], 1), _c('p', {
        staticClass: "h6"
      }, [dataItem.iconDescription ? _c('Icon', {
        staticClass: "card-action__content__icon-data",
        attrs: {
          "name": dataItem.iconDescription
        }
      }) : _vm._e(), _vm._v(" " + _vm._s(dataItem.description) + " ")], 1)]);
    }), item.content.hasInfo ? _c('div', {
      staticClass: "card-action__content__info",
      on: {
        "click": function click($event) {
          $event.stopPropagation();
          return _vm.onClickInfo(item.key);
        }
      }
    }, [_c('Icon', {
      staticClass: "card-action__content__info-icon",
      attrs: {
        "name": "info"
      }
    })], 1) : _vm._e()], 2) : _vm._e()])])], 1)])], 1);
  }), 0)], 1);
};
var SearchCardvue_type_template_id_5f1b68e2_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/SearchCard/SearchCard.vue?vue&type=template&id=5f1b68e2&scoped=true&

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.string.match.js
var es_string_match = __webpack_require__(4723);
;// CONCATENATED MODULE: ./src/helpers/normalizeString.ts


function normalizeString(str) {
  return str.normalize('NFD').replace(/[^a-zA-Zs]/g, '').toLowerCase();
}
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchCard/SearchCard.vue?vue&type=script&lang=ts&


















/* harmony default export */ var SearchCardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Card: Card_Card,
    OutlinedTextInput: OutlinedTextInput,
    Icon: Icon
  },
  props: {
    selected: {
      type: Number,
      default: -1
    },
    searchTitle: {
      type: String,
      default: ''
    },
    searchDisabled: {
      type: Boolean,
      default: false
    },
    listItems: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      placeholder: this.searchTitle,
      label: this.searchTitle,
      input: '',
      search: '',
      activeCard: this.selected,
      filtredList: this.listItems
    };
  },
  computed: {
    hasCardInfoData: function hasCardInfoData() {
      return this.listItems.some(function (item) {
        return item.content.data && item.content.data.length > 0;
      });
    }
  },
  watch: {
    input: function input(value) {
      var valueLowerCase = normalizeString(value);
      var pattern = Array.from(valueLowerCase).reduce(function (accumulator, currentValue, index) {
        return "".concat(accumulator, "[^").concat(value.substr(index), "]*?").concat(currentValue);
      }, '');
      var regex = RegExp(pattern);
      this.filtredList = this.listItems.filter(function (cardItem) {
        return normalizeString(cardItem.content.title).match(regex);
      });
    }
  },
  methods: {
    cardClickHandler: function cardClickHandler(key) {
      this.activeCard = key;
      this.$emit('selected', this.listItems.find(function (item) {
        return item.key === key;
      }));
    },
    onClickInfo: function onClickInfo(key) {
      this.$emit('info', this.listItems.find(function (item) {
        return item.key === key;
      }));
    },
    searchInputHandler: function searchInputHandler(value) {
      this.input = value;
    },
    searchInputFocusHandler: function searchInputFocusHandler() {
      this.label = '';
    },
    searchInputBlurHandler: function searchInputBlurHandler() {
      this.label = this.input.length > 0 ? '' : this.searchTitle;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/SearchCard/SearchCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var SearchCard_SearchCardvue_type_script_lang_ts_ = (SearchCardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SearchCard/SearchCard.vue?vue&type=style&index=0&id=5f1b68e2&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SearchCard/SearchCard.vue?vue&type=style&index=0&id=5f1b68e2&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/SearchCard/SearchCard.vue



;


/* normalize component */

var SearchCard_component = normalizeComponent(
  SearchCard_SearchCardvue_type_script_lang_ts_,
  SearchCardvue_type_template_id_5f1b68e2_scoped_true_render,
  SearchCardvue_type_template_id_5f1b68e2_scoped_true_staticRenderFns,
  false,
  null,
  "5f1b68e2",
  null
  
)

/* harmony default export */ var SearchCard = (SearchCard_component.exports);
;// CONCATENATED MODULE: ./src/components/SearchCard/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectGrouped/SelectGrouped.vue?vue&type=template&id=7d4f196e&scoped=true&
var SelectGroupedvue_type_template_id_7d4f196e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "select-grouped",
    attrs: {
      "tabindex": "0"
    }
  }, [_c('div', {
    staticClass: "select-grouped__box"
  }, [_c('div', {
    staticClass: "select-grouped__main",
    class: {
      'select-grouped__main--opened': _vm.isOpened
    },
    on: {
      "click": function click($event) {
        return _vm.toggleSelectGrouped();
      }
    }
  }, [_c('Icon', {
    staticClass: "select-grouped__main__icon",
    class: {
      'select-grouped__main__icon--opened': !_vm.isOpened
    },
    attrs: {
      "name": _vm.selectGroupedIcon(_vm.isOpened)
    }
  }), _c('div', {
    staticClass: "select-grouped__main__content",
    class: {
      'select-grouped__main__content--opened': _vm.isOpened
    }
  }, [_c('span', {
    staticClass: "select-grouped__value__title",
    class: {
      'select-grouped__value__title--opened': _vm.isOpened
    }
  }, [_vm._v(_vm._s(_vm.selectedOption.title))]), _vm.selectedOption.count ? _c('span', {
    staticClass: "select-grouped__value__count",
    class: {
      'select-grouped__value__count--opened': !_vm.isOpened
    }
  }, [_vm._v(" " + _vm._s(_vm.selectedOption.count))]) : _vm._e()])], 1)]), _c('div', {
    staticClass: "select-grouped__content",
    class: {
      'select-grouped__content--show': _vm.isOpened
    }
  }, _vm._l(_vm.items, function (item, key) {
    return _c('div', {
      key: item.option + key,
      staticClass: "select-grouped__content__box"
    }, [_c('div', {
      staticClass: "select-grouped__content__item--option subtitle-2"
    }, [_vm._v(" " + _vm._s(item.option) + " "), _c('p', {
      staticClass: "select-grouped__content__item--line"
    })]), _vm._l(item.subOptions, function (subOption, key) {
      return _c('div', {
        key: subOption.title + key
      }, [_c('span', {
        staticClass: "select-grouped__content__item",
        class: {
          'select-grouped__content__item--opened': _vm.selectedOption == subOption
        },
        on: {
          "click": function click($event) {
            return _vm.selectOption(item.option, subOption);
          }
        }
      }, [_vm._v(" " + _vm._s(subOption.title) + " ")])]);
    })], 2);
  }), 0)]);
};
var SelectGroupedvue_type_template_id_7d4f196e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectGrouped/SelectGrouped.vue?vue&type=script&lang=ts&


/* harmony default export */ var SelectGroupedvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    initiallySelectedOption: {
      type: Object,
      default: null
    },
    closeAfterSelect: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {
      selectedOption: {},
      isOpened: false
    };
  },
  methods: {
    selectGroupedIcon: function selectGroupedIcon() {
      return this.isOpened ? 'chevronDown' : 'chevronRight';
    },
    toggleSelectGrouped: function toggleSelectGrouped() {
      this.isOpened = !this.isOpened;
    },
    selectOption: function selectOption(group, subOption) {
      this.selectedOption = subOption;
      if (this.closeAfterSelect) {
        this.isOpened = false;
      }
      this.$emit('toggleOption', group, subOption);
    }
  },
  mounted: function mounted() {
    var initialSelectedOption = this.initiallySelectedOption || this.items[0].subOptions[0];
    this.selectOption(this.items[0].option, initialSelectedOption);
  }
}));
;// CONCATENATED MODULE: ./src/components/SelectGrouped/SelectGrouped.vue?vue&type=script&lang=ts&
 /* harmony default export */ var SelectGrouped_SelectGroupedvue_type_script_lang_ts_ = (SelectGroupedvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectGrouped/SelectGrouped.vue?vue&type=style&index=0&id=7d4f196e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SelectGrouped/SelectGrouped.vue?vue&type=style&index=0&id=7d4f196e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/SelectGrouped/SelectGrouped.vue



;


/* normalize component */

var SelectGrouped_component = normalizeComponent(
  SelectGrouped_SelectGroupedvue_type_script_lang_ts_,
  SelectGroupedvue_type_template_id_7d4f196e_scoped_true_render,
  SelectGroupedvue_type_template_id_7d4f196e_scoped_true_staticRenderFns,
  false,
  null,
  "7d4f196e",
  null
  
)

/* harmony default export */ var SelectGrouped = (SelectGrouped_component.exports);
;// CONCATENATED MODULE: ./src/components/SelectGrouped/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectBox/SelectBox.vue?vue&type=template&id=c4ee7f3e&scoped=true&
var SelectBoxvue_type_template_id_c4ee7f3e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "dropdown",
    class: {
      'dropdown--opened': _vm.showDropdown
    },
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focusout": function focusout($event) {
        return _vm.hideDropdown();
      }
    }
  }, [_c('div', {
    staticClass: "dropdown__main",
    on: {
      "click": function click($event) {
        return _vm.openDropdown();
      }
    }
  }, [_c('strong', {
    staticClass: "dropdown__value"
  }, [_vm._v(_vm._s(_vm.currentItem.value))]), _c('Icon', {
    attrs: {
      "name": "chevronDown"
    }
  })], 1), _c('ul', {
    staticClass: "dropdown__list"
  }, _vm._l(_vm.items, function (item) {
    return _c('li', {
      key: item.key,
      staticClass: "dropdown__item",
      class: {
        'dropdown__item--current': item === _vm.currentItem
      },
      on: {
        "click": function click($event) {
          return _vm.selectItem(item);
        }
      }
    }, [_vm._v(" " + _vm._s(item.value) + " "), item === _vm.currentItem ? _c('Icon', {
      staticClass: "dropdown__check",
      attrs: {
        "name": "check"
      }
    }) : _vm._e()], 1);
  }), 0)]);
};
var SelectBoxvue_type_template_id_c4ee7f3e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectBox/SelectBox.vue?vue&type=script&lang=ts&


/* harmony default export */ var SelectBoxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    initiallySelectedItem: {
      type: Object,
      default: null
    }
  },
  data: function data() {
    return {
      showDropdown: false,
      currentItem: this.initiallySelectedItem || this.items[0]
    };
  },
  methods: {
    hideDropdown: function hideDropdown() {
      this.showDropdown = false;
    },
    openDropdown: function openDropdown() {
      this.showDropdown = true;
    },
    selectItem: function selectItem(item) {
      this.currentItem = item;
      this.$emit('selected', item);
      this.hideDropdown();
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/SelectBox/SelectBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var SelectBox_SelectBoxvue_type_script_lang_ts_ = (SelectBoxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/SelectBox/SelectBox.vue?vue&type=style&index=0&id=c4ee7f3e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/SelectBox/SelectBox.vue?vue&type=style&index=0&id=c4ee7f3e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/SelectBox/SelectBox.vue



;


/* normalize component */

var SelectBox_component = normalizeComponent(
  SelectBox_SelectBoxvue_type_script_lang_ts_,
  SelectBoxvue_type_template_id_c4ee7f3e_scoped_true_render,
  SelectBoxvue_type_template_id_c4ee7f3e_scoped_true_staticRenderFns,
  false,
  null,
  "c4ee7f3e",
  null
  
)

/* harmony default export */ var SelectBox = (SelectBox_component.exports);
;// CONCATENATED MODULE: ./src/components/SelectBox/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Select/Select.vue?vue&type=template&id=62e7dc27&scoped=true&
var Selectvue_type_template_id_62e7dc27_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "select"
  }, [_c('div', {
    staticClass: "header",
    class: {
      'header--enabled': !_vm.disabled,
      'header--disabled': _vm.disabled
    },
    on: {
      "!click": function click($event) {
        return _vm.clickHandler.apply(null, arguments);
      }
    }
  }, [_vm.label ? _c('label', {
    staticClass: "label",
    class: {
      'label--minified': _vm.shouldMinimizeLabel
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('div', {
    staticClass: "input",
    class: {
      'input--focused': _vm.isFocused
    }
  }, [_vm._v(" " + _vm._s(_vm.internalValue) + " ")]), _c('div', {
    staticClass: "icon",
    class: {
      'icon--focused': _vm.isFocused,
      'icon--disabled': _vm.disabled
    }
  }, [_c('Icon', {
    attrs: {
      "name": "dropdown",
      "size": 32
    }
  })], 1)]), _c('div', {
    staticClass: "options-container",
    class: {
      'options-container--unfocused': !_vm.isFocused,
      'options-container--focused': _vm.isFocused
    }
  }, _vm._l(_vm.optionsList, function (option) {
    return _c('div', {
      key: option,
      staticClass: "option",
      on: {
        "click": function click($event) {
          return _vm.select(option);
        }
      }
    }, [_vm._v(" " + _vm._s(option) + " ")]);
  }), 0)]);
};
var Selectvue_type_template_id_62e7dc27_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Select/Select.vue?vue&type=script&lang=ts&


/* harmony default export */ var Selectvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  model: {
    prop: 'value',
    event: 'select'
  },
  components: {
    Icon: Icon
  },
  props: {
    value: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    },
    optionsList: {
      type: Array,
      required: true
    }
  },
  data: function data() {
    return {
      isFocused: false,
      internalValue: this.$props.value
    };
  },
  methods: {
    select: function select(option) {
      this.isFocused = false;
      this.internalValue = option;
      this.$emit('select', option);
    },
    clickHandler: function clickHandler() {
      this.isFocused = this.disabled ? false : !this.isFocused;
    }
  },
  computed: {
    hasContent: function hasContent() {
      return !!this.internalValue;
    },
    shouldMinimizeLabel: function shouldMinimizeLabel() {
      return this.hasContent;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Select/Select.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Select_Selectvue_type_script_lang_ts_ = (Selectvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Select/Select.vue?vue&type=style&index=0&id=62e7dc27&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Select/Select.vue?vue&type=style&index=0&id=62e7dc27&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Select/Select.vue



;


/* normalize component */

var Select_component = normalizeComponent(
  Select_Selectvue_type_script_lang_ts_,
  Selectvue_type_template_id_62e7dc27_scoped_true_render,
  Selectvue_type_template_id_62e7dc27_scoped_true_staticRenderFns,
  false,
  null,
  "62e7dc27",
  null
  
)

/* harmony default export */ var Select = (Select_component.exports);
;// CONCATENATED MODULE: ./src/components/Select/index.ts

;// CONCATENATED MODULE: ./src/components/Tabs/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tags/Tags.vue?vue&type=template&id=60214e29&scoped=true&
var Tagsvue_type_template_id_60214e29_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "tags"
  }, _vm._l(_vm.tagList, function (tag) {
    return _c('span', {
      key: tag,
      staticClass: "tags__tag caption"
    }, [_vm._v(" " + _vm._s(tag) + " ")]);
  }), 0);
};
var Tagsvue_type_template_id_60214e29_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tags/Tags.vue?vue&type=script&lang=ts&

/* harmony default export */ var Tagsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    tagList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Tags/Tags.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Tags_Tagsvue_type_script_lang_ts_ = (Tagsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tags/Tags.vue?vue&type=style&index=0&id=60214e29&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tags/Tags.vue?vue&type=style&index=0&id=60214e29&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Tags/Tags.vue



;


/* normalize component */

var Tags_component = normalizeComponent(
  Tags_Tagsvue_type_script_lang_ts_,
  Tagsvue_type_template_id_60214e29_scoped_true_render,
  Tagsvue_type_template_id_60214e29_scoped_true_staticRenderFns,
  false,
  null,
  "60214e29",
  null
  
)

/* harmony default export */ var Tags = (Tags_component.exports);
;// CONCATENATED MODULE: ./src/components/Tags/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=template&id=4316dc36&scoped=true&


var ToggleSwitchvue_type_template_id_4316dc36_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "toggle"
  }, [_c('label', {
    staticClass: "toggle__slot",
    class: {
      'toggle__slot--after': _vm.checked
    },
    attrs: {
      "for": _vm.toggleId
    }
  }, [_vm._t("default")], 2), _c('div', {
    staticClass: "toggle__switch"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.checked,
      expression: "checked"
    }],
    attrs: {
      "type": "checkbox",
      "id": _vm.toggleId
    },
    domProps: {
      "checked": Array.isArray(_vm.checked) ? _vm._i(_vm.checked, null) > -1 : _vm.checked
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.checked,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.checked = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.checked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.checked = $$c;
        }
      }, _vm.selectToggle]
    }
  }), _c('label', {
    staticClass: "toggle__slider",
    attrs: {
      "for": _vm.toggleId
    }
  })])]);
};
var ToggleSwitchvue_type_template_id_4316dc36_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=template&id=4316dc36&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=script&lang=ts&

/* harmony default export */ var ToggleSwitchvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    value: {
      type: Boolean,
      default: false
    },
    toggleId: String
  },
  data: function data() {
    return {
      checked: this.value
    };
  },
  methods: {
    selectToggle: function selectToggle() {
      this.$emit('input', this.checked);
    }
  },
  watch: {
    value: function value(newValue) {
      this.checked = newValue;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ToggleSwitch_ToggleSwitchvue_type_script_lang_ts_ = (ToggleSwitchvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=style&index=0&id=4316dc36&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ToggleSwitch/ToggleSwitch.vue?vue&type=style&index=0&id=4316dc36&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ToggleSwitch/ToggleSwitch.vue



;


/* normalize component */

var ToggleSwitch_component = normalizeComponent(
  ToggleSwitch_ToggleSwitchvue_type_script_lang_ts_,
  ToggleSwitchvue_type_template_id_4316dc36_scoped_true_render,
  ToggleSwitchvue_type_template_id_4316dc36_scoped_true_staticRenderFns,
  false,
  null,
  "4316dc36",
  null
  
)

/* harmony default export */ var ToggleSwitch = (ToggleSwitch_component.exports);
;// CONCATENATED MODULE: ./src/components/ToggleSwitch/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput/TextInput.vue?vue&type=template&id=af515158&scoped=true&
var TextInputvue_type_template_id_af515158_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "text-input",
    class: {
      'text-input--enabled': !_vm.disabled,
      'text-input--disabled': _vm.disabled,
      'text-input--error': _vm.shouldStyleError
    }
  }, [_vm.label ? _c('label', {
    staticClass: "label",
    class: {
      'label--minified': _vm.shouldMinimizeLabel
    }
  }, [_vm._v(_vm._s(_vm.label))]) : _vm._e(), _c('input', {
    ref: "input",
    staticClass: "input",
    attrs: {
      "type": "text",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.internalValue
    },
    on: {
      "focus": _vm.focusHandler,
      "blur": _vm.blurHandler,
      "input": _vm.inputHandler
    }
  }), _c('p', {
    staticClass: "text-input--error_message"
  }, [_vm._v(" " + _vm._s(_vm.errorMessage) + " ")])]);
};
var TextInputvue_type_template_id_af515158_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput/TextInput.vue?vue&type=script&lang=ts&

/* harmony default export */ var TextInputvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: ''
    },
    value: {
      type: String,
      required: true
    },
    hasError: {
      type: Boolean,
      default: false
    },
    errorMessage: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    // eslint-disable-next-line
    value: function value(newValue, oldValue) {
      this.internalValue = newValue;
    }
  },
  data: function data() {
    return {
      isFocused: false,
      internalValue: this.$props.value
    };
  },
  methods: {
    blurHandler: function blurHandler(e) {
      this.isFocused = false;
      this.$emit('blur', e.target.value);
    },
    focusHandler: function focusHandler(e) {
      this.isFocused = true;
      this.$emit('focus', e.target.value);
    },
    inputHandler: function inputHandler(e) {
      this.$emit('input', e.target.value);
    }
  },
  computed: {
    hasContent: function hasContent() {
      return !!this.value;
    },
    shouldMinimizeLabel: function shouldMinimizeLabel() {
      return this.isFocused || this.hasContent;
    },
    shouldStyleError: function shouldStyleError() {
      return this.hasError || !!this.errorMessage;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.vue?vue&type=script&lang=ts&
 /* harmony default export */ var TextInput_TextInputvue_type_script_lang_ts_ = (TextInputvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextInput/TextInput.vue?vue&type=style&index=0&id=af515158&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.vue?vue&type=style&index=0&id=af515158&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/TextInput/TextInput.vue



;


/* normalize component */

var TextInput_component = normalizeComponent(
  TextInput_TextInputvue_type_script_lang_ts_,
  TextInputvue_type_template_id_af515158_scoped_true_render,
  TextInputvue_type_template_id_af515158_scoped_true_staticRenderFns,
  false,
  null,
  "af515158",
  null
  
)

/* harmony default export */ var TextInput = (TextInput_component.exports);
;// CONCATENATED MODULE: ./src/components/TextInput/index.ts

;// CONCATENATED MODULE: ./src/components/Loading/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LessonDetailsCard/LessonDetailsCard.vue?vue&type=template&id=ef099c6e&scoped=true&
var LessonDetailsCardvue_type_template_id_ef099c6e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "lesson-details-card"
  }, [_c('div', {
    staticClass: "lesson-details-card__title",
    class: {
      'lesson-details-card__title--unclickable': _vm.unClickable
    },
    on: {
      "click": _vm.clickHandler
    }
  }, [_c('div', {
    staticClass: "lesson-details-card__title__border-icon"
  }, [_c('Icon', {
    staticClass: "lesson-details-card__title__border-icon__icon",
    attrs: {
      "name": "playArrow"
    }
  })], 1), _c('h6', {
    staticClass: "lesson-details-card__title__label h6"
  }, [_vm._v(" " + _vm._s(_vm.title) + " ")])]), _c('div', {
    staticClass: "lesson-details-card__slot hide-for-small"
  }, [_vm._t("default")], 2)]);
};
var LessonDetailsCardvue_type_template_id_ef099c6e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LessonDetailsCard/LessonDetailsCard.vue?vue&type=script&lang=ts&


/* harmony default export */ var LessonDetailsCardvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    unClickable: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    clickHandler: function clickHandler() {
      this.$emit('onClick');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/LessonDetailsCard/LessonDetailsCard.vue?vue&type=script&lang=ts&
 /* harmony default export */ var LessonDetailsCard_LessonDetailsCardvue_type_script_lang_ts_ = (LessonDetailsCardvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/LessonDetailsCard/LessonDetailsCard.vue?vue&type=style&index=0&id=ef099c6e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/LessonDetailsCard/LessonDetailsCard.vue?vue&type=style&index=0&id=ef099c6e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/LessonDetailsCard/LessonDetailsCard.vue



;


/* normalize component */

var LessonDetailsCard_component = normalizeComponent(
  LessonDetailsCard_LessonDetailsCardvue_type_script_lang_ts_,
  LessonDetailsCardvue_type_template_id_ef099c6e_scoped_true_render,
  LessonDetailsCardvue_type_template_id_ef099c6e_scoped_true_staticRenderFns,
  false,
  null,
  "ef099c6e",
  null
  
)

/* harmony default export */ var LessonDetailsCard = (LessonDetailsCard_component.exports);
;// CONCATENATED MODULE: ./src/components/LessonDetailsCard/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Link/Link.vue?vue&type=template&id=e13dd5c8&scoped=true&

var Linkvue_type_template_id_e13dd5c8_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('a', {
    staticClass: "link",
    class: {
      primary: _vm.primary,
      'subtitle-2': _vm.small,
      'subtitle-1': _vm.medium
    },
    attrs: {
      "href": _vm.href
    }
  }, [_vm._t("default")], 2);
};
var Linkvue_type_template_id_e13dd5c8_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=template&id=e13dd5c8&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Link/Link.vue?vue&type=script&lang=ts&

/* harmony default export */ var Link_Linkvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    small: {
      type: Boolean,
      default: false
    },
    medium: {
      type: Boolean,
      default: true
    },
    primary: {
      type: Boolean,
      default: false
    },
    href: {
      type: String,
      default: null
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=script&lang=ts&
 /* harmony default export */ var components_Link_Linkvue_type_script_lang_ts_ = (Link_Linkvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Link/Link.vue?vue&type=style&index=0&id=e13dd5c8&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Link/Link.vue?vue&type=style&index=0&id=e13dd5c8&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Link/Link.vue



;


/* normalize component */

var Link_Link_component = normalizeComponent(
  components_Link_Linkvue_type_script_lang_ts_,
  Linkvue_type_template_id_e13dd5c8_scoped_true_render,
  Linkvue_type_template_id_e13dd5c8_scoped_true_staticRenderFns,
  false,
  null,
  "e13dd5c8",
  null
  
)

/* harmony default export */ var Link_Link = (Link_Link_component.exports);
;// CONCATENATED MODULE: ./src/components/Link/index.ts

;// CONCATENATED MODULE: ./src/components/Logo/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/Popup.vue?vue&type=template&id=1bd0a774&scoped=true&
var Popupvue_type_template_id_1bd0a774_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "pop-up"
    }
  }, [_vm.active ? _c('div', {
    ref: "popup",
    staticClass: "pop-up",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.onEsc.apply(null, arguments);
      }
    }
  }, [_c('div', {
    class: {
      'pop-up__overlay--without': !_vm.overlay,
      'pop-up__overlay': _vm.overlay
    },
    on: {
      "click": _vm.onOverlayClick
    }
  }, [_c('div', {
    staticClass: "pop-up__container",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.hasCloseButton ? _c('button', {
    staticClass: "pop-up__close",
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.onCloseClick
    }
  }, [_c('Icon', {
    staticClass: "pop-up__close__icon",
    attrs: {
      "name": "close",
      "size": 32
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "pop-up__content"
  }, [_vm._t("default")], 2)])])]) : _vm._e()]);
};
var Popupvue_type_template_id_1bd0a774_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/Popup.vue?vue&type=script&lang=ts&


/* harmony default export */ var Popupvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    active: {
      type: Boolean,
      default: false
    },
    closeOnEsc: {
      type: Boolean,
      default: true
    },
    clickOutsideToClose: {
      type: Boolean,
      default: false
    },
    hasCloseButton: {
      type: Boolean,
      default: true
    },
    overlay: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    closePopup: function closePopup() {
      this.$emit('update:active', false);
    },
    onOverlayClick: function onOverlayClick() {
      if (this.clickOutsideToClose) {
        this.closePopup();
      }
    },
    onCloseClick: function onCloseClick() {
      if (this.hasCloseButton) {
        this.closePopup();
      }
    },
    onEsc: function onEsc() {
      if (this.closeOnEsc) {
        this.closePopup();
      }
    }
  },
  mounted: function mounted() {
    var popup = this.$refs.popup;
    popup && popup.focus();
  }
}));
;// CONCATENATED MODULE: ./src/components/Popup/Popup.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Popup_Popupvue_type_script_lang_ts_ = (Popupvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/Popup.vue?vue&type=style&index=0&id=1bd0a774&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Popup/Popup.vue?vue&type=style&index=0&id=1bd0a774&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Popup/Popup.vue



;


/* normalize component */

var Popup_component = normalizeComponent(
  Popup_Popupvue_type_script_lang_ts_,
  Popupvue_type_template_id_1bd0a774_scoped_true_render,
  Popupvue_type_template_id_1bd0a774_scoped_true_staticRenderFns,
  false,
  null,
  "1bd0a774",
  null
  
)

/* harmony default export */ var Popup = (Popup_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupTitle.vue?vue&type=template&id=67b306fc&scoped=true&
var PopupTitlevue_type_template_id_67b306fc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('strong', {
    staticClass: "title"
  }, [_vm._t("default")], 2);
};
var PopupTitlevue_type_template_id_67b306fc_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupTitle.vue?vue&type=script&lang=ts&

/* harmony default export */ var PopupTitlevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({}));
;// CONCATENATED MODULE: ./src/components/Popup/PopupTitle.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Popup_PopupTitlevue_type_script_lang_ts_ = (PopupTitlevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupTitle.vue?vue&type=style&index=0&id=67b306fc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Popup/PopupTitle.vue?vue&type=style&index=0&id=67b306fc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Popup/PopupTitle.vue



;


/* normalize component */

var PopupTitle_component = normalizeComponent(
  Popup_PopupTitlevue_type_script_lang_ts_,
  PopupTitlevue_type_template_id_67b306fc_scoped_true_render,
  PopupTitlevue_type_template_id_67b306fc_scoped_true_staticRenderFns,
  false,
  null,
  "67b306fc",
  null
  
)

/* harmony default export */ var PopupTitle = (PopupTitle_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupActions.vue?vue&type=template&id=54a4b24e&scoped=true&
var PopupActionsvue_type_template_id_54a4b24e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "actions"
  }, [_vm._t("default")], 2);
};
var PopupActionsvue_type_template_id_54a4b24e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupActions.vue?vue&type=script&lang=ts&

/* harmony default export */ var PopupActionsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({}));
;// CONCATENATED MODULE: ./src/components/Popup/PopupActions.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Popup_PopupActionsvue_type_script_lang_ts_ = (PopupActionsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupActions.vue?vue&type=style&index=0&id=54a4b24e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Popup/PopupActions.vue?vue&type=style&index=0&id=54a4b24e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Popup/PopupActions.vue



;


/* normalize component */

var PopupActions_component = normalizeComponent(
  Popup_PopupActionsvue_type_script_lang_ts_,
  PopupActionsvue_type_template_id_54a4b24e_scoped_true_render,
  PopupActionsvue_type_template_id_54a4b24e_scoped_true_staticRenderFns,
  false,
  null,
  "54a4b24e",
  null
  
)

/* harmony default export */ var PopupActions = (PopupActions_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupDescription.vue?vue&type=template&id=ac7507c0&scoped=true&
var PopupDescriptionvue_type_template_id_ac7507c0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('strong', {
    staticClass: "description"
  }, [_vm._t("default")], 2);
};
var PopupDescriptionvue_type_template_id_ac7507c0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupDescription.vue?vue&type=script&lang=ts&

/* harmony default export */ var PopupDescriptionvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({}));
;// CONCATENATED MODULE: ./src/components/Popup/PopupDescription.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Popup_PopupDescriptionvue_type_script_lang_ts_ = (PopupDescriptionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupDescription.vue?vue&type=style&index=0&id=ac7507c0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Popup/PopupDescription.vue?vue&type=style&index=0&id=ac7507c0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Popup/PopupDescription.vue



;


/* normalize component */

var PopupDescription_component = normalizeComponent(
  Popup_PopupDescriptionvue_type_script_lang_ts_,
  PopupDescriptionvue_type_template_id_ac7507c0_scoped_true_render,
  PopupDescriptionvue_type_template_id_ac7507c0_scoped_true_staticRenderFns,
  false,
  null,
  "ac7507c0",
  null
  
)

/* harmony default export */ var PopupDescription = (PopupDescription_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupImage.vue?vue&type=template&id=04206a76&scoped=true&
var PopupImagevue_type_template_id_04206a76_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('img', {
    staticClass: "popup-image",
    style: {
      '--maskUrl': "url('".concat(_vm.maskUrl, "')")
    },
    attrs: {
      "src": _vm.imgSrc,
      "alt": ""
    }
  });
};
var PopupImagevue_type_template_id_04206a76_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupImage.vue?vue&type=script&lang=ts&

/* harmony default export */ var PopupImagevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    imgSrc: {
      type: String,
      default: ''
    },
    maskUrl: {
      type: String,
      default: ''
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Popup/PopupImage.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Popup_PopupImagevue_type_script_lang_ts_ = (PopupImagevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Popup/PopupImage.vue?vue&type=style&index=0&id=04206a76&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Popup/PopupImage.vue?vue&type=style&index=0&id=04206a76&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Popup/PopupImage.vue



;


/* normalize component */

var PopupImage_component = normalizeComponent(
  Popup_PopupImagevue_type_script_lang_ts_,
  PopupImagevue_type_template_id_04206a76_scoped_true_render,
  PopupImagevue_type_template_id_04206a76_scoped_true_staticRenderFns,
  false,
  null,
  "04206a76",
  null
  
)

/* harmony default export */ var PopupImage = (PopupImage_component.exports);
;// CONCATENATED MODULE: ./src/components/Popup/index.ts





/* harmony default export */ var components_Popup = (Popup);

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProfileProgress/ProfileProgress.vue?vue&type=template&id=d0bb282e&scoped=true&


var ProfileProgressvue_type_template_id_d0bb282e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "profile-progress"
  }, _vm._l(_vm.progressList, function (progress) {
    return _c('div', {
      key: progress.description,
      staticClass: "profile-progress__column"
    }, [_c('span', {
      staticClass: "profile-progress__counter h2"
    }, [_vm._v(_vm._s(progress.counter))]), _c('span', {
      staticClass: "profile-progress__text subtitle-2"
    }, [_vm._v(_vm._s(progress.description))])]);
  }), 0);
};
var ProfileProgressvue_type_template_id_d0bb282e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/ProfileProgress/ProfileProgress.vue?vue&type=template&id=d0bb282e&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProfileProgress/ProfileProgress.vue?vue&type=script&lang=ts&

/* harmony default export */ var ProfileProgressvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    progressList: {
      type: Array,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/ProfileProgress/ProfileProgress.vue?vue&type=script&lang=ts&
 /* harmony default export */ var ProfileProgress_ProfileProgressvue_type_script_lang_ts_ = (ProfileProgressvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/ProfileProgress/ProfileProgress.vue?vue&type=style&index=0&id=d0bb282e&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/ProfileProgress/ProfileProgress.vue?vue&type=style&index=0&id=d0bb282e&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/ProfileProgress/ProfileProgress.vue



;


/* normalize component */

var ProfileProgress_component = normalizeComponent(
  ProfileProgress_ProfileProgressvue_type_script_lang_ts_,
  ProfileProgressvue_type_template_id_d0bb282e_scoped_true_render,
  ProfileProgressvue_type_template_id_d0bb282e_scoped_true_staticRenderFns,
  false,
  null,
  "d0bb282e",
  null
  
)

/* harmony default export */ var ProfileProgress = (ProfileProgress_component.exports);
;// CONCATENATED MODULE: ./src/components/ProfileProgress/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenu.vue?vue&type=template&id=09b19fdb&scoped=true&
var PipelineMenuvue_type_template_id_09b19fdb_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "pipeline-menu",
    style: _vm.cssVars
  }, [_c('div', {
    staticClass: "pipeline-menu__side",
    class: {
      'pipeline-menu__side--collapsed': _vm.collapsed,
      'pipeline-menu__side--show-mobile': _vm.showSideMenuMobile
    }
  }, [_c('div', {
    staticClass: "pipeline-menu__side__logo",
    class: {
      'pipeline-menu__side__logo--collapsed': _vm.collapsed
    }
  }, [_c('Logo'), _c('Logo', {
    staticClass: "college-name",
    attrs: {
      "name": "collegeName",
      "width": 125
    }
  }), _c('div', {
    staticClass: "pipeline-menu__side__logo__hide-mobile show-for-small",
    on: {
      "click": _vm.toggleSideMenuMobile
    }
  }, [_c('Icon', {
    attrs: {
      "name": "close",
      "size": 20
    }
  })], 1)], 1), _c('div', {
    staticClass: "pipeline-menu__side__container__separator"
  }, [_c('div', {
    staticClass: "pipeline-menu__side__container",
    class: {
      'pipeline-menu__side__container--collapsed': _vm.collapsed
    }
  }, _vm._l(_vm.items, function (item, itemIdx) {
    return _c('div', {
      key: itemIdx,
      staticClass: "pipeline-menu__side__container__item",
      class: {
        'pipeline-menu__side__container__item--visited': _vm.isStepVisited(item.steps),
        'pipeline-menu__side__container__item--current-step': _vm.isCurrentStep(item.steps)
      }
    }, [_c('PipelineMenuItemPosition', {
      attrs: {
        "position": itemIdx + 1,
        "is-visited": _vm.isStepVisited(item.steps),
        "is-current": _vm.isCurrentStep(item.steps)
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.goToStep(item.steps);
        }
      }
    }), _c('div', {
      staticClass: "pipeline-menu__side__container__item__content",
      class: {
        'pipeline-menu__side__container__item__content--collapsed': _vm.collapsed
      }
    }, [_c('div', {
      staticClass: "pipeline-menu__side__container__item__content__header"
    }, [_c('span', {
      staticClass: "pipeline-menu__side__container__item__content__header__title subtitle-1",
      on: {
        "click": function click($event) {
          return _vm.goToStep(item.steps);
        }
      }
    }, [_vm._v(_vm._s(item.title) + " ")]), _vm.isDropDownEnabled(itemIdx) ? _c('Icon', {
      staticClass: "pipeline-menu__side__container__item__content__header__icon",
      attrs: {
        "name": "dropdown"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.toggleChildren(itemIdx, true);
        }
      }
    }) : _vm._e(), _vm.isDropUpEnabled(itemIdx) ? _c('Icon', {
      staticClass: "pipeline-menu__side__container__item__content__header__icon",
      attrs: {
        "name": "dropup"
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.toggleChildren(itemIdx, false);
        }
      }
    }) : _vm._e()], 1), _c('transition', {
      attrs: {
        "name": "children-active"
      }
    }, [item.childrenActive || _vm.isCurrentStep(item.steps) ? _c('div', {
      staticClass: "pipeline-menu__side__container__item__content__children",
      class: {
        'pipeline-menu__side__container__item__content__children--active': item.childrenActive || _vm.isCurrentStep(item.steps)
      }
    }, _vm._l(item.children, function (child, childIdx) {
      return _c('div', {
        key: childIdx,
        staticClass: "pipeline-menu__side__container__item__content__children__item",
        class: {
          'pipeline-menu__side__container__item__content__children__item--visited': _vm.isStepVisited(child.steps),
          'pipeline-menu__side__container__item__content__children__item--current-step': _vm.isCurrentStep(child.steps)
        },
        on: {
          "click": function click($event) {
            return _vm.goToStep(child.steps);
          }
        }
      }, [_c('span', {
        staticClass: "pipeline-menu__side__container__item__content__children__item__title subtitle-2"
      }, [_vm._v(_vm._s(child.title))]), _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: _vm.isCurrentStep(child.steps),
          expression: "isCurrentStep(child.steps)"
        }],
        staticClass: "pipeline-menu__side__container__item__content__children__item__marker"
      })]);
    }), 0) : _vm._e()])], 1)], 1);
  }), 0), _vm.withFooterButton ? _c('Button', {
    staticClass: "pipeline-menu__side__container__footer-button",
    class: {
      'show-for-small hide-for-medium-up': _vm.footerButtonMobileOnly
    },
    attrs: {
      "small": "",
      "border": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onFooterButtonClick.apply(null, arguments);
      }
    }
  }, [_c('Icon', {
    attrs: {
      "name": _vm.footerButtonIcon,
      "size": 20
    }
  }), _c('p', [_vm._v(_vm._s(_vm.footerButtonText))])], 1) : _vm._e()], 1)]), _c('transition', {
    attrs: {
      "name": "overlay"
    }
  }, [_vm.showSideMenuMobile ? _c('div', {
    staticClass: "pipeline-menu__overlay"
  }) : _vm._e()]), _c('div', {
    staticClass: "pipeline-menu__top show-for-small",
    class: {
      'pipeline-menu__top--shadow': _vm.hasScroll
    }
  }, [_c('div', {
    staticClass: "pipeline-menu__top__menu",
    on: {
      "click": _vm.toggleSideMenuMobile
    }
  }, [_c('Icon', {
    attrs: {
      "name": "menu",
      "size": 20
    }
  })], 1), _c('div', {
    staticClass: "pipeline-menu__top__container"
  }, _vm._l(_vm.items, function (item, itemIdx) {
    return _c('div', {
      key: itemIdx,
      staticClass: "pipeline-menu__top__container__item",
      class: {
        'pipeline-menu__top__container__item--visited': _vm.isStepVisited(item.steps),
        'pipeline-menu__top__container__item--current-step': _vm.isCurrentStep(item.steps)
      }
    }, [_c('PipelineMenuItemPosition', {
      attrs: {
        "small": _vm.smallMobileItems,
        "position": itemIdx + 1,
        "is-visited": _vm.isStepVisited(item.steps),
        "is-current": _vm.isCurrentStep(item.steps)
      },
      nativeOn: {
        "click": function click($event) {
          return _vm.goToStep(item.steps);
        }
      }
    })], 1);
  }), 0)])], 1);
};
var PipelineMenuvue_type_template_id_09b19fdb_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenuItemPosition.vue?vue&type=template&id=15bf641e&scoped=true&
var PipelineMenuItemPositionvue_type_template_id_15bf641e_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "pipeline-menu-item-position caption",
    class: {
      'pipeline-menu-item-position--visited': _vm.isVisited,
      'pipeline-menu-item-position--current': _vm.isCurrent && !_vm.isVisited
    },
    style: _vm.cssVars
  }, [_vm.isVisited ? _c('Icon', {
    staticClass: "pipeline-menu-item-position__icon",
    attrs: {
      "name": "check",
      "size": 20
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.position))])], 1);
};
var PipelineMenuItemPositionvue_type_template_id_15bf641e_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenuItemPosition.vue?vue&type=script&lang=ts&




/* harmony default export */ var PipelineMenuItemPositionvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    isVisited: {
      type: Boolean,
      default: false
    },
    isCurrent: {
      type: Boolean,
      default: false
    },
    position: {
      type: Number,
      required: true
    },
    small: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    cssVars: function cssVars() {
      return {
        '--position-element-size': this.small ? '32px' : '40px',
        '--icon-margin': this.small ? '6px' : '10px'
      };
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenuItemPosition.vue?vue&type=script&lang=ts&
 /* harmony default export */ var PipelineMenu_PipelineMenuItemPositionvue_type_script_lang_ts_ = (PipelineMenuItemPositionvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenuItemPosition.vue?vue&type=style&index=0&id=15bf641e&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenuItemPosition.vue?vue&type=style&index=0&id=15bf641e&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenuItemPosition.vue



;


/* normalize component */

var PipelineMenuItemPosition_component = normalizeComponent(
  PipelineMenu_PipelineMenuItemPositionvue_type_script_lang_ts_,
  PipelineMenuItemPositionvue_type_template_id_15bf641e_scoped_true_render,
  PipelineMenuItemPositionvue_type_template_id_15bf641e_scoped_true_staticRenderFns,
  false,
  null,
  "15bf641e",
  null
  
)

/* harmony default export */ var PipelineMenuItemPosition = (PipelineMenuItemPosition_component.exports);
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenu.vue?vue&type=script&lang=ts&







/* harmony default export */ var PipelineMenuvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Logo: Logo,
    Icon: Icon,
    PipelineMenuItemPosition: PipelineMenuItemPosition,
    Button: Button
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    currentStep: {
      type: String,
      required: true
    },
    pipelineItems: {
      type: Array,
      required: true
    },
    stepHistory: {
      type: Array,
      required: true
    },
    smallMobileItems: {
      type: Boolean,
      default: false
    },
    withFooterButton: {
      type: Boolean,
      default: false
    },
    footerButtonText: {
      type: String,
      required: false
    },
    footerButtonIcon: {
      type: String,
      required: false
    },
    footerButtonMobileOnly: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      items: this.pipelineItems,
      showSideMenuMobile: false,
      hasScroll: false
    };
  },
  watch: {
    pipelineItems: function pipelineItems(value) {
      this.items = value;
    }
  },
  computed: {
    cssVars: function cssVars() {
      return {
        '--items-offset': this.smallMobileItems ? '16px' : '32px',
        '--top-justify': this.smallMobileItems ? 'center' : 'flex-start'
      };
    }
  },
  mounted: function mounted() {
    window.addEventListener('scroll', this.setHasScroll);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('scroll', this.setHasScroll);
  },
  methods: {
    goToStep: function goToStep(steps) {
      this.$emit('goToStep', steps[0]);
    },
    isCurrentStep: function isCurrentStep(steps) {
      return steps.includes(this.currentStep);
    },
    isDropDownEnabled: function isDropDownEnabled(index) {
      var item = this.items[index];
      var hasChildren = item.children.length > 0;
      var isStepVisited = this.isStepVisited(item.steps, false);
      var isCurrentStep = this.isCurrentStep(item.steps);
      return hasChildren && isStepVisited && !item.childrenActive && !isCurrentStep;
    },
    isDropUpEnabled: function isDropUpEnabled(index) {
      var item = this.items[index];
      var hasChildren = item.children.length > 0;
      var isCurrentStep = this.isCurrentStep(item.steps);
      return hasChildren && (item.childrenActive || isCurrentStep);
    },
    isStepVisited: function isStepVisited(steps) {
      var _this = this;
      var strict = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var arrayFn = strict ? 'every' : 'some';
      return steps[arrayFn](function (step) {
        return _this.stepHistory.includes(step);
      });
    },
    toggleChildren: function toggleChildren(index, active) {
      if (this.isCurrentStep(this.items[index].steps)) return;
      this.items[index].childrenActive = active;
    },
    setHasScroll: function setHasScroll() {
      this.hasScroll = window.scrollY > 0;
    },
    toggleSideMenuMobile: function toggleSideMenuMobile() {
      this.showSideMenuMobile = !this.showSideMenuMobile;
    },
    onFooterButtonClick: function onFooterButtonClick() {
      this.$emit('onFooterButtonClick');
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenu.vue?vue&type=script&lang=ts&
 /* harmony default export */ var PipelineMenu_PipelineMenuvue_type_script_lang_ts_ = (PipelineMenuvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/PipelineMenu/PipelineMenu.vue?vue&type=style&index=0&id=09b19fdb&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenu.vue?vue&type=style&index=0&id=09b19fdb&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/PipelineMenu/PipelineMenu.vue



;


/* normalize component */

var PipelineMenu_component = normalizeComponent(
  PipelineMenu_PipelineMenuvue_type_script_lang_ts_,
  PipelineMenuvue_type_template_id_09b19fdb_scoped_true_render,
  PipelineMenuvue_type_template_id_09b19fdb_scoped_true_staticRenderFns,
  false,
  null,
  "09b19fdb",
  null
  
)

/* harmony default export */ var PipelineMenu = (PipelineMenu_component.exports);
;// CONCATENATED MODULE: ./src/components/PipelineMenu/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RangeSlider/RangeSlider.vue?vue&type=template&id=24cd3310&scoped=true&
var RangeSlidervue_type_template_id_24cd3310_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('input', {
    staticClass: "range-slider",
    style: {
      '--progress': "".concat(_vm.internalProgress, "%")
    },
    attrs: {
      "type": "range",
      "disabled": _vm.disabled
    },
    domProps: {
      "value": _vm.internalProgress
    },
    on: {
      "input": _vm.inputHandle
    }
  });
};
var RangeSlidervue_type_template_id_24cd3310_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RangeSlider/RangeSlider.vue?vue&type=script&lang=ts&


/* harmony default export */ var RangeSlidervue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    progress: {
      type: Number,
      default: 0
    }
  },
  data: function data() {
    return {
      internalProgress: this.progress
    };
  },
  watch: {
    progress: function progress(value) {
      this.internalProgress = value;
    }
  },
  methods: {
    inputHandle: function inputHandle(event) {
      var value = event.target.value;
      this.internalProgress = value;
      this.$emit('input', value);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/RangeSlider/RangeSlider.vue?vue&type=script&lang=ts&
 /* harmony default export */ var RangeSlider_RangeSlidervue_type_script_lang_ts_ = (RangeSlidervue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/RangeSlider/RangeSlider.vue?vue&type=style&index=0&id=24cd3310&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/RangeSlider/RangeSlider.vue?vue&type=style&index=0&id=24cd3310&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/RangeSlider/RangeSlider.vue



;


/* normalize component */

var RangeSlider_component = normalizeComponent(
  RangeSlider_RangeSlidervue_type_script_lang_ts_,
  RangeSlidervue_type_template_id_24cd3310_scoped_true_render,
  RangeSlidervue_type_template_id_24cd3310_scoped_true_staticRenderFns,
  false,
  null,
  "24cd3310",
  null
  
)

/* harmony default export */ var RangeSlider = (RangeSlider_component.exports);
;// CONCATENATED MODULE: ./src/components/RangeSlider/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Toast/Toast.vue?vue&type=template&id=f001ef0a&scoped=true&
var Toastvue_type_template_id_f001ef0a_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "toast"
  }, [_vm.success ? _c('Icon', {
    staticClass: "toast__icon toast__icon--success",
    attrs: {
      "name": "check",
      "size": 15
    }
  }) : _vm._e(), _vm.error ? _c('Icon', {
    staticClass: "toast__icon toast__icon--error",
    attrs: {
      "name": "close",
      "size": 15
    }
  }) : _vm._e(), _c('span', {
    staticClass: "toast__message subtitle-1",
    class: {
      'toast__message--success': _vm.success,
      'toast__message--error': _vm.error
    }
  }, [_vm._t("default")], 2)], 1) : _vm._e()]);
};
var Toastvue_type_template_id_f001ef0a_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Toast/Toast.vue?vue&type=script&lang=ts&


/* harmony default export */ var Toastvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    success: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Toast/Toast.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Toast_Toastvue_type_script_lang_ts_ = (Toastvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Toast/Toast.vue?vue&type=style&index=0&id=f001ef0a&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Toast/Toast.vue?vue&type=style&index=0&id=f001ef0a&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/Toast/Toast.vue



;


/* normalize component */

var Toast_component = normalizeComponent(
  Toast_Toastvue_type_script_lang_ts_,
  Toastvue_type_template_id_f001ef0a_scoped_true_render,
  Toastvue_type_template_id_f001ef0a_scoped_true_staticRenderFns,
  false,
  null,
  "f001ef0a",
  null
  
)

/* harmony default export */ var Toast = (Toast_component.exports);
;// CONCATENATED MODULE: ./src/components/Toast/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tooltip/Tooltip.vue?vue&type=template&id=3b97d888&scoped=true&
var Tooltipvue_type_template_id_3b97d888_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "tooltip-container"
  }, [_c('div', {
    class: [_vm.arrowPositionClass.position, _vm.arrowPositionClass.direction]
  }, [_vm._t("default")], 2)]) : _vm._e()]);
};
var Tooltipvue_type_template_id_3b97d888_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tooltip/Tooltip.vue?vue&type=script&lang=ts&


/* harmony default export */ var Tooltipvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    left: {
      type: Boolean,
      default: false
    },
    onSide: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    arrowPositionClass: function arrowPositionClass() {
      var position = this.onSide ? 'side' : 'up';
      var direction = this.left ? 'left' : 'right';
      return {
        position: "tooltip__content--arrow-".concat(position),
        direction: "tooltip__content--arrow-".concat(position, "-").concat(direction)
      };
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Tooltip_Tooltipvue_type_script_lang_ts_ = (Tooltipvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Tooltip/Tooltip.vue?vue&type=style&index=0&id=3b97d888&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue?vue&type=style&index=0&id=3b97d888&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/Tooltip/Tooltip.vue



;


/* normalize component */

var Tooltip_component = normalizeComponent(
  Tooltip_Tooltipvue_type_script_lang_ts_,
  Tooltipvue_type_template_id_3b97d888_scoped_true_render,
  Tooltipvue_type_template_id_3b97d888_scoped_true_staticRenderFns,
  false,
  null,
  "3b97d888",
  null
  
)

/* harmony default export */ var Tooltip = (Tooltip_component.exports);
;// CONCATENATED MODULE: ./src/components/Tooltip/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextSizeButtons/TextSizeButtons.vue?vue&type=template&id=3a16d113&scoped=true&
var TextSizeButtonsvue_type_template_id_3a16d113_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "controls-container"
  }, [_c('div', {
    staticClass: "controls-container__button",
    on: {
      "click": function click($event) {
        return _vm.increaseFontSize();
      }
    }
  }, [_vm._v("A+")]), _c('div', {
    staticClass: "controls-container__button",
    on: {
      "click": function click($event) {
        return _vm.decreaseFontSize();
      }
    }
  }, [_vm._v("A-")])]);
};
var TextSizeButtonsvue_type_template_id_3a16d113_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextSizeButtons/TextSizeButtons.vue?vue&type=script&lang=ts&


/* harmony default export */ var TextSizeButtonsvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  props: {
    fontSize: {
      type: Number,
      default: 100
    },
    controlValue: {
      type: Number,
      default: 10
    }
  },
  data: function data() {
    return {
      internalFontSize: this.fontSize
    };
  },
  watch: {
    fontSize: function fontSize(value) {
      this.internalFontSize = value;
    }
  },
  methods: {
    increaseFontSize: function increaseFontSize() {
      this.internalFontSize += this.controlValue;
      this.handleFontControl();
    },
    decreaseFontSize: function decreaseFontSize() {
      this.internalFontSize = this.internalFontSize === 0 ? this.internalFontSize : this.internalFontSize - this.controlValue;
      this.handleFontControl();
    },
    handleFontControl: function handleFontControl() {
      this.$emit('changeFontSize', "".concat(this.internalFontSize, "%"));
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/TextSizeButtons/TextSizeButtons.vue?vue&type=script&lang=ts&
 /* harmony default export */ var TextSizeButtons_TextSizeButtonsvue_type_script_lang_ts_ = (TextSizeButtonsvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TextSizeButtons/TextSizeButtons.vue?vue&type=style&index=0&id=3a16d113&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/TextSizeButtons/TextSizeButtons.vue?vue&type=style&index=0&id=3a16d113&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/TextSizeButtons/TextSizeButtons.vue



;


/* normalize component */

var TextSizeButtons_component = normalizeComponent(
  TextSizeButtons_TextSizeButtonsvue_type_script_lang_ts_,
  TextSizeButtonsvue_type_template_id_3a16d113_scoped_true_render,
  TextSizeButtonsvue_type_template_id_3a16d113_scoped_true_staticRenderFns,
  false,
  null,
  "3a16d113",
  null
  
)

/* harmony default export */ var TextSizeButtons = (TextSizeButtons_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Timeline/Timeline.vue?vue&type=template&id=3d0027e3&
var Timelinevue_type_template_id_3d0027e3_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "timeline"
  }, [_vm._t("default")], 2);
};
var Timelinevue_type_template_id_3d0027e3_staticRenderFns = [];

// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.keys.js
var es_object_keys = __webpack_require__(7941);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptor.js
var es_object_get_own_property_descriptor = __webpack_require__(5003);
// EXTERNAL MODULE: ./node_modules/core-js/modules/es.object.get-own-property-descriptors.js
var es_object_get_own_property_descriptors = __webpack_require__(9337);
;// CONCATENATED MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js









function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
;// CONCATENATED MODULE: ./src/components/Timeline/types.ts



var RegisterTimelineItem = Symbol('registerTimelineItem');
var ItemType;
(function (ItemType) {
  ItemType["title"] = "title";
  ItemType["titleEnd"] = "titleEnd";
  ItemType["content"] = "content";
})(ItemType || (ItemType = {}));
var ItemPosition;
(function (ItemPosition) {
  ItemPosition["top"] = "top";
  ItemPosition["middle"] = "middle";
  ItemPosition["bottom"] = "bottom";
})(ItemPosition || (ItemPosition = {}));
;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Timeline/Timeline.vue?vue&type=script&lang=ts&







/* harmony default export */ var Timelinevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  data: function data() {
    return {
      items: []
    };
  },
  methods: {
    pushItem: function pushItem(item) {
      var observableItem = external_commonjs_vue_commonjs2_vue_root_Vue_default().observable(item);
      this.items.push(observableItem);
      return observableItem;
    },
    unsetLastBottom: function unsetLastBottom() {
      this.items[this.items.length - 1].position = ItemPosition.middle;
    },
    unsetLastTitleEnd: function unsetLastTitleEnd() {
      var titleEnd = this.items.find(function (item) {
        return item.type === ItemType.titleEnd;
      });
      if (titleEnd) titleEnd.type = ItemType.title;
    }
  },
  provide: function provide() {
    var _this = this;
    return _defineProperty({}, RegisterTimelineItem, function (timelineItem) {
      var item = _objectSpread2({}, timelineItem);
      if (_this.items.length === 0) {
        item = {
          type: ItemType.titleEnd,
          position: ItemPosition.top
        };
      } else {
        if (_this.items.length > 1) {
          _this.unsetLastBottom();
        }
        if (timelineItem.type === ItemType.title) {
          _this.unsetLastTitleEnd();
          item.type = ItemType.titleEnd;
        }
        item.position = ItemPosition.bottom;
      }
      return _this.pushItem(item);
    });
  }
}));
;// CONCATENATED MODULE: ./src/components/Timeline/Timeline.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Timeline_Timelinevue_type_script_lang_ts_ = (Timelinevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./src/components/Timeline/Timeline.vue





/* normalize component */
;
var Timeline_component = normalizeComponent(
  Timeline_Timelinevue_type_script_lang_ts_,
  Timelinevue_type_template_id_3d0027e3_render,
  Timelinevue_type_template_id_3d0027e3_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Timeline = (Timeline_component.exports);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Timeline/TimelineItem.vue?vue&type=template&id=618116a0&scoped=true&
var TimelineItemvue_type_template_id_618116a0_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "timeline-item"
  }, [_vm.isTitle ? _c('div', {
    staticClass: "timeline-item__bar"
  }, [_c('div', {
    class: "timeline-item__bar__line--".concat(_vm.topLineModifier)
  }), _c('div', {
    staticClass: "timeline-item__bar__dot",
    class: {
      'timeline-item__bar__dot--active': _vm.isTitleEnd
    }
  }), _c('div', {
    class: "timeline-item__bar__line--".concat(_vm.bottomLineModifier)
  })]) : _c('div', {
    staticClass: "timeline-item__bar"
  }, [_c('div', {
    class: "timeline-item__bar__line--".concat(_vm.fullLineModifier)
  })]), _c('div', {
    staticClass: "timeline-item__content"
  }, [_vm._t("default")], 2)]);
};
var TimelineItemvue_type_template_id_618116a0_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Timeline/TimelineItem.vue?vue&type=script&lang=ts&


/* harmony default export */ var TimelineItemvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  inject: {
    RegisterTimelineItem: RegisterTimelineItem
  },
  props: {
    title: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      item: {
        type: this.title ? ItemType.title : ItemType.content,
        position: ItemPosition.middle
      }
    };
  },
  computed: {
    isTitleEnd: function isTitleEnd() {
      return this.item.type === ItemType.titleEnd;
    },
    isTitle: function isTitle() {
      return this.item.type === ItemType.title || this.isTitleEnd;
    },
    isTop: function isTop() {
      return this.item.position === ItemPosition.top;
    },
    isBottom: function isBottom() {
      return this.item.position === ItemPosition.bottom;
    },
    topLineModifier: function topLineModifier() {
      return this.isTop ? 'blank' : 'active';
    },
    bottomLineModifier: function bottomLineModifier() {
      return this.isBottom || this.isTitleEnd ? 'blank' : 'active';
    },
    fullLineModifier: function fullLineModifier() {
      return this.isBottom && !this.isTitle ? 'full-blank' : 'full-active';
    }
  },
  mounted: function mounted() {
    // @ts-ignore
    this.item = this.RegisterTimelineItem(this.item);
  }
}));
;// CONCATENATED MODULE: ./src/components/Timeline/TimelineItem.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Timeline_TimelineItemvue_type_script_lang_ts_ = (TimelineItemvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Timeline/TimelineItem.vue?vue&type=style&index=0&id=618116a0&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Timeline/TimelineItem.vue?vue&type=style&index=0&id=618116a0&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Timeline/TimelineItem.vue



;


/* normalize component */

var TimelineItem_component = normalizeComponent(
  Timeline_TimelineItemvue_type_script_lang_ts_,
  TimelineItemvue_type_template_id_618116a0_scoped_true_render,
  TimelineItemvue_type_template_id_618116a0_scoped_true_staticRenderFns,
  false,
  null,
  "618116a0",
  null
  
)

/* harmony default export */ var TimelineItem = (TimelineItem_component.exports);
;// CONCATENATED MODULE: ./src/components/Timeline/index.ts


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MenuTree/MenuTree.vue?vue&type=template&id=0b46b36d&scoped=true&
var MenuTreevue_type_template_id_0b46b36d_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "dropdown",
    attrs: {
      "tabindex": "0"
    }
  }, _vm._l(_vm.items, function (item, key) {
    return _c('div', {
      key: item.option,
      staticClass: "dropdown__box",
      class: {
        'dropdown__box--selected': item.isOpened
      }
    }, [_c('div', {
      staticClass: "dropdown__main",
      class: {
        'dropdown__main--selected': item.isOpened
      },
      on: {
        "click": function click($event) {
          return _vm.toggleDropdown(key);
        }
      }
    }, [_c('div', {
      staticClass: "dropdown__main__content",
      class: {
        'dropdown__main__content--selected': item.isOpened
      }
    }, [_c('div', {
      staticClass: "dropdown__main__content--title"
    }, [_c('Icon', {
      attrs: {
        "name": _vm.dropdownIcon(item.isOpened)
      }
    }), _c('span', {
      staticClass: "dropdown__value__title",
      class: {
        'dropdown__value__title--selected': item.isOpened
      }
    }, [_vm._v(" " + _vm._s(item.option) + " ")])], 1), _c('span', {
      staticClass: "dropdown__value__count",
      class: {
        'dropdown__value__count--selected': item.isOpened
      }
    }, [_vm._v(" " + _vm._s(item.count))])])]), _c('div', {
      staticClass: "dropdown__content",
      class: {
        'dropdown__content--show': item.isOpened
      }
    }, _vm._l(item.subOptions, function (subOption, key) {
      return _c('div', {
        key: subOption.title + key,
        class: {
          dropdown__content__item: key !== 0,
          'dropdown__content__item--first': key === 0,
          'dropdown__content__item--first--selected': key === 0 && _vm.subOptionSelected === subOption,
          'dropdown__content__item--selected': _vm.subOptionSelected === subOption
        }
      }, [_c('div', {
        staticClass: "dropdown__content__item__text",
        on: {
          "click": function click($event) {
            return _vm.toggleSubOption(subOption);
          }
        }
      }, [_vm._v(" " + _vm._s(subOption.title) + " ")])]);
    }), 0)]);
  }), 0);
};
var MenuTreevue_type_template_id_0b46b36d_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MenuTree/MenuTree.vue?vue&type=script&lang=ts&





/* harmony default export */ var MenuTreevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    items: {
      type: Array,
      required: true
    },
    initiallySelectedIndex: {
      type: Number,
      default: null
    },
    multipleOptions: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      showDropdown: false,
      openedDropdowns: {},
      subOptionSelected: {}
    };
  },
  methods: {
    dropdownIcon: function dropdownIcon(isOpened) {
      return isOpened ? 'chevronDown' : 'chevronRight';
    },
    toggleDropdown: function toggleDropdown(toggledIndex) {
      var _changedItems$toggled;
      var changedItems = _toConsumableArray(this.items);
      if (!changedItems[toggledIndex] || (_changedItems$toggled = changedItems[toggledIndex]) !== null && _changedItems$toggled !== void 0 && _changedItems$toggled.isOpened) return;
      changedItems[toggledIndex].isOpened = !changedItems[toggledIndex].isOpened;
      if (!this.multipleOptions) {
        changedItems = changedItems.map(function (item, index) {
          if (toggledIndex === index) return item;
          item.isOpened = false;
          return item;
        });
        this.toggleSubOption(null);
      }
      this.$emit('update:items', changedItems);
      this.$emit('toggleOption', changedItems[toggledIndex].option, changedItems[toggledIndex].isOpened);
    },
    toggleSubOption: function toggleSubOption(option) {
      this.subOptionSelected = option;
      this.$emit('toggleSubOption', option);
    }
  },
  mounted: function mounted() {
    if (this.initiallySelectedIndex != null) {
      this.toggleDropdown(this.initiallySelectedIndex);
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/MenuTree/MenuTree.vue?vue&type=script&lang=ts&
 /* harmony default export */ var MenuTree_MenuTreevue_type_script_lang_ts_ = (MenuTreevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MenuTree/MenuTree.vue?vue&type=style&index=0&id=0b46b36d&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/MenuTree/MenuTree.vue?vue&type=style&index=0&id=0b46b36d&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/MenuTree/MenuTree.vue



;


/* normalize component */

var MenuTree_component = normalizeComponent(
  MenuTree_MenuTreevue_type_script_lang_ts_,
  MenuTreevue_type_template_id_0b46b36d_scoped_true_render,
  MenuTreevue_type_template_id_0b46b36d_scoped_true_staticRenderFns,
  false,
  null,
  "0b46b36d",
  null
  
)

/* harmony default export */ var MenuTree = (MenuTree_component.exports);
;// CONCATENATED MODULE: ./src/components/MenuTree/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/WhatsNewTag/WhatsNewTag.vue?vue&type=template&id=240b9366&scoped=true&
var WhatsNewTagvue_type_template_id_240b9366_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_vm.visible ? _c('div', {
    staticClass: "whatsnew"
  }, [_c('div', {
    staticClass: "whatsnew__content"
  }, [_c('span', [_vm._v(_vm._s(_vm.text))]), _c('Icon', {
    staticClass: "whatsnew__closeicon",
    attrs: {
      "name": "close",
      "size": 20
    }
  })], 1)]) : _vm._e()]);
};
var WhatsNewTagvue_type_template_id_240b9366_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/WhatsNewTag/WhatsNewTag.vue?vue&type=script&lang=ts&


/* harmony default export */ var WhatsNewTagvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    text: {
      type: String,
      required: true
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/WhatsNewTag/WhatsNewTag.vue?vue&type=script&lang=ts&
 /* harmony default export */ var WhatsNewTag_WhatsNewTagvue_type_script_lang_ts_ = (WhatsNewTagvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/WhatsNewTag/WhatsNewTag.vue?vue&type=style&index=0&id=240b9366&prod&scoped=true&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/WhatsNewTag/WhatsNewTag.vue?vue&type=style&index=0&id=240b9366&prod&scoped=true&lang=scss&

;// CONCATENATED MODULE: ./src/components/WhatsNewTag/WhatsNewTag.vue



;


/* normalize component */

var WhatsNewTag_component = normalizeComponent(
  WhatsNewTag_WhatsNewTagvue_type_script_lang_ts_,
  WhatsNewTagvue_type_template_id_240b9366_scoped_true_render,
  WhatsNewTagvue_type_template_id_240b9366_scoped_true_staticRenderFns,
  false,
  null,
  "240b9366",
  null
  
)

/* harmony default export */ var WhatsNewTag = (WhatsNewTag_component.exports);
;// CONCATENATED MODULE: ./src/components/WhatsNewTag/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=template&id=32c3c767&scoped=true&
var TermsOfUsevue_type_template_id_32c3c767_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('transition', {
    attrs: {
      "name": "modal-animation"
    }
  }, [_vm.active ? _c('div', {
    ref: "termsOfUse",
    staticClass: "terms-of-use",
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": function keydown($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) return null;
        return _vm.onEsc.apply(null, arguments);
      }
    }
  }, [_c('div', {
    staticClass: "terms-of-use__overlay",
    on: {
      "click": _vm.onOverlayClick
    }
  }, [_c('div', {
    staticClass: "terms-of-use__container",
    on: {
      "click": function click($event) {
        $event.stopPropagation();
      }
    }
  }, [_vm.hasCloseButton ? _c('button', {
    staticClass: "terms-of-use__close terms-of-use__close--border-radius",
    attrs: {
      "aria-label": "Fechar"
    },
    on: {
      "click": _vm.onCloseClick
    }
  }, [_c('Icon', {
    staticClass: "terms-of-use__close__icon",
    attrs: {
      "name": "close",
      "size": 26
    }
  }), _c('div', {
    staticClass: "terms-of-use__close__bar"
  })], 1) : _vm._e(), _c('div', {
    staticClass: "terms-of-use__logo"
  }, [_c('Logo', {
    attrs: {
      "name": "CollegeNameWithLogo",
      "width": 125
    }
  })], 1), _c('div', {
    staticClass: "terms-of-use__content"
  }, [_c('div', {
    staticClass: "terms-of-use__title"
  }, [_c('h3', [_vm._v(_vm._s(_vm.title))])]), _c('div', [_vm._t("default")], 2), _c('div', {
    staticClass: "terms-of-use__footer"
  }, [_c('Button', {
    attrs: {
      "primary": ""
    },
    nativeOn: {
      "click": function click($event) {
        return _vm.onAcceptClick.apply(null, arguments);
      }
    }
  }, [_vm._v("Aceito")]), _vm.helperLink ? _c('span', [_vm._v(" Ficou com alguma dúvida? Entre em contato através de nossa "), _c('a', {
    attrs: {
      "href": _vm.helperLink,
      "target": "_blank"
    }
  }, [_vm._v(" Central de Atendimento. ")])]) : _vm._e()], 1)])])])]) : _vm._e()]);
};
var TermsOfUsevue_type_template_id_32c3c767_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=script&lang=ts&




/* harmony default export */ var TermsOfUsevue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Logo: Logo,
    Icon: Icon,
    Button: components_Button
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    helperLink: {
      type: String,
      default: ''
    },
    closeOnEsc: {
      type: Boolean,
      default: false
    },
    clickOutsideToClose: {
      type: Boolean,
      default: false
    },
    hasCloseButton: {
      type: Boolean,
      default: false
    },
    active: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit('update:active', false);
    },
    onOverlayClick: function onOverlayClick() {
      if (this.clickOutsideToClose) {
        this.closeDialog();
      }
    },
    onCloseClick: function onCloseClick() {
      if (this.hasCloseButton) {
        this.closeDialog();
      }
    },
    onEsc: function onEsc() {
      if (this.closeOnEsc) {
        this.closeDialog();
      }
    },
    onAcceptClick: function onAcceptClick() {
      this.$emit('onAcceptClick');
    }
  },
  mounted: function mounted() {
    var termsOfUse = this.$refs.termsOfUse;
    termsOfUse && termsOfUse.focus();
  }
}));
;// CONCATENATED MODULE: ./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=script&lang=ts&
 /* harmony default export */ var TermsOfUSe_TermsOfUsevue_type_script_lang_ts_ = (TermsOfUsevue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=style&index=0&id=32c3c767&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=style&index=0&id=32c3c767&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=style&index=1&id=32c3c767&prod&lang=scss&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/TermsOfUSe/TermsOfUse.vue?vue&type=style&index=1&id=32c3c767&prod&lang=scss&

;// CONCATENATED MODULE: ./src/components/TermsOfUSe/TermsOfUse.vue



;



/* normalize component */

var TermsOfUse_component = normalizeComponent(
  TermsOfUSe_TermsOfUsevue_type_script_lang_ts_,
  TermsOfUsevue_type_template_id_32c3c767_scoped_true_render,
  TermsOfUsevue_type_template_id_32c3c767_scoped_true_staticRenderFns,
  false,
  null,
  "32c3c767",
  null
  
)

/* harmony default export */ var TermsOfUse = (TermsOfUse_component.exports);
;// CONCATENATED MODULE: ./src/components/TermsOfUSe/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileDownloadBox/FileDownloadBox.vue?vue&type=template&id=6a2be3bc&scoped=true&
var FileDownloadBoxvue_type_template_id_6a2be3bc_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "file-download-box-wrapper",
    on: {
      "click": _vm.onClick,
      "mouseover": _vm.onMouseOver,
      "mouseleave": _vm.onMouseLeave
    }
  }, [_c('div', [_c('p', {
    staticClass: "file-download-box-wrapper__label"
  }, [_vm._v(_vm._s(_vm.label))]), _c('p', {
    staticClass: "file-download-box-wrapper__filename"
  }, [_vm._v(_vm._s(_vm.filename))])]), _c('Icon', {
    staticClass: "file-download-box-wrapper__icon",
    attrs: {
      "name": _vm.iconName
    }
  })], 1);
};
var FileDownloadBoxvue_type_template_id_6a2be3bc_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileDownloadBox/FileDownloadBox.vue?vue&type=script&lang=ts&


/* harmony default export */ var FileDownloadBoxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    label: {
      type: String,
      required: true
    },
    filename: {
      type: String,
      required: true
    },
    fileUrl: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      isHovering: false
    };
  },
  computed: {
    iconName: function iconName() {
      return this.isHovering ? 'download' : 'check';
    }
  },
  methods: {
    onClick: function onClick() {
      window.open(this.fileUrl, '_blank', 'noopener,noreferrer');
    },
    onMouseOver: function onMouseOver() {
      this.isHovering = true;
    },
    onMouseLeave: function onMouseLeave() {
      this.isHovering = false;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/FileDownloadBox/FileDownloadBox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var FileDownloadBox_FileDownloadBoxvue_type_script_lang_ts_ = (FileDownloadBoxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/FileDownloadBox/FileDownloadBox.vue?vue&type=style&index=0&id=6a2be3bc&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/FileDownloadBox/FileDownloadBox.vue?vue&type=style&index=0&id=6a2be3bc&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/FileDownloadBox/FileDownloadBox.vue



;


/* normalize component */

var FileDownloadBox_component = normalizeComponent(
  FileDownloadBox_FileDownloadBoxvue_type_script_lang_ts_,
  FileDownloadBoxvue_type_template_id_6a2be3bc_scoped_true_render,
  FileDownloadBoxvue_type_template_id_6a2be3bc_scoped_true_staticRenderFns,
  false,
  null,
  "6a2be3bc",
  null
  
)

/* harmony default export */ var FileDownloadBox = (FileDownloadBox_component.exports);
;// CONCATENATED MODULE: ./src/components/FileDownloadBox/index.ts

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[4]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Checkbox/Checkbox.vue?vue&type=template&id=5c1e0be3&scoped=true&


var Checkboxvue_type_template_id_5c1e0be3_scoped_true_render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', [_c('label', {
    staticClass: "contents",
    attrs: {
      "for": _vm.id
    }
  }, [_c('span', {
    staticClass: "contents__checkbox"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.isChecked,
      expression: "isChecked"
    }],
    staticClass: "contents__checkbox-input",
    attrs: {
      "type": "checkbox",
      "id": _vm.id
    },
    domProps: {
      "checked": Array.isArray(_vm.isChecked) ? _vm._i(_vm.isChecked, null) > -1 : _vm.isChecked
    },
    on: {
      "change": [function ($event) {
        var $$a = _vm.isChecked,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isChecked = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.isChecked = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.isChecked = $$c;
        }
      }, _vm.selectCheckbox]
    }
  }), _c('span', {
    staticClass: "contents__checkbox-icon",
    class: {
      'contents__checkbox-icon--show': _vm.isChecked
    }
  }, [_c('Icon', {
    attrs: {
      "name": "check",
      "size": 16
    }
  })], 1)]), _c('span', {
    staticClass: "contents__slot",
    class: {
      'contents__slot--after': _vm.isChecked
    }
  }, [_vm._t("default")], 2)])]);
};
var Checkboxvue_type_template_id_5c1e0be3_scoped_true_staticRenderFns = [];

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=template&id=5c1e0be3&scoped=true&

;// CONCATENATED MODULE: ./node_modules/thread-loader/dist/cjs.js!./node_modules/babel-loader/lib/index.js!./node_modules/ts-loader/index.js??clonedRuleSet-41.use[2]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Checkbox/Checkbox.vue?vue&type=script&lang=ts&


/* harmony default export */ var Checkboxvue_type_script_lang_ts_ = (external_commonjs_vue_commonjs2_vue_root_Vue_default().extend({
  components: {
    Icon: Icon
  },
  props: {
    id: {
      type: String,
      required: true
    },
    checked: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      isChecked: this.checked
    };
  },
  methods: {
    selectCheckbox: function selectCheckbox() {
      this.$emit('input', this.isChecked);
    }
  },
  watch: {
    checked: function checked(newValue) {
      this.isChecked = newValue;
    }
  }
}));
;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=script&lang=ts&
 /* harmony default export */ var Checkbox_Checkboxvue_type_script_lang_ts_ = (Checkboxvue_type_script_lang_ts_); 
;// CONCATENATED MODULE: ./node_modules/mini-css-extract-plugin/dist/loader.js??clonedRuleSet-22.use[0]!./node_modules/@vue/cli-service/node_modules/css-loader/dist/cjs.js??clonedRuleSet-22.use[1]!./node_modules/@vue/vue-loader-v15/lib/loaders/stylePostLoader.js!./node_modules/postcss-loader/dist/cjs.js??clonedRuleSet-22.use[2]!./node_modules/sass-loader/dist/cjs.js??clonedRuleSet-22.use[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Checkbox/Checkbox.vue?vue&type=style&index=0&id=5c1e0be3&prod&lang=scss&scoped=true&
// extracted by mini-css-extract-plugin

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue?vue&type=style&index=0&id=5c1e0be3&prod&lang=scss&scoped=true&

;// CONCATENATED MODULE: ./src/components/Checkbox/Checkbox.vue



;


/* normalize component */

var Checkbox_component = normalizeComponent(
  Checkbox_Checkboxvue_type_script_lang_ts_,
  Checkboxvue_type_template_id_5c1e0be3_scoped_true_render,
  Checkboxvue_type_template_id_5c1e0be3_scoped_true_staticRenderFns,
  false,
  null,
  "5c1e0be3",
  null
  
)

/* harmony default export */ var Checkbox = (Checkbox_component.exports);
;// CONCATENATED MODULE: ./src/components/Checkbox/index.ts

;// CONCATENATED MODULE: ./src/index.ts

































































;// CONCATENATED MODULE: ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=vueComponents.common.js.map